/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/h5/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 301);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(39);
var hide = __webpack_require__(29);
var redefine = __webpack_require__(30);
var ctx = __webpack_require__(40);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(308);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * @module zrender/core/util
 */
// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT = {
  '[object Function]': 1,
  '[object RegExp]': 1,
  '[object Date]': 1,
  '[object Error]': 1,
  '[object CanvasGradient]': 1,
  '[object CanvasPattern]': 1,
  // For node-canvas
  '[object Image]': 1,
  '[object Canvas]': 1
};
var TYPED_ARRAY = {
  '[object Int8Array]': 1,
  '[object Uint8Array]': 1,
  '[object Uint8ClampedArray]': 1,
  '[object Int16Array]': 1,
  '[object Uint16Array]': 1,
  '[object Int32Array]': 1,
  '[object Uint32Array]': 1,
  '[object Float32Array]': 1,
  '[object Float64Array]': 1
};
var objToString = Object.prototype.toString;
var arrayProto = Array.prototype;
var nativeForEach = arrayProto.forEach;
var nativeFilter = arrayProto.filter;
var nativeSlice = arrayProto.slice;
var nativeMap = arrayProto.map;
var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  // Clear ctx instance for different environment
  if (name === 'createCanvas') {
    _ctx = null;
  }

  methods[name] = fn;
}
/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */


function clone(source) {
  if (source == null || typeof source !== 'object') {
    return source;
  }

  var result = source;
  var typeStr = objToString.call(source);

  if (typeStr === '[object Array]') {
    if (!isPrimitive(source)) {
      result = [];

      for (var i = 0, len = source.length; i < len; i++) {
        result[i] = clone(source[i]);
      }
    }
  } else if (TYPED_ARRAY[typeStr]) {
    if (!isPrimitive(source)) {
      var Ctor = source.constructor;

      if (source.constructor.from) {
        result = Ctor.from(source);
      } else {
        result = new Ctor(source.length);

        for (var i = 0, len = source.length; i < len; i++) {
          result[i] = clone(source[i]);
        }
      }
    }
  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
    result = {};

    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = clone(source[key]);
      }
    }
  }

  return result;
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */


function merge(target, source, overwrite) {
  // We should escapse that source is string
  // and enter for ... in ...
  if (!isObject(source) || !isObject(target)) {
    return overwrite ? clone(source) : target;
  }

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      var targetProp = target[key];
      var sourceProp = source[key];

      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
        // 如果需要递归覆盖，就递归调用merge
        merge(targetProp, sourceProp, overwrite);
      } else if (overwrite || !(key in target)) {
        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = clone(source[key], true);
      }
    }
  }

  return target;
}
/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */


function mergeAll(targetAndSources, overwrite) {
  var result = targetAndSources[0];

  for (var i = 1, len = targetAndSources.length; i < len; i++) {
    result = merge(result, targetAndSources[i], overwrite);
  }

  return result;
}
/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */


function extend(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */


function defaults(target, source, overlay) {
  for (var key in source) {
    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
      target[key] = source[key];
    }
  }

  return target;
}

var createCanvas = function () {
  return methods.createCanvas();
};

methods.createCanvas = function () {
  return document.createElement('canvas');
}; // FIXME


var _ctx;

function getContext() {
  if (!_ctx) {
    // Use util.createCanvas instead of createCanvas
    // because createCanvas may be overwritten in different environment
    _ctx = createCanvas().getContext('2d');
  }

  return _ctx;
}
/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */


function indexOf(array, value) {
  if (array) {
    if (array.indexOf) {
      return array.indexOf(value);
    }

    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === value) {
        return i;
      }
    }
  }

  return -1;
}
/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */


function inherits(clazz, baseClazz) {
  var clazzPrototype = clazz.prototype;

  function F() {}

  F.prototype = baseClazz.prototype;
  clazz.prototype = new F();

  for (var prop in clazzPrototype) {
    if (clazzPrototype.hasOwnProperty(prop)) {
      clazz.prototype[prop] = clazzPrototype[prop];
    }
  }

  clazz.prototype.constructor = clazz;
  clazz.superClass = baseClazz;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */


function mixin(target, source, overlay) {
  target = 'prototype' in target ? target.prototype : target;
  source = 'prototype' in source ? source.prototype : source;
  defaults(target, source, overlay);
}
/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */


function isArrayLike(data) {
  if (!data) {
    return;
  }

  if (typeof data === 'string') {
    return false;
  }

  return typeof data.length === 'number';
}
/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */


function each(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.forEach && obj.forEach === nativeForEach) {
    obj.forEach(cb, context);
  } else if (obj.length === +obj.length) {
    for (var i = 0, len = obj.length; i < len; i++) {
      cb.call(context, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        cb.call(context, obj[key], key, obj);
      }
    }
  }
}
/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function map(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.map && obj.map === nativeMap) {
    return obj.map(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      result.push(cb.call(context, obj[i], i, obj));
    }

    return result;
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */


function reduce(obj, cb, memo, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.reduce && obj.reduce === nativeReduce) {
    return obj.reduce(cb, memo, context);
  } else {
    for (var i = 0, len = obj.length; i < len; i++) {
      memo = cb.call(context, memo, obj[i], i, obj);
    }

    return memo;
  }
}
/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function filter(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.filter && obj.filter === nativeFilter) {
    return obj.filter(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      if (cb.call(context, obj[i], i, obj)) {
        result.push(obj[i]);
      }
    }

    return result;
  }
}
/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */


function find(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  for (var i = 0, len = obj.length; i < len; i++) {
    if (cb.call(context, obj[i], i, obj)) {
      return obj[i];
    }
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */


function bind(func, context) {
  var args = nativeSlice.call(arguments, 2);
  return function () {
    return func.apply(context, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */


function curry(func) {
  var args = nativeSlice.call(arguments, 1);
  return function () {
    return func.apply(this, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isArray(value) {
  return objToString.call(value) === '[object Array]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isString(value) {
  return objToString.call(value) === '[object String]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return type === 'function' || !!value && type === 'object';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isBuiltInObject(value) {
  return !!BUILTIN_OBJECT[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isTypedArray(value) {
  return !!TYPED_ARRAY[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isDom(value) {
  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */


function eqNaN(value) {
  /* eslint-disable-next-line no-self-compare */
  return value !== value;
}
/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */


function retrieve(values) {
  for (var i = 0, len = arguments.length; i < len; i++) {
    if (arguments[i] != null) {
      return arguments[i];
    }
  }
}

function retrieve2(value0, value1) {
  return value0 != null ? value0 : value1;
}

function retrieve3(value0, value1, value2) {
  return value0 != null ? value0 : value1 != null ? value1 : value2;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */


function slice() {
  return Function.call.apply(nativeSlice, arguments);
}
/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */


function normalizeCssArray(val) {
  if (typeof val === 'number') {
    return [val, val, val, val];
  }

  var len = val.length;

  if (len === 2) {
    // vertical | horizontal
    return [val[0], val[1], val[0], val[1]];
  } else if (len === 3) {
    // top | horizontal | bottom
    return [val[0], val[1], val[2], val[1]];
  }

  return val;
}
/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */


function assert(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {string} str string to be trimed
 * @return {string} trimed string
 */


function trim(str) {
  if (str == null) {
    return null;
  } else if (typeof str.trim === 'function') {
    return str.trim();
  } else {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }
}

var primitiveKey = '__ec_primitive__';
/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */

function setAsPrimitive(obj) {
  obj[primitiveKey] = true;
}

function isPrimitive(obj) {
  return obj[primitiveKey];
}
/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */


function HashMap(obj) {
  var isArr = isArray(obj); // Key should not be set on this, otherwise
  // methods get/set/... may be overrided.

  this.data = {};
  var thisMap = this;
  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);

  function visit(value, key) {
    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
  }
}

HashMap.prototype = {
  constructor: HashMap,
  // Do not provide `has` method to avoid defining what is `has`.
  // (We usually treat `null` and `undefined` as the same, different
  // from ES6 Map).
  get: function (key) {
    return this.data.hasOwnProperty(key) ? this.data[key] : null;
  },
  set: function (key, value) {
    // Comparing with invocation chaining, `return value` is more commonly
    // used in this case: `var someVal = map.set('a', genVal());`
    return this.data[key] = value;
  },
  // Although util.each can be performed on this hashMap directly, user
  // should not use the exposed keys, who are prefixed.
  each: function (cb, context) {
    context !== void 0 && (cb = bind(cb, context));
    /* eslint-disable guard-for-in */

    for (var key in this.data) {
      this.data.hasOwnProperty(key) && cb(this.data[key], key);
    }
    /* eslint-enable guard-for-in */

  },
  // Do not use this method if performance sensitive.
  removeKey: function (key) {
    delete this.data[key];
  }
};

function createHashMap(obj) {
  return new HashMap(obj);
}

function concatArray(a, b) {
  var newArray = new a.constructor(a.length + b.length);

  for (var i = 0; i < a.length; i++) {
    newArray[i] = a[i];
  }

  var offset = a.length;

  for (i = 0; i < b.length; i++) {
    newArray[i + offset] = b[i];
  }

  return newArray;
}

function noop() {}

exports.$override = $override;
exports.clone = clone;
exports.merge = merge;
exports.mergeAll = mergeAll;
exports.extend = extend;
exports.defaults = defaults;
exports.createCanvas = createCanvas;
exports.getContext = getContext;
exports.indexOf = indexOf;
exports.inherits = inherits;
exports.mixin = mixin;
exports.isArrayLike = isArrayLike;
exports.each = each;
exports.map = map;
exports.reduce = reduce;
exports.filter = filter;
exports.find = find;
exports.bind = bind;
exports.curry = curry;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports.isString = isString;
exports.isObject = isObject;
exports.isBuiltInObject = isBuiltInObject;
exports.isTypedArray = isTypedArray;
exports.isDom = isDom;
exports.eqNaN = eqNaN;
exports.retrieve = retrieve;
exports.retrieve2 = retrieve2;
exports.retrieve3 = retrieve3;
exports.slice = slice;
exports.normalizeCssArray = normalizeCssArray;
exports.assert = assert;
exports.trim = trim;
exports.setAsPrimitive = setAsPrimitive;
exports.isPrimitive = isPrimitive;
exports.createHashMap = createHashMap;
exports.concatArray = concatArray;
exports.noop = noop;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1),
    PropTypes = __webpack_require__(18),
    withSideEffect = __webpack_require__(553);

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
}

function handleStateChangeOnClient(title) {
  var nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

function DocumentTitle() {}
DocumentTitle.prototype = Object.create(React.Component.prototype);

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired
};

DocumentTitle.prototype.render = function() {
  if (this.props.children) {
    return React.Children.only(this.props.children);
  } else {
    return null;
  }
};

module.exports = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DocumentTitle);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ua=navigator.userAgent.toLowerCase();var UA={};var s=null;UA.ie=(s=ua.match(/(msie\s|trident.*rv:)([\d.]+)/))?s[2]:false;UA.firefox=(s=ua.match(/firefox\/([\d.]+)/))?!!s[1]:false;UA.chrome=(s=ua.match(/chrome\/([\d.]+)/))?!!s[1]:false;UA.opera=(s=ua.match(/opera.([\d.]+)/))?!!s[1]:false;UA.safari=(s=ua.match(/version\/([\d.]+).*safari/))?!!s[1]:false;UA.android=(s=ua.match(/android/))?!!s:false;UA.iphone=(s=ua.match(/iphone os/))?!!s:false;UA.ipad=(s=ua.match(/ipad/))?!!s:false;UA.ios=UA.ipad||UA.iphone;UA.isMobile=UA.android||UA.iphone;UA.isWin32=/win32/i.test(window.navigator.platform);UA.isWeixin=(s=ua.match(/MicroMessenger/i))?!!s:false;//判断是否是在微信浏览器里面
UA.isAli=(s=ua.match(/AlipayClient/i))?!!s:false;//判断是否是在支付宝浏览器里面
UA.isUcweb=(s=ua.match(/ucbrowser/))?!!s:false;UA.isMqq=navigator.userAgent.indexOf("QQ")!==-1;UA.isWeiBo=(s=ua.match(/__weibo__/))?!!s:false;//是否微博浏览器
UA.winClient=(s=ua.match(/winclient/i))?!!s:false;//是否pc客户端
UA.androidClient=(s=ua.match(/ACAndroidClient/i))?!!s:false;//是否安卓客户端
UA.androidTabClient=(s=ua.match(/ACAndroidTabClient/i))?!!s:false;//是否安卓平板客户端
UA.ipadClient=(s=ua.match(/ACIPadClient/i))?!!s:false;//是否ipad客户端
UA.iphoneClient=(s=ua.match(/ACiphoneclient/i))?!!s:false;//是否ipone客户端
UA.miniProgram=(s=ua.match(/miniprogram/i))?!!s:false;// 是否小程序
UA.iosClient=UA.ipadClient||UA.iphoneClient;//是否ios客户端
UA.mobileClient=UA.iphoneClient||UA.androidClient&&!UA.androidTabClient||UA.miniProgram;//是否手机客户端
UA.ACClient=UA.iosClient||UA.winClient||UA.androidClient;//是否客户端
/* harmony default export */ __webpack_exports__["a"] = (UA);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return parseQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parseQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return secondsTypefy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fixZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computeDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parseDate; });
/* unused harmony export getTop */
/* unused harmony export getLeft */
/* unused harmony export getDomPosition */
/* unused harmony export encodeParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return decodeParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return myStorage; });
var parseQueryString=function parseQueryString(param){if(param==null)return"";var pairs=[],str="";for(var prop in param){if(param.hasOwnProperty(prop)){var k=encodeURIComponent(prop),v=encodeURIComponent(param[prop]);pairs.push(k+"="+v);}}str="?"+pairs.join("&");return str;};//url参数转对象
var parseQuery=function parseQuery(query){// query = query.toLowerCase();
var reg=/([^=&\s]+)[=\s]*([^=&\s]*)/g;var obj={};while(reg.exec(query)){obj[RegExp.$1.toLowerCase()]=RegExp.$2;}return obj;};var cookie={set:function set(key,val,time){//设置cookie方法
var date=new Date();//获取当前时间
var expiresDays=time;//将date设置为n天以后的时间
date.setTime(date.getTime()+expiresDays*24*3600*1000);//格式化为cookie识别的时间
document.cookie=key+"="+val+";expires="+date.toGMTString();//设置cookie
},get:function get(key){//获取cookie方法
/*获取cookie参数*/var getCookie=document.cookie.replace(/[ ]/g,"");//获取cookie，并且将获得的cookie格式化，去掉空格字符
var arrCookie=getCookie.split(";");//将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
var tips;//声明变量tips
for(var i=0;i<arrCookie.length;i++){//使用for循环查找cookie中的tips变量
var arr=arrCookie[i].split("=");//将单条cookie用"等号"为标识，将单条cookie保存为arr数组
if(key===arr[0]){//匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
tips=arr[1];//将cookie的值赋给变量tips
break;//终止for循环遍历
}}return tips;},delete:function _delete(key){//删除cookie方法
var date=new Date();//获取当前时间
date.setTime(date.getTime()-10000);//将date设置为过去的时间
document.cookie=key+"=v; expires ="+date.toGMTString();//设置cookie
}};//秒格式化
var secondsTypefy=function secondsTypefy(seconds){return fixZero(Math.floor(seconds/60),2)+":"+fixZero(Math.ceil(seconds%60),2);};//补零
var fixZero=function fixZero(value,num){var len=(""+value).length;return Array(num>len?num-len+1||0:0).join(0)+value;};//计算日期 传入秒
var computeDate=function computeDate(startTime,diffTime){var date=new Date((startTime+diffTime*24*3600)*1000);return date.getFullYear()+"\u5E74"+fixZero(date.getMonth()+1,2)+"\u6708"+fixZero(date.getDate(),2)+"\u65E5";};// 日期格式化
var parseDate=function parseDate(timestamp){if(timestamp){var date=new Date(timestamp);return date.getFullYear()+"-"+fixZero(date.getMonth()+1,2)+"-"+fixZero(date.getDate(),2);}};//获取元素的纵坐标
var getTop=function getTop(e){var offset=e.offsetTop;if(e.offsetParent!=null)offset+=getTop(e.offsetParent);return offset;};// 获取元素的横坐标
var getLeft=function getLeft(e){var offset=e.offsetLeft;if(e.offsetParent!=null)offset+=getLeft(e.offsetParent);return offset;};// 获取dom位置信息
var getDomPosition=function getDomPosition(dom){if(dom){console.log("----");return Array.from(dom).map(function(node){var style=null;if(window.getComputedStyle){style=window.getComputedStyle(node,null);// 非IE
}else{style=node.currentStyle;// IE
}var _ref=node.getBoundingClientRect()||{},t=_ref.top,l=_ref.left;// const top = parseInt(node.offsetTop, 10);     //相对于父元素
// const left = parseInt(node.offsetLeft, 10);   //相对于父元素
var top=parseInt(t,10);// 相对于窗口
var left=parseInt(l,10);// 相对于窗口
var width=parseInt(style.width,10);var height=parseInt(style.height,10);return{left:left,top:top,width:width,height:height};});}else{return[];}};// 解决数据中有单引号问题
var encodeParams=function encodeParams(params){var dataJson=JSON.stringify(params);return dataJson.replace(/'/,"$d$");};var decodeParams=function decodeParams(str){var dataJson=str.replace(/\$d\$/g,"'");return JSON.parse(dataJson);};// 重写storage
var myStorage={storage:window.localStorage,init:function init(){window.myStorageData={};},setItem:function setItem(keyName,keyValue){this.storage.setItem(keyName,keyValue);window.myStorageData[keyName]=keyValue;},getItem:function getItem(keyName){var value=this.storage.getItem(keyName);if(!value)value=window.myStorageData&&window.myStorageData[keyName];return value;},removeItem:function removeItem(keyName){this.storage.removeItem(keyName);window.myStorageData[keyName]=null;}};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pdabc_api_sign__ = __webpack_require__(585);
/**
 * 调用方式：AXIOS.func({ data:{}, query:{} }, callback(res,err){ })
 */var defaults=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:__WEBPACK_IMPORTED_MODULE_2__env__["a" /* default */].apiBaseUrl});//获取token
var token="";if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].ACClient){token=JSON.parse(__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].getClientDataSync({data:["token"]})).token;}else if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].miniProgram){token=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1)).accessToken||"";}else{token=__WEBPACK_IMPORTED_MODULE_3__utils_tools__["e" /* myStorage */].getItem("ac_token")||"1f6ce06b52fb415a901486da642f1f59";// 临时测试服token
}__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common["access-token"]=token;__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post["Content-Type"]="application/json;charset=utf-8";// 埋点请求
var bpRequest=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({headers:{"access-token":token,"Content-Type":"application/json;charset=UTF-8"},baseURL:__WEBPACK_IMPORTED_MODULE_2__env__["a" /* default */].bpBaseUrl,timeout:15000});//接口地址列表
var API={LOGIN:"/ac-common/oauth/sms/stu",//登录
SMSCODE:"/ac-common/ms-code/v2",//短信验证码
SMSCODEPD:"/pdabc-common/sms-code",//爱课英语小班短信验证码
GETINFO_BYID:"/ac-common/user-stu",//学生信息
STU_COURSE:"/ac-client/stu-course",//学生课程列表
GETLIST_GOODS:"/ac-client/goods-info",//套餐列表
GET_GOOD_INFO:"/ac-order/goods-info/detail",// 单个套餐
GETORDER_WEIXIN:"/ac-order/order-info",//下单
GETORDER_LIST:"/ac-order/order-info",//订单列表列表
GETORDER_STATUS:"/ac-order/order-info",//查询订单
PAY_WEIXIN:"/ac-order/wxpay",//微信支付
PAY_ALI:"/ac-order/alipay",//支付宝支付
STUHOMEWORK_SINGLE:"/ac-client/stu-work-detail/getByStuIdAndClassSchId",//学生作业详情
STUHOMEWORK_LIST:"/ac-client/stu-work-detail/listByStuId",//学生作业列表
PAY_TEST:"/ac-order/tmp/buy",//支付测试
WEIXIN_SHARE:"/ac-common/wx/getShareParam",//获取微信配置
DOWORK:"/ac-client/stu-work-detail/do",//做作业
WORKINFO:"/ac-client/class-sch/workInfo",//获取作业列表
WORKINFO_NEW:"/ac-client/class-sch/workInfo2",//获取作业列表新
ADD_ADDRESS:"/ac-common/user-address",//新增用户地址
GET_ADDRESS:"/ac-common/user-address/listByUserId",//根据userid查询用户地址
GET_LOGISTICS:"/ac-order/waybill-info/listByUserId",//查询用户运单信息
GET_COURSE_INFO:"/ac-client/course-info/stu/v3",//查询课程信息
GET_DISCOUNT_LIST:"/ac-order/coupon-info/listByGoodsId",// 查询优惠券列表
GOODS_INVITE_AWARD:"/ac-order/goods-invite-award",// 套餐赠品
HOMEWOER_SAVE:"/ac-client/stu-work-detail/do/save",// 作业一题一保存
HOMEWOER_END:"/ac-client/stu-work-detail/do/end",// 作业结束
HOMEWOER_DETAIL:"/ac-client/stu-work-detail/getWorkDetail",// 获取作业进度
HOMEWOER_BP:"/ac-client/bp/question-answer",// 作业埋点（教研）
FEED_BACK_LIST:"/ac-client/help-center/question/list",// 帮助与反馈问题列表
FEED_BACK_DETAIL:"/ac-client/help-center/question/detail",// 帮助与反馈问题详情
CUSTOMER_SERVICE_QRCODE:"/ac-client/help-center/customer-service/qr-code",// 公众号二维码
SHARE_CONFIG:"/ac-client/share-config/list",// 获取分享配置
SHARE_CONFIG_BY_KEY:"/ac-client/share-config/getByKey",// 获取分享配置
SHARE_BP:"/bp/ac-share",// 分享数据记录
AC_CLIENT_BP:"/bp/ac-client",// 客户端埋点
WRITE_OFF:"/common/oauth/writeOff",// ac客户端注销功能
WRITE_OFF_PD:"/pdabc-common/oauth/writeOff",// pd客户端注销功能
GET_CLASS_PLAN:"/ac-client/class-regular-plan/list",// 获取学习计划
UPDATE_CLASS_PLAN:"/ac-client/class-regular-plan/update"};//接口方法列表
var AXIOS={login:function login(params,cb){return send(API.LOGIN,"POST",params,cb);},smsCode:function smsCode(params,cb){return send(API.SMSCODE,"POST",params,cb);},smsCodePd:function smsCodePd(params,cb){return send(API.SMSCODEPD,"POST",params,cb);},getInfoById:function getInfoById(params,cb){return send(API.GETINFO_BYID,"GET",params,cb);},getStuCourse:function getStuCourse(params,cb){return send(API.STU_COURSE,"GET",params,cb);},getGoodsInfo:function getGoodsInfo(params,cb){return send(API.GETLIST_GOODS,"GET",params,cb);},getGoodInfo:function getGoodInfo(params,cb){return send(API.GET_GOOD_INFO,"GET",params,cb);},getWxOrder:function getWxOrder(params,cb){return send(API.GETORDER_WEIXIN,"POST",params,cb);},getOrderList:function getOrderList(params,cb){return send(API.GETORDER_LIST,"GET",params,cb);},getOrderStatus:function getOrderStatus(params,cb){return send(API.GETORDER_STATUS,"GET",params,cb);},payWeixin:function payWeixin(params,cb){return send(API.PAY_WEIXIN,"POST",params,cb,true);},payAli:function payAli(params,cb){return send(API.PAY_ALI,"POST",params,cb,true);},getStuHomeworkSingle:function getStuHomeworkSingle(params,cb){return send(API.STUHOMEWORK_SINGLE,"GET",params,cb);},getStuHomeworkList:function getStuHomeworkList(params,cb){return send(API.STUHOMEWORK_LIST,"GET",params,cb);},payTest:function payTest(params,cb){return send(API.PAY_TEST,"POST",params,cb);},weixinShare:function weixinShare(params,cb){return send(API.WEIXIN_SHARE,"POST",params,cb);},doWork:function doWork(params,cb){return send(API.DOWORK,"POST",params,cb);},getWorkInfo:function getWorkInfo(params,cb){return send(API.WORKINFO,"GET",params,cb);},getWorkInfoNew:function getWorkInfoNew(params,cb){return send(API.WORKINFO_NEW,"GET",params,cb);},addAddress:function addAddress(params,cb){return send(API.ADD_ADDRESS,"POST",params,cb);},setAddress:function setAddress(params,cb){return send(API.ADD_ADDRESS,"PUT",params,cb);},getAddress:function getAddress(params,cb){return send(API.GET_ADDRESS,"GET",params,cb);},getLogistics:function getLogistics(params,cb){return send(API.GET_LOGISTICS,"GET",params,cb);},getCourseInfo:function getCourseInfo(params,cb){return send(API.GET_COURSE_INFO,"GET",params,cb);},getDiscountList:function getDiscountList(params,cb){return send(API.GET_DISCOUNT_LIST,"GET",params,cb);},getGoodsInviteAward:function getGoodsInviteAward(params,cb){return send(API.GOODS_INVITE_AWARD,"GET",params,cb);},homeworkSave:function homeworkSave(params,cb){return send(API.HOMEWOER_SAVE,"POST",params,cb);},homeworkEnd:function homeworkEnd(params,cb){return send(API.HOMEWOER_END,"POST",params,cb);},homeworkDetail:function homeworkDetail(params,cb){return send(API.HOMEWOER_DETAIL,"GET",params,cb);},homeworkBp:function homeworkBp(params,cb){return send(API.HOMEWOER_BP,"POST",params,cb);},getFeedBackList:function getFeedBackList(params,cb){return send(API.FEED_BACK_LIST,"GET",params,cb);},getFeedBackDetail:function getFeedBackDetail(params,cb){return send(API.FEED_BACK_DETAIL,"GET",params,cb);},getCsQrCode:function getCsQrCode(params,cb){return send(API.CUSTOMER_SERVICE_QRCODE,"GET",params,cb);},getShareConfig:function getShareConfig(params,cb){return send(API.SHARE_CONFIG,"GET",params,cb);},getShareConfigByKey:function getShareConfigByKey(params,cb){return send(API.SHARE_CONFIG_BY_KEY,"GET",params,cb);},shareBp:function shareBp(params,cb){return send(API.SHARE_BP,"POST",params,cb);},getLearningReport:function getLearningReport(params,cb){return send("/ac-client/stu-learning-report","GET",params,cb);},getLearningRecent:function getLearningRecent(params,cb){return send("/ac-client/stu-lesson-detail/recent","POST",params,cb);},// 获取到课打卡活动信息
getDailyAttendanceContent:function getDailyAttendanceContent(params,cb){return send("/ac-client/activity/attendLesson/stu","GET",params,cb);},// 获取用户到课奖励流水
getDailyAttendanceDetail:function getDailyAttendanceDetail(params,cb){return send("/ac-client/user-award-detail/attendLesson/stu","GET",params,cb);},// 每日打卡奖励的收货地址
addDailyAttendanceAddress:function addDailyAttendanceAddress(params,cb){return send("/ac-client/waybill-info/attendLessonConsigneeInfo","POST",params,cb);},// 跟读作品列表
getReadWorksList:function getReadWorksList(params,cb){return send("/ac-client/stu-course-section/readWork/list","GET",params,cb);},// 埋点
acClientBp:function acClientBp(params,cb){var channel=null;if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].winClient){channel="Windows";}if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].iphoneClient){channel="iPhone";}if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].ipadClient){channel="iPad";}if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].androidClient){channel="Android";}if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].androidTabClient){channel="AndroidPad";}params.data=Object.assign({},params.data,{remarkTime:new Date().getTime(),channel:channel});var config={url:API.AC_CLIENT_BP,method:"POST",data:params.data// withCredentials: true,
};return bpRequest(config);},writeOff:function writeOff(params,cb){return send(API.WRITE_OFF,"POST",params,cb);},writeOffPd:function writeOffPd(params,cb){return send(API.WRITE_OFF_PD,"POST",params,cb);},getClassPlan:function getClassPlan(params,cb){return send(API.GET_CLASS_PLAN,"GET",params,cb);},updateClassPlan:function updateClassPlan(params,cb){return send(API.UPDATE_CLASS_PLAN,"POST",params,cb);},getOrgInfo:function getOrgInfo(channelId,cb){return send("/ac-lesson2/org-info/"+channelId,"GET",{},cb);},// 第二教室 - 获取机构信息
changeOrg:function changeOrg(params,cb){return send("/ac-lesson2/org-info/change","POST",params,cb);},// 第二教室 - 切换机构
getOrgList:function getOrgList(params,cb){return send("/ac-lesson2/org-info/stu","GET",params,cb);}// 第二教室 - 切换机构
};function send(api){var method=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"GET";var params=arguments[2];var cb=arguments[3];var query=params.query,data=params.data;var url="";if(params){// query如果是string 直接拼在请求链接里
if(typeof query==="string"){url="/"+query;}// get方式 query转成参数拼在请求链接里
if(method==="GET"){url=""+url+Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["h" /* parseQueryString */])(data);}}var config={method:method,withCredentials:true};if(method==="POST"){config.url=api;config.data=data;}else{if(method==="PUT"){config.data=data;}config.url=api+url;}var signHeader=Object(__WEBPACK_IMPORTED_MODULE_5__pdabc_api_sign__["a" /* createHeader */])(config.url,{extraParams:config.data});config.headers=signHeader;return defaults.request(config).then(function(res){console.log("==========>接口响应res",res);if(res.data.errorCode===0&&api==="/ac-order/alipay"){typeof cb==="function"&&cb(res.data);return res.data;}if(res.data.errorCode===0){typeof cb==="function"&&cb(res.data.data);}else{typeof cb==="function"&&cb(null,{errorCode:res.data.errorCode,errorMessage:res.data.errorMessage});__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].httpError({errorCode:res.data.errorCode,errorMessage:res.data.errorMessage});}return res.data;}).catch(function(error){console.log("==========>接口响应error",error);typeof cb==="function"&&cb(null,error);return error;});}/* harmony default export */ __webpack_exports__["a"] = (AXIOS);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(550);
/*
 *调用方式：clientApi.func({key:value})
 */var API_TAG={H5_MESSAGE:"h5Message",// 发送数据给客户端
GETCLIENTDATA:"getClientData",// 异步获取客户端数据 （弃用）
GETCLIENTDATASYNC:"getClientDataSync",// 同步获取客户端数据
PAYRESULT:"payResult",// 通知客户端付钱结果（PC端）
HTTPERROR:"errorOccuredInH5",// 通知客户端H5接口错误
RECORD_TEST:"evaluate",// 发起语音评测
HOMEWORK_PLAYBACK:"homeworkPlayback",// 播放语音评测录音
CLOSE_PAGE:"closeH5Page",// 关闭H5页面
RESTARTHOMEWORK:"restartHomework",// 重做作业
COMPLETEHOMEWORK:"homeworkDone",// 作业完成
EVENT_TRACKING:"eventTracking",// 事件埋点
ALERT_VIEW:"alertView",//让客户端弹框
ANCHOR_CLIENT:"anchorClient",// 通知客户端滑动到锚点
APPLE_IAP:"appleIAP",// 通知ios调起内购
OPEN_BROSWER:"openBroswer",// 通知打开外部浏览器
BACK_REQUIRED:"backRequired",// 通知退出二次确认
SHARE_NEW:"h5ShareNew",// 客户端分享功能
DISPLAY_LESSON_DETAIL:"displayLessonDetail",// 显示课节详情页
WEBVIEW_DIRECTION:"webviewDirection",// 调整webview方向
TO_CLIENT_LOGIN:"toClientLogin"// 跳转到登录界面
};var clientApi={h5Message:function h5Message(params){return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.H5_MESSAGE,params);},getClientData:function getClientData(params){return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.GETCLIENTDATA,params);},getClientDataSync:function getClientDataSync(params){return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.GETCLIENTDATASYNC,params);},payResult:function payResult(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.PAYRESULT,params);},httpError:function httpError(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.HTTPERROR,params);},recordTest:function recordTest(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.RECORD_TEST,params);},homeworkPlayback:function homeworkPlayback(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.HOMEWORK_PLAYBACK,params);},closeH5Page:function closeH5Page(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.CLOSE_PAGE,params);},restartHomework:function restartHomework(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.RESTARTHOMEWORK,params);},completeHomework:function completeHomework(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.COMPLETEHOMEWORK,params);},eventTracking:function eventTracking(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.EVENT_TRACKING,params);},alertView:function alertView(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.ALERT_VIEW,params);},anchorClient:function anchorClient(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.ANCHOR_CLIENT,params);},appleIAP:function appleIAP(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.APPLE_IAP,params);},openBroswer:function openBroswer(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.OPEN_BROSWER,params);},backRequired:function backRequired(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.BACK_REQUIRED,params);},shareNew:function shareNew(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.SHARE_NEW,params);},showLessonDetail:function showLessonDetail(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.DISPLAY_LESSON_DETAIL,params);},webviewDirection:function webviewDirection(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.WEBVIEW_DIRECTION,params);},toClientLogin:function toClientLogin(params){Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(API_TAG.TO_CLIENT_LOGIN,params);}};/* harmony default export */ __webpack_exports__["a"] = (clientApi);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(104)('wks');
var uid = __webpack_require__(65);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var env = __webpack_require__(25);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var isArray = zrUtil.isArray;
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */

var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 * @param {Object} opt
 * @param {string} key
 * @param {Array.<string>} subOpts
 */


function defaultEmphasis(opt, key, subOpts) {
  // Caution: performance sensitive.
  if (opt) {
    opt[key] = opt[key] || {};
    opt.emphasis = opt.emphasis || {};
    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
        opt.emphasis[key][subOptName] = opt[key][subOptName];
      }
    }
  }
}

var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * The method do not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */

function getDataItemValue(dataItem) {
  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */


function isDataItemOption(dataItem) {
  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */


function mappingToExists(exists, newCptOptions) {
  // Mapping by the order by original option (but not order of
  // new option) in merge mode. Because we should ensure
  // some specified index (like xAxisIndex) is consistent with
  // original option, which is easy to understand, espatially in
  // media query. And in most case, merge option is used to
  // update partial option but not be expected to change order.
  newCptOptions = (newCptOptions || []).slice();
  var result = zrUtil.map(exists || [], function (obj, index) {
    return {
      exist: obj
    };
  }); // Mapping by id or name if specified.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    } // id has highest priority.


    for (var i = 0; i < result.length; i++) {
      if (!result[i].option // Consider name: two map to one.
      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }

    for (var i = 0; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Consider name: two map to one.
      // Can not match when both ids exist but different.
      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }
  }); // Otherwise mapping by index.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    }

    var i = 0;

    for (; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Existing model that already has id should be able to
      // mapped to (because after mapping performed model may
      // be assigned with a id, whish should not affect next
      // mapping), except those has inner id.
      && !isIdInner(exist) // Caution:
      // Do not overwrite id. But name can be overwritten,
      // because axis use name as 'show label text'.
      // 'exist' always has id and name and we dont
      // need to check it.
      && cptOption.id == null) {
        result[i].option = cptOption;
        break;
      }
    }

    if (i >= result.length) {
      result.push({
        option: cptOption
      });
    }
  });
  return result;
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = zrUtil.createHashMap();
  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    existCpt && idMap.set(existCpt.id, item);
  });
  each(mapResult, function (item, index) {
    var opt = item.option;
    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    var opt = item.option;
    var keyInfo = item.keyInfo;

    if (!isObject(opt)) {
      return;
    } // name can be overwitten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
    // because name may be used like in color pallet.
    : DUMMY_COMPONENT_NAME_PREFIX + index;

    if (existCpt) {
      keyInfo.id = existCpt.id;
    } else if (opt.id != null) {
      keyInfo.id = opt.id + '';
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}

function isNameSpecified(componentModel) {
  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.

  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
}
/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */


function isIdInner(cptOption) {
  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = sourceBatch[i].seriesId;
      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */


function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      var fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */


function makeInner() {
  // Consider different scope by es module import.
  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
  return function (hostObj) {
    return hostObj[key] || (hostObj[key] = {});
  };
}

var innerUniqueIndex = 0;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */

function parseFinder(ecModel, finder, opt) {
  if (zrUtil.isString(finder)) {
    var obj = {};
    obj[finder + 'Index'] = 0;
    finder = obj;
  }

  var defaultMainType = opt && opt.defaultMainType;

  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
    finder[defaultMainType + 'Index'] = 0;
  }

  var result = {};
  each(finder, function (value, key) {
    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.

    if (key === 'dataIndex' || key === 'dataIndexInside') {
      result[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    var queryParam = {
      mainType: mainType
    };

    if (queryType !== 'index' || value !== 'all') {
      queryParam[queryType] = value;
    }

    var models = ecModel.queryComponents(queryParam);
    result[mainType + 'Models'] = models;
    result[mainType + 'Model'] = models[0];
  });
  return result;
}

function has(obj, prop) {
  return obj && obj.hasOwnProperty(prop);
}

function setAttribute(dom, key, value) {
  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}

function getAttribute(dom, key) {
  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}

function getTooltipRenderMode(renderModeOption) {
  if (renderModeOption === 'auto') {
    // Using html when `document` exists, use richText otherwise
    return env.domSupported ? 'html' : 'richText';
  } else {
    return renderModeOption || 'html';
  }
}
/**
 * Group a list by key.
 *
 * @param {Array} array
 * @param {Function} getKey
 *        param {*} Array item
 *        return {string} key
 * @return {Object} Result
 *        {Array}: keys,
 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
 */


function groupData(array, getKey) {
  var buckets = zrUtil.createHashMap();
  var keys = [];
  zrUtil.each(array, function (item) {
    var key = getKey(item);
    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
  });
  return {
    keys: keys,
    buckets: buckets
  };
}

exports.normalizeToArray = normalizeToArray;
exports.defaultEmphasis = defaultEmphasis;
exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
exports.getDataItemValue = getDataItemValue;
exports.isDataItemOption = isDataItemOption;
exports.mappingToExists = mappingToExists;
exports.makeIdAndName = makeIdAndName;
exports.isNameSpecified = isNameSpecified;
exports.isIdInner = isIdInner;
exports.compressBatches = compressBatches;
exports.queryDataIndex = queryDataIndex;
exports.makeInner = makeInner;
exports.parseFinder = parseFinder;
exports.setAttribute = setAttribute;
exports.getAttribute = getAttribute;
exports.getTooltipRenderMode = getTooltipRenderMode;
exports.groupData = groupData;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(184);
var toPrimitive = __webpack_require__(45);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(47);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var pathTool = __webpack_require__(263);

var colorTool = __webpack_require__(99);

var matrix = __webpack_require__(74);

var vector = __webpack_require__(26);

var Path = __webpack_require__(27);

var Transformable = __webpack_require__(253);

var ZImage = __webpack_require__(171);

exports.Image = ZImage;

var Group = __webpack_require__(98);

exports.Group = Group;

var Text = __webpack_require__(174);

exports.Text = Text;

var Circle = __webpack_require__(267);

exports.Circle = Circle;

var Sector = __webpack_require__(824);

exports.Sector = Sector;

var Ring = __webpack_require__(825);

exports.Ring = Ring;

var Polygon = __webpack_require__(269);

exports.Polygon = Polygon;

var Polyline = __webpack_require__(271);

exports.Polyline = Polyline;

var Rect = __webpack_require__(272);

exports.Rect = Rect;

var Line = __webpack_require__(273);

exports.Line = Line;

var BezierCurve = __webpack_require__(828);

exports.BezierCurve = BezierCurve;

var Arc = __webpack_require__(829);

exports.Arc = Arc;

var CompoundPath = __webpack_require__(830);

exports.CompoundPath = CompoundPath;

var LinearGradient = __webpack_require__(274);

exports.LinearGradient = LinearGradient;

var RadialGradient = __webpack_require__(831);

exports.RadialGradient = RadialGradient;

var BoundingRect = __webpack_require__(33);

exports.BoundingRect = BoundingRect;

var IncrementalDisplayable = __webpack_require__(832);

exports.IncrementalDisplayable = IncrementalDisplayable;

var subPixelOptimizeUtil = __webpack_require__(175);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var mathMax = Math.max;
var mathMin = Math.min;
var EMPTY_OBJ = {};
var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.

var CACHED_LABEL_STYLE_PROPERTIES = {
  color: 'textFill',
  textBorderColor: 'textStroke',
  textBorderWidth: 'textStrokeWidth'
};
var EMPHASIS = 'emphasis';
var NORMAL = 'normal'; // Reserve 0 as default.

var _highlightNextDigit = 1;
var _highlightKeyMap = {};
var _customShapeMap = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return Path.extend(opts);
}
/**
 * Extend path
 */


function extendPath(pathData, opts) {
  return pathTool.extendFromString(pathData, opts);
}
/**
 * Register a user defined shape.
 * The shape class can be fetched by `getShapeClass`
 * This method will overwrite the registered shapes, including
 * the registered built-in shapes, if using the same `name`.
 * The shape can be used in `custom series` and
 * `graphic component` by declaring `{type: name}`.
 *
 * @param {string} name
 * @param {Object} ShapeClass Can be generated by `extendShape`.
 */


function registerShape(name, ShapeClass) {
  _customShapeMap[name] = ShapeClass;
}
/**
 * Find shape class registered by `registerShape`. Usually used in
 * fetching user defined shape.
 *
 * [Caution]:
 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
 * to use user registered shapes.
 * Because the built-in shape (see `getBuiltInShape`) will be registered by
 * `registerShape` by default. That enables users to get both built-in
 * shapes as well as the shapes belonging to themsleves. But users can overwrite
 * the built-in shapes by using names like 'circle', 'rect' via calling
 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
 * in case that it is overwritten by users, except that some features, like
 * `custom series`, `graphic component`, do it deliberately.
 *
 * (2) In the features like `custom series`, `graphic component`, the user input
 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
 * are reserved names, that is, if some user register a shape named `'image'`,
 * the shape will not be used. If we intending to add some more reserved names
 * in feature, that might bring break changes (disable some existing user shape
 * names). But that case probably rearly happen. So we dont make more mechanism
 * to resolve this issue here.
 *
 * @param {string} name
 * @return {Object} The shape class. If not found, return nothing.
 */


function getShapeClass(name) {
  if (_customShapeMap.hasOwnProperty(name)) {
    return _customShapeMap[name];
  }
}
/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makePath(pathData, opts, rect, layout) {
  var path = pathTool.createFromString(pathData, opts);

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, path.getBoundingRect());
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makeImage(imageUrl, rect, layout) {
  var path = new ZImage({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        path.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return path;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */


function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath = pathTool.mergePath;
/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeLine(param) {
  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeRect(param) {
  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.


var liftedColorMap = zrUtil.createHashMap();
var liftedColorCount = 0;

function liftColor(color) {
  if (typeof color !== 'string') {
    return color;
  }

  var liftedColor = liftedColorMap.get(color);

  if (!liftedColor) {
    liftedColor = colorTool.lift(color, -0.1);

    if (liftedColorCount < 10000) {
      liftedColorMap.set(color, liftedColor);
      liftedColorCount++;
    }
  }

  return liftedColor;
}

function cacheElementStl(el) {
  if (!el.__hoverStlDirty) {
    return;
  }

  el.__hoverStlDirty = false;
  var hoverStyle = el.__hoverStl;

  if (!hoverStyle) {
    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
    return;
  }

  var normalStyle = el.__cachedNormalStl = {};
  el.__cachedNormalZ2 = el.z2;
  var elStyle = el.style;

  for (var name in hoverStyle) {
    // See comment in `singleEnterEmphasis`.
    if (hoverStyle[name] != null) {
      normalStyle[name] = elStyle[name];
    }
  } // Always cache fill and stroke to normalStyle for lifting color.


  normalStyle.fill = elStyle.fill;
  normalStyle.stroke = elStyle.stroke;
}

function singleEnterEmphasis(el) {
  var hoverStl = el.__hoverStl;

  if (!hoverStl || el.__highlighted) {
    return;
  }

  var zr = el.__zr;
  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
  el.__highlighted = useHoverLayer ? 'layer' : 'plain';

  if (el.isGroup || !zr && el.useHoverLayer) {
    return;
  }

  var elTarget = el;
  var targetStyle = el.style;

  if (useHoverLayer) {
    elTarget = zr.addHover(el);
    targetStyle = elTarget.style;
  }

  rollbackDefaultTextStyle(targetStyle);

  if (!useHoverLayer) {
    cacheElementStl(elTarget);
  } // styles can be:
  // {
  //    label: {
  //        show: false,
  //        position: 'outside',
  //        fontSize: 18
  //    },
  //    emphasis: {
  //        label: {
  //            show: true
  //        }
  //    }
  // },
  // where properties of `emphasis` may not appear in `normal`. We previously use
  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
  // But consider rich text and setOption in merge mode, it is impossible to cover
  // all properties in merge. So we use merge mode when setting style here.
  // But we choose the merge strategy that only properties that is not `null/undefined`.
  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
  // But this strategy brings a trouble that `null/undefined` can not be used to remove
  // style any more in `emphasis`. Users can both set properties directly on normal and
  // emphasis to avoid this issue, or we might support `'none'` for this case if required.


  targetStyle.extendFrom(hoverStl);
  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
  applyDefaultTextStyle(targetStyle);

  if (!useHoverLayer) {
    el.dirty(false);
    el.z2 += Z2_EMPHASIS_LIFT;
  }
}

function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
    targetStyle[prop] = liftColor(targetStyle[prop]);
  }
}

function singleEnterNormal(el) {
  var highlighted = el.__highlighted;

  if (!highlighted) {
    return;
  }

  el.__highlighted = false;

  if (el.isGroup) {
    return;
  }

  if (highlighted === 'layer') {
    el.__zr && el.__zr.removeHover(el);
  } else {
    var style = el.style;
    var normalStl = el.__cachedNormalStl;

    if (normalStl) {
      rollbackDefaultTextStyle(style);
      el.setStyle(normalStl);
      applyDefaultTextStyle(style);
    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
    // when `el` is on emphasis state. So here by comparing with 1, we try
    // hard to make the bug case rare.


    var normalZ2 = el.__cachedNormalZ2;

    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
      el.z2 = normalZ2;
    }
  }
}

function traverseUpdate(el, updater, commonParam) {
  // If root is group, also enter updater for `highDownOnUpdate`.
  var fromState = NORMAL;
  var toState = NORMAL;
  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.

  el.__highlighted && (fromState = EMPHASIS, trigger = true);
  updater(el, commonParam);
  el.__highlighted && (toState = EMPHASIS, trigger = true);
  el.isGroup && el.traverse(function (child) {
    !child.isGroup && updater(child, commonParam);
  });
  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
}
/**
 * Set hover style (namely "emphasis style") of element, based on the current
 * style of the given `el`.
 * This method should be called after all of the normal styles have been adopted
 * to the `el`. See the reason on `setHoverStyle`.
 *
 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
 *        Often used when item group has a label element and it's hoverStyle is different.
 * @param {Object|boolean} [hoverStl] The specified hover style.
 *        If set as `false`, disable the hover style.
 *        Similarly, The `el.hoverStyle` can alse be set
 *        as `false` to disable the hover style.
 *        Otherwise, use the default hover style if not provided.
 */


function setElementHoverStyle(el, hoverStl) {
  // For performance consideration, it might be better to make the "hover style" only the
  // difference properties from the "normal style", but not a entire copy of all styles.
  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
  el.__hoverStlDirty = true; // FIXME
  // It is not completely right to save "normal"/"emphasis" flag on elements.
  // It probably should be saved on `data` of series. Consider the cases:
  // (1) A highlighted elements are moved out of the view port and re-enter
  // again by dataZoom.
  // (2) call `setOption` and replace elements totally when they are highlighted.

  if (el.__highlighted) {
    // Consider the case:
    // The styles of a highlighted `el` is being updated. The new "emphasis style"
    // should be adapted to the `el`. Notice here new "normal styles" should have
    // been set outside and the cached "normal style" is out of date.
    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
    // of this method. In most cases, `z2` is not set and hover style should be able
    // to rollback. Of course, that would bring bug, but only in a rare case, see
    // `doSingleLeaveHover` for details.

    singleEnterNormal(el);
    singleEnterEmphasis(el);
  }
}

function onElementMouseOver(e) {
  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
}

function onElementMouseOut(e) {
  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
}

function onElementEmphasisEvent(highlightDigit) {
  this.__highByOuter |= 1 << (highlightDigit || 0);
  traverseUpdate(this, singleEnterEmphasis);
}

function onElementNormalEvent(highlightDigit) {
  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
}

function shouldSilent(el, e) {
  return el.__highDownSilentOnTouch && e.zrByTouch;
}
/**
 * Set hover style (namely "emphasis style") of element,
 * based on the current style of the given `el`.
 *
 * (1)
 * **CONSTRAINTS** for this method:
 * <A> This method MUST be called after all of the normal styles having been adopted
 * to the `el`.
 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
 * "normal style" having been set to the el.
 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
 * a default hover style).
 *
 * The reason: this method treat the current style of the `el` as the "normal style"
 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
 * logic, where the el should shift from the original emphasis style to the new
 * "emphasis style" and should be able to "downplay" back to the new "normal style".
 *
 * Indeed, it is error-prone to make a interface has so many constraints, but I have
 * not found a better solution yet to fit the backward compatibility, performance and
 * the current programming style.
 *
 * (2)
 * Call the method for a "root" element once. Do not call it for each descendants.
 * If the descendants elemenets of a group has itself hover style different from the
 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
 * not call this method for them.
 *
 * (3) These input parameters can be set directly on `el`:
 *
 * @param {module:zrender/Element} el
 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
 */


function setHoverStyle(el, hoverStyle) {
  setAsHighDownDispatcher(el, true);
  traverseUpdate(el, setElementHoverStyle, hoverStyle);
}
/**
 * @param {module:zrender/Element} el
 * @param {Function} [el.highDownOnUpdate] Called when state updated.
 *        Since `setHoverStyle` has the constraint that it must be called after
 *        all of the normal style updated, `highDownOnUpdate` is not needed to
 *        trigger if both `fromState` and `toState` is 'normal', and needed to
 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
 *        to sync outside style settings to "emphasis" state.
 *        @this {string} This dispatcher `el`.
 *        @param {string} fromState Can be "normal" or "emphasis".
 *               `fromState` might equal to `toState`,
 *               for example, when this method is called when `el` is
 *               on "emphasis" state.
 *        @param {string} toState Can be "normal" or "emphasis".
 *
 *        FIXME
 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
 *        Because it is not a complete solution. The update
 *        listener should not have been mount in element,
 *        and the normal/emphasis state should not have
 *        mantained on elements.
 *
 * @param {boolean} [el.highDownSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conveniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, `highDownSilentOnTouch` should be used to disable
 *        hover-highlight on touch device.
 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
 */


function setAsHighDownDispatcher(el, asDispatcher) {
  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.

  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
  // called for each elements of a group in some cases.

  if (!disable || el.__highDownDispatcher) {
    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.

    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.

    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.

    el.__highByOuter = el.__highByOuter || 0;
    el.__highDownDispatcher = !disable;
  }
}
/**
 * @param {module:zrender/src/Element} el
 * @return {boolean}
 */


function isHighDownDispatcher(el) {
  return !!(el && el.__highDownDispatcher);
}
/**
 * Support hightlight/downplay record on each elements.
 * For the case: hover highlight/downplay (legend, visualMap, ...) and
 * user triggerred hightlight/downplay should not conflict.
 * Only all of the highlightDigit cleared, return to normal.
 * @param {string} highlightKey
 * @return {number} highlightDigit
 */


function getHighlightDigit(highlightKey) {
  var highlightDigit = _highlightKeyMap[highlightKey];

  if (highlightDigit == null && _highlightNextDigit <= 32) {
    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
  }

  return highlightDigit;
}
/**
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {string|Function} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */


function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
  opt = opt || EMPTY_OBJ;
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
  // is not supported util someone requests.

  var showNormal = normalModel.getShallow('show');
  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.

  var baseText;

  if (showNormal || showEmphasis) {
    if (labelFetcher) {
      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex);
    }

    if (baseText == null) {
      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
    }
  }

  var normalStyleText = showNormal ? baseText : null;
  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.

  if (normalStyleText != null || emphasisStyleText != null) {
    // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.
    // If we set default values on `emphasisStyle`, consider case:
    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
    // Then the 'red' will not work on emphasis.
    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
  }

  normalStyle.text = normalStyleText;
  emphasisStyle.text = emphasisStyleText;
}
/**
 * Modify label style manually.
 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
 *
 * @param {module:zrender/src/Element} el
 * @param {Object} [normalStyleProps] optional
 * @param {Object} [emphasisStyleProps] optional
 */


function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
  var elStyle = el.style;

  if (normalStyleProps) {
    rollbackDefaultTextStyle(elStyle);
    el.setStyle(normalStyleProps);
    applyDefaultTextStyle(elStyle);
  }

  elStyle = el.__hoverStl;

  if (emphasisStyleProps && elStyle) {
    rollbackDefaultTextStyle(elStyle);
    zrUtil.extend(elStyle, emphasisStyleProps);
    applyDefaultTextStyle(elStyle);
  }
}
/**
 * Set basic textStyle properties.
 * See more info in `setTextStyleCommon`.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */


function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);

  return textStyle;
}
/**
 * Set text option in the style.
 * See more info in `setTextStyleCommon`.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */


function setText(textStyle, labelModel, defaultColor) {
  var opt = {
    isRectText: true
  };
  var isEmphasis;

  if (defaultColor === false) {
    isEmphasis = true;
  } else {
    // Support setting color as 'auto' to get visual color.
    opt.autoColor = defaultColor;
  }

  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 *
 * The `textStyle` object can either be a plain object or an instance of
 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
 * After this mothod called, the `textStyle` object can then be used in
 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
 *
 * Default value will be adopted and `insideRollbackOpt` will be created.
 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
 *
 * opt: {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */


function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;

  if (opt.isRectText) {
    var textPosition;

    if (opt.getTextPosition) {
      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
    } else {
      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
      // in bar series, and magric type should be considered.

      textPosition === 'outside' && (textPosition = 'top');
    }

    textStyle.textPosition = textPosition;
    textStyle.textOffset = textStyleModel.getShallow('offset');
    var labelRotate = textStyleModel.getShallow('rotate');
    labelRotate != null && (labelRotate *= Math.PI / 180);
    textStyle.textRotation = labelRotate;
    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
  }

  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             rich: {
  //                 // no 'a' here but using parent 'a'.
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name in richItemNames) {
      if (richItemNames.hasOwnProperty(name)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
        // the default color `'blue'` will not be adopted if no color declared in `rich`.
        // That might confuses users. So probably we should put `textStyleModel` as the
        // root ancestor of the `richTextStyle`. But that would be a break change.

        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
      }
    }
  }

  textStyle.rich = richResult;
  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);

  if (opt.forceRich && !opt.textStyle) {
    opt.textStyle = {};
  }

  return textStyle;
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};

      for (var name in rich) {
        if (rich.hasOwnProperty(name)) {
          richItemNameMap[name] = 1;
        }
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (!isEmphasis) {
    if (isBlock) {
      textStyle.insideRollbackOpt = opt;
      applyDefaultTextStyle(textStyle);
    } // Set default finally.


    if (textStyle.textFill == null) {
      textStyle.textFill = opt.autoColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
  textStyle.textAlign = textStyleModel.getShallow('align');
  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
  textStyle.textWidth = textStyleModel.getShallow('width');
  textStyle.textHeight = textStyleModel.getShallow('height');
  textStyle.textTag = textStyleModel.getShallow('tag');

  if (!isBlock || !opt.disableBox) {
    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
    textStyle.textPadding = textStyleModel.getShallow('padding');
    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
  }

  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
}

function getAutoColor(color, opt) {
  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
}
/**
 * Give some default value to the input `textStyle` object, based on the current settings
 * in this `textStyle` object.
 *
 * The Scenario:
 * when text position is `inside` and `textFill` is not specified, we show
 * text border by default for better view. But it should be considered that text position
 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
 * restore the style.
 *
 * Usage (& NOTICE):
 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
 * be called before the modification and `applyDefaultTextStyle` should be called after that.
 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
 * does, `rollbackDefaultTextStyle` is not needed to be called).
 */


function applyDefaultTextStyle(textStyle) {
  var textPosition = textStyle.textPosition;
  var opt = textStyle.insideRollbackOpt;
  var insideRollback;

  if (opt && textStyle.textFill == null) {
    var autoColor = opt.autoColor;
    var isRectText = opt.isRectText;
    var useInsideStyle = opt.useInsideStyle;
    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.

    if (useInsideStyleCache || useAutoColorCache) {
      insideRollback = {
        textFill: textStyle.textFill,
        textStroke: textStyle.textStroke,
        textStrokeWidth: textStyle.textStrokeWidth
      };
    }

    if (useInsideStyleCache) {
      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.

      if (textStyle.textStroke == null) {
        textStyle.textStroke = autoColor;
        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
      }
    }

    if (useAutoColorCache) {
      textStyle.textFill = autoColor;
    }
  } // Always set `insideRollback`, so that the previous one can be cleared.


  textStyle.insideRollback = insideRollback;
}
/**
 * Consider the case: in a scatter,
 * label: {
 *     normal: {position: 'inside'},
 *     emphasis: {position: 'top'}
 * }
 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
 * should be retured to 'autoColor', but not keep '#fff'.
 */


function rollbackDefaultTextStyle(style) {
  var insideRollback = style.insideRollback;

  if (insideRollback) {
    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
    style.textFill = insideRollback.textFill;
    style.textStroke = insideRollback.textStroke;
    style.textStrokeWidth = insideRollback.textStrokeWidth;
    style.insideRollback = null;
  }
}

function getFont(opt, ecModel) {
  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
}

function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
  if (typeof dataIndex === 'function') {
    cb = dataIndex;
    dataIndex = null;
  } // Do not check 'animation' property directly here. Consider this case:
  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
  // but its parent model (`seriesModel`) does.


  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();

  if (animationEnabled) {
    var postfix = isUpdate ? 'Update' : '';
    var duration = animatableModel.getShallow('animationDuration' + postfix);
    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);

    if (typeof animationDelay === 'function') {
      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    }

    if (typeof duration === 'function') {
      duration = duration(dataIndex);
    }

    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
  } else {
    el.stopAnimation();
    el.attr(props);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */


function initProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
}
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */


function getTransform(target, ancestor) {
  var mat = matrix.identity([]);

  while (target && target !== ancestor) {
    matrix.mul(mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */


function applyTransform(target, transform, invert) {
  if (transform && !zrUtil.isArrayLike(transform)) {
    transform = Transformable.getLocalTransform(transform);
  }

  if (invert) {
    transform = matrix.invert([], transform);
  }

  return vector.applyTransform([], target, transform);
}
/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */


function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel, cb) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (!el.isGroup && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      position: vector.clone(el.position),
      rotation: el.rotation
    };

    if (el.shape) {
      obj.shape = zrUtil.extend({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (!el.isGroup && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        updateProps(el, newProp, animatableModel, el.dataIndex);
      } // else {
      //     if (el.previousProps) {
      //         graphic.updateProps
      //     }
      // }

    }
  });
}
/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */


function clipPointsByRect(points, rect) {
  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
  // and when element have border.
  return zrUtil.map(points, function (point) {
    var x = point[0];
    x = mathMax(x, rect.x);
    x = mathMin(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax(y, rect.y);
    y = mathMin(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */


function clipRectByRect(targetRect, rect) {
  var x = mathMax(targetRect.x, rect.x);
  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax(targetRect.y, rect.y);
  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
  // should be painted. So return undefined.

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */


function createIcon(iconStr, opt, rect) {
  opt = zrUtil.extend({
    rectHover: true
  }, opt);
  var style = opt.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
  }
}
/**
 * Return `true` if the given line (line `a`) and the given polygon
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {Array.<Array.<number>>} points Points of the polygon.
 * @return {boolean}
 */


function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
    var p = points[i];

    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
      return true;
    }

    p2 = p;
  }
}
/**
 * Return `true` if the given two lines (line `a` and line `b`)
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 *
 * @param {number} a1x
 * @param {number} a1y
 * @param {number} a2x
 * @param {number} a2y
 * @param {number} b1x
 * @param {number} b1y
 * @param {number} b2x
 * @param {number} b2y
 * @return {boolean}
 */


function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
  var mx = a2x - a1x;
  var my = a2y - a1y;
  var nx = b2x - b1x;
  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.

  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);

  if (nearZero(nmCrossProduct)) {
    return false;
  } // `vec_m` and `vec_n` are intersect iff
  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.


  var b1a1x = a1x - b1x;
  var b1a1y = a1y - b1y;
  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;

  if (q < 0 || q > 1) {
    return false;
  }

  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;

  if (p < 0 || p > 1) {
    return false;
  }

  return true;
}
/**
 * Cross product of 2-dimension vector.
 */


function crossProduct2d(x1, y1, x2, y2) {
  return x1 * y2 - x2 * y1;
}

function nearZero(val) {
  return val <= 1e-6 && val >= -1e-6;
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.


registerShape('circle', Circle);
registerShape('sector', Sector);
registerShape('ring', Ring);
registerShape('polygon', Polygon);
registerShape('polyline', Polyline);
registerShape('rect', Rect);
registerShape('line', Line);
registerShape('bezierCurve', BezierCurve);
registerShape('arc', Arc);
exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
exports.extendShape = extendShape;
exports.extendPath = extendPath;
exports.registerShape = registerShape;
exports.getShapeClass = getShapeClass;
exports.makePath = makePath;
exports.makeImage = makeImage;
exports.mergePath = mergePath;
exports.resizePath = resizePath;
exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;
exports.setElementHoverStyle = setElementHoverStyle;
exports.setHoverStyle = setHoverStyle;
exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
exports.isHighDownDispatcher = isHighDownDispatcher;
exports.getHighlightDigit = getHighlightDigit;
exports.setLabelStyle = setLabelStyle;
exports.modifyLabelStyle = modifyLabelStyle;
exports.setTextStyle = setTextStyle;
exports.setText = setText;
exports.getFont = getFont;
exports.updateProps = updateProps;
exports.initProps = initProps;
exports.getTransform = getTransform;
exports.applyTransform = applyTransform;
exports.transformDirection = transformDirection;
exports.groupTransition = groupTransition;
exports.clipPointsByRect = clipPointsByRect;
exports.clipRectByRect = clipRectByRect;
exports.createIcon = createIcon;
exports.linePolygonIntersect = linePolygonIntersect;
exports.lineLineIntersect = lineLineIntersect;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(525)();
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(46);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = apiDefine;
/* harmony export (immutable) */ __webpack_exports__["a"] = apiCancel;
var webapi=window.webapi={};window.myContext={};/**
 * 供客户端调用的接口
 *
 * pageTo:翻页    参数 pageIndex-页码
 * 定义位置：/src/components/RouteComponent/main
 *
 * evaluateResult:录音反馈  参数 total-总分 result-得分
 * 定义位置：/src/components/homeworkPage/homeworkPage
 */function apiDefine(){for(var _len=arguments.length,params=Array(_len),_key=0;_key<_len;_key++){params[_key]=arguments[_key];}params.forEach(function(opt){var apiName=opt.apiName,fn=opt.fn;webapi[apiName]=fn;});}function apiCancel(apiName){delete webapi[apiName];}// apiDefine('sendClientData',function(res){
//     alert(1);
//     window.myContext = {};
//     if(res){
//         const data = JSON.parse(res);
//         window.myContext = {...window.myContext,...data};
//     }
// })
// alert(123)

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROUND_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEEK; });
//课件url前置
var COURSE_URL="/h5";var ROUND_NAME={1:"carriage",2:"archery",3:"castle",4:"castle"};var WEEK={0:"周日",1:"周一",2:"周二",3:"周三",4:"周四",5:"周五",6:"周六"};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
var dev; // In browser

if (typeof window !== 'undefined') {
  dev = window.__DEV__;
} // In node
else if (typeof global !== 'undefined') {
    dev = global.__DEV__;
  }

if (typeof dev === 'undefined') {
  dev = true;
}

var __DEV__ = dev;
exports.__DEV__ = __DEV__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrender = __webpack_require__(249);

var zrUtil = __webpack_require__(2);

var colorTool = __webpack_require__(99);

var env = __webpack_require__(25);

var timsort = __webpack_require__(169);

var Eventful = __webpack_require__(97);

var GlobalModel = __webpack_require__(262);

var ExtensionAPI = __webpack_require__(276);

var CoordinateSystemManager = __webpack_require__(177);

var OptionManager = __webpack_require__(836);

var backwardCompat = __webpack_require__(837);

var dataStack = __webpack_require__(839);

var ComponentModel = __webpack_require__(56);

var SeriesModel = __webpack_require__(277);

var ComponentView = __webpack_require__(278);

var ChartView = __webpack_require__(279);

var graphic = __webpack_require__(17);

var modelUtil = __webpack_require__(13);

var _throttle = __webpack_require__(180);

var throttle = _throttle.throttle;

var seriesColor = __webpack_require__(841);

var aria = __webpack_require__(842);

var loadingDefault = __webpack_require__(843);

var Scheduler = __webpack_require__(844);

var lightTheme = __webpack_require__(845);

var darkTheme = __webpack_require__(846);

__webpack_require__(847);

var mapDataStorage = __webpack_require__(848);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var assert = zrUtil.assert;
var each = zrUtil.each;
var isFunction = zrUtil.isFunction;
var isObject = zrUtil.isObject;
var parseClassType = ComponentModel.parseClassType;
var version = '4.7.0';
var dependencies = {
  zrender: '4.3.0'
};
var TEST_FRAME_REMAIN_TIME = 1;
var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
var PRIORITY_PROCESSOR_DATASTACK = 900;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
// necessary?

var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS = '__flagInMainProcess';
var OPTION_UPDATED = '__optionUpdated';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;

function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
  return function (eventName, handler, context) {
    if (!ignoreDisposed && this._disposed) {
      disposedWarning(this.id);
      return;
    } // Event name is all lowercase


    eventName = eventName && eventName.toLowerCase();
    Eventful.prototype[method].call(this, eventName, handler, context);
  };
}
/**
 * @module echarts~MessageCenter
 */


function MessageCenter() {
  Eventful.call(this);
}

MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
zrUtil.mixin(MessageCenter, Eventful);
/**
 * @module echarts~ECharts
 */

function ECharts(dom, theme, opts) {
  opts = opts || {}; // Get theme by name

  if (typeof theme === 'string') {
    theme = themeStorage[theme];
  }
  /**
   * @type {string}
   */


  this.id;
  /**
   * Group id
   * @type {string}
   */

  this.group;
  /**
   * @type {HTMLElement}
   * @private
   */

  this._dom = dom;
  var defaultRenderer = 'canvas';

  /**
   * @type {module:zrender/ZRender}
   * @private
   */
  var zr = this._zr = zrender.init(dom, {
    renderer: opts.renderer || defaultRenderer,
    devicePixelRatio: opts.devicePixelRatio,
    width: opts.width,
    height: opts.height
  });
  /**
   * Expect 60 fps.
   * @type {Function}
   * @private
   */

  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
  var theme = zrUtil.clone(theme);
  theme && backwardCompat(theme, true);
  /**
   * @type {Object}
   * @private
   */

  this._theme = theme;
  /**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */

  this._chartsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */

  this._chartsMap = {};
  /**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */

  this._componentsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */

  this._componentsMap = {};
  /**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */

  this._coordSysMgr = new CoordinateSystemManager();
  /**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */

  var api = this._api = createExtensionAPI(this); // Sort on demand

  function prioritySortFunc(a, b) {
    return a.__prio - b.__prio;
  }

  timsort(visualFuncs, prioritySortFunc);
  timsort(dataProcessorFuncs, prioritySortFunc);
  /**
   * @type {module:echarts/stream/Scheduler}
   */

  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
  /**
   * @type {module:echarts~MessageCenter}
   * @private
   */

  this._messageCenter = new MessageCenter(); // Init mouse events

  this._initEvents(); // In case some people write `window.onresize = chart.resize`


  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure

  this._pendingActions = [];
  zr.animation.on('frame', this._onframe, this);
  bindRenderedEvent(zr, this); // ECharts instance can be used as value.

  zrUtil.setAsPrimitive(this);
}

var echartsProto = ECharts.prototype;

echartsProto._onframe = function () {
  if (this._disposed) {
    return;
  }

  var scheduler = this._scheduler; // Lazy update

  if (this[OPTION_UPDATED]) {
    var silent = this[OPTION_UPDATED].silent;
    this[IN_MAIN_PROCESS] = true;
    prepare(this);
    updateMethods.update.call(this);
    this[IN_MAIN_PROCESS] = false;
    this[OPTION_UPDATED] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  } // Avoid do both lazy update and progress in one frame.
  else if (scheduler.unfinished) {
      // Stream progress.
      var remainTime = TEST_FRAME_REMAIN_TIME;
      var ecModel = this._model;
      var api = this._api;
      scheduler.unfinished = false;

      do {
        var startTime = +new Date();
        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.

        scheduler.performDataProcessorTasks(ecModel);
        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
        // each frame is not a good user experience. So we follow the rule that
        // the extent of the coordinate system is determin in the first frame (the
        // frame is executed immedietely after task reset.
        // this._coordSysMgr.update(ecModel, api);
        // console.log('--- ec frame visual ---', remainTime);

        scheduler.performVisualTasks(ecModel);
        renderSeries(this, this._model, api, 'remain');
        remainTime -= +new Date() - startTime;
      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.


      if (!scheduler.unfinished) {
        this._zr.flush();
      } // Else, zr flushing be ensue within the same frame,
      // because zr flushing is after onframe event.

    }
};
/**
 * @return {HTMLElement}
 */


echartsProto.getDom = function () {
  return this._dom;
};
/**
 * @return {module:zrender~ZRender}
 */


echartsProto.getZr = function () {
  return this._zr;
};
/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */


echartsProto.setOption = function (option, notMerge, lazyUpdate) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var silent;

  if (isObject(notMerge)) {
    lazyUpdate = notMerge.lazyUpdate;
    silent = notMerge.silent;
    notMerge = notMerge.notMerge;
  }

  this[IN_MAIN_PROCESS] = true;

  if (!this._model || notMerge) {
    var optionManager = new OptionManager(this._api);
    var theme = this._theme;
    var ecModel = this._model = new GlobalModel();
    ecModel.scheduler = this._scheduler;
    ecModel.init(null, null, theme, optionManager);
  }

  this._model.setOption(option, optionPreprocessorFuncs);

  if (lazyUpdate) {
    this[OPTION_UPDATED] = {
      silent: silent
    };
    this[IN_MAIN_PROCESS] = false;
  } else {
    prepare(this);
    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
    // fetched after `setOption`.

    this._zr.flush();

    this[OPTION_UPDATED] = false;
    this[IN_MAIN_PROCESS] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @DEPRECATED
 */


echartsProto.setTheme = function () {
  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
};
/**
 * @return {module:echarts/model/Global}
 */


echartsProto.getModel = function () {
  return this._model;
};
/**
 * @return {Object}
 */


echartsProto.getOption = function () {
  return this._model && this._model.getOption();
};
/**
 * @return {number}
 */


echartsProto.getWidth = function () {
  return this._zr.getWidth();
};
/**
 * @return {number}
 */


echartsProto.getHeight = function () {
  return this._zr.getHeight();
};
/**
 * @return {number}
 */


echartsProto.getDevicePixelRatio = function () {
  return this._zr.painter.dpr || window.devicePixelRatio || 1;
};
/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */


echartsProto.getRenderedCanvas = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  opts = opts || {};
  opts.pixelRatio = opts.pixelRatio || 1;
  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
  var zr = this._zr; // var list = zr.storage.getDisplayList();
  // Stop animations
  // Never works before in init animation, so remove it.
  // zrUtil.each(list, function (el) {
  //     el.stopAnimation(true);
  // });

  return zr.painter.getRenderedCanvas(opts);
};
/**
 * Get svg data url
 * @return {string}
 */


echartsProto.getSvgDataUrl = function () {
  if (!env.svgSupported) {
    return;
  }

  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.pathToDataUrl();
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */


echartsProto.getDataURL = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  opts = opts || {};
  var excludeComponents = opts.excludeComponents;
  var ecModel = this._model;
  var excludesComponentViews = [];
  var self = this;
  each(excludeComponents, function (componentType) {
    ecModel.eachComponent({
      mainType: componentType
    }, function (component) {
      var view = self._componentsMap[component.__viewId];

      if (!view.group.ignore) {
        excludesComponentViews.push(view);
        view.group.ignore = true;
      }
    });
  });
  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataUrl() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
  each(excludesComponentViews, function (view) {
    view.group.ignore = false;
  });
  return url;
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */


echartsProto.getConnectedDataURL = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (!env.canvasSupported) {
    return;
  }

  var groupId = this.group;
  var mathMin = Math.min;
  var mathMax = Math.max;
  var MAX_NUMBER = Infinity;

  if (connectedGroups[groupId]) {
    var left = MAX_NUMBER;
    var top = MAX_NUMBER;
    var right = -MAX_NUMBER;
    var bottom = -MAX_NUMBER;
    var canvasList = [];
    var dpr = opts && opts.pixelRatio || 1;
    zrUtil.each(instances, function (chart, id) {
      if (chart.group === groupId) {
        var canvas = chart.getRenderedCanvas(zrUtil.clone(opts));
        var boundingRect = chart.getDom().getBoundingClientRect();
        left = mathMin(boundingRect.left, left);
        top = mathMin(boundingRect.top, top);
        right = mathMax(boundingRect.right, right);
        bottom = mathMax(boundingRect.bottom, bottom);
        canvasList.push({
          dom: canvas,
          left: boundingRect.left,
          top: boundingRect.top
        });
      }
    });
    left *= dpr;
    top *= dpr;
    right *= dpr;
    bottom *= dpr;
    var width = right - left;
    var height = bottom - top;
    var targetCanvas = zrUtil.createCanvas();
    targetCanvas.width = width;
    targetCanvas.height = height;
    var zr = zrender.init(targetCanvas); // Background between the charts

    if (opts.connectedBackgroundColor) {
      zr.add(new graphic.Rect({
        shape: {
          x: 0,
          y: 0,
          width: width,
          height: height
        },
        style: {
          fill: opts.connectedBackgroundColor
        }
      }));
    }

    each(canvasList, function (item) {
      var img = new graphic.Image({
        style: {
          x: item.left * dpr - left,
          y: item.top * dpr - top,
          image: item.dom
        }
      });
      zr.add(img);
    });
    zr.refreshImmediately();
    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
  } else {
    return this.getDataURL(opts);
  }
};
/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */


echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */

echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');

function doConvertPixel(methodName, finder, value) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var ecModel = this._model;

  var coordSysList = this._coordSysMgr.getCoordinateSystems();

  var result;
  finder = modelUtil.parseFinder(ecModel, finder);

  for (var i = 0; i < coordSysList.length; i++) {
    var coordSys = coordSysList[i];

    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
      return result;
    }
  }
}
/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */


echartsProto.containPixel = function (finder, value) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var ecModel = this._model;
  var result;
  finder = modelUtil.parseFinder(ecModel, finder);
  zrUtil.each(finder, function (models, key) {
    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
      var coordSys = model.coordinateSystem;

      if (coordSys && coordSys.containPoint) {
        result |= !!coordSys.containPoint(value);
      } else if (key === 'seriesModels') {
        var view = this._chartsMap[model.__viewId];

        if (view && view.containPoint) {
          result |= view.containPoint(value, model);
        } else {}
      } else {}
    }, this);
  }, this);
  return !!result;
};
/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */


echartsProto.getVisual = function (finder, visualType) {
  var ecModel = this._model;
  finder = modelUtil.parseFinder(ecModel, finder, {
    defaultMainType: 'series'
  });
  var seriesModel = finder.seriesModel;
  var data = seriesModel.getData();
  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
};
/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */


echartsProto.getViewOfComponentModel = function (componentModel) {
  return this._componentsMap[componentModel.__viewId];
};
/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */


echartsProto.getViewOfSeriesModel = function (seriesModel) {
  return this._chartsMap[seriesModel.__viewId];
};

var updateMethods = {
  prepareAndUpdate: function (payload) {
    prepare(this);
    updateMethods.update.call(this, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  update: function (payload) {
    // console.profile && console.profile('update');
    var ecModel = this._model;
    var api = this._api;
    var zr = this._zr;
    var coordSysMgr = this._coordSysMgr;
    var scheduler = this._scheduler; // update before setOption

    if (!ecModel) {
      return;
    }

    scheduler.restoreData(ecModel, payload);
    scheduler.performSeriesTasks(ecModel); // TODO
    // Save total ecModel here for undo/redo (after restoring data and before processing data).
    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
    // Create new coordinate system each update
    // In LineView may save the old coordinate system and use it to get the orignal point

    coordSysMgr.create(ecModel, api);
    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
    // stream modes after data processing, where the filtered data is used to
    // deteming whether use progressive rendering.

    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
    // can be fetched when coord sys updating (consider the barGrid extent fix). But
    // the drawback is the full coord info can not be fetched. Fortunately this full
    // coord is not requied in stream mode updater currently.

    coordSysMgr.update(ecModel, api);
    clearColorPalette(ecModel);
    scheduler.performVisualTasks(ecModel, payload);
    render(this, ecModel, api, payload); // Set background

    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8

    if (!env.canvasSupported) {
      var colorArr = colorTool.parse(backgroundColor);
      backgroundColor = colorTool.stringify(colorArr, 'rgb');

      if (colorArr[3] === 0) {
        backgroundColor = 'transparent';
      }
    } else {
      zr.setBackgroundColor(backgroundColor);
    }

    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateTransform: function (payload) {
    var ecModel = this._model;
    var ecIns = this;
    var api = this._api; // update before setOption

    if (!ecModel) {
      return;
    } // ChartView.markUpdateMethod(payload, 'updateTransform');


    var componentDirtyList = [];
    ecModel.eachComponent(function (componentType, componentModel) {
      var componentView = ecIns.getViewOfComponentModel(componentModel);

      if (componentView && componentView.__alive) {
        if (componentView.updateTransform) {
          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
          result && result.update && componentDirtyList.push(componentView);
        } else {
          componentDirtyList.push(componentView);
        }
      }
    });
    var seriesDirtyMap = zrUtil.createHashMap();
    ecModel.eachSeries(function (seriesModel) {
      var chartView = ecIns._chartsMap[seriesModel.__viewId];

      if (chartView.updateTransform) {
        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
      } else {
        seriesDirtyMap.set(seriesModel.uid, 1);
      }
    });
    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);

    this._scheduler.performVisualTasks(ecModel, payload, {
      setDirty: true,
      dirtyMap: seriesDirtyMap
    }); // Currently, not call render of components. Geo render cost a lot.
    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);


    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
    performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateView: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ChartView.markUpdateMethod(payload, 'updateView');
    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

    this._scheduler.performVisualTasks(ecModel, payload, {
      setDirty: true
    });

    render(this, this._model, this._api, payload);
    performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateVisual: function (payload) {
    updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateVisual');
    // clearColorPalette(ecModel);
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateLayout: function (payload) {
    updateMethods.update.call(this, payload); // var ecModel = this._model;
    // // update before setOption
    // if (!ecModel) {
    //     return;
    // }
    // ChartView.markUpdateMethod(payload, 'updateLayout');
    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
    // render(this, this._model, this._api, payload);
    // performPostUpdateFuncs(ecModel, this._api);
  }
};

function prepare(ecIns) {
  var ecModel = ecIns._model;
  var scheduler = ecIns._scheduler;
  scheduler.restorePipelines(ecModel);
  scheduler.prepareStageTasks();
  prepareView(ecIns, 'component', ecModel, scheduler);
  prepareView(ecIns, 'chart', ecModel, scheduler);
  scheduler.plan();
}
/**
 * @private
 */


function updateDirectly(ecIns, method, payload, mainType, subType) {
  var ecModel = ecIns._model; // broadcast

  if (!mainType) {
    // FIXME
    // Chart will not be update directly here, except set dirty.
    // But there is no such scenario now.
    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
    return;
  }

  var query = {};
  query[mainType + 'Id'] = payload[mainType + 'Id'];
  query[mainType + 'Index'] = payload[mainType + 'Index'];
  query[mainType + 'Name'] = payload[mainType + 'Name'];
  var condition = {
    mainType: mainType,
    query: query
  };
  subType && (condition.subType = subType); // subType may be '' by parseClassType;

  var excludeSeriesId = payload.excludeSeriesId;

  if (excludeSeriesId != null) {
    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
  } // If dispatchAction before setOption, do nothing.


  ecModel && ecModel.eachComponent(condition, function (model) {
    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
    }
  }, ecIns);

  function callView(view) {
    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
  }
}
/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */


echartsProto.resize = function (opts) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._zr.resize(opts);

  var ecModel = this._model; // Resize loading effect

  this._loadingFX && this._loadingFX.resize();

  if (!ecModel) {
    return;
  }

  var optionChanged = ecModel.resetOption('media');
  var silent = opts && opts.silent;
  this[IN_MAIN_PROCESS] = true;
  optionChanged && prepare(this);
  updateMethods.update.call(this);
  this[IN_MAIN_PROCESS] = false;
  flushPendingActions.call(this, silent);
  triggerUpdatedEvent.call(this, silent);
};

function updateStreamModes(ecIns, ecModel) {
  var chartsMap = ecIns._chartsMap;
  var scheduler = ecIns._scheduler;
  ecModel.eachSeries(function (seriesModel) {
    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
  });
}
/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */


echartsProto.showLoading = function (name, cfg) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (isObject(name)) {
    cfg = name;
    name = '';
  }

  name = name || 'default';
  this.hideLoading();

  if (!loadingEffects[name]) {
    return;
  }

  var el = loadingEffects[name](this._api, cfg);
  var zr = this._zr;
  this._loadingFX = el;
  zr.add(el);
};
/**
 * Hide loading effect
 */


echartsProto.hideLoading = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._loadingFX && this._zr.remove(this._loadingFX);
  this._loadingFX = null;
};
/**
 * @param {Object} eventObj
 * @return {Object}
 */


echartsProto.makeActionFromEvent = function (eventObj) {
  var payload = zrUtil.extend({}, eventObj);
  payload.type = eventActionMap[eventObj.type];
  return payload;
};
/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not flush.
 *                  undefined: Auto decide whether perform flush.
 */


echartsProto.dispatchAction = function (payload, opt) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  if (!isObject(opt)) {
    opt = {
      silent: !!opt
    };
  }

  if (!actions[payload.type]) {
    return;
  } // Avoid dispatch action before setOption. Especially in `connect`.


  if (!this._model) {
    return;
  } // May dispatchAction in rendering procedure


  if (this[IN_MAIN_PROCESS]) {
    this._pendingActions.push(payload);

    return;
  }

  doDispatchAction.call(this, payload, opt.silent);

  if (opt.flush) {
    this._zr.flush(true);
  } else if (opt.flush !== false && env.browser.weChat) {
    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
    // hang when sliding page (on touch event), which cause that zr does not
    // refresh util user interaction finished, which is not expected.
    // But `dispatchAction` may be called too frequently when pan on touch
    // screen, which impacts performance if do not throttle them.
    this._throttledZrFlush();
  }

  flushPendingActions.call(this, opt.silent);
  triggerUpdatedEvent.call(this, opt.silent);
};

function doDispatchAction(payload, silent) {
  var payloadType = payload.type;
  var escapeConnect = payload.escapeConnect;
  var actionWrap = actions[payloadType];
  var actionInfo = actionWrap.actionInfo;
  var cptType = (actionInfo.update || 'update').split(':');
  var updateMethod = cptType.pop();
  cptType = cptType[0] != null && parseClassType(cptType[0]);
  this[IN_MAIN_PROCESS] = true;
  var payloads = [payload];
  var batched = false; // Batch action

  if (payload.batch) {
    batched = true;
    payloads = zrUtil.map(payload.batch, function (item) {
      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
      item.batch = null;
      return item;
    });
  }

  var eventObjBatch = [];
  var eventObj;
  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
  each(payloads, function (batchItem) {
    // Action can specify the event by return it.
    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside

    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType

    eventObj.type = actionInfo.event || eventObj.type;
    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

    if (isHighDown) {
      // method, payload, mainType, subType
      updateDirectly(this, updateMethod, batchItem, 'series');
    } else if (cptType) {
      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
    }
  }, this);

  if (updateMethod !== 'none' && !isHighDown && !cptType) {
    // Still dirty
    if (this[OPTION_UPDATED]) {
      // FIXME Pass payload ?
      prepare(this);
      updateMethods.update.call(this, payload);
      this[OPTION_UPDATED] = false;
    } else {
      updateMethods[updateMethod].call(this, payload);
    }
  } // Follow the rule of action batch


  if (batched) {
    eventObj = {
      type: actionInfo.event || payloadType,
      escapeConnect: escapeConnect,
      batch: eventObjBatch
    };
  } else {
    eventObj = eventObjBatch[0];
  }

  this[IN_MAIN_PROCESS] = false;
  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
}

function flushPendingActions(silent) {
  var pendingActions = this._pendingActions;

  while (pendingActions.length) {
    var payload = pendingActions.shift();
    doDispatchAction.call(this, payload, silent);
  }
}

function triggerUpdatedEvent(silent) {
  !silent && this.trigger('updated');
}
/**
 * Event `rendered` is triggered when zr
 * rendered. It is useful for realtime
 * snapshot (reflect animation).
 *
 * Event `finished` is triggered when:
 * (1) zrender rendering finished.
 * (2) initial animation finished.
 * (3) progressive rendering finished.
 * (4) no pending action.
 * (5) no delayed setOption needs to be processed.
 */


function bindRenderedEvent(zr, ecIns) {
  zr.on('rendered', function () {
    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
    // so it should only be triggered when rendering indeed happend
    // in zrender. (Consider the case that dipatchAction is keep
    // triggering when mouse move).

    if ( // Although zr is dirty if initial animation is not finished
    // and this checking is called on frame, we also check
    // animation finished for robustness.
    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
      ecIns.trigger('finished');
    }
  });
}
/**
 * @param {Object} params
 * @param {number} params.seriesIndex
 * @param {Array|TypedArray} params.data
 */


echartsProto.appendData = function (params) {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  var seriesIndex = params.seriesIndex;
  var ecModel = this.getModel();
  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
  // system, util some scenario require that. In the expected usage of
  // `appendData`, the initial extent of coordinate system should better
  // be fixed by axis `min`/`max` setting or initial data, otherwise if
  // the extent changed while `appendData`, the location of the painted
  // graphic elements have to be changed, which make the usage of
  // `appendData` meaningless.

  this._scheduler.unfinished = true;
};
/**
 * Register event
 * @method
 */


echartsProto.on = createRegisterEventWithLowercaseName('on', false);
echartsProto.off = createRegisterEventWithLowercaseName('off', false);
echartsProto.one = createRegisterEventWithLowercaseName('one', false);
/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */

function prepareView(ecIns, type, ecModel, scheduler) {
  var isComponent = type === 'component';
  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
  var zr = ecIns._zr;
  var api = ecIns._api;

  for (var i = 0; i < viewList.length; i++) {
    viewList[i].__alive = false;
  }

  isComponent ? ecModel.eachComponent(function (componentType, model) {
    componentType !== 'series' && doPrepare(model);
  }) : ecModel.eachSeries(doPrepare);

  function doPrepare(model) {
    // Consider: id same and type changed.
    var viewId = '_ec_' + model.id + '_' + model.type;
    var view = viewMap[viewId];

    if (!view) {
      var classType = parseClassType(model.type);
      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
      view = new Clazz();
      view.init(ecModel, api);
      viewMap[viewId] = view;
      viewList.push(view);
      zr.add(view.group);
    }

    model.__viewId = view.__id = viewId;
    view.__alive = true;
    view.__model = model;
    view.group.__ecComponentInfo = {
      mainType: model.mainType,
      index: model.componentIndex
    };
    !isComponent && scheduler.prepareView(view, model, ecModel, api);
  }

  for (var i = 0; i < viewList.length;) {
    var view = viewList[i];

    if (!view.__alive) {
      !isComponent && view.renderTask.dispose();
      zr.remove(view.group);
      view.dispose(ecModel, api);
      viewList.splice(i, 1);
      delete viewMap[view.__id];
      view.__id = view.group.__ecComponentInfo = null;
    } else {
      i++;
    }
  }
} // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         var isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }


function clearColorPalette(ecModel) {
  ecModel.clearColorPalette();
  ecModel.eachSeries(function (seriesModel) {
    seriesModel.clearColorPalette();
  });
}

function render(ecIns, ecModel, api, payload) {
  renderComponents(ecIns, ecModel, api, payload);
  each(ecIns._chartsViews, function (chart) {
    chart.__alive = false;
  });
  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts

  each(ecIns._chartsViews, function (chart) {
    if (!chart.__alive) {
      chart.remove(ecModel, api);
    }
  });
}

function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
  each(dirtyList || ecIns._componentsViews, function (componentView) {
    var componentModel = componentView.__model;
    componentView.render(componentModel, ecModel, api, payload);
    updateZ(componentModel, componentView);
  });
}
/**
 * Render each chart and component
 * @private
 */


function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
  // Render all charts
  var scheduler = ecIns._scheduler;
  var unfinished;
  ecModel.eachSeries(function (seriesModel) {
    var chartView = ecIns._chartsMap[seriesModel.__viewId];
    chartView.__alive = true;
    var renderTask = chartView.renderTask;
    scheduler.updatePayload(renderTask, payload);

    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
      renderTask.dirty();
    }

    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
    chartView.group.silent = !!seriesModel.get('silent');
    updateZ(seriesModel, chartView);
    updateBlend(seriesModel, chartView);
  });
  scheduler.unfinished |= unfinished; // If use hover layer

  updateHoverLayerStatus(ecIns, ecModel); // Add aria

  aria(ecIns._zr.dom, ecModel);
}

function performPostUpdateFuncs(ecModel, api) {
  each(postUpdateFuncs, function (func) {
    func(ecModel, api);
  });
}

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
/**
 * @private
 */

echartsProto._initEvents = function () {
  each(MOUSE_EVENT_NAMES, function (eveName) {
    var handler = function (e) {
      var ecModel = this.getModel();
      var el = e.target;
      var params;
      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.

      if (isGlobalOut) {
        params = {};
      } else if (el && el.dataIndex != null) {
        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
      } // If element has custom eventData of components
      else if (el && el.eventData) {
          params = zrUtil.extend({}, el.eventData);
        } // Contract: if params prepared in mouse event,
      // these properties must be specified:
      // {
      //    componentType: string (component main type)
      //    componentIndex: number
      // }
      // Otherwise event query can not work.


      if (params) {
        var componentType = params.componentType;
        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
        // markLine/markPoint/markArea, the componentType is
        // 'markLine'/'markPoint'/'markArea', but we should better
        // enable them to be queried by seriesIndex, since their
        // option is set in each series.

        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
          componentType = 'series';
          componentIndex = params.seriesIndex;
        }

        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
        params.event = e;
        params.type = eveName;
        this._ecEventProcessor.eventInfo = {
          targetEl: el,
          packedEvent: params,
          model: model,
          view: view
        };
        this.trigger(eveName, params);
      }
    }; // Consider that some component (like tooltip, brush, ...)
    // register zr event handler, but user event handler might
    // do anything, such as call `setOption` or `dispatchAction`,
    // which probably update any of the content and probably
    // cause problem if it is called previous other inner handlers.


    handler.zrEventfulCallAtLast = true;

    this._zr.on(eveName, handler, this);
  }, this);
  each(eventActionMap, function (actionType, eventType) {
    this._messageCenter.on(eventType, function (event) {
      this.trigger(eventType, event);
    }, this);
  }, this);
};
/**
 * @return {boolean}
 */


echartsProto.isDisposed = function () {
  return this._disposed;
};
/**
 * Clear
 */


echartsProto.clear = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this.setOption({
    series: []
  }, true);
};
/**
 * Dispose instance
 */


echartsProto.dispose = function () {
  if (this._disposed) {
    disposedWarning(this.id);
    return;
  }

  this._disposed = true;
  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
  var api = this._api;
  var ecModel = this._model;
  each(this._componentsViews, function (component) {
    component.dispose(ecModel, api);
  });
  each(this._chartsViews, function (chart) {
    chart.dispose(ecModel, api);
  }); // Dispose after all views disposed

  this._zr.dispose();

  delete instances[this.id];
};

zrUtil.mixin(ECharts, Eventful);

function disposedWarning(id) {}

function updateHoverLayerStatus(ecIns, ecModel) {
  var zr = ecIns._zr;
  var storage = zr.storage;
  var elCount = 0;
  storage.traverse(function (el) {
    elCount++;
  });

  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.preventUsingHoverLayer) {
        return;
      }

      var chartView = ecIns._chartsMap[seriesModel.__viewId];

      if (chartView.__alive) {
        chartView.group.traverse(function (el) {
          // Don't switch back.
          el.useHoverLayer = true;
        });
      }
    });
  }
}
/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateBlend(seriesModel, chartView) {
  var blendMode = seriesModel.get('blendMode') || null;
  chartView.group.traverse(function (el) {
    // FIXME marker and other components
    if (!el.isGroup) {
      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
      if (el.style.blend !== blendMode) {
        el.setStyle('blend', blendMode);
      }
    }

    if (el.eachPendingDisplayable) {
      el.eachPendingDisplayable(function (displayable) {
        displayable.setStyle('blend', blendMode);
      });
    }
  });
}
/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateZ(model, view) {
  var z = model.get('z');
  var zlevel = model.get('zlevel'); // Set z and zlevel

  view.group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
    }
  });
}

function createExtensionAPI(ecInstance) {
  var coordSysMgr = ecInstance._coordSysMgr;
  return zrUtil.extend(new ExtensionAPI(ecInstance), {
    // Inject methods
    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
    getComponentByElement: function (el) {
      while (el) {
        var modelInfo = el.__ecComponentInfo;

        if (modelInfo != null) {
          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
        }

        el = el.parent;
      }
    }
  });
}
/**
 * @class
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */


function EventProcessor() {
  // These info required: targetEl, packedEvent, model, view
  this.eventInfo;
}

EventProcessor.prototype = {
  constructor: EventProcessor,
  normalizeQuery: function (query) {
    var cptQuery = {};
    var dataQuery = {};
    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.

    if (zrUtil.isString(query)) {
      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.

      cptQuery.mainType = condCptType.main || null;
      cptQuery.subType = condCptType.sub || null;
    } // `query` is an object, convert to {mainType, index, name, id}.
    else {
        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
        // can not be used in `compomentModel.filterForExposedEvent`.
        var suffixes = ['Index', 'Name', 'Id'];
        var dataKeys = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        zrUtil.each(query, function (val, key) {
          var reserved = false;

          for (var i = 0; i < suffixes.length; i++) {
            var propSuffix = suffixes[i];
            var suffixPos = key.lastIndexOf(propSuffix);

            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.

              if (mainType !== 'data') {
                cptQuery.mainType = mainType;
                cptQuery[propSuffix.toLowerCase()] = val;
                reserved = true;
              }
            }
          }

          if (dataKeys.hasOwnProperty(key)) {
            dataQuery[key] = val;
            reserved = true;
          }

          if (!reserved) {
            otherQuery[key] = val;
          }
        });
      }

    return {
      cptQuery: cptQuery,
      dataQuery: dataQuery,
      otherQuery: otherQuery
    };
  },
  filter: function (eventType, query, args) {
    // They should be assigned before each trigger call.
    var eventInfo = this.eventInfo;

    if (!eventInfo) {
      return true;
    }

    var targetEl = eventInfo.targetEl;
    var packedEvent = eventInfo.packedEvent;
    var model = eventInfo.model;
    var view = eventInfo.view; // For event like 'globalout'.

    if (!model || !view) {
      return true;
    }

    var cptQuery = query.cptQuery;
    var dataQuery = query.dataQuery;
    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));

    function check(query, host, prop, propOnHost) {
      return query[prop] == null || host[propOnHost || prop] === query[prop];
    }
  },
  afterTrigger: function () {
    // Make sure the eventInfo wont be used in next trigger.
    this.eventInfo = null;
  }
};
/**
 * @type {Object} key: actionType.
 * @inner
 */

var actions = {};
/**
 * Map eventType to actionType
 * @type {Object}
 */

var eventActionMap = {};
/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var dataProcessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var optionPreprocessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var postUpdateFuncs = [];
/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 */

var visualFuncs = [];
/**
 * Theme storage
 * @type {Object.<key, Object>}
 */

var themeStorage = {};
/**
 * Loading effects
 */

var loadingEffects = {};
var instances = {};
var connectedGroups = {};
var idBase = new Date() - 0;
var groupIdBase = new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';

function enableConnect(chart) {
  var STATUS_PENDING = 0;
  var STATUS_UPDATING = 1;
  var STATUS_UPDATED = 2;
  var STATUS_KEY = '__connectUpdateStatus';

  function updateConnectedChartsStatus(charts, status) {
    for (var i = 0; i < charts.length; i++) {
      var otherChart = charts[i];
      otherChart[STATUS_KEY] = status;
    }
  }

  each(eventActionMap, function (actionType, eventType) {
    chart._messageCenter.on(eventType, function (event) {
      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
        if (event && event.escapeConnect) {
          return;
        }

        var action = chart.makeActionFromEvent(event);
        var otherCharts = [];
        each(instances, function (otherChart) {
          if (otherChart !== chart && otherChart.group === chart.group) {
            otherCharts.push(otherChart);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
        each(otherCharts, function (otherChart) {
          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
            otherChart.dispatchAction(action);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
      }
    });
  });
}
/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */


function init(dom, theme, opts) {
  var existInstance = getInstanceByDom(dom);

  if (existInstance) {
    return existInstance;
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances[chart.id] = chart;
  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
  enableConnect(chart);
  return chart;
}
/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */


function connect(groupId) {
  // Is array of charts
  if (zrUtil.isArray(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    each(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    each(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @DEPRECATED
 * @return {string} groupId
 */


function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * @return {string} groupId
 */


var disconnect = disConnect;
/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */

function dispose(chart) {
  if (typeof chart === 'string') {
    chart = instances[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */


function getInstanceByDom(dom) {
  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
}
/**
 * @param {string} key
 * @return {echarts~ECharts}
 */


function getInstanceById(key) {
  return instances[key];
}
/**
 * Register theme
 */


function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */


function registerPreprocessor(preprocessorFunc) {
  optionPreprocessorFuncs.push(preprocessorFunc);
}
/**
 * @param {number} [priority=1000]
 * @param {Object|Function} processor
 */


function registerProcessor(priority, processor) {
  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */


function registerPostUpdate(postUpdateFunc) {
  postUpdateFuncs.push(postUpdateFunc);
}
/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */


function registerAction(actionInfo, eventName, action) {
  if (typeof eventName === 'function') {
    action = eventName;
    eventName = '';
  }

  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event; // Validate action type and event name.

  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */


function registerCoordinateSystem(type, CoordinateSystem) {
  CoordinateSystemManager.register(type, CoordinateSystem);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */


function getCoordinateSystemDimensions(type) {
  var coordSysCreator = CoordinateSystemManager.get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}
/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutTask
 */


function registerLayout(priority, layoutTask) {
  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
}
/**
 * @param {number} [priority=3000]
 * @param {module:echarts/stream/Task} visualTask
 */


function registerVisual(priority, visualTask) {
  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
}
/**
 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
 */


function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
  if (isFunction(priority) || isObject(priority)) {
    fn = priority;
    priority = defaultPriority;
  }

  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
  stageHandler.__prio = priority;
  stageHandler.__raw = fn;
  targetList.push(stageHandler);
  return stageHandler;
}
/**
 * @param {string} name
 */


function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentModel(opts
/*, superClass*/
) {
  // var Clazz = ComponentModel;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return ComponentModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentView(opts
/*, superClass*/
) {
  // var Clazz = ComponentView;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
  // }
  return ComponentView.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendSeriesModel(opts
/*, superClass*/
) {
  // var Clazz = SeriesModel;
  // if (superClass) {
  //     superClass = 'series.' + superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return SeriesModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendChartView(opts
/*, superClass*/
) {
  // var Clazz = ChartView;
  // if (superClass) {
  //     superClass = superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ChartView.getClass(classType.main, true);
  // }
  return ChartView.extend(opts);
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */


function setCanvasCreator(creator) {
  zrUtil.$override('createCanvas', creator);
}
/**
 * @param {string} mapName
 * @param {Array.<Object>|Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example GeoJSON
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 *
 *     $.get('airport.svg', function (svg) {
 *         echarts.registerMap('airport', {
 *             svg: svg
 *         }
 *     });
 *
 *     echarts.registerMap('eu', [
 *         {svg: eu-topographic.svg},
 *         {geoJSON: eu.json}
 *     ])
 */


function registerMap(mapName, geoJson, specialAreas) {
  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
}
/**
 * @param {string} mapName
 * @return {Object}
 */


function getMap(mapName) {
  // For backward compatibility, only return the first one.
  var records = mapDataStorage.retrieveMap(mapName);
  return records && records[0] && {
    geoJson: records[0].geoJSON,
    specialAreas: records[0].specialAreas
  };
}

registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
registerPreprocessor(backwardCompat);
registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
registerLoading('default', loadingDefault); // Default actions

registerAction({
  type: 'highlight',
  event: 'highlight',
  update: 'highlight'
}, zrUtil.noop);
registerAction({
  type: 'downplay',
  event: 'downplay',
  update: 'downplay'
}, zrUtil.noop); // Default theme

registerTheme('light', lightTheme);
registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};
exports.version = version;
exports.dependencies = dependencies;
exports.PRIORITY = PRIORITY;
exports.init = init;
exports.connect = connect;
exports.disConnect = disConnect;
exports.disconnect = disconnect;
exports.dispose = dispose;
exports.getInstanceByDom = getInstanceByDom;
exports.getInstanceById = getInstanceById;
exports.registerTheme = registerTheme;
exports.registerPreprocessor = registerPreprocessor;
exports.registerProcessor = registerProcessor;
exports.registerPostUpdate = registerPostUpdate;
exports.registerAction = registerAction;
exports.registerCoordinateSystem = registerCoordinateSystem;
exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
exports.registerLayout = registerLayout;
exports.registerVisual = registerVisual;
exports.registerLoading = registerLoading;
exports.extendComponentModel = extendComponentModel;
exports.extendComponentView = extendComponentView;
exports.extendSeriesModel = extendSeriesModel;
exports.extendChartView = extendChartView;
exports.setCanvasCreator = setCanvasCreator;
exports.registerMap = registerMap;
exports.getMap = getMap;
exports.dataTool = dataTool;
var ___ec_export = __webpack_require__(851);
(function () {
    for (var key in ___ec_export) {
        if (___ec_export.hasOwnProperty(key)) {
            exports[key] = ___ec_export[key];
        }
    }
})();

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */

/* global wx */
var env = {};

if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
  // In Weixin Application
  env = {
    browser: {},
    os: {},
    node: false,
    wxa: true,
    // Weixin Application
    canvasSupported: true,
    svgSupported: false,
    touchEventsSupported: true,
    domSupported: false
  };
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
  // In worker
  env = {
    browser: {},
    os: {},
    node: false,
    worker: true,
    canvasSupported: true,
    domSupported: false
  };
} else if (typeof navigator === 'undefined') {
  // In node
  env = {
    browser: {},
    os: {},
    node: true,
    worker: false,
    // Assume canvas is supported
    canvasSupported: true,
    svgSupported: true,
    domSupported: false
  };
} else {
  env = detect(navigator.userAgent);
}

var _default = env; // Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.

function detect(ua) {
  var os = {};
  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
  // var touchpad = webos && ua.match(/TouchPad/);
  // var kindle = ua.match(/Kindle\/([\d.]+)/);
  // var silk = ua.match(/Silk\/([\d._]+)/);
  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
  // var playbook = ua.match(/PlayBook/);
  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);

  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;

  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+

  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes
  // if (browser.webkit = !!webkit) browser.version = webkit[1];
  // if (android) os.android = true, os.version = android[2];
  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  // if (webos) os.webos = true, os.version = webos[2];
  // if (touchpad) os.touchpad = true;
  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
  // if (bb10) os.bb10 = true, os.version = bb10[2];
  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
  // if (playbook) browser.playbook = true;
  // if (kindle) os.kindle = true, os.version = kindle[1];
  // if (silk) browser.silk = true, browser.version = silk[1];
  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
  // if (chrome) browser.chrome = true, browser.version = chrome[1];

  if (firefox) {
    browser.firefox = true;
    browser.version = firefox[1];
  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
  // if (webview) browser.webview = true;


  if (ie) {
    browser.ie = true;
    browser.version = ie[1];
  }

  if (edge) {
    browser.edge = true;
    browser.version = edge[1];
  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
  // not be set on win phone. So we do not consider Win Phone.


  if (weChat) {
    browser.weChat = true;
  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));


  return {
    browser: browser,
    os: os,
    node: false,
    // 原生canvas支持，改极端点了
    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
    canvasSupported: !!document.createElement('canvas').getContext,
    svgSupported: typeof SVGRect !== 'undefined',
    // works on most browsers
    // IE10/11 does not support touch event, and MS Edge supports them but not by
    // default, so we dont check navigator.maxTouchPoints for them here.
    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
    // <http://caniuse.com/#search=pointer%20event>.
    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
    // events currently. So we dont use that on other browsers unless tested sufficiently.
    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
    // scroll, the `pointermove` event can not be fired any more. That will break some
    // features like "pan horizontally to move something and pan vertically to page scroll".
    // The horizontal pan probably be interrupted by the casually triggered page scroll.
    // (2) Although IE 10 supports pointer event, it use old style and is different from the
    // standard. So we exclude that. (IE 10 is hardly used on touch device)
    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
    // passiveSupported: detectPassiveSupport()
    domSupported: typeof document !== 'undefined'
  };
} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
// function detectPassiveSupport() {
//     // Test via a getter in the options object to see if the passive property is accessed
//     var supportsPassive = false;
//     try {
//         var opts = Object.defineProperty({}, 'passive', {
//             get: function() {
//                 supportsPassive = true;
//             }
//         });
//         window.addEventListener('testPassive', function() {}, opts);
//     } catch (e) {
//     }
//     return supportsPassive;
// }


module.exports = _default;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

/* global Float32Array */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */

function create(x, y) {
  var out = new ArrayCtor(2);

  if (x == null) {
    x = 0;
  }

  if (y == null) {
    y = 0;
  }

  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */


function copy(out, v) {
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */


function clone(v) {
  var out = new ArrayCtor(2);
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */


function set(out, a, b) {
  out[0] = a;
  out[1] = b;
  return out;
}
/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function add(out, v1, v2) {
  out[0] = v1[0] + v2[0];
  out[1] = v1[1] + v2[1];
  return out;
}
/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */


function scaleAndAdd(out, v1, v2, a) {
  out[0] = v1[0] + v2[0] * a;
  out[1] = v1[1] + v2[1] * a;
  return out;
}
/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function sub(out, v1, v2) {
  out[0] = v1[0] - v2[0];
  out[1] = v1[1] - v2[1];
  return out;
}
/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */


function len(v) {
  return Math.sqrt(lenSquare(v));
}

var length = len; // jshint ignore:line

/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */

function lenSquare(v) {
  return v[0] * v[0] + v[1] * v[1];
}

var lengthSquare = lenSquare;
/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */

function mul(out, v1, v2) {
  out[0] = v1[0] * v2[0];
  out[1] = v1[1] * v2[1];
  return out;
}
/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function div(out, v1, v2) {
  out[0] = v1[0] / v2[0];
  out[1] = v1[1] / v2[1];
  return out;
}
/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function dot(v1, v2) {
  return v1[0] * v2[0] + v1[1] * v2[1];
}
/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */


function scale(out, v, s) {
  out[0] = v[0] * s;
  out[1] = v[1] * s;
  return out;
}
/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */


function normalize(out, v) {
  var d = len(v);

  if (d === 0) {
    out[0] = 0;
    out[1] = 0;
  } else {
    out[0] = v[0] / d;
    out[1] = v[1] / d;
  }

  return out;
}
/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function distance(v1, v2) {
  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}

var dist = distance;
/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */

function distanceSquare(v1, v2) {
  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}

var distSquare = distanceSquare;
/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */

function negate(out, v) {
  out[0] = -v[0];
  out[1] = -v[1];
  return out;
}
/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */


function lerp(out, v1, v2, t) {
  out[0] = v1[0] + t * (v2[0] - v1[0]);
  out[1] = v1[1] + t * (v2[1] - v1[1]);
  return out;
}
/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */


function applyTransform(out, v, m) {
  var x = v[0];
  var y = v[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function min(out, v1, v2) {
  out[0] = Math.min(v1[0], v2[0]);
  out[1] = Math.min(v1[1], v2[1]);
  return out;
}
/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function max(out, v1, v2) {
  out[0] = Math.max(v1[0], v2[0]);
  out[1] = Math.max(v1[1], v2[1]);
  return out;
}

exports.create = create;
exports.copy = copy;
exports.clone = clone;
exports.set = set;
exports.add = add;
exports.scaleAndAdd = scaleAndAdd;
exports.sub = sub;
exports.len = len;
exports.length = length;
exports.lenSquare = lenSquare;
exports.lengthSquare = lengthSquare;
exports.mul = mul;
exports.div = div;
exports.dot = dot;
exports.scale = scale;
exports.normalize = normalize;
exports.distance = distance;
exports.dist = dist;
exports.distanceSquare = distanceSquare;
exports.distSquare = distSquare;
exports.negate = negate;
exports.lerp = lerp;
exports.applyTransform = applyTransform;
exports.min = min;
exports.max = max;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(126);

var zrUtil = __webpack_require__(2);

var PathProxy = __webpack_require__(127);

var pathContain = __webpack_require__(818);

var Pattern = __webpack_require__(258);

var getCanvasPattern = Pattern.prototype.getCanvasPattern;
var abs = Math.abs;
var pathProxyForDraw = new PathProxy(true);
/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */

function Path(opts) {
  Displayable.call(this, opts);
  /**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */

  this.path = null;
}

Path.prototype = {
  constructor: Path,
  type: 'path',
  __dirtyPath: true,
  strokeContainThreshold: 5,
  // This item default to be false. But in map series in echarts,
  // in order to improve performance, it should be set to true,
  // so the shorty segment won't draw.
  segmentIgnoreThreshold: 0,

  /**
   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
   * @type {boolean}
   */
  subPixelOptimize: false,
  brush: function (ctx, prevEl) {
    var style = this.style;
    var path = this.path || pathProxyForDraw;
    var hasStroke = style.hasStroke();
    var hasFill = style.hasFill();
    var fill = style.fill;
    var stroke = style.stroke;
    var hasFillGradient = hasFill && !!fill.colorStops;
    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
    var hasFillPattern = hasFill && !!fill.image;
    var hasStrokePattern = hasStroke && !!stroke.image;
    style.bind(ctx, this, prevEl);
    this.setTransform(ctx);

    if (this.__dirty) {
      var rect; // Update gradient because bounding rect may changed

      if (hasFillGradient) {
        rect = rect || this.getBoundingRect();
        this._fillGradient = style.getGradient(ctx, fill, rect);
      }

      if (hasStrokeGradient) {
        rect = rect || this.getBoundingRect();
        this._strokeGradient = style.getGradient(ctx, stroke, rect);
      }
    } // Use the gradient or pattern


    if (hasFillGradient) {
      // PENDING If may have affect the state
      ctx.fillStyle = this._fillGradient;
    } else if (hasFillPattern) {
      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
    }

    if (hasStrokeGradient) {
      ctx.strokeStyle = this._strokeGradient;
    } else if (hasStrokePattern) {
      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
    }

    var lineDash = style.lineDash;
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy

    var scale = this.getGlobalScale();
    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
    // Rebuild path in following 2 cases
    // 1. Path is dirty
    // 2. Path needs javascript implemented lineDash stroking.
    //    In this case, lineDash information will not be saved in PathProxy

    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
      path.beginPath(ctx); // Setting line dash before build path

      if (lineDash && !ctxLineDash) {
        path.setLineDash(lineDash);
        path.setLineDashOffset(lineDashOffset);
      }

      this.buildPath(path, this.shape, false); // Clear path dirty flag

      if (this.path) {
        this.__dirtyPath = false;
      }
    } else {
      // Replay path building
      ctx.beginPath();
      this.path.rebuildPath(ctx);
    }

    if (hasFill) {
      if (style.fillOpacity != null) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        path.fill(ctx);
        ctx.globalAlpha = originalGlobalAlpha;
      } else {
        path.fill(ctx);
      }
    }

    if (lineDash && ctxLineDash) {
      ctx.setLineDash(lineDash);
      ctx.lineDashOffset = lineDashOffset;
    }

    if (hasStroke) {
      if (style.strokeOpacity != null) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        path.stroke(ctx);
        ctx.globalAlpha = originalGlobalAlpha;
      } else {
        path.stroke(ctx);
      }
    }

    if (lineDash && ctxLineDash) {
      // PENDING
      // Remove lineDash
      ctx.setLineDash([]);
    } // Draw rect text


    if (style.text != null) {
      // Only restore transform when needs draw text.
      this.restoreTransform(ctx);
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
  // Like in circle
  buildPath: function (ctx, shapeCfg, inBundle) {},
  createPathProxy: function () {
    this.path = new PathProxy();
  },
  getBoundingRect: function () {
    var rect = this._rect;
    var style = this.style;
    var needsUpdateRect = !rect;

    if (needsUpdateRect) {
      var path = this.path;

      if (!path) {
        // Create path on demand.
        path = this.path = new PathProxy();
      }

      if (this.__dirtyPath) {
        path.beginPath();
        this.buildPath(path, this.shape, false);
      }

      rect = path.getBoundingRect();
    }

    this._rect = rect;

    if (style.hasStroke()) {
      // Needs update rect with stroke lineWidth when
      // 1. Element changes scale or lineWidth
      // 2. Shape is changed
      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());

      if (this.__dirty || needsUpdateRect) {
        rectWithStroke.copy(rect); // FIXME Must after updateTransform

        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical

        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill

        if (!style.hasFill()) {
          w = Math.max(w, this.strokeContainThreshold || 4);
        } // Consider line width
        // Line scale can't be 0;


        if (lineScale > 1e-10) {
          rectWithStroke.width += w / lineScale;
          rectWithStroke.height += w / lineScale;
          rectWithStroke.x -= w / lineScale / 2;
          rectWithStroke.y -= w / lineScale / 2;
        }
      } // Return rect with stroke


      return rectWithStroke;
    }

    return rect;
  },
  contain: function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    var style = this.style;
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      var pathData = this.path.data;

      if (style.hasStroke()) {
        var lineWidth = style.lineWidth;
        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;

        if (lineScale > 1e-10) {
          // Only add extra hover lineWidth when there are no fill
          if (!style.hasFill()) {
            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
          }

          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
            return true;
          }
        }
      }

      if (style.hasFill()) {
        return pathContain.contain(pathData, x, y);
      }
    }

    return false;
  },

  /**
   * @param  {boolean} dirtyPath
   */
  dirty: function (dirtyPath) {
    if (dirtyPath == null) {
      dirtyPath = true;
    } // Only mark dirty, not mark clean


    if (dirtyPath) {
      this.__dirtyPath = dirtyPath;
      this._rect = null;
    }

    this.__dirty = this.__dirtyText = true;
    this.__zr && this.__zr.refresh(); // Used as a clipping path

    if (this.__clipTarget) {
      this.__clipTarget.dirty();
    }
  },

  /**
   * Alias for animate('shape')
   * @param {boolean} loop
   */
  animateShape: function (loop) {
    return this.animate('shape', loop);
  },
  // Overwrite attrKV
  attrKV: function (key, value) {
    // FIXME
    if (key === 'shape') {
      this.setShape(value);
      this.__dirtyPath = true;
      this._rect = null;
    } else {
      Displayable.prototype.attrKV.call(this, key, value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setShape: function (key, value) {
    var shape = this.shape; // Path from string may not have shape

    if (shape) {
      if (zrUtil.isObject(key)) {
        for (var name in key) {
          if (key.hasOwnProperty(name)) {
            shape[name] = key[name];
          }
        }
      } else {
        shape[key] = value;
      }

      this.dirty(true);
    }

    return this;
  },
  getLineScale: function () {
    var m = this.transform; // Get the line scale.
    // Determinant of `m` means how much the area is enlarged by the
    // transformation. So its square root can be used as a scale factor
    // for width.

    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
  }
};
/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */

Path.extend = function (defaults) {
  var Sub = function (opts) {
    Path.call(this, opts);

    if (defaults.style) {
      // Extend default style
      this.style.extendFrom(defaults.style, false);
    } // Extend default shape


    var defaultShape = defaults.shape;

    if (defaultShape) {
      this.shape = this.shape || {};
      var thisShape = this.shape;

      for (var name in defaultShape) {
        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
          thisShape[name] = defaultShape[name];
        }
      }
    }

    defaults.init && defaults.init.call(this, opts);
  };

  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象

  for (var name in defaults) {
    // Extending prototype values and methods
    if (name !== 'style' && name !== 'shape') {
      Sub.prototype[name] = defaults[name];
    }
  }

  return Sub;
};

zrUtil.inherits(Path, Displayable);
var _default = Path;
module.exports = _default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
var RADIAN_EPSILON = 1e-4;

function _trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}
/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */


function linearMap(val, domain, range, clamp) {
  var subDomain = domain[1] - domain[0];
  var subRange = range[1] - range[0];

  if (subDomain === 0) {
    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= domain[0]) {
        return range[0];
      } else if (val >= domain[1]) {
        return range[1];
      }
    } else {
      if (val >= domain[0]) {
        return range[0];
      } else if (val <= domain[1]) {
        return range[1];
      }
    }
  } else {
    if (val === domain[0]) {
      return range[0];
    }

    if (val === domain[1]) {
      return range[1];
    }
  }

  return (val - domain[0]) / subDomain * subRange + range[0];
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */


function parsePercent(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (typeof percent === 'string') {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */


function round(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), 20);
  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}
/**
 * asc sort arr.
 * The input arr will be modified.
 *
 * @param {Array} arr
 * @return {Array} The input arr.
 */


function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision
 * @param {number} val
 */


function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      var tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low


  var e = 1;
  var count = 0;

  while (Math.round(val * e) / e !== val) {
    e *= 10;
    count++;
  }

  return count;
}
/**
 * @param {string|number} val
 * @return {number}
 */


function getPrecisionSafe(val) {
  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');

  if (eIndex > 0) {
    var precision = +str.slice(eIndex + 1);
    return precision < 0 ? -precision : 0;
  } else {
    var dotIndex = str.indexOf('.');
    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
  }
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */


function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */


function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var sum = zrUtil.reduce(valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return 0;
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = zrUtil.map(valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = zrUtil.map(votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = zrUtil.reduce(seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return seats[idx] / digits;
} // Number.MAX_SAFE_INTEGER, ie do not support.


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */


function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
}
/* eslint-disable */


var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/* eslint-enable */

/**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (typeof value === 'string') {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset specifed.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */


function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}
/**
 * Exponent of the quantity of a number
 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
 *
 * @param  {number} val non-negative value
 * @return {number}
 */


function quantityExponent(val) {
  if (val === 0) {
    return 0;
  }

  var exp = Math.floor(Math.log(val) / Math.LN10);
  /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */

  if (val / Math.pow(10, exp) >= 10) {
    exp++;
  }

  return exp;
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */


function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * This code was copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
 * See the license statement at the head of this file.
 * @param {Array.<number>} ascArr
 */


function quantile(ascArr, p) {
  var H = (ascArr.length - 1) * p + 1;
  var h = Math.floor(H);
  var v = +ascArr[h - 1];
  var e = H - h;
  return e ? v + e * (ascArr[h] - v) : v;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */


function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close[lg];
    }

    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */


function isNumeric(v) {
  return v - parseFloat(v) >= 0;
}

exports.linearMap = linearMap;
exports.parsePercent = parsePercent;
exports.round = round;
exports.asc = asc;
exports.getPrecision = getPrecision;
exports.getPrecisionSafe = getPrecisionSafe;
exports.getPixelPrecision = getPixelPrecision;
exports.getPercentWithPrecision = getPercentWithPrecision;
exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
exports.remRadian = remRadian;
exports.isRadianAroundZero = isRadianAroundZero;
exports.parseDate = parseDate;
exports.quantity = quantity;
exports.quantityExponent = quantityExponent;
exports.nice = nice;
exports.quantile = quantile;
exports.reformIntervals = reformIntervals;
exports.isNumeric = isNumeric;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var createDesc = __webpack_require__(64);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(29);
var has = __webpack_require__(34);
var SRC = __webpack_require__(65)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(39).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(10);
var defined = __webpack_require__(46);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apng__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_load_waitdialog_png__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_load_waitdialog_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_load_waitdialog_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Load=function(_Component){_inherits(Load,_Component);function Load(){_classCallCheck(this,Load);return _possibleConstructorReturn(this,(Load.__proto__||Object.getPrototypeOf(Load)).apply(this,arguments));}_createClass(Load,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'load '+this.props.type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'load_img',src:__WEBPACK_IMPORTED_MODULE_3__static_images_load_waitdialog_png___default.a,autoPlay:true}));}}]);return Load;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Load);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(26);

var matrix = __webpack_require__(74);

/**
 * @module echarts/core/BoundingRect
 */
var v2ApplyTransform = vec2.applyTransform;
var mathMin = Math.min;
var mathMax = Math.max;
/**
 * @alias module:echarts/core/BoundingRect
 */

function BoundingRect(x, y, width, height) {
  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }
  /**
   * @type {number}
   */


  this.x = x;
  /**
   * @type {number}
   */

  this.y = y;
  /**
   * @type {number}
   */

  this.width = width;
  /**
   * @type {number}
   */

  this.height = height;
}

BoundingRect.prototype = {
  constructor: BoundingRect,

  /**
   * @param {module:echarts/core/BoundingRect} other
   */
  union: function (other) {
    var x = mathMin(other.x, this.x);
    var y = mathMin(other.y, this.y);
    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
    this.x = x;
    this.y = y;
  },

  /**
   * @param {Array.<number>} m
   * @methods
   */
  applyTransform: function () {
    var lt = [];
    var rb = [];
    var lb = [];
    var rt = [];
    return function (m) {
      // In case usage like this
      // el.getBoundingRect().applyTransform(el.transform)
      // And element has no transform
      if (!m) {
        return;
      }

      lt[0] = lb[0] = this.x;
      lt[1] = rt[1] = this.y;
      rb[0] = rt[0] = this.x + this.width;
      rb[1] = lb[1] = this.y + this.height;
      v2ApplyTransform(lt, lt, m);
      v2ApplyTransform(rb, rb, m);
      v2ApplyTransform(lb, lb, m);
      v2ApplyTransform(rt, rt, m);
      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
      this.width = maxX - this.x;
      this.height = maxY - this.y;
    };
  }(),

  /**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */
  calculateTransform: function (b) {
    var a = this;
    var sx = b.width / a.width;
    var sy = b.height / a.height;
    var m = matrix.create(); // 矩阵右乘

    matrix.translate(m, m, [-a.x, -a.y]);
    matrix.scale(m, m, [sx, sy]);
    matrix.translate(m, m, [b.x, b.y]);
    return m;
  },

  /**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */
  intersect: function (b) {
    if (!b) {
      return false;
    }

    if (!(b instanceof BoundingRect)) {
      // Normalize negative width/height.
      b = BoundingRect.create(b);
    }

    var a = this;
    var ax0 = a.x;
    var ax1 = a.x + a.width;
    var ay0 = a.y;
    var ay1 = a.y + a.height;
    var bx0 = b.x;
    var bx1 = b.x + b.width;
    var by0 = b.y;
    var by1 = b.y + b.height;
    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
  },
  contain: function (x, y) {
    var rect = this;
    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
  },

  /**
   * @return {module:echarts/core/BoundingRect}
   */
  clone: function () {
    return new BoundingRect(this.x, this.y, this.width, this.height);
  },

  /**
   * Copy from another rect
   */
  copy: function (other) {
    this.x = other.x;
    this.y = other.y;
    this.width = other.width;
    this.height = other.height;
  },
  plain: function () {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }
};
/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */

BoundingRect.create = function (rect) {
  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
};

var _default = BoundingRect;
module.exports = _default;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87);
var defined = __webpack_require__(46);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(88);
var createDesc = __webpack_require__(64);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(45);
var has = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(184);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(34);
var toObject = __webpack_require__(19);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(225);
var isBuffer = __webpack_require__(567);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(23);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var textContain = __webpack_require__(75);

var numberUtil = __webpack_require__(28);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import Text from 'zrender/src/graphic/Text';

/**
 * 每三位默认加,格式化
 * @param {string|number} x
 * @return {string}
 */
function addCommas(x) {
  if (isNaN(x)) {
    return '-';
  }

  x = (x + '').split('.');
  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
}
/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */


function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}

var normalizeCssArray = zrUtil.normalizeCssArray;
var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};

function encodeHTML(source) {
  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}

var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTpl(tpl, paramsList, encode) {
  if (!zrUtil.isArray(paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTplSimple(tpl, param, encode) {
  zrUtil.each(param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
/**
 * @param {Object|string} [opt] If string, means color.
 * @param {string} [opt.color]
 * @param {string} [opt.extraCssText]
 * @param {string} [opt.type='item'] 'item' or 'subItem'
 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
 * @return {string}
 */


function getTooltipMarker(opt, extraCssText) {
  opt = zrUtil.isString(opt) ? {
    color: opt,
    extraCssText: extraCssText
  } : opt || {};
  var color = opt.color;
  var type = opt.type;
  var extraCssText = opt.extraCssText;
  var renderMode = opt.renderMode || 'html';
  var markerId = opt.markerId || 'X';

  if (!color) {
    return '';
  }

  if (renderMode === 'html') {
    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
  } else {
    // Space for rich element marker
    return {
      renderMode: renderMode,
      content: '{marker' + markerId + '|}  ',
      style: {
        color: color
      }
    };
  }
}

function pad(str, len) {
  str += '';
  return '0000'.substr(0, len - str.length) + str;
}
/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */


function formatTime(tpl, value, isUTC) {
  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = numberUtil.parseDate(value);
  var utc = isUTC ? 'UTC' : '';
  var y = date['get' + utc + 'FullYear']();
  var M = date['get' + utc + 'Month']() + 1;
  var d = date['get' + utc + 'Date']();
  var h = date['get' + utc + 'Hours']();
  var m = date['get' + utc + 'Minutes']();
  var s = date['get' + utc + 'Seconds']();
  var S = date['get' + utc + 'Milliseconds']();
  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */


function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}

var truncateText = textContain.truncateText;
/**
 * @public
 * @param {Object} opt
 * @param {string} opt.text
 * @param {string} opt.font
 * @param {string} [opt.textAlign='left']
 * @param {string} [opt.textVerticalAlign='top']
 * @param {Array.<number>} [opt.textPadding]
 * @param {number} [opt.textLineHeight]
 * @param {Object} [opt.rich]
 * @param {Object} [opt.truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */

function getTextBoundingRect(opt) {
  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
}
/**
 * @deprecated
 * the `textLineHeight` was added later.
 * For backward compatiblility, put it as the last parameter.
 * But deprecated this interface. Please use `getTextBoundingRect` instead.
 */


function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
}

exports.addCommas = addCommas;
exports.toCamelCase = toCamelCase;
exports.normalizeCssArray = normalizeCssArray;
exports.encodeHTML = encodeHTML;
exports.formatTpl = formatTpl;
exports.formatTplSimple = formatTplSimple;
exports.getTooltipMarker = getTooltipMarker;
exports.formatTime = formatTime;
exports.capitalFirst = capitalFirst;
exports.truncateText = truncateText;
exports.getTextBoundingRect = getTextBoundingRect;
exports.getTextRect = getTextRect;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(39);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(40);
var IObject = __webpack_require__(87);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(16);
var asc = __webpack_require__(152);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(59);
  var global = __webpack_require__(8);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(115);
  var $buffer = __webpack_require__(158);
  var ctx = __webpack_require__(40);
  var anInstance = __webpack_require__(71);
  var propertyDesc = __webpack_require__(64);
  var hide = __webpack_require__(29);
  var redefineAll = __webpack_require__(73);
  var toInteger = __webpack_require__(47);
  var toLength = __webpack_require__(16);
  var toIndex = __webpack_require__(210);
  var toAbsoluteIndex = __webpack_require__(67);
  var toPrimitive = __webpack_require__(45);
  var has = __webpack_require__(34);
  var classof = __webpack_require__(89);
  var isObject = __webpack_require__(11);
  var toObject = __webpack_require__(19);
  var isArrayIter = __webpack_require__(149);
  var create = __webpack_require__(68);
  var getPrototypeOf = __webpack_require__(37);
  var gOPN = __webpack_require__(69).f;
  var getIterFn = __webpack_require__(151);
  var uid = __webpack_require__(65);
  var wks = __webpack_require__(12);
  var createArrayMethod = __webpack_require__(49);
  var createArrayIncludes = __webpack_require__(105);
  var speciesConstructor = __webpack_require__(112);
  var ArrayIterators = __webpack_require__(154);
  var Iterators = __webpack_require__(79);
  var $iterDetect = __webpack_require__(109);
  var setSpecies = __webpack_require__(70);
  var arrayFill = __webpack_require__(153);
  var arrayCopyWithin = __webpack_require__(200);
  var $DP = __webpack_require__(15);
  var $GOPD = __webpack_require__(36);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(205);
var $export = __webpack_require__(0);
var shared = __webpack_require__(104)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(208))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_images_toast_error_png__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_images_toast_error_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_images_toast_error_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_toast_load_gif__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_toast_load_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_images_toast_load_gif__);
// import imgSuccess from '../static/images/toast/success.png';
var Toast={// DURATION_SHORT: 1500,
// DURATION_LONG: 5000,
// DURATION_ALWAYS: -1,
// DELAY_SHORT: 300,
// DELAY_LONG: 1000,
// POSITION_BOTTOM: "bottom",
// POSITION_CENTER: "cneter",
// POSITION_LITTLEBOTTOM: "littlebottom",
_default:{text:"undefined",duration:2000,delay:0,position:"bottom"},// _wait: [],
// _boxOnPag: null,
_getClientHeight:function _getClientHeight(){return document.documentElement.clientHeight;},_getClientWidth:function _getClientWidth(){return document.documentElement.clientWidth;},_createMaskBox:function _createMaskBox(){var dom=document.createElement("div");dom.className="toast-mask";dom.style.cssText="position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;";document.getElementById("root").appendChild(dom);},_creatInfoBox:function _creatInfoBox(text){var height=this._getClientHeight();var width=this._getClientWidth();var dom=document.createElement("div");dom.className="toast";if(text)dom.innerText=text;else dom.innerText=this._default.text;dom.style.cssText="display:inline-block;border-radius:5px;line-height:20px;transition:all 0.5s linear;opacity:0;text-align:center;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;min-width:80px;max-width:200px;padding:6px 10px;top:"+(height/3+20)+"px;";document.getElementById("root").appendChild(dom);dom.style.left=(width-dom.clientWidth)/2+"px";this._boxAnimation(dom,height,true);},_creatErrorBox:function _creatErrorBox(text){var height=this._getClientHeight();var width=this._getClientWidth();var dom=document.createElement("div");dom.className="toast";var imgDom=new Image();imgDom.src=__WEBPACK_IMPORTED_MODULE_0__static_images_toast_error_png___default.a;var textDom=document.createElement("div");if(text)textDom.innerText=text;else textDom.innerText=this._default.text;dom.style.cssText="display:inline-block;border-radius:5px;line-height:20px;text-align:center;transition:all 0.5s linear;opacity:0;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;width:120px;height:100px;top:"+height/3+"px;";imgDom.style.cssText="position:absolute;width:50px;height:50px;left:35px;top:15px;";textDom.style.cssText="position:absolute;left:0;right:0;bottom:6px;height:20px;font-size:12px;color:#fff";dom.appendChild(imgDom);dom.appendChild(textDom);document.getElementById("root").appendChild(dom);dom.style.left=(width-dom.clientWidth)/2+"px";this._boxAnimation(dom,height);},_creatLoadBox:function _creatLoadBox(text){var height=this._getClientHeight();var width=this._getClientWidth();var imgDom=new Image();imgDom.src=__WEBPACK_IMPORTED_MODULE_1__static_images_toast_load_gif___default.a;var dom=document.createElement("div");dom.className="toast";var textDom=document.createElement("div");if(text)textDom.innerText=text;else textDom.innerText="loading";dom.style.cssText="display:inline-block;border-radius:5px;line-height:20px;text-align:center;transition:all 0.5s linear;opacity:0;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;width:120px;height:100px;top:"+height/3+"px;";imgDom.style.cssText="position:absolute;width:80px;height:80px;left:20px;top:0";textDom.style.cssText="position:absolute;left:0;right:0;bottom:6px;height:20px;font-size:12px;color:#fff";dom.appendChild(imgDom);dom.appendChild(textDom);document.getElementById("root").appendChild(dom);dom.style.left=(width-dom.clientWidth)/2+"px";this._boxAnimation(dom,height);},_boxAnimation:function _boxAnimation(element,height,isInfo){var _this=this;// if(this.duration) const duration = this.duration;
// else const duration = this._default.duration;
var duration=this.duration?this.duration:this._default.duration;element.style.opacity="1";element.style.top=height*1/3+"px";isInfo&&setTimeout(function(){_this.clear(element);},duration);},clear:function clear(){var ele=document.getElementsByClassName("toast")[0];var eleMask=document.getElementsByClassName("toast-mask")[0];ele.style.opacity="0";setTimeout(function(){document.getElementById("root").removeChild(ele);if(eleMask){document.getElementById("root").removeChild(eleMask);}},1000);},info:function info(param){var _ref=param?param:{},text=_ref.text,duration=_ref.duration;this.duration=duration;this._createMaskBox();this._creatInfoBox(text);},error:function error(param){var _ref2=param?param:{},text=_ref2.text,duration=_ref2.duration;this.duration=duration;this._creatErrorBox(text);},load:function load(param){var _ref3=param?param:{},text=_ref3.text,duration=_ref3.duration;this.duration=duration;this._creatLoadBox(text);}};/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var env = __webpack_require__(25);

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

var _clazz = __webpack_require__(62);

var enableClassExtend = _clazz.enableClassExtend;
var enableClassCheck = _clazz.enableClassCheck;

var lineStyleMixin = __webpack_require__(815);

var areaStyleMixin = __webpack_require__(816);

var textStyleMixin = __webpack_require__(817);

var itemStyleMixin = __webpack_require__(833);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/model/Model
 */
var mixin = zrUtil.mixin;
var inner = makeInner();
/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} [option]
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */

function Model(option, parentModel, ecModel) {
  /**
   * @type {module:echarts/model/Model}
   * @readOnly
   */
  this.parentModel = parentModel;
  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */

  this.ecModel = ecModel;
  /**
   * @type {Object}
   * @protected
   */

  this.option = option; // Simple optimization
  // if (this.init) {
  //     if (arguments.length <= 4) {
  //         this.init(option, parentModel, ecModel, extraOpt);
  //     }
  //     else {
  //         this.init.apply(this, arguments);
  //     }
  // }
}

Model.prototype = {
  constructor: Model,

  /**
   * Model 的初始化函数
   * @param {Object} option
   */
  init: null,

  /**
   * 从新的 Option merge
   */
  mergeOption: function (option) {
    zrUtil.merge(this.option, option, true);
  },

  /**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  get: function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
  },

  /**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  getShallow: function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];
    var parentModel = !ignoreParent && getParent(this, key);

    if (val == null && parentModel) {
      val = parentModel.getShallow(key);
    }

    return val;
  },

  /**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path, parentModel) {
    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
    var thisParentModel;
    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
    return new Model(obj, parentModel, this.ecModel);
  },

  /**
   * If model has option
   */
  isEmpty: function () {
    return this.option == null;
  },
  restoreData: function () {},
  // Pending
  clone: function () {
    var Ctor = this.constructor;
    return new Ctor(zrUtil.clone(this.option));
  },
  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
  },
  // If path is null/undefined, return null/undefined.
  parsePath: function (path) {
    if (typeof path === 'string') {
      path = path.split('.');
    }

    return path;
  },

  /**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */
  customizeGetParent: function (getParentMethod) {
    inner(this).getParent = getParentMethod;
  },
  isAnimationEnabled: function () {
    if (!env.node) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  }
};

function doGet(obj, pathArr, parentModel) {
  for (var i = 0; i < pathArr.length; i++) {
    // Ignore empty
    if (!pathArr[i]) {
      continue;
    } // obj could be number/string/... (like 0)


    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

    if (obj == null) {
      break;
    }
  }

  if (obj == null && parentModel) {
    obj = parentModel.get(pathArr);
  }

  return obj;
} // `path` can be null/undefined


function getParent(model, path) {
  var getParentMethod = inner(model).getParent;
  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
} // Enable Model.extend.


enableClassExtend(Model);
enableClassCheck(Model);
mixin(Model, lineStyleMixin);
mixin(Model, areaStyleMixin);
mixin(Model, textStyleMixin);
mixin(Model, itemStyleMixin);
var _default = Model;
module.exports = _default;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Model = __webpack_require__(55);

var componentUtil = __webpack_require__(128);

var _clazz = __webpack_require__(62);

var enableClassManagement = _clazz.enableClassManagement;
var parseClassType = _clazz.parseClassType;

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

var layout = __webpack_require__(57);

var boxLayoutMixin = __webpack_require__(834);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Component model
 *
 * @module echarts/model/Component
 */
var inner = makeInner();
/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */

var ComponentModel = Model.extend({
  type: 'component',

  /**
   * @readOnly
   * @type {string}
   */
  id: '',

  /**
   * Because simplified concept is probably better, series.name (or component.name)
   * has been having too many resposibilities:
   * (1) Generating id (which requires name in option should not be modified).
   * (2) As an index to mapping series when merging option or calling API (a name
   * can refer to more then one components, which is convinient is some case).
   * (3) Display.
   * @readOnly
   */
  name: '',

  /**
   * @readOnly
   * @type {string}
   */
  mainType: '',

  /**
   * @readOnly
   * @type {string}
   */
  subType: '',

  /**
   * @readOnly
   * @type {number}
   */
  componentIndex: 0,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */
  ecModel: null,

  /**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */
  dependentModels: [],

  /**
   * @type {string}
   * @readOnly
   */
  uid: null,

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  $constructor: function (option, parentModel, ecModel, extraOpt) {
    Model.call(this, option, parentModel, ecModel, extraOpt);
    this.uid = componentUtil.getUID('ec_cpt_model');
  },
  init: function (option, parentModel, ecModel, extraOpt) {
    this.mergeDefaultAndTheme(option, ecModel);
  },
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
    var themeModel = ecModel.getTheme();
    zrUtil.merge(option, themeModel.get(this.mainType));
    zrUtil.merge(option, this.getDefaultOption());

    if (layoutMode) {
      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (option, extraOpt) {
    zrUtil.merge(this.option, option, true);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      layout.mergeLayoutParam(this.option, option, layoutMode);
    }
  },
  // Hooker after init or mergeOption
  optionUpdated: function (newCptOption, isInit) {},
  getDefaultOption: function () {
    var fields = inner(this);

    if (!fields.defaultOption) {
      var optList = [];
      var Class = this.constructor;

      while (Class) {
        var opt = Class.prototype.defaultOption;
        opt && optList.push(opt);
        Class = Class.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
      }

      fields.defaultOption = defaultOption;
    }

    return fields.defaultOption;
  },
  getReferringComponents: function (mainType) {
    return this.ecModel.queryComponents({
      mainType: mainType,
      index: this.get(mainType + 'Index', true),
      id: this.get(mainType + 'Id', true)
    });
  }
}); // Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

enableClassManagement(ComponentModel, {
  registerWhenExtend: true
});
componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.

componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
    deps = deps.concat(Clazz.prototype.dependencies || []);
  }); // Ensure main type.

  deps = zrUtil.map(deps, function (type) {
    return parseClassType(type).main;
  }); // Hack dataset for convenience.

  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
    deps.unshift('dataset');
  }

  return deps;
}

zrUtil.mixin(ComponentModel, boxLayoutMixin);
var _default = ComponentModel;
module.exports = _default;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var BoundingRect = __webpack_require__(33);

var _number = __webpack_require__(28);

var parsePercent = _number.parsePercent;

var formatUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Layout helpers for each component positioning
var each = zrUtil.each;
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var position = child.position;
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    position[0] = x;
    position[1] = y;
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = zrUtil.curry(boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = zrUtil.curry(boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = parsePercent(positionInfo.x, containerWidth);
  var y = parsePercent(positionInfo.y, containerHeight);
  var x2 = parsePercent(positionInfo.x2, containerWidth);
  var y2 = parsePercent(positionInfo.y2, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
  margin = formatUtil.normalizeCssArray(margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */


function getLayoutRect(positionInfo, containerRect, margin) {
  margin = formatUtil.normalizeCssArray(margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = parsePercent(positionInfo.left, containerWidth);
  var top = parsePercent(positionInfo.top, containerHeight);
  var right = parsePercent(positionInfo.right, containerWidth);
  var bottom = parsePercent(positionInfo.bottom, containerHeight);
  var width = parsePercent(positionInfo.width, containerWidth);
  var height = parsePercent(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */


function positionElement(el, positionInfo, containerRect, margin, opt) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';

  if (!h && !v) {
    return;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  positionInfo = getLayoutRect(zrUtil.defaults({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransform),
  // we can just only modify el.position to get final result.

  var elPos = el.position;
  var dx = h ? positionInfo.x - rect.x : 0;
  var dy = v ? positionInfo.y - rect.y : 0;
  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
}
/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 */


function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
/**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */


function mergeLayoutParam(targetOption, newOption, opt) {
  !zrUtil.isObject(opt) && (opt = {});
  var ignoreSize = opt.ignoreSize;
  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each(names, function (name) {
      merged[name] = targetOption[name];
    });
    each(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name = names[i];

          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
            newParams[name] = targetOption[name];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function copyLayoutParams(target, source) {
  source && target && each(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

exports.LOCATION_PARAMS = LOCATION_PARAMS;
exports.HV_NAMES = HV_NAMES;
exports.box = box;
exports.vbox = vbox;
exports.hbox = hbox;
exports.getAvailableSize = getAvailableSize;
exports.getLayoutRect = getLayoutRect;
exports.positionElement = positionElement;
exports.sizeCalculable = sizeCalculable;
exports.mergeLayoutParam = mergeLayoutParam;
exports.getLayoutParams = getLayoutParams;
exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(65)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(34);
var setDesc = __webpack_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(29)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */

function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    componentType = componentType.split(TYPE_DELIMITER);
    ret.main = componentType[0] || '';
    ret.sub = componentType[1] || '';
  }

  return ret;
}
/**
 * @public
 */


function checkClassType(componentType) {
  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
/**
 * @public
 */


function enableClassExtend(RootClass, mandatoryMethods) {
  RootClass.$constructor = RootClass;

  RootClass.extend = function (proto) {
    var superClass = this;

    var ExtendedClass = function () {
      if (!proto.$constructor) {
        superClass.apply(this, arguments);
      } else {
        proto.$constructor.apply(this, arguments);
      }
    };

    zrUtil.extend(ExtendedClass.prototype, proto);
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    zrUtil.inherits(ExtendedClass, this);
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
}

var classBase = 0;
/**
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 */

function enableClassCheck(Clz) {
  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
  Clz.prototype[classAttr] = true;

  Clz.isInstance = function (obj) {
    return !!(obj && obj[classAttr]);
  };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.


function superCall(context, methodName) {
  var args = zrUtil.slice(arguments, 2);
  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */


function enableClassManagement(entity, options) {
  options = options || {};
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */

  var storage = {};

  entity.registerClass = function (Clazz, componentType) {
    if (componentType) {
      checkClassType(componentType);
      componentType = parseClassType(componentType);

      if (!componentType.sub) {
        storage[componentType.main] = Clazz;
      } else if (componentType.sub !== IS_CONTAINER) {
        var container = makeContainer(componentType);
        container[componentType.sub] = Clazz;
      }
    }

    return Clazz;
  };

  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
    var Clazz = storage[componentMainType];

    if (Clazz && Clazz[IS_CONTAINER]) {
      Clazz = subType ? Clazz[subType] : null;
    }

    if (throwWhenNotFound && !Clazz) {
      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
    }

    return Clazz;
  };

  entity.getClassesByMainType = function (componentType) {
    componentType = parseClassType(componentType);
    var result = [];
    var obj = storage[componentType.main];

    if (obj && obj[IS_CONTAINER]) {
      zrUtil.each(obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  entity.hasClass = function (componentType) {
    // Just consider componentType.main.
    componentType = parseClassType(componentType);
    return !!storage[componentType.main];
  };
  /**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  entity.getAllClassMainTypes = function () {
    var types = [];
    zrUtil.each(storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */


  entity.hasSubTypes = function (componentType) {
    componentType = parseClassType(componentType);
    var obj = storage[componentType.main];
    return obj && obj[IS_CONTAINER];
  };

  entity.parseClassType = parseClassType;

  function makeContainer(componentType) {
    var container = storage[componentType.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentType.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }

  if (options.registerWhenExtend) {
    var originalExtend = entity.extend;

    if (originalExtend) {
      entity.extend = function (proto) {
        var ExtendedClass = originalExtend.call(this, proto);
        return entity.registerClass(ExtendedClass, proto.type);
      };
    }
  }

  return entity;
}
/**
 * @param {string|Array.<string>} properties
 */


function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
  // if (!zrUtil.isArray(properties)) {
  //     properties = properties != null ? [properties] : [];
  // }
  // zrUtil.each(properties, function (prop) {
  //     var value = obj[prop];
  //     Object.defineProperty
  //         && Object.defineProperty(obj, prop, {
  //             value: value, writable: false
  //         });
  //     zrUtil.isArray(obj[prop])
  //         && Object.freeze
  //         && Object.freeze(obj[prop]);
  // });
}

exports.parseClassType = parseClassType;
exports.enableClassExtend = enableClassExtend;
exports.enableClassCheck = enableClassCheck;
exports.enableClassManagement = enableClassManagement;
exports.setReadOnly = setReadOnly;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(309);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(186);
var enumBugKeys = __webpack_require__(136);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(187);
var enumBugKeys = __webpack_require__(136);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(133)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(137).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(186);
var hiddenKeys = __webpack_require__(136).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var dP = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(149);
var anObject = __webpack_require__(6);
var toLength = __webpack_require__(16);
var getIterFn = __webpack_require__(151);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(30);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */

/* global Float32Array */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * Create a identity matrix.
 * @return {Float32Array|Array.<number>}
 */

function create() {
  var out = new ArrayCtor(6);
  identity(out);
  return out;
}
/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */


function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */


function copy(out, m) {
  out[0] = m[0];
  out[1] = m[1];
  out[2] = m[2];
  out[3] = m[3];
  out[4] = m[4];
  out[5] = m[5];
  return out;
}
/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */


function mul(out, m1, m2) {
  // Consider matrix.mul(m, m2, m);
  // where out is the same as m2.
  // So use temp variable to escape error.
  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = out3;
  out[4] = out4;
  out[5] = out5;
  return out;
}
/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function translate(out, a, v) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4] + v[0];
  out[5] = a[5] + v[1];
  return out;
}
/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */


function rotate(out, a, rad) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var st = Math.sin(rad);
  var ct = Math.cos(rad);
  out[0] = aa * ct + ab * st;
  out[1] = -aa * st + ab * ct;
  out[2] = ac * ct + ad * st;
  out[3] = -ac * st + ct * ad;
  out[4] = ct * atx + st * aty;
  out[5] = ct * aty - st * atx;
  return out;
}
/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function scale(out, a, v) {
  var vx = v[0];
  var vy = v[1];
  out[0] = a[0] * vx;
  out[1] = a[1] * vy;
  out[2] = a[2] * vx;
  out[3] = a[3] * vy;
  out[4] = a[4] * vx;
  out[5] = a[5] * vy;
  return out;
}
/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */


function invert(out, a) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}
/**
 * Clone a new matrix.
 * @param {Float32Array|Array.<number>} a
 */


function clone(a) {
  var b = create();
  copy(b, a);
  return b;
}

exports.create = create;
exports.identity = identity;
exports.copy = copy;
exports.mul = mul;
exports.translate = translate;
exports.rotate = rotate;
exports.scale = scale;
exports.invert = invert;
exports.clone = clone;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(33);

var imageHelper = __webpack_require__(172);

var _util = __webpack_require__(2);

var getContext = _util.getContext;
var extend = _util.extend;
var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var trim = _util.trim;
var textWidthCache = {};
var textWidthCacheCounter = 0;
var TEXT_CACHE_MAX = 5000;
var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */


function getWidth(text, font) {
  font = font || DEFAULT_FONT;
  var key = text + ':' + font;

  if (textWidthCache[key]) {
    return textWidthCache[key];
  }

  var textLines = (text + '').split('\n');
  var width = 0;

  for (var i = 0, l = textLines.length; i < l; i++) {
    // textContain.measureText may be overrided in SVG or VML
    width = Math.max(measureText(textLines[i], font).width, width);
  }

  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
    textWidthCacheCounter = 0;
    textWidthCache = {};
  }

  textWidthCacheCounter++;
  textWidthCache[key] = width;
  return width;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */


function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
}

function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
  var outerWidth = getWidth(text, font);

  if (textPadding) {
    outerWidth += textPadding[1] + textPadding[3];
  }

  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
  rect.lineHeight = contentBlock.lineHeight;
  return rect;
}

function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
  var contentBlock = parseRichText(text, {
    rich: rich,
    truncate: truncate,
    font: font,
    textAlign: textAlign,
    textPadding: textPadding,
    textLineHeight: textLineHeight
  });
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  return new BoundingRect(x, y, outerWidth, outerHeight);
}
/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */


function adjustTextX(x, width, textAlign) {
  // FIXME Right to left language
  if (textAlign === 'right') {
    x -= width;
  } else if (textAlign === 'center') {
    x -= width / 2;
  }

  return x;
}
/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */


function adjustTextY(y, height, textVerticalAlign) {
  if (textVerticalAlign === 'middle') {
    y -= height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y -= height;
  }

  return y;
}
/**
 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
 * @public
 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
 */


function calculateTextPosition(out, style, rect) {
  var textPosition = style.textPosition;
  var distance = style.textDistance;
  var x = rect.x;
  var y = rect.y;
  distance = distance || 0;
  var height = rect.height;
  var width = rect.width;
  var halfHeight = height / 2;
  var textAlign = 'left';
  var textVerticalAlign = 'top';

  switch (textPosition) {
    case 'left':
      x -= distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'right':
      x += distance + width;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'top':
      x += width / 2;
      y -= distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'bottom':
      x += width / 2;
      y += height + distance;
      textAlign = 'center';
      break;

    case 'inside':
      x += width / 2;
      y += halfHeight;
      textAlign = 'center';
      textVerticalAlign = 'middle';
      break;

    case 'insideLeft':
      x += distance;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'insideRight':
      x += width - distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'insideTop':
      x += width / 2;
      y += distance;
      textAlign = 'center';
      break;

    case 'insideBottom':
      x += width / 2;
      y += height - distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'insideTopLeft':
      x += distance;
      y += distance;
      break;

    case 'insideTopRight':
      x += width - distance;
      y += distance;
      textAlign = 'right';
      break;

    case 'insideBottomLeft':
      x += distance;
      y += height - distance;
      textVerticalAlign = 'bottom';
      break;

    case 'insideBottomRight':
      x += width - distance;
      y += height - distance;
      textAlign = 'right';
      textVerticalAlign = 'bottom';
      break;
  }

  out = out || {};
  out.x = x;
  out.y = y;
  out.textAlign = textAlign;
  out.textVerticalAlign = textVerticalAlign;
  return out;
}
/**
 * To be removed. But still do not remove in case that some one has imported it.
 * @deprecated
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */


function adjustTextPositionOnRect(textPosition, rect, distance) {
  var dummyStyle = {
    textPosition: textPosition,
    textDistance: distance
  };
  return calculateTextPosition({}, dummyStyle, rect);
}
/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */


function truncateText(text, containerWidth, font, ellipsis, options) {
  if (!containerWidth) {
    return '';
  }

  var textLines = (text + '').split('\n');
  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
  // It is not appropriate that every line has '...' when truncate multiple lines.

  for (var i = 0, len = textLines.length; i < len; i++) {
    textLines[i] = truncateSingleLine(textLines[i], options);
  }

  return textLines.join('\n');
}

function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
  options = extend({}, options);
  options.font = font;
  var ellipsis = retrieve2(ellipsis, '...');
  options.maxIterations = retrieve2(options.maxIterations, 2);
  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
  // Other languages?

  options.cnCharWidth = getWidth('国', font); // FIXME
  // Consider proportional font?

  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.

  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.

  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
    contentWidth -= ascCharWidth;
  }

  var ellipsisWidth = getWidth(ellipsis, font);

  if (ellipsisWidth > contentWidth) {
    ellipsis = '';
    ellipsisWidth = 0;
  }

  contentWidth = containerWidth - ellipsisWidth;
  options.ellipsis = ellipsis;
  options.ellipsisWidth = ellipsisWidth;
  options.contentWidth = contentWidth;
  options.containerWidth = containerWidth;
  return options;
}

function truncateSingleLine(textLine, options) {
  var containerWidth = options.containerWidth;
  var font = options.font;
  var contentWidth = options.contentWidth;

  if (!containerWidth) {
    return '';
  }

  var lineWidth = getWidth(textLine, font);

  if (lineWidth <= containerWidth) {
    return textLine;
  }

  for (var j = 0;; j++) {
    if (lineWidth <= contentWidth || j >= options.maxIterations) {
      textLine += options.ellipsis;
      break;
    }

    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
    textLine = textLine.substr(0, subLength);
    lineWidth = getWidth(textLine, font);
  }

  if (textLine === '') {
    textLine = options.placeholder;
  }

  return textLine;
}

function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
  var width = 0;
  var i = 0;

  for (var len = text.length; i < len && width < contentWidth; i++) {
    var charCode = text.charCodeAt(i);
    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
  }

  return i;
}
/**
 * @public
 * @param {string} font
 * @return {number} line height
 */


function getLineHeight(font) {
  // FIXME A rough approach.
  return getWidth('国', font);
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */


function measureText(text, font) {
  return methods.measureText(text, font);
} // Avoid assign to an exported variable, for transforming to cjs.


methods.measureText = function (text, font) {
  var ctx = getContext();
  ctx.font = font || DEFAULT_FONT;
  return ctx.measureText(text);
};
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
 *  Notice: for performance, do not calculate outerWidth util needed.
 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
 *  Thus we can simply comparing the `input` text to determin whether the result changed,
 *  without travel the result `lines`.
 */


function parsePlainText(text, font, padding, textLineHeight, truncate) {
  text != null && (text += '');
  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
  var lines = text ? text.split('\n') : [];
  var height = lines.length * lineHeight;
  var outerHeight = height;
  var canCacheByTextString = true;

  if (padding) {
    outerHeight += padding[0] + padding[2];
  }

  if (text && truncate) {
    canCacheByTextString = false;
    var truncOuterHeight = truncate.outerHeight;
    var truncOuterWidth = truncate.outerWidth;

    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
      text = '';
      lines = [];
    } else if (truncOuterWidth != null) {
      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
        minChar: truncate.minChar,
        placeholder: truncate.placeholder
      }); // FIXME
      // It is not appropriate that every line has '...' when truncate multiple lines.

      for (var i = 0, len = lines.length; i < len; i++) {
        lines[i] = truncateSingleLine(lines[i], options);
      }
    }
  }

  return {
    lines: lines,
    height: height,
    outerHeight: outerHeight,
    lineHeight: lineHeight,
    canCacheByTextString: canCacheByTextString
  };
}
/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */


function parseRichText(text, style) {
  var contentBlock = {
    lines: [],
    width: 0,
    height: 0
  };
  text != null && (text += '');

  if (!text) {
    return contentBlock;
  }

  var lastIndex = STYLE_REG.lastIndex = 0;
  var result;

  while ((result = STYLE_REG.exec(text)) != null) {
    var matchedIndex = result.index;

    if (matchedIndex > lastIndex) {
      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
    }

    pushTokens(contentBlock, result[2], result[1]);
    lastIndex = STYLE_REG.lastIndex;
  }

  if (lastIndex < text.length) {
    pushTokens(contentBlock, text.substring(lastIndex, text.length));
  }

  var lines = contentBlock.lines;
  var contentHeight = 0;
  var contentWidth = 0; // For `textWidth: 100%`

  var pendingList = [];
  var stlPadding = style.textPadding;
  var truncate = style.truncate;
  var truncateWidth = truncate && truncate.outerWidth;
  var truncateHeight = truncate && truncate.outerHeight;

  if (stlPadding) {
    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
  } // Calculate layout info of tokens.


  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var lineHeight = 0;
    var lineWidth = 0;

    for (var j = 0; j < line.tokens.length; j++) {
      var token = line.tokens[j];
      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.

      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.

      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.

      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
      // as box height of the block.
      tokenStyle.textHeight, getLineHeight(font));
      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
      token.height = tokenHeight;
      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';

      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
        return {
          lines: [],
          width: 0,
          height: 0
        };
      }

      token.textWidth = getWidth(token.text, font);
      var tokenWidth = tokenStyle.textWidth;
      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
      // line when box width is needed to be auto.

      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
        token.percentWidth = tokenWidth;
        pendingList.push(token);
        tokenWidth = 0; // Do not truncate in this case, because there is no user case
        // and it is too complicated.
      } else {
        if (tokenWidthNotSpecified) {
          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
          // `getBoundingRect()` will not get correct result.

          var textBackgroundColor = tokenStyle.textBackgroundColor;
          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
          // (1) If image is not loaded, it will be loaded at render phase and call
          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
          // image, and then the right size will be calculated here at the next tick.
          // See `graphic/helper/text.js`.
          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
          // use `imageHelper.findExistImage` to find cached image.
          // `imageHelper.findExistImage` will always be called here before
          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
          // which ensures that image will not be rendered before correct size calcualted.

          if (bgImg) {
            bgImg = imageHelper.findExistImage(bgImg);

            if (imageHelper.isImageReady(bgImg)) {
              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
            }
          }
        }

        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
        tokenWidth += paddingW;
        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;

        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
            token.text = '';
            token.textWidth = tokenWidth = 0;
          } else {
            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
              minChar: truncate.minChar
            });
            token.textWidth = getWidth(token.text, font);
            tokenWidth = token.textWidth + paddingW;
          }
        }
      }

      lineWidth += token.width = tokenWidth;
      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
    }

    line.width = lineWidth;
    line.lineHeight = lineHeight;
    contentHeight += lineHeight;
    contentWidth = Math.max(contentWidth, lineWidth);
  }

  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);

  if (stlPadding) {
    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
  }

  for (var i = 0; i < pendingList.length; i++) {
    var token = pendingList[i];
    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.

    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
  }

  return contentBlock;
}

function pushTokens(block, str, styleName) {
  var isEmptyStr = str === '';
  var strs = str.split('\n');
  var lines = block.lines;

  for (var i = 0; i < strs.length; i++) {
    var text = strs[i];
    var token = {
      styleName: styleName,
      text: text,
      isLineHolder: !text && !isEmptyStr
    }; // The first token should be appended to the last line.

    if (!i) {
      var tokens = (lines[lines.length - 1] || (lines[0] = {
        tokens: []
      })).tokens; // Consider cases:
      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
      // (which is a placeholder) should be replaced by new token.
      // (2) A image backage, where token likes {a|}.
      // (3) A redundant '' will affect textAlign in line.
      // (4) tokens with the same tplName should not be merged, because
      // they should be displayed in different box (with border and padding).

      var tokensLen = tokens.length;
      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
      (text || !tokensLen || isEmptyStr) && tokens.push(token);
    } // Other tokens always start a new line.
    else {
        // If there is '', insert it as a placeholder.
        lines.push({
          tokens: [token]
        });
      }
  }
}

function makeFont(style) {
  // FIXME in node-canvas fontWeight is before fontStyle
  // Use `fontSize` `fontFamily` to check whether font properties are defined.
  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
  style.fontFamily || 'sans-serif'].join(' ');
  return font && trim(font) || style.textFont || style.font;
}

exports.DEFAULT_FONT = DEFAULT_FONT;
exports.$override = $override;
exports.getWidth = getWidth;
exports.getBoundingRect = getBoundingRect;
exports.adjustTextX = adjustTextX;
exports.adjustTextY = adjustTextY;
exports.calculateTextPosition = calculateTextPosition;
exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
exports.truncateText = truncateText;
exports.getLineHeight = getLineHeight;
exports.measureText = measureText;
exports.parsePlainText = parsePlainText;
exports.parseRichText = parseRichText;
exports.makeFont = makeFont;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).f;
var has = __webpack_require__(34);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(46);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(139);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(90);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WebViewHeader=function(_Component){_inherits(WebViewHeader,_Component);function WebViewHeader(props){_classCallCheck(this,WebViewHeader);var _this=_possibleConstructorReturn(this,(WebViewHeader.__proto__||Object.getPrototypeOf(WebViewHeader)).call(this,props));_this.handleClose=function(){__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].closeH5Page({reason:"closeSafe"});};_this.handleBack=function(){window.history.back();};_this.isMobile=__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient;return _this;}_createClass(WebViewHeader,[{key:'render',value:function render(){var _props=this.props,title=_props.title,showBack=_props.showBack,showClose=_props.showClose,background=_props.background;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container title_wrap '+(this.isMobile?'':'pc'),style:{background:background}},showBack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn back',onClick:this.handleBack}),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.title),showClose&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn close',onClick:this.handleClose}));}}]);return WebViewHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WebViewHeader);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Eventful = __webpack_require__(97);

exports.Dispatcher = Eventful;

var env = __webpack_require__(25);

var _dom = __webpack_require__(251);

var isCanvasEl = _dom.isCanvasEl;
var transformCoordWithViewport = _dom.transformCoordWithViewport;

/**
 * Utilities for mouse or touch events.
 */
var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var _calcOut = [];
/**
 * Get the `zrX` and `zrY`, which are relative to the top-left of
 * the input `el`.
 * CSS transform (2D & 3D) is supported.
 *
 * The strategy to fetch the coords:
 * + If `calculate` is not set as `true`, users of this method should
 * ensure that `el` is the same or the same size & location as `e.target`.
 * Otherwise the result coords are probably not expected. Because we
 * firstly try to get coords from e.offsetX/e.offsetY.
 * + If `calculate` is set as `true`, the input `el` can be any element
 * and we force to calculate the coords based on `el`.
 * + The input `el` should be positionable (not position:static).
 *
 * The force `calculate` can be used in case like:
 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} e Mouse event or touch event.
 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 */

function clientToLocal(el, e, out, calculate) {
  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
  // to the padding edge of the target element. The only browser using this convention
  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
  // not support the properties.
  // (see http://www.jacklmoore.com/notes/mouse-position/)
  // In zr painter.dom, padding edge equals to border edge.

  if (calculate || !env.canvasSupported) {
    calculateZrXY(el, e, out);
  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
  // zoom-factor, overflow / opacity layers, transforms ...)
  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
  // <https://bugs.jquery.com/ticket/8523#comment:14>
  // BTW3, In ff, offsetX/offsetY is always 0.
  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
      out.zrX = e.layerX;
      out.zrY = e.layerY;
    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
      } // For some other device, e.g., IOS safari.
      else {
          calculateZrXY(el, e, out);
        }

  return out;
}

function calculateZrXY(el, e, out) {
  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
  if (env.domSupported && el.getBoundingClientRect) {
    var ex = e.clientX;
    var ey = e.clientY;

    if (isCanvasEl(el)) {
      // Original approach, which do not support CSS transform.
      // marker can not be locationed in a canvas container
      // (getBoundingClientRect is always 0). We do not support
      // that input a pre-created canvas to zr while using css
      // transform in iOS.
      var box = el.getBoundingClientRect();
      out.zrX = ex - box.left;
      out.zrY = ey - box.top;
      return;
    } else {
      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
        out.zrX = _calcOut[0];
        out.zrY = _calcOut[1];
        return;
      }
    }
  }

  out.zrX = out.zrY = 0;
}
/**
 * Find native event compat for legency IE.
 * Should be called at the begining of a native event listener.
 *
 * @param {Event} [e] Mouse event or touch event or pointer event.
 *        For lagency IE, we use `window.event` is used.
 * @return {Event} The native event.
 */


function getNativeEvent(e) {
  return e || window.event;
}
/**
 * Normalize the coordinates of the input event.
 *
 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
 * the input `el`.
 * Get `e.zrDelta` if using mouse wheel.
 * Get `e.which`, see the comment inside this function.
 *
 * Do not calculate repeatly if `zrX` and `zrY` already exist.
 *
 * Notice: see comments in `clientToLocal`. check the relationship
 * between the result coords and the parameters `el` and `calculate`.
 *
 * @param {HTMLElement} el DOM element.
 * @param {Event} [e] See `getNativeEvent`.
 * @param {boolean} [calculate=false] Whether to force calculate
 *        the coordinates but not use ones provided by browser.
 * @return {UIEvent} The normalized native UIEvent.
 */


function normalizeEvent(el, e, calculate) {
  e = getNativeEvent(e);

  if (e.zrX != null) {
    return e;
  }

  var eventType = e.type;
  var isTouch = eventType && eventType.indexOf('touch') >= 0;

  if (!isTouch) {
    clientToLocal(el, e, e, calculate);
    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
  } else {
    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
    touch && clientToLocal(el, touch, e, calculate);
  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
  // If e.which has been defined, it may be readonly,
  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which


  var button = e.button;

  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
  } // [Caution]: `e.which` from browser is not always reliable. For example,
  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
  // `mousedown (pointerdown)` is the same as Chrome does.


  return e;
}
/**
 * @param {HTMLElement} el
 * @param {string} name
 * @param {Function} handler
 * @param {Object|boolean} opt If boolean, means `opt.capture`
 * @param {boolean} [opt.capture=false]
 * @param {boolean} [opt.passive=false]
 */


function addEventListener(el, name, handler, opt) {
  if (isDomLevel2) {
    // Reproduct the console warning:
    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
    // Consider marking event handler as 'passive' to make the page more responsive.
    // Just set console log level: verbose in chrome dev tool.
    // then the warning log will be printed when addEventListener called.
    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // We have not yet found a neat way to using passive. Because in zrender the dom event
    // listener delegate all of the upper events of element. Some of those events need
    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
    // Before passive can be adopted, these issues should be considered:
    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
    // passive or not.
    // (2) How to tread that some zrender event listener is passive, and some is not. If
    // we use other way but not preventDefault of mousewheel and touchmove, browser
    // compatibility should be handled.
    // var opts = (env.passiveSupported && name === 'mousewheel')
    //     ? {passive: true}
    //     // By default, the third param of el.addEventListener is `capture: false`.
    //     : void 0;
    // el.addEventListener(name, handler /* , opts */);
    el.addEventListener(name, handler, opt);
  } else {
    // For simplicity, do not implement `setCapture` for IE9-.
    el.attachEvent('on' + name, handler);
  }
}
/**
 * Parameter are the same as `addEventListener`.
 *
 * Notice that if a listener is registered twice, one with capture and one without,
 * remove each one separately. Removal of a capturing listener does not affect a
 * non-capturing version of the same listener, and vice versa.
 */


function removeEventListener(el, name, handler, opt) {
  if (isDomLevel2) {
    el.removeEventListener(name, handler, opt);
  } else {
    el.detachEvent('on' + name, handler);
  }
}
/**
 * preventDefault and stopPropagation.
 * Notice: do not use this method in zrender. It can only be
 * used by upper applications if necessary.
 *
 * @param {Event} e A mouse or touch event.
 */


var stop = isDomLevel2 ? function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.cancelBubble = true;
} : function (e) {
  e.returnValue = false;
  e.cancelBubble = true;
};
/**
 * This method only works for mouseup and mousedown. The functionality is restricted
 * for fault tolerance, See the `e.which` compatibility above.
 *
 * @param {MouseEvent} e
 * @return {boolean}
 */

function isMiddleOrRightButtonOnMouseUpDown(e) {
  return e.which === 2 || e.which === 3;
}
/**
 * To be removed.
 * @deprecated
 */


function notLeftMouse(e) {
  // If e.which is undefined, considered as left mouse event.
  return e.which > 1;
} // For backward compatibility


exports.clientToLocal = clientToLocal;
exports.getNativeEvent = getNativeEvent;
exports.normalizeEvent = normalizeEvent;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.stop = stop;
exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(26);

var v2Create = _vector.create;
var v2DistSquare = _vector.distSquare;

/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */
var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3; // 临时变量

var _v0 = v2Create();

var _v1 = v2Create();

var _v2 = v2Create();

function isAroundZero(val) {
  return val > -EPSILON && val < EPSILON;
}

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicDerivativeAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function cubicRootAt(p0, p1, p2, p3, val, roots) {
  // Evaluate roots of cubic functions
  var a = p3 + 3 * (p1 - p2) - p0;
  var b = 3 * (p2 - p1 * 2 + p0);
  var c = 3 * (p1 - p0);
  var d = p0 - val;
  var A = b * b - 3 * a * c;
  var B = b * c - 9 * a * d;
  var C = c * c - 3 * b * d;
  var n = 0;

  if (isAroundZero(A) && isAroundZero(B)) {
    if (isAroundZero(b)) {
      roots[0] = 0;
    } else {
      var t1 = -c / b; //t1, t2, t3, b is not zero

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = B * B - 4 * A * C;

    if (isAroundZero(disc)) {
      var K = B / A;
      var t1 = -b / a + K; // t1, a is not zero

      var t2 = -K / 2; // t2, t3

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
      var Y2 = A * b + 1.5 * a * (-B - discSqrt);

      if (Y1 < 0) {
        Y1 = -mathPow(-Y1, ONE_THIRD);
      } else {
        Y1 = mathPow(Y1, ONE_THIRD);
      }

      if (Y2 < 0) {
        Y2 = -mathPow(-Y2, ONE_THIRD);
      } else {
        Y2 = mathPow(Y2, ONE_THIRD);
      }

      var t1 = (-b - (Y1 + Y2)) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else {
      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
      var theta = Math.acos(T) / 3;
      var ASqrt = mathSqrt(A);
      var tmp = Math.cos(theta);
      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }

      if (t3 >= 0 && t3 <= 1) {
        roots[n++] = t3;
      }
    }
  }

  return n;
}
/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */


function cubicExtrema(p0, p1, p2, p3, extrema) {
  var b = 6 * p2 - 12 * p1 + 6 * p0;
  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
  var c = 3 * p1 - 3 * p0;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      extrema[0] = -b / (2 * a);
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        extrema[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function cubicSubdivide(p0, p1, p2, p3, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p23 = (p3 - p2) * t + p2;
  var p012 = (p12 - p01) * t + p01;
  var p123 = (p23 - p12) * t + p12;
  var p0123 = (p123 - p012) * t + p012; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012;
  out[3] = p0123; // Seg1

  out[4] = p0123;
  out[5] = p123;
  out[6] = p23;
  out[7] = p3;
}
/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */


function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  var prev;
  var next;
  var d1;
  var d2;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
    d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    prev = t - interval;
    next = t + interval; // t - interval

    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
    d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = cubicAt(x0, x1, x2, x3, next);
      _v2[1] = cubicAt(y0, y1, y2, y3, next);
      d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = cubicAt(x0, x1, x2, x3, t);
    out[1] = cubicAt(y0, y1, y2, y3, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}
/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticAt(p0, p1, p2, t) {
  var onet = 1 - t;
  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticDerivativeAt(p0, p1, p2, t) {
  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function quadraticRootAt(p0, p1, p2, val, roots) {
  var a = p0 - 2 * p1 + p2;
  var b = 2 * (p1 - p0);
  var c = p0 - val;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      var t1 = -b / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */


function quadraticExtremum(p0, p1, p2) {
  var divider = p0 + p2 - 2 * p1;

  if (divider === 0) {
    // p1 is center of p0 and p2
    return 0.5;
  } else {
    return (p0 - p1) / divider;
  }
}
/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function quadraticSubdivide(p0, p1, p2, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p012 = (p12 - p01) * t + p01; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012; // Seg1

  out[3] = p012;
  out[4] = p12;
  out[5] = p2;
}
/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */


function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = quadraticAt(x0, x1, x2, _t);
    _v1[1] = quadraticAt(y0, y1, y2, _t);
    var d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    var prev = t - interval;
    var next = t + interval; // t - interval

    _v1[0] = quadraticAt(x0, x1, x2, prev);
    _v1[1] = quadraticAt(y0, y1, y2, prev);
    var d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = quadraticAt(x0, x1, x2, next);
      _v2[1] = quadraticAt(y0, y1, y2, next);
      var d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = quadraticAt(x0, x1, x2, t);
    out[1] = quadraticAt(y0, y1, y2, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}

exports.cubicAt = cubicAt;
exports.cubicDerivativeAt = cubicDerivativeAt;
exports.cubicRootAt = cubicRootAt;
exports.cubicExtrema = cubicExtrema;
exports.cubicSubdivide = cubicSubdivide;
exports.cubicProjectPoint = cubicProjectPoint;
exports.quadraticAt = quadraticAt;
exports.quadraticDerivativeAt = quadraticDerivativeAt;
exports.quadraticRootAt = quadraticRootAt;
exports.quadraticExtremum = quadraticExtremum;
exports.quadraticSubdivide = quadraticSubdivide;
exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;
var isString = _util.isString;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param {module:echarts/model/Series} seriesModel
 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
 *        The input dimensionInfoList will be modified.
 * @param {Object} [opt]
 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
 * @param {boolean} [opt.byIndex=false]
 * @return {Object} calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */
function enableDataStack(seriesModel, dimensionInfoList, opt) {
  opt = opt || {};
  var byIndex = opt.byIndex;
  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.

  var mayStack = !!(seriesModel && seriesModel.get('stack'));
  var stackedByDimInfo;
  var stackedDimInfo;
  var stackResultDimension;
  var stackedOverDimension;
  each(dimensionInfoList, function (dimensionInfo, index) {
    if (isString(dimensionInfo)) {
      dimensionInfoList[index] = dimensionInfo = {
        name: dimensionInfo
      };
    }

    if (mayStack && !dimensionInfo.isExtraCoord) {
      // Find the first ordinal dimension as the stackedByDimInfo.
      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
        stackedByDimInfo = dimensionInfo;
      } // Find the first stackable dimension as the stackedDimInfo.


      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
        stackedDimInfo = dimensionInfo;
      }
    }
  });

  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
    // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
  // That put stack logic in List is for using conveniently in echarts extensions, but it
  // might not be a good way.


  if (stackedDimInfo) {
    // Use a weird name that not duplicated with other names.
    stackResultDimension = '__\0ecstackresult';
    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.

    if (stackedByDimInfo) {
      stackedByDimInfo.createInvertedIndices = true;
    }

    var stackedDimCoordDim = stackedDimInfo.coordDim;
    var stackedDimType = stackedDimInfo.type;
    var stackedDimCoordIndex = 0;
    each(dimensionInfoList, function (dimensionInfo) {
      if (dimensionInfo.coordDim === stackedDimCoordDim) {
        stackedDimCoordIndex++;
      }
    });
    dimensionInfoList.push({
      name: stackResultDimension,
      coordDim: stackedDimCoordDim,
      coordDimIndex: stackedDimCoordIndex,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true
    });
    stackedDimCoordIndex++;
    dimensionInfoList.push({
      name: stackedOverDimension,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: stackedOverDimension,
      coordDimIndex: stackedDimCoordIndex,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true
    });
  }

  return {
    stackedDimension: stackedDimInfo && stackedDimInfo.name,
    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
    isStackedByIndex: byIndex,
    stackedOverDimension: stackedOverDimension,
    stackResultDimension: stackResultDimension
  };
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} stackedDim
 */


function isDimensionStacked(data, stackedDim
/*, stackedByDim*/
) {
  // Each single series only maps to one pair of axis. So we do not need to
  // check stackByDim, whatever stacked by a dimension or stacked by index.
  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
  //     stackedByDim != null
  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
  //         : data.getCalculationInfo('isStackedByIndex')
  // );
}
/**
 * @param {module:echarts/data/List} data
 * @param {string} targetDim
 * @param {string} [stackedByDim] If not input this parameter, check whether
 *                                stacked by index.
 * @return {string} dimension
 */


function getStackedDimension(data, targetDim) {
  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

exports.enableDataStack = enableDataStack;
exports.isDimensionStacked = isDimensionStacked;
exports.getStackedDimension = getStackedDimension;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(2);

var OrdinalScale = __webpack_require__(855);

var IntervalScale = __webpack_require__(182);

var Scale = __webpack_require__(129);

var numberUtil = __webpack_require__(28);

var _barGrid = __webpack_require__(856);

var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
var makeColumnLayout = _barGrid.makeColumnLayout;
var retrieveColumnLayout = _barGrid.retrieveColumnLayout;

var BoundingRect = __webpack_require__(33);

__webpack_require__(857);

__webpack_require__(858);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */
function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var min = model.getMin();
  var max = model.getMax();
  var fixMin = min != null;
  var fixMax = max != null;
  var originalExtent = scale.getExtent();
  var axisDataLen;
  var boundaryGap;
  var span;

  if (scaleType === 'ordinal') {
    axisDataLen = model.getCategories().length;
  } else {
    boundaryGap = model.get('boundaryGap');

    if (!zrUtil.isArray(boundaryGap)) {
      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
    }

    if (typeof boundaryGap[0] === 'boolean') {
      boundaryGap = [0, 0];
    }

    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
  } // Notice: When min/max is not set (that is, when there are null/undefined,
  // which is the most common case), these cases should be ensured:
  // (1) For 'ordinal', show all axis.data.
  // (2) For others:
  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
  //      disabled).
  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
  //      be the result that originalExtent enlarged by boundaryGap.
  // (3) If no data, it should be ensured that `scale.setBlank` is set.
  // FIXME
  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
  // that the results processed by boundaryGap are positive/negative?


  if (min == null) {
    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
  }

  if (max == null) {
    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
  }

  if (min === 'dataMin') {
    min = originalExtent[0];
  } else if (typeof min === 'function') {
    min = min({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  if (max === 'dataMax') {
    max = originalExtent[1];
  } else if (typeof max === 'function') {
    max = max({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  (min == null || !isFinite(min)) && (min = NaN);
  (max == null || !isFinite(max)) && (max = NaN);
  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero

  if (model.getNeedCrossZero()) {
    // Axis is over zero and min is not set
    if (min > 0 && max > 0 && !fixMin) {
      min = 0;
    } // Axis is under zero and max is not set


    if (min < 0 && max < 0 && !fixMax) {
      max = 0;
    }
  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
  // is base axis
  // FIXME
  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
  //     Should not depend on series type `bar`?
  // (3) Fix that might overlap when using dataZoom.
  // (4) Consider other chart types using `barGrid`?
  // See #6728, #4862, `test/bar-overflow-time-plot.html`


  var ecModel = model.ecModel;

  if (ecModel && scaleType === 'time'
  /*|| scaleType === 'interval' */
  ) {
    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
    var isBaseAxisAndHasBarSeries;
    zrUtil.each(barSeriesModels, function (seriesModel) {
      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
    });

    if (isBaseAxisAndHasBarSeries) {
      // Calculate placement of bars on axis
      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow

      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
      min = adjustedScale.min;
      max = adjustedScale.max;
    }
  }

  return [min, max];
}

function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
  // Get Axis Length
  var axisExtent = model.axis.getExtent();
  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow

  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);

  if (barsOnCurrentAxis === undefined) {
    return {
      min: min,
      max: max
    };
  }

  var minOverflow = Infinity;
  zrUtil.each(barsOnCurrentAxis, function (item) {
    minOverflow = Math.min(item.offset, minOverflow);
  });
  var maxOverflow = -Infinity;
  zrUtil.each(barsOnCurrentAxis, function (item) {
    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
  });
  minOverflow = Math.abs(minOverflow);
  maxOverflow = Math.abs(maxOverflow);
  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow

  var oldRange = max - min;
  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
  max += overflowBuffer * (maxOverflow / totalOverFlow);
  min -= overflowBuffer * (minOverflow / totalOverFlow);
  return {
    min: min,
    max: max
  };
}

function niceScaleExtent(scale, model) {
  var extent = getScaleExtent(scale, model);
  var fixMin = model.getMin() != null;
  var fixMax = model.getMax() != null;
  var splitNumber = model.get('splitNumber');

  if (scale.type === 'log') {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  scale.setExtent(extent[0], extent[1]);
  scale.niceExtent({
    splitNumber: splitNumber,
    fixMin: fixMin,
    fixMax: fixMax,
    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  var interval = model.get('interval');

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */


function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);

      case 'value':
        return new IntervalScale();
      // Extended scale, like time and log

      default:
        return (Scale.getClass(axisType) || IntervalScale).create(model);
    }
  }
}
/**
 * Check if the axis corss 0
 */


function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {Function} Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not requied.
 *         return: {string} label string.
 */


function makeLabelFormatter(axis) {
  var labelFormatter = axis.getLabelModel().get('formatter');
  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;

  if (typeof labelFormatter === 'string') {
    labelFormatter = function (tpl) {
      return function (val) {
        // For category axis, get raw value; for numeric axis,
        // get foramtted label like '1,333,444'.
        val = axis.scale.getLabel(val);
        return tpl.replace('{value}', val != null ? val : '');
      };
    }(labelFormatter); // Consider empty array


    return labelFormatter;
  } else if (typeof labelFormatter === 'function') {
    return function (tickValue, idx) {
      // The original intention of `idx` is "the index of the tick in all ticks".
      // But the previous implementation of category axis do not consider the
      // `axisLabel.interval`, which cause that, for example, the `interval` is
      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
      // the definition here for back compatibility.
      if (categoryTickStart != null) {
        idx = tickValue - categoryTickStart;
      }

      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
    };
  } else {
    return function (tick) {
      return axis.scale.getLabel(tick);
    };
  }
}

function getAxisRawValue(axis, value) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
 */


function estimateLabelUnionRect(axis) {
  var axisModel = axis.model;
  var scale = axis.scale;

  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
    return;
  }

  var isCategory = axis.type === 'category';
  var realNumberScaleTicks;
  var tickCount;
  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.

  if (isCategory) {
    tickCount = scale.count();
  } else {
    realNumberScaleTicks = scale.getTicks();
    tickCount = realNumberScaleTicks.length;
  }

  var axisLabelModel = axis.getLabelModel();
  var labelFormatter = makeLabelFormatter(axis);
  var rect;
  var step = 1; // Simple optimization for large amount of labels

  if (tickCount > 40) {
    step = Math.ceil(tickCount / 40);
  }

  for (var i = 0; i < tickCount; i += step) {
    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
    var label = labelFormatter(tickValue);
    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
    rect ? rect.union(singleRect) : rect = singleRect;
  }

  return rect;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var boundingBox = textRect.plain();
  var beforeWidth = boundingBox.width;
  var beforeHeight = boundingBox.height;
  var afterWidth = beforeWidth * Math.cos(rotateRadians) + beforeHeight * Math.sin(rotateRadians);
  var afterHeight = beforeWidth * Math.sin(rotateRadians) + beforeHeight * Math.cos(rotateRadians);
  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
  return rotatedRect;
}
/**
 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
 * @return {number|String} Can be null|'auto'|number|function
 */


function getOptionCategoryInterval(model) {
  var interval = model.get('interval');
  return interval == null ? 'auto' : interval;
}
/**
 * Set `categoryInterval` as 0 implicitly indicates that
 * show all labels reguardless of overlap.
 * @param {Object} axis axisModel.axis
 * @return {boolean}
 */


function shouldShowAllLabels(axis) {
  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
}

exports.getScaleExtent = getScaleExtent;
exports.niceScaleExtent = niceScaleExtent;
exports.createScaleByModel = createScaleByModel;
exports.ifAxisCrossZero = ifAxisCrossZero;
exports.makeLabelFormatter = makeLabelFormatter;
exports.getAxisRawValue = getAxisRawValue;
exports.estimateLabelUnionRect = estimateLabelUnionRect;
exports.getOptionCategoryInterval = getOptionCategoryInterval;
exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(41);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(41);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(224);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _parser = __webpack_require__(558);

var _parser2 = _interopRequireDefault(_parser);

var _ajax = __webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * [ApngComponent description]
 * @param {string} className canvas' className
 * @param {object} style canvas' style
 * @param {string} src apng's path
 * @param {number} rate apng play rate
 * @param {function} onClick bind animation's click event
 * @param {bool} autoPlay auto play apng
 * @extends React
 */

var ApngComponent = function (_React$Component) {
    _inherits(ApngComponent, _React$Component);

    function ApngComponent(props) {
        _classCallCheck(this, ApngComponent);

        var _this = _possibleConstructorReturn(this, (ApngComponent.__proto__ || Object.getPrototypeOf(ApngComponent)).call(this, props));

        _initialiseProps.call(_this);

        var _props$src = props.src,
            src = _props$src === undefined ? '' : _props$src,
            _props$rate = props.rate,
            rate = _props$rate === undefined ? 1.0 : _props$rate,
            _props$autoPlay = props.autoPlay,
            autoPlay = _props$autoPlay === undefined ? false : _props$autoPlay;

        _this.state = {
            src: src,
            rate: rate,
            autoPlay: autoPlay,
            staticImg: null
        };
        _this.apng = null;
        _this.player = null;
        _this.isOne = false;
        _this.timer = [];
        _this.isPlay = false;
        _this.hasPerformance = typeof performance !== 'undefined';
        _this.speed = 1000 / (rate * 24); //1000/24 每秒24帧
        return _this;
    }

    _createClass(ApngComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getImgData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.src !== nextProps.src) {
                this.reset(nextProps);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.player) {
                this.player.stop();
                this.player._apng = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var staticImg = this.state.staticImg;

            return staticImg ? _react2.default.createElement('img', _extends({ src: staticImg }, this.props, { alt: '\u9759\u6001\u56FE\u7247' })) : _react2.default.createElement('canvas', _extends({ ref: 'canvasBox' }, this.props));
        }
    }]);

    return ApngComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.reset = function (nextProps) {
        var _nextProps$src = nextProps.src,
            src = _nextProps$src === undefined ? '' : _nextProps$src,
            _nextProps$rate = nextProps.rate,
            rate = _nextProps$rate === undefined ? 1.0 : _nextProps$rate,
            _nextProps$autoPlay = nextProps.autoPlay,
            autoPlay = _nextProps$autoPlay === undefined ? false : _nextProps$autoPlay;

        _this2.stop();
        _this2.apng = null;
        _this2.player = null;
        _this2.isOne = false;
        _this2.timer = [];
        _this2.isPlay = false;
        _this2.setState({
            src: src,
            rate: rate,
            autoPlay: autoPlay,
            staticImg: null
        }, function () {
            _this2.getImgData();
        });
    };

    this.play = function () {
        if (!_this2.player) return;
        if (!_this2.player.paused) return;
        _this2.player.play();
        _this2.isPlay = true;
    };

    this.pause = function () {
        if (!_this2.player) return;
        _this2.player.pause();
        _this2.resetPlayState();
        _this2.isPlay = false;
    };

    this.stop = function () {
        if (!_this2.player) return;
        _this2.player.stop();
        _this2.resetPlayState();
        _this2.isPlay = false;
    };

    this.one = function () {
        if (!_this2.player) return;
        _this2.resetPlayState();
        _this2.player.stop();
        var length = _this2.apng.frames.length || 0;
        _this2.isPlay = true;
        var performance = _this2.hasPerformance ? performance || window.performance : Date; // supports ios8 Safari
        var nextRenderTime = performance.now() + _this2.speed;
        var i = 0;
        var tick = function tick(now) {
            var _now = _this2.hasPerformance ? now : Date.now(); // supports ios8 Safari
            if (!_this2.isPlay || i > length - 2) {
                _this2.isPlay = false;
                return;
            }
            if (_now >= nextRenderTime) {
                _this2.player.renderNextFrame();
                i++;
                nextRenderTime = performance.now() + _this2.speed;
            }
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };

    this.resetPlayState = function () {
        if (_this2.timer.length > 0) {
            _this2.timer.forEach(function (item) {
                return clearTimeout(item);
            });
            _this2.timer = [];
        }
    };

    this.getImgData = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var canvas, _state, rate, src, autoPlay, data, p;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        canvas = _this2.refs.canvasBox;
                        _state = _this2.state, rate = _state.rate, src = _state.src, autoPlay = _state.autoPlay;
                        _context.next = 4;
                        return (0, _ajax.getImgBuffer)(src);

                    case 4:
                        data = _context.sent;

                        _this2.apng = (0, _parser2.default)(data);
                        //错误检测

                        if (!(typeof _this2.apng.width === 'number')) {
                            _context.next = 22;
                            break;
                        }

                        if (!(_this2.apng instanceof Error)) {
                            _context.next = 9;
                            break;
                        }

                        return _context.abrupt('return');

                    case 9:
                        _context.next = 11;
                        return _this2.apng.createImages();

                    case 11:
                        canvas.width = _this2.apng.width;
                        canvas.height = _this2.apng.height;
                        //创建canvas播放器
                        _context.next = 15;
                        return _this2.apng.getPlayer(canvas.getContext('2d'));

                    case 15:
                        p = _context.sent;

                        _this2.player = p;
                        _this2.player.playbackRate = rate;
                        if (autoPlay) {
                            _this2.player.play();
                            _this2.isPlay = true;
                        }
                        _this2.player.on('end', function () {
                            _this2.isPlay = false;
                        });
                        _context.next = 23;
                        break;

                    case 22:
                        _this2.setState({
                            staticImg: src
                        });

                    case 23:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));
};

exports.default = ApngComponent;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(566);

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Apng from 'react-apng';
// import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'
// import cloud from '../../static/images/homework-new/cloud.png'
var StepChange=function(_Component){_inherits(StepChange,_Component);function StepChange(props){_classCallCheck(this,StepChange);var _this=_possibleConstructorReturn(this,(StepChange.__proto__||Object.getPrototypeOf(StepChange)).call(this,props));_this.cloudPlay=function(cb){var active=_this.state.active;_this.timeOutArr.push(setTimeout(function(){_this.setState({active:!active});},100));if(cb)cb();};_this.state={active:props.status==='in'};_this.timeOutArr=[];return _this;}_createClass(StepChange,[{key:'componentWillUnmount',// componentDidMount(){
//     this.cloudStatuFun(this.props.status);
// }
value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}// componentWillReceiveProps(nextProps){
//     this.cloudStatuFun(nextProps.status);
// }
},{key:'render',value:function render(){var active=this.state.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new step_change'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cloud '+(active?'active':'')+' cloud1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cloud '+(active?'active':'')+' cloud2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cloud '+(active?'active':'')+' cloud3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cloud '+(active?'active':'')+' cloud4'}));}}]);return StepChange;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StepChange);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(710)();
}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * Event Mixin
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
var arrySlice = Array.prototype.slice;
/**
 * Event dispatcher.
 *
 * @alias module:zrender/mixin/Eventful
 * @constructor
 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
 *        `eventProcessor.xxx` called.
 * @param {Function} [eventProcessor.normalizeQuery]
 *        param: {string|Object} Raw query.
 *        return: {string|Object} Normalized query.
 * @param {Function} [eventProcessor.filter] Event will be dispatched only
 *        if it returns `true`.
 *        param: {string} eventType
 *        param: {string|Object} query
 *        return: {boolean}
 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
 *        param: {string} eventType
 */

var Eventful = function (eventProcessor) {
  this._$handlers = {};
  this._$eventProcessor = eventProcessor;
};

Eventful.prototype = {
  constructor: Eventful,

  /**
   * The handler can only be triggered once, then removed.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} context
   */
  one: function (event, query, handler, context) {
    return on(this, event, query, handler, context, true);
  },

  /**
   * Bind a handler.
   *
   * @param {string} event The event name.
   * @param {string|Object} [query] Condition used on event filter.
   * @param {Function} handler The event handler.
   * @param {Object} [context]
   */
  on: function (event, query, handler, context) {
    return on(this, event, query, handler, context, false);
  },

  /**
   * Whether any handler has bound.
   *
   * @param  {string}  event
   * @return {boolean}
   */
  isSilent: function (event) {
    var _h = this._$handlers;
    return !_h[event] || !_h[event].length;
  },

  /**
   * Unbind a event.
   *
   * @param {string} [event] The event name.
   *        If no `event` input, "off" all listeners.
   * @param {Function} [handler] The event handler.
   *        If no `handler` input, "off" all listeners of the `event`.
   */
  off: function (event, handler) {
    var _h = this._$handlers;

    if (!event) {
      this._$handlers = {};
      return this;
    }

    if (handler) {
      if (_h[event]) {
        var newList = [];

        for (var i = 0, l = _h[event].length; i < l; i++) {
          if (_h[event][i].h !== handler) {
            newList.push(_h[event][i]);
          }
        }

        _h[event] = newList;
      }

      if (_h[event] && _h[event].length === 0) {
        delete _h[event];
      }
    } else {
      delete _h[event];
    }

    return this;
  },

  /**
   * Dispatch a event.
   *
   * @param {string} type The event name.
   */
  trigger: function (type) {
    var _h = this._$handlers[type];
    var eventProcessor = this._$eventProcessor;

    if (_h) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 3) {
        args = arrySlice.call(args, 1);
      }

      var len = _h.length;

      for (var i = 0; i < len;) {
        var hItem = _h[i];

        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
          i++;
          continue;
        } // Optimize advise from backbone


        switch (argLen) {
          case 1:
            hItem.h.call(hItem.ctx);
            break;

          case 2:
            hItem.h.call(hItem.ctx, args[1]);
            break;

          case 3:
            hItem.h.call(hItem.ctx, args[1], args[2]);
            break;

          default:
            // have more than 2 given arguments
            hItem.h.apply(hItem.ctx, args);
            break;
        }

        if (hItem.one) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
    return this;
  },

  /**
   * Dispatch a event with context, which is specified at the last parameter.
   *
   * @param {string} type The event name.
   */
  triggerWithContext: function (type) {
    var _h = this._$handlers[type];
    var eventProcessor = this._$eventProcessor;

    if (_h) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 4) {
        args = arrySlice.call(args, 1, args.length - 1);
      }

      var ctx = args[args.length - 1];
      var len = _h.length;

      for (var i = 0; i < len;) {
        var hItem = _h[i];

        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
          i++;
          continue;
        } // Optimize advise from backbone


        switch (argLen) {
          case 1:
            hItem.h.call(ctx);
            break;

          case 2:
            hItem.h.call(ctx, args[1]);
            break;

          case 3:
            hItem.h.call(ctx, args[1], args[2]);
            break;

          default:
            // have more than 2 given arguments
            hItem.h.apply(ctx, args);
            break;
        }

        if (hItem.one) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
    return this;
  }
};

function normalizeQuery(host, query) {
  var eventProcessor = host._$eventProcessor;

  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
    query = eventProcessor.normalizeQuery(query);
  }

  return query;
}

function on(eventful, event, query, handler, context, isOnce) {
  var _h = eventful._$handlers;

  if (typeof query === 'function') {
    context = handler;
    handler = query;
    query = null;
  }

  if (!handler || !event) {
    return eventful;
  }

  query = normalizeQuery(eventful, query);

  if (!_h[event]) {
    _h[event] = [];
  }

  for (var i = 0; i < _h[event].length; i++) {
    if (_h[event][i].h === handler) {
      return eventful;
    }
  }

  var wrap = {
    h: handler,
    one: isOnce,
    query: query,
    ctx: context || eventful,
    // FIXME
    // Do not publish this feature util it is proved that it makes sense.
    callAtLast: handler.zrEventfulCallAtLast
  };
  var lastIndex = _h[event].length - 1;
  var lastWrap = _h[event][lastIndex];
  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
  return eventful;
} // ----------------------
// The events in zrender
// ----------------------

/**
 * @event module:zrender/mixin/Eventful#onclick
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseout
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousemove
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousewheel
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousedown
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseup
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrag
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragstart
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragend
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragenter
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragleave
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrop
 * @type {Function}
 * @default null
 */


var _default = Eventful;
module.exports = _default;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(2);

var Element = __webpack_require__(252);

var BoundingRect = __webpack_require__(33);

/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 */

/**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */
var Group = function (opts) {
  opts = opts || {};
  Element.call(this, opts);

  for (var key in opts) {
    if (opts.hasOwnProperty(key)) {
      this[key] = opts[key];
    }
  }

  this._children = [];
  this.__storage = null;
  this.__dirty = true;
};

Group.prototype = {
  constructor: Group,
  isGroup: true,

  /**
   * @type {string}
   */
  type: 'group',

  /**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * @return {Array.<module:zrender/Element>}
   */
  children: function () {
    return this._children.slice();
  },

  /**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */
  childAt: function (idx) {
    return this._children[idx];
  },

  /**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */
  childOfName: function (name) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].name === name) {
        return children[i];
      }
    }
  },

  /**
   * @return {number}
   */
  childCount: function () {
    return this._children.length;
  },

  /**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */
  add: function (child) {
    if (child && child !== this && child.parent !== this) {
      this._children.push(child);

      this._doAdd(child);
    }

    return this;
  },

  /**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */
  addBefore: function (child, nextSibling) {
    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
      var children = this._children;
      var idx = children.indexOf(nextSibling);

      if (idx >= 0) {
        children.splice(idx, 0, child);

        this._doAdd(child);
      }
    }

    return this;
  },
  _doAdd: function (child) {
    if (child.parent) {
      child.parent.remove(child);
    }

    child.parent = this;
    var storage = this.__storage;
    var zr = this.__zr;

    if (storage && storage !== child.__storage) {
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }

    zr && zr.refresh();
  },

  /**
   * 移除子节点
   * @param {module:zrender/Element} child
   */
  remove: function (child) {
    var zr = this.__zr;
    var storage = this.__storage;
    var children = this._children;
    var idx = zrUtil.indexOf(children, child);

    if (idx < 0) {
      return this;
    }

    children.splice(idx, 1);
    child.parent = null;

    if (storage) {
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }

    zr && zr.refresh();
    return this;
  },

  /**
   * 移除所有子节点
   */
  removeAll: function () {
    var children = this._children;
    var storage = this.__storage;
    var child;
    var i;

    for (i = 0; i < children.length; i++) {
      child = children[i];

      if (storage) {
        storage.delFromStorage(child);

        if (child instanceof Group) {
          child.delChildrenFromStorage(storage);
        }
      }

      child.parent = null;
    }

    children.length = 0;
    return this;
  },

  /**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */
  eachChild: function (cb, context) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      cb.call(context, child, i);
    }

    return this;
  },

  /**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      cb.call(context, child);

      if (child.type === 'group') {
        child.traverse(cb, context);
      }
    }

    return this;
  },
  addChildrenToStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }
  },
  delChildrenFromStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }
  },
  dirty: function () {
    this.__dirty = true;
    this.__zr && this.__zr.refresh();
    return this;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function (includeChildren) {
    // TODO Caching
    var rect = null;
    var tmpRect = new BoundingRect(0, 0, 0, 0);
    var children = includeChildren || this._children;
    var tmpMat = [];

    for (var i = 0; i < children.length; i++) {
      var child = children[i];

      if (child.ignore || child.invisible) {
        continue;
      }

      var childRect = child.getBoundingRect();
      var transform = child.getLocalTransform(tmpMat); // TODO
      // The boundingRect cacluated by transforming original
      // rect may be bigger than the actual bundingRect when rotation
      // is used. (Consider a circle rotated aginst its center, where
      // the actual boundingRect should be the same as that not be
      // rotated.) But we can not find better approach to calculate
      // actual boundingRect yet, considering performance.

      if (transform) {
        tmpRect.copy(childRect);
        tmpRect.applyTransform(transform);
        rect = rect || tmpRect.clone();
        rect.union(tmpRect);
      } else {
        rect = rect || childRect.clone();
        rect.union(childRect);
      }
    }

    return rect || tmpRect;
  }
};
zrUtil.inherits(Group, Element);
var _default = Group;
module.exports = _default;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(255);

var kCSSColorTable = {
  'transparent': [0, 0, 0, 0],
  'aliceblue': [240, 248, 255, 1],
  'antiquewhite': [250, 235, 215, 1],
  'aqua': [0, 255, 255, 1],
  'aquamarine': [127, 255, 212, 1],
  'azure': [240, 255, 255, 1],
  'beige': [245, 245, 220, 1],
  'bisque': [255, 228, 196, 1],
  'black': [0, 0, 0, 1],
  'blanchedalmond': [255, 235, 205, 1],
  'blue': [0, 0, 255, 1],
  'blueviolet': [138, 43, 226, 1],
  'brown': [165, 42, 42, 1],
  'burlywood': [222, 184, 135, 1],
  'cadetblue': [95, 158, 160, 1],
  'chartreuse': [127, 255, 0, 1],
  'chocolate': [210, 105, 30, 1],
  'coral': [255, 127, 80, 1],
  'cornflowerblue': [100, 149, 237, 1],
  'cornsilk': [255, 248, 220, 1],
  'crimson': [220, 20, 60, 1],
  'cyan': [0, 255, 255, 1],
  'darkblue': [0, 0, 139, 1],
  'darkcyan': [0, 139, 139, 1],
  'darkgoldenrod': [184, 134, 11, 1],
  'darkgray': [169, 169, 169, 1],
  'darkgreen': [0, 100, 0, 1],
  'darkgrey': [169, 169, 169, 1],
  'darkkhaki': [189, 183, 107, 1],
  'darkmagenta': [139, 0, 139, 1],
  'darkolivegreen': [85, 107, 47, 1],
  'darkorange': [255, 140, 0, 1],
  'darkorchid': [153, 50, 204, 1],
  'darkred': [139, 0, 0, 1],
  'darksalmon': [233, 150, 122, 1],
  'darkseagreen': [143, 188, 143, 1],
  'darkslateblue': [72, 61, 139, 1],
  'darkslategray': [47, 79, 79, 1],
  'darkslategrey': [47, 79, 79, 1],
  'darkturquoise': [0, 206, 209, 1],
  'darkviolet': [148, 0, 211, 1],
  'deeppink': [255, 20, 147, 1],
  'deepskyblue': [0, 191, 255, 1],
  'dimgray': [105, 105, 105, 1],
  'dimgrey': [105, 105, 105, 1],
  'dodgerblue': [30, 144, 255, 1],
  'firebrick': [178, 34, 34, 1],
  'floralwhite': [255, 250, 240, 1],
  'forestgreen': [34, 139, 34, 1],
  'fuchsia': [255, 0, 255, 1],
  'gainsboro': [220, 220, 220, 1],
  'ghostwhite': [248, 248, 255, 1],
  'gold': [255, 215, 0, 1],
  'goldenrod': [218, 165, 32, 1],
  'gray': [128, 128, 128, 1],
  'green': [0, 128, 0, 1],
  'greenyellow': [173, 255, 47, 1],
  'grey': [128, 128, 128, 1],
  'honeydew': [240, 255, 240, 1],
  'hotpink': [255, 105, 180, 1],
  'indianred': [205, 92, 92, 1],
  'indigo': [75, 0, 130, 1],
  'ivory': [255, 255, 240, 1],
  'khaki': [240, 230, 140, 1],
  'lavender': [230, 230, 250, 1],
  'lavenderblush': [255, 240, 245, 1],
  'lawngreen': [124, 252, 0, 1],
  'lemonchiffon': [255, 250, 205, 1],
  'lightblue': [173, 216, 230, 1],
  'lightcoral': [240, 128, 128, 1],
  'lightcyan': [224, 255, 255, 1],
  'lightgoldenrodyellow': [250, 250, 210, 1],
  'lightgray': [211, 211, 211, 1],
  'lightgreen': [144, 238, 144, 1],
  'lightgrey': [211, 211, 211, 1],
  'lightpink': [255, 182, 193, 1],
  'lightsalmon': [255, 160, 122, 1],
  'lightseagreen': [32, 178, 170, 1],
  'lightskyblue': [135, 206, 250, 1],
  'lightslategray': [119, 136, 153, 1],
  'lightslategrey': [119, 136, 153, 1],
  'lightsteelblue': [176, 196, 222, 1],
  'lightyellow': [255, 255, 224, 1],
  'lime': [0, 255, 0, 1],
  'limegreen': [50, 205, 50, 1],
  'linen': [250, 240, 230, 1],
  'magenta': [255, 0, 255, 1],
  'maroon': [128, 0, 0, 1],
  'mediumaquamarine': [102, 205, 170, 1],
  'mediumblue': [0, 0, 205, 1],
  'mediumorchid': [186, 85, 211, 1],
  'mediumpurple': [147, 112, 219, 1],
  'mediumseagreen': [60, 179, 113, 1],
  'mediumslateblue': [123, 104, 238, 1],
  'mediumspringgreen': [0, 250, 154, 1],
  'mediumturquoise': [72, 209, 204, 1],
  'mediumvioletred': [199, 21, 133, 1],
  'midnightblue': [25, 25, 112, 1],
  'mintcream': [245, 255, 250, 1],
  'mistyrose': [255, 228, 225, 1],
  'moccasin': [255, 228, 181, 1],
  'navajowhite': [255, 222, 173, 1],
  'navy': [0, 0, 128, 1],
  'oldlace': [253, 245, 230, 1],
  'olive': [128, 128, 0, 1],
  'olivedrab': [107, 142, 35, 1],
  'orange': [255, 165, 0, 1],
  'orangered': [255, 69, 0, 1],
  'orchid': [218, 112, 214, 1],
  'palegoldenrod': [238, 232, 170, 1],
  'palegreen': [152, 251, 152, 1],
  'paleturquoise': [175, 238, 238, 1],
  'palevioletred': [219, 112, 147, 1],
  'papayawhip': [255, 239, 213, 1],
  'peachpuff': [255, 218, 185, 1],
  'peru': [205, 133, 63, 1],
  'pink': [255, 192, 203, 1],
  'plum': [221, 160, 221, 1],
  'powderblue': [176, 224, 230, 1],
  'purple': [128, 0, 128, 1],
  'red': [255, 0, 0, 1],
  'rosybrown': [188, 143, 143, 1],
  'royalblue': [65, 105, 225, 1],
  'saddlebrown': [139, 69, 19, 1],
  'salmon': [250, 128, 114, 1],
  'sandybrown': [244, 164, 96, 1],
  'seagreen': [46, 139, 87, 1],
  'seashell': [255, 245, 238, 1],
  'sienna': [160, 82, 45, 1],
  'silver': [192, 192, 192, 1],
  'skyblue': [135, 206, 235, 1],
  'slateblue': [106, 90, 205, 1],
  'slategray': [112, 128, 144, 1],
  'slategrey': [112, 128, 144, 1],
  'snow': [255, 250, 250, 1],
  'springgreen': [0, 255, 127, 1],
  'steelblue': [70, 130, 180, 1],
  'tan': [210, 180, 140, 1],
  'teal': [0, 128, 128, 1],
  'thistle': [216, 191, 216, 1],
  'tomato': [255, 99, 71, 1],
  'turquoise': [64, 224, 208, 1],
  'violet': [238, 130, 238, 1],
  'wheat': [245, 222, 179, 1],
  'white': [255, 255, 255, 1],
  'whitesmoke': [245, 245, 245, 1],
  'yellow': [255, 255, 0, 1],
  'yellowgreen': [154, 205, 50, 1]
};

function clampCssByte(i) {
  // Clamp to integer 0 .. 255.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 255 ? 255 : i;
}

function clampCssAngle(i) {
  // Clamp to integer 0 .. 360.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 360 ? 360 : i;
}

function clampCssFloat(f) {
  // Clamp to float 0.0 .. 1.0.
  return f < 0 ? 0 : f > 1 ? 1 : f;
}

function parseCssInt(str) {
  // int or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssByte(parseFloat(str) / 100 * 255);
  }

  return clampCssByte(parseInt(str, 10));
}

function parseCssFloat(str) {
  // float or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssFloat(parseFloat(str) / 100);
  }

  return clampCssFloat(parseFloat(str));
}

function cssHueToRgb(m1, m2, h) {
  if (h < 0) {
    h += 1;
  } else if (h > 1) {
    h -= 1;
  }

  if (h * 6 < 1) {
    return m1 + (m2 - m1) * h * 6;
  }

  if (h * 2 < 1) {
    return m2;
  }

  if (h * 3 < 2) {
    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
  }

  return m1;
}

function lerpNumber(a, b, p) {
  return a + (b - a) * p;
}

function setRgba(out, r, g, b, a) {
  out[0] = r;
  out[1] = g;
  out[2] = b;
  out[3] = a;
  return out;
}

function copyRgba(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

var colorCache = new LRU(20);
var lastRemovedArr = null;

function putToCache(colorStr, rgbaArr) {
  // Reuse removed array
  if (lastRemovedArr) {
    copyRgba(lastRemovedArr, rgbaArr);
  }

  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
}
/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */


function parse(colorStr, rgbaArr) {
  if (!colorStr) {
    return;
  }

  rgbaArr = rgbaArr || [];
  var cached = colorCache.get(colorStr);

  if (cached) {
    return copyRgba(rgbaArr, cached);
  } // colorStr may be not string


  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.

  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.

  if (str in kCSSColorTable) {
    copyRgba(rgbaArr, kCSSColorTable[str]);
    putToCache(colorStr, rgbaArr);
    return rgbaArr;
  } // #abc and #abc123 syntax.


  if (str.charAt(0) === '#') {
    if (str.length === 4) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xfff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    } else if (str.length === 7) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xffffff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    }

    return;
  }

  var op = str.indexOf('(');
  var ep = str.indexOf(')');

  if (op !== -1 && ep + 1 === str.length) {
    var fname = str.substr(0, op);
    var params = str.substr(op + 1, ep - (op + 1)).split(',');
    var alpha = 1; // To allow case fallthrough.

    switch (fname) {
      case 'rgba':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        alpha = parseCssFloat(params.pop());
      // jshint ignore:line
      // Fall through.

      case 'rgb':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsla':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        params[3] = parseCssFloat(params[3]);
        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsl':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      default:
        return;
    }
  }

  setRgba(rgbaArr, 0, 0, 0, 1);
  return;
}
/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */


function hsla2rgba(hsla, rgba) {
  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
  // NOTE(deanm): According to the CSS spec s/l should only be
  // percentages, but we don't bother and let float or percentage.

  var s = parseCssFloat(hsla[1]);
  var l = parseCssFloat(hsla[2]);
  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
  var m1 = l * 2 - m2;
  rgba = rgba || [];
  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);

  if (hsla.length === 4) {
    rgba[3] = hsla[3];
  }

  return rgba;
}
/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */


function rgba2hsla(rgba) {
  if (!rgba) {
    return;
  } // RGB from 0 to 255


  var R = rgba[0] / 255;
  var G = rgba[1] / 255;
  var B = rgba[2] / 255;
  var vMin = Math.min(R, G, B); // Min. value of RGB

  var vMax = Math.max(R, G, B); // Max. value of RGB

  var delta = vMax - vMin; // Delta RGB value

  var L = (vMax + vMin) / 2;
  var H;
  var S; // HSL results from 0 to 1

  if (delta === 0) {
    H = 0;
    S = 0;
  } else {
    if (L < 0.5) {
      S = delta / (vMax + vMin);
    } else {
      S = delta / (2 - vMax - vMin);
    }

    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;

    if (R === vMax) {
      H = deltaB - deltaG;
    } else if (G === vMax) {
      H = 1 / 3 + deltaR - deltaB;
    } else if (B === vMax) {
      H = 2 / 3 + deltaG - deltaR;
    }

    if (H < 0) {
      H += 1;
    }

    if (H > 1) {
      H -= 1;
    }
  }

  var hsla = [H * 360, S, L];

  if (rgba[3] != null) {
    hsla.push(rgba[3]);
  }

  return hsla;
}
/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function lift(color, level) {
  var colorArr = parse(color);

  if (colorArr) {
    for (var i = 0; i < 3; i++) {
      if (level < 0) {
        colorArr[i] = colorArr[i] * (1 - level) | 0;
      } else {
        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
      }

      if (colorArr[i] > 255) {
        colorArr[i] = 255;
      } else if (color[i] < 0) {
        colorArr[i] = 0;
      }
    }

    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
  }
}
/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function toHex(color) {
  var colorArr = parse(color);

  if (colorArr) {
    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
  }
}
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */


function fastLerp(normalizedValue, colors, out) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  out = out || [];
  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = colors[leftIndex];
  var rightColor = colors[rightIndex];
  var dv = value - leftIndex;
  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
  return out;
}
/**
 * @deprecated
 */


var fastMapToColor = fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */

function lerp(normalizedValue, colors, fullOutput) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = parse(colors[leftIndex]);
  var rightColor = parse(colors[rightIndex]);
  var dv = value - leftIndex;
  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
  return fullOutput ? {
    color: color,
    leftIndex: leftIndex,
    rightIndex: rightIndex,
    value: value
  } : color;
}
/**
 * @deprecated
 */


var mapToColor = lerp;
/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */

function modifyHSL(color, h, s, l) {
  color = parse(color);

  if (color) {
    color = rgba2hsla(color);
    h != null && (color[0] = clampCssAngle(h));
    s != null && (color[1] = parseCssFloat(s));
    l != null && (color[2] = parseCssFloat(l));
    return stringify(hsla2rgba(color), 'rgba');
  }
}
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */


function modifyAlpha(color, alpha) {
  color = parse(color);

  if (color && alpha != null) {
    color[3] = clampCssFloat(alpha);
    return stringify(color, 'rgba');
  }
}
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */


function stringify(arrColor, type) {
  if (!arrColor || !arrColor.length) {
    return;
  }

  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];

  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
    colorStr += ',' + arrColor[3];
  }

  return type + '(' + colorStr + ')';
}

exports.parse = parse;
exports.lift = lift;
exports.toHex = toHex;
exports.fastLerp = fastLerp;
exports.fastMapToColor = fastMapToColor;
exports.lerp = lerp;
exports.mapToColor = mapToColor;
exports.modifyHSL = modifyHSL;
exports.modifyAlpha = modifyAlpha;
exports.stringify = stringify;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;
var getDataItemValue = _model.getDataItemValue;

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var each = _util.each;
var map = _util.map;
var isArray = _util.isArray;
var isString = _util.isString;
var isObject = _util.isObject;
var isTypedArray = _util.isTypedArray;
var isArrayLike = _util.isArrayLike;
var extend = _util.extend;
var assert = _util.assert;

var Source = __webpack_require__(101);

var _sourceType = __webpack_require__(102);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// The result of `guessOrdinal`.
var BE_ORDINAL = {
  Must: 1,
  // Encounter string but not '-' and not number-like.
  Might: 2,
  // Encounter string but number-like.
  Not: 3 // Other cases

};
var inner = makeInner();
/**
 * @see {module:echarts/data/Source}
 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
 * @return {string} sourceFormat
 */

function detectSourceFormat(datasetModel) {
  var data = datasetModel.option.source;
  var sourceFormat = SOURCE_FORMAT_UNKNOWN;

  if (isTypedArray(data)) {
    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
  } else if (isArray(data)) {
    // FIXME Whether tolerate null in top level array?
    if (data.length === 0) {
      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
    }

    for (var i = 0, len = data.length; i < len; i++) {
      var item = data[i];

      if (item == null) {
        continue;
      } else if (isArray(item)) {
        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
        break;
      } else if (isObject(item)) {
        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
        break;
      }
    }
  } else if (isObject(data)) {
    for (var key in data) {
      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
        break;
      }
    }
  } else if (data != null) {
    throw new Error('Invalid data');
  }

  inner(datasetModel).sourceFormat = sourceFormat;
}
/**
 * [Scenarios]:
 * (1) Provide source data directly:
 *     series: {
 *         encode: {...},
 *         dimensions: [...]
 *         seriesLayoutBy: 'row',
 *         data: [[...]]
 *     }
 * (2) Refer to datasetModel.
 *     series: [{
 *         encode: {...}
 *         // Ignore datasetIndex means `datasetIndex: 0`
 *         // and the dimensions defination in dataset is used
 *     }, {
 *         encode: {...},
 *         seriesLayoutBy: 'column',
 *         datasetIndex: 1
 *     }]
 *
 * Get data from series itself or datset.
 * @return {module:echarts/data/Source} source
 */


function getSource(seriesModel) {
  return inner(seriesModel).source;
}
/**
 * MUST be called before mergeOption of all series.
 * @param {module:echarts/model/Global} ecModel
 */


function resetSourceDefaulter(ecModel) {
  // `datasetMap` is used to make default encode.
  inner(ecModel).datasetMap = createHashMap();
}
/**
 * [Caution]:
 * MUST be called after series option merged and
 * before "series.getInitailData()" called.
 *
 * [The rule of making default encode]:
 * Category axis (if exists) alway map to the first dimension.
 * Each other axis occupies a subsequent dimension.
 *
 * [Why make default encode]:
 * Simplify the typing of encode in option, avoiding the case like that:
 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
 * where the "y" have to be manually typed as "1, 2, 3, ...".
 *
 * @param {module:echarts/model/Series} seriesModel
 */


function prepareSource(seriesModel) {
  var seriesOption = seriesModel.option;
  var data = seriesOption.data;
  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
  var fromDataset = false;
  var seriesLayoutBy = seriesOption.seriesLayoutBy;
  var sourceHeader = seriesOption.sourceHeader;
  var dimensionsDefine = seriesOption.dimensions;
  var datasetModel = getDatasetModel(seriesModel);

  if (datasetModel) {
    var datasetOption = datasetModel.option;
    data = datasetOption.source;
    sourceFormat = inner(datasetModel).sourceFormat;
    fromDataset = true; // These settings from series has higher priority.

    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
  }

  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
  inner(seriesModel).source = new Source({
    data: data,
    fromDataset: fromDataset,
    seriesLayoutBy: seriesLayoutBy,
    sourceFormat: sourceFormat,
    dimensionsDefine: completeResult.dimensionsDefine,
    startIndex: completeResult.startIndex,
    dimensionsDetectCount: completeResult.dimensionsDetectCount,
    // Note: dataset option does not have `encode`.
    encodeDefine: seriesOption.encode
  });
} // return {startIndex, dimensionsDefine, dimensionsCount}


function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
  if (!data) {
    return {
      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
    };
  }

  var dimensionsDetectCount;
  var startIndex;

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    // Rule: Most of the first line are string: it is header.
    // Caution: consider a line with 5 string and 1 number,
    // it still can not be sure it is a head, because the
    // 5 string may be 5 values of category columns.
    if (sourceHeader === 'auto' || sourceHeader == null) {
      arrayRowsTravelFirst(function (val) {
        // '-' is regarded as null/undefined.
        if (val != null && val !== '-') {
          if (isString(val)) {
            startIndex == null && (startIndex = 1);
          } else {
            startIndex = 0;
          }
        } // 10 is an experience number, avoid long loop.

      }, seriesLayoutBy, data, 10);
    } else {
      startIndex = sourceHeader ? 1 : 0;
    }

    if (!dimensionsDefine && startIndex === 1) {
      dimensionsDefine = [];
      arrayRowsTravelFirst(function (val, index) {
        dimensionsDefine[index] = val != null ? val : '';
      }, seriesLayoutBy, data);
    }

    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    if (!dimensionsDefine) {
      dimensionsDefine = objectRowsCollectDimensions(data);
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    if (!dimensionsDefine) {
      dimensionsDefine = [];
      each(data, function (colArr, key) {
        dimensionsDefine.push(key);
      });
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var value0 = getDataItemValue(data[0]);
    dimensionsDetectCount = isArray(value0) && value0.length || 1;
  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}

  return {
    startIndex: startIndex,
    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
    dimensionsDetectCount: dimensionsDetectCount
  };
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.


function normalizeDimensionsDefine(dimensionsDefine) {
  if (!dimensionsDefine) {
    // The meaning of null/undefined is different from empty array.
    return;
  }

  var nameMap = createHashMap();
  return map(dimensionsDefine, function (item, index) {
    item = extend({}, isObject(item) ? item : {
      name: item
    }); // User can set null in dimensions.
    // We dont auto specify name, othewise a given name may
    // cause it be refered unexpectedly.

    if (item.name == null) {
      return item;
    } // Also consider number form like 2012.


    item.name += ''; // User may also specify displayName.
    // displayName will always exists except user not
    // specified or dim name is not specified or detected.
    // (A auto generated dim name will not be used as
    // displayName).

    if (item.displayName == null) {
      item.displayName = item.name;
    }

    var exist = nameMap.get(item.name);

    if (!exist) {
      nameMap.set(item.name, {
        count: 1
      });
    } else {
      item.name += '-' + exist.count++;
    }

    return item;
  });
}

function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
  maxLoop == null && (maxLoop = Infinity);

  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      cb(data[i] ? data[i][0] : null, i);
    }
  } else {
    var value0 = data[0] || [];

    for (var i = 0; i < value0.length && i < maxLoop; i++) {
      cb(value0[i], i);
    }
  }
}

function objectRowsCollectDimensions(data) {
  var firstIndex = 0;
  var obj;

  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line


  if (obj) {
    var dimensions = [];
    each(obj, function (value, key) {
      dimensions.push(key);
    });
    return dimensions;
  }
}
/**
 * [The strategy of the arrengment of data dimensions for dataset]:
 * "value way": all axes are non-category axes. So series one by one take
 *     several (the number is coordSysDims.length) dimensions from dataset.
 *     The result of data arrengment of data dimensions like:
 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
 * "category way": at least one axis is category axis. So the the first data
 *     dimension is always mapped to the first category axis and shared by
 *     all of the series. The other data dimensions are taken by series like
 *     "value way" does.
 *     The result of data arrengment of data dimensions like:
 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
 *
 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */


function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
  var encode = {};
  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel || !coordDimensions) {
    return encode;
  }

  var encodeItemName = [];
  var encodeSeriesName = [];
  var ecModel = seriesModel.ecModel;
  var datasetMap = inner(ecModel).datasetMap;
  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
  var baseCategoryDimIndex;
  var categoryWayValueDimStart;
  coordDimensions = coordDimensions.slice();
  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
      name: coordDimInfo
    });

    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
      baseCategoryDimIndex = coordDimIdx;
      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
    }

    encode[coordDimInfo.name] = [];
  });
  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
    categoryWayDim: categoryWayValueDimStart,
    valueWayDim: 0
  }); // TODO
  // Auto detect first time axis and do arrangement.

  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
    var coordDimName = coordDimInfo.name;
    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.

    if (baseCategoryDimIndex == null) {
      var start = datasetRecord.valueWayDim;
      pushDim(encode[coordDimName], start, count);
      pushDim(encodeSeriesName, start, count);
      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
      // especially when encode x y specified.
      // consider: when mutiple series share one dimension
      // category axis, series name should better use
      // the other dimsion name. On the other hand, use
      // both dimensions name.
    } // In category way, the first category axis.
    else if (baseCategoryDimIndex === coordDimIdx) {
        pushDim(encode[coordDimName], 0, count);
        pushDim(encodeItemName, 0, count);
      } // In category way, the other axis.
      else {
          var start = datasetRecord.categoryWayDim;
          pushDim(encode[coordDimName], start, count);
          pushDim(encodeSeriesName, start, count);
          datasetRecord.categoryWayDim += count;
        }
  });

  function pushDim(dimIdxArr, idxFrom, idxCount) {
    for (var i = 0; i < idxCount; i++) {
      dimIdxArr.push(idxFrom + i);
    }
  }

  function getDataDimCountOnCoordDim(coordDimInfo) {
    var dimsDef = coordDimInfo.dimsDef;
    return dimsDef ? dimsDef.length : 1;
  }

  encodeItemName.length && (encode.itemName = encodeItemName);
  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
  return encode;
}
/**
 * Work for data like [{name: ..., value: ...}, ...].
 *
 * @param {module:model/Series} seriesModel
 * @param {module:data/Source} source
 * @return {Object} encode Never be `null/undefined`.
 */


function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
  var encode = {};
  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel) {
    return encode;
  }

  var sourceFormat = source.sourceFormat;
  var dimensionsDefine = source.dimensionsDefine;
  var potentialNameDimIndex;

  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    each(dimensionsDefine, function (dim, idx) {
      if ((isObject(dim) ? dim.name : dim) === 'name') {
        potentialNameDimIndex = idx;
      }
    });
  } // idxResult: {v, n}.


  var idxResult = function () {
    var idxRes0 = {};
    var idxRes1 = {};
    var guessRecords = []; // 5 is an experience value.

    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
      guessRecords.push(guessResult);
      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
      // and then find a name dim with the priority:
      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".

      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
        idxRes0.v = i;
      }

      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
        idxRes0.n = i;
      }

      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
        return idxRes0;
      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
      // find the first BE_ORDINAL.Might as the value dim,
      // and then find a name dim with the priority:
      // "other dim" > "the value dim itself".
      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
      // treated as number.


      if (!isPureNumber) {
        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
          idxRes1.v = i;
        }

        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
          idxRes1.n = i;
        }
      }
    }

    function fulfilled(idxResult) {
      return idxResult.v != null && idxResult.n != null;
    }

    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
  }();

  if (idxResult) {
    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.

    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
    // So we dont set encodeLabel here.

    encode.itemName = [nameDimIndex];
    encode.seriesName = [nameDimIndex];
  }

  return encode;
}
/**
 * If return null/undefined, indicate that should not use datasetModel.
 */


function getDatasetModel(seriesModel) {
  var option = seriesModel.option; // Caution: consider the scenario:
  // A dataset is declared and a series is not expected to use the dataset,
  // and at the beginning `setOption({series: { noData })` (just prepare other
  // option but no data), then `setOption({series: {data: [...]}); In this case,
  // the user should set an empty array to avoid that dataset is used by default.

  var thisData = option.data;

  if (!thisData) {
    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
  }
}
/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 *
 * @param {module:echars/data/Source} source
 * @param {number} dimIndex
 * @return {BE_ORDINAL} guess result.
 */


function guessOrdinal(source, dimIndex) {
  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}


function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
  var result; // Experience value.

  var maxLoop = 5;

  if (isTypedArray(data)) {
    return BE_ORDINAL.Not;
  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
  // always exists in source.


  var dimName;
  var dimType;

  if (dimensionsDefine) {
    var dimDefItem = dimensionsDefine[dimIndex];

    if (isObject(dimDefItem)) {
      dimName = dimDefItem.name;
      dimType = dimDefItem.type;
    } else if (isString(dimDefItem)) {
      dimName = dimDefItem;
    }
  }

  if (dimType != null) {
    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
  }

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
      var sample = data[dimIndex];

      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
        if ((result = detectValue(sample[startIndex + i])) != null) {
          return result;
        }
      }
    } else {
      for (var i = 0; i < data.length && i < maxLoop; i++) {
        var row = data[startIndex + i];

        if (row && (result = detectValue(row[dimIndex])) != null) {
          return result;
        }
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < data.length && i < maxLoop; i++) {
      var item = data[i];

      if (item && (result = detectValue(item[dimName])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    var sample = data[dimName];

    if (!sample || isTypedArray(sample)) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < sample.length && i < maxLoop; i++) {
      if ((result = detectValue(sample[i])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      var item = data[i];
      var val = getDataItemValue(item);

      if (!isArray(val)) {
        return BE_ORDINAL.Not;
      }

      if ((result = detectValue(val[dimIndex])) != null) {
        return result;
      }
    }
  }

  function detectValue(val) {
    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (val != null && isFinite(val) && val !== '') {
      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
    } else if (beStr && val !== '-') {
      return BE_ORDINAL.Must;
    }
  }

  return BE_ORDINAL.Not;
}

exports.BE_ORDINAL = BE_ORDINAL;
exports.detectSourceFormat = detectSourceFormat;
exports.getSource = getSource;
exports.resetSourceDefaulter = resetSourceDefaulter;
exports.prepareSource = prepareSource;
exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
exports.guessOrdinal = guessOrdinal;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var isTypedArray = _util.isTypedArray;

var _clazz = __webpack_require__(62);

var enableClassCheck = _clazz.enableClassCheck;

var _sourceType = __webpack_require__(102);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * [sourceFormat]
 *
 * + "original":
 * This format is only used in series.data, where
 * itemStyle can be specified in data item.
 *
 * + "arrayRows":
 * [
 *     ['product', 'score', 'amount'],
 *     ['Matcha Latte', 89.3, 95.8],
 *     ['Milk Tea', 92.1, 89.4],
 *     ['Cheese Cocoa', 94.4, 91.2],
 *     ['Walnut Brownie', 85.4, 76.9]
 * ]
 *
 * + "objectRows":
 * [
 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
 * ]
 *
 * + "keyedColumns":
 * {
 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
 *     'count': [823, 235, 1042, 988],
 *     'score': [95.8, 81.4, 91.2, 76.9]
 * }
 *
 * + "typedArray"
 *
 * + "unknown"
 */

/**
 * @constructor
 * @param {Object} fields
 * @param {string} fields.sourceFormat
 * @param {Array|Object} fields.fromDataset
 * @param {Array|Object} [fields.data]
 * @param {string} [seriesLayoutBy='column']
 * @param {Array.<Object|string>} [dimensionsDefine]
 * @param {Objet|HashMap} [encodeDefine]
 * @param {number} [startIndex=0]
 * @param {number} [dimensionsDetectCount]
 */
function Source(fields) {
  /**
   * @type {boolean}
   */
  this.fromDataset = fields.fromDataset;
  /**
   * Not null/undefined.
   * @type {Array|Object}
   */

  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
  /**
   * See also "detectSourceFormat".
   * Not null/undefined.
   * @type {string}
   */

  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
  /**
   * 'row' or 'column'
   * Not null/undefined.
   * @type {string} seriesLayoutBy
   */

  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
  /**
   * dimensions definition in option.
   * can be null/undefined.
   * @type {Array.<Object|string>}
   */

  this.dimensionsDefine = fields.dimensionsDefine;
  /**
   * encode definition in option.
   * can be null/undefined.
   * @type {Objet|HashMap}
   */

  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
  /**
   * Not null/undefined, uint.
   * @type {number}
   */

  this.startIndex = fields.startIndex || 0;
  /**
   * Can be null/undefined (when unknown), uint.
   * @type {number}
   */

  this.dimensionsDetectCount = fields.dimensionsDetectCount;
}
/**
 * Wrap original series data for some compatibility cases.
 */


Source.seriesDataToSource = function (data) {
  return new Source({
    data: data,
    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
    fromDataset: false
  });
};

enableClassCheck(Source);
var _default = Source;
module.exports = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Avoid typo.
var SOURCE_FORMAT_ORIGINAL = 'original';
var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME

var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
var SERIES_LAYOUT_BY_COLUMN = 'column';
var SERIES_LAYOUT_BY_ROW = 'row';
exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(2);

var isTypedArray = _util.isTypedArray;
var extend = _util.extend;
var assert = _util.assert;
var each = _util.each;
var isObject = _util.isObject;

var _model = __webpack_require__(13);

var getDataItemValue = _model.getDataItemValue;
var isDataItemOption = _model.isDataItemOption;

var _number = __webpack_require__(28);

var parseDate = _number.parseDate;

var Source = __webpack_require__(101);

var _sourceType = __webpack_require__(102);

var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO
// ??? refactor? check the outer usage of data provider.
// merge with defaultDimValueGetter?

/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */
function DefaultDataProvider(source, dimSize) {
  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  this._source = source;
  var data = this._data = source.data;
  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?

  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
    this._offset = 0;
    this._dimSize = dimSize;
    this._data = data;
  }

  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
  extend(this, methods);
}

var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration

providerProto.pure = false; // If data is persistent and will not be released after use.

providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource

providerProto.getSource = function () {
  return this._source;
};

var providerMethods = {
  'arrayRows_column': {
    pure: true,
    count: function () {
      return Math.max(0, this._data.length - this._source.startIndex);
    },
    getItem: function (idx) {
      return this._data[idx + this._source.startIndex];
    },
    appendData: appendDataSimply
  },
  'arrayRows_row': {
    pure: true,
    count: function () {
      var row = this._data[0];
      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
    },
    getItem: function (idx) {
      idx += this._source.startIndex;
      var item = [];
      var data = this._data;

      for (var i = 0; i < data.length; i++) {
        var row = data[i];
        item.push(row ? row[idx] : null);
      }

      return item;
    },
    appendData: function () {
      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
    }
  },
  'objectRows': {
    pure: true,
    count: countSimply,
    getItem: getItemSimply,
    appendData: appendDataSimply
  },
  'keyedColumns': {
    pure: true,
    count: function () {
      var dimName = this._source.dimensionsDefine[0].name;
      var col = this._data[dimName];
      return col ? col.length : 0;
    },
    getItem: function (idx) {
      var item = [];
      var dims = this._source.dimensionsDefine;

      for (var i = 0; i < dims.length; i++) {
        var col = this._data[dims[i].name];
        item.push(col ? col[idx] : null);
      }

      return item;
    },
    appendData: function (newData) {
      var data = this._data;
      each(newData, function (newCol, key) {
        var oldCol = data[key] || (data[key] = []);

        for (var i = 0; i < (newCol || []).length; i++) {
          oldCol.push(newCol[i]);
        }
      });
    }
  },
  'original': {
    count: countSimply,
    getItem: getItemSimply,
    appendData: appendDataSimply
  },
  'typedArray': {
    persistent: false,
    pure: true,
    count: function () {
      return this._data ? this._data.length / this._dimSize : 0;
    },
    getItem: function (idx, out) {
      idx = idx - this._offset;
      out = out || [];
      var offset = this._dimSize * idx;

      for (var i = 0; i < this._dimSize; i++) {
        out[i] = this._data[offset + i];
      }

      return out;
    },
    appendData: function (newData) {
      this._data = newData;
    },
    // Clean self if data is already used.
    clean: function () {
      // PENDING
      this._offset += this.count();
      this._data = null;
    }
  }
};

function countSimply() {
  return this._data.length;
}

function getItemSimply(idx) {
  return this._data[idx];
}

function appendDataSimply(newData) {
  for (var i = 0; i < newData.length; i++) {
    this._data.push(newData[i]);
  }
}

var rawValueGetters = {
  arrayRows: getRawValueSimply,
  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
    return dimIndex != null ? dataItem[dimName] : dataItem;
  },
  keyedColumns: getRawValueSimply,
  original: function (dataItem, dataIndex, dimIndex, dimName) {
    // FIXME
    // In some case (markpoint in geo (geo-map.html)), dataItem
    // is {coord: [...]}
    var value = getDataItemValue(dataItem);
    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
  },
  typedArray: getRawValueSimply
};

function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
  return dimIndex != null ? dataItem[dimIndex] : dataItem;
}

var defaultDimValueGetters = {
  arrayRows: getDimValueSimply,
  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
  },
  keyedColumns: getDimValueSimply,
  original: function (dataItem, dimName, dataIndex, dimIndex) {
    // Performance sensitive, do not use modelUtil.getDataItemValue.
    // If dataItem is an plain object with no value field, the var `value`
    // will be assigned with the object, but it will be tread correctly
    // in the `convertDataValue`.
    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }

    if (!this._rawData.pure && isDataItemOption(dataItem)) {
      this.hasItemOption = true;
    }

    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
    : value, this._dimensionInfos[dimName]);
  },
  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
    return dataItem[dimIndex];
  }
};

function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
}
/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
 */


function converDataValue(value, dimInfo) {
  // Performance sensitive.
  var dimType = dimInfo && dimInfo.type;

  if (dimType === 'ordinal') {
    // If given value is a category string
    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && typeof value !== 'number' && value != null && value !== '-') {
    value = +parseDate(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.


  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
  // If object, also parse to NaN
  : +value;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?

/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string|number} [dim] dimName or dimIndex
 * @return {Array.<number>|string|number} can be null/undefined.
 */


function retrieveRawValue(data, dataIndex, dim) {
  if (!data) {
    return;
  } // Consider data may be not persistent.


  var dataItem = data.getRawDataItem(dataIndex);

  if (dataItem == null) {
    return;
  }

  var sourceFormat = data.getProvider().getSource().sourceFormat;
  var dimName;
  var dimIndex;
  var dimInfo = data.getDimensionInfo(dim);

  if (dimInfo) {
    dimName = dimInfo.name;
    dimIndex = dimInfo.index;
  }

  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
}
/**
 * Compatible with some cases (in pie, map) like:
 * data: [{name: 'xx', value: 5, selected: true}, ...]
 * where only sourceFormat is 'original' and 'objectRows' supported.
 *
 * ??? TODO
 * Supported detail options in data item when using 'arrayRows'.
 *
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @param {string} attr like 'selected'
 */


function retrieveRawAttr(data, dataIndex, attr) {
  if (!data) {
    return;
  }

  var sourceFormat = data.getProvider().getSource().sourceFormat;

  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
    return;
  }

  var dataItem = data.getRawDataItem(dataIndex);

  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
    dataItem = null;
  }

  if (dataItem) {
    return dataItem[attr];
  }
}

exports.DefaultDataProvider = DefaultDataProvider;
exports.defaultDimValueGetters = defaultDimValueGetters;
exports.retrieveRawValue = retrieveRawValue;
exports.retrieveRawAttr = retrieveRawAttr;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(39);
var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(59) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(35);
var toLength = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(67);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(41);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(11);
var cof = __webpack_require__(41);
var MATCH = __webpack_require__(12)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(6);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(29);
var redefine = __webpack_require__(30);
var fails = __webpack_require__(10);
var defined = __webpack_require__(46);
var wks = __webpack_require__(12);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(23);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(30);
var redefineAll = __webpack_require__(73);
var meta = __webpack_require__(58);
var forOf = __webpack_require__(72);
var anInstance = __webpack_require__(71);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(109);
var setToStringTag = __webpack_require__(77);
var inheritIfRequired = __webpack_require__(140);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(29);
var uid = __webpack_require__(65);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(59) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(8)[K];
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(23);
var ctx = __webpack_require__(40);
var forOf = __webpack_require__(72);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * @Author: wangzongyu
 * @Date: 2020-07-30 19:18:22
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-24 14:12:29
 * @Description:
 * @FilePath: /web-ac-client/src/api/env.js
 */var TEST_SERVER='test-client.aircourses.com';// 测试服
var DEV_SERVER='dev-client.aircourses.com';// 开发服
var PRE_SERVER='47.111.78.238';// 预发布
var PRE_SERVER_HTTPS='pre-client.aircourses.com';// 预发布
var PROD_SERVER='client.aircourses.com';// 正式服
var ENV={local:{env:'local',baseUrl:'http://localhost:3000',wxBaseUrl:'http://dev-wx.aircourses.com',apiBaseUrl:'http://dev-api.aircourses.com',bpBaseUrl:'http://dev-bp.aircourses.com'},dev:{env:'dev',baseUrl:'http://dev-client.aircourses.com',wxBaseUrl:'http://dev-wx.aircourses.com',apiBaseUrl:'http://dev-api.aircourses.com',bpBaseUrl:'http://dev-bp.aircourses.com'},test:{env:'test',baseUrl:'http://test-client.aircourses.com',wxBaseUrl:'http://test-wx.aircourses.com',apiBaseUrl:'http://test-api.aircourses.com',bpBaseUrl:'http://test-bp.aircourses.com'},pre:{env:'pre',baseUrl:'https://pre-client.aircourses.com',wxBaseUrl:'https://pre-wx.aircourses.com',apiBaseUrl:'https://pre-api.aircourses.com',bpBaseUrl:'https://pre-bp.aircourses.com'},prod:{env:'prod',baseUrl:'https://client.aircourses.com',wxBaseUrl:'https://wx.aircourses.com',apiBaseUrl:'https://api.aircourses.com',bpBaseUrl:'https://bp.aircourses.com'}};var BASE_CONFIG=void 0;switch(window.location.hostname){case TEST_SERVER:BASE_CONFIG=ENV.test;break;case DEV_SERVER:BASE_CONFIG=ENV.dev;break;case PRE_SERVER:case PRE_SERVER_HTTPS:BASE_CONFIG=ENV.pre;break;case PROD_SERVER:BASE_CONFIG=ENV.prod;break;default:BASE_CONFIG=ENV.prod;break;}/* harmony default export */ __webpack_exports__["a"] = (BASE_CONFIG);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(18); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(592);

var ErrorCorrectLevel = __webpack_require__(233);

function getBackingStorePixelRatio(ctx) {
  return (// $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
    ctx.mozBackingStorePixelRatio || // $FlowFixMe
    ctx.msBackingStorePixelRatio || // $FlowFixMe
    ctx.oBackingStorePixelRatio || // $FlowFixMe
    ctx.backingStorePixelRatio || 1
  );
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/


function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000'
};
var PROP_TYPES = {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string
};

var QRCodeCanvas =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QRCodeCanvas, _React$Component);

  function QRCodeCanvas() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    }), _temp));
  }

  _createClass(QRCodeCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this2.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _props = this.props,
          value = _props.value,
          size = _props.size,
          level = _props.level,
          bgColor = _props.bgColor,
          fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var tileW = size / cells.length;
        var tileH = size / cells.length;
        var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
        canvas.height = canvas.width = size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          value = _props2.value,
          size = _props2.size,
          level = _props2.level,
          bgColor = _props2.bgColor,
          fgColor = _props2.fgColor,
          style = _props2.style,
          otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);

      var canvasStyle = _extends({
        height: size,
        width: size
      }, style);

      return React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this3._canvas = _ref2;
        }
      }, otherProps));
    }
  }]);

  return QRCodeCanvas;
}(React.Component);

Object.defineProperty(QRCodeCanvas, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCodeSVG =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(QRCodeSVG, _React$Component2);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
  }

  _createClass(QRCodeSVG, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this4 = this;

      return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
        return _this4.props[k] !== nextProps[k];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          value = _props3.value,
          size = _props3.size,
          level = _props3.level,
          bgColor = _props3.bgColor,
          fgColor = _props3.fgColor,
          otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return;
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var ops = [];
      cells.forEach(function (row, y) {
        var lastIsDark = false;
        var start = null;
        row.forEach(function (cell, x) {
          if (!cell && start !== null) {
            // M0 0h7v1H0z injects the space with the move and dropd the comma,
            // saving a char per operation
            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
            start = null;
            return;
          } // end of row, clean up or skip


          if (x === row.length - 1) {
            if (!cell) {
              // We would have closed the op above already so this can only mean
              // 2+ light modules in a row.
              return;
            }

            if (start === null) {
              // Just a single dark module.
              ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
            } else {
              // Otherwise finish the current line.
              ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
            }

            return;
          }

          if (cell && start === null) {
            start = x;
          }
        });
      });
      return React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
      }, otherProps), React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
      }), React.createElement("path", {
        fill: fgColor,
        d: ops.join('')
      }));
    }
  }]);

  return QRCodeSVG;
}(React.Component);

Object.defineProperty(QRCodeSVG, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: PROP_TYPES
});

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, ["renderAs"]);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return React.createElement(Component, otherProps);
};

QRCode.defaultProps = _extends({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseIcon_less__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseIcon_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CloseIcon_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CloseIcon=function(_Component){_inherits(CloseIcon,_Component);function CloseIcon(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CloseIcon);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CloseIcon.__proto__||Object.getPrototypeOf(CloseIcon)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(){var _this$props=_this.props,closeReason=_this$props.closeReason,callback=_this$props.callback;__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].closeH5Page({reason:closeReason});callback&&callback();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CloseIcon,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close_icon pointer',onClick:this.handleClick});}}]);return CloseIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CloseIcon);

/***/ }),
/* 124 */
/***/ (function(module, exports) {

var dpr = 1; // If in browser environment

if (typeof window !== 'undefined') {
  dpr = Math.max(window.devicePixelRatio || 1, 1);
}
/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */

/**
 * Debug log mode:
 * 0: Do nothing, for release.
 * 1: console.error, for debug.
 */


var debugMode = 0; // retina 屏幕优化

var devicePixelRatio = dpr;
exports.debugMode = debugMode;
exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

var ContextCachedBy = {
  NONE: 0,
  STYLE_BIND: 1,
  PLAIN_TEXT: 2
}; // Avoid confused with 0/false.

var WILL_BE_RESTORED = 9;
exports.ContextCachedBy = ContextCachedBy;
exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(2);

var Style = __webpack_require__(170);

var Element = __webpack_require__(252);

var RectText = __webpack_require__(812);

/**
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 */

/**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */
function Displayable(opts) {
  opts = opts || {};
  Element.call(this, opts); // Extend properties

  for (var name in opts) {
    if (opts.hasOwnProperty(name) && name !== 'style') {
      this[name] = opts[name];
    }
  }
  /**
   * @type {module:zrender/graphic/Style}
   */


  this.style = new Style(opts.style, this);
  this._rect = null; // Shapes for cascade clipping.
  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
  // because it is easy to only using null to check whether clipPaths changed.

  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
  // Stateful.call(this, opts);
}

Displayable.prototype = {
  constructor: Displayable,
  type: 'displayable',

  /**
   * Dirty flag. From which painter will determine if this displayable object needs brush.
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */
  __dirty: true,

  /**
   * Whether the displayable object is visible. when it is true, the displayable object
   * is not drawn, but the mouse event can still trigger the object.
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */
  invisible: false,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z: 0,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z2: 0,

  /**
   * The z level determines the displayable object can be drawn in which layer canvas.
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */
  zlevel: 0,

  /**
   * Whether it can be dragged.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  draggable: false,

  /**
   * Whether is it dragging.
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  dragging: false,

  /**
   * Whether to respond to mouse events.
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * If enable culling
   * @type {boolean}
   * @default false
   */
  culling: false,

  /**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */
  cursor: 'pointer',

  /**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */
  rectHover: false,

  /**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {boolean}
   */
  progressive: false,

  /**
   * @type {boolean}
   */
  incremental: false,

  /**
   * Scale ratio for global scale.
   * @type {boolean}
   */
  globalScaleRatio: 1,
  beforeBrush: function (ctx) {},
  afterBrush: function (ctx) {},

  /**
   * Graphic drawing method.
   * @param {CanvasRenderingContext2D} ctx
   */
  // Interface
  brush: function (ctx, prevEl) {},

  /**
   * Get the minimum bounding box.
   * @return {module:zrender/core/BoundingRect}
   */
  // Interface
  getBoundingRect: function () {},

  /**
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  contain: function (x, y) {
    return this.rectContain(x, y);
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    cb.call(context, this);
  },

  /**
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  rectContain: function (x, y) {
    var coord = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    return rect.contain(coord[0], coord[1]);
  },

  /**
   * Mark displayable element dirty and refresh next frame
   */
  dirty: function () {
    this.__dirty = this.__dirtyText = true;
    this._rect = null;
    this.__zr && this.__zr.refresh();
  },

  /**
   * If displayable object binded any event
   * @return {boolean}
   */
  // TODO, events bound by bind
  // isSilent: function () {
  //     return !(
  //         this.hoverable || this.draggable
  //         || this.onmousemove || this.onmouseover || this.onmouseout
  //         || this.onmousedown || this.onmouseup || this.onclick
  //         || this.ondragenter || this.ondragover || this.ondragleave
  //         || this.ondrop
  //     );
  // },

  /**
   * Alias for animate('style')
   * @param {boolean} loop
   */
  animateStyle: function (loop) {
    return this.animate('style', loop);
  },
  attrKV: function (key, value) {
    if (key !== 'style') {
      Element.prototype.attrKV.call(this, key, value);
    } else {
      this.style.set(value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setStyle: function (key, value) {
    this.style.set(key, value);
    this.dirty(false);
    return this;
  },

  /**
   * Use given style object
   * @param  {Object} obj
   */
  useStyle: function (obj) {
    this.style = new Style(obj, this);
    this.dirty(false);
    return this;
  },

  /**
   * The string value of `textPosition` needs to be calculated to a real postion.
   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
   * by default. See `contain/text.js#calculateTextPosition` for more details.
   * But some coutom shapes like "pin", "flag" have center that is not exactly
   * `[width/2, height/2]`. So we provide this hook to customize the calculation
   * for those shapes. It will be called if the `style.textPosition` is a string.
   * @param {Obejct} [out] Prepared out object. If not provided, this method should
   *        be responsible for creating one.
   * @param {module:zrender/graphic/Style} style
   * @param {Object} rect {x, y, width, height}
   * @return {Obejct} out The same as the input out.
   *         {
   *             x: number. mandatory.
   *             y: number. mandatory.
   *             textAlign: string. optional. use style.textAlign by default.
   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
   *         }
   */
  calculateTextPosition: null
};
zrUtil.inherits(Displayable, Element);
zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);

var _default = Displayable;
module.exports = _default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(84);

var vec2 = __webpack_require__(26);

var bbox = __webpack_require__(264);

var BoundingRect = __webpack_require__(33);

var _config = __webpack_require__(124);

var dpr = _config.devicePixelRatio;

/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */
// TODO getTotalLength, getPointAtLength

/* global Float32Array */
var CMD = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  // Rect
  R: 7
}; // var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };

var min = [];
var max = [];
var min2 = [];
var max2 = [];
var mathMin = Math.min;
var mathMax = Math.max;
var mathCos = Math.cos;
var mathSin = Math.sin;
var mathSqrt = Math.sqrt;
var mathAbs = Math.abs;
var hasTypedArray = typeof Float32Array !== 'undefined';
/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */

var PathProxy = function (notSaveData) {
  this._saveData = !(notSaveData || false);

  if (this._saveData) {
    /**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */
    this.data = [];
  }

  this._ctx = null;
};
/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */


PathProxy.prototype = {
  constructor: PathProxy,
  _xi: 0,
  _yi: 0,
  _x0: 0,
  _y0: 0,
  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
  _ux: 0,
  _uy: 0,
  _len: 0,
  _lineDash: null,
  _dashOffset: 0,
  _dashIdx: 0,
  _dashSum: 0,

  /**
   * @readOnly
   */
  setScale: function (sx, sy, segmentIgnoreThreshold) {
    // Compat. Previously there is no segmentIgnoreThreshold.
    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
  },
  getContext: function () {
    return this._ctx;
  },

  /**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  beginPath: function (ctx) {
    this._ctx = ctx;
    ctx && ctx.beginPath();
    ctx && (this.dpr = ctx.dpr); // Reset

    if (this._saveData) {
      this._len = 0;
    }

    if (this._lineDash) {
      this._lineDash = null;
      this._dashOffset = 0;
    }

    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  moveTo: function (x, y) {
    this.addData(CMD.M, x, y);
    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持

    this._x0 = x;
    this._y0 = y;
    this._xi = x;
    this._yi = y;
    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  lineTo: function (x, y) {
    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
    || this._len < 5;
    this.addData(CMD.L, x, y);

    if (this._ctx && exceedUnit) {
      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
    }

    if (exceedUnit) {
      this._xi = x;
      this._yi = y;
    }

    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */
  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);

    if (this._ctx) {
      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
    }

    this._xi = x3;
    this._yi = y3;
    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */
  quadraticCurveTo: function (x1, y1, x2, y2) {
    this.addData(CMD.Q, x1, y1, x2, y2);

    if (this._ctx) {
      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
    }

    this._xi = x2;
    this._yi = y2;
    return this;
  },

  /**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */
  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
    this._xi = mathCos(endAngle) * r + cx;
    this._yi = mathSin(endAngle) * r + cy;
    return this;
  },
  // TODO
  arcTo: function (x1, y1, x2, y2, radius) {
    if (this._ctx) {
      this._ctx.arcTo(x1, y1, x2, y2, radius);
    }

    return this;
  },
  // TODO
  rect: function (x, y, w, h) {
    this._ctx && this._ctx.rect(x, y, w, h);
    this.addData(CMD.R, x, y, w, h);
    return this;
  },

  /**
   * @return {module:zrender/core/PathProxy}
   */
  closePath: function () {
    this.addData(CMD.Z);
    var ctx = this._ctx;
    var x0 = this._x0;
    var y0 = this._y0;

    if (ctx) {
      this._needsDash() && this._dashedLineTo(x0, y0);
      ctx.closePath();
    }

    this._xi = x0;
    this._yi = y0;
    return this;
  },

  /**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  fill: function (ctx) {
    ctx && ctx.fill();
    this.toStatic();
  },

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  stroke: function (ctx) {
    ctx && ctx.stroke();
    this.toStatic();
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDash: function (lineDash) {
    if (lineDash instanceof Array) {
      this._lineDash = lineDash;
      this._dashIdx = 0;
      var lineDashSum = 0;

      for (var i = 0; i < lineDash.length; i++) {
        lineDashSum += lineDash[i];
      }

      this._dashSum = lineDashSum;
    }

    return this;
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDashOffset: function (offset) {
    this._dashOffset = offset;
    return this;
  },

  /**
   *
   * @return {boolean}
   */
  len: function () {
    return this._len;
  },

  /**
   * 直接设置 Path 数据
   */
  setData: function (data) {
    var len = data.length;

    if (!(this.data && this.data.length === len) && hasTypedArray) {
      this.data = new Float32Array(len);
    }

    for (var i = 0; i < len; i++) {
      this.data[i] = data[i];
    }

    this._len = len;
  },

  /**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */
  appendPath: function (path) {
    if (!(path instanceof Array)) {
      path = [path];
    }

    var len = path.length;
    var appendSize = 0;
    var offset = this._len;

    for (var i = 0; i < len; i++) {
      appendSize += path[i].len();
    }

    if (hasTypedArray && this.data instanceof Float32Array) {
      this.data = new Float32Array(offset + appendSize);
    }

    for (var i = 0; i < len; i++) {
      var appendPathData = path[i].data;

      for (var k = 0; k < appendPathData.length; k++) {
        this.data[offset++] = appendPathData[k];
      }
    }

    this._len = offset;
  },

  /**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */
  addData: function (cmd) {
    if (!this._saveData) {
      return;
    }

    var data = this.data;

    if (this._len + arguments.length > data.length) {
      // 因为之前的数组已经转换成静态的 Float32Array
      // 所以不够用时需要扩展一个新的动态数组
      this._expandData();

      data = this.data;
    }

    for (var i = 0; i < arguments.length; i++) {
      data[this._len++] = arguments[i];
    }

    this._prevCmd = cmd;
  },
  _expandData: function () {
    // Only if data is Float32Array
    if (!(this.data instanceof Array)) {
      var newData = [];

      for (var i = 0; i < this._len; i++) {
        newData[i] = this.data[i];
      }

      this.data = newData;
    }
  },

  /**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */
  _needsDash: function () {
    return this._lineDash;
  },
  _dashedLineTo: function (x1, y1) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var dx = x1 - x0;
    var dy = y1 - y0;
    var dist = mathSqrt(dx * dx + dy * dy);
    var x = x0;
    var y = y0;
    var dash;
    var nDash = lineDash.length;
    var idx;
    dx /= dist;
    dy /= dist;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum;
    x -= offset * dx;
    y -= offset * dy;

    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
      idx = this._dashIdx;
      dash = lineDash[idx];
      x += dx * dash;
      y += dy * dash;
      this._dashIdx = (idx + 1) % nDash; // Skip positive offset

      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
        continue;
      }

      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
    } // Offset for next lineTo


    dx = x - x1;
    dy = y - y1;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  // Not accurate dashed line to
  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var t;
    var dx;
    var dy;
    var cubicAt = curve.cubicAt;
    var bezierLen = 0;
    var idx = this._dashIdx;
    var nDash = lineDash.length;
    var x;
    var y;
    var tmpLen = 0;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum; // Bezier approx length

    for (t = 0; t < 1; t += 0.1) {
      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
      bezierLen += mathSqrt(dx * dx + dy * dy);
    } // Find idx after add offset


    for (; idx < nDash; idx++) {
      tmpLen += lineDash[idx];

      if (tmpLen > offset) {
        break;
      }
    }

    t = (tmpLen - offset) / bezierLen;

    while (t <= 1) {
      x = cubicAt(x0, x1, x2, x3, t);
      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
      // Bad result if dash is long

      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      t += lineDash[idx] / bezierLen;
      idx = (idx + 1) % nDash;
    } // Finish the last segment and calculate the new offset


    idx % 2 !== 0 && ctx.lineTo(x3, y3);
    dx = x3 - x;
    dy = y3 - y;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  _dashedQuadraticTo: function (x1, y1, x2, y2) {
    // Convert quadratic to cubic using degree elevation
    var x3 = x2;
    var y3 = y2;
    x2 = (x2 + 2 * x1) / 3;
    y2 = (y2 + 2 * y1) / 3;
    x1 = (this._xi + 2 * x1) / 3;
    y1 = (this._yi + 2 * y1) / 3;

    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
  },

  /**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */
  toStatic: function () {
    var data = this.data;

    if (data instanceof Array) {
      data.length = this._len;

      if (hasTypedArray) {
        this.data = new Float32Array(data);
      }
    }
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
    var data = this.data;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];

      if (i === 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = data[i];
        yi = data[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
          // 在 closePath 的时候使用
          x0 = data[i++];
          y0 = data[i++];
          xi = x0;
          yi = y0;
          min2[0] = x0;
          min2[1] = y0;
          max2[0] = x0;
          max2[1] = y0;
          break;

        case CMD.L:
          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.C:
          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.Q:
          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.A:
          // TODO Arc 判断的开销比较大
          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++];
          var endAngle = data[i++] + startAngle; // TODO Arc 旋转

          i += 1;
          var anticlockwise = 1 - data[i++];

          if (i === 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(startAngle) * rx + cx;
            y0 = mathSin(startAngle) * ry + cy;
          }

          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = data[i++];
          y0 = yi = data[i++];
          var width = data[i++];
          var height = data[i++]; // Use fromLine

          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
          break;

        case CMD.Z:
          xi = x0;
          yi = y0;
          break;
      } // Union


      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */
  rebuildPath: function (ctx) {
    var d = this.data;
    var x0;
    var y0;
    var xi;
    var yi;
    var x;
    var y;
    var ux = this._ux;
    var uy = this._uy;
    var len = this._len;

    for (var i = 0; i < len;) {
      var cmd = d[i++];

      if (i === 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = d[i];
        yi = d[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          x0 = xi = d[i++];
          y0 = yi = d[i++];
          ctx.moveTo(xi, yi);
          break;

        case CMD.L:
          x = d[i++];
          y = d[i++]; // Not draw too small seg between

          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
            ctx.lineTo(x, y);
            xi = x;
            yi = y;
          }

          break;

        case CMD.C:
          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.Q:
          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.A:
          var cx = d[i++];
          var cy = d[i++];
          var rx = d[i++];
          var ry = d[i++];
          var theta = d[i++];
          var dTheta = d[i++];
          var psi = d[i++];
          var fs = d[i++];
          var r = rx > ry ? rx : ry;
          var scaleX = rx > ry ? 1 : rx / ry;
          var scaleY = rx > ry ? ry / rx : 1;
          var isEllipse = Math.abs(rx - ry) > 1e-3;
          var endAngle = theta + dTheta;

          if (isEllipse) {
            ctx.translate(cx, cy);
            ctx.rotate(psi);
            ctx.scale(scaleX, scaleY);
            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
            ctx.scale(1 / scaleX, 1 / scaleY);
            ctx.rotate(-psi);
            ctx.translate(-cx, -cy);
          } else {
            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
          }

          if (i === 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(theta) * rx + cx;
            y0 = mathSin(theta) * ry + cy;
          }

          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = d[i];
          y0 = yi = d[i + 1];
          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
          break;

        case CMD.Z:
          ctx.closePath();
          xi = x0;
          yi = y0;
      }
    }
  }
};
PathProxy.CMD = CMD;
var _default = PathProxy;
module.exports = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var _clazz = __webpack_require__(62);

var parseClassType = _clazz.parseClassType;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var base = 0;
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base++, Math.random().toFixed(5)].join('_');
}
/**
 * @inner
 */


function enableSubTypeDefaulter(entity) {
  var subTypeDefaulters = {};

  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
    componentType = parseClassType(componentType);
    subTypeDefaulters[componentType.main] = defaulter;
  };

  entity.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = parseClassType(componentType).main;

      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };

  return entity;
}
/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */


function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var stack = result.noEntryList;
    var targetNameSet = {};
    zrUtil.each(targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (stack.length) {
      var currComponentType = stack.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    zrUtil.each(targetNameSet, function () {
      throw new Error('Circle dependency may exists');
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        stack.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };
  /**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */


  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    zrUtil.each(fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      zrUtil.each(availableDeps, function (dependentName) {
        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    zrUtil.each(originalDeps, function (dep) {
      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}

exports.getUID = getUID;
exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var clazzUtil = __webpack_require__(62);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * // Scale class management
 * @module echarts/scale/Scale
 */

/**
 * @param {Object} [setting]
 */
function Scale(setting) {
  this._setting = setting || {};
  /**
   * Extent
   * @type {Array.<number>}
   * @protected
   */

  this._extent = [Infinity, -Infinity];
  /**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */

  this._interval = 0;
  this.init && this.init.apply(this, arguments);
}
/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */


Scale.prototype.parse = function (val) {
  // Notice: This would be a trap here, If the implementation
  // of this method depends on extent, and this method is used
  // before extent set (like in dataZoom), it would be wrong.
  // Nevertheless, parse does not depend on extent generally.
  return val;
};

Scale.prototype.getSetting = function (name) {
  return this._setting[name];
};

Scale.prototype.contain = function (val) {
  var extent = this._extent;
  return val >= extent[0] && val <= extent[1];
};
/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */


Scale.prototype.normalize = function (val) {
  var extent = this._extent;

  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
};
/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */


Scale.prototype.scale = function (val) {
  var extent = this._extent;
  return val * (extent[1] - extent[0]) + extent[0];
};
/**
 * Set extent from data
 * @param {Array.<number>} other
 */


Scale.prototype.unionExtent = function (other) {
  var extent = this._extent;
  other[0] < extent[0] && (extent[0] = other[0]);
  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
  // this.setExtent(extent[0], extent[1]);
};
/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */


Scale.prototype.unionExtentFromData = function (data, dim) {
  this.unionExtent(data.getApproximateExtent(dim));
};
/**
 * Get extent
 * @return {Array.<number>}
 */


Scale.prototype.getExtent = function () {
  return this._extent.slice();
};
/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */


Scale.prototype.setExtent = function (start, end) {
  var thisExtent = this._extent;

  if (!isNaN(start)) {
    thisExtent[0] = start;
  }

  if (!isNaN(end)) {
    thisExtent[1] = end;
  }
};
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */


Scale.prototype.isBlank = function () {
  return this._isBlank;
},
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */
Scale.prototype.setBlank = function (isBlank) {
  this._isBlank = isBlank;
};
/**
 * @abstract
 * @param {*} tick
 * @return {string} label of the tick.
 */

Scale.prototype.getLabel = null;
clazzUtil.enableClassExtend(Scale);
clazzUtil.enableClassManagement(Scale, {
  registerWhenExtend: true
});
var _default = Scale;
module.exports = _default;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

var BoundingRect = __webpack_require__(33);

var _text = __webpack_require__(75);

var calculateTextPosition = _text.calculateTextPosition;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Symbol factory

/**
 * Triangle shape
 * @inner
 */
var Triangle = graphic.extendShape({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = graphic.extendShape({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin = graphic.extendShape({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow = graphic.extendShape({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */

var symbolCtors = {
  line: graphic.Line,
  rect: graphic.Rect,
  roundRect: graphic.Rect,
  square: graphic.Rect,
  circle: graphic.Circle,
  diamond: Diamond,
  pin: Pin,
  arrow: Arrow,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    // FIXME
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
zrUtil.each(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = graphic.extendShape({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function (out, style, rect) {
    var res = calculateTextPosition(out, style, rect);
    var shape = this.shape;

    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
      res.y = rect.y + rect.height * 0.4;
    }

    return res;
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;

    if (symbolType !== 'none') {
      var proxySymbol = symbolBuildProxies[symbolType];

      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;
    var symbolShape = this.shape;

    if (symbolShape && symbolShape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff';
    } else {
      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
      symbolStyle.fill && (symbolStyle.fill = color);
      symbolStyle.stroke && (symbolStyle.stroke = color);
    }

    this.dirty(false);
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */


function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty;
  symbolPath.setColor = symbolPathSetColor;
  symbolPath.setColor(color);
  return symbolPath;
}

exports.createSymbol = createSymbol;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Model = __webpack_require__(55);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  each(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));

      if (triggerAxis || cross) {
        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var key = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[key] = {
        key: key,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: []
      };
      axesInfoInCoordSys[key] = axisInfo;
      result.seriesInvolved |= involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[key] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var volatileOption = {};
  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
    var seriesTooltipShow = seriesModel.get('tooltip.show', true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
      return;
    }

    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  }, this);
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}

function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}

function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get('handle.show');
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

exports.collect = collect;
exports.fixValue = fixValue;
exports.getAxisInfo = getAxisInfo;
exports.getAxisPointerModel = getAxisPointerModel;
exports.makeKey = makeKey;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(39);
var LIBRARY = __webpack_require__(59);
var wksExt = __webpack_require__(185);
var defineProperty = __webpack_require__(15).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(104)('keys');
var uid = __webpack_require__(65);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(40)(Function.call, __webpack_require__(36).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(138).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(46);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(46);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(30);
var hide = __webpack_require__(29);
var Iterators = __webpack_require__(79);
var $iterCreate = __webpack_require__(146);
var setToStringTag = __webpack_require__(77);
var getPrototypeOf = __webpack_require__(37);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(68);
var descriptor = __webpack_require__(64);
var setToStringTag = __webpack_require__(77);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(29)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(108);
var defined = __webpack_require__(46);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(79);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(15);
var createDesc = __webpack_require__(64);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(89);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(79);
module.exports = __webpack_require__(39).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(411);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(16);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(60);
var step = __webpack_require__(201);
var Iterators = __webpack_require__(79);
var toIObject = __webpack_require__(35);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(145)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var invoke = __webpack_require__(191);
var html = __webpack_require__(137);
var cel = __webpack_require__(133);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(41)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(155).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(41)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(23);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(59);
var $typed = __webpack_require__(115);
var hide = __webpack_require__(29);
var redefineAll = __webpack_require__(73);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(71);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
var toIndex = __webpack_require__(210);
var gOPN = __webpack_require__(69).f;
var dP = __webpack_require__(15).f;
var arrayFill = __webpack_require__(153);
var setToStringTag = __webpack_require__(77);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(532);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(533);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(535);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(537);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(161);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(541);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(545);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(546);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(162);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(38);
var normalizeHeaderName = __webpack_require__(570);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(226);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(226);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(569)))

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar_less__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressBar_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProgressBar_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'
var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(){_classCallCheck(this,ProgressBar);return _possibleConstructorReturn(this,(ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).apply(this,arguments));}_createClass(ProgressBar,[{key:'render',value:function render(){var _props=this.props,currentNum=_props.currentNum,totalNum=_props.totalNum,outColor=_props.outColor,insertColor=_props.insertColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress_bar',style:{backgroundColor:outColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert',style:{backgroundColor:insertColor,width:currentNum/totalNum*100+'%'}}));}}]);return ProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CourseDetailHeader=function(_Component){_inherits(CourseDetailHeader,_Component);function CourseDetailHeader(){_classCallCheck(this,CourseDetailHeader);return _possibleConstructorReturn(this,(CourseDetailHeader.__proto__||Object.getPrototypeOf(CourseDetailHeader)).apply(this,arguments));}_createClass(CourseDetailHeader,[{key:'render',value:function render(){var _props=this.props,title=_props.title,stuCount=_props.stuCount,lessonDate=_props.lessonDate,stuStatus=_props.stuStatus,bg=_props.bg,isPermanent=_props.isPermanent;var curTime=new Date().getTime();var date=Object(__WEBPACK_IMPORTED_MODULE_1__utils_tools__["f" /* parseDate */])(lessonDate+86399999);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_wrap',style:{backgroundImage:'url('+bg+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shadow_wrap'}),title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},this.props.title),stuCount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text stu_count'},stuCount),stuStatus&&stuStatus!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text lesson_date'},lessonDate+86399999<curTime?'\u5DF2\u4E8E'+date+'\u5230\u671F':isPermanent?'永久有效':'\u6709\u6548\u671F\u81F3 '+date));}}]);return CourseDetailHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseDetailHeader);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vdieo_less__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vdieo_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Vdieo_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import paused from '../../static/images/util-template/paused.png';
// import playing from '../../static/images/util-template/playing.png';
var Vdieo=function(_Component){_inherits(Vdieo,_Component);function Vdieo(props){_classCallCheck(this,Vdieo);var _this=_possibleConstructorReturn(this,(Vdieo.__proto__||Object.getPrototypeOf(Vdieo)).call(this,props));_this.btnClick=function(e){window.event?window.event.cancelBubble=true:e.stopPropagation();var btnStatus=_this.state.btnStatus;if(btnStatus==='paused'){_this.video.play();_this.setState({btnStatus:'playing',showBtn:false});}else{_this.video.pause();clearTimeout(_this.timeout);_this.setState({btnStatus:'paused',showBtn:true});}};_this.wrapClick=function(type){if(type==='click'&&!__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].mobileClient)return false;var _this$state=_this.state,showBtn=_this$state.showBtn,btnStatus=_this$state.btnStatus;if(showBtn||btnStatus==='paused')return false;else{// console.log(type)
_this.setState({showBtn:true});_this.timeout=setTimeout(function(){_this.setState({showBtn:false});},2000);}};_this.state={btnStatus:'paused',showBtn:true};return _this;}_createClass(Vdieo,[{key:'render',value:function render(){var _this2=this;// const { btnStatus, showBtn } = this.state;
var _props=this.props,src=_props.src,style=_props.style,className=_props.className,poster=_props.poster;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video_wrap '+className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{src:src,style:Object.assign({},style),ref:function ref(com){_this2.video=com;},poster:poster,controls:true,preload:'auto','webkit-playsinline':'true',playsInline:'true','x-webkit-airplay':'true'}));}}]);return Vdieo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Vdieo);

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// https://github.com/mziccard/node-timsort
var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
var DEFAULT_TMP_STORAGE_LENGTH = 256;

function minRunLength(n) {
  var r = 0;

  while (n >= DEFAULT_MIN_MERGE) {
    r |= n & 1;
    n >>= 1;
  }

  return n + r;
}

function makeAscendingRun(array, lo, hi, compare) {
  var runHi = lo + 1;

  if (runHi === hi) {
    return 1;
  }

  if (compare(array[runHi++], array[lo]) < 0) {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
      runHi++;
    }

    reverseRun(array, lo, runHi);
  } else {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
      runHi++;
    }
  }

  return runHi - lo;
}

function reverseRun(array, lo, hi) {
  hi--;

  while (lo < hi) {
    var t = array[lo];
    array[lo++] = array[hi];
    array[hi--] = t;
  }
}

function binaryInsertionSort(array, lo, hi, start, compare) {
  if (start === lo) {
    start++;
  }

  for (; start < hi; start++) {
    var pivot = array[start];
    var left = lo;
    var right = start;
    var mid;

    while (left < right) {
      mid = left + right >>> 1;

      if (compare(pivot, array[mid]) < 0) {
        right = mid;
      } else {
        left = mid + 1;
      }
    }

    var n = start - left;

    switch (n) {
      case 3:
        array[left + 3] = array[left + 2];

      case 2:
        array[left + 2] = array[left + 1];

      case 1:
        array[left + 1] = array[left];
        break;

      default:
        while (n > 0) {
          array[left + n] = array[left + n - 1];
          n--;
        }

    }

    array[left] = pivot;
  }
}

function gallopLeft(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) > 0) {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  } else {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) > 0) {
      lastOffset = m + 1;
    } else {
      offset = m;
    }
  }

  return offset;
}

function gallopRight(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) < 0) {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  } else {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) < 0) {
      offset = m;
    } else {
      lastOffset = m + 1;
    }
  }

  return offset;
}

function TimSort(array, compare) {
  var minGallop = DEFAULT_MIN_GALLOPING;
  var length = 0;
  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
  var stackLength = 0;
  var runStart;
  var runLength;
  var stackSize = 0;
  length = array.length;

  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
    tmpStorageLength = length >>> 1;
  }

  var tmp = [];
  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
  runStart = [];
  runLength = [];

  function pushRun(_runStart, _runLength) {
    runStart[stackSize] = _runStart;
    runLength[stackSize] = _runLength;
    stackSize += 1;
  }

  function mergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
        if (runLength[n - 1] < runLength[n + 1]) {
          n--;
        }
      } else if (runLength[n] > runLength[n + 1]) {
        break;
      }

      mergeAt(n);
    }
  }

  function forceMergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
        n--;
      }

      mergeAt(n);
    }
  }

  function mergeAt(i) {
    var start1 = runStart[i];
    var length1 = runLength[i];
    var start2 = runStart[i + 1];
    var length2 = runLength[i + 1];
    runLength[i] = length1 + length2;

    if (i === stackSize - 3) {
      runStart[i + 1] = runStart[i + 2];
      runLength[i + 1] = runLength[i + 2];
    }

    stackSize--;
    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
    start1 += k;
    length1 -= k;

    if (length1 === 0) {
      return;
    }

    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

    if (length2 === 0) {
      return;
    }

    if (length1 <= length2) {
      mergeLow(start1, length1, start2, length2);
    } else {
      mergeHigh(start1, length1, start2, length2);
    }
  }

  function mergeLow(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length1; i++) {
      tmp[i] = array[start1 + i];
    }

    var cursor1 = 0;
    var cursor2 = start2;
    var dest = start1;
    array[dest++] = array[cursor2++];

    if (--length2 === 0) {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }

      return;
    }

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
      return;
    }

    var _minGallop = minGallop;
    var count1;
    var count2;
    var exit;

    while (1) {
      count1 = 0;
      count2 = 0;
      exit = false;

      do {
        if (compare(array[cursor2], tmp[cursor1]) < 0) {
          array[dest++] = array[cursor2++];
          count2++;
          count1 = 0;

          if (--length2 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest++] = tmp[cursor1++];
          count1++;
          count2 = 0;

          if (--length1 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

        if (count1 !== 0) {
          for (i = 0; i < count1; i++) {
            array[dest + i] = tmp[cursor1 + i];
          }

          dest += count1;
          cursor1 += count1;
          length1 -= count1;

          if (length1 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest++] = array[cursor2++];

        if (--length2 === 0) {
          exit = true;
          break;
        }

        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

        if (count2 !== 0) {
          for (i = 0; i < count2; i++) {
            array[dest + i] = array[cursor2 + i];
          }

          dest += count2;
          cursor2 += count2;
          length2 -= count2;

          if (length2 === 0) {
            exit = true;
            break;
          }
        }

        array[dest++] = tmp[cursor1++];

        if (--length1 === 1) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;
    minGallop < 1 && (minGallop = 1);

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
    } else if (length1 === 0) {
      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
    } else {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }
    }
  }

  function mergeHigh(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length2; i++) {
      tmp[i] = array[start2 + i];
    }

    var cursor1 = start1 + length1 - 1;
    var cursor2 = length2 - 1;
    var dest = start2 + length2 - 1;
    var customCursor = 0;
    var customDest = 0;
    array[dest--] = array[cursor1--];

    if (--length1 === 0) {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }

      return;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
      return;
    }

    var _minGallop = minGallop;

    while (true) {
      var count1 = 0;
      var count2 = 0;
      var exit = false;

      do {
        if (compare(tmp[cursor2], array[cursor1]) < 0) {
          array[dest--] = array[cursor1--];
          count1++;
          count2 = 0;

          if (--length1 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest--] = tmp[cursor2--];
          count2++;
          count1 = 0;

          if (--length2 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

        if (count1 !== 0) {
          dest -= count1;
          cursor1 -= count1;
          length1 -= count1;
          customDest = dest + 1;
          customCursor = cursor1 + 1;

          for (i = count1 - 1; i >= 0; i--) {
            array[customDest + i] = array[customCursor + i];
          }

          if (length1 === 0) {
            exit = true;
            break;
          }
        }

        array[dest--] = tmp[cursor2--];

        if (--length2 === 1) {
          exit = true;
          break;
        }

        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

        if (count2 !== 0) {
          dest -= count2;
          cursor2 -= count2;
          length2 -= count2;
          customDest = dest + 1;
          customCursor = cursor2 + 1;

          for (i = 0; i < count2; i++) {
            array[customDest + i] = tmp[customCursor + i];
          }

          if (length2 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest--] = array[cursor1--];

        if (--length1 === 0) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;

    if (minGallop < 1) {
      minGallop = 1;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
    } else if (length2 === 0) {
      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
    } else {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }
    }
  }

  this.mergeRuns = mergeRuns;
  this.forceMergeRuns = forceMergeRuns;
  this.pushRun = pushRun;
}

function sort(array, compare, lo, hi) {
  if (!lo) {
    lo = 0;
  }

  if (!hi) {
    hi = array.length;
  }

  var remaining = hi - lo;

  if (remaining < 2) {
    return;
  }

  var runLength = 0;

  if (remaining < DEFAULT_MIN_MERGE) {
    runLength = makeAscendingRun(array, lo, hi, compare);
    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
    return;
  }

  var ts = new TimSort(array, compare);
  var minRun = minRunLength(remaining);

  do {
    runLength = makeAscendingRun(array, lo, hi, compare);

    if (runLength < minRun) {
      var force = remaining;

      if (force > minRun) {
        force = minRun;
      }

      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
      runLength = force;
    }

    ts.pushRun(lo, runLength);
    ts.mergeRuns();
    remaining -= runLength;
    lo += runLength;
  } while (remaining !== 0);

  ts.forceMergeRuns();
}

module.exports = sort;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var fixShadow = __webpack_require__(257);

var _constant = __webpack_require__(125);

var ContextCachedBy = _constant.ContextCachedBy;
var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);

var Style = function (opts) {
  this.extendFrom(opts, false);
};

function createLinearGradient(ctx, obj, rect) {
  var x = obj.x == null ? 0 : obj.x;
  var x2 = obj.x2 == null ? 1 : obj.x2;
  var y = obj.y == null ? 0 : obj.y;
  var y2 = obj.y2 == null ? 0 : obj.y2;

  if (!obj.global) {
    x = x * rect.width + rect.x;
    x2 = x2 * rect.width + rect.x;
    y = y * rect.height + rect.y;
    y2 = y2 * rect.height + rect.y;
  } // Fix NaN when rect is Infinity


  x = isNaN(x) ? 0 : x;
  x2 = isNaN(x2) ? 1 : x2;
  y = isNaN(y) ? 0 : y;
  y2 = isNaN(y2) ? 0 : y2;
  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
  return canvasGradient;
}

function createRadialGradient(ctx, obj, rect) {
  var width = rect.width;
  var height = rect.height;
  var min = Math.min(width, height);
  var x = obj.x == null ? 0.5 : obj.x;
  var y = obj.y == null ? 0.5 : obj.y;
  var r = obj.r == null ? 0.5 : obj.r;

  if (!obj.global) {
    x = x * width + rect.x;
    y = y * height + rect.y;
    r = r * min;
  }

  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
  return canvasGradient;
}

Style.prototype = {
  constructor: Style,

  /**
   * @type {string}
   */
  fill: '#000',

  /**
   * @type {string}
   */
  stroke: null,

  /**
   * @type {number}
   */
  opacity: 1,

  /**
   * @type {number}
   */
  fillOpacity: null,

  /**
   * @type {number}
   */
  strokeOpacity: null,

  /**
   * `true` is not supported.
   * `false`/`null`/`undefined` are the same.
   * `false` is used to remove lineDash in some
   * case that `null`/`undefined` can not be set.
   * (e.g., emphasis.lineStyle in echarts)
   * @type {Array.<number>|boolean}
   */
  lineDash: null,

  /**
   * @type {number}
   */
  lineDashOffset: 0,

  /**
   * @type {number}
   */
  shadowBlur: 0,

  /**
   * @type {number}
   */
  shadowOffsetX: 0,

  /**
   * @type {number}
   */
  shadowOffsetY: 0,

  /**
   * @type {number}
   */
  lineWidth: 1,

  /**
   * If stroke ignore scale
   * @type {Boolean}
   */
  strokeNoScale: false,
  // Bounding rect text configuration
  // Not affected by element transform

  /**
   * @type {string}
   */
  text: null,

  /**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */
  font: null,

  /**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */
  textFont: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontStyle: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontWeight: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */
  fontSize: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontFamily: null,

  /**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */
  textTag: null,

  /**
   * @type {string}
   */
  textFill: '#000',

  /**
   * @type {string}
   */
  textStroke: null,

  /**
   * @type {number}
   */
  textWidth: null,

  /**
   * Only for textBackground.
   * @type {number}
   */
  textHeight: null,

  /**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */
  textStrokeWidth: 0,

  /**
   * @type {number}
   */
  textLineHeight: null,

  /**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */
  textPosition: 'inside',

  /**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */
  textRect: null,

  /**
   * [x, y]
   * @type {Array.<number>}
   */
  textOffset: null,

  /**
   * @type {string}
   */
  textAlign: null,

  /**
   * @type {string}
   */
  textVerticalAlign: null,

  /**
   * @type {number}
   */
  textDistance: 5,

  /**
   * @type {string}
   */
  textShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textShadowBlur: 0,

  /**
   * @type {number}
   */
  textShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textShadowOffsetY: 0,

  /**
   * @type {string}
   */
  textBoxShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textBoxShadowBlur: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetY: 0,

  /**
   * Whether transform text.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   * @type {boolean}
   */
  transformText: false,

  /**
   * Text rotate around position of Path or Image.
   * The origin of the rotation can be specified by `textOrigin`.
   * Only available in Path and Image element,
   * where the text is called as `RectText`.
   */
  textRotation: 0,

  /**
   * Text origin of text rotation.
   * Useful in the case like label rotation of circular symbol.
   * Only available in Path and Image element, where the text is called
   * as `RectText` and the element is called as "host element".
   * The value can be:
   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
   * base on the left-top corner of the rect of its host element.
   * + If specified as a string `center`, it is the center of the rect of
   * its host element.
   * + By default, this origin is the `textPosition`.
   * @type {string|Array.<number>}
   */
  textOrigin: null,

  /**
   * @type {string}
   */
  textBackgroundColor: null,

  /**
   * @type {string}
   */
  textBorderColor: null,

  /**
   * @type {number}
   */
  textBorderWidth: 0,

  /**
   * @type {number}
   */
  textBorderRadius: 0,

  /**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */
  textPadding: null,

  /**
   * Text styles for rich text.
   * @type {Object}
   */
  rich: null,

  /**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */
  truncate: null,

  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */
  blend: null,

  /**
   * @param {CanvasRenderingContext2D} ctx
   */
  bind: function (ctx, el, prevEl) {
    var style = this;
    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
    // Only apply cache if the last time cachced by this function.

    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;

    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
      var prop = STYLE_COMMON_PROPS[i];
      var styleName = prop[0];

      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
        // FIXME Invalid property value will cause style leak from previous element.
        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
      }
    }

    if (notCheckCache || style.fill !== prevStyle.fill) {
      ctx.fillStyle = style.fill;
    }

    if (notCheckCache || style.stroke !== prevStyle.stroke) {
      ctx.strokeStyle = style.stroke;
    }

    if (notCheckCache || style.opacity !== prevStyle.opacity) {
      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }

    if (notCheckCache || style.blend !== prevStyle.blend) {
      ctx.globalCompositeOperation = style.blend || 'source-over';
    }

    if (this.hasStroke()) {
      var lineWidth = style.lineWidth;
      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
    }
  },
  hasFill: function () {
    var fill = this.fill;
    return fill != null && fill !== 'none';
  },
  hasStroke: function () {
    var stroke = this.stroke;
    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
  },

  /**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */
  extendFrom: function (otherStyle, overwrite) {
    if (otherStyle) {
      for (var name in otherStyle) {
        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
          this[name] = otherStyle[name];
        }
      }
    }
  },

  /**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */
  set: function (obj, value) {
    if (typeof obj === 'string') {
      this[obj] = value;
    } else {
      this.extendFrom(obj, true);
    }
  },

  /**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */
  clone: function () {
    var newStyle = new this.constructor();
    newStyle.extendFrom(this, true);
    return newStyle;
  },
  getGradient: function (ctx, obj, rect) {
    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
    var canvasGradient = method(ctx, obj, rect);
    var colorStops = obj.colorStops;

    for (var i = 0; i < colorStops.length; i++) {
      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }

    return canvasGradient;
  }
};
var styleProto = Style.prototype;

for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
  var prop = STYLE_COMMON_PROPS[i];

  if (!(prop[0] in styleProto)) {
    styleProto[prop[0]] = prop[1];
  }
} // Provide for others


Style.getGradient = styleProto.getGradient;
var _default = Style;
module.exports = _default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(126);

var BoundingRect = __webpack_require__(33);

var zrUtil = __webpack_require__(2);

var imageHelper = __webpack_require__(172);

/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
function ZImage(opts) {
  Displayable.call(this, opts);
}

ZImage.prototype = {
  constructor: ZImage,
  type: 'image',
  brush: function (ctx, prevEl) {
    var style = this.style;
    var src = style.image; // Must bind each time

    style.bind(ctx, this, prevEl);
    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);

    if (!image || !imageHelper.isImageReady(image)) {
      return;
    } // 图片已经加载完成
    // if (image.nodeName.toUpperCase() == 'IMG') {
    //     if (!image.complete) {
    //         return;
    //     }
    // }
    // Else is canvas


    var x = style.x || 0;
    var y = style.y || 0;
    var width = style.width;
    var height = style.height;
    var aspect = image.width / image.height;

    if (width == null && height != null) {
      // Keep image/height ratio
      width = height * aspect;
    } else if (height == null && width != null) {
      height = width / aspect;
    } else if (width == null && height == null) {
      width = image.width;
      height = image.height;
    } // 设置transform


    this.setTransform(ctx);

    if (style.sWidth && style.sHeight) {
      var sx = style.sx || 0;
      var sy = style.sy || 0;
      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
      var sx = style.sx;
      var sy = style.sy;
      var sWidth = width - sx;
      var sHeight = height - sy;
      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else {
      ctx.drawImage(image, x, y, width, height);
    } // Draw rect text


    if (style.text != null) {
      // Only restore transform when needs draw text.
      this.restoreTransform(ctx);
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  getBoundingRect: function () {
    var style = this.style;

    if (!this._rect) {
      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
    }

    return this._rect;
  }
};
zrUtil.inherits(ZImage, Displayable);
var _default = ZImage;
module.exports = _default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(255);

var globalImageCache = new LRU(50);
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */

function findExistImage(newImageOrSrc) {
  if (typeof newImageOrSrc === 'string') {
    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    return cachedImgObj && cachedImgObj.image;
  } else {
    return newImageOrSrc;
  }
}
/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */


function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
  if (!newImageOrSrc) {
    return image;
  } else if (typeof newImageOrSrc === 'string') {
    // Image should not be loaded repeatly.
    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
      return image;
    } // Only when there is no existent image or existent image src
    // is different, this method is responsible for load.


    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    var pendingWrap = {
      hostEl: hostEl,
      cb: cb,
      cbPayload: cbPayload
    };

    if (cachedImgObj) {
      image = cachedImgObj.image;
      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
    } else {
      image = new Image();
      image.onload = image.onerror = imageOnLoad;
      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
        image: image,
        pending: [pendingWrap]
      });
      image.src = image.__zrImageSrc = newImageOrSrc;
    }

    return image;
  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
  else {
      return newImageOrSrc;
    }
}

function imageOnLoad() {
  var cachedImgObj = this.__cachedImgObj;
  this.onload = this.onerror = this.__cachedImgObj = null;

  for (var i = 0; i < cachedImgObj.pending.length; i++) {
    var pendingWrap = cachedImgObj.pending[i];
    var cb = pendingWrap.cb;
    cb && cb(this, pendingWrap.cbPayload);
    pendingWrap.hostEl.dirty();
  }

  cachedImgObj.pending.length = 0;
}

function isImageReady(image) {
  return image && image.width && image.height;
}

exports.findExistImage = findExistImage;
exports.createOrUpdateImage = createOrUpdateImage;
exports.isImageReady = isImageReady;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Parse shadow style
// TODO Only shallow path support
function _default(properties) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    }

    return style;
  };
}

module.exports = _default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(126);

var zrUtil = __webpack_require__(2);

var textContain = __webpack_require__(75);

var textHelper = __webpack_require__(260);

var _constant = __webpack_require__(125);

var ContextCachedBy = _constant.ContextCachedBy;

/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
var Text = function (opts) {
  // jshint ignore:line
  Displayable.call(this, opts);
};

Text.prototype = {
  constructor: Text,
  type: 'text',
  brush: function (ctx, prevEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.

    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
    var text = style.text; // Convert to string

    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
    // is in textHelper.renderText, and performance of text render should
    // be considered.
    // style.bind(ctx, this, prevEl);

    if (!textHelper.needDrawText(text, style)) {
      // The current el.style is not applied
      // and should not be used as cache.
      ctx.__attrCachedBy = ContextCachedBy.NONE;
      return;
    }

    this.setTransform(ctx);
    textHelper.renderText(this, ctx, text, style, null, prevEl);
    this.restoreTransform(ctx);
  },
  getBoundingRect: function () {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);

    if (!this._rect) {
      var text = style.text;
      text != null ? text += '' : text = '';
      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
      rect.x += style.x || 0;
      rect.y += style.y || 0;

      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
        var w = style.textStrokeWidth;
        rect.x -= w / 2;
        rect.y -= w / 2;
        rect.width += w;
        rect.height += w;
      }

      this._rect = rect;
    }

    return this._rect;
  }
};
zrUtil.inherits(Text, Displayable);
var _default = Text;
module.exports = _default;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * Sub-pixel optimize for canvas rendering, prevent from blur
 * when rendering a thin vertical/horizontal line.
 */
var round = Math.round;
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x1]
 * @param {number} [inputShape.y1]
 * @param {number} [inputShape.x2]
 * @param {number} [inputShape.y2]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */

function subPixelOptimizeLine(outputShape, inputShape, style) {
  if (!inputShape) {
    return;
  }

  var x1 = inputShape.x1;
  var x2 = inputShape.x2;
  var y1 = inputShape.y1;
  var y2 = inputShape.y2;
  outputShape.x1 = x1;
  outputShape.x2 = x2;
  outputShape.y1 = y1;
  outputShape.y2 = y2;
  var lineWidth = style && style.lineWidth;

  if (!lineWidth) {
    return;
  }

  if (round(x1 * 2) === round(x2 * 2)) {
    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
  }

  if (round(y1 * 2) === round(y2 * 2)) {
    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
  }
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} outputShape The modification will be performed on `outputShape`.
 *                 `outputShape` and `inputShape` can be the same object.
 *                 `outputShape` object can be used repeatly, because all of
 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
 * @param {Object} [inputShape]
 * @param {number} [inputShape.x]
 * @param {number} [inputShape.y]
 * @param {number} [inputShape.width]
 * @param {number} [inputShape.height]
 * @param {Object} [style]
 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
 */


function subPixelOptimizeRect(outputShape, inputShape, style) {
  if (!inputShape) {
    return;
  }

  var originX = inputShape.x;
  var originY = inputShape.y;
  var originWidth = inputShape.width;
  var originHeight = inputShape.height;
  outputShape.x = originX;
  outputShape.y = originY;
  outputShape.width = originWidth;
  outputShape.height = originHeight;
  var lineWidth = style && style.lineWidth;

  if (!lineWidth) {
    return;
  }

  outputShape.x = subPixelOptimize(originX, lineWidth, true);
  outputShape.y = subPixelOptimize(originY, lineWidth, true);
  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


function subPixelOptimize(position, lineWidth, positiveOrNegative) {
  if (!lineWidth) {
    return position;
  } // Assure that (position + lineWidth / 2) is near integer edge,
  // otherwise line will be fuzzy in canvas.


  var doubledPosition = round(position * 2);
  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * @param {Array.<Object>} colorStops
 */
var Gradient = function (colorStops) {
  this.colorStops = colorStops || [];
};

Gradient.prototype = {
  constructor: Gradient,
  addColorStop: function (offset, color) {
    this.colorStops.push({
      offset: offset,
      color: color
    });
  }
};
var _default = Gradient;
module.exports = _default;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var coordinateSystemCreators = {};

function CoordinateSystemManager() {
  this._coordinateSystems = [];
}

CoordinateSystemManager.prototype = {
  constructor: CoordinateSystemManager,
  create: function (ecModel, api) {
    var coordinateSystems = [];
    zrUtil.each(coordinateSystemCreators, function (creater, type) {
      var list = creater.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  },
  update: function (ecModel, api) {
    zrUtil.each(this._coordinateSystems, function (coordSys) {
      coordSys.update && coordSys.update(ecModel, api);
    });
  },
  getCoordinateSystems: function () {
    return this._coordinateSystems.slice();
  }
};

CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
  coordinateSystemCreators[type] = coordinateSystemCreator;
};

CoordinateSystemManager.get = function (type) {
  return coordinateSystemCreators[type];
};

var _default = CoordinateSystemManager;
module.exports = _default;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var assert = _util.assert;
var isArray = _util.isArray;

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} define
 * @return See the return of `createTask`.
 */
function createTask(define) {
  return new Task(define);
}
/**
 * @constructor
 * @param {Object} define
 * @param {Function} define.reset Custom reset
 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
 * @param {Function} [define.count] count is used to determin data task.
 * @param {Function} [define.onDirty] count is used to determin data task.
 */


function Task(define) {
  define = define || {};
  this._reset = define.reset;
  this._plan = define.plan;
  this._count = define.count;
  this._onDirty = define.onDirty;
  this._dirty = true; // Context must be specified implicitly, to
  // avoid miss update context when model changed.

  this.context;
}

var taskProto = Task.prototype;
/**
 * @param {Object} performArgs
 * @param {number} [performArgs.step] Specified step.
 * @param {number} [performArgs.skip] Skip customer perform call.
 * @param {number} [performArgs.modBy] Sampling window size.
 * @param {number} [performArgs.modDataCount] Sampling count.
 */

taskProto.perform = function (performArgs) {
  var upTask = this._upstream;
  var skip = performArgs && performArgs.skip; // TODO some refactor.
  // Pull data. Must pull data each time, because context.data
  // may be updated by Series.setData.

  if (this._dirty && upTask) {
    var context = this.context;
    context.data = context.outputData = upTask.context.outputData;
  }

  if (this.__pipeline) {
    this.__pipeline.currentTask = this;
  }

  var planResult;

  if (this._plan && !skip) {
    planResult = this._plan(this.context);
  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
  // elements uniformed distributed when progress, especially when moving or zooming.


  var lastModBy = normalizeModBy(this._modBy);
  var lastModDataCount = this._modDataCount || 0;
  var modBy = normalizeModBy(performArgs && performArgs.modBy);
  var modDataCount = performArgs && performArgs.modDataCount || 0;

  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
    planResult = 'reset';
  }

  function normalizeModBy(val) {
    !(val >= 1) && (val = 1); // jshint ignore:line

    return val;
  }

  var forceFirstProgress;

  if (this._dirty || planResult === 'reset') {
    this._dirty = false;
    forceFirstProgress = reset(this, skip);
  }

  this._modBy = modBy;
  this._modDataCount = modDataCount;
  var step = performArgs && performArgs.step;

  if (upTask) {
    this._dueEnd = upTask._outputDueEnd;
  } // DataTask or overallTask
  else {
      this._dueEnd = this._count ? this._count(this.context) : Infinity;
    } // Note: Stubs, that its host overall task let it has progress, has progress.
  // If no progress, pass index from upstream to downstream each time plan called.


  if (this._progress) {
    var start = this._dueIndex;
    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);

    if (!skip && (forceFirstProgress || start < end)) {
      var progress = this._progress;

      if (isArray(progress)) {
        for (var i = 0; i < progress.length; i++) {
          doProgress(this, progress[i], start, end, modBy, modDataCount);
        }
      } else {
        doProgress(this, progress, start, end, modBy, modDataCount);
      }
    }

    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
    // input data is the same, so use `dueIndex` as `outputDueEnd`.

    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
    this._outputDueEnd = outputDueEnd;
  } else {
    // (1) Some overall task has no progress.
    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
    // This should always be performed so it can be passed to downstream.
    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
  }

  return this.unfinished();
};

var iterator = function () {
  var end;
  var current;
  var modBy;
  var modDataCount;
  var winCount;
  var it = {
    reset: function (s, e, sStep, sCount) {
      current = s;
      end = e;
      modBy = sStep;
      modDataCount = sCount;
      winCount = Math.ceil(modDataCount / modBy);
      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
    }
  };
  return it;

  function sequentialNext() {
    return current < end ? current++ : null;
  }

  function modNext() {
    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
    // Use normal linear rendering mode.
    : current;
    current++;
    return result;
  }
}();

taskProto.dirty = function () {
  this._dirty = true;
  this._onDirty && this._onDirty(this.context);
};

function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
  iterator.reset(start, end, modBy, modDataCount);
  taskIns._callingProgress = progress;

  taskIns._callingProgress({
    start: start,
    end: end,
    count: end - start,
    next: iterator.next
  }, taskIns.context);
}

function reset(taskIns, skip) {
  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
  taskIns._settedOutputEnd = null;
  var progress;
  var forceFirstProgress;

  if (!skip && taskIns._reset) {
    progress = taskIns._reset(taskIns.context);

    if (progress && progress.progress) {
      forceFirstProgress = progress.forceFirstProgress;
      progress = progress.progress;
    } // To simplify no progress checking, array must has item.


    if (isArray(progress) && !progress.length) {
      progress = null;
    }
  }

  taskIns._progress = progress;
  taskIns._modBy = taskIns._modDataCount = null;
  var downstream = taskIns._downstream;
  downstream && downstream.dirty();
  return forceFirstProgress;
}
/**
 * @return {boolean}
 */


taskProto.unfinished = function () {
  return this._progress && this._dueIndex < this._dueEnd;
};
/**
 * @param {Object} downTask The downstream task.
 * @return {Object} The downstream task.
 */


taskProto.pipe = function (downTask) {
  // If already downstream, do not dirty downTask.
  if (this._downstream !== downTask || this._dirty) {
    this._downstream = downTask;
    downTask._upstream = this;
    downTask.dirty();
  }
};

taskProto.dispose = function () {
  if (this._disposed) {
    return;
  }

  this._upstream && (this._upstream._downstream = null);
  this._downstream && (this._downstream._upstream = null);
  this._dirty = false;
  this._disposed = true;
};

taskProto.getUpstream = function () {
  return this._upstream;
};

taskProto.getDownstream = function () {
  return this._downstream;
};

taskProto.setOutputEnd = function (end) {
  // This only happend in dataTask, dataZoom, map, currently.
  // where dataZoom do not set end each time, but only set
  // when reset. So we should record the setted end, in case
  // that the stub of dataZoom perform again and earse the
  // setted end by upstream.
  this._outputDueEnd = this._settedOutputEnd = end;
}; ///////////////////////////////////////////////////////////
// For stream debug (Should be commented out after used!)
// Usage: printTask(this, 'begin');
// Usage: printTask(this, null, {someExtraProp});
// function printTask(task, prefix, extra) {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     var props = [];
//     if (task.__pipeline) {
//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: 'idx', value: val});
//     } else {
//         var stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pid', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     var args = ['color: blue'];
//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: black', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// }


exports.createTask = createTask;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @return {string} If large mode changed, return string 'reset';
 */
function _default() {
  var inner = makeInner();
  return function (seriesModel) {
    var fields = inner(seriesModel);
    var pipelineContext = seriesModel.pipelineContext;
    var originalLarge = fields.large;
    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
    // exists. See #11611 . Probably we need to modify this structure, see the comment
    // on `performRawSeries` in `Schedular.js`.

    var large = fields.large = pipelineContext && pipelineContext.large;
    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
  };
}

module.exports = _default;

/***/ }),
/* 180 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    currCall = new Date().getTime();
    scope = this;
    args = arguments;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
    // than a new call of `cb`, that is, preserving the command order. Consider
    // calculating "scale rate" when roaming as an example. When a call of `cb`
    // happens, either the `exec` is called dierectly, or the call is delayed.
    // But the delayed call should never be later than next call of `cb`. Under
    // this assurance, we can simply update view state each time `dispatchAction`
    // triggered by user roaming, but not need to add extra code to avoid the
    // state being "rolled-back".

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */


function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */


function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

exports.throttle = throttle;
exports.createOrUpdate = createOrUpdate;
exports.clear = clear;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;
var createHashMap = _util.createHashMap;
var assert = _util.assert;

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);

function summarizeDimensions(data) {
  var summary = {};
  var encode = summary.encode = {};
  var notExtraCoordDimMap = createHashMap();
  var defaultedLabel = [];
  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.

  var userOutput = summary.userOutput = {
    dimensionNames: data.dimensions.slice(),
    encode: {}
  };
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var coordDim = dimItem.coordDim;

    if (coordDim) {
      var coordDimIndex = dimItem.coordDimIndex;
      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;

      if (!dimItem.isExtraCoord) {
        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
        // because when dataset is used, it is hard to guess which dimension
        // can be value dimension. If both show x, y on label is not look good,
        // and conventionally y axis is focused more.

        if (mayLabelDimType(dimItem.type)) {
          defaultedLabel[0] = dimName;
        } // User output encode do not contain generated coords.
        // And it only has index. User can use index to retrieve value from the raw item array.


        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
      }

      if (dimItem.defaultTooltip) {
        defaultedTooltip.push(dimName);
      }
    }

    OTHER_DIMENSIONS.each(function (v, otherDim) {
      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
      var dimIndex = dimItem.otherDims[otherDim];

      if (dimIndex != null && dimIndex !== false) {
        encodeArr[dimIndex] = dimItem.name;
      }
    });
  });
  var dataDimsOnCoord = [];
  var encodeFirstDimNotExtra = {};
  notExtraCoordDimMap.each(function (v, coordDim) {
    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
    // But should fix the case that radar axes: simplify the logic
    // of `completeDimension`, remove `extraPrefix`.

    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
    // dim canot on more than one coordDim.

    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
  });
  summary.dataDimsOnCoord = dataDimsOnCoord;
  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
  // in this way. Use label.formatter instead. May be remove this approach someday.

  if (encodeLabel && encodeLabel.length) {
    defaultedLabel = encodeLabel.slice();
  }

  var encodeTooltip = encode.tooltip;

  if (encodeTooltip && encodeTooltip.length) {
    defaultedTooltip = encodeTooltip.slice();
  } else if (!defaultedTooltip.length) {
    defaultedTooltip = defaultedLabel.slice();
  }

  encode.defaultedLabel = defaultedLabel;
  encode.defaultedTooltip = defaultedTooltip;
  return summary;
}

function getOrCreateEncodeArr(encode, dim) {
  if (!encode.hasOwnProperty(dim)) {
    encode[dim] = [];
  }

  return encode[dim];
}

function getDimensionTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}

function mayLabelDimType(dimType) {
  // In most cases, ordinal and time do not suitable for label.
  // Ordinal info can be displayed on axis. Time is too long.
  return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
//     // Get last value dim
//     var dimensions = data.dimensions.slice();
//     var valueType;
//     var valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }


exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
exports.summarizeDimensions = summarizeDimensions;
exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var numberUtil = __webpack_require__(28);

var formatUtil = __webpack_require__(44);

var Scale = __webpack_require__(129);

var helper = __webpack_require__(287);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Interval scale
 * @module echarts/scale/Interval
 */
var roundNumber = numberUtil.round;
/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */

var IntervalScale = Scale.extend({
  type: 'interval',
  _interval: 0,
  _intervalPrecision: 2,
  setExtent: function (start, end) {
    var thisExtent = this._extent; //start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  },
  unionExtent: function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
  },

  /**
   * Get interval
   */
  getInterval: function () {
    return this._interval;
  },

  /**
   * Set interval
   */
  setInterval: function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
    // We assume user wan't to set both interval, min, max to get a better result

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = helper.getIntervalPrecision(interval);
  },

  /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */
  getTicks: function (expandToNicedExtent) {
    var interval = this._interval;
    var extent = this._extent;
    var niceTickExtent = this._niceExtent;
    var intervalPrecision = this._intervalPrecision;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    } // Consider this case: using dataZoom toolbox, zoom and zoom.


    var safeLimit = 10000;

    if (extent[0] < niceTickExtent[0]) {
      if (expandToNicedExtent) {
        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
      } else {
        ticks.push(extent[0]);
      }
    }

    var tick = niceTickExtent[0];

    while (tick <= niceTickExtent[1]) {
      ticks.push(tick); // Avoid rounding error

      tick = roundNumber(tick + interval, intervalPrecision);

      if (tick === ticks[ticks.length - 1]) {
        // Consider out of safe float point, e.g.,
        // -3711126.9907707 + 2e-10 === -3711126.9907707
        break;
      }

      if (ticks.length > safeLimit) {
        return [];
      }
    } // Consider this case: the last item of ticks is smaller
    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];

    if (extent[1] > lastNiceTick) {
      if (expandToNicedExtent) {
        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
      } else {
        ticks.push(extent[1]);
      }
    }

    return ticks;
  },

  /**
   * @param {number} [splitNumber=5]
   * @return {Array.<Array.<number>>}
   */
  getMinorTicks: function (splitNumber) {
    var ticks = this.getTicks(true);
    var minorTicks = [];
    var extent = this.getExtent();

    for (var i = 1; i < ticks.length; i++) {
      var nextTick = ticks[i];
      var prevTick = ticks[i - 1];
      var count = 0;
      var minorTicksGroup = [];
      var interval = nextTick - prevTick;
      var minorInterval = interval / splitNumber;

      while (count < splitNumber - 1) {
        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.

        if (minorTick > extent[0] && minorTick < extent[1]) {
          minorTicksGroup.push(minorTick);
        }

        count++;
      }

      minorTicks.push(minorTicksGroup);
    }

    return minorTicks;
  },

  /**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */
  getLabel: function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = numberUtil.getPrecisionSafe(data) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    data = roundNumber(data, precision, true);
    return formatUtil.addCommas(data);
  },

  /**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */
  niceTicks: function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  },

  /**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        var expandSize = extent[0]; // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  }
});
/**
 * @return {module:echarts/scale/Time}
 */

IntervalScale.create = function () {
  return new IntervalScale();
};

var _default = IntervalScale;
module.exports = _default;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(304);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(133)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(34);
var toIObject = __webpack_require__(35);
var arrayIndexOf = __webpack_require__(105)(false);
var IE_PROTO = __webpack_require__(135)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(66);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(35);
var gOPN = __webpack_require__(69).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(106);
var pIE = __webpack_require__(88);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(87);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(23);
var isObject = __webpack_require__(11);
var invoke = __webpack_require__(191);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(8).parseInt;
var $trim = __webpack_require__(78).trim;
var ws = __webpack_require__(139);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(8).parseFloat;
var $trim = __webpack_require__(78).trim;

module.exports = 1 / $parseFloat(__webpack_require__(139) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(41);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(142);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(23);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(87);
var toLength = __webpack_require__(16);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(16);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(110)
});


/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(157);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(206);
var validate = __webpack_require__(80);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(114)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(15).f;
var create = __webpack_require__(68);
var redefineAll = __webpack_require__(73);
var ctx = __webpack_require__(40);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var $iterDefine = __webpack_require__(145);
var step = __webpack_require__(201);
var setSpecies = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(58).fastKey;
var validate = __webpack_require__(80);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(206);
var validate = __webpack_require__(80);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(114)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(49)(0);
var redefine = __webpack_require__(30);
var meta = __webpack_require__(58);
var assign = __webpack_require__(189);
var weak = __webpack_require__(209);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var validate = __webpack_require__(80);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(114)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(73);
var getWeak = __webpack_require__(58).getWeak;
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var createArrayMethod = __webpack_require__(49);
var $has = __webpack_require__(34);
var validate = __webpack_require__(80);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(69);
var gOPS = __webpack_require__(106);
var anObject = __webpack_require__(6);
var Reflect = __webpack_require__(8).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(107);
var isObject = __webpack_require__(11);
var toLength = __webpack_require__(16);
var ctx = __webpack_require__(40);
var IS_CONCAT_SPREADABLE = __webpack_require__(12)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(16);
var repeat = __webpack_require__(141);
var defined = __webpack_require__(46);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(66);
var toIObject = __webpack_require__(35);
var isEnum = __webpack_require__(88).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(89);
var from = __webpack_require__(216);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(72);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(81);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(221);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(536)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(556);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var settle = __webpack_require__(571);
var buildURL = __webpack_require__(573);
var parseHeaders = __webpack_require__(574);
var isURLSameOrigin = __webpack_require__(575);
var createError = __webpack_require__(227);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(576);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(577);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(572);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vip.f20401bf.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vip_no.6881339c.png";

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(235);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_toast__ = __webpack_require__(53);
var wx=window.wx;var weixinConfig=function weixinConfig(params,callback){var title=params.title,desc=params.desc,link=params.link,imgUrl=params.imgUrl;__WEBPACK_IMPORTED_MODULE_0__api_axios__["a" /* default */].weixinShare({data:{url:window.location.href.split('#')[0]}},function(res,err){if(err){console.log(err);__WEBPACK_IMPORTED_MODULE_1__utils_toast__["a" /* default */].info({text:err.errorMessage,duration:3000});}else{console.log(res);wx.config({debug:false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId:res.appId,// 必填，公众号的唯一标识
timestamp:res.timestamp,// 必填，生成签名的时间戳
nonceStr:res.nonceStr,// 必填，生成签名的随机串
signature:res.signature,// 必填，签名
jsApiList:['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareQZone']// 必填，需要使用的JS接口列表
});wx.ready(function(){wx.onMenuShareTimeline({title:title,// 分享标题
link:link,imgUrl:imgUrl,// 分享图标
success:function success(){console.log('wxShare success!');callback&&callback(3);}});wx.onMenuShareAppMessage({title:title,// 分享标题
desc:desc,// 分享描述
link:link,imgUrl:imgUrl,// 分享图标
success:function success(){console.log('wxShare success!');callback&&callback(2);}});wx.onMenuShareQQ({title:title,// 分享标题
desc:desc,// 分享描述
link:link,imgUrl:imgUrl// 分享图标
});wx.onMenuShareQZone({title:title,// 分享标题
desc:desc,// 分享描述
link:link,imgUrl:imgUrl// 分享图标
});});}});};/* harmony default export */ __webpack_exports__["a"] = (weixinConfig);

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play_apng.fb334c1c.png";

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apng__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Question_less__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Question_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Question_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_play_apng_png__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_play_apng_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_play_apng_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_light_png__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_light_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_light_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Load from '../../template/Load/Load';
var Question=function(_Component){_inherits(Question,_Component);function Question(props){_classCallCheck(this,Question);var _this=_possibleConstructorReturn(this,(Question.__proto__||Object.getPrototypeOf(Question)).call(this,props));_this.componentDidMount=function(){_this.setStep(_this.props.defaultStep);Object(__WEBPACK_IMPORTED_MODULE_4__api_web__["b" /* apiDefine */])({apiName:'evaluateResult',fn:_this.evaluateResult});// 定义接收录音结果方法
Object(__WEBPACK_IMPORTED_MODULE_4__api_web__["b" /* apiDefine */])({apiName:'homeworkPlaybackFinished',fn:_this.homeworkPlaybackFinished});// 定义接收录音播放终止方法
Object(__WEBPACK_IMPORTED_MODULE_4__api_web__["b" /* apiDefine */])({apiName:'storageEvaluatedAudio',fn:_this.storageEvaluatedAudio});// 定义接收录音地址方法
_this.initAudio();};_this.initAudio=function(){if(_this.audioExample){_this.audioExample.onerror=function(){__WEBPACK_IMPORTED_MODULE_3__utils_toast__["a" /* default */].info({text:'音频加载失败, 请重试'});// this.audioExample.load();
};_this.timeOutArr.push(setTimeout(function(){var defaultTime=_this.state.defaultTime;var level0=_this.props.level0;var mod=level0?1.5:1.8;_this.duration=defaultTime;try{_this.duration=_this.audioExample.duration?_this.audioExample.duration*mod+1:defaultTime;}catch(error){console.log(error);}_this.setStep('step1');},500));}};_this.playExample=function(){var _this$state=_this.state,recordStudentStatus=_this$state.recordStudentStatus,recordExampleStatus=_this$state.recordExampleStatus,step=_this$state.step,eventTrackingType=_this$state.eventTrackingType;if(step==='step2'||recordExampleStatus==='playing')return false;__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].homeworkPlayback({play:false});_this.example.play();_this.audioExample.play();__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_Play'});_this.setState({recordExampleStatus:'playing'});if(recordStudentStatus==='playing'&&step!==0){_this.setState({recordStudentStatus:'pause'});}_this.audioExample.onended=function(){_this.example.stop();_this.setState({recordExampleStatus:'pause'});};};_this.playStudent=function(){var _this$state2=_this.state,recordStudentStatus=_this$state2.recordStudentStatus,eventTrackingType=_this$state2.eventTrackingType;if(_this.state.step==='step1'||recordStudentStatus==='playing'||recordStudentStatus==='gray')return false;_this.audioExample.pause();_this.example.stop();__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].homeworkPlayback({play:true});__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_RecordPlay'});_this.setState({recordStudentStatus:'playing',recordExampleStatus:'pause'});};_this.homeworkPlaybackFinished=function(){var step=_this.state.step;if(step==='step1')return false;_this.setState({recordStudentStatus:'pause'});};_this.setStep=function(nextStep){var step=_this.state.step;if(nextStep===step)return false;if(nextStep==='step1'){_this.setState({recordStatus:'active',done:false,recordStudentStatus:'gray'});}if(nextStep==='step2'){_this.setState({recordStatus:'gray'});}if(nextStep==='step3'){_this.setState({recordStudentStatus:'pause',done:true});}if(nextStep==='step4'){_this.setState({recordStudentStatus:'pause'});}_this.setState({step:nextStep});};_this.restart=function(next){var eventTrackingType=_this.state.eventTrackingType;_this.setState({done:false,recordStudentStatus:'gray',recordExampleStatus:'pause',words:[]});var nextStep=next?_this.defaultStep:'step1';_this.setStep(nextStep);__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].homeworkPlayback({play:false});_this.audioExample.load();_this.example.stop();_this.props.restart();!next&&__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_Rerecord'});};_this.nextQuestion=function(){var _this$state3=_this.state,score=_this$state3.score,eventTrackingType=_this$state3.eventTrackingType;var isLast=_this.props.isLast;_this.props.nextQuestion(score);_this.restart(true);if(isLast)__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_Done'});else __WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_Next'});};_this.recordTest=function(e){var _this$state4=_this.state,questionInfo=_this$state4.questionInfo,eventTrackingType=_this$state4.eventTrackingType;var parameters=_this.props.parameters;var type=_this.props.type;_this.setState({hasClick:true,step:'step2',recordStatus:'gray',recordExampleStatus:'pause'});_this.audioExample.pause();_this.example.stop();setTimeout(function(){_this.setState({hasClick:false});},1000);var params={time:Math.ceil(_this.duration),needResult:true,sentence:questionInfo.text,parameters:parameters};if(type==='archery'){params.centerX=1148/_this.countInit;params.centerY=736/_this.countInit;}else{params.centerX=1120/_this.countInit;params.centerY=790/_this.countInit;}_this.protectTimer=setTimeout(function(){var protectRes={result:1.5,total:5};_this.evaluateResult(JSON.stringify(protectRes));},(Math.ceil(_this.duration)+3)*1000);__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].recordTest(params);__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_'+eventTrackingType+'_Record'});};_this.evaluateResult=function(res){clearTimeout(_this.protectTimer);var _this$props=_this.props,level0=_this$props.level0,type=_this$props.type;var _data=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tools__["c" /* decodeParams */])(res);var data={result:_data.result,total:_data.total,words:_data.fullMessage?_data.fullMessage.result.words:[]};var score=Math.round(data.result*20);_this.setState({score:score});if(score<0){return __WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].alertView({content:'\u8BC4\u6D4B\u5F02\u5E38('+Number(score)*-1+')',confirm:'确认',id:'H5_1004'});}if(!level0&&type==='castle'){_this.setState({words:data.words});}_this.timeOutArr.push(setTimeout(function(){_this.props.playResult(score);_this.timeOutArr.push(setTimeout(function(){_this.setStep('step3');},3300));},1000));};_this.storageEvaluatedAudio=function(obj){var onStorageEvaluatedAudio=_this.props.onStorageEvaluatedAudio;var _JSON$parse=JSON.parse(obj),audioUrl=_JSON$parse.audioUrl;console.log('音频地址：',audioUrl);_this.setState({audioUrl:audioUrl});onStorageEvaluatedAudio&&onStorageEvaluatedAudio(audioUrl);};_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.countInit=1600/_this.clientWidth;_this.defaultStep=props.defaultStep;// 传入初始步骤
_this.state={type:props.type,// 关卡类型
defaultTime:props.defaultTime,// 录音评测保护时间
recordStudentStatus:'gray',// 我的录音按钮状态
recordStatus:'gray',// 示例录音按钮状态
questionInfo:props.questionInfo,// 作业信息
eventTrackingType:props.type==='archery'?'Arrow':'Fireworks'};_this.timeOutArr=[];return _this;}_createClass(Question,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(nextProps);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}// 播放示例音频
// 播放当前录制音频
// 客户端录音播放终止
//设置当前步骤 暴露给父组件
//重录
// 发起录音评测
//接收评测结果
// 接收客户端上传地址回调
},{key:'render',value:function render(){var _this2=this;var _state=this.state,done=_state.done,recordStudentStatus=_state.recordStudentStatus,step=_state.step,recordStatus=_state.recordStatus,_state$words=_state.words,words=_state$words===undefined?[]:_state$words,questionInfo=_state.questionInfo;var _props=this.props,type=_props.type,isLast=_props.isLast;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container question '+type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question_pic',style:{backgroundImage:'url('+questionInfo.picture+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'sound pointer example',src:__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_play_apng_png___default.a// rate={2}
,autoPlay:false,onClick:this.playExample,ref:function ref(com){return _this2.example=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sound icons pointer student '+recordStudentStatus,onClick:this.playStudent})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question_text'},words.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:0}},words.map(function(ele,index){if(index!==0){ele.word=''+ele.word;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'words word'+index+' '+(ele.scores.overall<60?'red':ele.scores.overall<80?'nomal':'green'),key:index},ele.word.replace('$dd$','"'));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'word_f'},questionInfo.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'complete_icons_wrap '+(done?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons complete_icons reflash',onClick:function onClick(){_this2.restart(false);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons complete_icons next '+(isLast?'last':''),onClick:this.nextQuestion})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'record_wrap '+(!done?'active':'')},step==='step1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'record_light',src:__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_light_png___default.a,rate:1,autoPlay:true,ref:function ref(com){return _this2.recordLight=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'guide'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons record_btn '+recordStatus,ref:function ref(com){_this2.recordBtn=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'record_btn_hide',onClick:function onClick(){var step=_this2.state.step;if(step!=='step1')return false;_this2.recordTest();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{preload:'auto',ref:function ref(com){_this2.audioExample=com;},src:questionInfo.audio}));}}]);return Question;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__picker_address__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__picker_address__["a"]; });


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(63);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTransitionGroup = __webpack_require__(708);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func
};

var BaseModal = function (_React$Component) {
  _inherits(BaseModal, _React$Component);

  function BaseModal() {
    _classCallCheck(this, BaseModal);

    return _possibleConstructorReturn(this, (BaseModal.__proto__ || Object.getPrototypeOf(BaseModal)).call(this));
  }

  _createClass(BaseModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.refs.modalOverlay && !this.refs.modalOverlay.onclick) {

        // 点击阴影背景时cancel() popup
        this.refs.modalOverlay.onclick = function (e) {
          e.stopPropagation();
          _this2.props.onCancel && _this2.props.onCancel();
        };

        // 点击modal阻止默认行为
        // 原理：react event listener中无法阻止原生事件，所以用原生事件来替代react事件
        this.refs.modal.onclick = function (e) {
          return e.stopPropagation();
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var modal = _react2.default.createElement('span', null);
      if (this.props.visible) {
        modal = _react2.default.createElement(
          'div',
          { className: 'modal-overlay',
            ref: function ref(modalOverlay) {
              _this3.modalOverlay = modalOverlay;
            } },
          _react2.default.createElement(
            'div',
            { className: 'modal', ref: function ref(modal) {
                _this3.modal = modal;
              } },
            this.props.children
          )
        );
      }
      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        { classNames: 'modal-transition', timeout: 240, 'in': true },
        modal
      );
    }
  }]);

  return BaseModal;
}(_react2.default.Component);

BaseModal.propTypes = propTypes;

exports.default = BaseModal;
//# sourceMappingURL=BaseModal.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(96));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(63));

var _reactLifecyclesCompat = __webpack_require__(243);

var _PropTypes = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(96));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(96));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactLifecyclesCompat = __webpack_require__(243);

var _ChildMapping = __webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return {
        children: children
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):t.dayjs=n()}(this,function(){"use strict";var t="millisecond",n="second",e="minute",r="hour",i="day",s="week",u="month",o="quarter",a="year",h=/^(\d{4})-?(\d{1,2})-?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d{1,3})?$/,f=/\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,c=function(t,n,e){var r=String(t);return!r||r.length>=n?t:""+Array(n+1-r.length).join(e)+t},d={s:c,z:function(t){var n=-t.utcOffset(),e=Math.abs(n),r=Math.floor(e/60),i=e%60;return(n<=0?"+":"-")+c(r,2,"0")+":"+c(i,2,"0")},m:function(t,n){var e=12*(n.year()-t.year())+(n.month()-t.month()),r=t.clone().add(e,u),i=n-r<0,s=t.clone().add(e+(i?-1:1),u);return Number(-(e+(n-r)/(i?r-s:s-r))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:a,w:s,d:i,D:"date",h:r,m:e,s:n,ms:t,Q:o}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},$={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},l="en",m={};m[l]=$;var y=function(t){return t instanceof v},M=function(t,n,e){var r;if(!t)return l;if("string"==typeof t)m[t]&&(r=t),n&&(m[t]=n,r=t);else{var i=t.name;m[i]=t,r=i}return e||(l=r),r},g=function(t,n,e){if(y(t))return t.clone();var r=n?"string"==typeof n?{format:n,pl:e}:n:{};return r.date=t,new v(r)},D=d;D.l=M,D.i=y,D.w=function(t,n){return g(t,{locale:n.$L,utc:n.$u,$offset:n.$offset})};var v=function(){function c(t){this.$L=this.$L||M(t.locale,null,!0),this.parse(t)}var d=c.prototype;return d.parse=function(t){this.$d=function(t){var n=t.date,e=t.utc;if(null===n)return new Date(NaN);if(D.u(n))return new Date;if(n instanceof Date)return new Date(n);if("string"==typeof n&&!/Z$/i.test(n)){var r=n.match(h);if(r)return e?new Date(Date.UTC(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)):new Date(r[1],r[2]-1,r[3]||1,r[4]||0,r[5]||0,r[6]||0,r[7]||0)}return new Date(n)}(t),this.init()},d.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},d.$utils=function(){return D},d.isValid=function(){return!("Invalid Date"===this.$d.toString())},d.isSame=function(t,n){var e=g(t);return this.startOf(n)<=e&&e<=this.endOf(n)},d.isAfter=function(t,n){return g(t)<this.startOf(n)},d.isBefore=function(t,n){return this.endOf(n)<g(t)},d.$g=function(t,n,e){return D.u(t)?this[n]:this.set(e,t)},d.year=function(t){return this.$g(t,"$y",a)},d.month=function(t){return this.$g(t,"$M",u)},d.day=function(t){return this.$g(t,"$W",i)},d.date=function(t){return this.$g(t,"$D","date")},d.hour=function(t){return this.$g(t,"$H",r)},d.minute=function(t){return this.$g(t,"$m",e)},d.second=function(t){return this.$g(t,"$s",n)},d.millisecond=function(n){return this.$g(n,"$ms",t)},d.unix=function(){return Math.floor(this.valueOf()/1e3)},d.valueOf=function(){return this.$d.getTime()},d.startOf=function(t,o){var h=this,f=!!D.u(o)||o,c=D.p(t),d=function(t,n){var e=D.w(h.$u?Date.UTC(h.$y,n,t):new Date(h.$y,n,t),h);return f?e:e.endOf(i)},$=function(t,n){return D.w(h.toDate()[t].apply(h.toDate(),(f?[0,0,0,0]:[23,59,59,999]).slice(n)),h)},l=this.$W,m=this.$M,y=this.$D,M="set"+(this.$u?"UTC":"");switch(c){case a:return f?d(1,0):d(31,11);case u:return f?d(1,m):d(0,m+1);case s:var g=this.$locale().weekStart||0,v=(l<g?l+7:l)-g;return d(f?y-v:y+(6-v),m);case i:case"date":return $(M+"Hours",0);case r:return $(M+"Minutes",1);case e:return $(M+"Seconds",2);case n:return $(M+"Milliseconds",3);default:return this.clone()}},d.endOf=function(t){return this.startOf(t,!1)},d.$set=function(s,o){var h,f=D.p(s),c="set"+(this.$u?"UTC":""),d=(h={},h[i]=c+"Date",h.date=c+"Date",h[u]=c+"Month",h[a]=c+"FullYear",h[r]=c+"Hours",h[e]=c+"Minutes",h[n]=c+"Seconds",h[t]=c+"Milliseconds",h)[f],$=f===i?this.$D+(o-this.$W):o;if(f===u||f===a){var l=this.clone().set("date",1);l.$d[d]($),l.init(),this.$d=l.set("date",Math.min(this.$D,l.daysInMonth())).toDate()}else d&&this.$d[d]($);return this.init(),this},d.set=function(t,n){return this.clone().$set(t,n)},d.get=function(t){return this[D.p(t)]()},d.add=function(t,o){var h,f=this;t=Number(t);var c=D.p(o),d=function(n){var e=g(f);return D.w(e.date(e.date()+Math.round(n*t)),f)};if(c===u)return this.set(u,this.$M+t);if(c===a)return this.set(a,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(h={},h[e]=6e4,h[r]=36e5,h[n]=1e3,h)[c]||1,l=this.$d.getTime()+t*$;return D.w(l,this)},d.subtract=function(t,n){return this.add(-1*t,n)},d.format=function(t){var n=this;if(!this.isValid())return"Invalid Date";var e=t||"YYYY-MM-DDTHH:mm:ssZ",r=D.z(this),i=this.$locale(),s=this.$H,u=this.$m,o=this.$M,a=i.weekdays,h=i.months,c=function(t,r,i,s){return t&&(t[r]||t(n,e))||i[r].substr(0,s)},d=function(t){return D.s(s%12||12,t,"0")},$=i.meridiem||function(t,n,e){var r=t<12?"AM":"PM";return e?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:o+1,MM:D.s(o+1,2,"0"),MMM:c(i.monthsShort,o,h,3),MMMM:h[o]||h(this,e),D:this.$D,DD:D.s(this.$D,2,"0"),d:String(this.$W),dd:c(i.weekdaysMin,this.$W,a,2),ddd:c(i.weekdaysShort,this.$W,a,3),dddd:a[this.$W],H:String(s),HH:D.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:D.s(u,2,"0"),s:String(this.$s),ss:D.s(this.$s,2,"0"),SSS:D.s(this.$ms,3,"0"),Z:r};return e.replace(f,function(t,n){return n||l[t]||r.replace(":","")})},d.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},d.diff=function(t,h,f){var c,d=D.p(h),$=g(t),l=6e4*($.utcOffset()-this.utcOffset()),m=this-$,y=D.m(this,$);return y=(c={},c[a]=y/12,c[u]=y,c[o]=y/3,c[s]=(m-l)/6048e5,c[i]=(m-l)/864e5,c[r]=m/36e5,c[e]=m/6e4,c[n]=m/1e3,c)[d]||m,f?y:D.a(y)},d.daysInMonth=function(){return this.endOf(u).$D},d.$locale=function(){return m[this.$L]},d.locale=function(t,n){if(!t)return this.$L;var e=this.clone(),r=M(t,n,!0);return r&&(e.$L=r),e},d.clone=function(){return D.w(this.$d,this)},d.toDate=function(){return new Date(this.valueOf())},d.toJSON=function(){return this.isValid()?this.toISOString():null},d.toISOString=function(){return this.$d.toISOString()},d.toString=function(){return this.$d.toUTCString()},c}();return g.prototype=v.prototype,g.extend=function(t,n){return t(n,v,g),g},g.locale=M,g.isDayjs=y,g.unix=function(t){return g(1e3*t)},g.en=m[l],g.Ls=m,g});


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customerService_less__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customerService_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__customerService_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomerService=function(_Component){_inherits(CustomerService,_Component);function CustomerService(props){_classCallCheck(this,CustomerService);var _this=_possibleConstructorReturn(this,(CustomerService.__proto__||Object.getPrototypeOf(CustomerService)).call(this,props));_this.toCS=function(){var questionId=_this.props.questionId;var csUrl=_this.state.csUrl;var eventData={eventType:'c2_app_My_Help_Consult'};if(questionId){eventData.eventType='c2_app_My_Help_Question_Consult';eventData.questionId=questionId;}__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking(eventData);window.location.href=csUrl;};_this.state={csUrl:"https://www.sobot.com/chat/h5/index.html?sysNum=68243cdfdbc54199a4626e6e77f3b8b3&source=2",csUrlPc:''};return _this;}_createClass(CustomerService,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getCsQrCode({data:{}},function(res,err){if(err)alert(err.errorMessage);else{_this2.setState({csUrlPc:res.csQrCodeUrl});}});}},{key:'render',value:function render(){var isMobile=this.props.isMobile;var csUrlPc=this.state.csUrlPc;if(!isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'customerService pc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:csUrlPc,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u6253\u5F00\u5FAE\u4FE1\u626B\u4E00\u626B\u5173\u6CE8\u516C\u4F17\u53F7\u901A\u8FC7\u201C\u5728\u7EBF\u670D\u52A1\u201D > "\u54A8\u8BE2\u5C0F\u52A9\u624B"'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'customerService mobile',onClick:this.toCS},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u54A8\u8BE2\u5C0F\u52A9\u624B'));}}]);return CustomerService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CustomerService);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(250);

var env = __webpack_require__(25);

var zrUtil = __webpack_require__(2);

var Handler = __webpack_require__(802);

var Storage = __webpack_require__(806);

var Painter = __webpack_require__(810);

var Animation = __webpack_require__(813);

var HandlerProxy = __webpack_require__(814);

/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var useVML = !env.canvasSupported;
var painterCtors = {
  canvas: Painter
};
var instances = {}; // ZRender实例map索引

/**
 * @type {string}
 */

var version = '4.3.0';
/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} [opts]
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */

function init(dom, opts) {
  var zr = new ZRender(guid(), dom, opts);
  instances[zr.id] = zr;
  return zr;
}
/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */


function dispose(zr) {
  if (zr) {
    zr.dispose();
  } else {
    for (var key in instances) {
      if (instances.hasOwnProperty(key)) {
        instances[key].dispose();
      }
    }

    instances = {};
  }

  return this;
}
/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */


function getInstance(id) {
  return instances[id];
}

function registerPainter(name, Ctor) {
  painterCtors[name] = Ctor;
}

function delInstance(id) {
  delete instances[id];
}
/**
 * @module zrender/ZRender
 */

/**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */


var ZRender = function (id, dom, opts) {
  opts = opts || {};
  /**
   * @type {HTMLDomElement}
   */

  this.dom = dom;
  /**
   * @type {string}
   */

  this.id = id;
  var self = this;
  var storage = new Storage();
  var rendererType = opts.renderer; // TODO WebGL

  if (useVML) {
    if (!painterCtors.vml) {
      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
    }

    rendererType = 'vml';
  } else if (!rendererType || !painterCtors[rendererType]) {
    rendererType = 'canvas';
  }

  var painter = new painterCtors[rendererType](dom, storage, opts, id);
  this.storage = storage;
  this.painter = painter;
  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
  this.handler = new Handler(storage, painter, handerProxy, painter.root);
  /**
   * @type {module:zrender/animation/Animation}
   */

  this.animation = new Animation({
    stage: {
      update: zrUtil.bind(this.flush, this)
    }
  });
  this.animation.start();
  /**
   * @type {boolean}
   * @private
   */

  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
  // FIXME 有点ugly

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);
    el && el.removeSelfFromZr(self);
  };

  storage.addToStorage = function (el) {
    oldAddToStorage.call(storage, el);
    el.addSelfToZr(self);
  };
};

ZRender.prototype = {
  constructor: ZRender,

  /**
   * 获取实例唯一标识
   * @return {string}
   */
  getId: function () {
    return this.id;
  },

  /**
   * 添加元素
   * @param  {module:zrender/Element} el
   */
  add: function (el) {
    this.storage.addRoot(el);
    this._needsRefresh = true;
  },

  /**
   * 删除元素
   * @param  {module:zrender/Element} el
   */
  remove: function (el) {
    this.storage.delRoot(el);
    this._needsRefresh = true;
  },

  /**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */
  configLayer: function (zLevel, config) {
    if (this.painter.configLayer) {
      this.painter.configLayer(zLevel, config);
    }

    this._needsRefresh = true;
  },

  /**
   * Set background color
   * @param {string} backgroundColor
   */
  setBackgroundColor: function (backgroundColor) {
    if (this.painter.setBackgroundColor) {
      this.painter.setBackgroundColor(backgroundColor);
    }

    this._needsRefresh = true;
  },

  /**
   * Repaint the canvas immediately
   */
  refreshImmediately: function () {
    // var start = new Date();
    // Clear needsRefresh ahead to avoid something wrong happens in refresh
    // Or it will cause zrender refreshes again and again.
    this._needsRefresh = this._needsRefreshHover = false;
    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook

    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
    // var log = document.getElementById('log');
    // if (log) {
    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
    // }
  },

  /**
   * Mark and repaint the canvas in the next frame of browser
   */
  refresh: function () {
    this._needsRefresh = true;
  },

  /**
   * Perform all refresh
   */
  flush: function () {
    var triggerRendered;

    if (this._needsRefresh) {
      triggerRendered = true;
      this.refreshImmediately();
    }

    if (this._needsRefreshHover) {
      triggerRendered = true;
      this.refreshHoverImmediately();
    }

    triggerRendered && this.trigger('rendered');
  },

  /**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */
  addHover: function (el, style) {
    if (this.painter.addHover) {
      var elMirror = this.painter.addHover(el, style);
      this.refreshHover();
      return elMirror;
    }
  },

  /**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */
  removeHover: function (el) {
    if (this.painter.removeHover) {
      this.painter.removeHover(el);
      this.refreshHover();
    }
  },

  /**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */
  clearHover: function () {
    if (this.painter.clearHover) {
      this.painter.clearHover();
      this.refreshHover();
    }
  },

  /**
   * Refresh hover in next frame
   */
  refreshHover: function () {
    this._needsRefreshHover = true;
  },

  /**
   * Refresh hover immediately
   */
  refreshHoverImmediately: function () {
    this._needsRefreshHover = false;
    this.painter.refreshHover && this.painter.refreshHover();
  },

  /**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */
  resize: function (opts) {
    opts = opts || {};
    this.painter.resize(opts.width, opts.height);
    this.handler.resize();
  },

  /**
   * Stop and clear all animation immediately
   */
  clearAnimation: function () {
    this.animation.clear();
  },

  /**
   * Get container width
   */
  getWidth: function () {
    return this.painter.getWidth();
  },

  /**
   * Get container height
   */
  getHeight: function () {
    return this.painter.getHeight();
  },

  /**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */
  // toDataURL: function(type, backgroundColor) {
  //     return this.painter.getRenderedCanvas({
  //         backgroundColor: backgroundColor
  //     }).toDataURL(type);
  // },

  /**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */
  pathToImage: function (e, dpr) {
    return this.painter.pathToImage(e, dpr);
  },

  /**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    this.handler.setCursorStyle(cursorStyle);
  },

  /**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */
  findHover: function (x, y) {
    return this.handler.findHover(x, y);
  },

  /**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */
  on: function (eventName, eventHandler, context) {
    this.handler.on(eventName, eventHandler, context);
  },

  /**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */
  off: function (eventName, eventHandler) {
    this.handler.off(eventName, eventHandler);
  },

  /**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */
  trigger: function (eventName, event) {
    this.handler.trigger(eventName, event);
  },

  /**
   * Clear all objects and the canvas.
   */
  clear: function () {
    this.storage.delRoot();
    this.painter.clear();
  },

  /**
   * Dispose self.
   */
  dispose: function () {
    this.animation.stop();
    this.clear();
    this.storage.dispose();
    this.painter.dispose();
    this.handler.dispose();
    this.animation = this.storage = this.painter = this.handler = null;
    delInstance(this.id);
  }
};
exports.version = version;
exports.init = init;
exports.dispose = dispose;
exports.getInstance = getInstance;
exports.registerPainter = registerPainter;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */
var idStart = 0x0907;

function _default() {
  return idStart++;
}

module.exports = _default;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(25);

var _fourPointsTransform = __webpack_require__(804);

var buildTransformer = _fourPointsTransform.buildTransformer;
var EVENT_SAVED_PROP = '___zrEVENTSAVED';
var _calcOut = [];
/**
 * Transform "local coord" from `elFrom` to `elTarget`.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support when CSS transform is used.
 *
 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
 * to locate the element.
 *
 * For example, this code below positions a child of `document.body` on the event
 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
 * ```js
 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
 * if (!eqNaN(out[0])) {
 *     // Then locate the tip element on the event point.
 *     var tipEl = document.createElement('div');
 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
 *     document.body.appendChild(tipEl);
 * }
 * ```
 *
 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output..
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
 * @param {HTMLElement} elTarget The `out` is based on elTarget.
 * @param {number} inX
 * @param {number} inY
 * @return {boolean} Whether transform successfully.
 */

function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
}
/**
 * Transform between a "viewport coord" and a "local coord".
 * "viewport coord": the coord based on the left-top corner of the viewport
 *     of the browser.
 * "local coord": the coord based on the input `el`. The origin point is at
 *     the position of "left: 0; top: 0;" in the `el`.
 *
 * Support the case when CSS transform is used on el.
 *
 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
 *        it represents "local coord", otherwise "vireport coord".
 *        If can not transform, `out` will not be modified but return `false`.
 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
 * @param {number} inX If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {number} inY If `inverse: false`,
 *        it represents "vireport coord", otherwise "local coord".
 * @param {boolean} [inverse=false]
 *        `true`: from "viewport coord" to "local coord".
 *        `false`: from "local coord" to "viewport coord".
 * @return {boolean} Whether transform successfully.
 */


function transformCoordWithViewport(out, el, inX, inY, inverse) {
  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
    var markers = prepareCoordMarkers(el, saved);
    var transformer = preparePointerTransformer(markers, saved, inverse);

    if (transformer) {
      transformer(out, inX, inY);
      return true;
    }
  }

  return false;
}

function prepareCoordMarkers(el, saved) {
  var markers = saved.markers;

  if (markers) {
    return markers;
  }

  markers = saved.markers = [];
  var propLR = ['left', 'right'];
  var propTB = ['top', 'bottom'];

  for (var i = 0; i < 4; i++) {
    var marker = document.createElement('div');
    var stl = marker.style;
    var idxLR = i % 2;
    var idxTB = (i >> 1) % 2;
    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
    // 'height: 5px',
    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
    el.appendChild(marker);
    markers.push(marker);
  }

  return markers;
}

function preparePointerTransformer(markers, saved, inverse) {
  var transformerName = inverse ? 'invTrans' : 'trans';
  var transformer = saved[transformerName];
  var oldSrcCoords = saved.srcCoords;
  var oldCoordTheSame = true;
  var srcCoords = [];
  var destCoords = [];

  for (var i = 0; i < 4; i++) {
    var rect = markers[i].getBoundingClientRect();
    var ii = 2 * i;
    var x = rect.left;
    var y = rect.top;
    srcCoords.push(x, y);
    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
  } // Cache to avoid time consuming of `buildTransformer`.


  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
}

function isCanvasEl(el) {
  return el.nodeName.toUpperCase() === 'CANVAS';
}

exports.transformLocalCoord = transformLocalCoord;
exports.transformCoordWithViewport = transformCoordWithViewport;
exports.isCanvasEl = isCanvasEl;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(250);

var Eventful = __webpack_require__(97);

var Transformable = __webpack_require__(253);

var Animatable = __webpack_require__(807);

var zrUtil = __webpack_require__(2);

/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */
var Element = function (opts) {
  // jshint ignore:line
  Transformable.call(this, opts);
  Eventful.call(this, opts);
  Animatable.call(this, opts);
  /**
   * 画布元素ID
   * @type {string}
   */

  this.id = opts.id || guid();
};

Element.prototype = {
  /**
   * 元素类型
   * Element type
   * @type {string}
   */
  type: 'element',

  /**
   * 元素名字
   * Element name
   * @type {string}
   */
  name: '',

  /**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */
  __zr: null,

  /**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */
  ignore: false,

  /**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */
  clipPath: null,

  /**
   * 是否是 Group
   * @type {boolean}
   */
  isGroup: false,

  /**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */
  drift: function (dx, dy) {
    switch (this.draggable) {
      case 'horizontal':
        dy = 0;
        break;

      case 'vertical':
        dx = 0;
        break;
    }

    var m = this.transform;

    if (!m) {
      m = this.transform = [1, 0, 0, 1, 0, 0];
    }

    m[4] += dx;
    m[5] += dy;
    this.decomposeTransform();
    this.dirty(false);
  },

  /**
   * Hook before update
   */
  beforeUpdate: function () {},

  /**
   * Hook after update
   */
  afterUpdate: function () {},

  /**
   * Update each frame
   */
  update: function () {
    this.updateTransform();
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {},

  /**
   * @protected
   */
  attrKV: function (key, value) {
    if (key === 'position' || key === 'scale' || key === 'origin') {
      // Copy the array
      if (value) {
        var target = this[key];

        if (!target) {
          target = this[key] = [];
        }

        target[0] = value[0];
        target[1] = value[1];
      }
    } else {
      this[key] = value;
    }
  },

  /**
   * Hide the element
   */
  hide: function () {
    this.ignore = true;
    this.__zr && this.__zr.refresh();
  },

  /**
   * Show the element
   */
  show: function () {
    this.ignore = false;
    this.__zr && this.__zr.refresh();
  },

  /**
   * @param {string|Object} key
   * @param {*} value
   */
  attr: function (key, value) {
    if (typeof key === 'string') {
      this.attrKV(key, value);
    } else if (zrUtil.isObject(key)) {
      for (var name in key) {
        if (key.hasOwnProperty(name)) {
          this.attrKV(name, key[name]);
        }
      }
    }

    this.dirty(false);
    return this;
  },

  /**
   * @param {module:zrender/graphic/Path} clipPath
   */
  setClipPath: function (clipPath) {
    var zr = this.__zr;

    if (zr) {
      clipPath.addSelfToZr(zr);
    } // Remove previous clip path


    if (this.clipPath && this.clipPath !== clipPath) {
      this.removeClipPath();
    }

    this.clipPath = clipPath;
    clipPath.__zr = zr;
    clipPath.__clipTarget = this;
    this.dirty(false);
  },

  /**
   */
  removeClipPath: function () {
    var clipPath = this.clipPath;

    if (clipPath) {
      if (clipPath.__zr) {
        clipPath.removeSelfFromZr(clipPath.__zr);
      }

      clipPath.__zr = null;
      clipPath.__clipTarget = null;
      this.clipPath = null;
      this.dirty(false);
    }
  },

  /**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  addSelfToZr: function (zr) {
    this.__zr = zr; // 添加动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.addAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.addSelfToZr(zr);
    }
  },

  /**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  removeSelfFromZr: function (zr) {
    this.__zr = null; // 移除动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.removeAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.removeSelfFromZr(zr);
    }
  }
};
zrUtil.mixin(Element, Animatable);
zrUtil.mixin(Element, Transformable);
zrUtil.mixin(Element, Eventful);
var _default = Element;
module.exports = _default;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var matrix = __webpack_require__(74);

var vector = __webpack_require__(26);

/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */
var mIdentity = matrix.identity;
var EPSILON = 5e-5;

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */


var Transformable = function (opts) {
  opts = opts || {}; // If there are no given position, rotation, scale

  if (!opts.position) {
    /**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */
    this.position = [0, 0];
  }

  if (opts.rotation == null) {
    /**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */
    this.rotation = 0;
  }

  if (!opts.scale) {
    /**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */
    this.scale = [1, 1];
  }
  /**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */


  this.origin = this.origin || null;
};

var transformableProto = Transformable.prototype;
transformableProto.transform = null;
/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */

transformableProto.needLocalTransform = function () {
  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
};

var scaleTmp = [];

transformableProto.updateTransform = function () {
  var parent = this.parent;
  var parentHasTransform = parent && parent.transform;
  var needLocalTransform = this.needLocalTransform();
  var m = this.transform;

  if (!(needLocalTransform || parentHasTransform)) {
    m && mIdentity(m);
    return;
  }

  m = m || matrix.create();

  if (needLocalTransform) {
    this.getLocalTransform(m);
  } else {
    mIdentity(m);
  } // 应用父节点变换


  if (parentHasTransform) {
    if (needLocalTransform) {
      matrix.mul(m, parent.transform, m);
    } else {
      matrix.copy(m, parent.transform);
    }
  } // 保存这个变换矩阵


  this.transform = m;
  var globalScaleRatio = this.globalScaleRatio;

  if (globalScaleRatio != null && globalScaleRatio !== 1) {
    this.getGlobalScale(scaleTmp);
    var relX = scaleTmp[0] < 0 ? -1 : 1;
    var relY = scaleTmp[1] < 0 ? -1 : 1;
    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
    m[0] *= sx;
    m[1] *= sx;
    m[2] *= sy;
    m[3] *= sy;
  }

  this.invTransform = this.invTransform || matrix.create();
  matrix.invert(this.invTransform, m);
};

transformableProto.getLocalTransform = function (m) {
  return Transformable.getLocalTransform(this, m);
};
/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */


transformableProto.setTransform = function (ctx) {
  var m = this.transform;
  var dpr = ctx.dpr || 1;

  if (m) {
    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
  } else {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
};

transformableProto.restoreTransform = function (ctx) {
  var dpr = ctx.dpr || 1;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};

var tmpTransform = [];
var originTransform = matrix.create();

transformableProto.setLocalTransform = function (m) {
  if (!m) {
    // TODO return or set identity?
    return;
  }

  var sx = m[0] * m[0] + m[1] * m[1];
  var sy = m[2] * m[2] + m[3] * m[3];
  var position = this.position;
  var scale = this.scale;

  if (isNotAroundZero(sx - 1)) {
    sx = Math.sqrt(sx);
  }

  if (isNotAroundZero(sy - 1)) {
    sy = Math.sqrt(sy);
  }

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  position[0] = m[4];
  position[1] = m[5];
  scale[0] = sx;
  scale[1] = sy;
  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
};
/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */


transformableProto.decomposeTransform = function () {
  if (!this.transform) {
    return;
  }

  var parent = this.parent;
  var m = this.transform;

  if (parent && parent.transform) {
    // Get local transform and decompose them to position, scale, rotation
    matrix.mul(tmpTransform, parent.invTransform, m);
    m = tmpTransform;
  }

  var origin = this.origin;

  if (origin && (origin[0] || origin[1])) {
    originTransform[4] = origin[0];
    originTransform[5] = origin[1];
    matrix.mul(tmpTransform, m, originTransform);
    tmpTransform[4] -= origin[0];
    tmpTransform[5] -= origin[1];
    m = tmpTransform;
  }

  this.setLocalTransform(m);
};
/**
 * Get global scale
 * @return {Array.<number>}
 */


transformableProto.getGlobalScale = function (out) {
  var m = this.transform;
  out = out || [];

  if (!m) {
    out[0] = 1;
    out[1] = 1;
    return out;
  }

  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);

  if (m[0] < 0) {
    out[0] = -out[0];
  }

  if (m[3] < 0) {
    out[1] = -out[1];
  }

  return out;
};
/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToLocal = function (x, y) {
  var v2 = [x, y];
  var invTransform = this.invTransform;

  if (invTransform) {
    vector.applyTransform(v2, v2, invTransform);
  }

  return v2;
};
/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToGlobal = function (x, y) {
  var v2 = [x, y];
  var transform = this.transform;

  if (transform) {
    vector.applyTransform(v2, v2, transform);
  }

  return v2;
};
/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */


Transformable.getLocalTransform = function (target, m) {
  m = m || [];
  mIdentity(m);
  var origin = target.origin;
  var scale = target.scale || [1, 1];
  var rotation = target.rotation || 0;
  var position = target.position || [0, 0];

  if (origin) {
    // Translate to origin
    m[4] -= origin[0];
    m[5] -= origin[1];
  }

  matrix.scale(m, m, scale);

  if (rotation) {
    matrix.rotate(m, m, rotation);
  }

  if (origin) {
    // Translate back from origin
    m[4] += origin[0];
    m[5] += origin[1];
  }

  m[4] += position[0];
  m[5] += position[1];
  return m;
};

var _default = Transformable;
module.exports = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Clip = __webpack_require__(808);

var color = __webpack_require__(99);

var _util = __webpack_require__(2);

var isArrayLike = _util.isArrayLike;

/**
 * @module echarts/animation/Animator
 */
var arraySlice = Array.prototype.slice;

function defaultGetter(target, key) {
  return target[key];
}

function defaultSetter(target, key, value) {
  target[key] = value;
}
/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */


function interpolateNumber(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */


function interpolateString(p0, p1, percent) {
  return percent > 0.5 ? p1 : p0;
}
/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */


function interpolateArray(p0, p1, percent, out, arrDim) {
  var len = p0.length;

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
  } else {
    var len2 = len && p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
      }
    }
  }
} // arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1


function fillArr(arr0, arr1, arrDim) {
  var arr0Len = arr0.length;
  var arr1Len = arr1.length;

  if (arr0Len !== arr1Len) {
    // FIXME Not work for TypedArray
    var isPreviousLarger = arr0Len > arr1Len;

    if (isPreviousLarger) {
      // Cut the previous
      arr0.length = arr1Len;
    } else {
      // Fill the previous
      for (var i = arr0Len; i < arr1Len; i++) {
        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
      }
    }
  } // Handling NaN value


  var len2 = arr0[0] && arr0[0].length;

  for (var i = 0; i < arr0.length; i++) {
    if (arrDim === 1) {
      if (isNaN(arr0[i])) {
        arr0[i] = arr1[i];
      }
    } else {
      for (var j = 0; j < len2; j++) {
        if (isNaN(arr0[i][j])) {
          arr0[i][j] = arr1[i][j];
        }
      }
    }
  }
}
/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */


function isArraySame(arr0, arr1, arrDim) {
  if (arr0 === arr1) {
    return true;
  }

  var len = arr0.length;

  if (len !== arr1.length) {
    return false;
  }

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      if (arr0[i] !== arr1[i]) {
        return false;
      }
    }
  } else {
    var len2 = arr0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        if (arr0[i][j] !== arr1[i][j]) {
          return false;
        }
      }
    }
  }

  return true;
}
/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */


function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
  var len = p0.length;

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
  } else {
    var len2 = p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
      }
    }
  }
}
/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */


function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}

function cloneValue(value) {
  if (isArrayLike(value)) {
    var len = value.length;

    if (isArrayLike(value[0])) {
      var ret = [];

      for (var i = 0; i < len; i++) {
        ret.push(arraySlice.call(value[i]));
      }

      return ret;
    }

    return arraySlice.call(value);
  }

  return value;
}

function rgba2String(rgba) {
  rgba[0] = Math.floor(rgba[0]);
  rgba[1] = Math.floor(rgba[1]);
  rgba[2] = Math.floor(rgba[2]);
  return 'rgba(' + rgba.join(',') + ')';
}

function getArrayDim(keyframes) {
  var lastValue = keyframes[keyframes.length - 1].value;
  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
}

function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
  var getter = animator._getter;
  var setter = animator._setter;
  var useSpline = easing === 'spline';
  var trackLen = keyframes.length;

  if (!trackLen) {
    return;
  } // Guess data type


  var firstVal = keyframes[0].value;
  var isValueArray = isArrayLike(firstVal);
  var isValueColor = false;
  var isValueString = false; // For vertices morphing

  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
  var trackMaxTime; // Sort keyframe as ascending

  keyframes.sort(function (a, b) {
    return a.time - b.time;
  });
  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe

  var kfPercents = []; // Value of each keyframe

  var kfValues = [];
  var prevValue = keyframes[0].value;
  var isAllValueEqual = true;

  for (var i = 0; i < trackLen; i++) {
    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string

    var value = keyframes[i].value; // Check if value is equal, deep check if value is array

    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
      isAllValueEqual = false;
    }

    prevValue = value; // Try converting a string to a color array

    if (typeof value === 'string') {
      var colorArray = color.parse(value);

      if (colorArray) {
        value = colorArray;
        isValueColor = true;
      } else {
        isValueString = true;
      }
    }

    kfValues.push(value);
  }

  if (!forceAnimate && isAllValueEqual) {
    return;
  }

  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value

  for (var i = 0; i < trackLen - 1; i++) {
    if (isValueArray) {
      fillArr(kfValues[i], lastValue, arrDim);
    } else {
      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
        kfValues[i] = lastValue;
      }
    }
  }

  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
  // animation playback is sequency

  var lastFrame = 0;
  var lastFramePercent = 0;
  var start;
  var w;
  var p0;
  var p1;
  var p2;
  var p3;

  if (isValueColor) {
    var rgba = [0, 0, 0, 0];
  }

  var onframe = function (target, percent) {
    // Find the range keyframes
    // kf1-----kf2---------current--------kf3
    // find kf2 and kf3 and do interpolation
    var frame; // In the easing function like elasticOut, percent may less than 0

    if (percent < 0) {
      frame = 0;
    } else if (percent < lastFramePercent) {
      // Start from next key
      // PENDING start from lastFrame ?
      start = Math.min(lastFrame + 1, trackLen - 1);

      for (frame = start; frame >= 0; frame--) {
        if (kfPercents[frame] <= percent) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, trackLen - 2);
    } else {
      for (frame = lastFrame; frame < trackLen; frame++) {
        if (kfPercents[frame] > percent) {
          break;
        }
      }

      frame = Math.min(frame - 1, trackLen - 2);
    }

    lastFrame = frame;
    lastFramePercent = percent;
    var range = kfPercents[frame + 1] - kfPercents[frame];

    if (range === 0) {
      return;
    } else {
      w = (percent - kfPercents[frame]) / range;
    }

    if (useSpline) {
      p1 = kfValues[frame];
      p0 = kfValues[frame === 0 ? frame : frame - 1];
      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];

      if (isValueArray) {
        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(p1, p2, w);
        } else {
          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
        }

        setter(target, propName, value);
      }
    } else {
      if (isValueArray) {
        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
        } else {
          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
        }

        setter(target, propName, value);
      }
    }
  };

  var clip = new Clip({
    target: animator._target,
    life: trackMaxTime,
    loop: animator._loop,
    delay: animator._delay,
    onframe: onframe,
    ondestroy: oneTrackDone
  });

  if (easing && easing !== 'spline') {
    clip.easing = easing;
  }

  return clip;
}
/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */


var Animator = function (target, loop, getter, setter) {
  this._tracks = {};
  this._target = target;
  this._loop = loop || false;
  this._getter = getter || defaultGetter;
  this._setter = setter || defaultSetter;
  this._clipCount = 0;
  this._delay = 0;
  this._doneList = [];
  this._onframeList = [];
  this._clipList = [];
};

Animator.prototype = {
  /**
   * Set Animation keyframe
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */
  when: function (time
  /* ms */
  , props) {
    var tracks = this._tracks;

    for (var propName in props) {
      if (!props.hasOwnProperty(propName)) {
        continue;
      }

      if (!tracks[propName]) {
        tracks[propName] = []; // Invalid value

        var value = this._getter(this._target, propName);

        if (value == null) {
          // zrLog('Invalid property ' + propName);
          continue;
        } // If time is 0
        //  Then props is given initialize value
        // Else
        //  Initialize value from current prop value


        if (time !== 0) {
          tracks[propName].push({
            time: 0,
            value: cloneValue(value)
          });
        }
      }

      tracks[propName].push({
        time: time,
        value: props[propName]
      });
    }

    return this;
  },

  /**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */
  during: function (callback) {
    this._onframeList.push(callback);

    return this;
  },
  pause: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].pause();
    }

    this._paused = true;
  },
  resume: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].resume();
    }

    this._paused = false;
  },
  isPaused: function () {
    return !!this._paused;
  },
  _doneCallback: function () {
    // Clear all tracks
    this._tracks = {}; // Clear all clips

    this._clipList.length = 0;
    var doneList = this._doneList;
    var len = doneList.length;

    for (var i = 0; i < len; i++) {
      doneList[i].call(this);
    }
  },

  /**
   * Start the animation
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */
  start: function (easing, forceAnimate) {
    var self = this;
    var clipCount = 0;

    var oneTrackDone = function () {
      clipCount--;

      if (!clipCount) {
        self._doneCallback();
      }
    };

    var lastClip;

    for (var propName in this._tracks) {
      if (!this._tracks.hasOwnProperty(propName)) {
        continue;
      }

      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);

      if (clip) {
        this._clipList.push(clip);

        clipCount++; // If start after added to animation

        if (this.animation) {
          this.animation.addClip(clip);
        }

        lastClip = clip;
      }
    } // Add during callback on the last clip


    if (lastClip) {
      var oldOnFrame = lastClip.onframe;

      lastClip.onframe = function (target, percent) {
        oldOnFrame(target, percent);

        for (var i = 0; i < self._onframeList.length; i++) {
          self._onframeList[i](target, percent);
        }
      };
    } // This optimization will help the case that in the upper application
    // the view may be refreshed frequently, where animation will be
    // called repeatly but nothing changed.


    if (!clipCount) {
      this._doneCallback();
    }

    return this;
  },

  /**
   * Stop animation
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stop: function (forwardToLast) {
    var clipList = this._clipList;
    var animation = this.animation;

    for (var i = 0; i < clipList.length; i++) {
      var clip = clipList[i];

      if (forwardToLast) {
        // Move to last frame before stop
        clip.onframe(this._target, 1);
      }

      animation && animation.removeClip(clip);
    }

    clipList.length = 0;
  },

  /**
   * Set when animation delay starts
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */
  delay: function (time) {
    this._delay = time;
    return this;
  },

  /**
   * Add callback for animation end
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */
  done: function (cb) {
    if (cb) {
      this._doneList.push(cb);
    }

    return this;
  },

  /**
   * @return {Array.<module:zrender/animation/Clip>}
   */
  getClips: function () {
    return this._clipList;
  }
};
var _default = Animator;
module.exports = _default;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// Simple LRU cache use doubly linked list
// @module zrender/core/LRU

/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */
var LinkedList = function () {
  /**
   * @type {module:zrender/core/LRU~Entry}
   */
  this.head = null;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.tail = null;
  this._len = 0;
};

var linkedListProto = LinkedList.prototype;
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */

linkedListProto.insert = function (val) {
  var entry = new Entry(val);
  this.insertEntry(entry);
  return entry;
};
/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.insertEntry = function (entry) {
  if (!this.head) {
    this.head = this.tail = entry;
  } else {
    this.tail.next = entry;
    entry.prev = this.tail;
    entry.next = null;
    this.tail = entry;
  }

  this._len++;
};
/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.remove = function (entry) {
  var prev = entry.prev;
  var next = entry.next;

  if (prev) {
    prev.next = next;
  } else {
    // Is head
    this.head = next;
  }

  if (next) {
    next.prev = prev;
  } else {
    // Is tail
    this.tail = prev;
  }

  entry.next = entry.prev = null;
  this._len--;
};
/**
 * @return {number}
 */


linkedListProto.len = function () {
  return this._len;
};
/**
 * Clear list
 */


linkedListProto.clear = function () {
  this.head = this.tail = null;
  this._len = 0;
};
/**
 * @constructor
 * @param {} val
 */


var Entry = function (val) {
  /**
   * @type {}
   */
  this.value = val;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.next;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.prev;
};
/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */


var LRU = function (maxSize) {
  this._list = new LinkedList();
  this._map = {};
  this._maxSize = maxSize || 10;
  this._lastRemovedEntry = null;
};

var LRUProto = LRU.prototype;
/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */

LRUProto.put = function (key, value) {
  var list = this._list;
  var map = this._map;
  var removed = null;

  if (map[key] == null) {
    var len = list.len(); // Reuse last removed entry

    var entry = this._lastRemovedEntry;

    if (len >= this._maxSize && len > 0) {
      // Remove the least recently used
      var leastUsedEntry = list.head;
      list.remove(leastUsedEntry);
      delete map[leastUsedEntry.key];
      removed = leastUsedEntry.value;
      this._lastRemovedEntry = leastUsedEntry;
    }

    if (entry) {
      entry.value = value;
    } else {
      entry = new Entry(value);
    }

    entry.key = key;
    list.insertEntry(entry);
    map[key] = entry;
  }

  return removed;
};
/**
 * @param  {string} key
 * @return {}
 */


LRUProto.get = function (key) {
  var entry = this._map[key];
  var list = this._list;

  if (entry != null) {
    // Put the latest used entry in the tail
    if (entry !== list.tail) {
      list.remove(entry);
      list.insertEntry(entry);
    }

    return entry.value;
  }
};
/**
 * Clear the cache
 */


LRUProto.clear = function () {
  this._list.clear();

  this._map = {};
};

var _default = LRU;
module.exports = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(124);

var debugMode = _config.debugMode;

var logError = function () {};

if (debugMode === 1) {
  logError = console.error;
}

var _default = logError;
module.exports = _default;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

var SHADOW_PROPS = {
  'shadowBlur': 1,
  'shadowOffsetX': 1,
  'shadowOffsetY': 1,
  'textShadowBlur': 1,
  'textShadowOffsetX': 1,
  'textShadowOffsetY': 1,
  'textBoxShadowBlur': 1,
  'textBoxShadowOffsetX': 1,
  'textBoxShadowOffsetY': 1
};

function _default(ctx, propName, value) {
  if (SHADOW_PROPS.hasOwnProperty(propName)) {
    return value *= ctx.dpr;
  }

  return value;
}

module.exports = _default;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

var Pattern = function (image, repeat) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {image: ...}`, where this constructor will not be called.
  this.image = image;
  this.repeat = repeat; // Can be cloned

  this.type = 'pattern';
};

Pattern.prototype.getCanvasPattern = function (ctx) {
  return ctx.createPattern(this.image, this.repeat || 'repeat');
};

var _default = Pattern;
module.exports = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
  setTimeout(func, 16);
};

module.exports = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(2);

var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var each = _util.each;
var normalizeCssArray = _util.normalizeCssArray;
var isString = _util.isString;
var isObject = _util.isObject;

var textContain = __webpack_require__(75);

var roundRectHelper = __webpack_require__(261);

var imageHelper = __webpack_require__(172);

var fixShadow = __webpack_require__(257);

var _constant = __webpack_require__(125);

var ContextCachedBy = _constant.ContextCachedBy;
var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.

var VALID_TEXT_ALIGN = {
  left: 1,
  right: 1,
  center: 1
};
var VALID_TEXT_VERTICAL_ALIGN = {
  top: 1,
  bottom: 1,
  middle: 1
}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
// the default value of shadowColor is `'transparent'`.

var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
var _tmpTextPositionResult = {};
var _tmpBoxPositionResult = {};
/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */

function normalizeTextStyle(style) {
  normalizeStyle(style);
  each(style.rich, normalizeStyle);
  return style;
}

function normalizeStyle(style) {
  if (style) {
    style.font = textContain.makeFont(style);
    var textAlign = style.textAlign;
    textAlign === 'middle' && (textAlign = 'center');
    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.

    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
    var textPadding = style.textPadding;

    if (textPadding) {
      style.textPadding = normalizeCssArray(style.textPadding);
    }
  }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
 */


function renderText(hostEl, ctx, text, style, rect, prevEl) {
  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
} // Avoid setting to ctx according to prevEl if possible for
// performance in scenarios of large amount text.


function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
  'use strict';

  var needDrawBg = needDrawBackground(style);
  var prevStyle;
  var checkCache = false;
  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.

  if (prevEl !== WILL_BE_RESTORED) {
    if (prevEl) {
      prevStyle = prevEl.style;
      checkCache = !needDrawBg && cachedByMe && prevStyle;
    } // Prevent from using cache in `Style::bind`, because of the case:
    // ctx property is modified by other properties than `Style::bind`
    // used, and Style::bind is called next.


    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
  } // Since this will be restored, prevent from using these props to check cache in the next
  // entering of this method. But do not need to clear other cache like `Style::bind`.
  else if (cachedByMe) {
      ctx.__attrCachedBy = ContextCachedBy.NONE;
    }

  var styleFont = style.font || DEFAULT_FONT; // PENDING
  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
  // we can make font cache on ctx, which can cache for text el that are discontinuous.
  // But layer save/restore needed to be considered.
  // if (styleFont !== ctx.__fontCache) {
  //     ctx.font = styleFont;
  //     if (prevEl !== WILL_BE_RESTORED) {
  //         ctx.__fontCache = styleFont;
  //     }
  // }

  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
    ctx.font = styleFont;
  } // Use the final font from context-2d, because the final
  // font might not be the style.font when it is illegal.
  // But get `ctx.font` might be time consuming.


  var computedFont = hostEl.__computedFont;

  if (hostEl.__styleFont !== styleFont) {
    hostEl.__styleFont = styleFont;
    computedFont = hostEl.__computedFont = ctx.font;
  }

  var textPadding = style.textPadding;
  var textLineHeight = style.textLineHeight;
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirtyText) {
    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
  }

  var outerHeight = contentBlock.outerHeight;
  var textLines = contentBlock.lines;
  var lineHeight = contentBlock.lineHeight;
  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign || 'left';
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var textX = baseX;
  var textY = boxY;

  if (needDrawBg || textPadding) {
    // Consider performance, do not call getTextWidth util necessary.
    var textWidth = textContain.getWidth(text, computedFont);
    var outerWidth = textWidth;
    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

    if (textPadding) {
      textX = getTextXForPadding(baseX, textAlign, textPadding);
      textY += textPadding[0];
    }
  } // Always set textAlign and textBase line, because it is difficute to calculate
  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
  // font set happened.


  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  ctx.textBaseline = 'middle'; // Set text opacity

  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.

  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
    var styleProp = propItem[0];
    var ctxProp = propItem[1];
    var val = style[styleProp];

    if (!checkCache || val !== prevStyle[styleProp]) {
      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
    }
  } // `textBaseline` is set as 'middle'.


  textY += lineHeight / 2;
  var textStrokeWidth = style.textStrokeWidth;
  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
  var textStroke = getStroke(style.textStroke, textStrokeWidth);
  var textFill = getFill(style.textFill);

  if (textStroke) {
    if (strokeWidthChanged) {
      ctx.lineWidth = textStrokeWidth;
    }

    if (strokeChanged) {
      ctx.strokeStyle = textStroke;
    }
  }

  if (textFill) {
    if (!checkCache || style.textFill !== prevStyle.textFill) {
      ctx.fillStyle = textFill;
    }
  } // Optimize simply, in most cases only one line exists.


  if (textLines.length === 1) {
    // Fill after stroke so the outline will not cover the main part.
    textStroke && ctx.strokeText(textLines[0], textX, textY);
    textFill && ctx.fillText(textLines[0], textX, textY);
  } else {
    for (var i = 0; i < textLines.length; i++) {
      // Fill after stroke so the outline will not cover the main part.
      textStroke && ctx.strokeText(textLines[i], textX, textY);
      textFill && ctx.fillText(textLines[i], textX, textY);
      textY += lineHeight;
    }
  }
}

function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
  // Do not do cache for rich text because of the complexity.
  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
  if (prevEl !== WILL_BE_RESTORED) {
    ctx.__attrCachedBy = ContextCachedBy.NONE;
  }

  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirtyText) {
    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
  }

  drawRichText(hostEl, ctx, contentBlock, style, rect);
}

function drawRichText(hostEl, ctx, contentBlock, style, rect) {
  var contentWidth = contentBlock.width;
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var textPadding = style.textPadding;
  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var xLeft = boxX;
  var lineTop = boxY;

  if (textPadding) {
    xLeft += textPadding[3];
    lineTop += textPadding[0];
  }

  var xRight = xLeft + contentWidth;
  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

  for (var i = 0; i < contentBlock.lines.length; i++) {
    var line = contentBlock.lines[i];
    var tokens = line.tokens;
    var tokenCount = tokens.length;
    var lineHeight = line.lineHeight;
    var usedWidth = line.width;
    var leftIndex = 0;
    var lineXLeft = xLeft;
    var lineXRight = xRight;
    var rightIndex = tokenCount - 1;
    var token;

    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
      usedWidth -= token.width;
      lineXLeft += token.width;
      leftIndex++;
    }

    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
      usedWidth -= token.width;
      lineXRight -= token.width;
      rightIndex--;
    } // The other tokens are placed as textAlign 'center' if there is enough space.


    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;

    while (leftIndex <= rightIndex) {
      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.

      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
      lineXLeft += token.width;
      leftIndex++;
    }

    lineTop += lineHeight;
  }
}

function applyTextRotation(ctx, style, rect, x, y) {
  // textRotation only apply in RectText.
  if (rect && style.textRotation) {
    var origin = style.textOrigin;

    if (origin === 'center') {
      x = rect.width / 2 + rect.x;
      y = rect.height / 2 + rect.y;
    } else if (origin) {
      x = origin[0] + rect.x;
      y = origin[1] + rect.y;
    }

    ctx.translate(x, y); // Positive: anticlockwise

    ctx.rotate(-style.textRotation);
    ctx.translate(-x, -y);
  }
}

function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
  var tokenStyle = style.rich[token.styleName] || {};
  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
  // the bias of "Microsoft YaHei".

  var textVerticalAlign = token.textVerticalAlign;
  var y = lineTop + lineHeight / 2;

  if (textVerticalAlign === 'top') {
    y = lineTop + token.height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y = lineTop + lineHeight - token.height / 2;
  }

  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
  var textPadding = token.textPadding;

  if (textPadding) {
    x = getTextXForPadding(x, textAlign, textPadding);
    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
  }

  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle');
  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
  var textFill = getFill(tokenStyle.textFill || style.textFill);
  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
    ctx.strokeText(token.text, x, y);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
    ctx.fillText(token.text, x, y);
  }
}

function needDrawBackground(style) {
  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
// shape: {x, y, width, height}


function drawBackground(hostEl, ctx, style, x, y, width, height) {
  var textBackgroundColor = style.textBackgroundColor;
  var textBorderWidth = style.textBorderWidth;
  var textBorderColor = style.textBorderColor;
  var isPlainBg = isString(textBackgroundColor);
  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);

  if (isPlainBg || textBorderWidth && textBorderColor) {
    ctx.beginPath();
    var textBorderRadius = style.textBorderRadius;

    if (!textBorderRadius) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, {
        x: x,
        y: y,
        width: width,
        height: height,
        r: textBorderRadius
      });
    }

    ctx.closePath();
  }

  if (isPlainBg) {
    setCtx(ctx, 'fillStyle', textBackgroundColor);

    if (style.fillOpacity != null) {
      var originalGlobalAlpha = ctx.globalAlpha;
      ctx.globalAlpha = style.fillOpacity * style.opacity;
      ctx.fill();
      ctx.globalAlpha = originalGlobalAlpha;
    } else {
      ctx.fill();
    }
  } else if (isObject(textBackgroundColor)) {
    var image = textBackgroundColor.image;
    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);

    if (image && imageHelper.isImageReady(image)) {
      ctx.drawImage(image, x, y, width, height);
    }
  }

  if (textBorderWidth && textBorderColor) {
    setCtx(ctx, 'lineWidth', textBorderWidth);
    setCtx(ctx, 'strokeStyle', textBorderColor);

    if (style.strokeOpacity != null) {
      var originalGlobalAlpha = ctx.globalAlpha;
      ctx.globalAlpha = style.strokeOpacity * style.opacity;
      ctx.stroke();
      ctx.globalAlpha = originalGlobalAlpha;
    } else {
      ctx.stroke();
    }
  }
}

function onBgImageLoaded(image, textBackgroundColor) {
  // Replace image, so that `contain/text.js#parseRichText`
  // will get correct result in next tick.
  textBackgroundColor.image = image;
}

function getBoxPosition(out, hostEl, style, rect) {
  var baseX = style.x || 0;
  var baseY = style.y || 0;
  var textAlign = style.textAlign;
  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord

  if (rect) {
    var textPosition = style.textPosition;

    if (textPosition instanceof Array) {
      // Percent
      baseX = rect.x + parsePercent(textPosition[0], rect.width);
      baseY = rect.y + parsePercent(textPosition[1], rect.height);
    } else {
      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
      baseX = res.x;
      baseY = res.y; // Default align and baseline when has textPosition

      textAlign = textAlign || res.textAlign;
      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
    } // textOffset is only support in RectText, otherwise
    // we have to adjust boundingRect for textOffset.


    var textOffset = style.textOffset;

    if (textOffset) {
      baseX += textOffset[0];
      baseY += textOffset[1];
    }
  }

  out = out || {};
  out.baseX = baseX;
  out.baseY = baseY;
  out.textAlign = textAlign;
  out.textVerticalAlign = textVerticalAlign;
  return out;
}

function setCtx(ctx, prop, value) {
  ctx[prop] = fixShadow(ctx, prop, value);
  return ctx[prop];
}
/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */


function getStroke(stroke, lineWidth) {
  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
  : stroke.image || stroke.colorStops ? '#000' : stroke;
}

function getFill(fill) {
  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
  : fill.image || fill.colorStops ? '#000' : fill;
}

function parsePercent(value, maxValue) {
  if (typeof value === 'string') {
    if (value.lastIndexOf('%') >= 0) {
      return parseFloat(value) / 100 * maxValue;
    }

    return parseFloat(value);
  }

  return value;
}

function getTextXForPadding(x, textAlign, textPadding) {
  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */


function needDrawText(text, style) {
  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
}

exports.normalizeTextStyle = normalizeTextStyle;
exports.renderText = renderText;
exports.getBoxPosition = getBoxPosition;
exports.getStroke = getStroke;
exports.getFill = getFill;
exports.parsePercent = parsePercent;
exports.needDrawText = needDrawText;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * @param {Object} ctx
 * @param {Object} shape
 * @param {number} shape.x
 * @param {number} shape.y
 * @param {number} shape.width
 * @param {number} shape.height
 * @param {number} shape.r
 */
function buildPath(ctx, shape) {
  var x = shape.x;
  var y = shape.y;
  var width = shape.width;
  var height = shape.height;
  var r = shape.r;
  var r1;
  var r2;
  var r3;
  var r4; // Convert width and height to positive for better borderRadius

  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }

  if (typeof r === 'number') {
    r1 = r2 = r3 = r4 = r;
  } else if (r instanceof Array) {
    if (r.length === 1) {
      r1 = r2 = r3 = r4 = r[0];
    } else if (r.length === 2) {
      r1 = r3 = r[0];
      r2 = r4 = r[1];
    } else if (r.length === 3) {
      r1 = r[0];
      r2 = r4 = r[1];
      r3 = r[2];
    } else {
      r1 = r[0];
      r2 = r[1];
      r3 = r[2];
      r4 = r[3];
    }
  } else {
    r1 = r2 = r3 = r4 = 0;
  }

  var total;

  if (r1 + r2 > width) {
    total = r1 + r2;
    r1 *= width / total;
    r2 *= width / total;
  }

  if (r3 + r4 > width) {
    total = r3 + r4;
    r3 *= width / total;
    r4 *= width / total;
  }

  if (r2 + r3 > height) {
    total = r2 + r3;
    r2 *= height / total;
    r3 *= height / total;
  }

  if (r1 + r4 > height) {
    total = r1 + r4;
    r1 *= height / total;
    r4 *= height / total;
  }

  ctx.moveTo(x + r1, y);
  ctx.lineTo(x + width - r2, y);
  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
  ctx.lineTo(x + width, y + height - r3);
  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
  ctx.lineTo(x + r4, y + height);
  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
  ctx.lineTo(x, y + r1);
  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

exports.buildPath = buildPath;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(2);

var each = _util.each;
var filter = _util.filter;
var map = _util.map;
var isArray = _util.isArray;
var indexOf = _util.indexOf;
var isObject = _util.isObject;
var isString = _util.isString;
var createHashMap = _util.createHashMap;
var assert = _util.assert;
var clone = _util.clone;
var merge = _util.merge;
var extend = _util.extend;
var mixin = _util.mixin;

var modelUtil = __webpack_require__(13);

var Model = __webpack_require__(55);

var ComponentModel = __webpack_require__(56);

var globalDefault = __webpack_require__(835);

var colorPaletteMixin = __webpack_require__(275);

var _sourceHelper = __webpack_require__(100);

var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 */

/**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */
var OPTION_INNER_KEY = '\0_ec_inner';
/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */

var GlobalModel = Model.extend({
  init: function (option, parentModel, theme, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    /**
     * @type {module:echarts/model/Model}
     * @private
     */

    this._theme = new Model(theme);
    /**
     * @type {module:echarts/model/OptionManager}
     */

    this._optionManager = optionManager;
  },
  setOption: function (option, optionPreprocessorFuncs) {
    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');

    this._optionManager.setOption(option, optionPreprocessorFuncs);

    this.resetOption(null);
  },

  /**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */
  resetOption: function (type) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (!this.option || type === 'recreate') {
        initBase.call(this, baseOption);
      } else {
        this.restoreData();
        this.mergeOption(baseOption);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    }

    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);
      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this, this._api);

      if (mediaOptions.length) {
        each(mediaOptions, function (mediaOption) {
          this.mergeOption(mediaOption, optionChanged = true);
        }, this);
      }
    }

    return optionChanged;
  },

  /**
   * @protected
   */
  mergeOption: function (newOption) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var newCptTypes = [];
    resetSourceDefaulter(this); // If no component class, merge directly.
    // For example: color, animaiton options, etc.

    each(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!ComponentModel.hasClass(mainType)) {
        // globalSettingTask.dirty();
        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
      } else if (mainType) {
        newCptTypes.push(mainType);
      }
    });
    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);

    function visitComponent(mainType, dependencies) {
      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.

      each(mapResult, function (item, index) {
        var opt = item.option;

        if (isObject(opt)) {
          item.keyInfo.mainType = mainType;
          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
        }
      });
      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
      option[mainType] = [];
      componentsMap.set(mainType, []);
      each(mapResult, function (resultItem, index) {
        var componentModel = resultItem.exist;
        var newCptOption = resultItem.option;
        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
        // see removeEdgeAndAdd in topologicalTravel and
        // ComponentModel.getAllClassMainTypes.

        if (!newCptOption) {
          componentModel.mergeOption({}, this);
          componentModel.optionUpdated({}, false);
        } else {
          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);

          if (componentModel && componentModel.constructor === ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();

            componentModel.mergeOption(newCptOption, this);
            componentModel.optionUpdated(newCptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = extend({
              dependentModels: dependentModels,
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
            extend(componentModel, extraOpt);
            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
            // newCptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        componentsMap.get(mainType)[index] = componentModel;
        option[mainType][index] = componentModel.option;
      }, this); // Backup series for filtering.

      if (mainType === 'series') {
        createSeriesIndices(this, componentsMap.get('series'));
      }
    }

    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
  },

  /**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */
  getOption: function () {
    var option = clone(this.option);
    each(option, function (opts, mainType) {
      if (ComponentModel.hasClass(mainType)) {
        var opts = modelUtil.normalizeToArray(opts);

        for (var i = opts.length - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (modelUtil.isIdInner(opts[i])) {
            opts.splice(i, 1);
          }
        }

        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getTheme: function () {
    return this._theme;
  },

  /**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */
  getComponent: function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      return list[idx || 0];
    }
  },

  /**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */
  queryComponents: function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cpts = this._componentsMap.get(mainType);

    if (!cpts || !cpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      if (!isArray(index)) {
        index = [index];
      }

      result = filter(map(index, function (idx) {
        return cpts[idx];
      }), function (val) {
        return !!val;
      });
    } else if (id != null) {
      var isIdArray = isArray(id);
      result = filter(cpts, function (cpt) {
        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
      });
    } else if (name != null) {
      var isNameArray = isArray(name);
      result = filter(cpts, function (cpt) {
        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
      });
    } else {
      // Return all components with mainType
      result = cpts.slice();
    }

    return filterBySubType(result, condition);
  },

  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */
  findComponents: function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? filter(res, condition.filter) : res;
    }
  },

  /**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */
  eachComponent: function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (typeof mainType === 'function') {
      context = cb;
      cb = mainType;
      componentsMap.each(function (components, componentType) {
        each(components, function (component, index) {
          cb.call(context, componentType, component, index);
        });
      });
    } else if (isString(mainType)) {
      each(componentsMap.get(mainType), cb, context);
    } else if (isObject(mainType)) {
      var queryResult = this.findComponents(mainType);
      each(queryResult, cb, context);
    }
  },

  /**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByName: function (name) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.name === name;
    });
  },

  /**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */
  getSeriesByIndex: function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  },

  /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   *
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByType: function (subType) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.subType === subType;
    });
  },

  /**
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeries: function () {
    return this._componentsMap.get('series').slice();
  },

  /**
   * @return {number}
   */
  getSeriesCount: function () {
    return this._componentsMap.get('series').length;
  },

  /**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachSeries: function (cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  },

  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeries: function (cb, context) {
    each(this._componentsMap.get('series'), cb, context);
  },

  /**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @param {string} subType.
   * @param {Function} cb
   * @param {*} context
   */
  eachSeriesByType: function (subType, cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  },

  /**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeriesByType: function (subType, cb, context) {
    return each(this.getSeriesByType(subType), cb, context);
  },

  /**
   * @param {module:echarts/model/Series} seriesModel
   */
  isSeriesFiltered: function (seriesModel) {
    assertSeriesInitialized(this);
    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
  },

  /**
   * @return {Array.<number>}
   */
  getCurrentSeriesIndices: function () {
    return (this._seriesIndices || []).slice();
  },

  /**
   * @param {Function} cb
   * @param {*} context
   */
  filterSeries: function (cb, context) {
    assertSeriesInitialized(this);
    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
    createSeriesIndices(this, filteredSeries);
  },
  restoreData: function (payload) {
    var componentsMap = this._componentsMap;
    createSeriesIndices(this, componentsMap.get('series'));
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      componentTypes.push(componentType);
    });
    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
      each(componentsMap.get(componentType), function (component) {
        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
      });
    });
  }
});

function isNotTargetSeries(seriesModel, payload) {
  if (payload) {
    var index = payload.seiresIndex;
    var id = payload.seriesId;
    var name = payload.seriesName;
    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
  }
}
/**
 * @inner
 */


function mergeTheme(option, theme) {
  // PENDING
  // NOT use `colorLayer` in theme if option has `color`
  var notMergeColorLayer = option.color && !option.colorLayer;
  each(theme, function (themeItem, name) {
    if (name === 'colorLayer' && notMergeColorLayer) {
      return;
    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理


    if (!ComponentModel.hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function initBase(baseOption) {
  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.

  this.option = {};
  this.option[OPTION_INNER_KEY] = 1;
  /**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */

  this._componentsMap = createHashMap({
    series: []
  });
  /**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */

  this._seriesIndices;
  this._seriesIndicesMap;
  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property

  merge(baseOption, globalDefault, false);
  this.mergeOption(baseOption);
}
/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */


function getComponentsByTypes(componentsMap, types) {
  if (!isArray(types)) {
    types = types ? [types] : [];
  }

  var ret = {};
  each(types, function (type) {
    ret[type] = (componentsMap.get(type) || []).slice();
  });
  return ret;
}
/**
 * @inner
 */


function determineSubType(mainType, newCptOption, existComponent) {
  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * @inner
 */


function createSeriesIndices(ecModel, seriesModels) {
  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
    return series.componentIndex;
  }) || []);
}
/**
 * @inner
 */


function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
    return cpt.subType === condition.subType;
  }) : components;
}
/**
 * @inner
 */


function assertSeriesInitialized(ecModel) {}

mixin(GlobalModel, colorPaletteMixin);
var _default = GlobalModel;
module.exports = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var PathProxy = __webpack_require__(127);

var transformPath = __webpack_require__(823);

// command chars
// var cc = [
//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
// ];
var mathSqrt = Math.sqrt;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;

var vMag = function (v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};

var vRatio = function (u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
};

var vAngle = function (u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
};

function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
  var psi = psiDeg * (PI / 180.0);
  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);

  if (lambda > 1) {
    rx *= mathSqrt(lambda);
    ry *= mathSqrt(lambda);
  }

  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
  var cxp = f * rx * yp / ry;
  var cyp = f * -ry * xp / rx;
  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
  var dTheta = vAngle(u, v);

  if (vRatio(u, v) <= -1) {
    dTheta = PI;
  }

  if (vRatio(u, v) >= 1) {
    dTheta = 0;
  }

  if (fs === 0 && dTheta > 0) {
    dTheta = dTheta - 2 * PI;
  }

  if (fs === 1 && dTheta < 0) {
    dTheta = dTheta + 2 * PI;
  }

  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}

var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
// (1) delimiter can be comma or space, where continuous commas
// or spaces should be seen as one comma.
// (2) value can be like:
// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
// 'l-.5E1,54', '121-23-44-11' (no delimiter)

var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;

function createPathProxyFromString(data) {
  if (!data) {
    return new PathProxy();
  } // var data = data.replace(/-/g, ' -')
  //     .replace(/  /g, ' ')
  //     .replace(/ /g, ',')
  //     .replace(/,,/g, ',');
  // var n;
  // create pipes so that we can split the data
  // for (n = 0; n < cc.length; n++) {
  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
  // }
  // data = data.replace(/-/g, ',-');
  // create array
  // var arr = cs.split('|');
  // init context point


  var cpx = 0;
  var cpy = 0;
  var subpathX = cpx;
  var subpathY = cpy;
  var prevCmd;
  var path = new PathProxy();
  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
  // var cmdResult;
  // while ((cmdResult = commandReg.exec(data)) != null) {
  //     var cmdStr = cmdResult[1];
  //     var cmdContent = cmdResult[2];

  var cmdList = data.match(commandReg);

  for (var l = 0; l < cmdList.length; l++) {
    var cmdText = cmdList[l];
    var cmdStr = cmdText.charAt(0);
    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
    // var p = cmdContent.split(valueSplitReg);
    // var pLen = 0;
    // for (var i = 0; i < p.length; i++) {
    //     // '' and other invalid str => NaN
    //     var val = parseFloat(p[i]);
    //     !isNaN(val) && (p[pLen++] = val);
    // }

    var p = cmdText.match(numberReg) || [];
    var pLen = p.length;

    for (var i = 0; i < pLen; i++) {
      p[i] = parseFloat(p[i]);
    }

    var off = 0;

    while (off < pLen) {
      var ctlPtx;
      var ctlPty;
      var rx;
      var ry;
      var psi;
      var fa;
      var fs;
      var x1 = cpx;
      var y1 = cpy; // convert l, H, h, V, and v to L

      switch (cmdStr) {
        case 'l':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'L':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'm':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          subpathX = cpx;
          subpathY = cpy;
          cmdStr = 'l';
          break;

        case 'M':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          subpathX = cpx;
          subpathY = cpy;
          cmdStr = 'L';
          break;

        case 'h':
          cpx += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'H':
          cpx = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'v':
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'V':
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'C':
          cmd = CMD.C;
          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
          cpx = p[off - 2];
          cpy = p[off - 1];
          break;

        case 'c':
          cmd = CMD.C;
          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
          cpx += p[off - 2];
          cpy += p[off - 1];
          break;

        case 'S':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 's':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = cpx + p[off++];
          y1 = cpy + p[off++];
          cpx += p[off++];
          cpy += p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 'Q':
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'q':
          x1 = p[off++] + cpx;
          y1 = p[off++] + cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'T':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 't':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 'A':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;

        case 'a':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;
      }
    }

    if (cmdStr === 'z' || cmdStr === 'Z') {
      cmd = CMD.Z;
      path.addData(cmd); // z may be in the middle of the path.

      cpx = subpathX;
      cpy = subpathY;
    }

    prevCmd = cmd;
  }

  path.toStatic();
  return path;
} // TODO Optimize double memory cost problem


function createPathOptions(str, opts) {
  var pathProxy = createPathProxyFromString(str);
  opts = opts || {};

  opts.buildPath = function (path) {
    if (path.setData) {
      path.setData(pathProxy.data); // Svg and vml renderer don't have context

      var ctx = path.getContext();

      if (ctx) {
        path.rebuildPath(ctx);
      }
    } else {
      var ctx = path;
      pathProxy.rebuildPath(ctx);
    }
  };

  opts.applyTransform = function (m) {
    transformPath(pathProxy, m);
    this.dirty(true);
  };

  return opts;
}
/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */


function createFromString(str, opts) {
  return new Path(createPathOptions(str, opts));
}
/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */


function extendFromString(str, opts) {
  return Path.extend(createPathOptions(str, opts));
}
/**
 * Merge multiple paths
 */
// TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem


function mergePath(pathEls, opts) {
  var pathList = [];
  var len = pathEls.length;

  for (var i = 0; i < len; i++) {
    var pathEl = pathEls[i];

    if (!pathEl.path) {
      pathEl.createPathProxy();
    }

    if (pathEl.__dirtyPath) {
      pathEl.buildPath(pathEl.path, pathEl.shape, true);
    }

    pathList.push(pathEl.path);
  }

  var pathBundle = new Path(opts); // Need path proxy.

  pathBundle.createPathProxy();

  pathBundle.buildPath = function (path) {
    path.appendPath(pathList); // Svg and vml renderer don't have context

    var ctx = path.getContext();

    if (ctx) {
      path.rebuildPath(ctx);
    }
  };

  return pathBundle;
}

exports.createFromString = createFromString;
exports.extendFromString = extendFromString;
exports.mergePath = mergePath;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(26);

var curve = __webpack_require__(84);

/**
 * @author Yi Shen(https://github.com/pissang)
 */
var mathMin = Math.min;
var mathMax = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start = vec2.create();
var end = vec2.create();
var extremity = vec2.create();
/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */

function fromPoints(points, min, max) {
  if (points.length === 0) {
    return;
  }

  var p = points[0];
  var left = p[0];
  var right = p[0];
  var top = p[1];
  var bottom = p[1];
  var i;

  for (i = 1; i < points.length; i++) {
    p = points[i];
    left = mathMin(left, p[0]);
    right = mathMax(right, p[0]);
    top = mathMin(top, p[1]);
    bottom = mathMax(bottom, p[1]);
  }

  min[0] = left;
  min[1] = top;
  max[0] = right;
  max[1] = bottom;
}
/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromLine(x0, y0, x1, y1, min, max) {
  min[0] = mathMin(x0, x1);
  min[1] = mathMin(y0, y1);
  max[0] = mathMax(x0, x1);
  max[1] = mathMax(y0, y1);
}

var xDim = [];
var yDim = [];
/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */

function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
  var cubicExtrema = curve.cubicExtrema;
  var cubicAt = curve.cubicAt;
  var i;
  var n = cubicExtrema(x0, x1, x2, x3, xDim);
  min[0] = Infinity;
  min[1] = Infinity;
  max[0] = -Infinity;
  max[1] = -Infinity;

  for (i = 0; i < n; i++) {
    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
    min[0] = mathMin(x, min[0]);
    max[0] = mathMax(x, max[0]);
  }

  n = cubicExtrema(y0, y1, y2, y3, yDim);

  for (i = 0; i < n; i++) {
    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
    min[1] = mathMin(y, min[1]);
    max[1] = mathMax(y, max[1]);
  }

  min[0] = mathMin(x0, min[0]);
  max[0] = mathMax(x0, max[0]);
  min[0] = mathMin(x3, min[0]);
  max[0] = mathMax(x3, max[0]);
  min[1] = mathMin(y0, min[1]);
  max[1] = mathMax(y0, max[1]);
  min[1] = mathMin(y3, min[1]);
  max[1] = mathMax(y3, max[1]);
}
/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
  var quadraticExtremum = curve.quadraticExtremum;
  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero

  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
  var x = quadraticAt(x0, x1, x2, tx);
  var y = quadraticAt(y0, y1, y2, ty);
  min[0] = mathMin(x0, x2, x);
  min[1] = mathMin(y0, y2, y);
  max[0] = mathMax(x0, x2, x);
  max[1] = mathMax(y0, y2, y);
}
/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
  var vec2Min = vec2.min;
  var vec2Max = vec2.max;
  var diff = Math.abs(startAngle - endAngle);

  if (diff % PI2 < 1e-4 && diff > 1e-4) {
    // Is a circle
    min[0] = x - rx;
    min[1] = y - ry;
    max[0] = x + rx;
    max[1] = y + ry;
    return;
  }

  start[0] = mathCos(startAngle) * rx + x;
  start[1] = mathSin(startAngle) * ry + y;
  end[0] = mathCos(endAngle) * rx + x;
  end[1] = mathSin(endAngle) * ry + y;
  vec2Min(min, start, end);
  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]

  startAngle = startAngle % PI2;

  if (startAngle < 0) {
    startAngle = startAngle + PI2;
  }

  endAngle = endAngle % PI2;

  if (endAngle < 0) {
    endAngle = endAngle + PI2;
  }

  if (startAngle > endAngle && !anticlockwise) {
    endAngle += PI2;
  } else if (startAngle < endAngle && anticlockwise) {
    startAngle += PI2;
  }

  if (anticlockwise) {
    var tmp = endAngle;
    endAngle = startAngle;
    startAngle = tmp;
  } // var number = 0;
  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;


  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
    if (angle > startAngle) {
      extremity[0] = mathCos(angle) * rx + x;
      extremity[1] = mathSin(angle) * ry + y;
      vec2Min(min, extremity, min);
      vec2Max(max, extremity, max);
    }
  }
}

exports.fromPoints = fromPoints;
exports.fromLine = fromLine;
exports.fromCubic = fromCubic;
exports.fromQuadratic = fromQuadratic;
exports.fromArc = fromArc;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

var PI2 = Math.PI * 2;

function normalizeRadian(angle) {
  angle %= PI2;

  if (angle < 0) {
    angle += PI2;
  }

  return angle;
}

exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 266 */
/***/ (function(module, exports) {

function windingLine(x0, y0, x1, y1, x, y) {
  if (y > y0 && y > y1 || y < y0 && y < y1) {
    return 0;
  } // Ignore horizontal line


  if (y1 === y0) {
    return 0;
  }

  var dir = y1 < y0 ? 1 : -1;
  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon

  if (t === 1 || t === 0) {
    dir = y1 < y0 ? 0.5 : -0.5;
  }

  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".

  return x_ === x ? Infinity : x_ > x ? dir : 0;
}

module.exports = windingLine;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

/**
 * 圆形
 * @module zrender/shape/Circle
 */
var _default = Path.extend({
  type: 'circle',
  shape: {
    cx: 0,
    cy: 0,
    r: 0
  },
  buildPath: function (ctx, shape, inBundle) {
    // Better stroking in ShapeBundle
    // Always do it may have performence issue ( fill may be 2x more cost)
    if (inBundle) {
      ctx.moveTo(shape.cx + shape.r, shape.cy);
    } // else {
    //     if (ctx.allocate && !ctx.data.length) {
    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
    //     }
    // }
    // Better stroking in ShapeBundle
    // ctx.moveTo(shape.cx + shape.r, shape.cy);


    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
  }
});

module.exports = _default;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(25);

// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];

function _default(orignalBrush) {
  // version string can be: '11.0'
  return env.browser.ie && env.browser.version >= 11 ? function () {
    var clipPaths = this.__clipPaths;
    var style = this.style;
    var modified;

    if (clipPaths) {
      for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        var shape = clipPath && clipPath.shape;
        var type = clipPath && clipPath.type;

        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
          for (var j = 0; j < shadowTemp.length; j++) {
            // It is save to put shadowTemp static, because shadowTemp
            // will be all modified each item brush called.
            shadowTemp[j][2] = style[shadowTemp[j][0]];
            style[shadowTemp[j][0]] = shadowTemp[j][1];
          }

          modified = true;
          break;
        }
      }
    }

    orignalBrush.apply(this, arguments);

    if (modified) {
      for (var j = 0; j < shadowTemp.length; j++) {
        style[shadowTemp[j][0]] = shadowTemp[j][2];
      }
    }
  } : orignalBrush;
}

module.exports = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var polyHelper = __webpack_require__(270);

/**
 * 多边形
 * @module zrender/shape/Polygon
 */
var _default = Path.extend({
  type: 'polygon',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, true);
  }
});

module.exports = _default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var smoothSpline = __webpack_require__(826);

var smoothBezier = __webpack_require__(827);

function buildPath(ctx, shape, closePath) {
  var points = shape.points;
  var smooth = shape.smooth;

  if (points && points.length >= 2) {
    if (smooth && smooth !== 'spline') {
      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
      ctx.moveTo(points[0][0], points[0][1]);
      var len = points.length;

      for (var i = 0; i < (closePath ? len : len - 1); i++) {
        var cp1 = controlPoints[i * 2];
        var cp2 = controlPoints[i * 2 + 1];
        var p = points[(i + 1) % len];
        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
      }
    } else {
      if (smooth === 'spline') {
        points = smoothSpline(points, closePath);
      }

      ctx.moveTo(points[0][0], points[0][1]);

      for (var i = 1, l = points.length; i < l; i++) {
        ctx.lineTo(points[i][0], points[i][1]);
      }
    }

    closePath && ctx.closePath();
  }
}

exports.buildPath = buildPath;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var polyHelper = __webpack_require__(270);

/**
 * @module zrender/graphic/shape/Polyline
 */
var _default = Path.extend({
  type: 'polyline',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, false);
  }
});

module.exports = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var roundRectHelper = __webpack_require__(261);

var _subPixelOptimize = __webpack_require__(175);

var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;

/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */
// Avoid create repeatly.
var subPixelOptimizeOutputShape = {};

var _default = Path.extend({
  type: 'rect',
  shape: {
    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
    // r缩写为1         相当于 [1, 1, 1, 1]
    // r缩写为[1]       相当于 [1, 1, 1, 1]
    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
    r: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var x;
    var y;
    var width;
    var height;

    if (this.subPixelOptimize) {
      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
      x = subPixelOptimizeOutputShape.x;
      y = subPixelOptimizeOutputShape.y;
      width = subPixelOptimizeOutputShape.width;
      height = subPixelOptimizeOutputShape.height;
      subPixelOptimizeOutputShape.r = shape.r;
      shape = subPixelOptimizeOutputShape;
    } else {
      x = shape.x;
      y = shape.y;
      width = shape.width;
      height = shape.height;
    }

    if (!shape.r) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, shape);
    }

    ctx.closePath();
    return;
  }
});

module.exports = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var _subPixelOptimize = __webpack_require__(175);

var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;

/**
 * 直线
 * @module zrender/graphic/shape/Line
 */
// Avoid create repeatly.
var subPixelOptimizeOutputShape = {};

var _default = Path.extend({
  type: 'line',
  shape: {
    // Start point
    x1: 0,
    y1: 0,
    // End point
    x2: 0,
    y2: 0,
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1;
    var y1;
    var x2;
    var y2;

    if (this.subPixelOptimize) {
      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
      x1 = subPixelOptimizeOutputShape.x1;
      y1 = subPixelOptimizeOutputShape.y1;
      x2 = subPixelOptimizeOutputShape.x2;
      y2 = subPixelOptimizeOutputShape.y2;
    } else {
      x1 = shape.x1;
      y1 = shape.y1;
      x2 = shape.x2;
      y2 = shape.y2;
    }

    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (percent < 1) {
      x2 = x1 * (1 - percent) + x2 * percent;
      y2 = y1 * (1 - percent) + y2 * percent;
    }

    ctx.lineTo(x2, y2);
  },

  /**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */
  pointAt: function (p) {
    var shape = this.shape;
    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
  }
});

module.exports = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(2);

var Gradient = __webpack_require__(176);

/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */
var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'linear', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0 : x;
  this.y = y == null ? 0 : y;
  this.x2 = x2 == null ? 1 : x2;
  this.y2 = y2 == null ? 0 : y2; // Can be cloned

  this.type = 'linear'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

LinearGradient.prototype = {
  constructor: LinearGradient
};
zrUtil.inherits(LinearGradient, Gradient);
var _default = LinearGradient;
module.exports = _default;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;
var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();

function getNearestColorPalette(colors, requestColorNum) {
  var paletteNum = colors.length; // TODO colors must be in order

  for (var i = 0; i < paletteNum; i++) {
    if (colors[i].length > requestColorNum) {
      return colors[i];
    }
  }

  return colors[paletteNum - 1];
}

var _default = {
  clearColorPalette: function () {
    inner(this).colorIdx = 0;
    inner(this).colorNameMap = {};
  },

  /**
   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
   *                 twise with the same parameters will get different result.
   * @param {Object} [scope=this]
   * @param {Object} [requestColorNum]
   * @return {string} color string.
   */
  getColorFromPalette: function (name, scope, requestColorNum) {
    scope = scope || this;
    var scopeFields = inner(scope);
    var colorIdx = scopeFields.colorIdx || 0;
    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.

    if (colorNameMap.hasOwnProperty(name)) {
      return colorNameMap[name];
    }

    var defaultColorPalette = normalizeToArray(this.get('color', true));
    var layeredColorPalette = this.get('colorLayer', true);
    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.

    colorPalette = colorPalette || defaultColorPalette;

    if (!colorPalette || !colorPalette.length) {
      return;
    }

    var color = colorPalette[colorIdx];

    if (name) {
      colorNameMap[name] = color;
    }

    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
    return color;
  }
};
module.exports = _default;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js

function ExtensionAPI(chartInstance) {
  zrUtil.each(echartsAPIList, function (name) {
    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
  }, this);
}

var _default = ExtensionAPI;
module.exports = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(2);

var env = __webpack_require__(25);

var _format = __webpack_require__(44);

var formatTime = _format.formatTime;
var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;
var getTooltipMarker = _format.getTooltipMarker;

var modelUtil = __webpack_require__(13);

var ComponentModel = __webpack_require__(56);

var colorPaletteMixin = __webpack_require__(275);

var dataFormatMixin = __webpack_require__(840);

var _layout = __webpack_require__(57);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;

var _task = __webpack_require__(178);

var createTask = _task.createTask;

var _sourceHelper = __webpack_require__(100);

var prepareSource = _sourceHelper.prepareSource;
var getSource = _sourceHelper.getSource;

var _dataProvider = __webpack_require__(103);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = modelUtil.makeInner();
var SeriesModel = ComponentModel.extend({
  type: 'series.__base__',

  /**
   * @readOnly
   */
  seriesIndex: 0,
  // coodinateSystem will be injected in the echarts/CoordinateSystem
  coordinateSystem: null,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * legend visual provider to the legend component
   * @type {Object}
   */
  // PENDING
  legendVisualProvider: null,

  /**
   * Access path of color for visual
   */
  visualColorAccessPath: 'itemStyle.color',

  /**
   * Access path of borderColor for visual
   */
  visualBorderColorAccessPath: 'itemStyle.borderColor',

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  init: function (option, parentModel, ecModel, extraOpt) {
    /**
     * @type {number}
     * @readOnly
     */
    this.seriesIndex = this.componentIndex;
    this.dataTask = createTask({
      count: dataTaskCount,
      reset: dataTaskReset
    });
    this.dataTask.context = {
      model: this
    };
    this.mergeDefaultAndTheme(option, ecModel);
    prepareSource(this);
    var data = this.getInitialData(option, ecModel);
    wrapData(data, this);
    this.dataTask.context.data = data;

    /**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */
    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkList
    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
    // init or merge stage, because the data can be restored. So we do not `restoreData`
    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
    // Call `seriesModel.getRawData()` instead.
    // this.restoreData();

    autoSeriesName(this);
  },

  /**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (ComponentModel.hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option, 'label', ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (newSeriesOption, ecModel) {
    // this.settingTask.dirty();
    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
    }

    prepareSource(this);
    var data = this.getInitialData(newSeriesOption, ecModel);
    wrapData(data, this);
    this.dataTask.dirty();
    this.dataTask.context.data = data;
    inner(this).dataBeforeProcessed = data;
    autoSeriesName(this);
  },
  fillDataTextStyle: function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data && !zrUtil.isTypedArray(data)) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          modelUtil.defaultEmphasis(data[i], 'label', props);
        }
      }
    }
  },

  /**
   * Init a data structure from data related option in series
   * Must be overwritten
   */
  getInitialData: function () {},

  /**
   * Append data to list
   * @param {Object} params
   * @param {Array|TypedArray} params.data
   */
  appendData: function (params) {
    // FIXME ???
    // (1) If data from dataset, forbidden append.
    // (2) support append data of dataset.
    var data = this.getRawData();
    data.appendData(params.data);
  },

  /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */
  getData: function (dataType) {
    var task = getCurrentTask(this);

    if (task) {
      var data = task.context.data;
      return dataType == null ? data : data.getLinkedData(dataType);
    } else {
      // When series is not alive (that may happen when click toolbox
      // restore or setOption with not merge mode), series data may
      // be still need to judge animation or something when graphic
      // elements want to know whether fade out.
      return inner(this).data;
    }
  },

  /**
   * @param {module:echarts/data/List} data
   */
  setData: function (data) {
    var task = getCurrentTask(this);

    if (task) {
      var context = task.context; // Consider case: filter, data sample.

      if (context.data !== data && task.modifyOutputEnd) {
        task.setOutputEnd(data.count());
      }

      context.outputData = data; // Caution: setData should update context.data,
      // Because getData may be called multiply in a
      // single stage and expect to get the data just
      // set. (For example, AxisProxy, x y both call
      // getData and setDate sequentially).
      // So the context.data should be fetched from
      // upstream each time when a stage starts to be
      // performed.

      if (task !== this.dataTask) {
        context.data = data;
      }
    }

    inner(this).data = data;
  },

  /**
   * @see {module:echarts/data/helper/sourceHelper#getSource}
   * @return {module:echarts/data/Source} source
   */
  getSource: function () {
    return getSource(this);
  },

  /**
   * Get data before processed
   * @return {module:echarts/data/List}
   */
  getRawData: function () {
    return inner(this).dataBeforeProcessed;
  },

  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */
  getBaseAxis: function () {
    var coordSys = this.coordinateSystem;
    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  },
  // FIXME

  /**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
   *                                     string is used as DOM HTML content.
   *                                     'richText' is used for rendering tooltip in rich text form, for those where
   *                                     DOM operation is not supported.
   * @return {Object} formatted tooltip with `html` and `markers`
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
    var series = this;
    renderMode = renderMode || 'html';
    var newLine = renderMode === 'html' ? '<br/>' : '\n';
    var isRichText = renderMode === 'richText';
    var markers = {};
    var markerId = 0;

    function formatArrayValue(value) {
      // ??? TODO refactor these logic.
      // check: category-no-encode-has-axis-data in dataset.html
      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
      }, 0);
      var result = [];
      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
      }) // By default, all dims is used on tooltip.
      : zrUtil.each(value, setEachItem);

      function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.

        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
          return;
        }

        var dimType = dimInfo.type;
        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
        var dimHead = getTooltipMarker({
          color: color,
          type: 'subItem',
          renderMode: renderMode,
          markerId: markName
        });
        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
        valStr && result.push(valStr);

        if (isRichText) {
          markers[markName] = color;
          ++markerId;
        }
      }

      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
      var content = newLine + result.join(newLine || ', ');
      return {
        renderMode: renderMode,
        content: content,
        style: markers
      };
    }

    function formatSingleValue(val) {
      // return encodeHTML(addCommas(val));
      return {
        renderMode: renderMode,
        content: encodeHTML(addCommas(val)),
        style: markers
      };
    }

    var data = this.getData();
    var tooltipDims = data.mapDimension('defaultedTooltip', true);
    var tooltipDimLen = tooltipDims.length;
    var value = this.getRawValue(dataIndex);
    var isValueArr = zrUtil.isArray(value);
    var color = data.getItemVisual(dataIndex, 'color');

    if (zrUtil.isObject(color) && color.colorStops) {
      color = (color.colorStops[0] || {}).color;
    }

    color = color || 'transparent'; // Complicated rule for pretty tooltip.

    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
    var content = formattedValue.content;
    var markName = series.seriesIndex + 'at' + markerId;
    var colorEl = getTooltipMarker({
      color: color,
      type: 'item',
      renderMode: renderMode,
      markerId: markName
    });
    markers[markName] = color;
    ++markerId;
    var name = data.getName(dataIndex);
    var seriesName = this.name;

    if (!modelUtil.isNameSpecified(this)) {
      seriesName = '';
    }

    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
    return {
      html: html,
      markers: markers
    };
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return animationEnabled;
  },
  restoreData: function () {
    this.dataTask.dirty();
  },
  getColorFromPalette: function (name, scope, requestColorNum) {
    var ecModel = this.ecModel; // PENDING

    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
    }

    return color;
  },

  /**
   * Use `data.mapDimension(coordDim, true)` instead.
   * @deprecated
   */
  coordDimToDataDim: function (coordDim) {
    return this.getRawData().mapDimension(coordDim, true);
  },

  /**
   * Get progressive rendering count each step
   * @return {number}
   */
  getProgressive: function () {
    return this.get('progressive');
  },

  /**
   * Get progressive rendering count each step
   * @return {number}
   */
  getProgressiveThreshold: function () {
    return this.get('progressiveThreshold');
  },

  /**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */
  getAxisTooltipData: null,

  /**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */
  getTooltipPosition: null,

  /**
   * @see {module:echarts/stream/Scheduler}
   */
  pipeTask: null,

  /**
   * Convinient for override in extended class.
   * @protected
   * @type {Function}
   */
  preventIncremental: null,

  /**
   * @public
   * @readOnly
   * @type {Object}
   */
  pipelineContext: null
});
zrUtil.mixin(SeriesModel, dataFormatMixin);
zrUtil.mixin(SeriesModel, colorPaletteMixin);
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */

function autoSeriesName(seriesModel) {
  // User specified name has higher priority, otherwise it may cause
  // series can not be queried unexpectedly.
  var name = seriesModel.name;

  if (!modelUtil.isNameSpecified(seriesModel)) {
    seriesModel.name = getSeriesAutoName(seriesModel) || name;
  }
}

function getSeriesAutoName(seriesModel) {
  var data = seriesModel.getRawData();
  var dataDims = data.mapDimension('seriesName', true);
  var nameArr = [];
  zrUtil.each(dataDims, function (dataDim) {
    var dimInfo = data.getDimensionInfo(dataDim);
    dimInfo.displayName && nameArr.push(dimInfo.displayName);
  });
  return nameArr.join(' ');
}

function dataTaskCount(context) {
  return context.model.getRawData().count();
}

function dataTaskReset(context) {
  var seriesModel = context.model;
  seriesModel.setData(seriesModel.getRawData().cloneShallow());
  return dataTaskProgress;
}

function dataTaskProgress(param, context) {
  // Avoid repead cloneShallow when data just created in reset.
  if (param.end > context.outputData.count()) {
    context.model.getRawData().cloneShallow(context.outputData);
  }
} // TODO refactor


function wrapData(data, seriesModel) {
  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
  });
}

function onDataSelfChange(seriesModel) {
  var task = getCurrentTask(seriesModel);

  if (task) {
    // Consider case: filter, selectRange
    task.setOutputEnd(this.count());
  }
}

function getCurrentTask(seriesModel) {
  var scheduler = (seriesModel.ecModel || {}).scheduler;
  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);

  if (pipeline) {
    // When pipline finished, the currrentTask keep the last
    // task (renderTask).
    var task = pipeline.currentTask;

    if (task) {
      var agentStubMap = task.agentStubMap;

      if (agentStubMap) {
        task = agentStubMap.get(seriesModel.uid);
      }
    }

    return task;
  }
}

var _default = SeriesModel;
module.exports = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Group = __webpack_require__(98);

var componentUtil = __webpack_require__(128);

var clazzUtil = __webpack_require__(62);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var Component = function () {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewComponent');
};

Component.prototype = {
  constructor: Component,
  init: function (ecModel, api) {},
  render: function (componentModel, ecModel, api, payload) {},
  dispose: function () {},

  /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */
  filterForExposedEvent: null
};
var componentProto = Component.prototype;

componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
}; // Enable Component.extend.


clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Component, {
  registerWhenExtend: true
});
var _default = Component;
module.exports = _default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;

var Group = __webpack_require__(98);

var componentUtil = __webpack_require__(128);

var clazzUtil = __webpack_require__(62);

var modelUtil = __webpack_require__(13);

var graphicUtil = __webpack_require__(17);

var _task = __webpack_require__(178);

var createTask = _task.createTask;

var createRenderPlanner = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = modelUtil.makeInner();
var renderPlanner = createRenderPlanner();

function Chart() {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewChart');
  this.renderTask = createTask({
    plan: renderTaskPlan,
    reset: renderTaskReset
  });
  this.renderTask.context = {
    view: this
  };
}

Chart.prototype = {
  type: 'chart',

  /**
   * Init the chart.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {},

  /**
   * Render the chart.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  render: function (seriesModel, ecModel, api, payload) {},

  /**
   * Highlight series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  highlight: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
  },

  /**
   * Downplay series or specified data item.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  downplay: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'normal');
  },

  /**
   * Remove self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  remove: function (ecModel, api) {
    this.group.removeAll();
  },

  /**
   * Dispose self.
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  dispose: function () {},

  /**
   * Rendering preparation in progressive mode.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  incrementalPrepareRender: null,

  /**
   * Render in progressive mode.
   * @param  {Object} params See taskParams in `stream/task.js`
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  incrementalRender: null,

  /**
   * Update transform directly.
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   * @return {Object} {update: true}
   */
  updateTransform: null,

  /**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */
  // containPoint: function () {}

  /**
   * @param {string} eventType
   * @param {Object} query
   * @param {module:zrender/Element} targetEl
   * @param {Object} packedEvent
   * @return {boolen} Pass only when return `true`.
   */
  filterForExposedEvent: null
};
var chartProto = Chart.prototype;

chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
  this.render(seriesModel, ecModel, api, payload);
};
/**
 * Set state of single element
 * @param {module:zrender/Element} el
 * @param {string} state 'normal'|'emphasis'
 * @param {number} highlightDigit
 */


function elSetState(el, state, highlightDigit) {
  if (el) {
    el.trigger(state, highlightDigit);

    if (el.isGroup // Simple optimize.
    && !graphicUtil.isHighDownDispatcher(el)) {
      for (var i = 0, len = el.childCount(); i < len; i++) {
        elSetState(el.childAt(i), state, highlightDigit);
      }
    }
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload
 * @param {string} state 'normal'|'emphasis'
 */


function toggleHighlight(data, payload, state) {
  var dataIndex = modelUtil.queryDataIndex(data, payload);
  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;

  if (dataIndex != null) {
    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state, highlightDigit);
    });
  }
} // Enable Chart.extend.


clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Chart, {
  registerWhenExtend: true
});

Chart.markUpdateMethod = function (payload, methodName) {
  inner(payload).updateMethod = methodName;
};

function renderTaskPlan(context) {
  return renderPlanner(context.model);
}

function renderTaskReset(context) {
  var seriesModel = context.model;
  var ecModel = context.ecModel;
  var api = context.api;
  var payload = context.payload; // ???! remove updateView updateVisual

  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
  var view = context.view;
  var updateMethod = payload && inner(payload).updateMethod;
  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
  // is less than progressive threshold.
  : 'render';

  if (methodName !== 'render') {
    view[methodName](seriesModel, ecModel, api, payload);
  }

  return progressMethodMap[methodName];
}

var progressMethodMap = {
  incrementalPrepareRender: {
    progress: function (params, context) {
      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: true,
    progress: function (params, context) {
      context.view.render(context.model, context.ecModel, context.api, context.payload);
    }
  }
};
var _default = Chart;
module.exports = _default;

/***/ }),
/* 280 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Language: (Simplified) Chinese.
 */
var _default = {
  legend: {
    selector: {
      all: '全选',
      inverse: '反选'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: '矩形选择',
        polygon: '圈选',
        lineX: '横向选择',
        lineY: '纵向选择',
        keep: '保持选择',
        clear: '清除选择'
      }
    },
    dataView: {
      title: '数据视图',
      lang: ['数据视图', '关闭', '刷新']
    },
    dataZoom: {
      title: {
        zoom: '区域缩放',
        back: '区域缩放还原'
      }
    },
    magicType: {
      title: {
        line: '切换为折线图',
        bar: '切换为柱状图',
        stack: '切换为堆叠',
        tiled: '切换为平铺'
      }
    },
    restore: {
      title: '还原'
    },
    saveAsImage: {
      title: '保存为图片',
      lang: ['右键另存为图片']
    }
  },
  series: {
    typeNames: {
      pie: '饼图',
      bar: '柱状图',
      line: '折线图',
      scatter: '散点图',
      effectScatter: '涟漪散点图',
      radar: '雷达图',
      tree: '树图',
      treemap: '矩形树图',
      boxplot: '箱型图',
      candlestick: 'K线图',
      k: 'K线图',
      heatmap: '热力图',
      map: '地图',
      parallel: '平行坐标图',
      lines: '线图',
      graph: '关系图',
      sankey: '桑基图',
      funnel: '漏斗图',
      gauge: '仪表盘图',
      pictorialBar: '象形柱图',
      themeRiver: '主题河流图',
      sunburst: '旭日图'
    }
  },
  aria: {
    general: {
      withTitle: '这是一个关于“{title}”的图表。',
      withoutTitle: '这是一个图表，'
    },
    series: {
      single: {
        prefix: '',
        withName: '图表类型是{seriesType}，表示{seriesName}。',
        withoutName: '图表类型是{seriesType}。'
      },
      multiple: {
        prefix: '它由{seriesCount}个图表系列组成。',
        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
        withoutName: '第{seriesId}个系列是一个{seriesType}，',
        separator: {
          middle: '；',
          end: '。'
        }
      }
    },
    data: {
      allData: '其数据是——',
      partialData: '其中，前{displayCnt}项是——',
      withName: '{name}的数据是{value}',
      withoutName: '{value}',
      separator: {
        middle: '，',
        end: ''
      }
    }
  }
};
module.exports = _default;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var List = __webpack_require__(282);

var createDimensions = __webpack_require__(284);

var _sourceType = __webpack_require__(102);

var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;

var _dimensionHelper = __webpack_require__(181);

var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;

var _model = __webpack_require__(13);

var getDataItemValue = _model.getDataItemValue;

var CoordinateSystem = __webpack_require__(177);

var _referHelper = __webpack_require__(854);

var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;

var Source = __webpack_require__(101);

var _dataStackHelper = __webpack_require__(85);

var enableDataStack = _dataStackHelper.enableDataStack;

var _sourceHelper = __webpack_require__(100);

var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/data/Source|Array} source Or raw data.
 * @param {module:echarts/model/Series} seriesModel
 * @param {Object} [opt]
 * @param {string} [opt.generateCoord]
 * @param {boolean} [opt.useEncodeDefaulter]
 */
function createListFromArray(source, seriesModel, opt) {
  opt = opt || {};

  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  var coordSysName = seriesModel.get('coordinateSystem');
  var registeredCoordSys = CoordinateSystem.get(coordSysName);
  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
  var coordSysDimDefs;

  if (coordSysInfo) {
    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
      var dimInfo = {
        name: dim
      };
      var axisModel = coordSysInfo.axisMap.get(dim);

      if (axisModel) {
        var axisType = axisModel.get('type');
        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
      }

      return dimInfo;
    });
  }

  if (!coordSysDimDefs) {
    // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
  }

  var dimInfoList = createDimensions(source, {
    coordDimensions: coordSysDimDefs,
    generateCoord: opt.generateCoord,
    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
  });
  var firstCategoryDimIndex;
  var hasNameEncode;
  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
    var coordDim = dimInfo.coordDim;
    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);

    if (categoryAxisModel) {
      if (firstCategoryDimIndex == null) {
        firstCategoryDimIndex = dimIndex;
      }

      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
    }

    if (dimInfo.otherDims.itemName != null) {
      hasNameEncode = true;
    }
  });

  if (!hasNameEncode && firstCategoryDimIndex != null) {
    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
  }

  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
  var list = new List(dimInfoList, seriesModel);
  list.setCalculationInfo(stackCalculationInfo);
  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // Use dataIndex as ordinal value in categoryAxis
    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
  } : null;
  list.hasItemOption = false;
  list.initData(source, null, dimValueGetter);
  return list;
}

function isNeedCompleteOrdinalData(source) {
  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var sampleItem = firstDataNotNull(source.data || []);
    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
  }
}

function firstDataNotNull(data) {
  var i = 0;

  while (i < data.length && data[i] == null) {
    i++;
  }

  return data[i];
}

var _default = createListFromArray;
module.exports = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(2);

var Model = __webpack_require__(55);

var DataDiffer = __webpack_require__(853);

var Source = __webpack_require__(101);

var _dataProvider = __webpack_require__(103);

var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
var DefaultDataProvider = _dataProvider.DefaultDataProvider;

var _dimensionHelper = __webpack_require__(181);

var summarizeDimensions = _dimensionHelper.summarizeDimensions;

var DataDimensionInfo = __webpack_require__(283);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float64Array, Int32Array, Uint32Array, Uint16Array */

/**
 * List for data storage
 * @module echarts/data/List
 */
var isObject = zrUtil.isObject;
var UNDEFINED = 'undefined';
var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.

var ID_PREFIX = 'e\0\0';
var dataCtors = {
  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': Array
}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.

var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;

function getIndicesCtor(list) {
  // The possible max value in this._indicies is always this._rawCount despite of filtering.
  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
}

function cloneChunk(originalChunk) {
  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.

  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}

var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];

function transferProperties(target, source) {
  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
    if (source.hasOwnProperty(propName)) {
      target[propName] = source[propName];
    }
  });
  target.__wrappedMethods = source.__wrappedMethods;
  zrUtil.each(CLONE_PROPERTIES, function (propName) {
    target[propName] = zrUtil.clone(source[propName]);
  });
  target._calculationInfo = zrUtil.extend(source._calculationInfo);
}
/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 * @param {module:echarts/model/Model} hostModel
 */


var List = function (dimensions, hostModel) {
  dimensions = dimensions || ['x', 'y'];
  var dimensionInfos = {};
  var dimensionNames = [];
  var invertedIndicesMap = {};

  for (var i = 0; i < dimensions.length; i++) {
    // Use the original dimensions[i], where other flag props may exists.
    var dimensionInfo = dimensions[i];

    if (zrUtil.isString(dimensionInfo)) {
      dimensionInfo = new DataDimensionInfo({
        name: dimensionInfo
      });
    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
      dimensionInfo = new DataDimensionInfo(dimensionInfo);
    }

    var dimensionName = dimensionInfo.name;
    dimensionInfo.type = dimensionInfo.type || 'float';

    if (!dimensionInfo.coordDim) {
      dimensionInfo.coordDim = dimensionName;
      dimensionInfo.coordDimIndex = 0;
    }

    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
    dimensionNames.push(dimensionName);
    dimensionInfos[dimensionName] = dimensionInfo;
    dimensionInfo.index = i;

    if (dimensionInfo.createInvertedIndices) {
      invertedIndicesMap[dimensionName] = [];
    }
  }
  /**
   * @readOnly
   * @type {Array.<string>}
   */


  this.dimensions = dimensionNames;
  /**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */

  this._dimensionInfos = dimensionInfos;
  /**
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
  /**
   * @type {module:echarts/model/Model}
   */

  this.dataType;
  /**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */

  this._indices = null;
  this._count = 0;
  this._rawCount = 0;
  /**
   * Data storage
   * @type {Object.<key, Array.<TypedArray|Array>>}
   * @private
   */

  this._storage = {};
  /**
   * @type {Array.<string>}
   */

  this._nameList = [];
  /**
   * @type {Array.<string>}
   */

  this._idList = [];
  /**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */

  this._optionModels = [];
  /**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */

  this._visual = {};
  /**
   * Globel layout properties.
   * @type {Object}
   * @private
   */

  this._layout = {};
  /**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */

  this._itemVisuals = [];
  /**
   * Key: visual type, Value: boolean
   * @type {Object}
   * @readOnly
   */

  this.hasItemVisual = {};
  /**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */

  this._itemLayouts = [];
  /**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */

  this._graphicEls = [];
  /**
   * Max size of each chunk.
   * @type {number}
   * @private
   */

  this._chunkSize = 1e5;
  /**
   * @type {number}
   * @private
   */

  this._chunkCount = 0;
  /**
   * @type {Array.<Array|Object>}
   * @private
   */

  this._rawData;
  /**
   * Raw extent will not be cloned, but only transfered.
   * It will not be calculated util needed.
   * key: dim,
   * value: {end: number, extent: Array.<number>}
   * @type {Object}
   * @private
   */

  this._rawExtent = {};
  /**
   * @type {Object}
   * @private
   */

  this._extent = {};
  /**
   * key: dim
   * value: extent
   * @type {Object}
   * @private
   */

  this._approximateExtent = {};
  /**
   * Cache summary info for fast visit. See "dimensionHelper".
   * @type {Object}
   * @private
   */

  this._dimensionsSummary = summarizeDimensions(this);
  /**
   * @type {Object.<Array|TypedArray>}
   * @private
   */

  this._invertedIndicesMap = invertedIndicesMap;
  /**
   * @type {Object}
   * @private
   */

  this._calculationInfo = {};
  /**
   * User output info of this data.
   * DO NOT use it in other places!
   *
   * When preparing user params for user callbacks, we have
   * to clone these inner data structures to prevent users
   * from modifying them to effect built-in logic. And for
   * performance consideration we make this `userOutput` to
   * avoid clone them too many times.
   *
   * @type {Object}
   * @readOnly
   */

  this.userOutput = this._dimensionsSummary.userOutput;
};

var listProto = List.prototype;
listProto.type = 'list';
/**
 * If each data item has it's own option
 * @type {boolean}
 */

listProto.hasItemOption = true;
/**
 * The meanings of the input parameter `dim`:
 *
 * + If dim is a number (e.g., `1`), it means the index of the dimension.
 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
 * + If dim is a number-like string (e.g., `"1"`):
 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
 *     + If not, it will be converted to a number, which means the index of the dimension.
 *        (why? because of the backward compatbility. We have been tolerating number-like string in
 *        dimension setting, although now it seems that it is not a good idea.)
 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
 *     if no dimension name is defined as `"1"`.
 * + If dim is a not-number-like string, it means the concrete dim name.
 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
 *   or customized in `dimensions` property of option like `"age"`.
 *
 * Get dimension name
 * @param {string|number} dim See above.
 * @return {string} Concrete dim name.
 */

listProto.getDimension = function (dim) {
  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
    dim = this.dimensions[dim];
  }

  return dim;
};
/**
 * Get type and calculation info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */


listProto.getDimensionInfo = function (dim) {
  // Do not clone, because there may be categories in dimInfo.
  return this._dimensionInfos[this.getDimension(dim)];
};
/**
 * @return {Array.<string>} concrete dimension name list on coord.
 */


listProto.getDimensionsOnCoord = function () {
  return this._dimensionsSummary.dataDimsOnCoord.slice();
};
/**
 * @param {string} coordDim
 * @param {number} [idx] A coordDim may map to more than one data dim.
 *        If idx is `true`, return a array of all mapped dims.
 *        If idx is not specified, return the first dim not extra.
 * @return {string|Array.<string>} concrete data dim.
 *        If idx is number, and not found, return null/undefined.
 *        If idx is `true`, and not found, return empty array (always return array).
 */


listProto.mapDimension = function (coordDim, idx) {
  var dimensionsSummary = this._dimensionsSummary;

  if (idx == null) {
    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
  }

  var dims = dimensionsSummary.encode[coordDim];
  return idx === true // always return array if idx is `true`
  ? (dims || []).slice() : dims && dims[idx];
};
/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data source or data or data provider.
 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
 *        defualt label/tooltip.
 *        A name can be specified in encode.itemName,
 *        or dataItem.name (only for series option data),
 *        or provided in nameList from outside.
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */


listProto.initData = function (data, nameList, dimValueGetter) {
  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);

  if (notProvider) {
    data = new DefaultDataProvider(data, this.dimensions.length);
  }

  this._rawData = data; // Clear

  this._storage = {};
  this._indices = null;
  this._nameList = nameList || [];
  this._idList = [];
  this._nameRepeatCount = {};

  if (!dimValueGetter) {
    this.hasItemOption = false;
  }
  /**
   * @readOnly
   */


  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter

  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.

  this._rawExtent = {};

  this._initDataFromProvider(0, data.count()); // If data has no item option.


  if (data.pure) {
    this.hasItemOption = false;
  }
};

listProto.getProvider = function () {
  return this._rawData;
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 */


listProto.appendData = function (data) {
  var rawData = this._rawData;
  var start = this.count();
  rawData.appendData(data);
  var end = rawData.count();

  if (!rawData.persistent) {
    end += start;
  }

  this._initDataFromProvider(start, end);
};
/**
 * Caution: Can be only called on raw data (before `this._indices` created).
 * This method does not modify `rawData` (`dataProvider`), but only
 * add values to storage.
 *
 * The final count will be increased by `Math.max(values.length, names.length)`.
 *
 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
 *        [
 *            [12, 33, 44],
 *            [NaN, 43, 1],
 *            ['-', 'asdf', 0]
 *        ]
 *        Each item is exaclty cooresponding to a dimension.
 * @param {Array.<string>} [names]
 */


listProto.appendValues = function (values, names) {
  var chunkSize = this._chunkSize;
  var storage = this._storage;
  var dimensions = this.dimensions;
  var dimLen = dimensions.length;
  var rawExtent = this._rawExtent;
  var start = this.count();
  var end = start + Math.max(values.length, names ? names.length : 0);
  var originalChunkCount = this._chunkCount;

  for (var i = 0; i < dimLen; i++) {
    var dim = dimensions[i];

    if (!rawExtent[dim]) {
      rawExtent[dim] = getInitialExtent();
    }

    if (!storage[dim]) {
      storage[dim] = [];
    }

    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
    this._chunkCount = storage[dim].length;
  }

  var emptyDataItem = new Array(dimLen);

  for (var idx = start; idx < end; idx++) {
    var sourceIdx = idx - start;
    var chunkIndex = Math.floor(idx / chunkSize);
    var chunkOffset = idx % chunkSize; // Store the data by dimensions

    for (var k = 0; k < dimLen; k++) {
      var dim = dimensions[k];

      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);

      storage[dim][chunkIndex][chunkOffset] = val;
      var dimRawExtent = rawExtent[dim];
      val < dimRawExtent[0] && (dimRawExtent[0] = val);
      val > dimRawExtent[1] && (dimRawExtent[1] = val);
    }

    if (names) {
      this._nameList[idx] = names[sourceIdx];
    }
  }

  this._rawCount = this._count = end; // Reset data extent

  this._extent = {};
  prepareInvertedIndex(this);
};

listProto._initDataFromProvider = function (start, end) {
  // Optimize.
  if (start >= end) {
    return;
  }

  var chunkSize = this._chunkSize;
  var rawData = this._rawData;
  var storage = this._storage;
  var dimensions = this.dimensions;
  var dimLen = dimensions.length;
  var dimensionInfoMap = this._dimensionInfos;
  var nameList = this._nameList;
  var idList = this._idList;
  var rawExtent = this._rawExtent;
  var nameRepeatCount = this._nameRepeatCount = {};
  var nameDimIdx;
  var originalChunkCount = this._chunkCount;

  for (var i = 0; i < dimLen; i++) {
    var dim = dimensions[i];

    if (!rawExtent[dim]) {
      rawExtent[dim] = getInitialExtent();
    }

    var dimInfo = dimensionInfoMap[dim];

    if (dimInfo.otherDims.itemName === 0) {
      nameDimIdx = this._nameDimIdx = i;
    }

    if (dimInfo.otherDims.itemId === 0) {
      this._idDimIdx = i;
    }

    if (!storage[dim]) {
      storage[dim] = [];
    }

    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
    this._chunkCount = storage[dim].length;
  }

  var dataItem = new Array(dimLen);

  for (var idx = start; idx < end; idx++) {
    // NOTICE: Try not to write things into dataItem
    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of category
    // Use a tempValue to normalize the value to be a (x, y) value

    var chunkIndex = Math.floor(idx / chunkSize);
    var chunkOffset = idx % chunkSize; // Store the data by dimensions

    for (var k = 0; k < dimLen; k++) {
      var dim = dimensions[k];
      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero

      var val = this._dimValueGetter(dataItem, dim, idx, k);

      dimStorage[chunkOffset] = val;
      var dimRawExtent = rawExtent[dim];
      val < dimRawExtent[0] && (dimRawExtent[0] = val);
      val > dimRawExtent[1] && (dimRawExtent[1] = val);
    } // ??? FIXME not check by pure but sourceFormat?
    // TODO refactor these logic.


    if (!rawData.pure) {
      var name = nameList[idx];

      if (dataItem && name == null) {
        // If dataItem is {name: ...}, it has highest priority.
        // That is appropriate for many common cases.
        if (dataItem.name != null) {
          // There is no other place to persistent dataItem.name,
          // so save it to nameList.
          nameList[idx] = name = dataItem.name;
        } else if (nameDimIdx != null) {
          var nameDim = dimensions[nameDimIdx];
          var nameDimChunk = storage[nameDim][chunkIndex];

          if (nameDimChunk) {
            name = nameDimChunk[chunkOffset];
            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;

            if (ordinalMeta && ordinalMeta.categories.length) {
              name = ordinalMeta.categories[name];
            }
          }
        }
      } // Try using the id in option
      // id or name is used on dynamical data, mapping old and new items.


      var id = dataItem == null ? null : dataItem.id;

      if (id == null && name != null) {
        // Use name as id and add counter to avoid same name
        nameRepeatCount[name] = nameRepeatCount[name] || 0;
        id = name;

        if (nameRepeatCount[name] > 0) {
          id += '__ec__' + nameRepeatCount[name];
        }

        nameRepeatCount[name]++;
      }

      id != null && (idList[idx] = id);
    }
  }

  if (!rawData.persistent && rawData.clean) {
    // Clean unused data if data source is typed array.
    rawData.clean();
  }

  this._rawCount = this._count = end; // Reset data extent

  this._extent = {};
  prepareInvertedIndex(this);
};

function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
  var DataCtor = dataCtors[dimInfo.type];
  var lastChunkIndex = chunkCount - 1;
  var dim = dimInfo.name;
  var resizeChunkArray = storage[dim][lastChunkIndex];

  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
    // within the initial chunkSize.

    for (var j = 0; j < resizeChunkArray.length; j++) {
      newStore[j] = resizeChunkArray[j];
    }

    storage[dim][lastChunkIndex] = newStore;
  } // Create new chunks.


  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
  }
}

function prepareInvertedIndex(list) {
  var invertedIndicesMap = list._invertedIndicesMap;
  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.

    var ordinalMeta = dimInfo.ordinalMeta;

    if (ordinalMeta) {
      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
      // mapping to 0, we should set it as INDEX_NOT_FOUND.

      for (var i = 0; i < invertedIndices.length; i++) {
        invertedIndices[i] = INDEX_NOT_FOUND;
      }

      for (var i = 0; i < list._count; i++) {
        // Only support the case that all values are distinct.
        invertedIndices[list.get(dim, i)] = i;
      }
    }
  });
}

function getRawValueFromStore(list, dimIndex, rawIndex) {
  var val;

  if (dimIndex != null) {
    var chunkSize = list._chunkSize;
    var chunkIndex = Math.floor(rawIndex / chunkSize);
    var chunkOffset = rawIndex % chunkSize;
    var dim = list.dimensions[dimIndex];
    var chunk = list._storage[dim][chunkIndex];

    if (chunk) {
      val = chunk[chunkOffset];
      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;

      if (ordinalMeta && ordinalMeta.categories.length) {
        val = ordinalMeta.categories[val];
      }
    }
  }

  return val;
}
/**
 * @return {number}
 */


listProto.count = function () {
  return this._count;
};

listProto.getIndices = function () {
  var newIndices;
  var indices = this._indices;

  if (indices) {
    var Ctor = indices.constructor;
    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.

    if (Ctor === Array) {
      newIndices = new Ctor(thisCount);

      for (var i = 0; i < thisCount; i++) {
        newIndices[i] = indices[i];
      }
    } else {
      newIndices = new Ctor(indices.buffer, 0, thisCount);
    }
  } else {
    var Ctor = getIndicesCtor(this);
    var newIndices = new Ctor(this.count());

    for (var i = 0; i < newIndices.length; i++) {
      newIndices[i] = i;
    }
  }

  return newIndices;
};
/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.get = function (dim, idx
/*, stack */
) {
  if (!(idx >= 0 && idx < this._count)) {
    return NaN;
  }

  var storage = this._storage;

  if (!storage[dim]) {
    // TODO Warn ?
    return NaN;
  }

  idx = this.getRawIndex(idx);
  var chunkIndex = Math.floor(idx / this._chunkSize);
  var chunkOffset = idx % this._chunkSize;
  var chunkStore = storage[dim][chunkIndex];
  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
  // if (stack) {
  //     var dimensionInfo = this._dimensionInfos[dim];
  //     if (dimensionInfo && dimensionInfo.stackable) {
  //         var stackedOn = this.stackedOn;
  //         while (stackedOn) {
  //             // Get no stacked data of stacked on
  //             var stackedValue = stackedOn.get(dim, idx);
  //             // Considering positive stack, negative stack and empty data
  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
  //                 || (value <= 0 && stackedValue < 0) // Negative stack
  //             ) {
  //                 value += stackedValue;
  //             }
  //             stackedOn = stackedOn.stackedOn;
  //         }
  //     }
  // }

  return value;
};
/**
 * @param {string} dim concrete dim
 * @param {number} rawIndex
 * @return {number|string}
 */


listProto.getByRawIndex = function (dim, rawIdx) {
  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
    return NaN;
  }

  var dimStore = this._storage[dim];

  if (!dimStore) {
    // TODO Warn ?
    return NaN;
  }

  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
  var chunkOffset = rawIdx % this._chunkSize;
  var chunkStore = dimStore[chunkIndex];
  return chunkStore[chunkOffset];
};
/**
 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
 * Hack a much simpler _getFast
 * @private
 */


listProto._getFast = function (dim, rawIdx) {
  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
  var chunkOffset = rawIdx % this._chunkSize;
  var chunkStore = this._storage[dim][chunkIndex];
  return chunkStore[chunkOffset];
};
/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @return {number}
 */


listProto.getValues = function (dimensions, idx
/*, stack */
) {
  var values = [];

  if (!zrUtil.isArray(dimensions)) {
    // stack = idx;
    idx = dimensions;
    dimensions = this.dimensions;
  }

  for (var i = 0, len = dimensions.length; i < len; i++) {
    values.push(this.get(dimensions[i], idx
    /*, stack */
    ));
  }

  return values;
};
/**
 * If value is NaN. Inlcuding '-'
 * Only check the coord dimensions.
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */


listProto.hasValue = function (idx) {
  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;

  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
    // Ordinal type originally can be string or number.
    // But when an ordinal type is used on coord, it can
    // not be string but only number. So we can also use isNaN.
    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
      return false;
    }
  }

  return true;
};
/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */


listProto.getDataExtent = function (dim
/*, stack */
) {
  // Make sure use concrete dim as cache name.
  dim = this.getDimension(dim);
  var dimData = this._storage[dim];
  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));

  if (!dimData) {
    return initialExtent;
  } // Make more strict checkings to ensure hitting cache.


  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
  // var cacheName = dim;
  // Consider the most cases when using data zoom, `getDataExtent`
  // happened before filtering. We cache raw extent, which is not
  // necessary to be cleared and recalculated when restore data.

  var useRaw = !this._indices; // && !stack;

  var dimExtent;

  if (useRaw) {
    return this._rawExtent[dim].slice();
  }

  dimExtent = this._extent[dim];

  if (dimExtent) {
    return dimExtent.slice();
  }

  dimExtent = initialExtent;
  var min = dimExtent[0];
  var max = dimExtent[1];

  for (var i = 0; i < currEnd; i++) {
    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
    var value = this._getFast(dim, this.getRawIndex(i));

    value < min && (min = value);
    value > max && (max = value);
  }

  dimExtent = [min, max];
  this._extent[dim] = dimExtent;
  return dimExtent;
};
/**
 * Optimize for the scenario that data is filtered by a given extent.
 * Consider that if data amount is more than hundreds of thousand,
 * extent calculation will cost more than 10ms and the cache will
 * be erased because of the filtering.
 */


listProto.getApproximateExtent = function (dim
/*, stack */
) {
  dim = this.getDimension(dim);
  return this._approximateExtent[dim] || this.getDataExtent(dim
  /*, stack */
  );
};

listProto.setApproximateExtent = function (extent, dim
/*, stack */
) {
  dim = this.getDimension(dim);
  this._approximateExtent[dim] = extent.slice();
};
/**
 * @param {string} key
 * @return {*}
 */


listProto.getCalculationInfo = function (key) {
  return this._calculationInfo[key];
};
/**
 * @param {string|Object} key or k-v object
 * @param {*} [value]
 */


listProto.setCalculationInfo = function (key, value) {
  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
};
/**
 * Get sum of data in one dimension
 * @param {string} dim
 */


listProto.getSum = function (dim
/*, stack */
) {
  var dimData = this._storage[dim];
  var sum = 0;

  if (dimData) {
    for (var i = 0, len = this.count(); i < len; i++) {
      var value = this.get(dim, i
      /*, stack */
      );

      if (!isNaN(value)) {
        sum += value;
      }
    }
  }

  return sum;
};
/**
 * Get median of data in one dimension
 * @param {string} dim
 */


listProto.getMedian = function (dim
/*, stack */
) {
  var dimDataArray = []; // map all data of one dimension

  this.each(dim, function (val, idx) {
    if (!isNaN(val)) {
      dimDataArray.push(val);
    }
  }); // TODO
  // Use quick select?
  // immutability & sort

  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
    return a - b;
  });
  var len = this.count(); // calculate median

  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
}; // /**
//  * Retreive the index with given value
//  * @param {string} dim Concrete dimension.
//  * @param {number} value
//  * @return {number}
//  */
// Currently incorrect: should return dataIndex but not rawIndex.
// Do not fix it until this method is to be used somewhere.
// FIXME Precision of float value
// listProto.indexOf = function (dim, value) {
//     var storage = this._storage;
//     var dimData = storage[dim];
//     var chunkSize = this._chunkSize;
//     if (dimData) {
//         for (var i = 0, len = this.count(); i < len; i++) {
//             var chunkIndex = Math.floor(i / chunkSize);
//             var chunkOffset = i % chunkSize;
//             if (dimData[chunkIndex][chunkOffset] === value) {
//                 return i;
//             }
//         }
//     }
//     return -1;
// };

/**
 * Only support the dimension which inverted index created.
 * Do not support other cases until required.
 * @param {string} concrete dim
 * @param {number|string} value
 * @return {number} rawIndex
 */


listProto.rawIndexOf = function (dim, value) {
  var invertedIndices = dim && this._invertedIndicesMap[dim];
  var rawIndex = invertedIndices[value];

  if (rawIndex == null || isNaN(rawIndex)) {
    return INDEX_NOT_FOUND;
  }

  return rawIndex;
};
/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfName = function (name) {
  for (var i = 0, len = this.count(); i < len; i++) {
    if (this.getName(i) === name) {
      return i;
    }
  }

  return -1;
};
/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfRawIndex = function (rawIndex) {
  if (rawIndex >= this._rawCount || rawIndex < 0) {
    return -1;
  }

  if (!this._indices) {
    return rawIndex;
  } // Indices are ascending


  var indices = this._indices; // If rawIndex === dataIndex

  var rawDataIndex = indices[rawIndex];

  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
    return rawIndex;
  }

  var left = 0;
  var right = this._count - 1;

  while (left <= right) {
    var mid = (left + right) / 2 | 0;

    if (indices[mid] < rawIndex) {
      left = mid + 1;
    } else if (indices[mid] > rawIndex) {
      right = mid - 1;
    } else {
      return mid;
    }
  }

  return -1;
};
/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} If and only if multiple indices has
 *        the same value, they are put to the result.
 */


listProto.indicesOfNearest = function (dim, value, maxDistance) {
  var storage = this._storage;
  var dimData = storage[dim];
  var nearestIndices = [];

  if (!dimData) {
    return nearestIndices;
  }

  if (maxDistance == null) {
    maxDistance = Infinity;
  }

  var minDist = Infinity;
  var minDiff = -1;
  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.

  for (var i = 0, len = this.count(); i < len; i++) {
    var diff = value - this.get(dim, i);
    var dist = Math.abs(diff);

    if (dist <= maxDistance) {
      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
      // So we chose the one that `diff >= 0` in this csae.
      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
      // should be push to `nearestIndices`.
      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        nearestIndicesLen = 0;
      }

      if (diff === minDiff) {
        nearestIndices[nearestIndicesLen++] = i;
      }
    }
  }

  nearestIndices.length = nearestIndicesLen;
  return nearestIndices;
};
/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */


listProto.getRawIndex = getRawIndexWithoutIndices;

function getRawIndexWithoutIndices(idx) {
  return idx;
}

function getRawIndexWithIndices(idx) {
  if (idx < this._count && idx >= 0) {
    return this._indices[idx];
  }

  return -1;
}
/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */


listProto.getRawDataItem = function (idx) {
  if (!this._rawData.persistent) {
    var val = [];

    for (var i = 0; i < this.dimensions.length; i++) {
      var dim = this.dimensions[i];
      val.push(this.get(dim, idx));
    }

    return val;
  } else {
    return this._rawData.getItem(this.getRawIndex(idx));
  }
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getName = function (idx) {
  var rawIndex = this.getRawIndex(idx);
  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getId = function (idx) {
  return getId(this, this.getRawIndex(idx));
};

function getId(list, rawIndex) {
  var id = list._idList[rawIndex];

  if (id == null) {
    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
  }

  if (id == null) {
    // FIXME Check the usage in graph, should not use prefix.
    id = ID_PREFIX + rawIndex;
  }

  return id;
}

function normalizeDimensions(dimensions) {
  if (!zrUtil.isArray(dimensions)) {
    dimensions = [dimensions];
  }

  return dimensions;
}

function validateDimensions(list, dims) {
  for (var i = 0; i < dims.length; i++) {
    // stroage may be empty when no data, so use
    // dimensionInfos to check.
    if (!list._dimensionInfos[dims[i]]) {
      console.error('Unkown dimension ' + dims[i]);
    }
  }
}
/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */


listProto.each = function (dims, cb, context, contextCompat) {
  'use strict';

  if (!this._count) {
    return;
  }

  if (typeof dims === 'function') {
    contextCompat = context;
    context = cb;
    cb = dims;
    dims = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
  var dimSize = dims.length;

  for (var i = 0; i < this.count(); i++) {
    // Simple optimization
    switch (dimSize) {
      case 0:
        cb.call(context, i);
        break;

      case 1:
        cb.call(context, this.get(dims[0], i), i);
        break;

      case 2:
        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
        break;

      default:
        var k = 0;
        var value = [];

        for (; k < dimSize; k++) {
          value[k] = this.get(dims[k], i);
        } // Index


        value[k] = i;
        cb.apply(context, value);
    }
  }
};
/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {*} [context=this]
 */


listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
  'use strict';

  if (!this._count) {
    return;
  }

  if (typeof dimensions === 'function') {
    contextCompat = context;
    context = cb;
    cb = dimensions;
    dimensions = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var count = this.count();
  var Ctor = getIndicesCtor(this);
  var newIndices = new Ctor(count);
  var value = [];
  var dimSize = dimensions.length;
  var offset = 0;
  var dim0 = dimensions[0];

  for (var i = 0; i < count; i++) {
    var keep;
    var rawIdx = this.getRawIndex(i); // Simple optimization

    if (dimSize === 0) {
      keep = cb.call(context, i);
    } else if (dimSize === 1) {
      var val = this._getFast(dim0, rawIdx);

      keep = cb.call(context, val, i);
    } else {
      for (var k = 0; k < dimSize; k++) {
        value[k] = this._getFast(dim0, rawIdx);
      }

      value[k] = i;
      keep = cb.apply(context, value);
    }

    if (keep) {
      newIndices[offset++] = rawIdx;
    }
  } // Set indices after filtered.


  if (offset < count) {
    this._indices = newIndices;
  }

  this._count = offset; // Reset data extent

  this._extent = {};
  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return this;
};
/**
 * Select data in range. (For optimization of filter)
 * (Manually inline code, support 5 million data filtering in data zoom.)
 */


listProto.selectRange = function (range) {
  'use strict';

  if (!this._count) {
    return;
  }

  var dimensions = [];

  for (var dim in range) {
    if (range.hasOwnProperty(dim)) {
      dimensions.push(dim);
    }
  }

  var dimSize = dimensions.length;

  if (!dimSize) {
    return;
  }

  var originalCount = this.count();
  var Ctor = getIndicesCtor(this);
  var newIndices = new Ctor(originalCount);
  var offset = 0;
  var dim0 = dimensions[0];
  var min = range[dim0][0];
  var max = range[dim0][1];
  var quickFinished = false;

  if (!this._indices) {
    // Extreme optimization for common case. About 2x faster in chrome.
    var idx = 0;

    if (dimSize === 1) {
      var dimStorage = this._storage[dimensions[0]];

      for (var k = 0; k < this._chunkCount; k++) {
        var chunkStorage = dimStorage[k];
        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);

        for (var i = 0; i < len; i++) {
          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
          // value indicates the line should be broken. But for the case like
          // scatter plot, a data item with empty value will not be rendered,
          // but the axis extent may be effected if some other dim of the data
          // item has value. Fortunately it is not a significant negative effect.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = idx;
          }

          idx++;
        }
      }

      quickFinished = true;
    } else if (dimSize === 2) {
      var dimStorage = this._storage[dim0];
      var dimStorage2 = this._storage[dimensions[1]];
      var min2 = range[dimensions[1]][0];
      var max2 = range[dimensions[1]][1];

      for (var k = 0; k < this._chunkCount; k++) {
        var chunkStorage = dimStorage[k];
        var chunkStorage2 = dimStorage2[k];
        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);

        for (var i = 0; i < len; i++) {
          var val = chunkStorage[i];
          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.

          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
            newIndices[offset++] = idx;
          }

          idx++;
        }
      }

      quickFinished = true;
    }
  }

  if (!quickFinished) {
    if (dimSize === 1) {
      for (var i = 0; i < originalCount; i++) {
        var rawIndex = this.getRawIndex(i);

        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.


        if (val >= min && val <= max || isNaN(val)) {
          newIndices[offset++] = rawIndex;
        }
      }
    } else {
      for (var i = 0; i < originalCount; i++) {
        var keep = true;
        var rawIndex = this.getRawIndex(i);

        for (var k = 0; k < dimSize; k++) {
          var dimk = dimensions[k];

          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.


          if (val < range[dimk][0] || val > range[dimk][1]) {
            keep = false;
          }
        }

        if (keep) {
          newIndices[offset++] = this.getRawIndex(i);
        }
      }
    }
  } // Set indices after filtered.


  if (offset < originalCount) {
    this._indices = newIndices;
  }

  this._count = offset; // Reset data extent

  this._extent = {};
  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return this;
};
/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.mapArray = function (dimensions, cb, context, contextCompat) {
  'use strict';

  if (typeof dimensions === 'function') {
    contextCompat = context;
    context = cb;
    cb = dimensions;
    dimensions = [];
  } // contextCompat just for compat echarts3


  context = context || contextCompat || this;
  var result = [];
  this.each(dimensions, function () {
    result.push(cb && cb.apply(this, arguments));
  }, context);
  return result;
}; // Data in excludeDimensions is copied, otherwise transfered.


function cloneListForMapAndSample(original, excludeDimensions) {
  var allDimensions = original.dimensions;
  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

  transferProperties(list, original);
  var storage = list._storage = {};
  var originalStorage = original._storage; // Init storage

  for (var i = 0; i < allDimensions.length; i++) {
    var dim = allDimensions[i];

    if (originalStorage[dim]) {
      // Notice that we do not reset invertedIndicesMap here, becuase
      // there is no scenario of mapping or sampling ordinal dimension.
      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
        storage[dim] = cloneDimStore(originalStorage[dim]);
        list._rawExtent[dim] = getInitialExtent();
        list._extent[dim] = null;
      } else {
        // Direct reference for other dimensions
        storage[dim] = originalStorage[dim];
      }
    }
  }

  return list;
}

function cloneDimStore(originalDimStore) {
  var newDimStore = new Array(originalDimStore.length);

  for (var j = 0; j < originalDimStore.length; j++) {
    newDimStore[j] = cloneChunk(originalDimStore[j]);
  }

  return newDimStore;
}

function getInitialExtent() {
  return [Infinity, -Infinity];
}
/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.map = function (dimensions, cb, context, contextCompat) {
  'use strict'; // contextCompat just for compat echarts3

  context = context || contextCompat || this;
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
  // So we can reference to the same value

  list._indices = this._indices;
  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  var storage = list._storage;
  var tmpRetValue = [];
  var chunkSize = this._chunkSize;
  var dimSize = dimensions.length;
  var dataCount = this.count();
  var values = [];
  var rawExtent = list._rawExtent;

  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
      /*, stack */
      );
    }

    values[dimSize] = dataIndex;
    var retValue = cb && cb.apply(context, values);

    if (retValue != null) {
      // a number or string (in oridinal dimension)?
      if (typeof retValue !== 'object') {
        tmpRetValue[0] = retValue;
        retValue = tmpRetValue;
      }

      var rawIndex = this.getRawIndex(dataIndex);
      var chunkIndex = Math.floor(rawIndex / chunkSize);
      var chunkOffset = rawIndex % chunkSize;

      for (var i = 0; i < retValue.length; i++) {
        var dim = dimensions[i];
        var val = retValue[i];
        var rawExtentOnDim = rawExtent[dim];
        var dimStore = storage[dim];

        if (dimStore) {
          dimStore[chunkIndex][chunkOffset] = val;
        }

        if (val < rawExtentOnDim[0]) {
          rawExtentOnDim[0] = val;
        }

        if (val > rawExtentOnDim[1]) {
          rawExtentOnDim[1] = val;
        }
      }
    }
  }

  return list;
};
/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */


listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
  var list = cloneListForMapAndSample(this, [dimension]);
  var targetStorage = list._storage;
  var frameValues = [];
  var frameSize = Math.floor(1 / rate);
  var dimStore = targetStorage[dimension];
  var len = this.count();
  var chunkSize = this._chunkSize;
  var rawExtentOnDim = list._rawExtent[dimension];
  var newIndices = new (getIndicesCtor(this))(len);
  var offset = 0;

  for (var i = 0; i < len; i += frameSize) {
    // Last frame
    if (frameSize > len - i) {
      frameSize = len - i;
      frameValues.length = frameSize;
    }

    for (var k = 0; k < frameSize; k++) {
      var dataIdx = this.getRawIndex(i + k);
      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
      var originalChunkOffset = dataIdx % chunkSize;
      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
    }

    var value = sampleValue(frameValues);
    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data

    dimStore[sampleChunkIndex][sampleChunkOffset] = value;

    if (value < rawExtentOnDim[0]) {
      rawExtentOnDim[0] = value;
    }

    if (value > rawExtentOnDim[1]) {
      rawExtentOnDim[1] = value;
    }

    newIndices[offset++] = sampleFrameIdx;
  }

  list._count = offset;
  list._indices = newIndices;
  list.getRawIndex = getRawIndexWithIndices;
  return list;
};
/**
 * Get model of one data item.
 *
 * @param {number} idx
 */
// FIXME Model proxy ?


listProto.getItemModel = function (idx) {
  var hostModel = this.hostModel;
  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
};
/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */


listProto.diff = function (otherList) {
  var thisList = this;
  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
    return getId(otherList, idx);
  }, function (idx) {
    return getId(thisList, idx);
  });
};
/**
 * Get visual property.
 * @param {string} key
 */


listProto.getVisual = function (key) {
  var visual = this._visual;
  return visual && visual[key];
};
/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */


listProto.setVisual = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setVisual(name, key[name]);
      }
    }

    return;
  }

  this._visual = this._visual || {};
  this._visual[key] = val;
};
/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */


listProto.setLayout = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setLayout(name, key[name]);
      }
    }

    return;
  }

  this._layout[key] = val;
};
/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */


listProto.getLayout = function (key) {
  return this._layout[key];
};
/**
 * Get layout of single data item
 * @param {number} idx
 */


listProto.getItemLayout = function (idx) {
  return this._itemLayouts[idx];
};
/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */


listProto.setItemLayout = function (idx, layout, merge) {
  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
};
/**
 * Clear all layout of single data item
 */


listProto.clearItemLayouts = function () {
  this._itemLayouts.length = 0;
};
/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */


listProto.getItemVisual = function (idx, key, ignoreParent) {
  var itemVisual = this._itemVisuals[idx];
  var val = itemVisual && itemVisual[key];

  if (val == null && !ignoreParent) {
    // Use global visual property
    return this.getVisual(key);
  }

  return val;
};
/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */


listProto.setItemVisual = function (idx, key, value) {
  var itemVisual = this._itemVisuals[idx] || {};
  var hasItemVisual = this.hasItemVisual;
  this._itemVisuals[idx] = itemVisual;

  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        itemVisual[name] = key[name];
        hasItemVisual[name] = true;
      }
    }

    return;
  }

  itemVisual[key] = value;
  hasItemVisual[key] = true;
};
/**
 * Clear itemVisuals and list visual.
 */


listProto.clearAllVisual = function () {
  this._visual = {};
  this._itemVisuals = [];
  this.hasItemVisual = {};
};

var setItemDataAndSeriesIndex = function (child) {
  child.seriesIndex = this.seriesIndex;
  child.dataIndex = this.dataIndex;
  child.dataType = this.dataType;
};
/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */


listProto.setItemGraphicEl = function (idx, el) {
  var hostModel = this.hostModel;

  if (el) {
    // Add data index and series index for indexing the data by element
    // Useful in tooltip
    el.dataIndex = idx;
    el.dataType = this.dataType;
    el.seriesIndex = hostModel && hostModel.seriesIndex;

    if (el.type === 'group') {
      el.traverse(setItemDataAndSeriesIndex, el);
    }
  }

  this._graphicEls[idx] = el;
};
/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */


listProto.getItemGraphicEl = function (idx) {
  return this._graphicEls[idx];
};
/**
 * @param {Function} cb
 * @param {*} context
 */


listProto.eachItemGraphicEl = function (cb, context) {
  zrUtil.each(this._graphicEls, function (el, idx) {
    if (el) {
      cb && cb.call(context, el, idx);
    }
  });
};
/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */


listProto.cloneShallow = function (list) {
  if (!list) {
    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
    list = new List(dimensionInfoList, this.hostModel);
  } // FIXME


  list._storage = this._storage;
  transferProperties(list, this); // Clone will not change the data extent and indices

  if (this._indices) {
    var Ctor = this._indices.constructor;
    list._indices = new Ctor(this._indices);
  } else {
    list._indices = null;
  }

  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
  return list;
};
/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */


listProto.wrapMethod = function (methodName, injectFunction) {
  var originalMethod = this[methodName];

  if (typeof originalMethod !== 'function') {
    return;
  }

  this.__wrappedMethods = this.__wrappedMethods || [];

  this.__wrappedMethods.push(methodName);

  this[methodName] = function () {
    var res = originalMethod.apply(this, arguments);
    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
  };
}; // Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.


listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.

listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
var _default = List;
module.exports = _default;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @class
 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
 */
function DataDimensionInfo(opt) {
  if (opt != null) {
    zrUtil.extend(this, opt);
  }
  /**
   * Dimension name.
   * Mandatory.
   * @type {string}
   */
  // this.name;

  /**
   * The origin name in dimsDef, see source helper.
   * If displayName given, the tooltip will displayed vertically.
   * Optional.
   * @type {string}
   */
  // this.displayName;

  /**
   * Which coordSys dimension this dimension mapped to.
   * A `coordDim` can be a "coordSysDim" that the coordSys required
   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
   * (That is determined by whether `isExtraCoord` is `true`).
   * Mandatory.
   * @type {string}
   */
  // this.coordDim;

  /**
   * The index of this dimension in `series.encode[coordDim]`.
   * Mandatory.
   * @type {number}
   */
  // this.coordDimIndex;

  /**
   * Dimension type. The enumerable values are the key of
   * `dataCtors` of `data/List`.
   * Optional.
   * @type {string}
   */
  // this.type;

  /**
   * This index of this dimension info in `data/List#_dimensionInfos`.
   * Mandatory after added to `data/List`.
   * @type {number}
   */
  // this.index;

  /**
   * The format of `otherDims` is:
   * ```js
   * {
   *     tooltip: number optional,
   *     label: number optional,
   *     itemName: number optional,
   *     seriesName: number optional,
   * }
   * ```
   *
   * A `series.encode` can specified these fields:
   * ```js
   * encode: {
   *     // "3, 1, 5" is the index of data dimension.
   *     tooltip: [3, 1, 5],
   *     label: [0, 3],
   *     ...
   * }
   * ```
   * `otherDims` is the parse result of the `series.encode` above, like:
   * ```js
   * // Suppose the index of this data dimension is `3`.
   * this.otherDims = {
   *     // `3` is at the index `0` of the `encode.tooltip`
   *     tooltip: 0,
   *     // `3` is at the index `1` of the `encode.tooltip`
   *     label: 1
   * };
   * ```
   *
   * This prop should never be `null`/`undefined` after initialized.
   * @type {Object}
   */


  this.otherDims = {};
  /**
   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
   * "coordSys" required.
   * Mandatory.
   * @type {boolean}
   */
  // this.isExtraCoord;

  /**
   * @type {module:data/OrdinalMeta}
   */
  // this.ordinalMeta;

  /**
   * Whether to create inverted indices.
   * @type {boolean}
   */
  // this.createInvertedIndices;
}

;
var _default = DataDimensionInfo;
module.exports = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var completeDimensions = __webpack_require__(285);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Substitute `completeDimensions`.
 * `completeDimensions` is to be deprecated.
 */

/**
 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
 * @param {Object|Array} [opt]
 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
 * @param {number} [opt.dimensionsCount]
 * @param {string} [opt.generateCoord]
 * @param {string} [opt.generateCoordCount]
 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
 * @return {Array.<Object>} dimensionsInfo
 */
function _default(source, opt) {
  opt = opt || {};
  return completeDimensions(opt.coordDimensions || [], source, {
    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
    encodeDef: opt.encodeDefine || source.encodeDefine,
    dimCount: opt.dimensionsCount,
    encodeDefaulter: opt.encodeDefaulter,
    generateCoord: opt.generateCoord,
    generateCoordCount: opt.generateCoordCount
  });
}

module.exports = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var each = _util.each;
var isString = _util.isString;
var defaults = _util.defaults;
var extend = _util.extend;
var isObject = _util.isObject;
var clone = _util.clone;

var _model = __webpack_require__(13);

var normalizeToArray = _model.normalizeToArray;

var _sourceHelper = __webpack_require__(100);

var guessOrdinal = _sourceHelper.guessOrdinal;
var BE_ORDINAL = _sourceHelper.BE_ORDINAL;

var Source = __webpack_require__(101);

var _dimensionHelper = __webpack_require__(181);

var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;

var DataDimensionInfo = __webpack_require__(283);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @deprecated
 * Use `echarts/data/helper/createDimensions` instead.
 */

/**
 * @see {module:echarts/test/ut/spec/data/completeDimensions}
 *
 * This method builds the relationship between:
 * + "what the coord sys or series requires (see `sysDims`)",
 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
 * + "what the data source provids (see `source`)".
 *
 * Some guess strategy will be adapted if user does not define something.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      properties: 'name', 'type', 'displayName'.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
 *                                    provide dims count that the sysDim required.
 *      [{ordinalMeta}] can be specified.
 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
 *      If not specified, auto find the next available data dim.
 *      param source {module:data/Source}
 *      param dimCount {number}
 *      return {Object} encode Never be `null/undefined`.
 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
 *      If not specified, extra dim names will be:
 *      'value', 'value0', 'value1', ...
 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
 *      If `generateCoordCount` specified, the generated dim names will be:
 *      `generateCoord` + 0, `generateCoord` + 1, ...
 *      can be Infinity, indicate that use all of the remain columns.
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @return {Array.<module:data/DataDimensionInfo>}
 */
function completeDimensions(sysDims, source, opt) {
  if (!Source.isInstance(source)) {
    source = Source.seriesDataToSource(source);
  }

  opt = opt || {};
  sysDims = (sysDims || []).slice();
  var dimsDef = (opt.dimsDef || []).slice();
  var dataDimNameMap = createHashMap();
  var coordDimNameMap = createHashMap(); // var valueCandidate;

  var result = [];
  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.

  for (var i = 0; i < dimCount; i++) {
    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
      name: dimsDef[i]
    });
    var userDimName = dimDefItem.name;
    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      // Only if `series.dimensions` is defined in option
      // displayName, will be set, and dimension will be diplayed vertically in
      // tooltip by default.
      resultItem.name = resultItem.displayName = userDimName;
      dataDimNameMap.set(userDimName, i);
    }

    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
  }

  var encodeDef = opt.encodeDef;

  if (!encodeDef && opt.encodeDefaulter) {
    encodeDef = opt.encodeDefaulter(source, dimCount);
  }

  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.

  encodeDef.each(function (dataDims, coordDim) {
    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
    // this case.

    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
      encodeDef.set(coordDim, false);
      return;
    }

    var validDataDims = encodeDef.set(coordDim, []);
    each(dataDims, function (resultDimIdx, idx) {
      // The input resultDimIdx can be dim name or index.
      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        validDataDims[idx] = resultDimIdx;
        applyDim(result[resultDimIdx], coordDim, idx);
      }
    });
  }); // Apply templetes and default order from `sysDims`.

  var availDimIdx = 0;
  each(sysDims, function (sysDimItem, sysDimIndex) {
    var coordDim;
    var sysDimItem;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;

    if (isString(sysDimItem)) {
      coordDim = sysDimItem;
      sysDimItem = {};
    } else {
      coordDim = sysDimItem.name;
      var ordinalMeta = sysDimItem.ordinalMeta;
      sysDimItem.ordinalMeta = null;
      sysDimItem = clone(sysDimItem);
      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.

    if (dataDims === false) {
      return;
    }

    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < result.length && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    each(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = result[resultDimIdx];
      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
          name: sysDimItemDimsDefItem
        });
        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}


      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
    });
  });

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (OTHER_DIMENSIONS.get(coordDim) != null) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  } // Make sure the first extra dim is 'value'.


  var generateCoord = opt.generateCoord;
  var generateCoordCount = opt.generateCoordCount;
  var fromZero = generateCoordCount != null;
  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.

  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
    var coordDim = resultItem.coordDim;

    if (coordDim == null) {
      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
      resultItem.coordDimIndex = 0;

      if (!generateCoord || generateCoordCount <= 0) {
        resultItem.isExtraCoord = true;
      }

      generateCoordCount--;
    }

    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));

    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
    // {
    //    dataset: {source: [
    //        ['2001', 123],
    //        ['2002', 456],
    //        ...
    //        ['The others', 987],
    //    ]},
    //    series: {type: 'pie'}
    // }
    // The first colum should better be treated as a "ordinal" although it
    // might not able to be detected as an "ordinal" by `guessOrdinal`.
    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
      resultItem.type = 'ordinal';
    }
  }

  return result;
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in storage?


function getDimCount(source, sysDims, dimsDef, optDimCount) {
  // Note that the result dimCount should not small than columns count
  // of data, otherwise `dataDimNameMap` checking will be incorrect.
  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
  each(sysDims, function (sysDimItem) {
    var sysDimItemDimsDef = sysDimItem.dimsDef;
    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
  });
  return dimCount;
}

function genName(name, map, fromZero) {
  if (fromZero || map.get(name) != null) {
    var i = 0;

    while (map.get(name + i) != null) {
      i++;
    }

    name += i;
  }

  map.set(name, true);
  return name;
}

var _default = completeDimensions;
module.exports = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var isObject = _util.isObject;
var map = _util.map;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @constructor
 * @param {Object} [opt]
 * @param {Object} [opt.categories=[]]
 * @param {Object} [opt.needCollect=false]
 * @param {Object} [opt.deduplication=false]
 */
function OrdinalMeta(opt) {
  /**
   * @readOnly
   * @type {Array.<string>}
   */
  this.categories = opt.categories || [];
  /**
   * @private
   * @type {boolean}
   */

  this._needCollect = opt.needCollect;
  /**
   * @private
   * @type {boolean}
   */

  this._deduplication = opt.deduplication;
  /**
   * @private
   * @type {boolean}
   */

  this._map;
}
/**
 * @param {module:echarts/model/Model} axisModel
 * @return {module:echarts/data/OrdinalMeta}
 */


OrdinalMeta.createByAxisModel = function (axisModel) {
  var option = axisModel.option;
  var data = option.data;
  var categories = data && map(data, getName);
  return new OrdinalMeta({
    categories: categories,
    needCollect: !categories,
    // deduplication is default in axis.
    deduplication: option.dedplication !== false
  });
};

var proto = OrdinalMeta.prototype;
/**
 * @param {string} category
 * @return {number} ordinal
 */

proto.getOrdinal = function (category) {
  return getOrCreateMap(this).get(category);
};
/**
 * @param {*} category
 * @return {number} The ordinal. If not found, return NaN.
 */


proto.parseAndCollect = function (category) {
  var index;
  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
  // This feature is only supported when !needCollect, because we should
  // consider a common case: a value is 2017, which is a number but is
  // expected to be tread as a category. This case usually happen in dataset,
  // where it happent to be no need of the index feature.

  if (typeof category !== 'string' && !needCollect) {
    return category;
  } // Optimize for the scenario:
  // category is ['2012-01-01', '2012-01-02', ...], where the input
  // data has been ensured not duplicate and is large data.
  // Notice, if a dataset dimension provide categroies, usually echarts
  // should remove duplication except user tell echarts dont do that
  // (set axis.deduplication = false), because echarts do not know whether
  // the values in the category dimension has duplication (consider the
  // parallel-aqi example)


  if (needCollect && !this._deduplication) {
    index = this.categories.length;
    this.categories[index] = category;
    return index;
  }

  var map = getOrCreateMap(this);
  index = map.get(category);

  if (index == null) {
    if (needCollect) {
      index = this.categories.length;
      this.categories[index] = category;
      map.set(category, index);
    } else {
      index = NaN;
    }
  }

  return index;
}; // Consider big data, do not create map until needed.


function getOrCreateMap(ordinalMeta) {
  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
}

function getName(obj) {
  if (isObject(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

var _default = OrdinalMeta;
module.exports = _default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var numberUtil = __webpack_require__(28);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * For testable.
 */
var roundNumber = numberUtil.round;
/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = numberUtil.nice(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
/**
 * @param {number} interval
 * @return {number} interval precision
 */


function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return numberUtil.getPrecisionSafe(interval) + 2;
}

function clamp(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp(niceTickExtent, 0, extent);
  clamp(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}

exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
exports.getIntervalPrecision = getIntervalPrecision;
exports.fixExtent = fixExtent;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import * as axisHelper from './axisHelper';
var _default = {
  /**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */
  getMin: function (origin) {
    var option = this.option;
    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;

    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
      min = this.axis.scale.parse(min);
    }

    return min;
  },

  /**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */
  getMax: function (origin) {
    var option = this.option;
    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;

    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
      max = this.axis.scale.parse(max);
    }

    return max;
  },

  /**
   * @return {boolean}
   */
  getNeedCrossZero: function () {
    var option = this.option;
    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
  },

  /**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */
  getCoordSysModel: zrUtil.noop,

  /**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */
  setRange: function (rangeStart, rangeEnd) {
    this.option.rangeStart = rangeStart;
    this.option.rangeEnd = rangeEnd;
  },

  /**
   * Reset range
   */
  resetRange: function () {
    // rangeStart and rangeEnd is readonly.
    this.option.rangeStart = this.option.rangeEnd = null;
  }
};
module.exports = _default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;
var map = _util.map;

var _number = __webpack_require__(28);

var linearMap = _number.linearMap;
var getPixelPrecision = _number.getPixelPrecision;
var round = _number.round;

var _axisTickLabelBuilder = __webpack_require__(862);

var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var NORMALIZED_EXTENT = [0, 1];
/**
 * Base class of Axis.
 * @constructor
 */

var Axis = function (dim, scale, extent) {
  /**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
   * @type {string}
   */
  this.dim = dim;
  /**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */

  this.scale = scale;
  /**
   * @type {Array.<number>}
   * @private
   */

  this._extent = extent || [0, 0];
  /**
   * @type {boolean}
   */

  this.inverse = false;
  /**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */

  this.onBand = false;
};

Axis.prototype = {
  constructor: Axis,

  /**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  },

  /**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.scale.contain(data);
  },

  /**
   * Get coord extent.
   * @return {Array.<number>}
   */
  getExtent: function () {
    return this._extent.slice();
  },

  /**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */
  getPixelPrecision: function (dataExtent) {
    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
  },

  /**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  },

  /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */
  dataToCoord: function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
  },

  /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */
  coordToData: function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
    return this.scale.scale(t);
  },

  /**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */
  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
  },

  /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param {Object} [opt]
   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
   * @param {boolean} [opt.clamp] If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   * @return {Array.<Object>} [{
   *     coord: ...,
   *     tickValue: ...
   * }, ...]
   */
  getTicksCoords: function (opt) {
    opt = opt || {};
    var tickModel = opt.tickModel || this.getTickModel();
    var result = createAxisTicks(this, tickModel);
    var ticks = result.ticks;
    var ticksCoords = map(ticks, function (tickValue) {
      return {
        coord: this.dataToCoord(tickValue),
        tickValue: tickValue
      };
    }, this);
    var alignWithLabel = tickModel.get('alignWithLabel');
    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
    return ticksCoords;
  },

  /**
   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
   */
  getMinorTicksCoords: function () {
    if (this.scale.type === 'ordinal') {
      // Category axis doesn't support minor ticks
      return [];
    }

    var minorTickModel = this.model.getModel('minorTick');
    var splitNumber = minorTickModel.get('splitNumber'); // Protection.

    if (!(splitNumber > 0 && splitNumber < 100)) {
      splitNumber = 5;
    }

    var minorTicks = this.scale.getMinorTicks(splitNumber);
    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
      return map(minorTicksGroup, function (minorTick) {
        return {
          coord: this.dataToCoord(minorTick),
          tickValue: minorTick
        };
      }, this);
    }, this);
    return minorTicksCoords;
  },

  /**
   * @return {Array.<Object>} [{
   *     formattedLabel: string,
   *     rawLabel: axis.scale.getLabel(tickValue)
   *     tickValue: number
   * }, ...]
   */
  getViewLabels: function () {
    return createAxisLabels(this).labels;
  },

  /**
   * @return {module:echarts/coord/model/Model}
   */
  getLabelModel: function () {
    return this.model.getModel('axisLabel');
  },

  /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   * @return {module:echarts/coord/model/Model}
   */
  getTickModel: function () {
    return this.model.getModel('axisTick');
  },

  /**
   * Get width of band
   * @return {number}
   */
  getBandWidth: function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  },

  /**
   * @abstract
   * @return {boolean} Is horizontal
   */
  isHorizontal: null,

  /**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */
  getRotate: null,

  /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return {number} Auto interval for cateogry axis tick and label
   */
  calculateCategoryInterval: function () {
    return calculateCategoryInterval(this);
  }
};

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).


function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
  var ticksLen = ticksCoords.length;

  if (!axis.onBand || alignWithLabel || !ticksLen) {
    return;
  }

  var axisExtent = axis.getExtent();
  var last;
  var diffSize;

  if (ticksLen === 1) {
    ticksCoords[0].coord = axisExtent[0];
    last = ticksCoords[1] = {
      coord: axisExtent[0]
    };
  } else {
    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
    each(ticksCoords, function (ticksItem) {
      ticksItem.coord -= shift / 2;
    });
    var dataExtent = axis.scale.getExtent();
    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
    last = {
      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
    };
    ticksCoords.push(last);
  }

  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.

  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
  }

  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
    ticksCoords.unshift({
      coord: axisExtent[0]
    });
  }

  if (littleThan(axisExtent[1], last.coord)) {
    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
  }

  if (clamp && littleThan(last.coord, axisExtent[1])) {
    ticksCoords.push({
      coord: axisExtent[1]
    });
  }

  function littleThan(a, b) {
    // Avoid rounding error cause calculated tick coord different with extent.
    // It may cause an extra unecessary tick added.
    a = round(a);
    b = round(b);
    return inverse ? a > b : a < b;
  }
}

var _default = Axis;
module.exports = _default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var _symbol = __webpack_require__(130);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(17);

var _number = __webpack_require__(28);

var parsePercent = _number.parsePercent;

var _labelHelper = __webpack_require__(867);

var getDefaultLabel = _labelHelper.getDefaultLabel;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/Symbol
 */

/**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */
function SymbolClz(data, idx, seriesScope) {
  graphic.Group.call(this);
  this.updateData(data, idx, seriesScope);
}

var symbolProto = SymbolClz.prototype;
/**
 * @public
 * @static
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {Array.<number>} [width, height]
 */

var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
  var symbolSize = data.getItemVisual(idx, 'symbolSize');
  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
};

function getScale(symbolSize) {
  return [symbolSize[0] / 2, symbolSize[1] / 2];
}

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
  // Remove paths created before
  this.removeAll();
  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
  //     symbolType, -0.5, -0.5, 1, 1, color
  // );
  // If width/height are set too small (e.g., set to 1) on ios10
  // and macOS Sierra, a circle stroke become a rect, no matter what
  // the scale is set. So we set width/height as 2. See #4150.

  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
  symbolPath.attr({
    z2: 100,
    culling: true,
    scale: getScale(symbolSize)
  }); // Rewrite drift method

  symbolPath.drift = driftSymbol;
  this._symbolType = symbolType;
  this.add(symbolPath);
};
/**
 * Stop animation
 * @param {boolean} toLastFrame
 */


symbolProto.stopSymbolAnimation = function (toLastFrame) {
  this.childAt(0).stopAnimation(toLastFrame);
};
/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */


symbolProto.getSymbolPath = function () {
  return this.childAt(0);
};
/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */


symbolProto.getScale = function () {
  return this.childAt(0).scale;
};
/**
 * Highlight symbol
 */


symbolProto.highlight = function () {
  this.childAt(0).trigger('emphasis');
};
/**
 * Downplay symbol
 */


symbolProto.downplay = function () {
  this.childAt(0).trigger('normal');
};
/**
 * @param {number} zlevel
 * @param {number} z
 */


symbolProto.setZ = function (zlevel, z) {
  var symbolPath = this.childAt(0);
  symbolPath.zlevel = zlevel;
  symbolPath.z = z;
};

symbolProto.setDraggable = function (draggable) {
  var symbolPath = this.childAt(0);
  symbolPath.draggable = draggable;
  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
};
/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */


symbolProto.updateData = function (data, idx, seriesScope) {
  this.silent = false;
  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
  var seriesModel = data.hostModel;
  var symbolSize = getSymbolSize(data, idx);
  var isInit = symbolType !== this._symbolType;

  if (isInit) {
    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');

    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
  } else {
    var symbolPath = this.childAt(0);
    symbolPath.silent = false;
    graphic.updateProps(symbolPath, {
      scale: getScale(symbolSize)
    }, seriesModel, idx);
  }

  this._updateCommon(data, idx, symbolSize, seriesScope);

  if (isInit) {
    var symbolPath = this.childAt(0);
    var fadeIn = seriesScope && seriesScope.fadeIn;
    var target = {
      scale: symbolPath.scale.slice()
    };
    fadeIn && (target.style = {
      opacity: symbolPath.style.opacity
    });
    symbolPath.scale = [0, 0];
    fadeIn && (symbolPath.style.opacity = 0);
    graphic.initProps(symbolPath, target, seriesModel, idx);
  }

  this._seriesModel = seriesModel;
}; // Update common properties


var normalStyleAccessPath = ['itemStyle'];
var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
var normalLabelAccessPath = ['label'];
var emphasisLabelAccessPath = ['emphasis', 'label'];
/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */

symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
  var symbolPath = this.childAt(0);
  var seriesModel = data.hostModel;
  var color = data.getItemVisual(idx, 'color'); // Reset style

  if (symbolPath.type !== 'image') {
    symbolPath.useStyle({
      strokeNoScale: true
    });
  } else {
    symbolPath.setStyle({
      opacity: null,
      shadowBlur: null,
      shadowOffsetX: null,
      shadowOffsetY: null,
      shadowColor: null
    });
  }

  var itemStyle = seriesScope && seriesScope.itemStyle;
  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
  var symbolRotate = seriesScope && seriesScope.symbolRotate;
  var symbolOffset = seriesScope && seriesScope.symbolOffset;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
  var cursorStyle = seriesScope && seriesScope.cursorStyle;

  if (!seriesScope || data.hasItemOption) {
    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke

    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
    symbolRotate = itemModel.getShallow('symbolRotate');
    symbolOffset = itemModel.getShallow('symbolOffset');
    labelModel = itemModel.getModel(normalLabelAccessPath);
    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
    hoverAnimation = itemModel.getShallow('hoverAnimation');
    cursorStyle = itemModel.getShallow('cursor');
  } else {
    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
  }

  var elStyle = symbolPath.style;
  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);

  if (symbolOffset) {
    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
  }

  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!

  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
  symbolPath.setStyle(itemStyle);
  var opacity = data.getItemVisual(idx, 'opacity');

  if (opacity != null) {
    elStyle.opacity = opacity;
  }

  var liftZ = data.getItemVisual(idx, 'liftZ');
  var z2Origin = symbolPath.__z2Origin;

  if (liftZ != null) {
    if (z2Origin == null) {
      symbolPath.__z2Origin = symbolPath.z2;
      symbolPath.z2 += liftZ;
    }
  } else if (z2Origin != null) {
    symbolPath.z2 = z2Origin;
    symbolPath.__z2Origin = null;
  }

  var useNameLabel = seriesScope && seriesScope.useNameLabel;
  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
    labelFetcher: seriesModel,
    labelDataIndex: idx,
    defaultText: getLabelDefaultText,
    isRectText: true,
    autoColor: color
  }); // Do not execute util needed.

  function getLabelDefaultText(idx, opt) {
    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
  }

  symbolPath.__symbolOriginalScale = getScale(symbolSize);
  symbolPath.hoverStyle = hoverItemStyle;
  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
  graphic.setHoverStyle(symbolPath);
};

function highDownOnUpdate(fromState, toState) {
  // Do not support this hover animation util some scenario required.
  // Animation can only be supported in hover layer when using `el.incremetal`.
  if (this.incremental || this.useHoverLayer) {
    return;
  }

  if (toState === 'emphasis') {
    var scale = this.__symbolOriginalScale;
    var ratio = scale[1] / scale[0];
    var emphasisOpt = {
      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
    }; // FIXME
    // modify it after support stop specified animation.
    // toState === fromState
    //     ? (this.stopAnimation(), this.attr(emphasisOpt))

    this.animateTo(emphasisOpt, 400, 'elasticOut');
  } else if (toState === 'normal') {
    this.animateTo({
      scale: this.__symbolOriginalScale
    }, 400, 'elasticOut');
  }
}
/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */


symbolProto.fadeOut = function (cb, opt) {
  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out

  this.silent = symbolPath.silent = true; // Not show text when animating

  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
  graphic.updateProps(symbolPath, {
    style: {
      opacity: 0
    },
    scale: [0, 0]
  }, this._seriesModel, this.dataIndex, cb);
};

zrUtil.inherits(SymbolClz, graphic.Group);
var _default = SymbolClz;
module.exports = _default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataStackHelper = __webpack_require__(85);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

var _util = __webpack_require__(2);

var map = _util.map;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} coordSys
 * @param {module:echarts/data/List} data
 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
 */
function prepareDataCoordInfo(coordSys, data, valueOrigin) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = getValueStart(valueAxis, valueOrigin);
  var baseAxisDim = baseAxis.dim;
  var valueAxisDim = valueAxis.dim;
  var valueDim = data.mapDimension(valueAxisDim);
  var baseDim = data.mapDimension(baseAxisDim);
  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
  var dims = map(coordSys.dimensions, function (coordDim) {
    return data.mapDimension(coordDim);
  });
  var stacked;
  var stackResultDim = data.getCalculationInfo('stackResultDimension');

  if (stacked |= isDimensionStacked(data, dims[0]
  /*, dims[1]*/
  )) {
    // jshint ignore:line
    dims[0] = stackResultDim;
  }

  if (stacked |= isDimensionStacked(data, dims[1]
  /*, dims[0]*/
  )) {
    // jshint ignore:line
    dims[1] = stackResultDim;
  }

  return {
    dataDimsForPoint: dims,
    valueStart: valueStart,
    valueAxisDim: valueAxisDim,
    baseAxisDim: baseAxisDim,
    stacked: !!stacked,
    valueDim: valueDim,
    baseDim: baseDim,
    baseDataOffset: baseDataOffset,
    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
  };
}

function getValueStart(valueAxis, valueOrigin) {
  var valueStart = 0;
  var extent = valueAxis.scale.getExtent();

  if (valueOrigin === 'start') {
    valueStart = extent[0];
  } else if (valueOrigin === 'end') {
    valueStart = extent[1];
  } // auto
  else {
      // Both positive
      if (extent[0] > 0) {
        valueStart = extent[0];
      } // Both negative
      else if (extent[1] < 0) {
          valueStart = extent[1];
        } // If is one positive, and one negative, onZero shall be true

    }

  return valueStart;
}

function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
  var value = NaN;

  if (dataCoordInfo.stacked) {
    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
  }

  if (isNaN(value)) {
    value = dataCoordInfo.valueStart;
  }

  var baseDataOffset = dataCoordInfo.baseDataOffset;
  var stackedData = [];
  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
  stackedData[1 - baseDataOffset] = value;
  return coordSys.dataToPoint(stackedData);
}

exports.prepareDataCoordInfo = prepareDataCoordInfo;
exports.getStackedOnPoint = getStackedOnPoint;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var ComponentModel = __webpack_require__(56);

var axisModelCreator = __webpack_require__(880);

var axisModelCommonMixin = __webpack_require__(288);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisModel = ComponentModel.extend({
  type: 'cartesian2dAxis',

  /**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */
  axis: null,

  /**
   * @override
   */
  init: function () {
    AxisModel.superApply(this, 'init', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  mergeOption: function () {
    AxisModel.superApply(this, 'mergeOption', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  restoreData: function () {
    AxisModel.superApply(this, 'restoreData', arguments);
    this.resetRange();
  },

  /**
   * @override
   * @return {module:echarts/model/Component}
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'grid',
      index: this.option.gridIndex,
      id: this.option.gridId
    })[0];
  }
});

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  // Offset is for multiple axis on the same position
  offset: 0
};
axisModelCreator('x', AxisModel, getAxisType, extraOption);
axisModelCreator('y', AxisModel, getAxisType, extraOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var retrieve = _util.retrieve;
var defaults = _util.defaults;
var extend = _util.extend;
var each = _util.each;

var formatUtil = __webpack_require__(44);

var graphic = __webpack_require__(17);

var Model = __webpack_require__(55);

var _number = __webpack_require__(28);

var isRadianAroundZero = _number.isRadianAroundZero;
var remRadian = _number.remRadian;

var _symbol = __webpack_require__(130);

var createSymbol = _symbol.createSymbol;

var matrixUtil = __webpack_require__(74);

var _vector = __webpack_require__(26);

var v2ApplyTransform = _vector.applyTransform;

var _axisHelper = __webpack_require__(86);

var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */

var AxisBuilder = function (axisModel, opt) {
  /**
   * @readOnly
   */
  this.opt = opt;
  /**
   * @readOnly
   */

  this.axisModel = axisModel; // Default value

  defaults(opt, {
    labelOffset: 0,
    nameDirection: 1,
    tickDirection: 1,
    labelDirection: 1,
    silent: true
  });
  /**
   * @readOnly
   */

  this.group = new graphic.Group(); // FIXME Not use a seperate text group?

  var dumbGroup = new graphic.Group({
    position: opt.position.slice(),
    rotation: opt.rotation
  }); // this.group.add(dumbGroup);
  // this._dumbGroup = dumbGroup;

  dumbGroup.updateTransform();
  this._transform = dumbGroup.transform;
  this._dumbGroup = dumbGroup;
};

AxisBuilder.prototype = {
  constructor: AxisBuilder,
  hasBuilder: function (name) {
    return !!builders[name];
  },
  add: function (name) {
    builders[name].call(this);
  },
  getGroup: function () {
    return this.group;
  }
};
var builders = {
  /**
   * @private
   */
  axisLine: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;

    if (!axisModel.get('axisLine.show')) {
      return;
    }

    var extent = this.axisModel.axis.getExtent();
    var matrix = this._transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    }

    var lineStyle = extend({
      lineCap: 'round'
    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
    this.group.add(new graphic.Line({
      // Id for animation
      anid: 'line',
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    }));
    var arrows = axisModel.get('axisLine.symbol');
    var arrowSize = axisModel.get('axisLine.symbolSize');
    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;

    if (typeof arrowOffset === 'number') {
      arrowOffset = [arrowOffset, arrowOffset];
    }

    if (arrows != null) {
      if (typeof arrows === 'string') {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var symbolWidth = arrowSize[0];
      var symbolHeight = arrowSize[1];
      each([{
        rotate: opt.rotation + Math.PI / 2,
        offset: arrowOffset[0],
        r: 0
      }, {
        rotate: opt.rotation - Math.PI / 2,
        offset: arrowOffset[1],
        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
      }], function (point, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset

          var r = point.r + point.offset;
          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
          symbol.attr({
            rotation: point.rotate,
            position: pos,
            silent: true,
            z2: 11
          });
          this.group.add(symbol);
        }
      }, this);
    }
  },

  /**
   * @private
   */
  axisTickLabel: function () {
    var axisModel = this.axisModel;
    var opt = this.opt;
    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
    var labelEls = buildAxisLabel(this, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
    buildAxisMinorTicks(this, axisModel, opt);
  },

  /**
   * @private
   */
  axisName: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;
    var name = retrieve(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = this.axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
    // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
    // truncate rich text? (consider performance)

    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
      minChar: 2,
      placeholder: truncateOpt.placeholder
    }) : name;
    var tooltipOpt = axisModel.get('tooltip', true);
    var mainType = axisModel.mainType;
    var formatterParams = {
      componentType: mainType,
      name: name,
      $vars: ['name']
    };
    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'name',
      __fullText: name,
      __truncatedText: truncatedText,
      position: pos,
      rotation: labelLayout.rotation,
      silent: isLabelSilent(axisModel),
      z2: 1,
      tooltip: tooltipOpt && tooltipOpt.show ? extend({
        content: name,
        formatter: function () {
          return name;
        },
        formatterParams: formatterParams
      }, tooltipOpt) : null
    });
    graphic.setTextStyle(textEl.style, textStyleModel, {
      text: truncatedText,
      textFont: textFont,
      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
    });

    if (axisModel.get('triggerEvent')) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisName';
      textEl.eventData.name = name;
    } // FIXME


    this._dumbGroup.add(textEl);

    textEl.updateTransform();
    this.group.add(textEl);
    textEl.decomposeTransform();
  }
};

var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
  var eventData = {
    componentType: axisModel.mainType,
    componentIndex: axisModel.componentIndex
  };
  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
  return eventData;
};
/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */


var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
  var rotationDiff = remRadian(textRotation - axisRotation);
  var textAlign;
  var textVerticalAlign;

  if (isRadianAroundZero(rotationDiff)) {
    // Label is parallel with axis line.
    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI)) {
    // Label is inverse parallel with axis line.
    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff > 0 && rotationDiff < PI) {
      textAlign = direction > 0 ? 'right' : 'left';
    } else {
      textAlign = direction > 0 ? 'left' : 'right';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
};

function endTextLayout(opt, textPosition, textRotate, extent) {
  var rotationDiff = remRadian(textRotate - opt.rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (isRadianAroundZero(rotationDiff - PI / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
  var tooltipOpt = axisModel.get('tooltip');
  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
};

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  if (shouldShowAllLabels(axisModel.axis)) {
    return;
  } // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label


  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next, labelLayout) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = matrixUtil.identity([]);
  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}

function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
  var tickEls = [];
  var pt1 = [];
  var pt2 = [];

  for (var i = 0; i < ticksCoords.length; i++) {
    var tickCoord = ticksCoords[i].coord;
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = tickEndCoord;

    if (tickTransform) {
      v2ApplyTransform(pt1, pt1, tickTransform);
      v2ApplyTransform(pt2, pt2, tickTransform);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new graphic.Line({
      // Id for animation
      anid: aniid + '_' + ticksCoords[i].tickValue,
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: tickLineStyle,
      z2: 2,
      silent: true
    });
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var tickModel = axisModel.getModel('axisTick');

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * tickModel.get('length');
  var ticksCoords = axis.getTicksCoords();
  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
    stroke: axisModel.get('axisLine.lineStyle.color')
  }), 'ticks');

  for (var i = 0; i < ticksEls.length; i++) {
    axisBuilder.group.add(ticksEls[i]);
  }

  return ticksEls;
}

function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var minorTickModel = axisModel.getModel('minorTick');

  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var minorTicksCoords = axis.getMinorTicksCoords();

  if (!minorTicksCoords.length) {
    return;
  }

  var lineStyleModel = minorTickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
    stroke: axisModel.get('axisLine.lineStyle.color')
  }));

  for (var i = 0; i < minorTicksCoords.length; i++) {
    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);

    for (var k = 0; k < minorTicksEls.length; k++) {
      axisBuilder.group.add(minorTicksEls[k]);
    }
  }
}

function buildAxisLabel(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var labels = axis.getViewLabels(); // Special label rotate.

  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
  var labelEls = [];
  var silent = isLabelSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  each(labels, function (labelItem, index) {
    var tickValue = labelItem.tickValue;
    var formattedLabel = labelItem.formattedLabel;
    var rawLabel = labelItem.rawLabel;
    var itemLabelModel = labelModel;

    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
    var tickCoord = axis.dataToCoord(tickValue);
    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'label_' + tickValue,
      position: pos,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10
    });
    graphic.setTextStyle(textEl.style, itemLabelModel, {
      text: formattedLabel,
      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
      // index of axis.data. So tick should not be exposed to user
      // in category axis.
      // (2) Compatible with previous version, which always use formatted label as
      // input. But in interval scale the formatted label is like '223,445', which
      // maked user repalce ','. So we modify it to return original val but remain
      // it as 'string' to avoid error in replacing.
      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
    }); // Pack data for mouse event

    if (triggerEvent) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisLabel';
      textEl.eventData.value = rawLabel;
    } // FIXME


    axisBuilder._dumbGroup.add(textEl);

    textEl.updateTransform();
    labelEls.push(textEl);
    axisBuilder.group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

var _default = AxisBuilder;
module.exports = _default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(24);

var axisPointerModelHelper = __webpack_require__(131);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Base class of AxisView.
 */
var AxisView = echarts.extendComponentView({
  type: 'axis',

  /**
   * @private
   */
  _axisPointer: null,

  /**
   * @protected
   * @type {string}
   */
  axisPointerClass: null,

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
    AxisView.superApply(this, 'render', arguments);
    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
  },

  /**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */
  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
    AxisView.superApply(this, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    disposeAxisPointer(this, api);
    AxisView.superApply(this, 'dispose', arguments);
  }
});

function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);

  if (!Clazz) {
    return;
  }

  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
}

function disposeAxisPointer(axisView, ecModel, api) {
  var axisPointer = axisView._axisPointer;
  axisPointer && axisPointer.dispose(ecModel, api);
  axisView._axisPointer = null;
}

var axisPointerClazz = [];

AxisView.registerAxisPointerClass = function (type, clazz) {
  axisPointerClazz[type] = clazz;
};

AxisView.getAxisPointerClass = function (type) {
  return type && axisPointerClazz[type];
};

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 *
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, z2
 * }
 */
function layout(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
  var rawAxisPosition = axis.position;
  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (otherAxisOnZeroOf) {
    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get('axisLabel.rotate');
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var modelUtil = __webpack_require__(13);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */
function _default(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = modelUtil.queryDataIndex(data, finder);

  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
      return data.mapDimension(dim);
    }), dataIndex, true)) || [];
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

module.exports = _default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var env = __webpack_require__(25);

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
var each = zrUtil.each;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  inner(zr).records || (inner(zr).records = {});
  initGlobalListeners(zr, api);
  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (inner(zr).initialized) {
    return;
  }

  inner(zr).initialized = true;
  useHandler('click', zrUtil.curry(doEnter, 'click'));
  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each(inner(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */


function unregister(key, api) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  var record = (inner(zr).records || {})[key];

  if (record) {
    inner(zr).records[key] = null;
  }
}

exports.register = register;
exports.unregister = unregister;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

var textContain = __webpack_require__(75);

var formatUtil = __webpack_require__(44);

var matrix = __webpack_require__(74);

var axisHelper = __webpack_require__(86);

var AxisBuilder = __webpack_require__(293);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/model/Model} axisPointerModel
 */
function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */


function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get('label.precision'),
    formatter: axisPointerModel.get('label.formatter')
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = textContain.getBoundingRect(text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get('axisLine.lineStyle.color');
  }

  elOption.label = {
    shape: {
      x: 0,
      y: 0,
      width: width,
      height: height,
      r: labelModel.get('borderRadius')
    },
    position: position.slice(),
    // TODO: rich
    style: {
      text: text,
      textFont: font,
      textFill: labelModel.getTextColor(),
      textPosition: 'inside',
      textPadding: paddings,
      fill: bgColor,
      stroke: labelModel.get('borderColor') || 'transparent',
      lineWidth: labelModel.get('borderWidth') || 0,
      shadowBlur: labelModel.get('shadowBlur'),
      shadowColor: labelModel.get('shadowColor'),
      shadowOffsetX: labelModel.get('shadowOffsetX'),
      shadowOffsetY: labelModel.get('shadowOffsetY')
    },
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container


function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}
/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */


function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  value = axis.scale.parse(value);
  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
  // helps to debounce when when moving label.
  value, {
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params = {
      value: axisHelper.getAxisRawValue(axis, value),
      axisDimension: axis.dim,
      axisIndex: axis.index,
      seriesData: []
    };
    zrUtil.each(seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params.seriesData.push(dataParams);
    });

    if (zrUtil.isString(formatter)) {
      text = formatter.replace('{value}', text);
    } else if (zrUtil.isFunction(formatter)) {
      text = formatter(params);
    }
  }

  return text;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */


function getTransformedPosition(axis, value, layoutInfo) {
  var transform = matrix.create();
  matrix.rotate(transform, transform, layoutInfo.rotation);
  matrix.translate(transform, transform, layoutInfo.position);
  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}

function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */


function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */


function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}

function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

exports.buildElStyle = buildElStyle;
exports.buildLabelElOption = buildLabelElOption;
exports.getValueLabel = getValueLabel;
exports.getTransformedPosition = getTransformedPosition;
exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
exports.makeLineShape = makeLineShape;
exports.makeRectShape = makeRectShape;
exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
module.exports = __webpack_require__(307);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(303).enable();
  window.Promise = __webpack_require__(305);
}

// fetch() polyfill for making API calls.
__webpack_require__(306);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(132);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(183);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(183);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 306 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalize_css__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animate_css__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RouteComponent_main__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_eruda__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_eruda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_eruda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_env__ = __webpack_require__(121);
// import registerServiceWorker from './registerServiceWorker';
if(__WEBPACK_IMPORTED_MODULE_8__api_env__["a" /* default */].env!=="pre"&&__WEBPACK_IMPORTED_MODULE_8__api_env__["a" /* default */].env!=="prod"){__WEBPACK_IMPORTED_MODULE_7_eruda___default.a.init({useShadowDom:true});}__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_RouteComponent_main__["a" /* default */],null)),document.getElementById("root"));// registerServiceWorker();

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(132),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(310),ca=__webpack_require__(1),m=__webpack_require__(311),p=__webpack_require__(132),v=__webpack_require__(312),da=__webpack_require__(313),ea=__webpack_require__(314),fa=__webpack_require__(315),ha=__webpack_require__(318);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(316);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(317);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(320);

__webpack_require__(517);

__webpack_require__(518);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(321);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(154);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(202);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(205);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
module.exports = __webpack_require__(39);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(30);
var META = __webpack_require__(58).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(104);
var setToStringTag = __webpack_require__(77);
var uid = __webpack_require__(65);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(185);
var wksDefine = __webpack_require__(134);
var enumKeys = __webpack_require__(322);
var isArray = __webpack_require__(107);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var toIObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(45);
var createDesc = __webpack_require__(64);
var _create = __webpack_require__(68);
var gOPNExt = __webpack_require__(188);
var $GOPD = __webpack_require__(36);
var $DP = __webpack_require__(15);
var $keys = __webpack_require__(66);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(69).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(88).f = $propertyIsEnumerable;
  __webpack_require__(106).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(59)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(29)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(66);
var gOPS = __webpack_require__(106);
var pIE = __webpack_require__(88);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(68) });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(187) });


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(35);
var $getOwnPropertyDescriptor = __webpack_require__(36).f;

__webpack_require__(48)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(19);
var $getPrototypeOf = __webpack_require__(37);

__webpack_require__(48)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19);
var $keys = __webpack_require__(66);

__webpack_require__(48)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(48)('getOwnPropertyNames', function () {
  return __webpack_require__(188).f;
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(58).onFreeze;

__webpack_require__(48)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(58).onFreeze;

__webpack_require__(48)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(58).onFreeze;

__webpack_require__(48)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(11);

__webpack_require__(48)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(11);

__webpack_require__(48)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(11);

__webpack_require__(48)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(189) });


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(338) });


/***/ }),
/* 338 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(138).set });


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(89);
var test = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(30)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(190) });


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(37);
var HAS_INSTANCE = __webpack_require__(12)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(192);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(193);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var has = __webpack_require__(34);
var cof = __webpack_require__(41);
var inheritIfRequired = __webpack_require__(140);
var toPrimitive = __webpack_require__(45);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(69).f;
var gOPD = __webpack_require__(36).f;
var dP = __webpack_require__(15).f;
var $trim = __webpack_require__(78).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(68)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(30)(global, NUMBER, $Number);
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(47);
var aNumberValue = __webpack_require__(194);
var repeat = __webpack_require__(141);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(194);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(8).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(195) });


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(195);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(193);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(192);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(196);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(142);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(143);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(197) });


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(196) });


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(142) });


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(143);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(143);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(67);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var toLength = __webpack_require__(16);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(78)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(144)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(145)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(144)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(147);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(148)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(147);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(148)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(141)
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(147);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(148)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(31)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(31)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(31)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(31)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(31)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(31)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(31)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(31)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(31)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(31)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(31)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(31)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(31)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(45);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(400);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(30)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(12)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(29)(proto, TO_PRIMITIVE, __webpack_require__(403));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(45);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(107) });


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(40);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(149);
var toLength = __webpack_require__(16);
var createProperty = __webpack_require__(150);
var getIterFn = __webpack_require__(151);

$export($export.S + $export.F * !__webpack_require__(109)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(150);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(87) != Object || !__webpack_require__(42)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(137);
var cof = __webpack_require__(41);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(16);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(23);
var toObject = __webpack_require__(19);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(42)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(49)(0);
var STRICT = __webpack_require__(42)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var isArray = __webpack_require__(107);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(49)(1);

$export($export.P + $export.F * !__webpack_require__(42)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(49)(2);

$export($export.P + $export.F * !__webpack_require__(42)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(49)(3);

$export($export.P + $export.F * !__webpack_require__(42)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(49)(4);

$export($export.P + $export.F * !__webpack_require__(42)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(199);

$export($export.P + $export.F * !__webpack_require__(42)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(199);

$export($export.P + $export.F * !__webpack_require__(42)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(105)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(35);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(42)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(200) });

__webpack_require__(60)('copyWithin');


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(153) });

__webpack_require__(60)('fill');


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(49)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(60)(KEY);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(49)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(60)(KEY);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70)('Array');


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inheritIfRequired = __webpack_require__(140);
var dP = __webpack_require__(15).f;
var gOPN = __webpack_require__(69).f;
var isRegExp = __webpack_require__(108);
var $flags = __webpack_require__(110);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(30)(global, 'RegExp', $RegExp);
}

__webpack_require__(70)('RegExp');


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(202);
var anObject = __webpack_require__(6);
var $flags = __webpack_require__(110);
var DESCRIPTORS = __webpack_require__(14);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(30)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(111)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(111)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(111)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(111)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(108);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var global = __webpack_require__(8);
var ctx = __webpack_require__(40);
var classof = __webpack_require__(89);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var aFunction = __webpack_require__(23);
var anInstance = __webpack_require__(71);
var forOf = __webpack_require__(72);
var speciesConstructor = __webpack_require__(112);
var task = __webpack_require__(155).set;
var microtask = __webpack_require__(156)();
var newPromiseCapabilityModule = __webpack_require__(157);
var perform = __webpack_require__(203);
var userAgent = __webpack_require__(113);
var promiseResolve = __webpack_require__(204);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(73)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(77)($Promise, PROMISE);
__webpack_require__(70)(PROMISE);
Wrapper = __webpack_require__(39)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(109)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(209);
var validate = __webpack_require__(80);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(114)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(115);
var buffer = __webpack_require__(158);
var anObject = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(67);
var toLength = __webpack_require__(16);
var isObject = __webpack_require__(11);
var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
var speciesConstructor = __webpack_require__(112);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(70)(ARRAY_BUFFER);


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(115).ABV, {
  DataView: __webpack_require__(158).DataView
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(23);
var anObject = __webpack_require__(6);
var rApply = (__webpack_require__(8).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(68);
var aFunction = __webpack_require__(23);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var bind = __webpack_require__(190);
var rConstruct = (__webpack_require__(8).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(15);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(45);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(36).f;
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(146)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(37);
var has = __webpack_require__(34);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(6);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(36);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(37);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(211) });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(15);
var gOPD = __webpack_require__(36);
var getPrototypeOf = __webpack_require__(37);
var has = __webpack_require__(34);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(64);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(138);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(105)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(60)('includes');


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(212);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(16);
var aFunction = __webpack_require__(23);
var arraySpeciesCreate = __webpack_require__(152);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(60)('flatMap');


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(212);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(16);
var toInteger = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(152);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(60)('flatten');


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(144)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(213);
var userAgent = __webpack_require__(113);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(213);
var userAgent = __webpack_require__(113);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(78)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(78)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(46);
var toLength = __webpack_require__(16);
var isRegExp = __webpack_require__(108);
var getFlags = __webpack_require__(110);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(146)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('asyncIterator');


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('observable');


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(211);
var toIObject = __webpack_require__(35);
var gOPD = __webpack_require__(36);
var createProperty = __webpack_require__(150);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(214)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(214)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(23);
var $defineProperty = __webpack_require__(15);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(14) && $export($export.P + __webpack_require__(116), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(23);
var $defineProperty = __webpack_require__(15);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(14) && $export($export.P + __webpack_require__(116), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(37);
var getOwnPropertyDescriptor = __webpack_require__(36).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(116), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(37);
var getOwnPropertyDescriptor = __webpack_require__(36).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(116), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(215)('Map') });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(215)('Set') });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(117)('Map');


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(117)('Set');


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(117)('WeakMap');


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(117)('WeakSet');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(118)('Map');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(118)('Set');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(118)('WeakMap');


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(118)('WeakSet');


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(41);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(217);
var fround = __webpack_require__(197);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(217) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(39);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(112);
var promiseResolve = __webpack_require__(204);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(157);
var perform = __webpack_require__(203);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(37);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(207);
var from = __webpack_require__(216);
var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(37);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(37);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(51);
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(23);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(156)();
var process = __webpack_require__(8).process;
var isNode = __webpack_require__(41)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(8);
var core = __webpack_require__(39);
var microtask = __webpack_require__(156)();
var OBSERVABLE = __webpack_require__(12)('observable');
var aFunction = __webpack_require__(23);
var anObject = __webpack_require__(6);
var anInstance = __webpack_require__(71);
var redefineAll = __webpack_require__(73);
var hide = __webpack_require__(29);
var forOf = __webpack_require__(72);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(70)('Observable');


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(113);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(155);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(154);
var getKeys = __webpack_require__(66);
var redefine = __webpack_require__(30);
var global = __webpack_require__(8);
var hide = __webpack_require__(29);
var Iterators = __webpack_require__(79);
var wks = __webpack_require__(12);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76)))

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(519);
module.exports = __webpack_require__(39).RegExp.escape;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(520)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memberPage_MemberPage__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__payPage_AppPayPage__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__payPage_WebPayPage__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__payPage_H5PayPage__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__customerPage_DownloadPage__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__payPage_Paylink__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sharePage_SharePage__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__payPage_SuccessPage__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__customerPage_RulesPage__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__guidePage_GuidePage__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__privacyPage_privacyPage__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_agreement_index__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_agreementPd_index__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__homeworkNewPage_HomeworkPage__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__homeworkNewPage_CarriagePage__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__homeworkNewPage_ArcheryPage__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__homeworkNewPage_CastlePage__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__homeworkNewPage_HomeworkResultPage__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__courseDetailPage_CourseDetailPage__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__phonicsDetailPage_PhonicsDetaiPage__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__memberNewPage_MemberNewPage__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__experimentOrderPage_AddressPage__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__experimentOrderPage_NASAPayPage__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__experimentOrderPage_DiscountCouponPage__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__experimentOrderPage_LogisticsPage__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__paymentAgreement_paymentAgreement__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__UniversePayPage_UniversePayPage__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__customerPage_achievementRules__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__puDetailPage_puDetailPage__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__feedbackPage_feedbackPage__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__feedbackPage_feedbackDetailPage__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__dailyAttendancePage__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__dailyAttendancePage_rules__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__addAddressPage__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__customerPage_RulesPageBinguo__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__privacyPage_privacyBinguoPage__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__customerPage_RulesPageOMO__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__privacyPage_privacyOMO__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__anniversaryPage_anniversary__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__privacyPage_privacy2Page__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__privacyPage_privacy3Page__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__privacyPage_privacy4Page__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__privacyPage_privacyPd__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__privacyPage_ServiceusePage__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__privacyPage_privacyBinguo2Page__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__courseOutlinePage_courseOutline1Page__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__courseOutlinePage_courseOutline2Page__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__courseOutlinePage_courseOutline3Page__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__courseOutlinePage_courseOutlinePro1Page__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__courseOutlinePage_courseOutlinePro2Page__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__courseOutlinePage_courseOutlinePro3Page__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__courseOutlinePage_courseOutlinePro4Page__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__courseOutlinePage_courseOutlinePro5Page__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__courseOutlinePage_courseOutlinePro6Page__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__courseOutlinePage_courseOutlinePro7Page__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__courseOutlinePage_courseOutlinePro8Page__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__diamondShop__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__guideWXPage__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__testPage_webview__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__learningReport__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__readWorks__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__bannerArticle_page1__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__bannerArticle_page2__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__account_logoff__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__account_manage__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__classRegularPlan_classRegularPlan__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__lesson2_organization__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__lesson2_orgSelect__ = __webpack_require__(917);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AXIOS from '../../api/axios';
// pc、pad会员中心
// h5支付
// 下载页
// 扫码支付页
// 作业分享页
// 支付成功页
// 用户协议
// 新手引导
// 隐私协议
// 爱课用户服务协议
// 爱课精品小班用户服务协议
// 作业主页
// 作业冰淇淋车
// 作业射箭
// 作业烟花
// 作业结果页
// 课程详情
// 课程详情
// 会员中心页
// nasa收货地址
// nasa支付页
// 选择优惠券页面
// 物流详情页
// 用户支付协议
// 每日打卡页
// 每日打卡规则详情页
// 每日打卡页
// 客户端banner静态页面1
// 客户端banner静态页面2
// 账号注销
// 账号管理
// 学习计划
var RouteComponent=function(_React$Component){_inherits(RouteComponent,_React$Component);function RouteComponent(props){_classCallCheck(this,RouteComponent);var _this=_possibleConstructorReturn(this,(RouteComponent.__proto__||Object.getPrototypeOf(RouteComponent)).call(this,props));__WEBPACK_IMPORTED_MODULE_41__utils_tools__["e" /* myStorage */].init();_this.storage=__WEBPACK_IMPORTED_MODULE_41__utils_tools__["e" /* myStorage */];_this.state={};return _this;}_createClass(RouteComponent,[{key:"componentWillMount",value:function componentWillMount(){var clientData={token:"",device:""};if(__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].ACClient){var _ref=JSON.parse(__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].getClientDataSync({data:["token","device","userId","channel"]}))||{},token=_ref.token,device=_ref.device,userId=_ref.userId,channel=_ref.channel;clientData={token:token};clientData.device=device||"Android";this.storage.setItem("ac_token",token);this.storage.setItem("ac_id",userId);this.storage.setItem("ac_device",device);this.storage.setItem("channelId",channel);}else{// if(!window.localStorage.getItem('ac_token')){
//   AXIOS.login({
//     data:{phone:'18072791152',smsCode:200420,channel:'PC', debug:1}
//   },function(res,err){
//     if(err) console.log(err);
//     else{
//       window.token = res.accessToken;
//       window.localStorage.setItem('ac_token', res.accessToken);
//       window.localStorage.setItem('ac_id', res.id);
//       window.location.reload();
//     }
//   })
// }
}this.storage.setItem("panda_client_data",JSON.stringify(clientData));}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_3__api_web__["b" /* apiDefine */])({apiName:"sendClientData",fn:function fn(res){if(res){var data=JSON.parse(res);window.myContext=Object.assign({},window.myContext,data);}}});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/webpay",component:__WEBPACK_IMPORTED_MODULE_9__payPage_WebPayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/apppay",component:__WEBPACK_IMPORTED_MODULE_8__payPage_AppPayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/h5pay",component:__WEBPACK_IMPORTED_MODULE_10__payPage_H5PayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/paylink",component:__WEBPACK_IMPORTED_MODULE_12__payPage_Paylink__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/share",component:__WEBPACK_IMPORTED_MODULE_13__sharePage_SharePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/success",component:__WEBPACK_IMPORTED_MODULE_14__payPage_SuccessPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/customerrules",component:__WEBPACK_IMPORTED_MODULE_15__customerPage_RulesPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/customerrules-binguo",component:__WEBPACK_IMPORTED_MODULE_42__customerPage_RulesPageBinguo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/customerrules-omo",component:__WEBPACK_IMPORTED_MODULE_44__customerPage_RulesPageOMO__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/achievementrules",component:__WEBPACK_IMPORTED_MODULE_34__customerPage_achievementRules__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/download",component:__WEBPACK_IMPORTED_MODULE_11__customerPage_DownloadPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/member",component:__WEBPACK_IMPORTED_MODULE_7__memberPage_MemberPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/membernew",component:__WEBPACK_IMPORTED_MODULE_27__memberNewPage_MemberNewPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/guide",component:__WEBPACK_IMPORTED_MODULE_16__guidePage_GuidePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy",component:__WEBPACK_IMPORTED_MODULE_17__privacyPage_privacyPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy2",component:__WEBPACK_IMPORTED_MODULE_47__privacyPage_privacy2Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy3",component:__WEBPACK_IMPORTED_MODULE_48__privacyPage_privacy3Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacyPd",component:__WEBPACK_IMPORTED_MODULE_50__privacyPage_privacyPd__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/VRsafe",component:__WEBPACK_IMPORTED_MODULE_49__privacyPage_privacy4Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/Serviceuse",component:__WEBPACK_IMPORTED_MODULE_51__privacyPage_ServiceusePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy-binguo",component:__WEBPACK_IMPORTED_MODULE_52__privacyPage_privacyBinguo2Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy-binguo2",component:__WEBPACK_IMPORTED_MODULE_43__privacyPage_privacyBinguoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/privacy-omo",component:__WEBPACK_IMPORTED_MODULE_45__privacyPage_privacyOMO__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/address",component:__WEBPACK_IMPORTED_MODULE_28__experimentOrderPage_AddressPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/nasamk",component:__WEBPACK_IMPORTED_MODULE_29__experimentOrderPage_NASAPayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/phonicsmk",component:__WEBPACK_IMPORTED_MODULE_33__UniversePayPage_UniversePayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/universemk",component:__WEBPACK_IMPORTED_MODULE_33__UniversePayPage_UniversePayPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/discountcoupon",component:__WEBPACK_IMPORTED_MODULE_30__experimentOrderPage_DiscountCouponPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/paymentAgreement",component:__WEBPACK_IMPORTED_MODULE_32__paymentAgreement_paymentAgreement__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/logistics",component:__WEBPACK_IMPORTED_MODULE_31__experimentOrderPage_LogisticsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/nasadetail",component:__WEBPACK_IMPORTED_MODULE_25__courseDetailPage_CourseDetailPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/phonicsdetail",component:__WEBPACK_IMPORTED_MODULE_26__phonicsDetailPage_PhonicsDetaiPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/pudetail",component:__WEBPACK_IMPORTED_MODULE_35__puDetailPage_puDetailPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/coursedetail",component:__WEBPACK_IMPORTED_MODULE_25__courseDetailPage_CourseDetailPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/index",component:__WEBPACK_IMPORTED_MODULE_20__homeworkNewPage_HomeworkPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/result",component:__WEBPACK_IMPORTED_MODULE_24__homeworkNewPage_HomeworkResultPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{exact:true,from:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework",to:{pathname:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/index",search:window.location.search}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/castle/:index",component:__WEBPACK_IMPORTED_MODULE_23__homeworkNewPage_CastlePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/archery/:index",component:__WEBPACK_IMPORTED_MODULE_22__homeworkNewPage_ArcheryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/homework/carriage/:index",component:__WEBPACK_IMPORTED_MODULE_21__homeworkNewPage_CarriagePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/feedback/:id",component:__WEBPACK_IMPORTED_MODULE_37__feedbackPage_feedbackDetailPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/feedback",component:__WEBPACK_IMPORTED_MODULE_36__feedbackPage_feedbackPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/anniversary",component:__WEBPACK_IMPORTED_MODULE_46__anniversaryPage_anniversary__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-p1",component:__WEBPACK_IMPORTED_MODULE_53__courseOutlinePage_courseOutline1Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-p2",component:__WEBPACK_IMPORTED_MODULE_54__courseOutlinePage_courseOutline2Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-p3",component:__WEBPACK_IMPORTED_MODULE_55__courseOutlinePage_courseOutline3Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro1",component:__WEBPACK_IMPORTED_MODULE_56__courseOutlinePage_courseOutlinePro1Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro2",component:__WEBPACK_IMPORTED_MODULE_57__courseOutlinePage_courseOutlinePro2Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro3",component:__WEBPACK_IMPORTED_MODULE_58__courseOutlinePage_courseOutlinePro3Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro4",component:__WEBPACK_IMPORTED_MODULE_59__courseOutlinePage_courseOutlinePro4Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro5",component:__WEBPACK_IMPORTED_MODULE_60__courseOutlinePage_courseOutlinePro5Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro6",component:__WEBPACK_IMPORTED_MODULE_61__courseOutlinePage_courseOutlinePro6Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro7",component:__WEBPACK_IMPORTED_MODULE_62__courseOutlinePage_courseOutlinePro7Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/courseoutline-pro8",component:__WEBPACK_IMPORTED_MODULE_63__courseOutlinePage_courseOutlinePro8Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/diamondshop",component:__WEBPACK_IMPORTED_MODULE_64__diamondShop__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/guidewx",component:__WEBPACK_IMPORTED_MODULE_65__guideWXPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/testPage",component:__WEBPACK_IMPORTED_MODULE_66__testPage_webview__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/learning-report",component:__WEBPACK_IMPORTED_MODULE_67__learningReport__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/agreement",component:__WEBPACK_IMPORTED_MODULE_18__components_agreement_index__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/agreementPd",component:__WEBPACK_IMPORTED_MODULE_19__components_agreementPd_index__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/daily/attendance/rules",component:__WEBPACK_IMPORTED_MODULE_39__dailyAttendancePage_rules__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/daily/attendance",component:__WEBPACK_IMPORTED_MODULE_38__dailyAttendancePage__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/daily/address",component:__WEBPACK_IMPORTED_MODULE_40__addAddressPage__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/read/works",component:__WEBPACK_IMPORTED_MODULE_68__readWorks__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/banner/article1",component:__WEBPACK_IMPORTED_MODULE_69__bannerArticle_page1__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/banner/article2",component:__WEBPACK_IMPORTED_MODULE_70__bannerArticle_page2__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/account/logoff",component:__WEBPACK_IMPORTED_MODULE_71__account_logoff__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/account/manage",component:__WEBPACK_IMPORTED_MODULE_72__account_manage__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/classRegularPlan",component:__WEBPACK_IMPORTED_MODULE_73__classRegularPlan_classRegularPlan__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/lesson2/organization",component:__WEBPACK_IMPORTED_MODULE_74__lesson2_organization__["a" /* default */],exact:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* COURSE_URL */]+"/lesson2/org-select",component:__WEBPACK_IMPORTED_MODULE_75__lesson2_orgSelect__["a" /* default */],exact:true}));}}]);return RouteComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(RouteComponent));

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(526);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(218);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(218);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(160);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(534);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(162);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(219);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(538);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(540);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(542);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(162);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(544);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(163);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(223);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(163);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(548);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ua__ = __webpack_require__(4);
var iosSend=function iosSend(data){if(!window.prompt)return{};return prompt(JSON.stringify(data));};var windowSend=function windowSend(data){if(!window.prompt)return{};return prompt(JSON.stringify(data));};var androidSend=function androidSend(data){if(!window.JsToAndroid){return{};}return window.JsToAndroid.prompt(JSON.stringify(data));};var createNewTask=function createNewTask(tag){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};console.log('params',Object.assign({timeStamp:new Date().getTime(),msgTag:tag},params));var data=Object.assign({msgTag:tag},params);if(__WEBPACK_IMPORTED_MODULE_0__utils_ua__["a" /* default */].iosClient)return iosSend(data);else if(__WEBPACK_IMPORTED_MODULE_0__utils_ua__["a" /* default */].androidClient||__WEBPACK_IMPORTED_MODULE_0__utils_ua__["a" /* default */].androidTabClient)return androidSend(data);else if(__WEBPACK_IMPORTED_MODULE_0__utils_ua__["a" /* default */].winClient)return windowSend(data);};/* harmony default export */ __webpack_exports__["a"] = (createNewTask);

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_vip_png__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_vip_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_images_vip_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_vip_no_png__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_vip_no_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_images_vip_no_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryObj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var MemberPage=function(_Component){_inherits(MemberPage,_Component);function MemberPage(props){_classCallCheck(this,MemberPage);var _this=_possibleConstructorReturn(this,(MemberPage.__proto__||Object.getPrototypeOf(MemberPage)).call(this,props));_this.state={expireDate:null,completeRander:true};return _this;}_createClass(MemberPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){if(err){// alert(JSON.stringify(err))
}else{// alert(JSON.stringify(res))
if(res[0]){var expireDate=new Date(res[0].expireDate).getTime()+86400000;console.log(expireDate-new Date().getTime());_this2.setState({expireDate:expireDate-new Date().getTime()>0?res[0].expireDate:null,completeRander:true});}else{_this2.setState({completeRander:true});}}});}},{key:'render',value:function render(){console.log(this.state.expireDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'会员中心'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.state.completeRander?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container member'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.expireDate?__WEBPACK_IMPORTED_MODULE_6__static_images_vip_png___default.a:__WEBPACK_IMPORTED_MODULE_7__static_images_vip_no_png___default.a,alt:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.state.expireDate?'哈佛外教百科英语课程包':'您还不是哈佛外教百科英语课程的会员哦'),this.state.expireDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u6709\u6548\u671F\u81F3\uFF1A',this.state.expireDate):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u8BFE\u7A0B\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u8D2D\u4E70\u540E\u8BF7\u5728\u6709\u6548\u671F\u5185\u4F7F\u7528\uFF0C\u6B64\u8BFE\u7A0B\u4EC5\u9650\u4E8E\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u8BFE\u7A0B\u7CFB\u5217\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.\u83B7\u53D6\u5176\u5B83\u5BA2\u6237\u7AEF\u4E0B\u8F7D\u94FE\u63A5\u548C\u66F4\u591A\u6D3B\u52A8\u4FE1\u606F\uFF0C\u8BF7\u5173\u6CE8\u201C\u7231\u8BFEAirCourse\u201D\u670D\u52A1\u53F7\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.\u8D2D\u4E70\u540E7\u65E5\u5185\u53EF\u65E0\u7406\u7531\u9000\u6B3E\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.\u5982\u6709\u5176\u5B83\u4EFB\u4F55\u7591\u95EE\uFF0C\u8BF7\u8054\u7CFB4008-874-877\u3002')))):null,!this.state.completeRander?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Load_Load__["a" /* default */],null):null));}}]);return MemberPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MemberPage);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(1);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(554));
var shallowEqual = _interopDefault(__webpack_require__(555));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 555 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(557);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNotPNG = isNotPNG;
exports.isNotAPNG = isNotAPNG;
exports.default = parseAPNG;

var _crc = __webpack_require__(559);

var _crc2 = _interopRequireDefault(_crc);

var _structs = __webpack_require__(560);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errNotPNG = new Error('Not a PNG');
var errNotAPNG = new Error('Not an animated PNG');

function isNotPNG(err) {
    return err === errNotPNG;
}
function isNotAPNG(err) {
    return err === errNotAPNG;
}

// '\x89PNG\x0d\x0a\x1a\x0a'
var PNGSignature = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);

/**
 * Parse APNG data
 * @param {ArrayBuffer} buffer
 * @return {APNG|Error}
 */
function parseAPNG(buffer) {
    var bytes = new Uint8Array(buffer);

    if (Array.prototype.some.call(PNGSignature, function (b, i) {
        return b !== bytes[i];
    })) {
        return errNotPNG;
    }

    // fast animation test
    var isAnimated = false;
    eachChunk(bytes, function (type) {
        return !(isAnimated = type === 'acTL');
    });
    if (!isAnimated) {
        return errNotAPNG;
    }

    var preDataParts = [],
        postDataParts = [];
    var headerDataBytes = null,
        frame = null,
        frameNumber = 0,
        apng = new _structs.APNG();

    eachChunk(bytes, function (type, bytes, off, length) {
        var dv = new DataView(bytes.buffer);
        switch (type) {
            case 'IHDR':
                headerDataBytes = bytes.subarray(off + 8, off + 8 + length);
                apng.width = dv.getUint32(off + 8);
                apng.height = dv.getUint32(off + 12);
                break;
            case 'acTL':
                apng.numPlays = dv.getUint32(off + 8 + 4);
                break;
            case 'fcTL':
                if (frame) {
                    apng.frames.push(frame);
                    frameNumber++;
                }
                frame = new _structs.Frame();
                frame.width = dv.getUint32(off + 8 + 4);
                frame.height = dv.getUint32(off + 8 + 8);
                frame.left = dv.getUint32(off + 8 + 12);
                frame.top = dv.getUint32(off + 8 + 16);
                var delayN = dv.getUint16(off + 8 + 20);
                var delayD = dv.getUint16(off + 8 + 22);
                if (delayD === 0) {
                    delayD = 100;
                }
                frame.delay = 1000 * delayN / delayD;
                // https://bugzilla.mozilla.org/show_bug.cgi?id=125137
                // https://bugzilla.mozilla.org/show_bug.cgi?id=139677
                // https://bugzilla.mozilla.org/show_bug.cgi?id=207059
                if (frame.delay <= 10) {
                    frame.delay = 100;
                }
                apng.playTime += frame.delay;
                frame.disposeOp = dv.getUint8(off + 8 + 24);
                frame.blendOp = dv.getUint8(off + 8 + 25);
                frame.dataParts = [];
                if (frameNumber === 0 && frame.disposeOp === 2) {
                    frame.disposeOp = 1;
                }
                break;
            case 'fdAT':
                if (frame) {
                    frame.dataParts.push(bytes.subarray(off + 8 + 4, off + 8 + length));
                }
                break;
            case 'IDAT':
                if (frame) {
                    frame.dataParts.push(bytes.subarray(off + 8, off + 8 + length));
                }
                break;
            case 'IEND':
                postDataParts.push(subBuffer(bytes, off, 12 + length));
                break;
            default:
                preDataParts.push(subBuffer(bytes, off, 12 + length));
        }
    });

    if (frame) {
        apng.frames.push(frame);
    }

    if (apng.frames.length == 0) {
        return errNotAPNG;
    }

    var preBlob = new Blob(preDataParts),
        postBlob = new Blob(postDataParts);

    apng.frames.forEach(function (frame) {
        var bb = [];
        bb.push(PNGSignature);
        headerDataBytes.set(makeDWordArray(frame.width), 0);
        headerDataBytes.set(makeDWordArray(frame.height), 4);
        bb.push(makeChunkBytes('IHDR', headerDataBytes));
        bb.push(preBlob);
        frame.dataParts.forEach(function (p) {
            return bb.push(makeChunkBytes('IDAT', p));
        });
        bb.push(postBlob);
        frame.imageData = new Blob(bb, { 'type': 'image/png' });
        delete frame.dataParts;
        bb = null;
    });

    return apng;
}

/**
 * @param {Uint8Array} bytes
 * @param {function(string, Uint8Array, int, int): boolean} callback
 */
function eachChunk(bytes, callback) {
    var dv = new DataView(bytes.buffer);
    var off = 8,
        type = void 0,
        length = void 0,
        res = void 0;
    do {
        length = dv.getUint32(off);
        type = readString(bytes, off + 4, 4);
        res = callback(type, bytes, off, length);
        off += 12 + length;
    } while (res !== false && type != 'IEND' && off < bytes.length);
}

/**
 *
 * @param {Uint8Array} bytes
 * @param {number} off
 * @param {number} length
 * @return {string}
 */
function readString(bytes, off, length) {
    var chars = Array.prototype.slice.call(bytes.subarray(off, off + length));
    return String.fromCharCode.apply(String, chars);
}

/**
 *
 * @param {string} x
 * @return {Uint8Array}
 */
function makeStringArray(x) {
    var res = new Uint8Array(x.length);
    for (var i = 0; i < x.length; i++) {
        res[i] = x.charCodeAt(i);
    }
    return res;
}

/**
 * @param {Uint8Array} bytes
 * @param {int} start
 * @param {int} length
 * @return {Uint8Array}
 */
function subBuffer(bytes, start, length) {
    var a = new Uint8Array(length);
    a.set(bytes.subarray(start, start + length));
    return a;
}

/**
 * @param {string} type
 * @param {Uint8Array} dataBytes
 * @return {Uint8Array}
 */
var makeChunkBytes = function makeChunkBytes(type, dataBytes) {
    var crcLen = type.length + dataBytes.length;
    var bytes = new Uint8Array(crcLen + 8);
    var dv = new DataView(bytes.buffer);

    dv.setUint32(0, dataBytes.length);
    bytes.set(makeStringArray(type), 4);
    bytes.set(dataBytes, 8);
    var crc = (0, _crc2.default)(bytes, 4, crcLen);
    dv.setUint32(crcLen + 4, crc);
    return bytes;
};

var makeDWordArray = function makeDWordArray(x) {
    return new Uint8Array([x >>> 24 & 0xff, x >>> 16 & 0xff, x >>> 8 & 0xff, x & 0xff]);
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : bytes.length - start;

  var crc = -1;
  for (var _i = start, l = start + length; _i < l; _i++) {
    crc = crc >>> 8 ^ table[(crc ^ bytes[_i]) & 0xFF];
  }
  return crc ^ -1;
};

var table = new Uint32Array(256);

for (var i = 0; i < 256; i++) {
  var c = i;
  for (var k = 0; k < 8; k++) {
    c = (c & 1) !== 0 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
  }
  table[i] = c;
}

/**
 *
 * @param {Uint8Array} bytes
 * @param {number} start
 * @param {number} length
 * @return {number}
 */
;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Frame = exports.APNG = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _player = __webpack_require__(561);

var _player2 = _interopRequireDefault(_player);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @property {number} currFrameNumber
 * @property {Frame} currFrame
 * @property {boolean} paused
 * @property {boolean} ended
 */
var APNG = exports.APNG = function () {
    function APNG() {
        _classCallCheck(this, APNG);

        this.width = 0;
        this.height = 0;
        this.numPlays = 0;
        this.playTime = 0;
        this.frames = [];
    }
    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {Frame[]} */


    _createClass(APNG, [{
        key: 'createImages',


        /**
         *
         * @return {Promise.<*>}
         */
        value: function createImages() {
            return Promise.all(this.frames.map(function (f) {
                return f.createImage();
            }));
        }

        /**
         *
         * @param {CanvasRenderingContext2D} context
         * @param {boolean} autoPlay
         * @return {Promise.<Player>}
         */

    }, {
        key: 'getPlayer',
        value: function getPlayer(context) {
            var _this = this;

            var autoPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.createImages().then(function () {
                return new _player2.default(_this, context, autoPlay);
            });
        }
    }]);

    return APNG;
}();

var Frame = exports.Frame = function () {
    function Frame() {
        _classCallCheck(this, Frame);

        this.left = 0;
        this.top = 0;
        this.width = 0;
        this.height = 0;
        this.delay = 0;
        this.disposeOp = 0;
        this.blendOp = 0;
        this.imageData = null;
        this.imageElement = null;
    }
    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {number} */

    /** @type {Blob} */

    /** @type {HTMLImageElement} */


    _createClass(Frame, [{
        key: 'createImage',
        value: function createImage() {
            var _this2 = this;

            if (this.imageElement) {
                return Promise.resolve();
            }
            return new Promise(function (resolve, reject) {
                var url = URL.createObjectURL(_this2.imageData);
                _this2.imageElement = document.createElement('img');
                _this2.imageElement.onload = function () {
                    URL.revokeObjectURL(url);
                    resolve();
                };
                _this2.imageElement.onerror = function () {
                    URL.revokeObjectURL(url);
                    _this2.imageElement = null;
                    reject(new Error("Image creation error"));
                };
                _this2.imageElement.src = url;
            });
        }
    }]);

    return Frame;
}();

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(562);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    /**
     * @param {APNG} apng
     * @param {CanvasRenderingContext2D} context
     * @param {boolean} autoPlay
     */

    /** @type {boolean} */

    /** @type {number} */

    /** @type {Frame} */

    /** @type {number} */
    function _class(apng, context, autoPlay) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

        _this.playbackRate = 1.0;
        _this._currentFrameNumber = 0;
        _this._ended = false;
        _this._paused = true;
        _this._numPlays = 0;

        _this._apng = apng;
        _this.context = context;
        _this.stop();
        _this.hasPerformance = typeof performance !== 'undefined';
        if (autoPlay) {
            _this.play();
        }
        return _this;
    }

    /**
     *
     * @return {number}
     */

    /** @type {number} */


    /** @type {boolean} */

    /** @type {ImageData} */


    /** @type {APNG} */

    /** @type {CanvasRenderingContext2D} */


    _createClass(_class, [{
        key: 'renderNextFrame',
        value: function renderNextFrame() {
            this._currentFrameNumber = (this._currentFrameNumber + 1) % this._apng.frames.length;
            if (this._currentFrameNumber === this._apng.frames.length - 1) {
                this._numPlays++;
                if (this._apng.numPlays !== 0 && this._numPlays >= this._apng.numPlays) {
                    this.emit('end');
                    this._ended = true;
                    this._paused = true;
                }
            }

            if (this._prevFrame && this._prevFrame.disposeOp == 1) {
                this.context.clearRect(this._prevFrame.left, this._prevFrame.top, this._prevFrame.width, this._prevFrame.height);
            } else if (this._prevFrame && this._prevFrame.disposeOp == 2) {
                this.context.putImageData(this._prevFrameData, this._prevFrame.left, this._prevFrame.top);
            }

            var frame = this.currentFrame;
            this._prevFrame = frame;
            this._prevFrameData = null;
            if (frame.disposeOp == 2) {
                this._prevFrameData = this.context.getImageData(frame.left, frame.top, frame.width, frame.height);
            }
            if (frame.blendOp == 0) {
                this.context.clearRect(frame.left, frame.top, frame.width, frame.height);
            }

            this.context.drawImage(frame.imageElement, frame.left, frame.top);
        }

        // playback

    }, {
        key: 'play',
        value: function play() {
            var _this2 = this;

            this.emit('play');

            if (this._ended) {
                this.stop();
            }
            this._paused = false;
            var performance = this.hasPerformance ? performance || window.performance : Date; // supports ios8 Safari
            var nextRenderTime = performance.now() + this.currentFrame.delay / this.playbackRate;
            var tick = function tick(now) {
                var _now = _this2.hasPerformance ? now : Date.now(); // supports ios8 Safari
                if (_this2._ended || _this2._paused) {
                    return;
                }
                if (_now >= nextRenderTime) {
                    while (_now - nextRenderTime >= _this2._apng.playTime / _this2.playbackRate) {
                        nextRenderTime += _this2._apng.playTime / _this2.playbackRate;
                        _this2._numPlays++;
                    }
                    do {
                        _this2.renderNextFrame();
                        nextRenderTime += _this2.currentFrame.delay / _this2.playbackRate;
                    } while (!_this2._ended && _now > nextRenderTime);
                }
                requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        }
    }, {
        key: 'pause',
        value: function pause() {
            if (!this._paused) {
                this.emit('pause');
                this._paused = true;
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.emit('stop');
            this._numPlays = 0;
            this._ended = false;
            this._paused = true;
            // render first frame
            this._currentFrameNumber = -1;
            this.context.clearRect(0, 0, this._apng.width, this._apng.height);
            this.renderNextFrame();
        }
    }, {
        key: 'currentFrameNumber',
        get: function get() {
            return this._currentFrameNumber;
        }

        /**
         *
         * @return {Frame}
         */

    }, {
        key: 'currentFrame',
        get: function get() {
            return this._apng.frames[this._currentFrameNumber];
        }
    }, {
        key: 'paused',
        get: function get() {
            return this._paused;
        }
    }, {
        key: 'ended',
        get: function get() {
            return this._ended;
        }
    }]);

    return _class;
}(_events2.default);

exports.default = _class;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function getImgBuffer(url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';

        xhr.onload = function () {
            if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304)) {
                resolve(this.response);
            } else {
                reject(new Error(this));
            }
            // if (this.status === 200) {
            //     resolve(this.response);
            // } else {
            //     reject(this);
            // }
        };
        xhr.send();
    });
}
exports.getImgBuffer = getImgBuffer;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/waitdialog.cd4f0cfd.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var bind = __webpack_require__(225);
var Axios = __webpack_require__(568);
var defaults = __webpack_require__(164);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(229);
axios.CancelToken = __webpack_require__(583);
axios.isCancel = __webpack_require__(228);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(584);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(164);
var utils = __webpack_require__(38);
var InterceptorManager = __webpack_require__(578);
var dispatchRequest = __webpack_require__(579);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(227);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);
var transformData = __webpack_require__(580);
var isCancel = __webpack_require__(228);
var defaults = __webpack_require__(164);
var isAbsoluteURL = __webpack_require__(581);
var combineURLs = __webpack_require__(582);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(38);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(229);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return p; });
function t(n){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(n)}function n(t,n,r){return n in t?Object.defineProperty(t,n,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[n]=r,t}function r(t,n){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var e=Object.getOwnPropertySymbols(t);n&&(e=e.filter((function(n){return Object.getOwnPropertyDescriptor(t,n).enumerable}))),r.push.apply(r,e)}return r}function e(t){for(var e=1;e<arguments.length;e++){var o=null!=arguments[e]?arguments[e]:{};e%2?r(Object(o),!0).forEach((function(r){n(t,r,o[r])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(o)):r(Object(o)).forEach((function(n){Object.defineProperty(t,n,Object.getOwnPropertyDescriptor(o,n))}))}return t}function o(t,n){return function(t){if(Array.isArray(t))return t}(t)||function(t,n){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var r=[],e=!0,o=!1,i=void 0;try{for(var a,c=t[Symbol.iterator]();!(e=(a=c.next()).done)&&(r.push(a.value),!n||r.length!==n);e=!0);}catch(t){o=!0,i=t}finally{try{e||null==c.return||c.return()}finally{if(o)throw i}}return r}(t,n)||i(t,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(t,n){if(t){if("string"==typeof t)return a(t,n);var r=Object.prototype.toString.call(t).slice(8,-1);return"Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?a(t,n):void 0}}function a(t,n){(null==n||n>t.length)&&(n=t.length);for(var r=0,e=new Array(n);r<n;r++)e[r]=t[r];return e}var c="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};var u=function(t,n){return t(n={exports:{}},n.exports),n.exports}((function(t){!function(n){function r(t,n){var r=(65535&t)+(65535&n);return(t>>16)+(n>>16)+(r>>16)<<16|65535&r}function e(t,n,e,o,i,a){return r((c=r(r(n,t),r(o,a)))<<(u=i)|c>>>32-u,e);var c,u}function o(t,n,r,o,i,a,c){return e(n&r|~n&o,t,n,i,a,c)}function i(t,n,r,o,i,a,c){return e(n&o|r&~o,t,n,i,a,c)}function a(t,n,r,o,i,a,c){return e(n^r^o,t,n,i,a,c)}function c(t,n,r,o,i,a,c){return e(r^(n|~o),t,n,i,a,c)}function u(t,n){var e,u,f,l,p;t[n>>5]|=128<<n%32,t[14+(n+64>>>9<<4)]=n;var s=1732584193,y=-271733879,b=-1732584194,g=271733878;for(e=0;e<t.length;e+=16)u=s,f=y,l=b,p=g,s=o(s,y,b,g,t[e],7,-680876936),g=o(g,s,y,b,t[e+1],12,-389564586),b=o(b,g,s,y,t[e+2],17,606105819),y=o(y,b,g,s,t[e+3],22,-1044525330),s=o(s,y,b,g,t[e+4],7,-176418897),g=o(g,s,y,b,t[e+5],12,1200080426),b=o(b,g,s,y,t[e+6],17,-1473231341),y=o(y,b,g,s,t[e+7],22,-45705983),s=o(s,y,b,g,t[e+8],7,1770035416),g=o(g,s,y,b,t[e+9],12,-1958414417),b=o(b,g,s,y,t[e+10],17,-42063),y=o(y,b,g,s,t[e+11],22,-1990404162),s=o(s,y,b,g,t[e+12],7,1804603682),g=o(g,s,y,b,t[e+13],12,-40341101),b=o(b,g,s,y,t[e+14],17,-1502002290),s=i(s,y=o(y,b,g,s,t[e+15],22,1236535329),b,g,t[e+1],5,-165796510),g=i(g,s,y,b,t[e+6],9,-1069501632),b=i(b,g,s,y,t[e+11],14,643717713),y=i(y,b,g,s,t[e],20,-373897302),s=i(s,y,b,g,t[e+5],5,-701558691),g=i(g,s,y,b,t[e+10],9,38016083),b=i(b,g,s,y,t[e+15],14,-660478335),y=i(y,b,g,s,t[e+4],20,-405537848),s=i(s,y,b,g,t[e+9],5,568446438),g=i(g,s,y,b,t[e+14],9,-1019803690),b=i(b,g,s,y,t[e+3],14,-187363961),y=i(y,b,g,s,t[e+8],20,1163531501),s=i(s,y,b,g,t[e+13],5,-1444681467),g=i(g,s,y,b,t[e+2],9,-51403784),b=i(b,g,s,y,t[e+7],14,1735328473),s=a(s,y=i(y,b,g,s,t[e+12],20,-1926607734),b,g,t[e+5],4,-378558),g=a(g,s,y,b,t[e+8],11,-2022574463),b=a(b,g,s,y,t[e+11],16,1839030562),y=a(y,b,g,s,t[e+14],23,-35309556),s=a(s,y,b,g,t[e+1],4,-1530992060),g=a(g,s,y,b,t[e+4],11,1272893353),b=a(b,g,s,y,t[e+7],16,-155497632),y=a(y,b,g,s,t[e+10],23,-1094730640),s=a(s,y,b,g,t[e+13],4,681279174),g=a(g,s,y,b,t[e],11,-358537222),b=a(b,g,s,y,t[e+3],16,-722521979),y=a(y,b,g,s,t[e+6],23,76029189),s=a(s,y,b,g,t[e+9],4,-640364487),g=a(g,s,y,b,t[e+12],11,-421815835),b=a(b,g,s,y,t[e+15],16,530742520),s=c(s,y=a(y,b,g,s,t[e+2],23,-995338651),b,g,t[e],6,-198630844),g=c(g,s,y,b,t[e+7],10,1126891415),b=c(b,g,s,y,t[e+14],15,-1416354905),y=c(y,b,g,s,t[e+5],21,-57434055),s=c(s,y,b,g,t[e+12],6,1700485571),g=c(g,s,y,b,t[e+3],10,-1894986606),b=c(b,g,s,y,t[e+10],15,-1051523),y=c(y,b,g,s,t[e+1],21,-2054922799),s=c(s,y,b,g,t[e+8],6,1873313359),g=c(g,s,y,b,t[e+15],10,-30611744),b=c(b,g,s,y,t[e+6],15,-1560198380),y=c(y,b,g,s,t[e+13],21,1309151649),s=c(s,y,b,g,t[e+4],6,-145523070),g=c(g,s,y,b,t[e+11],10,-1120210379),b=c(b,g,s,y,t[e+2],15,718787259),y=c(y,b,g,s,t[e+9],21,-343485551),s=r(s,u),y=r(y,f),b=r(b,l),g=r(g,p);return[s,y,b,g]}function f(t){var n,r="",e=32*t.length;for(n=0;n<e;n+=8)r+=String.fromCharCode(t[n>>5]>>>n%32&255);return r}function l(t){var n,r=[];for(r[(t.length>>2)-1]=void 0,n=0;n<r.length;n+=1)r[n]=0;var e=8*t.length;for(n=0;n<e;n+=8)r[n>>5]|=(255&t.charCodeAt(n/8))<<n%32;return r}function p(t){var n,r,e="";for(r=0;r<t.length;r+=1)n=t.charCodeAt(r),e+="0123456789abcdef".charAt(n>>>4&15)+"0123456789abcdef".charAt(15&n);return e}function s(t){return unescape(encodeURIComponent(t))}function y(t){return function(t){return f(u(l(t),8*t.length))}(s(t))}function b(t,n){return function(t,n){var r,e,o=l(t),i=[],a=[];for(i[15]=a[15]=void 0,o.length>16&&(o=u(o,8*t.length)),r=0;r<16;r+=1)i[r]=909522486^o[r],a[r]=1549556828^o[r];return e=u(i.concat(l(n)),512+8*n.length),f(u(a.concat(e),640))}(s(t),s(n))}function g(t,n,r){return n?r?b(n,t):p(b(n,t)):r?y(t):p(y(t))}t.exports?t.exports=g:n.md5=g}(c)}));function f(n){var r,o=function(t){for(var n="",r=0;r<t;r++)n+=(~~(16*Math.random())).toString(16).toUpperCase();return n}(32),a=(new Date).getTime(),c=e(e({},n),{},{nonce:o,timestamp:a}),u="",f=function(t,n){var r;if("undefined"==typeof Symbol||null==t[Symbol.iterator]){if(Array.isArray(t)||(r=i(t))||n&&t&&"number"==typeof t.length){r&&(t=r);var e=0,o=function(){};return{s:o,n:function(){return e>=t.length?{done:!0}:{done:!1,value:t[e++]}},e:function(t){throw t},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,c=!0,u=!1;return{s:function(){r=t[Symbol.iterator]()},n:function(){var t=r.next();return c=t.done,t},e:function(t){u=!0,a=t},f:function(){try{c||null==r.return||r.return()}finally{if(u)throw a}}}}(Object.keys(c).sort());try{for(f.s();!(r=f.n()).done;){var l=r.value,p="object"===t(c[l])?JSON.stringify(c[l]):c[l];u+="".concat(l,"=").concat(p,"&")}}catch(t){f.e(t)}finally{f.f()}return{signObj:u.slice(0,-1),nonce:o,timestamp:a}}function l(t,n){var r,e=f(n),o=e.signObj,i=e.nonce,a=e.timestamp,c="".concat(t).concat(n?"?":"").concat(o).concat("0B60434D07FBDA039064CDCD1BD6F7FD");return{signature:u((r=c,r=(r+"").toString(),encodeURIComponent(r).replace(/!/g,"%21").replace(/'/g,"%27").replace(/\(/g,"%28").replace(/\)/g,"%29").replace(/\~/g,"%7E"))).toUpperCase(),nonce:i,timestamp:a,signStr:c}}function p(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.extraParams,i=void 0===r?{}:r,a=n.proxyPre,c=void 0===a?"":a,u=n.debug,f=void 0!==u&&u,l={},p={};try{p="string"==typeof i?JSON.parse(i):i}catch(t){console.log(t)}var y=decodeURIComponent(t).split("?"),b=o(y,2),g=b[0],m=b[1];return m&&m.split("&").forEach((function(t){var n=o(t.split("="),2),r=n[0],e=n[1];l[r]=e})),s(g=g.replace(c,""),e(e({},l),p),f)}function s(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2?arguments[2]:void 0,e=l(t,n),o=e.signature,i=e.nonce,a=e.timestamp,c=e.signStr;return r&&console.table({path:t,params:n,signature:o,nonce:i,timestamp:a,signStr:c}),{"x-ca-version":"1.0.0","x-ca-key":"487607","x-ca-signature":o,"x-ca-nonce":i,"x-ca-timestamp":a}}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(76)))

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Pay_AppPay__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_client__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryObj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var AppPayPage=function(_Component){_inherits(AppPayPage,_Component);function AppPayPage(props){_classCallCheck(this,AppPayPage);var _this2=_possibleConstructorReturn(this,(AppPayPage.__proto__||Object.getPrototypeOf(AppPayPage)).call(this,props));_this2._pushPage=function(path,id){var _this=_this2;var history=_this2.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* COURSE_URL */]+'/'+path,state:{id:id,goodsInfo:_this.state.goodsInfo},search:window.location.search});};_this2.state={lessonCnt:'0',lessonDate:'',goodsInfo:[],stuId:queryObj.stuid};_this2._pushPage.bind(_this2);return _this2;}_createClass(AppPayPage,[{key:'componentDidMount',value:function componentDidMount(){var _this=this;__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){if(err){__WEBPACK_IMPORTED_MODULE_6__api_client__["a" /* default */].httpError({errorCode:err.errorCode});}else{_this.setState({lessonCnt:res[0].remainLessonCnt,lessonDate:res[0].expireDate.replace(/-/g,'.')});}});__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getGoodsInfo({data:{userId:queryObj.stuid}},function(res,err){if(err)console.log(err);else{_this.setState({goodsInfo:res});}});}},{key:'render',value:function render(){var propsObj={pushPage:this._pushPage};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课时信息'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Pay_AppPay__["a" /* default */],Object.assign({},propsObj,this.state))));}}]);return AppPayPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppPayPage);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appStyle_less__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appStyle_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__appStyle_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppPay=function(_Component){_inherits(AppPay,_Component);function AppPay(props){_classCallCheck(this,AppPay);var _this2=_possibleConstructorReturn(this,(AppPay.__proto__||Object.getPrototypeOf(AppPay)).call(this,props));_this2.state={sectionId:0};_this2.pushPage=props.pushPage;return _this2;}_createClass(AppPay,[{key:'tabFun',value:function tabFun(id,canBuy,reason){this.setState({sectionId:id});console.log(canBuy,reason);// if(!canBuy) alert(reason)
// else{
window.location.href=window.location.origin+'/h5/h5pay'+window.location.search+'&goodsId='+id+'&lessondate='+new Date(this.props.lessonDate.replace(/\./g,'/')).getTime();// }
// this.pushPage('h5pay',id)
}},{key:'render',value:function render(){var _this=this;var goodsInfo=this.props.goodsInfo;var sectionItem=goodsInfo.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{key:index,canBuy:ele.canBuy,reason:ele.reason,num:ele.lessons,price:ele.totalAmount/100,expireDays:ele.expireDays,clickFun:function clickFun(canBuy,reason){return _this.tabFun(index,canBuy,reason);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container apppay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u5269\u4F59\u8BFE\u65F6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.lessonCnt),'\u8282'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub_head'},'\u6709\u6548\u671F\u81F3\uFF1A',this.props.lessonDate,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),sectionItem,!this.props.goodsInfo.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nolessons'},'\u6682\u65F6\u6CA1\u6709\u53EF\u8D2D\u4E70\u7684\u8BFE\u65F6'));}}]);return AppPay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Section=function Section(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'num'},props.num),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'\u8BFE\u65F6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price'},props.price||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'\u5143')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtext'},'\u6709\u6548\u671F',props.expireDays,'\u5929'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_right',onClick:function onClick(){props.clickFun(props.canBuy,props.reason);}},'\u8D2D\u4E70'));};/* harmony default export */ __webpack_exports__["a"] = (AppPay);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_Pay_WebPay__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryObj=Object(__WEBPACK_IMPORTED_MODULE_2__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var WebPayPage=function(_Component){_inherits(WebPayPage,_Component);function WebPayPage(){_classCallCheck(this,WebPayPage);var _this2=_possibleConstructorReturn(this,(WebPayPage.__proto__||Object.getPrototypeOf(WebPayPage)).call(this));_this2.state={lessonCnt:'0',lessonDate:'',userId:queryObj.stuid,goodsInfo:[],completeRander:false};_this2.payTest=_this2.payTest.bind(_this2);return _this2;}_createClass(WebPayPage,[{key:'payTest',value:function payTest(goodsNo){var _this=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].payTest({data:{userId:queryObj.stuid,goodsNo:goodsNo}},function(res,err){if(err){alert(err.errorMessage);}else{__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){if(err)console.log(err);else{_this.setState({lessonCnt:res[0].remainLessonCnt,lessonDate:res[0].expireDate});}});__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].payResult();}});}},{key:'getStuCourse',value:function getStuCourse(){var _this=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){if(err){console.log(err);}else{_this.setState({lessonCnt:res[0].remainLessonCnt,lessonDate:res[0].expireDate.replace(/-/g,'.')});}});}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var _this=this;this.getStuCourse();setInterval(function(){_this3.getStuCourse();},4000);__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getGoodsInfo({userId:queryObj.stuid},function(res,err){if(err)console.log(err);else{_this.setState({goodsInfo:res});_this.setState({completeRander:true});}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__template_Pay_WebPay__["a" /* default */],Object.assign({},this.state,{payTest:this.payTest})));}}]);return WebPayPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WebPayPage);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Load_Load__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WebPay=function(_Component){_inherits(WebPay,_Component);function WebPay(props){_classCallCheck(this,WebPay);var _this2=_possibleConstructorReturn(this,(WebPay.__proto__||Object.getPrototypeOf(WebPay)).call(this,props));_this2.state={sectionId:0};return _this2;}_createClass(WebPay,[{key:'tabFun',value:function tabFun(id,e){this.setState({sectionId:id,goodsNo:this.state.goodsInfo[id].goodsNo,totalAmount:this.state.goodsInfo[id].totalAmount});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({goodsInfo:nextProps.goodsInfo,goodsNo:nextProps.goodsInfo[0]?nextProps.goodsInfo[this.state.sectionId].goodsNo:'',totalAmount:nextProps.goodsInfo[0]?nextProps.goodsInfo[this.state.sectionId].totalAmount:''});}},{key:'render',value:function render(){var _this3=this;console.log(this.state);var _this=this;var sectionItem=void 0;if(this.props.goodsInfo.length)sectionItem=this.props.goodsInfo.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{key:index,num:ele.lessons,price:ele.totalAmount/100,selected:_this.state.sectionId===index&&'active',clickFun:function clickFun(e){return _this3.tabFun(index,e);},expireDays:ele.expireDays});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container webpay'},this.props.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u5269\u4F59\u8BFE\u65F6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.lessonCnt||0),'\u8282'),this.props.lessonDate&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub_head'},'\u6709\u6548\u671F\u81F3\uFF1A',this.props.lessonDate)),this.props.goodsInfo.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle_left'},sectionItem),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_qrcode_react___default.a,{size:148,value:'https://client.aircourses.com/h5/paylink?userid='+this.props.userId+'&goodsno='+this.state.goodsNo,fgColor:'#20C8F2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u4ED8\u6B3E',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.totalAmount/100||0),'\u5143'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u8BF7\u4F7F\u7528\u652F\u4ED8\u5B9D\u6216\u5FAE\u4FE1\u626B\u7801\u4ED8\u6B3E'),!window.location.href.indexOf("https")>-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pay_test',goodsno:this.state.goodsNo,onClick:function onClick(){_this3.props.payTest(_this3.state.goodsNo);}},'\u652F\u4ED8\u6D4B\u8BD5'))),!this.props.goodsInfo.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle nolessons'},'\u6682\u65F6\u6CA1\u6709\u53EF\u8D2D\u4E70\u7684\u8BFE\u65F6')),!this.props.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Load_Load__["a" /* default */],null));}}]);return WebPay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Section=function Section(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',onClick:props.clickFun},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'num'},props.num||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'\u8BFE\u65F6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price'},props.price||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'\u5143')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subtext'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6709\u6548\u671F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span'},props.expireDays||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5929')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.selected||''})));};/* harmony default export */ __webpack_exports__["a"] = (WebPay);

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(593);
var RSBlock = __webpack_require__(594);
var BitBuffer = __webpack_require__(595);
var util = __webpack_require__(596);
var Polynomial = __webpack_require__(234);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(232);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(233);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(232);
var Polynomial = __webpack_require__(234);
var math = __webpack_require__(235);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Pay_H5Pay__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ua__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var returnUrl='https://client.aircourses.com/h5/success';var channelList=[{num:1000,string:'guanwang'},{num:1001,string:'yingyongbao'},{num:1002,string:'360'},{num:1003,string:'baidu'},{num:1004,string:'ali'},{num:1005,string:'oppo'},{num:1006,string:'vivo'},{num:1007,string:'huawei'},{num:1008,string:'xiaomi'},{num:4000,string:'Windows'}];var H5PayPage=function(_Component){_inherits(H5PayPage,_Component);function H5PayPage(props){_classCallCheck(this,H5PayPage);var _this=_possibleConstructorReturn(this,(H5PayPage.__proto__||Object.getPrototypeOf(H5PayPage)).call(this,props));_this.payTest=function(isAllow){if(isAllow){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].payTest({data:{userId:queryObj.stuid,goodsNo:_this.state.goodsInfo[queryObj.goodsid].goodsNo}},function(res,err){// AXIOS.payTest({data:{userId:queryObj.stuId,goodsNo:'f49323df2c81400abdcd2ba5457949f0'}},function(res,err){
if(err)alert(err.errorMessage);else{var history=this.props.history;__WEBPACK_IMPORTED_MODULE_7__api_client__["a" /* default */].payResult({payResult:true});history.replace({pathname:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* COURSE_URL */]+'/success',search:window.location.search,state:{num:this.state.goodsInfo[this.state.id].totalAmount/100}});}});}else alert('请同意用户协议！');};_this.handlePay=function(orderNo,channel){if(channel===0){// 微信
var data={orderNo:orderNo,payType:'MWEB'};clearInterval(_this.interval);__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].payWeixin({data:data},function(res,err){if(err)alert(err.errorMessage);else{var mwebUrl=res.mwebUrl;if(__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].iosClient){_this.interval=setInterval(function(){_this.getOrderStatus();setTimeout(function(){clearInterval(_this.interval);},60000*2);},4000);window.location.replace(''+mwebUrl);}if(__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].androidClient)window.location.replace(mwebUrl+'&redirect_url='+encodeURIComponent(returnUrl+"?stuid="+queryObj.stuid+"&totalamount="+_this.state.totalAmount+"&success=1&type=wait&orderno="+orderNo));}});}else{var _data={// 支付宝
returnUrl:returnUrl+'?stuid='+queryObj.stuid+'&orderno='+orderNo+'&totalamount='+_this.state.totalamount+'&success=1&type=wait',orderNo:orderNo,payType:'QUICK_WAP_PAY'};__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://api.aircourses.com/ac-order/alipay',_data).then(function(res){document.getElementById('root').innerHTML=res.data;setTimeout(function(){document.forms[0].submit();},500);}).catch(function(err){alert('error'+JSON.stringify(err));});}};_this.handleClick=function(isAllow,channel){if(isAllow){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getWxOrder({data:{userId:queryObj.stuid,goodsNo:_this.state.goodsInfo[queryObj.goodsid].goodsNo,payType:channel===0?'MWEB':'QUICK_WAP_PAY',channelId:_this.channel,// app渠道id
version:2//接口版本
}},function(res,err){if(err)alert('获取订单失败：'+err.errorMessage);else{_this.setState({totalAmount:res.totalAmount,orderNo:res.orderNo});_this.handlePay(res.orderNo,channel);}});}else alert('请同意用户协议！');};if(!(Number(queryObj.channel)>999)){_this.index=channelList.findIndex(function(item){return item.string===queryObj.channel;});_this.channel=_this.index===-1?1000:channelList[_this.index].num;}else{_this.channel=queryObj.channel;}_this.state={lessonDate:Number(queryObj.lessondate)?queryObj.lessondate:new Date().getTime()};_this.payTest=_this.payTest.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.handlePay=_this.handlePay.bind(_this);return _this;}// 测试支付
// 第三方支付下单
// 获取订单号
_createClass(H5PayPage,[{key:'getOrderStatus',// 查询订单状态
value:function getOrderStatus(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getOrderStatus({query:queryObj.orderno},function(res,err){if(err)console.log(err);else{if(res.status!==0){clearInterval(_this2.interval);window.location.replace(returnUrl+'?stuid='+queryObj.stuid+'&orderno='+_this2.state.orderNo+'&totalamount='+_this2.state.totalamount+'&success=1&type=wait');}}});}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getGoodsInfo({},function(res,err){if(err)console.log(err);else{_this3.setState({goodsInfo:res});}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'支付'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page_wrap'},this.state.goodsInfo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Pay_H5Pay__["a" /* default */],Object.assign({id:queryObj.goodsid},this.state,{payTest:this.payTest,handleClick:this.handleClick}))));}}]);return H5PayPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (H5PayPage);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appStyle_less__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__appStyle_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__appStyle_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var H5Pay=function(_Component){_inherits(H5Pay,_Component);function H5Pay(props){_classCallCheck(this,H5Pay);var _this=_possibleConstructorReturn(this,(H5Pay.__proto__||Object.getPrototypeOf(H5Pay)).call(this,props));_this.state={channel:0,isAllow:true};return _this;}_createClass(H5Pay,[{key:'render',value:function render(){var _this2=this;console.log(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container h5pay'},this.props.goodsInfo[this.props.id]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'order'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lesson_detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},this.props.goodsInfo[this.props.id].name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sub'},'\u6709\u6548\u671F',this.props.goodsInfo[this.props.id].expireDays,'\u5929')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lesson_date'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6709\u6548\u671F\u81F3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1__utils_tools__["a" /* computeDate */])(this.props.lessonDate/1000,this.props.goodsInfo[this.props.id].expireDays))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lesson_price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5E94\u4ED8\u91D1\u989D'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price'},this.props.goodsInfo[this.props.id].totalAmount/100,'\u5143'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'channel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u7B2C\u4E09\u65B9\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weixin pay '+(this.state.channel===0?'active':''),onClick:function onClick(){_this2.setState({channel:0});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u5FAE\u4FE1\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alipay pay '+(this.state.channel===1?'active':''),onClick:function onClick(){_this2.setState({channel:1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u652F\u4ED8\u5B9D\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap '+(this.state.isAllow===true?'active':''),onClick:function onClick(){_this2.setState({isAllow:!_this2.state.isAllow});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://client.aircourses.com/h5/customerrules'},'\u540C\u610FAirCourse\u670D\u52A1\u534F\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_submit',onClick:function onClick(){_this2.props.handleClick(_this2.state.isAllow,_this2.state.channel);}},'\u7ACB\u5373\u652F\u4ED8'));}}]);return H5Pay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (H5Pay);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadPage=function(_Component){_inherits(DownloadPage,_Component);function DownloadPage(props){_classCallCheck(this,DownloadPage);var _this=_possibleConstructorReturn(this,(DownloadPage.__proto__||Object.getPrototypeOf(DownloadPage)).call(this,props));console.log(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */]);if(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].ipad)window.location.href='https://itunes.apple.com/cn/app/id1431703239';else if(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].iphone)window.location.href='https://itunes.apple.com/cn/app/id1431699300';else window.location.href='https://sj.qq.com/myapp/detail.htm?apkName=com.pandaabc.stu';_this.state={};return _this;}_createClass(DownloadPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'跳转中...'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container download'}));}}]);return DownloadPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DownloadPage);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_toast__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import axios from "axios";
var queryPara=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var returnUrl="https://client.aircourses.com/h5/success";var Paylink=function(_Component){_inherits(Paylink,_Component);function Paylink(props){_classCallCheck(this,Paylink);var _this=_possibleConstructorReturn(this,(Paylink.__proto__||Object.getPrototypeOf(Paylink)).call(this,props));_this.payWeixin=function(openid,isH5){var data={orderNo:queryPara.orderno};if(isH5){data.payType="MWEB";}else{data.payType="JSAPI";data.openid=openid;}__WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].payWeixin({data:data},function(res,err){if(err)alert(err.errorMessage);else{if(isH5){var mwebUrl=res.data.mwebUrl;window.location.replace(mwebUrl);}else{if(typeof window.WeixinJSBridge==="undefined"){if(document.addEventListener){document.addEventListener("WeixinJSBridgeReady",function(){_this.onBridgeReady(res);},false);}else if(document.attachEvent){document.attachEvent("WeixinJSBridgeReady",function(){_this.onBridgeReady(res);});document.attachEvent("onWeixinJSBridgeReady",function(){_this.onBridgeReady(res);});}}else{_this.onBridgeReady(res);}}}});};_this.fakePay=function(data){__WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].payTest({data:data},function(res,err){if(err)__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:err.errorMessage});else{__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:"虚拟支付完成"});}_this.setState({refuseClick:false});});};_this.payWeixin=_this.payWeixin.bind(_this);_this.onBridgeReady=_this.onBridgeReady.bind(_this);_this.payAli=_this.payAli.bind(_this);return _this;}// 公众号支付
_createClass(Paylink,[{key:"onBridgeReady",value:function onBridgeReady(data){// window.WeixinJSBridge.invoke('getBrandWCPayRequest', data)
window.WeixinJSBridge.invoke("getBrandWCPayRequest",data,function(res){if(res.err_msg==="get_brand_wcpay_request:ok"){// window.location.replace(`${returnUrl}?totalamount=${queryPara.totalamount}&success=1&channel=others`)
window.location.replace(returnUrl+"?stuid="+queryPara.userid+"&totalamount="+queryPara.totalamount+"&success=1&channel=others&type=wait&orderno="+queryPara.orderno);return;}// else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
//     window.location.replace(returnUrl+"?stuid="+queryPara.userid+"&totalamount="+queryPara.totalamount+"&success=0&channel=others&type=wait&orderno="+queryPara.orderno)
//     return;
// } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
//     window.location.replace(returnUrl+"?stuid="+queryPara.userid+"&totalamount="+queryPara.totalamount+"&success=0&channel=others&type=wait&orderno="+queryPara.orderno)
//     return;
// }
});}// 获取微信订单
// 虚拟支付
},{key:"payAli",//支付宝支付
value:function payAli(){var data={// returnUrl:`${returnUrl}?totalamount=${queryPara.totalamount}&success=1&channel=others`,
returnUrl:returnUrl+"?stuid="+queryPara.userid+"&orderno="+queryPara.orderno+"&totalamount="+queryPara.totalamount+"&success=1&channel=others&type=wait",orderNo:queryPara.orderno,payType:"QUICK_WAP_PAY"};__WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].payAli({data:data},function(res){document.getElementById("paylink_wrap").innerHTML=res.data;setTimeout(function(){document.forms[0].submit();},500);});// axios
//   .post(`https://api.aircourses.com/ac-order/alipay`, data)
//   .then(function (res) {
//     document.getElementById("paylink_wrap").innerHTML = res.data;
//     setTimeout(() => {
//       document.forms[0].submit();
//     }, 500);
//   })
//   .catch(function (err) {
//     alert("error" + JSON.stringify(err));
//   });
}},{key:"componentDidMount",value:function componentDidMount(){var couponid=queryPara.couponid,addressid=queryPara.addressid,goodsno=queryPara.goodsno,userid=queryPara.userid,inviteawardpackid=queryPara.inviteawardpackid,channel=queryPara.channel;var data={stuCouponDetailIds:couponid!=="-1"?[couponid]:[],goodsNo:goodsno,userId:userid,payType:__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].isWeixin?"MWEB":"QUICK_WAP_PAY",channelId:channel,version:2,//接口版本
addressId:addressid,saleType:typeof addressid==="undefined"?1:0,inviteAwardPackId:inviteawardpackid};if(window.location.origin!=="https://client.aircourses.com"){return this.fakePay(data);}if(!queryPara.orderno){// 获取订单号
__WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].getWxOrder({data:data},function(res,err){if(err)alert(err.errorMessage);else{window.location.replace(window.location.href+"&orderno="+res.orderNo+"&totalamount="+res.totalAmount);}});}else{if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].isWeixin){var openid=__WEBPACK_IMPORTED_MODULE_3__utils_tools__["b" /* cookie */].get("openid")||queryPara.openid;if(!openid){window.location.replace(window.location.origin+"/weixin_callback"+window.location.search);// alert(`${window.location.origin}/weixin_callback${window.location.search}`)
}else{__WEBPACK_IMPORTED_MODULE_3__utils_tools__["b" /* cookie */].set("openid",openid,1);this.payWeixin(openid,false);}}else{this.payAli();}}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:"爱课AirCourse"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"paylink_wrap"})));}}]);return Paylink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Paylink);

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/error.74a15276.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/load.c2a5aba0.gif";

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Share_Share__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Share_Guide__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_weixinConfig__ = __webpack_require__(237);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryPara=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var SharePage=function(_Component){_inherits(SharePage,_Component);function SharePage(props){_classCallCheck(this,SharePage);var _this2=_possibleConstructorReturn(this,(SharePage.__proto__||Object.getPrototypeOf(SharePage)).call(this,props));_this2.state={courseDetailGroupMpPhoto:'',audioUrl:'',stuEnName:'',stuPortrait:'',courseDetailEnName:'',guide:Boolean(queryPara.guide)};_this2.showGuide=_this2.showGuide.bind(_this2);_this2.hideGuide=_this2.hideGuide.bind(_this2);_this2.handlePush=_this2.handlePush.bind(_this2);return _this2;}_createClass(SharePage,[{key:'hideGuide',value:function hideGuide(){this.setState({guide:false});}},{key:'showGuide',value:function showGuide(){this.setState({guide:true});}},{key:'handlePush',value:function handlePush(classSchId){window.location.replace(window.location.origin+window.location.pathname+('?stuId='+queryPara.stuId+'&classSchId='+classSchId));}},{key:'componentDidMount',value:function componentDidMount(){var _this=this;__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].getStuHomeworkSingle({data:{stuId:queryPara.stuId,classSchId:queryPara.classSchId}},function(res,err){var _this3=this;if(err)console.log('err',err);else{_this.setState({courseDetailGroupMpPhoto:res.courseDetailCoverHPhoto,audioUrl:res.url,stuEnName:res.stuEnName,stuPortrait:res.stuPortrait,courseDetailEnName:res.courseDetailEnName});var wxConfig={title:'\u5FEB\u6765\u56F4\u89C2\u6211\u7684\u82F1\u8BED\u79C0\u300A'+res.courseDetailEnName+'\u300B\uFF01',desc:'只用哈佛外教的英语课，上完一节就停不下来！',link:encodeURI(window.location.origin+'/h5/share?stuId='+queryPara.stuId+'&classSchId='+queryPara.classSchId),imgUrl:res.courseDetailCoverHPhoto};Object(__WEBPACK_IMPORTED_MODULE_6__utils_weixinConfig__["a" /* default */])(wxConfig,function(){_this3.setState({guide:false});});}});__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].getStuHomeworkList({data:{stuId:queryPara.stuId,classSchId:queryPara.classSchId,num:1,row:4}},function(res,err){if(err)console.log('err',err);else{_this.setState({list:res});}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u5FEB\u6765\u56F4\u89C2\u6211\u7684\u82F1\u8BED\u79C0\u300A'+this.state.courseDetailEnName+'\u300B\uFF01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Share_Share__["a" /* default */],Object.assign({},this.state,{handleClick:this.showGuide,handlePush:this.handlePush})),this.state.guide&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Share_Guide__["a" /* default */],{handleClick:this.hideGuide})));}}]);return SharePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SharePage);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_play_share_png__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_play_share_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_play_share_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_pause_share_png__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_pause_share_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_pause_share_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Share=function(_Component){_inherits(Share,_Component);function Share(props){_classCallCheck(this,Share);var _this2=_possibleConstructorReturn(this,(Share.__proto__||Object.getPrototypeOf(Share)).call(this,props));_this2.state={isPlay:false,duration:0,currentTime:0,img:__WEBPACK_IMPORTED_MODULE_2__static_images_play_share_png___default.a};_this2.audio=new Audio();_this2.audioPlay=_this2.audioPlay.bind(_this2);_this2.audioPause=_this2.audioPause.bind(_this2);_this2.handleClick=props.handleClick;return _this2;}_createClass(Share,[{key:'audioPlay',value:function audioPlay(){var _this3=this;this.audio.play();this.interval=setInterval(function(){console.log((_this3.state.currentTime/_this3.state.duration-0.03)*100);_this3.setState({currentTime:_this3.audio.currentTime});},100);console.log(this.audio.currentTime);this.setState({isPlay:true,img:__WEBPACK_IMPORTED_MODULE_3__static_images_pause_share_png___default.a});}},{key:'audioPause',value:function audioPause(){this.audio.pause();this.setState({isPlay:false,img:__WEBPACK_IMPORTED_MODULE_2__static_images_play_share_png___default.a});clearInterval(this.interval);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){if(this.props.audioUrl)this.audio.src=this.props.audioUrl;this.audio.src=this.props.audioUrl;}},{key:'render',value:function render(){var _this4=this;var _this=this;var _list=this.props.list||[];var listItem=_list.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,style:{backgroundImage:'url('+ele.courseDetailCoverHPhoto+'?x-oss-process=image/resize,w_490)'},onClick:function onClick(){_this.props.handlePush(ele.classSchId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},ele.courseDetailEnName));});this.audio.oncanplaythrough=function(){_this.setState({duration:Math.round(this.duration)});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container share'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.stuPortrait,alt:'\u7528\u6237\u5934\u50CF'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u4F60\u7684\u597D\u53CB',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.stuEnName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\u9080\u4F60\u4E00\u8D77\u6765\u53C2\u4E0EAir Course')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn'},'\u6253\u5F00')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_top',style:{backgroundImage:'url('+this.props.courseDetailGroupMpPhoto+'?x-oss-process=image/resize,w_1000)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_title'},this.props.courseDetailEnName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_start',onClick:function onClick(){if(_this4.state.isPlay)_this4.audioPause();else _this4.audioPlay();},style:{backgroundImage:'url('+this.state.img+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_time'},Object(__WEBPACK_IMPORTED_MODULE_1__utils_tools__["i" /* secondsTypefy */])(this.state.currentTime)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insert',style:{right:(1-this.state.currentTime/this.state.duration)*100+'%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointer',style:{left:(this.state.currentTime/this.state.duration-0.03)*100+'%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_end'},Object(__WEBPACK_IMPORTED_MODULE_1__utils_tools__["i" /* secondsTypefy */])(this.state.duration)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'player_bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.stuPortrait,alt:'\u7528\u6237\u5934\u50CF'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user_name'},this.props.stuEnName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5206\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u66F4\u591A\u4F5C\u54C1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,listItem)));}}]);return Share;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Share);

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAuCAMAAAB6WzuLAAAAllBMVEUAAAAY0ekfyPMgyPMgyPIuye4Qw+gfyPMgyPIgyPIgyfIfyPIfyPMgyfMgyfMgyPMfyfMgx+8hyfMeyvggyPIgyfMgyPEgyfIgyPIgyPEfyPIgyfMgyPMfyfMgyfQhyPEgyvEeyfIfv/AgyPMfyPIgyPMgyPEhyvMgyPIfx/QnzvYgyPIgyPIgx/Agx/IeyPEey/IgyPL9MXxVAAAAMXRSTlMACvz48QUD5ci+9aORfmZHMR8VEO7o3tnNu5lzblFLNSQZCNGyqIJVQi0N1sOJX1w7/lEWHAAAATBJREFUOMuF1VeSg0AMBNBmyDY2BudssNdpI/e/3FZBU/xMg37nlYQmCABpPDKbKXpiUtWxnUtxqhjhWZG4asNVxdyqi7FvJfXa3TRmlUni/C1ZLJUEecRiE0ng72iiuSLAccRiM0lQrJjoJ1AE/rbt3lEE2LP7MJMElwUTpZIAnzR3XxK03W/mkuDZda8InJCJpoEiQNv9rZQEB3a/LCRBxu69tyTAtTFJD0HSbHQfwbFe1KT95EUPiXjqksy8RphMkZ2hOMNOynV3ke3kOKLY+7CTG4H3EiedhxQfb9jJ3lA8AliJHxGsLuLunpcU3yWsJEgIzFM8tfxK8ZXDTh4exSGAlThjAm8mhsdr3W6GAzuZuHw5v0PjcH0ZGKomCQZGs3caGvBxAR1p7Pb+Jv4B3Q1nuSr1ZsAAAAAASUVORK5CYII="

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAuBAMAAACytabNAAAAFVBMVEUAAAAgyPIgyPIgyPIgyPIgyPIgyPIc+LnVAAAABnRSTlMA8a0nKCWPqJUsAAAASUlEQVQoz2NgVRQKYIABCM8wLU0YLgLhqaWlJcFFIDyxtLREuAiElwYEcBEwb1RoVGgoC2EmcmxZwTEtTQQuAuExKwoZwEXAPABja4m7LZr2XwAAAABJRU5ErkJggg=="

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_guide_png__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_guide_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_images_guide_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_guide_btn_png__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_guide_btn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_guide_btn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Guide=function(_Component){_inherits(Guide,_Component);function Guide(props){_classCallCheck(this,Guide);var _this=_possibleConstructorReturn(this,(Guide.__proto__||Object.getPrototypeOf(Guide)).call(this,props));_this.state={};_this.handleClick=props.handleClick;console.log(props);return _this;}_createClass(Guide,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__static_images_guide_png___default.a,alt:'\u56FE\u7247',className:'guideImg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__static_images_guide_btn_png___default.a,alt:'\u56FE\u7247',className:'btnImg',onClick:this.handleClick}));}}]);return Guide;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Guide);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guide.9d5300e4.png";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guide_btn.4568e90f.png";

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Pay_Success__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_client__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var queryPara=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var SuccessPage=function(_Component){_inherits(SuccessPage,_Component);function SuccessPage(props){_classCallCheck(this,SuccessPage);var _this=_possibleConstructorReturn(this,(SuccessPage.__proto__||Object.getPrototypeOf(SuccessPage)).call(this,props));_this.state={result:false,stuId:queryPara.stuid,courseId:queryPara.courseid};_this.getOrderStatus=function(){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getOrderStatus({query:queryPara.orderno},function(res,err){if(err)console.log(err);else{if(res.status!==0){clearInterval(_this.interval);if(res.status===1){_this.setState({totalAmount:res.totalAmount,success:1});__WEBPACK_IMPORTED_MODULE_6__api_client__["a" /* default */].h5Message({htmlTitle:'支付成功'});}else{_this.setState({totalAmount:res.totalAmount,success:0});__WEBPACK_IMPORTED_MODULE_6__api_client__["a" /* default */].h5Message({htmlTitle:'支付失败'});}_this.setState({result:true,channel:queryPara.channel});}}});};if(queryPara.type!=='weixinfail'){_this.interval=setInterval(function(){_this.getOrderStatus();setTimeout(function(){clearInterval(_this.interval);},60000*2);},3000);}else{_this.state={totalAmount:queryPara.totalamount,success:Number(queryPara.success),channel:queryPara.channel,result:true};}// if(queryPara.orderno){
// else{
//     if(props.location.state){
//         this.state = {
//             num:props.location.state.num,
//             totalAmount:props.location.state.totalAmount,
//             success:props.location.state.success,
//         };
//     }
// }
_this.handleBack=_this.handleBack.bind(_this);return _this;}_createClass(SuccessPage,[{key:'handleBack',value:function handleBack(){var history=this.props.history;history.replace({pathname:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* COURSE_URL */]+'/apppay',search:window.location.search});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:''+(this.state.result?'支付完成':'正在支付')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Pay_Success__["a" /* default */],Object.assign({},this.state,{handleBack:this.handleBack,type:queryPara.type}))));}}]);return SuccessPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SuccessPage);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_success_pay_png__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_success_pay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_success_pay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_fail_pay_png__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_fail_pay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_fail_pay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_weixinfail_pay_png__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_weixinfail_pay_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_images_weixinfail_pay_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appStyle_less__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appStyle_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__appStyle_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Success=function(_Component){_inherits(Success,_Component);function Success(){_classCallCheck(this,Success);return _possibleConstructorReturn(this,(Success.__proto__||Object.getPrototypeOf(Success)).apply(this,arguments));}_createClass(Success,[{key:'render',value:function render(){var _props=this.props,result=_props.result,type=_props.type,totalAmount=_props.totalAmount,num=_props.num,success=_props.success,channel=_props.channel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:result?"container success "+(type==='weixinfail'?'weixinfail':''):"container success "+type},!result&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__static_images_weixinfail_pay_png___default.a,alt:'\u56FE\u7247'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].closeH5Page({reason:'closeSafe'});}},'\u5DF2\u652F\u4ED8'))// :
// <div className="notice">
//     <div className="icon">温馨提示</div>
//     <div className="text">受春节物流停运影响, 实验套装寄送可能受到阻延,实际以【我的】中的物流信息为准。</div>
// </div>
,type!=='weixinfail'&&result&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'number'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,totalAmount?totalAmount/100:num),'\u5143'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},success?'支付成功':'支付失败'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:success?__WEBPACK_IMPORTED_MODULE_2__static_images_success_pay_png___default.a:__WEBPACK_IMPORTED_MODULE_3__static_images_fail_pay_png___default.a,alt:'\u56FE\u7247'})),type==='weixinfail'&&result&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__static_images_weixinfail_pay_png___default.a,alt:'\u56FE\u7247'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u672A\u5B89\u88C5\u5FAE\u4FE1',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8BF7\u9009\u62E9\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F')),channel!=='others'&&result&&// <div className="btn" onClick={()=>{handleBack()}}>返回</div>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].closeH5Page({reason:'closeSafe'});}},'\u5B8C\u6210'));}}]);return Success;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Success);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/success_pay.7490d42e.png";

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/weixinfail_pay.7cf4cc5e.png";

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RulesPage=function(_Component){_inherits(RulesPage,_Component);function RulesPage(props){_classCallCheck(this,RulesPage);var _this=_possibleConstructorReturn(this,(RulesPage.__proto__||Object.getPrototypeOf(RulesPage)).call(this,props));_this.state={};return _this;}_createClass(RulesPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课服务使用协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container customerrules'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u7231\u8BFE\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B\u662F\u60A8\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u4E0E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u4E4B\u95F4\u5728\u4F7F\u7528\u5176\u7BA1\u7406\u7684\u7231\u8BFE\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u201D\uFF09\u4E2D\u6CE8\u518C\u4F7F\u7528\u65F6\u7B7E\u7F72\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E00\u3001\u91CD\u8981\u987B\u77E5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u5E94\u8BA4\u771F\u9605\u8BFB\uFF08\u672A\u6210\u5E74\u4EBA\u5E94\u5F53\u5728\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\uFF09\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u9664\u975E\u7528\u6237\u63A5\u53D7\u672C\u534F\u8BAE\uFF0C\u7528\u6237\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u53CA\u4F7F\u7528\u884C\u4E3A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7231\u8BFE\u5C06\u7ED9\u4E88\u6BCF\u4E2A\u7528\u6237\u4E00\u4E2A\u7528\u6237\u5E10\u53F7\u53CA\u76F8\u5E94\u7684\u5BC6\u7801\uFF0C\u8BE5\u7528\u6237\u5E10\u53F7\u548C\u5BC6\u7801\u7531\u7528\u6237\u8D1F\u8D23\u4FDD\u7BA1\uFF1B\u7528\u6237\u59A5\u5584\u4FDD\u7BA1\u5E10\u53F7\u548C\u5BC6\u7801\uFF0C\u9632\u6B62\u6CC4\u9732\uFF0C\u5982\u679C\u5E10\u53F7\u548C\u5BC6\u7801\u88AB\u76D7\u7528\u7684\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E8C\u3001\u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u7231\u8BFE\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u4EC5\u63D0\u4F9B\u8F6F\u4EF6\u76F8\u5173\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u8F6F\u4EF6\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u624B\u673A\u3001\u4E2A\u4EBA\u7535\u8111\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u4E3A\u672C\u534F\u8BAE\u5C65\u884C\u6216\u76F8\u5173\u7814\u7A76\u7684\u76EE\u7684\u6536\u96C6\u3001\u4F7F\u7528\u6216\u6388\u6743\u7B2C\u4E09\u65B9\uFF08\u4E14\u8BE5\u7B49\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E\u7231\u8BFE\u540C\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u4E49\u52A1\uFF09\u975E\u5546\u4E1A\u5730\u4F7F\u7528\u901A\u8FC7\u670D\u52A1\u83B7\u53D6\u7684\u7528\u6237\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8EAB\u4EFD\u4FE1\u606F\u3001\u6027\u522B\u3001\u804C\u4E1A\u3001\u5174\u8DA3\u7231\u597D\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8BED\u97F3\u8D44\u6599\uFF09\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u4E8E\u6392\u884C\u699C\u4E0A\uFF0C\u4F7F\u7231\u8BFE\u5176\u4ED6\u7528\u6237\u53EF\u4EE5\u67E5\u770B\u7528\u6237\u7684\u5934\u50CF\u3001\u540D\u5B57\u3001\u8BED\u97F3\u7B49\u4E2A\u4EBA\u8D44\u6599\u3001\u5E94\u7528\u4E8E\u76F8\u5173\u5B66\u672F\u3001\u5E94\u7528\u7814\u7A76\u7B49\u3002\u7231\u8BFE\u627F\u8BFA\uFF0C\u9664\u975E\u53E6\u884C\u53D6\u5F97\u7528\u6237\u7684\u4E8B\u5148\u540C\u610F\uFF0C\u5426\u5219\u7231\u8BFE\u4E0D\u4F1A\u5C06\u7528\u6237\u4FE1\u606F\u6388\u6743\u7ED9\u4E0E\u5C65\u884C\u672C\u534F\u8BAE\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u7528\u4E8E\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u56FD\u5BB6\u6807\u51C6\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4F9D\u6CD5\u6536\u96C6\u5E76\u4F7F\u7528\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u4E14\u65E0\u9700\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u4ED6\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u7528\u6237\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF085\uFF09\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\uFF1A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF087\uFF09\u6839\u636E\u7528\u6237\u7684\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF088\uFF09\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\uFF1A\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF089\uFF09\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF0810\uFF09\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF089\uFF09\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u4E8B\u5148\u5F81\u5F97\u7528\u6237\u7684\u6388\u6743\u540C\u610F\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF085\uFF09\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E09\u3001\u7528\u6237\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u8F6F\u4EF6\u529F\u80FD\u4E0E\u7528\u6237\u8FDB\u884C\u5206\u4EAB\u4EA4\u6D41\uFF0C\u5305\u62EC\u8BFE\u7A0B\u5B66\u4E60\u3001\u53D1\u5E16\u6559\u5B66\u3001\u6B4C\u66F2\u6F14\u5531\u4EE5\u53CA\u5206\u4EAB\u5176\u4ED6\u4E00\u5207\u7528\u6237\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4E3B\u9875\u3001\u7167\u7247\u4E0A\u4F20\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u65F6\u987B\u9075\u5B88\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u4E0D\u5F97\u4ECE\u4E8B\u4EE5\u4E0B\u884C\u4E3A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.2 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.3 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.4 \u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.5 \u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5E73\u53F0\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u5FC5\u987B\u6E05\u695A\u4F7F\u7528\u89C4\u5219\uFF0C\u7231\u8BFE\u4EC5\u4F9B\u4E2A\u4EBA\u4EA4\u6D41\u3001\u5B66\u4E60\u6B23\u8D4F\uFF0C\u975E\u5546\u4E1A\u6027\u8D28\u7684\u4F7F\u7528\uFF0C\u7528\u6237\u4E0D\u53EF\u5229\u7528\u672C\u670D\u52A1\u5BF9\u4FE1\u606F\u6216\u8868\u6F14\u7B49\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u8FDB\u884C\u51FA\u552E\u3001\u6216\u5229\u7528\u672C\u670D\u52A1\u8FDB\u884C\u8C03\u67E5\u3001\u5E7F\u544A\u3001\u6216\u7528\u4E8E\u5176\u4ED6\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001 \u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u65F6\u53D1\u5E03\u3001\u4F20\u64AD\u7684\u4FE1\u606F\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\uFF0C\u4FDD\u8BC1\u4E0D\u5F97\u53D1\u5E03\u8C23\u8A00\u6216\u5176\u4ED6\u4E0E\u4E8B\u5B9E\u4E0D\u7B26\u5F15\u8D77\u4ED6\u4EBA\u4E0D\u9002\u7684\u8A00\u8BBA\u3001\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\u3001\u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u4E0D\u5F97\u53D1\u5E03\u3001\u4F20\u64AD\u4FB5\u72AF\u77E5\u8BC6\u4EA7\u6743\u6216\u5176\u4ED6\u5408\u6CD5\u6743\u76CA\u7684\u4FE1\u606F\u3002\u7528\u6237\u4F20\u64AD\u5185\u5BB9\u4E2D\u6D89\u53CA\u7B2C\u4E09\u65B9\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u7684\u76F8\u5173\u6388\u6743\u6216\u5176\u4ED6\u5185\u5BB9\u7684\u5408\u6CD5\u6027\u7531\u7528\u6237\u81EA\u884C\u8D1F\u8D23\uFF0C\u7231\u8BFE\u5BF9\u76F8\u5173\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5C5E\u6216\u662F\u5426\u4FB5\u72AF\u4ED6\u4EBA\u6C11\u4E8B\u6743\u76CA\u7B49\u60C5\u51B5\u4E0D\u8FDB\u884C\u5BA1\u67E5\u6216\u76D1\u7763\uFF0C\u4F46\u5C06\u6309\u76F8\u5173\u6CD5\u89C4\u5BF9\u6D89\u5ACC\u4FB5\u6743\u7684\u5185\u5BB9\u5C65\u884C\u5220\u9664\u6216\u65AD\u5F00\u94FE\u63A5\u7B49\u804C\u8D23\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'7\u3001\u82E5\u7528\u6237\u53D1\u751F\u524D\u8FF03-6\u7684\u884C\u4E3A\u65F6\uFF0C\u7531\u7528\u6237\u627F\u62C5\u6240\u6709\u7684\u8FDD\u6CD5\u3001\u4FB5\u6743\u8D23\u4EFB\uFF0C\u82E5\u56E0\u6B64\u7ED9\u7231\u8BFE\u9020\u6210\u4EFB\u4F55\u635F\u5931\uFF0C\u7231\u8BFE\u6709\u6743\u5411\u8D23\u4EFB\u7528\u6237\u4E3B\u5F20\u76F8\u5173\u8D23\u4EFB\u3002\u540C\u65F6\uFF0C\u7231\u8BFE\u6709\u6743\u5BF9\u8FDD\u6CD5\u3001\u4FB5\u6743\u3001\u8FDD\u89C4\u7684\u7528\u6237\u7EC8\u6B62\u63D0\u4F9B\u670D\u52A1\u3002\u5982\u679C\u653F\u5E9C\u6216\u8005\u53F8\u6CD5\u673A\u5173\u8981\u6C42\u7231\u8BFE\u544A\u77E5\u8FDB\u884C\u4FB5\u6743\u884C\u4E3A\u7528\u6237\u7684\u5177\u4F53\u4FE1\u606F\u7684\uFF0C\u7231\u8BFE\u6709\u6743\u6839\u636E\u73B0\u884C\u6CD5\u89C4\u5411\u5176\u544A\u77E5\u7528\u6237\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'8\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u6709\u6743\u5728\u63D0\u4F9B\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u7231\u8BFE\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u56DB\u3001\u77E5\u8BC6\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u5206\u4EAB\u4E2A\u4EBA\u4F5C\u54C1\u65F6\uFF0C\u4E0D\u5F97\u4FB5\u72AF\u7B2C\u4E09\u65B9\u4EFB\u4F55\u77E5\u8BC6\u4EA7\u6743\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u5206\u4EAB\u4FE1\u606F\u4E2D\u542B\u6709\u7684\u5B8C\u5168\u7531\u7528\u6237\u81EA\u8EAB\u539F\u521B\u4FE1\u606F\u7684\u7248\u6743\u5F52\u7528\u6237\uFF0C\u4F46\u5176\u4E2D\u5229\u7528\u7231\u8BFE\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\uFF0C\u5229\u7528\u7231\u8BFE\u4E2D\u5DF2\u6709\u7D20\u6750\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\u7684\u7248\u6743\u7531\u7528\u6237\u4E0E\u7231\u8BFE\u5171\u6709\u3002\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u662F\u5BF9\u5176\u4EAB\u6709\u7248\u6743\u6216\u7ECF\u5408\u6CD5\u6388\u6743\u7684\u76F8\u5173\u5185\u5BB9\u7684\u7F51\u7EDC\u4F20\u64AD\u884C\u4E3A\u8BB8\u53EF\uFF0C\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u5373\u8868\u660E\u5176\u5DF2\u6388\u6743\u7231\u8BFE\u53CA\u5176\u4ED6\u7528\u6237\u6709\u6743\u590D\u5236\u3001\u4F20\u64AD\u524D\u8FF0\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E94\u3001\u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u9274\u4E8E\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u7231\u8BFE\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u670D\u52A1\u53CA\u514D\u8D39\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u7231\u8BFE\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u7231\u8BFE\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u670D\u52A1\u7684\u5E73\u53F0\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u7231\u8BFE\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u7231\u8BFE\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED90\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u5728\u63D0\u793A\u7528\u6237\u9700\u572810\u65E5\u5185\u6295\u5165\u5B9E\u9645\u4F7F\u7528\u540E\uFF0C\u82E5\u7528\u6237\u4E8E\u8BE510\u65E5\u5185\u4ECD\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u7231\u8BFE\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u5E10\u53F7\u6635\u79F0\u5982\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u56FD\u5BB6\u653F\u7B56\u8981\u6C42\u3001\u7231\u8BFE\u7684\u6635\u79F0\u7BA1\u7406\u8981\u6C42\uFF0C\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\uFF0C\u7231\u8BFE\u6709\u6743\u8981\u6C42\u7528\u6237\u8FDB\u884C\u4FEE\u6539\u6216\u6536\u56DE\u8BE5\u8D26\u53F7\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u516D\u3001\u5176\u4ED6\u4E8B\u5B9C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u6709\u6743\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u53D8\u5316\u3001\u7F51\u7AD9\u4EE5\u53CA\u76F8\u5E94\u7684\u7231\u8BFE\u8FD0\u8425\u7684\u9700\u8981\u4E0D\u65F6\u5730\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u5185\u5BB9\u8FDB\u884C\u4FEE\u6539\uFF0C\u5E76\u5728\u7F51\u7AD9\u4EE5\u53CA\u7231\u8BFE\u9192\u76EE\u4F4D\u7F6E\u5F20\u8D34\u3002\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\uFF0C\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\uFF0C\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u534F\u8BAE\u3002\u7528\u6237\u6709\u4E49\u52A1\u53CA\u65F6\u5173\u6CE8\u5E76\u9605\u8BFB\u6700\u65B0\u7248\u7684\u534F\u8BAE\u53CA\u7F51\u7AD9\u516C\u544A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\uFF0C\u53EF\u4EE5\u7ACB\u5373\u5411\u7231\u8BFE\u8FDB\u884C\u53CD\u9988\u4E14\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u7231\u8BFE\u4F9D\u636E\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u670D\u52A1\uFF1B\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u7684\uFF0C\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u672C\u534F\u8BAE\u81EA\u7528\u6237\u70B9\u51FB\u201C\u540C\u610F\u201D\u3001\u201C\u63A5\u53D7\u201D\u540E\u751F\u6548\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE,\u4E0D\u5177\u6CD5\u5F8B\u6216\u5951\u7EA6\u6548\u679C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u672C\u534F\u8BAE\u7684\u89E3\u91CA\u6743\u5F52\u7231\u8BFE\u6240\u6709\u3002')));}}]);return RulesPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RulesPage);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_guide_1_jpg__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_guide_1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_guide_1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_guide_2_jpg__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_guide_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_images_guide_2_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GuidePage=function(_Component){_inherits(GuidePage,_Component);function GuidePage(){_classCallCheck(this,GuidePage);return _possibleConstructorReturn(this,(GuidePage.__proto__||Object.getPrototypeOf(GuidePage)).apply(this,arguments));}_createClass(GuidePage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'新手指南'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container guide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section section1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u54C8\u4F5B\u96C6\u8BAD\u8425\u4E3B\u9898\u7279\u8272'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__static_images_guide_1_jpg___default.a,alt:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u7231\u8BFE\u82F1\u8BED100%\u9009\u7528\u54C8\u4F5B\u5916\u6559\uFF0C\u65E8\u5728\u4E3A\u4E2D\u56FD\u5C0F\u670B\u53CB\u63D0\u4F9B\u9AD8\u8D28\u91CF\u5728\u7EBF\u4E3B\u9898\u82F1\u8BED\u8BFE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__static_images_guide_2_jpg___default.a,alt:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u6BCF\u5929\u4E00\u4E2A\u4E3B\u9898\u8BFE\u7A0B\uFF0C4\u540D\u5B66\u751F\u5206\u7EC4\u5B66\u4E60\uFF0CAI\u6307\u5357\u6559\u5B66\uFF0C\u4EBA\u673A\u4E92\u52A8\uFF0C\u5B9E\u73B0\u82F1\u8BED\u52A0\u77E5\u8BC61+1\u6559\u80B2\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section section2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u4E3B\u9898\u8BFE - \u5B66\u4E60\u6D41\u7A0B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content img1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content img2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content img3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content img4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section section3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u5E38\u89C1\u95EE\u9898'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. \u4E0D\u540C\u7A0B\u5EA6\u7684\u5B69\u5B50\u4E00\u8D77\u4E0A\u8BFE\u5417\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7CFB\u7EDF\u4F1A\u6839\u636E\u5E74\u9F84\uFF0C\u6700\u5927\u7A0B\u5EA6\u7684\u5C06\u540C\u5E74\u9F84\u6BB5\u7684\u5B69\u5B50\u5206\u914D\u5230\u540C\u4E00\u6559\u5BA4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. \u901A\u8FC7\u4E0A\u8BFE\u5B69\u5B50\u53EF\u4EE5\u5B66\u5230\u4EC0\u4E48\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E0A\u8BFE\u5185\u5BB9\u6309\u7167\u7F8E\u56FD\u513F\u7AE5\u5730\u7406\u7684\u4E3B\u9898\u8BBE\u7F6E\uFF0C\u662F\u5178\u578B\u7684\u901A\u8BC6\u6559\u80B2\uFF0C\u6D89\u53CA\u751F\u547D\u79D1\u5B66\u3001\u81EA\u7136\u5730\u7406\u3001\u97F3\u4E50\u6587\u5316\u3001\u54F2\u5B66\u5B97\u6559\u3001\u4EBA\u6587\u827A\u672F\u7B49\u591A\u65B9\u4F4D\u77E5\u8BC6\uFF0C\u6BCF\u5929\u4E00\u4E2A\u4E3B\u9898\u8BFE\u7A0B\uFF0C\u5B9E\u73B0\u82F1\u8BED\u52A0\u77E5\u8BC6\u76841+1\u6559\u80B2\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u4F55\u65F6\u5F00\u59CB\u4E0A\u8BFE\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6BCF\u592919:30\u54C8\u4F5B\u8001\u5E08\u51C6\u65F6\u5F00\u8BFE\uFF0C\u51E1\u8D2D\u4E70\u201C\u54C8\u4F5B\u5916\u6559\u96C6\u8BAD\u8425\u201D\u5957\u9910\u7684\u7528\u6237\uFF0C\u53EF\u5728\u6709\u6548\u671F\u5185\u524D\u5F80\u4E0A\u8BFE\u3002\u5728APP\u4E0A\u8BFE\u9875\uFF0C\u53EF\u67E5\u770B\u6700\u8FD17\u5929\u7684\u8BFE\u7A0B\u5B89\u6392\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. \u8BBE\u5907\u68C0\u6D4B\u6709\u4EC0\u4E48\u7528\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E0A\u8BFE\u8FC7\u7A0B\u4E2D\u4F1A\u5360\u7528\u9EA6\u514B\u98CE\u548C\u6444\u50CF\u5934\uFF0C\u8BFE\u524D\u8FDB\u884C\u8BBE\u5907\u68C0\u6D4B\u4F1A\u4FDD\u8BC1\u4E0A\u8BFE\u4F53\u9A8C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u5728\u6559\u5BA4\u770B\u4E0D\u5230\u8001\u5E08\u548C\u5176\u4ED6\u5B66\u751F\u6216\u7ECF\u5E38\u88AB\u8E22\u51FA\u6559\u5BA4\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF7\u68C0\u67E5\u8BBE\u5907\u578B\u53F7\uFF0C\u6211\u4EEC\u652F\u6301\u7684\u8BBE\u5907\u578B\u53F7\u6709\uFF1AWindows7\u53CA\u4EE5\u4E0A\u3001iPad mini3\u53CA\u4EE5\u4E0A\u3001iPhone6\u53CA\u4EE5\u4E0A\u3001Android5.0\u53CA\u4EE5\u4E0A\u8BBE\u5907\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section section4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u95EE\u9898\u81EA\u67E5\u4E0E\u89E3\u51B3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u4E0A\u8BFE\u4E2D\u9014\u51FA\u73B0\u6CA1\u58F0\u97F3\u3001\u5361\u987F\u3001\u95EA\u9000\u7B49\u95EE\u9898\u65F6\uFF0C\u5EFA\u8BAE\u6309\u7167\u4EE5\u4E0B\u6B65\u9AA4\u8FDB\u884C\u5C1D\u8BD5\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. \u91CD\u542FAPP\uFF0C\u91CD\u65B0\u767B\u5F55'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. \u5173\u95ED\u65E0\u7EBF\u8DEF\u7531\u5668\uFF0C3\u79D2\u540E\u91CD\u65B0\u5F00\u542F\u65E0\u7EBF\u8DEF\u7531\u5668'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u7F51\u7EDC\u5207\u6362\u81F34G\u5C1D\u8BD5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. \u68C0\u67E5\u8BBE\u5907\u5185\u5B58\u662F\u5426\u5DF2\u6EE1\uFF0C\u5173\u95ED\u5176\u4ED6APP\u8FDB\u7A0B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5. \u627E\u5230\u4E0B\u8F7D\u5730\u5740\uFF0C\u91CD\u65B0\u4E0B\u8F7D\u6700\u65B0\u7248\u672CAir Course'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section section5',style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'head'},'\u6CE8\u610F\u4E8B\u9879'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. \u4E3A\u4E86\u4FDD\u8BC1\u6709\u826F\u597D\u7684\u4E0A\u8BFE\u4F53\u9A8C\uFF0C\u4E0A\u8BFE\u524D\uFF0C\u8BF7\u4FDD\u6301\u4E0A\u8BFE\u7684\u8BBE\u5907\u7F51\u7EDC\u7A33\u5B9A\u901A\u7545\uFF0C\u5E76\u4E14\u8BBE\u5907\u5185\u5B58\u5145\u8DB3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. \u4E0A\u8BFE\u671F\u95F4\uFF0C\u6700\u597D\u4E0D\u8981\u5F00\u542F\u5F55\u5C4F\u3001\u5F55\u97F3\u7B49\u5360\u7528\u9EA6\u514B\u98CE\u3001\u6444\u50CF\u5934\u7684\u5176\u4ED6\u7C7BAPP\uFF1B\u6700\u597D\u4E0D\u8981\u6253\u5F00\u5FAE\u4FE1\u3001QQ\u7B49\u6709\u5BC6\u96C6\u901A\u77E5\u7684APP\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. \u4E3A\u4E86\u60A8\u548C\u5176\u4ED6\u4EBA\u7684\u6559\u5B66\u4F53\u9A8C\uFF0C\u8BF7\u9009\u62E9\u5B89\u9759\u7684\u73AF\u5883\u8FDB\u884C\u4E0A\u8BFE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. \u5728\u4E0A\u8BFE\u8FC7\u7A0B\u4E2D\uFF0C\u4F1A\u6709\u8DDF\u8BFB\u73AF\u8282\uFF0C\u5EFA\u8BAE\u5927\u58F0\u8BFB\u51FA\u6765\u6216\u8005\u4F7F\u7528\u8033\u9EA6\uFF0C\u4E0D\u53D1\u58F0\u4F1A\u5F71\u54CD\u8BC4\u5206\u54E6\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u6709\u5176\u4ED6\u7591\u95EE\uFF0C\u8BF7\u8054\u7CFB400-688-6057')))));}}]);return GuidePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GuidePage);

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.c6777750.jpg";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.1a76c5b5.jpg";

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyPage=function(_Component){_inherits(PrivacyPage,_Component);function PrivacyPage(props){_classCallCheck(this,PrivacyPage);var _this=_possibleConstructorReturn(this,(PrivacyPage.__proto__||Object.getPrototypeOf(PrivacyPage)).call(this,props));_this.state={};return _this;}_createClass(PrivacyPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课隐私政策'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u9690\u79C1\u653F\u7B56\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528AirCourse\u7231\u8BFE\u5E73\u53F0\uFF0CAirCourse\u7231\u8BFE\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u7231\u8BFE\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7231\u8BFE\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u54C8\u4F5B\u767E\u79D1\u3001\u79D1\u5B66\u5B9E\u9A8C\u8BFE\u3001\u81EA\u7136\u62FC\u8BFB\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u7231\u8BFE\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u7231\u8BFE\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u7231\u8BFE\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u7231\u8BFE\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5F53\u60A8\u9009\u62E9\u901A\u8FC7\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u8D26\u6237\u767B\u5F55\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u540C\u610F\u6211\u4EEC\u4ECE\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u83B7\u53D6\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4FE1\u606F\uFF08\u5305\u62EC\u624B\u673A\u53F7\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\uFF0C\u5E76\u4E14\u60A8\u540C\u610F\u5C06\u60A8\u7684\u7B2C\u4E09\u65B9\u8D26\u6237\u4E0E\u60A8\u7684\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4F7F\u60A8\u53EF\u4EE5\u901A\u8FC7\u7B2C\u4E09\u65B9\u8D26\u6237\u76F4\u63A5\u767B\u5F55\u5E76\u4F7F\u7528\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u501F\u52A9\u8BE5\u8D26\u6237\u5B9E\u73B0\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u6211\u4EEC\u4F1A\u4F9D\u636E\u4E0E\u7B2C\u4E09\u65B9\u7684\u7EA6\u5B9A\uFF0C\u5E76\u5728\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u524D\u63D0\u4E0B\uFF0C\u4F7F\u7528\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u540C\u610F\u7231\u8BFE\u4ECE\u7B2C\u4E09\u65B9\u83B7\u53D6\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4FE1\u606F\uFF0C\u60A8\u5C06\u65E0\u6CD5\u901A\u8FC7\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u8D26\u6237\u7684\u65B9\u5F0F\u6CE8\u518C\u8D26\u53F7\u5E76\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u501F\u52A9\u8BE5\u7B2C\u4E09\u65B9\u8D26\u6237\u5B9E\u73B0\u6570\u636E\u7684\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09'),'\uFF0C\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.5 \u60A8\u8D2D\u4E70\u7231\u8BFE\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u7231\u8BFE\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u652F\u4ED8\u65B9\u5F0F\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u94F6\u884C\u8D26\u53F7\u7B49\u4FE1\u606F\u3002'),'\u5982\u60A8\u7684\u8D2D\u4E70\u662F\u901A\u8FC7\u7B2C\u4E09\u65B9\u8FDB\u884C\u7684\uFF0C\u6211\u4EEC\u53EF\u80FD\u8FD8\u4F1A\u6536\u96C6\u60A8\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\uFF08',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49'),'\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u7231\u8BFE\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u94F6\u884C\u8D26\u53F7\u3001\u7B2C\u4E09\u65B9\u652F\u4ED8\u5E73\u53F0\u7684\u8D26\u53F7\uFF08\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49\uFF09\u3001\u4E0E\u7231\u8BFE\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7231\u8BFE\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u7231\u8BFE\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u7231\u8BFE\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF08\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u7B49\uFF09\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u7231\u8BFE\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u7231\u8BFE\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u82E5\u60A8\u5E0C\u671B\u5411\u7231\u8BFE\u4E0A\u4F20\u60A8\u7684\u5934\u50CF\u53CA/\u6216\u5176\u4ED6\u56FE\u7247\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u7231\u8BFE\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u7231\u8BFE\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u7231\u8BFE\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F'),'\uFF0C\u4F46\u7231\u8BFE\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u7231\u8BFE\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355'),'\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u7231\u8BFE\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u7231\u8BFE\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u7231\u8BFE\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u7B2C\u4E09\u65B9\u652F\u4ED8\u5E73\u53F0\u83B7\u5F97',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\uFF08\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49\uFF09'),'\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u7231\u8BFE\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u7231\u8BFE\u6216\u8005\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u7231\u8BFE\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u7231\u8BFE\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u7231\u8BFE\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u7231\u8BFE\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u7231\u8BFE\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u7231\u8BFE\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u7231\u8BFE\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u7231\u8BFE\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u7231\u8BFE\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u7231\u8BFE\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u7231\u8BFE\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u7231\u8BFE\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u7231\u8BFE\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u7231\u8BFE\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u7231\u8BFE\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u7231\u8BFE\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u7231\u8BFE\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u7231\u8BFE\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u7231\u8BFE\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u7231\u8BFE\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u7231\u8BFE\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u7231\u8BFE\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u7231\u8BFE\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u7231\u8BFE\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u7231\u8BFE\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u7231\u8BFE\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u7231\u8BFE\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u7231\u8BFE\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u7231\u8BFE\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5982\u4E0D\u5E78\u53D1\u751F\u4FE1\u606F\u5B89\u5168\u4E8B\u6545\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\uFF0C\u53CA\u65F6\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u548C\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u7B49\u3002\u6211\u4EEC\u540C\u65F6\u5C06\u53CA\u65F6\u5C06\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u9002\u5408\u7684\u65B9\u5F0F\u544A\u77E5\u60A8\uFF1B\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E3B\u52A8\u4E0A\u62A5\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u7231\u8BFE\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u7231\u8BFE\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u7231\u8BFE\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u7231\u8BFE\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u7231\u8BFE\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3 \u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u7231\u8BFE\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u7231\u8BFE\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u7231\u8BFE\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u7231\u8BFE\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u7231\u8BFE\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u7231\u8BFE\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u7231\u8BFE\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u7231\u8BFE\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u7231\u8BFE\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u7231\u8BFE\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u7231\u8BFE\u505A\u51FA\u89E3\u91CA\uFF0C\u7231\u8BFE\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u7231\u8BFE\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u7231\u8BFE\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u7231\u8BFE\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u7231\u8BFE\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u7231\u8BFE\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u7231\u8BFE\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u7231\u8BFE\u4F1A\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u7231\u8BFE\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A\xA0400-887-4877\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5FAE\u4FE1\u516C\u4F17\u53F7\uFF1A\u7231\u8BFEAirCourse\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701 \u676D\u5DDE\u5E02 \u4F59\u676D\u533A \u4F59\u676D\u5858\u8DEF2301\u53F7\u6D77\u667A\u4E2D\u5FC38\u53F7\u697C\uFF08\u6536\u4EF6\u4EBA\uFF1A\u7231\u8BFE\u5BA2\u670D\u90E8\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u7231\u8BFE\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u7231\u8BFE\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return PrivacyPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrivacyPage);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Agreement=function(_Component){_inherits(Agreement,_Component);function Agreement(){_classCallCheck(this,Agreement);return _possibleConstructorReturn(this,(Agreement.__proto__||Object.getPrototypeOf(Agreement)).apply(this,arguments));}_createClass(Agreement,[{key:'render',// constructor (props) {
//   super(props)
// }
value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'agreementPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u300A\u7231\u8BFE\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),'\u662F\u60A8\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u4E0E\u676D\u5DDE\u6F58\u54D2\u7F51\u7EDC\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u4E4B\u95F4\u5728\u4F7F\u7528\u5176\u7BA1\u7406\u7684\u7231\u8BFE\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u201D\uFF09\u4E2D\u6CE8\u518C\u4F7F\u7528\u65F6\u7B7E\u7F72\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u4E00\u3001\u91CD\u8981\u987B\u77E5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'agreementEm\''},'1\u3001\u7528\u6237\u5E94\u8BA4\u771F\u9605\u8BFB\uFF08\u672A\u6210\u5E74\u4EBA\u5E94\u5F53\u5728\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\uFF09\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u9664\u975E\u7528\u6237\u63A5\u53D7\u672C\u534F\u8BAE\uFF0C\u7528\u6237\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u53CA\u4F7F\u7528\u884C\u4E3A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7231\u8BFE\u5C06\u7ED9\u4E88\u6BCF\u4E2A\u7528\u6237\u4E00\u4E2A\u7528\u6237\u5E10\u53F7\u53CA\u76F8\u5E94\u7684\u5BC6\u7801\uFF0C\u8BE5\u7528\u6237\u5E10\u53F7\u548C\u5BC6\u7801\u7531\u7528\u6237\u8D1F\u8D23\u4FDD\u7BA1\uFF1B\u7528\u6237\u59A5\u5584\u4FDD\u7BA1\u5E10\u53F7\u548C\u5BC6\u7801\uFF0C\u9632\u6B62\u6CC4\u9732\uFF0C\u5982\u679C\u5E10\u53F7\u548C\u5BC6\u7801\u88AB\u76D7\u7528\u7684\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u4E8C\u3001\u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u7231\u8BFE\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7231\u8BFE\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\uFF08\u4F8B\u5982\u8D2D\u4E70\u8BFE\u65F6\u7B49\uFF09\u4E3A\u6536\u8D39\u670D\u52A1\uFF0C\u7528\u6237\u4F7F\u7528\u6536\u8D39\u670D\u52A1\u9700\u8981\u5411\u7231\u8BFE\u652F\u4ED8\u4E00\u5B9A\u7684\u8D39\u7528\u3002\u5BF9\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u4F1A\u5728\u7528\u6237\u4F7F\u7528\u4E4B\u524D\u7ED9\u4E88\u7528\u6237\u660E\u786E\u7684\u63D0\u793A\uFF0C\u53EA\u6709\u7528\u6237\u6839\u636E\u63D0\u793A\u786E\u8BA4\u5176\u613F\u610F\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u7528\u6237\u624D\u80FD\u4F7F\u7528\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002\u5982\u7528\u6237\u62D2\u7EDD\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u5219\u7231\u8BFE\u6709\u6743\u4E0D\u5411\u7528\u6237\u63D0\u4F9B\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u4EC5\u63D0\u4F9B\u8F6F\u4EF6\u76F8\u5173\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u8F6F\u4EF6\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u624B\u673A\u3001\u4E2A\u4EBA\u7535\u8111\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u4E3A\u672C\u534F\u8BAE\u5C65\u884C\u6216\u76F8\u5173\u7814\u7A76\u7684\u76EE\u7684\u6536\u96C6\u3001\u4F7F\u7528\u6216\u6388\u6743\u7B2C\u4E09\u65B9\uFF08\u4E14\u8BE5\u7B49\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E\u7231\u8BFE\u540C\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u4E49\u52A1\uFF09\u975E\u5546\u4E1A\u5730\u4F7F\u7528\u901A\u8FC7\u670D\u52A1\u83B7\u53D6\u7684\u7528\u6237\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8EAB\u4EFD\u4FE1\u606F\u3001\u6027\u522B\u3001\u804C\u4E1A\u3001\u5174\u8DA3\u7231\u597D\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8BED\u97F3\u8D44\u6599\uFF09\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u4E8E\u6392\u884C\u699C\u4E0A\uFF0C\u4F7F\u7231\u8BFE\u5176\u4ED6\u7528\u6237\u53EF\u4EE5\u67E5\u770B\u7528\u6237\u7684\u5934\u50CF\u3001\u540D\u5B57\u3001\u8BED\u97F3\u7B49\u4E2A\u4EBA\u8D44\u6599\u3001\u5E94\u7528\u4E8E\u76F8\u5173\u5B66\u672F\u3001\u5E94\u7528\u7814\u7A76\u7B49\u3002\u7231\u8BFE\u627F\u8BFA\uFF0C\u9664\u975E\u53E6\u884C\u53D6\u5F97\u7528\u6237\u7684\u4E8B\u5148\u540C\u610F\uFF0C\u5426\u5219\u7231\u8BFE\u4E0D\u4F1A\u5C06\u7528\u6237\u4FE1\u606F\u6388\u6743\u7ED9\u4E0E\u5C65\u884C\u672C\u534F\u8BAE\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u7528\u4E8E\u5546\u4E1A\u76EE\u7684\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 5\u3001\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u56FD\u5BB6\u6807\u51C6\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4F9D\u6CD5\u6536\u96C6\u5E76\u4F7F\u7528\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u4E14\u65E0\u9700\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u4ED6\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u7528\u6237\u672C\u4EBA\u540C\u610F\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF085\uFF09\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\uFF1A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF087\uFF09\u6839\u636E\u7528\u6237\u7684\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF088\uFF09\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\uFF1A\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF089\uFF09\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF0810\uFF09\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF0811\uFF09\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 6\u3001\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u4E8B\u5148\u5F81\u5F97\u7528\u6237\u7684\u6388\u6743\u540C\u610F\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF085\uFF09\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u7528\u6237\u901A\u77E5\u5E76\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u4E09\u3001\u7528\u6237\u4F7F\u7528\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 1\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u8F6F\u4EF6\u529F\u80FD\u4E0E\u7528\u6237\u8FDB\u884C\u5206\u4EAB\u4EA4\u6D41\uFF0C\u5305\u62EC\u8BFE\u7A0B\u5B66\u4E60\u3001\u53D1\u5E16\u6559\u5B66\u3001\u6B4C\u66F2\u6F14\u5531\u4EE5\u53CA\u5206\u4EAB\u5176\u4ED6\u4E00\u5207\u7528\u6237\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4E3B\u9875\u3001\u7167\u7247\u4E0A\u4F20\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u65F6\u987B\u9075\u5B88\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u4E0D\u5F97\u4ECE\u4E8B\u4EE5\u4E0B\u884C\u4E3A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.1 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.2 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.3 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.4 \u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.5 \u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5E73\u53F0\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u5FC5\u987B\u6E05\u695A\u4F7F\u7528\u89C4\u5219\uFF0C\u7231\u8BFE\u4EC5\u4F9B\u4E2A\u4EBA\u4EA4\u6D41\u3001\u5B66\u4E60\u6B23\u8D4F\uFF0C\u975E\u5546\u4E1A\u6027\u8D28\u7684\u4F7F\u7528\uFF0C\u7528\u6237\u4E0D\u53EF\u5229\u7528\u672C\u670D\u52A1\u5BF9\u4FE1\u606F\u6216\u8868\u6F14\u7B49\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u8FDB\u884C\u51FA\u552E\u3001\u6216\u5229\u7528\u672C\u670D\u52A1\u8FDB\u884C\u8C03\u67E5\u3001\u5E7F\u544A\u3001\u6216\u7528\u4E8E\u5176\u4ED6\u5546\u4E1A\u76EE\u7684\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 5\u3001 \u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u65F6\u53D1\u5E03\u3001\u4F20\u64AD\u7684\u4FE1\u606F\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\uFF0C\u4FDD\u8BC1\u4E0D\u5F97\u53D1\u5E03\u8C23\u8A00\u6216\u5176\u4ED6\u4E0E\u4E8B\u5B9E\u4E0D\u7B26\u5F15\u8D77\u4ED6\u4EBA\u4E0D\u9002\u7684\u8A00\u8BBA\u3001\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 6\u3001\u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u4E0D\u5F97\u53D1\u5E03\u3001\u4F20\u64AD\u4FB5\u72AF\u77E5\u8BC6\u4EA7\u6743\u6216\u5176\u4ED6\u5408\u6CD5\u6743\u76CA\u7684\u4FE1\u606F\u3002\u7528\u6237\u4F20\u64AD\u5185\u5BB9\u4E2D\u6D89\u53CA\u7B2C\u4E09\u65B9\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u7684\u76F8\u5173\u6388\u6743\u6216\u5176\u4ED6\u5185\u5BB9\u7684\u5408\u6CD5\u6027\u7531\u7528\u6237\u81EA\u884C\u8D1F\u8D23\uFF0C\u7231\u8BFE\u5BF9\u76F8\u5173\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5C5E\u6216\u662F\u5426\u4FB5\u72AF\u4ED6\u4EBA\u6C11\u4E8B\u6743\u76CA\u7B49\u60C5\u51B5\u4E0D\u8FDB\u884C\u5BA1\u67E5\u6216\u76D1\u7763\uFF0C\u4F46\u5C06\u6309\u76F8\u5173\u6CD5\u89C4\u5BF9\u6D89\u5ACC\u4FB5\u6743\u7684\u5185\u5BB9\u5C65\u884C\u5220\u9664\u6216\u65AD\u5F00\u94FE\u63A5\u7B49\u804C\u8D23\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 7\u3001\u82E5\u7528\u6237\u53D1\u751F\u524D\u8FF03-6\u7684\u884C\u4E3A\u65F6\uFF0C\u7531\u7528\u6237\u627F\u62C5\u6240\u6709\u7684\u8FDD\u6CD5\u3001\u4FB5\u6743\u8D23\u4EFB\uFF0C\u82E5\u56E0\u6B64\u7ED9\u7231\u8BFE\u9020\u6210\u4EFB\u4F55\u635F\u5931\uFF0C\u7231\u8BFE\u6709\u6743\u5411\u8D23\u4EFB\u7528\u6237\u4E3B\u5F20\u76F8\u5173\u8D23\u4EFB\u3002\u540C\u65F6\uFF0C\u7231\u8BFE\u6709\u6743\u5BF9\u8FDD\u6CD5\u3001\u4FB5\u6743\u3001\u8FDD\u89C4\u7684\u7528\u6237\u7EC8\u6B62\u63D0\u4F9B\u670D\u52A1\u3002\u5982\u679C\u653F\u5E9C\u6216\u8005\u53F8\u6CD5\u673A\u5173\u8981\u6C42\u7231\u8BFE\u544A\u77E5\u8FDB\u884C\u4FB5\u6743\u884C\u4E3A\u7528\u6237\u7684\u5177\u4F53\u4FE1\u606F\u7684\uFF0C\u7231\u8BFE\u6709\u6743\u6839\u636E\u73B0\u884C\u6CD5\u89C4\u5411\u5176\u544A\u77E5\u7528\u6237\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 8\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u6709\u6743\u5728\u63D0\u4F9B\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u7231\u8BFE\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u56DB\u3001\u77E5\u8BC6\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 1\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u5206\u4EAB\u4E2A\u4EBA\u4F5C\u54C1\u65F6\uFF0C\u4E0D\u5F97\u4FB5\u72AF\u7B2C\u4E09\u65B9\u4EFB\u4F55\u77E5\u8BC6\u4EA7\u6743\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u5206\u4EAB\u4FE1\u606F\u4E2D\u542B\u6709\u7684\u5B8C\u5168\u7531\u7528\u6237\u81EA\u8EAB\u539F\u521B\u4FE1\u606F\u7684\u7248\u6743\u5F52\u7528\u6237\uFF0C\u4F46\u5176\u4E2D\u5229\u7528\u7231\u8BFE\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\uFF0C\u5229\u7528\u7231\u8BFE\u4E2D\u5DF2\u6709\u7D20\u6750\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\u7684\u7248\u6743\u7531\u7528\u6237\u4E0E\u7231\u8BFE\u5171\u6709\u3002\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u662F\u5BF9\u5176\u4EAB\u6709\u7248\u6743\u6216\u7ECF\u5408\u6CD5\u6388\u6743\u7684\u76F8\u5173\u5185\u5BB9\u7684\u7F51\u7EDC\u4F20\u64AD\u884C\u4E3A\u8BB8\u53EF\uFF0C\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u5373\u8868\u660E\u5176\u5DF2\u6388\u6743\u7231\u8BFE\u53CA\u5176\u4ED6\u7528\u6237\u6709\u6743\u590D\u5236\u3001\u4F20\u64AD\u524D\u8FF0\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u4E94\u3001\u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 1\u3001\u9274\u4E8E\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u7231\u8BFE\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u670D\u52A1\u53CA\u514D\u8D39\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u7231\u8BFE\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u7231\u8BFE\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u670D\u52A1\u7684\u5E73\u53F0\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u7231\u8BFE\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u7231\u8BFE\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED90\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u5728\u63D0\u793A\u7528\u6237\u9700\u572810\u65E5\u5185\u6295\u5165\u5B9E\u9645\u4F7F\u7528\u540E\uFF0C\u82E5\u7528\u6237\u4E8E\u8BE510\u65E5\u5185\u4ECD\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u7231\u8BFE\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u5E10\u53F7\u6635\u79F0\u5982\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u56FD\u5BB6\u653F\u7B56\u8981\u6C42\u3001\u7231\u8BFE\u7684\u6635\u79F0\u7BA1\u7406\u8981\u6C42\uFF0C\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\uFF0C\u7231\u8BFE\u6709\u6743\u8981\u6C42\u7528\u6237\u8FDB\u884C\u4FEE\u6539\u6216\u6536\u56DE\u8BE5\u8D26\u53F7\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u516D\u3001\u5176\u4ED6\u4E8B\u5B9C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 1\u3001\u7231\u8BFE\u6709\u6743\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u53D8\u5316\u3001\u7F51\u7AD9\u4EE5\u53CA\u76F8\u5E94\u7684\u7231\u8BFE\u8FD0\u8425\u7684\u9700\u8981\u4E0D\u65F6\u5730\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u5185\u5BB9\u8FDB\u884C\u4FEE\u6539\uFF0C\u5E76\u5728\u7F51\u7AD9\u4EE5\u53CA\u7231\u8BFE\u9192\u76EE\u4F4D\u7F6E\u5F20\u8D34\u3002\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\uFF0C\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\uFF0C\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u534F\u8BAE\u3002\u7528\u6237\u6709\u4E49\u52A1\u53CA\u65F6\u5173\u6CE8\u5E76\u9605\u8BFB\u6700\u65B0\u7248\u7684\u534F\u8BAE\u53CA\u7F51\u7AD9\u516C\u544A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\uFF0C\u53EF\u4EE5\u7ACB\u5373\u5411\u7231\u8BFE\u8FDB\u884C\u53CD\u9988\u4E14\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u7231\u8BFE\u4F9D\u636E\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u670D\u52A1\uFF1B\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u7684\uFF0C\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u672C\u534F\u8BAE\u81EA\u7528\u6237\u70B9\u51FB\u201C\u540C\u610F\u201D\u3001\u201C\u63A5\u53D7\u201D\u540E\u751F\u6548\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE,\u4E0D\u5177\u6CD5\u5F8B\u6216\u5951\u7EA6\u6548\u679C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u672C\u534F\u8BAE\u7684\u89E3\u91CA\u6743\u5F52\u7231\u8BFE\u6240\u6709\u3002')));}}]);return Agreement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Agreement);

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AgreementPd=function(_Component){_inherits(AgreementPd,_Component);function AgreementPd(){_classCallCheck(this,AgreementPd);return _possibleConstructorReturn(this,(AgreementPd.__proto__||Object.getPrototypeOf(AgreementPd)).apply(this,arguments));}_createClass(AgreementPd,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u670D\u52A1\u4F7F\u7528\u534F\u8BAE'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'agreement-pd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B\u662F\u60A8\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u4E0E\u676D\u5DDE\u6F58\u54D2-\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u4E4B\u95F4\u5728\u4F7F\u7528\u5176\u7BA1\u7406\u7684\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u201D\uFF09\u4E2D\u6CE8\u518C\u4F7F\u7528\u65F6\u7B7E\u7F72\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E00\u3001\u91CD\u8981\u987B\u77E5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5E94\u8BA4\u771F\u9605\u8BFB\uFF08\u672A\u6210\u5E74\u4EBA\u5E94\u5F53\u5728\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\uFF09\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u9664\u975E\u7528\u6237\u63A5\u53D7\u672C\u534F\u8BAE\uFF0C\u7528\u6237\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u53CA\u4F7F\u7528\u884C\u4E3A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5C06\u7ED9\u4E88\u6BCF\u4E2A\u7528\u6237\u4E00\u4E2A\u7528\u6237\u5E10\u53F7\uFF0C\u7531\u7528\u6237\u8D1F\u8D23\u4FDD\u7BA1\uFF0C\u7528\u6237\u901A\u8FC7\u624B\u673A\u9A8C\u8BC1\u7801\u7684\u5F62\u5F0F\u767B\u5F55\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\uFF1B\u7528\u6237\u59A5\u5584\u4FDD\u7BA1\u5E10\u53F7\uFF0C\u9632\u6B62\u6CC4\u9732\uFF0C\u5982\u679C\u5E10\u53F7-\u88AB\u76D7\u7528\u7684\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E8C\u3001\u670D\u52A1\u5185\u5BB9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\uFF08\u4F8B\u5982\u8D2D\u4E70\u8BFE\u65F6\u7B49\uFF09\u4E3A\u6536\u8D39\u670D\u52A1\uFF0C\u7528\u6237\u4F7F\u7528\u6536\u8D39\u670D\u52A1\u9700\u8981\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u652F\u4ED8\u4E00\u5B9A\u7684\u8D39\u7528\u3002\u5BF9\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4F1A\u5728\u7528\u6237\u4F7F\u7528\u4E4B\u524D\u7ED9\u4E88\u7528\u6237\u660E\u786E\u7684\u63D0\u793A\uFF0C\u53EA\u6709\u7528\u6237\u6839\u636E\u63D0\u793A\u786E\u8BA4\u5176\u613F\u610F\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u7528\u6237\u624D\u80FD\u4F7F\u7528\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002\u5982\u7528\u6237\u62D2\u7EDD\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u5219\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u4E0D\u5411\u7528\u6237\u63D0\u4F9B\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4EC5\u63D0\u4F9B\u8F6F\u4EF6\u76F8\u5173\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u8F6F\u4EF6\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u624B\u673A\u3001\u4E2A\u4EBA\u7535\u8111\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4E3A\u672C\u534F\u8BAE\u5C65\u884C\u6216\u76F8\u5173\u7814\u7A76\u7684\u76EE\u7684\u6536\u96C6\u3001\u4F7F\u7528\u6216\u6388\u6743\u7B2C\u4E09\u65B9\uFF08\u4E14\u8BE5\u7B49\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u540C\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u4E49\u52A1\uFF09\u975E\u5546\u4E1A\u5730\u4F7F\u7528\u901A\u8FC7\u670D\u52A1\u83B7\u53D6\u7684\u7528\u6237\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8EAB\u4EFD\u4FE1\u606F\u3001\u6027\u522B\u3001\u804C\u4E1A\u3001\u5174\u8DA3\u7231\u597D\u3001\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF09\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u4E8E\u6392\u884C\u699C\u4E0A\uFF0C\u4F7F\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5176\u4ED6\u7528\u6237\u53EF\u4EE5\u67E5\u770B\u7528\u6237\u7684\u5934\u50CF\u3001\u540D\u5B57\u3001\u5F71\u97F3\u7B49\u4E2A\u4EBA\u8D44\u6599\u3001\u5E94\u7528\u4E8E\u76F8\u5173\u5B66\u672F\u3001\u5E94\u7528\u7814\u7A76\u7B49\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u627F\u8BFA\uFF0C\u9664\u975E\u53E6\u884C\u53D6\u5F97\u7528\u6237\u7684\u4E8B\u5148\u540C\u610F\uFF0C\u5426\u5219\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4E0D\u4F1A\u5C06\u7528\u6237\u4FE1\u606F\u6388\u6743\u7ED9\u4E0E\u5C65\u884C\u672C\u534F\u8BAE\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u7528\u4E8E\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u56FD\u5BB6\u6807\u51C6\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u53EF\u80FD\u4F1A\u4F9D\u6CD5\u6536\u96C6\u5E76\u4F7F\u7528\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u4E14\u65E0\u9700\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u76F4\u63A5\u76F8\u5173\u7684\uFF1B\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u76F4\u63A5\u76F8\u5173\u7684\uFF1B\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u76F4\u63A5\u76F8\u5173\u7684\uFF1B\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u4ED6\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u7528\u6237\u672C\u4EBA\u540C\u610F\u7684\uFF1B\uFF085\uFF09\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\uFF1A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B\uFF087\uFF09\u6839\u636E\u7528\u6237\u7684\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B\uFF088\uFF09\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\uFF1A\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B\uFF089\uFF09\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B\uFF0810\uFF09\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B\uFF0811\uFF09\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\u3001\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u4E8B\u5148\u5F81\u5F97\u7528\u6237\u7684\u6388\u6743\u540C\u610F\uFF1A\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B\uFF085\uFF09\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\u3002\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u7528\u6237\u901A\u77E5\u5E76\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E09\u3001\u7528\u6237\u4F7F\u7528\u89C4\u5219')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u8F6F\u4EF6\u529F\u80FD\u4E0E\u7528\u6237\u8FDB\u884C\u5206\u4EAB\u4EA4\u6D41\uFF0C\u5305\u62EC\u8BFE\u7A0B\u5B66\u4E60\u3001\u53D1\u5E16\u6559\u5B66\u3001\u6B4C\u66F2\u6F14\u5531\u4EE5\u53CA\u5206\u4EAB\u5176\u4ED6\u4E00\u5207\u7528\u6237\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4E3B\u9875\u3001\u7167\u7247\u4E0A\u4F20\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u65F6\u987B\u9075\u5B88\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u4E0D\u5F97\u4ECE\u4E8B\u4EE5\u4E0B\u884C\u4E3A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.1\u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.2\u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.3\u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.4\u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.5\u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5E73\u53F0\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u5FC5\u987B\u6E05\u695A\u4F7F\u7528\u89C4\u5219\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4EC5\u4F9B\u4E2A\u4EBA\u4EA4\u6D41\u3001\u5B66\u4E60\u6B23\u8D4F\uFF0C\u975E\u5546\u4E1A\u6027\u8D28\u7684\u4F7F\u7528\uFF0C\u7528\u6237\u4E0D\u53EF\u5229\u7528\u672C\u670D\u52A1\u5BF9\u4FE1\u606F\u6216\u8868\u6F14\u7B49\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u8FDB\u884C\u51FA\u552E\u3001\u6216\u5229\u7528\u672C\u670D\u52A1\u8FDB\u884C\u8C03\u67E5\u3001\u5E7F\u544A\u3001\u6216\u7528\u4E8E\u5176\u4ED6\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001 \u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u65F6\u53D1\u5E03\u3001\u4F20\u64AD\u7684\u4FE1\u606F\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\uFF0C\u4FDD\u8BC1\u4E0D\u5F97\u53D1\u5E03\u8C23\u8A00\u6216\u5176\u4ED6\u4E0E\u4E8B\u5B9E\u4E0D\u7B26\u5F15\u8D77\u4ED6\u4EBA\u4E0D\u9002\u7684\u8A00\u8BBA\u3001\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\u3001\u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4E0D\u5F97\u53D1\u5E03\u3001\u4F20\u64AD\u4FB5\u72AF\u77E5\u8BC6\u4EA7\u6743\u6216\u5176\u4ED6\u5408\u6CD5\u6743\u76CA\u7684\u4FE1\u606F\u3002\u7528\u6237\u4F20\u64AD\u5185\u5BB9\u4E2D\u6D89\u53CA\u7B2C\u4E09\u65B9\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u7684\u76F8\u5173\u6388\u6743\u6216\u5176\u4ED6\u5185\u5BB9\u7684\u5408\u6CD5\u6027\u7531\u7528\u6237\u81EA\u884C\u8D1F\u8D23\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5BF9\u76F8\u5173\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5C5E\u6216\u662F\u5426\u4FB5\u72AF\u4ED6\u4EBA\u6C11\u4E8B\u6743\u76CA\u7B49\u60C5\u51B5\u4E0D\u8FDB\u884C\u5BA1\u67E5\u6216\u76D1\u7763\uFF0C\u4F46\u5C06\u6309\u76F8\u5173\u6CD5\u89C4\u5BF9\u6D89\u5ACC\u4FB5\u6743\u7684\u5185\u5BB9\u5C65\u884C\u5220\u9664\u6216\u65AD\u5F00\u94FE\u63A5\u7B49\u804C\u8D23\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'7\u3001\u82E5\u7528\u6237\u53D1\u751F\u524D\u8FF03-6\u7684\u884C\u4E3A\u65F6\uFF0C\u7531\u7528\u6237\u627F\u62C5\u6240\u6709\u7684\u8FDD\u6CD5\u3001\u4FB5\u6743\u8D23\u4EFB\uFF0C\u82E5\u56E0\u6B64\u7ED9\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u9020\u6210\u4EFB\u4F55\u635F\u5931\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u5411\u8D23\u4EFB\u7528\u6237\u4E3B\u5F20\u76F8\u5173\u8D23\u4EFB\u3002\u540C\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u5BF9\u8FDD\u6CD5\u3001\u4FB5\u6743\u3001\u8FDD\u89C4\u7684\u7528\u6237\u7EC8\u6B62\u63D0\u4F9B\u670D\u52A1\u3002\u5982\u679C\u653F\u5E9C\u6216\u8005\u53F8\u6CD5\u673A\u5173\u8981\u6C42\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u544A\u77E5\u8FDB\u884C\u4FB5\u6743\u884C\u4E3A\u7528\u6237\u7684\u5177\u4F53\u4FE1\u606F\u7684\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u6839\u636E\u73B0\u884C\u6CD5\u89C4\u5411\u5176\u544A\u77E5\u7528\u6237\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'8\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u5728\u63D0\u4F9B\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u56DB\u3001\u77E5\u8BC6\u4EA7\u6743')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5206\u4EAB\u4E2A\u4EBA\u4F5C\u54C1\u65F6\uFF0C\u4E0D\u5F97\u4FB5\u72AF\u7B2C\u4E09\u65B9\u4EFB\u4F55\u77E5\u8BC6\u4EA7\u6743\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5206\u4EAB\u4FE1\u606F\u4E2D\u542B\u6709\u7684\u5B8C\u5168\u7531\u7528\u6237\u81EA\u8EAB\u539F\u521B\u4FE1\u606F\u7684\u7248\u6743\u5F52\u7528\u6237\uFF0C\u4F46\u5176\u4E2D\u5229\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\uFF0C\u5229\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4E2D\u5DF2\u6709\u7D20\u6750\u800C\u5F62\u6210\u7684\u5F71\u97F3\u6216\u5176\u4ED6\u8D44\u6599\u7684\u7248\u6743\u7531\u7528\u6237\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5171\u6709\u3002\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u662F\u5BF9\u5176\u4EAB\u6709\u7248\u6743\u6216\u7ECF\u5408\u6CD5\u6388\u6743\u7684\u76F8\u5173\u5185\u5BB9\u7684\u7F51\u7EDC\u4F20\u64AD\u884C\u4E3A\u8BB8\u53EF\uFF0C\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u5373\u8868\u660E\u5176\u5DF2\u6388\u6743\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u53CA\u5176\u4ED6\u7528\u6237\u6709\u6743\u590D\u5236\u3001\u4F20\u64AD\u524D\u8FF0\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E94\u3001\u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u9274\u4E8E\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u670D\u52A1\u53CA\u514D\u8D39\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u670D\u52A1\u7684\u5E73\u53F0\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED90\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u5728\u63D0\u793A\u7528\u6237\u9700\u572810\u65E5\u5185\u6295\u5165\u5B9E\u9645\u4F7F\u7528\u540E\uFF0C\u82E5\u7528\u6237\u4E8E\u8BE510\u65E5\u5185\u4ECD\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u5E10\u53F7\u6635\u79F0\u5982\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u56FD\u5BB6\u653F\u7B56\u8981\u6C42\u3001\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u7684\u6635\u79F0\u7BA1\u7406\u8981\u6C42\uFF0C\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u8981\u6C42\u7528\u6237\u8FDB\u884C\u4FEE\u6539\u6216\u6536\u56DE\u8BE5\u8D26\u53F7\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u516D\u3001\u5176\u4ED6\u4E8B\u5B9C')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6709\u6743\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u53D8\u5316\u3001\u7F51\u7AD9\u4EE5\u53CA\u76F8\u5E94\u7684\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u8FD0\u8425\u7684\u9700\u8981\u4E0D\u65F6\u5730\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u5185\u5BB9\u8FDB\u884C\u4FEE\u6539\uFF0C\u5E76\u5728\u7F51\u7AD9\u4EE5\u53CA\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u9192\u76EE\u4F4D\u7F6E\u5F20\u8D34\u3002\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\uFF0C\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\uFF0C\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u534F\u8BAE\u3002\u7528\u6237\u6709\u4E49\u52A1\u53CA\u65F6\u5173\u6CE8\u5E76\u9605\u8BFB\u6700\u65B0\u7248\u7684\u534F\u8BAE\u53CA\u7F51\u7AD9\u516C\u544A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\uFF0C\u53EF\u4EE5\u7ACB\u5373\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u8FDB\u884C\u53CD\u9988\u4E14\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u4F9D\u636E\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u670D\u52A1\uFF1B\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u7684\uFF0C\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u672C\u534F\u8BAE\u81EA\u7528\u6237\u70B9\u51FB\u201C\u540C\u610F\u201D\u3001\u201C\u63A5\u53D7\u201D\u540E\u751F\u6548\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE,\u4E0D\u5177\u6CD5\u5F8B\u6216\u5951\u7EA6\u6548\u679C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u672C\u534F\u8BAE\u7684\u89E3\u91CA\u6743\u5F52\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u6240\u6709\u3002')));}}]);return AgreementPd;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AgreementPd);

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Homework__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_StepChange__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_client__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Toast from '../../utils/toast';
var queryObj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var HomeworkPage=function(_Component){_inherits(HomeworkPage,_Component);function HomeworkPage(props){_classCallCheck(this,HomeworkPage);var _this=_possibleConstructorReturn(this,(HomeworkPage.__proto__||Object.getPrototypeOf(HomeworkPage)).call(this,props));_this.handleClick=function(){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_Start'});var _this$state=_this.state,curIndex=_this$state.curIndex,roundIndex=_this$state.roundIndex;if(curIndex>0||roundIndex>0){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].alertView({title:'',content:'是否继续上次保存的进度？',confirm:'继续',cancel:'重做',id:'H5_1007'});}else{_this.goToWork({curIndex:1,roundIndex:0});_this.setState({showStepChange:true},function(){_this.stepChangeRef.cloudPlay();});}};_this.goToWork=function(_ref){var curIndex=_ref.curIndex,roundIndex=_ref.roundIndex;var nextRound=__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ROUND_NAME */][_this.sort[Number(roundIndex)]];var castleType=_this.sort.indexOf(4)>-1?'4':'3';setTimeout(function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/homework/'+nextRound+'/'+curIndex,search:window.location.search+'&castletype='+castleType+'&courseId='+_this.shareKeycourseId});},1000);};_this.alertViewBack=function(res){var data=JSON.parse(res);var _this$state2=_this.state,curIndex=_this$state2.curIndex,roundIndex=_this$state2.roundIndex;console.log(data);if(data.select==='confirm'&&data.id==='H5_1007'){_this.goToWork({curIndex:curIndex+1,roundIndex:roundIndex});}if(data.select==='cancel'&&data.id==='H5_1007'){_this.goToWork({curIndex:1,roundIndex:0});}_this.setState({showStepChange:true},function(){_this.stepChangeRef.cloudPlay();});};_this.debugClick=function(index){return __WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].shareNew({type:2,shareByUrl:true,shareUrl:window.location.href,resource:'homework'});};_this.state={sort:[]};_this.shareKeycourseId=210;// 分享key最初版本即是固定210，后改为根据接口courseId取值
return _this;}_createClass(HomeworkPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.storage=__WEBPACK_IMPORTED_MODULE_7__utils_tools__["e" /* myStorage */];Object(__WEBPACK_IMPORTED_MODULE_8__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
console.log('queryObj===',queryObj);__WEBPACK_IMPORTED_MODULE_9__api_axios__["a" /* default */].getWorkInfoNew({query:queryObj.classschid// query:'39774'
},function(res,err){if(err){console.log(err);__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].closeH5Page({reason:'homeworkError'});}else{_this2.sort=res.sort;_this2.shareKeycourseId=res.courseId||_this2.shareKeycourseId;_this2.setState({sort:res.sort,completeRender:true});__WEBPACK_IMPORTED_MODULE_9__api_axios__["a" /* default */].homeworkDetail({data:{classSchId:queryObj.classschid,type:0}},function(data,error){if(error)console.log(error);else{var _data=_slicedToArray(data,1),_data$=_data[0];_data$=_data$===undefined?{}:_data$;var progress=_data$.index;if(progress){var dataIndex=progress.toString();// 老数据 index为两位数
var type=Number(dataIndex[0]);var roundIndex=_this2.sort.indexOf(type);var curIndex=Number(dataIndex.slice(1));var subIndex=2;// 新数据 index为5位数：类型-题号-小题号
if(dataIndex.length>2){curIndex=Number(dataIndex.slice(1,3));subIndex=Number(dataIndex.slice(3,5));}// 烟花环节 只做完第一小题进度不加一
if(subIndex===1&&(type===3||type===4)){curIndex=curIndex-1;}// 当前类型最后一题 跳下一类型
if(!res.works[roundIndex][curIndex]){roundIndex=roundIndex+1<res.works.length?roundIndex+1:roundIndex;curIndex=0;}console.log('round',roundIndex,'sub',subIndex,'cur',curIndex);_this2.setState({curIndex:curIndex,roundIndex:roundIndex});_this2.storage.setItem('panda_homework_next',JSON.stringify(roundIndex));}}});_this2.storage.setItem('panda_homework_sort',JSON.stringify(res.sort));_this2.storage.setItem('panda_homework_questioninfo',JSON.stringify(res.works));}});}// 前往具体作业
// 客户端弹窗回调方法
},{key:'render',value:function render(){var _this3=this;var _state=this.state,completeRender=_state.completeRender,stepChange=_state.stepChange,showStepChange=_state.showStepChange,sort=_state.sort;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课后作业'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__["a" /* default */],{closeReason:'homeworkDone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Homework__["a" /* default */],{handleClick:this.handleClick,debugClick:this.debugClick,debug:queryObj.debug,sort:sort}),showStepChange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_StepChange__["a" /* default */],{status:stepChange||'out',ref:function ref(com){return _this3.stepChangeRef=com;}}),!completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],{type:'wide'})));}}]);return HomeworkPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeworkPage);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Homework=function(_Component){_inherits(Homework,_Component);function Homework(props){_classCallCheck(this,Homework);var _this=_possibleConstructorReturn(this,(Homework.__proto__||Object.getPrototypeOf(Homework)).call(this,props));_this.state={sort:props.sort};return _this;}_createClass(Homework,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextPorps){this.setState(nextPorps);}},{key:'render',value:function render(){var _this2=this;var debug=this.props.debug;// const { sort } = this.state;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new index'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons btn start',onClick:function onClick(){_this2.props.handleClick();}}),debug==='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'debug-btn',onClick:this.props.debugClick},'\u5BA2\u6237\u7AEF\u8C03\u8BD5\u5206\u4EAB'));}}]);return Homework;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Homework);

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Carriage__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_ProgressBar__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_axios__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CarriagePage=function(_Component){_inherits(CarriagePage,_Component);function CarriagePage(props){_classCallCheck(this,CarriagePage);var _this=_possibleConstructorReturn(this,(CarriagePage.__proto__||Object.getPrototypeOf(CarriagePage)).call(this,props));_this.alertViewBack=function(){__WEBPACK_IMPORTED_MODULE_8__api_client__["a" /* default */].closeH5Page({reason:'homeworkError'});};_this.closeIconCallback=function(){_this.child.pauseAudio();};_this.nextQuestion=function(score){var _this$state=_this.state,currentIndex=_this$state.currentIndex,totalIndex=_this$state.totalIndex,device=_this$state.device;var classschid=_this.queryObj.classschid;if(currentIndex+1>totalIndex){_this.setState({showStepChange:true},function(){_this.stepChangeRef.cloudPlay();});var nextIndex=_this.storage.getItem('panda_homework_next');var nextRound=__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ROUND_NAME */][_this.sort[Number(nextIndex)]];var nextPath=nextRound?nextRound+'/1':'result';var history=_this.props.history;setTimeout(function(){history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/homework/'+nextPath,search:''+window.location.search});},1000);}else{var _history=_this.props.history;_history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/homework/carriage/'+(currentIndex+2),search:''+window.location.search});_this.child.initAllState();_this.setState({currentIndex:currentIndex+1});}var params={type:0,device:device,classSchId:classschid,index:Number('1'+Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["d" /* fixZero */])(currentIndex+1,2)+'01'),isRight:score};var paramsBp={courseId:210,// 210-NGK
sourceType:2,// 1-课件 2-作业
qaType:2,//  题目类型 1-选择题、2-判断题、3-读音题、4-多选题
qaTemplate:'冰淇淋车选择',// 题目模板
deviceName:device,// 设备
classSchId:classschid,// 课次id
qaResult:score// 分数 0-错 1-对
};__WEBPACK_IMPORTED_MODULE_10__api_axios__["a" /* default */].homeworkSave({data:params},function(res,err){if(err)console.log(err);else{console.log('作业保存进度成功');}});__WEBPACK_IMPORTED_MODULE_10__api_axios__["a" /* default */].homeworkBp({data:paramsBp},function(res,err){if(err)console.log(err);else{console.log('作业结果埋点成功');}});};_this.storage=__WEBPACK_IMPORTED_MODULE_7__utils_tools__["e" /* myStorage */];_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.questionList=[];_this.state={showStepChange:true,currentIndex:Number(props.match.params.index)-1,totalIndex:2,haveData:false,device:JSON.parse(_this.storage.getItem('panda_client_data')).device};_this.timeOutArr=[];return _this;}_createClass(CarriagePage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_9__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
var questionList=void 0,curRoundIndex=void 0;try{questionList=JSON.parse(this.storage.getItem('panda_homework_questioninfo'));this.sort=JSON.parse(this.storage.getItem('panda_homework_sort'));curRoundIndex=this.sort.indexOf(1);this.storage.setItem('panda_homework_next',curRoundIndex+1);this.setState({completeRender:true,questionInfo:questionList[curRoundIndex],totalIndex:questionList[curRoundIndex].length-1,haveData:true});this.timeOutArr.push(setTimeout(function(){_this2.stepChangeRef.cloudPlay(function(){_this2.timeOutArr.push(setTimeout(function(){_this2.setState({showStepChange:false,stepChange:'out'});},1200));});},400));}catch(error){__WEBPACK_IMPORTED_MODULE_8__api_client__["a" /* default */].alertView({content:'作业异常，请重新开始',confirm:'确认',id:'H5_1005'});console.log(error);}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,stepChange=_state.stepChange,showStepChange=_state.showStepChange,currentIndex=_state.currentIndex,totalIndex=_state.totalIndex,questionInfo=_state.questionInfo,haveData=_state.haveData;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课后作业'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__["a" /* default */],{closeReason:'homeworkBreak',callback:this.closeIconCallback}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_ProgressBar__["a" /* default */],{currentNum:currentIndex+1,totalNum:totalIndex+1}),haveData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Carriage__["a" /* default */],{key:currentIndex,questionInfo:questionInfo,nextQuestion:this.nextQuestion,currentIndex:currentIndex,totalIndex:totalIndex,ref:function ref(com){return _this3.child=com;}}):null,!!showStepChange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__["a" /* default */],{status:stepChange||'in',ref:function ref(com){return _this3.stepChangeRef=com;}})));}}]);return CarriagePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CarriagePage);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apng__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carriage_less__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carriage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__carriage_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_horn_off_png__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_horn_off_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_horn_off_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_play_apng_png__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_play_apng_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_play_apng_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_carriage_right_png__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_carriage_right_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_carriage_right_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_carriage_wrong_png__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_carriage_wrong_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_carriage_wrong_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_images_homework_new_ice_cream_png__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_images_homework_new_ice_cream_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_images_homework_new_ice_cream_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_audio_car_in_mp3__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_audio_car_in_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_audio_car_in_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_audio_car_right_mp3__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_audio_car_right_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_audio_car_right_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_audio_car_wrong_mp3__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_audio_car_wrong_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_audio_car_wrong_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_audio_car_out_mp3__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_audio_car_out_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_audio_car_out_mp3__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var audioUrlList=[__WEBPACK_IMPORTED_MODULE_10__static_audio_car_in_mp3___default.a,__WEBPACK_IMPORTED_MODULE_11__static_audio_car_right_mp3___default.a,__WEBPACK_IMPORTED_MODULE_12__static_audio_car_wrong_mp3___default.a,__WEBPACK_IMPORTED_MODULE_13__static_audio_car_out_mp3___default.a];var Carriage=function(_Component){_inherits(Carriage,_Component);function Carriage(props){_classCallCheck(this,Carriage);var _this=_possibleConstructorReturn(this,(Carriage.__proto__||Object.getPrototypeOf(Carriage)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,questionInfo=_this$props.questionInfo,currentIndex=_this$props.currentIndex;var question=questionInfo[currentIndex];var picList=[];_this.rightIndex=Math.round(Math.random());//正确图片所在位置
picList[_this.rightIndex]=question.correctPicture;picList[1-_this.rightIndex]=question.disturbPicture;var questionList=picList.map(function(item,index){return{pic:item,key:index,animation:''};});_this.audioList=[];_this.noPlayed=true;//从未播放过音频
_this.refuseChoice=false;_this.state={currentIndex:props.currentIndex,//当前题目下标
carHeadStatus:'',//冰激淋车状态
playing:false,//音频播放
hideWrongItem:true,//选择错误后展示的图片
out:'',//汽车离开动画
question:question,questionList:questionList//问题列表
};_this.timeOutArr=[];return _this;}_createClass(Carriage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeOutArr.push(setTimeout(function(){_this2.audioDuration=_this2.audio.duration;_this2.initAllState();_this2.audio.onerror=function(){__WEBPACK_IMPORTED_MODULE_2__utils_toast__["a" /* default */].info({text:'音频加载失败，请重试'});//    this.audio && this.audio.load();
};_this2.audio.onpause=function(){_this2.noPlayed=false;_this2.setState({playing:false});};},200));}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.CarReadyTimer);clearTimeout(this.nextPageTimer);clearTimeout(this.outTimer);this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,carHeadStatus=_state.carHeadStatus,questionList=_state.questionList,playing=_state.playing,hideWrongItem=_state.hideWrongItem,out=_state.out,question=_state.question;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new carriage'},audioUrlList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{ref:function ref(dom){return _this3.audioList[index]=dom;},key:index,src:item});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'car-head '+carHeadStatus+' '+out}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icons horn-box',onClick:function onClick(){_this3.playAudio();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'horn horn-off '+(playing?'hide':''),src:__WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_horn_off_png___default.a,alt:'\u5173\u95ED'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'horn horn-on '+(playing?'':'hide'),src:__WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_play_apng_png___default.a,alt:'\u64AD\u653E'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{className:'audio',ref:function ref(dom){return _this3.audio=dom;},src:question.audio})),questionList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.key,className:'question-box question-box'+index+' '+item.animation+' '+(_this3.rightIndex===index?out:''),onClick:function onClick(){_this3.handleChoice(index);}},_this3.rightIndex!==index?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'ice-cream '+(hideWrongItem?'hide':''),ref:function ref(com){return _this3.iceCream=com;},src:__WEBPACK_IMPORTED_MODULE_9__static_images_homework_new_ice_cream_png___default.a}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box-top'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-mask '+(hideWrongItem?'hide':'')},_this3.rightIndex===index?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_carriage_right_png___default.a,alt:'\u6B63\u786E'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_carriage_wrong_png___default.a,alt:'\u6B63\u786E'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'section',src:item.pic,alt:'\u9009\u9879'})));}));}}]);return Carriage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.initAllState=function(){_this4.carReady();//冰激凌车进入
_this4.audio.onplaying=function(){_this4.setState({playing:true});};setTimeout(function(){_this4.playAudio();},3500);};this.playAudio=function(){_this4.audio&&_this4.audio.play();var timeOutTime=Number(_this4.audioDuration)>0?_this4.audioDuration:3;__WEBPACK_IMPORTED_MODULE_3__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_Car_Play'});_this4.timeOutArr.push(setTimeout(function(){_this4.noPlayed=false;_this4.setState({playing:false});},Math.round(timeOutTime*1000)));};this.pauseAudio=function(){_this4.audio&&_this4.audio.pause();};this.carReady=function(){_this4.CarReadyTimer=setTimeout(function(){_this4.audioList[0].play();_this4.setState({carHeadStatus:'ready'});},1000);};this.handleChoice=function(index){if(_this4.noPlayed||_this4.refuseChoice)return;_this4.refuseChoice=true;if(index===_this4.rightIndex){_this4.choiceRight();}else{_this4.choiceWrong();}};this.choiceRight=function(){var questionList=_this4.state.questionList;var newList=questionList.map(function(item,index){return Object.assign({},item,{animation:index===_this4.rightIndex?'move':''});});_this4.audioList[1].play();_this4.setState({questionList:newList,score:100},function(){_this4.carOut();});};this.choiceWrong=function(){_this4.audioList[2].play();_this4.setState({hideWrongItem:false,score:0},function(){_this4.iceCream.one();_this4.nextPageTimer=setTimeout(function(){_this4.props.nextQuestion(0);},2000);});};this.carOut=function(){_this4.outTimer=setTimeout(function(){_this4.audioList[3].play();_this4.setState({out:'out'},function(){_this4.nextPageTimer=setTimeout(function(){_this4.props.nextQuestion(1);},2000);});},2000);};};/* harmony default export */ __webpack_exports__["a"] = (Carriage);

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/horn_off.aece0cce.png";

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAACBCAMAAABNcyDqAAAAhFBMVEUAAAAysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWwysWzNP+LZAAAAK3RSTlMA+gLlJR8VBukw9SrZxb0bCeEO3c1j67WFXkisf1ilnpmScWrv04x4UkA6Mp7l5gAAAztJREFUeNrV3Ot6ojAUheGFeKYequKhWmtbqlPX/d/fmGnHYhUNQcje3xW8D89OgPwIxNeIXybtgEF78rJoQFOtuMd0vbgFJdXeQ/4ujGvQUDThpSYR5Lfo8nLdBaS3Y3Y7yG7Oa71Bcite7xlyu2Vntw6prXizntQdc0WLhG45VnY+inzXGrvWR7+jZX2Ia0frmhDWiV3ZXp/HzleI6suuc+jz2TmGoN6YrwRyymtnADEd7Gqf/D+70pn/tqvcbY52hft8yq7uDftOlwIR3zZHe9GRH+7j+Wazmcf7Fi4nxf57akZxP/j5xe3HI5wnxn76J9WcJzwt2Z6NlRg7FyeHmlOel7zXkE6OvZeCNWdZyyL98OXY0+c29XH2bEUorZgsvlo7bWY37eArQfY3HBuE5G29IPsKx1o98rZeph1z0kIv0x4FtNDLtGNG2uhF2ju0qn1X/SKgY3Ok29BWL8/emtJWH0mz45O01wuzY8U8ell2LFmx/vl+dnzQQe/FvsVZbebUC7Kjy7x6OfbceIaRGDtC5tdLsWPC/Pq6EDvWrEr/x9n+6npMWFxf3F5DRh266SXYURs76gXYgTkd9QLsaASuev924JWuev92NKd067Fetn1Tw60WLFX/VKYdWDvrG97tGPbd9b7twGjirvdtB5oF9OXYX4zdm764vQr9uFGO3a/+qVuR3eg/3PU+7cX1Hu3F9QN/9uL6h0EJdk/6T2f72ti96Yvb/eg9243+oYi+uN2fvrjdp963HRi465vu9qWx+9V7txfR+7dXr1+2AK16Y9eqN3atemO/u37MS6mwZ+iV2IHGuV6NvQr97MeuTn9iV6Yv1W70j/yfOntKr9B+1Ku0f+uV2o1erx2o310/GyIr8foK7UYf8o71r9tF62/aBest7GL1Vnaheku7SL21XaA+h12c3qcdiEK99mL63hCei9p67Uav1+6q740goqit1270eu1Gr9cOdNp67Uav1270eu0H/VSv3ej12u30E6F2o9drN3q99oM+0Ws/6EN9a/WnxoQZrUV8A1+vtQ14oUTibZgX6vTP6MFGxJVLVu3XXaYKt7puWx8+zWfjhEHysdzta6iivwy0XXSyCRNSAAAAAElFTkSuQmCC"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACCCAMAAABW6lvMAAAAgVBMVEUAAAD/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxH/JxHjjg0yAAAAKnRSTlMAa3FojPORYnSJ4o9vZVmbVP3BlwTolIbFvF7Z74MnGhX5t4AfCM5OQTNtkLFyAAADT0lEQVR42t3c6XKiQBiF4YOKGKIIiA4gcRvNcu7/AmdMJvUlkSTah6Qr8/5uq56isNi6G9/TPpqW85BhnC+SDT5qXc/y48h5Pq3X6KhDvyStrEoKtFfUeUZaeXSAXjGa821xgrai+HRkALWHJdsqV3jbqmRbtytIjbdsL0zxuiR8b2QEoWu+3wgvG/H9fsG5KT8q+ARgDboFWHY+JqQDQQYwXOGpVUgHgjvAKgs8dks6EASANcGxCSkQJADjAkAR85yuugRYNYCI7J4w45nlAHIKBBXAbI096UBQAVaNmgJBB3CGKQWCDmCOkidp14gFLyrGnAJBBzBESAeCDrBAKgQd0CDskjDkxcWIKRB0ACvkvLwbGWANsaBA0AFMkVAg6IDtBpusG8I1ndoBqCgQVABTACkFggpY4tiSbv3WAUztXl0gCIAdnqpEwoCOzdd4at0IBAGwvcdzd5kzQQBkNayIzoQrZ0CEl/UpJAB8EgygEXSATtABVkAhAeCDMAFEgg4QCTpAJOgAv4Q+4JVgAJ3QPcAa0+oe4JcQAA4EDwAjeABYPQ8AgSAABIIA8EMYAyJBB4gEHeCX0AP8EnpQGvkDGEEHqAQZ4JcwAvwSRvAt6HUD+NGnATn2BjCCDtAJOkAn+L4yBQrAE8EAfgm9/+o20Qgen1kCjwAj/KSntoBfUl8H6AQdoBN+wlsc72+yvL/N6/PLm3gEGEEH6AQdoBN0QPeECb+xiQrQi1RA94SIUjohoWtXN50Q7rfOAMCdkOC59VwAAL/0r/+VADCCMAMipWMDQCTs8NhSAKiEOzsEAkAhLAsAOwFgXTkfBNdZYddAJ4QdkCoAnbDdYCgBdEKKSgLohCFilx+hO8IOjQ6wBg7/R2gAndAglAA6IUQsAXRCg5yXtAA6JiwxkwA6oUKtA6RpuwusMwWgE5ILVtLMgO4J2QaoBYBOqAAUsQCQCQn+FgkAlRAXOFYKAHE1RXTu6sIp8CWEEv9KBYBCCFd4biQABEIKq+ewtFEm9PCyNGR7WQChwacAa5WzreUDpPqfr7i2kiXfNh8XEHu4ZVvlHi0V6S57Nap/gF4RnLHy3tqkwypu2Bx3HzCl2GFyuvvAt7evp/k8ZBNXJzsw/AGmnhki37BImwAAAABJRU5ErkJggg=="

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ice_cream.55a99002.png";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car_in.bfb6dfa8.mp3";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car_right.641739e2.mp3";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car_wrong.47982a9b.mp3";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car_out.5947e259.mp3";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Archery__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_ProgressBar__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_axios__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getIndex(cur){return Number('2'+Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["d" /* fixZero */])(cur+1,2)+'01');}var ArcheryPage=function(_Component){_inherits(ArcheryPage,_Component);function ArcheryPage(props){_classCallCheck(this,ArcheryPage);var _this=_possibleConstructorReturn(this,(ArcheryPage.__proto__||Object.getPrototypeOf(ArcheryPage)).call(this,props));_initialiseProps.call(_this);_this.storage=__WEBPACK_IMPORTED_MODULE_7__utils_tools__["e" /* myStorage */];_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.questionList=[];var currentIndex=Number(props.match.params.index)-1;_this.state={showStepChange:true,currentIndex:currentIndex,totalIndex:NaN,level0:_this.queryObj.castletype==='3'||_this.queryObj.castletype===3,device:JSON.parse(_this.storage.getItem('panda_client_data')).device,index:getIndex(currentIndex)};_this.timeOutArr=[];return _this;}_createClass(ArcheryPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var currentIndex=this.state.currentIndex;Object(__WEBPACK_IMPORTED_MODULE_9__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
var curRoundIndex=void 0,_questionList=void 0;try{_questionList=JSON.parse(this.storage.getItem('panda_homework_questioninfo'));this.sort=JSON.parse(this.storage.getItem('panda_homework_sort'));}catch(error){__WEBPACK_IMPORTED_MODULE_8__api_client__["a" /* default */].alertView({content:'作业异常，请重新开始',confirm:'确认',id:'H5_1005'});console.log(error);}curRoundIndex=this.sort.indexOf(2);this.questionList=_questionList[curRoundIndex];this.storage.setItem('panda_homework_next',curRoundIndex+1);this.setState({completeRender:true,questionInfo:this.questionList[currentIndex],totalIndex:this.questionList.length-1});this.timeOutArr.push(setTimeout(function(){_this2.stepChangeRef.cloudPlay(function(){_this2.timeOutArr.push(setTimeout(function(){_this2.setState({showStepChange:false,stepChange:'out'});},1200));});},400));}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}// 双重保存 一个月后删除
},{key:'render',value:function render(){var _this3=this;var _state=this.state,level0=_state.level0,stepChange=_state.stepChange,showStepChange=_state.showStepChange,currentIndex=_state.currentIndex,totalIndex=_state.totalIndex,questionInfo=_state.questionInfo,completeRender=_state.completeRender;var _queryObj=this.queryObj,device=_queryObj.device,classschid=_queryObj.classschid;var parameters={index:getIndex(currentIndex),device:device,type:0,classSchId:Number(classschid),isRight:0};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课后作业'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_CloseIcon__["a" /* default */],{closeReason:'homeworkBreak'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_HomeworkNew_ProgressBar__["a" /* default */],{currentNum:currentIndex+1,totalNum:totalIndex+1,insertColor:'#f55151',outColor:'#adadad'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Archery__["a" /* default */],{parameters:parameters,level0:level0,questionInfo:questionInfo,currentIndex:currentIndex,totalIndex:totalIndex,nextQuestion:this.nextQuestion,onStorageEvaluatedAudio:this.saveAudioUrl,ref:function ref(com){return _this3.child=com;}})),!!showStepChange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__["a" /* default */],{status:stepChange||'in',ref:function ref(com){return _this3.stepChangeRef=com;}})));}}]);return ArcheryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.alertViewBack=function(){__WEBPACK_IMPORTED_MODULE_8__api_client__["a" /* default */].closeH5Page({reason:'homeworkError'});};this.nextQuestion=function(score){var _state2=_this4.state,currentIndex=_state2.currentIndex,totalIndex=_state2.totalIndex,device=_state2.device,questionInfo=_state2.questionInfo;var classschid=_this4.queryObj.classschid;if(currentIndex+1>totalIndex){_this4.setState({showStepChange:true},function(){_this4.stepChangeRef.cloudPlay();});var nextIndex=_this4.storage.getItem('panda_homework_next');var nextRound=__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ROUND_NAME */][_this4.sort[Number(nextIndex)]];var nextPath=nextRound?nextRound+'/1':'result';var history=_this4.props.history;setTimeout(function(){history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/homework/'+nextPath,search:window.location.search});},1000);}else{var _history=_this4.props.history;_history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/homework/archery/'+(currentIndex+2),search:''+window.location.search});_this4.child.child.setStep('step1');_this4.child.restart();_this4.setState({currentIndex:currentIndex+1,questionInfo:_this4.questionList[currentIndex+1]});}var params={type:0,device:device,classSchId:classschid,index:getIndex(currentIndex),isRight:score>30?1:0,words:questionInfo.text,picUrl:questionInfo.picture,evaluateScore:score};var paramsBp={courseId:210,// 210-NGK
sourceType:2,// 1-课件 2-作业
qaType:3,//  题目类型 1-选择题、2-判断题、3-读音题、4-多选题
qaTemplate:'射箭读单词',// 题目模板
deviceName:device,// 设备
classSchId:classschid,// 课次id
qaResult:score// 分数
};__WEBPACK_IMPORTED_MODULE_10__api_axios__["a" /* default */].homeworkSave({data:params},function(res,err){if(err)console.log(err);else{console.log('作业保存进度成功');}});__WEBPACK_IMPORTED_MODULE_10__api_axios__["a" /* default */].homeworkBp({data:paramsBp},function(res,err){if(err)console.log(err);else{console.log('作业结果埋点成功');}});};this.saveAudioUrl=function(url){console.log('------',url);var currentIndex=_this4.state.currentIndex;var _queryObj2=_this4.queryObj,device=_queryObj2.device,classschid=_queryObj2.classschid;var params={index:getIndex(currentIndex),device:device,classSchId:Number(classschid),type:0,isRight:0,audioUrls:[url]};__WEBPACK_IMPORTED_MODULE_10__api_axios__["a" /* default */].homeworkSave({data:params},function(res,err){if(err)console.log(err);else{console.log('url保存成功');}});};};/* harmony default export */ __webpack_exports__["a"] = (ArcheryPage);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Question__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_audio_arrow_mp3__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_audio_arrow_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_audio_arrow_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_audio_showScore_mp3__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_audio_showScore_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_audio_showScore_mp3__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Archery=function(_Component){_inherits(Archery,_Component);function Archery(props){_classCallCheck(this,Archery);var _this=_possibleConstructorReturn(this,(Archery.__proto__||Object.getPrototypeOf(Archery)).call(this,props));_this.playResult=function(score){_this.setState({score:score>=30?score:30,playResult:true,arrowStyle:'transform 0.3s ease-in'});_this.arrowAudio.play();_this.timeOutArr.push(setTimeout(function(){_this.setState({showScore:true},function(){// this.arrowAudio.stop();
if(score>30){_this.showScoreAudio.play();}});_this.timeOutArr.push(setTimeout(function(){_this.setState({showScore:false});// this.showScoreAudio.stop();
},2500));},800));};_this.restart=function(){_this.setState({playResult:false,arrowStyle:'none'});};_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.countInit=1600/_this.clientWidth;_this.state={currentIndex:0,totalIndex:props.totalIndex,arrowStyle:'transform 0.3s ease-in'};_this.timeOutArr=[];return _this;}_createClass(Archery,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(nextProps);}},{key:'render',// nextQuestion = () => {
//     const { score } = this.state;
//     this.props.nextQuestion(score);
// }
value:function render(){var _this2=this;var _state=this.state,currentIndex=_state.currentIndex,totalIndex=_state.totalIndex,showScore=_state.showScore,score=_state.score,playResult=_state.playResult,arrowStyle=_state.arrowStyle;var _props=this.props,questionInfo=_props.questionInfo,completeRenderFun=_props.completeRenderFun,level0=_props.level0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new archery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hand '+(playResult?'active':'')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow '+(playResult?'':'score0')+' score'+(score>30?score>69?'3':'2':'1'),style:{transition:arrowStyle}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Question__["a" /* default */],{parameters:this.props.parameters,level0:level0,type:'archery',defaultStep:'step1',defaultTime:3,questionInfo:questionInfo,isLast:Boolean(currentIndex===totalIndex),nextQuestion:this.props.nextQuestion,playResult:this.playResult,restart:this.restart,completeRenderFun:completeRenderFun,onStorageEvaluatedAudio:this.props.onStorageEvaluatedAudio,ref:function ref(com){return _this2.child=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{preload:'auto',ref:function ref(com){_this2.arrowAudio=com;},src:__WEBPACK_IMPORTED_MODULE_3__static_audio_arrow_mp3___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{preload:'auto',ref:function ref(com){_this2.showScoreAudio=com;},src:__WEBPACK_IMPORTED_MODULE_4__static_audio_showScore_mp3___default.a}),!!showScore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score_shadow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score_wrap score'+(score>30?score>69?'3':'2':'1')+' '+(showScore?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score'},score/10))));}}]);return Archery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Archery);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/light.bc0d5245.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow.f9f2a3dc.mp3";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/showScore.2493f75b.mp3";

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Castle__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_Teach__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__template_HomeworkNew_ProgressBar__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__template_HomeworkNew_CloseIcon__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_web__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CastlePage=function(_Component){_inherits(CastlePage,_Component);function CastlePage(props){_classCallCheck(this,CastlePage);var _this=_possibleConstructorReturn(this,(CastlePage.__proto__||Object.getPrototypeOf(CastlePage)).call(this,props));_this.alertViewBack=function(){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].closeH5Page({reason:'homeworkError'});};_this.nextQuestion=function(score){var _this$state=_this.state,currentIndex=_this$state.currentIndex,totalIndex=_this$state.totalIndex,level0=_this$state.level0;if(currentIndex+1>totalIndex){_this.setState({showStepChange:true});setTimeout(function(){_this.stepChangeRef.cloudPlay();},0);var nextIndex=_this.storage.getItem('panda_homework_next');var nextRound=__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ROUND_NAME */][_this.sort[Number(nextIndex)]];var nextPath=nextRound?nextRound+'/1':'result';var history=_this.props.history;setTimeout(function(){history.push({pathname:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* COURSE_URL */]+'/homework/'+nextPath,search:''+window.location.search});},1000);}else{_this.child.restart();_this.child.child.setStep('step1');_this.setState({currentIndex:currentIndex+1,questionInfo:_this.questionList[currentIndex+1]});var _history=_this.props.history;_history.push({pathname:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* COURSE_URL */]+'/homework/castle/'+(currentIndex+2),search:''+window.location.search});if(level0){_this.setState({teach:true});}}};_this.teachComplete=function(){_this.setState({teach:false});};_this.hideLoad=function(){_this.setState({showLoad:false});};_this.showLoad=function(){_this.setState({showLoad:true});};_this.storage=__WEBPACK_IMPORTED_MODULE_9__utils_tools__["e" /* myStorage */];_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.questionList=[];_this.state={showStepChange:true,currentIndex:Number(props.match.params.index)-1,totalIndex:NaN,level0:_this.queryObj.castletype==='3'||_this.queryObj.castletype===3,teach:true,device:JSON.parse(_this.storage.getItem('panda_client_data')).device};_this.timeOutArr=[];return _this;}_createClass(CastlePage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _state=this.state,currentIndex=_state.currentIndex,level0=_state.level0;Object(__WEBPACK_IMPORTED_MODULE_11__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
var curRoundIndex=void 0,_questionList=void 0;try{_questionList=JSON.parse(this.storage.getItem('panda_homework_questioninfo'));this.sort=JSON.parse(this.storage.getItem('panda_homework_sort'));}catch(error){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].alertView({content:'作业异常，请重新开始',confirm:'确认',id:'H5_1005'});console.log(error);}curRoundIndex=level0?this.sort.indexOf(3):this.sort.indexOf(4);this.questionList=_questionList[curRoundIndex];this.storage.setItem('panda_homework_next',curRoundIndex+1);this.setState({completeRender:true,questionInfo:this.questionList[currentIndex],totalIndex:this.questionList.length-1});this.timeOutArr.push(setTimeout(function(){_this2.stepChangeRef.cloudPlay(function(){_this2.timeOutArr.push(setTimeout(function(){_this2.setState({showStepChange:false,stepChange:'out'});},1200));});},400));}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'render',value:function render(){var _this3=this;var _state2=this.state,completeRender=_state2.completeRender,showLoad=_state2.showLoad,stepChange=_state2.stepChange,showStepChange=_state2.showStepChange,currentIndex=_state2.currentIndex,totalIndex=_state2.totalIndex,teach=_state2.teach,level0=_state2.level0,questionInfo=_state2.questionInfo,device=_state2.device;var classschid=this.queryObj.classschid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课后作业'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__template_HomeworkNew_CloseIcon__["a" /* default */],{closeReason:'homeworkBreak'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__template_HomeworkNew_ProgressBar__["a" /* default */],{currentNum:currentIndex+1,totalNum:totalIndex+1}),teach&&level0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__template_HomeworkNew_Teach__["a" /* default */],{teachComplete:this.teachComplete,questionInfo:questionInfo}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_Castle__["a" /* default */],{device:device,classSchId:classschid,level0:level0,questionInfo:questionInfo,currentIndex:currentIndex,totalIndex:totalIndex,nextQuestion:this.nextQuestion,completeRenderFun:this.hideLoad,ref:function ref(com){return _this3.child=com;}})),!!showStepChange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__["a" /* default */],{status:stepChange||'in',ref:function ref(com){return _this3.stepChangeRef=com;}}),showLoad&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__template_Load_Load__["a" /* default */],null)));}}]);return CastlePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CastlePage);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apng__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Question__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_boom_png__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_boom_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_boom_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_firework1_png__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_firework1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_firework1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_firework2_png__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_firework2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_firework2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_firework3_png__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_firework3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_firework3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_audio_firework_1_mp3__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_audio_firework_1_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_audio_firework_1_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_audio_firework_2_mp3__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_audio_firework_2_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_audio_firework_2_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_audio_firework_3_mp3__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_audio_firework_3_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_audio_firework_3_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_tools__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getIndex(cur,level0,smallIndex){return Number(''+(level0?'3':'4')+Object(__WEBPACK_IMPORTED_MODULE_12__utils_tools__["d" /* fixZero */])(cur+1,2)+'0'+smallIndex);}var Castle=function(_Component){_inherits(Castle,_Component);function Castle(props){_classCallCheck(this,Castle);var _this=_possibleConstructorReturn(this,(Castle.__proto__||Object.getPrototypeOf(Castle)).call(this,props));_initialiseProps.call(_this);var device=props.device,classSchId=props.classSchId,currentIndex=props.currentIndex,totalIndex=props.totalIndex,level0=props.level0;_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.countInit=1600/_this.clientWidth;_this.questionInfo=props.questionInfo.picture?props.questionInfo:{picture:props.questionInfo.pictureATwo,text:props.questionInfo.textA,audio:props.questionInfo.audioA};_this.questionInfoB={picture:props.questionInfo.pictureBTwo,text:props.questionInfo.textB,audio:props.questionInfo.audioB};_this.state={level0:level0,classSchId:classSchId,device:device,currentIndex:currentIndex,totalIndex:totalIndex,questionInfo:_this.questionInfo,fireworks:[],fireworksStatus:false,level0Step:1};_this.timeOutArr=[];_this.firework=[];return _this;}_createClass(Castle,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(nextProps);}// 双重保存 一个月后删除
},{key:'render',value:function render(){var _this2=this;var _state=this.state,currentIndex=_state.currentIndex,totalIndex=_state.totalIndex,fireworks=_state.fireworks,fireworksStatus=_state.fireworksStatus,audioResult=_state.audioResult,fireResult=_state.fireResult,questionInfo=_state.questionInfo,level0Step=_state.level0Step,level0=_state.level0,device=_state.device,classSchId=_state.classSchId;var completeRenderFun=this.props.completeRenderFun;var parameters={index:getIndex(currentIndex,level0,level0Step),device:device,classSchId:Number(classSchId),type:0,isRight:0};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new castle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fireworks_wrap'},fireworks.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boom_wrap',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'boom',src:__WEBPACK_IMPORTED_MODULE_5__static_images_homework_new_boom_png___default.a,rate:0.2,autoPlay:false,ref:function ref(com){return _this2.firework[index]=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'firework'}));})),fireworksStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'firework1',src:fireResult,rate:1,autoPlay:true,ref:function ref(com){return _this2.firework1=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Question__["a" /* default */],{parameters:parameters,type:'castle',level0:level0,defaultStep:'step0',defaultTime:level0?6:8,questionInfo:questionInfo,isLast:level0?Boolean(currentIndex===totalIndex&&level0Step===2):Boolean(currentIndex===totalIndex),nextQuestion:this.nextQuestion,playResult:this.playResult,restart:this.restart,completeRenderFun:completeRenderFun,onStorageEvaluatedAudio:this.saveAudioUrl,ref:function ref(com){return _this2.child=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{preload:'auto',ref:function ref(com){_this2.audio1=com;},src:audioResult}));}}]);return Castle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.playResult=function(score){var num=void 0,audioResult=void 0,fireResult=void 0;if(score<60){num=[1];audioResult=__WEBPACK_IMPORTED_MODULE_9__static_audio_firework_1_mp3___default.a;fireResult=__WEBPACK_IMPORTED_MODULE_6__static_images_homework_new_firework1_png___default.a;}else if(score<80){num=[1,2];audioResult=__WEBPACK_IMPORTED_MODULE_10__static_audio_firework_2_mp3___default.a;fireResult=__WEBPACK_IMPORTED_MODULE_7__static_images_homework_new_firework2_png___default.a;}else{num=[1,2,3];audioResult=__WEBPACK_IMPORTED_MODULE_11__static_audio_firework_3_mp3___default.a;fireResult=__WEBPACK_IMPORTED_MODULE_8__static_images_homework_new_firework3_png___default.a;}_this3.setState({fireworks:num,fireResult:fireResult,audioResult:audioResult,score:score});_this3.timeOutArr.push(setTimeout(function(){_this3.firework.map(function(ele){if(ele){ele.one();_this3.audio1.play();}return false;});setTimeout(function(){_this3.setState({fireworksStatus:true});},1000);},200));};this.restart=function(){_this3.firework1.stop();_this3.setState({fireworksStatus:false,fireworks:[]});};this.nextQuestion=function(score){var _state2=_this3.state,level0Step=_state2.level0Step,classSchId=_state2.classSchId,device=_state2.device,currentIndex=_state2.currentIndex,level0=_state2.level0,questionInfo=_state2.questionInfo;var params={type:0,device:device,classSchId:classSchId,index:getIndex(currentIndex,level0,level0Step),isRight:score>30?1:0,evaluateScore:score,words:questionInfo.text,picUrl:questionInfo.picture};// 如果有两小题
if(_this3.questionInfoB.picture&&level0Step===1){_this3.setState({questionInfo:_this3.questionInfoB,level0Step:2});}else{_this3.props.nextQuestion(score);}var paramsBp={courseId:210,// 210-NGK
sourceType:2,// 1-课件 2-作业
qaType:3,//  题目类型 1-选择题、2-判断题、3-读音题、4-多选题
qaTemplate:'烟花读句子',// 题目模板
qaResult:score,// 分数
deviceName:device,// 设备
classSchId:classSchId// 课次id
};__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].homeworkSave({data:params},function(res,err){if(err)console.log(err);else{console.log('作业保存进度成功');}});__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].homeworkBp({data:paramsBp},function(res,err){if(err)console.log(err);else{console.log('作业结果埋点成功');}});setTimeout(function(){_this3.child&&_this3.child.initAudio();},500);};this.saveAudioUrl=function(url){console.log('------',url);var _state3=_this3.state,currentIndex=_state3.currentIndex,level0=_state3.level0,level0Step=_state3.level0Step,device=_state3.device,classSchId=_state3.classSchId;var params={index:getIndex(currentIndex,level0,level0Step),device:device,classSchId:Number(classSchId),type:0,isRight:0,audioUrls:[url]};__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].homeworkSave({data:params},function(res,err){if(err)console.log(err);else{console.log('url保存成功');}});};};/* harmony default export */ __webpack_exports__["a"] = (Castle);

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/boom.129bcb33.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework1.108791d9.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework2.c5dc8230.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework3.522a941d.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework_1.8e03abbf.mp3";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework_2.6394b48c.mp3";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firework_3.b6a95608.mp3";

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Teach_less__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Teach_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Teach_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_audio_fanshu_mp3__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_audio_fanshu_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_audio_fanshu_mp3__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'
var Teach=function(_Component){_inherits(Teach,_Component);function Teach(props){_classCallCheck(this,Teach);var _this=_possibleConstructorReturn(this,(Teach.__proto__||Object.getPrototypeOf(Teach)).call(this,props));_this.state={action:false};_this.timeOutArr=[];return _this;}_createClass(Teach,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeOutArr.push(setTimeout(function(){_this2.duration1=_this2.audio1.duration;_this2.duration2=_this2.audio2.duration;console.log(_this2.duration1,_this2.duration2);},200));this.timeOutArr.push(setTimeout(function(){try{var duration1=Number(_this2.duration1)>0?_this2.duration1:3;_this2.audio1.play();_this2.timeOutArr.push(setTimeout(function(){var action=_this2.state.action;_this2.audio3.play();_this2.setState({action:!action});_this2.timeOutArr.push(setTimeout(function(){var duration2=Number(_this2.duration2)>0?_this2.duration2:3;_this2.audio2.play();_this2.timeOutArr.push(setTimeout(function(){_this2.props.teachComplete();},Math.round(duration2*1000)+1000));},1500));},Math.round(duration1*1000)+1000));}catch(error){__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* default */].closeH5Page({reason:'homeworkError'});}},1500));this.audio1.onended=function(){};this.audio2.onended=function(){_this2.timeOutArr.push(setTimeout(function(){},1000));};}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'render',value:function render(){var _this3=this;var action=this.state.action;var questionInfo=this.props.questionInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach_pic_wrap',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach_pic pic1 action right '+(action?'active':''),style:{backgroundImage:'url('+questionInfo.pictureAOne+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach_pic pic1 left',style:{backgroundImage:'url('+questionInfo.pictureAOne+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach_pic pic2 right',style:{backgroundImage:'url('+questionInfo.pictureBOne+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'teach_pic pic2 action left '+(action?'active':''),style:{backgroundImage:'url('+questionInfo.pictureBOne+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{src:questionInfo.audioA,ref:function ref(com){return _this3.audio1=com;},preload:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{src:questionInfo.audioB,ref:function ref(com){return _this3.audio2=com;},preload:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{src:__WEBPACK_IMPORTED_MODULE_3__static_audio_fanshu_mp3___default.a,ref:function ref(com){return _this3.audio3=com;},preload:'true'}));}}]);return Teach;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Teach);

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fanshu.d022e89c.mp3";

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_HomeworkResult__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_env__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_axios__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeworkResultPage=function(_Component){_inherits(HomeworkResultPage,_Component);function HomeworkResultPage(props){_classCallCheck(this,HomeworkResultPage);var _this=_possibleConstructorReturn(this,(HomeworkResultPage.__proto__||Object.getPrototypeOf(HomeworkResultPage)).call(this,props));_this.handleDone=function(){__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_End_Complete'});__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].closeH5Page({reason:'homeworkDone'});};_this.handleShare=function(){var shareParams=_this.state.shareParams;if(!shareParams)return;return __WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].shareNew(Object.assign({},shareParams,{type:2,shareByUrl:true,shareUrl:__WEBPACK_IMPORTED_MODULE_6__api_env__["a" /* default */].wxBaseUrl+'/h5/share-work?stuId='+_this.queryObj.userid+'&classSchId='+_this.queryObj.classschid,resource:'homework'}));};_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var courseid=_this.queryObj.courseid;_this.state={showStepChange:true,shareParams:null};_this.shareKey=courseid+'_H5HomeWorkShare';// 分享内链配置key,
_this.timeOutArr=[];return _this;}_createClass(HomeworkResultPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].homeworkEnd({data:{classSchId:this.queryObj.classschid,type:0}},function(res,err){if(err)console.log(err.errorMessage);else{_this2.setState({awardCnt:res.awardCnt,starnum:res.score,completeRender:true},function(){_this2.stepChangeRef.cloudPlay(function(){_this2.timeOutArr.push(setTimeout(function(){_this2.setState({showStepChange:false,stepChange:'out'});},1200));});});}});__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].getShareConfigByKey({data:{key:this.shareKey}},function(res,err){var shareParams=res;console.log('shareParams==',shareParams);_this2.setState({shareParams:shareParams});});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,stepChange=_state.stepChange,showStepChange=_state.showStepChange,starnum=_state.starnum,awardCnt=_state.awardCnt,completeRender=_state.completeRender,shareParams=_state.shareParams;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课后作业'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_HomeworkNew_HomeworkResult__["a" /* default */],{starnum:starnum,awardCnt:awardCnt,handleDone:this.handleDone,handleShare:this.handleShare,isShowShare:!!shareParams}),showStepChange&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_HomeworkNew_StepChange__["a" /* default */],{status:stepChange||'in',ref:function ref(com){return _this3.stepChangeRef=com;}})));}}]);return HomeworkResultPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeworkResultPage);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apng___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apng__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_homework_new_diamond_png__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_homework_new_diamond_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_images_homework_new_diamond_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_audio_diamond_count_mp3__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_audio_diamond_count_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_audio_diamond_count_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ua__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomeworkResult=function(_Component){_inherits(HomeworkResult,_Component);function HomeworkResult(props){_classCallCheck(this,HomeworkResult);var _this=_possibleConstructorReturn(this,(HomeworkResult.__proto__||Object.getPrototypeOf(HomeworkResult)).call(this,props));_this.componentDidMount=function(){var count=_this.state.count;count===0&&_this.addstarFun();__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].completeHomework();};_this.addstarFun=function(){var starnum=_this.props.starnum*2;var array=[];var starArr=[];for(var i=0;i<10;i++){if(starnum-i>0)array.push(1);else array.push(0);}for(var _i=0;_i<array.length;_i++){if(_i%2!==0){starArr.push(array[_i]+array[_i-1]);}}_this.setState({starArr:starArr});};_this.openGift=function(){_this.audioCount.play();_this.setState({giftStatus:'open'},function(){_this.timeOutArr.push(setTimeout(function(){_this.setState({showApng:true});_this.countFun();},1000));});__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].eventTracking({eventType:'c2_app_HomeWork_End_GiftBox'});};_this.countFun=function(){var count=_this.state.count;if(count<0){_this.gift.stop();_this.audioCount.pause();_this.addstarFun();_this.setState({actionDone:true});return false;}setTimeout(function(){_this.setState({count:count-1});_this.countFun();},220);};_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.countInit=1600/_this.clientWidth;_this.defaultCnt=props.awardCnt;_this.state={count:props.awardCnt,// count: 12,
actionDone:props.awardCnt===0,giftStatus:'close',starArr:[]};_this.timeOutArr=[];_this.clientData=__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].getClientDataSync({data:['noShare']})||'{}';_this.clientData=JSON.parse(_this.clientData);return _this;}_createClass(HomeworkResult,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.timeOutArr.map(function(ele){return clearTimeout(ele);});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,actionDone=_state.actionDone,count=_state.count,showApng=_state.showApng,giftStatus=_state.giftStatus,starArr=_state.starArr;var _props$isShowShare=this.props.isShowShare,isShowShare=_props$isShowShare===undefined?true:_props$isShowShare;var starItem=starArr.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'star icons '+(ele===0?'':ele===1?'half':'complete')});});var _clientData$noShare=this.clientData.noShare,noShare=_clientData$noShare===undefined?false:_clientData$noShare;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container homework_new result'},actionDone?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'star_wrap'},starItem),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btnWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn done',onClick:this.props.handleDone}),!__WEBPACK_IMPORTED_MODULE_6__utils_ua__["a" /* default */].winClient&&!noShare&&isShowShare&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn share',onClick:this.props.handleShare}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dimond'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift '+giftStatus}),showApng?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apng___default.a,{className:'action_wrap',src:__WEBPACK_IMPORTED_MODULE_4__static_images_homework_new_diamond_png___default.a,rate:1,autoPlay:true,ref:function ref(com){return _this2.gift=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count count1'},'+',count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count count2'},this.defaultCnt-count)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,giftStatus==='close'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'finger'}),giftStatus==='close'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_hide',onClick:this.openGift}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{preload:'auto',ref:function ref(com){_this2.audioCount=com;},src:__WEBPACK_IMPORTED_MODULE_5__static_audio_diamond_count_mp3___default.a}));}}]);return HomeworkResult;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomeworkResult);

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diamond.051db131.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/diamond_count.82e3bc58.mp3";

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_images_detail_ngk_1_png__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_images_detail_ngk_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_images_detail_ngk_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_images_detail_ngk_2_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_images_detail_ngk_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_images_detail_ngk_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_images_detail_ngk_3_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_images_detail_ngk_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_images_detail_ngk_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_images_detail_ngk_4_png__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_images_detail_ngk_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_images_detail_ngk_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_images_detail_ngk_5_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_images_detail_ngk_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_images_detail_ngk_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_images_detail_ngk_6_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_images_detail_ngk_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_images_detail_ngk_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_images_detail_ngk_7_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_images_detail_ngk_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_images_detail_ngk_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_images_detail_ngk_8_png__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_images_detail_ngk_8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_images_detail_ngk_8_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_images_detail_ngk_9_png__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_images_detail_ngk_9_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__static_images_detail_ngk_9_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_images_detail_ngk_10_png__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_images_detail_ngk_10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_images_detail_ngk_10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_images_detail_1_png__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_images_detail_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__static_images_detail_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_images_detail_2_png__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_images_detail_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__static_images_detail_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_images_detail_3_png__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_images_detail_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_images_detail_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_images_detail_4_png__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__static_images_detail_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__static_images_detail_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_images_detail_5_png__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__static_images_detail_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__static_images_detail_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_images_detail_6_png__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__static_images_detail_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__static_images_detail_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__static_images_detail_7_png__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__static_images_detail_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__static_images_detail_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__static_images_detail_nasa_poster_1_png__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__static_images_detail_nasa_poster_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__static_images_detail_nasa_poster_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__static_images_detail_nasa_poster_2_png__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__static_images_detail_nasa_poster_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__static_images_detail_nasa_poster_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__static_images_detail_1_gif__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__static_images_detail_1_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__static_images_detail_1_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__static_images_detail_2_gif__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__static_images_detail_2_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__static_images_detail_2_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_images_detail_3_gif__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__static_images_detail_3_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__static_images_detail_3_gif__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ngk_poster="https://oss.aircourses.com/default/video/ngk1.jpg";var queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var ngkImg=[__WEBPACK_IMPORTED_MODULE_11__static_images_detail_ngk_1_png___default.a,__WEBPACK_IMPORTED_MODULE_12__static_images_detail_ngk_2_png___default.a,__WEBPACK_IMPORTED_MODULE_13__static_images_detail_ngk_3_png___default.a,__WEBPACK_IMPORTED_MODULE_14__static_images_detail_ngk_4_png___default.a,__WEBPACK_IMPORTED_MODULE_15__static_images_detail_ngk_5_png___default.a,__WEBPACK_IMPORTED_MODULE_16__static_images_detail_ngk_6_png___default.a,__WEBPACK_IMPORTED_MODULE_17__static_images_detail_ngk_7_png___default.a,__WEBPACK_IMPORTED_MODULE_18__static_images_detail_ngk_8_png___default.a,__WEBPACK_IMPORTED_MODULE_19__static_images_detail_ngk_9_png___default.a,__WEBPACK_IMPORTED_MODULE_20__static_images_detail_ngk_10_png___default.a];var ngkVideo='https://oss.aircourses.com/default/video/ngk1.mp4';var nasaImg=[__WEBPACK_IMPORTED_MODULE_21__static_images_detail_1_png___default.a,__WEBPACK_IMPORTED_MODULE_22__static_images_detail_2_png___default.a,__WEBPACK_IMPORTED_MODULE_23__static_images_detail_3_png___default.a,__WEBPACK_IMPORTED_MODULE_24__static_images_detail_4_png___default.a,__WEBPACK_IMPORTED_MODULE_25__static_images_detail_5_png___default.a,__WEBPACK_IMPORTED_MODULE_26__static_images_detail_6_png___default.a,__WEBPACK_IMPORTED_MODULE_27__static_images_detail_7_png___default.a];var nasaVideo=['https://oss.aircourses.com/default/video/nasa1.mp4','https://oss.aircourses.com/default/video/nasa2.mp4'];var gifList=[__WEBPACK_IMPORTED_MODULE_30__static_images_detail_1_gif___default.a,__WEBPACK_IMPORTED_MODULE_31__static_images_detail_2_gif___default.a,__WEBPACK_IMPORTED_MODULE_32__static_images_detail_3_gif___default.a];var CourseDetaiPage=function(_Component){_inherits(CourseDetaiPage,_Component);function CourseDetaiPage(props){_classCallCheck(this,CourseDetaiPage);var _this=_possibleConstructorReturn(this,(CourseDetaiPage.__proto__||Object.getPrototypeOf(CourseDetaiPage)).call(this,props));_this.pauseH5Media=function(){_this.videoNgk.video.pause();_this.videoRef.map(function(ele){ele.video.pause();return false;});};_this.imgList=Number(queryObj.courseid)===211?nasaImg:ngkImg;_this.videoList=nasaVideo;_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.clientHeight=document.body.clientHeight||document.documentElement.clientHeight;_this.countInit=750/_this.clientWidth;_this.tabItem=Number(queryObj.courseid)===211?[0,Math.round(5820/_this.countInit)]:[0,Math.round(7778/_this.countInit),Math.round(9884/_this.countInit)];_this.state={type:Number(queryObj.courseid)===211?'nasa':'ngk',completeRander:true,showVideo:true};_this.timeout=[];_this.videoRef=[];_this.videoNgk=null;return _this;}_createClass(CourseDetaiPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_5__api_web__["b" /* apiDefine */])({apiName:'pauseH5Media',fn:this.pauseH5Media});// 定义弹框回调方法
this.timeout.push(setTimeout(function(){__WEBPACK_IMPORTED_MODULE_9__api_client__["a" /* default */].h5Message({data:{offsetHeight:_this2.state.type==='nasa'?Math.round(8650/_this2.countInit):Math.round(14833/_this2.countInit),offsetWidth:_this2.clientWidth,tabItem:_this2.tabItem}});},0));__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].getCourseInfo({data:{stuId:queryObj.stuid,channelId:queryObj.channel},query:queryObj.courseid},function(res,err){if(err)alert(err.errorMessage);else{var coverHPhoto=res.coverHPhoto,cnName=res.cnName,stuCnt=res.stuCnt,stuExpireDate=res.stuExpireDate,stuStatus=res.stuStatus,isPermanent=res.isPermanent;_this2.setState({coverHPhoto:coverHPhoto,cnName:cnName,stuCnt:stuCnt,stuExpireDate:stuExpireDate,stuStatus:stuStatus,isPermanent:isPermanent});}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.timeout.map(function(ele){return clearTimeout(ele);});this.setState({showVideo:false});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,coverHPhoto=_state.coverHPhoto,cnName=_state.cnName,stuCnt=_state.stuCnt,stuExpireDate=_state.stuExpireDate,stuStatus=_state.stuStatus,type=_state.type,showVideo=_state.showVideo,isPermanent=_state.isPermanent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程详情'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.state.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"course_container "+type+" "+(__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].mobileClient?'':'pc')},!__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].mobileClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__["a" /* default */],{title:type==='nasa'?cnName:'',stuCount:(stuCnt||'')+"\u4EBA\u52A0\u5165\u5B66\u4E60",lessonDate:stuExpireDate||'',stuStatus:stuStatus,bg:coverHPhoto,isPermanent:isPermanent// 是否永久有效
}),this.imgList.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img_wrap img img"+index,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:node,alt:"\u8BFE\u7A0B\u8BE6\u60C5"}));}),showVideo&&type==='ngk'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__["a" /* default */],{src:ngkVideo,className:"video ngk1",poster:ngk_poster,ref:function ref(com){_this3.videoNgk=com;}}),showVideo&&type==='nasa'&&this.videoList.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__["a" /* default */],{src:encodeURI(node),poster:index===0?__WEBPACK_IMPORTED_MODULE_28__static_images_detail_nasa_poster_1_png___default.a:__WEBPACK_IMPORTED_MODULE_29__static_images_detail_nasa_poster_2_png___default.a,className:"video "+type+index,key:index,ref:function ref(com){_this3.videoRef[index]=com;}});}),type==='nasa'&&gifList.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gif_wrap gif"+index,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:node,alt:"gif"}));}))));}}]);return CourseDetaiPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseDetaiPage);

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.7b93a03d.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.bb335811.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.b4d4909c.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.0640c6d2.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.50928d9a.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.2903869b.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.0088c5af.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8.c425a752.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/9.8e2be454.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/10.7d30e963.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.c53379d9.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.9ea4d455.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.79b98d9e.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.de7ff9ed.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.c2dc0d85.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.6f84c5ac.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.2181c825.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nasa_poster_1.7c898a88.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nasa_poster_2.afbb5289.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.0fc81db2.gif";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.574bfbaa.gif";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.c01cd0b7.gif";

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_images_phonics_detail_1_png__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_images_phonics_detail_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_images_phonics_detail_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_images_phonics_detail_2_png__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_images_phonics_detail_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_images_phonics_detail_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_images_phonics_detail_3_png__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_images_phonics_detail_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_images_phonics_detail_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_images_phonics_detail_4_png__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_images_phonics_detail_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_images_phonics_detail_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_images_phonics_detail_5_png__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_images_phonics_detail_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_images_phonics_detail_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_images_phonics_detail_6_png__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_images_phonics_detail_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_images_phonics_detail_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_images_phonics_detail_7_png__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_images_phonics_detail_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_images_phonics_detail_7_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_images_phonics_detail_8_png__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_images_phonics_detail_8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_images_phonics_detail_8_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var vUrl='https://oss.aircourses.com/default/video/phonics/phc.mp4';var pUrl='https://oss.aircourses.com/default/video/phonics/phc.png';var PhonicsDetaiPage=function(_Component){_inherits(PhonicsDetaiPage,_Component);function PhonicsDetaiPage(props){_classCallCheck(this,PhonicsDetaiPage);var _this=_possibleConstructorReturn(this,(PhonicsDetaiPage.__proto__||Object.getPrototypeOf(PhonicsDetaiPage)).call(this,props));_this.pauseH5Media=function(){_this.videoRef.video&&_this.videoRef.video.pause();};_this.isMobile=__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].mobileClient;_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.clientHeight=document.body.clientHeight||document.documentElement.clientHeight;_this.countInit=750/_this.clientWidth;_this.tabItem=[0,Math.round(5820/_this.countInit)];_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.imgList=[__WEBPACK_IMPORTED_MODULE_11__static_images_phonics_detail_1_png___default.a,__WEBPACK_IMPORTED_MODULE_12__static_images_phonics_detail_2_png___default.a,__WEBPACK_IMPORTED_MODULE_13__static_images_phonics_detail_3_png___default.a,__WEBPACK_IMPORTED_MODULE_14__static_images_phonics_detail_4_png___default.a,__WEBPACK_IMPORTED_MODULE_15__static_images_phonics_detail_5_png___default.a,__WEBPACK_IMPORTED_MODULE_16__static_images_phonics_detail_6_png___default.a,__WEBPACK_IMPORTED_MODULE_17__static_images_phonics_detail_7_png___default.a,__WEBPACK_IMPORTED_MODULE_18__static_images_phonics_detail_8_png___default.a];_this.state={type:'phonics',completeRander:true,showVideo:true};_this.timeout=[];_this.videoRef=null;return _this;}_createClass(PhonicsDetaiPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_5__api_web__["b" /* apiDefine */])({apiName:'pauseH5Media',fn:this.pauseH5Media});// 定义弹框回调方法
this.timeout.push(setTimeout(function(){__WEBPACK_IMPORTED_MODULE_9__api_client__["a" /* default */].h5Message({data:{offsetHeight:Math.round(8970/_this2.countInit),offsetWidth:_this2.clientWidth,tabItem:_this2.tabItem}});},0));__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].getCourseInfo({data:{stuId:this.queryObj.stuid,channelId:this.queryObj.channel},query:this.queryObj.courseid},function(res,err){if(err)alert(err.errorMessage);else{var coverHPhoto=res.coverHPhoto,cnName=res.cnName,stuCnt=res.stuCnt,stuExpireDate=res.stuExpireDate,stuStatus=res.stuStatus,isPermanent=res.isPermanent;_this2.setState({coverHPhoto:coverHPhoto,cnName:cnName,stuCnt:stuCnt,stuExpireDate:stuExpireDate,stuStatus:stuStatus,isPermanent:isPermanent});}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.timeout.map(function(ele){return clearTimeout(ele);});this.setState({showVideo:false});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,coverHPhoto=_state.coverHPhoto,cnName=_state.cnName,stuCnt=_state.stuCnt,stuExpireDate=_state.stuExpireDate,stuStatus=_state.stuStatus,type=_state.type,isPermanent=_state.isPermanent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程详情'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.state.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"phonics_detail "+type+" "+(this.isMobile?'':'pc')},!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__["a" /* default */],{title:cnName,stuCount:(stuCnt||'')+"\u4EBA\u6B63\u5728\u5B66\u4E60",lessonDate:stuExpireDate||'',stuStatus:stuStatus,bg:coverHPhoto,isPermanent:isPermanent// 是否永久有效
}),this.imgList.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img_wrap img img"+(index+1),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"img",src:node}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__["a" /* default */],{src:vUrl,poster:pUrl,className:"video "+(this.isMobile?'':'pc'),ref:function ref(com){_this3.videoRef=com;}}))));}}]);return PhonicsDetaiPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PhonicsDetaiPage);

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.8c801983.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.14f0f3ba.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.ef75927b.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.7185cfe6.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.93bb444e.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.d01e1fe8.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.3a4413c2.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8.4b8518ed.png";

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_vip_png__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_images_vip_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_images_vip_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_images_vip_no_png__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_images_vip_no_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_images_vip_no_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* 哈佛购课页面/会员中心页
*/var queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var MemberPage=function(_Component){_inherits(MemberPage,_Component);function MemberPage(props){_classCallCheck(this,MemberPage);var _this=_possibleConstructorReturn(this,(MemberPage.__proto__||Object.getPrototypeOf(MemberPage)).call(this,props));_this.getStuCourse=function(){__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getStuCourse({data:{stuId:queryObj.stuid,courseId:210}},function(res,err){if(err){// alert(JSON.stringify(err))
}else{if(res[0]){var expireDate=new Date(res[0].expireDate).getTime()+86400000;if(expireDate>_this.state.curExpireDate&&(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].winClient||__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].androidTabClient)){// 购买之后则关闭付款二维码
_this.setState({showErweima:false});}_this.setState({expireDate:expireDate-new Date().getTime()>0?res[0].expireDate:null,completeRander:true,curExpireDate:expireDate,stuStatus:res[0].stuStatus});}else{_this.setState({completeRander:true});}}});};_this.handleClick=function(index){if(_this.state.list[index].available){_this.setState({goodsNo:_this.state.list[index].goodsNo});setTimeout(function(){window.location.href=window.location.origin+'/h5/nasamk'+window.location.search+'&goodsId='+_this.state.list[index].id;},300);}else{alert(_this.state.list[index].unavailableReason);}};_this.state={expireDate:null,channelId:Number(queryObj.channel)>=1000?queryObj.channel:null,completeRander:false// 加载中
};return _this;}_createClass(MemberPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var channelId=this.state.channelId;var data={userId:queryObj.stuid};if(channelId)data.channelId=channelId;this.getStuCourse();//        setInterval(()=>{
//            this.getStuCourse()
//        }, 4000)
__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getGoodsInfo({data:data},function(res,err){if(err)console.log(err);else{_this2.setState({list:res});}});}// 获取学生当前套餐信息
// 点击续费或购买
},{key:'render',value:function render(){var _this3=this;var _state=this.state,showErweima=_state.showErweima,goodsNo=_state.goodsNo,_state$list=_state.list,list=_state$list===undefined?[]:_state$list,expireDate=_state.expireDate,_state$stuStatus=_state.stuStatus,stuStatus=_state$stuStatus===undefined?0:_state$stuStatus,completeRander=_state.completeRander;var item=list.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item',key:index,style:{backgroundImage:'url('+ele.posterUrl+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},ele.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},'\uFFE5',ele.totalAmount/100,' \u5143'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},'\u6709\u6548\u671F\uFF1A',ele.expireDays,' \u5929')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn',onClick:_this3.handleClick.bind(_this3,index)},stuStatus!==0?'续费':'购买'));});// alert(document.body.clientWidth)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'会员中心'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,completeRander?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container member_new '+(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_top_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:expireDate?__WEBPACK_IMPORTED_MODULE_8__static_images_vip_png___default.a:__WEBPACK_IMPORTED_MODULE_9__static_images_vip_no_png___default.a,alt:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,expireDate?'哈佛外教百科英语课程包':'您还不是哈佛外教百科英语课程的会员哦'),expireDate&&(stuStatus===2||stuStatus===4)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u6709\u6548\u671F\u81F3\uFF1A',expireDate):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u8BFE\u7A0B\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u8D2D\u4E70\u540E\u8BF7\u5728\u6709\u6548\u671F\u5185\u4F7F\u7528\uFF0C\u6B64\u8BFE\u7A0B\u4EC5\u9650\u4E8E\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u8BFE\u7A0B\u7CFB\u5217\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.\u83B7\u53D6\u5176\u5B83\u5BA2\u6237\u7AEF\u4E0B\u8F7D\u94FE\u63A5\u548C\u66F4\u591A\u6D3B\u52A8\u4FE1\u606F\uFF0C\u8BF7\u5173\u6CE8\u201C\u7231\u8BFEAirCourse\u201D\u670D\u52A1\u53F7\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.\u8D2D\u4E70\u540E7\u65E5\u5185\u53EF\u65E0\u7406\u7531\u9000\u6B3E\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.\u5982\u6709\u5176\u5B83\u4EFB\u4F55\u7591\u95EE\uFF0C\u8BF7\u8054\u7CFB4008-874-877\u3002')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content_bottom_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u5168\u90E8\u5957\u9910'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item_wrap'},item))):null,!completeRander?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null):null,showErweima?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima_wrap ngk',onClick:function onClick(){_this3.setState({showErweima:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_qrcode_react___default.a,{size:148,value:'https://client.aircourses.com/h5/paylink?channel='+queryObj.channel+'&userid='+queryObj.stuid+'&goodsno='+goodsNo,fgColor:'#333'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8BF7\u7528\u624B\u673A\u652F\u4ED8\u5B9D\u6216\u5FAE\u4FE1\u626B\u7801\u4ED8\u6B3E'))):null));}}]);return MemberPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MemberPage);

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Address_Address__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ua__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import clientApi from '../../api/client';
var queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var AddressPage=function(_Component){_inherits(AddressPage,_Component);function AddressPage(props){_classCallCheck(this,AddressPage);var _this=_possibleConstructorReturn(this,(AddressPage.__proto__||Object.getPrototypeOf(AddressPage)).call(this,props));_this.addAddress=function(info){var addressId=_this.state.addressId;var data=Object.assign({userId:queryObj.stuid},info);var source=_this.source?_this.source:'nasamk';if(typeof addressId==='undefined'){__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].addAddress({data:data},function(res,err){if(err)alert(err.errorMessage);else{var history=_this.props.history;history.replace({pathname:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* COURSE_URL */]+'/'+source,search:window.location.search});}});}else{__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].setAddress({data:data,query:addressId+''},function(res,err){if(err)alert(err.errorMessage);else{var history=_this.props.history;history.replace({pathname:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* COURSE_URL */]+'/'+source,search:window.location.search});}});}};_this.isMobile=__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].mobileClient;_this.addressId=props.location.state?props.location.state.addressId:undefined;_this.source=props.location.state?props.location.state.source:null;_this.storage=__WEBPACK_IMPORTED_MODULE_6__utils_tools__["e" /* myStorage */];var userAddress=_this.storage.getItem('user_address');_this.state={completeRander:true,userAddress:userAddress?JSON.parse(userAddress):null,addressId:_this.addressId};return _this;}_createClass(AddressPage,[{key:'componentWillMount',value:function componentWillMount(){var isAllowAgreement=this.props.location.state.isAllowAgreement;if(isAllowAgreement){localStorage.setItem('is_allow_agreement',isAllowAgreement);}localStorage.setItem('no_use_discount',this.props.location.state.notUseDiscount);var discountCoupon=this.props.location.state.discountCoupon;if(!!discountCoupon&&Object.keys(discountCoupon).length>0){localStorage.setItem('user_discount',JSON.stringify(this.props.location.state.discountCoupon));}}},{key:'render',value:function render(){var userAddress=this.state.userAddress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'收货地址'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.state.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:true,showClose:false,title:'\u6536\u8D27\u5730\u5740'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Address_Address__["a" /* default */],{defaultAddress:userAddress,addAddress:this.addAddress.bind(this)})));}}]);return AddressPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddressPage);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_addressPicker__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_ChinaAreaSelector_ChinaAreaSelectorPC__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_spring_picker_lib_style_css__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_spring_picker_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_spring_picker_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ChinaAreaSelector from '../../template/ChinaAreaSelector/ChinaAreaSelector';
var Adress=function(_Component){_inherits(Adress,_Component);function Adress(props){_classCallCheck(this,Adress);var _this=_possibleConstructorReturn(this,(Adress.__proto__||Object.getPrototypeOf(Adress)).call(this,props));_this.handleReset=function(type){_this.setState(_defineProperty({},type,''));};_this.onFocus=function(type,e){_this.setState({focusItem:type});};_this.onChange=function(type,e){var value=e.target.value;if(type==='tele'){if(/\D+/.test(value))return false;}_this.setState(_defineProperty({},type,value));};_this.onkeyUp=function(e){// const value = e.target.value;
// console.log(/^\d/.test(value))
};_this.addressPickerPC=function(value){_this.setState({address:value.names});_this.defaultAddress=value.names;};_this.onSave=function(){var errorMsg=['收货人姓名需要在2-25个字符之间','请输入正确的手机号码','详细地址需要在5-120个字符之间'];var addAddress=_this.props.addAddress;var infoOk=[];infoOk=_this.input.map(function(ele,index){var value=ele.value;if(index===0){return value.length>1&&value.length<26&&!/^\s/.test(value);}else if(index===1){return /^1[0-9]{10}$/.test(value);}else{return value.length>4&&value.length<121;}});var errorIndex=infoOk.indexOf(false);// if(errorIndex > -1) return alert(errorMsg[errorIndex]);
// else if(!this.state.address.length) return alert('请填写城市');
if(errorIndex>-1)return __WEBPACK_IMPORTED_MODULE_5__api_client__["a" /* default */].alertView({title:'提示',content:errorMsg[errorIndex],confirm:'确定',cancel:'取消',id:'H5_1002'});else if(!_this.state.address.length)return __WEBPACK_IMPORTED_MODULE_5__api_client__["a" /* default */].alertView({title:'提示',content:'请选择省市区',confirm:'确定',cancel:'取消',id:'H5_1002'});else{var _this$state=_this.state,name=_this$state.name,tele=_this$state.tele,addressDetail=_this$state.addressDetail,address=_this$state.address;addAddress({consignee:name,consigneePhone:tele,province:address[0],city:address[1],area:address[2],detail:addressDetail});}};_this.testClick=function(e){var className=e.target.className;if(className.indexOf('container')!==-1){_this.hideKeyboard();_this.setState({focusItem:null});}};_this.sendNotificationToH5=function(res){var _JSON$parse=JSON.parse(res),notification=_JSON$parse.notification;console.log(notification);if(notification==='hideKeyboard'){_this.hideKeyboard();}};_this.hideKeyboard=function(){_this.input.forEach(function(element){element.blur();});};_this.isMobile=__WEBPACK_IMPORTED_MODULE_3__utils_ua__["a" /* default */].mobileClient;_this.input=[];_this.useraddress=props.defaultAddress?props.defaultAddress:{};_this.defaultAddress=Boolean(_this.useraddress.province)?[_this.useraddress.province,_this.useraddress.city,_this.useraddress.area]:[];_this.initAddress=__WEBPACK_IMPORTED_MODULE_3__utils_ua__["a" /* default */].mobileClient?['北京市','北京市','东城区']:['北京市','东城区'];_this.state={name:_this.useraddress.consignee,tele:_this.useraddress.consigneePhone,addressDetail:_this.useraddress.detail,address:_this.defaultAddress.length?_this.defaultAddress:_this.initAddress,addressPickerVisible:false,addressPickerVisiblePC:null};return _this;}_createClass(Adress,[{key:'showAddressPicker',value:function showAddressPicker(e){e.nativeEvent.stopImmediatePropagation();if(this.isMobile){this.setState({addressPickerVisible:true});}else{this.setState({addressPickerVisiblePC:true});}}},{key:'handleChangeAddress',value:function handleChangeAddress(address){this.setState({address:address});this.defaultAddress=address;}},{key:'closeAddressPicker',value:function closeAddressPicker(address){this.setState({address:address,addressPickerVisible:false});}},{key:'cancelAddressPicker',value:function cancelAddressPicker(){this.setState({address:this.defaultAddress,addressPickerVisible:false});}},{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_4__api_web__["b" /* apiDefine */])({apiName:'sendNotificationToH5',fn:this.sendNotificationToH5});// 定义客户端隐藏键盘方法
// console.log(isNaN('a'))
}},{key:'render',value:function render(){var _this2=this;var _state=this.state,addressPickerVisible=_state.addressPickerVisible,addressPickerVisiblePC=_state.addressPickerVisiblePC,address=_state.address,name=_state.name,tele=_state.tele,addressDetail=_state.addressDetail,focusItem=_state.focusItem;// console.info({...this.state})
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container address '+(this.isMobile?'':'pc'),onClick:this.testClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:name.length&&focusItem==='name'?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'\u6536\u8D27\u4EBA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D',id:'name',ref:function ref(com){_this2.input[0]=com;},value:name,onChange:this.onChange.bind(this,'name'),onFocus:this.onFocus.bind(this,'name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'after',onClick:this.handleReset.bind(this,'name')},'\xD7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:tele.length&&focusItem==='tele'?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'\u624B\u673A\u53F7\u7801'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801',maxLength:'11',id:'tele',ref:function ref(com){_this2.input[1]=com;},value:tele,onChange:this.onChange.bind(this,'tele'),onKeyUp:this.onkeyUp.bind(this),onFocus:this.onFocus.bind(this,'tele')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'after',onClick:this.handleReset.bind(this,'tele')},'\xD7')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'\u6240\u5728\u5730\u533A'),!this.defaultAddress.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_placeholder',onClick:this.showAddressPicker.bind(this)},'\u8BF7\u9009\u62E9\u7701\u5E02\u533A'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address',onClick:this.showAddressPicker.bind(this)},address.join(' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'address '+(addressDetail.length&&focusItem==='addressDetail'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'\u8BE6\u7EC6\u5730\u5740'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'\u5982\u9053\u8DEF\u3001\u95E8\u724C\u53F7\u3001\u5C0F\u533A\u3001\u697C\u680B\u53F7\u3001\u5355\u5143\u5BA4\u7B49',ref:function ref(com){_this2.input[2]=com;},value:addressDetail,onChange:this.onChange.bind(this,'addressDetail'),onFocus:this.onFocus.bind(this,'addressDetail')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'after',onClick:this.handleReset.bind(this,'addressDetail')},'\xD7')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn save',onClick:this.onSave},'\u4FDD\u5B58\u5E76\u4F7F\u7528'),this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_addressPicker__["a" /* PickerAddress */],{defaultValue:address,onCancel:this.cancelAddressPicker.bind(this),onConfirm:this.closeAddressPicker.bind(this),visible:addressPickerVisible,onChange:this.handleChangeAddress.bind(this)}),!this.isMobile&&addressPickerVisiblePC&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_picker_pc_wrap',onClick:function onClick(){_this2.setState({addressPickerVisiblePC:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_picker_pc',onClick:function onClick(e){e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_ChinaAreaSelector_ChinaAreaSelectorPC__["a" /* default */]// defaultValue={address}
,{onChange:function onChange(value){_this2.addressPickerPC(value);}}))));}}]);return Adress;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Adress);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spring_picker__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spring_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spring_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__address__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={defaultValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onConfirm:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onCancel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,visible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};var PickerAddress=function(_React$Component){_inherits(PickerAddress,_React$Component);function PickerAddress(props){_classCallCheck(this,PickerAddress);var _this=_possibleConstructorReturn(this,(PickerAddress.__proto__||Object.getPrototypeOf(PickerAddress)).call(this));_this.props=props;_this.address=[];return _this;}_createClass(PickerAddress,[{key:'initDefaultData',value:function initDefaultData(){this.data={provins:{list:__WEBPACK_IMPORTED_MODULE_3__address__["c" /* provins */],defaultValue:this.props.defaultValue[0],displayValue:function displayValue(name){return name;}},citys:{list:__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][this.props.defaultValue[0]],defaultValue:this.props.defaultValue[1],displayValue:function displayValue(name){return name;}},areas:{list:__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][this.props.defaultValue[1]],defaultValue:this.props.defaultValue[2],displayValue:function displayValue(name){return name;}}};}},{key:'handleChangeProvin',value:function handleChangeProvin(provin){this.data.provins={list:__WEBPACK_IMPORTED_MODULE_3__address__["c" /* provins */],defaultValue:provin};this.data.citys={list:__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin],defaultValue:__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin][0]};this.data.areas={list:__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin][0]],defaultValue:__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin][0]][0]};this.address=[];this.address.push(provin);this.address.push(__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin][0]);this.address.push(__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][__WEBPACK_IMPORTED_MODULE_3__address__["b" /* citys */][provin][0]][0]);this.props.onChange(this.address);}},{key:'handleChangeCity',value:function handleChangeCity(city){this.address[1]=city;this.address[2]=__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][city][0];this.data.areas={list:__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][city],defaultValue:__WEBPACK_IMPORTED_MODULE_3__address__["a" /* areas */][city][0]};this.props.onChange(this.address);}},{key:'handleChangeArea',value:function handleChangeArea(area){this.address[2]=area;this.props.onChange(this.address);}},{key:'handleClose',value:function handleClose(){this.props.onConfirm(this.address);}},{key:'handleCancel',value:function handleCancel(){this.props.onCancel();}},{key:'render',value:function render(){this.initDefaultData();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ui-picker-address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_spring_picker__["Popup"],{onConfirm:this.handleClose.bind(this),onCancel:this.handleCancel.bind(this),visible:this.props.visible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_spring_picker__["Picker"],{onChange:this.handleChangeProvin.bind(this),data:this.data.provins}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_spring_picker__["Picker"],{onChange:this.handleChangeCity.bind(this),data:this.data.citys}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_spring_picker__["Picker"],{onChange:this.handleChangeArea.bind(this),data:this.data.areas})));}}]);return PickerAddress;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PickerAddress.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (PickerAddress);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(704);

Object.defineProperty(exports, 'Picker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_picker).default;
  }
});

var _popup = __webpack_require__(707);

Object.defineProperty(exports, 'Popup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_popup).default;
  }
});

var _BaseModal = __webpack_require__(241);

Object.defineProperty(exports, 'BaseModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(63);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(705);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getIndex = function getIndex(list, item) {
  if (list && list.length < 1) {
    return 0;
  }
  var index1 = _lodash2.default.findIndex(list, item);
  var index2 = list.indexOf(item);
  var index = Math.max(index1, index2);
  if (index < 0) {
    throw new Error('list数组中不存在defaultValue');
  }
  return index;
};

var Picker = function (_React$Component) {
  _inherits(Picker, _React$Component);

  function Picker(props) {
    _classCallCheck(this, Picker);

    var _this = _possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this));

    _this.props = props;
    _this.startY = 0;
    _this.endY = 0;
    //当前拖动的Y坐标
    _this.currentY = 0;
    _this.itemHeight = 36;
    _this.selectedIndex = _this.getInitialIndex();
    _this.state = { style: {} };
    _this._defaultValue = null;
    return _this;
  }

  // 初始化获得selectedIndex


  _createClass(Picker, [{
    key: 'getInitialIndex',
    value: function getInitialIndex() {
      var index = getIndex(this.props.data.list, this.props.data.defaultValue);
      if (!this.props.data.defaultValue && this.props.data.list.length > 3) {
        index = Math.floor(this.props.data.list.length / 2);
      }
      return index;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isEqual = _lodash2.default.isEqual(nextProps.data.defaultValue, this._defaultValue);
      if (!isEqual) {
        this._defaultValue = nextProps.data.defaultValue;
        this.selectedIndex = this.getReceivePropsIndex(nextProps.data);
        if (this.selectedIndex === 0) {
          this.setState({
            style: {
              transform: 'translate3d(0px, ' + this.itemHeight * 2 + 'px, 0px)'
            }
          });
        }
      }
    }
  }, {
    key: 'getReceivePropsIndex',
    value: function getReceivePropsIndex(data) {
      if (this._defaultValue) {
        this.selectedIndex = getIndex(data.list, data.defaultValue);
      }
      return this.selectedIndex;
    }
  }, {
    key: 'getInitialStyle',
    value: function getInitialStyle() {
      this.currentY = 0;
      if (this.selectedIndex > 2) {
        this.currentY = -(this.selectedIndex - 2) * this.itemHeight;
      } else {
        this.currentY = (2 - this.selectedIndex) * this.itemHeight;
      }
      return 'translate3d(0px, ' + this.currentY + 'px, 0px)';
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(e) {
      e.preventDefault();
      if (this.props.data.list.length <= 1) {
        return;
      }
      this.startY = e.nativeEvent.changedTouches[0].pageY;
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(e) {
      e.preventDefault();
      if (this.props.data.list.length <= 1) {
        return;
      }
      this.endY = e.nativeEvent.changedTouches[0].pageY;
      // 实际滚动距离
      var v = parseInt(this.endY - this.startY);
      var value = v % this.itemHeight;
      // 计算出每次拖动的36px整倍数
      this.currentY += v - value;

      // 正数y最大值
      var max1 = 2 * this.itemHeight;
      // 负数y最小值
      var max2 = (this.props.data.list.length - 3) * this.itemHeight;

      if (this.currentY > max1) {
        this.currentY = max1;
      } else if (this.currentY > 0 && this.currentY < max1) {
        this.currentY = this.currentY;
      } else if (this.currentY === max1) {
        this.currentY = this.currentY;
      } else if (Math.abs(this.currentY) > max2) {
        this.currentY = -max2;
      }

      this.countListIndex(this.currentY);

      this.setState({
        style: {
          transform: 'translate3d(0px, ' + this.currentY + 'px, 0px)'
        }
      });
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(e) {
      e.preventDefault();
      if (this.props.data.list.length <= 1) {
        return;
      }
      var pageY = e.nativeEvent.changedTouches[0].pageY;
      var value = parseInt(pageY - this.startY);
      var y = this.currentY + value;
      var style = 'translate3d(0px, ' + y + 'px, 0px)';
      this.setState({
        style: {
          transform: style
        }
      });
    }

    // 计算list数组索引

  }, {
    key: 'countListIndex',
    value: function countListIndex(pageY) {
      var n = pageY / this.itemHeight;
      n = n > 0 ? 2 - n : Math.abs(n) + 2;
      this.setSelectedValue(n);
    }

    // set选中值

  }, {
    key: 'setSelectedValue',
    value: function setSelectedValue(index) {
      var length = this.props.data.list.length;
      if (length === 0) {
        this.callback(null);
        return;
      }
      if (index < 0 || index > length - 1) {
        throw new Error('滑动取值索引数值出现错误' + index);
      }
      var value = this.props.data.list[index];
      this.selectedIndex = index;

      this.callback(value);
    }

    // 回调

  }, {
    key: 'callback',
    value: function callback(value) {
      this.props.onChange(value);
    }
  }, {
    key: 'getSelectedClass',
    value: function getSelectedClass(index) {
      if (this.selectedIndex === index) {
        return 'ui-picker-item-selected';
      }
      return '';
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setSelectedValue(this.selectedIndex);
    }
  }, {
    key: 'handleWrapperStart',
    value: function handleWrapperStart(e) {
      e.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = {
        transform: this.getInitialStyle()
      };
      return _react2.default.createElement(
        'div',
        { className: 'ui-picker-wrapper', onTouchStart: this.handleWrapperStart.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'ui-picker',
            style: this.state.style.transform ? this.state.style : style,
            onTouchStart: this.handleTouchStart.bind(this),
            onTouchMove: this.handleTouchMove.bind(this),
            onTouchEnd: this.handleTouchEnd.bind(this) },
          this.props.data.list.map(function (data, index) {
            var displayValue = _this2.props.data.displayValue(data);
            return _react2.default.createElement(
              'div',
              { key: index,
                className: 'ui-picker-item ' + _this2.getSelectedClass(index) },
              displayValue
            );
          })
        ),
        _react2.default.createElement('div', { className: 'ui-picker-center' })
      );
    }
  }]);

  return Picker;
}(_react2.default.Component);

Picker.propTypes = {
  // 数据源
  data: _propTypes2.default.object.isRequired,
  // 当停止滑动选中立即回调onchange方法
  onChange: _propTypes2.default.func.isRequired
};

exports.default = Picker;
//# sourceMappingURL=index.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76), __webpack_require__(706)(module)))

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(63);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(18);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseModal = __webpack_require__(241);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired
};

var Popup = function (_React$Component) {
  _inherits(Popup, _React$Component);

  function Popup() {
    _classCallCheck(this, Popup);

    return _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this));
  }

  _createClass(Popup, [{
    key: 'handleCancel',
    value: function handleCancel() {
      if (this.props.onCancel) {
        this.props.onCancel();
      }
    }
  }, {
    key: 'handleConfirm',
    value: function handleConfirm() {
      if (this.props.onConfirm) {
        this.props.onConfirm();
      }
    }

    /**
     * 使用原生事件替代react事件
     * 当BaseModal modal使用原生事件来阻止冒泡时
     * 完成与取消按钮的react onClick会失效，所以使用原生事件而不使用react事件
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.refs.confirmButton && !this.refs.confirmButton.onclick) {

        this.refs.confirmButton.onclick = function (e) {
          e.stopPropagation();
          _this2.handleConfirm();
        };
        this.refs.cancelButton.onclick = function (e) {
          e.stopPropagation();
          _this2.handleCancel();
        };
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isZh = !navigator.language || navigator.language.toLowerCase() === 'zh-cn' || navigator.language.toLowerCase() === 'zh';
      var text1 = !isZh ? 'Cancel' : '取消';
      var text2 = !isZh ? 'Finish' : '完成';
      return _react2.default.createElement(
        _BaseModal2.default,
        {
          onCancel: this.handleCancel.bind(this),
          visible: this.props.visible },
        _react2.default.createElement(
          'div',
          { className: 'ui-popup-title' },
          _react2.default.createElement(
            'span',
            { ref: 'cancelButton' },
            text1
          ),
          _react2.default.createElement(
            'span',
            { ref: 'confirmButton' },
            text2
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'ui-popup-content' },
          this.props.children
        )
      );
    }
  }]);

  return Popup;
}(_react2.default.Component);

Popup.propTypes = propTypes;

exports.default = Popup;
//# sourceMappingURL=index.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(709));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(716));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(245));

var _Transition = _interopRequireDefault(__webpack_require__(242));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(96));

var _addClass = _interopRequireDefault(__webpack_require__(712));

var _removeClass = _interopRequireDefault(__webpack_require__(715));

var _react = _interopRequireDefault(__webpack_require__(1));

var _Transition = _interopRequireDefault(__webpack_require__(242));

var _PropTypes = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(711);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(713);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(714));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 713 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(96));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = __webpack_require__(63);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(245));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};;
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? propTypes : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return provins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return citys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areas; });
var provins=['北京市','天津市','河北省','山西省','内蒙古','辽宁省','吉林省','黑龙江省','上海市','江苏省','浙江省','安徽省','福建省','江西省','山东省','河南省','湖北省','湖南省','广东省','广西','海南省','重庆市','四川省','贵州省','云南省','西藏','陕西省','甘肃省','青海','宁夏','新疆'];var citys={'北京市':['北京市'],'天津市':['天津市'],'河北省':['石家庄市','唐山市','秦皇岛市','邯郸市','邢台市','保定市','张家口市','承德市','沧州市','廊坊市','衡水市'],'山西省':['太原市','大同市','阳泉市','长治市','晋城市','朔州市','晋中市','运城市','忻州市','临汾市','吕梁市'],'内蒙古':['呼和浩特市','包头市','乌海市','赤峰市','通辽市','鄂尔多斯市','呼伦贝尔市','巴彦淖尔市','乌兰察布市','兴安盟','锡林郭勒盟','阿拉善盟'],'辽宁省':['沈阳市','大连市','鞍山市','抚顺市','本溪市','丹东市','锦州市','营口市','阜新市','辽阳市','盘锦市','铁岭市','朝阳市','葫芦岛市'],'吉林省':['长春市','吉林市','四平市','辽源市','通化市','白山市','松原市','白城市','延边朝鲜族自治州'],'黑龙江省':['哈尔滨市','齐齐哈尔市','鸡西市','鹤岗市','双鸭山市','大庆市','伊春市','佳木斯市','七台河市','牡丹江市','黑河市','绥化市','大兴安岭地区'],'上海市':['上海市'],'江苏省':['南京市','无锡市','徐州市','常州市','苏州市','南通市','连云港市','淮安市','盐城市','扬州市','镇江市','泰州市','宿迁市'],'浙江省':['杭州市','宁波市','温州市','嘉兴市','湖州市','绍兴市','金华市','衢州市','舟山市','台州市','丽水市'],'安徽省':['合肥市','芜湖市','蚌埠市','淮南市','马鞍山市','淮北市','铜陵市','安庆市','黄山市','滁州市','阜阳市','宿州市','巢湖市','六安市','亳州市','池州市','宣城市'],'福建省':['福州市','厦门市','莆田市','三明市','泉州市','漳州市','南平市','龙岩市','宁德市'],'江西省':['南昌市','景德镇市','萍乡市','九江市','新余市','鹰潭市','赣州市','吉安市','宜春市','抚州市','上饶市'],'山东省':['济南市','青岛市','淄博市','枣庄市','东营市','烟台市','潍坊市','济宁市','泰安市','威海市','日照市','莱芜市','临沂市','德州市','聊城市','滨州市','菏泽市'],'河南省':['郑州市','开封市','洛阳市','平顶山市','安阳市','鹤壁市','新乡市','焦作市','濮阳市','许昌市','漯河市','三门峡市','南阳市','商丘市','信阳市','周口市','驻马店市'],'湖北省':['武汉市','黄石市','十堰市','宜昌市','襄樊市','鄂州市','荆门市','孝感市','荆州市','黄冈市','咸宁市','随州市','恩施土家族苗族自治州','直辖行政单位'],'湖南省':['长沙市','株洲市','湘潭市','衡阳市','邵阳市','岳阳市','常德市','张家界市','益阳市','郴州市','永州市','怀化市','娄底市','湘西土家族苗族自治州'],'广东省':['广州市','韶关市','深圳市','珠海市','汕头市','佛山市','江门市','湛江市','茂名市','肇庆市','惠州市','梅州市','汕尾市','河源市','阳江市','清远市','东莞市','中山市','潮州市','揭阳市','云浮市'],'广西':['南宁市','柳州市','桂林市','梧州市','北海市','防城港市','钦州市','贵港市','玉林市','百色市','贺州市','河池市','来宾市','崇左市'],'海南省':['海口市','三亚市'],'重庆市':['市辖区','县'],'四川省':['成都市','自贡市','攀枝花市','泸州市','德阳市','绵阳市','广元市','遂宁市','内江市','乐山市','南充市','眉山市','宜宾市','广安市','达州市','雅安市','巴中市','资阳市','阿坝藏族羌族自治州','甘孜藏族自治州','凉山彝族自治州'],'贵州省':['贵阳市','六盘水市','遵义市','安顺市','铜仁地区','黔西南布依族苗族自治州','毕节地区','黔东南苗族侗族自治州','黔南布依族苗族自治州'],'云南省':['昆明市','曲靖市','玉溪市','保山市','昭通市','丽江市','思茅市','临沧市','楚雄彝族自治州','红河哈尼族彝族自治州','文山壮族苗族自治州','西双版纳傣族自治州','大理白族自治州','德宏傣族景颇族自治州','怒江傈僳族自治州','迪庆藏族自治州'],'西藏':['拉萨市','昌都地区','山南地区','日喀则地区','那曲地区','阿里地区','林芝地区'],'陕西省':['西安市','铜川市','宝鸡市','咸阳市','渭南市','延安市','汉中市','榆林市','安康市','商洛市'],'甘肃省':['兰州市','嘉峪关市','金昌市','白银市','天水市','武威市','张掖市','平凉市','酒泉市','庆阳市','定西市','陇南市','临夏回族自治州','甘南藏族自治州'],'青海':['西宁市','海东地区','海北藏族自治州','黄南藏族自治州','海南藏族自治州','果洛藏族自治州','玉树藏族自治州','海西蒙古族藏族自治州'],'宁夏':['银川市','石嘴山市','吴忠市','固原市','中卫市'],'新疆':['乌鲁木齐市','克拉玛依市','吐鲁番地区','哈密地区','昌吉回族自治州','博尔塔拉蒙古自治州','巴音郭楞蒙古自治州','阿克苏地区','克孜勒苏柯尔克孜自治州','喀什地区','和田地区','伊犁哈萨克','塔城地区','阿勒泰地区','石河子市','阿拉尔市','图木舒克市','五家渠市']};var areas={'北京市':['东城区','西城区','崇文区','宣武区','朝阳区','丰台区','石景山区','海淀区','门头沟区','房山区','通州区','顺义区','昌平区','大兴区','怀柔区','平谷区','密云县','延庆县'],'天津市':['和平区','河东区','河西区','南开区','河北区','红桥区','塘沽区','汉沽区','大港区','东丽区','西青区','津南区','北辰区','武清区','宝坻区','宁河县','静海县','蓟县'],'石家庄市':['长安区','桥东区','桥西区','新华区','井陉矿区','裕华区','井陉县','正定县','栾城县','行唐县','灵寿县','高邑县','深泽县','赞皇县','无极县','平山县','元氏县','赵县','辛集市','藁城市','晋州市','新乐市','鹿泉市'],'唐山市':['路南区','路北区','古冶区','开平区','丰南区','丰润区','滦县','滦南县','乐亭县','迁西县','玉田县','唐海县','遵化市','迁安市'],'秦皇岛市':['海港区','山海关区','北戴河区','青龙满族自治县','昌黎县','抚宁县','卢龙县'],'邯郸市':['邯山区','丛台区','复兴区','峰峰矿区','邯郸县','临漳县','成安县','大名县','涉县','磁县','肥乡县','永年县','邱县','鸡泽县','广平县','馆陶县','魏县','曲周县','武安市'],'邢台市':['桥东区','桥西区','邢台县','临城县','内丘县','柏乡县','隆尧县','任县','南和县','宁晋县','巨鹿县','新河县','广宗县','平乡县','威县','清河县','临西县','南宫市','沙河市'],'保定市':['新市区','北市区','南市区','满城县','清苑县','涞水县','阜平县','徐水县','定兴县','唐县','高阳县','容城县','涞源县','望都县','安新县','易县','曲阳县','蠡县','顺平县','博野县','雄县','涿州市','定州市','安国市','高碑店市'],'张家口市':['桥东区','桥西区','宣化区','下花园区','宣化县','张北县','康保县','沽源县','尚义县','蔚县','阳原县','怀安县','万全县','怀来县','涿鹿县','赤城县','崇礼县'],'承德市':['双桥区','双滦区','鹰手营子矿区','承德县','兴隆县','平泉县','滦平县','隆化县','丰宁满族自治县','宽城满族自治县','围场满族蒙古族自治县'],'沧州市':['新华区','运河区','沧县','青县','东光县','海兴县','盐山县','肃宁县','南皮县','吴桥县','献县','孟村回族自治县','泊头市','任丘市','黄骅市','河间市'],'廊坊市':['安次区','广阳区','固安县','永清县','香河县','大城县','文安县','大厂回族自治县','霸州市','三河市'],'衡水市':['桃城区','枣强县','武邑县','武强县','饶阳县','安平县','故城县','景县','阜城县','冀州市','深州市'],'太原市':['小店区','迎泽区','杏花岭区','尖草坪区','万柏林区','晋源区','清徐县','阳曲县','娄烦县','古交市'],'大同市':['城区','矿区','南郊区','新荣区','阳高县','天镇县','广灵县','灵丘县','浑源县','左云县','大同县'],'阳泉市':['城区','矿区','郊区','平定县','盂县'],'长治市':['城区','郊区','长治县','襄垣县','屯留县','平顺县','黎城县','壶关县','长子县','武乡县','沁县','沁源县','潞城市'],'晋城市':['城区','沁水县','阳城县','陵川县','泽州县','高平市'],'朔州市':['朔城区','平鲁区','山阴县','应县','右玉县','怀仁县'],'晋中市':['榆次区','榆社县','左权县','和顺县','昔阳县','寿阳县','太谷县','祁县','平遥县','灵石县','介休市'],'运城市':['盐湖区','临猗县','万荣县','闻喜县','稷山县','新绛县','绛县','垣曲县','夏县','平陆县','芮城县','永济市','河津市'],'忻州市':['忻府区','定襄县','五台县','代县','繁峙县','宁武县','静乐县','神池县','五寨县','岢岚县','河曲县','保德县','偏关县','原平市'],'临汾市':['尧都区','曲沃县','翼城县','襄汾县','洪洞县','古县','安泽县','浮山县','吉县','乡宁县','大宁县','隰县','永和县','蒲县','汾西县','侯马市','霍州市'],'吕梁市':['离石区','文水县','交城县','兴县','临县','柳林县','石楼县','岚县','方山县','中阳县','交口县','孝义市','汾阳市'],'呼和浩特市':['新城区','回民区','玉泉区','赛罕区','土默特左旗','托克托县','和林格尔县','清水河县','武川县'],'包头市':['东河区','昆都仑区','青山区','石拐区','白云矿区','九原区','土默特右旗','固阳县','达尔罕茂明安联合旗'],'乌海市':['海勃湾区','海南区','乌达区'],'赤峰市':['红山区','元宝山区','松山区','阿鲁科尔沁旗','巴林左旗','巴林右旗','林西县','克什克腾旗','翁牛特旗','喀喇沁旗','宁城县','敖汉旗'],'通辽市':['科尔沁区','科尔沁左翼中旗','科尔沁左翼后旗','开鲁县','库伦旗','奈曼旗','扎鲁特旗','霍林郭勒市'],'鄂尔多斯市':['东胜区','达拉特旗','准格尔旗','鄂托克前旗','鄂托克旗','杭锦旗','乌审旗','伊金霍洛旗'],'呼伦贝尔市':['海拉尔区','阿荣旗','莫力达瓦达斡尔族自治旗','鄂伦春自治旗','鄂温克族自治旗','陈巴尔虎旗','新巴尔虎左旗','新巴尔虎右旗','满洲里市','牙克石市','扎兰屯市','额尔古纳市','根河市'],'巴彦淖尔市':['临河区','五原县','磴口县','乌拉特前旗','乌拉特中旗','乌拉特后旗','杭锦后旗'],'乌兰察布市':['集宁区','卓资县','化德县','商都县','兴和县','凉城县','察哈尔右翼前旗','察哈尔右翼中旗','察哈尔右翼后旗','四子王旗','丰镇市'],'兴安盟':['乌兰浩特市','阿尔山市','科尔沁右翼前旗','科尔沁右翼中旗','扎赉特旗','突泉县'],'锡林郭勒盟':['二连浩特市','锡林浩特市','阿巴嘎旗','苏尼特左旗','苏尼特右旗','东乌珠穆沁旗','西乌珠穆沁旗','太仆寺旗','镶黄旗','正镶白旗','正蓝旗','多伦县'],'阿拉善盟':['阿拉善左旗','阿拉善右旗','额济纳旗'],'沈阳市':['和平区','沈河区','大东区','皇姑区','铁西区','苏家屯区','东陵区','沈北新区','于洪区','辽中县','康平县','法库县','新民市'],'大连市':['中山区','西岗区','沙河口区','甘井子区','旅顺口区','金州区','长海县','瓦房店市','普兰店市','庄河市'],'鞍山市':['铁东区','铁西区','立山区','千山区','台安县','岫岩满族自治县','海城市'],'抚顺市':['新抚区','东洲区','望花区','顺城区','抚顺县','新宾满族自治县','清原满族自治县'],'本溪市':['平山区','溪湖区','明山区','南芬区','本溪满族自治县','桓仁满族自治县'],'丹东市':['元宝区','振兴区','振安区','宽甸满族自治县','东港市','凤城市'],'锦州市':['古塔区','凌河区','太和区','黑山县','义县','凌海市','北镇市'],'营口市':['站前区','西市区','鲅鱼圈区','老边区','盖州市','大石桥市'],'阜新市':['海州区','新邱区','太平区','清河门区','细河区','阜新蒙古族自治县','彰武县'],'辽阳市':['白塔区','文圣区','宏伟区','弓长岭区','太子河区','辽阳县','灯塔市'],'盘锦市':['双台子区','兴隆台区','大洼县','盘山县'],'铁岭市':['银州区','清河区','铁岭县','西丰县','昌图县','调兵山市','开原市'],'朝阳市':['双塔区','龙城区','朝阳县','建平县','喀喇沁左翼蒙古族自治县','北票市','凌源市'],'葫芦岛市':['连山区','龙港区','南票区','绥中县','建昌县','兴城市'],'长春市':['南关区','宽城区','朝阳区','二道区','绿园区','双阳区','农安县','九台市','榆树市','德惠市'],'吉林市':['昌邑区','龙潭区','船营区','丰满区','永吉县','蛟河市','桦甸市','舒兰市','磐石市'],'四平市':['铁西区','铁东区','梨树县','伊通满族自治县','公主岭市','双辽市'],'辽源市':['龙山区','西安区','东丰县','东辽县'],'通化市':['东昌区','二道江区','通化县','辉南县','柳河县','梅河口市','集安市'],'白山市':['八道江区','江源区','抚松县','靖宇县','长白朝鲜族自治县','临江市'],'松原市':['宁江区','前郭尔罗斯蒙古族自治县','长岭县','乾安县','扶余县'],'白城市':['洮北区','镇赉县','通榆县','洮南市','大安市'],'延边朝鲜族自治州':['延吉市','图们市','敦化市','珲春市','龙井市','和龙市','汪清县','安图县'],'哈尔滨市':['道里区','南岗区','道外区','平房区','松北区','香坊区','呼兰区','阿城区','依兰县','方正县','宾县','巴彦县','木兰县','通河县','延寿县','双城市','尚志市','五常市'],'齐齐哈尔市':['龙沙区','建华区','铁锋区','昂昂溪区','富拉尔基区','碾子山区','梅里斯达斡尔族区','龙江县','依安县','泰来县','甘南县','富裕县','克山县','克东县','拜泉县','讷河市'],'鸡西市':['鸡冠区','恒山区','滴道区','梨树区','城子河区','麻山区','鸡东县','虎林市','密山市'],'鹤岗市':['向阳区','工农区','南山区','兴安区','东山区','兴山区','萝北县','绥滨县'],'双鸭山市':['尖山区','岭东区','四方台区','宝山区','集贤县','友谊县','宝清县','饶河县'],'大庆市':['萨尔图区','龙凤区','让胡路区','红岗区','大同区','肇州县','肇源县','林甸县','杜尔伯特蒙古族自治县'],'伊春市':['伊春区','南岔区','友好区','西林区','翠峦区','新青区','美溪区','金山屯区','五营区','乌马河区','汤旺河区','带岭区','乌伊岭区','红星区','上甘岭区','嘉荫县','铁力市'],'佳木斯市':['向阳区','前进区','东风区','郊区','桦南县','桦川县','汤原县','抚远县','同江市','富锦市'],'七台河市':['新兴区','桃山区','茄子河区','勃利县'],'牡丹江市':['东安区','阳明区','爱民区','西安区','东宁县','林口县','绥芬河市','海林市','宁安市','穆棱市'],'黑河市':['爱辉区','嫩江县','逊克县','孙吴县','北安市','五大连池市'],'绥化市':['北林区','望奎县','兰西县','青冈县','庆安县','明水县','绥棱县','安达市','肇东市','海伦市'],'大兴安岭地区':['加格达奇区','松岭区','新林区','呼中区','呼玛县','塔河县','漠河县'],'上海市':['黄浦区','卢湾区','徐汇区','长宁区','静安区','普陀区','闸北区','虹口区','杨浦区','闵行区','宝山区','嘉定区','浦东新区','金山区','松江区','青浦区','南汇区','奉贤区','崇明县'],'南京市':['玄武区','白下区','秦淮区','建邺区','鼓楼区','下关区','浦口区','栖霞区','雨花台区','江宁区','六合区','溧水县','高淳县'],'无锡市':['崇安区','南长区','北塘区','锡山区','惠山区','滨湖区','江阴市','宜兴市'],'徐州市':['鼓楼区','云龙区','九里区','贾汪区','泉山区','丰县','沛县','铜山县','睢宁县','新沂市','邳州市'],'常州市':['天宁区','钟楼区','戚墅堰区','新北区','武进区','溧阳市','金坛市'],'苏州市':['沧浪区','平江区','金阊区','虎丘区','吴中区','相城区','常熟市','张家港市','昆山市','吴江市','太仓市'],'南通市':['崇川区','港闸区','海安县','如东县','启东市','如皋市','通州市','海门市'],'连云港市':['连云区','新浦区','海州区','赣榆县','东海县','灌云县','灌南县'],'淮安市':['清河区','楚州区','淮阴区','清浦区','涟水县','洪泽县','盱眙县','金湖县'],'盐城市':['亭湖区','盐都区','响水县','滨海县','阜宁县','射阳县','建湖县','东台市','大丰市'],'扬州市':['广陵区','邗江区','维扬区','宝应县','仪征市','高邮市','江都市'],'镇江市':['京口区','润州区','丹徒区','丹阳市','扬中市','句容市'],'泰州市':['海陵区','高港区','兴化市','靖江市','泰兴市','姜堰市'],'宿迁市':['宿城区','宿豫区','沭阳县','泗阳县','泗洪县'],'杭州市':['上城区','下城区','江干区','拱墅区','西湖区','滨江区','萧山区','余杭区','桐庐县','淳安县','建德市','富阳市','临安市'],'宁波市':['海曙区','江东区','江北区','北仑区','镇海区','鄞州区','象山县','宁海县','余姚市','慈溪市','奉化市'],'温州市':['鹿城区','龙湾区','瓯海区','洞头县','永嘉县','平阳县','苍南县','文成县','泰顺县','瑞安市','乐清市'],'嘉兴市':['秀城区','秀洲区','嘉善县','海盐县','海宁市','平湖市','桐乡市'],'湖州市':['吴兴区','南浔区','德清县','长兴县','安吉县'],'绍兴市':['越城区','绍兴县','新昌县','诸暨市','上虞市','嵊州市'],'金华市':['婺城区','金东区','武义县','浦江县','磐安县','兰溪市','义乌市','东阳市','永康市'],'衢州市':['柯城区','衢江区','常山县','开化县','龙游县','江山市'],'舟山市':['定海区','普陀区','岱山县','嵊泗县'],'台州市':['椒江区','黄岩区','路桥区','玉环县','三门县','天台县','仙居县','温岭市','临海市'],'丽水市':['莲都区','青田县','缙云县','遂昌县','松阳县','云和县','庆元县','景宁畲族自治县','龙泉市'],'合肥市':['瑶海区','庐阳区','蜀山区','包河区','长丰县','肥东县','肥西县'],'芜湖市':['镜湖区','弋江区','鸠江区','三山区','芜湖县','繁昌县','南陵县'],'蚌埠市':['龙子湖区','蚌山区','禹会区','淮上区','怀远县','五河县','固镇县'],'淮南市':['大通区','田家庵区','谢家集区','八公山区','潘集区','凤台县'],'马鞍山市':['金家庄区','花山区','雨山区','当涂县'],'淮北市':['杜集区','相山区','烈山区','濉溪县'],'铜陵市':['铜官山区','狮子山区','郊区','铜陵县'],'安庆市':['迎江区','大观区','宜秀区','怀宁县','枞阳县','潜山县','太湖县','宿松县','望江县','岳西县','桐城市'],'黄山市':['屯溪区','黄山区','徽州区','歙县','休宁县','黟县','祁门县'],'滁州市':['琅琊区','南谯区','来安县','全椒县','定远县','凤阳县','天长市','明光市'],'阜阳市':['颍州区','颍东区','颍泉区','临泉县','太和县','阜南县','颍上县','颍上县'],'宿州市':['埇桥区','砀山县','萧县','灵璧县','泗县'],'巢湖市':['居巢区','庐江县','无为县','含山县','和县'],'六安市':['金安区','裕安区','寿县','霍邱县','舒城县','金寨县','霍山县'],'亳州市':['谯城区','涡阳县','蒙城县','利辛县'],'池州市':['贵池区','东至县','石台县','青阳县'],'宣城市':['宣州区','郎溪县','广德县','泾县','绩溪县','旌德县','宁国市'],'福州市':['鼓楼区','台江区','仓山区','马尾区','晋安区','闽侯县','连江县','罗源县','闽清县','永泰县','平潭县','福清市','长乐市'],'厦门市':['思明区','海沧区','湖里区','集美区','同安区','翔安区'],'莆田市':['城厢区','涵江区','荔城区','秀屿区','仙游县'],'三明市':['梅列区','三元区','明溪县','清流县','宁化县','大田县','尤溪县','沙县','将乐县','泰宁县','建宁县','永安市'],'泉州市':['鲤城区','丰泽区','洛江区','泉港区','惠安县','安溪县','永春县','德化县','金门县','石狮市','晋江市','南安市'],'漳州市':['芗城区','龙文区','云霄县','漳浦县','诏安县','长泰县','东山县','南靖县','平和县','华安县','龙海市'],'南平市':['延平区','顺昌县','浦城县','光泽县','松溪县','政和县','邵武市','武夷山市','建瓯市','建阳市'],'龙岩市':['新罗区','长汀县','永定县','上杭县','武平县','连城县','漳平市'],'宁德市':['蕉城区','霞浦县','古田县','屏南县','寿宁县','周宁县','柘荣县','福安市','福鼎市'],'南昌市':['东湖区','西湖区','青云谱区','湾里区','青山湖区','南昌县','新建县','安义县','进贤县'],'景德镇市':['昌江区','珠山区','浮梁县','乐平市'],'萍乡市':['安源区','湘东区','莲花县','上栗县','芦溪县'],'九江市':['庐山区','浔阳区','九江县','武宁县','修水县','永修县','德安县','星子县','都昌县','湖口县','彭泽县','瑞昌市'],'新余市':['渝水区','分宜县'],'鹰潭市':['月湖区','余江县','贵溪市'],'赣州市':['章贡区','赣县','信丰县','大余县','上犹县','崇义县','安远县','龙南县','定南县','全南县','宁都县','于都县','兴国县','会昌县','寻乌县','石城县','瑞金市','南康市'],'吉安市':['吉州区','青原区','吉安县','吉水县','峡江县','新干县','永丰县','泰和县','遂川县','万安县','安福县','永新县','井冈山市'],'宜春市':['袁州区','奉新县','万载县','上高县','宜丰县','靖安县','铜鼓县','丰城市','樟树市','高安市'],'抚州市':['临川区','南城县','黎川县','南丰县','崇仁县','乐安县','宜黄县','金溪县','资溪县','东乡县','广昌县'],'上饶市':['信州区','上饶县','广丰县','玉山县','铅山县','横峰县','弋阳县','余干县','鄱阳县','万年县','婺源县','德兴市'],'济南市':['历下区','市中区','槐荫区','天桥区','历城区','长清区','平阴县','济阳县','商河县','章丘市'],'青岛市':['市南区','市北区','四方区','黄岛区','崂山区','李沧区','城阳区','胶州市','即墨市','平度市','胶南市','莱西市'],'淄博市':['淄川区','张店区','博山区','临淄区','周村区','桓台县','高青县','沂源县'],'枣庄市':['市中区','薛城区','峄城区','台儿庄区','山亭区','滕州市'],'东营市':['东营区','河口区','垦利县','利津县','广饶县'],'烟台市':['芝罘区','福山区','牟平区','莱山区','长岛县','龙口市','莱阳市','莱州市','蓬莱市','招远市','栖霞市','海阳市'],'潍坊市':['潍城区','寒亭区','坊子区','奎文区','临朐县','昌乐县','青州市','诸城市','寿光市','安丘市','高密市','昌邑市'],'济宁市':['市中区','任城区','微山县','鱼台县','金乡县','嘉祥县','汶上县','泗水县','梁山县','曲阜市','兖州市','邹城市'],'泰安市':['泰山区','岱岳区','宁阳县','东平县','新泰市','肥城市'],'威海市':['环翠区','文登市','荣成市','乳山市'],'日照市':['东港区','岚山区','五莲县','莒县'],'莱芜市':['莱城区','钢城区'],'临沂市':['兰山区','罗庄区','河东区','沂南县','郯城县','沂水县','苍山县','费县','平邑县','莒南县','蒙阴县','临沭县'],'德州市':['德城区','陵县','宁津县','庆云县','临邑县','齐河县','平原县','夏津县','武城县','乐陵市','禹城市'],'聊城市':['东昌府区','阳谷县','莘县','茌平县','东阿县','冠县','高唐县','临清市'],'滨州市':['滨城区','惠民县','阳信县','无棣县','沾化县','博兴县','邹平县'],'菏泽市':['牡丹区','曹县','单县','成武县','巨野县','郓城县','鄄城县','定陶县','东明县'],'郑州市':['中原区','二七区','管城回族区','金水区','上街区','惠济区','中牟县','巩义市','荥阳市','新密市','新郑市','登封市'],'开封市':['龙亭区','顺河回族区','鼓楼区','禹王台区','金明区','杞县','通许县','尉氏县','开封县','兰考县'],'洛阳市':['老城区','西工区','廛河回族区','涧西区','吉利区','洛龙区','孟津县','新安县','栾川县','嵩县','汝阳县','宜阳县','洛宁县','伊川县','偃师市'],'平顶山市':['新华区','卫东区','石龙区','湛河区','宝丰县','叶县','鲁山县','郏县','舞钢市','汝州市'],'安阳市':['文峰区','北关区','殷都区','龙安区','安阳县','汤阴县','滑县','内黄县','林州市'],'鹤壁市':['鹤山区','山城区','淇滨区','浚县','淇县'],'新乡市':['红旗区','卫滨区','凤泉区','牧野区','新乡县','获嘉县','原阳县','延津县','封丘县','长垣县','卫辉市','辉县市'],'焦作市':['解放区','中站区','马村区','山阳区','修武县','博爱县','武陟县','温县','济源市','沁阳市','孟州市'],'濮阳市':['华龙区','清丰县','南乐县','范县','台前县','濮阳县'],'许昌市':['魏都区','许昌县','鄢陵县','襄城县','禹州市','长葛市'],'漯河市':['源汇区','郾城区','召陵区','舞阳县','临颍县'],'三门峡市':['湖滨区','渑池县','陕县','卢氏县','义马市','灵宝市'],'南阳市':['宛城区','卧龙区','南召县','方城县','西峡县','镇平县','内乡县','淅川县','社旗县','唐河县','新野县','桐柏县','邓州市'],'商丘市':['梁园区','睢阳区','民权县','睢县','宁陵县','柘城县','虞城县','夏邑县','永城市'],'信阳市':['浉河区','平桥区','罗山县','光山县','新县','商城县','固始县','潢川县','淮滨县','息县'],'周口市':['川汇区','扶沟县','西华县','商水县','沈丘县','郸城县','淮阳县','太康县','鹿邑县','项城市'],'驻马店市':['驿城区','西平县','上蔡县','平舆县','正阳县','确山县','泌阳县','汝南县','遂平县','新蔡县'],'武汉市':['江岸区','江汉区','硚口区','汉阳区','武昌区','青山区','洪山区','东西湖区','汉南区','蔡甸区','江夏区','黄陂区','新洲区'],'黄石市':['黄石港区','西塞山区','下陆区','铁山区','阳新县','大冶市'],'十堰市':['茅箭区','张湾区','郧县','郧西县','竹山县','竹溪县','房县','丹江口市'],'宜昌市':['西陵区','伍家岗区','点军区','猇亭区','夷陵区','远安县','兴山县','秭归县','长阳土家族自治县','五峰土家族自治县','宜都市','当阳市','枝江市'],'襄樊市':['襄城区','樊城区','襄阳区','南漳县','谷城县','保康县','老河口市','枣阳市','宜城市'],'鄂州市':['梁子湖区','华容区','鄂城区'],'荆门市':['东宝区','掇刀区','京山县','沙洋县','钟祥市'],'孝感市':['孝南区','孝昌县','大悟县','云梦县','应城市','安陆市','汉川市'],'荆州市':['沙市区','荆州区','公安县','监利县','江陵县','石首市','洪湖市','松滋市'],'黄冈市':['黄州区','团风县','红安县','罗田县','英山县','浠水县','蕲春县','黄梅县','麻城市','武穴市'],'咸宁市':['咸安区','嘉鱼县','通城县','崇阳县','通山县','赤壁市'],'随州市':['曾都区','广水市'],'恩施土家族苗族自治州':['恩施市','利川市','建始县','巴东县','宣恩县','咸丰县','来凤县','鹤峰县'],'直辖行政单位':['仙桃市','潜江市','天门市','神农架林区'],'长沙市':['芙蓉区','天心区','岳麓区','开福区','雨花区','长沙县','望城县','宁乡县','浏阳市'],'株洲市':['荷塘区','芦淞区','石峰区','天元区','株洲县','攸县','茶陵县','炎陵县','醴陵市'],'湘潭市':['雨湖区','岳塘区','湘潭县','湘乡市','韶山市'],'衡阳市':['珠晖区','雁峰区','石鼓区','蒸湘区','南岳区','衡阳县','衡南县','衡山县','衡东县','祁东县','耒阳市','常宁市'],'邵阳市':['双清区','大祥区','北塔区','邵东县','新邵县','邵阳县','隆回县','洞口县','绥宁县','新宁县','城步苗族自治县','武冈市'],'岳阳市':['岳阳楼区','云溪区','君山区','岳阳县','华容县','湘阴县','平江县','汨罗市','临湘市'],'常德市':['武陵区','鼎城区','安乡县','汉寿县','澧县','临澧县','桃源县','石门县','津市市'],'张家界市':['永定区','武陵源区','慈利县','桑植县'],'益阳市':['资阳区','赫山区','南县','桃江县','安化县','沅江市'],'郴州市':['北湖区','苏仙区','桂阳县','宜章县','永兴县','嘉禾县','临武县','汝城县','桂东县','安仁县','资兴市'],'永州市':['零陵区','冷水滩区','祁阳县','东安县','双牌县','道县','江永县','宁远县','蓝山县','新田县','江华瑶族自治县'],'怀化市':['鹤城区','中方县','沅陵县','辰溪县','溆浦县','会同县','麻阳苗族自治县','新晃侗族自治县','芷江侗族自治县','靖州苗族侗族自治县','通道侗族自治县','洪江市'],'娄底市':['娄星区','双峰县','新化县','冷水江市','涟源市'],'湘西土家族苗族自治州':['吉首市','泸溪县','凤凰县','花垣县','保靖县','古丈县','永顺县','龙山县'],'广州市':['荔湾区','越秀区','海珠区','天河区','白云区','黄埔区','番禺区','花都区','南沙区','萝岗区','增城市','从化市'],'韶关市':['武江区','浈江区','曲江区','始兴县','仁化县','翁源县','乳源瑶族自治县','新丰县','乐昌市','南雄市'],'深圳市':['罗湖区','福田区','南山区','宝安区','龙岗区','盐田区'],'珠海市':['香洲区','斗门区','金湾区'],'汕头市':['龙湖区','金平区','濠江区','潮阳区','潮南区','澄海区','南澳县'],'佛山市':['禅城区','南海区','顺德区','三水区','高明区'],'江门市':['蓬江区','江海区','新会区','台山市','开平市','鹤山市','恩平市'],'湛江市':['赤坎区','霞山区','坡头区','麻章区','遂溪县','徐闻县','廉江市','雷州市','吴川市'],'茂名市':['茂南区','茂港区','电白县','高州市','化州市','信宜市'],'肇庆市':['端州区','鼎湖区','广宁县','怀集县','封开县','德庆县','高要市','四会市'],'惠州市':['惠城区','惠阳区','博罗县','惠东县','龙门县'],'梅州市':['梅江区','梅县','大埔县','丰顺县','五华县','平远县','蕉岭县','兴宁市'],'汕尾市':['城区','海丰县','陆河县','陆丰市'],'河源市':['源城区','紫金县','龙川县','连平县','和平县','东源县'],'阳江市':['江城区','阳西县','阳东县','阳春市'],'清远市':['清城区','佛冈县','阳山县','连山壮族瑶族自治县','连南瑶族自治县','清新县','英德市','连州市'],'东莞市':['市辖区'],'中山市':['市辖区'],'潮州市':['湘桥区','潮安县','饶平县'],'揭阳市':['榕城区','揭东县','揭西县','惠来县','普宁市'],'云浮市':['云城区','新兴县','郁南县','云安县','罗定市'],'南宁市':['兴宁区','青秀区','江南区','西乡塘区','良庆区','邕宁区','武鸣县','隆安县','马山县','上林县','宾阳县','横县'],'柳州市':['城中区','鱼峰区','柳南区','柳北区','柳江县','柳城县','鹿寨县','融安县','融水苗族自治县','三江侗族自治县'],'桂林市':['秀峰区','叠彩区','象山区','七星区','雁山区','阳朔县','临桂县','灵川县','全州县','兴安县','永福县','灌阳县','龙胜各族自治县','资源县','平乐县','荔蒲县','恭城瑶族自治县'],'梧州市':['万秀区','蝶山区','长洲区','苍梧县','藤县','蒙山县','岑溪市'],'北海市':['海城区','银海区','铁山港区','合浦县'],'防城港市':['港口区','防城区','上思县','东兴市'],'钦州市':['钦南区','钦北区','灵山县','浦北县'],'贵港市':['港北区','港南区','覃塘区','平南县','桂平市'],'玉林市':['玉州区','容县','陆川县','博白县','兴业县','北流市'],'百色市':['右江区','田阳县','田东县','平果县','德保县','靖西县','那坡县','凌云县','乐业县','田林县','西林县','隆林各族自治县'],'贺州市':['八步区','昭平县','钟山县','富川瑶族自治县'],'河池市':['金城江区','南丹县','天峨县','凤山县','东兰县','罗城仫佬族自治县','环江毛南族自治县','巴马瑶族自治县','都安瑶族自治县','大化瑶族自治县','宜州市'],'来宾市':['兴宾区','忻城县','象州县','武宣县','金秀瑶族自治县','合山市'],'崇左市':['江洲区','扶绥县','宁明县','龙州县','大新县','天等县','凭祥市'],'海口市':['秀英区','龙华区','琼山区','美兰区'],'三亚市':['直辖县级行政单位','五指山市','琼海市','儋州市','文昌市','万宁市','东方市','定安县','屯昌县','澄迈县','临高县','白沙黎族自治县','昌江黎族自治县','乐东黎族自治县','陵水黎族自治县','保亭黎族苗族自治县','琼中黎族苗族自治县','西沙群岛','南沙群岛','中沙群岛的岛礁及其海域'],'市辖区':['万州区','涪陵区','渝中区','大渡口区','江北区','沙坪坝区','九龙坡区','南岸区','北碚区','万盛区','双桥区','渝北区','巴南区','黔江区','长寿区','江津区','合川区','永川区','永川区'],'县':['綦江县','潼南县','铜梁县','大足县','荣昌县','璧山县','梁平县','城口县','丰都县','垫江县','武隆县','忠县','开县','云阳县','奉节县','巫山县','巫溪县','石柱土家族自治县','秀山土家族苗族自治县','酉阳土家族苗族自治县','彭水苗族土家族自治县'],'成都市':['锦江区','青羊区','金牛区','武侯区','成华区','龙泉驿区','青白江区','新都区','温江区','金堂县','双流县','郫县','大邑县','蒲江县','新津县','都江堰市','彭州市','邛崃市','崇州市'],'自贡市':['自流井区','贡井区','大安区','沿滩区','荣县','富顺县'],'攀枝花市':['东区','西区','仁和区','米易县','盐边县'],'泸州市':['江阳区','纳溪区','龙马潭区','泸县','合江县','叙永县','古蔺县'],'德阳市':['旌阳区','中江县','罗江县','广汉市','什邡市','绵竹市'],'绵阳市':['涪城区','游仙区','三台县','盐亭县','安县','梓潼县','北川羌族自治县','平武县','江油市'],'广元市':['市中区','元坝区','朝天区','旺苍县','青川县','剑阁县','苍溪县'],'遂宁市':['船山区','安居区','蓬溪县','射洪县','大英县'],'内江市':['市中区','东兴区','威远县','资中县','隆昌县'],'乐山市':['市中区','沙湾区','五通桥区','金口河区','犍为县','井研县','夹江县','沐川县','峨边彝族自治县','马边彝族自治县','峨眉山市'],'南充市':['顺庆区','高坪区','嘉陵区','南部县','营山县','蓬安县','仪陇县','西充县','阆中市'],'眉山市':['东坡区','仁寿县','彭山县','洪雅县','丹棱县','青神县'],'宜宾市':['翠屏区','宜宾县','南溪县','江安县','长宁县','高县','珙县','筠连县','兴文县','屏山县'],'广安市':['广安区','岳池县','武胜县','邻水县','华蓥市'],'达州市':['通川区','达县','宣汉县','开江县','大竹县','渠县','万源市'],'雅安市':['雨城区','名山县','荥经县','汉源县','石棉县','天全县','芦山县','宝兴县'],'巴中市':['巴州区','通江县','南江县','平昌县'],'资阳市':['雁江区','安岳县','乐至县','简阳市'],'阿坝藏族羌族自治州':['汶川县','理县','茂县','松潘县','九寨沟县','金川县','小金县','黑水县','马尔康县','壤塘县','阿坝县','若尔盖县','红原县'],'甘孜藏族自治州':['康定县','泸定县','丹巴县','九龙县','雅江县','道孚县','炉霍县','甘孜县','新龙县','德格县','白玉县','石渠县','色达县','理塘县','巴塘县','乡城县','稻城县','得荣县'],'凉山彝族自治州':['西昌市','木里藏族自治县','盐源县','德昌县','会理县','会东县','宁南县','普格县','布拖县','金阳县','昭觉县','喜德县','冕宁县','越西县','甘洛县','美姑县','雷波县'],'贵阳市':['南明区','云岩区','花溪区','乌当区','白云区','小河区','开阳县','息烽县','修文县','清镇市'],'六盘水市':['钟山区','六枝特区','水城县','盘县'],'遵义市':['红花岗区','汇川区','遵义县','桐梓县','绥阳县','正安县','道真仡佬族苗族自治县','务川仡佬族苗族自治县','凤冈县','湄潭县','余庆县','习水县','赤水市','仁怀市'],'安顺市':['西秀区','平坝县','普定县','镇宁布依族苗族自治县','关岭布依族苗族自治县','紫云苗族布依族自治县'],'铜仁地区':['铜仁市','江口县','玉屏侗族自治县','石阡县','思南县','印江土家族苗族自治县','德江县','沿河土家族自治县','松桃苗族自治县','万山特区'],'黔西南布依族苗族自治州':['兴义市','兴仁县','普安县','晴隆县','贞丰县','望谟县','册亨县','安龙县'],'毕节地区':['毕节市','大方县','黔西县','金沙县','织金县','纳雍县','威宁彝族回族苗族自治县','赫章县'],'黔东南苗族侗族自治州':['凯里市','黄平县','施秉县','三穗县','镇远县','岑巩县','天柱县','锦屏县','剑河县','台江县','黎平县','榕江县','从江县','雷山县','麻江县','丹寨县'],'黔南布依族苗族自治州':['都匀市','福泉市','荔波县','贵定县','瓮安县','独山县','平塘县','罗甸县','长顺县','龙里县','惠水县','三都水族自治县'],'昆明市':['五华区','盘龙区','官渡区','西山区','东川区','呈贡县','晋宁县','富民县','宜良县','石林彝族自治县','嵩明县','禄劝彝族苗族自治县','寻甸回族彝族自治县','安宁市'],'曲靖市':['麒麟区','马龙县','陆良县','师宗县','罗平县','富源县','会泽县','沾益县','宣威市'],'玉溪市':['红塔区','江川县','澄江县','通海县','华宁县','易门县','峨山彝族自治县','新平彝族傣族自治县','元江哈尼族彝族傣族自治县'],'保山市':['隆阳区','施甸县','腾冲县','龙陵县','昌宁县'],'昭通市':['昭阳区','鲁甸县','巧家县','盐津县','大关县','永善县','绥江县','镇雄县','彝良县','威信县','水富县'],'丽江市':['古城区','玉龙纳西族自治县','永胜县','华坪县','宁蒗彝族自治县'],'思茅市':['翠云区','普洱哈尼族彝族自治县','墨江哈尼族自治县','景东彝族自治县','景谷傣族彝族自治县','镇沅彝族哈尼族拉祜族自治县','江城哈尼族彝族自治县','孟连傣族拉祜族佤族自治县','澜沧拉祜族自治县','西盟佤族自治县'],'临沧市':['临翔区','凤庆县','云县','永德县','镇康县','双江拉祜族佤族布朗族傣族自治县','耿马傣族佤族自治县','沧源佤族自治县'],'楚雄彝族自治州':['楚雄市','双柏县','牟定县','南华县','姚安县','大姚县','永仁县','元谋县','武定县','禄丰县'],'红河哈尼族彝族自治州':['个旧市','开远市','蒙自县','屏边苗族自治县','建水县','石屏县','弥勒县','泸西县','元阳县','红河县','金平苗族瑶族傣族自治县','绿春县','河口瑶族自治县'],'文山壮族苗族自治州':['文山县','砚山县','西畴县','麻栗坡县','马关县','丘北县','广南县','富宁县'],'西双版纳傣族自治州':['景洪市','勐海县','勐腊县'],'大理白族自治州':['大理市','漾濞彝族自治县','祥云县','宾川县','弥渡县','南涧彝族自治县','巍山彝族回族自治县','永平县','云龙县','洱源县','剑川县','鹤庆县'],'德宏傣族景颇族自治州':['瑞丽市','潞西市','梁河县','盈江县','陇川县'],'怒江傈僳族自治州':['泸水县','福贡县','贡山独龙族怒族自治县','兰坪白族普米族自治县'],'迪庆藏族自治州':['香格里拉县','德钦县','维西傈僳族自治县'],'拉萨市':['城关区','林周县','当雄县','尼木县','曲水县','堆龙德庆县','达孜县','墨竹工卡县'],'昌都地区':['昌都县','江达县','贡觉县','类乌齐县','丁青县','察雅县','八宿县','左贡县','芒康县','洛隆县','边坝县'],'山南地区':['乃东县','扎囊县','贡嘎县','桑日县','琼结县','曲松县','措美县','洛扎县','加查县','隆子县','错那县','浪卡子县'],'日喀则地区':['日喀则市','南木林县','江孜县','定日县','萨迦县','拉孜县','昂仁县','谢通门县','白朗县','仁布县','康马县','定结县','仲巴县','亚东县','吉隆县','聂拉木县','萨嘎县','岗巴县'],'那曲地区':['那曲县','嘉黎县','比如县','聂荣县','安多县','申扎县','索县','班戈县','巴青县','尼玛县'],'阿里地区':['普兰县','札达县','噶尔县','日土县','革吉县','改则县','措勤县'],'林芝地区':['林芝县','工布江达县','米林县','墨脱县','波密县','察隅县','朗县'],'西安市':['新城区','碑林区','莲湖区','灞桥区','未央区','雁塔区','阎良区','临潼区','长安区','蓝田县','周至县','户县','高陵县'],'铜川市':['王益区','印台区','耀州区','宜君县'],'宝鸡市':['渭滨区','金台区','陈仓区','凤翔县','岐山县','扶风县','眉县','陇县','千阳县','麟游县','凤县','太白县'],'咸阳市':['秦都区','杨凌区','渭城区','三原县','泾阳县','乾县','礼泉县','永寿县','彬县','长武县','旬邑县','淳化县','武功县','兴平市'],'渭南市':['临渭区','华县','潼关县','大荔县','合阳县','澄城县','蒲城县','白水县','富平县','韩城市','华阴市'],'延安市':['宝塔区','延长县','延川县','子长县','安塞县','志丹县','吴起县','甘泉县','富县','洛川县','宜川县','黄龙县','黄陵县'],'汉中市':['汉台区','南郑县','城固县','洋县','西乡县','勉县','宁强县','略阳县','镇巴县','留坝县','佛坪县'],'榆林市':['榆阳区','神木县','府谷县','横山县','靖边县','定边县','绥德县','米脂县','佳县','吴堡县','清涧县','子洲县'],'安康市':['汉滨区','汉阴县','石泉县','宁陕县','紫阳县','岚皋县','平利县','镇坪县','旬阳县','白河县'],'商洛市':['商州区','洛南县','丹凤县','商南县','山阳县','镇安县','柞水县'],'兰州市':['城关区','七里河区','西固区','安宁区','红古区','永登县','皋兰县','榆中县'],'嘉峪关市':[''],'金昌市':['金川区','永昌县'],'白银市':['白银区','平川区','靖远县','会宁县','景泰县'],'天水市':['秦城区','北道区','清水县','秦安县','甘谷县','武山县','张家川回族自治县'],'武威市':['凉州区','民勤县','古浪县','天祝藏族自治县'],'张掖市':['甘州区','肃南裕固族自治县','民乐县','临泽县','高台县','山丹县'],'平凉市':['崆峒区','泾川县','灵台县','崇信县','华亭县','庄浪县','静宁县'],'酒泉市':['肃州区','金塔县','瓜州县','肃北蒙古族自治县','阿克塞哈萨克族自治县','玉门市','敦煌市'],'庆阳市':['西峰区','庆城县','环县','华池县','合水县','正宁县','宁县','镇原县'],'定西市':['安定区','通渭县','陇西县','渭源县','临洮县','漳县','岷县'],'陇南市':['武都区','成县','文县','宕昌县','康县','西和县','礼县','徽县','两当县'],'临夏回族自治州':['临夏市','临夏县','康乐县','永靖县','广河县','和政县','东乡族自治县','积石山保安族东乡族撒拉族自治县'],'甘南藏族自治州':['合作市','临潭县','卓尼县','舟曲县','迭部县','玛曲县','碌曲县','夏河县'],'西宁市':['城东区','城中区','城西区','城北区','大通回族土族自治县','湟中县','湟源县'],'海东地区':['平安县','民和回族土族自治县','乐都县','互助土族自治县','化隆回族自治县','循化撒拉族自治县'],'海北藏族自治州':['门源回族自治县','祁连县','海晏县','刚察县'],'黄南藏族自治州':['同仁县','尖扎县','泽库县','河南蒙古族自治县'],'海南藏族自治州':['共和县','同德县','贵德县','兴海县','贵南县'],'果洛藏族自治州':['玛沁县','班玛县','甘德县','达日县','久治县','玛多县'],'玉树藏族自治州':['玉树县','杂多县','称多县','治多县','囊谦县','曲麻莱县'],'海西蒙古族藏族自治州':['格尔木市','德令哈市','乌兰县','都兰县','天峻县'],'银川市':['兴庆区','西夏区','金凤区','永宁县','贺兰县','灵武市'],'石嘴山市':['大武口区','惠农区','平罗县'],'吴忠市':['利通区','盐池县','同心县','青铜峡市'],'固原市':['原州区','西吉县','隆德县','泾源县','彭阳县'],'中卫市':['沙坡头区','中宁县','海原县'],'乌鲁木齐市':['天山区','沙依巴克区','新市区','水磨沟区','头屯河区','达坂城区','东山区','乌鲁木齐县'],'克拉玛依市':['独山子区','克拉玛依区','白碱滩区','乌尔禾区'],'吐鲁番地区':['吐鲁番市','鄯善县','托克逊县'],'哈密地区':['哈密市','巴里坤哈萨克自治县','伊吾县'],'昌吉回族自治州':['昌吉市','阜康市','米泉市','呼图壁县','玛纳斯县','奇台县','吉木萨尔县','木垒哈萨克自治县'],'博尔塔拉蒙古自治州':['博乐市','精河县','温泉县'],'巴音郭楞蒙古自治州':['库尔勒市','轮台县','尉犁县','若羌县','且末县','焉耆回族自治县','和静县','和硕县','博湖县'],'阿克苏地区':['阿克苏市','温宿县','库车县','沙雅县','新和县','拜城县','乌什县','阿瓦提县','柯坪县'],'克孜勒苏柯尔克孜自治州':['阿图什市','阿克陶县','阿合奇县','乌恰县'],'喀什地区':['喀什市','疏附县','疏勒县','英吉沙县','泽普县','莎车县','叶城县','麦盖提县','岳普湖县','伽师县','巴楚县','塔什库尔干塔吉克自治县'],'和田地区':['和田市','和田县','墨玉县','皮山县','洛浦县','策勒县','于田县','民丰县'],'伊犁哈萨克':['伊宁市','奎屯市','伊宁县','察布查尔锡伯自治县','霍城县','巩留县','新源县','昭苏县','特克斯县','尼勒克县'],'塔城地区':['塔城市','乌苏市','额敏县','沙湾县','托里县','裕民县','和布克赛尔蒙古自治县'],'阿勒泰地区':['阿勒泰市','布尔津县','富蕴县','福海县','哈巴河县','青河县','吉木乃县'],'石河子市':[''],'阿拉尔市':[''],'图木舒克市':[''],'五家渠市':['']};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChinaAreaData_data2__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * create by lzsheng
 * 2017-08-017
 */var ChinaAreaSelector=function(_Component){_inherits(ChinaAreaSelector,_Component);function ChinaAreaSelector(props){_classCallCheck(this,ChinaAreaSelector);var _this=_possibleConstructorReturn(this,(ChinaAreaSelector.__proto__||Object.getPrototypeOf(ChinaAreaSelector)).call(this,props));_this.initSelector=function(value){// console.log("initSelector", value)
var pId=value[0];var cId=value[1];var aId=value[2];var pData=void 0,cData=void 0,aData=void 0;if(isNaN(value[0])){pData=_this.DATA.filter(function(el,i){return el.name===pId;})[0];cData=pData.child.filter(function(el,i){return el.name===cId;})[0];if(aId){aData=cData.child.filter(function(el,i){return el.name===aId;})[0];}}else{pData=_this.DATA.filter(function(el,i){return el.id===pId;})[0];cData=pData.child.filter(function(el,i){return el.id===cId;})[0];if(aId){aData=cData.child.filter(function(el,i){return el.id===aId;})[0];}}// if (typeof aData === 'undefined') {
//   aData = cData.child[0]
// }
_this.toSetState('province',pData);_this.toSetState('city',cData);_this.toSetState('area',aData);};_this.toSetState=function(dataName,_obj){// console.log('toSetState', dataName, _obj)
_this[dataName]=_obj;_this.forceUpdate();//更新视图
_this.outputValue();};_this.outputValue=function(){clearTimeout(_this.outputValueTimer);_this.outputValueTimer=setTimeout(function(){var province=_this.province,city=_this.city,area=_this.area;var _outputValue={ids:[province.id,city.id,area&&area.id||''],names:[province.name,city.name,area&&area.name||'']};_this.props.onChange(_outputValue);},100);};_this.handleChangeProvince=function(id){// console.log('-----handleChangeProvince-----')
// console.log('handleChangeProvince', id)
var _value=_this.DATA.filter(function(el,i){return el.id===id;})[0];console.log('handleChangeProvince',_value);_this.toSetState('province',_value);_this.handleChangeCity(-1);_this.handleChangeArea(-1);};_this.handleChangeCity=function(id){// console.log('-----handleChangeCity-----')
// console.log('handleChangeCity', id)
var province=_this.province;var _value=province.child.filter(function(el,i){return el.id===id;})[0];if(typeof _value==='undefined'){_value=province.child[0];}console.log('handleChangeCity',_value);_this.toSetState('city',_value);_this.handleChangeArea(-1);};_this.handleChangeArea=function(id){// console.log('-----handleChangeArea-----')
// console.log('handleChangeArea', id)
var city=_this.city;if(typeof city.child==='undefined'){_this.toSetState('area',{});return;}var _value=city.child.filter(function(el,i){return el.id===id;})[0];if(typeof _value==='undefined'){_value=city.child[0];}// console.log('handleChangeArea', _value)
_this.toSetState('area',_value);};_this.state={};_this.defaultValue=_this.props.defaultValue&&_this.props.defaultValue.length>0?_this.props.defaultValue:["110000","110101",""];//默认数据
//原始数据
_this.DATA=__WEBPACK_IMPORTED_MODULE_2__ChinaAreaData_data2__["a" /* data */];//选中的省数据
_this.province={};//选中的市数据
_this.city={};//选中的区数据
_this.area={};//计时器
_this.outputValueTimer=null;return _this;}_createClass(ChinaAreaSelector,[{key:'componentDidMount',value:function componentDidMount(){this.initSelector(this.defaultValue);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;//默认值动态改变时（hack 父组件的初始化数据为异步数据时)
if(nextProps.defaultValue&&nextProps.defaultValue.length>0){if(nextProps.defaultValue.length!==this.defaultValue.length){this.initSelector(nextProps.defaultValue);}else{var isDifferent=false;nextProps.defaultValue.forEach(function(el,i){if(el!==_this2.defaultValue[i]){isDifferent=true;}});if(isDifferent){this.defaultValue=nextProps.defaultValue;this.initSelector(nextProps.defaultValue);}}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.outputValueTimer);}},{key:'render',value:function render(){var _this3=this;var province=this.province,city=this.city,area=this.area;if(!province.id){return null;}else{// console.log("------render------")
// console.log("province", province, "city", city, "area", area)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_picker_pc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'province',onChange:function onChange(e){_this3.handleChangeProvince(e.target.value);},value:province.id},this.DATA.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:el.id,key:el.id},el.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'city',onChange:function onChange(e){_this3.handleChangeCity(e.target.value);},value:city.id},province.child.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:el.id,key:el.id},el.name);})),city.child&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'child',onChange:function onChange(e){_this3.handleChangeArea(e.target.value);},value:area.id},city.child.map(function(el,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:el.id,key:el.id},el.name);})));}}}]);return ChinaAreaSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ChinaAreaSelector.propTypes={defaultValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ChinaAreaSelector);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return data; });
//2017-05-25 by lzsheng
//数据来源于腾讯http://lbs.qq.com/webservice_v1/guide-region.html
//数据来源的请求http://apis.map.qq.com/ws/district/v1/list?key=3LBBZ-AVSRF-XHQJO-JIOHV-GNOU6-TJFKL
// let data = qqData.result//请求回来的数据
// let provinceData = data[0]//省
// let cityData = data[1]//市
// let countyData = data[2]//区
// data.forEach(function(element) {
//     element.forEach(function(_element) {
//         _element.name = _element.fullname
//         delete _element.cidx
//         delete _element.pinyin
//         delete _element.location
//         delete _element.fullname
//     }, this);
// }, this);
// let myData = []
// //找出该省下属的市
// provinceData.forEach(function(pr_element) {
//     const provinceID = pr_element.id.substr(0,2);//省-前两位数字相同
//     pr_element.child = [];//在省数据中，追加属于该省的市数据
//     cityData.forEach(function(ci_element) {
//         const cityID = ci_element.id.substr(0,4);//省市-前四位数字相同
//         if(ci_element.id.indexOf(provinceID)==0){
//             pr_element.child.push(ci_element);//在省数据中，追加属于该省的市数据
//             ci_element.child = [];//在市数据中，追加属于该市的区数据
//             countyData.forEach(function(co_element) {
//                 const countyID = co_element.id.substr(4,2);
//                 if(co_element.id.indexOf(cityID)==0){
//                     ci_element.child.push(co_element);//在市数据中，追加属于该市的区数据
//                 }
//             }, this);
//             if(ci_element.child.length==0){
//                 delete ci_element.child
//             }
//         }
//     }, this);
//     if(pr_element.child.length==0){
//         delete pr_element.child
//     }
// }, this);
// console.log("=====string数据======")
// console.log(JSON.stringify(provinceData))
var data=[{"id":"110000","name":"北京市","child":[{"id":"110101","name":"东城区"},{"id":"110102","name":"西城区"},{"id":"110105","name":"朝阳区"},{"id":"110106","name":"丰台区"},{"id":"110107","name":"石景山区"},{"id":"110108","name":"海淀区"},{"id":"110109","name":"门头沟区"},{"id":"110111","name":"房山区"},{"id":"110112","name":"通州区"},{"id":"110113","name":"顺义区"},{"id":"110114","name":"昌平区"},{"id":"110115","name":"大兴区"},{"id":"110116","name":"怀柔区"},{"id":"110117","name":"平谷区"},{"id":"110118","name":"密云区"},{"id":"110119","name":"延庆区"}]},{"id":"120000","name":"天津市","child":[{"id":"120101","name":"和平区"},{"id":"120102","name":"河东区"},{"id":"120103","name":"河西区"},{"id":"120104","name":"南开区"},{"id":"120105","name":"河北区"},{"id":"120106","name":"红桥区"},{"id":"120110","name":"东丽区"},{"id":"120111","name":"西青区"},{"id":"120112","name":"津南区"},{"id":"120113","name":"北辰区"},{"id":"120114","name":"武清区"},{"id":"120115","name":"宝坻区"},{"id":"120116","name":"滨海新区"},{"id":"120117","name":"宁河区"},{"id":"120118","name":"静海区"},{"id":"120119","name":"蓟州区"}]},{"id":"130000","name":"河北省","child":[{"id":"130100","name":"石家庄市","child":[{"id":"130102","name":"长安区"},{"id":"130104","name":"桥西区"},{"id":"130105","name":"新华区"},{"id":"130107","name":"井陉矿区"},{"id":"130108","name":"裕华区"},{"id":"130109","name":"藁城区"},{"id":"130110","name":"鹿泉区"},{"id":"130111","name":"栾城区"},{"id":"130121","name":"井陉县"},{"id":"130123","name":"正定县"},{"id":"130125","name":"行唐县"},{"id":"130126","name":"灵寿县"},{"id":"130127","name":"高邑县"},{"id":"130128","name":"深泽县"},{"id":"130129","name":"赞皇县"},{"id":"130130","name":"无极县"},{"id":"130131","name":"平山县"},{"id":"130132","name":"元氏县"},{"id":"130133","name":"赵县"},{"id":"130183","name":"晋州市"},{"id":"130184","name":"新乐市"}]},{"id":"130200","name":"唐山市","child":[{"id":"130202","name":"路南区"},{"id":"130203","name":"路北区"},{"id":"130204","name":"古冶区"},{"id":"130205","name":"开平区"},{"id":"130207","name":"丰南区"},{"id":"130208","name":"丰润区"},{"id":"130209","name":"曹妃甸区"},{"id":"130223","name":"滦县"},{"id":"130224","name":"滦南县"},{"id":"130225","name":"乐亭县"},{"id":"130227","name":"迁西县"},{"id":"130229","name":"玉田县"},{"id":"130281","name":"遵化市"},{"id":"130283","name":"迁安市"}]},{"id":"130300","name":"秦皇岛市","child":[{"id":"130302","name":"海港区"},{"id":"130303","name":"山海关区"},{"id":"130304","name":"北戴河区"},{"id":"130306","name":"抚宁区"},{"id":"130321","name":"青龙满族自治县"},{"id":"130322","name":"昌黎县"},{"id":"130324","name":"卢龙县"}]},{"id":"130400","name":"邯郸市","child":[{"id":"130402","name":"邯山区"},{"id":"130403","name":"丛台区"},{"id":"130404","name":"复兴区"},{"id":"130406","name":"峰峰矿区"},{"id":"130407","name":"肥乡区"},{"id":"130408","name":"永年区"},{"id":"130423","name":"临漳县"},{"id":"130424","name":"成安县"},{"id":"130425","name":"大名县"},{"id":"130426","name":"涉县"},{"id":"130427","name":"磁县"},{"id":"130430","name":"邱县"},{"id":"130431","name":"鸡泽县"},{"id":"130432","name":"广平县"},{"id":"130433","name":"馆陶县"},{"id":"130434","name":"魏县"},{"id":"130435","name":"曲周县"},{"id":"130481","name":"武安市"}]},{"id":"130500","name":"邢台市","child":[{"id":"130502","name":"桥东区"},{"id":"130503","name":"桥西区"},{"id":"130521","name":"邢台县"},{"id":"130522","name":"临城县"},{"id":"130523","name":"内丘县"},{"id":"130524","name":"柏乡县"},{"id":"130525","name":"隆尧县"},{"id":"130526","name":"任县"},{"id":"130527","name":"南和县"},{"id":"130528","name":"宁晋县"},{"id":"130529","name":"巨鹿县"},{"id":"130530","name":"新河县"},{"id":"130531","name":"广宗县"},{"id":"130532","name":"平乡县"},{"id":"130533","name":"威县"},{"id":"130534","name":"清河县"},{"id":"130535","name":"临西县"},{"id":"130581","name":"南宫市"},{"id":"130582","name":"沙河市"}]},{"id":"130600","name":"保定市","child":[{"id":"130602","name":"竞秀区"},{"id":"130606","name":"莲池区"},{"id":"130607","name":"满城区"},{"id":"130608","name":"清苑区"},{"id":"130609","name":"徐水区"},{"id":"130623","name":"涞水县"},{"id":"130624","name":"阜平县"},{"id":"130626","name":"定兴县"},{"id":"130627","name":"唐县"},{"id":"130628","name":"高阳县"},{"id":"130629","name":"容城县"},{"id":"130630","name":"涞源县"},{"id":"130631","name":"望都县"},{"id":"130632","name":"安新县"},{"id":"130633","name":"易县"},{"id":"130634","name":"曲阳县"},{"id":"130635","name":"蠡县"},{"id":"130636","name":"顺平县"},{"id":"130637","name":"博野县"},{"id":"130638","name":"雄县"},{"id":"130681","name":"涿州市"},{"id":"130683","name":"安国市"},{"id":"130684","name":"高碑店市"}]},{"id":"130700","name":"张家口市","child":[{"id":"130702","name":"桥东区"},{"id":"130703","name":"桥西区"},{"id":"130705","name":"宣化区"},{"id":"130706","name":"下花园区"},{"id":"130708","name":"万全区"},{"id":"130709","name":"崇礼区"},{"id":"130722","name":"张北县"},{"id":"130723","name":"康保县"},{"id":"130724","name":"沽源县"},{"id":"130725","name":"尚义县"},{"id":"130726","name":"蔚县"},{"id":"130727","name":"阳原县"},{"id":"130728","name":"怀安县"},{"id":"130730","name":"怀来县"},{"id":"130731","name":"涿鹿县"},{"id":"130732","name":"赤城县"}]},{"id":"130800","name":"承德市","child":[{"id":"130802","name":"双桥区"},{"id":"130803","name":"双滦区"},{"id":"130804","name":"鹰手营子矿区"},{"id":"130821","name":"承德县"},{"id":"130822","name":"兴隆县"},{"id":"130823","name":"平泉县"},{"id":"130824","name":"滦平县"},{"id":"130825","name":"隆化县"},{"id":"130826","name":"丰宁满族自治县"},{"id":"130827","name":"宽城满族自治县"},{"id":"130828","name":"围场满族蒙古族自治县"}]},{"id":"130900","name":"沧州市","child":[{"id":"130902","name":"新华区"},{"id":"130903","name":"运河区"},{"id":"130921","name":"沧县"},{"id":"130922","name":"青县"},{"id":"130923","name":"东光县"},{"id":"130924","name":"海兴县"},{"id":"130925","name":"盐山县"},{"id":"130926","name":"肃宁县"},{"id":"130927","name":"南皮县"},{"id":"130928","name":"吴桥县"},{"id":"130929","name":"献县"},{"id":"130930","name":"孟村回族自治县"},{"id":"130981","name":"泊头市"},{"id":"130982","name":"任丘市"},{"id":"130983","name":"黄骅市"},{"id":"130984","name":"河间市"}]},{"id":"131000","name":"廊坊市","child":[{"id":"131002","name":"安次区"},{"id":"131003","name":"广阳区"},{"id":"131022","name":"固安县"},{"id":"131023","name":"永清县"},{"id":"131024","name":"香河县"},{"id":"131025","name":"大城县"},{"id":"131026","name":"文安县"},{"id":"131028","name":"大厂回族自治县"},{"id":"131081","name":"霸州市"},{"id":"131082","name":"三河市"}]},{"id":"131100","name":"衡水市","child":[{"id":"131102","name":"桃城区"},{"id":"131103","name":"冀州区"},{"id":"131121","name":"枣强县"},{"id":"131122","name":"武邑县"},{"id":"131123","name":"武强县"},{"id":"131124","name":"饶阳县"},{"id":"131125","name":"安平县"},{"id":"131126","name":"故城县"},{"id":"131127","name":"景县"},{"id":"131128","name":"阜城县"},{"id":"131182","name":"深州市"}]},{"id":"139001","name":"定州市"},{"id":"139002","name":"辛集市"}]},{"id":"140000","name":"山西省","child":[{"id":"140100","name":"太原市","child":[{"id":"140105","name":"小店区"},{"id":"140106","name":"迎泽区"},{"id":"140107","name":"杏花岭区"},{"id":"140108","name":"尖草坪区"},{"id":"140109","name":"万柏林区"},{"id":"140110","name":"晋源区"},{"id":"140121","name":"清徐县"},{"id":"140122","name":"阳曲县"},{"id":"140123","name":"娄烦县"},{"id":"140181","name":"古交市"}]},{"id":"140200","name":"大同市","child":[{"id":"140202","name":"城区"},{"id":"140203","name":"矿区"},{"id":"140211","name":"南郊区"},{"id":"140212","name":"新荣区"},{"id":"140221","name":"阳高县"},{"id":"140222","name":"天镇县"},{"id":"140223","name":"广灵县"},{"id":"140224","name":"灵丘县"},{"id":"140225","name":"浑源县"},{"id":"140226","name":"左云县"},{"id":"140227","name":"大同县"}]},{"id":"140300","name":"阳泉市","child":[{"id":"140302","name":"城区"},{"id":"140303","name":"矿区"},{"id":"140311","name":"郊区"},{"id":"140321","name":"平定县"},{"id":"140322","name":"盂县"}]},{"id":"140400","name":"长治市","child":[{"id":"140402","name":"城区"},{"id":"140411","name":"郊区"},{"id":"140421","name":"长治县"},{"id":"140423","name":"襄垣县"},{"id":"140424","name":"屯留县"},{"id":"140425","name":"平顺县"},{"id":"140426","name":"黎城县"},{"id":"140427","name":"壶关县"},{"id":"140428","name":"长子县"},{"id":"140429","name":"武乡县"},{"id":"140430","name":"沁县"},{"id":"140431","name":"沁源县"},{"id":"140481","name":"潞城市"}]},{"id":"140500","name":"晋城市","child":[{"id":"140502","name":"城区"},{"id":"140521","name":"沁水县"},{"id":"140522","name":"阳城县"},{"id":"140524","name":"陵川县"},{"id":"140525","name":"泽州县"},{"id":"140581","name":"高平市"}]},{"id":"140600","name":"朔州市","child":[{"id":"140602","name":"朔城区"},{"id":"140603","name":"平鲁区"},{"id":"140621","name":"山阴县"},{"id":"140622","name":"应县"},{"id":"140623","name":"右玉县"},{"id":"140624","name":"怀仁县"}]},{"id":"140700","name":"晋中市","child":[{"id":"140702","name":"榆次区"},{"id":"140721","name":"榆社县"},{"id":"140722","name":"左权县"},{"id":"140723","name":"和顺县"},{"id":"140724","name":"昔阳县"},{"id":"140725","name":"寿阳县"},{"id":"140726","name":"太谷县"},{"id":"140727","name":"祁县"},{"id":"140728","name":"平遥县"},{"id":"140729","name":"灵石县"},{"id":"140781","name":"介休市"}]},{"id":"140800","name":"运城市","child":[{"id":"140802","name":"盐湖区"},{"id":"140821","name":"临猗县"},{"id":"140822","name":"万荣县"},{"id":"140823","name":"闻喜县"},{"id":"140824","name":"稷山县"},{"id":"140825","name":"新绛县"},{"id":"140826","name":"绛县"},{"id":"140827","name":"垣曲县"},{"id":"140828","name":"夏县"},{"id":"140829","name":"平陆县"},{"id":"140830","name":"芮城县"},{"id":"140881","name":"永济市"},{"id":"140882","name":"河津市"}]},{"id":"140900","name":"忻州市","child":[{"id":"140902","name":"忻府区"},{"id":"140921","name":"定襄县"},{"id":"140922","name":"五台县"},{"id":"140923","name":"代县"},{"id":"140924","name":"繁峙县"},{"id":"140925","name":"宁武县"},{"id":"140926","name":"静乐县"},{"id":"140927","name":"神池县"},{"id":"140928","name":"五寨县"},{"id":"140929","name":"岢岚县"},{"id":"140930","name":"河曲县"},{"id":"140931","name":"保德县"},{"id":"140932","name":"偏关县"},{"id":"140981","name":"原平市"}]},{"id":"141000","name":"临汾市","child":[{"id":"141002","name":"尧都区"},{"id":"141021","name":"曲沃县"},{"id":"141022","name":"翼城县"},{"id":"141023","name":"襄汾县"},{"id":"141024","name":"洪洞县"},{"id":"141025","name":"古县"},{"id":"141026","name":"安泽县"},{"id":"141027","name":"浮山县"},{"id":"141028","name":"吉县"},{"id":"141029","name":"乡宁县"},{"id":"141030","name":"大宁县"},{"id":"141031","name":"隰县"},{"id":"141032","name":"永和县"},{"id":"141033","name":"蒲县"},{"id":"141034","name":"汾西县"},{"id":"141081","name":"侯马市"},{"id":"141082","name":"霍州市"}]},{"id":"141100","name":"吕梁市","child":[{"id":"141102","name":"离石区"},{"id":"141121","name":"文水县"},{"id":"141122","name":"交城县"},{"id":"141123","name":"兴县"},{"id":"141124","name":"临县"},{"id":"141125","name":"柳林县"},{"id":"141126","name":"石楼县"},{"id":"141127","name":"岚县"},{"id":"141128","name":"方山县"},{"id":"141129","name":"中阳县"},{"id":"141130","name":"交口县"},{"id":"141181","name":"孝义市"},{"id":"141182","name":"汾阳市"}]}]},{"id":"150000","name":"内蒙古自治区","child":[{"id":"150100","name":"呼和浩特市","child":[{"id":"150102","name":"新城区"},{"id":"150103","name":"回民区"},{"id":"150104","name":"玉泉区"},{"id":"150105","name":"赛罕区"},{"id":"150121","name":"土默特左旗"},{"id":"150122","name":"托克托县"},{"id":"150123","name":"和林格尔县"},{"id":"150124","name":"清水河县"},{"id":"150125","name":"武川县"}]},{"id":"150200","name":"包头市","child":[{"id":"150202","name":"东河区"},{"id":"150203","name":"昆都仑区"},{"id":"150204","name":"青山区"},{"id":"150205","name":"石拐区"},{"id":"150206","name":"白云鄂博矿区"},{"id":"150207","name":"九原区"},{"id":"150221","name":"土默特右旗"},{"id":"150222","name":"固阳县"},{"id":"150223","name":"达尔罕茂明安联合旗"}]},{"id":"150300","name":"乌海市","child":[{"id":"150302","name":"海勃湾区"},{"id":"150303","name":"海南区"},{"id":"150304","name":"乌达区"}]},{"id":"150400","name":"赤峰市","child":[{"id":"150402","name":"红山区"},{"id":"150403","name":"元宝山区"},{"id":"150404","name":"松山区"},{"id":"150421","name":"阿鲁科尔沁旗"},{"id":"150422","name":"巴林左旗"},{"id":"150423","name":"巴林右旗"},{"id":"150424","name":"林西县"},{"id":"150425","name":"克什克腾旗"},{"id":"150426","name":"翁牛特旗"},{"id":"150428","name":"喀喇沁旗"},{"id":"150429","name":"宁城县"},{"id":"150430","name":"敖汉旗"}]},{"id":"150500","name":"通辽市","child":[{"id":"150502","name":"科尔沁区"},{"id":"150521","name":"科尔沁左翼中旗"},{"id":"150522","name":"科尔沁左翼后旗"},{"id":"150523","name":"开鲁县"},{"id":"150524","name":"库伦旗"},{"id":"150525","name":"奈曼旗"},{"id":"150526","name":"扎鲁特旗"},{"id":"150581","name":"霍林郭勒市"}]},{"id":"150600","name":"鄂尔多斯市","child":[{"id":"150602","name":"东胜区"},{"id":"150603","name":"康巴什区"},{"id":"150621","name":"达拉特旗"},{"id":"150622","name":"准格尔旗"},{"id":"150623","name":"鄂托克前旗"},{"id":"150624","name":"鄂托克旗"},{"id":"150625","name":"杭锦旗"},{"id":"150626","name":"乌审旗"},{"id":"150627","name":"伊金霍洛旗"}]},{"id":"150700","name":"呼伦贝尔市","child":[{"id":"150702","name":"海拉尔区"},{"id":"150703","name":"扎赉诺尔区"},{"id":"150721","name":"阿荣旗"},{"id":"150722","name":"莫力达瓦达斡尔族自治旗"},{"id":"150723","name":"鄂伦春自治旗"},{"id":"150724","name":"鄂温克族自治旗"},{"id":"150725","name":"陈巴尔虎旗"},{"id":"150726","name":"新巴尔虎左旗"},{"id":"150727","name":"新巴尔虎右旗"},{"id":"150781","name":"满洲里市"},{"id":"150782","name":"牙克石市"},{"id":"150783","name":"扎兰屯市"},{"id":"150784","name":"额尔古纳市"},{"id":"150785","name":"根河市"}]},{"id":"150800","name":"巴彦淖尔市","child":[{"id":"150802","name":"临河区"},{"id":"150821","name":"五原县"},{"id":"150822","name":"磴口县"},{"id":"150823","name":"乌拉特前旗"},{"id":"150824","name":"乌拉特中旗"},{"id":"150825","name":"乌拉特后旗"},{"id":"150826","name":"杭锦后旗"}]},{"id":"150900","name":"乌兰察布市","child":[{"id":"150902","name":"集宁区"},{"id":"150921","name":"卓资县"},{"id":"150922","name":"化德县"},{"id":"150923","name":"商都县"},{"id":"150924","name":"兴和县"},{"id":"150925","name":"凉城县"},{"id":"150926","name":"察哈尔右翼前旗"},{"id":"150927","name":"察哈尔右翼中旗"},{"id":"150928","name":"察哈尔右翼后旗"},{"id":"150929","name":"四子王旗"},{"id":"150981","name":"丰镇市"}]},{"id":"152200","name":"兴安盟","child":[{"id":"152201","name":"乌兰浩特市"},{"id":"152202","name":"阿尔山市"},{"id":"152221","name":"科尔沁右翼前旗"},{"id":"152222","name":"科尔沁右翼中旗"},{"id":"152223","name":"扎赉特旗"},{"id":"152224","name":"突泉县"}]},{"id":"152500","name":"锡林郭勒盟","child":[{"id":"152501","name":"二连浩特市"},{"id":"152502","name":"锡林浩特市"},{"id":"152522","name":"阿巴嘎旗"},{"id":"152523","name":"苏尼特左旗"},{"id":"152524","name":"苏尼特右旗"},{"id":"152525","name":"东乌珠穆沁旗"},{"id":"152526","name":"西乌珠穆沁旗"},{"id":"152527","name":"太仆寺旗"},{"id":"152528","name":"镶黄旗"},{"id":"152529","name":"正镶白旗"},{"id":"152530","name":"正蓝旗"},{"id":"152531","name":"多伦县"}]},{"id":"152900","name":"阿拉善盟","child":[{"id":"152921","name":"阿拉善左旗"},{"id":"152922","name":"阿拉善右旗"},{"id":"152923","name":"额济纳旗"}]}]},{"id":"210000","name":"辽宁省","child":[{"id":"210100","name":"沈阳市","child":[{"id":"210102","name":"和平区"},{"id":"210103","name":"沈河区"},{"id":"210104","name":"大东区"},{"id":"210105","name":"皇姑区"},{"id":"210106","name":"铁西区"},{"id":"210111","name":"苏家屯区"},{"id":"210112","name":"浑南区"},{"id":"210113","name":"沈北新区"},{"id":"210114","name":"于洪区"},{"id":"210115","name":"辽中区"},{"id":"210123","name":"康平县"},{"id":"210124","name":"法库县"},{"id":"210181","name":"新民市"}]},{"id":"210200","name":"大连市","child":[{"id":"210202","name":"中山区"},{"id":"210203","name":"西岗区"},{"id":"210204","name":"沙河口区"},{"id":"210211","name":"甘井子区"},{"id":"210212","name":"旅顺口区"},{"id":"210213","name":"金州区"},{"id":"210214","name":"普兰店区"},{"id":"210224","name":"长海县"},{"id":"210281","name":"瓦房店市"},{"id":"210283","name":"庄河市"}]},{"id":"210300","name":"鞍山市","child":[{"id":"210302","name":"铁东区"},{"id":"210303","name":"铁西区"},{"id":"210304","name":"立山区"},{"id":"210311","name":"千山区"},{"id":"210321","name":"台安县"},{"id":"210323","name":"岫岩满族自治县"},{"id":"210381","name":"海城市"}]},{"id":"210400","name":"抚顺市","child":[{"id":"210402","name":"新抚区"},{"id":"210403","name":"东洲区"},{"id":"210404","name":"望花区"},{"id":"210411","name":"顺城区"},{"id":"210421","name":"抚顺县"},{"id":"210422","name":"新宾满族自治县"},{"id":"210423","name":"清原满族自治县"}]},{"id":"210500","name":"本溪市","child":[{"id":"210502","name":"平山区"},{"id":"210503","name":"溪湖区"},{"id":"210504","name":"明山区"},{"id":"210505","name":"南芬区"},{"id":"210521","name":"本溪满族自治县"},{"id":"210522","name":"桓仁满族自治县"}]},{"id":"210600","name":"丹东市","child":[{"id":"210602","name":"元宝区"},{"id":"210603","name":"振兴区"},{"id":"210604","name":"振安区"},{"id":"210624","name":"宽甸满族自治县"},{"id":"210681","name":"东港市"},{"id":"210682","name":"凤城市"}]},{"id":"210700","name":"锦州市","child":[{"id":"210702","name":"古塔区"},{"id":"210703","name":"凌河区"},{"id":"210711","name":"太和区"},{"id":"210726","name":"黑山县"},{"id":"210727","name":"义县"},{"id":"210781","name":"凌海市"},{"id":"210782","name":"北镇市"}]},{"id":"210800","name":"营口市","child":[{"id":"210802","name":"站前区"},{"id":"210803","name":"西市区"},{"id":"210804","name":"鲅鱼圈区"},{"id":"210811","name":"老边区"},{"id":"210881","name":"盖州市"},{"id":"210882","name":"大石桥市"}]},{"id":"210900","name":"阜新市","child":[{"id":"210902","name":"海州区"},{"id":"210903","name":"新邱区"},{"id":"210904","name":"太平区"},{"id":"210905","name":"清河门区"},{"id":"210911","name":"细河区"},{"id":"210921","name":"阜新蒙古族自治县"},{"id":"210922","name":"彰武县"}]},{"id":"211000","name":"辽阳市","child":[{"id":"211002","name":"白塔区"},{"id":"211003","name":"文圣区"},{"id":"211004","name":"宏伟区"},{"id":"211005","name":"弓长岭区"},{"id":"211011","name":"太子河区"},{"id":"211021","name":"辽阳县"},{"id":"211081","name":"灯塔市"}]},{"id":"211100","name":"盘锦市","child":[{"id":"211102","name":"双台子区"},{"id":"211103","name":"兴隆台区"},{"id":"211104","name":"大洼区"},{"id":"211122","name":"盘山县"}]},{"id":"211200","name":"铁岭市","child":[{"id":"211202","name":"银州区"},{"id":"211204","name":"清河区"},{"id":"211221","name":"铁岭县"},{"id":"211223","name":"西丰县"},{"id":"211224","name":"昌图县"},{"id":"211281","name":"调兵山市"},{"id":"211282","name":"开原市"}]},{"id":"211300","name":"朝阳市","child":[{"id":"211302","name":"双塔区"},{"id":"211303","name":"龙城区"},{"id":"211321","name":"朝阳县"},{"id":"211322","name":"建平县"},{"id":"211324","name":"喀喇沁左翼蒙古族自治县"},{"id":"211381","name":"北票市"},{"id":"211382","name":"凌源市"}]},{"id":"211400","name":"葫芦岛市","child":[{"id":"211402","name":"连山区"},{"id":"211403","name":"龙港区"},{"id":"211404","name":"南票区"},{"id":"211421","name":"绥中县"},{"id":"211422","name":"建昌县"},{"id":"211481","name":"兴城市"}]}]},{"id":"220000","name":"吉林省","child":[{"id":"220100","name":"长春市","child":[{"id":"220102","name":"南关区"},{"id":"220103","name":"宽城区"},{"id":"220104","name":"朝阳区"},{"id":"220105","name":"二道区"},{"id":"220106","name":"绿园区"},{"id":"220112","name":"双阳区"},{"id":"220113","name":"九台区"},{"id":"220122","name":"农安县"},{"id":"220182","name":"榆树市"},{"id":"220183","name":"德惠市"}]},{"id":"220200","name":"吉林市","child":[{"id":"220202","name":"昌邑区"},{"id":"220203","name":"龙潭区"},{"id":"220204","name":"船营区"},{"id":"220211","name":"丰满区"},{"id":"220221","name":"永吉县"},{"id":"220281","name":"蛟河市"},{"id":"220282","name":"桦甸市"},{"id":"220283","name":"舒兰市"},{"id":"220284","name":"磐石市"}]},{"id":"220300","name":"四平市","child":[{"id":"220302","name":"铁西区"},{"id":"220303","name":"铁东区"},{"id":"220322","name":"梨树县"},{"id":"220323","name":"伊通满族自治县"},{"id":"220381","name":"公主岭市"},{"id":"220382","name":"双辽市"}]},{"id":"220400","name":"辽源市","child":[{"id":"220402","name":"龙山区"},{"id":"220403","name":"西安区"},{"id":"220421","name":"东丰县"},{"id":"220422","name":"东辽县"}]},{"id":"220500","name":"通化市","child":[{"id":"220502","name":"东昌区"},{"id":"220503","name":"二道江区"},{"id":"220521","name":"通化县"},{"id":"220523","name":"辉南县"},{"id":"220524","name":"柳河县"},{"id":"220581","name":"梅河口市"},{"id":"220582","name":"集安市"}]},{"id":"220600","name":"白山市","child":[{"id":"220602","name":"浑江区"},{"id":"220605","name":"江源区"},{"id":"220621","name":"抚松县"},{"id":"220622","name":"靖宇县"},{"id":"220623","name":"长白朝鲜族自治县"},{"id":"220681","name":"临江市"}]},{"id":"220700","name":"松原市","child":[{"id":"220702","name":"宁江区"},{"id":"220721","name":"前郭尔罗斯蒙古族自治县"},{"id":"220722","name":"长岭县"},{"id":"220723","name":"乾安县"},{"id":"220781","name":"扶余市"}]},{"id":"220800","name":"白城市","child":[{"id":"220802","name":"洮北区"},{"id":"220821","name":"镇赉县"},{"id":"220822","name":"通榆县"},{"id":"220881","name":"洮南市"},{"id":"220882","name":"大安市"}]},{"id":"222400","name":"延边朝鲜族自治州","child":[{"id":"222401","name":"延吉市"},{"id":"222402","name":"图们市"},{"id":"222403","name":"敦化市"},{"id":"222404","name":"珲春市"},{"id":"222405","name":"龙井市"},{"id":"222406","name":"和龙市"},{"id":"222424","name":"汪清县"},{"id":"222426","name":"安图县"}]}]},{"id":"230000","name":"黑龙江省","child":[{"id":"230100","name":"哈尔滨市","child":[{"id":"230102","name":"道里区"},{"id":"230103","name":"南岗区"},{"id":"230104","name":"道外区"},{"id":"230108","name":"平房区"},{"id":"230109","name":"松北区"},{"id":"230110","name":"香坊区"},{"id":"230111","name":"呼兰区"},{"id":"230112","name":"阿城区"},{"id":"230113","name":"双城区"},{"id":"230123","name":"依兰县"},{"id":"230124","name":"方正县"},{"id":"230125","name":"宾县"},{"id":"230126","name":"巴彦县"},{"id":"230127","name":"木兰县"},{"id":"230128","name":"通河县"},{"id":"230129","name":"延寿县"},{"id":"230183","name":"尚志市"},{"id":"230184","name":"五常市"}]},{"id":"230200","name":"齐齐哈尔市","child":[{"id":"230202","name":"龙沙区"},{"id":"230203","name":"建华区"},{"id":"230204","name":"铁锋区"},{"id":"230205","name":"昂昂溪区"},{"id":"230206","name":"富拉尔基区"},{"id":"230207","name":"碾子山区"},{"id":"230208","name":"梅里斯达斡尔族区"},{"id":"230221","name":"龙江县"},{"id":"230223","name":"依安县"},{"id":"230224","name":"泰来县"},{"id":"230225","name":"甘南县"},{"id":"230227","name":"富裕县"},{"id":"230229","name":"克山县"},{"id":"230230","name":"克东县"},{"id":"230231","name":"拜泉县"},{"id":"230281","name":"讷河市"}]},{"id":"230300","name":"鸡西市","child":[{"id":"230302","name":"鸡冠区"},{"id":"230303","name":"恒山区"},{"id":"230304","name":"滴道区"},{"id":"230305","name":"梨树区"},{"id":"230306","name":"城子河区"},{"id":"230307","name":"麻山区"},{"id":"230321","name":"鸡东县"},{"id":"230381","name":"虎林市"},{"id":"230382","name":"密山市"}]},{"id":"230400","name":"鹤岗市","child":[{"id":"230402","name":"向阳区"},{"id":"230403","name":"工农区"},{"id":"230404","name":"南山区"},{"id":"230405","name":"兴安区"},{"id":"230406","name":"东山区"},{"id":"230407","name":"兴山区"},{"id":"230421","name":"萝北县"},{"id":"230422","name":"绥滨县"}]},{"id":"230500","name":"双鸭山市","child":[{"id":"230502","name":"尖山区"},{"id":"230503","name":"岭东区"},{"id":"230505","name":"四方台区"},{"id":"230506","name":"宝山区"},{"id":"230521","name":"集贤县"},{"id":"230522","name":"友谊县"},{"id":"230523","name":"宝清县"},{"id":"230524","name":"饶河县"}]},{"id":"230600","name":"大庆市","child":[{"id":"230602","name":"萨尔图区"},{"id":"230603","name":"龙凤区"},{"id":"230604","name":"让胡路区"},{"id":"230605","name":"红岗区"},{"id":"230606","name":"大同区"},{"id":"230621","name":"肇州县"},{"id":"230622","name":"肇源县"},{"id":"230623","name":"林甸县"},{"id":"230624","name":"杜尔伯特蒙古族自治县"}]},{"id":"230700","name":"伊春市","child":[{"id":"230702","name":"伊春区"},{"id":"230703","name":"南岔区"},{"id":"230704","name":"友好区"},{"id":"230705","name":"西林区"},{"id":"230706","name":"翠峦区"},{"id":"230707","name":"新青区"},{"id":"230708","name":"美溪区"},{"id":"230709","name":"金山屯区"},{"id":"230710","name":"五营区"},{"id":"230711","name":"乌马河区"},{"id":"230712","name":"汤旺河区"},{"id":"230713","name":"带岭区"},{"id":"230714","name":"乌伊岭区"},{"id":"230715","name":"红星区"},{"id":"230716","name":"上甘岭区"},{"id":"230722","name":"嘉荫县"},{"id":"230781","name":"铁力市"}]},{"id":"230800","name":"佳木斯市","child":[{"id":"230803","name":"向阳区"},{"id":"230804","name":"前进区"},{"id":"230805","name":"东风区"},{"id":"230811","name":"郊区"},{"id":"230822","name":"桦南县"},{"id":"230826","name":"桦川县"},{"id":"230828","name":"汤原县"},{"id":"230881","name":"同江市"},{"id":"230882","name":"富锦市"},{"id":"230883","name":"抚远市"}]},{"id":"230900","name":"七台河市","child":[{"id":"230902","name":"新兴区"},{"id":"230903","name":"桃山区"},{"id":"230904","name":"茄子河区"},{"id":"230921","name":"勃利县"}]},{"id":"231000","name":"牡丹江市","child":[{"id":"231002","name":"东安区"},{"id":"231003","name":"阳明区"},{"id":"231004","name":"爱民区"},{"id":"231005","name":"西安区"},{"id":"231025","name":"林口县"},{"id":"231081","name":"绥芬河市"},{"id":"231083","name":"海林市"},{"id":"231084","name":"宁安市"},{"id":"231085","name":"穆棱市"},{"id":"231086","name":"东宁市"}]},{"id":"231100","name":"黑河市","child":[{"id":"231102","name":"爱辉区"},{"id":"231121","name":"嫩江县"},{"id":"231123","name":"逊克县"},{"id":"231124","name":"孙吴县"},{"id":"231181","name":"北安市"},{"id":"231182","name":"五大连池市"}]},{"id":"231200","name":"绥化市","child":[{"id":"231202","name":"北林区"},{"id":"231221","name":"望奎县"},{"id":"231222","name":"兰西县"},{"id":"231223","name":"青冈县"},{"id":"231224","name":"庆安县"},{"id":"231225","name":"明水县"},{"id":"231226","name":"绥棱县"},{"id":"231281","name":"安达市"},{"id":"231282","name":"肇东市"},{"id":"231283","name":"海伦市"}]},{"id":"232700","name":"大兴安岭地区","child":[{"id":"232701","name":"加格达奇区"},{"id":"232721","name":"呼玛县"},{"id":"232722","name":"塔河县"},{"id":"232723","name":"漠河县"}]}]},{"id":"310000","name":"上海市","child":[{"id":"310101","name":"黄浦区"},{"id":"310104","name":"徐汇区"},{"id":"310105","name":"长宁区"},{"id":"310106","name":"静安区"},{"id":"310107","name":"普陀区"},{"id":"310109","name":"虹口区"},{"id":"310110","name":"杨浦区"},{"id":"310112","name":"闵行区"},{"id":"310113","name":"宝山区"},{"id":"310114","name":"嘉定区"},{"id":"310115","name":"浦东新区"},{"id":"310116","name":"金山区"},{"id":"310117","name":"松江区"},{"id":"310118","name":"青浦区"},{"id":"310120","name":"奉贤区"},{"id":"310151","name":"崇明区"}]},{"id":"320000","name":"江苏省","child":[{"id":"320100","name":"南京市","child":[{"id":"320102","name":"玄武区"},{"id":"320104","name":"秦淮区"},{"id":"320105","name":"建邺区"},{"id":"320106","name":"鼓楼区"},{"id":"320111","name":"浦口区"},{"id":"320113","name":"栖霞区"},{"id":"320114","name":"雨花台区"},{"id":"320115","name":"江宁区"},{"id":"320116","name":"六合区"},{"id":"320117","name":"溧水区"},{"id":"320118","name":"高淳区"}]},{"id":"320200","name":"无锡市","child":[{"id":"320205","name":"锡山区"},{"id":"320206","name":"惠山区"},{"id":"320211","name":"滨湖区"},{"id":"320213","name":"梁溪区"},{"id":"320214","name":"新吴区"},{"id":"320281","name":"江阴市"},{"id":"320282","name":"宜兴市"}]},{"id":"320300","name":"徐州市","child":[{"id":"320302","name":"鼓楼区"},{"id":"320303","name":"云龙区"},{"id":"320305","name":"贾汪区"},{"id":"320311","name":"泉山区"},{"id":"320312","name":"铜山区"},{"id":"320321","name":"丰县"},{"id":"320322","name":"沛县"},{"id":"320324","name":"睢宁县"},{"id":"320381","name":"新沂市"},{"id":"320382","name":"邳州市"}]},{"id":"320400","name":"常州市","child":[{"id":"320402","name":"天宁区"},{"id":"320404","name":"钟楼区"},{"id":"320411","name":"新北区"},{"id":"320412","name":"武进区"},{"id":"320413","name":"金坛区"},{"id":"320481","name":"溧阳市"}]},{"id":"320500","name":"苏州市","child":[{"id":"320505","name":"虎丘区"},{"id":"320506","name":"吴中区"},{"id":"320507","name":"相城区"},{"id":"320508","name":"姑苏区"},{"id":"320509","name":"吴江区"},{"id":"320581","name":"常熟市"},{"id":"320582","name":"张家港市"},{"id":"320583","name":"昆山市"},{"id":"320585","name":"太仓市"}]},{"id":"320600","name":"南通市","child":[{"id":"320602","name":"崇川区"},{"id":"320611","name":"港闸区"},{"id":"320612","name":"通州区"},{"id":"320621","name":"海安县"},{"id":"320623","name":"如东县"},{"id":"320681","name":"启东市"},{"id":"320682","name":"如皋市"},{"id":"320684","name":"海门市"}]},{"id":"320700","name":"连云港市","child":[{"id":"320703","name":"连云区"},{"id":"320706","name":"海州区"},{"id":"320707","name":"赣榆区"},{"id":"320722","name":"东海县"},{"id":"320723","name":"灌云县"},{"id":"320724","name":"灌南县"}]},{"id":"320800","name":"淮安市","child":[{"id":"320803","name":"淮安区"},{"id":"320804","name":"淮阴区"},{"id":"320812","name":"清江浦区"},{"id":"320813","name":"洪泽区"},{"id":"320826","name":"涟水县"},{"id":"320830","name":"盱眙县"},{"id":"320831","name":"金湖县"}]},{"id":"320900","name":"盐城市","child":[{"id":"320902","name":"亭湖区"},{"id":"320903","name":"盐都区"},{"id":"320904","name":"大丰区"},{"id":"320921","name":"响水县"},{"id":"320922","name":"滨海县"},{"id":"320923","name":"阜宁县"},{"id":"320924","name":"射阳县"},{"id":"320925","name":"建湖县"},{"id":"320981","name":"东台市"}]},{"id":"321000","name":"扬州市","child":[{"id":"321002","name":"广陵区"},{"id":"321003","name":"邗江区"},{"id":"321012","name":"江都区"},{"id":"321023","name":"宝应县"},{"id":"321081","name":"仪征市"},{"id":"321084","name":"高邮市"}]},{"id":"321100","name":"镇江市","child":[{"id":"321102","name":"京口区"},{"id":"321111","name":"润州区"},{"id":"321112","name":"丹徒区"},{"id":"321181","name":"丹阳市"},{"id":"321182","name":"扬中市"},{"id":"321183","name":"句容市"}]},{"id":"321200","name":"泰州市","child":[{"id":"321202","name":"海陵区"},{"id":"321203","name":"高港区"},{"id":"321204","name":"姜堰区"},{"id":"321281","name":"兴化市"},{"id":"321282","name":"靖江市"},{"id":"321283","name":"泰兴市"}]},{"id":"321300","name":"宿迁市","child":[{"id":"321302","name":"宿城区"},{"id":"321311","name":"宿豫区"},{"id":"321322","name":"沭阳县"},{"id":"321323","name":"泗阳县"},{"id":"321324","name":"泗洪县"}]}]},{"id":"330000","name":"浙江省","child":[{"id":"330100","name":"杭州市","child":[{"id":"330102","name":"上城区"},{"id":"330103","name":"下城区"},{"id":"330104","name":"江干区"},{"id":"330105","name":"拱墅区"},{"id":"330106","name":"西湖区"},{"id":"330108","name":"滨江区"},{"id":"330109","name":"萧山区"},{"id":"330110","name":"余杭区"},{"id":"330111","name":"富阳区"},{"id":"330122","name":"桐庐县"},{"id":"330127","name":"淳安县"},{"id":"330182","name":"建德市"},{"id":"330185","name":"临安市"}]},{"id":"330200","name":"宁波市","child":[{"id":"330203","name":"海曙区"},{"id":"330205","name":"江北区"},{"id":"330206","name":"北仑区"},{"id":"330211","name":"镇海区"},{"id":"330212","name":"鄞州区"},{"id":"330213","name":"奉化区"},{"id":"330225","name":"象山县"},{"id":"330226","name":"宁海县"},{"id":"330281","name":"余姚市"},{"id":"330282","name":"慈溪市"}]},{"id":"330300","name":"温州市","child":[{"id":"330302","name":"鹿城区"},{"id":"330303","name":"龙湾区"},{"id":"330304","name":"瓯海区"},{"id":"330305","name":"洞头区"},{"id":"330324","name":"永嘉县"},{"id":"330326","name":"平阳县"},{"id":"330327","name":"苍南县"},{"id":"330328","name":"文成县"},{"id":"330329","name":"泰顺县"},{"id":"330381","name":"瑞安市"},{"id":"330382","name":"乐清市"}]},{"id":"330400","name":"嘉兴市","child":[{"id":"330402","name":"南湖区"},{"id":"330411","name":"秀洲区"},{"id":"330421","name":"嘉善县"},{"id":"330424","name":"海盐县"},{"id":"330481","name":"海宁市"},{"id":"330482","name":"平湖市"},{"id":"330483","name":"桐乡市"}]},{"id":"330500","name":"湖州市","child":[{"id":"330502","name":"吴兴区"},{"id":"330503","name":"南浔区"},{"id":"330521","name":"德清县"},{"id":"330522","name":"长兴县"},{"id":"330523","name":"安吉县"}]},{"id":"330600","name":"绍兴市","child":[{"id":"330602","name":"越城区"},{"id":"330603","name":"柯桥区"},{"id":"330604","name":"上虞区"},{"id":"330624","name":"新昌县"},{"id":"330681","name":"诸暨市"},{"id":"330683","name":"嵊州市"}]},{"id":"330700","name":"金华市","child":[{"id":"330702","name":"婺城区"},{"id":"330703","name":"金东区"},{"id":"330723","name":"武义县"},{"id":"330726","name":"浦江县"},{"id":"330727","name":"磐安县"},{"id":"330781","name":"兰溪市"},{"id":"330782","name":"义乌市"},{"id":"330783","name":"东阳市"},{"id":"330784","name":"永康市"}]},{"id":"330800","name":"衢州市","child":[{"id":"330802","name":"柯城区"},{"id":"330803","name":"衢江区"},{"id":"330822","name":"常山县"},{"id":"330824","name":"开化县"},{"id":"330825","name":"龙游县"},{"id":"330881","name":"江山市"}]},{"id":"330900","name":"舟山市","child":[{"id":"330902","name":"定海区"},{"id":"330903","name":"普陀区"},{"id":"330921","name":"岱山县"},{"id":"330922","name":"嵊泗县"}]},{"id":"331000","name":"台州市","child":[{"id":"331002","name":"椒江区"},{"id":"331003","name":"黄岩区"},{"id":"331004","name":"路桥区"},{"id":"331021","name":"玉环县"},{"id":"331022","name":"三门县"},{"id":"331023","name":"天台县"},{"id":"331024","name":"仙居县"},{"id":"331081","name":"温岭市"},{"id":"331082","name":"临海市"}]},{"id":"331100","name":"丽水市","child":[{"id":"331102","name":"莲都区"},{"id":"331121","name":"青田县"},{"id":"331122","name":"缙云县"},{"id":"331123","name":"遂昌县"},{"id":"331124","name":"松阳县"},{"id":"331125","name":"云和县"},{"id":"331126","name":"庆元县"},{"id":"331127","name":"景宁畲族自治县"},{"id":"331181","name":"龙泉市"}]}]},{"id":"340000","name":"安徽省","child":[{"id":"340100","name":"合肥市","child":[{"id":"340102","name":"瑶海区"},{"id":"340103","name":"庐阳区"},{"id":"340104","name":"蜀山区"},{"id":"340111","name":"包河区"},{"id":"340121","name":"长丰县"},{"id":"340122","name":"肥东县"},{"id":"340123","name":"肥西县"},{"id":"340124","name":"庐江县"},{"id":"340181","name":"巢湖市"}]},{"id":"340200","name":"芜湖市","child":[{"id":"340202","name":"镜湖区"},{"id":"340203","name":"弋江区"},{"id":"340207","name":"鸠江区"},{"id":"340208","name":"三山区"},{"id":"340221","name":"芜湖县"},{"id":"340222","name":"繁昌县"},{"id":"340223","name":"南陵县"},{"id":"340225","name":"无为县"}]},{"id":"340300","name":"蚌埠市","child":[{"id":"340302","name":"龙子湖区"},{"id":"340303","name":"蚌山区"},{"id":"340304","name":"禹会区"},{"id":"340311","name":"淮上区"},{"id":"340321","name":"怀远县"},{"id":"340322","name":"五河县"},{"id":"340323","name":"固镇县"}]},{"id":"340400","name":"淮南市","child":[{"id":"340402","name":"大通区"},{"id":"340403","name":"田家庵区"},{"id":"340404","name":"谢家集区"},{"id":"340405","name":"八公山区"},{"id":"340406","name":"潘集区"},{"id":"340421","name":"凤台县"},{"id":"340422","name":"寿县"}]},{"id":"340500","name":"马鞍山市","child":[{"id":"340503","name":"花山区"},{"id":"340504","name":"雨山区"},{"id":"340506","name":"博望区"},{"id":"340521","name":"当涂县"},{"id":"340522","name":"含山县"},{"id":"340523","name":"和县"}]},{"id":"340600","name":"淮北市","child":[{"id":"340602","name":"杜集区"},{"id":"340603","name":"相山区"},{"id":"340604","name":"烈山区"},{"id":"340621","name":"濉溪县"}]},{"id":"340700","name":"铜陵市","child":[{"id":"340705","name":"铜官区"},{"id":"340706","name":"义安区"},{"id":"340711","name":"郊区"},{"id":"340722","name":"枞阳县"}]},{"id":"340800","name":"安庆市","child":[{"id":"340802","name":"迎江区"},{"id":"340803","name":"大观区"},{"id":"340811","name":"宜秀区"},{"id":"340822","name":"怀宁县"},{"id":"340824","name":"潜山县"},{"id":"340825","name":"太湖县"},{"id":"340826","name":"宿松县"},{"id":"340827","name":"望江县"},{"id":"340828","name":"岳西县"},{"id":"340881","name":"桐城市"}]},{"id":"341000","name":"黄山市","child":[{"id":"341002","name":"屯溪区"},{"id":"341003","name":"黄山区"},{"id":"341004","name":"徽州区"},{"id":"341021","name":"歙县"},{"id":"341022","name":"休宁县"},{"id":"341023","name":"黟县"},{"id":"341024","name":"祁门县"}]},{"id":"341100","name":"滁州市","child":[{"id":"341102","name":"琅琊区"},{"id":"341103","name":"南谯区"},{"id":"341122","name":"来安县"},{"id":"341124","name":"全椒县"},{"id":"341125","name":"定远县"},{"id":"341126","name":"凤阳县"},{"id":"341181","name":"天长市"},{"id":"341182","name":"明光市"}]},{"id":"341200","name":"阜阳市","child":[{"id":"341202","name":"颍州区"},{"id":"341203","name":"颍东区"},{"id":"341204","name":"颍泉区"},{"id":"341221","name":"临泉县"},{"id":"341222","name":"太和县"},{"id":"341225","name":"阜南县"},{"id":"341226","name":"颍上县"},{"id":"341282","name":"界首市"}]},{"id":"341300","name":"宿州市","child":[{"id":"341302","name":"埇桥区"},{"id":"341321","name":"砀山县"},{"id":"341322","name":"萧县"},{"id":"341323","name":"灵璧县"},{"id":"341324","name":"泗县"}]},{"id":"341500","name":"六安市","child":[{"id":"341502","name":"金安区"},{"id":"341503","name":"裕安区"},{"id":"341504","name":"叶集区"},{"id":"341522","name":"霍邱县"},{"id":"341523","name":"舒城县"},{"id":"341524","name":"金寨县"},{"id":"341525","name":"霍山县"}]},{"id":"341600","name":"亳州市","child":[{"id":"341602","name":"谯城区"},{"id":"341621","name":"涡阳县"},{"id":"341622","name":"蒙城县"},{"id":"341623","name":"利辛县"}]},{"id":"341700","name":"池州市","child":[{"id":"341702","name":"贵池区"},{"id":"341721","name":"东至县"},{"id":"341722","name":"石台县"},{"id":"341723","name":"青阳县"}]},{"id":"341800","name":"宣城市","child":[{"id":"341802","name":"宣州区"},{"id":"341821","name":"郎溪县"},{"id":"341822","name":"广德县"},{"id":"341823","name":"泾县"},{"id":"341824","name":"绩溪县"},{"id":"341825","name":"旌德县"},{"id":"341881","name":"宁国市"}]}]},{"id":"350000","name":"福建省","child":[{"id":"350100","name":"福州市","child":[{"id":"350102","name":"鼓楼区"},{"id":"350103","name":"台江区"},{"id":"350104","name":"仓山区"},{"id":"350105","name":"马尾区"},{"id":"350111","name":"晋安区"},{"id":"350121","name":"闽侯县"},{"id":"350122","name":"连江县"},{"id":"350123","name":"罗源县"},{"id":"350124","name":"闽清县"},{"id":"350125","name":"永泰县"},{"id":"350128","name":"平潭县"},{"id":"350181","name":"福清市"},{"id":"350182","name":"长乐市"}]},{"id":"350200","name":"厦门市","child":[{"id":"350203","name":"思明区"},{"id":"350205","name":"海沧区"},{"id":"350206","name":"湖里区"},{"id":"350211","name":"集美区"},{"id":"350212","name":"同安区"},{"id":"350213","name":"翔安区"}]},{"id":"350300","name":"莆田市","child":[{"id":"350302","name":"城厢区"},{"id":"350303","name":"涵江区"},{"id":"350304","name":"荔城区"},{"id":"350305","name":"秀屿区"},{"id":"350322","name":"仙游县"}]},{"id":"350400","name":"三明市","child":[{"id":"350402","name":"梅列区"},{"id":"350403","name":"三元区"},{"id":"350421","name":"明溪县"},{"id":"350423","name":"清流县"},{"id":"350424","name":"宁化县"},{"id":"350425","name":"大田县"},{"id":"350426","name":"尤溪县"},{"id":"350427","name":"沙县"},{"id":"350428","name":"将乐县"},{"id":"350429","name":"泰宁县"},{"id":"350430","name":"建宁县"},{"id":"350481","name":"永安市"}]},{"id":"350500","name":"泉州市","child":[{"id":"350502","name":"鲤城区"},{"id":"350503","name":"丰泽区"},{"id":"350504","name":"洛江区"},{"id":"350505","name":"泉港区"},{"id":"350521","name":"惠安县"},{"id":"350524","name":"安溪县"},{"id":"350525","name":"永春县"},{"id":"350526","name":"德化县"},{"id":"350527","name":"金门县"},{"id":"350581","name":"石狮市"},{"id":"350582","name":"晋江市"},{"id":"350583","name":"南安市"}]},{"id":"350600","name":"漳州市","child":[{"id":"350602","name":"芗城区"},{"id":"350603","name":"龙文区"},{"id":"350622","name":"云霄县"},{"id":"350623","name":"漳浦县"},{"id":"350624","name":"诏安县"},{"id":"350625","name":"长泰县"},{"id":"350626","name":"东山县"},{"id":"350627","name":"南靖县"},{"id":"350628","name":"平和县"},{"id":"350629","name":"华安县"},{"id":"350681","name":"龙海市"}]},{"id":"350700","name":"南平市","child":[{"id":"350702","name":"延平区"},{"id":"350703","name":"建阳区"},{"id":"350721","name":"顺昌县"},{"id":"350722","name":"浦城县"},{"id":"350723","name":"光泽县"},{"id":"350724","name":"松溪县"},{"id":"350725","name":"政和县"},{"id":"350781","name":"邵武市"},{"id":"350782","name":"武夷山市"},{"id":"350783","name":"建瓯市"}]},{"id":"350800","name":"龙岩市","child":[{"id":"350802","name":"新罗区"},{"id":"350803","name":"永定区"},{"id":"350821","name":"长汀县"},{"id":"350823","name":"上杭县"},{"id":"350824","name":"武平县"},{"id":"350825","name":"连城县"},{"id":"350881","name":"漳平市"}]},{"id":"350900","name":"宁德市","child":[{"id":"350902","name":"蕉城区"},{"id":"350921","name":"霞浦县"},{"id":"350922","name":"古田县"},{"id":"350923","name":"屏南县"},{"id":"350924","name":"寿宁县"},{"id":"350925","name":"周宁县"},{"id":"350926","name":"柘荣县"},{"id":"350981","name":"福安市"},{"id":"350982","name":"福鼎市"}]}]},{"id":"360000","name":"江西省","child":[{"id":"360100","name":"南昌市","child":[{"id":"360102","name":"东湖区"},{"id":"360103","name":"西湖区"},{"id":"360104","name":"青云谱区"},{"id":"360105","name":"湾里区"},{"id":"360111","name":"青山湖区"},{"id":"360112","name":"新建区"},{"id":"360121","name":"南昌县"},{"id":"360123","name":"安义县"},{"id":"360124","name":"进贤县"}]},{"id":"360200","name":"景德镇市","child":[{"id":"360202","name":"昌江区"},{"id":"360203","name":"珠山区"},{"id":"360222","name":"浮梁县"},{"id":"360281","name":"乐平市"}]},{"id":"360300","name":"萍乡市","child":[{"id":"360302","name":"安源区"},{"id":"360313","name":"湘东区"},{"id":"360321","name":"莲花县"},{"id":"360322","name":"上栗县"},{"id":"360323","name":"芦溪县"}]},{"id":"360400","name":"九江市","child":[{"id":"360402","name":"濂溪区"},{"id":"360403","name":"浔阳区"},{"id":"360421","name":"九江县"},{"id":"360423","name":"武宁县"},{"id":"360424","name":"修水县"},{"id":"360425","name":"永修县"},{"id":"360426","name":"德安县"},{"id":"360428","name":"都昌县"},{"id":"360429","name":"湖口县"},{"id":"360430","name":"彭泽县"},{"id":"360481","name":"瑞昌市"},{"id":"360482","name":"共青城市"},{"id":"360483","name":"庐山市"}]},{"id":"360500","name":"新余市","child":[{"id":"360502","name":"渝水区"},{"id":"360521","name":"分宜县"}]},{"id":"360600","name":"鹰潭市","child":[{"id":"360602","name":"月湖区"},{"id":"360622","name":"余江县"},{"id":"360681","name":"贵溪市"}]},{"id":"360700","name":"赣州市","child":[{"id":"360702","name":"章贡区"},{"id":"360703","name":"南康区"},{"id":"360704","name":"赣县区"},{"id":"360722","name":"信丰县"},{"id":"360723","name":"大余县"},{"id":"360724","name":"上犹县"},{"id":"360725","name":"崇义县"},{"id":"360726","name":"安远县"},{"id":"360727","name":"龙南县"},{"id":"360728","name":"定南县"},{"id":"360729","name":"全南县"},{"id":"360730","name":"宁都县"},{"id":"360731","name":"于都县"},{"id":"360732","name":"兴国县"},{"id":"360733","name":"会昌县"},{"id":"360734","name":"寻乌县"},{"id":"360735","name":"石城县"},{"id":"360781","name":"瑞金市"}]},{"id":"360800","name":"吉安市","child":[{"id":"360802","name":"吉州区"},{"id":"360803","name":"青原区"},{"id":"360821","name":"吉安县"},{"id":"360822","name":"吉水县"},{"id":"360823","name":"峡江县"},{"id":"360824","name":"新干县"},{"id":"360825","name":"永丰县"},{"id":"360826","name":"泰和县"},{"id":"360827","name":"遂川县"},{"id":"360828","name":"万安县"},{"id":"360829","name":"安福县"},{"id":"360830","name":"永新县"},{"id":"360881","name":"井冈山市"}]},{"id":"360900","name":"宜春市","child":[{"id":"360902","name":"袁州区"},{"id":"360921","name":"奉新县"},{"id":"360922","name":"万载县"},{"id":"360923","name":"上高县"},{"id":"360924","name":"宜丰县"},{"id":"360925","name":"靖安县"},{"id":"360926","name":"铜鼓县"},{"id":"360981","name":"丰城市"},{"id":"360982","name":"樟树市"},{"id":"360983","name":"高安市"}]},{"id":"361000","name":"抚州市","child":[{"id":"361002","name":"临川区"},{"id":"361003","name":"东乡区"},{"id":"361021","name":"南城县"},{"id":"361022","name":"黎川县"},{"id":"361023","name":"南丰县"},{"id":"361024","name":"崇仁县"},{"id":"361025","name":"乐安县"},{"id":"361026","name":"宜黄县"},{"id":"361027","name":"金溪县"},{"id":"361028","name":"资溪县"},{"id":"361030","name":"广昌县"}]},{"id":"361100","name":"上饶市","child":[{"id":"361102","name":"信州区"},{"id":"361103","name":"广丰区"},{"id":"361121","name":"上饶县"},{"id":"361123","name":"玉山县"},{"id":"361124","name":"铅山县"},{"id":"361125","name":"横峰县"},{"id":"361126","name":"弋阳县"},{"id":"361127","name":"余干县"},{"id":"361128","name":"鄱阳县"},{"id":"361129","name":"万年县"},{"id":"361130","name":"婺源县"},{"id":"361181","name":"德兴市"}]}]},{"id":"370000","name":"山东省","child":[{"id":"370100","name":"济南市","child":[{"id":"370102","name":"历下区"},{"id":"370103","name":"市中区"},{"id":"370104","name":"槐荫区"},{"id":"370105","name":"天桥区"},{"id":"370112","name":"历城区"},{"id":"370113","name":"长清区"},{"id":"370114","name":"章丘区"},{"id":"370124","name":"平阴县"},{"id":"370125","name":"济阳县"},{"id":"370126","name":"商河县"}]},{"id":"370200","name":"青岛市","child":[{"id":"370202","name":"市南区"},{"id":"370203","name":"市北区"},{"id":"370211","name":"黄岛区"},{"id":"370212","name":"崂山区"},{"id":"370213","name":"李沧区"},{"id":"370214","name":"城阳区"},{"id":"370281","name":"胶州市"},{"id":"370282","name":"即墨市"},{"id":"370283","name":"平度市"},{"id":"370285","name":"莱西市"}]},{"id":"370300","name":"淄博市","child":[{"id":"370302","name":"淄川区"},{"id":"370303","name":"张店区"},{"id":"370304","name":"博山区"},{"id":"370305","name":"临淄区"},{"id":"370306","name":"周村区"},{"id":"370321","name":"桓台县"},{"id":"370322","name":"高青县"},{"id":"370323","name":"沂源县"}]},{"id":"370400","name":"枣庄市","child":[{"id":"370402","name":"市中区"},{"id":"370403","name":"薛城区"},{"id":"370404","name":"峄城区"},{"id":"370405","name":"台儿庄区"},{"id":"370406","name":"山亭区"},{"id":"370481","name":"滕州市"}]},{"id":"370500","name":"东营市","child":[{"id":"370502","name":"东营区"},{"id":"370503","name":"河口区"},{"id":"370505","name":"垦利区"},{"id":"370522","name":"利津县"},{"id":"370523","name":"广饶县"}]},{"id":"370600","name":"烟台市","child":[{"id":"370602","name":"芝罘区"},{"id":"370611","name":"福山区"},{"id":"370612","name":"牟平区"},{"id":"370613","name":"莱山区"},{"id":"370634","name":"长岛县"},{"id":"370681","name":"龙口市"},{"id":"370682","name":"莱阳市"},{"id":"370683","name":"莱州市"},{"id":"370684","name":"蓬莱市"},{"id":"370685","name":"招远市"},{"id":"370686","name":"栖霞市"},{"id":"370687","name":"海阳市"}]},{"id":"370700","name":"潍坊市","child":[{"id":"370702","name":"潍城区"},{"id":"370703","name":"寒亭区"},{"id":"370704","name":"坊子区"},{"id":"370705","name":"奎文区"},{"id":"370724","name":"临朐县"},{"id":"370725","name":"昌乐县"},{"id":"370781","name":"青州市"},{"id":"370782","name":"诸城市"},{"id":"370783","name":"寿光市"},{"id":"370784","name":"安丘市"},{"id":"370785","name":"高密市"},{"id":"370786","name":"昌邑市"}]},{"id":"370800","name":"济宁市","child":[{"id":"370811","name":"任城区"},{"id":"370812","name":"兖州区"},{"id":"370826","name":"微山县"},{"id":"370827","name":"鱼台县"},{"id":"370828","name":"金乡县"},{"id":"370829","name":"嘉祥县"},{"id":"370830","name":"汶上县"},{"id":"370831","name":"泗水县"},{"id":"370832","name":"梁山县"},{"id":"370881","name":"曲阜市"},{"id":"370883","name":"邹城市"}]},{"id":"370900","name":"泰安市","child":[{"id":"370902","name":"泰山区"},{"id":"370911","name":"岱岳区"},{"id":"370921","name":"宁阳县"},{"id":"370923","name":"东平县"},{"id":"370982","name":"新泰市"},{"id":"370983","name":"肥城市"}]},{"id":"371000","name":"威海市","child":[{"id":"371002","name":"环翠区"},{"id":"371003","name":"文登区"},{"id":"371082","name":"荣成市"},{"id":"371083","name":"乳山市"}]},{"id":"371100","name":"日照市","child":[{"id":"371102","name":"东港区"},{"id":"371103","name":"岚山区"},{"id":"371121","name":"五莲县"},{"id":"371122","name":"莒县"}]},{"id":"371200","name":"莱芜市","child":[{"id":"371202","name":"莱城区"},{"id":"371203","name":"钢城区"}]},{"id":"371300","name":"临沂市","child":[{"id":"371302","name":"兰山区"},{"id":"371311","name":"罗庄区"},{"id":"371312","name":"河东区"},{"id":"371321","name":"沂南县"},{"id":"371322","name":"郯城县"},{"id":"371323","name":"沂水县"},{"id":"371324","name":"兰陵县"},{"id":"371325","name":"费县"},{"id":"371326","name":"平邑县"},{"id":"371327","name":"莒南县"},{"id":"371328","name":"蒙阴县"},{"id":"371329","name":"临沭县"}]},{"id":"371400","name":"德州市","child":[{"id":"371402","name":"德城区"},{"id":"371403","name":"陵城区"},{"id":"371422","name":"宁津县"},{"id":"371423","name":"庆云县"},{"id":"371424","name":"临邑县"},{"id":"371425","name":"齐河县"},{"id":"371426","name":"平原县"},{"id":"371427","name":"夏津县"},{"id":"371428","name":"武城县"},{"id":"371481","name":"乐陵市"},{"id":"371482","name":"禹城市"}]},{"id":"371500","name":"聊城市","child":[{"id":"371502","name":"东昌府区"},{"id":"371521","name":"阳谷县"},{"id":"371522","name":"莘县"},{"id":"371523","name":"茌平县"},{"id":"371524","name":"东阿县"},{"id":"371525","name":"冠县"},{"id":"371526","name":"高唐县"},{"id":"371581","name":"临清市"}]},{"id":"371600","name":"滨州市","child":[{"id":"371602","name":"滨城区"},{"id":"371603","name":"沾化区"},{"id":"371621","name":"惠民县"},{"id":"371622","name":"阳信县"},{"id":"371623","name":"无棣县"},{"id":"371625","name":"博兴县"},{"id":"371626","name":"邹平县"}]},{"id":"371700","name":"菏泽市","child":[{"id":"371702","name":"牡丹区"},{"id":"371703","name":"定陶区"},{"id":"371721","name":"曹县"},{"id":"371722","name":"单县"},{"id":"371723","name":"成武县"},{"id":"371724","name":"巨野县"},{"id":"371725","name":"郓城县"},{"id":"371726","name":"鄄城县"},{"id":"371728","name":"东明县"}]}]},{"id":"410000","name":"河南省","child":[{"id":"410100","name":"郑州市","child":[{"id":"410102","name":"中原区"},{"id":"410103","name":"二七区"},{"id":"410104","name":"管城回族区"},{"id":"410105","name":"金水区"},{"id":"410106","name":"上街区"},{"id":"410108","name":"惠济区"},{"id":"410122","name":"中牟县"},{"id":"410181","name":"巩义市"},{"id":"410182","name":"荥阳市"},{"id":"410183","name":"新密市"},{"id":"410184","name":"新郑市"},{"id":"410185","name":"登封市"}]},{"id":"410200","name":"开封市","child":[{"id":"410202","name":"龙亭区"},{"id":"410203","name":"顺河回族区"},{"id":"410204","name":"鼓楼区"},{"id":"410205","name":"禹王台区"},{"id":"410212","name":"祥符区"},{"id":"410221","name":"杞县"},{"id":"410222","name":"通许县"},{"id":"410223","name":"尉氏县"},{"id":"410225","name":"兰考县"}]},{"id":"410300","name":"洛阳市","child":[{"id":"410302","name":"老城区"},{"id":"410303","name":"西工区"},{"id":"410304","name":"瀍河回族区"},{"id":"410305","name":"涧西区"},{"id":"410306","name":"吉利区"},{"id":"410311","name":"洛龙区"},{"id":"410322","name":"孟津县"},{"id":"410323","name":"新安县"},{"id":"410324","name":"栾川县"},{"id":"410325","name":"嵩县"},{"id":"410326","name":"汝阳县"},{"id":"410327","name":"宜阳县"},{"id":"410328","name":"洛宁县"},{"id":"410329","name":"伊川县"},{"id":"410381","name":"偃师市"}]},{"id":"410400","name":"平顶山市","child":[{"id":"410402","name":"新华区"},{"id":"410403","name":"卫东区"},{"id":"410404","name":"石龙区"},{"id":"410411","name":"湛河区"},{"id":"410421","name":"宝丰县"},{"id":"410422","name":"叶县"},{"id":"410423","name":"鲁山县"},{"id":"410425","name":"郏县"},{"id":"410481","name":"舞钢市"},{"id":"410482","name":"汝州市"}]},{"id":"410500","name":"安阳市","child":[{"id":"410502","name":"文峰区"},{"id":"410503","name":"北关区"},{"id":"410505","name":"殷都区"},{"id":"410506","name":"龙安区"},{"id":"410522","name":"安阳县"},{"id":"410523","name":"汤阴县"},{"id":"410526","name":"滑县"},{"id":"410527","name":"内黄县"},{"id":"410581","name":"林州市"}]},{"id":"410600","name":"鹤壁市","child":[{"id":"410602","name":"鹤山区"},{"id":"410603","name":"山城区"},{"id":"410611","name":"淇滨区"},{"id":"410621","name":"浚县"},{"id":"410622","name":"淇县"}]},{"id":"410700","name":"新乡市","child":[{"id":"410702","name":"红旗区"},{"id":"410703","name":"卫滨区"},{"id":"410704","name":"凤泉区"},{"id":"410711","name":"牧野区"},{"id":"410721","name":"新乡县"},{"id":"410724","name":"获嘉县"},{"id":"410725","name":"原阳县"},{"id":"410726","name":"延津县"},{"id":"410727","name":"封丘县"},{"id":"410728","name":"长垣县"},{"id":"410781","name":"卫辉市"},{"id":"410782","name":"辉县市"}]},{"id":"410800","name":"焦作市","child":[{"id":"410802","name":"解放区"},{"id":"410803","name":"中站区"},{"id":"410804","name":"马村区"},{"id":"410811","name":"山阳区"},{"id":"410821","name":"修武县"},{"id":"410822","name":"博爱县"},{"id":"410823","name":"武陟县"},{"id":"410825","name":"温县"},{"id":"410882","name":"沁阳市"},{"id":"410883","name":"孟州市"}]},{"id":"410900","name":"濮阳市","child":[{"id":"410902","name":"华龙区"},{"id":"410922","name":"清丰县"},{"id":"410923","name":"南乐县"},{"id":"410926","name":"范县"},{"id":"410927","name":"台前县"},{"id":"410928","name":"濮阳县"}]},{"id":"411000","name":"许昌市","child":[{"id":"411002","name":"魏都区"},{"id":"411003","name":"建安区"},{"id":"411024","name":"鄢陵县"},{"id":"411025","name":"襄城县"},{"id":"411081","name":"禹州市"},{"id":"411082","name":"长葛市"}]},{"id":"411100","name":"漯河市","child":[{"id":"411102","name":"源汇区"},{"id":"411103","name":"郾城区"},{"id":"411104","name":"召陵区"},{"id":"411121","name":"舞阳县"},{"id":"411122","name":"临颍县"}]},{"id":"411200","name":"三门峡市","child":[{"id":"411202","name":"湖滨区"},{"id":"411203","name":"陕州区"},{"id":"411221","name":"渑池县"},{"id":"411224","name":"卢氏县"},{"id":"411281","name":"义马市"},{"id":"411282","name":"灵宝市"}]},{"id":"411300","name":"南阳市","child":[{"id":"411302","name":"宛城区"},{"id":"411303","name":"卧龙区"},{"id":"411321","name":"南召县"},{"id":"411322","name":"方城县"},{"id":"411323","name":"西峡县"},{"id":"411324","name":"镇平县"},{"id":"411325","name":"内乡县"},{"id":"411326","name":"淅川县"},{"id":"411327","name":"社旗县"},{"id":"411328","name":"唐河县"},{"id":"411329","name":"新野县"},{"id":"411330","name":"桐柏县"},{"id":"411381","name":"邓州市"}]},{"id":"411400","name":"商丘市","child":[{"id":"411402","name":"梁园区"},{"id":"411403","name":"睢阳区"},{"id":"411421","name":"民权县"},{"id":"411422","name":"睢县"},{"id":"411423","name":"宁陵县"},{"id":"411424","name":"柘城县"},{"id":"411425","name":"虞城县"},{"id":"411426","name":"夏邑县"},{"id":"411481","name":"永城市"}]},{"id":"411500","name":"信阳市","child":[{"id":"411502","name":"浉河区"},{"id":"411503","name":"平桥区"},{"id":"411521","name":"罗山县"},{"id":"411522","name":"光山县"},{"id":"411523","name":"新县"},{"id":"411524","name":"商城县"},{"id":"411525","name":"固始县"},{"id":"411526","name":"潢川县"},{"id":"411527","name":"淮滨县"},{"id":"411528","name":"息县"}]},{"id":"411600","name":"周口市","child":[{"id":"411602","name":"川汇区"},{"id":"411621","name":"扶沟县"},{"id":"411622","name":"西华县"},{"id":"411623","name":"商水县"},{"id":"411624","name":"沈丘县"},{"id":"411625","name":"郸城县"},{"id":"411626","name":"淮阳县"},{"id":"411627","name":"太康县"},{"id":"411628","name":"鹿邑县"},{"id":"411681","name":"项城市"}]},{"id":"411700","name":"驻马店市","child":[{"id":"411702","name":"驿城区"},{"id":"411721","name":"西平县"},{"id":"411722","name":"上蔡县"},{"id":"411723","name":"平舆县"},{"id":"411724","name":"正阳县"},{"id":"411725","name":"确山县"},{"id":"411726","name":"泌阳县"},{"id":"411727","name":"汝南县"},{"id":"411728","name":"遂平县"},{"id":"411729","name":"新蔡县"}]},{"id":"419001","name":"济源市"}]},{"id":"420000","name":"湖北省","child":[{"id":"420100","name":"武汉市","child":[{"id":"420102","name":"江岸区"},{"id":"420103","name":"江汉区"},{"id":"420104","name":"硚口区"},{"id":"420105","name":"汉阳区"},{"id":"420106","name":"武昌区"},{"id":"420107","name":"青山区"},{"id":"420111","name":"洪山区"},{"id":"420112","name":"东西湖区"},{"id":"420113","name":"汉南区"},{"id":"420114","name":"蔡甸区"},{"id":"420115","name":"江夏区"},{"id":"420116","name":"黄陂区"},{"id":"420117","name":"新洲区"}]},{"id":"420200","name":"黄石市","child":[{"id":"420202","name":"黄石港区"},{"id":"420203","name":"西塞山区"},{"id":"420204","name":"下陆区"},{"id":"420205","name":"铁山区"},{"id":"420222","name":"阳新县"},{"id":"420281","name":"大冶市"}]},{"id":"420300","name":"十堰市","child":[{"id":"420302","name":"茅箭区"},{"id":"420303","name":"张湾区"},{"id":"420304","name":"郧阳区"},{"id":"420322","name":"郧西县"},{"id":"420323","name":"竹山县"},{"id":"420324","name":"竹溪县"},{"id":"420325","name":"房县"},{"id":"420381","name":"丹江口市"}]},{"id":"420500","name":"宜昌市","child":[{"id":"420502","name":"西陵区"},{"id":"420503","name":"伍家岗区"},{"id":"420504","name":"点军区"},{"id":"420505","name":"猇亭区"},{"id":"420506","name":"夷陵区"},{"id":"420525","name":"远安县"},{"id":"420526","name":"兴山县"},{"id":"420527","name":"秭归县"},{"id":"420528","name":"长阳土家族自治县"},{"id":"420529","name":"五峰土家族自治县"},{"id":"420581","name":"宜都市"},{"id":"420582","name":"当阳市"},{"id":"420583","name":"枝江市"}]},{"id":"420600","name":"襄阳市","child":[{"id":"420602","name":"襄城区"},{"id":"420606","name":"樊城区"},{"id":"420607","name":"襄州区"},{"id":"420624","name":"南漳县"},{"id":"420625","name":"谷城县"},{"id":"420626","name":"保康县"},{"id":"420682","name":"老河口市"},{"id":"420683","name":"枣阳市"},{"id":"420684","name":"宜城市"}]},{"id":"420700","name":"鄂州市","child":[{"id":"420702","name":"梁子湖区"},{"id":"420703","name":"华容区"},{"id":"420704","name":"鄂城区"}]},{"id":"420800","name":"荆门市","child":[{"id":"420802","name":"东宝区"},{"id":"420804","name":"掇刀区"},{"id":"420821","name":"京山县"},{"id":"420822","name":"沙洋县"},{"id":"420881","name":"钟祥市"}]},{"id":"420900","name":"孝感市","child":[{"id":"420902","name":"孝南区"},{"id":"420921","name":"孝昌县"},{"id":"420922","name":"大悟县"},{"id":"420923","name":"云梦县"},{"id":"420981","name":"应城市"},{"id":"420982","name":"安陆市"},{"id":"420984","name":"汉川市"}]},{"id":"421000","name":"荆州市","child":[{"id":"421002","name":"沙市区"},{"id":"421003","name":"荆州区"},{"id":"421022","name":"公安县"},{"id":"421023","name":"监利县"},{"id":"421024","name":"江陵县"},{"id":"421081","name":"石首市"},{"id":"421083","name":"洪湖市"},{"id":"421087","name":"松滋市"}]},{"id":"421100","name":"黄冈市","child":[{"id":"421102","name":"黄州区"},{"id":"421121","name":"团风县"},{"id":"421122","name":"红安县"},{"id":"421123","name":"罗田县"},{"id":"421124","name":"英山县"},{"id":"421125","name":"浠水县"},{"id":"421126","name":"蕲春县"},{"id":"421127","name":"黄梅县"},{"id":"421181","name":"麻城市"},{"id":"421182","name":"武穴市"}]},{"id":"421200","name":"咸宁市","child":[{"id":"421202","name":"咸安区"},{"id":"421221","name":"嘉鱼县"},{"id":"421222","name":"通城县"},{"id":"421223","name":"崇阳县"},{"id":"421224","name":"通山县"},{"id":"421281","name":"赤壁市"}]},{"id":"421300","name":"随州市","child":[{"id":"421303","name":"曾都区"},{"id":"421321","name":"随县"},{"id":"421381","name":"广水市"}]},{"id":"422800","name":"恩施土家族苗族自治州","child":[{"id":"422801","name":"恩施市"},{"id":"422802","name":"利川市"},{"id":"422822","name":"建始县"},{"id":"422823","name":"巴东县"},{"id":"422825","name":"宣恩县"},{"id":"422826","name":"咸丰县"},{"id":"422827","name":"来凤县"},{"id":"422828","name":"鹤峰县"}]},{"id":"429004","name":"仙桃市"},{"id":"429005","name":"潜江市"},{"id":"429006","name":"天门市"},{"id":"429021","name":"神农架林区"}]},{"id":"430000","name":"湖南省","child":[{"id":"430100","name":"长沙市","child":[{"id":"430102","name":"芙蓉区"},{"id":"430103","name":"天心区"},{"id":"430104","name":"岳麓区"},{"id":"430105","name":"开福区"},{"id":"430111","name":"雨花区"},{"id":"430112","name":"望城区"},{"id":"430121","name":"长沙县"},{"id":"430124","name":"宁乡县"},{"id":"430181","name":"浏阳市"}]},{"id":"430200","name":"株洲市","child":[{"id":"430202","name":"荷塘区"},{"id":"430203","name":"芦淞区"},{"id":"430204","name":"石峰区"},{"id":"430211","name":"天元区"},{"id":"430221","name":"株洲县"},{"id":"430223","name":"攸县"},{"id":"430224","name":"茶陵县"},{"id":"430225","name":"炎陵县"},{"id":"430281","name":"醴陵市"}]},{"id":"430300","name":"湘潭市","child":[{"id":"430302","name":"雨湖区"},{"id":"430304","name":"岳塘区"},{"id":"430321","name":"湘潭县"},{"id":"430381","name":"湘乡市"},{"id":"430382","name":"韶山市"}]},{"id":"430400","name":"衡阳市","child":[{"id":"430405","name":"珠晖区"},{"id":"430406","name":"雁峰区"},{"id":"430407","name":"石鼓区"},{"id":"430408","name":"蒸湘区"},{"id":"430412","name":"南岳区"},{"id":"430421","name":"衡阳县"},{"id":"430422","name":"衡南县"},{"id":"430423","name":"衡山县"},{"id":"430424","name":"衡东县"},{"id":"430426","name":"祁东县"},{"id":"430481","name":"耒阳市"},{"id":"430482","name":"常宁市"}]},{"id":"430500","name":"邵阳市","child":[{"id":"430502","name":"双清区"},{"id":"430503","name":"大祥区"},{"id":"430511","name":"北塔区"},{"id":"430521","name":"邵东县"},{"id":"430522","name":"新邵县"},{"id":"430523","name":"邵阳县"},{"id":"430524","name":"隆回县"},{"id":"430525","name":"洞口县"},{"id":"430527","name":"绥宁县"},{"id":"430528","name":"新宁县"},{"id":"430529","name":"城步苗族自治县"},{"id":"430581","name":"武冈市"}]},{"id":"430600","name":"岳阳市","child":[{"id":"430602","name":"岳阳楼区"},{"id":"430603","name":"云溪区"},{"id":"430611","name":"君山区"},{"id":"430621","name":"岳阳县"},{"id":"430623","name":"华容县"},{"id":"430624","name":"湘阴县"},{"id":"430626","name":"平江县"},{"id":"430681","name":"汨罗市"},{"id":"430682","name":"临湘市"}]},{"id":"430700","name":"常德市","child":[{"id":"430702","name":"武陵区"},{"id":"430703","name":"鼎城区"},{"id":"430721","name":"安乡县"},{"id":"430722","name":"汉寿县"},{"id":"430723","name":"澧县"},{"id":"430724","name":"临澧县"},{"id":"430725","name":"桃源县"},{"id":"430726","name":"石门县"},{"id":"430781","name":"津市市"}]},{"id":"430800","name":"张家界市","child":[{"id":"430802","name":"永定区"},{"id":"430811","name":"武陵源区"},{"id":"430821","name":"慈利县"},{"id":"430822","name":"桑植县"}]},{"id":"430900","name":"益阳市","child":[{"id":"430902","name":"资阳区"},{"id":"430903","name":"赫山区"},{"id":"430921","name":"南县"},{"id":"430922","name":"桃江县"},{"id":"430923","name":"安化县"},{"id":"430981","name":"沅江市"}]},{"id":"431000","name":"郴州市","child":[{"id":"431002","name":"北湖区"},{"id":"431003","name":"苏仙区"},{"id":"431021","name":"桂阳县"},{"id":"431022","name":"宜章县"},{"id":"431023","name":"永兴县"},{"id":"431024","name":"嘉禾县"},{"id":"431025","name":"临武县"},{"id":"431026","name":"汝城县"},{"id":"431027","name":"桂东县"},{"id":"431028","name":"安仁县"},{"id":"431081","name":"资兴市"}]},{"id":"431100","name":"永州市","child":[{"id":"431102","name":"零陵区"},{"id":"431103","name":"冷水滩区"},{"id":"431121","name":"祁阳县"},{"id":"431122","name":"东安县"},{"id":"431123","name":"双牌县"},{"id":"431124","name":"道县"},{"id":"431125","name":"江永县"},{"id":"431126","name":"宁远县"},{"id":"431127","name":"蓝山县"},{"id":"431128","name":"新田县"},{"id":"431129","name":"江华瑶族自治县"}]},{"id":"431200","name":"怀化市","child":[{"id":"431202","name":"鹤城区"},{"id":"431221","name":"中方县"},{"id":"431222","name":"沅陵县"},{"id":"431223","name":"辰溪县"},{"id":"431224","name":"溆浦县"},{"id":"431225","name":"会同县"},{"id":"431226","name":"麻阳苗族自治县"},{"id":"431227","name":"新晃侗族自治县"},{"id":"431228","name":"芷江侗族自治县"},{"id":"431229","name":"靖州苗族侗族自治县"},{"id":"431230","name":"通道侗族自治县"},{"id":"431281","name":"洪江市"}]},{"id":"431300","name":"娄底市","child":[{"id":"431302","name":"娄星区"},{"id":"431321","name":"双峰县"},{"id":"431322","name":"新化县"},{"id":"431381","name":"冷水江市"},{"id":"431382","name":"涟源市"}]},{"id":"433100","name":"湘西土家族苗族自治州","child":[{"id":"433101","name":"吉首市"},{"id":"433122","name":"泸溪县"},{"id":"433123","name":"凤凰县"},{"id":"433124","name":"花垣县"},{"id":"433125","name":"保靖县"},{"id":"433126","name":"古丈县"},{"id":"433127","name":"永顺县"},{"id":"433130","name":"龙山县"}]}]},{"id":"440000","name":"广东省","child":[{"id":"440100","name":"广州市","child":[{"id":"440103","name":"荔湾区"},{"id":"440104","name":"越秀区"},{"id":"440105","name":"海珠区"},{"id":"440106","name":"天河区"},{"id":"440111","name":"白云区"},{"id":"440112","name":"黄埔区"},{"id":"440113","name":"番禺区"},{"id":"440114","name":"花都区"},{"id":"440115","name":"南沙区"},{"id":"440117","name":"从化区"},{"id":"440118","name":"增城区"}]},{"id":"440200","name":"韶关市","child":[{"id":"440203","name":"武江区"},{"id":"440204","name":"浈江区"},{"id":"440205","name":"曲江区"},{"id":"440222","name":"始兴县"},{"id":"440224","name":"仁化县"},{"id":"440229","name":"翁源县"},{"id":"440232","name":"乳源瑶族自治县"},{"id":"440233","name":"新丰县"},{"id":"440281","name":"乐昌市"},{"id":"440282","name":"南雄市"}]},{"id":"440300","name":"深圳市","child":[{"id":"440303","name":"罗湖区"},{"id":"440304","name":"福田区"},{"id":"440305","name":"南山区"},{"id":"440306","name":"宝安区"},{"id":"440307","name":"龙岗区"},{"id":"440308","name":"盐田区"},{"id":"440309","name":"龙华区"},{"id":"440310","name":"坪山区"}]},{"id":"440400","name":"珠海市","child":[{"id":"440402","name":"香洲区"},{"id":"440403","name":"斗门区"},{"id":"440404","name":"金湾区"}]},{"id":"440500","name":"汕头市","child":[{"id":"440507","name":"龙湖区"},{"id":"440511","name":"金平区"},{"id":"440512","name":"濠江区"},{"id":"440513","name":"潮阳区"},{"id":"440514","name":"潮南区"},{"id":"440515","name":"澄海区"},{"id":"440523","name":"南澳县"}]},{"id":"440600","name":"佛山市","child":[{"id":"440604","name":"禅城区"},{"id":"440605","name":"南海区"},{"id":"440606","name":"顺德区"},{"id":"440607","name":"三水区"},{"id":"440608","name":"高明区"}]},{"id":"440700","name":"江门市","child":[{"id":"440703","name":"蓬江区"},{"id":"440704","name":"江海区"},{"id":"440705","name":"新会区"},{"id":"440781","name":"台山市"},{"id":"440783","name":"开平市"},{"id":"440784","name":"鹤山市"},{"id":"440785","name":"恩平市"}]},{"id":"440800","name":"湛江市","child":[{"id":"440802","name":"赤坎区"},{"id":"440803","name":"霞山区"},{"id":"440804","name":"坡头区"},{"id":"440811","name":"麻章区"},{"id":"440823","name":"遂溪县"},{"id":"440825","name":"徐闻县"},{"id":"440881","name":"廉江市"},{"id":"440882","name":"雷州市"},{"id":"440883","name":"吴川市"}]},{"id":"440900","name":"茂名市","child":[{"id":"440902","name":"茂南区"},{"id":"440904","name":"电白区"},{"id":"440981","name":"高州市"},{"id":"440982","name":"化州市"},{"id":"440983","name":"信宜市"}]},{"id":"441200","name":"肇庆市","child":[{"id":"441202","name":"端州区"},{"id":"441203","name":"鼎湖区"},{"id":"441204","name":"高要区"},{"id":"441223","name":"广宁县"},{"id":"441224","name":"怀集县"},{"id":"441225","name":"封开县"},{"id":"441226","name":"德庆县"},{"id":"441284","name":"四会市"}]},{"id":"441300","name":"惠州市","child":[{"id":"441302","name":"惠城区"},{"id":"441303","name":"惠阳区"},{"id":"441322","name":"博罗县"},{"id":"441323","name":"惠东县"},{"id":"441324","name":"龙门县"}]},{"id":"441400","name":"梅州市","child":[{"id":"441402","name":"梅江区"},{"id":"441403","name":"梅县区"},{"id":"441422","name":"大埔县"},{"id":"441423","name":"丰顺县"},{"id":"441424","name":"五华县"},{"id":"441426","name":"平远县"},{"id":"441427","name":"蕉岭县"},{"id":"441481","name":"兴宁市"}]},{"id":"441500","name":"汕尾市","child":[{"id":"441502","name":"城区"},{"id":"441521","name":"海丰县"},{"id":"441523","name":"陆河县"},{"id":"441581","name":"陆丰市"}]},{"id":"441600","name":"河源市","child":[{"id":"441602","name":"源城区"},{"id":"441621","name":"紫金县"},{"id":"441622","name":"龙川县"},{"id":"441623","name":"连平县"},{"id":"441624","name":"和平县"},{"id":"441625","name":"东源县"}]},{"id":"441700","name":"阳江市","child":[{"id":"441702","name":"江城区"},{"id":"441704","name":"阳东区"},{"id":"441721","name":"阳西县"},{"id":"441781","name":"阳春市"}]},{"id":"441800","name":"清远市","child":[{"id":"441802","name":"清城区"},{"id":"441803","name":"清新区"},{"id":"441821","name":"佛冈县"},{"id":"441823","name":"阳山县"},{"id":"441825","name":"连山壮族瑶族自治县"},{"id":"441826","name":"连南瑶族自治县"},{"id":"441881","name":"英德市"},{"id":"441882","name":"连州市"}]},{"id":"441900","name":"东莞市","child":[{"id":"441999","name":"东莞市"}]},{"id":"442000","name":"中山市","child":[{"id":"442099","name":"中山市"}]},{"id":"445100","name":"潮州市","child":[{"id":"445102","name":"湘桥区"},{"id":"445103","name":"潮安区"},{"id":"445122","name":"饶平县"}]},{"id":"445200","name":"揭阳市","child":[{"id":"445202","name":"榕城区"},{"id":"445203","name":"揭东区"},{"id":"445222","name":"揭西县"},{"id":"445224","name":"惠来县"},{"id":"445281","name":"普宁市"}]},{"id":"445300","name":"云浮市","child":[{"id":"445302","name":"云城区"},{"id":"445303","name":"云安区"},{"id":"445321","name":"新兴县"},{"id":"445322","name":"郁南县"},{"id":"445381","name":"罗定市"}]}]},{"id":"450000","name":"广西壮族自治区","child":[{"id":"450100","name":"南宁市","child":[{"id":"450102","name":"兴宁区"},{"id":"450103","name":"青秀区"},{"id":"450105","name":"江南区"},{"id":"450107","name":"西乡塘区"},{"id":"450108","name":"良庆区"},{"id":"450109","name":"邕宁区"},{"id":"450110","name":"武鸣区"},{"id":"450123","name":"隆安县"},{"id":"450124","name":"马山县"},{"id":"450125","name":"上林县"},{"id":"450126","name":"宾阳县"},{"id":"450127","name":"横县"}]},{"id":"450200","name":"柳州市","child":[{"id":"450202","name":"城中区"},{"id":"450203","name":"鱼峰区"},{"id":"450204","name":"柳南区"},{"id":"450205","name":"柳北区"},{"id":"450206","name":"柳江区"},{"id":"450222","name":"柳城县"},{"id":"450223","name":"鹿寨县"},{"id":"450224","name":"融安县"},{"id":"450225","name":"融水苗族自治县"},{"id":"450226","name":"三江侗族自治县"}]},{"id":"450300","name":"桂林市","child":[{"id":"450302","name":"秀峰区"},{"id":"450303","name":"叠彩区"},{"id":"450304","name":"象山区"},{"id":"450305","name":"七星区"},{"id":"450311","name":"雁山区"},{"id":"450312","name":"临桂区"},{"id":"450321","name":"阳朔县"},{"id":"450323","name":"灵川县"},{"id":"450324","name":"全州县"},{"id":"450325","name":"兴安县"},{"id":"450326","name":"永福县"},{"id":"450327","name":"灌阳县"},{"id":"450328","name":"龙胜各族自治县"},{"id":"450329","name":"资源县"},{"id":"450330","name":"平乐县"},{"id":"450331","name":"荔浦县"},{"id":"450332","name":"恭城瑶族自治县"}]},{"id":"450400","name":"梧州市","child":[{"id":"450403","name":"万秀区"},{"id":"450405","name":"长洲区"},{"id":"450406","name":"龙圩区"},{"id":"450421","name":"苍梧县"},{"id":"450422","name":"藤县"},{"id":"450423","name":"蒙山县"},{"id":"450481","name":"岑溪市"}]},{"id":"450500","name":"北海市","child":[{"id":"450502","name":"海城区"},{"id":"450503","name":"银海区"},{"id":"450512","name":"铁山港区"},{"id":"450521","name":"合浦县"}]},{"id":"450600","name":"防城港市","child":[{"id":"450602","name":"港口区"},{"id":"450603","name":"防城区"},{"id":"450621","name":"上思县"},{"id":"450681","name":"东兴市"}]},{"id":"450700","name":"钦州市","child":[{"id":"450702","name":"钦南区"},{"id":"450703","name":"钦北区"},{"id":"450721","name":"灵山县"},{"id":"450722","name":"浦北县"}]},{"id":"450800","name":"贵港市","child":[{"id":"450802","name":"港北区"},{"id":"450803","name":"港南区"},{"id":"450804","name":"覃塘区"},{"id":"450821","name":"平南县"},{"id":"450881","name":"桂平市"}]},{"id":"450900","name":"玉林市","child":[{"id":"450902","name":"玉州区"},{"id":"450903","name":"福绵区"},{"id":"450921","name":"容县"},{"id":"450922","name":"陆川县"},{"id":"450923","name":"博白县"},{"id":"450924","name":"兴业县"},{"id":"450981","name":"北流市"}]},{"id":"451000","name":"百色市","child":[{"id":"451002","name":"右江区"},{"id":"451021","name":"田阳县"},{"id":"451022","name":"田东县"},{"id":"451023","name":"平果县"},{"id":"451024","name":"德保县"},{"id":"451026","name":"那坡县"},{"id":"451027","name":"凌云县"},{"id":"451028","name":"乐业县"},{"id":"451029","name":"田林县"},{"id":"451030","name":"西林县"},{"id":"451031","name":"隆林各族自治县"},{"id":"451081","name":"靖西市"}]},{"id":"451100","name":"贺州市","child":[{"id":"451102","name":"八步区"},{"id":"451103","name":"平桂区"},{"id":"451121","name":"昭平县"},{"id":"451122","name":"钟山县"},{"id":"451123","name":"富川瑶族自治县"}]},{"id":"451200","name":"河池市","child":[{"id":"451202","name":"金城江区"},{"id":"451203","name":"宜州区"},{"id":"451221","name":"南丹县"},{"id":"451222","name":"天峨县"},{"id":"451223","name":"凤山县"},{"id":"451224","name":"东兰县"},{"id":"451225","name":"罗城仫佬族自治县"},{"id":"451226","name":"环江毛南族自治县"},{"id":"451227","name":"巴马瑶族自治县"},{"id":"451228","name":"都安瑶族自治县"},{"id":"451229","name":"大化瑶族自治县"}]},{"id":"451300","name":"来宾市","child":[{"id":"451302","name":"兴宾区"},{"id":"451321","name":"忻城县"},{"id":"451322","name":"象州县"},{"id":"451323","name":"武宣县"},{"id":"451324","name":"金秀瑶族自治县"},{"id":"451381","name":"合山市"}]},{"id":"451400","name":"崇左市","child":[{"id":"451402","name":"江州区"},{"id":"451421","name":"扶绥县"},{"id":"451422","name":"宁明县"},{"id":"451423","name":"龙州县"},{"id":"451424","name":"大新县"},{"id":"451425","name":"天等县"},{"id":"451481","name":"凭祥市"}]}]},{"id":"460000","name":"海南省","child":[{"id":"460100","name":"海口市","child":[{"id":"460105","name":"秀英区"},{"id":"460106","name":"龙华区"},{"id":"460107","name":"琼山区"},{"id":"460108","name":"美兰区"}]},{"id":"460200","name":"三亚市","child":[{"id":"460202","name":"海棠区"},{"id":"460203","name":"吉阳区"},{"id":"460204","name":"天涯区"},{"id":"460205","name":"崖州区"}]},{"id":"460300","name":"三沙市","child":[{"id":"460321","name":"西沙群岛"},{"id":"460322","name":"南沙群岛"},{"id":"460323","name":"中沙群岛的岛礁及其海域"}]},{"id":"460400","name":"儋州市","child":[{"id":"460499","name":"儋州市"}]},{"id":"469001","name":"五指山市"},{"id":"469002","name":"琼海市"},{"id":"469005","name":"文昌市"},{"id":"469006","name":"万宁市"},{"id":"469007","name":"东方市"},{"id":"469021","name":"定安县"},{"id":"469022","name":"屯昌县"},{"id":"469023","name":"澄迈县"},{"id":"469024","name":"临高县"},{"id":"469025","name":"白沙黎族自治县"},{"id":"469026","name":"昌江黎族自治县"},{"id":"469027","name":"乐东黎族自治县"},{"id":"469028","name":"陵水黎族自治县"},{"id":"469029","name":"保亭黎族苗族自治县"},{"id":"469030","name":"琼中黎族苗族自治县"}]},{"id":"500000","name":"重庆市","child":[{"id":"500101","name":"万州区"},{"id":"500102","name":"涪陵区"},{"id":"500103","name":"渝中区"},{"id":"500104","name":"大渡口区"},{"id":"500105","name":"江北区"},{"id":"500106","name":"沙坪坝区"},{"id":"500107","name":"九龙坡区"},{"id":"500108","name":"南岸区"},{"id":"500109","name":"北碚区"},{"id":"500110","name":"綦江区"},{"id":"500111","name":"大足区"},{"id":"500112","name":"渝北区"},{"id":"500113","name":"巴南区"},{"id":"500114","name":"黔江区"},{"id":"500115","name":"长寿区"},{"id":"500116","name":"江津区"},{"id":"500117","name":"合川区"},{"id":"500118","name":"永川区"},{"id":"500119","name":"南川区"},{"id":"500120","name":"璧山区"},{"id":"500151","name":"铜梁区"},{"id":"500152","name":"潼南区"},{"id":"500153","name":"荣昌区"},{"id":"500154","name":"开州区"},{"id":"500155","name":"梁平区"},{"id":"500156","name":"武隆区"},{"id":"500229","name":"城口县"},{"id":"500230","name":"丰都县"},{"id":"500231","name":"垫江县"},{"id":"500233","name":"忠县"},{"id":"500235","name":"云阳县"},{"id":"500236","name":"奉节县"},{"id":"500237","name":"巫山县"},{"id":"500238","name":"巫溪县"},{"id":"500240","name":"石柱土家族自治县"},{"id":"500241","name":"秀山土家族苗族自治县"},{"id":"500242","name":"酉阳土家族苗族自治县"},{"id":"500243","name":"彭水苗族土家族自治县"}]},{"id":"510000","name":"四川省","child":[{"id":"510100","name":"成都市","child":[{"id":"510104","name":"锦江区"},{"id":"510105","name":"青羊区"},{"id":"510106","name":"金牛区"},{"id":"510107","name":"武侯区"},{"id":"510108","name":"成华区"},{"id":"510112","name":"龙泉驿区"},{"id":"510113","name":"青白江区"},{"id":"510114","name":"新都区"},{"id":"510115","name":"温江区"},{"id":"510116","name":"双流区"},{"id":"510117","name":"郫都区"},{"id":"510121","name":"金堂县"},{"id":"510129","name":"大邑县"},{"id":"510131","name":"蒲江县"},{"id":"510132","name":"新津县"},{"id":"510181","name":"都江堰市"},{"id":"510182","name":"彭州市"},{"id":"510183","name":"邛崃市"},{"id":"510184","name":"崇州市"},{"id":"510185","name":"简阳市"}]},{"id":"510300","name":"自贡市","child":[{"id":"510302","name":"自流井区"},{"id":"510303","name":"贡井区"},{"id":"510304","name":"大安区"},{"id":"510311","name":"沿滩区"},{"id":"510321","name":"荣县"},{"id":"510322","name":"富顺县"}]},{"id":"510400","name":"攀枝花市","child":[{"id":"510402","name":"东区"},{"id":"510403","name":"西区"},{"id":"510411","name":"仁和区"},{"id":"510421","name":"米易县"},{"id":"510422","name":"盐边县"}]},{"id":"510500","name":"泸州市","child":[{"id":"510502","name":"江阳区"},{"id":"510503","name":"纳溪区"},{"id":"510504","name":"龙马潭区"},{"id":"510521","name":"泸县"},{"id":"510522","name":"合江县"},{"id":"510524","name":"叙永县"},{"id":"510525","name":"古蔺县"}]},{"id":"510600","name":"德阳市","child":[{"id":"510603","name":"旌阳区"},{"id":"510623","name":"中江县"},{"id":"510626","name":"罗江县"},{"id":"510681","name":"广汉市"},{"id":"510682","name":"什邡市"},{"id":"510683","name":"绵竹市"}]},{"id":"510700","name":"绵阳市","child":[{"id":"510703","name":"涪城区"},{"id":"510704","name":"游仙区"},{"id":"510705","name":"安州区"},{"id":"510722","name":"三台县"},{"id":"510723","name":"盐亭县"},{"id":"510725","name":"梓潼县"},{"id":"510726","name":"北川羌族自治县"},{"id":"510727","name":"平武县"},{"id":"510781","name":"江油市"}]},{"id":"510800","name":"广元市","child":[{"id":"510802","name":"利州区"},{"id":"510811","name":"昭化区"},{"id":"510812","name":"朝天区"},{"id":"510821","name":"旺苍县"},{"id":"510822","name":"青川县"},{"id":"510823","name":"剑阁县"},{"id":"510824","name":"苍溪县"}]},{"id":"510900","name":"遂宁市","child":[{"id":"510903","name":"船山区"},{"id":"510904","name":"安居区"},{"id":"510921","name":"蓬溪县"},{"id":"510922","name":"射洪县"},{"id":"510923","name":"大英县"}]},{"id":"511000","name":"内江市","child":[{"id":"511002","name":"市中区"},{"id":"511011","name":"东兴区"},{"id":"511024","name":"威远县"},{"id":"511025","name":"资中县"},{"id":"511028","name":"隆昌县"}]},{"id":"511100","name":"乐山市","child":[{"id":"511102","name":"市中区"},{"id":"511111","name":"沙湾区"},{"id":"511112","name":"五通桥区"},{"id":"511113","name":"金口河区"},{"id":"511123","name":"犍为县"},{"id":"511124","name":"井研县"},{"id":"511126","name":"夹江县"},{"id":"511129","name":"沐川县"},{"id":"511132","name":"峨边彝族自治县"},{"id":"511133","name":"马边彝族自治县"},{"id":"511181","name":"峨眉山市"}]},{"id":"511300","name":"南充市","child":[{"id":"511302","name":"顺庆区"},{"id":"511303","name":"高坪区"},{"id":"511304","name":"嘉陵区"},{"id":"511321","name":"南部县"},{"id":"511322","name":"营山县"},{"id":"511323","name":"蓬安县"},{"id":"511324","name":"仪陇县"},{"id":"511325","name":"西充县"},{"id":"511381","name":"阆中市"}]},{"id":"511400","name":"眉山市","child":[{"id":"511402","name":"东坡区"},{"id":"511403","name":"彭山区"},{"id":"511421","name":"仁寿县"},{"id":"511423","name":"洪雅县"},{"id":"511424","name":"丹棱县"},{"id":"511425","name":"青神县"}]},{"id":"511500","name":"宜宾市","child":[{"id":"511502","name":"翠屏区"},{"id":"511503","name":"南溪区"},{"id":"511521","name":"宜宾县"},{"id":"511523","name":"江安县"},{"id":"511524","name":"长宁县"},{"id":"511525","name":"高县"},{"id":"511526","name":"珙县"},{"id":"511527","name":"筠连县"},{"id":"511528","name":"兴文县"},{"id":"511529","name":"屏山县"}]},{"id":"511600","name":"广安市","child":[{"id":"511602","name":"广安区"},{"id":"511603","name":"前锋区"},{"id":"511621","name":"岳池县"},{"id":"511622","name":"武胜县"},{"id":"511623","name":"邻水县"},{"id":"511681","name":"华蓥市"}]},{"id":"511700","name":"达州市","child":[{"id":"511702","name":"通川区"},{"id":"511703","name":"达川区"},{"id":"511722","name":"宣汉县"},{"id":"511723","name":"开江县"},{"id":"511724","name":"大竹县"},{"id":"511725","name":"渠县"},{"id":"511781","name":"万源市"}]},{"id":"511800","name":"雅安市","child":[{"id":"511802","name":"雨城区"},{"id":"511803","name":"名山区"},{"id":"511822","name":"荥经县"},{"id":"511823","name":"汉源县"},{"id":"511824","name":"石棉县"},{"id":"511825","name":"天全县"},{"id":"511826","name":"芦山县"},{"id":"511827","name":"宝兴县"}]},{"id":"511900","name":"巴中市","child":[{"id":"511902","name":"巴州区"},{"id":"511903","name":"恩阳区"},{"id":"511921","name":"通江县"},{"id":"511922","name":"南江县"},{"id":"511923","name":"平昌县"}]},{"id":"512000","name":"资阳市","child":[{"id":"512002","name":"雁江区"},{"id":"512021","name":"安岳县"},{"id":"512022","name":"乐至县"}]},{"id":"513200","name":"阿坝藏族羌族自治州","child":[{"id":"513201","name":"马尔康市"},{"id":"513221","name":"汶川县"},{"id":"513222","name":"理县"},{"id":"513223","name":"茂县"},{"id":"513224","name":"松潘县"},{"id":"513225","name":"九寨沟县"},{"id":"513226","name":"金川县"},{"id":"513227","name":"小金县"},{"id":"513228","name":"黑水县"},{"id":"513230","name":"壤塘县"},{"id":"513231","name":"阿坝县"},{"id":"513232","name":"若尔盖县"},{"id":"513233","name":"红原县"}]},{"id":"513300","name":"甘孜藏族自治州","child":[{"id":"513301","name":"康定市"},{"id":"513322","name":"泸定县"},{"id":"513323","name":"丹巴县"},{"id":"513324","name":"九龙县"},{"id":"513325","name":"雅江县"},{"id":"513326","name":"道孚县"},{"id":"513327","name":"炉霍县"},{"id":"513328","name":"甘孜县"},{"id":"513329","name":"新龙县"},{"id":"513330","name":"德格县"},{"id":"513331","name":"白玉县"},{"id":"513332","name":"石渠县"},{"id":"513333","name":"色达县"},{"id":"513334","name":"理塘县"},{"id":"513335","name":"巴塘县"},{"id":"513336","name":"乡城县"},{"id":"513337","name":"稻城县"},{"id":"513338","name":"得荣县"}]},{"id":"513400","name":"凉山彝族自治州","child":[{"id":"513401","name":"西昌市"},{"id":"513422","name":"木里藏族自治县"},{"id":"513423","name":"盐源县"},{"id":"513424","name":"德昌县"},{"id":"513425","name":"会理县"},{"id":"513426","name":"会东县"},{"id":"513427","name":"宁南县"},{"id":"513428","name":"普格县"},{"id":"513429","name":"布拖县"},{"id":"513430","name":"金阳县"},{"id":"513431","name":"昭觉县"},{"id":"513432","name":"喜德县"},{"id":"513433","name":"冕宁县"},{"id":"513434","name":"越西县"},{"id":"513435","name":"甘洛县"},{"id":"513436","name":"美姑县"},{"id":"513437","name":"雷波县"}]}]},{"id":"520000","name":"贵州省","child":[{"id":"520100","name":"贵阳市","child":[{"id":"520102","name":"南明区"},{"id":"520103","name":"云岩区"},{"id":"520111","name":"花溪区"},{"id":"520112","name":"乌当区"},{"id":"520113","name":"白云区"},{"id":"520115","name":"观山湖区"},{"id":"520121","name":"开阳县"},{"id":"520122","name":"息烽县"},{"id":"520123","name":"修文县"},{"id":"520181","name":"清镇市"}]},{"id":"520200","name":"六盘水市","child":[{"id":"520201","name":"钟山区"},{"id":"520203","name":"六枝特区"},{"id":"520221","name":"水城县"},{"id":"520222","name":"盘县"}]},{"id":"520300","name":"遵义市","child":[{"id":"520302","name":"红花岗区"},{"id":"520303","name":"汇川区"},{"id":"520304","name":"播州区"},{"id":"520322","name":"桐梓县"},{"id":"520323","name":"绥阳县"},{"id":"520324","name":"正安县"},{"id":"520325","name":"道真仡佬族苗族自治县"},{"id":"520326","name":"务川仡佬族苗族自治县"},{"id":"520327","name":"凤冈县"},{"id":"520328","name":"湄潭县"},{"id":"520329","name":"余庆县"},{"id":"520330","name":"习水县"},{"id":"520381","name":"赤水市"},{"id":"520382","name":"仁怀市"}]},{"id":"520400","name":"安顺市","child":[{"id":"520402","name":"西秀区"},{"id":"520403","name":"平坝区"},{"id":"520422","name":"普定县"},{"id":"520423","name":"镇宁布依族苗族自治县"},{"id":"520424","name":"关岭布依族苗族自治县"},{"id":"520425","name":"紫云苗族布依族自治县"}]},{"id":"520500","name":"毕节市","child":[{"id":"520502","name":"七星关区"},{"id":"520521","name":"大方县"},{"id":"520522","name":"黔西县"},{"id":"520523","name":"金沙县"},{"id":"520524","name":"织金县"},{"id":"520525","name":"纳雍县"},{"id":"520526","name":"威宁彝族回族苗族自治县"},{"id":"520527","name":"赫章县"}]},{"id":"520600","name":"铜仁市","child":[{"id":"520602","name":"碧江区"},{"id":"520603","name":"万山区"},{"id":"520621","name":"江口县"},{"id":"520622","name":"玉屏侗族自治县"},{"id":"520623","name":"石阡县"},{"id":"520624","name":"思南县"},{"id":"520625","name":"印江土家族苗族自治县"},{"id":"520626","name":"德江县"},{"id":"520627","name":"沿河土家族自治县"},{"id":"520628","name":"松桃苗族自治县"}]},{"id":"522300","name":"黔西南布依族苗族自治州","child":[{"id":"522301","name":"兴义市"},{"id":"522322","name":"兴仁县"},{"id":"522323","name":"普安县"},{"id":"522324","name":"晴隆县"},{"id":"522325","name":"贞丰县"},{"id":"522326","name":"望谟县"},{"id":"522327","name":"册亨县"},{"id":"522328","name":"安龙县"}]},{"id":"522600","name":"黔东南苗族侗族自治州","child":[{"id":"522601","name":"凯里市"},{"id":"522622","name":"黄平县"},{"id":"522623","name":"施秉县"},{"id":"522624","name":"三穗县"},{"id":"522625","name":"镇远县"},{"id":"522626","name":"岑巩县"},{"id":"522627","name":"天柱县"},{"id":"522628","name":"锦屏县"},{"id":"522629","name":"剑河县"},{"id":"522630","name":"台江县"},{"id":"522631","name":"黎平县"},{"id":"522632","name":"榕江县"},{"id":"522633","name":"从江县"},{"id":"522634","name":"雷山县"},{"id":"522635","name":"麻江县"},{"id":"522636","name":"丹寨县"}]},{"id":"522700","name":"黔南布依族苗族自治州","child":[{"id":"522701","name":"都匀市"},{"id":"522702","name":"福泉市"},{"id":"522722","name":"荔波县"},{"id":"522723","name":"贵定县"},{"id":"522725","name":"瓮安县"},{"id":"522726","name":"独山县"},{"id":"522727","name":"平塘县"},{"id":"522728","name":"罗甸县"},{"id":"522729","name":"长顺县"},{"id":"522730","name":"龙里县"},{"id":"522731","name":"惠水县"},{"id":"522732","name":"三都水族自治县"}]}]},{"id":"530000","name":"云南省","child":[{"id":"530100","name":"昆明市","child":[{"id":"530102","name":"五华区"},{"id":"530103","name":"盘龙区"},{"id":"530111","name":"官渡区"},{"id":"530112","name":"西山区"},{"id":"530113","name":"东川区"},{"id":"530114","name":"呈贡区"},{"id":"530115","name":"晋宁区"},{"id":"530124","name":"富民县"},{"id":"530125","name":"宜良县"},{"id":"530126","name":"石林彝族自治县"},{"id":"530127","name":"嵩明县"},{"id":"530128","name":"禄劝彝族苗族自治县"},{"id":"530129","name":"寻甸回族彝族自治县"},{"id":"530181","name":"安宁市"}]},{"id":"530300","name":"曲靖市","child":[{"id":"530302","name":"麒麟区"},{"id":"530303","name":"沾益区"},{"id":"530321","name":"马龙县"},{"id":"530322","name":"陆良县"},{"id":"530323","name":"师宗县"},{"id":"530324","name":"罗平县"},{"id":"530325","name":"富源县"},{"id":"530326","name":"会泽县"},{"id":"530381","name":"宣威市"}]},{"id":"530400","name":"玉溪市","child":[{"id":"530402","name":"红塔区"},{"id":"530403","name":"江川区"},{"id":"530422","name":"澄江县"},{"id":"530423","name":"通海县"},{"id":"530424","name":"华宁县"},{"id":"530425","name":"易门县"},{"id":"530426","name":"峨山彝族自治县"},{"id":"530427","name":"新平彝族傣族自治县"},{"id":"530428","name":"元江哈尼族彝族傣族自治县"}]},{"id":"530500","name":"保山市","child":[{"id":"530502","name":"隆阳区"},{"id":"530521","name":"施甸县"},{"id":"530523","name":"龙陵县"},{"id":"530524","name":"昌宁县"},{"id":"530581","name":"腾冲市"}]},{"id":"530600","name":"昭通市","child":[{"id":"530602","name":"昭阳区"},{"id":"530621","name":"鲁甸县"},{"id":"530622","name":"巧家县"},{"id":"530623","name":"盐津县"},{"id":"530624","name":"大关县"},{"id":"530625","name":"永善县"},{"id":"530626","name":"绥江县"},{"id":"530627","name":"镇雄县"},{"id":"530628","name":"彝良县"},{"id":"530629","name":"威信县"},{"id":"530630","name":"水富县"}]},{"id":"530700","name":"丽江市","child":[{"id":"530702","name":"古城区"},{"id":"530721","name":"玉龙纳西族自治县"},{"id":"530722","name":"永胜县"},{"id":"530723","name":"华坪县"},{"id":"530724","name":"宁蒗彝族自治县"}]},{"id":"530800","name":"普洱市","child":[{"id":"530802","name":"思茅区"},{"id":"530821","name":"宁洱哈尼族彝族自治县"},{"id":"530822","name":"墨江哈尼族自治县"},{"id":"530823","name":"景东彝族自治县"},{"id":"530824","name":"景谷傣族彝族自治县"},{"id":"530825","name":"镇沅彝族哈尼族拉祜族自治县"},{"id":"530826","name":"江城哈尼族彝族自治县"},{"id":"530827","name":"孟连傣族拉祜族佤族自治县"},{"id":"530828","name":"澜沧拉祜族自治县"},{"id":"530829","name":"西盟佤族自治县"}]},{"id":"530900","name":"临沧市","child":[{"id":"530902","name":"临翔区"},{"id":"530921","name":"凤庆县"},{"id":"530922","name":"云县"},{"id":"530923","name":"永德县"},{"id":"530924","name":"镇康县"},{"id":"530925","name":"双江拉祜族佤族布朗族傣族自治县"},{"id":"530926","name":"耿马傣族佤族自治县"},{"id":"530927","name":"沧源佤族自治县"}]},{"id":"532300","name":"楚雄彝族自治州","child":[{"id":"532301","name":"楚雄市"},{"id":"532322","name":"双柏县"},{"id":"532323","name":"牟定县"},{"id":"532324","name":"南华县"},{"id":"532325","name":"姚安县"},{"id":"532326","name":"大姚县"},{"id":"532327","name":"永仁县"},{"id":"532328","name":"元谋县"},{"id":"532329","name":"武定县"},{"id":"532331","name":"禄丰县"}]},{"id":"532500","name":"红河哈尼族彝族自治州","child":[{"id":"532501","name":"个旧市"},{"id":"532502","name":"开远市"},{"id":"532503","name":"蒙自市"},{"id":"532504","name":"弥勒市"},{"id":"532523","name":"屏边苗族自治县"},{"id":"532524","name":"建水县"},{"id":"532525","name":"石屏县"},{"id":"532527","name":"泸西县"},{"id":"532528","name":"元阳县"},{"id":"532529","name":"红河县"},{"id":"532530","name":"金平苗族瑶族傣族自治县"},{"id":"532531","name":"绿春县"},{"id":"532532","name":"河口瑶族自治县"}]},{"id":"532600","name":"文山壮族苗族自治州","child":[{"id":"532601","name":"文山市"},{"id":"532622","name":"砚山县"},{"id":"532623","name":"西畴县"},{"id":"532624","name":"麻栗坡县"},{"id":"532625","name":"马关县"},{"id":"532626","name":"丘北县"},{"id":"532627","name":"广南县"},{"id":"532628","name":"富宁县"}]},{"id":"532800","name":"西双版纳傣族自治州","child":[{"id":"532801","name":"景洪市"},{"id":"532822","name":"勐海县"},{"id":"532823","name":"勐腊县"}]},{"id":"532900","name":"大理白族自治州","child":[{"id":"532901","name":"大理市"},{"id":"532922","name":"漾濞彝族自治县"},{"id":"532923","name":"祥云县"},{"id":"532924","name":"宾川县"},{"id":"532925","name":"弥渡县"},{"id":"532926","name":"南涧彝族自治县"},{"id":"532927","name":"巍山彝族回族自治县"},{"id":"532928","name":"永平县"},{"id":"532929","name":"云龙县"},{"id":"532930","name":"洱源县"},{"id":"532931","name":"剑川县"},{"id":"532932","name":"鹤庆县"}]},{"id":"533100","name":"德宏傣族景颇族自治州","child":[{"id":"533102","name":"瑞丽市"},{"id":"533103","name":"芒市"},{"id":"533122","name":"梁河县"},{"id":"533123","name":"盈江县"},{"id":"533124","name":"陇川县"}]},{"id":"533300","name":"怒江傈僳族自治州","child":[{"id":"533301","name":"泸水市"},{"id":"533323","name":"福贡县"},{"id":"533324","name":"贡山独龙族怒族自治县"},{"id":"533325","name":"兰坪白族普米族自治县"}]},{"id":"533400","name":"迪庆藏族自治州","child":[{"id":"533401","name":"香格里拉市"},{"id":"533422","name":"德钦县"},{"id":"533423","name":"维西傈僳族自治县"}]}]},{"id":"540000","name":"西藏自治区","child":[{"id":"540100","name":"拉萨市","child":[{"id":"540102","name":"城关区"},{"id":"540103","name":"堆龙德庆区"},{"id":"540121","name":"林周县"},{"id":"540122","name":"当雄县"},{"id":"540123","name":"尼木县"},{"id":"540124","name":"曲水县"},{"id":"540126","name":"达孜县"},{"id":"540127","name":"墨竹工卡县"}]},{"id":"540200","name":"日喀则市","child":[{"id":"540202","name":"桑珠孜区"},{"id":"540221","name":"南木林县"},{"id":"540222","name":"江孜县"},{"id":"540223","name":"定日县"},{"id":"540224","name":"萨迦县"},{"id":"540225","name":"拉孜县"},{"id":"540226","name":"昂仁县"},{"id":"540227","name":"谢通门县"},{"id":"540228","name":"白朗县"},{"id":"540229","name":"仁布县"},{"id":"540230","name":"康马县"},{"id":"540231","name":"定结县"},{"id":"540232","name":"仲巴县"},{"id":"540233","name":"亚东县"},{"id":"540234","name":"吉隆县"},{"id":"540235","name":"聂拉木县"},{"id":"540236","name":"萨嘎县"},{"id":"540237","name":"岗巴县"}]},{"id":"540300","name":"昌都市","child":[{"id":"540302","name":"卡若区"},{"id":"540321","name":"江达县"},{"id":"540322","name":"贡觉县"},{"id":"540323","name":"类乌齐县"},{"id":"540324","name":"丁青县"},{"id":"540325","name":"察雅县"},{"id":"540326","name":"八宿县"},{"id":"540327","name":"左贡县"},{"id":"540328","name":"芒康县"},{"id":"540329","name":"洛隆县"},{"id":"540330","name":"边坝县"}]},{"id":"540400","name":"林芝市","child":[{"id":"540402","name":"巴宜区"},{"id":"540421","name":"工布江达县"},{"id":"540422","name":"米林县"},{"id":"540423","name":"墨脱县"},{"id":"540424","name":"波密县"},{"id":"540425","name":"察隅县"},{"id":"540426","name":"朗县"}]},{"id":"540500","name":"山南市","child":[{"id":"540502","name":"乃东区"},{"id":"540521","name":"扎囊县"},{"id":"540522","name":"贡嘎县"},{"id":"540523","name":"桑日县"},{"id":"540524","name":"琼结县"},{"id":"540525","name":"曲松县"},{"id":"540526","name":"措美县"},{"id":"540527","name":"洛扎县"},{"id":"540528","name":"加查县"},{"id":"540529","name":"隆子县"},{"id":"540530","name":"错那县"},{"id":"540531","name":"浪卡子县"}]},{"id":"542400","name":"那曲地区","child":[{"id":"542421","name":"那曲县"},{"id":"542422","name":"嘉黎县"},{"id":"542423","name":"比如县"},{"id":"542424","name":"聂荣县"},{"id":"542425","name":"安多县"},{"id":"542426","name":"申扎县"},{"id":"542427","name":"索县"},{"id":"542428","name":"班戈县"},{"id":"542429","name":"巴青县"},{"id":"542430","name":"尼玛县"},{"id":"542431","name":"双湖县"}]},{"id":"542500","name":"阿里地区","child":[{"id":"542521","name":"普兰县"},{"id":"542522","name":"札达县"},{"id":"542523","name":"噶尔县"},{"id":"542524","name":"日土县"},{"id":"542525","name":"革吉县"},{"id":"542526","name":"改则县"},{"id":"542527","name":"措勤县"}]}]},{"id":"610000","name":"陕西省","child":[{"id":"610100","name":"西安市","child":[{"id":"610102","name":"新城区"},{"id":"610103","name":"碑林区"},{"id":"610104","name":"莲湖区"},{"id":"610111","name":"灞桥区"},{"id":"610112","name":"未央区"},{"id":"610113","name":"雁塔区"},{"id":"610114","name":"阎良区"},{"id":"610115","name":"临潼区"},{"id":"610116","name":"长安区"},{"id":"610117","name":"高陵区"},{"id":"610118","name":"鄠邑区"},{"id":"610122","name":"蓝田县"},{"id":"610124","name":"周至县"}]},{"id":"610200","name":"铜川市","child":[{"id":"610202","name":"王益区"},{"id":"610203","name":"印台区"},{"id":"610204","name":"耀州区"},{"id":"610222","name":"宜君县"}]},{"id":"610300","name":"宝鸡市","child":[{"id":"610302","name":"渭滨区"},{"id":"610303","name":"金台区"},{"id":"610304","name":"陈仓区"},{"id":"610322","name":"凤翔县"},{"id":"610323","name":"岐山县"},{"id":"610324","name":"扶风县"},{"id":"610326","name":"眉县"},{"id":"610327","name":"陇县"},{"id":"610328","name":"千阳县"},{"id":"610329","name":"麟游县"},{"id":"610330","name":"凤县"},{"id":"610331","name":"太白县"}]},{"id":"610400","name":"咸阳市","child":[{"id":"610402","name":"秦都区"},{"id":"610403","name":"杨陵区"},{"id":"610404","name":"渭城区"},{"id":"610422","name":"三原县"},{"id":"610423","name":"泾阳县"},{"id":"610424","name":"乾县"},{"id":"610425","name":"礼泉县"},{"id":"610426","name":"永寿县"},{"id":"610427","name":"彬县"},{"id":"610428","name":"长武县"},{"id":"610429","name":"旬邑县"},{"id":"610430","name":"淳化县"},{"id":"610431","name":"武功县"},{"id":"610481","name":"兴平市"}]},{"id":"610500","name":"渭南市","child":[{"id":"610502","name":"临渭区"},{"id":"610503","name":"华州区"},{"id":"610522","name":"潼关县"},{"id":"610523","name":"大荔县"},{"id":"610524","name":"合阳县"},{"id":"610525","name":"澄城县"},{"id":"610526","name":"蒲城县"},{"id":"610527","name":"白水县"},{"id":"610528","name":"富平县"},{"id":"610581","name":"韩城市"},{"id":"610582","name":"华阴市"}]},{"id":"610600","name":"延安市","child":[{"id":"610602","name":"宝塔区"},{"id":"610603","name":"安塞区"},{"id":"610621","name":"延长县"},{"id":"610622","name":"延川县"},{"id":"610623","name":"子长县"},{"id":"610625","name":"志丹县"},{"id":"610626","name":"吴起县"},{"id":"610627","name":"甘泉县"},{"id":"610628","name":"富县"},{"id":"610629","name":"洛川县"},{"id":"610630","name":"宜川县"},{"id":"610631","name":"黄龙县"},{"id":"610632","name":"黄陵县"}]},{"id":"610700","name":"汉中市","child":[{"id":"610702","name":"汉台区"},{"id":"610721","name":"南郑县"},{"id":"610722","name":"城固县"},{"id":"610723","name":"洋县"},{"id":"610724","name":"西乡县"},{"id":"610725","name":"勉县"},{"id":"610726","name":"宁强县"},{"id":"610727","name":"略阳县"},{"id":"610728","name":"镇巴县"},{"id":"610729","name":"留坝县"},{"id":"610730","name":"佛坪县"}]},{"id":"610800","name":"榆林市","child":[{"id":"610802","name":"榆阳区"},{"id":"610803","name":"横山区"},{"id":"610821","name":"神木县"},{"id":"610822","name":"府谷县"},{"id":"610824","name":"靖边县"},{"id":"610825","name":"定边县"},{"id":"610826","name":"绥德县"},{"id":"610827","name":"米脂县"},{"id":"610828","name":"佳县"},{"id":"610829","name":"吴堡县"},{"id":"610830","name":"清涧县"},{"id":"610831","name":"子洲县"}]},{"id":"610900","name":"安康市","child":[{"id":"610902","name":"汉滨区"},{"id":"610921","name":"汉阴县"},{"id":"610922","name":"石泉县"},{"id":"610923","name":"宁陕县"},{"id":"610924","name":"紫阳县"},{"id":"610925","name":"岚皋县"},{"id":"610926","name":"平利县"},{"id":"610927","name":"镇坪县"},{"id":"610928","name":"旬阳县"},{"id":"610929","name":"白河县"}]},{"id":"611000","name":"商洛市","child":[{"id":"611002","name":"商州区"},{"id":"611021","name":"洛南县"},{"id":"611022","name":"丹凤县"},{"id":"611023","name":"商南县"},{"id":"611024","name":"山阳县"},{"id":"611025","name":"镇安县"},{"id":"611026","name":"柞水县"}]}]},{"id":"620000","name":"甘肃省","child":[{"id":"620100","name":"兰州市","child":[{"id":"620102","name":"城关区"},{"id":"620103","name":"七里河区"},{"id":"620104","name":"西固区"},{"id":"620105","name":"安宁区"},{"id":"620111","name":"红古区"},{"id":"620121","name":"永登县"},{"id":"620122","name":"皋兰县"},{"id":"620123","name":"榆中县"}]},{"id":"620200","name":"嘉峪关市","child":[{"id":"620299","name":"嘉峪关市"}]},{"id":"620300","name":"金昌市","child":[{"id":"620302","name":"金川区"},{"id":"620321","name":"永昌县"}]},{"id":"620400","name":"白银市","child":[{"id":"620402","name":"白银区"},{"id":"620403","name":"平川区"},{"id":"620421","name":"靖远县"},{"id":"620422","name":"会宁县"},{"id":"620423","name":"景泰县"}]},{"id":"620500","name":"天水市","child":[{"id":"620502","name":"秦州区"},{"id":"620503","name":"麦积区"},{"id":"620521","name":"清水县"},{"id":"620522","name":"秦安县"},{"id":"620523","name":"甘谷县"},{"id":"620524","name":"武山县"},{"id":"620525","name":"张家川回族自治县"}]},{"id":"620600","name":"武威市","child":[{"id":"620602","name":"凉州区"},{"id":"620621","name":"民勤县"},{"id":"620622","name":"古浪县"},{"id":"620623","name":"天祝藏族自治县"}]},{"id":"620700","name":"张掖市","child":[{"id":"620702","name":"甘州区"},{"id":"620721","name":"肃南裕固族自治县"},{"id":"620722","name":"民乐县"},{"id":"620723","name":"临泽县"},{"id":"620724","name":"高台县"},{"id":"620725","name":"山丹县"}]},{"id":"620800","name":"平凉市","child":[{"id":"620802","name":"崆峒区"},{"id":"620821","name":"泾川县"},{"id":"620822","name":"灵台县"},{"id":"620823","name":"崇信县"},{"id":"620824","name":"华亭县"},{"id":"620825","name":"庄浪县"},{"id":"620826","name":"静宁县"}]},{"id":"620900","name":"酒泉市","child":[{"id":"620902","name":"肃州区"},{"id":"620921","name":"金塔县"},{"id":"620922","name":"瓜州县"},{"id":"620923","name":"肃北蒙古族自治县"},{"id":"620924","name":"阿克塞哈萨克族自治县"},{"id":"620981","name":"玉门市"},{"id":"620982","name":"敦煌市"}]},{"id":"621000","name":"庆阳市","child":[{"id":"621002","name":"西峰区"},{"id":"621021","name":"庆城县"},{"id":"621022","name":"环县"},{"id":"621023","name":"华池县"},{"id":"621024","name":"合水县"},{"id":"621025","name":"正宁县"},{"id":"621026","name":"宁县"},{"id":"621027","name":"镇原县"}]},{"id":"621100","name":"定西市","child":[{"id":"621102","name":"安定区"},{"id":"621121","name":"通渭县"},{"id":"621122","name":"陇西县"},{"id":"621123","name":"渭源县"},{"id":"621124","name":"临洮县"},{"id":"621125","name":"漳县"},{"id":"621126","name":"岷县"}]},{"id":"621200","name":"陇南市","child":[{"id":"621202","name":"武都区"},{"id":"621221","name":"成县"},{"id":"621222","name":"文县"},{"id":"621223","name":"宕昌县"},{"id":"621224","name":"康县"},{"id":"621225","name":"西和县"},{"id":"621226","name":"礼县"},{"id":"621227","name":"徽县"},{"id":"621228","name":"两当县"}]},{"id":"622900","name":"临夏回族自治州","child":[{"id":"622901","name":"临夏市"},{"id":"622921","name":"临夏县"},{"id":"622922","name":"康乐县"},{"id":"622923","name":"永靖县"},{"id":"622924","name":"广河县"},{"id":"622925","name":"和政县"},{"id":"622926","name":"东乡族自治县"},{"id":"622927","name":"积石山保安族东乡族撒拉族自治县"}]},{"id":"623000","name":"甘南藏族自治州","child":[{"id":"623001","name":"合作市"},{"id":"623021","name":"临潭县"},{"id":"623022","name":"卓尼县"},{"id":"623023","name":"舟曲县"},{"id":"623024","name":"迭部县"},{"id":"623025","name":"玛曲县"},{"id":"623026","name":"碌曲县"},{"id":"623027","name":"夏河县"}]}]},{"id":"630000","name":"青海省","child":[{"id":"630100","name":"西宁市","child":[{"id":"630102","name":"城东区"},{"id":"630103","name":"城中区"},{"id":"630104","name":"城西区"},{"id":"630105","name":"城北区"},{"id":"630121","name":"大通回族土族自治县"},{"id":"630122","name":"湟中县"},{"id":"630123","name":"湟源县"}]},{"id":"630200","name":"海东市","child":[{"id":"630202","name":"乐都区"},{"id":"630203","name":"平安区"},{"id":"630222","name":"民和回族土族自治县"},{"id":"630223","name":"互助土族自治县"},{"id":"630224","name":"化隆回族自治县"},{"id":"630225","name":"循化撒拉族自治县"}]},{"id":"632200","name":"海北藏族自治州","child":[{"id":"632221","name":"门源回族自治县"},{"id":"632222","name":"祁连县"},{"id":"632223","name":"海晏县"},{"id":"632224","name":"刚察县"}]},{"id":"632300","name":"黄南藏族自治州","child":[{"id":"632321","name":"同仁县"},{"id":"632322","name":"尖扎县"},{"id":"632323","name":"泽库县"},{"id":"632324","name":"河南蒙古族自治县"}]},{"id":"632500","name":"海南藏族自治州","child":[{"id":"632521","name":"共和县"},{"id":"632522","name":"同德县"},{"id":"632523","name":"贵德县"},{"id":"632524","name":"兴海县"},{"id":"632525","name":"贵南县"}]},{"id":"632600","name":"果洛藏族自治州","child":[{"id":"632621","name":"玛沁县"},{"id":"632622","name":"班玛县"},{"id":"632623","name":"甘德县"},{"id":"632624","name":"达日县"},{"id":"632625","name":"久治县"},{"id":"632626","name":"玛多县"}]},{"id":"632700","name":"玉树藏族自治州","child":[{"id":"632701","name":"玉树市"},{"id":"632722","name":"杂多县"},{"id":"632723","name":"称多县"},{"id":"632724","name":"治多县"},{"id":"632725","name":"囊谦县"},{"id":"632726","name":"曲麻莱县"}]},{"id":"632800","name":"海西蒙古族藏族自治州","child":[{"id":"632801","name":"格尔木市"},{"id":"632802","name":"德令哈市"},{"id":"632821","name":"乌兰县"},{"id":"632822","name":"都兰县"},{"id":"632823","name":"天峻县"},{"id":"632824","name":"冷湖行政区"},{"id":"632825","name":"大柴旦行政区"},{"id":"632826","name":"茫崖行政区"}]}]},{"id":"640000","name":"宁夏回族自治区","child":[{"id":"640100","name":"银川市","child":[{"id":"640104","name":"兴庆区"},{"id":"640105","name":"西夏区"},{"id":"640106","name":"金凤区"},{"id":"640121","name":"永宁县"},{"id":"640122","name":"贺兰县"},{"id":"640181","name":"灵武市"}]},{"id":"640200","name":"石嘴山市","child":[{"id":"640202","name":"大武口区"},{"id":"640205","name":"惠农区"},{"id":"640221","name":"平罗县"}]},{"id":"640300","name":"吴忠市","child":[{"id":"640302","name":"利通区"},{"id":"640303","name":"红寺堡区"},{"id":"640323","name":"盐池县"},{"id":"640324","name":"同心县"},{"id":"640381","name":"青铜峡市"}]},{"id":"640400","name":"固原市","child":[{"id":"640402","name":"原州区"},{"id":"640422","name":"西吉县"},{"id":"640423","name":"隆德县"},{"id":"640424","name":"泾源县"},{"id":"640425","name":"彭阳县"}]},{"id":"640500","name":"中卫市","child":[{"id":"640502","name":"沙坡头区"},{"id":"640521","name":"中宁县"},{"id":"640522","name":"海原县"}]}]},{"id":"650000","name":"新疆维吾尔自治区","child":[{"id":"650100","name":"乌鲁木齐市","child":[{"id":"650102","name":"天山区"},{"id":"650103","name":"沙依巴克区"},{"id":"650104","name":"新市区"},{"id":"650105","name":"水磨沟区"},{"id":"650106","name":"头屯河区"},{"id":"650107","name":"达坂城区"},{"id":"650109","name":"米东区"},{"id":"650121","name":"乌鲁木齐县"}]},{"id":"650200","name":"克拉玛依市","child":[{"id":"650202","name":"独山子区"},{"id":"650203","name":"克拉玛依区"},{"id":"650204","name":"白碱滩区"},{"id":"650205","name":"乌尔禾区"}]},{"id":"650400","name":"吐鲁番市","child":[{"id":"650402","name":"高昌区"},{"id":"650421","name":"鄯善县"},{"id":"650422","name":"托克逊县"}]},{"id":"650500","name":"哈密市","child":[{"id":"650502","name":"伊州区"},{"id":"650521","name":"巴里坤哈萨克自治县"},{"id":"650522","name":"伊吾县"}]},{"id":"652300","name":"昌吉回族自治州","child":[{"id":"652301","name":"昌吉市"},{"id":"652302","name":"阜康市"},{"id":"652323","name":"呼图壁县"},{"id":"652324","name":"玛纳斯县"},{"id":"652325","name":"奇台县"},{"id":"652327","name":"吉木萨尔县"},{"id":"652328","name":"木垒哈萨克自治县"}]},{"id":"652700","name":"博尔塔拉蒙古自治州","child":[{"id":"652701","name":"博乐市"},{"id":"652702","name":"阿拉山口市"},{"id":"652722","name":"精河县"},{"id":"652723","name":"温泉县"}]},{"id":"652800","name":"巴音郭楞蒙古自治州","child":[{"id":"652801","name":"库尔勒市"},{"id":"652822","name":"轮台县"},{"id":"652823","name":"尉犁县"},{"id":"652824","name":"若羌县"},{"id":"652825","name":"且末县"},{"id":"652826","name":"焉耆回族自治县"},{"id":"652827","name":"和静县"},{"id":"652828","name":"和硕县"},{"id":"652829","name":"博湖县"}]},{"id":"652900","name":"阿克苏地区","child":[{"id":"652901","name":"阿克苏市"},{"id":"652922","name":"温宿县"},{"id":"652923","name":"库车县"},{"id":"652924","name":"沙雅县"},{"id":"652925","name":"新和县"},{"id":"652926","name":"拜城县"},{"id":"652927","name":"乌什县"},{"id":"652928","name":"阿瓦提县"},{"id":"652929","name":"柯坪县"}]},{"id":"653000","name":"克孜勒苏柯尔克孜自治州","child":[{"id":"653001","name":"阿图什市"},{"id":"653022","name":"阿克陶县"},{"id":"653023","name":"阿合奇县"},{"id":"653024","name":"乌恰县"}]},{"id":"653100","name":"喀什地区","child":[{"id":"653101","name":"喀什市"},{"id":"653121","name":"疏附县"},{"id":"653122","name":"疏勒县"},{"id":"653123","name":"英吉沙县"},{"id":"653124","name":"泽普县"},{"id":"653125","name":"莎车县"},{"id":"653126","name":"叶城县"},{"id":"653127","name":"麦盖提县"},{"id":"653128","name":"岳普湖县"},{"id":"653129","name":"伽师县"},{"id":"653130","name":"巴楚县"},{"id":"653131","name":"塔什库尔干塔吉克自治县"}]},{"id":"653200","name":"和田地区","child":[{"id":"653201","name":"和田市"},{"id":"653221","name":"和田县"},{"id":"653222","name":"墨玉县"},{"id":"653223","name":"皮山县"},{"id":"653224","name":"洛浦县"},{"id":"653225","name":"策勒县"},{"id":"653226","name":"于田县"},{"id":"653227","name":"民丰县"}]},{"id":"654000","name":"伊犁哈萨克自治州","child":[{"id":"654002","name":"伊宁市"},{"id":"654003","name":"奎屯市"},{"id":"654004","name":"霍尔果斯市"},{"id":"654021","name":"伊宁县"},{"id":"654022","name":"察布查尔锡伯自治县"},{"id":"654023","name":"霍城县"},{"id":"654024","name":"巩留县"},{"id":"654025","name":"新源县"},{"id":"654026","name":"昭苏县"},{"id":"654027","name":"特克斯县"},{"id":"654028","name":"尼勒克县"}]},{"id":"654200","name":"塔城地区","child":[{"id":"654201","name":"塔城市"},{"id":"654202","name":"乌苏市"},{"id":"654221","name":"额敏县"},{"id":"654223","name":"沙湾县"},{"id":"654224","name":"托里县"},{"id":"654225","name":"裕民县"},{"id":"654226","name":"和布克赛尔蒙古自治县"}]},{"id":"654300","name":"阿勒泰地区","child":[{"id":"654301","name":"阿勒泰市"},{"id":"654321","name":"布尔津县"},{"id":"654322","name":"富蕴县"},{"id":"654323","name":"福海县"},{"id":"654324","name":"哈巴河县"},{"id":"654325","name":"青河县"},{"id":"654326","name":"吉木乃县"}]},{"id":"659001","name":"石河子市"},{"id":"659002","name":"阿拉尔市"},{"id":"659003","name":"图木舒克市"},{"id":"659004","name":"五家渠市"},{"id":"659005","name":"北屯市"},{"id":"659006","name":"铁门关市"},{"id":"659007","name":"双河市"},{"id":"659008","name":"可克达拉市"},{"id":"659009","name":"昆玉市"}]},{"id":"710000","name":"台湾省","child":[{"id":"710100","name":"台北市","child":[{"id":"710101","name":"中正区"},{"id":"710102","name":"大同区"},{"id":"710103","name":"中山区"},{"id":"710104","name":"松山区"},{"id":"710105","name":"大安区"},{"id":"710106","name":"万华区"},{"id":"710107","name":"信义区"},{"id":"710108","name":"士林区"},{"id":"710109","name":"北投区"},{"id":"710110","name":"内湖区"},{"id":"710111","name":"南港区"},{"id":"710112","name":"文山区"}]},{"id":"710200","name":"高雄市","child":[{"id":"710201","name":"新兴区"},{"id":"710202","name":"前金区"},{"id":"710203","name":"苓雅区"},{"id":"710204","name":"盐埕区"},{"id":"710205","name":"鼓山区"},{"id":"710206","name":"旗津区"},{"id":"710207","name":"前镇区"},{"id":"710208","name":"三民区"},{"id":"710209","name":"左营区"},{"id":"710210","name":"楠梓区"},{"id":"710211","name":"小港区"},{"id":"710242","name":"仁武区"},{"id":"710243","name":"大社区"},{"id":"710244","name":"冈山区"},{"id":"710245","name":"路竹区"},{"id":"710246","name":"阿莲区"},{"id":"710247","name":"田寮区"},{"id":"710248","name":"燕巢区"},{"id":"710249","name":"桥头区"},{"id":"710250","name":"梓官区"},{"id":"710251","name":"弥陀区"},{"id":"710252","name":"永安区"},{"id":"710253","name":"湖内区"},{"id":"710254","name":"凤山区"},{"id":"710255","name":"大寮区"},{"id":"710256","name":"林园区"},{"id":"710257","name":"鸟松区"},{"id":"710258","name":"大树区"},{"id":"710259","name":"旗山区"},{"id":"710260","name":"美浓区"},{"id":"710261","name":"六龟区"},{"id":"710262","name":"内门区"},{"id":"710263","name":"杉林区"},{"id":"710264","name":"甲仙区"},{"id":"710265","name":"桃源区"},{"id":"710266","name":"那玛夏区"},{"id":"710267","name":"茂林区"},{"id":"710268","name":"茄萣区"}]},{"id":"710300","name":"台南市","child":[{"id":"710301","name":"中西区"},{"id":"710302","name":"东区"},{"id":"710303","name":"南区"},{"id":"710304","name":"北区"},{"id":"710305","name":"安平区"},{"id":"710306","name":"安南区"},{"id":"710339","name":"永康区"},{"id":"710340","name":"归仁区"},{"id":"710341","name":"新化区"},{"id":"710342","name":"左镇区"},{"id":"710343","name":"玉井区"},{"id":"710344","name":"楠西区"},{"id":"710345","name":"南化区"},{"id":"710346","name":"仁德区"},{"id":"710347","name":"关庙区"},{"id":"710348","name":"龙崎区"},{"id":"710349","name":"官田区"},{"id":"710350","name":"麻豆区"},{"id":"710351","name":"佳里区"},{"id":"710352","name":"西港区"},{"id":"710353","name":"七股区"},{"id":"710354","name":"将军区"},{"id":"710355","name":"学甲区"},{"id":"710356","name":"北门区"},{"id":"710357","name":"新营区"},{"id":"710358","name":"后壁区"},{"id":"710359","name":"白河区"},{"id":"710360","name":"东山区"},{"id":"710361","name":"六甲区"},{"id":"710362","name":"下营区"},{"id":"710363","name":"柳营区"},{"id":"710364","name":"盐水区"},{"id":"710365","name":"善化区"},{"id":"710366","name":"大内区"},{"id":"710367","name":"山上区"},{"id":"710368","name":"新市区"},{"id":"710369","name":"安定区"}]},{"id":"710400","name":"台中市","child":[{"id":"710401","name":"中区"},{"id":"710402","name":"东区"},{"id":"710403","name":"南区"},{"id":"710404","name":"西区"},{"id":"710405","name":"北区"},{"id":"710406","name":"北屯区"},{"id":"710407","name":"西屯区"},{"id":"710408","name":"南屯区"},{"id":"710431","name":"太平区"},{"id":"710432","name":"大里区"},{"id":"710433","name":"雾峰区"},{"id":"710434","name":"乌日区"},{"id":"710435","name":"丰原区"},{"id":"710436","name":"后里区"},{"id":"710437","name":"石冈区"},{"id":"710438","name":"东势区"},{"id":"710439","name":"和平区"},{"id":"710440","name":"新社区"},{"id":"710441","name":"潭子区"},{"id":"710442","name":"大雅区"},{"id":"710443","name":"神冈区"},{"id":"710444","name":"大肚区"},{"id":"710445","name":"沙鹿区"},{"id":"710446","name":"龙井区"},{"id":"710447","name":"梧栖区"},{"id":"710448","name":"清水区"},{"id":"710449","name":"大甲区"},{"id":"710450","name":"外埔区"},{"id":"710451","name":"大安区"}]},{"id":"710600","name":"南投县","child":[{"id":"710614","name":"南投市"},{"id":"710615","name":"中寮乡"},{"id":"710616","name":"草屯镇"},{"id":"710617","name":"国姓乡"},{"id":"710618","name":"埔里镇"},{"id":"710619","name":"仁爱乡"},{"id":"710620","name":"名间乡"},{"id":"710621","name":"集集镇"},{"id":"710622","name":"水里乡"},{"id":"710623","name":"鱼池乡"},{"id":"710624","name":"信义乡"},{"id":"710625","name":"竹山镇"},{"id":"710626","name":"鹿谷乡"}]},{"id":"710700","name":"基隆市","child":[{"id":"710701","name":"仁爱区"},{"id":"710702","name":"信义区"},{"id":"710703","name":"中正区"},{"id":"710704","name":"中山区"},{"id":"710705","name":"安乐区"},{"id":"710706","name":"暖暖区"},{"id":"710707","name":"七堵区"}]},{"id":"710800","name":"新竹市","child":[{"id":"710801","name":"东区"},{"id":"710802","name":"北区"},{"id":"710803","name":"香山区"}]},{"id":"710900","name":"嘉义市","child":[{"id":"710901","name":"东区"},{"id":"710902","name":"西区"}]},{"id":"711100","name":"新北市","child":[{"id":"711130","name":"万里区"},{"id":"711131","name":"金山区"},{"id":"711132","name":"板桥区"},{"id":"711133","name":"汐止区"},{"id":"711134","name":"深坑区"},{"id":"711135","name":"石碇区"},{"id":"711136","name":"瑞芳区"},{"id":"711137","name":"平溪区"},{"id":"711138","name":"双溪区"},{"id":"711139","name":"贡寮区"},{"id":"711140","name":"新店区"},{"id":"711141","name":"坪林区"},{"id":"711142","name":"乌来区"},{"id":"711143","name":"永和区"},{"id":"711144","name":"中和区"},{"id":"711145","name":"土城区"},{"id":"711146","name":"三峡区"},{"id":"711147","name":"树林区"},{"id":"711148","name":"莺歌区"},{"id":"711149","name":"三重区"},{"id":"711150","name":"新庄区"},{"id":"711151","name":"泰山区"},{"id":"711152","name":"林口区"},{"id":"711153","name":"芦洲区"},{"id":"711154","name":"五股区"},{"id":"711155","name":"八里区"},{"id":"711156","name":"淡水区"},{"id":"711157","name":"三芝区"},{"id":"711158","name":"石门区"}]},{"id":"711200","name":"宜兰县","child":[{"id":"711214","name":"宜兰市"},{"id":"711215","name":"头城镇"},{"id":"711216","name":"礁溪乡"},{"id":"711217","name":"壮围乡"},{"id":"711218","name":"员山乡"},{"id":"711219","name":"罗东镇"},{"id":"711220","name":"三星乡"},{"id":"711221","name":"大同乡"},{"id":"711222","name":"五结乡"},{"id":"711223","name":"冬山乡"},{"id":"711224","name":"苏澳镇"},{"id":"711225","name":"南澳乡"}]},{"id":"711300","name":"新竹县","child":[{"id":"711314","name":"竹北市"},{"id":"711315","name":"湖口乡"},{"id":"711316","name":"新丰乡"},{"id":"711317","name":"新埔镇"},{"id":"711318","name":"关西镇"},{"id":"711319","name":"芎林乡"},{"id":"711320","name":"宝山乡"},{"id":"711321","name":"竹东镇"},{"id":"711322","name":"五峰乡"},{"id":"711323","name":"横山乡"},{"id":"711324","name":"尖石乡"},{"id":"711325","name":"北埔乡"},{"id":"711326","name":"峨眉乡"}]},{"id":"711400","name":"桃园市","child":[{"id":"711414","name":"中坜区"},{"id":"711415","name":"平镇区"},{"id":"711416","name":"龙潭区"},{"id":"711417","name":"杨梅区"},{"id":"711418","name":"新屋区"},{"id":"711419","name":"观音区"},{"id":"711420","name":"桃园区"},{"id":"711421","name":"龟山区"},{"id":"711422","name":"八德区"},{"id":"711423","name":"大溪区"},{"id":"711424","name":"复兴区"},{"id":"711425","name":"大园区"},{"id":"711426","name":"芦竹区"}]},{"id":"711500","name":"苗栗县","child":[{"id":"711519","name":"竹南镇"},{"id":"711520","name":"头份市"},{"id":"711521","name":"三湾乡"},{"id":"711522","name":"南庄乡"},{"id":"711523","name":"狮潭乡"},{"id":"711524","name":"后龙镇"},{"id":"711525","name":"通霄镇"},{"id":"711526","name":"苑里镇"},{"id":"711527","name":"苗栗市"},{"id":"711528","name":"造桥乡"},{"id":"711529","name":"头屋乡"},{"id":"711530","name":"公馆乡"},{"id":"711531","name":"大湖乡"},{"id":"711532","name":"泰安乡"},{"id":"711533","name":"铜锣乡"},{"id":"711534","name":"三义乡"},{"id":"711535","name":"西湖乡"},{"id":"711536","name":"卓兰镇"}]},{"id":"711700","name":"彰化县","child":[{"id":"711727","name":"彰化市"},{"id":"711728","name":"芬园乡"},{"id":"711729","name":"花坛乡"},{"id":"711730","name":"秀水乡"},{"id":"711731","name":"鹿港镇"},{"id":"711732","name":"福兴乡"},{"id":"711733","name":"线西乡"},{"id":"711734","name":"和美镇"},{"id":"711735","name":"伸港乡"},{"id":"711736","name":"员林市"},{"id":"711737","name":"社头乡"},{"id":"711738","name":"永靖乡"},{"id":"711739","name":"埔心乡"},{"id":"711740","name":"溪湖镇"},{"id":"711741","name":"大村乡"},{"id":"711742","name":"埔盐乡"},{"id":"711743","name":"田中镇"},{"id":"711744","name":"北斗镇"},{"id":"711745","name":"田尾乡"},{"id":"711746","name":"埤头乡"},{"id":"711747","name":"溪州乡"},{"id":"711748","name":"竹塘乡"},{"id":"711749","name":"二林镇"},{"id":"711750","name":"大城乡"},{"id":"711751","name":"芳苑乡"},{"id":"711752","name":"二水乡"}]},{"id":"711900","name":"嘉义县","child":[{"id":"711919","name":"番路乡"},{"id":"711920","name":"梅山乡"},{"id":"711921","name":"竹崎乡"},{"id":"711922","name":"阿里山乡"},{"id":"711923","name":"中埔乡"},{"id":"711924","name":"大埔乡"},{"id":"711925","name":"水上乡"},{"id":"711926","name":"鹿草乡"},{"id":"711927","name":"太保市"},{"id":"711928","name":"朴子市"},{"id":"711929","name":"东石乡"},{"id":"711930","name":"六脚乡"},{"id":"711931","name":"新港乡"},{"id":"711932","name":"民雄乡"},{"id":"711933","name":"大林镇"},{"id":"711934","name":"溪口乡"},{"id":"711935","name":"义竹乡"},{"id":"711936","name":"布袋镇"}]},{"id":"712100","name":"云林县","child":[{"id":"712121","name":"斗南镇"},{"id":"712122","name":"大埤乡"},{"id":"712123","name":"虎尾镇"},{"id":"712124","name":"土库镇"},{"id":"712125","name":"褒忠乡"},{"id":"712126","name":"东势乡"},{"id":"712127","name":"台西乡"},{"id":"712128","name":"仑背乡"},{"id":"712129","name":"麦寮乡"},{"id":"712130","name":"斗六市"},{"id":"712131","name":"林内乡"},{"id":"712132","name":"古坑乡"},{"id":"712133","name":"莿桐乡"},{"id":"712134","name":"西螺镇"},{"id":"712135","name":"二仑乡"},{"id":"712136","name":"北港镇"},{"id":"712137","name":"水林乡"},{"id":"712138","name":"口湖乡"},{"id":"712139","name":"四湖乡"},{"id":"712140","name":"元长乡"}]},{"id":"712400","name":"屏东县","child":[{"id":"712434","name":"屏东市"},{"id":"712435","name":"三地门乡"},{"id":"712436","name":"雾台乡"},{"id":"712437","name":"玛家乡"},{"id":"712438","name":"九如乡"},{"id":"712439","name":"里港乡"},{"id":"712440","name":"高树乡"},{"id":"712441","name":"盐埔乡"},{"id":"712442","name":"长治乡"},{"id":"712443","name":"麟洛乡"},{"id":"712444","name":"竹田乡"},{"id":"712445","name":"内埔乡"},{"id":"712446","name":"万丹乡"},{"id":"712447","name":"潮州镇"},{"id":"712448","name":"泰武乡"},{"id":"712449","name":"来义乡"},{"id":"712450","name":"万峦乡"},{"id":"712451","name":"崁顶乡"},{"id":"712452","name":"新埤乡"},{"id":"712453","name":"南州乡"},{"id":"712454","name":"林边乡"},{"id":"712455","name":"东港镇"},{"id":"712456","name":"琉球乡"},{"id":"712457","name":"佳冬乡"},{"id":"712458","name":"新园乡"},{"id":"712459","name":"枋寮乡"},{"id":"712460","name":"枋山乡"},{"id":"712461","name":"春日乡"},{"id":"712462","name":"狮子乡"},{"id":"712463","name":"车城乡"},{"id":"712464","name":"牡丹乡"},{"id":"712465","name":"恒春镇"},{"id":"712466","name":"满州乡"}]},{"id":"712500","name":"台东县","child":[{"id":"712517","name":"台东市"},{"id":"712518","name":"绿岛乡"},{"id":"712519","name":"兰屿乡"},{"id":"712520","name":"延平乡"},{"id":"712521","name":"卑南乡"},{"id":"712522","name":"鹿野乡"},{"id":"712523","name":"关山镇"},{"id":"712524","name":"海端乡"},{"id":"712525","name":"池上乡"},{"id":"712526","name":"东河乡"},{"id":"712527","name":"成功镇"},{"id":"712528","name":"长滨乡"},{"id":"712529","name":"金峰乡"},{"id":"712530","name":"大武乡"},{"id":"712531","name":"达仁乡"},{"id":"712532","name":"太麻里乡"}]},{"id":"712600","name":"花莲县","child":[{"id":"712615","name":"花莲市"},{"id":"712616","name":"新城乡"},{"id":"712618","name":"秀林乡"},{"id":"712619","name":"吉安乡"},{"id":"712620","name":"寿丰乡"},{"id":"712621","name":"凤林镇"},{"id":"712622","name":"光复乡"},{"id":"712623","name":"丰滨乡"},{"id":"712624","name":"瑞穗乡"},{"id":"712625","name":"万荣乡"},{"id":"712626","name":"玉里镇"},{"id":"712627","name":"卓溪乡"},{"id":"712628","name":"富里乡"}]},{"id":"712700","name":"澎湖县","child":[{"id":"712707","name":"马公市"},{"id":"712708","name":"西屿乡"},{"id":"712709","name":"望安乡"},{"id":"712710","name":"七美乡"},{"id":"712711","name":"白沙乡"},{"id":"712712","name":"湖西乡"}]}]},{"id":"810000","name":"香港特别行政区","child":[{"id":"810101","name":"中西区"},{"id":"810102","name":"东区"},{"id":"810103","name":"九龙城区"},{"id":"810104","name":"观塘区"},{"id":"810105","name":"南区"},{"id":"810106","name":"深水埗区"},{"id":"810107","name":"湾仔区"},{"id":"810108","name":"黄大仙区"},{"id":"810109","name":"油尖旺区"},{"id":"810110","name":"离岛区"},{"id":"810111","name":"葵青区"},{"id":"810112","name":"北区"},{"id":"810113","name":"西贡区"},{"id":"810114","name":"沙田区"},{"id":"810115","name":"屯门区"},{"id":"810116","name":"大埔区"},{"id":"810117","name":"荃湾区"},{"id":"810118","name":"元朗区"}]},{"id":"820000","name":"澳门特别行政区","child":[{"id":"820101","name":"澳门半岛"},{"id":"820102","name":"氹仔"},{"id":"820103","name":"路氹城"},{"id":"820104","name":"路环"}]}];

/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode_react__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__template_NASAPay_NASAPay__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* 支付页
*/var queryObj=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var returnUrl='https://client.aircourses.com/h5/success';var NASAPayPage=function(_Component){_inherits(NASAPayPage,_Component);function NASAPayPage(props){var _this2=this;_classCallCheck(this,NASAPayPage);var _this=_possibleConstructorReturn(this,(NASAPayPage.__proto__||Object.getPrototypeOf(NASAPayPage)).call(this,props));_this.checkOrder=function(){var orderNo=_this.state.orderNo;__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getOrderStatus({query:orderNo+''},function(res,err){if(err)return;else{if(res.status===1){__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].closeH5Page({reason:'closeSafe'});}else{__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:'支付未完成'});}}});};_this.handlePay=function(orderNo,payType){__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:'支付进行中，请勿退出当前页面'});if(payType===0){// 微信
var data={orderNo:orderNo,payType:'MWEB'};__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].payWeixin({data:data},function(res,err){if(err)alert(err.errorMessage);else{var mwebUrl=res.mwebUrl;if(__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].iosClient){window.location.replace(''+mwebUrl);}else if(__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].androidClient){window.location.replace(mwebUrl+'&redirect_url='+encodeURIComponent(returnUrl+"?stuid="+queryObj.stuid+"&totalamount="+_this.state.totalAmount+"&success=1&type=wait&orderno="+orderNo)+'&courseid='+queryObj.courseid);}}});}else{var _data={// 支付宝
returnUrl:returnUrl+'?stuid='+queryObj.stuid+'&orderno='+orderNo+'&totalamount='+_this.state.totalamount+'&success=1&type=wait&courseid='+queryObj.courseid,orderNo:orderNo,payType:'QUICK_WAP_PAY'};__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('https://api.aircourses.com/ac-order/alipay',_data).then(function(res){document.getElementById('root').innerHTML=res.data;setTimeout(function(){document.forms[0].submit();},500);}).catch(function(err){alert('error'+JSON.stringify(err));});}};_this.handleClick=function(goodsNo,payType,inviteAwardPackId,isHaveEntity){_this.setState({inviteAwardPackId:inviteAwardPackId,isHaveEntity:isHaveEntity});if(!_this.state.isAllowAgreement){__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].alertView({content:'请同意用户支付协议',confirm:'确定',id:'H5_1006'});return;}var _this$state=_this.state,addressId=_this$state.addressId,refuseClick=_this$state.refuseClick,courseId=_this$state.courseId,notUseDiscount=_this$state.notUseDiscount,isHasDiscount=_this$state.isHasDiscount,discountCoupon=_this$state.discountCoupon,coursesInfo=_this$state.coursesInfo,ngkLevel=_this$state.ngkLevel,inviteAwardList=_this$state.inviteAwardList;var apple_iap=queryObj.apple_iap,yange=queryObj.yange;if(refuseClick)return;_this.setState({refuseClick:true});// applereviewing为1 审核中不强行提醒填写地址
if(!inviteAwardList.length||inviteAwardList.length&&addressId||Number(yange)===1){// apple_iap不传走h5扫码支付, 兼容老版本
if(apple_iap==='1'&&__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].iosClient){// apple_iap为1 ios内购
__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].appleIAP({type:'NASA'});setTimeout(function(){_this.setState({refuseClick:false});},2000);return;}if(apple_iap==='2'&&__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].iosClient){// 新版本传2, 按优惠券有无判断是否走内购
if(notUseDiscount==='1'||!isHasDiscount||Number(yange)===1){// 选择不使用优惠券或暂无优惠券 走内购
if(courseId==='211'){__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].appleIAP({type:'NASA',inviteAwardPackId:inviteAwardPackId,addressId:addressId});}else{__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].appleIAP({goodsId:Number(queryObj.goodsid)});}setTimeout(function(){_this.setState({refuseClick:false});},2000);return;}}if(_this.isMobile){// 安卓或苹果手机 非内购
var data={stuCouponDetailIds:!!discountCoupon&&discountCoupon.id?[discountCoupon.id]:[],userId:queryObj.stuid,goodsNo:goodsNo,payType:payType===0?'MWEB':'QUICK_WAP_PAY',channelId:queryObj.channel,// app渠道id
version:2,// 接口版本
addressId:isHaveEntity?addressId:null,// 有实物赠品才传addressId
saleType:courseId==='211'?1:0,// 默认0：NGK课程，1：NASA实验课课程
selectLevel:courseId==='210'?ngkLevel:null,inviteAwardPackId:inviteAwardPackId};if(window.location.origin!=="https://client.aircourses.com"){return _this.fakePay(data);}__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getWxOrder({data:data},function(res,err){if(err)__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:err.errorMessage});else{_this.setState({orderNo:res.orderNo/*, notUseDiscount: '0', isHasDiscount: false*/});if(res.status!==1){// 未支付成功
_this.handlePay(res.orderNo,payType);// 获取订单号成功 第三方支付
}else{_this.GetDiscountList(coursesInfo.id);alert('支付成功');}}_this.setState({refuseClick:false});});}else{// 桌面或ipad扫码支付
_this.setState({showErweima:true,refuseClick:false});}}else{_this.setState({refuseClick:false});__WEBPACK_IMPORTED_MODULE_11__api_client__["a" /* default */].alertView({title:'提示',content:'我们会为您寄送一份实验器材包，请先填写收货地址哦～',confirm:'去填写',cancel:'取消',id:'H5_1001'});}};_this.handleAddress=function(){var history=_this.props.history;var addressId=_this.state.addressId;history.push({pathname:__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* COURSE_URL */]+'/address',search:window.location.search,state:{source:'nasamk',addressId:addressId,isAllowAgreement:_this.state.isAllowAgreement,notUseDiscount:_this.state.notUseDiscount,// 是否选择使用优惠券
discountCoupon:_this.state.discountCoupon}});};_this.handleDiscount=function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* COURSE_URL */]+'/discountcoupon',search:window.location.search,state:{goodsId:queryObj.goodsid||_this.state.coursesInfo.id,couponId:_this.state.discountCoupon&&_this.state.discountCoupon.id||-1,notUseDiscount:_this.state.notUseDiscount,// 是否选择使用优惠券
discountCoupon:_this.state.discountCoupon,isAllowAgreement:_this.state.isAllowAgreement}});};_this.agreementSelect=function(){_this.setState({isAllowAgreement:!_this.state.isAllowAgreement});};_this.clickToAgreement=function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* COURSE_URL */]+'/paymentAgreement',state:{isAllowAgreement:_this.state.isAllowAgreement,notUseDiscount:_this.state.notUseDiscount,// 是否选择使用优惠券
discountCoupon:_this.state.discountCoupon}});};_this.alertViewBack=function(res){var data=JSON.parse(res);if(data.select==='confirm'){if(data.id==='H5_1001'){_this.handleAddress();}else if(data.id==='H5_1003'){_this.checkOrder();}}};_this.getGoodInfoOld=function(stuId,courseId){__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getGoodsInfo({data:{userId:stuId,courseId:courseId}},function(res,err){if(err)console.log(err);else{_this.setState({coursesInfo:res[0]||{},completeRander:true});}if(!!res[0]&&res[0].id){_this.GetDiscountList(res[0].id);}});};_this.getGoodInfoNew=function(goodsId){__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getGoodInfo({query:goodsId},function(res,err){if(err)console.log(err);else{_this.setState({coursesInfo:res||{},completeRander:true});// 获取赠品列表
__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getGoodsInviteAward({data:{goodsId:goodsId}},function(res,err){if(err)console.log(err);else if(res.length){_this.setState({inviteAwardList:res});}});}});// 获取优惠券列表
_this.GetDiscountList(goodsId);};_this.getAddress=function(stuId){var storage=__WEBPACK_IMPORTED_MODULE_9__utils_tools__["e" /* myStorage */];storage.removeItem('user_address');__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getAddress({data:{userId:stuId}},function(res,err){if(err)console.log(err);else{if(res.length){_this.setState({userAddress:res[0],addressId:res[0].id});storage.setItem('user_address',JSON.stringify(res[0]));}else{storage.setItem('user_address',JSON.stringify({consignee:"",consigneePhone:"",province:"",city:"",area:"",detail:""}));}}});};_this.GetDiscountList=function(goodsId){if(__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].iosClient){// ios客户端关闭优惠券
return;}if(localStorage.getItem('no_use_discount')==='1'){// 已选不使用优惠券
_this.setState({notUseDiscount:'1',isHasDiscount:true// 有优惠券可用
});localStorage.removeItem('no_use_discount');return;}var discountCoupon=localStorage.getItem('user_discount');if(discountCoupon){// 已选择过优惠券则直接使用
_this.setState({discountCoupon:JSON.parse(discountCoupon),isHasDiscount:true// 有优惠券可用
});localStorage.removeItem('user_discount');// 清除，下次进入则重新接口获取
return;}__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getDiscountList({data:{goodsId:goodsId}},function(res,err){if(err)console.log(err);else{if(res.length>0){// 有可以使用的优惠券则选择第一张
_this.setState({discountCoupon:res[0],isHasDiscount:true// 有优惠券可用
});}else{_this.setState({discountCoupon:{},isHasDiscount:false// 无优惠券可用
});}}});};_this.fakePay=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].payTest({data:data},function(res,err){if(err)__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:err.errorMessage});else{__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:'虚拟支付完成'});}_this.setState({refuseClick:false});});case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.isMobile=__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].mobileClient;_this.interval=[];_this.timeout=[];_this.state={completeRander:false,refuseClick:false,// 禁止点击
coursesInfo:{},inviteAwardList:[],//赠品信息
courseId:queryObj.courseid,ngkLevel:typeof queryObj.ngklevel!=='undefined'?Number(queryObj.ngklevel):null,discountCoupon:{},notUseDiscount:'0',// 是否选择优惠券
isHasDiscount:false,// 是否有可用优惠券
isAllowAgreement:true// 是否允许协议
};return _this;}// 第三方支付下单
// 获取订单号
// 选择地址
// 选择优惠券
// 是否同意支付协议
// 跳转至支付协议
_createClass(NASAPayPage,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.interval.map(function(ele){return clearInterval(ele);});this.timeout.map(function(ele){return clearTimeout(ele);});}},{key:'componentWillMount',value:function componentWillMount(){var courseid=queryObj.courseid,stuid=queryObj.stuid,goodsid=queryObj.goodsid;if(localStorage.getItem('is_allow_agreement')){this.setState({isAllowAgreement:localStorage.getItem('is_allow_agreement')});localStorage.removeItem('is_allow_agreement');}Object(__WEBPACK_IMPORTED_MODULE_7__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
// 获取地址信息
this.getAddress(stuid);// 获取套餐信息
if(!goodsid){// 兼容老版本， 若未传goodsid
this.getGoodInfoOld(stuid,courseid);}else{this.getGoodInfoNew(goodsid);}}// 获取优惠券列表
// 虚拟支付
},{key:'render',value:function render(){var _this3=this;var _state=this.state,userAddress=_state.userAddress,coursesInfo=_state.coursesInfo,inviteAwardList=_state.inviteAwardList,courseId=_state.courseId,showErweima=_state.showErweima,addressId=_state.addressId,isHasDiscount=_state.isHasDiscount,discountCoupon=_state.discountCoupon,notUseDiscount=_state.notUseDiscount,isAllowAgreement=_state.isAllowAgreement,ngkLevel=_state.ngkLevel,inviteAwardPackId=_state.inviteAwardPackId,isHaveEntity=_state.isHaveEntity;var qrcodeUrl='';if(isHaveEntity){qrcodeUrl=window.location.origin+'/h5/paylink?channel='+queryObj.channel+'&userid='+queryObj.stuid+'&goodsno='+coursesInfo.goodsNo+'&addressid='+(typeof addressId==='undefined'?'-1':addressId)+'&couponid='+(discountCoupon.id||'-1')+'&ngklevel='+(typeof ngkLevel==='undefined'?'-1':ngkLevel)+'&inviteawardpackid='+inviteAwardPackId;}else{qrcodeUrl=window.location.origin+'/h5/paylink?channel='+queryObj.channel+'&userid='+queryObj.stuid+'&goodsno='+coursesInfo.goodsNo+'&couponid='+(discountCoupon.id||'-1')+'&ngklevel='+(typeof ngkLevel==='undefined'?'-1':ngkLevel)+'&inviteawardpackid='+inviteAwardPackId;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,{title:'确认订单'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,!this.state.completeRander&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__template_Load_Load__["a" /* default */],null),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:false,showClose:false,title:'\u786E\u8BA4\u8BA2\u5355'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__template_NASAPay_NASAPay__["a" /* default */],{yange:queryObj.yange,handleAddress:this.handleAddress,handleDiscount:this.handleDiscount,userAddress:userAddress,coursesInfo:coursesInfo,courseId:courseId,handleClick:this.handleClick.bind(this),agreementSelect:this.agreementSelect,appleIAP:queryObj.apple_iap,notUseDiscount:notUseDiscount,isHasDiscount:isHasDiscount,isAllowAgreement:isAllowAgreement,clickToAgreement:this.clickToAgreement,discountCoupon:discountCoupon,inviteAwardList:inviteAwardList}),!!showErweima&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'erweima_wrap nasa',onClick:function onClick(){_this3.setState({showErweima:false});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'erweima'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_qrcode_react___default.a,{size:148,value:qrcodeUrl,fgColor:'#333'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'\u8BF7\u7528\u624B\u673A\u652F\u4ED8\u5B9D\u6216\u5FAE\u4FE1\u626B\u7801\u4ED8\u6B3E')))));}}]);return NASAPayPage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NASAPayPage);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NASAPay=function(_Component){_inherits(NASAPay,_Component);function NASAPay(props){_classCallCheck(this,NASAPay);var _this=_possibleConstructorReturn(this,(NASAPay.__proto__||Object.getPrototypeOf(NASAPay)).call(this,props));_this.handleClick=function(index){// const { inviteAwardList } = this.props;
_this.setState({inviteAwardIndex:index});window.user_inviteAwardIndex=index;};_this.isMobile=__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].mobileClient;_this.storage=__WEBPACK_IMPORTED_MODULE_3__utils_tools__["e" /* myStorage */];_this.state={channel:Number(_this.storage.getItem('user_channel'))||0,inviteAwardIndex:window.user_inviteAwardIndex||0};return _this;}_createClass(NASAPay,[{key:'render',value:function render(){var _this2=this;var _state=this.state,channel=_state.channel,inviteAwardIndex=_state.inviteAwardIndex;var _props=this.props,userAddress=_props.userAddress,coursesInfo=_props.coursesInfo,inviteAwardList=_props.inviteAwardList,courseId=_props.courseId,isHasDiscount=_props.isHasDiscount,discountCoupon=_props.discountCoupon,notUseDiscount=_props.notUseDiscount,isAllowAgreement=_props.isAllowAgreement,handleClick=_props.handleClick,agreementSelect=_props.agreementSelect,clickToAgreement=_props.clickToAgreement;var _price=coursesInfo.totalAmount||0;//原价
// 有实物赠品显示地址
var isHaveEntity=inviteAwardList[inviteAwardIndex]?inviteAwardList[inviteAwardIndex].isHaveEntity:0;var price=_price;//优惠后价格
if(discountCoupon.couponAmount){price=Number(discountCoupon.couponAmount-price)>0?0:price-discountCoupon.couponAmount;}price=price/100;var inviteAwardItem=inviteAwardList.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_rows',key:index,onClick:function onClick(i){_this2.handleClick(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},ele.inviteAwardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(inviteAwardIndex===index?'active':'')}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container nasapay '+(this.isMobile?'':'pc')},coursesInfo.purchaseReminder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},coursesInfo.purchaseReminder)),!!isHaveEntity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_wrap'},userAddress?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.handleAddress},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},userAddress.consignee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tele'},' ',userAddress.consigneePhone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address'},userAddress.province+' '+userAddress.city+' '+userAddress.area+' '+userAddress.detail)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address',onClick:this.props.handleAddress},'\u8BF7\u586B\u5199\u6536\u8D27\u5730\u5740'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go',onClick:this.props.handleAddress})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rows course'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{backgroundImage:'url('+coursesInfo.picUrl+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},coursesInfo.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},'\uFFE5',_price/100-~~(_price/100)>0?(_price/100).toFixed(2):_price/100))),!!inviteAwardList.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_wrap'},inviteAwardList.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'\u8D60\u54C1\u4EFB\u9009\u5176\u4E00'),inviteAwardItem):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_rows one'},inviteAwardList[0].inviteAwardName))),!__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].iosClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_coupon',onClick:this.props.handleDiscount},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\u4F18\u60E0\u5238'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_status '+(isHasDiscount?'has':'notHas')},!isHasDiscount?'无可用优惠券':notUseDiscount==='1'?'不使用优惠券':'-'+(Object.keys(discountCoupon).length>0&&Number(discountCoupon.couponAmount/100||0)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go'})),!__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].iosClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pay_way_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weixin pay_way',onClick:function onClick(){_this2.setState({channel:0});_this2.storage.removeItem('user_channel');_this2.storage.setItem('user_channel',0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u5FAE\u4FE1\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(this.state.channel===0?'active':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alipay pay_way',onClick:function onClick(){_this2.setState({channel:1});_this2.storage.removeItem('user_channel');_this2.storage.setItem('user_channel',1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u652F\u4ED8\u5B9D\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(this.state.channel===1?'active':'')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:agreementSelect,className:'agreement '+(isAllowAgreement?'allow':'notAllow')}),'\u540C\u610F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:clickToAgreement},'\u300AAirCourse\u7528\u6237\u652F\u4ED8\u534F\u8BAE\u300B')),courseId==='211'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u8BFE\u7A0B\u6709\u6548\u671F\u4E3A\u8D2D\u8BFE\u8D77365\u5929\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u8BFE\u7A0B\u4E00\u7ECF\u8D2D\u4E70\u4E0D\u5F97\u9000\u6362\u3001\u4E0D\u5F97\u8F6C\u8BFE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u60A8\u53EF\u6839\u636E\u65F6\u95F4\u5B89\u6392\u81EA\u884C\u7EA6\u8BFE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u8BFE\u7A0B\u5305\u542B\u4EB2\u5B50\u4E92\u52A8\u5B9E\u9A8C\u5957\u88C5\u4E00\u4EFD\uFF0C\u5C06\u4E8E\u652F\u4ED8\u540E1-7\u65E5\u5185\u524D\u6309\u7167\u60A8\u586B\u5199\u7684\u6536\u8D27\u5730\u5740\u4E3A\u60A8\u5BC4\u51FA\uFF0C\u6240\u6709\u6750\u6599\u5747\u7ECF\u8FC7\u4E13\u4E1A\u68C0\u6D4B\uFF0C\u53EF\u653E\u5FC3\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001\u5982\u6709\u4EFB\u4F55\u5176\u4ED6\u95EE\u9898\uFF0C\u8BF7\u62E8\u6253\u5BA2\u670D\u70ED\u7EBF\uFF1A400-688-6057\u3002')),this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn pay',onClick:function onClick(){var inviteAwardPackId=inviteAwardList.length?inviteAwardList[inviteAwardIndex].inviteAwardPackId:null;handleClick(coursesInfo.goodsNo,channel,inviteAwardPackId,isHaveEntity);}},'\u7ACB\u5373\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},'\uFFE5',price-~~price>0?price.toFixed(2):price)),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap',onClick:function onClick(){var inviteAwardPackId=inviteAwardList.length?inviteAwardList[inviteAwardIndex].inviteAwardPackId:null;handleClick(coursesInfo.goodsNo,channel,inviteAwardPackId,isHaveEntity);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn pay'},'\u7ACB\u5373\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},price-~~price>0?price.toFixed(2):price,'\u5143')));}}]);return NASAPay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NASAPay);

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DiscountCouponPage_less__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DiscountCouponPage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DiscountCouponPage_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* 选择优惠券页面
*/// import { COURSE_URL } from "../../constants";
var DiscountCoupon=function(_Component){_inherits(DiscountCoupon,_Component);function DiscountCoupon(props){_classCallCheck(this,DiscountCoupon);var _this=_possibleConstructorReturn(this,(DiscountCoupon.__proto__||Object.getPrototypeOf(DiscountCoupon)).call(this,props));_this.sendNotificationToH5=function(res){var _JSON$parse=JSON.parse(res),notification=_JSON$parse.notification;if(notification==='aboutToClose'){localStorage.removeItem('no_use_discount');localStorage.removeItem('user_discount');// 清除，下次进入则重新接口获取
}};_this.GetDiscountList=function(goodsId){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getDiscountList({data:{goodsId:goodsId}},function(res,err){if(err){alert(err.errorMessage);return;}_this.setState({discountList:res||[],completeRender:true});});};_this.handleBack=function(){window.history.back();};_this.state={couponId:'',// 所选优惠券
isMobile:__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].mobileClient,completeRender:false,// 是否loading
discountList:[]// 优惠券列表
};return _this;}_createClass(DiscountCoupon,[{key:'componentWillMount',value:function componentWillMount(){// 保存是否勾选协议
var isAllowAgreement=this.props.location.state.isAllowAgreement;if(isAllowAgreement){localStorage.setItem('is_allow_agreement',isAllowAgreement);}localStorage.setItem('no_use_discount',this.props.location.state.notUseDiscount);var discountCoupon=this.props.location.state.discountCoupon;if(!!discountCoupon&&Object.keys(discountCoupon).length>0){localStorage.setItem('user_discount',JSON.stringify(this.props.location.state.discountCoupon));}this.setState({couponId:this.props.location.state.couponId// source: this.props.location.state.source
});// 获取该课程可用优惠券列表
this.GetDiscountList(this.props.location.state.goodsId);Object(__WEBPACK_IMPORTED_MODULE_5__api_web__["b" /* apiDefine */])({apiName:'sendNotificationToH5',fn:this.sendNotificationToH5});// 定义客户端关闭按钮
}// 获取该课程可用优惠券列表
// 退回上一页
},{key:'selectDiscount',// 选择优惠券
value:function selectDiscount(id,item){if(!id)throw new Error('id must be required');// const { source } = this.state;
// const sourcePath = source ? source : 'nasapay'; 
this.setState({couponId:id});if(item){// 选择使用优惠券
localStorage.setItem('no_use_discount','0');localStorage.setItem('user_discount',JSON.stringify(item));}else{localStorage.setItem('no_use_discount','1');localStorage.removeItem('user_discount');}// this.props.history.replace(`${COURSE_URL}/${sourcePath}${window.location.search}`);
this.handleBack();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,discountList=_state.discountList,completeRender=_state.completeRender,isMobile=_state.isMobile,couponId=_state.couponId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'选择优惠券'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__template_Load_Load__["a" /* default */],null),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn back',onClick:this.handleBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4F7F\u7528\u4F18\u60E0\u5238'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line'})),discountList.length===0&&completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty '+(isMobile?'':'empty_pc')},'\u6CA1\u6709\u53EF\u7528\u7684\u4F18\u60E0\u5238\u54E6')),discountList.length>0&&completeRender&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_wrap '+(isMobile?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_item no_use',onClick:function onClick(){return _this2.selectDiscount(-1);}},'\u4E0D\u4F7F\u7528\u4F18\u60E0\u5238',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle '+(couponId===-1?'active':'')})),discountList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,className:'discount_item can_use',onClick:function onClick(){return _this2.selectDiscount(item.id,item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'diccount_desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_desc_title'},item.couponName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_desc_time'},'\u6709\u6548\u671F\u81F3',__WEBPACK_IMPORTED_MODULE_2_dayjs___default()(item.endTime).format('YYYY-MM-DD HH:mm')),item.couponCourseType===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'platform'},'\u5168\u5E73\u53F0\u901A\u7528'),item.couponCourseType===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'platform'},item.couponCourseInfos.length===1?'\u8D2D\u4E70\u300A'+item.couponCourseInfos[0].cnName+'\u300B\u53EF\u7528':'限定课程可以使用')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'money'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'money_cur'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA5'),item.couponAmount/100||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'money_total'},item.couponConditionAmount===0?'无门槛使用':'\u6EE1'+(item.couponConditionAmount/100||0)+'\u53EF\u7528'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle '+(couponId===item.id?'active':'')})));}))));}}]);return DiscountCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DiscountCoupon);

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_Logistics_Logistics__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__template_Nothing_Nothing__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_loginModal_login__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ua__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { COURSE_URL } from "../../constants";
var queryObj=Object(__WEBPACK_IMPORTED_MODULE_5__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var LogisticsPage=function(_Component){_inherits(LogisticsPage,_Component);function LogisticsPage(props){_classCallCheck(this,LogisticsPage);var _this=_possibleConstructorReturn(this,(LogisticsPage.__proto__||Object.getPrototypeOf(LogisticsPage)).call(this,props));_this.getChildrenMsg=function(result,msg){console.log('mes',msg);_this.setState({loginModalShow:msg.loginShow});localStorage.setItem('loginStuId',msg.id);__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getLogistics({data:{userId:msg.id}},function(res,err){_this.setState({completeRander:true,logisticsInfo:res,id:msg.id});});};_this.getChildrenClose=function(result,msg){_this.setState({loginModalShow:msg});};_this.isMobile=__WEBPACK_IMPORTED_MODULE_9__utils_ua__["a" /* default */].mobileClient;_this.state={loginModalShow:false,channelId:'',id:null};return _this;}_createClass(LogisticsPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var channelId=queryObj.channelid;var id=localStorage.getItem('loginStuId');var stu=queryObj.stuid;var userId=stu||id;__WEBPACK_IMPORTED_MODULE_6__api_axios__["a" /* default */].getLogistics({data:{userId:userId}},function(res,err){// if(err) alert(err.errorMessage);
// 如果返回错误，跳转登录页面
if(err){_this2.setState({loginModalShow:true,channelId:channelId});console.log('133',localStorage.setItem('loginStuId',queryObj.stuid));}else{_this2.setState({completeRander:true,logisticsInfo:res,channelId:channelId// loginModalShow: false
// logisticsInfo: [
//     {
//         waybillNo:123456,
//         status: 0,
//         inviteAwardName: '实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材实验器材',
//         consignee: '王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗',
//         consigneePhone: '13546875645',
//         // province: '浙江省',
//         // city: '杭州市',
//         // area: '拱墅区',
//         // addressDetail: '丰潭路508号7号楼11F'
//         addressId: 0
//     },
//     {
//         waybillNo:123456,
//         status: 0,
//         inviteAwardName: '实验器材',
//         consignee: '王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗王二狗',
//         consigneePhone: '13546875645',
//         province: '浙江省',
//         city: '杭州市',
//         area: '拱墅区',
//         addressDetail: '丰潭路508号7号楼11F',
//         addressId: 1
//     }
// ]
});}});}// 登录后关闭弹窗
},{key:'render',value:function render(){var _state=this.state,_state$logisticsInfo=_state.logisticsInfo,logisticsInfo=_state$logisticsInfo===undefined?[]:_state$logisticsInfo,completeRander=_state.completeRander,loginModalShow=_state.loginModalShow,channelId=_state.channelId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'物流详情'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:false,showClose:false,title:'物流详情'}),!!(completeRander&&logisticsInfo.length)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_Logistics_Logistics__["a" /* default */],{logisticsInfo:logisticsInfo,isMobile:this.isMobile}),!!(completeRander&&!logisticsInfo.length)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__template_Nothing_Nothing__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_loginModal_login__["a" /* default */],{loginModalShow:loginModalShow,channelId:channelId,parent:this})));}}]);return LogisticsPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LogisticsPage);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logistics=function(_Component){_inherits(Logistics,_Component);function Logistics(props){_classCallCheck(this,Logistics);var _this=_possibleConstructorReturn(this,(Logistics.__proto__||Object.getPrototypeOf(Logistics)).call(this,props));_this.state={channel:0,isAllow:true,btnDown:[]};return _this;}_createClass(Logistics,[{key:'btnDown',value:function btnDown(index){var list=[];list[index]='down';this.setState({btnDown:list});}},{key:'btnUp',value:function btnUp(){this.setState({btnDown:[]});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,logisticsInfo=_props.logisticsInfo,isMobile=_props.isMobile;var btnDown=this.state.btnDown;var items=logisticsInfo.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rows status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text'},'\u8FD0\u5355\u53F7\uFF1A',!!ele.status?ele.waybillNo:'暂无'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'blue'},ele.status?'已发货':'待发货')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rows course'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{backgroundImage:'url('+ele.inviteAwardPicUrl+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title '+(ele.inviteAwardName&&ele.inviteAwardName.length>=32&&'long')},ele.inviteAwardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'num'},'x1')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'break_line'}),!!ele.addressId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},'\u6536\u8D27\u4EBA\uFF1A',ele.consignee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tele'},ele.consigneePhone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address'},ele.province+' '+ele.city+' '+ele.area+' '+ele.addressDetail)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn detail status'+ele.status+' '+btnDown[index],onMouseUp:function onMouseUp(e){var classname=e.target.className;_this2.btnUp();if(classname.indexOf('status0')>-1)return false;window.location.href='https://baidu.com/s?wd='+ele.waybillNo;},onTouchEnd:function onTouchEnd(e){var classname=e.target.className;_this2.btnUp();if(classname.indexOf('status0')>-1)return false;window.location.href='https://baidu.com/s?wd='+ele.waybillNo;},onMouseDown:function onMouseDown(e){var classname=e.target.className;if(classname.indexOf('status0')>-1)return false;_this2.btnDown(index);},onTouchStart:function onTouchStart(e){var classname=e.target.className;if(classname.indexOf('status0')>-1)return false;_this2.btnDown(index);},onMouseOut:_this2.btnUp.bind(_this2)},'\u67E5\u770B\u7269\u6D41')));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container logistics '+(isMobile?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'excl'},'!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u5173\u6CE8\u7231\u8BFEAirCourse\u516C\u4F17\u53F7\uFF0C\u8F93\u5165\u201C\u4EBA\u5DE5\u201D\u6216\u201C\u8F6C\u4EBA\u5DE5\u201D\u54A8\u8BE2\u5BA2\u670D')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,items));}}]);return Logistics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Logistics);

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nothing=function(_Component){_inherits(Nothing,_Component);function Nothing(){_classCallCheck(this,Nothing);return _possibleConstructorReturn(this,(Nothing.__proto__||Object.getPrototypeOf(Nothing)).apply(this,arguments));}_createClass(Nothing,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nothing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E'));}}]);return Nothing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Nothing);

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nothing.d09aadce.png";

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_login_phone_png__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_images_login_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_images_login_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_login_code_png__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_login_code_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_login_code_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_login_close_png__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_login_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_login_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WebViewHeader=function(_Component){_inherits(WebViewHeader,_Component);function WebViewHeader(props){_classCallCheck(this,WebViewHeader);var _this=_possibleConstructorReturn(this,(WebViewHeader.__proto__||Object.getPrototypeOf(WebViewHeader)).call(this,props));_this.closeHide=function(){_this.props.parent.getChildrenClose(_this,'false');};_this.toLogin=function(channelId){var _this$state=_this.state,phoneInput=_this$state.phoneInput,codeInput=_this$state.codeInput;var reg=/^[1][3,4,5,7,8][0-9]{9}$/;var reg2=/^[0-9]{6}$/;var reg001=/^[0][0][1][0-9]{8}$/;var phoneTest=reg.test(phoneInput)||reg001.test(phoneInput);var codeTest=reg2.test(codeInput);console.log('1212',reg.test(phoneInput),reg001.test(phoneInput),reg2.test(codeInput));console.log('233',phoneTest,codeTest);if(!phoneTest){console.log('手机号正确');alert('请填写正确手机号');return;}if(!codeTest){console.log('验证码正确');alert('请填写正确验证码');return;}__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].login({data:{phone:phoneInput,smsCode:codeInput,channel:'WX_MP',channelId:channelId}},function(res,err){if(err)alert(err.errorMessage);else{console.log('登录成功',res);var params={loginShow:false,id:res.id};_this.props.parent.getChildrenMsg(_this,params);}});};_this.getCode=function(){var _this$state2=_this.state,timeLiked=_this$state2.timeLiked,phoneInput=_this$state2.phoneInput;if(phoneInput===''){alert('请输入手机号');return;}if(!timeLiked)return;__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].smsCode({data:{phone:phoneInput,type:1}},function(res,err){if(err)alert(err.errorMessage);else{alert('验证码已发送');}});_this.countDown();};_this.countDown=function(){var count=_this.state.count;if(count===1){_this.setState({count:60,timeLiked:true});}else{_this.setState({count:count-1,timeLiked:false,codeText:count+'s'});setTimeout(_this.countDown.bind(_this),1000);}};_this.state={codeText:'请输入验证码',channelId:'',phoneInput:'',codeInput:'',count:60,timeLiked:true};return _this;}// 获取手机号value
_createClass(WebViewHeader,[{key:'phoneInputChange',value:function phoneInputChange(){var value=this.refs.phoneInput.value;this.setState({phoneInput:value});}// 获取验证码value
},{key:'codeInputChange',value:function codeInputChange(){// const { timeLiked } = this.state
var value=this.refs.codeInput.value;this.setState({codeInput:value});}// 关闭按钮
},{key:'toAgree',// 跳转到服务协议页面
value:function toAgree(){// const { history } = this.props;
// history.replace('/agreement')
// this.props.history.push('/agreement')
// history.push({
//   pathname: `${COURSE_URL}/agreement}`,
// });
window.location.href=__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* COURSE_URL */]+'/agreement';}// 登录
// 验证码
},{key:'render',value:function render(){var _this2=this;var _props=this.props,loginModalShow=_props.loginModalShow,channelId=_props.channelId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,loginModalShow===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginModal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'close',src:__WEBPACK_IMPORTED_MODULE_3__static_images_login_close_png___default.a,alt:'close',onClick:this.closeHide}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u7528\u6237\u767B\u5F55'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__static_images_login_phone_png___default.a,alt:'phone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'\u8BF7\u8F93\u5165\u624B\u673A\u53F7',ref:'phoneInput',onChange:function onChange(){return _this2.phoneInputChange();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__static_images_login_code_png___default.a,alt:'code'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801',ref:'codeInput',onChange:function onChange(){return _this2.codeInputChange();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.getCode.bind(this)},this.state.codeText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn',onClick:this.toLogin.bind(this,channelId)},'\u767B\u5F55'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'agreement'},'\u672A\u6CE8\u518C\u7528\u6237\u767B\u5F55\u540E\u81EA\u52A8\u6CE8\u518C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u6CE8\u518C\u5373\u8868\u660E\u540C\u610F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.toAgree},'\u300AAirCourse\u670D\u52A1\u534F\u8BAE\u300B')))));}}]);return WebViewHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WebViewHeader);

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/code.77333594.png";

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentAgreement=function(_Component){_inherits(PaymentAgreement,_Component);function PaymentAgreement(props){_classCallCheck(this,PaymentAgreement);var _this=_possibleConstructorReturn(this,(PaymentAgreement.__proto__||Object.getPrototypeOf(PaymentAgreement)).call(this,props));_this.handleBack=function(){window.history.back();};_this.state={isMobile:__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient};return _this;}_createClass(PaymentAgreement,[{key:'componentWillMount',value:function componentWillMount(){var isAllowAgreement=this.props.location.state.isAllowAgreement;if(isAllowAgreement){localStorage.setItem('is_allow_agreement',isAllowAgreement);}localStorage.setItem('no_use_discount',this.props.location.state.notUseDiscount);var discountCoupon=this.props.location.state.discountCoupon;if(!!discountCoupon&&Object.keys(discountCoupon).length>0){localStorage.setItem('user_discount',JSON.stringify(this.props.location.state.discountCoupon));}}// 退回上一页
},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'用户支付协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container customerrules '+(this.state.isMobile?'':'pc')},!this.state.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn back',onClick:this.handleBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'\u7528\u6237\u652F\u4ED8\u534F\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.state.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300AAirCourse\u7528\u6237\u652F\u4ED8\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u60A8\u597D\uFF0C\u5728\u4F7F\u7528AirCourse\u7F51\u7EDC\u82F1\u8BED\u8BFE\u7A0B\u670D\u52A1\u4E4B\u524D\uFF0C\u8BF7\u60A8\u5E94\u4ED4\u7EC6\u9605\u8BFB\u672C\u8BFE\u7A0B\u670D\u52A1\u534F\u8BAE\uFF0C\u5728\u6309\u7167\u672C\u534F\u8BAE\u63D0\u793A\u586B\u5199\u4FE1\u606F\u3001\u9605\u8BFB\u5E76\u540C\u610F\u672C\u534F\u8BAE\u540E\uFF0C\u5373\u8868\u793A\u60A8\u5DF2\u5145\u5206\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u63A5\u53D7\u672C\u534F\u8BAE\u7684\u5168\u90E8\u5185\u5BB9\u3002\u672C\u534F\u8BAE\u5373\u6784\u6210\u5BF9\u53CC\u65B9\u5177\u6709\u7EA6\u675F\u529B\u7684\u6CD5\u5F8B\u6587\u4EF6\u3002\u7532\u65B9\u5C4A\u65F6\u4E0D\u5E94\u4EE5\u672A\u9605\u8BFB\u672C\u534F\u8BAE\u7684\u5185\u5BB9\u6216\u8005\u672A\u83B7\u5F97\u672C\u7AD9\u5BF9\u60A8\u95EE\u8BE2\u7684\u89E3\u7B54\u7B49\u7406\u7531\uFF0C\u4E3B\u5F20\u672C\u534F\u8BAE\u65E0\u6548\uFF0C\u6216\u8981\u6C42\u64A4\u9500\u3002AirCourse\u82F1\u8BED\u7F51\u7AD9\u4E0A\u7684\u5404\u9879\u670D\u52A1\u7684\u6240\u6709\u6743\u548C\u8FD0\u4F5C\u6743\u5F52\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u6240\u6709\u3002\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u5C06\u5B8C\u5168\u6309\u7167\u5176\u53D1\u5E03\u7684\u670D\u52A1\u6761\u6B3E\u548C\u64CD\u4F5C\u89C4\u5219\u4E25\u683C\u6267\u884C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E00\u3001\u534F\u8BAE\u4E3B\u4F53\u548C\u7B7E\u8BA2\u65B9\u5F0F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u672C\u534F\u8BAE\u4E2D\u7684\u201C\u7532\u65B9\u201D\u662F\u6307\u8D2D\u4E70\u4E59\u65B9\u76F8\u5E94\u8BFE\u7A0B\u7684\u81EA\u7136\u4EBA\uFF0C\u201C\u4E59\u65B9\u201D\u662F\u6307\u201C\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u201D\u3002\u672C\u534F\u8BAE\u4E2D\u7684\u201C\u5B66\u5458\u201D\u6216\u8005\u201C\u7532\u65B9\u5B66\u5458\u201D\u662F\u6307\u5728\u4E59\u65B9\u7684\u5B98\u65B9\u7F51\u7AD9\u4E2D\u7684\u7532\u65B9\u7684\u6CE8\u518C\u8D26\u6237\u4E0B\u5B66\u4E60\u7532\u65B9\u6240\u8D2D\u4E70\u7684\u8BFE\u7A0B\u5305\u7684\u4E00\u540D\u56FA\u5B9A\u5B66\u5458\uFF0C\u5373\u672C\u534F\u8BAE\u7532\u65B9\u767B\u8BB0\u7684\u5B66\u5458\u672C\u4EBA\uFF0C\u672A\u7ECF\u4E59\u65B9\u8BB8\u53EF\uFF0C\u4E0D\u5F97\u5411\u7B2C\u4E09\u65B9\u8F6C\u8BA9\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u8BFE\u7A0B\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\uFF0E\u672C\u534F\u8BAE\u7684\u201C\u7532\u65B9\u201D\u5E94\u4E3A\u6CD5\u5F8B\u4E0A\u7684\u5DF2\u6EE118\u5468\u5C81\u7684\u5B8C\u5168\u6C11\u4E8B\u884C\u4E3A\u80FD\u529B\u4EBA\uFF0C\u82E5\u201C\u7532\u65B9\u201D\u4E0D\u5177\u5907\u8BE5\u4E3B\u4F53\u8D44\u683C\uFF0C\u5219\u7532\u65B9\u7684\u76D1\u62A4\u4EBA\u5E94\u627F\u62C5\u56E0\u6B64\u800C\u5BFC\u81F4\u7684\u4E00\u5207\u540E\u679C\uFF0C\u4E14\u4E59\u65B9\u6709\u6743\u6CE8\u9500\u6216\u6C38\u4E45\u51BB\u7ED3\u7532\u65B9\u7684\u8D26\u6237\uFF0C\u5E76\u5411\u7532\u65B9\u53CA\u5176\u76D1\u62A4\u4EBA\u7D22\u507F\u76F8\u5E94\u635F\u5931\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.\u901A\u8FC7\u7532\u65B9\u8D26\u53F7\u5728\u4E59\u65B9\u7F51\u7AD9\u53D1\u751F\u7684\u8BFE\u7A0B\u8D2D\u4E70\u884C\u4E3A\u5747\u89C6\u4E3A\u7532\u65B9\u672C\u4EBA\u7684\u771F\u5B9E\u610F\u601D\uFF0C\u8868\u793A\u7532\u65B9\u672C\u4EBA\u7684\u884C\u4E3A\u3002\u672C\u534F\u8BAE\u901A\u8FC7\u7535\u5B50\u6587\u672C\u5F62\u6210\u5236\u6210\u81EA\u4E59\u65B9\u6536\u5230\u7532\u65B9\u652F\u4ED8\u7684\u8BFE\u7A0B\u8D39\u7528\u8D77\u751F\u6548\uFF0C\u4E00\u7ECF\u6210\u7ACB\u751F\u6548\u5373\u4E0D\u53EF\u64A4\u9500\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E8C\u3001\u8BFE\u7A0B\u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u4E59\u65B9\u4F1A\u6839\u636E\u5B66\u5458\u7684\u80FD\u529B\u9636\u6BB5\uFF0C\u5B89\u6392\u6700\u5408\u9002\u7684\u8D77\u59CB\u8BFE\u7A0B\u7EA7\u522B\uFF0C\u7532\u65B9\u540C\u610F\u6240\u8D2D\u4E70\u534F\u8BAE\u8BFE\u7A0B\u4ECE\u8BE5\u7EA7\u522B\u5F00\u59CB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2.\u7532\u65B9\u6B64\u6B21\u8D2D\u4E70\u8BFE\uFF1A\u3016\u3017\u5143/\u3016\u3017\u8BFE\u65F6\uFF08\u5929\u6570\uFF09\u8BFE\u7A0B\uFF08\u4EE5\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u652F\u4ED8\u94FE\u63A5\u652F\u4ED8\u6700\u7EC8\u4EF7\u683C\u4E3A\u51C6\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.\u4E59\u65B9\u63D0\u4F9B\u7684\u8BFE\u7A0B\u662F\u6309\u7167\u7532\u65B9\u8D2D\u4E70\u7684\u6709\u6548\u671F\u63D0\u4F9B\u670D\u52A1\uFF0C\u5373\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u6216\u4E59\u65B9\u6388\u6743\u7684\u6E20\u9053\u8D2D\u4E70\u540E\uFF0C\u5373\u53EF\u5728\u6240\u8D2D\u4E70\u7684\u6709\u6548\u671F\u5185\u4EAB\u53D7\u7532\u65B9\u63D0\u4F9B\u7684\u7F51\u7EDC\u5728\u7EBF\u6559\u5B66\u7B49\u670D\u52A1\u3002\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5728\u7EBF\u76F4\u64AD\u8BFE\u5802\uFF0C\u89C6\u9891\u97F3\u9891\u6587\u4EF6\u4F7F\u7528\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4.\u4E59\u65B9\u627F\u8BFA\u6309\u7167\u7532\u65B9\u652F\u4ED8\u65F6\u6240\u7EA6\u5B9A\u7684\u6709\u6548\u5929\u6570\u4E3A\u7532\u65B9\u63D0\u4F9B\u5728\u7EBF\u6559\u5B66\u670D\u52A1\uFF0C\u8D85\u8FC7\u6709\u6548\u671F\uFF0C\u7532\u65B9\u8D26\u53F7\u5C06\u4F1A\u5931\u6548\uFF0C\u9700\u7532\u7531\u65B9\u91CD\u65B0\u8D2D\u4E70\u65B9\u53EF\u7EE7\u7EED\u4EAB\u53D7\u7532\u65B9\u7684\u76F8\u5173\u670D\u52A1\u5185\u5BB9\u3002\u5728\u7532\u65B9\u8D2D\u4E70\u7684\u6709\u6548\u671F\u5185\uFF0C\u4E59\u65B9\u6BCF\u665A\u5C06\u63D0\u4F9B\u4E00\u8282\u5728\u7EBF\u5916\u6559\u76F4\u64AD\u8BFE\uFF0C\u63D0\u4F9B\u7684\u6709\u6548\u670D\u52A1\u65F6\u957F\u4E3A\uFF1A\u3016\u3017\u5929\u6709\u6548\u671F\uFF0C\u5373\u7532\u65B9\u5728\u4E59\u65B9\u5E73\u53F0\u8D2D\u4E70\u540E\u6BCF\u8D85\u8FC724\u5C0F\u65F6\uFF0C\u6D88\u8017\u4E00\u5929\u6709\u6548\u671F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E09\u3001\u8BFE\u7A0B\u670D\u52A1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u6216\u4E59\u65B9\u6388\u6743\u7684\u6E20\u9053\u8D2D\u4E70\u4E59\u65B9\u8BFE\u7A0B\u540E\uFF0C\u5373\u53EF\u7528\u8D2D\u4E70\u65F6\u7684\u624B\u673A\u53F7\u4F5C\u4E3A\u767B\u5F55\u8D26\u53F7\u4EAB\u53D7\u6709\u6548\u671F\u5185\u7684\u8BFE\u7A0B\u7B49\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2.\u7532\u65B9\u4E0D\u5F97\u4F7F\u7528\u8D2D\u4E70\u8D26\u53F7\u7528\u4E8E\u4EFB\u4F55\u8FDD\u6CD5\uFF0C\u5546\u4E1A\u7528\u9014\u4ECE\u800C\u4FB5\u72AF\u4E59\u65B9\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u5426\u5219\uFF0C\u7532\u65B9\u627F\u62C5\u4E00\u5207\u4E59\u65B9\u635F\u5931\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.\u7532\u65B9\u53EF\u4EE5\u4ECE\u4E59\u65B9\u83B7\u53D6\u6240\u8D2D\u4E70\u8BFE\u7A0B\u76F8\u5173\u7684\u652F\u6301\u6027\u8F85\u52A9\u670D\u52A1\u3002\u4E59\u65B9\u5E94\u5F53\u534F\u52A9\u7532\u65B9\u987A\u5229\u4F7F\u7528\u5E73\u53F0\u4EA7\u54C1\u8FDB\u884C\u5B66\u4E60\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4.\u4E3A\u4FDD\u62A4\u4E59\u65B9\u5408\u6CD5\u6743\u5229\uFF0C\u4E59\u65B9\u6709\u6743\u9650\u5236\u7532\u65B9\u540C\u4E00\u8D26\u53F7\u7ED1\u5B9A\u7684\u8BBE\u5907\u6570\u91CF\u4E3A\u30103\u3011\u53F0\uFF0C\u4E14\u7532\u65B9\u540C\u4E00\u8D26\u53F7\u7684\u30103\u3011\u53F0\u8BBE\u5907\u4E00\u7ECF\u7ED1\u5B9A\uFF0C\u5373\u4E0D\u5F97\u65B0\u589E/\u53D8\u66F4\u7ED1\u5B9A\u8BE5\u30103\u3011\u53F0\u8BBE\u5907\u4EE5\u5916\u7684\u5176\u4ED6\u8BBE\u5907\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u56DB\u3001\u4E0A\u8BFE\u89C4\u5B9A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u4E3A\u786E\u4FDD\u6240\u5728\u73ED\u7EA7\u826F\u597D\u7684\u8BFE\u5802\u6C1B\u56F4\uFF0C\u7532\u65B9\u5E94\u534F\u52A9\u4E59\u65B9\uFF0C\u4FDD\u969C\u5B66\u5458\u5728\u4E0A\u8BFE\u8FC7\u7A0B\u4E2D\u4E0D\u5435\u95F9\uFF0C\u4E0D\u8FDF\u5230\uFF0C\u4E0D\u65E9\u9000\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2.\u5982\u9047\u7279\u6B8A\u539F\u56E0\uFF0C\u4E59\u65B9\u5728\u544A\u77E5\u7532\u65B9\u7684\u540C\u65F6\u6709\u6743\u5BF9\u7532\u65B9\u4E0A\u8BFE\u8D26\u53F7\u505A\u9759\u97F3\u3001\u4E0B\u7EBF\u7B49\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.\u7532\u65B9\u6216\u5B66\u5458\u5728\u8BFE\u7A0B\u8FDB\u884C\u4E2D\u5982\u5B58\u5728\u4EE5\u4E0B\u60C5\u5F62\uFF0C\u4E59\u65B9\u6216\u5916\u6559\u6709\u6743\u4E2D\u6B62\u8BFE\u7A0B\u670D\u52A1\uFF0C\u4E14\u6263\u9664\u8BFE\u65F6\uFF1B\u540C\u65F6\u4E59\u65B9\u6709\u6743\u5220\u9664\u8BE5\u6B21\u8BFE\u7A0B\u670D\u52A1\u7684\u5168\u90E8\u89C6\u9891\uFF0C\u4E14\u65E0\u987B\u627F\u62C5\u4EFB\u4F55\u6CD5\u5F8B\u540E\u679C\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(1)\u8863\u7740\u66B4\u9732\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u88F8\u9732\u8EAB\u4F53\u9690\u79C1\u90E8\u4F4D\u7B49\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(2)\u591A\u4E2A\u5B69\u5B50\u4E0A\u8BFE\u6216\u975E\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u5B66\u5458\u672C\u4EBA\u4E0A\u8BFE\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6210\u4EBA\u4EE3\u66FF\u4E0A\u8BFE\u7B49\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(3)\u5BB6\u66B4\u884C\u4E3A\u6216\u8005\u4E0D\u9002\u5F53\u7684\u7BA1\u6559\u884C\u4E3A\uFF0C\u5305\u62EC\u60E9\u7F5A\u6027\u7684\u80A2\u4F53\u63A5\u89E6\u6216\u8005\u4E25\u91CD\u8FB1\u9A82\u7B49\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(4)\u4F7F\u7528\u5371\u9669\u7684\u7528\u5177\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5200\u5177\u3001\u4EFF\u771F\u67AA\u7B49\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(5)\u635F\u5BB3\u56FD\u5BB6\u7684\u5C0A\u4E25\u6216\u8005\u5229\u76CA\uFF0C\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(6)\u5371\u5BB3\u4EBA\u8EAB\u3001\u8D22\u4EA7\u5B89\u5168\uFF0C\u6CC4\u9732\u4E2A\u4EBA\u9690\u79C1\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(7)\u59A8\u788D\u793E\u4F1A\u516C\u5171\u79E9\u5E8F\u6216\u8005\u8FDD\u80CC\u793E\u4F1A\u826F\u597D\u98CE\u5C1A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(8)\u6709\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u8FF7\u4FE1\u3001\u6050\u6016\u3001\u66B4\u529B\u76F8\u5173\u7684\u8A00\u884C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(9)\u6709\u6C11\u65CF\u3001\u79CD\u65CF\u3001\u5B97\u6559\u3001\u6027\u522B\u6B67\u89C6\u76F8\u5173\u7684\u8A00\u884C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(10)\u5BF9\u5916\u6559\u8FDB\u884C\u653B\u51FB\u6027\u3001\u6B67\u89C6\u6027\u7684\u8A00\u884C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(11)\u8FDD\u53CD\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6CD5\u5F8B\u6CD5\u89C4\u7684\u5176\u4ED6\u884C\u4E3A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(12)\u8FDD\u53CD\u5916\u6559\u6240\u5728\u5730\u76F8\u5173\u6CD5\u5F8B\u6216\u4E59\u65B9\u5E73\u53F0\u89C4\u5219\u7684\u884C\u4E3A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(13)\u4E59\u65B9\u5408\u7406\u8BA4\u5B9A\u5E94\u5F53\u5BF9\u7532\u65B9\u4E2D\u6B62\u8BFE\u7A0B\u670D\u52A1\u6216\u5220\u9664\u76F8\u5173\u89C6\u9891\u7684\u5176\u4ED6\u884C\u4E3A\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E94\u3001\u9000\u8D39'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7532\u65B9\u4E86\u89E3\u5E76\u540C\u610F\u7B7E\u8BA2\u672C\u5408\u540C\u540E\uFF0C\u82E5\u6B32\u7533\u8BF7\u89E3\u9664\u6216\u7EC8\u6B62\u5408\u540C\u53CA\u9000\u8D39\uFF0C\u5E94\u5728\u8D2D\u4E70\u540E\u30107\u3011\u5929\u5185\u5411\u4E59\u65B9\u63D0\u51FA\u89E3\u9664\u7533\u8BF7\uFF0C\u4E59\u65B9\u5C06\u5728\u6536\u5230\u7533\u8BF7\u540E\u7684\u30103\u3011\u4E2A\u5DE5\u4F5C\u65E5\u5185\u539F\u8DEF\u8FD4\u8FD8\u7532\u65B9\u652F\u4ED8\u7684\u8D39\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u516D\u3001\u8BB8\u53EF\u4F7F\u7528\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7532\u65B9\u540C\u610F\uFF0C\u4E59\u65B9\u5BF9\u7532\u65B9\u5728\u4E59\u65B9\u7F51\u4E0A\u53D1\u8868\u7684\u4F9B\u5B66\u4E60\u4EA4\u6D41\u7684\u4F5C\u54C1\u3001\u8BC4\u4EF7\uFF0C\u4EAB\u6709\u72EC\u5BB6\u7684\u51FA\u7248\u3001\u53D1\u884C\u548C\u590D\u5236\u7684\u6743\u5229\u3002\u7532\u65B9\u4EE5\u6B64\u6388\u4E88\u4E59\u65B9\u53CA\u5176\u5173\u8054\u516C\u53F8\u72EC\u5BB6\u7684\u3001\u5168\u7403\u901A\u7528\u7684\u3001\u6C38\u4E45\u7684\u3001\u514D\u8D39\u7684\u8BB8\u53EF\u4F7F\u7528\u6743\u5229(\u5E76\u6709\u6743\u5728\u591A\u4E2A\u5C42\u9762\u5BF9\u8BE5\u6743\u5229\u8FDB\u884C\u518D\u6388\u6743)\uFF0C\u4F7F\u4E59\u65B9\u53CA\u5176\u5173\u8054\u516C\u53F8\u6709\u6743(\u5168\u90E8\u6216\u90E8\u5206\u5730)\u4F7F\u7528\u3001\u590D\u5236\u3001\u4FEE\u8BA2\u3001\u6539\u5199\u3001\u53D1\u5E03\u3001\u7FFB\u8BD1\u3001\u5206\u53D1\u3001\u6267\u884C\u548C\u5C55\u793A\u7532\u65B9\u7684\u4F7F\u7528\u6570\u636E\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6CE8\u518C\u8D44\u6599\u3001\u4EA4\u6613\u884C\u4E3A\u6570\u636E\u53CA\u5168\u90E8\u5C55\u793A\u4E8E\u7F51\u7AD9\u7684\u5404\u7C7B\u4FE1\u606F)\u6216\u5236\u4F5C\u5176\u6D3E\u751F\u4F5C\u54C1\uFF0C\u548C/\u6216\u4EE5\u73B0\u5728\u5DF2\u77E5\u6216\u65E5\u540E\u5F00\u53D1\u7684\u4EFB\u4F55\u5F62\u5F0F\u3001\u5A92\u4F53\u6216\u6280\u672F\uFF0C\u5C06\u4E0A\u8FF0\u4FE1\u606F\u7EB3\u5165\u5176\u5B83\u4F5C\u54C1\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E03\u3001\u77E5\u8BC6\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E59\u65B9\u7F51\u7AD9\u5185\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u8868\u73B0\u7684\u4F5C\u54C1(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u8F6F\u4EF6\u3001\u58F0\u97F3\u3001\u56FE\u7247\u3001\u5F55\u50CF\u3001\u8868\u683C\u3001\u7535\u5B50\u90AE\u4EF6\u7B49)\u7684\u8457\u4F5C\u6743\uFF0C\u7531\u4E59\u65B9\u4EAB\u6709\uFF0C\u7532\u65B9\u672A\u7ECF\u8BB8\u53EF\uFF0C\u4E0D\u5F97\u64C5\u81EA\u5BF9\u4E59\u65B9\u7684\u5305\u62EC\u6559\u6750\u3001\u7535\u5B50\u8BFE\u4EF6\u5728\u5185\u7684\u4EFB\u4F55\u4F5C\u54C1\u8FDB\u884C\u4EFB\u4F55\u5F62\u5F0F\u7684\u7FFB\u5F55\u3001\u590D\u5236\u6216\u4ECE\u4E8B\u5176\u4ED6\u4EFB\u4F55\u8FDD\u53CD\u8457\u4F5C\u6743\u6CD5\u7B49\u76F8\u5173\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u6D3B\u52A8\u3002\u5BF9\u4FB5\u72AF\u4E59\u65B9\u77E5\u8BC6\u4EA7\u6743\u7684\u4E2A\u4EBA\u548C\u7EC4\u7EC7\uFF0C\u4E59\u65B9\u53CA\u5176\u5173\u8054\u516C\u53F8\u5C06\u4F9D\u6CD5\u8FFD\u7A76\u5176\u6C11\u4E8B\u6216\u5211\u4E8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u516B\u3001\u4E0D\u53EF\u6297\u529B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u63D0\u4F9B\u8BFE\u7A0B\u670D\u52A1\u7684\u5916\u6559\u6240\u5728\u5730\u53D1\u751F\u7A81\u53D1\u7684\u81EA\u7136\u707E\u5BB3\u3001\u653F\u6CBB\u52A8\u4E71\u7B49\u4E0D\u4EE5\u4E59\u65B9\u7684\u610F\u5FD7\u4E3A\u8F6C\u79FB\u7684\u7A81\u53D1\u4E8B\u4EF6\uFF0C\u4E59\u65B9\u5BF9\u7532\u65B9\u6709\u901A\u77E5\u4E49\u52A1\uFF0C\u5E76\u4E14\u6709\u6743\u5EF6\u671F\u63D0\u4F9B\u670D\u52A1\uFF0C\u6216\u8005\u6682\u65F6\u505C\u6B62\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E5D\u3001\u8D23\u4EFB\u9650\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u56E0\u4E0D\u53EF\u6297\u529B\u6216\u5176\u4ED6\u4E59\u65B9\u65E0\u6CD5\u63A7\u5236\u7684\u539F\u56E0\u4F7F\u4E59\u65B9\u7CFB\u7EDF\u5D29\u6E83\u6216\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u5BFC\u81F4\u7F51\u4E0A\u4EA4\u6613\u65E0\u6CD5\u5B8C\u6210\u6216\u4E22\u5931\u6709\u5173\u7684\u4FE1\u606F\u3001\u8BB0\u5F55\u7B49\uFF0C\u4E59\u65B9\u4E0D\u627F\u62C5\u8D23\u4EFB\uFF0C\u4F46\u662F\u4E59\u65B9\u4F1A\u5C3D\u53EF\u80FD\u5408\u7406\u5730\u534F\u52A9\u5904\u7406\u76F8\u5173\u4E8B\u5B9C\uFF0C\u5E76\u52AA\u529B\u4F7F\u7532\u65B9\u514D\u53D7\u7ECF\u6D4E\u635F\u5931\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5341\u3001\u6CD5\u5F8B\u7BA1\u8F96\u548C\u9002\u7528'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.\u672C\u534F\u8BAE\u7684\u8BA2\u7ACB\u3001\u6267\u884C\u548C\u89E3\u91CA\u53CA\u4E89\u8BAE\u7684\u89E3\u51B3\u5747\u5E94\u9002\u7528\u4E2D\u56FD\u6CD5\u5F8B\u3002\u5982\u53D1\u751F\u670D\u52A1\u6761\u6B3E\u4E0E\u4E2D\u56FD\u6CD5\u5F8B\u76F8\u62B5\u89E6\u65F6\uFF0C\u5219\u8FD9\u4E9B\u6761\u6B3E\u5C06\u5B8C\u5168\u6309\u6CD5\u5F8B\u89C4\u5B9A\u91CD\u65B0\u89E3\u91CA\uFF0C\u800C\u5176\u5B83\u5408\u6CD5\u6761\u6B3E\u5219\u4F9D\u65E7\u4FDD\u6301\u5BF9\u7528\u6237\u4EA7\u751F\u6CD5\u5F8B\u6548\u529B\u548C\u5F71\u54CD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2.\u672C\u534F\u8BAE\u7684\u89C4\u5B9A\u662F\u53EF\u5206\u5272\u7684\uFF0C\u5982\u672C\u534F\u8BAE\u4EFB\u4F55\u89C4\u5B9A\u88AB\u88C1\u5B9A\u4E3A\u65E0\u6548\u6216\u4E0D\u53EF\u6267\u884C\uFF0C\u8BE5\u89C4\u5B9A\u53EF\u88AB\u5220\u9664\u800C\u5176\u4F59\u6761\u6B3E\u5E94\u4E88\u4EE5\u6267\u884C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.\u5982\u53CC\u65B9\u5C31\u672C\u534F\u8BAE\u5185\u5BB9\u6216\u5176\u6267\u884C\u53D1\u751F\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u53CC\u65B9\u5E94\u5C3D\u529B\u53CB\u597D\u534F\u5546\u89E3\u51B3\uFF1B\u534F\u5546\u4E0D\u6210\u65F6\uFF0C\u4EFB\u4F55\u4E00\u65B9\u5747\u53EF\u5411\u4E59\u65B9\u6240\u5728\u5730\u7684\u4EBA\u6C11\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'textIndent'},'s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7532\u65B9\uFF08\u5B66\u5458\u5BB6\u957F\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E59\u65B9\uFF08\u516C\u53F8\uFF09\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u676D\u5DDE\u5E02\u62F1\u5885\u533A\u4E30\u6F6D\u8DEF508\u53F7\u5929\u884C\u56FD\u9645\u4E2D\u5FC37\u53F7\u697C11\u5C421101\u5BA4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A0571-89809613'))));}}]);return PaymentAgreement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PaymentAgreement);

/***/ }),
/* 743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_UniversePay_main__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* 支付页
*/var queryObj=Object(__WEBPACK_IMPORTED_MODULE_8__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var returnUrl='https://client.aircourses.com/h5/success';var PhonicsPayPage=function(_Component){_inherits(PhonicsPayPage,_Component);function PhonicsPayPage(props){_classCallCheck(this,PhonicsPayPage);var _this=_possibleConstructorReturn(this,(PhonicsPayPage.__proto__||Object.getPrototypeOf(PhonicsPayPage)).call(this,props));_this.getAddress=function(userId){var storage=__WEBPACK_IMPORTED_MODULE_8__utils_tools__["e" /* myStorage */];storage.removeItem('user_address');// 获取地址信息
return __WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getAddress({data:{userId:userId}},function(res,err){if(err)console.log(err);else{if(res.length){_this.setState({userAddress:res[0],addressId:res[0].id});storage.setItem('user_address',JSON.stringify(res[0]));return res[0].id;}else{storage.setItem('user_address',JSON.stringify({consignee:"",consigneePhone:"",province:"",city:"",area:"",detail:""}));}return true;}});};_this.GetGoodInfo=function(goodsId){__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getGoodInfo({query:goodsId},function(res,err){if(err)console.log(err);else{_this.setState({coursesInfo:res||{},completeRander:true});}});__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getGoodsInviteAward({data:{goodsId:goodsId}},function(res,err){if(err)console.log(err);else if(res.length){_this.setState({inviteAwardList:res});}});};_this.GetDiscountList=function(goodsId){var yange=queryObj.yange;if(Number(yange)===1){// 审核中
return;}if(localStorage.getItem('no_use_discount')==='1'){// 已选不使用优惠券
_this.setState({notUseDiscount:'1',isHasDiscount:true// 有优惠券可用
});localStorage.removeItem('no_use_discount');return;}var discountCoupon=localStorage.getItem('user_discount');if(discountCoupon){// 已选择过优惠券则直接使用
_this.setState({discountCoupon:JSON.parse(discountCoupon),isHasDiscount:true// 有优惠券可用
});localStorage.removeItem('user_discount');// 清除，下次进入则重新接口获取
return;}__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getDiscountList({data:{goodsId:goodsId}},function(res,err){if(err)console.log(err);else{if(res.length>0){// 有可以使用的优惠券则选择第一张
_this.setState({discountCoupon:res[0],isHasDiscount:true// 有优惠券可用
});}else{_this.setState({discountCoupon:{},isHasDiscount:false// 无优惠券可用
});}}});};_this.checkOrder=function(){var orderNo=_this.state.orderNo;__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getOrderStatus({query:orderNo+''},function(res,err){if(err)return;else{if(res.status===1){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].closeH5Page({reason:'closeSafe'});}else{__WEBPACK_IMPORTED_MODULE_9__utils_toast__["a" /* default */].info({text:'支付未完成'});}}});};_this.handlePay=function(orderNo,payType){__WEBPACK_IMPORTED_MODULE_9__utils_toast__["a" /* default */].info({text:'支付进行中，请勿退出当前页面'});if(payType===0){// 微信
var data={orderNo:orderNo,payType:'MWEB'};__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].payWeixin({data:data},function(res,err){if(err)alert(err.errorMessage);else{var mwebUrl=res.mwebUrl;if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].iphoneClient){window.location.replace(''+mwebUrl);}else if(__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].androidClient){window.location.replace(mwebUrl+'&redirect_url='+encodeURIComponent(returnUrl+"?stuid="+queryObj.stuid+"&totalamount="+_this.state.totalAmount+"&success=1&type=wait&orderno="+orderNo)+'&courseid='+queryObj.courseid);}}});}else{var _data={// 支付宝
returnUrl:returnUrl+'?stuid='+queryObj.stuid+'&orderno='+orderNo+'&totalamount='+_this.state.totalamount+'&success=1&type=wait&courseid='+queryObj.courseid,orderNo:orderNo,payType:'QUICK_WAP_PAY'};__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://api.aircourses.com/ac-order/alipay',_data).then(function(res){document.getElementById('root').innerHTML=res.data;setTimeout(function(){document.forms[0].submit();},500);}).catch(function(err){alert('error'+JSON.stringify(err));});}//        this.GetDiscountList(this.state.coursesInfo.id)
};_this.handleClick=function(goodsNo,payType,inviteAwardPackId,isHaveEntity){var _this$state=_this.state,addressId=_this$state.addressId,refuseClick=_this$state.refuseClick,isAllowAgreement=_this$state.isAllowAgreement,inviteAwardList=_this$state.inviteAwardList;var yange=queryObj.yange;_this.setState({inviteAwardPackId:inviteAwardPackId,isHaveEntity:isHaveEntity});if(!isAllowAgreement){__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].alertView({content:'请同意用户支付协议',confirm:'确定',id:'H5_1006'});return;}if(refuseClick)return;_this.setState({refuseClick:true});// applereviewing为1审核模式 || 没有赠品 || 有赠品有地址 不提示
if(!inviteAwardList.length||inviteAwardList.length&&addressId||Number(yange)===1){if(_this.isMobile){// 安卓或苹果 非内购
var data={stuCouponDetailIds:!!_this.state.discountCoupon&&_this.state.discountCoupon.id?[_this.state.discountCoupon.id]:[],userId:queryObj.stuid,payType:payType===0?'MWEB':'QUICK_WAP_PAY',channelId:queryObj.channel,// app渠道id
version:2,// 接口版本
goodsNo:goodsNo,addressId:isHaveEntity?addressId:null,// 有实物赠品才传addressId
inviteAwardPackId:inviteAwardPackId};if(window.location.origin!=="https://client.aircourses.com"){return _this.fakePay(data);}__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getWxOrder({data:data},function(res,err){if(err)alert('获取订单失败：'+err.errorMessage);else{_this.setState({orderNo:res.orderNo/*, notUseDiscount: '0', isHasDiscount: false*/});if(res.status!==1){// 未支付成功
_this.handlePay(res.orderNo,payType);// 获取订单号成功 第三方支付
}else{_this.GetDiscountList(_this.state.coursesInfo.id);alert('支付成功');}}_this.setState({refuseClick:false});});}else{// 桌面或ipad扫码支付
_this.setState({showErweima:true,refuseClick:false});}}else{_this.setState({refuseClick:false});__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].alertView({title:'提示',content:'我们会为您寄送一份实验器材包，请先填写收货地址哦～',confirm:'去填写',cancel:'取消',id:'H5_1001'});}};_this.handleAddress=function(){var history=_this.props.history;var _this$state2=_this.state,addressId=_this$state2.addressId,isAllowAgreement=_this$state2.isAllowAgreement,notUseDiscount=_this$state2.notUseDiscount,discountCoupon=_this$state2.discountCoupon;history.push({pathname:__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* COURSE_URL */]+'/address',search:window.location.search,state:{addressId:addressId,isAllowAgreement:isAllowAgreement,notUseDiscount:notUseDiscount,// 是否选择使用优惠券
discountCoupon:discountCoupon,source:'universemk'//告诉目标页面上一页地址
}});};_this.handleDiscount=function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* COURSE_URL */]+'/discountcoupon',search:window.location.search,state:{goodsId:queryObj.goodsid||_this.state.coursesInfo.id,couponId:_this.state.discountCoupon&&_this.state.discountCoupon.id||-1,notUseDiscount:_this.state.notUseDiscount,// 是否选择使用优惠券
discountCoupon:_this.state.discountCoupon,isAllowAgreement:_this.state.isAllowAgreement}});};_this.agreementSelect=function(){_this.setState({isAllowAgreement:!_this.state.isAllowAgreement});};_this.clickToAgreement=function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* COURSE_URL */]+'/paymentAgreement',state:{isAllowAgreement:_this.state.isAllowAgreement,notUseDiscount:_this.state.notUseDiscount,// 是否选择使用优惠券
discountCoupon:_this.state.discountCoupon}});};_this.alertViewBack=function(res){var data=JSON.parse(res);if(data.select==='confirm'){if(data.id==='H5_1001'){_this.handleAddress();}else if(data.id==='H5_1003'){_this.checkOrder();}}};_this.fakePay=function(data){__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].payTest({data:data},function(res,err){if(err)console.log(err);else{__WEBPACK_IMPORTED_MODULE_9__utils_toast__["a" /* default */].info({text:'虚拟支付完成'});}_this.setState({refuseClick:false});});};_this.isMobile=__WEBPACK_IMPORTED_MODULE_4__utils_ua__["a" /* default */].mobileClient;_this.interval=[];_this.timeout=[];_this.state={completeRander:false,refuseClick:false,// 禁止点击
coursesInfo:{},courseId:queryObj.courseid,inviteAwardList:[],// 赠品列表
discountCoupon:{},notUseDiscount:'0',// 是否选择优惠券
isHasDiscount:false,// 是否有可用优惠券
isAllowAgreement:true// 是否允许协议
};return _this;}_createClass(PhonicsPayPage,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.interval.map(function(ele){return clearInterval(ele);});this.timeout.map(function(ele){return clearTimeout(ele);});}},{key:'componentWillMount',value:function componentWillMount(){if(localStorage.getItem('is_allow_agreement')){this.setState({isAllowAgreement:localStorage.getItem('is_allow_agreement')});localStorage.removeItem('is_allow_agreement');}Object(__WEBPACK_IMPORTED_MODULE_6__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
this.getAddress(queryObj.stuid);// 获取地址
this.GetGoodInfo(queryObj.goodsid);// 获取套餐信息
this.GetDiscountList(queryObj.goodsid);// 获取优惠券列表
}// 获取地址
// 获取套餐信息
// 获取优惠券列表
// 第三方支付下单
// 获取订单号
// 选择地址(实验课)
// 选择优惠券
// 是否同意支付协议
// 跳转至支付协议
// 虚拟支付
},{key:'render',value:function render(){var _this2=this;var _state=this.state,userAddress=_state.userAddress,coursesInfo=_state.coursesInfo,courseId=_state.courseId,showErweima=_state.showErweima,addressId=_state.addressId,completeRander=_state.completeRander,isHasDiscount=_state.isHasDiscount,discountCoupon=_state.discountCoupon,notUseDiscount=_state.notUseDiscount,isAllowAgreement=_state.isAllowAgreement,inviteAwardList=_state.inviteAwardList,inviteAwardPackId=_state.inviteAwardPackId,isHaveEntity=_state.isHaveEntity;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'确认订单'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__template_Load_Load__["a" /* default */],null),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:false,showClose:false,title:'\u786E\u8BA4\u8BA2\u5355'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__template_UniversePay_main__["a" /* default */],{yange:queryObj.yange,handleAddress:this.handleAddress,handleDiscount:this.handleDiscount,userAddress:userAddress,coursesInfo:coursesInfo,courseId:courseId,handleClick:this.handleClick.bind(this),agreementSelect:this.agreementSelect,appleIAP:queryObj.apple_iap,notUseDiscount:notUseDiscount,isHasDiscount:isHasDiscount,isAllowAgreement:isAllowAgreement,clickToAgreement:this.clickToAgreement,discountCoupon:discountCoupon,inviteAwardList:inviteAwardList}),!!showErweima&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima_wrap nasa',onClick:function onClick(){_this2.setState({showErweima:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'erweima'},isHaveEntity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_qrcode_react___default.a,{size:148,value:window.location.origin+'/h5/paylink?channel='+queryObj.channel+'&userid='+queryObj.stuid+'&goodsno='+coursesInfo.goodsNo+'&addressid='+addressId+'&couponid='+(discountCoupon.id||'-1')+'&inviteawardpackid='+inviteAwardPackId,fgColor:'#333'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_qrcode_react___default.a,{size:148,value:window.location.origin+'/h5/paylink?channel='+queryObj.channel+'&userid='+queryObj.stuid+'&goodsno='+coursesInfo.goodsNo+'&couponid='+(discountCoupon.id||'-1')+'&inviteawardpackid='+inviteAwardPackId,fgColor:'#333'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8BF7\u7528\u624B\u673A\u652F\u4ED8\u5B9D\u6216\u5FAE\u4FE1\u626B\u7801\u4ED8\u6B3E')))));}}]);return PhonicsPayPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PhonicsPayPage);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UniversePay=function(_Component){_inherits(UniversePay,_Component);function UniversePay(props){_classCallCheck(this,UniversePay);var _this=_possibleConstructorReturn(this,(UniversePay.__proto__||Object.getPrototypeOf(UniversePay)).call(this,props));_this.handleClick=function(index){_this.setState({inviteAwardIndex:index});window.user_inviteAwardIndex=index;};_this.isMobile=__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].mobileClient;_this.storage=__WEBPACK_IMPORTED_MODULE_3__utils_tools__["e" /* myStorage */];_this.state={channel:Number(_this.storage.getItem('user_channel'))||0,inviteAwardIndex:window.user_inviteAwardIndex||0};return _this;}_createClass(UniversePay,[{key:'render',value:function render(){var _this2=this;var _state=this.state,channel=_state.channel,inviteAwardIndex=_state.inviteAwardIndex;var _props=this.props,courseId=_props.courseId,userAddress=_props.userAddress,coursesInfo=_props.coursesInfo,appleIAP=_props.appleIAP,isHasDiscount=_props.isHasDiscount,discountCoupon=_props.discountCoupon,notUseDiscount=_props.notUseDiscount,isAllowAgreement=_props.isAllowAgreement,handleClick=_props.handleClick,agreementSelect=_props.agreementSelect,clickToAgreement=_props.clickToAgreement,inviteAwardList=_props.inviteAwardList;var _price=coursesInfo.totalAmount||0;//原价
var price=_price;//优惠后价格
// 有实物赠品显示地址
var isHaveEntity=inviteAwardList[inviteAwardIndex]?inviteAwardList[inviteAwardIndex].isHaveEntity:0;if(discountCoupon.couponAmount){price=Number(discountCoupon.couponAmount-price)>0?0:price-discountCoupon.couponAmount;}price=price/100;var inviteAwardItem=inviteAwardList.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_rows',key:index,onClick:function onClick(i){_this2.handleClick(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'name'},ele.inviteAwardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(inviteAwardIndex===index?'active':'')}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container phonicspay '+(this.isMobile?'':'pc')},coursesInfo.purchaseReminder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},coursesInfo.purchaseReminder)),!!!!isHaveEntity&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address_wrap'},userAddress?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.handleAddress},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},userAddress.consignee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tele'},' ',userAddress.consigneePhone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address'},userAddress.province+' '+userAddress.city+' '+userAddress.area+' '+userAddress.detail)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address',onClick:this.props.handleAddress},'\u8BF7\u586B\u5199\u6536\u8D27\u5730\u5740'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go',onClick:this.props.handleAddress})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rows course'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img',style:{backgroundImage:'url('+coursesInfo.picUrl+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},coursesInfo.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},'\uFFE5',_price/100-~~(_price/100)>0?(_price/100).toFixed(2):_price/100))),!!inviteAwardList.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_wrap'},inviteAwardList.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'\u8D60\u54C1\u4EFB\u9009\u5176\u4E00'),inviteAwardItem):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gift_rows one'},inviteAwardList[0].inviteAwardName))),!__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].iosClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_coupon',onClick:this.props.handleDiscount},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\u4F18\u60E0\u5238'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount_status '+(isHasDiscount?'has':'notHas')},!isHasDiscount?'无可用优惠券':notUseDiscount==='1'?'不使用优惠券':'-'+(Object.keys(discountCoupon).length>0&&Number(discountCoupon.couponAmount/100||0)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go'})),this.isMobile&&appleIAP!=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pay_way_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weixin pay_way',onClick:function onClick(){_this2.setState({channel:0});_this2.storage.removeItem('user_channel');_this2.storage.setItem('user_channel',0);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u5FAE\u4FE1\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(this.state.channel===0?'active':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alipay pay_way',onClick:function onClick(){_this2.setState({channel:1});_this2.storage.removeItem('user_channel');_this2.storage.setItem('user_channel',1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},'\u652F\u4ED8\u5B9D\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status '+(this.state.channel===1?'active':'')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:agreementSelect,className:'agreement '+(isAllowAgreement?'allow':'notAllow')}),'\u540C\u610F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:clickToAgreement},'\u300AAirCourse\u7528\u6237\u652F\u4ED8\u534F\u8BAE\u300B')),courseId!=='212'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u672C\u8BFE\u7A0B\u6709\u6548\u671F\u4E3A365\u5929\uFF0C\u8D2D\u4E70\u540E\u7ACB\u5373\u751F\u6548\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u672C\u8BFE\u7A0B\u51714\u4E2A\u4E0A\u8BFE\u65F6\u95F4\u6BB5\uFF1A9:00\uFF0C16:00\uFF0C19:00\uFF0C20:30\u3002\u4E0A\u8BFE\u524D\u5747\u53EF\u9884\u7EA6\u3001\u5E76\u652F\u6301\u91CD\u590D\u9884\u7EA6\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u8BFE\u7A0B\u4E00\u7ECF\u8D2D\u4E70\u4E0D\u5F97\u9000\u6362\u3001\u4E0D\u5F97\u8F6C\u8BFE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u62E8\u6253\u5BA2\u670D\u70ED\u7EBF\uFF1A400-688-6057\u3002')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u8D2D\u4E70\u6210\u529F\u540E\u8BFE\u7A0B\u7ACB\u5373\u751F\u6548\uFF0C\u4E0D\u53EF\u9000\u6362\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u5728\u5BA2\u6237\u7AEF\u5185\u9884\u7EA6\u540E\u4E0A\u8BFE\uFF0C\u6BCF\u59299\u4E2A\u65F6\u95F4\u6BB5\u53EF\u9884\u7EA6\u8BFE\u7A0B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u8BFE\u7A0B\u91C7\u7528\u9884\u7EA6\u89E3\u9501\u5236\uFF0C\u9700\u6309\u7167\u8BFE\u7A0B\u987A\u5E8F\u4E0A\u8BFE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u5982\u6709\u4EFB\u4F55\u5176\u4ED6\u95EE\u9898\uFF0C\u8BF7\u62E8\u6253\u5BA2\u670D\u70ED\u7EBF\uFF1A4008-874-877\u3002')),this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn pay',onClick:function onClick(){var inviteAwardPackId=inviteAwardList.length?inviteAwardList[inviteAwardIndex].inviteAwardPackId:null;handleClick(coursesInfo.goodsNo,channel,inviteAwardPackId,isHaveEntity);}},'\u7ACB\u5373\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},'\uFFE5',price-~~price>0?price.toFixed(2):price)),!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn_wrap',onClick:function onClick(){var inviteAwardPackId=inviteAwardList.length?inviteAwardList[inviteAwardIndex].inviteAwardPackId:null;handleClick(coursesInfo.goodsNo,channel,inviteAwardPackId,isHaveEntity);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn pay'},'\u7ACB\u5373\u652F\u4ED8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price'},price-~~price>0?price.toFixed(2):price,'\u5143')));}}]);return UniversePay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UniversePay);

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AchievementRulesPage=function(_Component){_inherits(AchievementRulesPage,_Component);function AchievementRulesPage(props){_classCallCheck(this,AchievementRulesPage);var _this=_possibleConstructorReturn(this,(AchievementRulesPage.__proto__||Object.getPrototypeOf(AchievementRulesPage)).call(this,props));_this.state={};return _this;}_createClass(AchievementRulesPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'成就规则'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container achievementrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},!__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u6210\u5C31\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6210\u5C31\u4EE3\u8868\u7231\u8BFEAirCourse\u5E73\u53F0\u5BF9\u60A8\u5B66\u4E60\u7684\u8BA4\u53EF\uFF0C\u6BCF\u4E00\u4E2A\u6210\u5C31\u90FD\u6709\u4E0D\u540C\u7684\u4EF7\u503C\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u7231\u8BFE\u8FBE\u6210\u4E0D\u540C\u7684\u76EE\u6807\uFF0C\u5C31\u53EF\u4EE5\u83B7\u5F97\u5E76\u5347\u7EA7\u5404\u4E2A\u6210\u5C31\uFF0C\u6BCF\u4E2A\u6210\u5C31\u7B49\u7EA7\u5BF9\u5E94\u4E00\u4E2A\u4E0D\u540C\u7684\u56FE\u6807\uFF0C\u9010\u6E10\u5347\u7EA7\u6210\u5C31\u5373\u53EF\u89E3\u9501\u65B0\u7684\u56FE\u6807\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6BCF\u4E2A\u6210\u5C31\u7684\u83B7\u5F97\u90FD\u53EF\u4EE5\u83B7\u5F97\u6210\u5C31\u70B9\uFF0C\u6210\u5C31\u7B49\u7EA7\u8D8A\u9AD8\u83B7\u5F97\u7684\u6210\u5C31\u70B9\u4E5F\u8D8A\u9AD8\uFF0C\u6210\u5C31\u70B9\u7D2F\u8BA1\u5230\u7279\u5B9A\u70B9\u6570\u53EF\u4EE5\u83B7\u5F97\u5956\u52B1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2022',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6D3B\u52A8\u7C7B\u6210\u5C31\uFF0C\u53EA\u80FD\u5728\u5B8C\u6210\u67D0\u4E9B\u6D3B\u52A8\u540E\u83B7\u5F97\uFF0C\u5728\u8BE5\u6D3B\u52A8\u7ED3\u675F\u540E\uFF0C\u5982\u679C\u60A8\u672A\u83B7\u5F97\u8BE5\u6210\u5C31\uFF0C\u8BE5\u6210\u5C31\u7684\u56FE\u6807\u5C31\u4F1A\u6D88\u5931\u3002'))));}}]);return AchievementRulesPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AchievementRulesPage);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_Load_Load__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var vUrl='https://oss.aircourses.com/default/video/pu/pu.mp4';var vUrl2='https://oss.aircourses.com/default/video/pu/pu2.mp4';var pUrl='https://oss.aircourses.com/default/video/pu/pu.png';var pUrl2='https://oss.aircourses.com/default/video/pu/pu2.jpg';// 暂时隐藏 以免运营又要
// const gifUrl = 'https://oss.aircourses.com/default/video/pu/pu.gif';
var PuDetaiPage=function(_Component){_inherits(PuDetaiPage,_Component);function PuDetaiPage(props){_classCallCheck(this,PuDetaiPage);var _this=_possibleConstructorReturn(this,(PuDetaiPage.__proto__||Object.getPrototypeOf(PuDetaiPage)).call(this,props));_this.pauseH5Media=function(){_this.videoRef.video&&_this.videoRef.video.pause();_this.videoRef2.video&&_this.videoRef2.video.pause();};_this.isMobile=__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].mobileClient;_this.clientWidth=document.body.clientWidth||document.documentElement.clientWidth;_this.clientHeight=document.body.clientHeight||document.documentElement.clientHeight;_this.countInit=750/_this.clientWidth;_this.tabItem=[0,Math.round(6500/_this.countInit)];_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.imgList=["https://oss.aircourses.com/web/client/pudetail/1.jpg","https://oss.aircourses.com/web/client/pudetail/2.jpg","https://oss.aircourses.com/web/client/pudetail/3.jpg","https://oss.aircourses.com/web/client/pudetail/4.jpg","https://oss.aircourses.com/web/client/pudetail/5.jpg","https://oss.aircourses.com/web/client/pudetail/6.jpg","https://oss.aircourses.com/web/client/pudetail/7.jpg","https://oss.aircourses.com/web/client/pudetail/8.jpg"];_this.videoRef=null;_this.videoRef2=null;_this.state={type:'pu',completeRander:true,showVideo:true};_this.timeout=[];return _this;}_createClass(PuDetaiPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_5__api_web__["b" /* apiDefine */])({apiName:'pauseH5Media',fn:this.pauseH5Media});// 定义弹框回调方法
this.timeout.push(setTimeout(function(){__WEBPACK_IMPORTED_MODULE_9__api_client__["a" /* default */].h5Message({data:{offsetHeight:Math.round(11143/_this2.countInit),offsetWidth:_this2.clientWidth,tabItem:_this2.tabItem}});},0));__WEBPACK_IMPORTED_MODULE_7__api_axios__["a" /* default */].getCourseInfo({data:{stuId:this.queryObj.stuid,channelId:this.queryObj.channel},query:this.queryObj.courseid},function(res,err){if(err)alert(err.errorMessage);else{var coverHPhoto=res.coverHPhoto,cnName=res.cnName,stuCnt=res.stuCnt,stuExpireDate=res.stuExpireDate,stuStatus=res.stuStatus,isPermanent=res.isPermanent;_this2.setState({coverHPhoto:coverHPhoto,cnName:cnName,stuCnt:stuCnt,stuExpireDate:stuExpireDate,stuStatus:stuStatus,isPermanent:isPermanent});}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.timeout.map(function(ele){return clearTimeout(ele);});this.setState({showVideo:false});}},{key:"render",value:function render(){var _this3=this;var _state=this.state,coverHPhoto=_state.coverHPhoto,cnName=_state.cnName,stuCnt=_state.stuCnt,stuExpireDate=_state.stuExpireDate,stuStatus=_state.stuStatus,type=_state.type,isPermanent=_state.isPermanent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程详情'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.state.completeRander&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__template_Load_Load__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pu_detail "+type+" "+(this.isMobile?'':'pc')+" "+(__WEBPACK_IMPORTED_MODULE_8__utils_ua__["a" /* default */].winClient?'win':'')},!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_CourseDetailHeader_CourseDetailHeader__["a" /* default */],{title:cnName,stuCount:(stuCnt||'')+"\u4EBA\u6B63\u5728\u5B66\u4E60",lessonDate:stuExpireDate||'',stuStatus:stuStatus,bg:coverHPhoto,isPermanent:isPermanent// 是否永久有效
}),this.imgList.map(function(node,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img_wrap img img"+(index+1),key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"img",src:node}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__["a" /* default */],{src:vUrl,poster:pUrl,className:"video "+(this.isMobile?'':'pc'),ref:function ref(com){_this3.videoRef=com;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_UtilTemplate_Vdieo__["a" /* default */],{src:vUrl2,poster:pUrl2,className:"video2 "+(this.isMobile?'':'pc'),ref:function ref(com){_this3.videoRef2=com;}}))));}}]);return PuDetaiPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PuDetaiPage);

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_UtilTemplate_Empty__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerService__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_less__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_client__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackPage=function(_Component){_inherits(FeedbackPage,_Component);function FeedbackPage(props){_classCallCheck(this,FeedbackPage);var _this=_possibleConstructorReturn(this,(FeedbackPage.__proto__||Object.getPrototypeOf(FeedbackPage)).call(this,props));_this.getList=function(num){var _this$state=_this.state,row=_this$state.row,list=_this$state.list;__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].getFeedBackList({data:{type:0,row:row,num:num}},function(res,err){if(err)console.log(err);else{_this.setState({list:list.concat(res)});}});};_this.toDetail=function(id){var history=_this.props.history;var eventType=_this.isMobile?'c2_app_My_Help_Question':'c2_app_Home_Settings_Help_Question';__WEBPACK_IMPORTED_MODULE_10__api_client__["a" /* default */].eventTracking({eventType:eventType,questionId:id});history.push({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/feedback/'+id,search:window.location.search});};_this.isMobile=__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].mobileClient;_this.queryObj=Object(__WEBPACK_IMPORTED_MODULE_7__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.state={list:[],row:20,num:1};return _this;}_createClass(FeedbackPage,[{key:'componentWillMount',value:function componentWillMount(){this.getList(1);}// 获取问题列表
// 根据id进入问题详情
},{key:'render',value:function render(){var _this2=this;var list=this.state.list;var yange=this.queryObj.yange;// yange = 1 苹果审核期间不显示二维码
var listItem=list.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,onClick:function onClick(){_this2.toDetail(ele.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},ele.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'go'}));});if(this.isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'帮助与反馈'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-wrap mobile'},list.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container feedback-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ul-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,listItem)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tips'},'\u2014\u2014\u6CA1\u627E\u5230\u9700\u8981\u7684? \u8BD5\u8BD5\u76F4\u63A5\u54A8\u8BE2\u5C0F\u52A9\u624B\u2014\u2014')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_UtilTemplate_Empty__["a" /* default */],{text:'\u6682\u65E0\u6570\u636E!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__customerService__["a" /* default */],{isMobile:this.isMobile,oringin:'feedback_list'}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'帮助与反馈'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:false,showClose:false,title:'\u5E2E\u52A9\u4E0E\u53CD\u9988'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-wrap pc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list__header'},'\u5E38\u89C1\u95EE\u9898'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container feedback-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ul-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,listItem)),yange!=='1'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__customerService__["a" /* default */],{isMobile:this.isMobile,oringin:'feedback_list'})))));}}]);return FeedbackPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FeedbackPage);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Empty_less__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Empty_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Empty_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Empty=function(_Component){_inherits(Empty,_Component);function Empty(){_classCallCheck(this,Empty);return _possibleConstructorReturn(this,(Empty.__proto__||Object.getPrototypeOf(Empty)).apply(this,arguments));}_createClass(Empty,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty-util'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},this.props.text||''));}}]);return Empty;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_WebViewHeader_WebViewHeader__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customerService__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ua__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackDetailPage=function(_Component){_inherits(FeedbackDetailPage,_Component);function FeedbackDetailPage(props){_classCallCheck(this,FeedbackDetailPage);var _this=_possibleConstructorReturn(this,(FeedbackDetailPage.__proto__||Object.getPrototypeOf(FeedbackDetailPage)).call(this,props));_this.isMobile=__WEBPACK_IMPORTED_MODULE_6__utils_ua__["a" /* default */].mobileClient;_this.state={title:'',// 标题
content:'',// 内容
id:props.match.params.id||''// 作业id 从路由中拿
};return _this;}_createClass(FeedbackDetailPage,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var id=this.state.id;// 根据id获取作业详情
__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getFeedBackDetail({query:id},function(res,err){if(err)console.log(err);else{_this2.setState(res);}});}},{key:'render',value:function render(){var _state=this.state,content=_state.content,title=_state.title,id=_state.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'问题详情'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_WebViewHeader_WebViewHeader__["a" /* default */],{showBack:true,showClose:false,title:'\u95EE\u9898\u8BE6\u60C5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container feedback-detail '+(this.isMobile?'mobile':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title',style:{"WebkitBoxOrient":"vertical"}},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',dangerouslySetInnerHTML:{__html:content}}),this.isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__customerService__["a" /* default */],{oringin:'feedback_detail',questionId:id,isMobile:this.isMobile}))));}}]);return FeedbackDetailPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FeedbackDetailPage);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CountDown__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_client__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AWARD_STATUS=[null,null,null,'，实物奖励待发货','，实物奖励已发货'];var queryObj=Object(__WEBPACK_IMPORTED_MODULE_6__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var DailyAttendance=function(_React$PureComponent){_inherits(DailyAttendance,_React$PureComponent);function DailyAttendance(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DailyAttendance);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DailyAttendance.__proto__||Object.getPrototypeOf(DailyAttendance)).call.apply(_ref,[this].concat(args))),_this),_this.state={status:-1,// 打卡按钮状态-1->初始态,0->未开始,1->已开始,2->已结束
awardRules:[],awardsList:[],activityUserInfo:{},activityInfo:{},clockDesc:null,showTanAward:false,// 是否显示奖品弹框
showTanAddress:false,// 是否添加地址弹框
isComplete:false,// 是否完成所有打卡
beginDate:null,willGetAward:{},awardName:null,awardDesc:null,awardBigImg:null,threshold:null,progress:0},_this.scrollTop=0,_this.getActivityData=function(){return __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getDailyAttendanceContent({data:{activityId:queryObj.activityid,stuId:queryObj.stuid}},function(data){var _ref2=data||{},_ref2$activityInfo=_ref2.activityInfo,activityInfo=_ref2$activityInfo===undefined?{}:_ref2$activityInfo,_ref2$activityUserInf=_ref2.activityUserInfo,activityUserInfo=_ref2$activityUserInf===undefined?{}:_ref2$activityUserInf;var _activityInfo$awardRu=activityInfo.awardRules,awardRules=_activityInfo$awardRu===undefined?[]:_activityInfo$awardRu,status=activityInfo.status,beginTime=activityInfo.beginTime,_activityInfo$clockDe=activityInfo.clockDesc,clockDesc=_activityInfo$clockDe===undefined?'':_activityInfo$clockDe;var progress=0;var isComplete=false;var willGetAward={};var awardRulesCount=awardRules.length;if(awardRulesCount>0){var willList=awardRules.filter(function(item){return item.threshold>activityUserInfo.threshold;});if(willList.length>0){var _willList$=willList[0],threshold=_willList$.threshold,awardName=_willList$.awardName;willGetAward={name:awardName,time:threshold-activityUserInfo.threshold};}else{isComplete=true;}}if(awardRulesCount>1){progress=awardRules.reduce(function(t,item,index){return activityUserInfo.threshold>=item.threshold?index:t;},0)/(awardRules.length-1);}var beginDate=new Date(beginTime||new Date().getTime());var currDate=new Date();var dateDiff=Math.ceil((beginDate-currDate)/1000/3600/24);if(dateDiff>0&&dateDiff<=2){beginDate=dateDiff>1?'后天':'明天';}else{beginDate=beginDate.getMonth()+1+'\u6708'+beginDate.getDate()+'\u65E5';}_this.setState({activityInfo:activityInfo,awardRules:awardRules,activityUserInfo:activityUserInfo,status:status,isComplete:isComplete,beginDate:beginDate,progress:progress,willGetAward:willGetAward,clockDesc:clockDesc.split(/\s/).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'clock-desc',key:item},index+1,'.',item);})});});},_this.getAwardDetail=function(){return __WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getDailyAttendanceDetail({data:{stuId:queryObj.stuid}},function(res){res=res||[];var needAddress=[];var awardsList=res.map(function(item){var awardDate=new Date(item.awardDate||new Date().getTime());var month=awardDate.getMonth()+1;var date=awardDate.getDate();item.date=(month>=10?month:'0'+month)+'-'+date;item.isNeedAddress===1&&needAddress.push(item);return item;});// 一进入页面，如果有未填写地址的奖品，弹框提示添加地址
if(needAddress.length>0){var _needAddress$=needAddress[0],awardName=_needAddress$.awardName,bigAwardPic=_needAddress$.bigAwardPic,threshold=_needAddress$.threshold;_this.setState({showTanAddress:true,awardName:awardName,awardBigImg:bigAwardPic,threshold:threshold,awardsList:awardsList});_this.stopBodyScroll(true);}else{_this.setState({awardsList:awardsList});}});},_this.stopBodyScroll=function(isFixed){var bodyEl=document.body;if(isFixed){_this.scrollTop=window.scrollY;bodyEl.style.position='fixed';bodyEl.style.top=-_this.scrollTop+'px';}else{bodyEl.style.position='';bodyEl.style.top='';window.scrollTo(0,_this.scrollTop);// 回到原先的top
}},_this.toShowBigAwardImg=function(img,name,desc){_this.setState({showTanAward:true,awardName:name,awardBigImg:img,awardDesc:desc});_this.stopBodyScroll(true);},_this.hideTan=function(type){type===1&&_this.setState({showTanAward:false});type===2&&_this.setState({showTanAddress:false});_this.stopBodyScroll(false);},_this.goTo=function(path){var history=_this.props.history;var _this$state$activityI=_this.state.activityInfo,activityInfo=_this$state$activityI===undefined?{}:_this$state$activityI;history.push({pathname:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* COURSE_URL */]+'/'+path,search:window.location.search,state:{source:'daily/attendance',ruleImg:activityInfo.ruleDetailPic||null}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DailyAttendance,[{key:'componentDidMount',value:function componentDidMount(){this.getActivityData();this.getAwardDetail();__WEBPACK_IMPORTED_MODULE_7__api_client__["a" /* default */].backRequired({backRequired:false});}// 获取到课打卡活动信息
// 获取用户到课奖励流水
// 禁止蒙层下的页面滑动
// 显示奖品大图弹框
/**
     * 隐藏弹框
     * @param {number} type 
     * type=1 隐藏奖品大图弹框
     * type=2 隐藏添加地址弹框
     */},{key:'render',value:function render(){var _this2=this;var _state=this.state,status=_state.status,activityUserInfo=_state.activityUserInfo,awardRules=_state.awardRules,awardsList=_state.awardsList,activityInfo=_state.activityInfo,showTanAward=_state.showTanAward,showTanAddress=_state.showTanAddress,isComplete=_state.isComplete,progress=_state.progress,beginDate=_state.beginDate,willGetAward=_state.willGetAward,awardBigImg=_state.awardBigImg,awardName=_state.awardName,awardDesc=_state.awardDesc,threshold=_state.threshold,clockDesc=_state.clockDesc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:activityInfo.name||''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DailyAttendancePage',style:activityInfo.bottomPic?{background:'#B25426 url('+activityInfo.bottomPic+') top center / contain no-repeat'}:{}},(status===1||status===2)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count-down-dialog'},status===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8DDD\u79BB\u6253\u5361\u6D3B\u52A8\u7ED3\u675F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CountDown__["a" /* default */],{endTime:activityInfo.endTime||null})),status===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'end-text'},'\u6D3B\u52A8\u5DF2\u7ED3\u675F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'attendance-award-title'},'\u70B9\u51FB\u56FE\u7247\u67E5\u770B\u5956\u54C1\u8BE6\u60C5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-intro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-intro-box awards-'+awardRules.length},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-box'},awardRules.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.threshold,className:'attendance-award'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-img',style:item.smallAwardPic?{backgroundImage:'url('+item.smallAwardPic+')'}:{},onClick:_this2.toShowBigAwardImg.bind(_this2,item.bigAwardPic,item.awardName,item.awardDesc)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-time'},item.threshold,'\u5929'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-award-desc'},item.awardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-attendance'+(activityUserInfo.threshold>=item.threshold?' active':'')}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-progress-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-progress',style:{width:progress*100+'%'}}))))),(status===0||status===1)&&activityInfo.beginTime?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attendance-btn-box'},status===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28 font36'},'\u6253\u5361\u5C06\u4E8E ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color1 font48'},beginDate),' \u5F00\u59CB')),status===1&&!isComplete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5DF2\u8FDE\u7EED\u6253\u5361 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color1 font46'},activityUserInfo.threshold),' \u5929'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt20'},'\u518D\u6253\u5361 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color1 font38'},willGetAward.time),' \u5929 \u53EF\u5F97 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color1'},willGetAward.name))),status===1&&isComplete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font48'},'\u592A\u68D2\u4E86\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt20 font36'},'\u4F60',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color1'},'\u5DF2\u5B8C\u6210'),'\u5168\u90E8\u6253\u5361\u6311\u6218'))):null,awardsList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-award-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'\u6211\u7684\u5956\u54C1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'my-award-ul'},awardsList.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.id,className:'my-award-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-award-icon',style:item.smallAwardPic?{backgroundImage:'url('+item.smallAwardPic+')'}:{},onClick:_this2.toShowBigAwardImg.bind(_this2,item.bigAwardPic,item.awardName,item.awardDesc)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'my-award-desc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font32'},'\u6253\u5361\u7B2C',item.threshold,'\u5929'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt20'},'\u83B7\u5F97',item.awardName,item.isNeedAddress===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{className:'color2',onClick:_this2.goTo.bind(_this2,'daily/address')},'\u586B\u5199\u6536\u8D27\u5730\u5740'),' \u9886\u53D6\u5B9E\u7269\u5956\u52B1'):AWARD_STATUS[item.awardStatus]||null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'my-award-time'},item.date));}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'h3'},'\u89C4\u5219\u8BF4\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rules-intro'},clockDesc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-more',onClick:this.goTo.bind(this,'daily/attendance/rules')},'\u66F4\u591A\u89C4\u5219\u8BF4\u660E'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'company-name'},'\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-award-box-mask'+(showTanAward?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-award-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-award-img-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-award-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:awardBigImg?{height:'100%',background:'url('+awardBigImg+') center center / 85% 85% no-repeat'}:{height:'100%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font44'},awardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt32 fw_normal'},awardDesc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-sure',onClick:this.hideTan.bind(this,1)},'\u786E\u5B9A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-address-box-mask'+(showTanAddress?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-address-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'21\u5929\u82F1\u8BED\u4E60\u60EF\u517B\u6210'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt96 font36 color4'},'\u606D\u559C\u60A8\uFF0C\u5DF2\u5B8C\u6210\u6253\u5361',threshold,'\u5929'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tan-address-img',style:awardBigImg?{background:'url('+awardBigImg+') center center / 85% 85% no-repeat'}:{}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'font30 color3'},'\u83B7\u5F97',awardName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-add',onClick:this.goTo.bind(this,'daily/address')},'\u586B\u5199\u6536\u8D27\u5730\u5740'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt27 color5 font22 fw_normal'},'\u8BF7\u5C3D\u5FEB\u586B\u5199\u6536\u8D27\u5730\u5740\uFF0C\u9886\u53D6\u5B9E\u7269\u5956\u52B1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-close',onClick:this.hideTan.bind(this,2)})))));}}]);return DailyAttendance;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (DailyAttendance);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CountDown=function(_React$PureComponent){_inherits(CountDown,_React$PureComponent);function CountDown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CountDown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CountDown.__proto__||Object.getPrototypeOf(CountDown)).call.apply(_ref,[this].concat(args))),_this),_this.state={day:'00',hour:'00',minute:'00',second:'00'},_this.timer=null,_this.parsetNum=function(num){return num<10?'0'+num:num;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CountDown,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var endTime=this.props.endTime;console.log(endTime-new Date().getTime());if(endTime){var currentTime=new Date().getTime();var sysSecond=(endTime-currentTime)/1000;this.timer=setInterval(function(){if(sysSecond>0){sysSecond-=1;var day=_this2.parsetNum(Math.floor(sysSecond/3600/24));var hour=_this2.parsetNum(Math.floor(sysSecond/3600%24));var minute=_this2.parsetNum(Math.floor(sysSecond/60%60));var second=_this2.parsetNum(Math.floor(sysSecond%60));_this2.setState({day:day,hour:hour,minute:minute,second:second});}else{clearInterval(_this2.timer);}},1000);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}},{key:'render',value:function render(){var _state=this.state,day=_state.day,hour=_state.hour,minute=_state.minute,second=_state.second;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count-down-component'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-down-span'},day),'\u5929',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-down-span'},hour),'\u65F6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-down-span'},minute),'\u5206',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-down-span'},second),'\u79D2');}}]);return CountDown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DailyAttendanceRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
function DailyAttendanceRules(props){var history=props.history;var state=history.location.state;document.documentElement.scrollTop=document.body.scrollTop=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u6D3B\u52A8\u89C4\u5219'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DailyAttendanceRules'},state&&state.ruleImg?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'rules-img',src:state.ruleImg,alt:'\u6D3B\u52A8\u89C4\u5219'}):null,__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].winClient?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-back',onClick:history.goBack},'\u8FD4\u56DE'):null));}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addressPicker__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_web__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Popup, Picker } from 'spring-picker';
// import { provins, citys, areas } from '../addressPicker/picker-address/address';
var queryObj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));var AddAddress=function(_React$PureComponent){_inherits(AddAddress,_React$PureComponent);function AddAddress(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddAddress);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddAddress.__proto__||Object.getPrototypeOf(AddAddress)).call.apply(_ref,[this].concat(args))),_this),_this.state={defaultAddress:['北京市','北京市','东城区'],visible:false,address:'',canSubmit:false},_this.addressData={userId:queryObj.stuid,consignee:null,consigneePhone:null,province:null,city:null,area:null,detail:null},_this.backConfirm=function(){__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].alertView({id:'H5_1001',confirm:'确定',cancel:'取消',content:'填写收货地址后才能领取奖励，确定退出当前页面吗？',title:'温馨提示'});},_this.alertViewBack=function(str){var data=JSON.parse(str);var select=data.select,id=data.id;if(id==='H5_1001'){if(select==='confirm'){var history=_this.props.history;if(history.location.state&&history.location.state.source){history.goBack();}else{history.replace({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/daily/attendance',search:window.location.search});}}}},_this.handleClose=function(address){_this.addressData.province=address[0]||'';_this.addressData.city=address[1]||'';_this.addressData.area=address[2]||'';_this.setState({visible:false,address:address.join(' '),canSubmit:Object.values(_this.addressData).every(function(item){return!!item;})});},_this.handleCancel=function(){_this.setState({visible:false});},_this.onChange=function(address){_this.setState({defaultAddress:[].concat(_toConsumableArray(address))});},_this.showAddressPicker=function(){_this.setState({visible:true});},_this.inputChange=function(name,elem){_this.addressData[name]=elem.target.value;_this.setState({canSubmit:Object.values(_this.addressData).every(function(item){return!!item;})});},_this.toSubmit=function(){var canSubmit=_this.state.canSubmit;var errorMsg=['收货人姓名需要在2-25个字符之间','请输入正确的手机号码','详细地址需要在5-120个字符之间'];if(!canSubmit){return;}var consigneeLen=_this.addressData.consignee.trim().length;var detailLen=_this.addressData.detail.trim().length;if(consigneeLen<2||consigneeLen>25){return _this.alertView(errorMsg[0]);}if(!/^1[0-9]{10}$/.test(_this.addressData.consigneePhone)){return _this.alertView(errorMsg[1]);}if(detailLen<5||detailLen>120){return _this.alertView(errorMsg[2]);}__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].addDailyAttendanceAddress({data:_this.addressData},function(){var history=_this.props.history;if(history.location.state&&history.location.state.source){history.goBack();}else{history.replace({pathname:__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* COURSE_URL */]+'/daily/attendance',search:window.location.search});}});},_this.alertView=function(content){__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].alertView({title:'提示',content:content,confirm:'确定',cancel:'取消',id:'H5_1002'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddAddress,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].backRequired({backRequired:true});Object(__WEBPACK_IMPORTED_MODULE_8__api_web__["b" /* apiDefine */])({apiName:'backConfirm',fn:this.backConfirm});Object(__WEBPACK_IMPORTED_MODULE_8__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});var clientData=__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].getClientDataSync({data:['userId']})||'{}';clientData=JSON.parse(clientData);this.addressData.userId=this.addressData.userId||clientData.userId;}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_8__api_web__["a" /* apiCancel */])('backConfirm');Object(__WEBPACK_IMPORTED_MODULE_8__api_web__["a" /* apiCancel */])('alertViewBack');}},{key:'render',value:function render(){var _state=this.state,defaultAddress=_state.defaultAddress,visible=_state.visible,address=_state.address,canSubmit=_state.canSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u65B0\u589E\u5730\u5740'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'AddAddressPage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'address-label'},'\u6536\u8D27\u4EBA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'address-input',placeholder:'\u6536\u8D27\u4EBA\u59D3\u540D',onChange:this.inputChange.bind(this,'consignee')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'address-label'},'\u624B\u673A\u53F7\u7801'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'address-input',placeholder:'\u6536\u8D27\u4EBA\u624B\u673A\u53F7\u7801',onChange:this.inputChange.bind(this,'consigneePhone')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'address-label'},'\u6240\u5728\u5730\u533A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'address-input',placeholder:'\u6240\u5728\u5730\u533A',onClick:this.showAddressPicker,value:address,readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'address-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'address-label'},'\u8BE6\u7EC6\u5730\u5740'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'address-textarea',placeholder:'\u5982\u8857\u9053\u3001\u95E8\u724C\u53F7\u3001\u5C0F\u533A\u3001\u697C\u680B\u53F7\u3001\u5355\u5143\u7B49',onChange:this.inputChange.bind(this,'detail')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-sure'+(canSubmit?' active':''),onClick:this.toSubmit},'\u786E\u8BA4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__addressPicker__["a" /* PickerAddress */],{defaultValue:defaultAddress,onChange:this.onChange,onConfirm:this.handleClose,onCancel:this.handleCancel,visible:visible})));}}]);return AddAddress;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (AddAddress);

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RulesPageBinguo=function(_Component){_inherits(RulesPageBinguo,_Component);function RulesPageBinguo(){_classCallCheck(this,RulesPageBinguo);return _possibleConstructorReturn(this,(RulesPageBinguo.__proto__||Object.getPrototypeOf(RulesPageBinguo)).apply(this,arguments));}_createClass(RulesPageBinguo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'用户服务协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container customerrules binguo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u5BBE\u679C\u82F1\u8BED\u7528\u6237\u6CE8\u518C\u534F\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'1. \u7279\u522B\u63D0\u793A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1 \u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u79F0\u201C\u5BBE\u679C\u82F1\u8BED\u201D\uFF09\u540C\u610F\u6309\u7167\u672C\u7528\u6237\u6CE8\u518C\u534F\u8BAE\uFF08\u4EE5\u4E0B\u79F0\u201C\u672C\u534F\u8BAE\u201D\uFF09\u7684\u89C4\u5B9A\u53CA\u5176\u4E0D\u65F6\u53D1\u5E03\u7684\u64CD\u4F5C\u89C4\u5219\u63D0\u4F9B\u57FA\u4E8E\u4E92\u8054\u7F51\u4EE5\u53CA\u79FB\u52A8\u7F51\u7684\u76F8\u5173\u670D\u52A1\uFF08\u4EE5\u4E0B\u79F0\u201C\u7F51\u7EDC\u670D\u52A1\u201D\uFF09\uFF0C\u4E3A\u83B7\u5F97\u7F51\u7EDC\u670D\u52A1\uFF0C\u670D\u52A1\u4F7F\u7528\u4EBA\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u5E94\u5F53\u540C\u610F\u672C\u534F\u8BAE\u7684\u5168\u90E8\u6761\u6B3E\u5E76\u6309\u7167\u9875\u9762\u4E0A\u7684\u63D0\u793A\u5B8C\u6210\u5168\u90E8\u7684\u6CE8\u518C\u7A0B\u5E8F\u3002\u8BF7\u52A1\u5FC5\u5BA1\u614E\u9605\u8BFB\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u5404\u6761\u6B3E\u5185\u5BB9\uFF0C\u8BF7\u6CE8\u610F\u514D\u9664\u6216\u9650\u5236\u5BBE\u679C\u82F1\u8BED\u8D23\u4EFB\u7684\u6761\u6B3E\u3001\u6743\u5229\u8BB8\u53EF\u548C\u4FE1\u606F\u4F7F\u7528\u7684\u6761\u6B3E\u3001\u6CD5\u5F8B\u9002\u7528\u548C\u4E89\u8BAE\u89E3\u51B3\u7684\u6761\u6B3E\u7B49\u3002\u4E3A\u4F7F\u5BB9\u6613\u8FA8\u6790\uFF0C\u514D\u9664\u6216\u9650\u5236\u5BBE\u679C\u82F1\u8BED\u8D23\u4EFB\u7684\u6761\u6B3E\u5DF2\u4EE5\u52A0\u7C97\u5F62\u5F0F\u63D0\u793A\u7528\u6237\u6CE8\u610F\u3002\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002\u5982\u679C\u7528\u6237\u4E0D\u540C\u610F\u672C\u534F\u8BAE\u6216\u5176\u4E2D\u4EFB\u4F55\u6761\u6B3E\u7EA6\u5B9A\uFF0C\u5E94\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u7A0B\u5E8F\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E5F\u5C06\u65E0\u6CD5\u4E3A\u60A8\u63D0\u4F9B\u7F51\u7EDC\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u672A\u6210\u5E74\u4EBA\u7528\u6237\u8BF7\u5728\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\u672C\u534F\u8BAE\uFF0C\u5E76\u5728\u63D0\u4EA4\u4E2A\u4EBA\u4FE1\u606F\u4E4B\u524D\u5BFB\u6C42\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u7684\u540C\u610F\u548C\u6307\u5BFC\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.2 \u7528\u6237\u6CE8\u518C\u6210\u529F\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1.3 \u7528\u6237\u6CE8\u518C\u6210\u529F\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u4F1A\u5411\u6BCF\u4F4D\u6CE8\u518C\u7528\u6237\u62E8\u6253\u7535\u8BDD\u8FDB\u4E00\u6B65\u4ECB\u7ECD\u672C\u516C\u53F8\u7684\u76F8\u5173\u670D\u52A1\u60C5\u51B5\u3002\u7528\u6237\u7684\u6CE8\u518C\u884C\u4E3A\u5373\u89C6\u540C\u4E3A\u540C\u610F\u63A5\u53D7\u516C\u53F8\u8FDB\u4E00\u6B65\u7684\u7535\u8BDD\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1.4 \u7528\u6237\u5728\u5BBE\u679C\u82F1\u8BED\u7F51\u7AD9\u6216\u8005App\u5185\u53D1\u751F\u7684\u8BFE\u7A0B\u8D2D\u4E70\u884C\u4E3A\u5747\u89C6\u4E3A\u7528\u6237\u672C\u4EBA\u7684\u771F\u5B9E\u610F\u601D\uFF0C\u8868\u793A\u7528\u6237\u672C\u4EBA\u7684\u884C\u4E3A\u3002\u672C\u534F\u8BAE\u901A\u8FC7\u7535\u5B50\u6587\u672C\u5F62\u6210\u5236\u6210\u81EA\u5BBE\u679C\u82F1\u8BED\u6536\u5230\u7528\u6237\u652F\u4ED8\u7684\u8BFE\u7A0B\u8D39\u7528\u8D77\u751F\u6548\uFF0C\u4E00\u7ECF\u6210\u7ACB\u751F\u6548\u5373\u4E0D\u53EF\u64A4\u9500\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'2. \u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2.1 \u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u5BBE\u679C\u82F1\u8BED\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.2 \u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u90E8\u5206\u7F51\u7EDC\u670D\u52A1\u4E3A\u6536\u8D39\u7684\u7F51\u7EDC\u670D\u52A1\uFF0C\u7528\u6237\u4F7F\u7528\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u9700\u8981\u5411\u5BBE\u679C\u82F1\u8BED\u652F\u4ED8\u4E00\u5B9A\u7684\u8D39\u7528\u3002\u5BF9\u4E8E\u6536\u8D39\u7684\u7F51\u7EDC\u670D\u52A1\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u5728\u7528\u6237\u4F7F\u7528\u4E4B\u524D\u7ED9\u4E88\u7528\u6237\u660E\u786E\u7684\u63D0\u793A\uFF0C\u53EA\u6709\u7528\u6237\u6839\u636E\u63D0\u793A\u786E\u8BA4\u5176\u613F\u610F\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u7528\u6237\u624D\u80FD\u4F7F\u7528\u8BE5\u7B49\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u3002\u5982\u7528\u6237\u62D2\u7EDD\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u5219\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u4E0D\u5411\u7528\u6237\u63D0\u4F9B\u8BE5\u7B49\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.3 \u7528\u6237\u7406\u89E3\uFF0C\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u8BFE\u7A0B\u662F\u6309\u7167\u7528\u6237\u8D2D\u4E70\u7684\u6709\u6548\u671F\u63D0\u4F9B\u670D\u52A1\uFF0C\u5373\u7528\u6237\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u6216\u5BBE\u679C\u82F1\u8BED\u6388\u6743\u7684\u6E20\u9053\u8D2D\u4E70\u540E\uFF0C\u5373\u53EF\u5728\u6240\u8D2D\u4E70\u7684\u6709\u6548\u671F\u5185\u4EAB\u53D7\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u7F51\u7EDC\u5728\u7EBF\u6559\u5B66\u7B49\u670D\u52A1\u3002\u5BBE\u679C\u82F1\u8BED\u627F\u8BFA\u6309\u7167\u7528\u6237\u652F\u4ED8\u65F6\u6240\u7EA6\u5B9A\u7684\u6709\u6548\u5929\u6570\u4E3A\u7528\u6237\u63D0\u4F9B\u5728\u7EBF\u6559\u5B66\u670D\u52A1\uFF0C\u8D85\u8FC7\u6709\u6548\u671F\uFF0C\u7528\u6237\u6240\u8D2D\u8BFE\u7A0B\u5C06\u4F1A\u5931\u6548\uFF0C\u9700\u7531\u7528\u6237\u91CD\u65B0\u8D2D\u4E70\u65B9\u53EF\u7EE7\u7EED\u4EAB\u53D7\u76F8\u5173\u670D\u52A1\u5185\u5BB9\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.4 \u7528\u6237\u7406\u89E3\uFF0C\u5BBE\u679C\u82F1\u8BED\u4EC5\u63D0\u4F9B\u76F8\u5173\u7684\u7F51\u7EDC\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u7F51\u7EDC\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u4E2A\u4EBA\u7535\u8111\u3001\u624B\u673A\u3001\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2.5 \u7528\u6237\u7406\u89E3\uFF0C\u4E3A\u4FDD\u62A4\u5BBE\u679C\u82F1\u8BED\u5408\u6CD5\u6743\u5229\uFF0C\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u9650\u5236\u7528\u6237\u540C\u4E00\u8D26\u53F7\u7ED1\u5B9A\u7684\u8BBE\u5907\u6570\u91CF\u4E3A\u30103\u3011\u53F0\uFF0C\u540C\u4E00\u8D26\u53F7\u7684\u30103\u3011\u53F0\u8BBE\u5907\u4E00\u7ECF\u7ED1\u5B9A\uFF0C\u5373\u4E0D\u5F97\u65B0\u589E/\u53D8\u66F4\u7ED1\u5B9A\u8BE5\u30103\u3011\u53F0\u8BBE\u5907\u4EE5\u5916\u7684\u5176\u4ED6\u8BBE\u5907\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'3. \u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3.1 \u9274\u4E8E\u7F51\u7EDC\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u7F51\u7EDC\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u7F51\u7EDC\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u7F51\u7EDC\u670D\u52A1\uFF0C\u5BBE\u679C\u82F1\u8BED\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u7F51\u7EDC\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\uFF0C\u5BBE\u679C\u82F1\u8BED\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u5BBE\u679C\u82F1\u8BED\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u5BBE\u679C\u82F1\u8BED\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.2 \u7528\u6237\u7406\u89E3\uFF0C\u5BBE\u679C\u82F1\u8BED\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u7F51\u7EDC\u670D\u52A1\u7684\u5E73\u53F0\uFF08\u5982\u4E92\u8054\u7F51\u7F51\u7AD9\u3001\u79FB\u52A8\u7F51\u7EDC\u7B49\uFF09\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u5BBE\u679C\u82F1\u8BED\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u5BBE\u679C\u82F1\u8BED\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.3 \u5982\u53D1\u751F\u4E0B\u5217\u4EFB\u4F55\u4E00\u79CD\u60C5\u5F62\uFF0C\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u968F\u65F6\u4E2D\u65AD\u6216\u7EC8\u6B62\u5411\u7528\u6237\u63D0\u4F9B\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u7F51\u7EDC\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\uFF09\u800C\u65E0\u9700\u5BF9\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.3.1 \u7528\u6237\u63D0\u4F9B\u7684\u4E2A\u4EBA\u8D44\u6599\u4E0D\u771F\u5B9E\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.3.2 \u7528\u6237\u8FDD\u53CD\u672C\u534F\u8BAE\u4E2D\u89C4\u5B9A\u7684\u4F7F\u7528\u89C4\u5219\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'3.3.3 \u7528\u6237\u5728\u4F7F\u7528\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u65F6\u672A\u6309\u89C4\u5B9A\u5411\u5BBE\u679C\u82F1\u8BED\u652F\u4ED8\u76F8\u5E94\u7684\u670D\u52A1\u8D39\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.4 \u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u7F51\u7EDC\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED180\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u7528\u6237\u6CE8\u518C\u7684\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u7684\u5E10\u53F7\u5728\u5176\u8BA2\u8D2D\u7684\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u7684\u670D\u52A1\u671F\u6EE1\u4E4B\u540E\u8FDE\u7EED180\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u7F51\u7EDC\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'4. \u4F7F\u7528\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4.1 \u7528\u6237\u5728\u7533\u8BF7\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u65F6\uFF0C\u5FC5\u987B\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u51C6\u786E\u7684\u4E2A\u4EBA\u8D44\u6599\uFF0C\u5982\u4E2A\u4EBA\u8D44\u6599\u6709\u4EFB\u4F55\u53D8\u52A8\uFF0C\u5FC5\u987B\u53CA\u65F6\u66F4\u65B0\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.2 \u7528\u6237\u4E0D\u5E94\u5C06\u5176\u5E10\u53F7\u3001\u5BC6\u7801\u8F6C\u8BA9\u6216\u51FA\u501F\u4E88\u4ED6\u4EBA\u4F7F\u7528\u3002\u5982\u7528\u6237\u53D1\u73B0\u5176\u5E10\u53F7\u906D\u4ED6\u4EBA\u975E\u6CD5\u4F7F\u7528\uFF0C\u5E94\u7ACB\u5373\u901A\u77E5\u5BBE\u679C\u82F1\u8BED\u3002\u56E0\u9ED1\u5BA2\u884C\u4E3A\u6216\u7528\u6237\u7684\u4FDD\u7BA1\u758F\u5FFD\u5BFC\u81F4\u5E10\u53F7\u3001\u5BC6\u7801\u906D\u4ED6\u4EBA\u975E\u6CD5\u4F7F\u7528\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.3 \u7528\u6237\u540C\u610F\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u5728\u63D0\u4F9B\u7F51\u7EDC\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5728\u5BBE\u679C\u82F1\u8BED\u7F51\u7AD9\u7684\u4EFB\u4F55\u9875\u9762\u4E0A\u6295\u653E\u5E7F\u544A\uFF09\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u5BBE\u679C\u82F1\u8BED\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.4 \u5BF9\u4E8E\u7528\u6237\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5FAE\u4FE1\u670D\u52A1\u53F7\u3001\u5FAE\u4FE1\u8001\u5E08\u4E2A\u4EBA\u53F7\u3001\u8BBA\u575B\u3001BBS\u3001\u6559\u80B2\u95EE\u7B54\uFF09\u4E0A\u4F20\u5230\u5BBE\u679C\u82F1\u8BED\u7F51\u7AD9\u4E0A\u53EF\u516C\u5F00\u83B7\u53D6\u533A\u57DF\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u7528\u6237\u540C\u610F\u5BBE\u679C\u82F1\u8BED\u5728\u5168\u4E16\u754C\u8303\u56F4\u5185\u5177\u6709\u514D\u8D39\u7684\u3001\u6C38\u4E45\u6027\u7684\u3001\u4E0D\u53EF\u64A4\u9500\u7684\u3001\u975E\u72EC\u5BB6\u7684\u548C\u5B8C\u5168\u518D\u8BB8\u53EF\u7684\u6743\u5229\u548C\u8BB8\u53EF\uFF0C\u4EE5\u4F7F\u7528\u3001\u590D\u5236\u3001\u4FEE\u6539\u3001\u6539\u7F16\u3001\u51FA\u7248\u3001\u7FFB\u8BD1\u3001\u636E\u4EE5\u521B\u4F5C\u884D\u751F\u4F5C\u54C1\u3001\u4F20\u64AD\u3001\u8868\u6F14\u548C\u5C55\u793A\u6B64\u7B49\u5185\u5BB9\uFF08\u6574\u4F53\u6216\u90E8\u5206\uFF09\uFF0C\u548C/\u6216\u5C06\u6B64\u7B49\u5185\u5BB9\u7F16\u5165\u5F53\u524D\u5DF2\u77E5\u7684\u6216\u4EE5\u540E\u5F00\u53D1\u7684\u5176\u4ED6\u4EFB\u4F55\u5F62\u5F0F\u7684\u4F5C\u54C1\u3001\u5A92\u4F53\u6216\u6280\u672F\u4E2D\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5 \u7528\u6237\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u8FC7\u7A0B\u4E2D\uFF0C\u5FC5\u987B\u9075\u5FAA\u4EE5\u4E0B\u539F\u5219\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.1 \u9075\u5B88\u4E2D\u56FD\u6709\u5173\u7684\u6CD5\u5F8B\u548C\u6CD5\u89C4\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.2 \u9075\u5B88\u6240\u6709\u4E0E\u7F51\u7EDC\u670D\u52A1\u6709\u5173\u7684\u7F51\u7EDC\u534F\u8BAE\u3001\u89C4\u5B9A\u548C\u7A0B\u5E8F\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.3 \u4E0D\u5F97\u4E3A\u4EFB\u4F55\u975E\u6CD5\u76EE\u7684\u800C\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\u7CFB\u7EDF\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.4 \u4E0D\u5F97\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u4FB5\u72AF\u5BBE\u679C\u82F1\u8BED\u7684\u5546\u4E1A\u5229\u76CA\uFF0C\u5305\u62EC\u5E76\u4E0D\u9650\u4E8E\u53D1\u5E03\u975E\u7ECF\u5BBE\u679C\u82F1\u8BED\u8BB8\u53EF\u7684\u5546\u4E1A\u5E7F\u544A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.5 \u4E0D\u5F97\u5229\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u7CFB\u7EDF\u8FDB\u884C\u4EFB\u4F55\u53EF\u80FD\u5BF9\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6B63\u5E38\u8FD0\u8F6C\u9020\u6210\u4E0D\u5229\u5F71\u54CD\u7684\u884C\u4E3A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.6 \u4E0D\u5F97\u5229\u7528\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u7F51\u7EDC\u670D\u52A1\u4E0A\u4F20\u3001\u5C55\u793A\u6216\u4F20\u64AD\u4EFB\u4F55\u865A\u5047\u7684\u3001\u9A9A\u6270\u6027\u7684\u3001\u4E2D\u4F24\u4ED6\u4EBA\u7684\u3001\u8FB1\u9A82\u6027\u7684\u3001\u6050\u5413\u6027\u7684\u3001\u5EB8\u4FD7\u6DEB\u79FD\u7684\u6216\u5176\u4ED6\u4EFB\u4F55\u975E\u6CD5\u7684\u4FE1\u606F\u8D44\u6599\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.7 \u4E0D\u5F97\u4FB5\u72AF\u5176\u4ED6\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u4E13\u5229\u6743\u3001\u8457\u4F5C\u6743\u3001\u5546\u6807\u6743\u3001\u540D\u8A89\u6743\u6216\u5176\u4ED6\u4EFB\u4F55\u5408\u6CD5\u6743\u76CA\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.5.8 \u4E0D\u5F97\u5229\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u7CFB\u7EDF\u8FDB\u884C\u4EFB\u4F55\u4E0D\u5229\u4E8E\u5BBE\u679C\u82F1\u8BED\u7684\u884C\u4E3A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.6 \u5BBE\u679C\u82F1\u8BED\u6709\u6743\u5BF9\u7528\u6237\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u7684\u60C5\u51B5\u8FDB\u884C\u5BA1\u67E5\u548C\u76D1\u7763(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5BF9\u7528\u6237\u5B58\u50A8\u5728\u5BBE\u679C\u82F1\u8BED\u7684\u5185\u5BB9\u8FDB\u884C\u5BA1\u6838)\uFF0C\u5982\u7528\u6237\u5728\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\u65F6\u8FDD\u53CD\u4EFB\u4F55\u4E0A\u8FF0\u89C4\u5B9A\uFF0C\u5BBE\u679C\u82F1\u8BED\u6216\u5176\u6388\u6743\u7684\u4EBA\u6709\u6743\u8981\u6C42\u7528\u6237\u6539\u6B63\u6216\u76F4\u63A5\u91C7\u53D6\u4E00\u5207\u5FC5\u8981\u7684\u63AA\u65BD\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u66F4\u6539\u6216\u5220\u9664\u7528\u6237\u5F20\u8D34\u7684\u5185\u5BB9\u7B49\u3001\u6682\u505C\u6216\u7EC8\u6B62\u7528\u6237\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\u7684\u6743\u5229\uFF09\u4EE5\u51CF\u8F7B\u7528\u6237\u4E0D\u5F53\u884C\u4E3A\u9020\u6210\u7684\u5F71\u54CD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.7 \u5BBE\u679C\u82F1\u8BED\u9488\u5BF9\u67D0\u4E9B\u7279\u5B9A\u7684\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u7684\u4F7F\u7528\u901A\u8FC7\u5404\u79CD\u65B9\u5F0F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7F51\u9875\u516C\u544A\u3001\u7535\u5B50\u90AE\u4EF6\u3001\u670D\u52A1\u53F7\u6D88\u606F\u63D0\u9192\u3001\u77ED\u4FE1\u63D0\u9192\u7B49\uFF09\u4F5C\u51FA\u7684\u4EFB\u4F55\u58F0\u660E\u3001\u901A\u77E5\u3001\u8B66\u793A\u7B49\u5185\u5BB9\u89C6\u4E3A\u672C\u534F\u8BAE\u7684\u4E00\u90E8\u5206\uFF0C\u7528\u6237\u5982\u4F7F\u7528\u8BE5\u7B49\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\uFF0C\u89C6\u4E3A\u7528\u6237\u540C\u610F\u8BE5\u7B49\u58F0\u660E\u3001\u901A\u77E5\u3001\u8B66\u793A\u7684\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.8 \u51E1\u7528\u6237\u6635\u79F0\u4E2D\u51FA\u73B0\u5982\u4E0B\u4FE1\u606F\u8005\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF09\uFF0C\u5BBE\u679C\u82F1\u8BED\u6709\u6743\u8FDB\u884C\u5C4F\u853D\u3001\u9501\u5B9A\uFF0C\u751A\u81F3\u6CE8\u9500\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.1.\u4F7F\u7528\u4E25\u91CD\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u98CE\u5E8F\u826F\u4FD7\uFF0C\u5305\u542B\u6216\u6697\u85CF\u53CD\u52A8\u3001\u8272\u60C5\u7B49\u4FE1\u606F\uFF08\u542B\u7B26\u53F7\u3001\u5730\u5740\u7B49\uFF09\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.2.\u4F7F\u7528\u515A\u548C\u56FD\u5BB6\u9886\u5BFC\u4EBA\u3001\u53E4\u4ECA\u4E2D\u5916\u6BD4\u8F83\u6709\u5F71\u54CD\u7684\u540D\u4EBA\u3001\u7F51\u7EDC\u4E0A\u77E5\u540D\u4EBA\u58EB\u7684\u771F\u5B9E\u59D3\u540D\u3001\u5B57\u3001\u53F7\u3001\u827A\u540D\u3001\u7B14\u540D\u3001\u5934\u8854\u7B49\u4E3A\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.3.\u4F7F\u7528\u56FD\u5BB6\u673A\u6784\u3001\u4F01\u4E8B\u4E1A\u5355\u4F4D\u3001\u77E5\u540D\u516C\u53F8\u6216\u54C1\u724C\u7684\u540D\u79F0\u53CA\u6807\u8BC6\u4E3A\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.4.\u542B\u6027\u522B\u6B67\u89C6\u3001\u79CD\u65CF\u6B67\u89C6\u3001\u5730\u57DF\u6B67\u89C6\u7B49\u4FE1\u606F\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.5.\u542B\u81EA\u4FAE\u8FB1\u3001\u7325\u4EB5\u6216\u8005\u5BF9\u4ED6\u4EBA\u8FDB\u884C\u4FAE\u8FB1\u3001\u6311\u8845\u3001\u6F2B\u9A82\u3001\u4EBA\u8EAB\u653B\u51FB\u7B49\u4E0D\u6587\u660E\u3001\u4E0D\u5065\u5EB7\u4FE1\u606F\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.6.\u542B\u6613\u4EA7\u751F\u6B67\u4E49\u3001\u5F15\u8D77\u4ED6\u4EBA\u8BEF\u89E3\u7684\u4FE1\u606F\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.7.\u672A\u83B7\u5F97\u5BBE\u679C\u82F1\u8BED\u5B98\u65B9\u6B63\u5F0F\u8BB8\u53EF\u800C\u4F7F\u7528\u5E26\u6709\u5BBE\u679C\u82F1\u8BED\u76F8\u5173\u540D\u79F0\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.8.\u4E0E\u5BBE\u679C\u82F1\u8BED\u8001\u5E08\u3001\u53CA\u793E\u533A\u7BA1\u7406\u4EBA\u5458\u7684\u6635\u79F0\u8FD1\u4F3C\u6216\u96F7\u540C\uFF0C\u5E76\u53EF\u80FD\u5F15\u8D77\u6DF7\u6DC6\u6216\u7EA0\u7EB7\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.9.\u5E26\u6709\u660E\u663E\u5E7F\u544A\u6027\u8D28\u7684\u6635\u79F0\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'4.8.10.\u5E26\u6709\u5176\u5B83\u6CD5\u5F8B\u6CD5\u89C4\u4EE5\u53CA\u5BBE\u679C\u82F1\u8BED\u89C4\u5219\u4E2D\u6240\u7981\u6B62\u4FE1\u606F\u7684\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'5. \u4E0A\u8BFE\u89C4\u5B9A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5.1. \u4E3A\u786E\u4FDD\u6240\u5728\u73ED\u7EA7\u826F\u597D\u7684\u8BFE\u5802\u6C1B\u56F4\uFF0C\u7528\u6237\u5E94\u534F\u52A9\u5BBE\u679C\u82F1\u8BED\uFF0C\u4FDD\u969C\u5B66\u5458\u5728\u4E0A\u8BFE\u8FC7\u7A0B\u4E2D\u4E0D\u5435\u95F9\uFF0C\u4E0D\u8FDF\u5230\uFF0C\u4E0D\u65E9\u9000\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.2. \u5982\u9047\u7279\u6B8A\u539F\u56E0\uFF0C\u5BBE\u679C\u82F1\u8BED\u5728\u544A\u77E5\u7528\u6237\u7684\u540C\u65F6\u6709\u6743\u5BF9\u7528\u6237\u4E0A\u8BFE\u8D26\u53F7\u505A\u9759\u97F3\u3001\u4E0B\u7EBF\u7B49\u5904\u7406\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3. \u7528\u6237\u6216\u5B66\u5458\u5728\u8BFE\u7A0B\u8FDB\u884C\u4E2D\u5982\u5B58\u5728\u4EE5\u4E0B\u60C5\u5F62\uFF0C\u5BBE\u679C\u82F1\u8BED\u6216\u5916\u6559\u6709\u6743\u4E2D\u6B62\u8BFE\u7A0B\u670D\u52A1\uFF0C\u4E14\u6263\u9664\u8BFE\u65F6\uFF1B\u540C\u65F6\u6709\u6743\u5220\u9664\u8BE5\u6B21\u8BFE\u7A0B\u670D\u52A1\u7684\u5168\u90E8\u89C6\u9891\uFF0C\u4E14\u65E0\u987B\u627F\u62C5\u4EFB\u4F55\u6CD5\u5F8B\u540E\u679C\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.1\u8863\u7740\u66B4\u9732\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u88F8\u9732\u8EAB\u4F53\u9690\u79C1\u90E8\u4F4D\u7B49\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.2 \u591A\u4E2A\u5B69\u5B50\u4E0A\u8BFE\u6216\u975E\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u5B66\u5458\u672C\u4EBA\u4E0A\u8BFE\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6210\u4EBA\u4EE3\u66FF\u4E0A\u8BFE\u7B49\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.3 \u5BB6\u66B4\u884C\u4E3A\u6216\u8005\u4E0D\u9002\u5F53\u7684\u7BA1\u6559\u884C\u4E3A\uFF0C\u5305\u62EC\u60E9\u7F5A\u6027\u7684\u80A2\u4F53\u63A5\u89E6\u6216\u8005\u4E25\u91CD\u8FB1\u9A82\u7B49\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.4\u4F7F\u7528\u5371\u9669\u7684\u7528\u5177\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5200\u5177\u3001\u4EFF\u771F\u67AA\u7B49\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.5\u635F\u5BB3\u56FD\u5BB6\u7684\u5C0A\u4E25\u6216\u8005\u5229\u76CA\uFF0C\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.6\u5371\u5BB3\u4EBA\u8EAB\u3001\u8D22\u4EA7\u5B89\u5168\uFF0C\u6CC4\u9732\u4E2A\u4EBA\u9690\u79C1\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.7\u59A8\u788D\u793E\u4F1A\u516C\u5171\u79E9\u5E8F\u6216\u8005\u8FDD\u80CC\u793E\u4F1A\u826F\u597D\u98CE\u5C1A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.8\u6709\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u8FF7\u4FE1\u3001\u6050\u6016\u3001\u66B4\u529B\u76F8\u5173\u7684\u8A00\u884C\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.9\u6709\u6C11\u65CF\u3001\u79CD\u65CF\u3001\u5B97\u6559\u3001\u6027\u522B\u6B67\u89C6\u76F8\u5173\u7684\u8A00\u884C\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.10\u5BF9\u5916\u6559\u8FDB\u884C\u653B\u51FB\u6027\u3001\u6B67\u89C6\u6027\u7684\u8A00\u884C\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.11\u8FDD\u53CD\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6CD5\u5F8B\u6CD5\u89C4\u7684\u5176\u4ED6\u884C\u4E3A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.12 \u8FDD\u53CD\u5916\u6559\u6240\u5728\u5730\u76F8\u5173\u6CD5\u5F8B\u6216\u4E59\u65B9\u5E73\u53F0\u89C4\u5219\u7684\u884C\u4E3A\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'5.3.13 \u5BBE\u679C\u82F1\u8BED\u5408\u7406\u8BA4\u5B9A\u5E94\u5F53\u5BF9\u7528\u6237\u4E2D\u6B62\u8BFE\u7A0B\u670D\u52A1\u6216\u5220\u9664\u76F8\u5173\u89C6\u9891\u7684\u5176\u4ED6\u884C\u4E3A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'6. \u53EA\u662F\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1 \u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u7F51\u7EDC\u670D\u52A1\u4E2D\u5305\u542B\u7684\u4EFB\u4F55\u6587\u672C\u3001\u56FE\u7247\u3001\u56FE\u5F62\u3001\u97F3\u9891\u548C/\u6216\u89C6\u9891\u8D44\u6599\u5747\u53D7\u7248\u6743\u3001\u5546\u6807\u548C/\u6216\u5176\u5B83\u8D22\u4EA7\u6240\u6709\u6743\u6CD5\u5F8B\u7684\u4FDD\u62A4\uFF0C\u672A\u7ECF\u76F8\u5173\u6743\u5229\u4EBA\u540C\u610F\uFF0C\u4E0A\u8FF0\u8D44\u6599\u5747\u4E0D\u5F97\u5728\u4EFB\u4F55\u5A92\u4F53\u76F4\u63A5\u6216\u95F4\u63A5\u53D1\u5E03\u3001\u64AD\u653E\u3001\u51FA\u4E8E\u64AD\u653E\u6216\u53D1\u5E03\u76EE\u7684\u800C\u6539\u5199\u6216\u518D\u53D1\u884C\uFF0C\u6216\u8005\u88AB\u7528\u4E8E\u5176\u4ED6\u4EFB\u4F55\u5546\u4E1A\u76EE\u7684\u3002\u6240\u6709\u8FD9\u4E9B\u8D44\u6599\u6216\u8D44\u6599\u7684\u4EFB\u4F55\u90E8\u5206\u4EC5\u53EF\u4F5C\u4E3A\u79C1\u4EBA\u548C\u975E\u5546\u4E1A\u7528\u9014\u800C\u4FDD\u5B58\u5728\u67D0\u53F0\u8BA1\u7B97\u673A\u5185\u3002\u5C31\u7531\u4E0A\u8FF0\u8D44\u6599\u4EA7\u751F\u6216\u5728\u4F20\u9001\u6216\u9012\u4EA4\u5168\u90E8\u6216\u90E8\u5206\u4E0A\u8FF0\u8D44\u6599\u8FC7\u7A0B\u4E2D\u4EA7\u751F\u7684\u5EF6\u8BEF\u3001\u4E0D\u51C6\u786E\u3001\u9519\u8BEF\u548C\u9057\u6F0F\u6216\u4ECE\u4E2D\u4EA7\u751F\u6216\u7531\u6B64\u4EA7\u751F\u7684\u4EFB\u4F55\u635F\u5BB3\u8D54\u507F\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u4EE5\u4EFB\u4F55\u5F62\u5F0F\uFF0C\u5411\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u8D1F\u8D23\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'6.2 \u5BBE\u679C\u82F1\u8BED\u4E3A\u63D0\u4F9B\u7F51\u7EDC\u670D\u52A1\u800C\u4F7F\u7528\u7684\u4EFB\u4F55\u8F6F\u4EF6\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8F6F\u4EF6\u4E2D\u6240\u542B\u7684\u4EFB\u4F55\u56FE\u8C61\u3001\u7167\u7247\u3001\u52A8\u753B\u3001\u5F55\u50CF\u3001\u5F55\u97F3\u3001\u97F3\u4E50\u3001\u6587\u5B57\u548C\u9644\u52A0\u7A0B\u5E8F\u3001\u968F\u9644\u7684\u5E2E\u52A9\u6750\u6599\uFF09\u7684\u4E00\u5207\u6743\u5229\u5747\u5C5E\u4E8E\u8BE5\u8F6F\u4EF6\u7684\u8457\u4F5C\u6743\u4EBA\uFF0C\u672A\u7ECF\u8BE5\u8F6F\u4EF6\u7684\u8457\u4F5C\u6743\u4EBA\u8BB8\u53EF\uFF0C\u7528\u6237\u4E0D\u5F97\u5BF9\u8BE5\u8F6F\u4EF6\u8FDB\u884C\u53CD\u5411\u5DE5\u7A0B\uFF08reverse engineer\uFF09\u3001\u53CD\u5411\u7F16\u8BD1\uFF08decompile\uFF09\u6216\u53CD\u6C47\u7F16\uFF08disassemble\uFF09\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'7. \u514D\u8D23\u58F0\u660E'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1 \u7528\u6237\u660E\u786E\u540C\u610F\u5176\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u6240\u5B58\u5728\u7684\u98CE\u9669\u5C06\u5B8C\u5168\u7531\u5176\u81EA\u5DF1\u627F\u62C5\uFF1B\u56E0\u5176\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7F51\u7EDC\u670D\u52A1\u800C\u4EA7\u751F\u7684\u4E00\u5207\u540E\u679C\u4E5F\u7531\u5176\u81EA\u5DF1\u627F\u62C5\uFF0C\u5BBE\u679C\u82F1\u8BED\u5BF9\u7528\u6237\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2 \u5BBE\u679C\u82F1\u8BED\u4E0D\u62C5\u4FDD\u7F51\u7EDC\u670D\u52A1\u4E00\u5B9A\u80FD\u6EE1\u8DB3\u7528\u6237\u7684\u8981\u6C42\uFF0C\u4E5F\u4E0D\u62C5\u4FDD\u7F51\u7EDC\u670D\u52A1\u4E0D\u4F1A\u4E2D\u65AD\uFF0C\u5BF9\u7F51\u7EDC\u670D\u52A1\u7684\u53CA\u65F6\u6027\u3001\u5B89\u5168\u6027\u3001\u51C6\u786E\u6027\u4E5F\u90FD\u4E0D\u4F5C\u62C5\u4FDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3 \u5BBE\u679C\u82F1\u8BED\u4E0D\u4FDD\u8BC1\u4E3A\u5411\u7528\u6237\u63D0\u4F9B\u4FBF\u5229\u800C\u8BBE\u7F6E\u7684\u5916\u90E8\u94FE\u63A5\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\uFF0C\u540C\u65F6\uFF0C\u5BF9\u4E8E\u8BE5\u7B49\u5916\u90E8\u94FE\u63A5\u6307\u5411\u7684\u4E0D\u7531\u5BBE\u679C\u82F1\u8BED\u5B9E\u9645\u63A7\u5236\u7684\u4EFB\u4F55\u7F51\u9875\u4E0A\u7684\u5185\u5BB9\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u5BF9\u4E8E\u56E0\u4E0D\u53EF\u6297\u529B\u6216\u5BBE\u679C\u82F1\u8BED\u4E0D\u80FD\u63A7\u5236\u7684\u539F\u56E0\u9020\u6210\u7684\u7F51\u7EDC\u670D\u52A1\u4E2D\u65AD\u6216\u5176\u5B83\u7F3A\u9677\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u5C06\u5C3D\u529B\u51CF\u5C11\u56E0\u6B64\u800C\u7ED9\u7528\u6237\u9020\u6210\u7684\u635F\u5931\u548C\u5F71\u54CD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5 \u7528\u6237\u7406\u89E3\u5E76\u540C\u610F\uFF0C\u5BF9\u4E8E\u5BBE\u679C\u82F1\u8BED\u5411\u7528\u6237\u63D0\u4F9B\u7684\u4E0B\u5217\u4EA7\u54C1\u6216\u8005\u670D\u52A1\u7684\u8D28\u91CF\u7F3A\u9677\u672C\u8EAB\u53CA\u5176\u5F15\u53D1\u7684\u4EFB\u4F55\u635F\u5931\uFF0C\u5BBE\u679C\u82F1\u8BED\u65E0\u9700\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7.5.1 \u5BBE\u679C\u82F1\u8BED\u5411\u7528\u6237\u514D\u8D39\u63D0\u4F9B\u7684\u5404\u9879\u7F51\u7EDC\u670D\u52A1\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7.5.2 \u5BBE\u679C\u82F1\u8BED\u5411\u7528\u6237\u8D60\u9001\u7684\u4EFB\u4F55\u4EA7\u54C1\u6216\u8005\u670D\u52A1\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'7.5.3 \u5BBE\u679C\u82F1\u8BED\u5411\u6536\u8D39\u7F51\u7EDC\u670D\u52A1\u7528\u6237\u9644\u8D60\u7684\u5404\u79CD\u4EA7\u54C1\u6216\u8005\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'8. \u8FDD\u7EA6\u8D54\u507F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1 \u5982\u56E0\u5BBE\u679C\u82F1\u8BED\u8FDD\u53CD\u6709\u5173\u6CD5\u5F8B\u3001\u6CD5\u89C4\u6216\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u4EFB\u4F55\u6761\u6B3E\u800C\u7ED9\u7528\u6237\u9020\u6210\u635F\u5931\uFF0C\u5BBE\u679C\u82F1\u8BED\u540C\u610F\u627F\u62C5\u7531\u6B64\u9020\u6210\u7684\u635F\u5BB3\u8D54\u507F\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2 \u7528\u6237\u540C\u610F\u4FDD\u969C\u548C\u7EF4\u62A4\u5BBE\u679C\u82F1\u8BED\u53CA\u5176\u4ED6\u7528\u6237\u7684\u5229\u76CA\uFF0C\u5982\u56E0\u7528\u6237\u8FDD\u53CD\u6709\u5173\u6CD5\u5F8B\u3001\u6CD5\u89C4\u6216\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u4EFB\u4F55\u6761\u6B3E\u800C\u7ED9\u5BBE\u679C\u82F1\u8BED\u6216\u4EFB\u4F55\u5176\u4ED6\u7B2C\u4E09\u4EBA\u9020\u6210\u635F\u5931\uFF0C\u7528\u6237\u540C\u610F\u627F\u62C5\u7531\u6B64\u9020\u6210\u7684\u635F\u5BB3\u8D54\u507F\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'9. \u534F\u8BAE\u4FEE\u6539'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1 \u5BBE\u679C\u82F1\u8BED\u6709\u6743\u968F\u65F6\u4FEE\u6539\u672C\u534F\u8BAE\u7684\u4EFB\u4F55\u6761\u6B3E\uFF0C\u4E00\u65E6\u672C\u534F\u8BAE\u7684\u5185\u5BB9\u53D1\u751F\u53D8\u52A8\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u4F1A\u76F4\u63A5\u5728\u5BBE\u679C\u82F1\u8BED\u7F51\u7AD9\u6216\u8005App\u7528\u6237\u6CE8\u518C\u9875\u9762\u4E0A\u516C\u5E03\u4FEE\u6539\u4E4B\u540E\u7684\u534F\u8BAE\u5185\u5BB9\uFF0C\u8BE5\u516C\u5E03\u884C\u4E3A\u89C6\u4E3A\u5BBE\u679C\u82F1\u8BED\u5DF2\u7ECF\u901A\u77E5\u7528\u6237\u4FEE\u6539\u5185\u5BB9\u3002\u5BBE\u679C\u82F1\u8BED\u4E5F\u53EF\u901A\u8FC7\u5176\u4ED6\u9002\u5F53\u65B9\u5F0F\u5411\u7528\u6237\u63D0\u793A\u4FEE\u6539\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2 \u5982\u679C\u4E0D\u540C\u610F\u5BBE\u679C\u82F1\u8BED\u5BF9\u672C\u534F\u8BAE\u76F8\u5173\u6761\u6B3E\u6240\u505A\u7684\u4FEE\u6539\uFF0C\u7528\u6237\u6709\u6743\u505C\u6B62\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\u3002\u5982\u679C\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\uFF0C\u5219\u89C6\u4E3A\u7528\u6237\u63A5\u53D7\u5BBE\u679C\u82F1\u8BED\u5BF9\u672C\u534F\u8BAE\u76F8\u5173\u6761\u6B3E\u6240\u505A\u7684\u4FEE\u6539\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'10. \u901A\u77E5\u9001\u8FBE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'10.1 \u672C\u534F\u8BAE\u9879\u4E0B\u5BBE\u679C\u82F1\u8BED\u5BF9\u4E8E\u7528\u6237\u6240\u6709\u7684\u901A\u77E5\u5747\u53EF\u901A\u8FC7\u7F51\u9875\u516C\u544A\u3001\u7535\u5B50\u90AE\u4EF6\u3001\u624B\u673A\u77ED\u4FE1\u6216\u5E38\u89C4\u7684\u4FE1\u4EF6\u4F20\u9001\u7B49\u65B9\u5F0F\u8FDB\u884C\uFF1B\u8BE5\u7B49\u901A\u77E5\u4E8E\u53D1\u9001\u4E4B\u65E5\u89C6\u4E3A\u5DF2\u9001\u8FBE\u6536\u4EF6\u4EBA\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'10.2 \u7528\u6237\u5BF9\u4E8E\u5BBE\u679C\u82F1\u8BED\u7684\u901A\u77E5\u5E94\u5F53\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u5BF9\u5916\u6B63\u5F0F\u516C\u5E03\u7684\u901A\u4FE1\u5730\u5740\u3001\u8054\u7CFB\u7535\u8BDD\u7B49\u8054\u7CFB\u4FE1\u606F\u8FDB\u884C\u9001\u8FBE\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u7ECF\u8425\u5730\u5740\uFF1A\u6D59\u6C5F\u7701\u676D\u5DDE\u5E02\u62F1\u5885\u533A\u5EB7\u4E2D\u8DEF16\u53F73\u5E623\u5C42311\u5BA4',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u8054\u7CFB\u7535\u8BDD\uFF1A0571-88321763'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'11. \u6CD5\u5F8B\u7BA1\u8F96'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u672C\u534F\u8BAE\u7684\u8BA2\u7ACB\u3001\u6267\u884C\u548C\u89E3\u91CA\u53CA\u4E89\u8BAE\u7684\u89E3\u51B3\u5747\u5E94\u9002\u7528\u4E2D\u56FD\u6CD5\u5F8B\u5E76\u53D7\u4E2D\u56FD\u6CD5\u9662\u7BA1\u8F96\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u53CC\u65B9\u5C31\u672C\u534F\u8BAE\u5185\u5BB9\u6216\u5176\u6267\u884C\u53D1\u751F\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u53CC\u65B9\u5E94\u5C3D\u91CF\u53CB\u597D\u534F\u5546\u89E3\u51B3\uFF1B\u534F\u5546\u4E0D\u6210\u65F6\uFF0C\u4EFB\u4F55\u4E00\u65B9\u5747\u53EF\u5411\u5BBE\u679C\u82F1\u8BED\u6240\u5728\u5730\u7684\u4EBA\u6C11\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'11. \u5176\u4ED6\u89C4\u5B9A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'12.1 \u672C\u534F\u8BAE\u6784\u6210\u53CC\u65B9\u5BF9\u672C\u534F\u8BAE\u4E4B\u7EA6\u5B9A\u4E8B\u9879\u53CA\u5176\u4ED6\u6709\u5173\u4E8B\u5B9C\u7684\u5B8C\u6574\u534F\u8BAE\uFF0C\u9664\u672C\u534F\u8BAE\u89C4\u5B9A\u7684\u4E4B\u5916\uFF0C\u672A\u8D4B\u4E88\u672C\u534F\u8BAE\u5404\u65B9\u5176\u4ED6\u6743\u5229\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'12.2 \u5982\u672C\u534F\u8BAE\u4E2D\u7684\u4EFB\u4F55\u6761\u6B3E\u65E0\u8BBA\u56E0\u4F55\u79CD\u539F\u56E0\u5B8C\u5168\u6216\u90E8\u5206\u65E0\u6548\u6216\u4E0D\u5177\u6709\u6267\u884C\u529B\uFF0C\u672C\u534F\u8BAE\u7684\u5176\u4F59\u6761\u6B3E\u4ECD\u5E94\u6709\u6548\u5E76\u4E14\u6709\u7EA6\u675F\u529B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'12.3 \u672C\u534F\u8BAE\u4E2D\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE\uFF0C\u5728\u89E3\u91CA\u672C\u534F\u8BAE\u65F6\u5E94\u88AB\u5FFD\u7565\u3002 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}]);return RulesPageBinguo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RulesPageBinguo);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyBinguoPage=function(_Component){_inherits(PrivacyBinguoPage,_Component);function PrivacyBinguoPage(props){_classCallCheck(this,PrivacyBinguoPage);var _this=_possibleConstructorReturn(this,(PrivacyBinguoPage.__proto__||Object.getPrototypeOf(PrivacyBinguoPage)).call(this,props));_this.state={};return _this;}_createClass(PrivacyBinguoPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'用户隐私协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7528\u6237\u9690\u79C1\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528Bingo\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\uFF0CBingo\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u5BBE\u679C\u82F1\u8BED\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u5BBE\u679C\u82F1\u8BED\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u767E\u79D1\u82F1\u8BED\u8BAD\u7EC3\u8425\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u5BBE\u679C\u82F1\u8BED\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u5BBE\u679C\u82F1\u8BED\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u5BBE\u679C\u82F1\u8BED\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5F53\u60A8\u9009\u62E9\u901A\u8FC7\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u8D26\u6237\u767B\u5F55\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u540C\u610F\u6211\u4EEC\u4ECE\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u83B7\u53D6\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4FE1\u606F\uFF08\u5305\u62EC\u624B\u673A\u53F7\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\uFF0C\u5E76\u4E14\u60A8\u540C\u610F\u5C06\u60A8\u7684\u7B2C\u4E09\u65B9\u8D26\u6237\u4E0E\u60A8\u7684\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4F7F\u60A8\u53EF\u4EE5\u901A\u8FC7\u7B2C\u4E09\u65B9\u8D26\u6237\u76F4\u63A5\u767B\u5F55\u5E76\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u501F\u52A9\u8BE5\u8D26\u6237\u5B9E\u73B0\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u6211\u4EEC\u4F1A\u4F9D\u636E\u4E0E\u7B2C\u4E09\u65B9\u7684\u7EA6\u5B9A\uFF0C\u5E76\u5728\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u524D\u63D0\u4E0B\uFF0C\u4F7F\u7528\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u540C\u610F\u5BBE\u679C\u82F1\u8BED\u4ECE\u7B2C\u4E09\u65B9\u83B7\u53D6\u60A8\u6388\u6743\u5171\u4EAB\u7684\u4FE1\u606F\uFF0C\u60A8\u5C06\u65E0\u6CD5\u901A\u8FC7\u5FAE\u4FE1\u7B49\u7B2C\u4E09\u65B9\u8D26\u6237\u7684\u65B9\u5F0F\u6CE8\u518C\u8D26\u53F7\u5E76\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u501F\u52A9\u8BE5\u7B2C\u4E09\u65B9\u8D26\u6237\u5B9E\u73B0\u6570\u636E\u7684\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09'),'\uFF0C\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.5 \u60A8\u8D2D\u4E70\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u5BBE\u679C\u82F1\u8BED\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u652F\u4ED8\u65B9\u5F0F\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u94F6\u884C\u8D26\u53F7\u7B49\u4FE1\u606F\u3002'),'\u5982\u60A8\u7684\u8D2D\u4E70\u662F\u901A\u8FC7\u7B2C\u4E09\u65B9\u8FDB\u884C\u7684\uFF0C\u6211\u4EEC\u53EF\u80FD\u8FD8\u4F1A\u6536\u96C6\u60A8\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\uFF08',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49'),'\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u5BBE\u679C\u82F1\u8BED\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u94F6\u884C\u8D26\u53F7\u3001\u7B2C\u4E09\u65B9\u652F\u4ED8\u5E73\u53F0\u7684\u8D26\u53F7\uFF08\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49\uFF09\u3001\u4E0E\u5BBE\u679C\u82F1\u8BED\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u5BBE\u679C\u82F1\u8BED\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF08\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u7B49\uFF09\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u5BBE\u679C\u82F1\u8BED\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u5BBE\u679C\u82F1\u8BED\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u82E5\u60A8\u5E0C\u671B\u5411\u5BBE\u679C\u82F1\u8BED\u4E0A\u4F20\u60A8\u7684\u5934\u50CF\u53CA/\u6216\u5176\u4ED6\u56FE\u7247\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u5BBE\u679C\u82F1\u8BED\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u5BBE\u679C\u82F1\u8BED\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u5BBE\u679C\u82F1\u8BED\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u5BBE\u679C\u82F1\u8BED\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5BBE\u679C\u82F1\u8BED\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u5BBE\u679C\u82F1\u8BED\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u5BBE\u679C\u82F1\u8BED\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F'),'\uFF0C\u4F46\u5BBE\u679C\u82F1\u8BED\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355'),'\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u5BBE\u679C\u82F1\u8BED\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u5BBE\u679C\u82F1\u8BED\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u5BBE\u679C\u82F1\u8BED\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u7B2C\u4E09\u65B9\u652F\u4ED8\u5E73\u53F0\u83B7\u5F97',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u7684\u7B2C\u4E09\u65B9\u652F\u4ED8\u8D26\u6237\uFF08\u652F\u4ED8\u5B9D\u8D26\u53F7\u3001\u62FC\u591A\u591A\u8D26\u53F7\u3001\u5929\u732B\u8D26\u53F7\u3001\u6709\u8D5E\u8D26\u53F7\u3001\u5FAE\u4FE1\u8D26\u53F7\u3001\u4EAC\u4E1C\u8D26\u6237\u3001\u5C0F\u9E45\u901A\u8D26\u53F7\u3001\u82F9\u679C\u8D26\u53F7\u3001\u534E\u4E3A\u8D26\u53F7\u3001\u5C0F\u7C73\u8D26\u53F7\u7B49\uFF09'),'\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u5BBE\u679C\u82F1\u8BED\u6216\u8005\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u5BBE\u679C\u82F1\u8BED\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u5BBE\u679C\u82F1\u8BED\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u5BBE\u679C\u82F1\u8BED\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u5BBE\u679C\u82F1\u8BED\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u5BBE\u679C\u82F1\u8BED\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u5BBE\u679C\u82F1\u8BED\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u5BBE\u679C\u82F1\u8BED\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u5BBE\u679C\u82F1\u8BED\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u5BBE\u679C\u82F1\u8BED\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u5BBE\u679C\u82F1\u8BED\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u5BBE\u679C\u82F1\u8BED\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u5BBE\u679C\u82F1\u8BED\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u5BBE\u679C\u82F1\u8BED\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u5BBE\u679C\u82F1\u8BED\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u5BBE\u679C\u82F1\u8BED\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u5BBE\u679C\u82F1\u8BED\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u5BBE\u679C\u82F1\u8BED\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5982\u4E0D\u5E78\u53D1\u751F\u4FE1\u606F\u5B89\u5168\u4E8B\u6545\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\uFF0C\u53CA\u65F6\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u548C\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u7B49\u3002\u6211\u4EEC\u540C\u65F6\u5C06\u53CA\u65F6\u5C06\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u9002\u5408\u7684\u65B9\u5F0F\u544A\u77E5\u60A8\uFF1B\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E3B\u52A8\u4E0A\u62A5\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u5BBE\u679C\u82F1\u8BED\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u5BBE\u679C\u82F1\u8BED\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uF0B7\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u5BBE\u679C\u82F1\u8BED\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u5BBE\u679C\u82F1\u8BED\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u5BBE\u679C\u82F1\u8BED\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u5BBE\u679C\u82F1\u8BED\u505A\u51FA\u89E3\u91CA\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u5BBE\u679C\u82F1\u8BED\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u5BBE\u679C\u82F1\u8BED\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u5BBE\u679C\u82F1\u8BED\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u5BBE\u679C\u82F1\u8BED\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u5BBE\u679C\u82F1\u8BED\u4F1A\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u67AB\u6866\u6811-\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A0571-88321763\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701\u676D\u5DDE\u5E02\u62F1\u5885\u533A\u5EB7\u4E2D\u8DEF16\u53F73\u5E623\u5C42311\u5BA4\uFF08\u6536\u4EF6\u4EBA\uFF1A\u5BBE\u679C\u82F1\u8BED\u5BA2\u670D\u90E8\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u5BBE\u679C\u82F1\u8BED\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u5BBE\u679C\u82F1\u8BED\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return PrivacyBinguoPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrivacyBinguoPage);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RulesPage=function(_Component){_inherits(RulesPage,_Component);function RulesPage(props){_classCallCheck(this,RulesPage);var _this=_possibleConstructorReturn(this,(RulesPage.__proto__||Object.getPrototypeOf(RulesPage)).call(this,props));_this.state={};return _this;}_createClass(RulesPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'第2教室服务使用协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container customerrules'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7B2C2\u6559\u5BA4\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u7B2C2\u6559\u5BA4\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B\u662F\u60A8\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u4E0E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u4E4B\u95F4\u5728\u4F7F\u7528\u5176\u7BA1\u7406\u7684\u7B2C2\u6559\u5BA4\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7B2C2\u6559\u5BA4\u201D\uFF09\u4E2D\u6CE8\u518C\u4F7F\u7528\u65F6\u7B7E\u7F72\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E00\u3001\u91CD\u8981\u987B\u77E5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u5E94\u8BA4\u771F\u9605\u8BFB\uFF08\u672A\u6210\u5E74\u4EBA\u5E94\u5F53\u5728\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\uFF09\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u9664\u975E\u7528\u6237\u63A5\u53D7\u672C\u534F\u8BAE\uFF0C\u7528\u6237\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u53CA\u4F7F\u7528\u884C\u4E3A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u7ED9\u4E88\u6BCF\u4E2A\u7528\u6237\u4E00\u4E2A\u7528\u6237\u5E10\u53F7\u53CA\u76F8\u5E94\u7684\u5BC6\u7801\uFF0C\u8BE5\u7528\u6237\u5E10\u53F7\u548C\u5BC6\u7801\u7531\u7528\u6237\u8D1F\u8D23\u4FDD\u7BA1\uFF1B\u7528\u6237\u59A5\u5584\u4FDD\u7BA1\u5E10\u53F7\u548C\u5BC6\u7801\uFF0C\u9632\u6B62\u6CC4\u9732\uFF0C\u5982\u679C\u5E10\u53F7\u548C\u5BC6\u7801\u88AB\u76D7\u7528\u7684\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E8C\u3001\u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7B2C2\u6559\u5BA4\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u7B2C2\u6559\u5BA4\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7B2C2\u6559\u5BA4\u4EC5\u63D0\u4F9B\u8F6F\u4EF6\u76F8\u5173\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u8F6F\u4EF6\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u624B\u673A\u3001\u4E2A\u4EBA\u7535\u8111\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u540C\u610F\u7B2C2\u6559\u5BA4\u4E3A\u672C\u534F\u8BAE\u5C65\u884C\u6216\u76F8\u5173\u7814\u7A76\u7684\u76EE\u7684\u6536\u96C6\u3001\u4F7F\u7528\u6216\u6388\u6743\u7B2C\u4E09\u65B9\uFF08\u4E14\u8BE5\u7B49\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E\u7B2C2\u6559\u5BA4\u540C\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u4E49\u52A1\uFF09\u975E\u5546\u4E1A\u5730\u4F7F\u7528\u901A\u8FC7\u670D\u52A1\u83B7\u53D6\u7684\u7528\u6237\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8EAB\u4EFD\u4FE1\u606F\u3001\u6027\u522B\u3001\u804C\u4E1A\u3001\u5174\u8DA3\u7231\u597D\u3001\u5728\u7B2C2\u6559\u5BA4\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8BED\u97F3\u8D44\u6599\uFF09\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u4E8E\u6392\u884C\u699C\u4E0A\uFF0C\u4F7F\u7B2C2\u6559\u5BA4\u5176\u4ED6\u7528\u6237\u53EF\u4EE5\u67E5\u770B\u7528\u6237\u7684\u5934\u50CF\u3001\u540D\u5B57\u3001\u8BED\u97F3\u7B49\u4E2A\u4EBA\u8D44\u6599\u3001\u5E94\u7528\u4E8E\u76F8\u5173\u5B66\u672F\u3001\u5E94\u7528\u7814\u7A76\u7B49\u3002\u7B2C2\u6559\u5BA4\u627F\u8BFA\uFF0C\u9664\u975E\u53E6\u884C\u53D6\u5F97\u7528\u6237\u7684\u4E8B\u5148\u540C\u610F\uFF0C\u5426\u5219\u7B2C2\u6559\u5BA4\u4E0D\u4F1A\u5C06\u7528\u6237\u4FE1\u606F\u6388\u6743\u7ED9\u4E0E\u5C65\u884C\u672C\u534F\u8BAE\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u7528\u4E8E\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u56FD\u5BB6\u6807\u51C6\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u4F9D\u6CD5\u6536\u96C6\u5E76\u4F7F\u7528\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u4E14\u65E0\u9700\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u76F4\u63A5\u76F8\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u4ED6\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u7528\u6237\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF085\uFF09\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\uFF1A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF087\uFF09\u6839\u636E\u7528\u6237\u7684\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF088\uFF09\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\uFF1A\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF089\uFF09\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF0810\uFF09\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF089\uFF09\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7B2C2\u6559\u5BA4\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u4E8B\u5148\u5F81\u5F97\u7528\u6237\u7684\u6388\u6743\u540C\u610F\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF085\uFF09\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E09\u3001\u7528\u6237\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7528\u6237\u6709\u6743\u4F7F\u7528\u7B2C2\u6559\u5BA4\u8F6F\u4EF6\u529F\u80FD\u4E0E\u7528\u6237\u8FDB\u884C\u5206\u4EAB\u4EA4\u6D41\uFF0C\u5305\u62EC\u8BFE\u7A0B\u5B66\u4E60\u3001\u53D1\u5E16\u6559\u5B66\u3001\u6B4C\u66F2\u6F14\u5531\u4EE5\u53CA\u5206\u4EAB\u5176\u4ED6\u4E00\u5207\u7528\u6237\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u6709\u6743\u4F7F\u7528\u7B2C2\u6559\u5BA4\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4E3B\u9875\u3001\u7167\u7247\u4E0A\u4F20\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u7528\u6237\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u65F6\u987B\u9075\u5B88\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u4E0D\u5F97\u4ECE\u4E8B\u4EE5\u4E0B\u884C\u4E3A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.2 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.3 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.4 \u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.5 \u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5E73\u53F0\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u5FC5\u987B\u6E05\u695A\u4F7F\u7528\u89C4\u5219\uFF0C\u7B2C2\u6559\u5BA4\u4EC5\u4F9B\u4E2A\u4EBA\u4EA4\u6D41\u3001\u5B66\u4E60\u6B23\u8D4F\uFF0C\u975E\u5546\u4E1A\u6027\u8D28\u7684\u4F7F\u7528\uFF0C\u7528\u6237\u4E0D\u53EF\u5229\u7528\u672C\u670D\u52A1\u5BF9\u4FE1\u606F\u6216\u8868\u6F14\u7B49\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u8FDB\u884C\u51FA\u552E\u3001\u6216\u5229\u7528\u672C\u670D\u52A1\u8FDB\u884C\u8C03\u67E5\u3001\u5E7F\u544A\u3001\u6216\u7528\u4E8E\u5176\u4ED6\u5546\u4E1A\u76EE\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001 \u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u65F6\u53D1\u5E03\u3001\u4F20\u64AD\u7684\u4FE1\u606F\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\uFF0C\u4FDD\u8BC1\u4E0D\u5F97\u53D1\u5E03\u8C23\u8A00\u6216\u5176\u4ED6\u4E0E\u4E8B\u5B9E\u4E0D\u7B26\u5F15\u8D77\u4ED6\u4EBA\u4E0D\u9002\u7684\u8A00\u8BBA\u3001\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\u3001\u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4E0D\u5F97\u53D1\u5E03\u3001\u4F20\u64AD\u4FB5\u72AF\u77E5\u8BC6\u4EA7\u6743\u6216\u5176\u4ED6\u5408\u6CD5\u6743\u76CA\u7684\u4FE1\u606F\u3002\u7528\u6237\u4F20\u64AD\u5185\u5BB9\u4E2D\u6D89\u53CA\u7B2C\u4E09\u65B9\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u7684\u76F8\u5173\u6388\u6743\u6216\u5176\u4ED6\u5185\u5BB9\u7684\u5408\u6CD5\u6027\u7531\u7528\u6237\u81EA\u884C\u8D1F\u8D23\uFF0C\u7B2C2\u6559\u5BA4\u5BF9\u76F8\u5173\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5C5E\u6216\u662F\u5426\u4FB5\u72AF\u4ED6\u4EBA\u6C11\u4E8B\u6743\u76CA\u7B49\u60C5\u51B5\u4E0D\u8FDB\u884C\u5BA1\u67E5\u6216\u76D1\u7763\uFF0C\u4F46\u5C06\u6309\u76F8\u5173\u6CD5\u89C4\u5BF9\u6D89\u5ACC\u4FB5\u6743\u7684\u5185\u5BB9\u5C65\u884C\u5220\u9664\u6216\u65AD\u5F00\u94FE\u63A5\u7B49\u804C\u8D23\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'7\u3001\u82E5\u7528\u6237\u53D1\u751F\u524D\u8FF03-6\u7684\u884C\u4E3A\u65F6\uFF0C\u7531\u7528\u6237\u627F\u62C5\u6240\u6709\u7684\u8FDD\u6CD5\u3001\u4FB5\u6743\u8D23\u4EFB\uFF0C\u82E5\u56E0\u6B64\u7ED9\u7B2C2\u6559\u5BA4\u9020\u6210\u4EFB\u4F55\u635F\u5931\uFF0C\u7B2C2\u6559\u5BA4\u6709\u6743\u5411\u8D23\u4EFB\u7528\u6237\u4E3B\u5F20\u76F8\u5173\u8D23\u4EFB\u3002\u540C\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u6709\u6743\u5BF9\u8FDD\u6CD5\u3001\u4FB5\u6743\u3001\u8FDD\u89C4\u7684\u7528\u6237\u7EC8\u6B62\u63D0\u4F9B\u670D\u52A1\u3002\u5982\u679C\u653F\u5E9C\u6216\u8005\u53F8\u6CD5\u673A\u5173\u8981\u6C42\u7B2C2\u6559\u5BA4\u544A\u77E5\u8FDB\u884C\u4FB5\u6743\u884C\u4E3A\u7528\u6237\u7684\u5177\u4F53\u4FE1\u606F\u7684\uFF0C\u7B2C2\u6559\u5BA4\u6709\u6743\u6839\u636E\u73B0\u884C\u6CD5\u89C4\u5411\u5176\u544A\u77E5\u7528\u6237\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'8\u3001\u7528\u6237\u540C\u610F\u7B2C2\u6559\u5BA4\u6709\u6743\u5728\u63D0\u4F9B\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u7B2C2\u6559\u5BA4\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u56DB\u3001\u77E5\u8BC6\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u5206\u4EAB\u4E2A\u4EBA\u4F5C\u54C1\u65F6\uFF0C\u4E0D\u5F97\u4FB5\u72AF\u7B2C\u4E09\u65B9\u4EFB\u4F55\u77E5\u8BC6\u4EA7\u6743\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u4F7F\u7528\u7B2C2\u6559\u5BA4\u5206\u4EAB\u4FE1\u606F\u4E2D\u542B\u6709\u7684\u5B8C\u5168\u7531\u7528\u6237\u81EA\u8EAB\u539F\u521B\u4FE1\u606F\u7684\u7248\u6743\u5F52\u7528\u6237\uFF0C\u4F46\u5176\u4E2D\u5229\u7528\u7B2C2\u6559\u5BA4\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\uFF0C\u5229\u7528\u7B2C2\u6559\u5BA4\u4E2D\u5DF2\u6709\u7D20\u6750\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\u7684\u7248\u6743\u7531\u7528\u6237\u4E0E\u7B2C2\u6559\u5BA4\u5171\u6709\u3002\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u662F\u5BF9\u5176\u4EAB\u6709\u7248\u6743\u6216\u7ECF\u5408\u6CD5\u6388\u6743\u7684\u76F8\u5173\u5185\u5BB9\u7684\u7F51\u7EDC\u4F20\u64AD\u884C\u4E3A\u8BB8\u53EF\uFF0C\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u5373\u8868\u660E\u5176\u5DF2\u6388\u6743\u7B2C2\u6559\u5BA4\u53CA\u5176\u4ED6\u7528\u6237\u6709\u6743\u590D\u5236\u3001\u4F20\u64AD\u524D\u8FF0\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u4E94\u3001\u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u9274\u4E8E\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u7B2C2\u6559\u5BA4\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u670D\u52A1\u53CA\u514D\u8D39\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u670D\u52A1\uFF0C\u7B2C2\u6559\u5BA4\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7B2C2\u6559\u5BA4\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u7B2C2\u6559\u5BA4\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u7B2C2\u6559\u5BA4\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7B2C2\u6559\u5BA4\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u670D\u52A1\u7684\u5E73\u53F0\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u7B2C2\u6559\u5BA4\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u7B2C2\u6559\u5BA4\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED90\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u5728\u63D0\u793A\u7528\u6237\u9700\u572810\u65E5\u5185\u6295\u5165\u5B9E\u9645\u4F7F\u7528\u540E\uFF0C\u82E5\u7528\u6237\u4E8E\u8BE510\u65E5\u5185\u4ECD\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u7B2C2\u6559\u5BA4\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u5E10\u53F7\u6635\u79F0\u5982\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u56FD\u5BB6\u653F\u7B56\u8981\u6C42\u3001\u7B2C2\u6559\u5BA4\u7684\u6635\u79F0\u7BA1\u7406\u8981\u6C42\uFF0C\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\uFF0C\u7B2C2\u6559\u5BA4\u6709\u6743\u8981\u6C42\u7528\u6237\u8FDB\u884C\u4FEE\u6539\u6216\u6536\u56DE\u8BE5\u8D26\u53F7\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u516D\u3001\u5176\u4ED6\u4E8B\u5B9C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7B2C2\u6559\u5BA4\u6709\u6743\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u53D8\u5316\u3001\u7F51\u7AD9\u4EE5\u53CA\u76F8\u5E94\u7684\u7B2C2\u6559\u5BA4\u8FD0\u8425\u7684\u9700\u8981\u4E0D\u65F6\u5730\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u5185\u5BB9\u8FDB\u884C\u4FEE\u6539\uFF0C\u5E76\u5728\u7F51\u7AD9\u4EE5\u53CA\u7B2C2\u6559\u5BA4\u9192\u76EE\u4F4D\u7F6E\u5F20\u8D34\u3002\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\uFF0C\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\uFF0C\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u534F\u8BAE\u3002\u7528\u6237\u6709\u4E49\u52A1\u53CA\u65F6\u5173\u6CE8\u5E76\u9605\u8BFB\u6700\u65B0\u7248\u7684\u534F\u8BAE\u53CA\u7F51\u7AD9\u516C\u544A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\uFF0C\u53EF\u4EE5\u7ACB\u5373\u5411\u7B2C2\u6559\u5BA4\u8FDB\u884C\u53CD\u9988\u4E14\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u7B2C2\u6559\u5BA4\u4F9D\u636E\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u670D\u52A1\uFF1B\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u7684\uFF0C\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u672C\u534F\u8BAE\u81EA\u7528\u6237\u70B9\u51FB\u201C\u540C\u610F\u201D\u3001\u201C\u63A5\u53D7\u201D\u540E\u751F\u6548\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE,\u4E0D\u5177\u6CD5\u5F8B\u6216\u5951\u7EA6\u6548\u679C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u672C\u534F\u8BAE\u7684\u89E3\u91CA\u6743\u5F52\u7B2C2\u6559\u5BA4\u6240\u6709\u3002')));}}]);return RulesPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RulesPage);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privacy2Page=function(_Component){_inherits(Privacy2Page,_Component);function Privacy2Page(props){_classCallCheck(this,Privacy2Page);var _this=_possibleConstructorReturn(this,(Privacy2Page.__proto__||Object.getPrototypeOf(Privacy2Page)).call(this,props));_this.state={};return _this;}_createClass(Privacy2Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'第2教室隐私政策'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7B2C2\u6559\u5BA4\u9690\u79C1\u653F\u7B56\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u5E73\u53F0\uFF0C\u7B2C2\u6559\u5BA4\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7B2C2\u6559\u5BA4\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u7B2C2\u6559\u5BA4\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7B2C2\u6559\u5BA4\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u54C8\u4F5B\u767E\u79D1\u3001\u79D1\u5B66\u5B9E\u9A8C\u8BFE\u3001\u81EA\u7136\u62FC\u8BFB\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u7B2C2\u6559\u5BA4\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u7B2C2\u6559\u5BA4\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u7B2C2\u6559\u5BA4\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u7B2C2\u6559\u5BA4\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09\uFF0C'),'\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u60A8\u8D2D\u4E70\u7B2C2\u6559\u5BA4\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u7B2C2\u6559\u5BA4\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u7B2C2\u6559\u5BA4\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u4EA4\u6613\u65F6\u95F4\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u7B49\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u7B2C2\u6559\u5BA4\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u3001\u4E0E\u7B2C2\u6559\u5BA4\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7B2C2\u6559\u5BA4\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u7B2C2\u6559\u5BA4\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF0C\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u3001\u9488\u5BF9\u60A8\u4F7F\u7528\u8BBE\u5907\u7684\u4F18\u5316\u9002\u914D\u3001\u5F53\u7F51\u7EDC\u8D28\u91CF\u5B58\u5728\u95EE\u9898\u65F6\u7684\u7CBE\u51C6\u63D0\u793A\u7B49\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u7B2C2\u6559\u5BA4\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u7B2C2\u6559\u5BA4\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u7B2C2\u6559\u5BA4\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7B2C2\u6559\u5BA4\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u5728\u7EBF\u4EA4\u6D41\uFF0C\u89C6\u9891\u4E92\u52A8\uFF0C\u4EE5\u53CA\u66F4\u6362\u60A8\u5728APP\u5185\u7684\u4E2A\u4EBA\u5934\u50CF\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u7B2C2\u6559\u5BA4\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7B2C2\u6559\u5BA4\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u4EA4\u6D41\uFF0C\u5728\u8BFE\u5802\u4E2D\u7684\u8BED\u97F3\u6D4B\u8BC4\u73AF\u8282\u6D4B\u8BC4\u60A8\u7684\u53D1\u97F3\u662F\u5426\u6807\u51C6\u5E76\u4E14\u7ED9\u5230\u53CD\u9988\uFF0C\u4EE5\u53CA\u5728\u8BFE\u540E\u4F5C\u4E1A\u73AF\u8282\u901A\u8FC7\u8BED\u97F3\u6D4B\u8BC4\u7ED9\u5230\u5F97\u5206\u53CD\u9988\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u4E3A\u4E86\u60A8\u53EF\u4EE5\u83B7\u5F97\u66F4\u5B8C\u5584\u7684\u8BFE\u7A0B\u4F53\u9A8C\uFF0C\u6211\u4EEC\u4F1A\u54A8\u8BE2\u60A8\u662F\u5426\u8981\u5F00\u542F\u5199\u5165\u5916\u90E8\u5B58\u50A8\u5668\u7684\u6743\u9650\uFF0C\u8BE5\u6743\u9650\u7528\u4E8E\u60A8\u5728\u6211\u4EEC\u8BFE\u5802\u4E2D\u5B8C\u6210\u8BFE\u7A0B\u5B66\u4E60\u540E\uFF0C\u6211\u4EEC\u4F1A\u7ED9\u5230\u60A8\u4E0A\u8BFE\u7684\u7ED3\u679C\u62A5\u544A\uFF0C\u4E14\u53EF\u4EE5\u4FDD\u5B58\u5230\u60A8\u7684\u8BBE\u5907\u672C\u5730\uFF0C\u6B64\u7C7B\u4FDD\u5B58\u56FE\u7247\u3001\u4E8C\u7EF4\u7801\u64CD\u4F5C\u9700\u8981\u5F00\u901A\u8BE5\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u80FD\u7ED9\u60A8\u63D0\u4F9B\u66F4\u5B8C\u6574\u7684\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u4E00\u4E9B\u7B2C\u4E09\u65B9SDK\uFF0C\u5176\u4E2D\u53CB\u76DF\u548C\u4E2A\u63A8SDK\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\u4F1A\u9700\u8981\u60A8\u5F00\u542F\u8BBF\u95EE\u60A8\u7684\u7CBE\u51C6\u5B9A\u4F4D\u548C\u8BBF\u95EE\u7C97\u7565\u4F4D\u7F6E\u7684\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u662F\u5426\u5F00\u542F\u5F00\u542F\u8BE5\u6743\u9650\u4EE5\u8BA9\u6211\u4EEC\u6709\u66F4\u591A\u7684\u53C2\u8003\u6765\u4E3A\u60A8\u540E\u671F\u63D0\u4F9B\u66F4\u7CBE\u51C6\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u7B2C2\u6559\u5BA4\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C2\u6559\u5BA4\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u7B2C2\u6559\u5BA4\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.8 \u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u7B2C2\u6559\u5BA4\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F\uFF0C'),'\u4F46\u7B2C2\u6559\u5BA4\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.9 \u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u7B2C2\u6559\u5BA4\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u7B2C2\u6559\u5BA4\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u7B2C2\u6559\u5BA4\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u82F9\u679C\u652F\u4ED8\u83B7\u5F97\u60A8\u7684\u82F9\u679C\u652F\u4ED8\u8D26\u6237\u4FE1\u606F\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u7B2C2\u6559\u5BA4\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u7B2C2\u6559\u5BA4\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u7B2C2\u6559\u5BA4\u6216\u8005\u7B2C2\u6559\u5BA4\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u7B2C2\u6559\u5BA4\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u7B2C2\u6559\u5BA4\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3 \u6B64\u5916\u6211\u4EEC\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u66F4\u4E13\u4E1A\u3001\u5B89\u5168\u7684\u57FA\u7840\u4E1A\u52A1\u529F\u80FD\u548C\u9644\u52A0\u4E1A\u52A1\u529F\u80FD\uFF0C\u51FA\u4E8E\u6280\u672F\u9700\u8981\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u4EE5\u4E0B\u7B2C\u4E09\u65B9\u8F6F\u4EF6\u5F00\u53D1\u5DE5\u5177\u5305\uFF08SDK\uFF09\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u7684\u7B2C\u4E09\u65B9SDK\u53CA\u7B2C\u4E09\u65B9\u6240\u6536\u96C6\u6216\u4E0E\u4E4B\u5171\u4EAB\u7684\u4FE1\u606F\u5982\u4E0B\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.1 \u817E\u8BAFBuglySDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u63D0\u9AD8\u670D\u52A1\u7A33\u5B9A\u6027\uFF0C\u4FBF\u4E8E\u76F8\u5173\u670D\u52A1\u5D29\u6E83\u540E\u5FEB\u901F\u51C6\u786E\u5B9A\u4F4D\u5B58\u5728\u95EE\u9898\uFF0C\u817E\u8BAFBugly\u5C06\u5728\u60A8\u4F7F\u7528\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\u6536\u96C6\u5E76\u5171\u4EAB\u60A8\u7684\u8BBE\u5907\u4FE1\u606F\uFF0C\u5305\u62EC\u8BBE\u5907ID\u3001\u7CFB\u7EDF\u7248\u672C\u3001\u8BBE\u5907\u578B\u53F7\u7B49\u8BBE\u5907\u57FA\u7840\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.2 \u5FAE\u4FE1\u5206\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u4F7F\u60A8\u7684\u5B66\u4E60\u6210\u679C\u53EF\u4EE5\u5728\u5FAE\u4FE1\u5E73\u53F0\u4E0A\u8FDB\u884C\u5206\u4EAB\uFF0C\u5FAE\u4FE1\u5206\u4EABSDK\u5C06\u6536\u96C6\u60A8\u7684\u8BBE\u5907\u54C1\u724C\u3001\u578B\u53F7\u3001IMEI\u3001\u624B\u673A\u53F7\u3001\u7F51\u7EDC\u8FDE\u63A5\u3001IP\u3001MAC\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.3 \u521B\u84DD\u95EA\u9A8CSDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u60A8\u63D0\u4F9B\u65B9\u4FBF\u7684\u4E00\u952E\u767B\u5F55\u7B49\u670D\u52A1\uFF0C\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u521B\u84DDSDK\uFF0C\u521B\u84DDSDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u3001\u624B\u673A\u673A\u578B\u3001\u7CFB\u7EDF\u7248\u672C\u3001IP\u5730\u5740\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.4 \u53CB\u76DF+SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u53CB\u76DF+SDK\uFF0C\u53CB\u76DF+SDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID/IDFA/OPENUDID/GUID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.5 \u667A\u9F7F\u5BA2\u670DSDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5E2E\u52A9\u7528\u6237\u5728\u5E94\u7528\u5185\u4F7F\u7528\u652F\u6301\u5BA2\u670D\u7CFB\u7EDF\uFF0C\u6211\u4EEC\u4F7F\u7528\u4E86\u652F\u6301\u5BA2\u670DSDK\uFF0C\u667A\u9F7F\u5BA2\u670DSDK\u9700\u8981\u624B\u673A\u60A8\u7684\u8BBE\u5907\u578B\u53F7\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\uFF0Cip\u5730\u5740\uFF0Cmac\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.6 \u4E2A\u63A8SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u901A\u8FC7APP\u7ED9\u7528\u6237\u53D1\u9001\u6D88\u606F\u63A8\u9001\uFF0C\u6211\u4EEC\u4F7F\u7528\u4E86\u4E2A\u63A8SDK\uFF0C\u4E2A\u63A8SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u5E73\u53F0\u3001\u8BBE\u5907\u5382\u5546\u3001\u8BBE\u5907\u54C1\u724C\u3001\u8BBE\u5907\u8BC6\u522B\u7801\u7B49\u8BBE\u5907\u4FE1\u606F\uFF0C\u5E94\u7528\u5217\u8868\u4FE1\u606F\u3001\u7F51\u7EDC\u4FE1\u606F\u4EE5\u53CA\u4F4D\u7F6E\u76F8\u5173\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.7 \u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5E2E\u52A9\u7528\u6237\u67E5\u8BE2\u64CD\u4F5C\u95EE\u9898\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09\uFF0C\u8BE5SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u578B\u53F7\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\uFF0Cip\u5730\u5740\uFF0Cmac\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.8 \u58F0\u7F51Agora SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u5B9E\u73B0\u8BED\u97F3\u3001\u89C6\u9891\u4E92\u52A8\u76F4\u64AD\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86Agora SDK\uFF0CAgora SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u5199\u5165\u5916\u7F6E\u5B58\u50A8\u5668\u6743\u9650\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u9EA6\u514B\u98CE\uFF0C\u76F8\u673A\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.9 \u58F0\u901ASDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u3001\u4F5C\u4E1A\u4E2D\u7B49\u573A\u666F\u4F7F\u7528\u8BED\u97F3\u6D4B\u8BC4\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u58F0\u901ASDK\uFF0C\u58F0\u901ASDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u9EA6\u514B\u98CE\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u7248\u672C\u4FE1\u606F\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4EE5\u4E0A\u7B2C\u4E09\u65B9SDK\u4F1A\u6839\u636E\u4EA7\u54C1\u529F\u80FD\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6211\u4EEC\u4EC5\u4F1A\u5728\u60A8\u6388\u6743\u540C\u610F\u5F00\u901A\u76F8\u5173\u529F\u80FD\u6216\u60A8\u5728\u4E3B\u52A8\u4F7F\u7528\u76F8\u5173\u529F\u80FD\u6211\u4EEC\u7ED9\u4E88\u5145\u5206\u63D0\u793A\u65F6\uFF0C\u624D\u4F1A\u5C06\u60A8\u7684\u5BF9\u5E94\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u7ED9\u4E0A\u8FF0\u7B2C\u4E09\u65B9\u63D2\u4EF6\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u7B2C2\u6559\u5BA4\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u7B2C2\u6559\u5BA4\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u7B2C2\u6559\u5BA4\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u7B2C2\u6559\u5BA4\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u7B2C2\u6559\u5BA4\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u7B2C2\u6559\u5BA4\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u7B2C2\u6559\u5BA4\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u7B2C2\u6559\u5BA4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u7B2C2\u6559\u5BA4\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u7B2C2\u6559\u5BA4\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u7B2C2\u6559\u5BA4\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u7B2C2\u6559\u5BA4\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u7B2C2\u6559\u5BA4\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u7B2C2\u6559\u5BA4\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u7B2C2\u6559\u5BA4\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u7B2C2\u6559\u5BA4\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u7B2C2\u6559\u5BA4\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u7B2C2\u6559\u5BA4\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u7B2C2\u6559\u5BA4\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u7B2C2\u6559\u5BA4\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u7B2C2\u6559\u5BA4\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u7B2C2\u6559\u5BA4\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u7B2C2\u6559\u5BA4\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u7B2C2\u6559\u5BA4\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u7B2C2\u6559\u5BA4\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5728\u4E0D\u5E78\u53D1\u751F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u540E\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\u3010\u5E76\u6700\u8FDF\u4E0D\u8FDF\u4E8E30\u4E2A\u81EA\u7136\u65E5\u5185\u3011\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u6216\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u3001\u5BF9\u60A8\u7684\u8865\u6551\u63AA\u65BD\u7B49\u3002\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u6211\u4EEC\u5C06\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u65B9\u5F0F\u544A\u77E5\u60A8\uFF0C\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E0A\u62A5\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u7B2C2\u6559\u5BA4\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u7B2C2\u6559\u5BA4\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u7B2C2\u6559\u5BA4\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u7B2C2\u6559\u5BA4\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u7B2C2\u6559\u5BA4\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uF0B7\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u7B2C2\u6559\u5BA4\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u7B2C2\u6559\u5BA4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u7B2C2\u6559\u5BA4\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u7B2C2\u6559\u5BA4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u7B2C2\u6559\u5BA4\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u7B2C2\u6559\u5BA4\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u7B2C2\u6559\u5BA4\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u7B2C2\u6559\u5BA4\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u7B2C2\u6559\u5BA4\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u7B2C2\u6559\u5BA4\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u7B2C2\u6559\u5BA4\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u7B2C2\u6559\u5BA4\u505A\u51FA\u89E3\u91CA\uFF0C\u7B2C2\u6559\u5BA4\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u7B2C2\u6559\u5BA4\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u7B2C2\u6559\u5BA4\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u7B2C2\u6559\u5BA4\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u7B2C2\u6559\u5BA4\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u7B2C2\u6559\u5BA4\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u7B2C2\u6559\u5BA4\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u7B2C2\u6559\u5BA4\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u7B2C2\u6559\u5BA4\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u7B2C2\u6559\u5BA4\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u7B2C2\u6559\u5BA4\u4F1A\u5728\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u7B2C2\u6559\u5BA4\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u7B2C2\u6559\u5BA4\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A0571-88321763')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u7B2C2\u6559\u5BA4\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u7B2C2\u6559\u5BA4\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return Privacy2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Privacy2Page);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_anniversary_01_jpg__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_anniversary_01_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_anniversary_01_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_anniversary_02_jpg__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_anniversary_02_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_images_anniversary_02_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_anniversary_03_jpg__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_anniversary_03_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_anniversary_03_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_anniversary_04_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_images_anniversary_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_images_anniversary_04_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var anniversaryPage=function(_Component){_inherits(anniversaryPage,_Component);function anniversaryPage(){_classCallCheck(this,anniversaryPage);return _possibleConstructorReturn(this,(anniversaryPage.__proto__||Object.getPrototypeOf(anniversaryPage)).apply(this,arguments));}_createClass(anniversaryPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'周年庆'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container anniversary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__static_images_anniversary_01_jpg___default.a,alt:'\u7231\u8BFE\u5468\u5E74\u5E86'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__static_images_anniversary_02_jpg___default.a,alt:'\u7231\u8BFE\u5468\u5E74\u5E86'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__static_images_anniversary_03_jpg___default.a,alt:'\u7231\u8BFE\u5468\u5E74\u5E86'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__static_images_anniversary_04_png___default.a,alt:'\u7231\u8BFE\u5468\u5E74\u5E86'})));}}]);return anniversaryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (anniversaryPage);

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01.ce83c7e4.jpg";

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02.9111f51a.jpg";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/03.b2a4338f.jpg";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/04.86b25b5f.png";

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privacy2Page=function(_Component){_inherits(Privacy2Page,_Component);function Privacy2Page(props){_classCallCheck(this,Privacy2Page);var _this=_possibleConstructorReturn(this,(Privacy2Page.__proto__||Object.getPrototypeOf(Privacy2Page)).call(this,props));_this.state={};return _this;}_createClass(Privacy2Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课隐私政策'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u9690\u79C1\u653F\u7B56\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528AirCourse\u7231\u8BFE\u5E73\u53F0\uFF0CAirCourse\u7231\u8BFE\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u7231\u8BFE\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7231\u8BFE\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u54C8\u4F5B\u767E\u79D1\u3001\u79D1\u5B66\u5B9E\u9A8C\u8BFE\u3001\u81EA\u7136\u62FC\u8BFB\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u7231\u8BFE\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u7231\u8BFE\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u7231\u8BFE\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u7231\u8BFE\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09\uFF0C'),'\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u60A8\u8D2D\u4E70\u7231\u8BFE\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u7231\u8BFE\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u4EA4\u6613\u65F6\u95F4\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u7B49\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u7231\u8BFE\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u3001\u4E0E\u7231\u8BFE\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7231\u8BFE\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u7231\u8BFE\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u7231\u8BFE\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF0C\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u3001\u9488\u5BF9\u60A8\u4F7F\u7528\u8BBE\u5907\u7684\u4F18\u5316\u9002\u914D\u3001\u5F53\u7F51\u7EDC\u8D28\u91CF\u5B58\u5728\u95EE\u9898\u65F6\u7684\u7CBE\u51C6\u63D0\u793A\u7B49\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u7231\u8BFE\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u7231\u8BFE\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u5728\u7EBF\u4EA4\u6D41\uFF0C\u89C6\u9891\u4E92\u52A8\uFF0C\u4EE5\u53CA\u66F4\u6362\u60A8\u5728APP\u5185\u7684\u4E2A\u4EBA\u5934\u50CF\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u7231\u8BFE\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u4EA4\u6D41\uFF0C\u5728\u8BFE\u5802\u4E2D\u7684\u8BED\u97F3\u6D4B\u8BC4\u73AF\u8282\u6D4B\u8BC4\u60A8\u7684\u53D1\u97F3\u662F\u5426\u6807\u51C6\u5E76\u4E14\u7ED9\u5230\u53CD\u9988\uFF0C\u4EE5\u53CA\u5728\u8BFE\u540E\u4F5C\u4E1A\u73AF\u8282\u901A\u8FC7\u8BED\u97F3\u6D4B\u8BC4\u7ED9\u5230\u5F97\u5206\u53CD\u9988\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u4E3A\u4E86\u60A8\u53EF\u4EE5\u83B7\u5F97\u66F4\u5B8C\u5584\u7684\u8BFE\u7A0B\u4F53\u9A8C\uFF0C\u6211\u4EEC\u4F1A\u54A8\u8BE2\u60A8\u662F\u5426\u8981\u5F00\u542F\u5199\u5165\u5916\u90E8\u5B58\u50A8\u5668\u7684\u6743\u9650\uFF0C\u8BE5\u6743\u9650\u7528\u4E8E\u60A8\u5728\u6211\u4EEC\u8BFE\u5802\u4E2D\u5B8C\u6210\u8BFE\u7A0B\u5B66\u4E60\u540E\uFF0C\u6211\u4EEC\u4F1A\u7ED9\u5230\u60A8\u4E0A\u8BFE\u7684\u7ED3\u679C\u62A5\u544A\uFF0C\u4E14\u53EF\u4EE5\u4FDD\u5B58\u5230\u60A8\u7684\u8BBE\u5907\u672C\u5730\uFF0C\u6B64\u7C7B\u4FDD\u5B58\u56FE\u7247\u3001\u4E8C\u7EF4\u7801\u64CD\u4F5C\u9700\u8981\u5F00\u901A\u8BE5\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u80FD\u7ED9\u60A8\u63D0\u4F9B\u66F4\u5B8C\u6574\u7684\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u4E00\u4E9B\u7B2C\u4E09\u65B9SDK\uFF0C\u5176\u4E2D\u53CB\u76DF\u548C\u4E2A\u63A8SDK\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\u4F1A\u9700\u8981\u60A8\u5F00\u542F\u8BBF\u95EE\u60A8\u7684\u7CBE\u51C6\u5B9A\u4F4D\u548C\u8BBF\u95EE\u7C97\u7565\u4F4D\u7F6E\u7684\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u662F\u5426\u5F00\u542F\u5F00\u542F\u8BE5\u6743\u9650\u4EE5\u8BA9\u6211\u4EEC\u6709\u66F4\u591A\u7684\u53C2\u8003\u6765\u4E3A\u60A8\u540E\u671F\u63D0\u4F9B\u66F4\u7CBE\u51C6\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u7231\u8BFE\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.8 \u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u7231\u8BFE\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u7231\u8BFE\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F\uFF0C'),'\u4F46\u7231\u8BFE\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.9 \u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u7231\u8BFE\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u7231\u8BFE\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u7231\u8BFE\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u7231\u8BFE\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u82F9\u679C\u652F\u4ED8\u83B7\u5F97\u60A8\u7684\u82F9\u679C\u652F\u4ED8\u8D26\u6237\u4FE1\u606F\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u7231\u8BFE\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u7231\u8BFE\u6216\u8005\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u7231\u8BFE\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u7231\u8BFE\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3 \u6B64\u5916\u6211\u4EEC\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u66F4\u4E13\u4E1A\u3001\u5B89\u5168\u7684\u57FA\u7840\u4E1A\u52A1\u529F\u80FD\u548C\u9644\u52A0\u4E1A\u52A1\u529F\u80FD\uFF0C\u51FA\u4E8E\u6280\u672F\u9700\u8981\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u4EE5\u4E0B\u7B2C\u4E09\u65B9\u8F6F\u4EF6\u5F00\u53D1\u5DE5\u5177\u5305\uFF08SDK\uFF09\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u7684\u7B2C\u4E09\u65B9SDK\u53CA\u7B2C\u4E09\u65B9\u6240\u6536\u96C6\u6216\u4E0E\u4E4B\u5171\u4EAB\u7684\u4FE1\u606F\u5982\u4E0B\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.1 \u817E\u8BAFBuglySDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u63D0\u9AD8\u670D\u52A1\u7A33\u5B9A\u6027\uFF0C\u4FBF\u4E8E\u76F8\u5173\u670D\u52A1\u5D29\u6E83\u540E\u5FEB\u901F\u51C6\u786E\u5B9A\u4F4D\u5B58\u5728\u95EE\u9898\uFF0C\u817E\u8BAFBugly\u5C06\u5728\u60A8\u4F7F\u7528\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\u6536\u96C6\u5E76\u5171\u4EAB\u60A8\u7684\u8BBE\u5907\u4FE1\u606F\uFF0C\u5305\u62EC\u8BBE\u5907ID\u3001\u7CFB\u7EDF\u7248\u672C\u3001\u8BBE\u5907\u578B\u53F7\u7B49\u8BBE\u5907\u57FA\u7840\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.2 \u5FAE\u4FE1\u5206\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u4F7F\u60A8\u7684\u5B66\u4E60\u6210\u679C\u53EF\u4EE5\u5728\u5FAE\u4FE1\u5E73\u53F0\u4E0A\u8FDB\u884C\u5206\u4EAB\uFF0C\u5FAE\u4FE1\u5206\u4EABSDK\u5C06\u6536\u96C6\u60A8\u7684\u8BBE\u5907\u54C1\u724C\u3001\u578B\u53F7\u3001IMEI\u3001\u624B\u673A\u53F7\u3001\u7F51\u7EDC\u8FDE\u63A5\u3001IP\u3001MAC\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.3 \u521B\u84DD\u95EA\u9A8CSDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u60A8\u63D0\u4F9B\u65B9\u4FBF\u7684\u4E00\u952E\u767B\u5F55\u7B49\u670D\u52A1\uFF0C\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u521B\u84DDSDK\uFF0C\u521B\u84DDSDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u3001\u624B\u673A\u673A\u578B\u3001\u7CFB\u7EDF\u7248\u672C\u3001IP\u5730\u5740\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.4 \u53CB\u76DF+SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u53CB\u76DF+SDK\uFF0C\u53CB\u76DF+SDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID/IDFA/OPENUDID/GUID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.5 \u667A\u9F7F\u5BA2\u670DSDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5E2E\u52A9\u7528\u6237\u5728\u5E94\u7528\u5185\u4F7F\u7528\u652F\u6301\u5BA2\u670D\u7CFB\u7EDF\uFF0C\u6211\u4EEC\u4F7F\u7528\u4E86\u652F\u6301\u5BA2\u670DSDK\uFF0C\u667A\u9F7F\u5BA2\u670DSDK\u9700\u8981\u624B\u673A\u60A8\u7684\u8BBE\u5907\u578B\u53F7\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\uFF0Cip\u5730\u5740\uFF0Cmac\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.6 \u4E2A\u63A8SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u901A\u8FC7APP\u7ED9\u7528\u6237\u53D1\u9001\u6D88\u606F\u63A8\u9001\uFF0C\u6211\u4EEC\u4F7F\u7528\u4E86\u4E2A\u63A8SDK\uFF0C\u4E2A\u63A8SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u5E73\u53F0\u3001\u8BBE\u5907\u5382\u5546\u3001\u8BBE\u5907\u54C1\u724C\u3001\u8BBE\u5907\u8BC6\u522B\u7801\u7B49\u8BBE\u5907\u4FE1\u606F\uFF0C\u5E94\u7528\u5217\u8868\u4FE1\u606F\u3001\u7F51\u7EDC\u4FE1\u606F\u4EE5\u53CA\u4F4D\u7F6E\u76F8\u5173\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.7 \u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5E2E\u52A9\u7528\u6237\u67E5\u8BE2\u64CD\u4F5C\u95EE\u9898\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09\uFF0C\u8BE5SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u578B\u53F7\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\uFF0Cip\u5730\u5740\uFF0Cmac\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.8 \u58F0\u7F51Agora SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u5B9E\u73B0\u8BED\u97F3\u3001\u89C6\u9891\u4E92\u52A8\u76F4\u64AD\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86Agora SDK\uFF0CAgora SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u5199\u5165\u5916\u7F6E\u5B58\u50A8\u5668\u6743\u9650\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u9EA6\u514B\u98CE\uFF0C\u76F8\u673A\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.9 \u58F0\u901ASDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u3001\u4F5C\u4E1A\u4E2D\u7B49\u573A\u666F\u4F7F\u7528\u8BED\u97F3\u6D4B\u8BC4\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u58F0\u901ASDK\uFF0C\u58F0\u901ASDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u9EA6\u514B\u98CE\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u7248\u672C\u4FE1\u606F\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4EE5\u4E0A\u7B2C\u4E09\u65B9SDK\u4F1A\u6839\u636E\u4EA7\u54C1\u529F\u80FD\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6211\u4EEC\u4EC5\u4F1A\u5728\u60A8\u6388\u6743\u540C\u610F\u5F00\u901A\u76F8\u5173\u529F\u80FD\u6216\u60A8\u5728\u4E3B\u52A8\u4F7F\u7528\u76F8\u5173\u529F\u80FD\u6211\u4EEC\u7ED9\u4E88\u5145\u5206\u63D0\u793A\u65F6\uFF0C\u624D\u4F1A\u5C06\u60A8\u7684\u5BF9\u5E94\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u7ED9\u4E0A\u8FF0\u7B2C\u4E09\u65B9\u63D2\u4EF6\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u7231\u8BFE\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u7231\u8BFE\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u7231\u8BFE\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u7231\u8BFE\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u7231\u8BFE\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u7231\u8BFE\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u7231\u8BFE\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u7231\u8BFE\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u7231\u8BFE\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u7231\u8BFE\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u7231\u8BFE\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u7231\u8BFE\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u7231\u8BFE\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u7231\u8BFE\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u7231\u8BFE\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u7231\u8BFE\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u7231\u8BFE\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u7231\u8BFE\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u7231\u8BFE\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u7231\u8BFE\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u7231\u8BFE\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u7231\u8BFE\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u7231\u8BFE\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u7231\u8BFE\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u7231\u8BFE\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u7231\u8BFE\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u7231\u8BFE\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u7231\u8BFE\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5728\u4E0D\u5E78\u53D1\u751F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u540E\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\u3010\u5E76\u6700\u8FDF\u4E0D\u8FDF\u4E8E30\u4E2A\u81EA\u7136\u65E5\u5185\u3011\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u6216\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u3001\u5BF9\u60A8\u7684\u8865\u6551\u63AA\u65BD\u7B49\u3002\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u6211\u4EEC\u5C06\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u65B9\u5F0F\u544A\u77E5\u60A8\uFF0C\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E0A\u62A5\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u7231\u8BFE\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u7231\u8BFE\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u7231\u8BFE\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u7231\u8BFE\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u7231\u8BFE\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uF0B7\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u7231\u8BFE\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u7231\u8BFE\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u7231\u8BFE\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u7231\u8BFE\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u7231\u8BFE\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u7231\u8BFE\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u7231\u8BFE\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u7231\u8BFE\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u7231\u8BFE\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u7231\u8BFE\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u7231\u8BFE\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u7231\u8BFE\u505A\u51FA\u89E3\u91CA\uFF0C\u7231\u8BFE\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u7231\u8BFE\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u7231\u8BFE\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u7231\u8BFE\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u7231\u8BFE\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u7231\u8BFE\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u7231\u8BFE\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u7231\u8BFE\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u7231\u8BFE\u4F1A\u5728\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u7231\u8BFE\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A\xA0400-887-4877\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5FAE\u4FE1\u516C\u4F17\u53F7\uFF1A\u7231\u8BFEAirCourse\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701 \u676D\u5DDE\u5E02 \u4F59\u676D\u533A \u4F59\u676D\u5858\u8DEF2301\u53F7\u6D77\u667A\u4E2D\u5FC38\u53F7\u697C\uFF08\u6536\u4EF6\u4EBA\uFF1A\u7231\u8BFE\u5BA2\u670D\u90E8\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u7231\u8BFE\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u7231\u8BFE\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return Privacy2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Privacy2Page);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privacy3Page=function(_Component){_inherits(Privacy3Page,_Component);function Privacy3Page(props){_classCallCheck(this,Privacy3Page);var _this=_possibleConstructorReturn(this,(Privacy3Page.__proto__||Object.getPrototypeOf(Privacy3Page)).call(this,props));_this.state={};return _this;}_createClass(Privacy3Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课优佳隐私政策'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u7231\u8BFE\u4F18\u4F73\u9690\u79C1\u653F\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u5E73\u53F0\uFF0C\u7231\u8BFE\u4F18\u4F73\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u4F18\u4F73\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u7231\u8BFE\u4F18\u4F73\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7231\u8BFE\u4F18\u4F73\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u54C8\u4F5B\u767E\u79D1\u3001\u79D1\u5B66\u5B9E\u9A8C\u8BFE\u3001\u81EA\u7136\u62FC\u8BFB\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u7231\u8BFE\u4F18\u4F73\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'title'},'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1 \u60A8\u5411\u7231\u8BFE\u4F18\u4F73\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.1 \u4E3A\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002 \u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u7231\u8BFE\u4F18\u4F73\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u7231\u8BFE\u4F18\u4F73\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.1.2 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09\uFF0C \u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247 \u7B49\u4FE1\u606F\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09 \uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.1.3 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.1.4 \u60A8\u8D2D\u4E70\u7231\u8BFE\u4F18\u4F73\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u4F18\u4F73\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5411\u7231\u8BFE\u4F18\u4F73\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002 \u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u4EA4\u6613\u65F6\u95F4\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u7B49\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u7231\u8BFE\u4F18\u4F73\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u3001\u4E0E\u7231\u8BFE\u4F18\u4F73\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9 \u7B49\u4E0E\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7231\u8BFE\u4F18\u4F73\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.2 \u7231\u8BFE\u4F18\u4F73\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF08\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u7B49\uFF09\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u7231\u8BFE\u4F18\u4F73\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1 \uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u7231\u8BFE\u4F18\u4F73\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8 \u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3\xA0\u7231\u8BFE\u4F18\u4F73\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.1 \u4E3A\u63D0\u5347\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.2\xA0\u82E5\u60A8\u5E0C\u671B\u5411\u7231\u8BFE\u4F18\u4F73\u4E0A\u4F20\u60A8\u7684\u5934\u50CF\u53CA/\u6216\u5176\u4ED6\u56FE\u7247\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u4F18\u4F73\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u7231\u8BFE\u4F18\u4F73\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u4F18\u4F73\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.4\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u7231\u8BFE\u4F18\u4F73\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.5\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u7231\u8BFE\u4F18\u4F73\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.6\xA0\u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u7231\u8BFE\u4F18\u4F73\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F\uFF0C\u4F46\u7231\u8BFE\u4F18\u4F73\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.3.7\xA0\u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A\u60A8\u5728\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u7231\u8BFE\u4F18\u4F73\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u7231\u8BFE\u4F18\u4F73\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u7231\u8BFE\u4F18\u4F73\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u82F9\u679C\u652F\u4ED8\u83B7\u5F97\u60A8\u7684\u82F9\u679C\u652F\u4ED8\u8D26\u6237\u4FE1\u606F\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u7231\u8BFE\u4F18\u4F73\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u7231\u8BFE\u4F18\u4F73\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u7231\u8BFE\u4F18\u4F73\u6216\u8005\u7231\u8BFE\u4F18\u4F73\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u7231\u8BFE\u4F18\u4F73\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u7231\u8BFE\u4F18\u4F73\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 \u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u7231\u8BFE\u4F18\u4F73\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.4 \u5F53\u7231\u8BFE\u4F18\u4F73\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u7231\u8BFE\u4F18\u4F73\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u7231\u8BFE\u4F18\u4F73\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u7231\u8BFE\u4F18\u4F73\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u7231\u8BFE\u4F18\u4F73\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u7231\u8BFE\u4F18\u4F73\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 \u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u7231\u8BFE\u4F18\u4F73\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F\u3002\u5982\u679C\u7231\u8BFE\u4F18\u4F73\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u7231\u8BFE\u4F18\u4F73\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u7231\u8BFE\u4F18\u4F73\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u7231\u8BFE\u4F18\u4F73\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u7231\u8BFE\u4F18\u4F73\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u7231\u8BFE\u4F18\u4F73\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u7231\u8BFE\u4F18\u4F73\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u7231\u8BFE\u4F18\u4F73\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u7231\u8BFE\u4F18\u4F73\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u7231\u8BFE\u4F18\u4F73\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u7231\u8BFE\u4F18\u4F73\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u7231\u8BFE\u4F18\u4F73\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u7231\u8BFE\u4F18\u4F73\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5982\u4E0D\u5E78\u53D1\u751F\u4FE1\u606F\u5B89\u5168\u4E8B\u6545\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\uFF0C\u53CA\u65F6\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u548C\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u7B49\u3002\u6211\u4EEC\u540C\u65F6\u5C06\u53CA\u65F6\u5C06\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u9002\u5408\u7684\u65B9\u5F0F\u544A\u77E5\u60A8\uFF1B\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E3B\u52A8\u4E0A\u62A5\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u7231\u8BFE\u4F18\u4F73\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u7231\u8BFE\u4F18\u4F73\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u7231\u8BFE\u4F18\u4F73\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u7231\u8BFE\u4F18\u4F73\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uF0B7\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u7231\u8BFE\u4F18\u4F73\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u7231\u8BFE\u4F18\u4F73\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u7231\u8BFE\u4F18\u4F73\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u7231\u8BFE\u4F18\u4F73\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u7231\u8BFE\u4F18\u4F73\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u7231\u8BFE\u4F18\u4F73\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u7231\u8BFE\u4F18\u4F73\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u7231\u8BFE\u4F18\u4F73\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u7231\u8BFE\u4F18\u4F73\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u7231\u8BFE\u4F18\u4F73\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u7231\u8BFE\u4F18\u4F73\u505A\u51FA\u89E3\u91CA\uFF0C\u7231\u8BFE\u4F18\u4F73\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u4F18\u4F73\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u7231\u8BFE\u4F18\u4F73\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u4F18\u4F73\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u7231\u8BFE\u4F18\u4F73\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u7231\u8BFE\u4F18\u4F73\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u7231\u8BFE\u4F18\u4F73\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u7231\u8BFE\u4F18\u4F73\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u7231\u8BFE\u4F18\u4F73\u4F1A\u5728\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u7231\u8BFE\u4F18\u4F73\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A\xA0400-887-4877\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5FAE\u4FE1\u516C\u4F17\u53F7\uFF1A\u7231\u8BFEAirCourse\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701 \u676D\u5DDE\u5E02 \u4F59\u676D\u533A \u4F59\u676D\u5858\u8DEF2301\u53F7\u6D77\u667A\u4E2D\u5FC38\u53F7\u697C\uFF08\u6536\u4EF6\u4EBA\uFF1A\u7231\u8BFE\u5BA2\u670D\u90E8\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u7231\u8BFE\u4F18\u4F73\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u7231\u8BFE\u4F18\u4F73\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return Privacy3Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Privacy3Page);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privacy4Page=function(_Component){_inherits(Privacy4Page,_Component);function Privacy4Page(props){_classCallCheck(this,Privacy4Page);var _this=_possibleConstructorReturn(this,(Privacy4Page.__proto__||Object.getPrototypeOf(Privacy4Page)).call(this,props));_this.state={};return _this;}_createClass(Privacy4Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'VR课程项目免责协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'VR\u8BFE\u7A0B\u9879\u76EE\u514D\u8D23\u534F\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u53C2\u4E0E\u8005\u5728\u6B64\u660E\u786E\u627F\u8BA4\u5C06\u81EA\u884C\u627F\u62C5\u53C2\u52A0\u201CVR\u5927\u5F00\u773C\u754C\u201D\u8BFE\u7A0B\u4E2D\u5404\u79CD\u73AF\u8282\u6240\u53EF\u80FD\u5B58\u5728\u7684\u4E00\u5207\u98CE\u9669\u3002\u2002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u6211\u5DF2\u8BA4\u771F\u9605\u8BFB\u5B89\u5168\u987B\u77E5\uFF0C\u5E76\u5C06\u4E25\u683C\u9075\u5FAA\u5176\u6240\u8FF0\u89C4\u5219\u64CD\u4F5C\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\uFF09\u5B69\u5B50\u5728\u4F7F\u7528VR\u773C\u955C\u65F6\u9700\u5FC5\u987B\u6709\u6210\u4EBA\u5728\u8EAB\u8FB9\u966A\u4F34\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\uFF09\u4E0D\u80FD\u628AVR\u773C\u955C\u6B63\u5BF9\u592A\u9633\u6216\u66B4\u9732\u5728\u9633\u5149\u76F4\u5C04\u4E0B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\uFF09\u6BCF\u6B21\u8FDE\u7EED\u4F7F\u7528VR\u773C\u955C\u7684\u65F6\u95F4\u4E0D\u8981\u8D85\u8FC715\u5206\u949F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\uFF09\u5982\u6709\u5934\u6655\u3001\u773C\u75B2\u52B3\u7B49\u4E0D\u9002\u53CD\u5E94\uFF0C\u8BF7\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\uFF09\u5728\u5750\u7740\u65F6\u4F7F\u7528\u773C\u955C\uFF0C\u907F\u514D\u7AD9\u7ACB\u3001\u6D3B\u52A8\u65F6\u4F7F\u7528\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\uFF09\u4F7F\u7528VR\u773C\u955C\u65F6\u8981\u7ECF\u5E38\u505C\u4E0B\u6765\u4F11\u606F\u4E00\u4F1A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2\u3001\u6211\u5DF2\u4E86\u89E3\u5E76\u540C\u610F\u9075\u5B88VR\u8BFE\u7A0B\u6240\u91C7\u7528\u7684\u5F62\u5F0F\u5E76\u613F\u610F\u9075\u5FAA\uFF1B\u6211\u5DF2\u77E5\u9053\u201CVR\u5927\u5F00\u773C\u754C\u201D\u662F\u7531\u8BF8\u591AVR\u573A\u666F\u53CA\u4E92\u52A8\u7EC4\u6210\uFF0C\u5728\u4F69\u5E26VR\u773C\u955C\u4F53\u9A8C\u8BFE\u7A0B\u65F6\u5B58\u5728\u4E00\u5B9A\u7684\u8FD0\u52A8\u98CE\u9669\u3002\u6E38\u620F\u4E2D\u5982\u78B0\u649E\u3001\u8E29\u8E0F\u3001\u7269\u54C1\u6C61\u635F\u7B49\u4EFB\u4F55\u95EE\u9898\u8981\u81EA\u884C\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6211\u540C\u610F\u5728\u8BFE\u7A0B\u4F53\u9A8C\u524D\u68C0\u67E5\u9644\u8FD1\u4E0A\u8BFE\u73AF\u5883\u3001\u8BBE\u65BD\u3001\u8BBE\u5907\uFF0C\u5982\u679C\u6211\u53D1\u73B0\u5B58\u5728\u4EFB\u4F55\u4E0D\u5B89\u5168\u56E0\u7D20\uFF0C\u5C06\u53CA\u65F6\u8FDB\u884C\u76F8\u5E94\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3\u3001\u6211\u627F\u8BFA\u5728\u4E0A\u8BFE\u65F6\u4F1A\u6CE8\u610F\u4EBA\u8EAB\u5B89\u5168\u3002\u82E5\u5728\u8BFE\u7A0B\u4F53\u9A8C\u65F6\u56E0\u4E3A\u81EA\u8EAB\u539F\u56E0\uFF0C\u5BFC\u81F4\u6454\u8DE4\u3001\u8DCC\u5012\u3001\u78D5\u78B0\u7B49\u9020\u6210\u4F24\u5BB3\u7684\uFF0C\u8BFE\u7A0B\u65B9\u4E0D\u8D1F\u4EFB\u4F55\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4\u3001\u6211\u660E\u767D\u6B8B\u75BE\u4EBA\u3001\u5B55\u5987\u7B49\u7279\u6B8A\u4EBA\u7FA4\u4EE5\u53CA\u9189\u9152\u6216\u8EAB\u60A3\u5FC3\u810F\u75C5\u3001\u9AD8\u8840\u538B\u3001\u7CD6\u5C3F\u75C5\u3001\u4E60\u60EF\u6027\u8131\u81FC\u3001\u766B\u75EB\u3001\u9AA8\u8D28\u758F\u677E\u7B49\u4E0D\u9002\u5B9C\u672C\u9879\u6D3B\u52A8\u7684\u75BE\u75C5\u7981\u6B62\u8FDB\u884C\u4F53\u9A8C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5\u3001\u6211\u660E\u767D\u5E76\u63A5\u53D7\u82E5\u56E0\u6211\u7684\u4E0D\u5F53\u64CD\u4F5C\uFF0C\u9020\u6210\u8BBE\u5907\u635F\u574F\uFF0C\u6216\u9020\u6210\u672C\u4EBA\u6216\u4ED6\u4EBA\u751F\u547D\u5065\u5EB7\u5B89\u5168\uFF0C\u7531\u6211\u672C\u4EBA\u627F\u62C5\u4E00\u5207\u540E\u679C\uFF0C\u8BFE\u7A0B\u65B9\u4E0D\u627F\u62C5\u4E00\u5207\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6\u3001\u6211\u660E\u767D\u672A\u6EE1\u5341\u516D\u5468\u5C81\u9700\u76D1\u62A4\u4EBA\u786E\u8BA4\u540C\u610F\u53C2\u52A0\uFF0C\u5341\u4E8C\u5468\u5C81\u4EE5\u4E0B\u7684\uFF0C\u9700\u7531\u76D1\u62A4\u4EBA\u966A\u540C\uFF0C\u672A\u6210\u5E74\u4EBA\u4F53\u9A8C\u8BFE\u7A0B\u65F6\u4EA7\u751F\u7684\u4EFB\u4F55\u95EE\u9898\u7531\u76D1\u62A4\u4EBA\u627F\u62C5\uFF0C\u8BFE\u7A0B\u65B9\u4E0D\u627F\u62C5\u4E00\u5207\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'7\u3001\u6211\u660E\u767D\u5DF2\u6EE1\u4E94\u5341\u4E94\u5468\u5C81\u7684\u8001\u4EBA\u4E0D\u9002\u5B9C\u53C2\u52A0\u672C\u9879\u76EE\u6D3B\u52A8\uFF0C\u5982\u672C\u4EBA\u575A\u6301\u81EA\u613F\u53C2\u52A0\uFF0C\u8FC7\u7A0B\u4E2D\u9020\u6210\u7684\u4EFB\u4F55\u635F\u5BB3\uFF0C\u8BFE\u7A0B\u65B9\u5C06\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002')));}}]);return Privacy4Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Privacy4Page);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privacy2Page=function(_Component){_inherits(Privacy2Page,_Component);function Privacy2Page(props){_classCallCheck(this,Privacy2Page);var _this=_possibleConstructorReturn(this,(Privacy2Page.__proto__||Object.getPrototypeOf(Privacy2Page)).call(this,props));_this.state={};return _this;}_createClass(Privacy2Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课精品小班平台用户隐私政策'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7528\u6237\u9690\u79C1\u653F\u7B56\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E73\u53F0\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09\uFF0C'),'\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u60A8\u8D2D\u4E70\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u4EA4\u6613\u65F6\u95F4\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u7B49\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u3001\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF0C\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u3001\u9488\u5BF9\u60A8\u4F7F\u7528\u8BBE\u5907\u7684\u4F18\u5316\u9002\u914D\u3001\u5F53\u7F51\u7EDC\u8D28\u91CF\u5B58\u5728\u95EE\u9898\u65F6\u7684\u7CBE\u51C6\u63D0\u793A\u7B49\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u5728\u7EBF\u4EA4\u6D41\uFF0C\u89C6\u9891\u4E92\u52A8\uFF0C\u4EE5\u53CA\u66F4\u6362\u60A8\u5728APP\u5185\u7684\u4E2A\u4EBA\u5934\u50CF\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u8FD9\u4E9B\u529F\u80FD\u5728\u4E0A\u8BFE\u65F6\u548C\u540C\u5B66\u4EA4\u6D41\uFF0C\u5728\u8BFE\u5802\u4E2D\u7684\u8BED\u97F3\u6D4B\u8BC4\u73AF\u8282\u6D4B\u8BC4\u60A8\u7684\u53D1\u97F3\u662F\u5426\u6807\u51C6\u5E76\u4E14\u7ED9\u5230\u53CD\u9988\uFF0C\u4EE5\u53CA\u5728\u8BFE\u540E\u4F5C\u4E1A\u73AF\u8282\u901A\u8FC7\u8BED\u97F3\u6D4B\u8BC4\u7ED9\u5230\u5F97\u5206\u53CD\u9988\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u4E3A\u4E86\u60A8\u53EF\u4EE5\u83B7\u5F97\u66F4\u5B8C\u5584\u7684\u8BFE\u7A0B\u4F53\u9A8C\uFF0C\u6211\u4EEC\u4F1A\u54A8\u8BE2\u60A8\u662F\u5426\u8981\u5F00\u542F\u5199\u5165\u5916\u90E8\u5B58\u50A8\u5668\u7684\u6743\u9650\uFF0C\u8BE5\u6743\u9650\u7528\u4E8E\u60A8\u5728\u6211\u4EEC\u8BFE\u5802\u4E2D\u5B8C\u6210\u8BFE\u7A0B\u5B66\u4E60\u540E\uFF0C\u6211\u4EEC\u4F1A\u7ED9\u5230\u60A8\u4E0A\u8BFE\u7684\u7ED3\u679C\u62A5\u544A\uFF0C\u4E14\u53EF\u4EE5\u4FDD\u5B58\u5230\u60A8\u7684\u8BBE\u5907\u672C\u5730\uFF0C\u6B64\u7C7B\u4FDD\u5B58\u56FE\u7247\u3001\u4E8C\u7EF4\u7801\u64CD\u4F5C\u9700\u8981\u5F00\u901A\u8BE5\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u80FD\u7ED9\u60A8\u63D0\u4F9B\u66F4\u5B8C\u6574\u7684\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u4E00\u4E9B\u7B2C\u4E09\u65B9SDK\uFF0C\u5176\u4E2D\u53CB\u76DF\u548C\u4E2A\u63A8SDK\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\u4F1A\u9700\u8981\u60A8\u5F00\u542F\u8BBF\u95EE\u60A8\u7684\u7CBE\u51C6\u5B9A\u4F4D\u548C\u8BBF\u95EE\u7C97\u7565\u4F4D\u7F6E\u7684\u6743\u9650\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u662F\u5426\u5F00\u542F\u5F00\u542F\u8BE5\u6743\u9650\u4EE5\u8BA9\u6211\u4EEC\u6709\u66F4\u591A\u7684\u53C2\u8003\u6765\u4E3A\u60A8\u540E\u671F\u63D0\u4F9B\u66F4\u7CBE\u51C6\u7684\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.8 \u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F\uFF0C'),'\u4F46\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.9 \u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u82F9\u679C\u652F\u4ED8\u83B7\u5F97\u60A8\u7684\u82F9\u679C\u652F\u4ED8\u8D26\u6237\u4FE1\u606F\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6216\u8005\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3 \u6B64\u5916\u6211\u4EEC\u4E3A\u4E86\u7ED9\u60A8\u63D0\u4F9B\u66F4\u4E13\u4E1A\u3001\u5B89\u5168\u7684\u57FA\u7840\u4E1A\u52A1\u529F\u80FD\u548C\u9644\u52A0\u4E1A\u52A1\u529F\u80FD\uFF0C\u51FA\u4E8E\u6280\u672F\u9700\u8981\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u4EE5\u4E0B\u7B2C\u4E09\u65B9\u8F6F\u4EF6\u5F00\u53D1\u5DE5\u5177\u5305\uFF08SDK\uFF09\uFF0C\u6211\u4EEC\u5E73\u53F0\u5D4C\u5165\u7684\u7B2C\u4E09\u65B9SDK\u53CA\u7B2C\u4E09\u65B9\u6240\u6536\u96C6\u6216\u4E0E\u4E4B\u5171\u4EAB\u7684\u4FE1\u606F\u5982\u4E0B\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.1 \u817E\u8BAFBuglySDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u63D0\u9AD8\u670D\u52A1\u7A33\u5B9A\u6027\uFF0C\u4FBF\u4E8E\u76F8\u5173\u670D\u52A1\u5D29\u6E83\u540E\u5FEB\u901F\u51C6\u786E\u5B9A\u4F4D\u5B58\u5728\u95EE\u9898\uFF0C\u817E\u8BAFBugly\u5C06\u5728\u60A8\u4F7F\u7528\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\u6536\u96C6\u5E76\u5171\u4EAB\u60A8\u7684\u8BBE\u5907\u4FE1\u606F\uFF0C\u5305\u62EC\u8BBE\u5907ID\u3001\u7CFB\u7EDF\u7248\u672C\u3001\u8BBE\u5907\u578B\u53F7\u7B49\u8BBE\u5907\u57FA\u7840\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.2 \u5FAE\u4FE1\u5206\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u4F7F\u60A8\u7684\u5B66\u4E60\u6210\u679C\u53EF\u4EE5\u5728\u5FAE\u4FE1\u5E73\u53F0\u4E0A\u8FDB\u884C\u5206\u4EAB\uFF0C\u5FAE\u4FE1\u5206\u4EABSDK\u5C06\u6536\u96C6\u60A8\u7684\u8BBE\u5907\u54C1\u724C\u3001\u578B\u53F7\u3001IMEI\u3001\u624B\u673A\u53F7\u3001\u7F51\u7EDC\u8FDE\u63A5\u3001IP\u3001MAC\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.3 \u521B\u84DD\u95EA\u9A8CSDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u60A8\u63D0\u4F9B\u65B9\u4FBF\u7684\u4E00\u952E\u767B\u5F55\u7B49\u670D\u52A1\uFF0C\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u521B\u84DDSDK\uFF0C\u521B\u84DDSDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u3001\u624B\u673A\u673A\u578B\u3001\u7CFB\u7EDF\u7248\u672C\u3001IP\u5730\u5740\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.4 \u53CB\u76DF+SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6211\u4EEC\u7684\u4EA7\u54C1\u96C6\u6210\u53CB\u76DF+SDK\uFF0C\u53CB\u76DF+SDK\u9700\u8981\u6536\u96C6\u60A8\u7684\u8BBE\u5907Mac\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08IMEI/android ID/IDFA/OPENUDID/GUID\u3001SIM \u5361 IMSI \u4FE1\u606F\uFF09\u4EE5\u63D0\u4F9B\u7EDF\u8BA1\u5206\u6790\u670D\u52A1\uFF0C\u5E76\u901A\u8FC7\u5730\u7406\u4F4D\u7F6E\u6821\u51C6\u62A5\u8868\u6570\u636E\u51C6\u786E\u6027\uFF0C\u63D0\u4F9B\u57FA\u7840\u53CD\u4F5C\u5F0A\u80FD\u529B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.5 \u4E2A\u63A8SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u901A\u8FC7APP\u7ED9\u7528\u6237\u53D1\u9001\u6D88\u606F\u63A8\u9001\uFF0C\u6211\u4EEC\u4F7F\u7528\u4E86\u4E2A\u63A8SDK\uFF0C\u4E2A\u63A8SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u5E73\u53F0\u3001\u8BBE\u5907\u5382\u5546\u3001\u8BBE\u5907\u54C1\u724C\u3001\u8BBE\u5907\u8BC6\u522B\u7801\u7B49\u8BBE\u5907\u4FE1\u606F\uFF0C\u5E94\u7528\u5217\u8868\u4FE1\u606F\u3001\u7F51\u7EDC\u4FE1\u606F\u4EE5\u53CA\u4F4D\u7F6E\u76F8\u5173\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.6 \u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5E2E\u52A9\u7528\u6237\u67E5\u8BE2\u64CD\u4F5C\u95EE\u9898\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u963F\u91CC\u4E91\u6587\u4EF6\u4E0A\u4F20\u670D\u52A1\uFF08OSS\uFF09\uFF0C\u8BE5SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u578B\u53F7\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\uFF0Cip\u5730\u5740\uFF0Cmac\u5730\u5740\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.7 \u58F0\u7F51Agora SDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u5B9E\u73B0\u8BED\u97F3\u3001\u89C6\u9891\u4E92\u52A8\u76F4\u64AD\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86Agora SDK\uFF0CAgora SDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u5199\u5165\u5916\u7F6E\u5B58\u50A8\u5668\u6743\u9650\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0C\u7CFB\u7EDF\u7248\u672C\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u9EA6\u514B\u98CE\uFF0C\u76F8\u673A\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.3.8 \u58F0\u901ASDK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4E3A\u4E86\u5728\u8BFE\u5802\u5185\u3001\u4F5C\u4E1A\u4E2D\u7B49\u573A\u666F\u4F7F\u7528\u8BED\u97F3\u6D4B\u8BC4\u670D\u52A1\uFF0C\u6211\u4EEC\u63A5\u5165\u4E86\u58F0\u901ASDK\uFF0C\u58F0\u901ASDK\u9700\u8981\u83B7\u53D6\u60A8\u7684\u9EA6\u514B\u98CE\uFF0C\u8BBE\u5907\u578B\u53F7\uFF0C\u7248\u672C\u4FE1\u606F\uFF0C\u7F51\u7EDC\u4FE1\u606F\uFF0CApp\u7248\u672C\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u4EE5\u4E0A\u7B2C\u4E09\u65B9SDK\u4F1A\u6839\u636E\u4EA7\u54C1\u529F\u80FD\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6211\u4EEC\u4EC5\u4F1A\u5728\u60A8\u6388\u6743\u540C\u610F\u5F00\u901A\u76F8\u5173\u529F\u80FD\u6216\u60A8\u5728\u4E3B\u52A8\u4F7F\u7528\u76F8\u5173\u529F\u80FD\u6211\u4EEC\u7ED9\u4E88\u5145\u5206\u63D0\u793A\u65F6\uFF0C\u624D\u4F1A\u5C06\u60A8\u7684\u5BF9\u5E94\u4E2A\u4EBA\u4FE1\u606F\u6388\u6743\u7ED9\u4E0A\u8FF0\u7B2C\u4E09\u65B9\u63D2\u4EF6\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{style:{marginTop:20,display:'block'}},'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{style:{marginTop:20,display:'block'}},'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5728\u4E0D\u5E78\u53D1\u751F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u540E\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\u3010\u5E76\u6700\u8FDF\u4E0D\u8FDF\u4E8E30\u4E2A\u81EA\u7136\u65E5\u5185\u3011\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u6216\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u3001\u5BF9\u60A8\u7684\u8865\u6551\u63AA\u65BD\u7B49\u3002\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u6211\u4EEC\u5C06\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u65B9\u5F0F\u544A\u77E5\u60A8\uFF0C\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E0A\u62A5\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3 \u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u505A\u51FA\u89E3\u91CA\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4F1A\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A\xA0400-887-4877\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5FAE\u4FE1\u516C\u4F17\u53F7\uFF1A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED_service\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701 \u676D\u5DDE\u5E02 \u4F59\u676D\u533A \u4F59\u676D\u5858\u8DEF2301\u53F7\u6D77\u667A\u4E2D\u5FC38\u53F7\u697C\uFF08\u6536\u4EF6\u4EBA\uFF1A\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u7231\u8BFE\u7CBE\u54C1\u5C0F\u73ED\u5E73\u53F0\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return Privacy2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Privacy2Page);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ServiceusePage=function(_Component){_inherits(ServiceusePage,_Component);function ServiceusePage(props){_classCallCheck(this,ServiceusePage);var _this=_possibleConstructorReturn(this,(ServiceusePage.__proto__||Object.getPrototypeOf(ServiceusePage)).call(this,props));_this.state={};return _this;}_createClass(ServiceusePage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课优佳服务使用协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'\u300A\u7231\u8BFE\u4F18\u4F73\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u7231\u8BFE\u4F18\u4F73\u670D\u52A1\u4F7F\u7528\u534F\u8BAE\u300B\u662F\u60A8\uFF08\u4EE5\u4E0B\u79F0\u201C\u7528\u6237\u201D\uFF09\u4E0E\u676D\u5DDE\u6F58\u54D2\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u4E4B\u95F4\u5728\u4F7F\u7528\u5176\u7BA1\u7406\u7684\u7231\u8BFE\u4F18\u4F73\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7231\u8BFE\u4F18\u4F73\u201D\uFF09\u4E2D\u6CE8\u518C\u4F7F\u7528\u65F6\u7B7E\u7F72\u7684\u534F\u8BAE\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u4E00\u3001\u91CD\u8981\u987B\u77E5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5E94\u8BA4\u771F\u9605\u8BFB\uFF08\u672A\u6210\u5E74\u4EBA\u5E94\u5F53\u5728\u76D1\u62A4\u4EBA\u966A\u540C\u4E0B\u9605\u8BFB\uFF09\u3001\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u9664\u975E\u7528\u6237\u63A5\u53D7\u672C\u534F\u8BAE\uFF0C\u7528\u6237\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u6CE8\u518C\u53CA\u4F7F\u7528\u884C\u4E3A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u5728\u8FDB\u884C\u6CE8\u518C\u7A0B\u5E8F\u8FC7\u7A0B\u4E2D\u70B9\u51FB\u201C\u540C\u610F\u201D\u6309\u94AE\u5373\u8868\u793A\u7528\u6237\u5B8C\u5168\u63A5\u53D7\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6761\u6B3E\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7231\u8BFE\u4F18\u4F73\u5C06\u7ED9\u4E88\u6BCF\u4E2A\u7528\u6237\u4E00\u4E2A\u7528\u6237\u5E10\u53F7\u53CA\u76F8\u5E94\u7684\u5BC6\u7801\uFF0C\u8BE5\u7528\u6237\u5E10\u53F7\u548C\u5BC6\u7801\u7531\u7528\u6237\u8D1F\u8D23\u4FDD\u7BA1\uFF1B\u7528\u6237\u59A5\u5584\u4FDD\u7BA1\u5E10\u53F7\u548C\u5BC6\u7801\uFF0C\u9632\u6B62\u6CC4\u9732\uFF0C\u5982\u679C\u5E10\u53F7\u548C\u5BC6\u7801\u88AB\u76D7\u7528\u7684\uFF0C\u7528\u6237\u5E94\u5F53\u5BF9\u4EE5\u5176\u7528\u6237\u5E10\u53F7\u8FDB\u884C\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\u8D1F\u6CD5\u5F8B\u8D23\u4EFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u4E8C\u3001\u670D\u52A1\u5185\u5BB9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u4F18\u4F73\u670D\u52A1\u7684\u5177\u4F53\u5185\u5BB9\u7531\u7231\u8BFE\u4F18\u4F73\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u63D0\u4F9B\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7231\u8BFE\u4F18\u4F73\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\uFF08\u4F8B\u5982\u8D2D\u4E70\u8BFE\u65F6\u7B49\uFF09\u4E3A\u6536\u8D39\u670D\u52A1\uFF0C\u7528\u6237\u4F7F\u7528\u6536\u8D39\u670D\u52A1\u9700\u8981\u5411\u7231\u8BFE\u4F18\u4F73\u652F\u4ED8\u4E00\u5B9A\u7684\u8D39\u7528\u3002\u5BF9\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u4F18\u4F73\u4F1A\u5728\u7528\u6237\u4F7F\u7528\u4E4B\u524D\u7ED9\u4E88\u7528\u6237\u660E\u786E\u7684\u63D0\u793A\uFF0C\u53EA\u6709\u7528\u6237\u6839\u636E\u63D0\u793A\u786E\u8BA4\u5176\u613F\u610F\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u7528\u6237\u624D\u80FD\u4F7F\u7528\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002\u5982\u7528\u6237\u62D2\u7EDD\u652F\u4ED8\u76F8\u5173\u8D39\u7528\uFF0C\u5219\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u4E0D\u5411\u7528\u6237\u63D0\u4F9B\u8BE5\u7B49\u6536\u8D39\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u4F18\u4F73\u4EC5\u63D0\u4F9B\u8F6F\u4EF6\u76F8\u5173\u670D\u52A1\uFF0C\u9664\u6B64\u4E4B\u5916\u4E0E\u76F8\u5173\u8F6F\u4EF6\u670D\u52A1\u6709\u5173\u7684\u8BBE\u5907\uFF08\u5982\u624B\u673A\u3001\u4E2A\u4EBA\u7535\u8111\u53CA\u5176\u4ED6\u4E0E\u63A5\u5165\u4E92\u8054\u7F51\u6216\u79FB\u52A8\u7F51\u6709\u5173\u7684\u88C5\u7F6E\uFF09\u53CA\u6240\u9700\u7684\u8D39\u7528\uFF08\u5982\u4E3A\u63A5\u5165\u4E92\u8054\u7F51\u800C\u652F\u4ED8\u7684\u7535\u8BDD\u8D39\u53CA\u4E0A\u7F51\u8D39\u3001\u4E3A\u4F7F\u7528\u79FB\u52A8\u7F51\u800C\u652F\u4ED8\u7684\u624B\u673A\u8D39\uFF09\u5747\u5E94\u7531\u7528\u6237\u81EA\u884C\u8D1F\u62C5\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u4F18\u4F73\u4E3A\u672C\u534F\u8BAE\u5C65\u884C\u6216\u76F8\u5173\u7814\u7A76\u7684\u76EE\u7684\u6536\u96C6\u3001\u4F7F\u7528\u6216\u6388\u6743\u7B2C\u4E09\u65B9\uFF08\u4E14\u8BE5\u7B49\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E\u7231\u8BFE\u4F18\u4F73\u540C\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u4E49\u52A1\uFF09\u975E\u5546\u4E1A\u5730\u4F7F\u7528\u901A\u8FC7\u670D\u52A1\u83B7\u53D6\u7684\u7528\u6237\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u8EAB\u4EFD\u4FE1\u606F\u3001\u6027\u522B\u3001\u804C\u4E1A\u3001\u5174\u8DA3\u7231\u597D\u3001\u5728\u7231\u8BFE\u4F18\u4F73\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8BED\u97F3\u8D44\u6599\uFF09\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u4E8E\u6392\u884C\u699C\u4E0A\uFF0C\u4F7F\u7231\u8BFE\u4F18\u4F73\u5176\u4ED6\u7528\u6237\u53EF\u4EE5\u67E5\u770B\u7528\u6237\u7684\u5934\u50CF\u3001\u540D\u5B57\u3001\u8BED\u97F3\u7B49\u4E2A\u4EBA\u8D44\u6599\u3001\u5E94\u7528\u4E8E\u76F8\u5173\u5B66\u672F\u3001\u5E94\u7528\u7814\u7A76\u7B49\u3002\u7231\u8BFE\u4F18\u4F73\u627F\u8BFA\uFF0C\u9664\u975E\u53E6\u884C\u53D6\u5F97\u7528\u6237\u7684\u4E8B\u5148\u540C\u610F\uFF0C\u5426\u5219\u7231\u8BFE\u4F18\u4F73\u4E0D\u4F1A\u5C06\u7528\u6237\u4FE1\u606F\u6388\u6743\u7ED9\u4E0E\u5C65\u884C\u672C\u534F\u8BAE\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u7528\u4E8E\u5546\u4E1A\u76EE\u7684\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 5\u3001\u6839\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u56FD\u5BB6\u6807\u51C6\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u4F18\u4F73\u53EF\u80FD\u4F1A\u4F9D\u6CD5\u6536\u96C6\u5E76\u4F7F\u7528\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u4E14\u65E0\u9700\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u76F4\u63A5\u76F8\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u4ED6\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u7528\u6237\u672C\u4EBA\u540C\u610F\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF085\uFF09\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\uFF1A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF087\uFF09\u6839\u636E\u7528\u6237\u7684\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF088\uFF09\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\uFF1A\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF089\uFF09\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF0810\uFF09\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF0811\uFF09\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 6\u3001\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u7231\u8BFE\u4F18\u4F73\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u4E8B\u5148\u5F81\u5F97\u7528\u6237\u7684\u6388\u6743\u540C\u610F\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF081\uFF09\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF082\uFF09\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF083\uFF09\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF084\uFF09\u51FA\u4E8E\u7EF4\u62A4\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF085\uFF09\u7528\u6237\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \uFF086\uFF09\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' \u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u7528\u6237\u901A\u77E5\u5E76\u5F81\u5F97\u7528\u6237\u7684\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u4E09\u3001\u7528\u6237\u4F7F\u7528\u89C4\u5219'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u6CE8\u518C\u6210\u529F\u540E\uFF0C\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u8F6F\u4EF6\u529F\u80FD\u4E0E\u7528\u6237\u8FDB\u884C\u5206\u4EAB\u4EA4\u6D41\uFF0C\u5305\u62EC\u8BFE\u7A0B\u5B66\u4E60\u3001\u53D1\u5E16\u6559\u5B66\u3001\u6B4C\u66F2\u6F14\u5531\u4EE5\u53CA\u5206\u4EAB\u5176\u4ED6\u4E00\u5207\u7528\u6237\u611F\u5174\u8DA3\u7684\u5185\u5BB9\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u6709\u6743\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4E3B\u9875\u3001\u7167\u7247\u4E0A\u4F20\u3001\u5206\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u65F6\u987B\u9075\u5B88\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u4E0D\u5F97\u4ECE\u4E8B\u4EE5\u4E0B\u884C\u4E3A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.1 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.2 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.3 \u53D1\u5E03\u3001\u4F20\u9001\u3001\u4F20\u64AD\u3001\u50A8\u5B58\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.4 \u53D1\u8868\u3001\u4F20\u9001\u3001\u4F20\u64AD\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3.5 \u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5E73\u53F0\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u5FC5\u987B\u6E05\u695A\u4F7F\u7528\u89C4\u5219\uFF0C\u7231\u8BFE\u4F18\u4F73\u4EC5\u4F9B\u4E2A\u4EBA\u4EA4\u6D41\u3001\u5B66\u4E60\u6B23\u8D4F\uFF0C\u975E\u5546\u4E1A\u6027\u8D28\u7684\u4F7F\u7528\uFF0C\u7528\u6237\u4E0D\u53EF\u5229\u7528\u672C\u670D\u52A1\u5BF9\u4FE1\u606F\u6216\u8868\u6F14\u7B49\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u8FDB\u884C\u51FA\u552E\u3001\u6216\u5229\u7528\u672C\u670D\u52A1\u8FDB\u884C\u8C03\u67E5\u3001\u5E7F\u544A\u3001\u6216\u7528\u4E8E\u5176\u4ED6\u5546\u4E1A\u76EE\u7684\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 5\u3001 \u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u65F6\u53D1\u5E03\u3001\u4F20\u64AD\u7684\u4FE1\u606F\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\uFF0C\u4FDD\u8BC1\u4E0D\u5F97\u53D1\u5E03\u8C23\u8A00\u6216\u5176\u4ED6\u4E0E\u4E8B\u5B9E\u4E0D\u7B26\u5F15\u8D77\u4ED6\u4EBA\u4E0D\u9002\u7684\u8A00\u8BBA\u3001\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 6\u3001\u7528\u6237\u4FDD\u8BC1\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u4E0D\u5F97\u53D1\u5E03\u3001\u4F20\u64AD\u4FB5\u72AF\u77E5\u8BC6\u4EA7\u6743\u6216\u5176\u4ED6\u5408\u6CD5\u6743\u76CA\u7684\u4FE1\u606F\u3002\u7528\u6237\u4F20\u64AD\u5185\u5BB9\u4E2D\u6D89\u53CA\u7B2C\u4E09\u65B9\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u5185\u5BB9\u7684\u76F8\u5173\u6388\u6743\u6216\u5176\u4ED6\u5185\u5BB9\u7684\u5408\u6CD5\u6027\u7531\u7528\u6237\u81EA\u884C\u8D1F\u8D23\uFF0C\u7231\u8BFE\u4F18\u4F73\u5BF9\u76F8\u5173\u5185\u5BB9\u7684\u77E5\u8BC6\u4EA7\u6743\u6743\u5C5E\u6216\u662F\u5426\u4FB5\u72AF\u4ED6\u4EBA\u6C11\u4E8B\u6743\u76CA\u7B49\u60C5\u51B5\u4E0D\u8FDB\u884C\u5BA1\u67E5\u6216\u76D1\u7763\uFF0C\u4F46\u5C06\u6309\u76F8\u5173\u6CD5\u89C4\u5BF9\u6D89\u5ACC\u4FB5\u6743\u7684\u5185\u5BB9\u5C65\u884C\u5220\u9664\u6216\u65AD\u5F00\u94FE\u63A5\u7B49\u804C\u8D23\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 7\u3001\u82E5\u7528\u6237\u53D1\u751F\u524D\u8FF03-6\u7684\u884C\u4E3A\u65F6\uFF0C\u7531\u7528\u6237\u627F\u62C5\u6240\u6709\u7684\u8FDD\u6CD5\u3001\u4FB5\u6743\u8D23\u4EFB\uFF0C\u82E5\u56E0\u6B64\u7ED9\u7231\u8BFE\u4F18\u4F73\u9020\u6210\u4EFB\u4F55\u635F\u5931\uFF0C\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u5411\u8D23\u4EFB\u7528\u6237\u4E3B\u5F20\u76F8\u5173\u8D23\u4EFB\u3002\u540C\u65F6\uFF0C\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u5BF9\u8FDD\u6CD5\u3001\u4FB5\u6743\u3001\u8FDD\u89C4\u7684\u7528\u6237\u7EC8\u6B62\u63D0\u4F9B\u670D\u52A1\u3002\u5982\u679C\u653F\u5E9C\u6216\u8005\u53F8\u6CD5\u673A\u5173\u8981\u6C42\u7231\u8BFE\u4F18\u4F73\u544A\u77E5\u8FDB\u884C\u4FB5\u6743\u884C\u4E3A\u7528\u6237\u7684\u5177\u4F53\u4FE1\u606F\u7684\uFF0C\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u6839\u636E\u73B0\u884C\u6CD5\u89C4\u5411\u5176\u544A\u77E5\u7528\u6237\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 8\u3001\u7528\u6237\u540C\u610F\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u5728\u63D0\u4F9B\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EE5\u5404\u79CD\u65B9\u5F0F\u6295\u653E\u5404\u79CD\u5546\u4E1A\u6027\u5E7F\u544A\u6216\u5176\u4ED6\u4EFB\u4F55\u7C7B\u578B\u7684\u5546\u4E1A\u4FE1\u606F\uFF0C\u5E76\u4E14\uFF0C\u7528\u6237\u540C\u610F\u63A5\u53D7\u7231\u8BFE\u4F18\u4F73\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u6216\u5176\u4ED6\u65B9\u5F0F\u5411\u7528\u6237\u53D1\u9001\u5546\u54C1\u4FC3\u9500\u6216\u5176\u4ED6\u76F8\u5173\u5546\u4E1A\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u56DB\u3001\u77E5\u8BC6\u4EA7\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7528\u6237\u5728\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u5206\u4EAB\u4E2A\u4EBA\u4F5C\u54C1\u65F6\uFF0C\u4E0D\u5F97\u4FB5\u72AF\u7B2C\u4E09\u65B9\u4EFB\u4F55\u77E5\u8BC6\u4EA7\u6743\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u4F7F\u7528\u7231\u8BFE\u4F18\u4F73\u5206\u4EAB\u4FE1\u606F\u4E2D\u542B\u6709\u7684\u5B8C\u5168\u7531\u7528\u6237\u81EA\u8EAB\u539F\u521B\u4FE1\u606F\u7684\u7248\u6743\u5F52\u7528\u6237\uFF0C\u4F46\u5176\u4E2D\u5229\u7528\u7231\u8BFE\u4F18\u4F73\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\uFF0C\u5229\u7528\u7231\u8BFE\u4F18\u4F73\u4E2D\u5DF2\u6709\u7D20\u6750\u800C\u5F62\u6210\u7684\u5F55\u97F3\u6216\u5176\u4ED6\u8D44\u6599\u7684\u7248\u6743\u7531\u7528\u6237\u4E0E\u7231\u8BFE\u5171\u6709\u3002\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u662F\u5BF9\u5176\u4EAB\u6709\u7248\u6743\u6216\u7ECF\u5408\u6CD5\u6388\u6743\u7684\u76F8\u5173\u5185\u5BB9\u7684\u7F51\u7EDC\u4F20\u64AD\u884C\u4E3A\u8BB8\u53EF\uFF0C\u7528\u6237\u7684\u5206\u4EAB\u884C\u4E3A\u5373\u8868\u660E\u5176\u5DF2\u6388\u6743\u7231\u8BFE\u4F18\u4F73\u53CA\u5176\u4ED6\u7528\u6237\u6709\u6743\u590D\u5236\u3001\u4F20\u64AD\u524D\u8FF0\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u4E94\u3001\u670D\u52A1\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u9274\u4E8E\u670D\u52A1\u7684\u7279\u6B8A\u6027\uFF0C\u7528\u6237\u540C\u610F\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u968F\u65F6\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u90E8\u5206\u6216\u5168\u90E8\u7684\u670D\u52A1\uFF08\u5305\u62EC\u6536\u8D39\u670D\u52A1\u53CA\u514D\u8D39\u670D\u52A1\uFF09\u3002\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u514D\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u4F18\u4F73\u65E0\u9700\u901A\u77E5\u7528\u6237\uFF0C\u4E5F\u65E0\u9700\u5BF9\u4EFB\u4F55\u7528\u6237\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF1B\u5982\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u7684\u670D\u52A1\u5C5E\u4E8E\u6536\u8D39\u670D\u52A1\uFF0C\u7231\u8BFE\u4F18\u4F73\u5E94\u5F53\u5728\u53D8\u66F4\u3001\u4E2D\u65AD\u6216\u7EC8\u6B62\u4E4B\u524D\u4E8B\u5148\u901A\u77E5\u7528\u6237\uFF0C\u5E76\u5E94\u5411\u53D7\u5F71\u54CD\u7684\u7528\u6237\u63D0\u4F9B\u7B49\u503C\u7684\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5982\u7528\u6237\u4E0D\u613F\u610F\u63A5\u53D7\u66FF\u4EE3\u6027\u7684\u6536\u8D39\u670D\u52A1\uFF0C\u5C31\u8BE5\u7528\u6237\u5DF2\u7ECF\u5411\u7231\u8BFE\u652F\u4ED8\u7684\u670D\u52A1\u8D39\uFF0C\u7231\u8BFE\u4F18\u4F73\u5E94\u5F53\u6309\u7167\u8BE5\u7528\u6237\u5B9E\u9645\u4F7F\u7528\u76F8\u5E94\u6536\u8D39\u670D\u52A1\u7684\u60C5\u51B5\u6263\u9664\u76F8\u5E94\u670D\u52A1\u8D39\u4E4B\u540E\u5C06\u5269\u4F59\u7684\u670D\u52A1\u8D39\u9000\u8FD8\u7ED9\u8BE5\u7528\u6237\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u7528\u6237\u7406\u89E3\uFF0C\u7231\u8BFE\u4F18\u4F73\u9700\u8981\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5730\u5BF9\u63D0\u4F9B\u670D\u52A1\u7684\u5E73\u53F0\u6216\u76F8\u5173\u7684\u8BBE\u5907\u8FDB\u884C\u68C0\u4FEE\u6216\u8005\u7EF4\u62A4\uFF0C\u5982\u56E0\u6B64\u7C7B\u60C5\u51B5\u800C\u9020\u6210\u6536\u8D39\u670D\u52A1\u5728\u5408\u7406\u65F6\u95F4\u5185\u7684\u4E2D\u65AD\uFF0C\u7231\u8BFE\u4F18\u4F73\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F46\u7231\u8BFE\u5E94\u5C3D\u53EF\u80FD\u4E8B\u5148\u8FDB\u884C\u901A\u544A\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u5982\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u670D\u52A1\u7684\u5E10\u53F7\u5728\u4EFB\u4F55\u8FDE\u7EED90\u65E5\u5185\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u6216\u8005\u5728\u63D0\u793A\u7528\u6237\u9700\u572810\u65E5\u5185\u6295\u5165\u5B9E\u9645\u4F7F\u7528\u540E\uFF0C\u82E5\u7528\u6237\u4E8E\u8BE510\u65E5\u5185\u4ECD\u672A\u5B9E\u9645\u4F7F\u7528\uFF0C\u5219\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u5220\u9664\u8BE5\u5E10\u53F7\u5E76\u505C\u6B62\u4E3A\u8BE5\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u670D\u52A1\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u7528\u6237\u6CE8\u518C\u7684\u514D\u8D39\u5E10\u53F7\u6635\u79F0\u5982\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u56FD\u5BB6\u653F\u7B56\u8981\u6C42\u3001\u7231\u8BFE\u4F18\u4F73\u7684\u6635\u79F0\u7BA1\u7406\u8981\u6C42\uFF0C\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\uFF0C\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u8981\u6C42\u7528\u6237\u8FDB\u884C\u4FEE\u6539\u6216\u6536\u56DE\u8BE5\u8D26\u53F7\u6635\u79F0\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},'\u516D\u3001\u5176\u4ED6\u4E8B\u5B9C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1\u3001\u7231\u8BFE\u4F18\u4F73\u6709\u6743\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u53D8\u5316\u3001\u7F51\u7AD9\u4EE5\u53CA\u76F8\u5E94\u7684\u7231\u8BFE\u8FD0\u8425\u7684\u9700\u8981\u4E0D\u65F6\u5730\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u5185\u5BB9\u8FDB\u884C\u4FEE\u6539\uFF0C\u5E76\u5728\u7F51\u7AD9\u4EE5\u53CA\u7231\u8BFE\u4F18\u4F73\u9192\u76EE\u4F4D\u7F6E\u5F20\u8D34\u3002\u4FEE\u6539\u540E\u7684\u534F\u8BAE\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\uFF0C\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u534F\u8BAE\uFF0C\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u534F\u8BAE\u3002\u7528\u6237\u6709\u4E49\u52A1\u53CA\u65F6\u5173\u6CE8\u5E76\u9605\u8BFB\u6700\u65B0\u7248\u7684\u534F\u8BAE\u53CA\u7F51\u7AD9\u516C\u544A\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\uFF0C\u53EF\u4EE5\u7ACB\u5373\u5411\u7231\u8BFE\u4F18\u4F73\u8FDB\u884C\u53CD\u9988\u4E14\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u7231\u8BFE\u4F18\u4F73\u4F9D\u636E\u672C\u534F\u8BAE\u63D0\u4F9B\u7684\u670D\u52A1\uFF1B\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1\u7684\uFF0C\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u534F\u8BAE\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 2\u3001\u672C\u534F\u8BAE\u81EA\u7528\u6237\u70B9\u51FB\u201C\u540C\u610F\u201D\u3001\u201C\u63A5\u53D7\u201D\u540E\u751F\u6548\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 3\u3001\u672C\u534F\u8BAE\u6240\u6709\u6761\u6B3E\u7684\u6807\u9898\u4EC5\u4E3A\u65B9\u4FBF\u800C\u8BBE,\u4E0D\u5177\u6CD5\u5F8B\u6216\u5951\u7EA6\u6548\u679C\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' 4\u3001\u672C\u534F\u8BAE\u7684\u89E3\u91CA\u6743\u5F52\u7231\u8BFE\u4F18\u4F73\u6240\u6709\u3002')));}}]);return ServiceusePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ServiceusePage);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyBinguo2Page=function(_Component){_inherits(PrivacyBinguo2Page,_Component);function PrivacyBinguo2Page(props){_classCallCheck(this,PrivacyBinguo2Page);var _this=_possibleConstructorReturn(this,(PrivacyBinguo2Page.__proto__||Object.getPrototypeOf(PrivacyBinguo2Page)).call(this,props));_this.state={};return _this;}_createClass(PrivacyBinguo2Page,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'用户隐私协议'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container privacyrules '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u300A\u7528\u6237\u9690\u79C1\u534F\u8BAE\u300B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u5F15\u8A00'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B22\u8FCE\u60A8\u4F7F\u7528Bingo\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\uFF0CBingo\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u5BBE\u679C\u82F1\u8BED\u201D\uFF09\u5F52\u5C5E\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\u7BA1\u7406\uFF0C\u5BBE\u679C\u82F1\u8BED\u5BF9\u6BCF\u4E00\u4F4D\u7528\u6237\u7684\u9690\u79C1\u6743\u91C7\u53D6\u9AD8\u5EA6\u5C0A\u91CD\u4E14\u4FDD\u62A4\u7684\u6001\u5EA6\u3002\u676D\u5DDE\u67AB\u6866\u6811\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u7BA1\u7406\u516C\u53F8\u201D\uFF09\u975E\u5E38\u91CD\u89C6\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\uFF0C\u4E3A\u540C\u65F6\u7ED9\u60A8\u63D0\u4F9B\u66F4\u51C6\u786E\u3001\u6709\u4E2A\u6027\u5316\u7684\u670D\u52A1\u548C\u66F4\u5B89\u5168\u7684\u4E92\u8054\u7F51\u73AF\u5883\uFF0C\u6211\u4EEC\u4F9D\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF08GB/T 35273-2017\uFF09\u4EE5\u53CA\u5176\u4ED6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6280\u672F\u89C4\u8303\uFF0C\u53D1\u5E03\u6B64\u300A\u9690\u79C1\u653F\u7B56\u300B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u653F\u7B56\u9002\u7528\u4E8E\u6211\u4EEC\u7684\u6240\u6709\u4EA7\u54C1\u53CA\u670D\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5BBE\u679C\u82F1\u8BED\u5E73\u53F0\u5185\u7684\u6240\u6709\u8BFE\u7A0B\uFF0C\u5982\u54C8\u4F5B\u767E\u79D1\u3001\u79D1\u5B66\u5B9E\u9A8C\u8BFE\u3001\u81EA\u7136\u62FC\u8BFB\u7B49\uFF09\uFF0C\u672C\u653F\u7B56\u4E0E\u60A8\u6240\u4F7F\u7528\u7684\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u606F\u606F\u76F8\u5173\uFF0C\u60A8\u5728\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u542F\u52A8\u3001\u6D4F\u89C8\u3001\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u672C\u653F\u7B56\u7684\u7EA6\u5B9A\u5904\u7406\u548C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5C06\u5C3D\u91CF\u4EE5\u7B80\u660E\u3001\u627C\u8981\u7684\u8868\u8FF0\u5411\u60A8\u89E3\u91CA\u672C\u653F\u7B56\u6240\u6D89\u53CA\u7684\u6280\u672F\u8BCD\u6C47\uFF0C\u4EE5\u4FBF\u4E8E\u60A8\u7406\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u6B64\uFF0C\u5E0C\u671B\u901A\u8FC7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5411\u60A8\u8BF4\u660E\uFF0C\u5BBE\u679C\u82F1\u8BED\u5982\u4F55\u53D6\u5F97\u3001\u4F7F\u7528\u3001\u5206\u4EAB\u3001\u4FDD\u5B58\u548C\u7BA1\u7406\u8FD9\u4E9B\u4FE1\u606F\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u5728\u4F7F\u7528/\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u5404\u9879\u4EA7\u54C1\u4E0E\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u653F\u7B56\uFF08\u5C24\u5176\u662F\u52A0\u7C97\u63D0\u793A\u7684\u5185\u5BB9\uFF09\uFF0C\u5E76\u5728\u9700\u8981\u65F6\uFF0C\u6309\u7167\u672C\u653F\u7B56\u7684\u6307\u5F15\uFF0C\u4F5C\u51FA\u9002\u5F53\u7684\u9009\u62E9\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u672C\u653F\u7B56\u7684\u5185\u5BB9\uFF0C\u5C06\u53EF\u80FD\u5BFC\u81F4\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u65E0\u6CD5\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u6211\u4EEC\u62DF\u8FBE\u5230\u7684\u670D\u52A1\u6548\u679C\uFF0C\u60A8\u5E94\u7ACB\u5373\u505C\u6B62\u8BBF\u95EE/\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u3002\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u90FD\u8868\u793A\u60A8\u5145\u5206\u7406\u89E3\u548C\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u5305\u62EC\u66F4\u65B0\u7248\u672C\uFF09\u7684\u5168\u90E8\u5185\u5BB9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5C06\u5E2E\u52A9\u60A8\u4E86\u89E3\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E00\u7AE0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E8C\u7AE0 \u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E09\u7AE0 \u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u56DB\u7AE0 \u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u7B2C\u5341\u4E00\u7AE0 \u5176\u4ED6'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E00\u7AE0\xA0\xA0\u5982\u4F55\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u4FE1\u606F\u662F\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\uFF0C\u5982\u59D3\u540D\u3001\u51FA\u751F\u65E5\u671F\u3001\u8EAB\u4EFD\u8BC1\u4EF6\u53F7\u7801\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4F4F\u5740\u3001\u901A\u4FE1\u901A\u8BAF\u8054\u7CFB\u65B9\u5F0F\u3001\u901A\u4FE1\u8BB0\u5F55\u548C\u5185\u5BB9\u3001\u8D26\u53F7\u5BC6\u7801\u3001\u8D22\u4EA7\u4FE1\u606F\u3001\u5F81\u4FE1\u4FE1\u606F\u3001\u884C\u8E2A\u8F68\u8FF9\u3001\u4F4F\u5BBF\u4FE1\u606F\u3001\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4EA4\u6613\u4FE1\u606F\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5982\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\u3001\u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\u3001\u4E2A\u4EBA\u751F\u7269\u8BC6\u522B\u4FE1\u606F\u3001\u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\u3001\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\u53CA\u5176\u4ED6\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E0A\u8FF0\u4FE1\u606F\u6240\u5305\u542B\u7684\u5185\u5BB9\uFF0C\u5747\u51FA\u81EA\u4E8EGB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.1 \u60A8\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1\xA0\u4E3A\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u60A8\u9996\u5148\u9700\u8981\u6CE8\u518C\u624B\u673A\u8D26\u53F7\u5E76\u4EE5\u624B\u673A\u8D26\u53F7\u548C\u9A8C\u8BC1\u7801\u7684\u65B9\u5F0F\u767B\u5F55\uFF08\u201C\u8D26\u53F7\u767B\u5F55\u201D\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.1 \u4F7F\u7528\u624B\u673A\u8D26\u53F7\u767B\u5F55\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u9700\u5411\u6211\u4EEC\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u7801\u3002'),'\u6211\u4EEC\u6536\u96C6\u8FD9\u4E00\u4FE1\u606F\u662F\u4E3A\u4E86\u8BC6\u522B\u548C\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\u3002\u8FD9\u4E5F\u6709\u52A9\u4E8E\u5BBE\u679C\u82F1\u8BED\u5C06\u60A8\u7684\u624B\u673A\u53F7\u7801\u4E0E\u5BBE\u679C\u82F1\u8BED\u8D26\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u6B64\u5B9E\u73B0\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u6570\u636E\u5728\u4E0D\u540C\u8BBE\u5907\u4E4B\u95F4\u7684\u540C\u6B65\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u624B\u673A\u53F7\u7801\uFF0C\u60A8\u5C06\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u767B\u5F55\uFF0C\u4E5F\u65E0\u6CD5\u4EE5\u624B\u673A\u53F7\u7801\u5B9E\u73B0\u6570\u636E\u540C\u6B65\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.2 \u5728\u6CE8\u518C\u5B8C\u6210\u540E\uFF0C\u60A8\u9700\u8981\u586B\u5199',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5E74\u9F84\u3001\u82F1\u8BED\u57FA\u7840\uFF08\u5982\u4E0D\u586B\u5199\uFF0C\u5C06\u53EF\u80FD\u65E0\u6CD5\u83B7\u5F97\u6211\u4EEC\u6B63\u5E38\u63D0\u4F9B\u7684\u670D\u52A1\uFF09\uFF0C'),'\u60A8\u8FD8\u53EF\u4EE5\u9009\u62E9\u4FEE\u6539\u6216\u8865\u5145\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5934\u50CF\u3001\u6635\u79F0\u3001\u5730\u533A\u3001\u5174\u8DA3\u3001\u5BC6\u7801\u3001\u6807\u7B7E\u3001\u7167\u7247'),'\u7B49\u4FE1\u606F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\uFF08\u4F46\u4E0D\u63D0\u4F9B\u8FD9\u4E9B\u4FE1\u606F\u4E0D\u5F71\u54CD\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF09'),'\uFF0C\u8FD9\u4E9B\u4FE1\u606F\u5747\u5C5E\u4E8E\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u3002\u5BF9\u4E8E\u8BE5\u7B49\u8D26\u53F7\u4FE1\u606F\u6240\u6D89\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u4E88\u4EE5\u4FDD\u62A4\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.3 \u56E0\u5B9E\u540D\u5236\u3001\u8EAB\u4EFD\u8BA4\u8BC1\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4E3A\u8BC1\u5B9E\u60A8\u7684\u4E2A\u4EBA\u8EAB\u4EFD\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u8EAB\u4EFD\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u7684\u624B\u673A\u53F7\u7801\u3001\u771F\u5B9E\u59D3\u540D\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u4EBA\u50CF\u7167\u7247\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.1.4 \u60A8\u8D2D\u4E70\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u7684\u6536\u8D39\u4EA7\u54C1\u53CA/\u670D\u52A1\u65F6\u3001\u4E3A\u4E86\u5C65\u884C\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u534F\u8BAE\u5411\u60A8\u63D0\u4F9B\u5BBE\u679C\u82F1\u8BED\u7684\u8BFE\u7A0B\u8BB2\u89E3\u3001\u7763\u5B66\u7FA4\u8FD0\u8425\u670D\u52A1\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u53EF\u80FD\u9700\u8981\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u4F9B\u60A8\u7684\u624B\u673A\u53F7\u3002'),'\u4E3A\u4E86\u5E2E\u52A9\u60A8\u987A\u5229\u5B8C\u6210\u4EA4\u6613\u3001\u4FDD\u969C\u60A8\u7684\u4EA4\u6613\u5B89\u5168\u3001\u67E5\u8BE2\u8BA2\u5355\u4FE1\u606F\u7B49\uFF0C\u5728\u60A8\u4E0B\u5355\u4EA4\u6613\u6216\u4E3A\u4E86\u5B8C\u6210\u4EA4\u6613\u65F6\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u4EA4\u6613\u5546\u54C1/\u670D\u52A1\u4FE1\u606F\u3001\u8BA2\u5355\u53F7\u3001\u4EA4\u6613\u91D1\u989D\u3001\u4EA4\u6613\u65F6\u95F4\u3001\u8054\u7CFB\u7535\u8BDD\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u7B49\u4FE1\u606F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.1.2 \u5728\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u60A8\u53EF\u80FD\u4F1A\u56E0\u8D26\u53F7\u7BA1\u7406\u3001\u4EA7\u54C1\u4F7F\u7528\u7B49\u95EE\u9898\u8054\u7CFB\u5BBE\u679C\u82F1\u8BED\u5BA2\u670D\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u3002\u4E3A\u6B64\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u63D0\u4F9B',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u59D3\u540D\u3001\u624B\u673A\u53F7\u7801\u3001\u624B\u673A\u5145\u503C\u8BB0\u5F55\u3001\u8EAB\u4EFD\u8BC1\u7167\u7247\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u8D2D\u4E70\u8BB0\u5F55\u3001\u652F\u4ED8\u8BB0\u5F55\u3001\u7CFB\u7EDF\u64CD\u4F5C\u8BB0\u5F55\u3001\u7167\u7247\u3001\u82F9\u679C\u652F\u4ED8\u8D26\u53F7\u3001\u4E0E\u5BBE\u679C\u82F1\u8BED\u8FDB\u884C\u8054\u7CFB\u7684\u901A\u4FE1\u8BB0\u5F55\u53CA\u5185\u5BB9'),'\u7B49\u4E0E\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u5BBE\u679C\u82F1\u8BED\u7684\u5BA2\u670D\u4EBA\u5458\u548C\u8BFE\u7A0B\u670D\u52A1\u987E\u95EE\u4E0E\u60A8\u8054\u7CFB\uFF0C\u5E76\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002\u5982\u679C\u60A8\u62D2\u7EDD\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u65E0\u6CD5\u5E2E\u52A9\u60A8\u89E3\u51B3\u76F8\u5173\u95EE\u9898\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.2 \u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u53CA\u7F51\u7EDC\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5F53\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6536\u96C6\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E3A\u60A8\u63D0\u4F9B\u6301\u7EED\u7A33\u5B9A\u7684\u670D\u52A1\u652F\u6301\uFF08\u5982\u6570\u636E\u7684\u5B9E\u65F6\u540C\u6B65\u7B49\uFF09\uFF0C\u540C\u65F6\u6709\u52A9\u4E8E\u5BBE\u679C\u82F1\u8BED\u4E0D\u65AD\u6539\u5584\u81EA\u8EAB\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u4ECE\u800C\u4F7F\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u83B7\u5F97\u6700\u4F18\u4F53\u9A8C\u3002\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u6240\u4F7F\u7528\u7684\u76F8\u5173\u8BBE\u5907\u4FE1\u606F\u5305\u62EC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BBE\u5907\u540D\u79F0\u3001\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u64CD\u4F5C\u7CFB\u7EDF\u548C\u5E94\u7528\u7A0B\u5E8F\u7248\u672C\u53CA\u7C7B\u578B\u3001\u8BED\u8A00\u8BBE\u7F6E\u3001\u5206\u8FA8\u7387\u3001\u79FB\u52A8\u7EC8\u7AEF\u968F\u673A\u5B58\u50A8\u5185\u5B58\u3001\u767B\u5F55IP\u5730\u5740\u3001\u63A5\u5165\u7F51\u7EDC\u7684\u65B9\u5F0F\u3001\u7F51\u7EDC\u8D28\u91CF\u6570\u636E\u3001\u79FB\u52A8\u7F51\u7EDC\u4FE1\u606F\uFF08\u5305\u62EC\u8FD0\u8425\u5546\u540D\u79F0\uFF09\u3001\u65E5\u5FD7\u4FE1\u606F\uFF08\u5982\u64CD\u4F5C\u65E5\u5FD7\u3001\u670D\u52A1\u65E5\u5FD7\uFF09\u7B49\u7B49\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.3\xA0\u5BBE\u679C\u82F1\u8BED\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u6536\u96C6\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.1 \u4E3A\u63D0\u5347\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u4F7F\u7528\u4F53\u9A8C\u548C\u4FBF\u5229\u7A0B\u5EA6\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u901A\u8FC7\u8C03\u7528\u8BBE\u5907\u6743\u9650\u7684\u65B9\u5F0F\u6536\u96C6\u60A8\u7684\u5982\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\u63D0\u4F9B\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u80FD\u65E0\u6CD5\u4F7F\u7528\u4E0E\u63D0\u5347\u7528\u6237\u4F53\u9A8C\u76F8\u5173\u7684\u529F\u80FD\uFF0C\u60A8\u4E5F\u53EF\u80FD\u9700\u8981\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FC7\u7A0B\u4E2D\u624B\u52A8\u91CD\u590D\u586B\u5199\u4E00\u4E9B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.2\xA0\u82E5\u60A8\u5E0C\u671B\u5411\u5BBE\u679C\u82F1\u8BED\u4E0A\u4F20\u60A8\u7684\u5934\u50CF\u53CA/\u6216\u5176\u4ED6\u56FE\u7247\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u5BBE\u679C\u82F1\u8BED\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u4E2D\u7684\u6444\u50CF\u5934\u6216\u8005\u76F8\u518C\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.3\xA0\u82E5\u60A8\u540C\u610F\u5411\u5BBE\u679C\u82F1\u8BED\u4E0A\u4F20\u60A8\u7684\u5F55\u97F3\u8D44\u6599\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u6388\u6743\u5BBE\u679C\u82F1\u8BED\u8C03\u7528\u60A8\u6240\u4F7F\u7528\u8BBE\u5907\u7684\u9EA6\u514B\u98CE\u6743\u9650\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.4\xA0\u82E5\u60A8\u5E0C\u671B\u5B9E\u73B0\u6216\u4F53\u9A8C\u4E0A\u8FF0\u529F\u80FD\uFF0C\u60A8\u53EF\u80FD\u9700\u8981\u5728\u60A8\u7684\u8BBE\u5907\u4E2D\u5411\u5BBE\u679C\u82F1\u8BED\u5F00\u542F\u60A8\u7684\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u3002\u60A8\u4E5F\u53EF\u4EE5\u968F\u65F6\u9009\u62E9\u5173\u95ED\u76F8\u5E94\u8BBF\u95EE\u6743\u9650\u4EE5\u53D6\u6D88\u76F8\u5E94\u6388\u6743\u3002\u5728\u4E0D\u540C\u8BBE\u5907\u4E2D\uFF0C\u6743\u9650\u663E\u793A\u65B9\u5F0F\u53CA\u5173\u95ED\u65B9\u5F0F\u53EF\u80FD\u6709\u6240\u4E0D\u540C\uFF0C\u5177\u4F53\u8BF7\u53C2\u8003\u8BBE\u5907\u53CA\u7CFB\u7EDF\u5F00\u53D1\u65B9\u7684\u8BF4\u660E\u6216\u6307\u5F15\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.5\xA0\u4E3A\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u9700\u8981\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5BBE\u679C\u82F1\u8BED\u4F1A\u5728\u6240\u6709\u7684\u8BFE\u7A0B\u5185\u6536\u5F55\u60A8\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599\uFF0C'),'\u5E76\u53EF\u80FD\u4F1A\u5728\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\uFF08\u5B66\u4E60\u62A5\u544A/\u5B9D\u8D1D\u79C0\u7B49\uFF09\u663E\u793A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u6027\u522B\u3001\u5934\u50CF\u3001\u6635\u79F0\u3001\u5728\u5BBE\u679C\u82F1\u8BED\u4E2D\u5F62\u6210\u7684\u97F3\u89C6\u9891\u7B49\u5F71\u97F3\u8D44\u6599'),'\u7B49\uFF09\u4EE5\u4F9B\u5176\u4ED6\u7528\u6237\u67E5\u770B\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.6\xA0\u4E3A\u5B66\u672F\u7814\u7A76\u3001\u5E94\u7528\u7814\u7A76\u7684\u9700\u8981\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u91C7\u96C6\u60A8\u63D0\u4F9B\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u751F\u65E5\u3001\u804C\u4E1A\u3001\u6027\u522B\u3001\u5174\u8DA3\u3001\u5728\u5BBE\u679C\u82F1\u8BED\u4E2D\u5F62\u6210\u7684\u5F55\u97F3\u7B49\u8D44\u6599\u548C\u4FE1\u606F'),'\uFF0C\u4F46\u5BBE\u679C\u82F1\u8BED\u627F\u8BFA\u6B64\u7C7B\u7814\u7A76\u4E2D\u4F1A\u505A\u53BB\u6807\u8BC6\u5316\u6216\u4F5C\u533F\u540D\u5316\u5904\u7406\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.3.7\xA0\u4E3A\u5411\u60A8\u63A8\u8350\u5408\u9002\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u548C\u5C65\u884C\u53CC\u65B9\u95F4\u7B7E\u8BA2\u7684\u534F\u8BAE\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u91C7\u96C6\u60A8\u7684\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF0C\u5305\u62EC\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6D4F\u89C8\u8BB0\u5F55\u3001\u4F7F\u7528\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u3001\u5B66\u4E60\u6570\u636E\uFF1B\u8FD8\u5C06\u53EF\u80FD\u9700\u8981\u60A8\u63D0\u4F9B\u6210\u7EE9\u5355'),'\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.4 \u7B2C\u4E09\u65B9\u5411\u60A8\u6536\u96C6\u7684\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.1 \u82F9\u679C\u652F\u4ED8\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5411\u5BBE\u679C\u82F1\u8BED\u4ED8\u6B3E\u7684\u65B9\u5F0F\u83B7\u53D6\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u7684\u4EA7\u54C1\u53CA\u865A\u62DF\u4EA7\u54C1\uFF0C\u5305\u62EC\u94BB\u77F3\u3001\u8BFE\u7A0B\u670D\u52A1\u7B49\u3002\u4E0A\u8FF0\u4ED8\u6B3E\u670D\u52A1\u5C06\u7531\u5BBE\u679C\u82F1\u8BED\u4EE5\u5916\u7684\u82F9\u679C\u516C\u53F8\u63D0\u4F9B\uFF0C\u5BBE\u679C\u82F1\u8BED\u5E76\u4E0D\u4F1A\u83B7\u53D6\u4E0E\u60A8\u4ED8\u6B3E\u76F8\u5173\u7684\u5BC6\u7801\u7B49\u4FE1\u606F\u3002\u4F46\u53EF\u80FD\u4ECE\u60A8\u6216\u82F9\u679C\u652F\u4ED8\u83B7\u5F97\u60A8\u7684\u82F9\u679C\u652F\u4ED8\u8D26\u6237\u4FE1\u606F\u3002\u82E5\u60A8\u5E0C\u671B\u4E86\u89E3\u82F9\u679C\u652F\u4ED8\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u5177\u4F53\u89C4\u5219\uFF0C\u8BF7\u67E5\u9605\u60A8\u9009\u62E9\u7684\u82F9\u679C\u652F\u4ED8\u670D\u52A1\u7684\u9690\u79C1\u653F\u7B56\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.4.2 \u7B2C\u4E09\u65B9\u5E7F\u544A\u63A8\u9001\u7B49\u670D\u52A1\u63D0\u4F9B\u5546\u6536\u96C6\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u5408\u4F5C\uFF0C\u5728\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63A5\u5165\u7B2C\u4E09\u65B9\u670D\u52A1\uFF08\u4F8B\u5982\u6295\u653E\u5E7F\u544A\u3001\u94FE\u63A5\u6216\u8005\u5176\u5B83\u5F62\u5F0F\u7684\u63A8\u5E7F\u5185\u5BB9\uFF09\u3002\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u60A8\u63D0\u4F9B\u7ED9\u5BBE\u679C\u82F1\u8BED\u6216\u8005\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u624B\u673A\u53F7\u7801\u3001\u6635\u79F0\u3001\u5934\u50CF\u7B49\uFF09\u4E0E\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5171\u4EAB\uFF0C\u4E5F\u4E0D\u4F1A\u4EE3\u8868\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u4E3A\u5176\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u63A5\u5165\u7684\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u53EF\u80FD\u6709\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\uFF0C\u5176\u4E0D\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u675F\u3002\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u5546\u53EF\u80FD\u4F1A\u6839\u636E\u5176\u81EA\u5DF1\u7684\u9690\u79C1\u653F\u7B56\u6536\u96C6\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u7B2C\u4E09\u65B9\u670D\u52A1\u5546\u5728\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u5BBE\u679C\u82F1\u8BED\u65E0\u6CD5\u4FDD\u8BC1\u5176\u4E00\u5B9A\u4F1A\u6309\u7167\u6211\u4EEC\u63D0\u51FA\u7684\u8981\u6C42\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'1.5\xA0\u60A8\u5145\u5206\u77E5\u6653\uFF0C\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u65E0\u9700\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.1 \u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.2 \u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.4 \u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.5 \u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.6 \u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.7 \u6839\u636E\u60A8\u8981\u6C42\u7B7E\u8BA2\u548C\u5C65\u884C\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.8 \u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.5.9 \u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1.6\xA0\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u5411\u7B2C\u4E09\u65B9\u63D0\u4F9B\u7ECF\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u786E\u4FDD\u6570\u636E\u63A5\u6536\u65B9\u65E0\u6CD5\u590D\u539F\u5E76\u91CD\u65B0\u8BC6\u522B\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u7684\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u7684\u5BF9\u5916\u5171\u4EAB\u3001\u8F6C\u8BA9\u53CA\u516C\u5F00\u62AB\u9732\u884C\u4E3A\uFF0C\u5BF9\u6B64\u7C7B\u6570\u636E\u7684\u4FDD\u5B58\u53CA\u5904\u7406\u5C06\u65E0\u9700\u53E6\u884C\u5411\u60A8\u901A\u77E5\u5E76\u5F81\u5F97\u60A8\u7684\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E8C\u7AE0\xA0\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5728\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u540E\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u6839\u636E\u5982\u4E0B\u89C4\u5219\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.1 \u4F1A\u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u7EA6\u5B9A\u5E76\u4E3A\u5B9E\u73B0\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u529F\u80FD\u5BF9\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u4F7F\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.2 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u8BF7\u60A8\u6CE8\u610F\uFF0C\u5BF9\u4E8E\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u6240\u63D0\u4F9B\u7684\u6240\u6709\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u60A8\u5220\u9664\u6216\u901A\u8FC7\u76F8\u5173\u8BBE\u7F6E\u62D2\u7EDD\u6211\u4EEC\u6536\u96C6\uFF0C\u5426\u5219\u60A8\u5C06\u5728\u4F7F\u7528\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\u3001\u8D26\u53F7\u6CE8\u9500\u524D\u6301\u7EED\u6388\u6743\u6211\u4EEC\u4F7F\u7528'),'\u3002\u4F46\u5728\u60A8\u6CE8\u9500\u8D26\u53F7\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u505C\u6B62\u4F7F\u7528\u5E76\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'2.3 \u5BBE\u679C\u82F1\u8BED\u4F1A\u5BF9\u65D7\u4E0B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u7EDF\u8BA1\uFF0C\u5E76\u53EF\u80FD\u4F1A\u4E0E\u516C\u4F17\u6216\u7B2C\u4E09\u65B9\u5171\u4EAB\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\uFF0C\u4EE5\u5C55\u793A\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u6574\u4F53\u4F7F\u7528\u8D8B\u52BF\u3002\u4F46\u8FD9\u4E9B\u7EDF\u8BA1\u4FE1\u606F\u4E0D\u4F1A\u5305\u542B\u60A8\u7684\u4EFB\u4F55\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'2.4 \u5F53\u5BBE\u679C\u82F1\u8BED\u8981\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7528\u4E8E\u672C\u653F\u7B56\u672A\u8F7D\u660E\u7684\u5176\u5B83\u7528\u9014\u65F6\uFF0C\u6216\u5C06\u57FA\u4E8E\u7279\u5B9A\u76EE\u7684\u6536\u96C6\u800C\u6765\u7684\u4FE1\u606F\u7528\u4E8E\u5176\u4ED6\u76EE\u7684\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u4E3B\u52A8\u4E8B\u5148\u5F81\u6C42\u60A8\u7684\u660E\u793A\u540C\u610F\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E09\u7AE0\xA0\u5C06\u5982\u4F55\u4F7F\u7528Cookie\u548C\u540C\u7C7B\u6280\u672F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'3.1 \u4E3A\u4E86\u66F4\u597D\u5730\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F7F\u7528\u4E86\u82E5\u5E72\u81EA\u52A8\u6570\u636E\u6536\u96C6\u5DE5\u5177\uFF0C\u76EE\u524D\u5305\u62ECFlash Cookies\u548C\u5185\u5D4CWeb\u94FE\u63A5\u3002\u501F\u52A9\u8FD9\u4E9B\u6280\u672F\uFF0C\u5BBE\u679C\u82F1\u8BED\u80FD\u591F\u5B9E\u65F6\u8DDF\u8E2A\u60A8\u7684\u5B66\u4E60\u8FDB\u5EA6\uFF0C\u5E76\u4E86\u89E3\u60A8\u7684\u504F\u597D\u4FE1\u606F\uFF0C\u4ECE\u800C\u4E3A\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u3001\u66F4\u4E2A\u6027\u5316\u7684\u7528\u6237\u4F53\u9A8C\u3002\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u4E0A\u8FF0\u6280\u672F\u7528\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002\u8BF7\u60A8\u7406\u89E3\uFF0C\u5BBE\u679C\u82F1\u8BED\u7684\u67D0\u4E9B\u670D\u52A1\u53EA\u80FD\u901A\u8FC7\u4F7F\u7528\u4E0A\u8FF0\u6280\u672F\u624D\u53EF\u5F97\u5230\u5B9E\u73B0\u3002\u5982\u60A8\u7684\u8BBE\u5907\u6216\u76F8\u5173\u7A0B\u5E8F\u5141\u8BB8\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6539\u53D8\u8BBE\u7F6E\uFF0C\u6216\u901A\u8FC7\u8BBF\u95EE\u63D0\u4F9B\u5546\u7684\u7F51\u9875\u7B49\u5408\u9002\u7684\u65B9\u5F0F\uFF0C\u6765\u5173\u95ED\u6216\u5220\u9664\u4E0A\u8FF0\u6280\u672F\u3002\u4F46\u8FD9\u4E00\u4E3E\u52A8\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u56DB\u7AE0\xA0\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5171\u4EAB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1 \u5BBE\u679C\u82F1\u8BED\u5C06\u4E25\u683C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4FDD\u5BC6\u3002\u9664\u4EE5\u4E0B\u60C5\u51B5\u5916\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5411\u5176\u4ED6\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.2 \u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\uFF0C\u6216\u57FA\u4E8E\u53F8\u6CD5\u6216\u884C\u653F\u4E3B\u7BA1\u90E8\u95E8\u7684\u5F3A\u5236\u6027\u8981\u6C42\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.3 \u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u4E3A\u7EF4\u62A4\u60A8\u6216\u5176\u4ED6\u5BBE\u679C\u82F1\u8BED\u7528\u6237\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u5408\u6CD5\u6743\u76CA\u6216\u662F\u793E\u4F1A\u516C\u5171\u5229\u76CA\u800C\u6709\u5FC5\u8981\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.4 \u5E94\u60A8\u7684\u76D1\u62A4\u4EBA\u7684\u5408\u6CD5\u8981\u6C42\u800C\u63D0\u4F9B\u60A8\u7684\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.5 \u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.6 \u6839\u636E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5171\u4EAB\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.1.7 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u57FA\u4E8E\u60A8\u7684\u76F8\u5E94\u6388\u6743\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u7BA1\u7406\u516C\u53F8\u7684\u5173\u8054\u65B9\u5171\u4EAB\u3002\u4F46\u5BBE\u679C\u82F1\u8BED\u53EA\u4F1A\u5171\u4EAB\u5FC5\u8981\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4E14\u53D7\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u8FF0\u76EE\u7684\u4E4B\u7EA6\u675F'),'\u3002\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u7684\u5173\u8054\u65B9\u8981\u6539\u53D8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5904\u7406\u76EE\u7684\uFF0C\u5C06\u9002\u65F6\u5411\u60A8\u5F81\u5F97\u660E\u793A\u540C\u610F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.2 \u5BF9\u5BBE\u679C\u82F1\u8BED\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u5C06\u5C3D\u5408\u7406\u7684\u52AA\u529B\u8981\u6C42\u5176\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u65F6\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5C3D\u529B\u8981\u6C42\u5176\u91C7\u53D6\u76F8\u5173\u7684\u4FDD\u5BC6\u548C\u5B89\u5168\u63AA\u65BD\uFF0C\u4EE5\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8F6C\u8BA9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3\xA0\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.1 \u4E8B\u5148\u83B7\u5F97\u60A8\u660E\u786E\u7684\u540C\u610F\u6216\u6388\u6743\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.2\xA0\u6839\u636E\u9002\u7528\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u7684\u8981\u6C42\u3001\u5F3A\u5236\u6027\u7684\u884C\u653F\u6216\u53F8\u6CD5\u8981\u6C42\u800C\u5FC5\u987B\u8FDB\u884C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.3\xA0\u6839\u636E\u4E0E\u60A8\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE\uFF08\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u4EE5\u53CA\u76F8\u5E94\u7684\u5E73\u53F0\u89C4\u5219\uFF09\u6216\u5176\u4ED6\u7684\u6CD5\u5F8B\u6587\u4EF6\u7EA6\u5B9A\u800C\u63D0\u4F9B\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.3.4 \u5728\u6D89\u53CA\u6536\u8D2D\u3001\u517C\u5E76\u3001\u7834\u4EA7\u6E05\u7B97\u3001\u91CD\u7EC4\u7B49\u91CD\u5927\u53D8\u66F4\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7684\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u6216\u7EC4\u7EC7\u7EE7\u7EED\u5C65\u884C\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u9879\u4E0B\u7684\u8D23\u4EFB\u548C\u4E49\u52A1\u3002\u5982\u53D8\u66F4\u540E\u7684\u4E3B\u4F53\u9700\u53D8\u66F4\u4E2A\u4EBA\u4FE1\u606F\u4F7F\u7528\u76EE\u7684\uFF0C\u6211\u4EEC\u4F1A\u8981\u6C42\u5176\u4E8B\u5148\u83B7\u5F97\u60A8\u7684\u660E\u793A\u540C\u610F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u516C\u5F00\u62AB\u9732'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4\xA0\u5BBE\u679C\u82F1\u8BED\u4EC5\u4F1A\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\uFF0C\u4E14\u5728\u91C7\u53D6\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u7684\u524D\u63D0\u4E0B\uFF0C\u624D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.1 \u6839\u636E\u60A8\u7684\u9700\u6C42\uFF0C\u5728\u60A8\u660E\u786E\u540C\u610F\u7684\u62AB\u9732\u65B9\u5F0F\u4E0B\u62AB\u9732\u60A8\u6240\u6307\u5B9A\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'4.4.2 \u6839\u636E\u6CD5\u5F8B\u3001\u6CD5\u89C4\u7684\u8981\u6C42\u3001\u884C\u653F\u6216\u53F8\u6CD5\u673A\u5173\u7684\u5F3A\u5236\u6027\u8981\u6C42\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5F53\u5BBE\u679C\u82F1\u8BED\u6536\u5230\u4E0A\u8FF0\u62AB\u9732\u8BF7\u6C42\u65F6\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u4F9D\u6CD5\u8981\u6C42\u8BF7\u6C42\u65B9\u51FA\u5177\u76F8\u5173\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u5982\u4F20\u7968\u6216\u534F\u52A9\u8C03\u67E5\u51FD\u7B49\u3002\u5BBE\u679C\u82F1\u8BED\u4F1A\u614E\u91CD\u5BA1\u67E5\u6BCF\u4E00\u4E2A\u62AB\u9732\u8BF7\u6C42\uFF0C\u4EE5\u786E\u4FDD\u8BE5\u7B49\u62AB\u9732\u8BF7\u6C42\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u3002\u5728\u6CD5\u5F8B\u6CD5\u89C4\u8BB8\u53EF\u7684\u524D\u63D0\u4E0B\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u5BF9\u5305\u542B\u62AB\u9732\u4FE1\u606F\u7684\u6587\u4EF6\u91C7\u53D6\u52A0\u5BC6\u4FDD\u62A4\u7B49\u63AA\u65BD\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E94\u7AE0\xA0\u5982\u4F55\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1\xA0\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u91CD\u89C6\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\uFF0C\u5E76\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u6301\u7EED\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u9632\u5176\u4ED6\u4EBA\u5728\u672A\u7ECF\u6388\u6743\u7684\u60C5\u51B5\u4E0B\u8BBF\u95EE\u3001\u7BE1\u6539\u6216\u62AB\u9732\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.1 \u5BBE\u679C\u82F1\u8BED\u5DF2\u91C7\u7528\u7B26\u5408\u884C\u4E1A\u6807\u51C6\u7684\u5B89\u5168\u9632\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9632\u6B62\u6570\u636E\u906D\u5230\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F8B\u5982\uFF0C\u5728\u60A8\u7684\u79FB\u52A8\u8BBE\u5907\u4E0E\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E4B\u95F4\u4EA4\u6362\u6570\u636E\u65F6\u8FDB\u884CSSL\u52A0\u5BC6\u4FDD\u62A4\uFF1B\u6211\u4EEC\u4F1A\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.1.2 \u5BBE\u679C\u82F1\u8BED\u4EC5\u5141\u8BB8\u6709\u5FC5\u8981\u77E5\u6653\u7684\u4EBA\u5458\u8BBF\u95EE\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4E3A\u6B64\u8BBE\u7F6E\u4E86\u4E25\u683C\u7684\u8BBF\u95EE\u6743\u9650\u63A7\u5236\u548C\u76D1\u63A7\u673A\u5236\u3002\u5BBE\u679C\u82F1\u8BED\u540C\u65F6\u8981\u6C42\u53EF\u80FD\u63A5\u89E6\u5230\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u6240\u6709\u4EBA\u5458\u5C65\u884C\u76F8\u5E94\u7684\u4FDD\u5BC6\u4E49\u52A1\u3002\u5982\u679C\u672A\u80FD\u5C65\u884C\u8FD9\u4E9B\u4E49\u52A1\uFF0C\u53EF\u80FD\u4F1A\u88AB\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u6216\u88AB\u7EC8\u6B62\u4E0E\u5BBE\u679C\u82F1\u8BED\u7684\u76F8\u5E94\u6CD5\u5F8B\u5173\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.2 \u5BBE\u679C\u82F1\u8BED\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u786E\u4FDD\u672A\u6536\u96C6\u65E0\u5173\u7684\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.3 \u8BF7\u60A8\u7406\u89E3\uFF0C\u7531\u4E8E\u6280\u672F\u7684\u9650\u5236\u4EE5\u53CA\u53EF\u80FD\u5B58\u5728\u7684\u5404\u79CD\u6076\u610F\u624B\u6BB5\uFF0C\u5728\u4E92\u8054\u7F51\u884C\u4E1A\uFF0C\u5373\u4FBF\u6211\u4EEC\u7AED\u5C3D\u6240\u80FD\u52A0\u5F3A\u5B89\u5168\u63AA\u65BD\uFF0C\u4F46\u4E5F\u4E0D\u53EF\u80FD\u59CB\u7EC8\u4FDD\u8BC1\u4FE1\u606F\u767E\u5206\u4E4B\u767E\u7684\u7EDD\u5BF9\u5B89\u5168\u3002\u60A8\u9700\u8981\u4E86\u89E3\u548C\u77E5\u6089\uFF0C\u60A8\u63A5\u5165\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u7528\u7684\u7CFB\u7EDF\u548C\u901A\u8BAF\u7F51\u7EDC\uFF0C\u6709\u53EF\u80FD\u56E0\u6211\u4EEC\u53EF\u63A7\u8303\u56F4\u5916\u7684\u5176\u4ED6\u56E0\u7D20\u800C\u51FA\u73B0\u95EE\u9898\uFF0C\u5728\u6B64\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u4F9D\u6CD5\u5C3D\u529B\u534F\u52A9\u89E3\u51B3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5.4 \u5982\u4E0D\u5E78\u53D1\u751F\u4FE1\u606F\u5B89\u5168\u4E8B\u6545\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\uFF0C\u53CA\u65F6\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u548C\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u7B49\u3002\u6211\u4EEC\u540C\u65F6\u5C06\u53CA\u65F6\u5C06\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u9002\u5408\u7684\u65B9\u5F0F\u544A\u77E5\u60A8\uFF1B\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002\u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E3B\u52A8\u4E0A\u62A5\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516D\u7AE0\xA0\u5982\u4F55\u4FDD\u5B58\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u671F\u9650'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.1\u5728\u7528\u6237\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u671F\u95F4\uFF0C\u5BBE\u679C\u82F1\u8BED\u4F1A\u6301\u7EED\u4FDD\u5B58\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.2\u5BBE\u679C\u82F1\u8BED\u627F\u8BFA\u59CB\u7EC8\u6309\u7167\u6CD5\u5F8B\u7684\u89C4\u5B9A\u5728\u5408\u7406\u5FC5\u8981\u671F\u9650\u5185\u5728\u5B58\u50A8\u60A8\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5BF9\u4E8E\u65E5\u5FD7\u4FE1\u606F\u3001\u8BB0\u5F55\u5907\u4EFD\u7B49\u4FE1\u606F\u4E3A\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4F46\u6839\u636E\u6CD5\u5F8B\u89C4\u5B9A\u6709\u6700\u77ED\u4FDD\u5B58\u671F\u9650\u8981\u6C42\u7684\uFF0C\u5219\u6211\u4EEC\u4F1A\u4FDD\u5B58\u6CD5\u5F8B\u8981\u6C42\u7684\u6700\u77ED\u671F\u9650\uFF09\uFF1B\u4EA4\u6613\u4FE1\u606F\u4E3A\u4EA4\u6613\u5B8C\u6210\u65E5\u8D77\u4E09\u5E74\u6216\u60A8\u6CE8\u9500\u8D26\u53F7\u540E180\u5929\uFF08\u4EE5\u8F83\u957F\u8005\u4E3A\u51C6\uFF09\u3002\u5728\u8D85\u51FA\u4E0A\u8FF0\u671F\u9650\u540E\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u8FDB\u884C\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4FDD\u5B58\u5730\u57DF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.3\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5C06\u5168\u90E8\u88AB\u5B58\u50A8\u4E8E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'6.4\u76EE\u524D\u6211\u4EEC\u4E0D\u5B58\u5728\u5411\u5883\u5916\u63D0\u4F9B\u4E2A\u4EBA\u4FE1\u606F\u7684\u573A\u666F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E03\u7AE0\xA0\u7BA1\u7406\u3001\u67E5\u770B\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u5C0A\u91CD\u60A8\u5BF9\u81EA\u5DF1\u7684\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002\u6211\u4EEC\u4FDD\u969C\u60A8\u5BF9\u4E2A\u4EBA\u4FE1\u606F\u6240\u4EAB\u6709\u7684\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u3001\u7BA1\u7406\u7B49\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BBF\u95EE\u548C\u66F4\u6B63\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1\xA0\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u4E4B\u5916\uFF0C\u60A8\u6709\u6743\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u6743\u3002\u5F53\u60A8\u53D1\u73B0\u6211\u4EEC\u5904\u7406\u5173\u4E8E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6709\u9519\u8BEF\u6216\u8005\u60A8\u6709\u5176\u4ED6\u4FEE\u6539\u3001\u8865\u5145\u9700\u6C42\u65F6\uFF0C\u60A8\u4E5F\u6709\u6743\u8981\u6C42\u6211\u4EEC\u6216\u81EA\u884C\u4E88\u4EE5\u66F4\u6B63\u3002\u60A8\u884C\u4F7F\u6570\u636E\u8BBF\u95EE\u548C\u66F4\u6B63\u6743\u7684\u65B9\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.1 \u5982\u679C\u60A8\u5E0C\u671B\u8BBF\u95EE\u6216\u4FEE\u6539\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u7684\u8D26\u53F7\u4FE1\u606F\uFF0C\u5305\u62EC\u5934\u50CF\u3001\u6635\u79F0\u3001\u6027\u522B\u3001\u751F\u65E5\u7B49\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8FDB\u884C\u64CD\u4F5C\uFF08\u53EF\u901A\u8FC7\u70B9\u51FB\u201C\u6211\u7684\u201D\uFF0C\u8FDB\u5165\u4E2A\u4EBA\u4E3B\u9875\u540E\uFF0C\u70B9\u51FB\u6635\u79F0\u533A\u57DF\u540E\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF09\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.1.2 \u5982\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u63D0\u4F9B\u53D1\u8868\u8BDD\u9898\u3001\u53C2\u4E0E\u8BA8\u8BBA\u3001\u7559\u8A00\u7B49\u529F\u80FD\u5E76\u4F7F\u5F97\u60A8\u6709\u673A\u4F1A\u901A\u8FC7\u8FD9\u4E9B\u670D\u52A1\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5219\u5BBE\u679C\u82F1\u8BED\u5728\u63D0\u4F9B\u524D\u8FF0\u670D\u52A1\u7684\u540C\u65F6\u4F1A\u63D0\u4F9B\u76F8\u5E94\u7684\u529F\u80FD\u786E\u4FDD\u60A8\u53EF\u4EE5\u518D\u6B21\u8BBF\u95EE\u6216\u5220\u9664\u60A8\u5728\u524D\u8FF0\u670D\u52A1\u8FC7\u7A0B\u4E2D\u516C\u5F00\u6216\u63D0\u4F9B\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.2\xA0\u60A8\u6709\u6743\u77E5\u6089\u901A\u8FC7\u5BBE\u679C\u82F1\u8BED\u83B7\u5F97\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u653F\u7B56\u7B2C\u4E00\u7AE0\u548C\u7B2C\u56DB\u7AE0\u4E86\u89E3\u7B2C\u4E09\u65B9\u7684\u8EAB\u4EFD\u6216\u7C7B\u578B\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u53CA\u64A4\u56DE\u5DF2\u540C\u610F\u7684\u6388\u6743'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\uF0B7\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u51FA\u5220\u9664\u4E2A\u4EBA\u4FE1\u606F\u7684\u8BF7\u6C42\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.1\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u76F8\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.2\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5374\u672A\u5F81\u5F97\u60A8\u7684\u540C\u610F\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.3\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u4E0E\u60A8\u7684\u7EA6\u5B9A\u6216\u6CD5\u5F8B\u7684\u89C4\u5B9A\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.4\xA0\u5982\u679C\u60A8\u4E0D\u518D\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u6216\u8005\u60A8\u6CE8\u9500\u4E86\u76F8\u5173\u8D26\u53F7\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.3.5\xA0\u5982\u679C\u5BBE\u679C\u82F1\u8BED\u4E0D\u518D\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.4 \u60A8\u6709\u6743\u5411\u5BBE\u679C\u82F1\u8BED\u64A4\u56DE\u60A8\u6B64\u524D\u4F5C\u51FA\u7684\u6709\u5173\u540C\u610F\u6536\u96C6\u3001\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u6388\u6743\u3002\u5F53\u60A8\u64A4\u56DE\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u5C06\u4E0D\u518D\u5904\u7406\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u3002\u4F46\u60A8\u64A4\u56DE\u540C\u610F\u7684\u51B3\u5B9A\uFF0C\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u800C\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u6D3B\u52A8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.5\xA0\u60A8\u53EF\u4EE5\u901A\u8FC7\u5220\u9664\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\u7684\u65B9\u5F0F\u64A4\u56DE\u60A8\u6B64\u524D\u5C31\u7279\u5B9A\u4E2A\u4EBA\u4FE1\u606F\u800C\u5BF9\u6211\u4EEC\u4F5C\u51FA\u7684\u540C\u610F\u6388\u6743\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6CE8\u9500\u8D26\u53F7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.6\xA0\u60A8\u6709\u6743\u968F\u65F6\u6CE8\u9500\u60A8\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u4E2D\u6CE8\u518C\u7684\u8D26\u53F7\u3002\u4E3A\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u60A8\u9700\u8981\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u5BBE\u679C\u82F1\u8BED\u63D0\u51FA\u60A8\u7684\u8D26\u53F7\u6CE8\u9500\u8BF7\u6C42\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5728\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u540E\u5BF9\u60A8\u7684\u8BF7\u6C42\u4F5C\u51FA\u54CD\u5E94')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'7.7\xA0\u8BF7\u60A8\u6CE8\u610F\uFF0C\u6CE8\u9500\u5BBE\u679C\u82F1\u8BED\u76F8\u5173\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u8D26\u53F7\u662F\u4E0D\u53EF\u6062\u590D\u7684\u64CD\u4F5C\u3002\u5728\u6CE8\u9500\u8D26\u53F7\u4E4B\u540E\uFF0C\u6211\u4EEC\u5C06\u505C\u6B62\u4E3A\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\uFF0C\u5E76\u5C06\u5220\u9664\u8BE5\u8D26\u53F7\u9879\u4E0B\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u9664\u975E\u6CD5\u5F8B\u6CD5\u89C4\u53E6\u6709\u89C4\u5B9A\u3002'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.8\xA0\u5728\u5BBE\u679C\u82F1\u8BED\u4EC5\u4F9D\u636E\u4FE1\u606F\u7CFB\u7EDF\u3001\u7B97\u6CD5\u7B49\u5728\u5185\u7684\u975E\u4EBA\u5DE5\u81EA\u52A8\u51B3\u7B56\u673A\u5236\u505A\u51FA\u51B3\u5B9A\uFF0C\u5E76\u4E14\u8FD9\u4E9B\u51B3\u5B9A\u663E\u8457\u5F71\u54CD\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u60A8\u6709\u6743\u8981\u6C42\u5BBE\u679C\u82F1\u8BED\u505A\u51FA\u89E3\u91CA\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E5F\u5C06\u63D0\u4F9B\u9002\u5F53\u7684\u6551\u6D4E\u65B9\u5F0F\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u83B7\u53D6\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.9\xA0\u6839\u636E\u60A8\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u4EE5\u5411\u60A8\u63D0\u4F9B\u5BBE\u679C\u82F1\u8BED\u6301\u6709\u7684\u6709\u5173\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u526F\u672C\uFF08\u5982\u4E2A\u4EBA\u57FA\u672C\u8D44\u6599\uFF09\u3002\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u6761\u6B3E\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u5411\u6211\u4EEC\u63D0\u51FA\u8BF7\u6C42\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u54CD\u5E94\u60A8\u7684\u4E0A\u8FF0\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.10\u5982\u679C\u60A8\u5BF9\u5BBE\u679C\u82F1\u8BED\u5728\u4EE5\u4E0A\u5217\u660E\u7684\u6709\u5173\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u53CA\u64A4\u56DE\u540C\u610F\u3001\u6CE8\u9500\u8D26\u53F7\u3001\u7EA6\u675F\u4FE1\u606F\u7CFB\u7EDF\u81EA\u52A8\u51B3\u7B56\u65B9\u6CD5\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u6216\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7B2C\u5341\u7AE0\u8F7D\u660E\u7684\u8054\u7CFB\u65B9\u5F0F\u4E0E\u6211\u4EEC\u53D6\u5F97\u8054\u7CFB\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.11\xA0\u5BF9\u4E8E\u60A8\u5408\u7406\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u539F\u5219\u4E0A\u4E0D\u6536\u53D6\u8D39\u7528\uFF0C\u4F46\u5BF9\u591A\u6B21\u91CD\u590D\u3001\u8D85\u51FA\u5408\u7406\u9650\u5EA6\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u89C6\u60C5\u51B5\u6536\u53D6\u4E00\u5B9A\u6210\u672C\u8D39\u7528\u3002\u5BF9\u4E8E\u90A3\u4E9B\u65E0\u7AEF\u91CD\u590D\u3001\u9700\u8981\u8FC7\u591A\u6280\u672F\u624B\u6BB5\u3001\u7ED9\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u5E26\u6765\u98CE\u9669\u6216\u8005\u975E\u5E38\u4E0D\u5207\u5B9E\u9645\u7684\u8BF7\u6C42\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E88\u4EE5\u62D2\u7EDD\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12\xA0\u5728\u4EE5\u4E0B\u60C5\u5F62\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u65E0\u6CD5\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.1\xA0\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.2\xA0\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.3\xA0\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u548C\u5BA1\u5224\u7B49\u6709\u5173\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.4\xA0\u6709\u8BC1\u636E\u8868\u660E\u60A8\u5B58\u5728\u4E3B\u89C2\u6076\u610F\u6216\u6EE5\u7528\u6743\u5229\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.5\xA0\u54CD\u5E94\u60A8\u7684\u8BF7\u6C42\u5C06\u5BFC\u81F4\u5176\u4ED6\u4E2A\u4EBA\u3001\u7EC4\u7EC7\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u4E25\u91CD\u635F\u5BB3\u7684\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.12.6\xA0\u6D89\u53CA\u5546\u4E1A\u79D8\u5BC6\u7684\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7533\u8BC9\u673A\u5236'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'7.13 \u5BBE\u679C\u82F1\u8BED\u5DF2\u7ECF\u5EFA\u7ACB\u7533\u8BC9\u7BA1\u7406\u673A\u5236\uFF0C\u5305\u62EC\u8DDF\u8E2A\u6D41\u7A0B\u7B49\u3002\u4E3A\u4E86\u4FDD\u969C\u8D26\u53F7\u53CA\u8D22\u4EA7\u5B89\u5168\uFF0C\u5BBE\u679C\u82F1\u8BED\u53EF\u80FD\u4F1A\u4E0E\u60A8\u6838\u5B9E\u76F8\u5173\u4FE1\u606F\u3002\u5BBE\u679C\u82F1\u8BED\u5C06\u5728\u6536\u5230\u60A8\u7684\u53CD\u9988\u540E\u5C3D\u5FEB\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\uFF0C\u6700\u957F\u4E0D\u8D85\u8FC730\u5929\u3002\u82E5\u60A8\u5BF9\u7B54\u590D\u610F\u89C1\u4E0D\u6EE1\u610F\uFF0C\u60A8\u53EF\u4EE5\u518D\u6B21\u901A\u8FC7\u5BA2\u6237\u670D\u52A1\u8FDB\u884C\u7533\u8BC9\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u516B\u7AE0\xA0\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.1\xA0\u5BBE\u679C\u82F1\u8BED\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u5982\u679C\u60A8\u662F\u672A\u6EE118\u5468\u5C81\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5E94\u5728\u76D1\u62A4\u4EBA\u76D1\u62A4\u3001\u6307\u5BFC\u5E76\u83B7\u5F97\u76D1\u62A4\u4EBA\u540C\u610F\u60C5\u51B5\u4E0B\u4ED4\u7EC6\u9605\u8BFB\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u548C\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.2\xA0\u5982\u679C\u60A8/\u60A8\u7684\u76D1\u62A4\u4EBA\u4E0D\u540C\u610F\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u60A8\u5E94\u8BE5\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'8.3\xA0\u82E5\u60A8\u662F\u672A\u6210\u5E74\u4EBA\u7684\u76D1\u62A4\u4EBA\uFF0C\u5F53\u60A8\u5BF9\u60A8\u6240\u76D1\u62A4\u7684\u672A\u6210\u5E74\u4EBA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6216\u5176\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u7528\u6237\u4FE1\u606F\u6709\u4EFB\u4F55\u7591\u95EE\u65F6\uFF0C\u8BF7\u60A8\u53CA\u65F6\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002\u6211\u4EEC\u5C06\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u672C\u653F\u7B56\u7684\u89C4\u5B9A\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u7528\u6237\u4FE1\u606F\u7684\u4FDD\u5BC6\u6027\u53CA\u5B89\u5168\u6027\u3002\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u4E5D\u7AE0\xA0\u672C\u653F\u7B56\u5982\u4F55\u66F4\u65B0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1\xA0\u5982\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u53D1\u751F\u4EE5\u4E0B\u53D8\u5316\uFF0C\u5BBE\u679C\u82F1\u8BED\u5C06\u53CA\u65F6\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u8FDB\u884C\u76F8\u5E94\u7684\u4FEE\u8BA2\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.1\xA0\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u6240\u6D89\u4E1A\u52A1\u529F\u80FD\u53D1\u751F\u53D8\u66F4\uFF0C\u5BFC\u81F4\u5904\u7406\u4E2A\u4EBA\u4FE1\u606F\u7684\u76EE\u7684\u3001\u7C7B\u578B\u3001\u4F7F\u7528\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.2\xA0\u60A8\u53C2\u4E0E\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u65B9\u9762\u7684\u6743\u5229\u53CA\u5176\u884C\u4F7F\u65B9\u5F0F\u53D1\u751F\u91CD\u5927\u53D8\u5316\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.3\xA0\u5BBE\u679C\u82F1\u8BED\u8D1F\u8D23\u5904\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u7684\u90E8\u95E8\u7684\u8054\u7EDC\u65B9\u5F0F\u53D1\u751F\u53D8\u66F4\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.1.4\xA0\u53D1\u751F\u5176\u4ED6\u53EF\u80FD\u5F71\u54CD\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u6216\u5F71\u54CD\u7528\u6237\u9690\u79C1\u6743\u5229\u7684\u53D8\u66F4\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.2\u300A\u9690\u79C1\u653F\u7B56\u300B\u4FEE\u8BA2\u540E\u5BBE\u679C\u82F1\u8BED\u4F1A\u5728\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u76F8\u5173\u754C\u9762\u53D1\u5E03\u6700\u65B0\u7248\u672C\u5E76\u4EE5\u5F39\u7A97\u3001\u63A8\u9001\u901A\u77E5\u7B49\u5408\u7406\u7684\u65B9\u5F0F\u544A\u77E5\u7528\u6237\uFF0C\u4EE5\u4FBF\u7528\u6237\u53CA\u65F6\u4E86\u89E3\u300A\u9690\u79C1\u653F\u7B56\u300B\u7684\u6700\u65B0\u7248\u672C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.3\u672A\u7ECF\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u5BBE\u679C\u82F1\u8BED\u4E0D\u4F1A\u524A\u51CF\u60A8\u57FA\u4E8E\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6240\u4EAB\u6709\u7684\u6743\u5229\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'9.4\u5982\u65E0\u7279\u6B8A\u8BF4\u660E\uFF0C\u4FEE\u8BA2\u540E\u7684\u300A\u9690\u79C1\u653F\u7B56\u300B\u81EA\u516C\u5E03\u4E4B\u65E5\u8D77\u751F\u6548\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u7AE0\xA0\u6295\u8BC9\u53CA\u5EFA\u8BAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10.1\xA0\u60A8\u5728\u4F7F\u7528\u5BBE\u679C\u82F1\u8BED\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u5BF9\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6709\u4EFB\u4F55\u7684\u7591\u4E49\u6216\u5EFA\u8BAE\uFF0C\u6216\u60A8\u8BA4\u4E3A\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6CA1\u6709\u5F97\u5230\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u89C4\u5B9A\u7684\u4FDD\u62A4\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\uFF0C\u6211\u4EEC\u5C06\u771F\u8BDA\u5730\u5904\u7406\u60A8\u7684\u6295\u8BC9\u53CA\u5EFA\u8BAE\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u516C\u53F8\u540D\u79F0\uFF1A\u676D\u5DDE\u67AB\u6866\u6811-\u6559\u80B2\u79D1\u6280\u6709\u9650\u516C\u53F8'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u8054\u7CFB\u7535\u8BDD\uFF1A0571-88321763\uFF089:30-21:00\uFF09'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5730\u5740\uFF1A\u6D59\u6C5F\u7701\u676D\u5DDE\u5E02\u62F1\u5885\u533A\u5EB7\u4E2D\u8DEF16\u53F73\u5E623\u5C42311\u5BA4\uFF08\u6536\u4EF6\u4EBA\uFF1A\u5BBE\u679C\u82F1\u8BED\u5BA2\u670D\u90E8\uFF09')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'\u7B2C\u5341\u4E00\u7AE0\xA0\u5176\u4ED6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.1 \u56E0\u672C\u653F\u7B56\u4EE5\u53CA\u6211\u4EEC\u5904\u7406\u60A8\u4E2A\u4EBA\u4FE1\u606F\u4E8B\u5B9C\u5F15\u8D77\u7684\u4EFB\u4F55\u4E89\u8BAE\uFF0C\u60A8\u53EF\u8BC9\u81F3\u6709\u7BA1\u8F96\u6743\u7684\u4EBA\u6C11\u6CD5\u9662\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.2 \u5982\u679C\u60A8\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u4E5F\u53EF\u5411\u6709\u5173\u653F\u5E9C\u90E8\u95E8\u8FDB\u884C\u53CD\u6620\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'11.3\xA0\u5728\u5BBE\u679C\u82F1\u8BED\u53D1\u5E03\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6216\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u5747\u89C6\u4E3A\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u751F\u6548\u3002\u5BBE\u679C\u82F1\u8BED\u505C\u6B62\u8FD0\u8425\u6216\u6C38\u4E45\u505C\u6B62\u63D0\u4F9B\u4EA7\u54C1\u53CA/\u6216\u670D\u52A1\u65F6\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u5931\u6548\u3002'))));}}]);return PrivacyBinguo2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrivacyBinguo2Page);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { apiDefine } from "../../api/web";
// import { parseQuery } from "../../utils/tools";
var pic='https://oss.aircourses.com/web/client/outline/p1.png';var CourseOutline1Page=function(_Component){_inherits(CourseOutline1Page,_Component);function CourseOutline1Page(){_classCallCheck(this,CourseOutline1Page);return _possibleConstructorReturn(this,(CourseOutline1Page.__proto__||Object.getPrototypeOf(CourseOutline1Page)).apply(this,arguments));}_createClass(CourseOutline1Page,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:pic,alt:"outline"}))));}}]);return CourseOutline1Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutline1Page);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { apiDefine } from "../../api/web";
// import { parseQuery } from "../../utils/tools";
var pic='https://oss.aircourses.com/web/client/outline/p2.png';var CourseOutline2Page=function(_Component){_inherits(CourseOutline2Page,_Component);function CourseOutline2Page(){_classCallCheck(this,CourseOutline2Page);return _possibleConstructorReturn(this,(CourseOutline2Page.__proto__||Object.getPrototypeOf(CourseOutline2Page)).apply(this,arguments));}_createClass(CourseOutline2Page,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:pic,alt:"outline"}))));}}]);return CourseOutline2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutline2Page);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=['https://oss.aircourses.com/web/client/outline/261/1.jpg','https://oss.aircourses.com/web/client/outline/261/2.jpg','https://oss.aircourses.com/web/client/outline/261/3.jpg','https://oss.aircourses.com/web/client/outline/261/4.jpg','https://oss.aircourses.com/web/client/outline/261/5.jpg'];var hide=['https://oss.aircourses.com/web/client/outline/261/week1.jpg','https://oss.aircourses.com/web/client/outline/261/week2.jpg','https://oss.aircourses.com/web/client/outline/261/week3.jpg','https://oss.aircourses.com/web/client/outline/261/week4.jpg'];var CourseOutline3Page=function(_Component){_inherits(CourseOutline3Page,_Component);function CourseOutline3Page(props){_classCallCheck(this,CourseOutline3Page);var _this=_possibleConstructorReturn(this,(CourseOutline3Page.__proto__||Object.getPrototypeOf(CourseOutline3Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutline3Page,[{key:"render",value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline pro "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"course_box",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fist_wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:ele,alt:"outline",className:"fist"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon "+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:hide[index],alt:"outline",className:"second "+(showIndex.includes(index)&&'active')}));}))));}}]);return CourseOutline3Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutline3Page);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=['https://oss.aircourses.com/web/client/outline/pro1_test/pro1-1.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-3.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-5.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-7.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-9.jpg'];var hide=['https://oss.aircourses.com/web/client/outline/pro1_test/pro1-2.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-4.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-6.jpg','https://oss.aircourses.com/web/client/outline/pro1_test/pro1-8.jpg'];var CourseOutlinePro1Page=function(_Component){_inherits(CourseOutlinePro1Page,_Component);function CourseOutlinePro1Page(props){_classCallCheck(this,CourseOutlinePro1Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro1Page.__proto__||Object.getPrototypeOf(CourseOutlinePro1Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro1Page,[{key:"render",value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline pro "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"course_box",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fist_wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:ele,alt:"outline",className:"fist"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon "+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:hide[index],alt:"outline",className:"second "+(showIndex.includes(index)&&'active')}));}))));}}]);return CourseOutlinePro1Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro1Page);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=['https://oss.aircourses.com/web/client/outline/pro2_test/pro2-1.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-3.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-5.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-7.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-9.jpg'];var hide=['https://oss.aircourses.com/web/client/outline/pro2_test/pro2-2.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-4.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-6.jpg','https://oss.aircourses.com/web/client/outline/pro2_test/pro2-8.jpg'];var CourseOutlinePro2Page=function(_Component){_inherits(CourseOutlinePro2Page,_Component);function CourseOutlinePro2Page(props){_classCallCheck(this,CourseOutlinePro2Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro2Page.__proto__||Object.getPrototypeOf(CourseOutlinePro2Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro2Page,[{key:"render",value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline pro "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"course_box",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fist_wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:ele,alt:"outline",className:"fist"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon "+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:hide[index],alt:"outline",className:"second "+(showIndex.includes(index)&&'active')}));}))));}}]);return CourseOutlinePro2Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro2Page);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=['https://oss.aircourses.com/web/client/outline/pro3_test/pro3-1.png','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-3.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-5.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-7.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-9.jpg'];var hide=['https://oss.aircourses.com/web/client/outline/pro3_test/pro1-2.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-4.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-6.jpg','https://oss.aircourses.com/web/client/outline/pro3_test/pro1-8.jpg'];var locked='https://oss.aircourses.com/web/client/outline/pro3_test/pro3-10.jpg';var CourseOutlinePro3Page=function(_Component){_inherits(CourseOutlinePro3Page,_Component);function CourseOutlinePro3Page(props){_classCallCheck(this,CourseOutlinePro3Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro3Page.__proto__||Object.getPrototypeOf(CourseOutlinePro3Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro3Page,[{key:"render",value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"courseoutline pro "+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"course_box",key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fist_wrap"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:ele,alt:"outline",className:"fist"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon "+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:hide[index],alt:"outline",className:"second "+(showIndex.includes(index)&&'active')}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:locked,alt:""})));}}]);return CourseOutlinePro3Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro3Page);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=['https://oss.aircourses.com/web/client/outline/263/1.jpg','https://oss.aircourses.com/web/client/outline/263/2.jpg','https://oss.aircourses.com/web/client/outline/263/3.jpg','https://oss.aircourses.com/web/client/outline/263/4.jpg','https://oss.aircourses.com/web/client/outline/263/5.jpg'];var hide=['https://oss.aircourses.com/web/client/outline/263/week1.jpg','https://oss.aircourses.com/web/client/outline/263/week2.jpg','https://oss.aircourses.com/web/client/outline/263/week3.jpg','https://oss.aircourses.com/web/client/outline/263/week4.jpg'];var locked='https://oss.aircourses.com/web/client/outline/263/lock.jpg';var CourseOutlinePro4Page=function(_Component){_inherits(CourseOutlinePro4Page,_Component);function CourseOutlinePro4Page(props){_classCallCheck(this,CourseOutlinePro4Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro4Page.__proto__||Object.getPrototypeOf(CourseOutlinePro4Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro4Page,[{key:'render',value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'courseoutline pro '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fist_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:ele,alt:'outline',className:'fist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon '+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:hide[index],alt:'outline',className:'second '+(showIndex.includes(index)&&'active')}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:locked,alt:''})));}}]);return CourseOutlinePro4Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro4Page);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=[['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_q1.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_q2.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_q3.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_q4.jpg','https://oss.aircourses.com/web/client/outline/263/5.jpg'],['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_q1.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_q2.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_q3.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_q4.png','https://oss.aircourses.com/web/client/outline/263/5.jpg'],['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_q1.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_q2.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_q3.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_q4.png','https://oss.aircourses.com/web/client/outline/263/5.jpg']];var hide=[['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_week1.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_week2.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_week3.jpg','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p1_week4.jpg'],['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_week1.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_week2.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_week3.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p2_week4.png'],['https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_week1.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_week2.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_week3.png','https://oss.aircourses.com/web/client/outline/p1_p2_p3/p3_week4.png']];var CourseOutlinePro5Page=function(_Component){_inherits(CourseOutlinePro5Page,_Component);function CourseOutlinePro5Page(props){_classCallCheck(this,CourseOutlinePro5Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro5Page.__proto__||Object.getPrototypeOf(CourseOutlinePro5Page)).call(this,props));_this.handleClick=function(showIndex){var arr=[].concat(_this.state.showIndex);var index=arr.indexOf(showIndex);console.log(showIndex,index);if(index===-1){arr.push(showIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro5Page,[{key:'render',value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'courseoutline pro '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(item,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx},item.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fist_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:ele,alt:'outline',className:'fist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon '+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:hide[idx][index],alt:'outline',className:'second '+(showIndex.includes(index)&&'active')}));}));}))));}}]);return CourseOutlinePro5Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro5Page);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var pic=[['https://oss.aircourses.com/web/client/outline/pro6/P1-Q1.jpg','https://oss.aircourses.com/web/client/outline/pro6/P1-Q2.jpg','https://oss.aircourses.com/web/client/outline/pro6/P1-Q3.jpg','https://oss.aircourses.com/web/client/outline/pro6/P1-Q4.jpg','https://oss.aircourses.com/web/client/outline/263/5.jpg'],['https://oss.aircourses.com/web/client/outline/pro6/P2-Q1.png','https://oss.aircourses.com/web/client/outline/pro6/P2-Q2.png','https://oss.aircourses.com/web/client/outline/pro6/P2-Q3.png','https://oss.aircourses.com/web/client/outline/pro6/P2-Q4.png','https://oss.aircourses.com/web/client/outline/263/5.jpg'],['https://oss.aircourses.com/web/client/outline/pro6/P3-Q1.png','https://oss.aircourses.com/web/client/outline/pro6/P3-Q2.png','https://oss.aircourses.com/web/client/outline/pro6/P3-Q3.png','https://oss.aircourses.com/web/client/outline/pro6/P3-Q4.png','https://oss.aircourses.com/web/client/outline/263/5.jpg']];var hide=[['https://oss.aircourses.com/web/client/outline/pro6/p1_1.png','https://oss.aircourses.com/web/client/outline/pro6/p1_2.png','https://oss.aircourses.com/web/client/outline/pro6/p1_3.png','https://oss.aircourses.com/web/client/outline/pro6/p1_4.png'],['https://oss.aircourses.com/web/client/outline/pro6/p2_1.png','https://oss.aircourses.com/web/client/outline/pro6/p2_2.png','https://oss.aircourses.com/web/client/outline/pro6/p2_3.png','https://oss.aircourses.com/web/client/outline/pro6/p2_4.png'],['https://oss.aircourses.com/web/client/outline/pro6/p3_1.png','https://oss.aircourses.com/web/client/outline/pro6/p3_2.png','https://oss.aircourses.com/web/client/outline/pro6/p3_3.png','https://oss.aircourses.com/web/client/outline/pro6/p3_4.png']];var CourseOutlinePro5Page=function(_Component){_inherits(CourseOutlinePro5Page,_Component);function CourseOutlinePro5Page(props){_classCallCheck(this,CourseOutlinePro5Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro5Page.__proto__||Object.getPrototypeOf(CourseOutlinePro5Page)).call(this,props));_this.handleClick=function(idx,childIdx){var arr=[].concat(_this.state.showIndex);var compIndex=idx+'_'+childIdx;var index=arr.indexOf(compIndex);// console.log(arr, compIndex);
if(index===-1){arr.push(compIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:[]};return _this;}_createClass(CourseOutlinePro5Page,[{key:'render',value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'courseoutline pro '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(item,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx},item.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fist_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:ele,alt:'outline',className:'fist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon '+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,idx,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:hide[idx][index],alt:'outline',className:'second '+(showIndex.includes(idx+'_'+index)&&'active')}));}));}))));}}]);return CourseOutlinePro5Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro5Page);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 直播大班课课程大纲
var pic=[['https://oss.aircourses.com/web/client/outline/pro7/P1-Q1.png']];var hide=[['https://oss.aircourses.com/web/client/outline/pro7/p1_1.png']];var CourseOutlinePro5Page=function(_Component){_inherits(CourseOutlinePro5Page,_Component);function CourseOutlinePro5Page(props){_classCallCheck(this,CourseOutlinePro5Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro5Page.__proto__||Object.getPrototypeOf(CourseOutlinePro5Page)).call(this,props));_this.handleClick=function(idx,childIdx){var arr=[].concat(_this.state.showIndex);var compIndex=idx+'_'+childIdx;var index=arr.indexOf(compIndex);// console.log(arr, compIndex);
if(index===-1){arr.push(compIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:['0_0']};return _this;}_createClass(CourseOutlinePro5Page,[{key:'render',value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'courseoutline pro '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(item,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx},item.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fist_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:ele,alt:'outline',className:'fist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon '+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,idx,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:hide[idx][index],alt:'outline',className:'second '+(showIndex.includes(idx+'_'+index)&&'active')}));}));}))));}}]);return CourseOutlinePro5Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro5Page);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 282课程的课程大纲
var pic=[['https://oss.aircourses.com/web/client/outline/pro8/P1-Q1.png']];var hide=[['https://oss.aircourses.com/web/client/outline/pro8/p1_1.png']];var CourseOutlinePro5Page=function(_Component){_inherits(CourseOutlinePro5Page,_Component);function CourseOutlinePro5Page(props){_classCallCheck(this,CourseOutlinePro5Page);var _this=_possibleConstructorReturn(this,(CourseOutlinePro5Page.__proto__||Object.getPrototypeOf(CourseOutlinePro5Page)).call(this,props));_this.handleClick=function(idx,childIdx){var arr=[].concat(_this.state.showIndex);var compIndex=idx+'_'+childIdx;var index=arr.indexOf(compIndex);// console.log(arr, compIndex);
if(index===-1){arr.push(compIndex);}else{arr.splice(index,1);}_this.setState({showIndex:arr});};_this.state={showIndex:['0_0']};return _this;}_createClass(CourseOutlinePro5Page,[{key:'render',value:function render(){var _this2=this;var showIndex=this.state.showIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'课程大纲'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'courseoutline pro '+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].mobileClient?'':'pc')},pic.map(function(item,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx},item.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'course_box',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fist_wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:ele,alt:'outline',className:'fist'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon '+(showIndex.includes(index)?'active':''),onClick:_this2.handleClick.bind(_this2,idx,index)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:hide[idx][index],alt:'outline',className:'second '+(showIndex.includes(idx+'_'+index)&&'active')}));}));}))));}}]);return CourseOutlinePro5Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CourseOutlinePro5Page);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var img1='https://oss.aircourses.com/web/client/diamond/pc.png';var img2='https://oss.aircourses.com/web/client/diamond/pad.png';var DiamondShop=function(_Component){_inherits(DiamondShop,_Component);function DiamondShop(){_classCallCheck(this,DiamondShop);return _possibleConstructorReturn(this,(DiamondShop.__proto__||Object.getPrototypeOf(DiamondShop)).apply(this,arguments));}_createClass(DiamondShop,[{key:'render',value:function render(){var img=__WEBPACK_IMPORTED_MODULE_1__utils_ua__["a" /* default */].winClient?img1:img2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,{title:'钻石商城'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container diamondShop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:img,alt:'\u94BB\u77F3\u5546\u57CE'})));}}]);return DiamondShop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DiamondShop);

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_guidewx_an_png__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_images_guidewx_an_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_images_guidewx_an_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_guidewx_ios_png__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_guidewx_ios_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_guidewx_ios_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GuideWXPage=function(_Component){_inherits(GuideWXPage,_Component);function GuideWXPage(){_classCallCheck(this,GuideWXPage);return _possibleConstructorReturn(this,(GuideWXPage.__proto__||Object.getPrototypeOf(GuideWXPage)).apply(this,arguments));}_createClass(GuideWXPage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'爱课客户端'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container guidewx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:''+(__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].iphone?__WEBPACK_IMPORTED_MODULE_5__static_images_guidewx_ios_png___default.a:__WEBPACK_IMPORTED_MODULE_4__static_images_guidewx_an_png___default.a),alt:'\u7231\u8BFE\u670D\u52A1\u53F7'}))));}}]);return GuideWXPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GuideWXPage);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/an.f306c797.png";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ios.e739a15d.png";

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_weixinConfig__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_shareBp__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var webviewPage=function(_Component){_inherits(webviewPage,_Component);function webviewPage(props){_classCallCheck(this,webviewPage);var _this=_possibleConstructorReturn(this,(webviewPage.__proto__||Object.getPrototypeOf(webviewPage)).call(this,props));_this.openBroswer=function(){var _this$state=_this.state,url=_this$state.url,token=_this$state.token;__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].openBroswer({url:url+'?token='+window.btoa(token)});};_this.handleClick=function(){_this.props.sendShareBp(1);};_this.backRequire=function(e){var backRequired=e.target.checked;_this.setState({backRequired:backRequired});__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].backRequired({backRequired:backRequired});};_this.backConfirm=function(){__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].alertView({content:'确认退出吗',confirm:'确定',cancel:'取消',id:'H5_1006'});};_this.alertViewBack=function(res){var data=JSON.parse(res);if(data.select==='confirm'){__WEBPACK_IMPORTED_MODULE_2__api_client__["a" /* default */].closeH5Page({reason:'closeSafe'});}};var _this$props$location$=_this.props.location.query;_this$props$location$=_this$props$location$===undefined?{}:_this$props$location$;var courseId=_this$props$location$.courseId,userId=_this$props$location$.userId;_this.state={backRequired:false,url:'http://www.baidu.com',shareParams:{},userId:userId||window.localStorage.getItem('ac_id'),token:userId||window.localStorage.getItem('ac_token'),courseId:courseId};return _this;}_createClass(webviewPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var courseId=this.state.courseId;var key=courseId+'_UnitReport';Object(__WEBPACK_IMPORTED_MODULE_3__api_web__["b" /* apiDefine */])({apiName:'backConfirm',fn:this.backConfirm});// 退出二次确认
Object(__WEBPACK_IMPORTED_MODULE_3__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});// 定义弹框回调方法
__WEBPACK_IMPORTED_MODULE_5__api_axios__["a" /* default */].getShareConfig({key:key},function(res,err){var shareParams=res[key]||{};var desc=shareParams.description,title=shareParams.shortTitledd,imgUrl=shareParams.icon;_this2.setState({shareParams:shareParams});var wxConfig={title:title,desc:desc,imgUrl:imgUrl,link:encodeURI(''+window.location.href)};Object(__WEBPACK_IMPORTED_MODULE_4__utils_weixinConfig__["a" /* default */])(wxConfig,function(type){_this2.props.sendShareBp(type);});});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'客户端接口测试'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container test'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'\u9000\u51FA\u4E8C\u6B21\u786E\u8BA4\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:this.backRequire.bind(this)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.openBroswer},'\u6253\u5F00\u5916\u90E8\u6D4F\u89C8\u5668'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.handleClick},'\u70B9\u51FB\u6309\u94AE\uFF08\u57CB\u70B9\uFF09'))));}}]);return webviewPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__hoc_shareBp__["a" /* default */])(webviewPage,{courseId:230,url:window.location.href,key:'H5_testPage'}));

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareBpWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function shareBpWrapper(WrappedComponent,_ref){var courseId=_ref.courseId,key=_ref.key,pageUrl=_ref.url;var ShareBp=function(_Component){_inherits(ShareBp,_Component);function ShareBp(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,ShareBp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=ShareBp.__proto__||Object.getPrototypeOf(ShareBp)).call.apply(_ref2,[this].concat(args))),_this),_this.sendShareBp=function(){var optType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var channelId=window.localStorage.getItem("channelId");var userId=window.localStorage.getItem("userId");var url=window.location.hostname.includes('aircourses')?'https://bp.aircourses.com/bp/ac-share':'http://192.168.10.209:8899/bp/ac-share';__WEBPACK_IMPORTED_MODULE_1_axios___default()({url:url,method:'post',data:{userId:userId,courseId:courseId,channelId:channelId,key:key,url:pageUrl,optType:optType,type:3,remarktime:new Date().getTime()}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShareBp,[{key:"componentDidMount",value:function componentDidMount(){this.sendShareBp();}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.props,{sendShareBp:this.sendShareBp}));}}]);return ShareBp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return ShareBp;}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_MyNothing__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_legend__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dayjs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_less__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 引入 ECharts 主模块
var colors=['#00a0ff','#FFCE65'];var option={grid:{left:"1%",right:"2%",bottom:"3%",top:"20%",// 顶部空出20%的空间，来显示legend
containLabel:true},legend:{left:"right",// 像右对齐
top:'5%',itemGap:20,textStyle:{fontSize:14},selectedMode:false},tooltip:{show:true,trigger:'axis',formatter:'\n            <div class="tips-title">{b}\u5B66\u4E60\u65F6\u957F</div>\n            <div class="tips-item item1">\n                <span class="tips-circle" style="border-color: #00a0ff"></span>\n                <span>{c0}\u5206\u949F</span>\n            </div>\n            <div class="tips-item item2">\n                <span class="tips-circle" style="border-color: #FFCE65"></span>\n                <span>{c1}\u5206\u949F</span>\n            </div>\n        ',padding:[6,12],backgroundColor:'rgba(0,0,0,0.64)',axisPointer:{type:'line',z:1,lineStyle:{color:'#ccc'}}},xAxis:{type:'category',axisLine:{show:false},axisTick:{show:false},axisLabel:{margin:20,textStyle:{color:'#999'}}},yAxis:{type:'value',axisLine:{show:false},axisTick:{show:false},splitLine:{lineStyle:{color:['#efefef']}},axisLabel:{textStyle:{color:'#999'}}},series:[{type:'line',color:colors[0],showSymol:true,symbolSize:8,z:3,lineStyle:{width:3},areaStyle:{color:new __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'rgba(0, 160, 255, 0.38)'},{offset:1,color:'rgba(255, 255, 255, 0.16)'}])}},{name:'平台用户平均值',type:'line',color:colors[1],showSymol:true,symbolSize:8,z:2,lineStyle:{width:3}}],textStyle:{fontFamily:'clientFont'}};var LearningReport=function(_Component){_inherits(LearningReport,_Component);function LearningReport(){_classCallCheck(this,LearningReport);var _this=_possibleConstructorReturn(this,(LearningReport.__proto__||Object.getPrototypeOf(LearningReport)).call(this));_this.handleClick=function(index){var list=_this.state.list;var info=list[index];if(!info)return;__WEBPACK_IMPORTED_MODULE_9__api_client__["a" /* default */].showLessonDetail(Object.assign({},info));};_this.handleBottom=function(visibility){if(visibility){setTimeout(_this.getData,2000);}};_this.refresh=function(){var _this$state=_this.state,userId=_this$state.userId,list=_this$state.list;__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].getLearningRecent({data:{stuId:userId,row:list.length,num:1}},function(res,err){if(err){console.log(err.errorCode);}else{_this.setState({list:res});}});};_this.getData=function(){var _this$state2=_this.state,row=_this$state2.row,num=_this$state2.num,noMore=_this$state2.noMore,userId=_this$state2.userId;if(noMore)return;__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].getLearningRecent({data:{stuId:userId,row:row,num:num}},function(res,err){if(err){}else{if(res.length){_this.setState({num:_this.state.num+1,list:_this.state.list.concat(res),showSensor:true});}else{_this.setState({showSensor:true,noMore:true});}}});};_this.state={userId:window.localStorage.getItem('ac_id'),num:1,row:7,interval:30,noMore:false,list:[]};document.title='学习报告';return _this;}_createClass(LearningReport,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,userId=_state.userId,interval=_state.interval;var mychart=__WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.init(this.chart);Object(__WEBPACK_IMPORTED_MODULE_11__api_web__["b" /* apiDefine */])({apiName:'refresh',fn:this.refresh});// 定义刷新数据接口
__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].getLearningReport({query:userId},function(res,err){if(err){console.log('err',err);}else{var recentStudy=res.recentStudy;var xData=[],durationList=[],avgDurationList=[];recentStudy.forEach(function(ele){xData.push(__WEBPACK_IMPORTED_MODULE_10_dayjs___default()(ele.classDate).format('MM/DD'));durationList.push(ele.duration||0);avgDurationList.push(ele.avgDuration||0);});var newOption=Object.assign({},option,{xAxis:Object.assign({},option.xAxis,{data:xData}),yAxis:Object.assign({},option.yAxis,{minInterval:interval,maxInterval:interval}),series:[Object.assign({},option.series[0],{name:res.stuEnName,data:durationList}),Object.assign({},option.series[1],{data:avgDurationList})]});mychart.setOption(newOption);}});this.getData();}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,list=_state2.list,noMore=_state2.noMore,showSensor=_state2.showSensor;var listLength=list.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'learningReport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},'\u8FD1\u4E03\u65E5\u5B66\u4E60\u65F6\u957F(\u5206)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'char'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chartsWrap',ref:function ref(dom){return _this2.chart=dom;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'span'},'\u6BCF\u592924:00\u66F4\u65B0\u5F53\u5929\u7684\u5B66\u4E60\u65F6\u957F')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},'\u4E0A\u8BFE\u8BB0\u5F55'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},!!(showSensor&&listLength)&&list.map(function(ele,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'item',key:ele.classSchId,onClick:_this2.handleClick.bind(_this2,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'poster',style:{backgroundImage:'url('+ele.courseDetailCoverHPhoto+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'after '+(ele.completeStatus&&'done')},ele.completeStatus?'完成':'未完成')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},ele.courseCnName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc'},(ele.courseDetailLevelCnTitle||'')+' '+(ele.courseDetailUnitCnTitle||'')+' '+ele.courseDetailCnName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'date'},'\u4E0A\u8BFE\u65F6\u95F4: ',__WEBPACK_IMPORTED_MODULE_10_dayjs___default()(ele.classStartTime).format('YYYY-MM-DD HH:mm:ss'))));}),!!(showSensor&&!listLength)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template_MyNothing__["a" /* default */],{text:'\u8FD1\u4E00\u4E2A\u6708\uFF0C\u4F60\u90FD\u6CA1\u6709\u4E0A\u8BFE\u8BB0\u5F55\u54E6~'})),!!(showSensor&&listLength)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_visibility_sensor___default.a,{onChange:this.handleBottom},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tips'},noMore?'最多展示一个月的上课记录哦~':'加载中...')));}}]);return LearningReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LearningReport);

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(63));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["react-visibility-sensor"] = factory(require("react"), require("react-dom"));
	else
		root["react-visibility-sensor"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(5)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value; // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.

  switch (offsetDir) {
    case 'top':
      return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;

    case 'left':
      return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;

    case 'bottom':
      return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;

    case 'right':
      return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VisibilitySensor; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function normalizeRect(rect) {
  if (rect.width === undefined) {
    rect.width = rect.right - rect.left;
  }

  if (rect.height === undefined) {
    rect.height = rect.bottom - rect.top;
  }

  return rect;
}

var VisibilitySensor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VisibilitySensor, _React$Component);

  function VisibilitySensor(props) {
    var _this;

    _classCallCheck(this, VisibilitySensor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getContainer", function () {
      return _this.props.containment || window;
    });

    _defineProperty(_assertThisInitialized(_this), "addEventListener", function (target, event, delay, throttle) {
      if (!_this.debounceCheck) {
        _this.debounceCheck = {};
      }

      var timeout;
      var func;

      var later = function later() {
        timeout = null;

        _this.check();
      };

      if (throttle > -1) {
        func = function func() {
          if (!timeout) {
            timeout = setTimeout(later, throttle || 0);
          }
        };
      } else {
        func = function func() {
          clearTimeout(timeout);
          timeout = setTimeout(later, delay || 0);
        };
      }

      var info = {
        target: target,
        fn: func,
        getLastTimeout: function getLastTimeout() {
          return timeout;
        }
      };
      target.addEventListener(event, info.fn);
      _this.debounceCheck[event] = info;
    });

    _defineProperty(_assertThisInitialized(_this), "startWatching", function () {
      if (_this.debounceCheck || _this.interval) {
        return;
      }

      if (_this.props.intervalCheck) {
        _this.interval = setInterval(_this.check, _this.props.intervalDelay);
      }

      if (_this.props.scrollCheck) {
        _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
      }

      if (_this.props.resizeCheck) {
        _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
      } // if dont need delayed call, check on load ( before the first interval fires )


      !_this.props.delayedCall && _this.check();
    });

    _defineProperty(_assertThisInitialized(_this), "stopWatching", function () {
      if (_this.debounceCheck) {
        // clean up event listeners and their debounce callers
        for (var debounceEvent in _this.debounceCheck) {
          if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
            var debounceInfo = _this.debounceCheck[debounceEvent];
            clearTimeout(debounceInfo.getLastTimeout());
            debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
            _this.debounceCheck[debounceEvent] = null;
          }
        }
      }

      _this.debounceCheck = null;

      if (_this.interval) {
        _this.interval = clearInterval(_this.interval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "check", function () {
      var el = _this.node;
      var rect;
      var containmentRect; // if the component has rendered to null, dont update visibility

      if (!el) {
        return _this.state;
      }

      rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));

      if (_this.props.containment) {
        var containmentDOMRect = _this.props.containment.getBoundingClientRect();

        containmentRect = {
          top: containmentDOMRect.top,
          left: containmentDOMRect.left,
          bottom: containmentDOMRect.bottom,
          right: containmentDOMRect.right
        };
      } else {
        containmentRect = {
          top: 0,
          left: 0,
          bottom: window.innerHeight || document.documentElement.clientHeight,
          right: window.innerWidth || document.documentElement.clientWidth
        };
      } // Check if visibility is wanted via offset?


      var offset = _this.props.offset || {};
      var hasValidOffset = _typeof(offset) === "object";

      if (hasValidOffset) {
        containmentRect.top += offset.top || 0;
        containmentRect.left += offset.left || 0;
        containmentRect.bottom -= offset.bottom || 0;
        containmentRect.right -= offset.right || 0;
      }

      var visibilityRect = {
        top: rect.top >= containmentRect.top,
        left: rect.left >= containmentRect.left,
        bottom: rect.bottom <= containmentRect.bottom,
        right: rect.right <= containmentRect.right
      }; // https://github.com/joshwnj/react-visibility-sensor/pull/114

      var hasSize = rect.height > 0 && rect.width > 0;
      var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right; // check for partial visibility

      if (hasSize && _this.props.partialVisibility) {
        var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left; // account for partial visibility on a single edge

        if (typeof _this.props.partialVisibility === "string") {
          partialVisible = visibilityRect[_this.props.partialVisibility];
        } // if we have minimum top visibility set by props, lets check, if it meets the passed value
        // so if for instance element is at least 200px in viewport, then show it.


        isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
      } // Deprecated options for calculating offset.


      if (typeof offset.direction === "string" && typeof offset.value === "number") {
        console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
        isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset, rect, containmentRect);
      }

      var state = _this.state; // notify the parent when the value changes

      if (_this.state.isVisible !== isVisible) {
        state = {
          isVisible: isVisible,
          visibilityRect: visibilityRect
        };

        _this.setState(state);

        if (_this.props.onChange) _this.props.onChange(isVisible);
      }

      return state;
    });

    _this.state = {
      isVisible: null,
      visibilityRect: {}
    };
    return _this;
  }

  _createClass(VisibilitySensor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active) {
        this.startWatching();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopWatching();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // re-register node in componentDidUpdate if children diffs [#103]
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active && !prevProps.active) {
        this.setState({
          isVisible: null,
          visibilityRect: {}
        });
        this.startWatching();
      } else if (!this.props.active) {
        this.stopWatching();
      }
    }
  }, {
    key: "roundRectDown",
    value: function roundRectDown(rect) {
      return {
        top: Math.floor(rect.top),
        left: Math.floor(rect.left),
        bottom: Math.floor(rect.bottom),
        right: Math.floor(rect.right)
      };
    }
    /**
     * Check if the element is within the visible viewport
     */

  }, {
    key: "render",
    value: function render() {
      if (this.props.children instanceof Function) {
        return this.props.children({
          isVisible: this.state.isVisible,
          visibilityRect: this.state.visibilityRect
        });
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
    }
  }]);

  return VisibilitySensor;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

_defineProperty(VisibilitySensor, "defaultProps", {
  active: true,
  partialVisibility: false,
  minTopValue: 0,
  scrollCheck: false,
  scrollDelay: 250,
  scrollThrottle: -1,
  resizeCheck: false,
  resizeDelay: 250,
  resizeThrottle: -1,
  intervalCheck: true,
  intervalDelay: 100,
  delayedCall: false,
  offset: {},
  containment: null,
  children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
});

_defineProperty(VisibilitySensor, "propTypes", {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"])]),
  delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  }), // deprecated offset property
  prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"]),
    value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  })]),
  scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func]),
  minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
});



/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(6);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);
});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MyNothing=function(_Component){_inherits(MyNothing,_Component);function MyNothing(){_classCallCheck(this,MyNothing);return _possibleConstructorReturn(this,(MyNothing.__proto__||Object.getPrototypeOf(MyNothing)).apply(this,arguments));}_createClass(MyNothing,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'myNothing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},this.props.text||'这里空空如也～'));}}]);return MyNothing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MyNothing);

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2);

var vec2 = __webpack_require__(26);

var Draggable = __webpack_require__(803);

var Eventful = __webpack_require__(97);

var eventTool = __webpack_require__(83);

var GestureMgr = __webpack_require__(805);

/**
 * [The interface between `Handler` and `HandlerProxy`]:
 *
 * The default `HandlerProxy` only support the common standard web environment
 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
 * But `HandlerProxy` can be replaced to support more non-standard environment
 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
 * not provided (like echarts-gl did).
 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
 * make break changes util inevitable. The interface include the public methods
 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
 * drives `Handler`.
 */

/**
 * [Drag outside]:
 *
 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
 * zrender area when dragging. That is important for the improvement of the user experience
 * when dragging something near the boundary without being terminated unexpectedly.
 *
 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
 * to resolve this issue. But some drawbacks of it is described in
 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
 *
 * Instead, we referenced the specifications:
 * https://www.w3.org/TR/touch-events/#the-touchmove-event
 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
 * where the the mousemove/touchmove can be continue to fire if the user began a drag
 * operation and the pointer has left the boundary. (for the mouse event, browsers
 * only do it on `document` and when the pointer has left the boundary of the browser.)
 *
 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
 * to fire until release the pointer. That is implemented by listen to those event on
 * `document`.
 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
 * The touch event support this feature by default.
 *
 * Note:
 * There might be some cases that the mouse event can not be
 * received on `document`. For example,
 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
 * of zr dom throw Error .
 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
 * zr dom call `stopPropagation`.
 * In these cases, the `mousemove` event might be keep triggered event
 * if the mouse is released. We try to reduce the side-effect in those cases.
 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
 *
 * Note:
 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
 * `document` capture phase to prevent the propagation to any listener of the webpage.
 * But they are needed to work when the pointer inside the zrender dom.
 */
var SILENT = 'silent';

function makeEventPacket(eveType, targetInfo, event) {
  return {
    type: eveType,
    event: event,
    // target can only be an element that is not silent.
    target: targetInfo.target,
    // topTarget can be a silent element.
    topTarget: targetInfo.topTarget,
    cancelBubble: false,
    offsetX: event.zrX,
    offsetY: event.zrY,
    gestureEvent: event.gestureEvent,
    pinchX: event.pinchX,
    pinchY: event.pinchY,
    pinchScale: event.pinchScale,
    wheelDelta: event.zrDelta,
    zrByTouch: event.zrByTouch,
    which: event.which,
    stop: stopEvent
  };
}

function stopEvent() {
  eventTool.stop(this.event);
}

function EmptyProxy() {}

EmptyProxy.prototype.dispose = function () {};

var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */

var Handler = function (storage, painter, proxy, painterRoot) {
  Eventful.call(this);
  this.storage = storage;
  this.painter = painter;
  this.painterRoot = painterRoot;
  proxy = proxy || new EmptyProxy();
  /**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */

  this.proxy = null;
  /**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */

  this._hovered = {};
  /**
   * @private
   * @type {Date}
   */

  this._lastTouchMoment;
  /**
   * @private
   * @type {number}
   */

  this._lastX;
  /**
   * @private
   * @type {number}
   */

  this._lastY;
  /**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */

  this._gestureMgr;
  Draggable.call(this);
  this.setHandlerProxy(proxy);
};

Handler.prototype = {
  constructor: Handler,
  setHandlerProxy: function (proxy) {
    if (this.proxy) {
      this.proxy.dispose();
    }

    if (proxy) {
      util.each(handlerNames, function (name) {
        proxy.on && proxy.on(name, this[name], this);
      }, this); // Attach handler

      proxy.handler = this;
    }

    this.proxy = proxy;
  },
  mousemove: function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var isOutside = isOutsideBoundary(this, x, y);
    var lastHovered = this._hovered;
    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
    // See #6198.

    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
      lastHoveredTarget = lastHovered.target;
    }

    var hovered = this._hovered = isOutside ? {
      x: x,
      y: y
    } : this.findHover(x, y);
    var hoveredTarget = hovered.target;
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element

    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(lastHovered, 'mouseout', event);
    } // Mouse moving on one element


    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element

    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(hovered, 'mouseover', event);
    }
  },
  mouseout: function (event) {
    var eventControl = event.zrEventControl;
    var zrIsToLocalDOM = event.zrIsToLocalDOM;

    if (eventControl !== 'only_globalout') {
      this.dispatchToElement(this._hovered, 'mouseout', event);
    }

    if (eventControl !== 'no_globalout') {
      // FIXME: if the pointer moving from the extra doms to realy "outside",
      // the `globalout` should have been triggered. But currently not.
      !zrIsToLocalDOM && this.trigger('globalout', {
        type: 'globalout',
        event: event
      });
    }
  },

  /**
   * Resize
   */
  resize: function (event) {
    this._hovered = {};
  },

  /**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */
  dispatch: function (eventName, eventArgs) {
    var handler = this[eventName];
    handler && handler.call(this, eventArgs);
  },

  /**
   * Dispose
   */
  dispose: function () {
    this.proxy.dispose();
    this.storage = this.proxy = this.painter = null;
  },

  /**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(cursorStyle);
  },

  /**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */
  dispatchToElement: function (targetInfo, eventName, event) {
    targetInfo = targetInfo || {};
    var el = targetInfo.target;

    if (el && el.silent) {
      return;
    }

    var eventHandler = 'on' + eventName;
    var eventPacket = makeEventPacket(eventName, targetInfo, event);

    while (el) {
      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
      el.trigger(eventName, eventPacket);
      el = el.parent;

      if (eventPacket.cancelBubble) {
        break;
      }
    }

    if (!eventPacket.cancelBubble) {
      // 冒泡到顶级 zrender 对象
      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在

      this.painter && this.painter.eachOtherLayer(function (layer) {
        if (typeof layer[eventHandler] === 'function') {
          layer[eventHandler].call(layer, eventPacket);
        }

        if (layer.trigger) {
          layer.trigger(eventName, eventPacket);
        }
      });
    }
  },

  /**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */
  findHover: function (x, y, exclude) {
    var list = this.storage.getDisplayList();
    var out = {
      x: x,
      y: y
    };

    for (var i = list.length - 1; i >= 0; i--) {
      var hoverCheckResult;

      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
        !out.topTarget && (out.topTarget = list[i]);

        if (hoverCheckResult !== SILENT) {
          out.target = list[i];
          break;
        }
      }
    }

    return out;
  },
  processGesture: function (event, stage) {
    if (!this._gestureMgr) {
      this._gestureMgr = new GestureMgr();
    }

    var gestureMgr = this._gestureMgr;
    stage === 'start' && gestureMgr.clear();
    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.

    if (gestureInfo) {
      var type = gestureInfo.type;
      event.gestureEvent = type;
      this.dispatchToElement({
        target: gestureInfo.target
      }, type, gestureInfo.event);
    }
  }
}; // Common handlers

util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  Handler.prototype[name] = function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var isOutside = isOutsideBoundary(this, x, y);
    var hovered;
    var hoveredTarget;

    if (name !== 'mouseup' || !isOutside) {
      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
      hovered = this.findHover(x, y);
      hoveredTarget = hovered.target;
    }

    if (name === 'mousedown') {
      this._downEl = hoveredTarget;
      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup

      this._upEl = hoveredTarget;
    } else if (name === 'mouseup') {
      this._upEl = hoveredTarget;
    } else if (name === 'click') {
      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
      // including the case that `mousedown` - `mousemove` - `mouseup`,
      // which should be filtered, otherwise it will bring trouble to
      // pan and zoom.
      || !this._downPoint // Arbitrary value
      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
        return;
      }

      this._downPoint = null;
    }

    this.dispatchToElement(hovered, name, event);
  };
});

function isHover(displayable, x, y) {
  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
    var el = displayable;
    var isSilent;

    while (el) {
      // If clipped by ancestor.
      // FIXME: If clipPath has neither stroke nor fill,
      // el.clipPath.contain(x, y) will always return false.
      if (el.clipPath && !el.clipPath.contain(x, y)) {
        return false;
      }

      if (el.silent) {
        isSilent = true;
      }

      el = el.parent;
    }

    return isSilent ? SILENT : true;
  }

  return false;
}
/**
 * See [Drag outside].
 */


function isOutsideBoundary(handlerInstance, x, y) {
  var painter = handlerInstance.painter;
  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}

util.mixin(Handler, Eventful);
util.mixin(Handler, Draggable);
var _default = Handler;
module.exports = _default;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function Draggable() {
  this.on('mousedown', this._dragStart, this);
  this.on('mousemove', this._drag, this);
  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
  // See [Drag outside] in `Handler.js`. So we do not need to trigger
  // `_dragEnd` when globalout. That would brings better user experience.
  // this.on('globalout', this._dragEnd, this);
  // this._dropTarget = null;
  // this._draggingTarget = null;
  // this._x = 0;
  // this._y = 0;
}

Draggable.prototype = {
  constructor: Draggable,
  _dragStart: function (e) {
    var draggingTarget = e.target; // Find if there is draggable in the ancestor

    while (draggingTarget && !draggingTarget.draggable) {
      draggingTarget = draggingTarget.parent;
    }

    if (draggingTarget) {
      this._draggingTarget = draggingTarget;
      draggingTarget.dragging = true;
      this._x = e.offsetX;
      this._y = e.offsetY;
      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
    }
  },
  _drag: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      var x = e.offsetX;
      var y = e.offsetY;
      var dx = x - this._x;
      var dy = y - this._y;
      this._x = x;
      this._y = y;
      draggingTarget.drift(dx, dy, e);
      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
      var dropTarget = this.findHover(x, y, draggingTarget).target;
      var lastDropTarget = this._dropTarget;
      this._dropTarget = dropTarget;

      if (draggingTarget !== dropTarget) {
        if (lastDropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
        }

        if (dropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
        }
      }
    }
  },
  _dragEnd: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      draggingTarget.dragging = false;
    }

    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);

    if (this._dropTarget) {
      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
    }

    this._draggingTarget = null;
    this._dropTarget = null;
  }
};

function param(target, e) {
  return {
    target: target,
    topTarget: e && e.topTarget
  };
}

var _default = Draggable;
module.exports = _default;

/***/ }),
/* 804 */
/***/ (function(module, exports) {

/**
 * The algoritm is learnt from
 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
 * And we made some optimization for matrix inversion.
 * Other similar approaches:
 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
 */
var LN2 = Math.log(2);

function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
  var cacheKey = rowMask + '-' + colMask;
  var fullRank = rows.length;

  if (detCache.hasOwnProperty(cacheKey)) {
    return detCache[cacheKey];
  }

  if (rank === 1) {
    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
    return rows[rowStart][colStart];
  }

  var subRowMask = rowMask | 1 << rowStart;
  var subRowStart = rowStart + 1;

  while (rowMask & 1 << subRowStart) {
    subRowStart++;
  }

  var sum = 0;

  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
    var colTag = 1 << j;

    if (!(colTag & colMask)) {
      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
      colLocalIdx++;
    }
  }

  detCache[cacheKey] = sum;
  return sum;
}
/**
 * Usage:
 * ```js
 * var transformer = buildTransformer(
 *     [10, 44, 100, 44, 100, 300, 10, 300],
 *     [50, 54, 130, 14, 140, 330, 14, 220]
 * );
 * var out = [];
 * transformer && transformer([11, 33], out);
 * ```
 *
 * Notice: `buildTransformer` may take more than 10ms in some Android device.
 *
 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
 * @return {Function} transformer If fail, return null/undefined.
 */


function buildTransformer(src, dest) {
  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
  var detCache = {};
  var det = determinant(mA, 8, 0, 0, 0, detCache);

  if (det === 0) {
    // can not make transformer when and only when
    // any three of the markers are collinear.
    return;
  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.


  var vh = [];

  for (var i = 0; i < 8; i++) {
    for (var j = 0; j < 8; j++) {
      vh[j] == null && (vh[j] = 0);
      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
  }

  return function (out, srcPointX, srcPointY) {
    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
  };
}

exports.buildTransformer = buildTransformer;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var eventUtil = __webpack_require__(83);

/**
 * Only implements needed gestures for mobile.
 */
var GestureMgr = function () {
  /**
   * @private
   * @type {Array.<Object>}
   */
  this._track = [];
};

GestureMgr.prototype = {
  constructor: GestureMgr,
  recognize: function (event, target, root) {
    this._doTrack(event, target, root);

    return this._recognize(event);
  },
  clear: function () {
    this._track.length = 0;
    return this;
  },
  _doTrack: function (event, target, root) {
    var touches = event.touches;

    if (!touches) {
      return;
    }

    var trackItem = {
      points: [],
      touches: [],
      target: target,
      event: event
    };

    for (var i = 0, len = touches.length; i < len; i++) {
      var touch = touches[i];
      var pos = eventUtil.clientToLocal(root, touch, {});
      trackItem.points.push([pos.zrX, pos.zrY]);
      trackItem.touches.push(touch);
    }

    this._track.push(trackItem);
  },
  _recognize: function (event) {
    for (var eventName in recognizers) {
      if (recognizers.hasOwnProperty(eventName)) {
        var gestureInfo = recognizers[eventName](this._track, event);

        if (gestureInfo) {
          return gestureInfo;
        }
      }
    }
  }
};

function dist(pointPair) {
  var dx = pointPair[1][0] - pointPair[0][0];
  var dy = pointPair[1][1] - pointPair[0][1];
  return Math.sqrt(dx * dx + dy * dy);
}

function center(pointPair) {
  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
}

var recognizers = {
  pinch: function (track, event) {
    var trackLen = track.length;

    if (!trackLen) {
      return;
    }

    var pinchEnd = (track[trackLen - 1] || {}).points;
    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;

    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
      var pinchScale = dist(pinchEnd) / dist(pinchPre);
      !isFinite(pinchScale) && (pinchScale = 1);
      event.pinchScale = pinchScale;
      var pinchCenter = center(pinchEnd);
      event.pinchX = pinchCenter[0];
      event.pinchY = pinchCenter[1];
      return {
        type: 'pinch',
        target: track[0].target,
        event: event
      };
    }
  } // Only pinch currently.

};
var _default = GestureMgr;
module.exports = _default;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2);

var env = __webpack_require__(25);

var Group = __webpack_require__(98);

var timsort = __webpack_require__(169);

// Use timsort because in most case elements are partially sorted
// https://jsfiddle.net/pissang/jr4x7mdm/8/
function shapeCompareFunc(a, b) {
  if (a.zlevel === b.zlevel) {
    if (a.z === b.z) {
      // if (a.z2 === b.z2) {
      //     // FIXME Slow has renderidx compare
      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
      //     return a.__renderidx - b.__renderidx;
      // }
      return a.z2 - b.z2;
    }

    return a.z - b.z;
  }

  return a.zlevel - b.zlevel;
}
/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */


var Storage = function () {
  // jshint ignore:line
  this._roots = [];
  this._displayList = [];
  this._displayListLen = 0;
};

Storage.prototype = {
  constructor: Storage,

  /**
   * @param  {Function} cb
   *
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._roots.length; i++) {
      this._roots[i].traverse(cb, context);
    }
  },

  /**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */
  getDisplayList: function (update, includeIgnore) {
    includeIgnore = includeIgnore || false;

    if (update) {
      this.updateDisplayList(includeIgnore);
    }

    return this._displayList;
  },

  /**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */
  updateDisplayList: function (includeIgnore) {
    this._displayListLen = 0;
    var roots = this._roots;
    var displayList = this._displayList;

    for (var i = 0, len = roots.length; i < len; i++) {
      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
    }

    displayList.length = this._displayListLen;
    env.canvasSupported && timsort(displayList, shapeCompareFunc);
  },
  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
    if (el.ignore && !includeIgnore) {
      return;
    }

    el.beforeUpdate();

    if (el.__dirty) {
      el.update();
    }

    el.afterUpdate();
    var userSetClipPath = el.clipPath;

    if (userSetClipPath) {
      // FIXME 效率影响
      if (clipPaths) {
        clipPaths = clipPaths.slice();
      } else {
        clipPaths = [];
      }

      var currentClipPath = userSetClipPath;
      var parentClipPath = el; // Recursively add clip path

      while (currentClipPath) {
        // clipPath 的变换是基于使用这个 clipPath 的元素
        currentClipPath.parent = parentClipPath;
        currentClipPath.updateTransform();
        clipPaths.push(currentClipPath);
        parentClipPath = currentClipPath;
        currentClipPath = currentClipPath.clipPath;
      }
    }

    if (el.isGroup) {
      var children = el._children;

      for (var i = 0; i < children.length; i++) {
        var child = children[i]; // Force to mark as dirty if group is dirty
        // FIXME __dirtyPath ?

        if (el.__dirty) {
          child.__dirty = true;
        }

        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
      } // Mark group clean here


      el.__dirty = false;
    } else {
      el.__clipPaths = clipPaths;
      this._displayList[this._displayListLen++] = el;
    }
  },

  /**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */
  addRoot: function (el) {
    if (el.__storage === this) {
      return;
    }

    if (el instanceof Group) {
      el.addChildrenToStorage(this);
    }

    this.addToStorage(el);

    this._roots.push(el);
  },

  /**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */
  delRoot: function (el) {
    if (el == null) {
      // 不指定el清空
      for (var i = 0; i < this._roots.length; i++) {
        var root = this._roots[i];

        if (root instanceof Group) {
          root.delChildrenFromStorage(this);
        }
      }

      this._roots = [];
      this._displayList = [];
      this._displayListLen = 0;
      return;
    }

    if (el instanceof Array) {
      for (var i = 0, l = el.length; i < l; i++) {
        this.delRoot(el[i]);
      }

      return;
    }

    var idx = util.indexOf(this._roots, el);

    if (idx >= 0) {
      this.delFromStorage(el);

      this._roots.splice(idx, 1);

      if (el instanceof Group) {
        el.delChildrenFromStorage(this);
      }
    }
  },
  addToStorage: function (el) {
    if (el) {
      el.__storage = this;
      el.dirty(false);
    }

    return this;
  },
  delFromStorage: function (el) {
    if (el) {
      el.__storage = null;
    }

    return this;
  },

  /**
   * 清空并且释放Storage
   */
  dispose: function () {
    this._renderList = this._roots = null;
  },
  displayableSortFunc: shapeCompareFunc
};
var _default = Storage;
module.exports = _default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var Animator = __webpack_require__(254);

var logError = __webpack_require__(256);

var _util = __webpack_require__(2);

var isString = _util.isString;
var isFunction = _util.isFunction;
var isObject = _util.isObject;
var isArrayLike = _util.isArrayLike;
var indexOf = _util.indexOf;

/**
 * @alias module:zrender/mixin/Animatable
 * @constructor
 */
var Animatable = function () {
  /**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */
  this.animators = [];
};

Animatable.prototype = {
  constructor: Animatable,

  /**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */
  animate: function (path, loop) {
    var target;
    var animatingShape = false;
    var el = this;
    var zr = this.__zr;

    if (path) {
      var pathSplitted = path.split('.');
      var prop = el; // If animating shape

      animatingShape = pathSplitted[0] === 'shape';

      for (var i = 0, l = pathSplitted.length; i < l; i++) {
        if (!prop) {
          continue;
        }

        prop = prop[pathSplitted[i]];
      }

      if (prop) {
        target = prop;
      }
    } else {
      target = el;
    }

    if (!target) {
      logError('Property "' + path + '" is not existed in element ' + el.id);
      return;
    }

    var animators = el.animators;
    var animator = new Animator(target, loop);
    animator.during(function (target) {
      el.dirty(animatingShape);
    }).done(function () {
      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
      animators.splice(indexOf(animators, animator), 1);
    });
    animators.push(animator); // If animate after added to the zrender

    if (zr) {
      zr.animation.addAnimator(animator);
    }

    return animator;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stopAnimation: function (forwardToLast) {
    var animators = this.animators;
    var len = animators.length;

    for (var i = 0; i < len; i++) {
      animators[i].stop(forwardToLast);
    }

    animators.length = 0;
    return this;
  },

  /**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */
  // TODO Return animation key
  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
    animateTo(this, target, time, delay, easing, callback, forceAnimate);
  },

  /**
   * Animate from the target state to current state.
   * The params and the return value are the same as `this.animateTo`.
   */
  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
  }
};

function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
  // animateTo(target, time, easing, callback);
  if (isString(delay)) {
    callback = easing;
    easing = delay;
    delay = 0;
  } // animateTo(target, time, delay, callback);
  else if (isFunction(easing)) {
      callback = easing;
      easing = 'linear';
      delay = 0;
    } // animateTo(target, time, callback);
    else if (isFunction(delay)) {
        callback = delay;
        delay = 0;
      } // animateTo(target, callback)
      else if (isFunction(time)) {
          callback = time;
          time = 500;
        } // animateTo(target)
        else if (!time) {
            time = 500;
          } // Stop all previous animations


  animatable.stopAnimation();
  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
  // if there is nothing to animate

  var animators = animatable.animators.slice();
  var count = animators.length;

  function done() {
    count--;

    if (!count) {
      callback && callback();
    }
  } // No animators. This should be checked before animators[i].start(),
  // because 'done' may be executed immediately if no need to animate.


  if (!count) {
    callback && callback();
  } // Start after all animators created
  // Incase any animator is done immediately when all animation properties are not changed


  for (var i = 0; i < animators.length; i++) {
    animators[i].done(done).start(easing, forceAnimate);
  }
}
/**
 * @param {string} path=''
 * @param {Object} source=animatable
 * @param {Object} target
 * @param {number} [time=500]
 * @param {number} [delay=0]
 * @param {boolean} [reverse] If `true`, animate
 *        from the `target` to current state.
 *
 * @example
 *  // Animate position
 *  el._animateToShallow({
 *      position: [10, 10]
 *  })
 *
 *  // Animate shape, style and position in 100ms, delayed 100ms
 *  el._animateToShallow({
 *      shape: {
 *          width: 500
 *      },
 *      style: {
 *          fill: 'red'
 *      }
 *      position: [10, 10]
 *  }, 100, 100)
 */


function animateToShallow(animatable, path, source, target, time, delay, reverse) {
  var objShallow = {};
  var propertyCount = 0;

  for (var name in target) {
    if (!target.hasOwnProperty(name)) {
      continue;
    }

    if (source[name] != null) {
      if (isObject(target[name]) && !isArrayLike(target[name])) {
        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
      } else {
        if (reverse) {
          objShallow[name] = source[name];
          setAttrByPath(animatable, path, name, target[name]);
        } else {
          objShallow[name] = target[name];
        }

        propertyCount++;
      }
    } else if (target[name] != null && !reverse) {
      setAttrByPath(animatable, path, name, target[name]);
    }
  }

  if (propertyCount > 0) {
    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
  }
}

function setAttrByPath(el, path, name, value) {
  // Attr directly if not has property
  // FIXME, if some property not needed for element ?
  if (!path) {
    el.attr(name, value);
  } else {
    // Only support set shape or style
    var props = {};
    props[path] = {};
    props[path][name] = value;
    el.attr(props);
  }
}

var _default = Animatable;
module.exports = _default;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var easingFuncs = __webpack_require__(809);

/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */
function Clip(options) {
  this._target = options.target; // 生命周期

  this._life = options.life || 1000; // 延时

  this._delay = options.delay || 0; // 开始时间
  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒

  this._initialized = false; // 是否循环

  this.loop = options.loop == null ? false : options.loop;
  this.gap = options.gap || 0;
  this.easing = options.easing || 'Linear';
  this.onframe = options.onframe;
  this.ondestroy = options.ondestroy;
  this.onrestart = options.onrestart;
  this._pausedTime = 0;
  this._paused = false;
}

Clip.prototype = {
  constructor: Clip,
  step: function (globalTime, deltaTime) {
    // Set startTime on first step, or _startTime may has milleseconds different between clips
    // PENDING
    if (!this._initialized) {
      this._startTime = globalTime + this._delay;
      this._initialized = true;
    }

    if (this._paused) {
      this._pausedTime += deltaTime;
      return;
    }

    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始

    if (percent < 0) {
      return;
    }

    percent = Math.min(percent, 1);
    var easing = this.easing;
    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
    this.fire('frame', schedule); // 结束

    if (percent === 1) {
      if (this.loop) {
        this.restart(globalTime); // 重新开始周期
        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件

        return 'restart';
      } // 动画完成将这个控制器标识为待删除
      // 在Animation.update中进行批量删除


      this._needsRemove = true;
      return 'destroy';
    }

    return null;
  },
  restart: function (globalTime) {
    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
    this._startTime = globalTime - remainder + this.gap;
    this._pausedTime = 0;
    this._needsRemove = false;
  },
  fire: function (eventType, arg) {
    eventType = 'on' + eventType;

    if (this[eventType]) {
      this[eventType](this._target, arg);
    }
  },
  pause: function () {
    this._paused = true;
  },
  resume: function () {
    this._paused = false;
  }
};
var _default = Clip;
module.exports = _default;

/***/ }),
/* 809 */
/***/ (function(module, exports) {

/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */
var easing = {
  /**
  * @param {number} k
  * @return {number}
  */
  linear: function (k) {
    return k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticIn: function (k) {
    return k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticOut: function (k) {
    return k * (2 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  },
  // 三次方的缓动（t^3）

  /**
  * @param {number} k
  * @return {number}
  */
  cubicIn: function (k) {
    return k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicOut: function (k) {
    return --k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k + 2);
  },
  // 四次方的缓动（t^4）

  /**
  * @param {number} k
  * @return {number}
  */
  quarticIn: function (k) {
    return k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticOut: function (k) {
    return 1 - --k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k;
    }

    return -0.5 * ((k -= 2) * k * k * k - 2);
  },
  // 五次方的缓动（t^5）

  /**
  * @param {number} k
  * @return {number}
  */
  quinticIn: function (k) {
    return k * k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticOut: function (k) {
    return --k * k * k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },
  // 正弦曲线的缓动（sin(t)）

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalIn: function (k) {
    return 1 - Math.cos(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalOut: function (k) {
    return Math.sin(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalInOut: function (k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  },
  // 指数曲线的缓动（2^t）

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialIn: function (k) {
    return k === 0 ? 0 : Math.pow(1024, k - 1);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialOut: function (k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialInOut: function (k) {
    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }

    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },
  // 圆形曲线的缓动（sqrt(1-t^2)）

  /**
  * @param {number} k
  * @return {number}
  */
  circularIn: function (k) {
    return 1 - Math.sqrt(1 - k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularOut: function (k) {
    return Math.sqrt(1 - --k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularInOut: function (k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }

    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },
  // 创建类似于弹簧在停止前来回振荡的动画

  /**
  * @param {number} k
  * @return {number}
  */
  elasticIn: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticInOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    if ((k *= 2) < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    }

    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
  },
  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动

  /**
  * @param {number} k
  * @return {number}
  */
  backIn: function (k) {
    var s = 1.70158;
    return k * k * ((s + 1) * k - s);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backOut: function (k) {
    var s = 1.70158;
    return --k * k * ((s + 1) * k + s) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backInOut: function (k) {
    var s = 1.70158 * 1.525;

    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }

    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },
  // 创建弹跳效果

  /**
  * @param {number} k
  * @return {number}
  */
  bounceIn: function (k) {
    return 1 - easing.bounceOut(1 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceOut: function (k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    }
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceInOut: function (k) {
    if (k < 0.5) {
      return easing.bounceIn(k * 2) * 0.5;
    }

    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};
var _default = easing;
module.exports = _default;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(124);

var devicePixelRatio = _config.devicePixelRatio;

var util = __webpack_require__(2);

var logError = __webpack_require__(256);

var BoundingRect = __webpack_require__(33);

var timsort = __webpack_require__(169);

var Layer = __webpack_require__(811);

var requestAnimationFrame = __webpack_require__(259);

var Image = __webpack_require__(171);

var env = __webpack_require__(25);

var HOVER_LAYER_ZLEVEL = 1e5;
var CANVAS_ZLEVEL = 314159;
var EL_AFTER_INCREMENTAL_INC = 0.01;
var INCREMENTAL_INC = 0.001;

function parseInt10(val) {
  return parseInt(val, 10);
}

function isLayerValid(layer) {
  if (!layer) {
    return false;
  }

  if (layer.__builtin__) {
    return true;
  }

  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
    return false;
  }

  return true;
}

var tmpRect = new BoundingRect(0, 0, 0, 0);
var viewRect = new BoundingRect(0, 0, 0, 0);

function isDisplayableCulled(el, width, height) {
  tmpRect.copy(el.getBoundingRect());

  if (el.transform) {
    tmpRect.applyTransform(el.transform);
  }

  viewRect.width = width;
  viewRect.height = height;
  return !tmpRect.intersect(viewRect);
}

function isClipPathChanged(clipPaths, prevClipPaths) {
  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
  if (clipPaths === prevClipPaths) {
    return false;
  }

  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
    return true;
  }

  for (var i = 0; i < clipPaths.length; i++) {
    if (clipPaths[i] !== prevClipPaths[i]) {
      return true;
    }
  }

  return false;
}

function doClip(clipPaths, ctx) {
  for (var i = 0; i < clipPaths.length; i++) {
    var clipPath = clipPaths[i];
    clipPath.setTransform(ctx);
    ctx.beginPath();
    clipPath.buildPath(ctx, clipPath.shape);
    ctx.clip(); // Transform back

    clipPath.restoreTransform(ctx);
  }
}

function createRoot(width, height) {
  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected

  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
  // dom does not act as expected) when some of the parent dom has
  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
  // the canvas is not at the top part of the page.
  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
  // this `overflow:hidden` to avoid the bug.
  // 'overflow:hidden',
  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
  return domRoot;
}
/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var Painter = function (root, storage, opts) {
  this.type = 'canvas'; // In node environment using node-canvas

  var singleCanvas = !root.nodeName // In node ?
  || root.nodeName.toUpperCase() === 'CANVAS';
  this._opts = opts = util.extend({}, opts || {});
  /**
   * @type {number}
   */

  this.dpr = opts.devicePixelRatio || devicePixelRatio;
  /**
   * @type {boolean}
   * @private
   */

  this._singleCanvas = singleCanvas;
  /**
   * 绘图容器
   * @type {HTMLElement}
   */

  this.root = root;
  var rootStyle = root.style;

  if (rootStyle) {
    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
    root.innerHTML = '';
  }
  /**
   * @type {module:zrender/Storage}
   */


  this.storage = storage;
  /**
   * @type {Array.<number>}
   * @private
   */

  var zlevelList = this._zlevelList = [];
  /**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */

  var layers = this._layers = {};
  /**
   * @type {Object.<string, Object>}
   * @private
   */

  this._layerConfig = {};
  /**
   * zrender will do compositing when root is a canvas and have multiple zlevels.
   */

  this._needsManuallyCompositing = false;

  if (!singleCanvas) {
    this._width = this._getSize(0);
    this._height = this._getSize(1);
    var domRoot = this._domRoot = createRoot(this._width, this._height);
    root.appendChild(domRoot);
  } else {
    var width = root.width;
    var height = root.height;

    if (opts.width != null) {
      width = opts.width;
    }

    if (opts.height != null) {
      height = opts.height;
    }

    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly

    root.width = width * this.dpr;
    root.height = height * this.dpr;
    this._width = width;
    this._height = height; // Create layer if only one given canvas
    // Device can be specified to create a high dpi image.

    var mainLayer = new Layer(root, this, this.dpr);
    mainLayer.__builtin__ = true;
    mainLayer.initContext(); // FIXME Use canvas width and height
    // mainLayer.resize(width, height);

    layers[CANVAS_ZLEVEL] = mainLayer;
    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.

    zlevelList.push(CANVAS_ZLEVEL);
    this._domRoot = root;
  }
  /**
   * @type {module:zrender/Layer}
   * @private
   */


  this._hoverlayer = null;
  this._hoverElements = [];
};

Painter.prototype = {
  constructor: Painter,
  getType: function () {
    return 'canvas';
  },

  /**
   * If painter use a single canvas
   * @return {boolean}
   */
  isSingleCanvas: function () {
    return this._singleCanvas;
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._domRoot;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */
  refresh: function (paintAll) {
    var list = this.storage.getDisplayList(true);
    var zlevelList = this._zlevelList;
    this._redrawId = Math.random();

    this._paintList(list, paintAll, this._redrawId); // Paint custum layers


    for (var i = 0; i < zlevelList.length; i++) {
      var z = zlevelList[i];
      var layer = this._layers[z];

      if (!layer.__builtin__ && layer.refresh) {
        var clearColor = i === 0 ? this._backgroundColor : null;
        layer.refresh(clearColor);
      }
    }

    this.refreshHover();
    return this;
  },
  addHover: function (el, hoverStyle) {
    if (el.__hoverMir) {
      return;
    }

    var elMirror = new el.constructor({
      style: el.style,
      shape: el.shape,
      z: el.z,
      z2: el.z2,
      silent: el.silent
    });
    elMirror.__from = el;
    el.__hoverMir = elMirror;
    hoverStyle && elMirror.setStyle(hoverStyle);

    this._hoverElements.push(elMirror);

    return elMirror;
  },
  removeHover: function (el) {
    var elMirror = el.__hoverMir;
    var hoverElements = this._hoverElements;
    var idx = util.indexOf(hoverElements, elMirror);

    if (idx >= 0) {
      hoverElements.splice(idx, 1);
    }

    el.__hoverMir = null;
  },
  clearHover: function (el) {
    var hoverElements = this._hoverElements;

    for (var i = 0; i < hoverElements.length; i++) {
      var from = hoverElements[i].__from;

      if (from) {
        from.__hoverMir = null;
      }
    }

    hoverElements.length = 0;
  },
  refreshHover: function () {
    var hoverElements = this._hoverElements;
    var len = hoverElements.length;
    var hoverLayer = this._hoverlayer;
    hoverLayer && hoverLayer.clear();

    if (!len) {
      return;
    }

    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
    // FIXME?

    if (!hoverLayer) {
      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
    }

    var scope = {};
    hoverLayer.ctx.save();

    for (var i = 0; i < len;) {
      var el = hoverElements[i];
      var originalEl = el.__from; // Original el is removed
      // PENDING

      if (!(originalEl && originalEl.__zr)) {
        hoverElements.splice(i, 1);
        originalEl.__hoverMir = null;
        len--;
        continue;
      }

      i++; // Use transform
      // FIXME style and shape ?

      if (!originalEl.invisible) {
        el.transform = originalEl.transform;
        el.invTransform = originalEl.invTransform;
        el.__clipPaths = originalEl.__clipPaths; // el.

        this._doPaintEl(el, hoverLayer, true, scope);
      }
    }

    hoverLayer.ctx.restore();
  },
  getHoverLayer: function () {
    return this.getLayer(HOVER_LAYER_ZLEVEL);
  },
  _paintList: function (list, paintAll, redrawId) {
    if (this._redrawId !== redrawId) {
      return;
    }

    paintAll = paintAll || false;

    this._updateLayerStatus(list);

    var finished = this._doPaintList(list, paintAll);

    if (this._needsManuallyCompositing) {
      this._compositeManually();
    }

    if (!finished) {
      var self = this;
      requestAnimationFrame(function () {
        self._paintList(list, paintAll, redrawId);
      });
    }
  },
  _compositeManually: function () {
    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
    var width = this._domRoot.width;
    var height = this._domRoot.height;
    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?

    this.eachBuiltinLayer(function (layer) {
      if (layer.virtual) {
        ctx.drawImage(layer.dom, 0, 0, width, height);
      }
    });
  },
  _doPaintList: function (list, paintAll) {
    var layerList = [];

    for (var zi = 0; zi < this._zlevelList.length; zi++) {
      var zlevel = this._zlevelList[zi];
      var layer = this._layers[zlevel];

      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
        layerList.push(layer);
      }
    }

    var finished = true;

    for (var k = 0; k < layerList.length; k++) {
      var layer = layerList[k];
      var ctx = layer.ctx;
      var scope = {};
      ctx.save();
      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
      var useTimer = !paintAll && layer.incremental && Date.now;
      var startTime = useTimer && Date.now();
      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.

      if (layer.__startIndex === layer.__endIndex) {
        layer.clear(false, clearColor);
      } else if (start === layer.__startIndex) {
        var firstEl = list[start];

        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
          layer.clear(false, clearColor);
        }
      }

      if (start === -1) {
        console.error('For some unknown reason. drawIndex is -1');
        start = layer.__startIndex;
      }

      for (var i = start; i < layer.__endIndex; i++) {
        var el = list[i];

        this._doPaintEl(el, layer, paintAll, scope);

        el.__dirty = el.__dirtyText = false;

        if (useTimer) {
          // Date.now can be executed in 13,025,305 ops/second.
          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
          // The rest elements will be drawn in the next frame.

          if (dTime > 15) {
            break;
          }
        }
      }

      layer.__drawIndex = i;

      if (layer.__drawIndex < layer.__endIndex) {
        finished = false;
      }

      if (scope.prevElClipPaths) {
        // Needs restore the state. If last drawn element is in the clipping area.
        ctx.restore();
      }

      ctx.restore();
    }

    if (env.wxa) {
      // Flush for weixin application
      util.each(this._layers, function (layer) {
        if (layer && layer.ctx && layer.ctx.draw) {
          layer.ctx.draw();
        }
      });
    }

    return finished;
  },
  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
    var ctx = currentLayer.ctx;
    var m = el.transform;

    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
    !el.invisible // Ignore transparent element
    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
    // Draw a scale 0 element can cause all following draw wrong
    // And setTransform with scale 0 will cause set back transform failed.
    && !(m && !m[0] && !m[3]) // Ignore culled element
    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
      var clipPaths = el.__clipPaths;
      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements

      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
        // If has previous clipping state, restore from it
        if (prevElClipPaths) {
          ctx.restore();
          scope.prevElClipPaths = null; // Reset prevEl since context has been restored

          scope.prevEl = null;
        } // New clipping state


        if (clipPaths) {
          ctx.save();
          doClip(clipPaths, ctx);
          scope.prevElClipPaths = clipPaths;
        }
      }

      el.beforeBrush && el.beforeBrush(ctx);
      el.brush(ctx, scope.prevEl || null);
      scope.prevEl = el;
      el.afterBrush && el.afterBrush(ctx);
    }
  },

  /**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @param {boolean} virtual Virtual layer will not be inserted into dom.
   * @return {module:zrender/Layer}
   */
  getLayer: function (zlevel, virtual) {
    if (this._singleCanvas && !this._needsManuallyCompositing) {
      zlevel = CANVAS_ZLEVEL;
    }

    var layer = this._layers[zlevel];

    if (!layer) {
      // Create a new layer
      layer = new Layer('zr_' + zlevel, this, this.dpr);
      layer.zlevel = zlevel;
      layer.__builtin__ = true;

      if (this._layerConfig[zlevel]) {
        util.merge(layer, this._layerConfig[zlevel], true);
      }

      if (virtual) {
        layer.virtual = virtual;
      }

      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
      // Or excanvas will get 0px clientWidth and clientHeight

      layer.initContext();
    }

    return layer;
  },
  insertLayer: function (zlevel, layer) {
    var layersMap = this._layers;
    var zlevelList = this._zlevelList;
    var len = zlevelList.length;
    var prevLayer = null;
    var i = -1;
    var domRoot = this._domRoot;

    if (layersMap[zlevel]) {
      logError('ZLevel ' + zlevel + ' has been used already');
      return;
    } // Check if is a valid layer


    if (!isLayerValid(layer)) {
      logError('Layer of zlevel ' + zlevel + ' is not valid');
      return;
    }

    if (len > 0 && zlevel > zlevelList[0]) {
      for (i = 0; i < len - 1; i++) {
        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
          break;
        }
      }

      prevLayer = layersMap[zlevelList[i]];
    }

    zlevelList.splice(i + 1, 0, zlevel);
    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
    // (It can be a WebGL layer and assigned to a ZImage element)
    // But it still under management of zrender.

    if (!layer.virtual) {
      if (prevLayer) {
        var prevDom = prevLayer.dom;

        if (prevDom.nextSibling) {
          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
        } else {
          domRoot.appendChild(layer.dom);
        }
      } else {
        if (domRoot.firstChild) {
          domRoot.insertBefore(layer.dom, domRoot.firstChild);
        } else {
          domRoot.appendChild(layer.dom);
        }
      }
    }
  },
  // Iterate each layer
  eachLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      cb.call(context, this._layers[z], z);
    }
  },
  // Iterate each buildin layer
  eachBuiltinLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },
  // Iterate each other layer except buildin layer
  eachOtherLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (!layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },

  /**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */
  getLayers: function () {
    return this._layers;
  },
  _updateLayerStatus: function (list) {
    this.eachBuiltinLayer(function (layer, z) {
      layer.__dirty = layer.__used = false;
    });

    function updatePrevLayer(idx) {
      if (prevLayer) {
        if (prevLayer.__endIndex !== idx) {
          prevLayer.__dirty = true;
        }

        prevLayer.__endIndex = idx;
      }
    }

    if (this._singleCanvas) {
      for (var i = 1; i < list.length; i++) {
        var el = list[i];

        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
          this._needsManuallyCompositing = true;
          break;
        }
      }
    }

    var prevLayer = null;
    var incrementalLayerCount = 0;

    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var zlevel = el.zlevel;
      var layer; // PENDING If change one incremental element style ?
      // TODO Where there are non-incremental elements between incremental elements.

      if (el.incremental) {
        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
        layer.incremental = true;
        incrementalLayerCount = 1;
      } else {
        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
      }

      if (!layer.__builtin__) {
        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
      }

      if (layer !== prevLayer) {
        layer.__used = true;

        if (layer.__startIndex !== i) {
          layer.__dirty = true;
        }

        layer.__startIndex = i;

        if (!layer.incremental) {
          layer.__drawIndex = i;
        } else {
          // Mark layer draw index needs to update.
          layer.__drawIndex = -1;
        }

        updatePrevLayer(i);
        prevLayer = layer;
      }

      if (el.__dirty) {
        layer.__dirty = true;

        if (layer.incremental && layer.__drawIndex < 0) {
          // Start draw from the first dirty element.
          layer.__drawIndex = i;
        }
      }
    }

    updatePrevLayer(i);
    this.eachBuiltinLayer(function (layer, z) {
      // Used in last frame but not in this frame. Needs clear
      if (!layer.__used && layer.getElementCount() > 0) {
        layer.__dirty = true;
        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
      } // For incremental layer. In case start index changed and no elements are dirty.


      if (layer.__dirty && layer.__drawIndex < 0) {
        layer.__drawIndex = layer.__startIndex;
      }
    });
  },

  /**
   * 清除hover层外所有内容
   */
  clear: function () {
    this.eachBuiltinLayer(this._clearLayer);
    return this;
  },
  _clearLayer: function (layer) {
    layer.clear();
  },
  setBackgroundColor: function (backgroundColor) {
    this._backgroundColor = backgroundColor;
  },

  /**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */
  configLayer: function (zlevel, config) {
    if (config) {
      var layerConfig = this._layerConfig;

      if (!layerConfig[zlevel]) {
        layerConfig[zlevel] = config;
      } else {
        util.merge(layerConfig[zlevel], config, true);
      }

      for (var i = 0; i < this._zlevelList.length; i++) {
        var _zlevel = this._zlevelList[i];

        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
          var layer = this._layers[_zlevel];
          util.merge(layer, layerConfig[zlevel], true);
        }
      }
    }
  },

  /**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */
  delLayer: function (zlevel) {
    var layers = this._layers;
    var zlevelList = this._zlevelList;
    var layer = layers[zlevel];

    if (!layer) {
      return;
    }

    layer.dom.parentNode.removeChild(layer.dom);
    delete layers[zlevel];
    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
  },

  /**
   * 区域大小变化后重绘
   */
  resize: function (width, height) {
    if (!this._domRoot.style) {
      // Maybe in node or worker
      if (width == null || height == null) {
        return;
      }

      this._width = width;
      this._height = height;
      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
    } else {
      var domRoot = this._domRoot; // FIXME Why ?

      domRoot.style.display = 'none'; // Save input w/h

      var opts = this._opts;
      width != null && (opts.width = width);
      height != null && (opts.height = height);
      width = this._getSize(0);
      height = this._getSize(1);
      domRoot.style.display = ''; // 优化没有实际改变的resize

      if (this._width !== width || height !== this._height) {
        domRoot.style.width = width + 'px';
        domRoot.style.height = height + 'px';

        for (var id in this._layers) {
          if (this._layers.hasOwnProperty(id)) {
            this._layers[id].resize(width, height);
          }
        }

        util.each(this._progressiveLayers, function (layer) {
          layer.resize(width, height);
        });
        this.refresh(true);
      }

      this._width = width;
      this._height = height;
    }

    return this;
  },

  /**
   * 清除单独的一个层
   * @param {number} zlevel
   */
  clearLayer: function (zlevel) {
    var layer = this._layers[zlevel];

    if (layer) {
      layer.clear();
    }
  },

  /**
   * 释放
   */
  dispose: function () {
    this.root.innerHTML = '';
    this.root = this.storage = this._domRoot = this._layers = null;
  },

  /**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */
  getRenderedCanvas: function (opts) {
    opts = opts || {};

    if (this._singleCanvas && !this._compositeManually) {
      return this._layers[CANVAS_ZLEVEL].dom;
    }

    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
    imageLayer.initContext();
    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);

    if (opts.pixelRatio <= this.dpr) {
      this.refresh();
      var width = imageLayer.dom.width;
      var height = imageLayer.dom.height;
      var ctx = imageLayer.ctx;
      this.eachLayer(function (layer) {
        if (layer.__builtin__) {
          ctx.drawImage(layer.dom, 0, 0, width, height);
        } else if (layer.renderToCanvas) {
          imageLayer.ctx.save();
          layer.renderToCanvas(imageLayer.ctx);
          imageLayer.ctx.restore();
        }
      });
    } else {
      // PENDING, echarts-gl and incremental rendering.
      var scope = {};
      var displayList = this.storage.getDisplayList(true);

      for (var i = 0; i < displayList.length; i++) {
        var el = displayList[i];

        this._doPaintEl(el, imageLayer, true, scope);
      }
    }

    return imageLayer.dom;
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  pathToImage: function (path, dpr) {
    dpr = dpr || this.dpr;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var rect = path.getBoundingRect();
    var style = path.style;
    var shadowBlurSize = style.shadowBlur * dpr;
    var shadowOffsetX = style.shadowOffsetX * dpr;
    var shadowOffsetY = style.shadowOffsetY * dpr;
    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
    var width = rect.width + leftMargin + rightMargin;
    var height = rect.height + topMargin + bottomMargin;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);
    ctx.dpr = dpr;
    var pathTransform = {
      position: path.position,
      rotation: path.rotation,
      scale: path.scale
    };
    path.position = [leftMargin - rect.x, topMargin - rect.y];
    path.rotation = 0;
    path.scale = [1, 1];
    path.updateTransform();

    if (path) {
      path.brush(ctx);
    }

    var ImageShape = Image;
    var imgShape = new ImageShape({
      style: {
        x: 0,
        y: 0,
        image: canvas
      }
    });

    if (pathTransform.position != null) {
      imgShape.position = path.position = pathTransform.position;
    }

    if (pathTransform.rotation != null) {
      imgShape.rotation = path.rotation = pathTransform.rotation;
    }

    if (pathTransform.scale != null) {
      imgShape.scale = path.scale = pathTransform.scale;
    }

    return imgShape;
  }
};
var _default = Painter;
module.exports = _default;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2);

var _config = __webpack_require__(124);

var devicePixelRatio = _config.devicePixelRatio;

var Style = __webpack_require__(170);

var Pattern = __webpack_require__(258);

/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */
function returnFalse() {
  return false;
}
/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */


function createDom(id, painter, dpr) {
  var newDom = util.createCanvas();
  var width = painter.getWidth();
  var height = painter.getHeight();
  var newDomStyle = newDom.style;

  if (newDomStyle) {
    // In node or some other non-browser environment
    newDomStyle.position = 'absolute';
    newDomStyle.left = 0;
    newDomStyle.top = 0;
    newDomStyle.width = width + 'px';
    newDomStyle.height = height + 'px';
    newDom.setAttribute('data-zr-dom-id', id);
  }

  newDom.width = width * dpr;
  newDom.height = height * dpr;
  return newDom;
}
/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */


var Layer = function (id, painter, dpr) {
  var dom;
  dpr = dpr || devicePixelRatio;

  if (typeof id === 'string') {
    dom = createDom(id, painter, dpr);
  } // Not using isDom because in node it will return false
  else if (util.isObject(id)) {
      dom = id;
      id = dom.id;
    }

  this.id = id;
  this.dom = dom;
  var domStyle = dom.style;

  if (domStyle) {
    // Not in node
    dom.onselectstart = returnFalse; // 避免页面选中的尴尬

    domStyle['-webkit-user-select'] = 'none';
    domStyle['user-select'] = 'none';
    domStyle['-webkit-touch-callout'] = 'none';
    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
    domStyle['padding'] = 0; // eslint-disable-line dot-notation

    domStyle['margin'] = 0; // eslint-disable-line dot-notation

    domStyle['border-width'] = 0;
  }

  this.domBack = null;
  this.ctxBack = null;
  this.painter = painter;
  this.config = null; // Configs

  /**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */

  this.clearColor = 0;
  /**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */

  this.motionBlur = false;
  /**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */

  this.lastFrameAlpha = 0.7;
  /**
   * Layer dpr
   * @type {number}
   */

  this.dpr = dpr;
};

Layer.prototype = {
  constructor: Layer,
  __dirty: true,
  __used: false,
  __drawIndex: 0,
  __startIndex: 0,
  __endIndex: 0,
  incremental: false,
  getElementCount: function () {
    return this.__endIndex - this.__startIndex;
  },
  initContext: function () {
    this.ctx = this.dom.getContext('2d');
    this.ctx.dpr = this.dpr;
  },
  createBackBuffer: function () {
    var dpr = this.dpr;
    this.domBack = createDom('back-' + this.id, this.painter, dpr);
    this.ctxBack = this.domBack.getContext('2d');

    if (dpr !== 1) {
      this.ctxBack.scale(dpr, dpr);
    }
  },

  /**
   * @param  {number} width
   * @param  {number} height
   */
  resize: function (width, height) {
    var dpr = this.dpr;
    var dom = this.dom;
    var domStyle = dom.style;
    var domBack = this.domBack;

    if (domStyle) {
      domStyle.width = width + 'px';
      domStyle.height = height + 'px';
    }

    dom.width = width * dpr;
    dom.height = height * dpr;

    if (domBack) {
      domBack.width = width * dpr;
      domBack.height = height * dpr;

      if (dpr !== 1) {
        this.ctxBack.scale(dpr, dpr);
      }
    }
  },

  /**
   * 清空该层画布
   * @param {boolean} [clearAll]=false Clear all with out motion blur
   * @param {Color} [clearColor]
   */
  clear: function (clearAll, clearColor) {
    var dom = this.dom;
    var ctx = this.ctx;
    var width = dom.width;
    var height = dom.height;
    var clearColor = clearColor || this.clearColor;
    var haveMotionBLur = this.motionBlur && !clearAll;
    var lastFrameAlpha = this.lastFrameAlpha;
    var dpr = this.dpr;

    if (haveMotionBLur) {
      if (!this.domBack) {
        this.createBackBuffer();
      }

      this.ctxBack.globalCompositeOperation = 'copy';
      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
    }

    ctx.clearRect(0, 0, width, height);

    if (clearColor && clearColor !== 'transparent') {
      var clearColorGradientOrPattern; // Gradient

      if (clearColor.colorStops) {
        // Cache canvas gradient
        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
          x: 0,
          y: 0,
          width: width,
          height: height
        });
        clearColor.__canvasGradient = clearColorGradientOrPattern;
      } // Pattern
      else if (clearColor.image) {
          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
        }

      ctx.save();
      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    }

    if (haveMotionBLur) {
      var domBack = this.domBack;
      ctx.save();
      ctx.globalAlpha = lastFrameAlpha;
      ctx.drawImage(domBack, 0, 0, width, height);
      ctx.restore();
    }
  }
};
var _default = Layer;
module.exports = _default;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var textHelper = __webpack_require__(260);

var BoundingRect = __webpack_require__(33);

var _constant = __webpack_require__(125);

var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;

/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */
var tmpRect = new BoundingRect();

var RectText = function () {};

RectText.prototype = {
  constructor: RectText,

  /**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */
  drawRectText: function (ctx, rect) {
    var style = this.style;
    rect = style.textRect || rect; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!textHelper.needDrawText(text, style)) {
      return;
    } // FIXME
    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
    // text propably break the cache for its host elements.


    ctx.save(); // Transform rect to view space

    var transform = this.transform;

    if (!style.transformText) {
      if (transform) {
        tmpRect.copy(rect);
        tmpRect.applyTransform(transform);
        rect = tmpRect;
      }
    } else {
      this.setTransform(ctx);
    } // transformText and textRotation can not be used at the same time.


    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
    ctx.restore();
  }
};
var _default = RectText;
module.exports = _default;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2);

var _event = __webpack_require__(83);

var Dispatcher = _event.Dispatcher;

var requestAnimationFrame = __webpack_require__(259);

var Animator = __webpack_require__(254);

/**
 * Animation main class, dispatch and manage all animation controllers
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */
// TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236

/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 */

/**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */
var Animation = function (options) {
  options = options || {};
  this.stage = options.stage || {};

  this.onframe = options.onframe || function () {}; // private properties


  this._clips = [];
  this._running = false;
  this._time;
  this._pausedTime;
  this._pauseStart;
  this._paused = false;
  Dispatcher.call(this);
};

Animation.prototype = {
  constructor: Animation,

  /**
   * Add clip
   * @param {module:zrender/animation/Clip} clip
   */
  addClip: function (clip) {
    this._clips.push(clip);
  },

  /**
   * Add animator
   * @param {module:zrender/animation/Animator} animator
   */
  addAnimator: function (animator) {
    animator.animation = this;
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.addClip(clips[i]);
    }
  },

  /**
   * Delete animation clip
   * @param {module:zrender/animation/Clip} clip
   */
  removeClip: function (clip) {
    var idx = util.indexOf(this._clips, clip);

    if (idx >= 0) {
      this._clips.splice(idx, 1);
    }
  },

  /**
   * Delete animation clip
   * @param {module:zrender/animation/Animator} animator
   */
  removeAnimator: function (animator) {
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.removeClip(clips[i]);
    }

    animator.animation = null;
  },
  _update: function () {
    var time = new Date().getTime() - this._pausedTime;

    var delta = time - this._time;
    var clips = this._clips;
    var len = clips.length;
    var deferredEvents = [];
    var deferredClips = [];

    for (var i = 0; i < len; i++) {
      var clip = clips[i];
      var e = clip.step(time, delta); // Throw out the events need to be called after
      // stage.update, like destroy

      if (e) {
        deferredEvents.push(e);
        deferredClips.push(clip);
      }
    } // Remove the finished clip


    for (var i = 0; i < len;) {
      if (clips[i]._needsRemove) {
        clips[i] = clips[len - 1];
        clips.pop();
        len--;
      } else {
        i++;
      }
    }

    len = deferredEvents.length;

    for (var i = 0; i < len; i++) {
      deferredClips[i].fire(deferredEvents[i]);
    }

    this._time = time;
    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
    // depends on the sequence (e.g., echarts-stream and finish
    // event judge)

    this.trigger('frame', delta);

    if (this.stage.update) {
      this.stage.update();
    }
  },
  _startLoop: function () {
    var self = this;
    this._running = true;

    function step() {
      if (self._running) {
        requestAnimationFrame(step);
        !self._paused && self._update();
      }
    }

    requestAnimationFrame(step);
  },

  /**
   * Start animation.
   */
  start: function () {
    this._time = new Date().getTime();
    this._pausedTime = 0;

    this._startLoop();
  },

  /**
   * Stop animation.
   */
  stop: function () {
    this._running = false;
  },

  /**
   * Pause animation.
   */
  pause: function () {
    if (!this._paused) {
      this._pauseStart = new Date().getTime();
      this._paused = true;
    }
  },

  /**
   * Resume animation.
   */
  resume: function () {
    if (this._paused) {
      this._pausedTime += new Date().getTime() - this._pauseStart;
      this._paused = false;
    }
  },

  /**
   * Clear animation.
   */
  clear: function () {
    this._clips = [];
  },

  /**
   * Whether animation finished.
   */
  isFinished: function () {
    return !this._clips.length;
  },

  /**
   * Creat animator for a target, whose props can be animated.
   *
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] Whether loop animation.
   * @param  {Function} [options.getter=null] Get value from target.
   * @param  {Function} [options.setter=null] Set value to target.
   * @return {module:zrender/animation/Animation~Animator}
   */
  // TODO Gap
  animate: function (target, options) {
    options = options || {};
    var animator = new Animator(target, options.loop, options.getter, options.setter);
    this.addAnimator(animator);
    return animator;
  }
};
util.mixin(Animation, Dispatcher);
var _default = Animation;
module.exports = _default;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var _event = __webpack_require__(83);

var addEventListener = _event.addEventListener;
var removeEventListener = _event.removeEventListener;
var normalizeEvent = _event.normalizeEvent;
var getNativeEvent = _event.getNativeEvent;

var zrUtil = __webpack_require__(2);

var Eventful = __webpack_require__(97);

var env = __webpack_require__(25);

/* global document */
var TOUCH_CLICK_DELAY = 300;
var globalEventSupported = env.domSupported;

var localNativeListenerNames = function () {
  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
  var pointerEventNameMap = {
    pointerdown: 1,
    pointerup: 1,
    pointermove: 1,
    pointerout: 1
  };
  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
    var nm = name.replace('mouse', 'pointer');
    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
  });
  return {
    mouse: mouseHandlerNames,
    touch: touchHandlerNames,
    pointer: pointerHandlerNames
  };
}();

var globalNativeListenerNames = {
  mouse: ['mousemove', 'mouseup'],
  pointer: ['pointermove', 'pointerup']
};

function eventNameFix(name) {
  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
}

function isPointerFromTouch(event) {
  var pointerType = event.pointerType;
  return pointerType === 'pen' || pointerType === 'touch';
} // function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }

/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 *
 * @param {DOMHandlerScope} scope
 */


function setTouchTimer(scope) {
  scope.touching = true;

  if (scope.touchTimer != null) {
    clearTimeout(scope.touchTimer);
    scope.touchTimer = null;
  }

  scope.touchTimer = setTimeout(function () {
    scope.touching = false;
    scope.touchTimer = null;
  }, 700);
} // Mark touch, which is useful in distinguish touch and
// mouse event in upper applicatoin.


function markTouch(event) {
  event && (event.zrByTouch = true);
} // function markTriggeredFromLocal(event) {
//     event && (event.__zrIsFromLocal = true);
// }
// function isTriggeredFromLocal(instance, event) {
//     return !!(event && event.__zrIsFromLocal);
// }


function normalizeGlobalEvent(instance, event) {
  // offsetX, offsetY still need to be calculated. They are necessary in the event
  // handlers of the upper applications. Set `true` to force calculate them.
  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
}
/**
 * Detect whether the given el is in `painterRoot`.
 */


function isLocalEl(instance, el) {
  var elTmp = el;
  var isLocal = false;

  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
    elTmp = elTmp.parentNode;
  }

  return isLocal;
}
/**
 * Make a fake event but not change the original event,
 * becuase the global event probably be used by other
 * listeners not belonging to zrender.
 * @class
 */


function FakeGlobalEvent(instance, event) {
  this.type = event.type;
  this.target = this.currentTarget = instance.dom;
  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY

  this.clientX = event.clientX;
  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
  // we do not copy `targetTouches` and `changedTouches` here.
}

var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
// otherwise it is dangerous. See more details in
// [Drag outside] in `Handler.js`.

fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
/**
 * Local DOM Handlers
 * @this {HandlerProxy}
 */

var localDOMHandlers = {
  mousedown: function (event) {
    event = normalizeEvent(this.dom, event);
    this._mayPointerCapture = [event.zrX, event.zrY];
    this.trigger('mousedown', event);
  },
  mousemove: function (event) {
    event = normalizeEvent(this.dom, event);
    var downPoint = this._mayPointerCapture;

    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
      togglePointerCapture(this, true);
    }

    this.trigger('mousemove', event);
  },
  mouseup: function (event) {
    event = normalizeEvent(this.dom, event);
    togglePointerCapture(this, false);
    this.trigger('mouseup', event);
  },
  mouseout: function (event) {
    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
    // `globalout` will be delayed to final pointer cature release.

    if (this._pointerCapturing) {
      event.zrEventControl = 'no_globalout';
    } // There might be some doms created by upper layer application
    // at the same level of painter.getViewportRoot() (e.g., tooltip
    // dom created by echarts), where 'globalout' event should not
    // be triggered when mouse enters these doms. (But 'mouseout'
    // should be triggered at the original hovered element as usual).


    var element = event.toElement || event.relatedTarget;
    event.zrIsToLocalDOM = isLocalEl(this, element);
    this.trigger('mouseout', event);
  },
  touchstart: function (event) {
    // Default mouse behaviour should not be disabled here.
    // For example, page may needs to be slided.
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this._lastTouchMoment = new Date();
    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
    // we simulate "mouseover-->mousedown" in touch device. So we trigger
    // `mousemove` here (to trigger `mouseover` inside), and then trigger
    // `mousedown`.

    localDOMHandlers.mousemove.call(this, event);
    localDOMHandlers.mousedown.call(this, event);
  },
  touchmove: function (event) {
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
    // there is gestrue event, because mouse move and pinch may
    // be used at the same time.

    localDOMHandlers.mousemove.call(this, event);
  },
  touchend: function (event) {
    event = normalizeEvent(this.dom, event);
    markTouch(event);
    this.handler.processGesture(event, 'end');
    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
    // we can conveniently implement "hover style" in both PC and touch device just
    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
    // to remove "hover style" on an element, without any additional code for
    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
    // style" will remain for user view)
    // click event should always be triggered no matter whether
    // there is gestrue event. System click can not be prevented.

    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
      localDOMHandlers.click.call(this, event);
    }
  },
  pointerdown: function (event) {
    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
    //     this._msGesture.addPointer(event.pointerId);
    // }
  },
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      localDOMHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    localDOMHandlers.mouseup.call(this, event);
  },
  pointerout: function (event) {
    // pointerout will be triggered when tap on touch screen
    // (IE11+/Edge on MS Surface) after click event triggered,
    // which is inconsistent with the mousout behavior we defined
    // in touchend. So we unify them.
    // (check localDOMHandlers.touchend for detailed explanation)
    if (!isPointerFromTouch(event)) {
      localDOMHandlers.mouseout.call(this, event);
    }
  }
};
/**
 * Othere DOM UI Event handlers for zr dom.
 * @this {HandlerProxy}
 */

zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  localDOMHandlers[name] = function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger(name, event);
  };
});
/**
 * DOM UI Event handlers for global page.
 *
 * [Caution]:
 * those handlers should both support in capture phase and bubble phase!
 *
 * @this {HandlerProxy}
 */

var globalDOMHandlers = {
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      globalDOMHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    globalDOMHandlers.mouseup.call(this, event);
  },
  mousemove: function (event) {
    this.trigger('mousemove', event);
  },
  mouseup: function (event) {
    var pointerCaptureReleasing = this._pointerCapturing;
    togglePointerCapture(this, false);
    this.trigger('mouseup', event);

    if (pointerCaptureReleasing) {
      event.zrEventControl = 'only_globalout';
      this.trigger('mouseout', event);
    }
  }
};
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */

function mountLocalDOMEventListeners(instance, scope) {
  var domHandlers = scope.domHandlers;

  if (env.pointerEventsSupported) {
    // Only IE11+/Edge
    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
    // at the same time.
    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
    // screen, which do not occurs in pointer event.
    // So we use pointer event to both detect touch gesture and mouse behavior.
    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
        // markTriggeredFromLocal(event);
        domHandlers[nativeEventName].call(instance, event);
      });
    }); // FIXME
    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
    // which does not prevent defuault behavior occasionally (which may cause view port
    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
    // touch screen. And we only support click behavior on MS touch screen now.
    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
    // We dont support touch on IE on win7.
    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
    // if (typeof MSGesture === 'function') {
    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
    // }
  } else {
    if (env.touchEventsSupported) {
      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
          // markTriggeredFromLocal(event);
          domHandlers[nativeEventName].call(instance, event);
          setTouchTimer(scope);
        });
      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
      // addEventListener(root, 'mouseout', this._mouseoutHandler);
    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
    // mouse event can not be handle in those devices.
    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
    // mouseevent after touch event triggered, see `setTouchTimer`.


    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
        event = getNativeEvent(event);

        if (!scope.touching) {
          // markTriggeredFromLocal(event);
          domHandlers[nativeEventName].call(instance, event);
        }
      });
    });
  }
}
/**
 * @param {HandlerProxy} instance
 * @param {DOMHandlerScope} scope
 */


function mountGlobalDOMEventListeners(instance, scope) {
  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
  if (env.pointerEventsSupported) {
    zrUtil.each(globalNativeListenerNames.pointer, mount);
  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
  else if (!env.touchEventsSupported) {
      zrUtil.each(globalNativeListenerNames.mouse, mount);
    }

  function mount(nativeEventName) {
    function nativeEventListener(event) {
      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
      // This checking supports both `useCapture` or not.
      // PENDING: if there is performance issue in some devices,
      // we probably can not use `useCapture` and change a easier
      // to judes whether local (mark).

      if (!isLocalEl(instance, event.target)) {
        event = normalizeGlobalEvent(instance, event);
        scope.domHandlers[nativeEventName].call(instance, event);
      }
    }

    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
      capture: true
    } // See [Drag Outside] in `Handler.js`
    );
  }
}

function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
  scope.mounted[nativeEventName] = listener;
  scope.listenerOpts[nativeEventName] = opt;
  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
}

function unmountDOMEventListeners(scope) {
  var mounted = scope.mounted;

  for (var nativeEventName in mounted) {
    if (mounted.hasOwnProperty(nativeEventName)) {
      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    }
  }

  scope.mounted = {};
}
/**
 * See [Drag Outside] in `Handler.js`.
 * @implement
 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
 *        `true`: start to capture pointer if it is not capturing.
 *        `false`: end the capture if it is capturing.
 */


function togglePointerCapture(instance, isPointerCapturing) {
  instance._mayPointerCapture = null;

  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
    instance._pointerCapturing = isPointerCapturing;
    var globalHandlerScope = instance._globalHandlerScope;
    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
  }
}
/**
 * @inner
 * @class
 */


function DOMHandlerScope(domTarget, domHandlers) {
  this.domTarget = domTarget;
  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
  // Used for unmount.

  this.mounted = {};
  this.listenerOpts = {};
  this.touchTimer = null;
  this.touching = false;
}
/**
 * @public
 * @class
 */


function HandlerDomProxy(dom, painterRoot) {
  Eventful.call(this);
  this.dom = dom;
  this.painterRoot = painterRoot;
  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);

  if (globalEventSupported) {
    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
  }
  /**
   * @type {boolean}
   */


  this._pointerCapturing = false;
  /**
   * @type {Array.<number>} [x, y] or null.
   */

  this._mayPointerCapture = null;
  mountLocalDOMEventListeners(this, this._localHandlerScope);
}

var handlerDomProxyProto = HandlerDomProxy.prototype;

handlerDomProxyProto.dispose = function () {
  unmountDOMEventListeners(this._localHandlerScope);

  if (globalEventSupported) {
    unmountDOMEventListeners(this._globalHandlerScope);
  }
};

handlerDomProxyProto.setCursor = function (cursorStyle) {
  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
};

zrUtil.mixin(HandlerDomProxy, Eventful);
var _default = HandlerDomProxy;
module.exports = _default;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(173);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getLineStyle: function (excludes) {
    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
    // erase the previous style when assigning to el.style.

    style.lineDash = this.getLineDash(style.lineWidth);
    return style;
  },
  getLineDash: function (lineWidth) {
    if (lineWidth == null) {
      lineWidth = 1;
    }

    var lineType = this.get('type');
    var dotSize = Math.max(lineWidth, 2);
    var dashSize = lineWidth * 4;
    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
    // `lineDash` gotten form the latter one is not able to erase that from the former
    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
  }
};
module.exports = _default;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(173);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
var _default = {
  getAreaStyle: function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  }
};
module.exports = _default;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var textContain = __webpack_require__(75);

var graphicUtil = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PATH_COLOR = ['textStyle', 'color'];
var _default = {
  /**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */
  getTextColor: function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  },

  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */
  getFont: function () {
    return graphicUtil.getFont({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  },
  getTextRect: function (text) {
    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
  }
};
module.exports = _default;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(127);

var line = __webpack_require__(819);

var cubic = __webpack_require__(820);

var quadratic = __webpack_require__(821);

var arc = __webpack_require__(822);

var _util = __webpack_require__(265);

var normalizeRadian = _util.normalizeRadian;

var curve = __webpack_require__(84);

var windingLine = __webpack_require__(266);

var CMD = PathProxy.CMD;
var PI2 = Math.PI * 2;
var EPSILON = 1e-4;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
} // 临时数组


var roots = [-1, -1, -1];
var extrema = [-1, -1];

function swapExtrema() {
  var tmp = extrema[0];
  extrema[0] = extrema[1];
  extrema[1] = tmp;
}

function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
    return 0;
  }

  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var w = 0;
    var nExtrema = -1;
    var y0_;
    var y1_;

    for (var i = 0; i < nRoots; i++) {
      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon

      var unit = t === 0 || t === 1 ? 0.5 : 1;
      var x_ = curve.cubicAt(x0, x1, x2, x3, t);

      if (x_ < x) {
        // Quick reject
        continue;
      }

      if (nExtrema < 0) {
        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);

        if (extrema[1] < extrema[0] && nExtrema > 1) {
          swapExtrema();
        }

        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);

        if (nExtrema > 1) {
          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
        }
      }

      if (nExtrema === 2) {
        // 分成三段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else if (t < extrema[1]) {
          w += y1_ < y0_ ? unit : -unit;
        } else {
          w += y3 < y1_ ? unit : -unit;
        }
      } else {
        // 分成两段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else {
          w += y3 < y0_ ? unit : -unit;
        }
      }
    }

    return w;
  }
}

function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
    return 0;
  }

  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var t = curve.quadraticExtremum(y0, y1, y2);

    if (t >= 0 && t <= 1) {
      var w = 0;
      var y_ = curve.quadraticAt(y0, y1, y2, t);

      for (var i = 0; i < nRoots; i++) {
        // Remove one endpoint.
        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);

        if (x_ < x) {
          // Quick reject
          continue;
        }

        if (roots[i] < t) {
          w += y_ < y0 ? unit : -unit;
        } else {
          w += y2 < y_ ? unit : -unit;
        }
      }

      return w;
    } else {
      // Remove one endpoint.
      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);

      if (x_ < x) {
        // Quick reject
        return 0;
      }

      return y2 < y0 ? unit : -unit;
    }
  }
} // TODO
// Arc 旋转


function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
  y -= cy;

  if (y > r || y < -r) {
    return 0;
  }

  var tmp = Math.sqrt(r * r - y * y);
  roots[0] = -tmp;
  roots[1] = tmp;
  var diff = Math.abs(startAngle - endAngle);

  if (diff < 1e-4) {
    return 0;
  }

  if (diff % PI2 < 1e-4) {
    // Is a circle
    startAngle = 0;
    endAngle = PI2;
    var dir = anticlockwise ? 1 : -1;

    if (x >= roots[0] + cx && x <= roots[1] + cx) {
      return dir;
    } else {
      return 0;
    }
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var w = 0;

  for (var i = 0; i < 2; i++) {
    var x_ = roots[i];

    if (x_ + cx > x) {
      var angle = Math.atan2(y, x_);
      var dir = anticlockwise ? 1 : -1;

      if (angle < 0) {
        angle = PI2 + angle;
      }

      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
          dir = -dir;
        }

        w += dir;
      }
    }
  }

  return w;
}

function containPath(data, lineWidth, isStroke, x, y) {
  var w = 0;
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++]; // Begin a new subpath

    if (cmd === CMD.M && i > 1) {
      // Close previous subpath
      if (!isStroke) {
        w += windingLine(xi, yi, x0, y0, x, y);
      } // 如果被任何一个 subpath 包含
      // if (w !== 0) {
      //     return true;
      // }

    }

    if (i === 1) {
      // 如果第一个命令是 L, C, Q
      // 则 previous point 同绘制命令的第一个 point
      //
      // 第一个命令为 Arc 的情况下会在后面特殊处理
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    switch (cmd) {
      case CMD.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD.L:
        if (isStroke) {
          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.C:
        if (isStroke) {
          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.Q:
        if (isStroke) {
          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        i += 1;
        var anticlockwise = 1 - data[i++];
        var x1 = Math.cos(theta) * rx + cx;
        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i > 1) {
          w += windingLine(xi, yi, x1, y1, x, y);
        } else {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        if (isStroke) {
          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
            return true;
          }
        } else {
          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
        }

        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        var x1 = x0 + width;
        var y1 = y0 + height;

        if (isStroke) {
          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // FIXME Clockwise ?
          w += windingLine(x1, y0, x1, y1, x, y);
          w += windingLine(x0, y1, x0, y0, x, y);
        }

        break;

      case CMD.Z:
        if (isStroke) {
          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // Close a subpath
          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
          // FIXME subpaths may overlap
          // if (w !== 0) {
          //     return true;
          // }
        }

        xi = x0;
        yi = y0;
        break;
    }
  }

  if (!isStroke && !isAroundEqual(yi, y0)) {
    w += windingLine(xi, yi, x0, y0, x, y) || 0;
  }

  return w !== 0;
}

function contain(pathData, x, y) {
  return containPath(pathData, 0, false, x, y);
}

function containStroke(pathData, lineWidth, x, y) {
  return containPath(pathData, lineWidth, true, x, y);
}

exports.contain = contain;
exports.containStroke = containStroke;

/***/ }),
/* 819 */
/***/ (function(module, exports) {

/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  var _a = 0;
  var _b = x0; // Quick reject

  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
    return false;
  }

  if (x0 !== x1) {
    _a = (y0 - y1) / (x0 - x1);
    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
  } else {
    return Math.abs(x - x0) <= _l / 2;
  }

  var tmp = _a * x - y + _b;

  var _s = tmp * tmp / (_a * _a + 1);

  return _s <= _l / 2 * _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(84);

/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
    return false;
  }

  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var _curve = __webpack_require__(84);

var quadraticProjectPoint = _curve.quadraticProjectPoint;

/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
    return false;
  }

  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(265);

var normalizeRadian = _util.normalizeRadian;
var PI2 = Math.PI * 2;
/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */

function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);

  if (d - _l > r || d + _l < r) {
    return false;
  }

  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
    // Is a circle
    return true;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2;
  }

  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
}

exports.containStroke = containStroke;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(127);

var _vector = __webpack_require__(26);

var v2ApplyTransform = _vector.applyTransform;
var CMD = PathProxy.CMD;
var points = [[], [], []];
var mathSqrt = Math.sqrt;
var mathAtan2 = Math.atan2;

function _default(path, m) {
  var data = path.data;
  var cmd;
  var nPoint;
  var i;
  var j;
  var k;
  var p;
  var M = CMD.M;
  var C = CMD.C;
  var L = CMD.L;
  var R = CMD.R;
  var A = CMD.A;
  var Q = CMD.Q;

  for (i = 0, j = 0; i < data.length;) {
    cmd = data[i++];
    j = i;
    nPoint = 0;

    switch (cmd) {
      case M:
        nPoint = 1;
        break;

      case L:
        nPoint = 1;
        break;

      case C:
        nPoint = 3;
        break;

      case Q:
        nPoint = 2;
        break;

      case A:
        var x = m[4];
        var y = m[5];
        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx

        data[i] *= sx;
        data[i++] += x; // cy

        data[i] *= sy;
        data[i++] += y; // Scale rx and ry
        // FIXME Assume psi is 0 here

        data[i++] *= sx;
        data[i++] *= sy; // Start angle

        data[i++] += angle; // end angle

        data[i++] += angle; // FIXME psi

        i += 2;
        j = i;
        break;

      case R:
        // x0, y0
        p[0] = data[i++];
        p[1] = data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1]; // x1, y1

        p[0] += data[i++];
        p[1] += data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1];
    }

    for (k = 0; k < nPoint; k++) {
      var p = points[k];
      p[0] = data[i++];
      p[1] = data[i++];
      v2ApplyTransform(p, p, m); // Write back

      data[j++] = p[0];
      data[j++] = p[1];
    }
  }
}

module.exports = _default;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var fixClipWithShadow = __webpack_require__(268);

/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */
var _default = Path.extend({
  type: 'sector',
  shape: {
    cx: 0,
    cy: 0,
    r0: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
    ctx.lineTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);

    if (r0 !== 0) {
      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
    }

    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */
var _default = Path.extend({
  type: 'ring',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    r0: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var PI2 = Math.PI * 2;
    ctx.moveTo(x + shape.r, y);
    ctx.arc(x, y, shape.r, 0, PI2, false);
    ctx.moveTo(x + shape.r0, y);
    ctx.arc(x, y, shape.r0, 0, PI2, true);
  }
});

module.exports = _default;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(26);

var v2Distance = _vector.distance;

/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * @inner
 */
function interpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */


function _default(points, isLoop) {
  var len = points.length;
  var ret = [];
  var distance = 0;

  for (var i = 1; i < len; i++) {
    distance += v2Distance(points[i - 1], points[i]);
  }

  var segs = distance / 2;
  segs = segs < len ? len : segs;

  for (var i = 0; i < segs; i++) {
    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
    var idx = Math.floor(pos);
    var w = pos - idx;
    var p0;
    var p1 = points[idx % len];
    var p2;
    var p3;

    if (!isLoop) {
      p0 = points[idx === 0 ? idx : idx - 1];
      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
    } else {
      p0 = points[(idx - 1 + len) % len];
      p2 = points[(idx + 1) % len];
      p3 = points[(idx + 2) % len];
    }

    var w2 = w * w;
    var w3 = w * w2;
    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
  }

  return ret;
}

module.exports = _default;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(26);

var v2Min = _vector.min;
var v2Max = _vector.max;
var v2Scale = _vector.scale;
var v2Distance = _vector.distance;
var v2Add = _vector.add;
var v2Clone = _vector.clone;
var v2Sub = _vector.sub;

/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */
function _default(points, smooth, isLoop, constraint) {
  var cps = [];
  var v = [];
  var v1 = [];
  var v2 = [];
  var prevPoint;
  var nextPoint;
  var min;
  var max;

  if (constraint) {
    min = [Infinity, Infinity];
    max = [-Infinity, -Infinity];

    for (var i = 0, len = points.length; i < len; i++) {
      v2Min(min, min, points[i]);
      v2Max(max, max, points[i]);
    } // 与指定的包围盒做并集


    v2Min(min, min, constraint[0]);
    v2Max(max, max, constraint[1]);
  }

  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];

    if (isLoop) {
      prevPoint = points[i ? i - 1 : len - 1];
      nextPoint = points[(i + 1) % len];
    } else {
      if (i === 0 || i === len - 1) {
        cps.push(v2Clone(points[i]));
        continue;
      } else {
        prevPoint = points[i - 1];
        nextPoint = points[i + 1];
      }
    }

    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length

    v2Scale(v, v, smooth);
    var d0 = v2Distance(point, prevPoint);
    var d1 = v2Distance(point, nextPoint);
    var sum = d0 + d1;

    if (sum !== 0) {
      d0 /= sum;
      d1 /= sum;
    }

    v2Scale(v1, v, -d0);
    v2Scale(v2, v, d1);
    var cp0 = v2Add([], point, v1);
    var cp1 = v2Add([], point, v2);

    if (constraint) {
      v2Max(cp0, cp0, min);
      v2Min(cp0, cp0, max);
      v2Max(cp1, cp1, min);
      v2Min(cp1, cp1, max);
    }

    cps.push(cp0);
    cps.push(cp1);
  }

  if (isLoop) {
    cps.push(cps.shift());
  }

  return cps;
}

module.exports = _default;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

var vec2 = __webpack_require__(26);

var _curve = __webpack_require__(84);

var quadraticSubdivide = _curve.quadraticSubdivide;
var cubicSubdivide = _curve.cubicSubdivide;
var quadraticAt = _curve.quadraticAt;
var cubicAt = _curve.cubicAt;
var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
var cubicDerivativeAt = _curve.cubicDerivativeAt;

/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */
var out = [];

function someVectorAt(shape, t, isTangent) {
  var cpx2 = shape.cpx2;
  var cpy2 = shape.cpy2;

  if (cpx2 === null || cpy2 === null) {
    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
  } else {
    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
  }
}

var _default = Path.extend({
  type: 'bezier-curve',
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    // cpx2: 0,
    // cpy2: 0
    // Curve show percent, for animating
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var cpx1 = shape.cpx1;
    var cpy1 = shape.cpy1;
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (cpx2 == null || cpy2 == null) {
      if (percent < 1) {
        quadraticSubdivide(x1, cpx1, x2, percent, out);
        cpx1 = out[1];
        x2 = out[2];
        quadraticSubdivide(y1, cpy1, y2, percent, out);
        cpy1 = out[1];
        y2 = out[2];
      }

      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
    } else {
      if (percent < 1) {
        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
        cpx1 = out[1];
        cpx2 = out[2];
        x2 = out[3];
        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
        cpy1 = out[1];
        cpy2 = out[2];
        y2 = out[3];
      }

      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
    }
  },

  /**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  pointAt: function (t) {
    return someVectorAt(this.shape, t, false);
  },

  /**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  tangentAt: function (t) {
    var p = someVectorAt(this.shape, t, true);
    return vec2.normalize(p, p);
  }
});

module.exports = _default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */
var _default = Path.extend({
  type: 'arc',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
  }
});

module.exports = _default;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

// CompoundPath to improve performance
var _default = Path.extend({
  type: 'compound',
  shape: {
    paths: null
  },
  _updatePathDirty: function () {
    var dirtyPath = this.__dirtyPath;
    var paths = this.shape.paths;

    for (var i = 0; i < paths.length; i++) {
      // Mark as dirty if any subpath is dirty
      dirtyPath = dirtyPath || paths[i].__dirtyPath;
    }

    this.__dirtyPath = dirtyPath;
    this.__dirty = this.__dirty || dirtyPath;
  },
  beforeBrush: function () {
    this._updatePathDirty();

    var paths = this.shape.paths || [];
    var scale = this.getGlobalScale(); // Update path scale

    for (var i = 0; i < paths.length; i++) {
      if (!paths[i].path) {
        paths[i].createPathProxy();
      }

      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
    }
  },
  buildPath: function (ctx, shape) {
    var paths = shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].buildPath(ctx, paths[i].shape, true);
    }
  },
  afterBrush: function () {
    var paths = this.shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].__dirtyPath = false;
    }
  },
  getBoundingRect: function () {
    this._updatePathDirty();

    return Path.prototype.getBoundingRect.call(this);
  }
});

module.exports = _default;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(2);

var Gradient = __webpack_require__(176);

/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */
var RadialGradient = function (x, y, r, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'radial', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0.5 : x;
  this.y = y == null ? 0.5 : y;
  this.r = r == null ? 0.5 : r; // Can be cloned

  this.type = 'radial'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

RadialGradient.prototype = {
  constructor: RadialGradient
};
zrUtil.inherits(RadialGradient, Gradient);
var _default = RadialGradient;
module.exports = _default;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(2);

var inherits = _util.inherits;

var Displayble = __webpack_require__(126);

var BoundingRect = __webpack_require__(33);

/**
 * Displayable for incremental rendering. It will be rendered in a separate layer
 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
 * addDisplayables will render the added displayables incremetally.
 *
 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
 */
// TODO Style override ?
function IncrementalDisplayble(opts) {
  Displayble.call(this, opts);
  this._displayables = [];
  this._temporaryDisplayables = [];
  this._cursor = 0;
  this.notClear = true;
}

IncrementalDisplayble.prototype.incremental = true;

IncrementalDisplayble.prototype.clearDisplaybles = function () {
  this._displayables = [];
  this._temporaryDisplayables = [];
  this._cursor = 0;
  this.dirty();
  this.notClear = false;
};

IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
  if (notPersistent) {
    this._temporaryDisplayables.push(displayable);
  } else {
    this._displayables.push(displayable);
  }

  this.dirty();
};

IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
  notPersistent = notPersistent || false;

  for (var i = 0; i < displayables.length; i++) {
    this.addDisplayable(displayables[i], notPersistent);
  }
};

IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
  for (var i = this._cursor; i < this._displayables.length; i++) {
    cb && cb(this._displayables[i]);
  }

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    cb && cb(this._temporaryDisplayables[i]);
  }
};

IncrementalDisplayble.prototype.update = function () {
  this.updateTransform();

  for (var i = this._cursor; i < this._displayables.length; i++) {
    var displayable = this._displayables[i]; // PENDING

    displayable.parent = this;
    displayable.update();
    displayable.parent = null;
  }

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    var displayable = this._temporaryDisplayables[i]; // PENDING

    displayable.parent = this;
    displayable.update();
    displayable.parent = null;
  }
};

IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
  // Render persistant displayables.
  for (var i = this._cursor; i < this._displayables.length; i++) {
    var displayable = this._displayables[i];
    displayable.beforeBrush && displayable.beforeBrush(ctx);
    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
    displayable.afterBrush && displayable.afterBrush(ctx);
  }

  this._cursor = i; // Render temporary displayables.

  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
    var displayable = this._temporaryDisplayables[i];
    displayable.beforeBrush && displayable.beforeBrush(ctx);
    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
    displayable.afterBrush && displayable.afterBrush(ctx);
  }

  this._temporaryDisplayables = [];
  this.notClear = true;
};

var m = [];

IncrementalDisplayble.prototype.getBoundingRect = function () {
  if (!this._rect) {
    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);

    for (var i = 0; i < this._displayables.length; i++) {
      var displayable = this._displayables[i];
      var childRect = displayable.getBoundingRect().clone();

      if (displayable.needLocalTransform()) {
        childRect.applyTransform(displayable.getLocalTransform(m));
      }

      rect.union(childRect);
    }

    this._rect = rect;
  }

  return this._rect;
};

IncrementalDisplayble.prototype.contain = function (x, y) {
  var localPos = this.transformCoordToLocal(x, y);
  var rect = this.getBoundingRect();

  if (rect.contain(localPos[0], localPos[1])) {
    for (var i = 0; i < this._displayables.length; i++) {
      var displayable = this._displayables[i];

      if (displayable.contain(x, y)) {
        return true;
      }
    }
  }

  return false;
};

inherits(IncrementalDisplayble, Displayble);
var _default = IncrementalDisplayble;
module.exports = _default;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var makeStyleMapper = __webpack_require__(173);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
var _default = {
  getItemStyle: function (excludes, includes) {
    var style = getItemStyle(this, excludes, includes);
    var lineDash = this.getBorderLineDash();
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getBorderLineDash: function () {
    var lineType = this.get('borderType');
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
  }
};
module.exports = _default;

/***/ }),
/* 834 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = {
  getBoxLayoutParams: function () {
    return {
      left: this.get('left'),
      top: this.get('top'),
      right: this.get('right'),
      bottom: this.get('bottom'),
      width: this.get('width'),
      height: this.get('height')
    };
  }
};
module.exports = _default;

/***/ }),
/* 835 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  platform = navigator.platform || '';
}

var _default = {
  // backgroundColor: 'rgba(0,0,0,0)',
  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
  // Light colors:
  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
  // Dark colors:
  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 300,
  animationEasing: 'exponentialOut',
  animationEasingUpdate: 'cubicOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
};
module.exports = _default;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var modelUtil = __webpack_require__(13);

var ComponentModel = __webpack_require__(56);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */
var each = zrUtil.each;
var clone = zrUtil.clone;
var map = zrUtil.map;
var merge = zrUtil.merge;
var QUERY_REG = /^(min|max)?(.+)$/;
/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */

function OptionManager(api) {
  /**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */
  this._api = api;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._timelineOptions = [];
  /**
   * @private
   * @type {Array.<Object>}
   */

  this._mediaList = [];
  /**
   * @private
   * @type {Object}
   */

  this._mediaDefault;
  /**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */

  this._currentMediaIndices = [];
  /**
   * @private
   * @type {Object}
   */

  this._optionBackup;
  /**
   * @private
   * @type {Object}
   */

  this._newBaseOption;
} // timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);


OptionManager.prototype = {
  constructor: OptionManager,

  /**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */
  setOption: function (rawOption, optionPreprocessorFuncs) {
    if (rawOption) {
      // That set dat primitive is dangerous if user reuse the data when setOption again.
      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
      });
    } // Caution: some series modify option data, if do not clone,
    // it should ensure that the repeat modify correctly
    // (create a new object when modify itself).


    rawOption = clone(rawOption); // FIXME
    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。

    var oldOptionBackup = this._optionBackup;
    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (oldOptionBackup) {
      // Only baseOption can be merged.
      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline opitons will not be merged to the formers, but just substitude them.

      if (newParsedOption.timelineOptions.length) {
        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        oldOptionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  },

  /**
   * @param {boolean} isRecreate
   * @return {Object}
   */
  mountOption: function (isRecreate) {
    var optionBackup = this._optionBackup; // TODO
    // 如果没有reset功能则不clone。

    this._timelineOptions = map(optionBackup.timelineOptions, clone);
    this._mediaList = map(optionBackup.mediaList, clone);
    this._mediaDefault = clone(optionBackup.mediaDefault);
    this._currentMediaIndices = [];
    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */
  getTimelineOption: function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
      }
    }

    return option;
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */
  getMediaOption: function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = map(indices, function (index) {
        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  }
};

function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
  var timelineOptions = [];
  var mediaList = [];
  var mediaDefault;
  var baseOption; // Compatible with ec2.

  var timelineOpt = rawOption.timeline;

  if (rawOption.baseOption) {
    baseOption = rawOption.baseOption;
  } // For timeline


  if (timelineOpt || rawOption.options) {
    baseOption = baseOption || {};
    timelineOptions = (rawOption.options || []).slice();
  } // For media query


  if (rawOption.media) {
    baseOption = baseOption || {};
    var media = rawOption.media;
    each(media, function (singleMedia) {
      if (singleMedia && singleMedia.option) {
        if (singleMedia.query) {
          mediaList.push(singleMedia);
        } else if (!mediaDefault) {
          // Use the first media default.
          mediaDefault = singleMedia;
        }
      }
    });
  } // For normal option


  if (!baseOption) {
    baseOption = rawOption;
  } // Set timelineOpt to baseOption in ec3,
  // which is convenient for merge option.


  if (!baseOption.timeline) {
    baseOption.timeline = timelineOpt;
  } // Preprocess.


  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
    return media.option;
  })), function (option) {
    each(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  });
  return {
    baseOption: baseOption,
    timelineOptions: timelineOptions,
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lowser case for convenientce.

  };
  var applicatable = true;
  zrUtil.each(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicatable = false;
    }
  });
  return applicatable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */


function mergeOption(oldOption, newOption) {
  newOption = newOption || {};
  each(newOption, function (newCptOpt, mainType) {
    if (newCptOpt == null) {
      return;
    }

    var oldCptOpt = oldOption[mainType];

    if (!ComponentModel.hasClass(mainType)) {
      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
    } else {
      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
      oldOption[mainType] = map(mapResult, function (item) {
        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
      });
    }
  });
}

var _default = OptionManager;
module.exports = _default;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;
var isArray = _util.isArray;
var isObject = _util.isObject;

var compatStyle = __webpack_require__(838);

var _model = __webpack_require__(13);

var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Compatitable with 2.0
function get(opt, path) {
  path = path.split(',');
  var obj = opt;

  for (var i = 0; i < path.length; i++) {
    obj = obj && obj[path[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set(opt, path, val, overwrite) {
  path = path.split(',');
  var obj = opt;
  var key;

  for (var i = 0; i < path.length - 1; i++) {
    key = path[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[path[i]] == null) {
    obj[path[i]] = val;
  }
}

function compatLayoutProperties(option) {
  each(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];

function _default(option, isTheme) {
  compatStyle(option, isTheme); // Make sure series array for model initialization.

  option.series = normalizeToArray(option.series);
  each(option.series, function (seriesOpt) {
    if (!isObject(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'line') {
      if (seriesOpt.clipOverflow != null) {
        seriesOpt.clip = seriesOpt.clipOverflow;
      }
    } else if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;
      }
    } else if (seriesType === 'gauge') {
      var pointerColor = get(seriesOpt, 'pointer.color');
      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
    }

    compatLayoutProperties(seriesOpt);
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  each(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!isArray(options)) {
        options = [options];
      }

      each(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var modelUtil = __webpack_require__(13);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var isObject = zrUtil.isObject;
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatEC2ItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function convertNormalEmphasis(opt, optType, useExtend) {
  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
    var normalOpt = opt[optType].normal;
    var emphasisOpt = opt[optType].emphasis;

    if (normalOpt) {
      // Timeline controlStyle has other properties besides normal and emphasis
      if (useExtend) {
        opt[optType].normal = opt[optType].emphasis = null;
        zrUtil.defaults(opt[optType], normalOpt);
      } else {
        opt[optType] = normalOpt;
      }
    }

    if (emphasisOpt) {
      opt.emphasis = opt.emphasis || {};
      opt.emphasis[optType] = emphasisOpt;
    }
  }
}

function removeEC3NormalStatus(opt) {
  convertNormalEmphasis(opt, 'itemStyle');
  convertNormalEmphasis(opt, 'lineStyle');
  convertNormalEmphasis(opt, 'areaStyle');
  convertNormalEmphasis(opt, 'label');
  convertNormalEmphasis(opt, 'labelLine'); // treemap

  convertNormalEmphasis(opt, 'upperLabel'); // graph

  convertNormalEmphasis(opt, 'edgeLabel');
}

function compatTextStyle(opt, propName) {
  // Check whether is not object (string\null\undefined ...)
  var labelOptSingle = isObject(opt) && opt[propName];
  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];

      if (textStyle.hasOwnProperty(propName)) {
        labelOptSingle[propName] = textStyle[propName];
      }
    }
  }
}

function compatEC3CommonStyles(opt) {
  if (opt) {
    removeEC3NormalStatus(opt);
    compatTextStyle(opt, 'label');
    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
  }
}

function processSeries(seriesOpt) {
  if (!isObject(seriesOpt)) {
    return;
  }

  compatEC2ItemStyle(seriesOpt);
  removeEC3NormalStatus(seriesOpt);
  compatTextStyle(seriesOpt, 'label'); // treemap

  compatTextStyle(seriesOpt, 'upperLabel'); // graph

  compatTextStyle(seriesOpt, 'edgeLabel');

  if (seriesOpt.emphasis) {
    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap

    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph

    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
  }

  var markPoint = seriesOpt.markPoint;

  if (markPoint) {
    compatEC2ItemStyle(markPoint);
    compatEC3CommonStyles(markPoint);
  }

  var markLine = seriesOpt.markLine;

  if (markLine) {
    compatEC2ItemStyle(markLine);
    compatEC3CommonStyles(markLine);
  }

  var markArea = seriesOpt.markArea;

  if (markArea) {
    compatEC3CommonStyles(markArea);
  }

  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
  // then the backward compat based on option type will not be performed.

  if (seriesOpt.type === 'graph') {
    data = data || seriesOpt.nodes;
    var edgeData = seriesOpt.links || seriesOpt.edges;

    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
      for (var i = 0; i < edgeData.length; i++) {
        compatEC3CommonStyles(edgeData[i]);
      }
    }

    zrUtil.each(seriesOpt.categories, function (opt) {
      removeEC3NormalStatus(opt);
    });
  }

  if (data && !zrUtil.isTypedArray(data)) {
    for (var i = 0; i < data.length; i++) {
      compatEC3CommonStyles(data[i]);
    }
  } // mark point data


  var markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatEC3CommonStyles(mpData[i]);
    }
  } // mark line data


  var markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (zrUtil.isArray(mlData[i])) {
        compatEC3CommonStyles(mlData[i][0]);
        compatEC3CommonStyles(mlData[i][1]);
      } else {
        compatEC3CommonStyles(mlData[i]);
      }
    }
  } // Series


  if (seriesOpt.type === 'gauge') {
    compatTextStyle(seriesOpt, 'axisLabel');
    compatTextStyle(seriesOpt, 'title');
    compatTextStyle(seriesOpt, 'detail');
  } else if (seriesOpt.type === 'treemap') {
    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
    zrUtil.each(seriesOpt.levels, function (opt) {
      removeEC3NormalStatus(opt);
    });
  } else if (seriesOpt.type === 'tree') {
    removeEC3NormalStatus(seriesOpt.leaves);
  } // sunburst starts from ec4, so it does not need to compat levels.

}

function toArr(o) {
  return zrUtil.isArray(o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (zrUtil.isArray(o) ? o[0] : o) || {};
}

function _default(option, isTheme) {
  each(toArr(option.series), function (seriesOpt) {
    isObject(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each(axes, function (axisName) {
    each(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each(toArr(option.calendar), function (calendarOpt) {
    convertNormalEmphasis(calendarOpt, 'itemStyle');
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name');
  });
  each(toArr(option.geo), function (geoOpt) {
    if (isObject(geoOpt)) {
      compatEC3CommonStyles(geoOpt);
      each(toArr(geoOpt.regions), function (regionObj) {
        compatEC3CommonStyles(regionObj);
      });
    }
  });
  each(toArr(option.timeline), function (timelineOpt) {
    compatEC3CommonStyles(timelineOpt);
    convertNormalEmphasis(timelineOpt, 'label');
    convertNormalEmphasis(timelineOpt, 'itemStyle');
    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
    var data = timelineOpt.data;
    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
      if (zrUtil.isObject(item)) {
        convertNormalEmphasis(item, 'label');
        convertNormalEmphasis(item, 'itemStyle');
      }
    });
  });
  each(toArr(option.toolbox), function (toolboxOpt) {
    convertNormalEmphasis(toolboxOpt, 'iconStyle');
    each(toolboxOpt.feature, function (featureOpt) {
      convertNormalEmphasis(featureOpt, 'iconStyle');
    });
  });
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
}

module.exports = _default;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatly.
//     Should be executed after series filtered and before stack calculation.
function _default(ecModel) {
  var stackInfoMap = createHashMap();
  ecModel.eachSeries(function (seriesModel) {
    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.

    if (stack) {
      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
      var data = seriesModel.getData();
      var stackInfo = {
        // Used for calculate axis extent automatically.
        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
        stackedDimension: data.getCalculationInfo('stackedDimension'),
        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
        data: data,
        seriesModel: seriesModel
      }; // If stacked on axis that do not support data stack.

      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
        return;
      }

      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
      stackInfoList.push(stackInfo);
    }
  });
  stackInfoMap.each(calculateStack);
}

function calculateStack(stackInfoList) {
  each(stackInfoList, function (targetStackInfo, idxInStack) {
    var resultVal = [];
    var resultNaN = [NaN, NaN];
    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
    var targetData = targetStackInfo.data;
    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
    // depending on legend selection.

    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
      // should also be NaN, to draw a appropriate belt area.

      if (isNaN(sum)) {
        return resultNaN;
      }

      var byValue;
      var stackedDataRawIndex;

      if (isStackedByIndex) {
        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
      } else {
        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
      } // If stackOver is NaN, chart view will render point on value start.


      var stackedOver = NaN;

      for (var j = idxInStack - 1; j >= 0; j--) {
        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.

        if (!isStackedByIndex) {
          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
        }

        if (stackedDataRawIndex >= 0) {
          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data

          if (sum >= 0 && val > 0 || // Positive stack
          sum <= 0 && val < 0 // Negative stack
          ) {
              sum += val;
              stackedOver = val;
              break;
            }
        }
      }

      resultVal[0] = sum;
      resultVal[1] = stackedOver;
      return resultVal;
    });
    targetData.hostModel.setData(newData); // Update for consequent calculation

    targetStackInfo.data = newData;
  });
}

module.exports = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataProvider = __webpack_require__(103);

var retrieveRawValue = _dataProvider.retrieveRawValue;

var _format = __webpack_require__(44);

var getTooltipMarker = _format.getTooltipMarker;
var formatTpl = _format.formatTpl;

var _model = __webpack_require__(13);

var getTooltipRenderMode = _model.getTooltipRenderMode;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly

var _default = {
  /**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */
  getDataParams: function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex);
    var itemOpt = data.getRawDataItem(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');
    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
    var tooltipModel = this.ecModel.getComponent('tooltip');
    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
    var renderMode = getTooltipRenderMode(renderModeOption);
    var mainType = this.mainType;
    var isSeries = mainType === 'series';
    var userOutput = data.userOutput;
    return {
      componentType: mainType,
      componentSubType: this.subType,
      componentIndex: this.componentIndex,
      seriesType: isSeries ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: isSeries ? this.id : null,
      seriesName: isSeries ? this.name : null,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      borderColor: borderColor,
      dimensionNames: userOutput ? userOutput.dimensionNames : null,
      encode: userOutput ? userOutput.encode : null,
      marker: getTooltipMarker({
        color: color,
        renderMode: renderMode
      }),
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  },

  /**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex] Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param {string} [labelProp='label']
   * @return {string} If not formatter, return null/undefined
   */
  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var itemModel = data.getItemModel(dataIndex);
    var params = this.getDataParams(dataIndex, dataType);

    if (dimIndex != null && params.value instanceof Array) {
      params.value = params.value[dimIndex];
    }

    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);

    if (typeof formatter === 'function') {
      params.status = status;
      params.dimensionIndex = dimIndex;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
      // Do not support '}' in dim name util have to.

      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
        var len = dim.length;

        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
        }

        return retrieveRawValue(data, dataIndex, dim);
      });
    }
  },

  /**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Array|number|string}
   */
  getRawValue: function (idx, dataType) {
    return retrieveRawValue(this.getData(dataType), idx);
  },

  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */
  formatTooltip: function () {// Empty function
  }
};
module.exports = _default;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Gradient = __webpack_require__(176);

var _util = __webpack_require__(2);

var isFunction = _util.isFunction;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle

    var color = seriesModel.get(colorAccessPath);
    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color

    if (!color || colorCallback) {
      color = seriesModel.getColorFromPalette( // TODO series count changed.
      seriesModel.name, null, ecModel.getSeriesCount());
    }

    data.setVisual('color', color);
    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
    var borderColor = seriesModel.get(borderColorAccessPath);
    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (colorCallback) {
        data.each(function (idx) {
          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
        });
      } // itemStyle in each data item


      var dataEach = function (data, idx) {
        var itemModel = data.getItemModel(idx);
        var color = itemModel.get(colorAccessPath, true);
        var borderColor = itemModel.get(borderColorAccessPath, true);

        if (color != null) {
          data.setItemVisual(idx, 'color', color);
        }

        if (borderColor != null) {
          data.setItemVisual(idx, 'borderColor', borderColor);
        }
      };

      return {
        dataEach: data.hasItemOption ? dataEach : null
      };
    }
  }
};
module.exports = _default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var lang = __webpack_require__(280);

var _dataProvider = __webpack_require__(103);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(dom, ecModel) {
  var ariaModel = ecModel.getModel('aria');

  if (!ariaModel.get('show')) {
    return;
  } else if (ariaModel.get('description')) {
    dom.setAttribute('aria-label', ariaModel.get('description'));
    return;
  }

  var seriesCnt = 0;
  ecModel.eachSeries(function (seriesModel, idx) {
    ++seriesCnt;
  }, this);
  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
  var ariaLabel;

  if (seriesCnt < 1) {
    // No series, no aria label
    return;
  } else {
    var title = getTitle();

    if (title) {
      ariaLabel = replace(getConfig('general.withTitle'), {
        title: title
      });
    } else {
      ariaLabel = getConfig('general.withoutTitle');
    }

    var seriesLabels = [];
    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
    ariaLabel += replace(getConfig(prefix), {
      seriesCount: seriesCnt
    });
    ecModel.eachSeries(function (seriesModel, idx) {
      if (idx < displaySeriesCnt) {
        var seriesLabel;
        var seriesName = seriesModel.get('name');
        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
        seriesLabel = replace(seriesLabel, {
          seriesId: seriesModel.seriesIndex,
          seriesName: seriesModel.get('name'),
          seriesType: getSeriesTypeName(seriesModel.subType)
        });
        var data = seriesModel.getData();
        window.data = data;

        if (data.count() > maxDataCnt) {
          // Show part of data
          seriesLabel += replace(getConfig('data.partialData'), {
            displayCnt: maxDataCnt
          });
        } else {
          seriesLabel += getConfig('data.allData');
        }

        var dataLabels = [];

        for (var i = 0; i < data.count(); i++) {
          if (i < maxDataCnt) {
            var name = data.getName(i);
            var value = retrieveRawValue(data, i);
            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
              name: name,
              value: value
            }));
          }
        }

        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
        seriesLabels.push(seriesLabel);
      }
    });
    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
    dom.setAttribute('aria-label', ariaLabel);
  }

  function replace(str, keyValues) {
    if (typeof str !== 'string') {
      return str;
    }

    var result = str;
    zrUtil.each(keyValues, function (value, key) {
      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
    });
    return result;
  }

  function getConfig(path) {
    var userConfig = ariaModel.get(path);

    if (userConfig == null) {
      var pathArr = path.split('.');
      var result = lang.aria;

      for (var i = 0; i < pathArr.length; ++i) {
        result = result[pathArr[i]];
      }

      return result;
    } else {
      return userConfig;
    }
  }

  function getTitle() {
    var title = ecModel.getModel('title').option;

    if (title && title.length) {
      title = title[0];
    }

    return title && title.text;
  }

  function getSeriesTypeName(type) {
    return lang.series.typeNames[type] || '自定义图';
  }
}

module.exports = _default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function _default(api, opts) {
  opts = opts || {};
  zrUtil.defaults(opts, {
    text: 'loading',
    color: '#c23531',
    textColor: '#000',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    zlevel: 0
  });
  var mask = new graphic.Rect({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  var arc = new graphic.Arc({
    shape: {
      startAngle: -PI / 2,
      endAngle: -PI / 2 + 0.1,
      r: 10
    },
    style: {
      stroke: opts.color,
      lineCap: 'round',
      lineWidth: 5
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  var labelRect = new graphic.Rect({
    style: {
      fill: 'none',
      text: opts.text,
      textPosition: 'right',
      textDistance: 10,
      textFill: opts.textColor
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  arc.animateShape(true).when(1000, {
    endAngle: PI * 3 / 2
  }).start('circularInOut');
  arc.animateShape(true).when(1000, {
    startAngle: PI * 3 / 2
  }).delay(300).start('circularInOut');
  var group = new graphic.Group();
  group.add(arc);
  group.add(labelRect);
  group.add(mask); // Inject resize

  group.resize = function () {
    var cx = api.getWidth() / 2;
    var cy = api.getHeight() / 2;
    arc.setShape({
      cx: cx,
      cy: cy
    });
    var r = arc.shape.r;
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

module.exports = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var each = _util.each;
var map = _util.map;
var isFunction = _util.isFunction;
var createHashMap = _util.createHashMap;
var noop = _util.noop;

var _task = __webpack_require__(178);

var createTask = _task.createTask;

var _component = __webpack_require__(128);

var getUID = _component.getUID;

var GlobalModel = __webpack_require__(262);

var ExtensionAPI = __webpack_require__(276);

var _model = __webpack_require__(13);

var normalizeToArray = _model.normalizeToArray;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/stream/Scheduler
 */

/**
 * @constructor
 */
function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
  this.ecInstance = ecInstance;
  this.api = api;
  this.unfinished; // Fix current processors in case that in some rear cases that
  // processors might be registered after echarts instance created.
  // Register processors incrementally for a echarts instance is
  // not supported by this stream architecture.

  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
  var visualHandlers = this._visualHandlers = visualHandlers.slice();
  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
  /**
   * @private
   * @type {
   *     [handlerUID: string]: {
   *         seriesTaskMap?: {
   *             [seriesUID: string]: Task
   *         },
   *         overallTask?: Task
   *     }
   * }
   */

  this._stageTaskMap = createHashMap();
}

var proto = Scheduler.prototype;
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} payload
 */

proto.restoreData = function (ecModel, payload) {
  // TODO: Only restroe needed series and components, but not all components.
  // Currently `restoreData` of all of the series and component will be called.
  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
  // and some components like coordinate system, axes, dataZoom, visualMap only
  // need their target series refresh.
  // (1) If we are implementing this feature some day, we should consider these cases:
  // if a data processor depends on a component (e.g., dataZoomProcessor depends
  // on the settings of `dataZoom`), it should be re-performed if the component
  // is modified by `setOption`.
  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
  // it should be re-performed when the result array of `getTargetSeries` changed.
  // We use `dependencies` to cover these issues.
  // (3) How to update target series when coordinate system related components modified.
  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
  // and this case all of the tasks will be set as dirty.
  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
  // depends on all of the series.
  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
  // that the overall task is set as dirty and to be performed, otherwise it probably cause
  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
  // probably cause state chaos (consider `dataZoomProcessor`).

  this._stageTaskMap.each(function (taskRecord) {
    var overallTask = taskRecord.overallTask;
    overallTask && overallTask.dirty();
  });
}; // If seriesModel provided, incremental threshold is check by series data.


proto.getPerformArgs = function (task, isBlock) {
  // For overall task
  if (!task.__pipeline) {
    return;
  }

  var pipeline = this._pipelineMap.get(task.__pipeline.id);

  var pCtx = pipeline.context;
  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
  var step = incremental ? pipeline.step : null;
  var modDataCount = pCtx && pCtx.modDataCount;
  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
  return {
    step: step,
    modBy: modBy,
    modDataCount: modDataCount
  };
};

proto.getPipeline = function (pipelineId) {
  return this._pipelineMap.get(pipelineId);
};
/**
 * Current, progressive rendering starts from visual and layout.
 * Always detect render mode in the same stage, avoiding that incorrect
 * detection caused by data filtering.
 * Caution:
 * `updateStreamModes` use `seriesModel.getData()`.
 */


proto.updateStreamModes = function (seriesModel, view) {
  var pipeline = this._pipelineMap.get(seriesModel.uid);

  var data = seriesModel.getData();
  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
  // animation frame. Note that some types of series do not provide
  // `view.incrementalPrepareRender` but support `chart.appendData`. We
  // use the term `incremental` but not `progressive` to describe the
  // case that `chart.appendData`.

  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
  // see `test/candlestick-large3.html`

  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
  seriesModel.pipelineContext = pipeline.context = {
    progressiveRender: progressiveRender,
    modDataCount: modDataCount,
    large: large
  };
};

proto.restorePipelines = function (ecModel) {
  var scheduler = this;
  var pipelineMap = scheduler._pipelineMap = createHashMap();
  ecModel.eachSeries(function (seriesModel) {
    var progressive = seriesModel.getProgressive();
    var pipelineId = seriesModel.uid;
    pipelineMap.set(pipelineId, {
      id: pipelineId,
      head: null,
      tail: null,
      threshold: seriesModel.getProgressiveThreshold(),
      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
      blockIndex: -1,
      step: Math.round(progressive || 700),
      count: 0
    });
    pipe(scheduler, seriesModel, seriesModel.dataTask);
  });
};

proto.prepareStageTasks = function () {
  var stageTaskMap = this._stageTaskMap;
  var ecModel = this.ecInstance.getModel();
  var api = this.api;
  each(this._allHandlers, function (handler) {
    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
  }, this);
};

proto.prepareView = function (view, model, ecModel, api) {
  var renderTask = view.renderTask;
  var context = renderTask.context;
  context.model = model;
  context.ecModel = ecModel;
  context.api = api;
  renderTask.__block = !view.incrementalPrepareRender;
  pipe(this, model, renderTask);
};

proto.performDataProcessorTasks = function (ecModel, payload) {
  // If we do not use `block` here, it should be considered when to update modes.
  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
    block: true
  });
}; // opt
// opt.visualType: 'visual' or 'layout'
// opt.setDirty


proto.performVisualTasks = function (ecModel, payload, opt) {
  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
};

function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
  opt = opt || {};
  var unfinished;
  each(stageHandlers, function (stageHandler, idx) {
    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
      return;
    }

    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);

    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
    var overallTask = stageHandlerRecord.overallTask;

    if (overallTask) {
      var overallNeedDirty;
      var agentStubMap = overallTask.agentStubMap;
      agentStubMap.each(function (stub) {
        if (needSetDirty(opt, stub)) {
          stub.dirty();
          overallNeedDirty = true;
        }
      });
      overallNeedDirty && overallTask.dirty();
      updatePayload(overallTask, payload);
      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
      // then execute the overall task. And stub will call seriesModel.setData,
      // which ensures that in the overallTask seriesModel.getData() will not
      // return incorrect data.

      agentStubMap.each(function (stub) {
        stub.perform(performArgs);
      });
      unfinished |= overallTask.perform(performArgs);
    } else if (seriesTaskMap) {
      seriesTaskMap.each(function (task, pipelineId) {
        if (needSetDirty(opt, task)) {
          task.dirty();
        }

        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
        // if intending to decalare `performRawSeries` in handlers, only
        // stream-independent (specifically, data item independent) operations can be
        // performed. Because is a series is filtered, most of the tasks will not
        // be performed. A stream-dependent operation probably cause wrong biz logic.
        // Perhaps we should not provide a separate callback for this case instead
        // of providing the config `performRawSeries`. The stream-dependent operaions
        // and stream-independent operations should better not be mixed.

        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
        updatePayload(task, payload);
        unfinished |= task.perform(performArgs);
      });
    }
  });

  function needSetDirty(opt, task) {
    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
  }

  scheduler.unfinished |= unfinished;
}

proto.performSeriesTasks = function (ecModel) {
  var unfinished;
  ecModel.eachSeries(function (seriesModel) {
    // Progress to the end for dataInit and dataRestore.
    unfinished |= seriesModel.dataTask.perform();
  });
  this.unfinished |= unfinished;
};

proto.plan = function () {
  // Travel pipelines, check block.
  this._pipelineMap.each(function (pipeline) {
    var task = pipeline.tail;

    do {
      if (task.__block) {
        pipeline.blockIndex = task.__idxInPipeline;
        break;
      }

      task = task.getUpstream();
    } while (task);
  });
};

var updatePayload = proto.updatePayload = function (task, payload) {
  payload !== 'remain' && (task.context.payload = payload);
};

function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
  var seriesType = stageHandler.seriesType;
  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
  // it works but it may cause other irrelevant charts blocked.

  if (stageHandler.createOnAllSeries) {
    ecModel.eachRawSeries(create);
  } else if (seriesType) {
    ecModel.eachRawSeriesByType(seriesType, create);
  } else if (getTargetSeries) {
    getTargetSeries(ecModel, api).each(create);
  }

  function create(seriesModel) {
    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
    // Reuse original task instance.

    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
      plan: seriesTaskPlan,
      reset: seriesTaskReset,
      count: seriesTaskCount
    }));
    task.context = {
      model: seriesModel,
      ecModel: ecModel,
      api: api,
      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
      plan: stageHandler.plan,
      reset: stageHandler.reset,
      scheduler: scheduler
    };
    pipe(scheduler, seriesModel, task);
  } // Clear unused series tasks.


  var pipelineMap = scheduler._pipelineMap;
  seriesTaskMap.each(function (task, pipelineId) {
    if (!pipelineMap.get(pipelineId)) {
      task.dispose();
      seriesTaskMap.removeKey(pipelineId);
    }
  });
}

function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
  || createTask({
    reset: overallTaskReset
  });
  overallTask.context = {
    ecModel: ecModel,
    api: api,
    overallReset: stageHandler.overallReset,
    scheduler: scheduler
  }; // Reuse orignal stubs.

  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
  var seriesType = stageHandler.seriesType;
  var getTargetSeries = stageHandler.getTargetSeries;
  var overallProgress = true;
  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
  // stub in each pipelines, it will set the overall task dirty when the pipeline
  // progress. Moreover, to avoid call the overall task each frame (too frequent),
  // we set the pipeline block.

  if (seriesType) {
    ecModel.eachRawSeriesByType(seriesType, createStub);
  } else if (getTargetSeries) {
    getTargetSeries(ecModel, api).each(createStub);
  } // Otherwise, (usually it is legancy case), the overall task will only be
  // executed when upstream dirty. Otherwise the progressive rendering of all
  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
  // dirty info from upsteam.
  else {
      overallProgress = false;
      each(ecModel.getSeries(), createStub);
    }

  function createStub(seriesModel) {
    var pipelineId = seriesModel.uid;
    var stub = agentStubMap.get(pipelineId);

    if (!stub) {
      stub = agentStubMap.set(pipelineId, createTask({
        reset: stubReset,
        onDirty: stubOnDirty
      })); // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.

      overallTask.dirty();
    }

    stub.context = {
      model: seriesModel,
      overallProgress: overallProgress,
      modifyOutputEnd: modifyOutputEnd
    };
    stub.agent = overallTask;
    stub.__block = overallProgress;
    pipe(scheduler, seriesModel, stub);
  } // Clear unused stubs.


  var pipelineMap = scheduler._pipelineMap;
  agentStubMap.each(function (stub, pipelineId) {
    if (!pipelineMap.get(pipelineId)) {
      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.

      overallTask.dirty();
      agentStubMap.removeKey(pipelineId);
    }
  });
}

function overallTaskReset(context) {
  context.overallReset(context.ecModel, context.api, context.payload);
}

function stubReset(context, upstreamContext) {
  return context.overallProgress && stubProgress;
}

function stubProgress() {
  this.agent.dirty();
  this.getDownstream().dirty();
}

function stubOnDirty() {
  this.agent && this.agent.dirty();
}

function seriesTaskPlan(context) {
  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
}

function seriesTaskReset(context) {
  if (context.useClearVisual) {
    context.data.clearAllVisual();
  }

  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
    return makeSeriesTaskProgress(idx);
  }) : singleSeriesTaskProgress;
}

var singleSeriesTaskProgress = makeSeriesTaskProgress(0);

function makeSeriesTaskProgress(resetDefineIdx) {
  return function (params, context) {
    var data = context.data;
    var resetDefine = context.resetDefines[resetDefineIdx];

    if (resetDefine && resetDefine.dataEach) {
      for (var i = params.start; i < params.end; i++) {
        resetDefine.dataEach(data, i);
      }
    } else if (resetDefine && resetDefine.progress) {
      resetDefine.progress(params, data);
    }
  };
}

function seriesTaskCount(context) {
  return context.data.count();
}

function pipe(scheduler, seriesModel, task) {
  var pipelineId = seriesModel.uid;

  var pipeline = scheduler._pipelineMap.get(pipelineId);

  !pipeline.head && (pipeline.head = task);
  pipeline.tail && pipeline.tail.pipe(task);
  pipeline.tail = task;
  task.__idxInPipeline = pipeline.count++;
  task.__pipeline = pipeline;
}

Scheduler.wrapStageHandler = function (stageHandler, visualType) {
  if (isFunction(stageHandler)) {
    stageHandler = {
      overallReset: stageHandler,
      seriesType: detectSeriseType(stageHandler)
    };
  }

  stageHandler.uid = getUID('stageHandler');
  visualType && (stageHandler.visualType = visualType);
  return stageHandler;
};
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */


function detectSeriseType(legacyFunc) {
  seriesType = null;

  try {
    // Assume there is no async when calling `eachSeriesByType`.
    legacyFunc(ecModelMock, apiMock);
  } catch (e) {}

  return seriesType;
}

var ecModelMock = {};
var apiMock = {};
var seriesType;
mockMethods(ecModelMock, GlobalModel);
mockMethods(apiMock, ExtensionAPI);

ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
  seriesType = type;
};

ecModelMock.eachComponent = function (cond) {
  if (cond.mainType === 'series' && cond.subType) {
    seriesType = cond.subType;
  }
};

function mockMethods(target, Clz) {
  /* eslint-disable */
  for (var name in Clz.prototype) {
    // Do not use hasOwnProperty
    target[name] = noop;
  }
  /* eslint-enable */

}

var _default = Scheduler;
module.exports = _default;

/***/ }),
/* 845 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
var _default = {
  color: colorAll,
  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
};
module.exports = _default;

/***/ }),
/* 846 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var contrastColor = '#eee';

var axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor
      }
    },
    axisTick: {
      lineStyle: {
        color: contrastColor
      }
    },
    axisLabel: {
      textStyle: {
        color: contrastColor
      }
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#aaa'
      }
    },
    splitArea: {
      areaStyle: {
        color: contrastColor
      }
    }
  };
};

var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
var theme = {
  color: colorPalette,
  backgroundColor: '#333',
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: contrastColor
      },
      crossStyle: {
        color: contrastColor
      },
      label: {
        color: '#000'
      }
    }
  },
  legend: {
    textStyle: {
      color: contrastColor
    }
  },
  textStyle: {
    color: contrastColor
  },
  title: {
    textStyle: {
      color: contrastColor
    }
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: contrastColor
      }
    }
  },
  dataZoom: {
    textStyle: {
      color: contrastColor
    }
  },
  visualMap: {
    textStyle: {
      color: contrastColor
    }
  },
  timeline: {
    lineStyle: {
      color: contrastColor
    },
    itemStyle: {
      normal: {
        color: colorPalette[1]
      }
    },
    label: {
      normal: {
        textStyle: {
          color: contrastColor
        }
      }
    },
    controlStyle: {
      normal: {
        color: contrastColor,
        borderColor: contrastColor
      }
    }
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),
  line: {
    symbol: 'circle'
  },
  graph: {
    color: colorPalette
  },
  gauge: {
    title: {
      textStyle: {
        color: contrastColor
      }
    }
  },
  candlestick: {
    itemStyle: {
      normal: {
        color: '#FD1050',
        color0: '#0CF49B',
        borderColor: '#FD1050',
        borderColor0: '#0CF49B'
      }
    }
  }
};
theme.categoryAxis.splitLine.show = false;
var _default = theme;
module.exports = _default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ComponentModel = __webpack_require__(56);

var ComponentView = __webpack_require__(278);

var _sourceHelper = __webpack_require__(100);

var detectSourceFormat = _sourceHelper.detectSourceFormat;

var _sourceType = __webpack_require__(102);

var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * This module is imported by echarts directly.
 *
 * Notice:
 * Always keep this file exists for backward compatibility.
 * Because before 4.1.0, dataset is an optional component,
 * some users may import this module manually.
 */
ComponentModel.extend({
  type: 'dataset',

  /**
   * @protected
   */
  defaultOption: {
    // 'row', 'column'
    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
    sourceHeader: null,
    dimensions: null,
    source: null
  },
  optionUpdated: function () {
    detectSourceFormat(this);
  }
});
ComponentView.extend({
  type: 'dataset'
});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var isString = _util.isString;
var isArray = _util.isArray;
var each = _util.each;
var assert = _util.assert;

var _parseSVG = __webpack_require__(849);

var parseXML = _parseSVG.parseXML;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var storage = createHashMap(); // For minimize the code size of common echarts package,
// do not put too much logic in this module.

var _default = {
  // The format of record: see `echarts.registerMap`.
  // Compatible with previous `echarts.registerMap`.
  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
    var records;

    if (isArray(rawGeoJson)) {
      records = rawGeoJson;
    } else if (rawGeoJson.svg) {
      records = [{
        type: 'svg',
        source: rawGeoJson.svg,
        specialAreas: rawGeoJson.specialAreas
      }];
    } else {
      // Backward compatibility.
      if (rawGeoJson.geoJson && !rawGeoJson.features) {
        rawSpecialAreas = rawGeoJson.specialAreas;
        rawGeoJson = rawGeoJson.geoJson;
      }

      records = [{
        type: 'geoJSON',
        source: rawGeoJson,
        specialAreas: rawSpecialAreas
      }];
    }

    each(records, function (record) {
      var type = record.type;
      type === 'geoJson' && (type = record.type = 'geoJSON');
      var parse = parsers[type];
      parse(record);
    });
    return storage.set(mapName, records);
  },
  retrieveMap: function (mapName) {
    return storage.get(mapName);
  }
};
var parsers = {
  geoJSON: function (record) {
    var source = record.source;
    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
  },
  // Only perform parse to XML object here, which might be time
  // consiming for large SVG.
  // Although convert XML to zrender element is also time consiming,
  // if we do it here, the clone of zrender elements has to be
  // required. So we do it once for each geo instance, util real
  // performance issues call for optimizing it.
  svg: function (record) {
    record.svgXML = parseXML(record.source);
  }
};
module.exports = _default;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var Group = __webpack_require__(98);

var ZImage = __webpack_require__(171);

var Text = __webpack_require__(174);

var Circle = __webpack_require__(267);

var Rect = __webpack_require__(272);

var Ellipse = __webpack_require__(850);

var Line = __webpack_require__(273);

var Path = __webpack_require__(27);

var Polygon = __webpack_require__(269);

var Polyline = __webpack_require__(271);

var LinearGradient = __webpack_require__(274);

var Style = __webpack_require__(170);

var matrix = __webpack_require__(74);

var _path = __webpack_require__(263);

var createFromString = _path.createFromString;

var _util = __webpack_require__(2);

var isString = _util.isString;
var extend = _util.extend;
var defaults = _util.defaults;
var trim = _util.trim;
var each = _util.each;
// import RadialGradient from '../graphic/RadialGradient';
// import Pattern from '../graphic/Pattern';
// import * as vector from '../core/vector';
// Most of the values can be separated by comma and/or white space.
var DILIMITER_REG = /[\s,]+/;
/**
 * For big svg string, this method might be time consuming.
 *
 * @param {string} svg xml string
 * @return {Object} xml root.
 */

function parseXML(svg) {
  if (isString(svg)) {
    var parser = new DOMParser();
    svg = parser.parseFromString(svg, 'text/xml');
  } // Document node. If using $.get, doc node may be input.


  if (svg.nodeType === 9) {
    svg = svg.firstChild;
  } // nodeName of <!DOCTYPE svg> is also 'svg'.


  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
    svg = svg.nextSibling;
  }

  return svg;
}

function SVGParser() {
  this._defs = {};
  this._root = null;
  this._isDefine = false;
  this._isText = false;
}

SVGParser.prototype.parse = function (xml, opt) {
  opt = opt || {};
  var svg = parseXML(xml);

  if (!svg) {
    throw new Error('Illegal svg');
  }

  var root = new Group();
  this._root = root; // parse view port

  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
  // TODO: Other percent value not supported yet.

  var width = parseFloat(svg.getAttribute('width') || opt.width);
  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.

  isNaN(width) && (width = null);
  isNaN(height) && (height = null); // Apply inline style on svg element.

  parseAttributes(svg, root, null, true);
  var child = svg.firstChild;

  while (child) {
    this._parseNode(child, root);

    child = child.nextSibling;
  }

  var viewBoxRect;
  var viewBoxTransform;

  if (viewBox) {
    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.

    if (viewBoxArr.length >= 4) {
      viewBoxRect = {
        x: parseFloat(viewBoxArr[0] || 0),
        y: parseFloat(viewBoxArr[1] || 0),
        width: parseFloat(viewBoxArr[2]),
        height: parseFloat(viewBoxArr[3])
      };
    }
  }

  if (viewBoxRect && width != null && height != null) {
    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);

    if (!opt.ignoreViewBox) {
      // If set transform on the output group, it probably bring trouble when
      // some users only intend to show the clipped content inside the viewBox,
      // but not intend to transform the output group. So we keep the output
      // group no transform. If the user intend to use the viewBox as a
      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
      // manually according to the viewBox info in the output of this method.
      var elRoot = root;
      root = new Group();
      root.add(elRoot);
      elRoot.scale = viewBoxTransform.scale.slice();
      elRoot.position = viewBoxTransform.position.slice();
    }
  } // Some shapes might be overflow the viewport, which should be
  // clipped despite whether the viewBox is used, as the SVG does.


  if (!opt.ignoreRootClip && width != null && height != null) {
    root.setClipPath(new Rect({
      shape: {
        x: 0,
        y: 0,
        width: width,
        height: height
      }
    }));
  } // Set width/height on group just for output the viewport size.


  return {
    root: root,
    width: width,
    height: height,
    viewBoxRect: viewBoxRect,
    viewBoxTransform: viewBoxTransform
  };
};

SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
  // support <style>...</style> in svg, where nodeName is 'style',
  // CSS classes is defined globally wherever the style tags are declared.

  if (nodeName === 'defs') {
    // define flag
    this._isDefine = true;
  } else if (nodeName === 'text') {
    this._isText = true;
  }

  var el;

  if (this._isDefine) {
    var parser = defineParsers[nodeName];

    if (parser) {
      var def = parser.call(this, xmlNode);
      var id = xmlNode.getAttribute('id');

      if (id) {
        this._defs[id] = def;
      }
    }
  } else {
    var parser = nodeParsers[nodeName];

    if (parser) {
      el = parser.call(this, xmlNode, parentGroup);
      parentGroup.add(el);
    }
  }

  var child = xmlNode.firstChild;

  while (child) {
    if (child.nodeType === 1) {
      this._parseNode(child, el);
    } // Is text


    if (child.nodeType === 3 && this._isText) {
      this._parseText(child, el);
    }

    child = child.nextSibling;
  } // Quit define


  if (nodeName === 'defs') {
    this._isDefine = false;
  } else if (nodeName === 'text') {
    this._isText = false;
  }
};

SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
  if (xmlNode.nodeType === 1) {
    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    this._textX += parseFloat(dx);
    this._textY += parseFloat(dy);
  }

  var text = new Text({
    style: {
      text: xmlNode.textContent,
      transformText: true
    },
    position: [this._textX || 0, this._textY || 0]
  });
  inheritStyle(parentGroup, text);
  parseAttributes(xmlNode, text, this._defs);
  var fontSize = text.style.fontSize;

  if (fontSize && fontSize < 9) {
    // PENDING
    text.style.fontSize = 9;
    text.scale = text.scale || [1, 1];
    text.scale[0] *= fontSize / 9;
    text.scale[1] *= fontSize / 9;
  }

  var rect = text.getBoundingRect();
  this._textX += rect.width;
  parentGroup.add(text);
  return text;
};

var nodeParsers = {
  'g': function (xmlNode, parentGroup) {
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    return g;
  },
  'rect': function (xmlNode, parentGroup) {
    var rect = new Rect();
    inheritStyle(parentGroup, rect);
    parseAttributes(xmlNode, rect, this._defs);
    rect.setShape({
      x: parseFloat(xmlNode.getAttribute('x') || 0),
      y: parseFloat(xmlNode.getAttribute('y') || 0),
      width: parseFloat(xmlNode.getAttribute('width') || 0),
      height: parseFloat(xmlNode.getAttribute('height') || 0)
    }); // console.log(xmlNode.getAttribute('transform'));
    // console.log(rect.transform);

    return rect;
  },
  'circle': function (xmlNode, parentGroup) {
    var circle = new Circle();
    inheritStyle(parentGroup, circle);
    parseAttributes(xmlNode, circle, this._defs);
    circle.setShape({
      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
      r: parseFloat(xmlNode.getAttribute('r') || 0)
    });
    return circle;
  },
  'line': function (xmlNode, parentGroup) {
    var line = new Line();
    inheritStyle(parentGroup, line);
    parseAttributes(xmlNode, line, this._defs);
    line.setShape({
      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
    });
    return line;
  },
  'ellipse': function (xmlNode, parentGroup) {
    var ellipse = new Ellipse();
    inheritStyle(parentGroup, ellipse);
    parseAttributes(xmlNode, ellipse, this._defs);
    ellipse.setShape({
      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
    });
    return ellipse;
  },
  'polygon': function (xmlNode, parentGroup) {
    var points = xmlNode.getAttribute('points');

    if (points) {
      points = parsePoints(points);
    }

    var polygon = new Polygon({
      shape: {
        points: points || []
      }
    });
    inheritStyle(parentGroup, polygon);
    parseAttributes(xmlNode, polygon, this._defs);
    return polygon;
  },
  'polyline': function (xmlNode, parentGroup) {
    var path = new Path();
    inheritStyle(parentGroup, path);
    parseAttributes(xmlNode, path, this._defs);
    var points = xmlNode.getAttribute('points');

    if (points) {
      points = parsePoints(points);
    }

    var polyline = new Polyline({
      shape: {
        points: points || []
      }
    });
    return polyline;
  },
  'image': function (xmlNode, parentGroup) {
    var img = new ZImage();
    inheritStyle(parentGroup, img);
    parseAttributes(xmlNode, img, this._defs);
    img.setStyle({
      image: xmlNode.getAttribute('xlink:href'),
      x: xmlNode.getAttribute('x'),
      y: xmlNode.getAttribute('y'),
      width: xmlNode.getAttribute('width'),
      height: xmlNode.getAttribute('height')
    });
    return img;
  },
  'text': function (xmlNode, parentGroup) {
    var x = xmlNode.getAttribute('x') || 0;
    var y = xmlNode.getAttribute('y') || 0;
    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    this._textX = parseFloat(x) + parseFloat(dx);
    this._textY = parseFloat(y) + parseFloat(dy);
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    return g;
  },
  'tspan': function (xmlNode, parentGroup) {
    var x = xmlNode.getAttribute('x');
    var y = xmlNode.getAttribute('y');

    if (x != null) {
      // new offset x
      this._textX = parseFloat(x);
    }

    if (y != null) {
      // new offset y
      this._textY = parseFloat(y);
    }

    var dx = xmlNode.getAttribute('dx') || 0;
    var dy = xmlNode.getAttribute('dy') || 0;
    var g = new Group();
    inheritStyle(parentGroup, g);
    parseAttributes(xmlNode, g, this._defs);
    this._textX += dx;
    this._textY += dy;
    return g;
  },
  'path': function (xmlNode, parentGroup) {
    // TODO svg fill rule
    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
    // path.style.globalCompositeOperation = 'xor';
    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.

    var path = createFromString(d);
    inheritStyle(parentGroup, path);
    parseAttributes(xmlNode, path, this._defs);
    return path;
  }
};
var defineParsers = {
  'lineargradient': function (xmlNode) {
    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
    var gradient = new LinearGradient(x1, y1, x2, y2);

    _parseGradientColorStops(xmlNode, gradient);

    return gradient;
  },
  'radialgradient': function (xmlNode) {}
};

function _parseGradientColorStops(xmlNode, gradient) {
  var stop = xmlNode.firstChild;

  while (stop) {
    if (stop.nodeType === 1) {
      var offset = stop.getAttribute('offset');

      if (offset.indexOf('%') > 0) {
        // percentage
        offset = parseInt(offset, 10) / 100;
      } else if (offset) {
        // number from 0 to 1
        offset = parseFloat(offset);
      } else {
        offset = 0;
      }

      var stopColor = stop.getAttribute('stop-color') || '#000000';
      gradient.addColorStop(offset, stopColor);
    }

    stop = stop.nextSibling;
  }
}

function inheritStyle(parent, child) {
  if (parent && parent.__inheritedStyle) {
    if (!child.__inheritedStyle) {
      child.__inheritedStyle = {};
    }

    defaults(child.__inheritedStyle, parent.__inheritedStyle);
  }
}

function parsePoints(pointsString) {
  var list = trim(pointsString).split(DILIMITER_REG);
  var points = [];

  for (var i = 0; i < list.length; i += 2) {
    var x = parseFloat(list[i]);
    var y = parseFloat(list[i + 1]);
    points.push([x, y]);
  }

  return points;
}

var attributesMap = {
  'fill': 'fill',
  'stroke': 'stroke',
  'stroke-width': 'lineWidth',
  'opacity': 'opacity',
  'fill-opacity': 'fillOpacity',
  'stroke-opacity': 'strokeOpacity',
  'stroke-dasharray': 'lineDash',
  'stroke-dashoffset': 'lineDashOffset',
  'stroke-linecap': 'lineCap',
  'stroke-linejoin': 'lineJoin',
  'stroke-miterlimit': 'miterLimit',
  'font-family': 'fontFamily',
  'font-size': 'fontSize',
  'font-style': 'fontStyle',
  'font-weight': 'fontWeight',
  'text-align': 'textAlign',
  'alignment-baseline': 'textBaseline'
};

function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
  var zrStyle = el.__inheritedStyle || {};
  var isTextEl = el.type === 'text'; // TODO Shadow

  if (xmlNode.nodeType === 1) {
    parseTransformAttribute(xmlNode, el);
    extend(zrStyle, parseStyleAttribute(xmlNode));

    if (!onlyInlineStyle) {
      for (var svgAttrName in attributesMap) {
        if (attributesMap.hasOwnProperty(svgAttrName)) {
          var attrValue = xmlNode.getAttribute(svgAttrName);

          if (attrValue != null) {
            zrStyle[attributesMap[svgAttrName]] = attrValue;
          }
        }
      }
    }
  }

  var elFillProp = isTextEl ? 'textFill' : 'fill';
  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
  el.style = el.style || new Style();
  var elStyle = el.style;
  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
  });

  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
    zrStyle.textBaseline = 'alphabetic';
  }

  if (zrStyle.textBaseline === 'alphabetic') {
    zrStyle.textBaseline = 'bottom';
  }

  if (zrStyle.textAlign === 'start') {
    zrStyle.textAlign = 'left';
  }

  if (zrStyle.textAlign === 'end') {
    zrStyle.textAlign = 'right';
  }

  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
  });

  if (zrStyle.lineDash) {
    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
  }

  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
    // enable stroke
    el[elStrokeProp] = true;
  }

  el.__inheritedStyle = zrStyle;
}

var urlRegex = /url\(\s*#(.*?)\)/;

function getPaint(str, defs) {
  // if (str === 'none') {
  //     return;
  // }
  var urlMatch = defs && str && str.match(urlRegex);

  if (urlMatch) {
    var url = trim(urlMatch[1]);
    var def = defs[url];
    return def;
  }

  return str;
}

var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;

function parseTransformAttribute(xmlNode, node) {
  var transform = xmlNode.getAttribute('transform');

  if (transform) {
    transform = transform.replace(/,/g, ' ');
    var m = null;
    var transformOps = [];
    transform.replace(transformRegex, function (str, type, value) {
      transformOps.push(type, value);
    });

    for (var i = transformOps.length - 1; i > 0; i -= 2) {
      var value = transformOps[i];
      var type = transformOps[i - 1];
      m = m || matrix.create();

      switch (type) {
        case 'translate':
          value = trim(value).split(DILIMITER_REG);
          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
          break;

        case 'scale':
          value = trim(value).split(DILIMITER_REG);
          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
          break;

        case 'rotate':
          value = trim(value).split(DILIMITER_REG);
          matrix.rotate(m, m, parseFloat(value[0]));
          break;

        case 'skew':
          value = trim(value).split(DILIMITER_REG);
          console.warn('Skew transform is not supported yet');
          break;

        case 'matrix':
          var value = trim(value).split(DILIMITER_REG);
          m[0] = parseFloat(value[0]);
          m[1] = parseFloat(value[1]);
          m[2] = parseFloat(value[2]);
          m[3] = parseFloat(value[3]);
          m[4] = parseFloat(value[4]);
          m[5] = parseFloat(value[5]);
          break;
      }
    }

    node.setLocalTransform(m);
  }
} // Value may contain space.


var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;

function parseStyleAttribute(xmlNode) {
  var style = xmlNode.getAttribute('style');
  var result = {};

  if (!style) {
    return result;
  }

  var styleList = {};
  styleRegex.lastIndex = 0;
  var styleRegResult;

  while ((styleRegResult = styleRegex.exec(style)) != null) {
    styleList[styleRegResult[1]] = styleRegResult[2];
  }

  for (var svgAttrName in attributesMap) {
    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
    }
  }

  return result;
}
/**
 * @param {Array.<number>} viewBoxRect
 * @param {number} width
 * @param {number} height
 * @return {Object} {scale, position}
 */


function makeViewBoxTransform(viewBoxRect, width, height) {
  var scaleX = width / viewBoxRect.width;
  var scaleY = height / viewBoxRect.height;
  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'

  var viewBoxScale = [scale, scale];
  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
  return {
    scale: viewBoxScale,
    position: viewBoxPosition
  };
}
/**
 * @param {string|XMLElement} xml
 * @param {Object} [opt]
 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
 * @param {boolean} [opt.ignoreViewBox]
 * @param {boolean} [opt.ignoreRootClip]
 * @return {Object} result:
 * {
 *     root: Group, The root of the the result tree of zrender shapes,
 *     width: number, the viewport width of the SVG,
 *     height: number, the viewport height of the SVG,
 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
 * }
 */


function parseSVG(xml, opt) {
  var parser = new SVGParser();
  return parser.parse(xml, opt);
}

exports.parseXML = parseXML;
exports.makeViewBoxTransform = makeViewBoxTransform;
exports.parseSVG = parseSVG;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(27);

/**
 * 椭圆形状
 * @module zrender/graphic/shape/Ellipse
 */
var _default = Path.extend({
  type: 'ellipse',
  shape: {
    cx: 0,
    cy: 0,
    rx: 0,
    ry: 0
  },
  buildPath: function (ctx, shape) {
    var k = 0.5522848;
    var x = shape.cx;
    var y = shape.cy;
    var a = shape.rx;
    var b = shape.ry;
    var ox = a * k; // 水平控制点偏移量

    var oy = b * k; // 垂直控制点偏移量
    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线

    ctx.moveTo(x - a, y);
    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrender = __webpack_require__(249);

exports.zrender = zrender;

var matrix = __webpack_require__(74);

exports.matrix = matrix;

var vector = __webpack_require__(26);

exports.vector = vector;

var zrUtil = __webpack_require__(2);

var colorTool = __webpack_require__(99);

exports.color = colorTool;

var graphicUtil = __webpack_require__(17);

var numberUtil = __webpack_require__(28);

exports.number = numberUtil;

var formatUtil = __webpack_require__(44);

exports.format = formatUtil;

var _throttle = __webpack_require__(180);

var throttle = _throttle.throttle;
exports.throttle = _throttle.throttle;

var ecHelper = __webpack_require__(852);

exports.helper = ecHelper;

var parseGeoJSON = __webpack_require__(859);

exports.parseGeoJSON = parseGeoJSON;

var _List = __webpack_require__(282);

exports.List = _List;

var _Model = __webpack_require__(55);

exports.Model = _Model;

var _Axis = __webpack_require__(289);

exports.Axis = _Axis;

var _env = __webpack_require__(25);

exports.env = _env;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */
var parseGeoJson = parseGeoJSON;
var ecUtil = {};
zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
  ecUtil[name] = zrUtil[name];
});
var graphic = {};
zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
  graphic[name] = graphicUtil[name];
});
exports.parseGeoJson = parseGeoJson;
exports.util = ecUtil;
exports.graphic = graphic;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var createListFromArray = __webpack_require__(281);

var axisHelper = __webpack_require__(86);

var axisModelCommonMixin = __webpack_require__(288);

var Model = __webpack_require__(55);

var _layout = __webpack_require__(57);

var getLayoutRect = _layout.getLayoutRect;
exports.getLayoutRect = _layout.getLayoutRect;

var _dataStackHelper = __webpack_require__(85);

var enableDataStack = _dataStackHelper.enableDataStack;
var isDimensionStacked = _dataStackHelper.isDimensionStacked;
var getStackedDimension = _dataStackHelper.getStackedDimension;

var _completeDimensions = __webpack_require__(285);

exports.completeDimensions = _completeDimensions;

var _createDimensions = __webpack_require__(284);

exports.createDimensions = _createDimensions;

var _symbol = __webpack_require__(130);

exports.createSymbol = _symbol.createSymbol;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';

/**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */
function createList(seriesModel) {
  return createListFromArray(seriesModel.getSource(), seriesModel);
} // export function createGraph(seriesModel) {
//     var nodes = seriesModel.get('data');
//     var links = seriesModel.get('links');
//     return createGraphFromNodeEdge(nodes, links, seriesModel);
// }


var dataStack = {
  isDimensionStacked: isDimensionStacked,
  enableDataStack: enableDataStack,
  getStackedDimension: getStackedDimension
};
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolDesc
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 */

/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */
function createScale(dataExtent, option) {
  var axisModel = option;

  if (!Model.isInstance(option)) {
    axisModel = new Model(option);
    zrUtil.mixin(axisModel, axisModelCommonMixin);
  }

  var scale = axisHelper.createScaleByModel(axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  axisHelper.niceScaleExtent(scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */


function mixinAxisModelCommonMethods(Model) {
  zrUtil.mixin(Model, axisModelCommonMixin);
}

exports.createList = createList;
exports.dataStack = dataStack;
exports.createScale = createScale;
exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 853 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function defaultKeyGetter(item) {
  return item;
}
/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */


function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
  this._old = oldArr;
  this._new = newArr;
  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
  this.context = context;
}

DataDiffer.prototype = {
  constructor: DataDiffer,

  /**
   * Callback function when add a data
   */
  add: function (func) {
    this._add = func;
    return this;
  },

  /**
   * Callback function when update a data
   */
  update: function (func) {
    this._update = func;
    return this;
  },

  /**
   * Callback function when remove a data
   */
  remove: function (func) {
    this._remove = func;
    return this;
  },
  execute: function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];
    var i;
    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);

    for (i = 0; i < oldArr.length; i++) {
      var key = oldDataKeyArr[i];
      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.

      if (idx != null) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var len = idx.length;

        if (len) {
          len === 1 && (newDataIndexMap[key] = null);
          idx = idx.shift();
        } else {
          newDataIndexMap[key] = null;
        }

        this._update && this._update(idx, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    for (var i = 0; i < newDataKeyArr.length; i++) {
      var key = newDataKeyArr[i];

      if (newDataIndexMap.hasOwnProperty(key)) {
        var idx = newDataIndexMap[key];

        if (idx == null) {
          continue;
        } // idx can never be empty array here. see 'set null' logic above.


        if (!idx.length) {
          this._add && this._add(idx);
        } else {
          for (var j = 0, len = idx.length; j < len; j++) {
            this._add && this._add(idx[j]);
          }
        }
      }
    }
  }
};

function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
  for (var i = 0; i < arr.length; i++) {
    // Add prefix to avoid conflict with Object.prototype.
    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
    var existence = map[key];

    if (existence == null) {
      keyArr.push(key);
      map[key] = i;
    } else {
      if (!existence.length) {
        map[key] = existence = [existence];
      }

      existence.push(i);
    }
  }
}

var _default = DataDiffer;
module.exports = _default;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(2);

var createHashMap = _util.createHashMap;
var retrieve = _util.retrieve;
var each = _util.each;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */
// TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */
function CoordSysInfo(coordSysName) {
  /**
   * @type {string}
   */
  this.coordSysName = coordSysName;
  /**
   * @type {Array.<string>}
   */

  this.coordSysDims = [];
  /**
   * @type {module:zrender/core/util#HashMap}
   */

  this.axisMap = createHashMap();
  /**
   * @type {module:zrender/core/util#HashMap}
   */

  this.categoryAxisMap = createHashMap();
  /**
   * @type {number}
   */

  this.firstCategoryDimIndex = null;
}
/**
 * @return {module:model/referHelper#CoordSysInfo}
 */


function getCoordSysInfoBySeries(seriesModel) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var result = new CoordSysInfo(coordSysName);
  var fetch = fetchers[coordSysName];

  if (fetch) {
    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
    return result;
  }
}

var fetchers = {
  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
    result.coordSysDims = ['x', 'y'];
    axisMap.set('x', xAxisModel);
    axisMap.set('y', yAxisModel);

    if (isCategory(xAxisModel)) {
      categoryAxisMap.set('x', xAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(yAxisModel)) {
      categoryAxisMap.set('y', yAxisModel);
      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
    }
  },
  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
    result.coordSysDims = ['single'];
    axisMap.set('single', singleAxisModel);

    if (isCategory(singleAxisModel)) {
      categoryAxisMap.set('single', singleAxisModel);
      result.firstCategoryDimIndex = 0;
    }
  },
  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
    var polarModel = seriesModel.getReferringComponents('polar')[0];
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var angleAxisModel = polarModel.findAxisModel('angleAxis');
    result.coordSysDims = ['radius', 'angle'];
    axisMap.set('radius', radiusAxisModel);
    axisMap.set('angle', angleAxisModel);

    if (isCategory(radiusAxisModel)) {
      categoryAxisMap.set('radius', radiusAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(angleAxisModel)) {
      categoryAxisMap.set('angle', angleAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
    result.coordSysDims = ['lng', 'lat'];
  },
  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
    var ecModel = seriesModel.ecModel;
    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
      var axisDim = coordSysDims[index];
      axisMap.set(axisDim, axisModel);

      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
        categoryAxisMap.set(axisDim, axisModel);
        result.firstCategoryDimIndex = index;
      }
    });
  }
};

function isCategory(axisModel) {
  return axisModel.get('type') === 'category';
}

exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Scale = __webpack_require__(129);

var OrdinalMeta = __webpack_require__(286);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */
// FIXME only one data
var scaleProto = Scale.prototype;
var OrdinalScale = Scale.extend({
  type: 'ordinal',

  /**
   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
   */
  init: function (ordinalMeta, extent) {
    // Caution: Should not use instanceof, consider ec-extensions using
    // import approach to get OrdinalMeta class.
    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
      ordinalMeta = new OrdinalMeta({
        categories: ordinalMeta
      });
    }

    this._ordinalMeta = ordinalMeta;
    this._extent = extent || [0, ordinalMeta.categories.length - 1];
  },
  parse: function (val) {
    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
    : Math.round(val);
  },
  contain: function (rank) {
    rank = this.parse(rank);
    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
  },

  /**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */
  normalize: function (val) {
    return scaleProto.normalize.call(this, this.parse(val));
  },
  scale: function (val) {
    return Math.round(scaleProto.scale.call(this, val));
  },

  /**
   * @return {Array}
   */
  getTicks: function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push(rank);
      rank++;
    }

    return ticks;
  },

  /**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */
  getLabel: function (n) {
    if (!this.isBlank()) {
      // Note that if no data, ordinalMeta.categories is an empty array.
      return this._ordinalMeta.categories[n];
    }
  },

  /**
   * @return {number}
   */
  count: function () {
    return this._extent[1] - this._extent[0] + 1;
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  },
  getOrdinalMeta: function () {
    return this._ordinalMeta;
  },
  niceTicks: zrUtil.noop,
  niceExtent: zrUtil.noop
});
/**
 * @return {module:echarts/scale/Time}
 */

OrdinalScale.create = function () {
  return new OrdinalScale();
};

var _default = OrdinalScale;
module.exports = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var _number = __webpack_require__(28);

var parsePercent = _number.parsePercent;

var _dataStackHelper = __webpack_require__(85);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

var createRenderPlanner = __webpack_require__(179);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
var STACK_PREFIX = '__ec_stack_';
var LARGE_BAR_MIN_WIDTH = 0.5;
var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barMinWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(zrUtil.defaults({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}

function prepareLayoutBarSeries(seriesType, ecModel) {
  var seriesModels = [];
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
      seriesModels.push(seriesModel);
    }
  });
  return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */


function getValueAxesMinGaps(barSeries) {
  /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */
  var axisValues = {};
  zrUtil.each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();

    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
      return;
    }

    var data = seriesModel.getData();
    var key = baseAxis.dim + '_' + baseAxis.index;
    var dim = data.mapDimension(baseAxis.dim);

    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
      var value = data.get(dim, i);

      if (!axisValues[key]) {
        // No previous data for the axis
        axisValues[key] = [value];
      } else {
        // No value in previous series
        axisValues[key].push(value);
      } // Ignore duplicated time values in the same axis

    }
  });
  var axisMinGaps = [];

  for (var key in axisValues) {
    if (axisValues.hasOwnProperty(key)) {
      var valuesInAxis = axisValues[key];

      if (valuesInAxis) {
        // Sort axis values into ascending order to calculate gaps
        valuesInAxis.sort(function (a, b) {
          return a - b;
        });
        var min = null;

        for (var j = 1; j < valuesInAxis.length; ++j) {
          var delta = valuesInAxis[j] - valuesInAxis[j - 1];

          if (delta > 0) {
            // Ignore 0 delta because they are of the same axis value
            min = min === null ? delta : Math.min(min, delta);
          }
        } // Set to null if only have one data


        axisMinGaps[key] = min;
      }
    }
  }

  return axisMinGaps;
}

function makeColumnLayout(barSeries) {
  var axisMinGaps = getValueAxesMinGaps(barSeries);
  var seriesInfoList = [];
  zrUtil.each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth;

    if (baseAxis.type === 'category') {
      bandWidth = baseAxis.getBandWidth();
    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
      var key = baseAxis.dim + '_' + baseAxis.index;
      var minGap = axisMinGaps[key];
      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
      var scale = baseAxis.scale.getExtent();
      var scaleSpan = Math.abs(scale[1] - scale[0]);
      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
    } else {
      var data = seriesModel.getData();
      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    }

    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
    // the auto-calculated bar width might be less than 1.
    seriesModel.get('barMinWidth') || 1, bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    seriesInfoList.push({
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barMinWidth: barMinWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    });
  });
  return doCalBarWidthAndOffset(seriesInfoList);
}

function doCalBarWidthAndOffset(seriesInfoList) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barMinWidth = seriesInfo.barMinWidth;
    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column) {
      var maxWidth = column.maxWidth;
      var minWidth = column.minWidth;

      if (!column.width) {
        var finalWidth = autoWidth;

        if (maxWidth && maxWidth < finalWidth) {
          finalWidth = Math.min(maxWidth, remainedWidth);
        } // `minWidth` has higher priority. `minWidth` decide that wheter the
        // bar is able to be visible. So `minWidth` should not be restricted
        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
        // the extreme cases for `value` axis, bars are allowed to overlap
        // with each other if `minWidth` specified.


        if (minWidth && minWidth > finalWidth) {
          finalWidth = minWidth;
        }

        if (finalWidth !== autoWidth) {
          column.width = finalWidth;
          remainedWidth -= finalWidth + barGapPercent * finalWidth;
          autoWidthCount--;
        }
      } else {
        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
        // CSS does. Becuase barWidth can be a percent value, where
        // `barMaxWidth` can be used to restrict the final width.
        var finalWidth = column.width;

        if (maxWidth) {
          finalWidth = Math.min(finalWidth, maxWidth);
        } // `minWidth` has higher priority, as described above


        if (minWidth) {
          finalWidth = Math.max(finalWidth, minWidth);
        }

        column.width = finalWidth;
        remainedWidth -= finalWidth + barGapPercent * finalWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        bandWidth: bandWidth,
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}
/**
 * @param {Object} barWidthAndOffset The result of makeColumnLayout
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
 */


function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
  if (barWidthAndOffset && axis) {
    var result = barWidthAndOffset[getAxisKey(axis)];

    if (result != null && seriesModel != null) {
      result = result[getSeriesStackId(seriesModel)];
    }

    return result;
  }
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 */


function layout(seriesType, ecModel) {
  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
  var barWidthAndOffset = makeColumnLayout(seriesModels);
  var lastStackCoords = {};
  var lastStackCoordsOrigin = {};
  zrUtil.each(seriesModels, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243

    data.setLayout({
      bandWidth: columnLayoutInfo.bandWidth,
      offset: columnOffset,
      size: columnWidth
    });
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var stacked = isDimensionStacked(data, valueDim
    /*, baseDim*/
    );
    var isValueAxisH = valueAxis.isHorizontal();
    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);

    for (var idx = 0, len = data.count(); idx < len; idx++) {
      var value = data.get(valueDim, idx);
      var baseValue = data.get(baseDim, idx);
      var sign = value >= 0 ? 'p' : 'n';
      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
      // stackResultDimension directly.

      if (stacked) {
        // Only ordinal axis can be stacked.
        if (!lastStackCoords[stackId][baseValue]) {
          lastStackCoords[stackId][baseValue] = {
            p: valueAxisStart,
            // Positive stack
            n: valueAxisStart // Negative stack

          };
        } // Should also consider #4243


        baseCoord = lastStackCoords[stackId][baseValue][sign];
      }

      var x;
      var y;
      var width;
      var height;

      if (isValueAxisH) {
        var coord = cartesian.dataToPoint([value, baseValue]);
        x = baseCoord;
        y = coord[1] + columnOffset;
        width = coord[0] - valueAxisStart;
        height = columnWidth;

        if (Math.abs(width) < barMinHeight) {
          width = (width < 0 ? -1 : 1) * barMinHeight;
        } // Ignore stack from NaN value


        if (!isNaN(width)) {
          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
        }
      } else {
        var coord = cartesian.dataToPoint([baseValue, value]);
        x = coord[0] + columnOffset;
        y = baseCoord;
        width = columnWidth;
        height = coord[1] - valueAxisStart;

        if (Math.abs(height) < barMinHeight) {
          // Include zero to has a positive bar
          height = (height <= 0 ? -1 : 1) * barMinHeight;
        } // Ignore stack from NaN value


        if (!isNaN(height)) {
          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
        }
      }

      data.setItemLayout(idx, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, this);
} // TODO: Do not support stack in large mode yet.


var largeLayout = {
  seriesType: 'bar',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var coordLayout = cartesian.grid.getRect();
    var baseAxis = cartesian.getBaseAxis();
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var valueAxisHorizontal = valueAxis.isHorizontal();
    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;

    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
      // jshint ignore:line
      barWidth = LARGE_BAR_MIN_WIDTH;
    }

    return {
      progress: progress
    };

    function progress(params, data) {
      var count = params.count;
      var largePoints = new LargeArr(count * 2);
      var largeBackgroundPoints = new LargeArr(count * 2);
      var largeDataIndices = new LargeArr(count);
      var dataIndex;
      var coord = [];
      var valuePair = [];
      var pointsOffset = 0;
      var idxOffset = 0;

      while ((dataIndex = params.next()) != null) {
        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.

        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
        largePoints[pointsOffset++] = coord[0];
        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
        largePoints[pointsOffset++] = coord[1];
        largeDataIndices[idxOffset++] = dataIndex;
      }

      data.setLayout({
        largePoints: largePoints,
        largeDataIndices: largeDataIndices,
        largeBackgroundPoints: largeBackgroundPoints,
        barWidth: barWidth,
        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
        valueAxisHorizontal: valueAxisHorizontal
      });
    }
  }
};

function isOnCartesian(seriesModel) {
  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}

function isInLargeMode(seriesModel) {
  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.


function getValueAxisStart(baseAxis, valueAxis, stacked) {
  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

exports.getLayoutOnAxis = getLayoutOnAxis;
exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
exports.makeColumnLayout = makeColumnLayout;
exports.retrieveColumnLayout = retrieveColumnLayout;
exports.layout = layout;
exports.largeLayout = largeLayout;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var numberUtil = __webpack_require__(28);

var formatUtil = __webpack_require__(44);

var scaleHelper = __webpack_require__(287);

var IntervalScale = __webpack_require__(182);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The "scaleLevels" was originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment on the definition of "scaleLevels" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var intervalScaleProto = IntervalScale.prototype;
var mathCeil = Math.ceil;
var mathFloor = Math.floor;
var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};
/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */


var TimeScale = IntervalScale.extend({
  type: 'time',

  /**
   * @override
   */
  getLabel: function (val) {
    var stepLvl = this._stepLvl;
    var date = new Date(val);
    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
  },

  /**
   * @override
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= ONE_DAY;
      extent[1] += ONE_DAY;
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - ONE_DAY;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
    }
  },

  /**
   * @override
   */
  niceTicks: function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    var approxInterval = span / approxTickNum;

    if (minInterval != null && approxInterval < minInterval) {
      approxInterval = minInterval;
    }

    if (maxInterval != null && approxInterval > maxInterval) {
      approxInterval = maxInterval;
    }

    var scaleLevelsLen = scaleLevels.length;
    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
    var interval = level[1]; // Same with interval scale if span is much larger than 1 year

    if (level[0] === 'year') {
      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
      // var niceYearSpan = numberUtil.nice(yearSpan, false);

      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
      interval *= yearStep;
    }

    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
    scaleHelper.fixExtent(niceExtent, extent);
    this._stepLvl = level; // Interval will be used in getTicks

    this._interval = interval;
    this._niceExtent = niceExtent;
  },
  parse: function (val) {
    // val might be float.
    return +numberUtil.parseDate(val);
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  TimeScale.prototype[methodName] = function (val) {
    return intervalScaleProto[methodName].call(this, this.parse(val));
  };
});
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */

var scaleLevels = [// Format              interval
['hh:mm:ss', ONE_SECOND], // 1s
['hh:mm:ss', ONE_SECOND * 5], // 5s
['hh:mm:ss', ONE_SECOND * 10], // 10s
['hh:mm:ss', ONE_SECOND * 15], // 15s
['hh:mm:ss', ONE_SECOND * 30], // 30s
['hh:mm\nMM-dd', ONE_MINUTE], // 1m
['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
['hh:mm\nMM-dd', ONE_HOUR], // 1h
['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
['MM-dd\nyyyy', ONE_DAY], // 1d
['MM-dd\nyyyy', ONE_DAY * 2], // 2d
['MM-dd\nyyyy', ONE_DAY * 3], // 3d
['MM-dd\nyyyy', ONE_DAY * 4], // 4d
['MM-dd\nyyyy', ONE_DAY * 5], // 5d
['MM-dd\nyyyy', ONE_DAY * 6], // 6d
['week', ONE_DAY * 7], // 7d
['MM-dd\nyyyy', ONE_DAY * 10], // 10d
['week', ONE_DAY * 14], // 2w
['week', ONE_DAY * 21], // 3w
['month', ONE_DAY * 31], // 1M
['week', ONE_DAY * 42], // 6w
['month', ONE_DAY * 62], // 2M
['week', ONE_DAY * 70], // 10w
['quarter', ONE_DAY * 95], // 3M
['month', ONE_DAY * 31 * 4], // 4M
['month', ONE_DAY * 31 * 5], // 5M
['half-year', ONE_DAY * 380 / 2], // 6M
['month', ONE_DAY * 31 * 8], // 8M
['month', ONE_DAY * 31 * 10], // 10M
['year', ONE_DAY * 380] // 1Y
];
/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */

TimeScale.create = function (model) {
  return new TimeScale({
    useUTC: model.ecModel.get('useUTC')
  });
};

var _default = TimeScale;
module.exports = _default;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Scale = __webpack_require__(129);

var numberUtil = __webpack_require__(28);

var IntervalScale = __webpack_require__(182);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Log scale
 * @module echarts/scale/Log
 */
// Use some method of IntervalScale
var scaleProto = Scale.prototype;
var intervalScaleProto = IntervalScale.prototype;
var getPrecisionSafe = numberUtil.getPrecisionSafe;
var roundingErrorFix = numberUtil.round;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow = Math.pow;
var mathLog = Math.log;
var LogScale = Scale.extend({
  type: 'log',
  base: 10,
  $constructor: function () {
    Scale.apply(this, arguments);
    this._originalScale = new IntervalScale();
  },

  /**
   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
   * @return {Array.<number>}
   */
  getTicks: function (expandToNicedExtent) {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158

      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return powVal;
    }, this);
  },

  /**
   * @param {number} splitNumber
   * @return {Array.<Array.<number>>}
   */
  getMinorTicks: intervalScaleProto.getMinorTicks,

  /**
   * @param {number} val
   * @return {string}
   */
  getLabel: intervalScaleProto.getLabel,

  /**
   * @param  {number} val
   * @return {number}
   */
  scale: function (val) {
    val = scaleProto.scale.call(this, val);
    return mathPow(this.base, val);
  },

  /**
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var base = this.base;
    start = mathLog(start) / mathLog(base);
    end = mathLog(end) / mathLog(base);
    intervalScaleProto.setExtent.call(this, start, end);
  },

  /**
   * @return {number} end
   */
  getExtent: function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow(base, extent[0]);
    extent[1] = mathPow(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  },

  /**
   * @param  {Array.<number>} extent
   */
  unionExtent: function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    // TODO
    // filter value that <= 0
    this.unionExtent(data.getApproximateExtent(dim));
  },

  /**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */
  niceTicks: function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = numberUtil.quantity(span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  },

  /**
   * Nice extent.
   * @override
   */
  niceExtent: function (opt) {
    intervalScaleProto.niceExtent.call(this, opt);
    var originalScale = this._originalScale;
    originalScale.__fixMin = opt.fixMin;
    originalScale.__fixMax = opt.fixMax;
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  LogScale.prototype[methodName] = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return scaleProto[methodName].call(this, val);
  };
});

LogScale.create = function () {
  return new LogScale();
};

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, getPrecisionSafe(originalVal));
}

var _default = LogScale;
module.exports = _default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Region = __webpack_require__(860);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */
function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var encodeScale = json.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = json.features;

  for (var f = 0; f < features.length; f++) {
    var feature = features[f];
    var geometry = feature.geometry;
    var coordinates = geometry.coordinates;
    var encodeOffsets = geometry.encodeOffsets;

    for (var c = 0; c < coordinates.length; c++) {
      var coordinate = coordinates[c];

      if (geometry.type === 'Polygon') {
        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
      } else if (geometry.type === 'MultiPolygon') {
        for (var c2 = 0; c2 < coordinate.length; c2++) {
          var polygon = coordinate[c2];
          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
        }
      }
    }
  } // Has been decoded


  json.UTF8Encoding = false;
  return json;
}

function decodePolygon(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}
/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @return {module:zrender/container/Group}
 */


function _default(geoJson) {
  decode(geoJson);
  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var coordinates = geo.coordinates;
    var geometries = [];

    if (geo.type === 'Polygon') {
      geometries.push({
        type: 'polygon',
        // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).
        exterior: coordinates[0],
        interiors: coordinates.slice(1)
      });
    }

    if (geo.type === 'MultiPolygon') {
      zrUtil.each(coordinates, function (item) {
        if (item[0]) {
          geometries.push({
            type: 'polygon',
            exterior: item[0],
            interiors: item.slice(1)
          });
        }
      });
    }

    var region = new Region(properties.name, geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

module.exports = _default;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BoundingRect = __webpack_require__(33);

var bbox = __webpack_require__(264);

var vec2 = __webpack_require__(26);

var polygonContain = __webpack_require__(861);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/coord/geo/Region
 */

/**
 * @param {string|Region} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */
function Region(name, geometries, cp) {
  /**
   * @type {string}
   * @readOnly
   */
  this.name = name;
  /**
   * @type {Array.<Array>}
   * @readOnly
   */

  this.geometries = geometries;

  if (!cp) {
    var rect = this.getBoundingRect();
    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  } else {
    cp = [cp[0], cp[1]];
  }
  /**
   * @type {Array.<number>}
   */


  this.center = cp;
}

Region.prototype = {
  constructor: Region,
  properties: null,

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    var rect = this._rect;

    if (rect) {
      return rect;
    }

    var MAX_NUMBER = Number.MAX_VALUE;
    var min = [MAX_NUMBER, MAX_NUMBER];
    var max = [-MAX_NUMBER, -MAX_NUMBER];
    var min2 = [];
    var max2 = [];
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon
      if (geometries[i].type !== 'polygon') {
        continue;
      } // Doesn't consider hole


      var exterior = geometries[i].exterior;
      bbox.fromPoints(exterior, min2, max2);
      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      if (polygonContain.contain(exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (polygonContain.contain(interiors[k])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  },
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new BoundingRect(x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      for (var p = 0; p < exterior.length; p++) {
        vec2.applyTransform(exterior[p], exterior[p], transform);
      }

      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
        for (var p = 0; p < interiors[h].length; p++) {
          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  },
  cloneShallow: function (name) {
    name == null && (name = this.name);
    var newRegion = new Region(name, this.geometries, this.center);
    newRegion._rect = this._rect;
    newRegion.transformTo = null; // Simply avoid to be called.

    return newRegion;
  }
};
var _default = Region;
module.exports = _default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var windingLine = __webpack_require__(266);

var EPSILON = 1e-8;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
}

function contain(points, x, y) {
  var w = 0;
  var p = points[0];

  if (!p) {
    return false;
  }

  for (var i = 1; i < points.length; i++) {
    var p2 = points[i];
    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
    p = p2;
  } // Close polygon


  var p0 = points[0];

  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
  }

  return w !== 0;
}

exports.contain = contain;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var textContain = __webpack_require__(75);

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

var _axisHelper = __webpack_require__(86);

var makeLabelFormatter = _axisHelper.makeLabelFormatter;
var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
/**
 * @param {module:echats/coord/Axis} axis
 * @return {Object} {
 *     labels: [{
 *         formattedLabel: string,
 *         rawLabel: string,
 *         tickValue: number
 *     }, ...],
 *     labelCategoryInterval: number
 * }
 */

function createAxisLabels(axis) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
}
/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */


function createAxisTicks(axis, tickModel) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
    ticks: axis.scale.getTicks()
  };
}

function makeCategoryLabels(axis) {
  var labelModel = axis.getLabelModel();
  var result = makeCategoryLabelsActually(axis, labelModel);
  return !labelModel.get('show') || axis.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: result.labelCategoryInterval
  } : result;
}

function makeCategoryLabelsActually(axis, labelModel) {
  var labelsCache = getListCache(axis, 'labels');
  var optionLabelInterval = getOptionCategoryInterval(labelModel);
  var result = listCacheGet(labelsCache, optionLabelInterval);

  if (result) {
    return result;
  }

  var labels;
  var numericLabelInterval;

  if (zrUtil.isFunction(optionLabelInterval)) {
    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
  } else {
    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
  } // Cache to avoid calling interval function repeatly.


  return listCacheSet(labelsCache, optionLabelInterval, {
    labels: labels,
    labelCategoryInterval: numericLabelInterval
  });
}

function makeCategoryTicks(axis, tickModel) {
  var ticksCache = getListCache(axis, 'ticks');
  var optionTickInterval = getOptionCategoryInterval(tickModel);
  var result = listCacheGet(ticksCache, optionTickInterval);

  if (result) {
    return result;
  }

  var ticks;
  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
  // we should not return all ticks.

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    ticks = [];
  }

  if (zrUtil.isFunction(optionTickInterval)) {
    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
  } // Always use label interval by default despite label show. Consider this
  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
  // labels. `splitLine` and `axisTick` should be consistent in this case.
  else if (optionTickInterval === 'auto') {
      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
      tickCategoryInterval = labelsResult.labelCategoryInterval;
      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
        return labelItem.tickValue;
      });
    } else {
      tickCategoryInterval = optionTickInterval;
      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.


  return listCacheSet(ticksCache, optionTickInterval, {
    ticks: ticks,
    tickCategoryInterval: tickCategoryInterval
  });
}

function makeRealNumberLabels(axis) {
  var ticks = axis.scale.getTicks();
  var labelFormatter = makeLabelFormatter(axis);
  return {
    labels: zrUtil.map(ticks, function (tickValue, idx) {
      return {
        formattedLabel: labelFormatter(tickValue, idx),
        rawLabel: axis.scale.getLabel(tickValue),
        tickValue: tickValue
      };
    })
  };
} // Large category data calculation is performence sensitive, and ticks and label
// probably be fetched by multiple times. So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.


function getListCache(axis, prop) {
  // Because key can be funciton, and cache size always be small, we use array cache.
  return inner(axis)[prop] || (inner(axis)[prop] = []);
}

function listCacheGet(cache, key) {
  for (var i = 0; i < cache.length; i++) {
    if (cache[i].key === key) {
      return cache[i].value;
    }
  }
}

function listCacheSet(cache, key, value) {
  cache.push({
    key: key,
    value: value
  });
  return value;
}

function makeAutoCategoryInterval(axis) {
  var result = inner(axis).autoInterval;
  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
}
/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */


function calculateCategoryInterval(axis) {
  var params = fetchAutoCategoryIntervalCalculationParams(axis);
  var labelFormatter = makeLabelFormatter(axis);
  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
  // avoid generating a long array by `getTicks`
  // in large category data case.

  var tickCount = ordinalScale.count();

  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
    return 0;
  }

  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.

  if (tickCount > 40) {
    step = Math.max(1, Math.floor(tickCount / 40));
  }

  var tickValue = ordinalExtent[0];
  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
  var unitW = Math.abs(unitSpan * Math.cos(rotation));
  var unitH = Math.abs(unitSpan * Math.sin(rotation));
  var maxW = 0;
  var maxH = 0; // Caution: Performance sensitive for large category data.
  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    var width = 0;
    var height = 0; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number

    width = rect.width * 1.3;
    height = rect.height * 1.3; // Min size, void long loop.

    maxW = Math.max(maxW, width, 7);
    maxH = Math.max(maxH, height, 7);
  }

  var dw = maxW / unitW;
  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

  isNaN(dw) && (dw = Infinity);
  isNaN(dh) && (dh = Infinity);
  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
  var cache = inner(axis.model);
  var axisExtent = axis.getExtent();
  var lastAutoInterval = cache.lastAutoInterval;
  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
  // otherwise the calculated interval might jitter when the zoom
  // window size is close to the interval-changing size.
  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
  // The jitter will cause that sometimes the displayed labels are
  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).

  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
  // point is not the same when zooming in or zooming out.
  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
  // be used. Otherwise some hiden labels might not be shown again.
  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
    interval = lastAutoInterval;
  } // Only update cache if cache not used, otherwise the
  // changing of interval is too insensitive.
  else {
      cache.lastTickCount = tickCount;
      cache.lastAutoInterval = interval;
      cache.axisExtend0 = axisExtent[0];
      cache.axisExtend1 = axisExtent[1];
    }

  return interval;
}

function fetchAutoCategoryIntervalCalculationParams(axis) {
  var labelModel = axis.getLabelModel();
  return {
    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
    labelRotate: labelModel.get('rotate') || 0,
    font: labelModel.getFont()
  };
}

function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
  var labelFormatter = makeLabelFormatter(axis);
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent();
  var labelModel = axis.getLabelModel();
  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...

  var step = Math.max((categoryInterval || 0) + 1, 1);
  var startTick = ordinalExtent[0];
  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
  // while zooming and moving while interval > 0. Otherwise the selection
  // of displayable ticks and symbols probably keep changing.
  // 3 is empirical value.

  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
    startTick = Math.round(Math.ceil(startTick / step) * step);
  } // (1) Only add min max label here but leave overlap checking
  // to render stage, which also ensure the returned list
  // suitable for splitLine and splitArea rendering.
  // (2) Scales except category always contain min max label so
  // do not need to perform this process.


  var showAllLabel = shouldShowAllLabels(axis);
  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;

  if (includeMinLabel && startTick !== ordinalExtent[0]) {
    addItem(ordinalExtent[0]);
  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.


  var tickValue = startTick;

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    addItem(tickValue);
  }

  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
    addItem(ordinalExtent[1]);
  }

  function addItem(tVal) {
    result.push(onlyTick ? tVal : {
      formattedLabel: labelFormatter(tVal),
      rawLabel: ordinalScale.getLabel(tVal),
      tickValue: tVal
    });
  }

  return result;
} // When interval is function, the result `false` means ignore the tick.
// It is time consuming for large category data.


function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
  var ordinalScale = axis.scale;
  var labelFormatter = makeLabelFormatter(axis);
  var result = [];
  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
    var rawLabel = ordinalScale.getLabel(tickValue);

    if (categoryInterval(tickValue, rawLabel)) {
      result.push(onlyTick ? tickValue : {
        formattedLabel: labelFormatter(tickValue),
        rawLabel: rawLabel,
        tickValue: tickValue
      });
    }
  });
  return result;
}

exports.createAxisLabels = createAxisLabels;
exports.createAxisTicks = createAxisTicks;
exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

__webpack_require__(864);

__webpack_require__(865);

var visualSymbol = __webpack_require__(871);

var layoutPoints = __webpack_require__(872);

var dataSample = __webpack_require__(873);

__webpack_require__(874);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// In case developer forget to include grid component
echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
echarts.registerLayout(layoutPoints('line')); // Down sample after filter

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var createListFromArray = __webpack_require__(281);

var SeriesModel = __webpack_require__(277);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = SeriesModel.extend({
  type: 'series.line',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(this.getSource(), this, {
      useEncodeDefaulter: true
    });
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // stack: null
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // If clip the overflow value
    clip: true,
    // cursor: null,
    label: {
      position: 'top'
    },
    // itemStyle: {
    // },
    lineStyle: {
      width: 2,
      type: 'solid'
    },
    // areaStyle: {
    // origin of areaStyle. Valid values:
    // `'auto'/null/undefined`: from axisLine to data
    // `'start'`: from min to data
    // `'end'`: from data to max
    // origin: 'auto'
    // },
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    symbol: 'emptyCircle',
    symbolSize: 4,
    symbolRotate: null,
    showSymbol: true,
    // `false`: follow the label interval strategy.
    // `true`: show all symbols.
    // `'auto'`: If possible, show all symbols, otherwise
    //           follow the label interval strategy.
    showAllSymbol: 'auto',
    // Whether to connect break point.
    connectNulls: false,
    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity
  }
});

module.exports = _default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(2);

var SymbolDraw = __webpack_require__(866);

var SymbolClz = __webpack_require__(290);

var lineAnimationDiff = __webpack_require__(868);

var graphic = __webpack_require__(17);

var modelUtil = __webpack_require__(13);

var _poly = __webpack_require__(869);

var Polyline = _poly.Polyline;
var Polygon = _poly.Polygon;

var ChartView = __webpack_require__(279);

var _helper = __webpack_require__(291);

var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
var getStackedOnPoint = _helper.getStackedOnPoint;

var _createClipPathFromCoordSys = __webpack_require__(870);

var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME step not support polar
function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    var p1 = points1[i];
    var p2 = points2[i];

    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
      return;
    }
  }

  return true;
}

function getSmooth(smooth) {
  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
}
/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Object} dataCoordInfo
 * @param {Array.<Array.<number>>} points
 */


function getStackedOnPoints(coordSys, data, dataCoordInfo) {
  if (!dataCoordInfo.valueDim) {
    return [];
  }

  var points = [];

  for (var idx = 0, len = data.count(); idx < len; idx++) {
    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
  }

  return points;
}

function turnPointsIntoStep(points, coordSys, stepTurnAt) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];

  for (var i = 0; i < points.length - 1; i++) {
    var nextPt = points[i + 1];
    var pt = points[i];
    stepPoints.push(pt);
    var stepPt = [];

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
        break;

      case 'middle':
        // default is start
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt);
        stepPoints.push(stepPt2);
        break;

      default:
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
    }
  } // Last points


  points[i] && stepPoints.push(points[i]);
  return stepPoints;
}

function getVisualGradient(data, coordSys) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  if (coordSys.type !== 'cartesian2d') {
    return;
  }

  var coordDim;
  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    var dimIndex = visualMetaList[i].dimension;
    var dimName = data.dimensions[dimIndex];
    var dimInfo = data.getDimensionInfo(dimName);
    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y

    if (coordDim === 'x' || coordDim === 'y') {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta) {
    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.

  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStops[0].coord - tinyExtent;
  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  zrUtil.each(colorStops, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStops.push({
    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStops.unshift({
    // notice colorStops.length have been changed.
    offset: stopLen ? colorStops[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  }); // zrUtil.each(colorStops, function (colorStop) {
  //     // Make sure each offset has rounded px to avoid not sharp edge
  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
  // });

  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
  gradient[coordDim] = minCoord;
  gradient[coordDim + '2'] = maxCoord;
  return gradient;
}

function getIsIgnoreFunc(seriesModel, data, coordSys) {
  var showAllSymbol = seriesModel.get('showAllSymbol');
  var isAuto = showAllSymbol === 'auto';

  if (showAllSymbol && !isAuto) {
    return;
  }

  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

  if (!categoryAxis) {
    return;
  } // Note that category label interval strategy might bring some weird effect
  // in some scenario: users may wonder why some of the symbols are not
  // displayed. So we show all symbols as possible as we can.


  if (isAuto // Simplify the logic, do not determine label overlap here.
  && canShowAllSymbolForCategory(categoryAxis, data)) {
    return;
  } // Otherwise follow the label interval strategy on category axis.


  var categoryDataDim = data.mapDimension(categoryAxis.dim);
  var labelMap = {};
  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
    labelMap[labelItem.tickValue] = 1;
  });
  return function (dataIndex) {
    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
  };
}

function canShowAllSymbolForCategory(categoryAxis, data) {
  // In mose cases, line is monotonous on category axis, and the label size
  // is close with each other. So we check the symbol size and some of the
  // label size alone with the category axis to estimate whether all symbol
  // can be shown without overlap.
  var axisExtent = categoryAxis.getExtent();
  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
  // Sampling some points, max 5.

  var dataLen = data.count();
  var step = Math.max(1, Math.round(dataLen / 5));

  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
    * 1.5 > availSize) {
      return false;
    }
  }

  return true;
}

function createLineClipPath(coordSys, hasAnimation, seriesModel) {
  if (coordSys.type === 'cartesian2d') {
    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis

    if (!seriesModel.get('clip', true)) {
      var rectShape = clipPath.shape;
      var expandSize = Math.max(rectShape.width, rectShape.height);

      if (isHorizontal) {
        rectShape.y -= expandSize;
        rectShape.height += expandSize * 2;
      } else {
        rectShape.x -= expandSize;
        rectShape.width += expandSize * 2;
      }
    }

    return clipPath;
  } else {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  }
}

var _default = ChartView.extend({
  type: 'line',
  init: function () {
    var lineGroup = new graphic.Group();
    var symbolDraw = new SymbolDraw();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  },
  render: function (seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle');
    var areaStyleModel = seriesModel.getModel('areaStyle');
    var points = data.mapArray(data.getItemLayout);
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var valueOrigin = areaStyleModel.get('origin');
    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
    var showSymbol = seriesModel.get('showSymbol');
    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols

    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar && seriesModel.get('step');
    var clipShapeForSymbol;

    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
      // See #7913 and `test/dataZoom-clip.html`.

      if (clipShapeForSymbol.width != null) {
        clipShapeForSymbol.x -= 0.1;
        clipShapeForSymbol.y -= 0.1;
        clipShapeForSymbol.width += 0.2;
        clipShapeForSymbol.height += 0.2;
      } else if (clipShapeForSymbol.r0) {
        clipShapeForSymbol.r0 -= 0.5;
        clipShapeForSymbol.r1 += 0.5;
      }
    }

    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol
      });

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step);
        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
      }

      polyline = this._newPolyline(points, coordSys, hasAnimation);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      }

      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // Update clipPath


      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
      // because points are not changed

      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol
      }); // Stop symbol animation and sync with line points
      // FIXME performance?

      data.eachItemGraphicEl(function (el) {
        el.stopAnimation(true);
      }); // In the case data zoom triggerred refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step);
            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    var smooth = seriesModel.get('smooth');
    smooth = getSmooth(seriesModel.get('smooth'));
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: seriesModel.get('smoothMonotone'),
      connectNulls: seriesModel.get('connectNulls')
    });

    if (polygon) {
      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
      var stackedOnSmooth = 0;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel'
      }));

      if (stackedOnSeries) {
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: seriesModel.get('smoothMonotone'),
        connectNulls: seriesModel.get('connectNulls')
      });
    }

    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
    this._valueOrigin = valueOrigin;
  },
  dispose: function () {},
  highlight: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var pt = data.getItemLayout(dataIndex);

        if (!pt) {
          // Null data
          return;
        } // fix #11360: should't draw symbol outside clipShapeForSymbol


        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
          return;
        }

        symbol = new SymbolClz(data, dataIndex);
        symbol.position = pt;
        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  },
  downplay: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolyline: function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new Polyline({
      shape: {
        points: points
      },
      silent: true,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolygon: function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new Polygon({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      silent: true
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  },

  /**
   * @private
   */
  // FIXME Two value axis
  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
      next = turnPointsIntoStep(diff.next, coordSys, step);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
    } // `diff.current` is subset of `current` (which should be ensured by
    // turnPointsIntoStep), so points in `__points` can be updated when
    // points in `current` are update during animation.


    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    graphic.updateProps(polyline, {
      shape: {
        points: next
      }
    }, seriesModel);

    if (polygon) {
      polygon.setShape({
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      graphic.updateProps(polygon, {
        shape: {
          points: next,
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel);
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
        }
      });
    }
  },
  remove: function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
  }
});

module.exports = _default;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(17);

var SymbolClz = __webpack_require__(290);

var _util = __webpack_require__(2);

var isObject = _util.isObject;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @module echarts/chart/helper/SymbolDraw
 */

/**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */
function SymbolDraw(symbolCtor) {
  this.group = new graphic.Group();
  this._symbolCtor = symbolCtor || SymbolClz;
}

var symbolDrawProto = SymbolDraw.prototype;

function symbolNeedsDraw(data, point, idx, opt) {
  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
  // the symbol element shape. We use the same clip shape here as
  // the line clip.
  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */


symbolDrawProto.updateData = function (data, opt) {
  opt = normalizeUpdateOpt(opt);
  var group = this.group;
  var seriesModel = data.hostModel;
  var oldData = this._data;
  var SymbolCtor = this._symbolCtor;
  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
  // stream mode to normal mode, where previous elements should be removed.

  if (!oldData) {
    group.removeAll();
  }

  data.diff(oldData).add(function (newIdx) {
    var point = data.getItemLayout(newIdx);

    if (symbolNeedsDraw(data, point, newIdx, opt)) {
      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
      symbolEl.attr('position', point);
      data.setItemGraphicEl(newIdx, symbolEl);
      group.add(symbolEl);
    }
  }).update(function (newIdx, oldIdx) {
    var symbolEl = oldData.getItemGraphicEl(oldIdx);
    var point = data.getItemLayout(newIdx);

    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
      group.remove(symbolEl);
      return;
    }

    if (!symbolEl) {
      symbolEl = new SymbolCtor(data, newIdx);
      symbolEl.attr('position', point);
    } else {
      symbolEl.updateData(data, newIdx, seriesScope);
      graphic.updateProps(symbolEl, {
        position: point
      }, seriesModel);
    } // Add back


    group.add(symbolEl);
    data.setItemGraphicEl(newIdx, symbolEl);
  }).remove(function (oldIdx) {
    var el = oldData.getItemGraphicEl(oldIdx);
    el && el.fadeOut(function () {
      group.remove(el);
    });
  }).execute();
  this._data = data;
};

symbolDrawProto.isPersistent = function () {
  return true;
};

symbolDrawProto.updateLayout = function () {
  var data = this._data;

  if (data) {
    // Not use animation
    data.eachItemGraphicEl(function (el, idx) {
      var point = data.getItemLayout(idx);
      el.attr('position', point);
    });
  }
};

symbolDrawProto.incrementalPrepareUpdate = function (data) {
  this._seriesScope = makeSeriesScope(data);
  this._data = null;
  this.group.removeAll();
};
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Object} [opt] Or isIgnore
 * @param {Function} [opt.isIgnore]
 * @param {Object} [opt.clipShape]
 */


symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
  opt = normalizeUpdateOpt(opt);

  function updateIncrementalAndHover(el) {
    if (!el.isGroup) {
      el.incremental = el.useHoverLayer = true;
    }
  }

  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
    var point = data.getItemLayout(idx);

    if (symbolNeedsDraw(data, point, idx, opt)) {
      var el = new this._symbolCtor(data, idx, this._seriesScope);
      el.traverse(updateIncrementalAndHover);
      el.attr('position', point);
      this.group.add(el);
      data.setItemGraphicEl(idx, el);
    }
  }
};

function normalizeUpdateOpt(opt) {
  if (opt != null && !isObject(opt)) {
    opt = {
      isIgnore: opt
    };
  }

  return opt || {};
}

symbolDrawProto.remove = function (enableAnimation) {
  var group = this.group;
  var data = this._data; // Incremental model do not have this._data.

  if (data && enableAnimation) {
    data.eachItemGraphicEl(function (el) {
      el.fadeOut(function () {
        group.remove(el);
      });
    });
  } else {
    group.removeAll();
  }
};

function makeSeriesScope(data) {
  var seriesModel = data.hostModel;
  return {
    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
    symbolRotate: seriesModel.get('symbolRotate'),
    symbolOffset: seriesModel.get('symbolOffset'),
    hoverAnimation: seriesModel.get('hoverAnimation'),
    labelModel: seriesModel.getModel('label'),
    hoverLabelModel: seriesModel.getModel('emphasis.label'),
    cursorStyle: seriesModel.get('cursor')
  };
}

var _default = SymbolDraw;
module.exports = _default;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _dataProvider = __webpack_require__(103);

var retrieveRawValue = _dataProvider.retrieveRawValue;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @param {module:echarts/data/List} data
 * @param {number} dataIndex
 * @return {string} label string. Not null/undefined
 */
function getDefaultLabel(data, dataIndex) {
  var labelDims = data.mapDimension('defaultedLabel', true);
  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)

  if (len === 1) {
    return retrieveRawValue(data, dataIndex, labelDims[0]);
  } else if (len) {
    var vals = [];

    for (var i = 0; i < labelDims.length; i++) {
      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
      vals.push(val);
    }

    return vals.join(' ');
  }
}

exports.getDefaultLabel = getDefaultLabel;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _helper = __webpack_require__(291);

var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
var getStackedOnPoint = _helper.getStackedOnPoint;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// var arrayDiff = require('zrender/src/core/arrayDiff');
// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
// function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }
function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
  // var oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        var currentPt = oldData.getItemLayout(diffItem.idx);
        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly

        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
          currentPt = nextPt.slice();
        }

        currPoints.push(currentPt);
        nextPoints.push(nextPt);
        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var idx = diffItem.idx;
        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
        nextPoints.push(newData.getItemLayout(idx).slice());
        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
        nextStackedPoints.push(newStackedOnPoints[idx]);
        rawIndices.push(newData.getRawIndex(idx));
        break;

      case '-':
        var idx = diffItem.idx;
        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
        // FIXME FIXME FIXME

        if (rawIndex !== idx) {
          currPoints.push(oldData.getItemLayout(idx));
          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
          currStackedPoints.push(oldStackedOnPoints[idx]);
          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
          rawIndices.push(rawIndex);
        } else {
          pointAdded = false;
        }

    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var sortedCurrPoints = [];
  var sortedNextPoints = [];
  var sortedCurrStackedPoints = [];
  var sortedNextStackedPoints = [];
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    sortedCurrPoints[i] = currPoints[idx];
    sortedNextPoints[i] = nextPoints[idx];
    sortedCurrStackedPoints[i] = currStackedPoints[idx];
    sortedNextStackedPoints[i] = nextStackedPoints[idx];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

module.exports = _default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var Path = __webpack_require__(27);

var vec2 = __webpack_require__(26);

var fixClipWithShadow = __webpack_require__(268);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Poly path support NaN point
var vec2Min = vec2.min;
var vec2Max = vec2.max;
var scaleAndAdd = vec2.scaleAndAdd;
var v2Copy = vec2.copy; // Temporary variable

var v = [];
var cp0 = [];
var cp1 = [];

function isPointNull(p) {
  return isNaN(p[0]) || isNaN(p[1]);
}

function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  // if (smoothMonotone == null) {
  //     if (isMono(points, 'x')) {
  //         return drawMono(ctx, points, start, segLen, allLen,
  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
  //     }
  //     else if (isMono(points, 'y')) {
  //         return drawMono(ctx, points, start, segLen, allLen,
  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
  //     }
  //     else {
  //         return drawNonMono.apply(this, arguments);
  //     }
  // }
  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
  //     return drawMono.apply(this, arguments);
  // }
  // else {
  //     return drawNonMono.apply(this, arguments);
  // }
  if (smoothMonotone === 'none' || !smoothMonotone) {
    return drawNonMono.apply(this, arguments);
  } else {
    return drawMono.apply(this, arguments);
  }
}
/**
 * Check if points is in monotone.
 *
 * @param {number[][]} points         Array of points which is in [x, y] form
 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
 *                                    dimension that is checking.
 *                                    If is 'none', `drawNonMono` should be
 *                                    called.
 *                                    If is undefined, either being monotone
 *                                    in 'x' or 'y' will call `drawMono`.
 */
// function isMono(points, smoothMonotone) {
//     if (points.length <= 1) {
//         return true;
//     }
//     var dim = smoothMonotone === 'x' ? 0 : 1;
//     var last = points[0][dim];
//     var lastDiff = 0;
//     for (var i = 1; i < points.length; ++i) {
//         var diff = points[i][dim] - last;
//         if (!isNaN(diff) && !isNaN(lastDiff)
//             && diff !== 0 && lastDiff !== 0
//             && ((diff >= 0) !== (lastDiff >= 0))
//         ) {
//             return false;
//         }
//         if (!isNaN(diff) && diff !== 0) {
//             lastDiff = diff;
//             last = points[i][dim];
//         }
//     }
//     return true;
// }

/**
 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
 * control points will be used. This should be used when points are monotone
 * either in x or y dimension.
 */


function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
    } else {
      if (smooth > 0) {
        var prevP = points[prevIdx];
        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both

        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
        v2Copy(cp0, prevP);
        cp0[dim] = prevP[dim] + ctrlLen;
        v2Copy(cp1, p);
        cp1[dim] = p[dim] - ctrlLen;
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */


function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
      v2Copy(cp0, p);
    } else {
      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextP = points[nextIdx];

        if (connectNulls) {
          // Find next point not null
          while (nextP && isPointNull(points[nextIdx])) {
            nextIdx += dir;
            nextP = points[nextIdx];
          }
        }

        var ratioNextSeg = 0.5;
        var prevP = points[prevIdx];
        var nextP = points[nextIdx]; // Last point

        if (!nextP || isPointNull(nextP)) {
          v2Copy(cp1, p);
        } else {
          // If next data is null in not connect case
          if (isPointNull(nextP) && !connectNulls) {
            nextP = p;
          }

          vec2.sub(v, nextP, prevP);
          var lenPrevSeg;
          var lenNextSeg;

          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
            var dim = smoothMonotone === 'x' ? 0 : 1;
            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
          } else {
            lenPrevSeg = vec2.dist(p, prevP);
            lenNextSeg = vec2.dist(p, nextP);
          } // Use ratio of seg length


          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
        } // Smooth constraint


        vec2Min(cp0, cp0, smoothMax);
        vec2Max(cp0, cp0, smoothMin);
        vec2Min(cp1, cp1, smoothMax);
        vec2Max(cp1, cp1, smoothMin);
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment

        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}

function getBoundingBox(points, smoothConstraint) {
  var ptMin = [Infinity, Infinity];
  var ptMax = [-Infinity, -Infinity];

  if (smoothConstraint) {
    for (var i = 0; i < points.length; i++) {
      var pt = points[i];

      if (pt[0] < ptMin[0]) {
        ptMin[0] = pt[0];
      }

      if (pt[1] < ptMin[1]) {
        ptMin[1] = pt[1];
      }

      if (pt[0] > ptMax[0]) {
        ptMax[0] = pt[0];
      }

      if (pt[1] > ptMax[1]) {
        ptMax[1] = pt[1];
      }
    }
  }

  return {
    min: smoothConstraint ? ptMin : ptMax,
    max: smoothConstraint ? ptMax : ptMin
  };
}

var Polyline = Path.extend({
  type: 'ec-polyline',
  shape: {
    points: [],
    smooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  style: {
    fill: null,
    stroke: '#000'
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length;
    var result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  }
});
var Polygon = Path.extend({
  type: 'ec-polygon',
  shape: {
    points: [],
    // Offset between stacked base points and points
    stackedOnPoints: [],
    smooth: 0,
    stackedOnSmooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length;
    var smoothMonotone = shape.smoothMonotone;
    var bbox = getBoundingBox(points, shape.smoothConstraint);
    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  }
});
exports.Polyline = Polyline;
exports.Polygon = Polygon;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var graphic = __webpack_require__(17);

var _number = __webpack_require__(28);

var round = _number.round;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function createGridClipPath(cartesian, hasAnimation, seriesModel) {
  var rect = cartesian.getArea();
  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
  var x = rect.x;
  var y = rect.y;
  var width = rect.width;
  var height = rect.height;
  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner

  x -= lineWidth / 2;
  y -= lineWidth / 2;
  width += lineWidth;
  height += lineWidth;
  var clipPath = new graphic.Rect({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
    graphic.initProps(clipPath, {
      shape: {
        width: width,
        height: height
      }
    }, seriesModel);
  }

  return clipPath;
}

function createPolarClipPath(polar, hasAnimation, seriesModel) {
  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.

  var clipPath = new graphic.Sector({
    shape: {
      cx: round(polar.cx, 1),
      cy: round(polar.cy, 1),
      r0: round(sectorArea.r0, 1),
      r: round(sectorArea.r, 1),
      startAngle: sectorArea.startAngle,
      endAngle: sectorArea.endAngle,
      clockwise: sectorArea.clockwise
    }
  });

  if (hasAnimation) {
    clipPath.shape.endAngle = sectorArea.startAngle;
    graphic.initProps(clipPath, {
      shape: {
        endAngle: sectorArea.endAngle
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipPath(coordSys, hasAnimation, seriesModel) {
  if (!coordSys) {
    return null;
  } else if (coordSys.type === 'polar') {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  } else if (coordSys.type === 'cartesian2d') {
    return createGridClipPath(coordSys, hasAnimation, seriesModel);
  }

  return null;
}

exports.createGridClipPath = createGridClipPath;
exports.createPolarClipPath = createPolarClipPath;
exports.createClipPath = createClipPath;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var isFunction = _util.isFunction;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(seriesType, defaultSymbolType, legendSymbol) {
  // Encoding visual for all series include which is filtered for legend drawing
  return {
    seriesType: seriesType,
    // For legend.
    performRawSeries: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var symbolType = seriesModel.get('symbol');
      var symbolSize = seriesModel.get('symbolSize');
      var keepAspect = seriesModel.get('symbolKeepAspect');
      var hasSymbolTypeCallback = isFunction(symbolType);
      var hasSymbolSizeCallback = isFunction(symbolSize);
      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback;
      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
      data.setVisual({
        legendSymbol: legendSymbol || seriesSymbol,
        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
        // some cases but generally it is not recommanded.
        symbol: seriesSymbol,
        symbolSize: seriesSymbolSize,
        symbolKeepAspect: keepAspect
      }); // Only visible series has each data be visual encoded

      if (ecModel.isSeriesFiltered(seriesModel)) {
        return;
      }

      function dataEach(data, idx) {
        if (hasCallback) {
          var rawValue = seriesModel.getRawValue(idx);
          var params = seriesModel.getDataParams(idx);
          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
        }

        if (data.hasItemOption) {
          var itemModel = data.getItemModel(idx);
          var itemSymbolType = itemModel.getShallow('symbol', true);
          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol

          if (itemSymbolType != null) {
            data.setItemVisual(idx, 'symbol', itemSymbolType);
          }

          if (itemSymbolSize != null) {
            // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
          }

          if (itemSymbolKeepAspect != null) {
            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
          }
        }
      }

      return {
        dataEach: data.hasItemOption || hasCallback ? dataEach : null
      };
    }
  };
}

module.exports = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _util = __webpack_require__(2);

var map = _util.map;

var createRenderPlanner = __webpack_require__(179);

var _dataStackHelper = __webpack_require__(85);

var isDimensionStacked = _dataStackHelper.isDimensionStacked;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
function _default(seriesType) {
  return {
    seriesType: seriesType,
    plan: createRenderPlanner(),
    reset: function (seriesModel) {
      var data = seriesModel.getData();
      var coordSys = seriesModel.coordinateSystem;
      var pipelineContext = seriesModel.pipelineContext;
      var isLargeRender = pipelineContext.large;

      if (!coordSys) {
        return;
      }

      var dims = map(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }).slice(0, 2);
      var dimLen = dims.length;
      var stackResultDim = data.getCalculationInfo('stackResultDimension');

      if (isDimensionStacked(data, dims[0]
      /*, dims[1]*/
      )) {
        dims[0] = stackResultDim;
      }

      if (isDimensionStacked(data, dims[1]
      /*, dims[0]*/
      )) {
        dims[1] = stackResultDim;
      }

      function progress(params, data) {
        var segCount = params.end - params.start;
        var points = isLargeRender && new Float32Array(segCount * dimLen);

        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
          var point;

          if (dimLen === 1) {
            var x = data.get(dims[0], i);
            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
          } else {
            var x = tmpIn[0] = data.get(dims[0], i);
            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement

            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
          }

          if (isLargeRender) {
            points[offset++] = point ? point[0] : NaN;
            points[offset++] = point ? point[1] : NaN;
          } else {
            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
          }
        }

        isLargeRender && data.setLayout('symbolPoints', points);
      }

      return dimLen && {
        progress: progress
      };
    }
  };
}

module.exports = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(max) ? max : NaN;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(min) ? min : NaN;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame, value) {
  return Math.round(frame.length / 2);
};

function _default(seriesType) {
  return {
    seriesType: seriesType,
    modifyOutputEnd: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var sampling = seriesModel.get('sampling');
      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling

      if (coordSys.type === 'cartesian2d' && sampling) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var extent = baseAxis.getExtent(); // Coordinste system has been resized

        var size = extent[1] - extent[0];
        var rate = Math.round(data.count() / size);

        if (rate > 1) {
          var sampler;

          if (typeof sampling === 'string') {
            sampler = samplers[sampling];
          } else if (typeof sampling === 'function') {
            sampler = sampling;
          }

          if (sampler) {
            // Only support sample the first dim mapped from value axis.
            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
          }
        }
      }
    }
  };
}

module.exports = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

__webpack_require__(875);

__webpack_require__(882);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Grid view
echarts.extendComponentView({
  type: 'grid',
  render: function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new graphic.Rect({
        shape: gridModel.coordinateSystem.getRect(),
        style: zrUtil.defaults({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  }
});
echarts.registerPreprocessor(function (option) {
  // Only create grid when need
  if (option.xAxis && option.yAxis && !option.grid) {
    option.grid = {};
  }
});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var _util = __webpack_require__(2);

var isObject = _util.isObject;
var each = _util.each;
var map = _util.map;
var indexOf = _util.indexOf;
var retrieve = _util.retrieve;

var _layout = __webpack_require__(57);

var getLayoutRect = _layout.getLayoutRect;

var _axisHelper = __webpack_require__(86);

var createScaleByModel = _axisHelper.createScaleByModel;
var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
var niceScaleExtent = _axisHelper.niceScaleExtent;
var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;

var Cartesian2D = __webpack_require__(876);

var Axis2D = __webpack_require__(878);

var CoordinateSystem = __webpack_require__(177);

var _dataStackHelper = __webpack_require__(85);

var getStackedDimension = _dataStackHelper.getStackedDimension;

__webpack_require__(879);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */
// Depends on GridModel, AxisModel, which performs preprocess.

/**
 * Check if the axis is used in the specified grid
 * @inner
 */
function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function Grid(gridModel, ecModel, api) {
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */
  this._coordsMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */

  this._coordsList = [];
  /**
   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
   * @private
   */

  this._axesMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesList = [];

  this._initCartesian(gridModel, ecModel, api);

  this.model = gridModel;
}

var gridProto = Grid.prototype;
gridProto.type = 'grid';
gridProto.axisPointerEnabled = true;

gridProto.getRect = function () {
  return this._rect;
};

gridProto.update = function (ecModel, api) {
  var axesMap = this._axesMap;

  this._updateScale(ecModel, this.model);

  each(axesMap.x, function (xAxis) {
    niceScaleExtent(xAxis.scale, xAxis.model);
  });
  each(axesMap.y, function (yAxis) {
    niceScaleExtent(yAxis.scale, yAxis.model);
  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.

  var onZeroRecords = {};
  each(axesMap.x, function (xAxis) {
    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
  });
  each(axesMap.y, function (yAxis) {
    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
  }); // Resize again if containLabel is enabled
  // FIXME It may cause getting wrong grid size in data processing stage

  this.resize(this.model, api);
};

function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
  axis.getAxesOnZeroOf = function () {
    // TODO: onZero of multiple axes.
    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
  }; // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.


  var otherAxes = axesMap[otherAxisDim];
  var otherAxisOnZeroOf;
  var axisModel = axis.model;
  var onZero = axisModel.get('axisLine.onZero');
  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');

  if (!onZero) {
    return;
  } // If target axis is specified.


  if (onZeroAxisIndex != null) {
    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    }
  } else {
    // Find the first available other axis.
    for (var idx in otherAxes) {
      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
      // if both onZero, the two Y axes overlap.
      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
        otherAxisOnZeroOf = otherAxes[idx];
        break;
      }
    }
  }

  if (otherAxisOnZeroOf) {
    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
  }

  function getOnZeroRecordKey(axis) {
    return axis.dim + '_' + axis.index;
  }
}

function canOnZeroToAxis(axis) {
  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
}
/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */


gridProto.resize = function (gridModel, api, ignoreContainLabel) {
  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
  this._rect = gridRect;
  var axesList = this._axesList;
  adjustAxes(); // Minus label size

  if (!ignoreContainLabel && gridModel.get('containLabel')) {
    each(axesList, function (axis) {
      if (!axis.model.get('axisLabel.inside')) {
        var labelUnionRect = estimateLabelUnionRect(axis);

        if (labelUnionRect) {
          var dim = axis.isHorizontal() ? 'height' : 'width';
          var margin = axis.model.get('axisLabel.margin');
          gridRect[dim] -= labelUnionRect[dim] + margin;

          if (axis.position === 'top') {
            gridRect.y += labelUnionRect.height + margin;
          } else if (axis.position === 'left') {
            gridRect.x += labelUnionRect.width + margin;
          }
        }
      }
    });
    adjustAxes();
  }

  function adjustAxes() {
    each(axesList, function (axis) {
      var isHorizontal = axis.isHorizontal();
      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(extent[idx], extent[1 - idx]);
      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
    });
  }
};
/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */


gridProto.getAxis = function (axisType, axisIndex) {
  var axesMapOnDim = this._axesMap[axisType];

  if (axesMapOnDim != null) {
    if (axisIndex == null) {
      // Find first axis
      for (var name in axesMapOnDim) {
        if (axesMapOnDim.hasOwnProperty(name)) {
          return axesMapOnDim[name];
        }
      }
    }

    return axesMapOnDim[axisIndex];
  }
};
/**
 * @return {Array.<module:echarts/coord/Axis>}
 */


gridProto.getAxes = function () {
  return this._axesList.slice();
};
/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */


gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
  if (xAxisIndex != null && yAxisIndex != null) {
    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
    return this._coordsMap[key];
  }

  if (isObject(xAxisIndex)) {
    yAxisIndex = xAxisIndex.yAxisIndex;
    xAxisIndex = xAxisIndex.xAxisIndex;
  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.


  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
      return coordList[i];
    }
  }
};

gridProto.getCartesians = function () {
  return this._coordsList.slice();
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertToPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertFromPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
};
/**
 * @inner
 */


gridProto._findConvertTarget = function (ecModel, finder) {
  var seriesModel = finder.seriesModel;
  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
  var gridModel = finder.gridModel;
  var coordsList = this._coordsList;
  var cartesian;
  var axis;

  if (seriesModel) {
    cartesian = seriesModel.coordinateSystem;
    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
  } else if (xAxisModel && yAxisModel) {
    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  } else if (xAxisModel) {
    axis = this.getAxis('x', xAxisModel.componentIndex);
  } else if (yAxisModel) {
    axis = this.getAxis('y', yAxisModel.componentIndex);
  } // Lowest priority.
  else if (gridModel) {
      var grid = gridModel.coordinateSystem;

      if (grid === this) {
        cartesian = this._coordsList[0];
      }
    }

  return {
    cartesian: cartesian,
    axis: axis
  };
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.containPoint = function (point) {
  var coord = this._coordsList[0];

  if (coord) {
    return coord.containPoint(point);
  }
};
/**
 * Initialize cartesian coordinate systems
 * @private
 */


gridProto._initCartesian = function (gridModel, ecModel, api) {
  var axisPositionUsed = {
    left: false,
    right: false,
    top: false,
    bottom: false
  };
  var axesMap = {
    x: {},
    y: {}
  };
  var axesCount = {
    x: 0,
    y: 0
  }; /// Create axis

  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

  if (!axesCount.x || !axesCount.y) {
    // Roll back when there no either x or y axis
    this._axesMap = {};
    this._axesList = [];
    return;
  }

  this._axesMap = axesMap; /// Create cartesian2d

  each(axesMap.x, function (xAxis, xAxisIndex) {
    each(axesMap.y, function (yAxis, yAxisIndex) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      var cartesian = new Cartesian2D(key);
      cartesian.grid = this;
      cartesian.model = gridModel;
      this._coordsMap[key] = cartesian;

      this._coordsList.push(cartesian);

      cartesian.addAxis(xAxis);
      cartesian.addAxis(yAxis);
    }, this);
  }, this);

  function createAxisCreator(axisType) {
    return function (axisModel, idx) {
      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
        return;
      }

      var axisPosition = axisModel.get('position');

      if (axisType === 'x') {
        // Fix position
        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
          // Default bottom of X
          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
        }
      } else {
        // Fix position
        if (axisPosition !== 'left' && axisPosition !== 'right') {
          // Default left of Y
          axisPosition = axisPositionUsed.left ? 'right' : 'left';
        }
      }

      axisPositionUsed[axisPosition] = true;
      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel

      axisModel.axis = axis; // Inject axisModel into axis

      axis.model = axisModel; // Inject grid info axis

      axis.grid = this; // Index of axis, can be used as key

      axis.index = idx;

      this._axesList.push(axis);

      axesMap[axisType][idx] = axis;
      axesCount[axisType]++;
    };
  }
};
/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */


gridProto._updateScale = function (ecModel, gridModel) {
  // Reset scale
  each(this._axesList, function (axis) {
    axis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (isCartesian2D(seriesModel)) {
      var axesModels = findAxesModels(seriesModel, ecModel);
      var xAxisModel = axesModels[0];
      var yAxisModel = axesModels[1];

      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
        return;
      }

      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
      var data = seriesModel.getData();
      var xAxis = cartesian.getAxis('x');
      var yAxis = cartesian.getAxis('y');

      if (data.type === 'list') {
        unionExtent(data, xAxis, seriesModel);
        unionExtent(data, yAxis, seriesModel);
      }
    }
  }, this);

  function unionExtent(data, axis, seriesModel) {
    each(data.mapDimension(axis.dim, true), function (dim) {
      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
      // is [0.1, 0.5], the extent of the `stackResultDimension`
      // is [7, 9], the final extent should not include [0.1, 0.5].
      data, getStackedDimension(data, dim));
    });
  }
};
/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */


gridProto.getTooltipAxes = function (dim) {
  var baseAxes = [];
  var otherAxes = [];
  each(this.getCartesians(), function (cartesian) {
    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
    var otherAxis = cartesian.getOtherAxis(baseAxis);
    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
  });
  return {
    baseAxes: baseAxes,
    otherAxes: otherAxes
  };
};
/**
 * @inner
 */


function updateAxisTransform(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

var axesTypes = ['xAxis', 'yAxis'];
/**
 * @inner
 */

function findAxesModels(seriesModel, ecModel) {
  return map(axesTypes, function (axisType) {
    var axisModel = seriesModel.getReferringComponents(axisType)[0];
    return axisModel;
  });
}
/**
 * @inner
 */


function isCartesian2D(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}

Grid.create = function (ecModel, api) {
  var grids = [];
  ecModel.eachComponent('grid', function (gridModel, idx) {
    var grid = new Grid(gridModel, ecModel, api);
    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
    // should be performed in create stage.

    grid.resize(gridModel, api, true);
    gridModel.coordinateSystem = grid;
    grids.push(grid);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (!isCartesian2D(seriesModel)) {
      return;
    }

    var axesModels = findAxesModels(seriesModel, ecModel);
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var gridModel = xAxisModel.getCoordSysModel();
    var grid = gridModel.coordinateSystem;
    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  });
  return grids;
}; // For deciding which dimensions to use when creating list data


Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
CoordinateSystem.register('cartesian2d', Grid);
var _default = Grid;
module.exports = _default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var BoundingRect = __webpack_require__(33);

var Cartesian = __webpack_require__(877);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function Cartesian2D(name) {
  Cartesian.call(this, name);
}

Cartesian2D.prototype = {
  constructor: Cartesian2D,
  type: 'cartesian2d',

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  },

  /**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  },

  /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  dataToPoint: function (data, reserved, out) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out = out || [];
    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
    return out;
  },

  /**
   * @param {Array.<number>} data
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  clampData: function (data, out) {
    var xScale = this.getAxis('x').scale;
    var yScale = this.getAxis('y').scale;
    var xAxisExtent = xScale.getExtent();
    var yAxisExtent = yScale.getExtent();
    var x = xScale.parse(data[0]);
    var y = yScale.parse(data[1]);
    out = out || [];
    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
    return out;
  },

  /**
   * @param {Array.<number>} point
   * @param {Array.<number>} out
   * @return {Array.<number>}
   */
  pointToData: function (point, out) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out = out || [];
    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
    return out;
  },

  /**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */
  getOtherAxis: function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  },

  /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   * @return {BoundingRect}
   */
  getArea: function () {
    var xExtent = this.getAxis('x').getGlobalExtent();
    var yExtent = this.getAxis('y').getGlobalExtent();
    var x = Math.min(xExtent[0], xExtent[1]);
    var y = Math.min(yExtent[0], yExtent[1]);
    var width = Math.max(xExtent[0], xExtent[1]) - x;
    var height = Math.max(yExtent[0], yExtent[1]) - y;
    var rect = new BoundingRect(x, y, width, height);
    return rect;
  }
};
zrUtil.inherits(Cartesian2D, Cartesian);
var _default = Cartesian2D;
module.exports = _default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */
function dimAxisMapper(dim) {
  return this._axes[dim];
}
/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */


var Cartesian = function (name) {
  this._axes = {};
  this._dimList = [];
  /**
   * @type {string}
   */

  this.name = name || '';
};

Cartesian.prototype = {
  constructor: Cartesian,
  type: 'cartesian',

  /**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */
  getAxis: function (dim) {
    return this._axes[dim];
  },

  /**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */
  getAxes: function () {
    return zrUtil.map(this._dimList, dimAxisMapper, this);
  },

  /**
   * Get axes list by given scale type
   */
  getAxesByScale: function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return zrUtil.filter(this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  },

  /**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */
  addAxis: function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  },

  /**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  dataToCoord: function (val) {
    return this._dataCoordConvert(val, 'dataToCoord');
  },

  /**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  coordToData: function (val) {
    return this._dataCoordConvert(val, 'coordToData');
  },
  _dataCoordConvert: function (input, method) {
    var dimList = this._dimList;
    var output = input instanceof Array ? [] : {};

    for (var i = 0; i < dimList.length; i++) {
      var dim = dimList[i];
      var axis = this._axes[dim];
      output[dim] = axis[method](input[dim]);
    }

    return output;
  }
};
var _default = Cartesian;
module.exports = _default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Axis = __webpack_require__(289);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var Axis2D = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */

  this.position = position || 'bottom';
};

Axis2D.prototype = {
  constructor: Axis2D,

  /**
   * Index of axis, can be used as key
   */
  index: 0,

  /**
   * Implemented in <module:echarts/coord/cartesian/Grid>.
   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
   *         If not on zero of other axis, return null/undefined.
   *         If no axes, return an empty array.
   */
  getAxesOnZeroOf: null,

  /**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */
  model: null,
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */
  getGlobalExtent: function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  },
  getOtherAxis: function () {
    this.grid.getOtherAxis();
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  },

  /**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toLocalCoord: null,

  /**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toGlobalCoord: null
};
zrUtil.inherits(Axis2D, Axis);
var _default = Axis2D;
module.exports = _default;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(292);

var ComponentModel = __webpack_require__(56);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
var _default = ComponentModel.extend({
  type: 'grid',
  dependencies: ['xAxis', 'yAxis'],
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/cartesian/Grid}
   */
  coordinateSystem: null,
  defaultOption: {
    show: false,
    zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 60,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  }
});

module.exports = _default;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var axisDefault = __webpack_require__(881);

var ComponentModel = __webpack_require__(56);

var _layout = __webpack_require__(57);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;

var OrdinalMeta = __webpack_require__(286);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME axisType is fixed ?
var AXIS_TYPES = ['value', 'category', 'time', 'log'];
/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */

function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
  zrUtil.each(AXIS_TYPES, function (axisType) {
    BaseAxisModelClass.extend({
      /**
       * @readOnly
       */
      type: axisName + 'Axis.' + axisType,
      mergeDefaultAndTheme: function (option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
        zrUtil.merge(option, this.getDefaultOption());
        option.type = axisTypeDefaulter(axisName, option);

        if (layoutMode) {
          mergeLayoutParam(option, inputPositionParams, layoutMode);
        }
      },

      /**
       * @override
       */
      optionUpdated: function () {
        var thisOption = this.option;

        if (thisOption.type === 'category') {
          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
        }
      },

      /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */
      getCategories: function (rawData) {
        var option = this.option; // FIXME
        // warning if called before all of 'getInitailData' finished.

        if (option.type === 'category') {
          if (rawData) {
            return option.data;
          }

          return this.__ordinalMeta.categories;
        }
      },
      getOrdinalMeta: function () {
        return this.__ordinalMeta;
      },
      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
    });
  });
  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
}

module.exports = _default;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var defaultOption = {
  show: true,
  zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: false,
  // Axis name displayed.
  name: '',
  // 'start' | 'middle' | 'end'
  nameLocation: 'end',
  // By degree. By defualt auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: false,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: false,
  tooltip: {
    show: false
  },
  axisPointer: {},
  axisLine: {
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    lineStyle: {
      color: '#333',
      width: 1,
      type: 'solid'
    },
    // The arrow at both ends the the axis.
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: true,
    // Whether axisTick is inside the grid or outside the grid.
    inside: false,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: true,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: false,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: ['#ccc'],
      width: 1,
      type: 'solid'
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};
var axisDefault = {};
axisDefault.categoryAxis = zrUtil.merge({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: true,
  // Set false to faster category collection.
  // Only usefull in the case like: category is
  // ['2012-01-01', '2012-01-02', ...], where the input
  // data has been ensured not duplicate and is large data.
  // null means "auto":
  // if axis.data provided, do not deduplication,
  // else do deduplication.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
axisDefault.valueAxis = zrUtil.merge({
  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
  boundaryGap: [0, 0],
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  // Min value of the axis. can be:
  // + a number
  // + 'dataMin': use the min value in data.
  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
  // min: null,
  // Max value of the axis. can be:
  // + a number
  // + 'dataMax': use the max value in data.
  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
  // max: null,
  // Readonly prop, specifies start value of the range when using data zoom.
  // rangeStart: null
  // Readonly prop, specifies end value of the range when using data zoom.
  // rangeEnd: null
  // Optional value can be:
  // + `false`: always include value 0.
  // + `true`: the extent do not consider value 0.
  // scale: false,
  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
  splitNumber: 5,
  // Interval specifies the span of the ticks is mandatorily.
  // interval: null
  // Specify min interval when auto calculate tick interval.
  // minInterval: null
  // Specify max interval when auto calculate tick interval.
  // maxInterval: null
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: false,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Lenght of minor tick
    length: 3,
    // Same inside with axisTick
    // Line style
    lineStyle: {// Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: false,
    lineStyle: {
      color: '#eee',
      width: 1
    }
  }
}, defaultOption);
axisDefault.timeAxis = zrUtil.defaults({
  scale: true,
  min: 'dataMin',
  max: 'dataMax'
}, axisDefault.valueAxis);
axisDefault.logAxis = zrUtil.defaults({
  scale: true,
  logBase: 10
}, axisDefault.valueAxis);
var _default = axisDefault;
module.exports = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

__webpack_require__(292);

__webpack_require__(883);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

var AxisBuilder = __webpack_require__(293);

var AxisView = __webpack_require__(294);

var cartesianAxisHelper = __webpack_require__(295);

var _axisSplitHelper = __webpack_require__(884);

var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
var CartesianAxisView = AxisView.extend({
  type: 'cartesianAxis',
  axisPointerClass: 'CartesianAxisPointer',

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    zrUtil.each(selfBuilderAttrs, function (name) {
      if (axisModel.get(name + '.show')) {
        this['_' + name](axisModel, gridModel);
      }
    }, this);
    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },
  remove: function () {
    rectCoordAxisHandleRemove(this);
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _splitLine: function (axisModel, gridModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      var tickValue = ticksCoords[i].tickValue;

      this._axisGroup.add(new graphic.Line({
        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
        subPixelOptimize: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: zrUtil.defaults({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      }));
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _minorSplitLine: function (axisModel, gridModel) {
    var axis = axisModel.axis;
    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var minorTicksCoords = axis.getMinorTicksCoords();

    if (!minorTicksCoords.length) {
      return;
    }

    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);

        if (isHorizontal) {
          p1[0] = tickCoord;
          p1[1] = gridRect.y;
          p2[0] = tickCoord;
          p2[1] = gridRect.y + gridRect.height;
        } else {
          p1[0] = gridRect.x;
          p1[1] = tickCoord;
          p2[0] = gridRect.x + gridRect.width;
          p2[1] = tickCoord;
        }

        this._axisGroup.add(new graphic.Line({
          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
          subPixelOptimize: true,
          shape: {
            x1: p1[0],
            y1: p1[1],
            x2: p2[0],
            y2: p2[1]
          },
          style: lineStyle,
          silent: true
        }));
      }
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @private
   */
  _splitArea: function (axisModel, gridModel) {
    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
  }
});
CartesianAxisView.extend({
  type: 'xAxis'
});
CartesianAxisView.extend({
  type: 'yAxis'
});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var graphic = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
  var axis = axisModel.axis;

  if (axis.scale.isBlank()) {
    return;
  }

  var splitAreaModel = axisModel.getModel('splitArea');
  var areaStyleModel = splitAreaModel.getModel('areaStyle');
  var areaColors = areaStyleModel.get('color');
  var gridRect = gridModel.coordinateSystem.getRect();
  var ticksCoords = axis.getTicksCoords({
    tickModel: splitAreaModel,
    clamp: true
  });

  if (!ticksCoords.length) {
    return;
  } // For Making appropriate splitArea animation, the color and anid
  // should be corresponding to previous one if possible.


  var areaColorsLen = areaColors.length;
  var lastSplitAreaColors = axisView.__splitAreaColors;
  var newSplitAreaColors = zrUtil.createHashMap();
  var colorIndex = 0;

  if (lastSplitAreaColors) {
    for (var i = 0; i < ticksCoords.length; i++) {
      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);

      if (cIndex != null) {
        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
        break;
      }
    }
  }

  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
  var areaStyle = areaStyleModel.getAreaStyle();
  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];

  for (var i = 1; i < ticksCoords.length; i++) {
    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
    var x;
    var y;
    var width;
    var height;

    if (axis.isHorizontal()) {
      x = prev;
      y = gridRect.y;
      width = tickCoord - x;
      height = gridRect.height;
      prev = x + width;
    } else {
      x = gridRect.x;
      y = prev;
      width = gridRect.width;
      height = tickCoord - y;
      prev = y + height;
    }

    var tickValue = ticksCoords[i - 1].tickValue;
    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
    axisGroup.add(new graphic.Rect({
      anid: tickValue != null ? 'area_' + tickValue : null,
      shape: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      style: zrUtil.defaults({
        fill: areaColors[colorIndex]
      }, areaStyle),
      silent: true
    }));
    colorIndex = (colorIndex + 1) % areaColorsLen;
  }

  axisView.__splitAreaColors = newSplitAreaColors;
}

function rectCoordAxisHandleRemove(axisView) {
  axisView.__splitAreaColors = null;
}

exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var echarts = __webpack_require__(24);

var graphic = __webpack_require__(17);

var _layout = __webpack_require__(57);

var getLayoutRect = _layout.getLayoutRect;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Model
echarts.extendComponentModel({
  type: 'title',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 6,
    show: true,
    text: '',
    // 超链接跳转
    // link: null,
    // 仅支持self | blank
    target: 'blank',
    subtext: '',
    // 超链接跳转
    // sublink: null,
    // 仅支持self | blank
    subtarget: 'blank',
    // 'center' ¦ 'left' ¦ 'right'
    // ¦ {number}（x坐标，单位px）
    left: 0,
    // 'top' ¦ 'bottom' ¦ 'center'
    // ¦ {number}（y坐标，单位px）
    top: 0,
    // 水平对齐
    // 'auto' | 'left' | 'right' | 'center'
    // 默认根据 left 的位置判断是左对齐还是右对齐
    // textAlign: null
    //
    // 垂直对齐
    // 'auto' | 'top' | 'bottom' | 'middle'
    // 默认根据 top 位置判断是上对齐还是下对齐
    // textVerticalAlign: null
    // textBaseline: null // The same as textVerticalAlign.
    backgroundColor: 'rgba(0,0,0,0)',
    // 标题边框颜色
    borderColor: '#ccc',
    // 标题边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 标题内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 主副标题纵向间隔，单位px，默认为10，
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bolder',
      color: '#333'
    },
    subtextStyle: {
      color: '#aaa'
    }
  }
}); // View

echarts.extendComponentView({
  type: 'title',
  render: function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
    var textEl = new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: titleModel.get('text'),
        textFill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new graphic.Text({
      style: graphic.setTextStyle({}, subtextStyleModel, {
        text: subText,
        textFill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        textVerticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    var triggerEvent = titleModel.get('triggerEvent', true);
    textEl.silent = !link && !triggerEvent;
    subTextEl.silent = !sublink && !triggerEvent;

    if (link) {
      textEl.on('click', function () {
        window.open(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        window.open(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    textEl.eventData = subTextEl.eventData = triggerEvent ? {
      componentType: 'title',
      componentIndex: titleModel.componentIndex
    } : null;
    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = getLayoutRect(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right');

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textVerticalAlign) {
      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');

      if (textVerticalAlign === 'center') {
        textVerticalAlign = 'middle';
      }

      if (textVerticalAlign === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textVerticalAlign === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textVerticalAlign = textVerticalAlign || 'top';
    }

    group.attr('position', [layoutRect.x, layoutRect.y]);
    var alignStyle = {
      textAlign: textAlign,
      textVerticalAlign: textVerticalAlign
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new graphic.Rect({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      subPixelOptimize: true,
      silent: true
    });
    group.add(rect);
  }
});

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

__webpack_require__(887);

__webpack_require__(893);

__webpack_require__(894);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME Better way to pack data in graphic element

/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */
echarts.registerAction({
  type: 'showTip',
  event: 'showTip',
  update: 'tooltip:manuallyShowTip'
}, // noop
function () {});
echarts.registerAction({
  type: 'hideTip',
  event: 'hideTip',
  update: 'tooltip:manuallyHideTip'
}, // noop
function () {});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

var axisPointerModelHelper = __webpack_require__(131);

var axisTrigger = __webpack_require__(888);

__webpack_require__(889);

__webpack_require__(890);

__webpack_require__(891);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// CartesianAxisPointer is not supposed to be required here. But consider
// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
echarts.registerPreprocessor(function (option) {
  // Always has a global axisPointerModel for default setting.
  if (option) {
    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
    // is not set, remain null/undefined, otherwise it will
    // override existent link setting.

    if (link && !zrUtil.isArray(link)) {
      option.axisPointer.link = [link];
    }
  }
}); // This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
  // allAxesInfo should be updated when setOption performed.
  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
}); // Broadcast to all views.

echarts.registerAction({
  type: 'updateAxisPointer',
  event: 'updateAxisPointer',
  update: ':updateAxisPointer'
}, axisTrigger);

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

var modelHelper = __webpack_require__(131);

var findPointFromSeries = __webpack_require__(296);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var curry = zrUtil.curry;
var inner = makeInner();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */

function _default(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = findPointFromSeries({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputFinder = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: curry(showPointer, showValueMap),
    showTooltip: curry(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  each(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  each(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
  });
  updateModelActually(showValueMap, axesInfo, outputFinder);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputFinder;
}

function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By defualt use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    zrUtil.extend(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!dontSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  each(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.getData().mapDimension(dim, true);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      // false,
      axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      each(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = modelHelper.makeKey(coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get('label.precision'),
      formatter: axisPointerModel.get('label.formatter')
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputFinder) {
  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = inner(zr)[highDownKey] || {};
  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  zrUtil.each(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  zrUtil.each(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

module.exports = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisPointerModel = echarts.extendComponentModel({
  type: 'axisPointer',
  coordSysAxesInfo: null,
  defaultOption: {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // 'click' | 'mousemove' | 'none'
    triggerOn: null,
    // set default in AxisPonterView.js
    zlevel: 0,
    z: 50,
    type: 'line',
    // 'line' 'shadow' 'cross' 'none'.
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    // Init value depends on whether handle is used.
    // [group0, group1, ...]
    // Each group can be: {
    //      mapper: function () {},
    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
    //      xAxisId: ...,
    //      yAxisName: ...,
    //      angleAxisIndex: ...
    // }
    // mapper: can be ignored.
    //      input: {axisInfo, value}
    //      output: {axisInfo, value}
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#aaa',
      width: 1,
      type: 'solid'
    },
    shadowStyle: {
      color: 'rgba(150,150,150,0.3)'
    },
    label: {
      show: true,
      formatter: null,
      // string | Function
      precision: 'auto',
      // Or a number like 0, 1, 2 ...
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      // default: axis line color
      borderColor: null,
      borderWidth: 0,
      shadowBlur: 3,
      shadowColor: '#aaa' // Considering applicability, common style should
      // better not have shadowOffset.
      // shadowOffsetX: 0,
      // shadowOffsetY: 2

    },
    handle: {
      show: false,

      /* eslint-disable */
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      // jshint ignore:line

      /* eslint-enable */
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  }
});
var _default = AxisPointerModel;
module.exports = _default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var globalListener = __webpack_require__(297);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AxisPointerView = echarts.extendComponentView({
  type: 'axisPointer',
  render: function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    globalListener.unregister(api.getZr(), 'axisPointer');
    AxisPointerView.superApply(this._model, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    globalListener.unregister('axisPointer', api);
    AxisPointerView.superApply(this._model, 'dispose', arguments);
  }
});
var _default = AxisPointerView;
module.exports = _default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var BaseAxisPointer = __webpack_require__(892);

var viewHelper = __webpack_require__(298);

var cartesianAxisHelper = __webpack_require__(295);

var AxisView = __webpack_require__(294);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var CartesianAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  }
});

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
var _default = CartesianAxisPointer;
module.exports = _default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var clazzUtil = __webpack_require__(62);

var graphic = __webpack_require__(17);

var axisPointerModelHelper = __webpack_require__(131);

var eventTool = __webpack_require__(83);

var throttleUtil = __webpack_require__(180);

var _model = __webpack_require__(13);

var makeInner = _model.makeInner;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var inner = makeInner();
var clone = zrUtil.clone;
var bind = zrUtil.bind;
/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */

function BaseAxisPointer() {}

BaseAxisPointer.prototype = {
  /**
   * @private
   */
  _group: null,

  /**
   * @private
   */
  _lastGraphicKey: null,

  /**
   * @private
   */
  _handle: null,

  /**
   * @private
   */
  _dragging: false,

  /**
   * @private
   */
  _lastValue: null,

  /**
   * @private
   */
  _lastStatus: null,

  /**
   * @private
   */
  _payloadInfo: null,

  /**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */
  animationThreshold: 15,

  /**
   * @implement
   */
  render: function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new graphic.Group();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  },

  /**
   * @implement
   */
  remove: function (api) {
    this.clear(api);
  },

  /**
   * @implement
   */
  dispose: function (api) {
    this.clear(api);
  },

  /**
   * @protected
   */
  determineAnimation: function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  },

  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  },

  /**
   * @protected
   */
  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
      group.add(pointerEl);
    }
  },

  /**
   * @protected
   */
  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @protected
   */
  updatePointerEl: function (group, elOption, updateProps) {
    var pointerEl = inner(group).pointerEl;

    if (pointerEl && elOption.pointer) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  },

  /**
   * @protected
   */
  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = inner(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        shape: elOption.label.shape,
        position: elOption.label.position
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @private
   */
  _renderHandle: function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          eventTool.stop(e.event);
        },
        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
        drift: bind(this._onHandleDragMove, this),
        ondragend: bind(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position

    var handleSize = handleModel.get('size');

    if (!zrUtil.isArray(handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  },

  /**
   * @private
   */
  _moveHandleToValue: function (value, isInit) {
    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  },

  /**
   * @private
   */
  _onHandleDragMove: function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    inner(handle).lastProp = null;

    this._doDispatchAxisPointer();
  },

  /**
   * Throttled method.
   * @private
   */
  _doDispatchAxisPointer: function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  },

  /**
   * @private
   */
  _onHandleDragEnd: function (moveAnimation) {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  },

  /**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */
  getHandleTransform: null,

  /**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */
  updateHandleTransform: null,

  /**
   * @private
   */
  clear: function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }
  },

  /**
   * @protected
   */
  doClear: function () {// Implemented by sub-class if necessary.
  },

  /**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */
  buildLabel: function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  }
};
BaseAxisPointer.prototype.constructor = BaseAxisPointer;

function updateProps(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(inner(el).lastProp, props)) {
    inner(el).lastProp = props;
    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
    var equals = true;
    zrUtil.each(newProps, function (item, key) {
      equals = equals && propsEqual(lastProps[key], item);
    });
    return !!equals;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    position: trans.position.slice(),
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

clazzUtil.enableClassExtend(BaseAxisPointer);
var _default = BaseAxisPointer;
module.exports = _default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _default = echarts.extendComponentModel({
  type: 'tooltip',
  dependencies: ['axisPointer'],
  defaultOption: {
    zlevel: 0,
    z: 60,
    show: true,
    // tooltip主体内容
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    // 'single' | 'multipleByCoordSys'
    renderMode: 'auto',
    // 'auto' | 'html' | 'richText'
    // 'auto': use html by default, and use non-html if `document` is not defined
    // 'html': use html for tooltip
    // 'richText': use canvas, svg, and etc. for tooltip
    // 位置 {Array} | {Function}
    // position: null
    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
    // align: null,
    // verticalAlign: null,
    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
    confine: false,
    // 内容格式器：{string}（Template） ¦ {Function}
    // formatter: null
    showDelay: 0,
    // 隐藏延迟，单位ms
    hideDelay: 100,
    // 动画变换时间，单位s
    transitionDuration: 0.4,
    enterable: false,
    // 提示背景颜色，默认为透明度为0.7的黑色
    backgroundColor: 'rgba(50,50,50,0.7)',
    // 提示边框颜色
    borderColor: '#333',
    // 提示边框圆角，单位px，默认为4
    borderRadius: 4,
    // 提示边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 提示内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // Extra css text
    extraCssText: '',
    // 坐标轴指示器，坐标轴触发有效
    axisPointer: {
      // 默认为直线
      // 可选为：'line' | 'shadow' | 'cross'
      type: 'line',
      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
      // 极坐标系会默认选择 angle 轴
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {} // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.

      }
    },
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  }
});

module.exports = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

var env = __webpack_require__(25);

var TooltipContent = __webpack_require__(895);

var TooltipRichContent = __webpack_require__(896);

var formatUtil = __webpack_require__(44);

var numberUtil = __webpack_require__(28);

var graphic = __webpack_require__(17);

var findPointFromSeries = __webpack_require__(296);

var layoutUtil = __webpack_require__(57);

var Model = __webpack_require__(55);

var globalListener = __webpack_require__(297);

var axisHelper = __webpack_require__(86);

var axisPointerViewHelper = __webpack_require__(298);

var _model = __webpack_require__(13);

var getTooltipRenderMode = _model.getTooltipRenderMode;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var bind = zrUtil.bind;
var each = zrUtil.each;
var parsePercent = numberUtil.parsePercent;
var proxyRect = new graphic.Rect({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var _default = echarts.extendComponentView({
  type: 'tooltip',
  init: function (ecModel, api) {
    if (env.node) {
      return;
    }

    var tooltipModel = ecModel.getComponent('tooltip');
    var renderMode = tooltipModel.get('renderMode');
    this._renderMode = getTooltipRenderMode(renderMode);
    var tooltipContent;

    if (this._renderMode === 'html') {
      tooltipContent = new TooltipContent(api.getDom(), api, {
        appendToBody: tooltipModel.get('appendToBody', true)
      });
      this._newLine = '<br/>';
    } else {
      tooltipContent = new TooltipRichContent(api);
      this._newLine = '\n';
    }

    this._tooltipContent = tooltipContent;
  },
  render: function (tooltipModel, ecModel, api) {
    if (env.node) {
      return;
    } // Reset


    this.group.removeAll();
    /**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */

    this._tooltipModel = tooltipModel;
    /**
     * @private
     * @type {module:echarts/model/Global}
     */

    this._ecModel = ecModel;
    /**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */

    this._api = api;
    /**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */

    this._lastDataByCoordSys = null;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update();
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow();
  },
  _initGlobalListener: function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  },
  _keepShow: function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api; // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && tooltipModel.get('triggerOn') !== 'none') {
      var self = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self._lastX,
          y: self._lastY
        });
      });
    }
  },

  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */
  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || env.node) {
      return;
    }

    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;

    if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.position = [payload.x, payload.y];
      el.update();
      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        dataByCoordSys: payload.dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = findPointFromSeries(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          position: payload.position,
          target: pointInfo.el
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target
      }, dispatchAction);
    }
  },
  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent && this._tooltipModel) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction(payload, api));
    }
  },
  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.
  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex;
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);

    if (tooltipModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  },
  _tryShow: function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } // Always show item tooltip if mouse is on the element with dataIndex
    else if (el && el.dataIndex != null) {
        this._lastDataByCoordSys = null;

        this._showSeriesItemTooltip(e, el, dispatchAction);
      } // Tooltip provided directly. Like legend.
      else if (el && el.tooltip) {
          this._lastDataByCoordSys = null;

          this._showComponentItemTooltip(e, el, dispatchAction);
        } else {
          this._lastDataByCoordSys = null;

          this._hide(dispatchAction);
        }
  },
  _showOrMove: function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easyer to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = zrUtil.bind(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  },
  _showAxisTooltip: function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleDefaultHTML = [];
    var singleParamsList = [];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
    var renderMode = this._renderMode;
    var newLine = this._newLine;
    var markers = {};
    each(dataByCoordSys, function (itemCoordSys) {
      // var coordParamList = [];
      // var coordDefaultHTML = [];
      // var coordTooltipModel = buildTooltipModel([
      //     e.tooltipOption,
      //     itemCoordSys.tooltipOption,
      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
      //     globalTooltipModel
      // ]);
      // var displayMode = coordTooltipModel.get('displayMode');
      // var paramsList = displayMode === 'single' ? singleParamsList : [];
      each(itemCoordSys.dataByAxis, function (item) {
        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
        var axisValue = item.value;
        var seriesDefaultHTML = [];

        if (!axisModel || axisValue == null) {
          return;
        }

        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
        zrUtil.each(item.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var dataParams = series && series.getDataParams(dataIndex);
          dataParams.axisDim = item.axisDim;
          dataParams.axisIndex = item.axisIndex;
          dataParams.axisType = item.axisType;
          dataParams.axisId = item.axisId;
          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
          dataParams.axisValueLabel = valueLabel;

          if (dataParams) {
            singleParamsList.push(dataParams);
            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
            var html;

            if (zrUtil.isObject(seriesTooltip)) {
              html = seriesTooltip.html;
              var newMarkers = seriesTooltip.markers;
              zrUtil.merge(markers, newMarkers);
            } else {
              html = seriesTooltip;
            }

            seriesDefaultHTML.push(html);
          }
        }); // Default tooltip content
        // FIXME
        // (1) shold be the first data which has name?
        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.

        var firstLine = valueLabel;

        if (renderMode !== 'html') {
          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
        } else {
          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
        }
      });
    }, this); // In most case, the second axis is shown upper than the first one.

    singleDefaultHTML.reverse();
    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
    var positionExpr = e.position;

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  },
  _showSeriesItemTooltip: function (e, el, dispatchAction) {
    var ecModel = this._ecModel; // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = el.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = el.dataModel || seriesModel;
    var dataIndex = el.dataIndex;
    var dataType = el.dataType;
    var data = dataModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
    var defaultHtml;
    var markers;

    if (zrUtil.isObject(seriesTooltip)) {
      defaultHtml = seriesTooltip.html;
      markers = seriesTooltip.markers;
    } else {
      defaultHtml = seriesTooltip;
      markers = null;
    }

    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  },
  _showComponentItemTooltip: function (e, el, dispatchAction) {
    var tooltipOpt = el.tooltip;

    if (typeof tooltipOpt === 'string') {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on cooridinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  },
  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    if (formatter && typeof formatter === 'string') {
      html = formatUtil.formatTpl(formatter, params, true);
    } else if (typeof formatter === 'function') {
      var callback = bind(function (cbTicket, html) {
        if (cbTicket === this._ticket) {
          tooltipContent.setContent(html, markers, tooltipModel);

          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        }
      }, this);
      this._ticket = asyncTicket;
      html = formatter(params, asyncTicket, callback);
    }

    tooltipContent.setContent(html, markers, tooltipModel);
    tooltipContent.show(tooltipModel);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  },

  /**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */
  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (typeof positionExpr === 'function') {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (zrUtil.isArray(positionExpr)) {
      x = parsePercent(positionExpr[0], viewWidth);
      y = parsePercent(positionExpr[1], viewHeight);
    } else if (zrUtil.isObject(positionExpr)) {
      positionExpr.width = contentSize[0];
      positionExpr.height = contentSize[1];
      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (typeof positionExpr === 'string' && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (tooltipModel.get('confine')) {
      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  },
  // FIXME
  // Should we remove this but leave this to user?
  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
    var lastCoordSys = this._lastDataByCoordSys;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    return !!contentNotChanged;
  },
  _hide: function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  },
  dispose: function (ecModel, api) {
    if (env.node) {
      return;
    }

    this._tooltipContent.dispose();

    globalListener.unregister('itemTooltip', api);
  }
});
/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade) {
  var resultModel = modelCascade.pop();

  while (modelCascade.length) {
    var tooltipOpt = modelCascade.pop();

    if (tooltipOpt) {
      if (Model.isInstance(tooltipOpt)) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (typeof tooltipOpt === 'string') {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
    }
  }

  return resultModel;
}

function makeDispatchAction(payload, api) {
  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
  var size = content.getOuterSize();
  var width = size.width;
  var height = size.height;

  if (gapH != null) {
    if (x + width + gapH > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
  var size = content.getOuterSize();
  var width = size.width;
  var height = size.height;
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function calcTooltipPosition(position, rect, contentSize) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var gap = 5;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - gap;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + gap;
      break;

    case 'left':
      x = rect.x - domWidth - gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}

module.exports = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var zrColor = __webpack_require__(99);

var eventUtil = __webpack_require__(83);

var domUtil = __webpack_require__(251);

var env = __webpack_require__(25);

var formatUtil = __webpack_require__(44);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var each = zrUtil.each;
var toCamelCase = formatUtil.toCamelCase;
var vendors = ['', '-webkit-', '-moz-', '-o-'];
var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
/**
 * @param {number} duration
 * @return {string}
 * @inner
 */

function assembleTransition(duration) {
  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
  return zrUtil.map(vendors, function (vendorPrefix) {
    return vendorPrefix + 'transition:' + transitionText;
  }).join(';');
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
  each(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}
/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */


function assembleCssText(tooltipModel) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.

  transitionDuration && cssText.push(assembleTransition(transitionDuration));

  if (backgroundColor) {
    if (env.canvasSupported) {
      cssText.push('background-Color:' + backgroundColor);
    } else {
      // for ie
      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
      cssText.push('filter:alpha(opacity=70)');
    }
  } // Border style


  each(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = toCamelCase(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.


function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
  var zrPainter = zr && zr.painter;

  if (appendToBody) {
    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();

    if (zrViewportRoot) {
      // Some APPs might use scale on body, so we support CSS transform here.
      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
    }
  } else {
    out[0] = zrX;
    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.

    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();

    if (viewportRootOffset) {
      out[0] += viewportRootOffset.offsetLeft;
      out[1] += viewportRootOffset.offsetTop;
    }
  }
}
/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @param {HTMLElement} container
 * @param {ExtensionAPI} api
 * @param {Object} [opt]
 * @param {boolean} [opt.appendToBody]
 *        `false`: the DOM element will be inside the container. Default value.
 *        `true`: the DOM element will be appended to HTML body, which avoid
 *                some overflow clip but intrude outside of the container.
 * @constructor
 */


function TooltipContent(container, api, opt) {
  if (env.wxa) {
    return null;
  }

  var el = document.createElement('div');
  el.domBelongToZr = true;
  this.el = el;
  var zr = this._zr = api.getZr();
  var appendToBody = this._appendToBody = opt && opt.appendToBody;
  this._styleCoord = [0, 0];
  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);

  if (appendToBody) {
    document.body.appendChild(el);
  } else {
    container.appendChild(el);
  }

  this._container = container;
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout; // FIXME
  // Is it needed to trigger zr event manually if
  // the browser do not support `pointer-events: none`.

  var self = this;

  el.onmouseenter = function () {
    // clear the timeout in hideLater and keep showing tooltip
    if (self._enterable) {
      clearTimeout(self._hideTimeout);
      self._show = true;
    }

    self._inContent = true;
  };

  el.onmousemove = function (e) {
    e = e || window.event;

    if (!self._enterable) {
      // `pointer-events: none` is set to tooltip content div
      // if `enterable` is set as `false`, and `el.onmousemove`
      // can not be triggered. But in browser that do not
      // support `pointer-events`, we need to do this:
      // Try trigger zrender event to avoid mouse
      // in and out shape too frequently
      var handler = zr.handler;
      var zrViewportRoot = zr.painter.getViewportRoot();
      eventUtil.normalizeEvent(zrViewportRoot, e, true);
      handler.dispatch('mousemove', e);
    }
  };

  el.onmouseleave = function () {
    if (self._enterable) {
      if (self._show) {
        self.hideLater(self._hideDelay);
      }
    }

    self._inContent = false;
  };
}

TooltipContent.prototype = {
  constructor: TooltipContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function () {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
      domStyle.position = 'relative';
    } // Hide the tooltip
    // PENDING
    // this.hide();

  },
  show: function (tooltipModel) {
    clearTimeout(this._hideTimeout);
    var el = this.el;
    var styleCoord = this._styleCoord;
    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
    // we should set initial value to `left` and `top`.
    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occsionally move over the tooltip, a mouseout event will be
    // triggered by canvas, and cuase some unexpectable result like dragging
    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
    // it. Although it is not suppored by IE8~IE10, fortunately it is a rare
    // scenario.

    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
    this._show = true;
  },
  setContent: function (content) {
    this.el.innerHTML = content == null ? '' : content;
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var el = this.el;
    return [el.clientWidth, el.clientHeight];
  },
  moveTo: function (zrX, zrY) {
    var styleCoord = this._styleCoord;
    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
    var style = this.el.style;
    style.left = styleCoord[0] + 'px';
    style.top = styleCoord[1] + 'px';
  },
  hide: function () {
    this.el.style.display = 'none';
    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  },
  dispose: function () {
    this.el.parentNode.removeChild(this.el);
  },
  getOuterSize: function () {
    var width = this.el.clientWidth;
    var height = this.el.clientHeight; // Consider browser compatibility.
    // IE8 does not support getComputedStyle.

    if (document.defaultView && document.defaultView.getComputedStyle) {
      var stl = document.defaultView.getComputedStyle(this.el);

      if (stl) {
        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
      }
    }

    return {
      width: width,
      height: height
    };
  }
};
var _default = TooltipContent;
module.exports = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var zrUtil = __webpack_require__(2);

var Text = __webpack_require__(174);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// import Group from 'zrender/src/container/Group';

/**
 * @alias module:echarts/component/tooltip/TooltipRichContent
 * @constructor
 */
function TooltipRichContent(api) {
  this._zr = api.getZr();
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout;
}

TooltipRichContent.prototype = {
  constructor: TooltipRichContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function () {// noop
  },
  show: function (tooltipModel) {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }

    this.el.attr('show', true);
    this._show = true;
  },

  /**
   * Set tooltip content
   *
   * @param {string} content rich text string of content
   * @param {Object} markerRich rich text style
   * @param {Object} tooltipModel tooltip model
   */
  setContent: function (content, markerRich, tooltipModel) {
    if (this.el) {
      this._zr.remove(this.el);
    }

    var markers = {};
    var text = content;
    var prefix = '{marker';
    var suffix = '|}';
    var startId = text.indexOf(prefix);

    while (startId >= 0) {
      var endId = text.indexOf(suffix);
      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);

      if (name.indexOf('sub') > -1) {
        markers['marker' + name] = {
          textWidth: 4,
          textHeight: 4,
          textBorderRadius: 2,
          textBackgroundColor: markerRich[name],
          // TODO: textOffset is not implemented for rich text
          textOffset: [3, 0]
        };
      } else {
        markers['marker' + name] = {
          textWidth: 10,
          textHeight: 10,
          textBorderRadius: 5,
          textBackgroundColor: markerRich[name]
        };
      }

      text = text.substr(endId + 1);
      startId = text.indexOf('{marker');
    }

    this.el = new Text({
      style: {
        rich: markers,
        text: content,
        textLineHeight: 20,
        textBackgroundColor: tooltipModel.get('backgroundColor'),
        textBorderRadius: tooltipModel.get('borderRadius'),
        textFill: tooltipModel.get('textStyle.color'),
        textPadding: tooltipModel.get('padding')
      },
      z: tooltipModel.get('z')
    });

    this._zr.add(this.el);

    var self = this;
    this.el.on('mouseover', function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    });
    this.el.on('mouseout', function () {
      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }

      self._inContent = false;
    });
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var bounding = this.el.getBoundingRect();
    return [bounding.width, bounding.height];
  },
  moveTo: function (x, y) {
    if (this.el) {
      this.el.attr('position', [x, y]);
    }
  },
  hide: function () {
    if (this.el) {
      this.el.hide();
    }

    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  },
  getOuterSize: function () {
    var size = this.getSize();
    return {
      width: size[0],
      height: size[1]
    };
  }
};
var _default = TooltipRichContent;
module.exports = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

__webpack_require__(898);

__webpack_require__(899);

__webpack_require__(900);

var legendFilter = __webpack_require__(902);

var Component = __webpack_require__(56);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Do not contain scrollable legend, for sake of file size.
// Series Filter
echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
Component.registerSubTypeDefaulter('legend', function () {
  // Default 'plain' when no type specified.
  return 'plain';
});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

var Model = __webpack_require__(55);

var _model = __webpack_require__(13);

var isNameSpecified = _model.isNameSpecified;

var lang = __webpack_require__(280);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var langSelector = lang.legend.selector;
var defaultSelectorOption = {
  all: {
    type: 'all',
    title: zrUtil.clone(langSelector.all)
  },
  inverse: {
    type: 'inverse',
    title: zrUtil.clone(langSelector.inverse)
  }
};
var LegendModel = echarts.extendComponentModel({
  type: 'legend.plain',
  dependencies: ['series'],
  layoutMode: {
    type: 'box',
    // legend.width/height are maxWidth/maxHeight actually,
    // whereas realy width/height is calculated by its content.
    // (Setting {left: 10, right: 10} does not make sense).
    // So consider the case:
    // `setOption({legend: {left: 10});`
    // then `setOption({legend: {right: 10});`
    // The previous `left` should be cleared by setting `ignoreSize`.
    ignoreSize: true
  },
  init: function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};

    this._updateSelector(option);
  },
  mergeOption: function (option) {
    LegendModel.superCall(this, 'mergeOption', option);

    this._updateSelector(option);
  },
  _updateSelector: function (option) {
    var selector = option.selector;

    if (selector === true) {
      selector = option.selector = ['all', 'inverse'];
    }

    if (zrUtil.isArray(selector)) {
      zrUtil.each(selector, function (item, index) {
        zrUtil.isString(item) && (item = {
          type: item
        });
        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
      });
    }
  },
  optionUpdated: function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name = legendData[i].get('name');

        if (this.isSelected(name)) {
          // Force to unselect others
          this.select(name);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  },
  _updateData: function (ecModel) {
    var potentialData = [];
    var availableNames = [];
    ecModel.eachRawSeries(function (seriesModel) {
      var seriesName = seriesModel.name;
      availableNames.push(seriesName);
      var isPotential;

      if (seriesModel.legendVisualProvider) {
        var provider = seriesModel.legendVisualProvider;
        var names = provider.getAllNames();

        if (!ecModel.isSeriesFiltered(seriesModel)) {
          availableNames = availableNames.concat(names);
        }

        if (names.length) {
          potentialData = potentialData.concat(names);
        } else {
          isPotential = true;
        }
      } else {
        isPotential = true;
      }

      if (isPotential && isNameSpecified(seriesModel)) {
        potentialData.push(seriesModel.name);
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
    // which is convinient for user preparing option.

    var rawData = this.get('data') || potentialData;
    var legendData = zrUtil.map(rawData, function (dataItem) {
      // Can be string or number
      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
        dataItem = {
          name: dataItem
        };
      }

      return new Model(dataItem, this, this.ecModel);
    }, this);
    /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */

    this._data = legendData;
  },

  /**
   * @return {Array.<module:echarts/model/Model>}
   */
  getData: function () {
    return this._data;
  },

  /**
   * @param {string} name
   */
  select: function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      zrUtil.each(data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  },

  /**
   * @param {string} name
   */
  unSelect: function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  },

  /**
   * @param {string} name
   */
  toggleSelected: function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  },
  allSelect: function () {
    var data = this._data;
    var selected = this.option.selected;
    zrUtil.each(data, function (dataItem) {
      selected[dataItem.get('name', true)] = true;
    });
  },
  inverseSelect: function () {
    var data = this._data;
    var selected = this.option.selected;
    zrUtil.each(data, function (dataItem) {
      var name = dataItem.get('name', true); // Initially, default value is true

      if (!selected.hasOwnProperty(name)) {
        selected[name] = true;
      }

      selected[name] = !selected[name];
    });
  },

  /**
   * @param {string} name
   */
  isSelected: function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
  },
  getOrient: function () {
    return this.get('orient') === 'vertical' ? {
      index: 1,
      name: 'vertical'
    } : {
      index: 0,
      name: 'horizontal'
    };
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 4,
    show: true,
    // 布局方式，默认为水平布局，可选为：
    // 'horizontal' | 'vertical'
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    // 水平对齐
    // 'auto' | 'left' | 'right'
    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    // 图例边框颜色
    borderColor: '#ccc',
    borderRadius: 0,
    // 图例边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 图例内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 各个item之间的间隔，单位px，默认为10，
    // 横向布局时为水平间隔，纵向布局时为纵向间隔
    itemGap: 10,
    // the width of legend symbol
    itemWidth: 25,
    // the height of legend symbol
    itemHeight: 14,
    // the color of unselected legend symbol
    inactiveColor: '#ccc',
    // the borderColor of unselected legend symbol
    inactiveBorderColor: '#ccc',
    itemStyle: {
      // the default borderWidth of legend symbol
      borderWidth: 0
    },
    textStyle: {
      // 图例文字颜色
      color: '#333'
    },
    // formatter: '',
    // 选择模式，默认开启图例开关
    selectedMode: true,
    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
    // selected: null,
    // 图例内容（详见legend.data，数组中每一项代表一个item
    // data: [],
    // Usage:
    // selector: [{type: 'all or inverse', title: xxx}]
    // or
    // selector: true
    // or
    // selector: ['all', 'inverse']
    selector: false,
    selectorLabel: {
      show: true,
      borderRadius: 10,
      padding: [3, 5, 3, 5],
      fontSize: 12,
      fontFamily: ' sans-serif',
      color: '#666',
      borderWidth: 1,
      borderColor: '#666'
    },
    emphasis: {
      selectorLabel: {
        show: true,
        color: '#eee',
        backgroundColor: '#666'
      }
    },
    // Value can be 'start' or 'end'
    selectorPosition: 'auto',
    selectorItemGap: 7,
    selectorButtonGap: 10,
    // Tooltip 相关配置
    tooltip: {
      show: false
    }
  }
});
var _default = LegendModel;
module.exports = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
      legendModel[methodName]();
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    zrUtil.each(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
    selected: selectedMap
  } : {
    name: payload.name,
    selected: selectedMap
  };
}
/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */


echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _config = __webpack_require__(22);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(24);

var zrUtil = __webpack_require__(2);

var _symbol = __webpack_require__(130);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(17);

var _listComponent = __webpack_require__(901);

var makeBackground = _listComponent.makeBackground;

var layoutUtil = __webpack_require__(57);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var curry = zrUtil.curry;
var each = zrUtil.each;
var Group = graphic.Group;

var _default = echarts.extendComponentView({
  type: 'legend.plain',
  newlineDisabled: false,

  /**
   * @override
   */
  init: function () {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this.group.add(this._contentGroup = new Group());
    /**
     * @private
     * @type {module:zrender/Element}
     */

    this._backgroundEl;
    /**
     * @private
     * @type {module:zrender/container/Group}
     */

    this.group.add(this._selectorGroup = new Group());
    /**
     * If first rendering, `contentGroup.position` is [0, 0], which
     * does not make sense and may cause unexepcted animation if adopted.
     * @private
     * @type {boolean}
     */

    this._isFirstRender = true;
  },

  /**
   * @protected
   */
  getContentGroup: function () {
    return this._contentGroup;
  },

  /**
   * @protected
   */
  getSelectorGroup: function () {
    return this._selectorGroup;
  },

  /**
   * @override
   */
  render: function (legendModel, ecModel, api) {
    var isFirstRender = this._isFirstRender;
    this._isFirstRender = false;
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');
    var orient = legendModel.get('orient');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
    }

    var selector = legendModel.get('selector', true);
    var selectorPosition = legendModel.get('selectorPosition', true);

    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.

    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
  },

  /**
   * @protected
   */
  resetInner: function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
    this.getSelectorGroup().removeAll();
  },

  /**
   * @protected
   */
  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = zrUtil.createHashMap();
    var selectMode = legendModel.get('selectedMode');
    var excludeSeriesId = [];
    ecModel.eachRawSeries(function (seriesModel) {
      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
    });
    each(legendModel.getData(), function (itemModel, dataIndex) {
      var name = itemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        contentGroup.add(new Group({
          newline: true
        }));
        return;
      } // Representitive series.


      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawed
        return;
      } // Legend to control series.


      if (seriesModel) {
        var data = seriesModel.getData();
        var color = data.getVisual('color');
        var borderColor = data.getVisual('borderColor'); // If color is a callback function

        if (typeof color === 'function') {
          // Use the first data
          color = color(seriesModel.getDataParams(0));
        } // If borderColor is a callback function


        if (typeof borderColor === 'function') {
          // Use the first data
          borderColor = borderColor(seriesModel.getDataParams(0));
        } // Using rect symbol defaultly


        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
        var symbolType = data.getVisual('symbol');

        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);

        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
        legendDrawnMap.set(name, true);
      } else {
        // Legend to control data. In pie and funnel.
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendVisualProvider) {
            var provider = seriesModel.legendVisualProvider;

            if (!provider.containName(name)) {
              return;
            }

            var idx = provider.indexOfName(name);
            var color = provider.getItemVisual(idx, 'color');
            var borderColor = provider.getItemVisual(idx, 'borderColor');
            var legendSymbolType = 'roundRect';

            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.


            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
            // more than one pie series.
            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }
    }, this);

    if (selector) {
      this._createSelector(selector, legendModel, api, orient, selectorPosition);
    }
  },
  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    each(selector, function (selectorItem) {
      createSelectorButton(selectorItem);
    });

    function createSelectorButton(selectorItem) {
      var type = selectorItem.type;
      var labelText = new graphic.Text({
        style: {
          x: 0,
          y: 0,
          align: 'center',
          verticalAlign: 'middle'
        },
        onclick: function () {
          api.dispatchAction({
            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
          });
        }
      });
      selectorGroup.add(labelText);
      var labelModel = legendModel.getModel('selectorLabel');
      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
        defaultText: selectorItem.title,
        isRectText: false
      });
      graphic.setHoverStyle(labelText);
    }
  },
  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var inactiveColor = legendModel.get('inactiveColor');
    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
    var legendModelItemStyle = legendModel.getModel('itemStyle');
    var isSelected = legendModel.isSelected(name);
    var itemGroup = new Group();
    var textStyleModel = itemModel.getModel('textStyle');
    var itemIcon = itemModel.get('icon');
    var tooltipModel = itemModel.getModel('tooltip');
    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first

    legendSymbolType = itemIcon || legendSymbolType;
    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
    symbolKeepAspect == null ? true : symbolKeepAspect);
    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
    // PENDING

    if (!itemIcon && symbolType // At least show one symbol, can't be all none
    && (symbolType !== legendSymbolType || symbolType === 'none')) {
      var size = itemHeight * 0.8;

      if (symbolType === 'none') {
        symbolType = 'circle';
      }

      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center

      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (typeof formatter === 'string' && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (typeof formatter === 'function') {
      content = formatter(name);
    }

    itemGroup.add(new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        textAlign: textAlign,
        textVerticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new graphic.Rect({
      shape: itemGroup.getBoundingRect(),
      invisible: true,
      tooltip: tooltipModel.get('show') ? zrUtil.extend({
        content: name,
        // Defaul formatter
        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
          return name;
        },
        formatterParams: {
          componentType: 'legend',
          legendIndex: legendModel.componentIndex,
          name: name,
          $vars: ['name']
        }
      }, tooltipModel.option) : null
    });
    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    graphic.setHoverStyle(itemGroup);
    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  },

  /**
   * @protected
   */
  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    var contentPos = [-contentRect.x, -contentRect.y];

    if (selector) {
      // Place buttons in selectorGroup
      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
      var selectorRect = selectorGroup.getBoundingRect();
      var selectorPos = [-selectorRect.x, -selectorRect.y];
      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
      var orientIdx = legendModel.getOrient().index;
      var wh = orientIdx === 0 ? 'width' : 'height';
      var hw = orientIdx === 0 ? 'height' : 'width';
      var yx = orientIdx === 0 ? 'y' : 'x';

      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
      } else {
        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
      } //Always align selector to content as 'middle'


      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
      selectorGroup.attr('position', selectorPos);
      contentGroup.attr('position', contentPos);
      var mainRect = {
        x: 0,
        y: 0
      };
      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
      return mainRect;
    } else {
      contentGroup.attr('position', contentPos);
      return this.group.getBoundingRect();
    }
  },

  /**
   * @protected
   */
  remove: function () {
    this.getContentGroup().removeAll();
    this._isFirstRender = true;
  }
});

function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
  var itemStyle;

  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
    itemStyle = legendModelItemStyle.getItemStyle();
    symbol.style.stroke = borderColor;

    if (!isSelected) {
      itemStyle.stroke = inactiveBorderColor;
    }
  } else {
    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
  }

  return symbol.setStyle(itemStyle);
}

function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
  // downplay before unselect
  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: seriesName != null ? seriesName : dataName
  }); // highlight after select

  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}

function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    api.dispatchAction({
      type: 'highlight',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    api.dispatchAction({
      type: 'downplay',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

module.exports = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var _layout = __webpack_require__(57);

var getLayoutRect = _layout.getLayoutRect;
var layoutBox = _layout.box;
var positionElement = _layout.positionElement;

var formatUtil = __webpack_require__(44);

var graphic = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */
function layout(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  positionElement(group, boxLayoutParams, viewportSize, padding);
}

function makeBackground(rect, componentModel) {
  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  var rect = new graphic.Rect({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

exports.layout = layout;
exports.makeBackground = makeBackground;

/***/ }),
/* 902 */
/***/ (function(module, exports) {


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

module.exports = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_env__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SHARE_KEY='210_H5HomeWorkShare';// 分享内链配置key
var MAX=10;var ReadWorks=function(_React$PureComponent){_inherits(ReadWorks,_React$PureComponent);function ReadWorks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReadWorks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReadWorks.__proto__||Object.getPrototypeOf(ReadWorks)).call.apply(_ref,[this].concat(args))),_this),_this.state={list:[]},_this.num=1,_this.loadMoreStatus=1,_this.starsArr=new Array(3).fill(0),_this.onScroll=function(){if(_this.loadMoreStatus!==2){return;}var _document$documentEle=document.documentElement,scrollHeight=_document$documentEle.scrollHeight,clientHeight=_document$documentEle.clientHeight;var scrollTop=document.documentElement.scrollTop||document.body.scrollTop;if(scrollTop+clientHeight>=scrollHeight-20){_this.loadMoreStatus=1;_this.getData(_this.num++);}},_this.getData=function(num){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getReadWorksList({data:{num:num,row:MAX}}).then(function(res){var list=_this.state.list;var _res$data=res.data,data=_res$data===undefined?[]:_res$data;if(data.length>=MAX){_this.loadMoreStatus=2;}else{_this.loadMoreStatus=0;}if(num===1&&data.length===0){return _this.setState({list:null});}_this.setState({list:[].concat(_toConsumableArray(list.concat(data)))});});},_this.toShare=function(stuId,courseSectionId,classSchId,star,courseDetailId,courseId,e){e.stopPropagation();__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].acClientBp({data:{project:'客户端3.12.0',type:1,pageName:'跟读作品列表',clickName:'分享',userId:stuId,courseId:courseId,courseDetailId:courseDetailId,kind:star}});__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].shareNew(Object.assign({},_this.shareParams,{type:2,shareByUrl:true,shareUrl:__WEBPACK_IMPORTED_MODULE_5__api_env__["a" /* default */].wxBaseUrl+'/h5/share-read?stuId='+stuId+'&classSchId='+classSchId+'&courseSectionId='+courseSectionId+'&star='+star+'&courseDetailId='+courseDetailId,resource:'homework'}));},_this.goDetail=function(stuId,courseSectionId,classSchId,star,courseDetailId,courseId){var wxBaseUrl=__WEBPACK_IMPORTED_MODULE_5__api_env__["a" /* default */].wxBaseUrl;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].acClientBp({data:{project:'客户端3.12.0',type:1,pageName:'跟读作品列表',clickName:'作品',userId:stuId,courseId:courseId,courseDetailId:courseDetailId,kind:star}});window.location.href=wxBaseUrl+'/h5/share-read?stuId='+stuId+'&classSchId='+classSchId+'&courseSectionId='+courseSectionId+'&star='+star+'&courseDetailId='+courseDetailId;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReadWorks,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getShareConfig({params:{key:SHARE_KEY}}).then(function(){var res=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _res$data2=res.data,data=_res$data2===undefined?{}:_res$data2;_this2.shareParams=data[SHARE_KEY];});this.getData(this.num++);window.addEventListener('scroll',this.onScroll);}},{key:'render',value:function render(){var _this3=this;var _state=this.state,loadMoreStatus=_state.loadMoreStatus,list=_state.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u8DDF\u8BFB\u4F5C\u54C1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ReadWorks'},list&&list.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'works-list'},list.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'works-model',onClick:_this3.goDetail.bind(_this3,item.stuId,item.courseSectionId,item.classSchId||0,item.starsCnt,item.courseDetailId,item.courseId)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'works-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-img',style:item.cover?{'background':'url('+item.cover+') center center / cover no-repeat'}:{}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'content-title'},item.enTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'content-desc'},item.cnTitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'works-status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'works-stars-box'},_this3.starsArr.map(function(_,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index,className:'works-stars'+(item.starsCnt>index?' active':'')});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'works-operate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'works-operate-btn',onClick:function onClick(e){return e.stopPropagation();}},item.likeCount),!__WEBPACK_IMPORTED_MODULE_2__utils_ua__["a" /* default */].winClient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'works-operate-btn',onClick:_this3.toShare.bind(_this3,item.stuId,item.courseSectionId,item.classSchId||0,item.starsCnt,item.courseDetailId,item.courseId)},'\u5206\u4EAB'))));})):null,loadMoreStatus===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'no-more'},'\u6CA1\u6709\u66F4\u591A\u4E86 ~'),list===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty-img'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F~'))));}}]);return ReadWorks;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (ReadWorks);

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BannerArticlePage1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var source=['https://oss.aircourses.com/web/client/bannerArticle/article1/img_5.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_7.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_6.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_11.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_1.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_8.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_12.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_13.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_9.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_2.png','https://oss.aircourses.com/web/client/bannerArticle/article1/img_10.png','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_7.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/img_3.png','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_1.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_2.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/img_4.png','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_3.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_4.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_5.gif','https://oss.aircourses.com/web/client/bannerArticle/article1/gif_6.gif'];function BannerArticlePage1(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BannerArticlePage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u8DDF\u54C8\u4F5B\u5916\u6559\u5B66\u82F1\u8BED\uFF01\u6BCF\u665A30\u5206\u949F\uFF0C\u517B\u6210\u82F1\u8BED\u5B66\u4E60\u597D\u4E60\u60EF\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:source[0],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u5F88\u591A\u5B69\u5B50\u4E0A\u7F51\u8BFE\u8FD8\u9700\u8981\u5168\u5BB6\u603B\u52A8\u5458\uFF0C\u7238\u7238\u5988\u5988\u76EF\u7740\u624D\u80FD\u4E0A\u3002\u800C\u54B1\u4EEC\u7231\u8BFE\u7684\u5B9D\u8D1D\u4EEC\u65E9\u5DF2\u517B\u6210',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6BCF\u665A19:30/20:00\u51C6\u65F6\u4E0A\u7231\u8BFE\uFF0C\u548C\u54C8\u4F5B\u5916\u6559\u4E00\u8D77\u5B66\u82F1\u8BED'),'\u7684\u597D\u4E60\u60EF\uFF0C\u7B80\u76F4\u90FD\u4E0D\u8981\u592A\u4F18\u79C0\uFF01\u4E3A\u5B9D\u8D1D\u4EEC\u7684\u81EA\u5F8B\u70B9\u8D5E\uFF01 \u6BCF\u592930\u5206\u949F\u7684\u8BFE\u7A0B\u8BBE\u7F6E\uFF0C365\u5929\u4E0D\u95F4\u65AD\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[1],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt12',src:source[2],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt12',src:source[3],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u4E0D\u8FC7\uFF0C\u597D\u4E60\u60EF\u7684\u517B\u6210\u4ECE\u6765\u90FD\u4E0D\u662F\u4E00\u8E74\u800C\u5C31\u7684\u3002\u4ECA\u5929\uFF0C\u5C0F\u7231\u5C31\u6765\u548C\u5927\u5BB6\u4ECB\u7ECD\u4E0B\u7231\u8BFE\u7684\u5C0F\u4F19\u4F34\u4EEC\u662F\u600E\u4E48\u517B\u6210\u81EA\u5F8B\u7684\u597D\u4E60\u60EF\u7684\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle',src:source[4],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u597D\u8001\u5E08\u5BF9\u5B69\u5B50\u7684\u5F71\u54CD\u662F\u6DF1\u8FDC\u7684\uFF0C\u9047\u5230\u81EA\u5DF1\u559C\u6B22\u7684\u8001\u5E08\uFF0C\u6BD4\u5982\u54B1\u54C8\u4F5B\u5916\u6559\u4EEC\uFF0C\u5B69\u5B50\u7684\u5B66\u4E60\u5174\u8DA3\u548C\u6548\u679C\u90FD\u4F1A\u66F4\u597D\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'AirCourse\u7231\u8BFE\u662F\u548C\u54C8\u4F5BHSA\uFF08\u54C8\u4F5B\u5927\u5B66\u5B66\u751F\u8054\u76DF\u4F1A\uFF09\u5408\u4F5C\u7684\u8BED\u57F9\u673A\u6784'),'\uFF0C\u6240\u6709\u5916\u6559\u5747\u7531\u7231\u8BFE\u4E0E\u54C8\u4F5BHSA\u8054\u5408\u7504\u9009\u57F9\u517B\uFF0C\u6C34\u5E73\u6709\u4FDD\u969C\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[5],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u76EE\u524D\uFF0C\u7231\u8BFE\u5E73\u53F0\u4E0A\u5DF2\u7ECF\u6C47\u805A\u4E86\u8BB8\u591A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4F18\u79C0\u7684\u54C8\u4F5B\u660E\u661F\u5916\u6559'),'\uFF0C\u4E0D\u4EC5\u4E13\u4E1A\u6280\u80FD\u5F3A\uFF0C\u800C\u4E14\u6DF1\u53D7\u5B69\u5B50\u4EEC\u559C\u7231\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex mt28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg1',style:{backgroundImage:'url('+source[6]+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6765\u81EA\u54C8\u4F5B\u5927\u5B66\u620F\u5267\u5A92\u4F53\u4E13\u4E1A\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Jacob\u8001\u5E08'),'\uFF0C\u56E0\u4E3A\u5176\u5BCC\u6709\u8868\u6F14\u529B\u7684\u6559\u5B66\u98CE\u683C\uFF0C\u88AB\u5927\u5BB6\u79F0\u4E3A\u201C\u620F\u7CBE\u8001\u5E08\u201D\uFF0C\u6536\u83B7\u4E86\u4E00\u7968\u5C0F\u7C89\u4E1D\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex mt12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg2',style:{backgroundImage:'url('+source[7]+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u54C8\u4F5B\u5404\u7C7B\u5956\u5B66\u91D1\u62FF\u5230\u624B\u8F6F\u7684\u8D85\u7EA7\u5B66\u9738',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Yanet\u8001\u5E08'),'\uFF0C\u5B66\u4E60\u6210\u7EE9\u4F18\u5F02\uFF0C\u4E00\u76F4\u4ECE\u4E8B\u5C11\u513F\u6559\u80B2\u5DE5\u4F5C\uFF0C\u5BF9\u5F85\u5C0F\u670B\u53CB\u6709\u4F7F\u4E0D\u5B8C\u7684\u7EDD\u62DB\uFF0C\u5927\u5BB6\u90FD\u79F0\u547C\u5979\u4E3A\u201C\u6700\u7F8E\u8001\u5E08\u201D\u3002')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u8BA9\u4E16\u754C\u4E0A\u6700\u4F1A\u5B66\u4E60\u7684\u5B66\u9738\u6559\u5A03\u5B66\u4E60\uFF0C\u4F60\u8FD8\u6709\u4EC0\u4E48\u4E0D\u653E\u5FC3\u7684\u5462\uFF01\u6B64\u5916\uFF0C\u6BCF\u4E00\u5802\u5916\u6559\u8BFE\uFF0C',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5177\u4F53\u5230\u5916\u6559\u7684\u53D1\u97F3\u3001\u8BED\u901F\u3001\u624B\u52BF\u3001\u8868\u60C5\u7B49'),'\uFF0C\u7231\u8BFE\u6559\u7814\u56E2\u961F\u90FD\u4F1A\u548C\u5916\u6559\u4EEC\u53CD\u590D\u786E\u8BA4\u3001\u6253\u78E8\uFF0C\u786E\u4FDD\u5448\u732E\u7ED9\u6700\u597D\u7684\u8BFE\u5802\u6559\u5B66\u7ED3\u679C\uFF01\u6211\u4EEC\u7684\u6559\u7814\u56E2\u961F\u4E5F\u5F88\u725B\u903C\u54E6\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[8],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u6211\u4EEC\u76F8\u4FE1\uFF0C\u8BA4\u771F\u8D1F\u8D23\u7684\u8001\u5E08\u624D\u80FD\u7ED9\u5B69\u5B50\u4EEC\u6700\u597D\u7684\u6559\u80B2\uFF0C\u4E0D\u8F9C\u8D1F\u6BCF\u5929\u51C6\u70B9\u6765\u4E0A\u8BFE\u7684\u5B9D\u8D1D\u4EEC\u5440~'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle',src:source[9],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u662FAl\u4E92\u52A8\u8BFE\uFF0C1V4\u8BFE\u5802\u7684\u3002\u8FD8\u6709',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u597D\u53CB\u7EC4\u961F\u529F\u80FD'),'\uFF0C\u53EF\u4EE5\u9080\u8BF7\u81EA\u5DF1\u7684\u5C0F\u4F19\u4F34\u4E00\u8D77\u4E0A\u8BFE\uFF0C\u8BA9\u4E0A\u8BFE\u53D8\u5F97\u5145\u6EE1\u4EEA\u5F0F\u611F\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u9664\u4E86\u53EF\u4EE5\u548C\u597D\u53CB\u4E00\u8D77\u7EC4\u961F\u4E0A\u8BFE\uFF0C\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u901A\u8FC7\u5168\u65B0\u7684\u667A\u80FD\u4E92\u52A8\u8BFE\u5802\uFF0C\u53EF\u4EE5\u6709\u6548\u5730\u63D0\u9AD8\u5B69\u5B50\u4E0A\u8BFE\u7684\u6CE8\u610F\u529B\u3001\u7ADE\u4E89\u529B\u3001\u79EF\u6781\u6027\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6BCF\u8282\u8BFE\u90FD\u662F\u4EE5\u573A\u666F\u52A8\u753B\u5F00\u59CB\u5F15\u5165\uFF0C\u5185\u5BB9\u8BBE\u7F6E\u6709\u8DA3\uFF0C\u54EA\u4E2A\u5B69\u5B50\u4E0D\u7231\u5462\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[10],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u8BFE\u5802\u8FC7\u7A0B\u4E2D\u5916\u6559\u8FD8\u4F1A\u91C7\u7528\u573A\u666F\u5F0F\u6559\u5B66\uFF0C\u9F13\u52B1\u5B69\u5B50\u5F00\u53E3\u8BF4\u82F1\u8BED\u3002',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u540C\u4F34\u7ADE\u7B54\u3001\u6E38\u620FPK'),'\u7684\u5F62\u5F0F\u6765\u6FC0\u52B1\u5B69\u5B50\uFF0C\u7B54\u5BF9\u9898\u8FD8\u53EF\u4EE5\u8D62\u5F97\u94BB\u77F3\uFF0C\u7B54\u5BF9\u7684\u8D8A\u591A\uFF0C\u53C2\u52A0\u4E92\u52A8\u8D8A\u79EF\u6781\uFF0C\u83B7\u5F97\u7684\u94BB\u77F3\u4E5F\u8D8A\u591A\uFF01\u5B69\u5B50\u5B66\u4E60\u79EF\u6781\u6027\u81EA\u7136\u5F88\u9AD8\u4E86\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[11],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle',src:source[12],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u4F5C\u4E3A\u4E00\u95E8\u82F1\u8BED\u77E5\u8BC6\u62D3\u5C55\u8BFE\uFF0C\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u6BCF\u5929\u90FD\u4F1A\u6709\u7279\u5B9A\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4E3B\u9898\u8BFE\u7A0B'),'\uFF08365\u5929\u6BCF\u5929\u4E0D\u91CD\u6837\uFF09\uFF0C\u8FD9\u4E9B\u4E3B\u9898\u8BFE\u7A0B\u5168\u90FD\u662F\u53C2\u8003\u7F8E\u56FD\u539F\u7248\u6559\u6750\u7684\uFF0C\u5185\u5BB9\u6DB5\u76D6',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u751F\u547D\u79D1\u5B66\u3001\u81EA\u7136\u5730\u7406\u3001\u4EBA\u6587\u827A\u672F\u7B49\u5404\u65B9\u9762\u767E\u79D1\u77E5\u8BC6')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[13],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u800C\u4E14\uFF0C\u8FD9\u4E9B\u4E3B\u9898\u8BFE\u7684\u5185\u5BB9\u90FD\u975E\u5E38\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5B9E\u7528\u63A5\u5730\u6C14'),'\uFF0C\u6DB5\u76D6\u5404\u79CD\u65E5\u5E38\u751F\u6D3B\u573A\u666F\u7684\u5B9E\u7528\u8BED\u53E5\u3001\u5404\u7C7B\u767E\u79D1\u77E5\u8BC6\uFF0C\u5E38\u89C1\u7684\u8282\u65E5\u3001\u6587\u5316\u7B49\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[14],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u6BCF\u5929\u90FD\u80FD\u5B66\u4E60\u5230\u65B0\u7684\u6709\u8DA3\u7684\u77E5\u8BC6\uFF0C\u4F1A\u4E0D\u65AD\u9A71\u52A8\u7740\u5B69\u5B50\u63A2\u7D22\u5B66\u4E60\uFF0C\u5B69\u5B50\u4F1A\u5F88\u671F\u5F85\u6BCF\u5929\u7684\u8BFE\u7A0B\u5185\u5BB9\uFF0C\u5B66\u4E60\u7684\u4E3B\u52A8\u6027\u5C31\u4E0A\u6765\u4E86~\u8FD9\u5927\u6982\u4FBF\u662F\u201C\u5174\u8DA3\u662F\u6700\u5927\u7684\u5B66\u4E60\u52A8\u529B\u201D\u4E86\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle',src:source[15],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u4E3A\u4E86\u80FD\u591F\u4FDD\u8BC1\u5B69\u5B50\u4EEC\u6700\u5927\u5316\u7684\u5B66\u4E60\u6548\u679C\uFF0C\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u7684\u8BFE\u7A0B\u8BBE\u8BA1\u4E5F\u662F\u76F8\u5F53\u79D1\u5B66\u7684\u54E6~',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u901A\u8FC7\u6253\u9020\u201C\u8BFE\u524D-\u8BFE\u4E2D-\u8BFE\u540E\u201D\u7684\u5B66\u4E60\u95ED\u73AF\uFF0C\u5E2E\u52A9\u5B69\u5B50\u517B\u6210\u5B66\u4E60\u7684\u6B63\u786E\u59FF\u52BF\uFF01')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u5148\u9884\u4E60\uFF0C\u518D\u542C\u8BFE\uFF0C\u518D\u590D\u4E60'),'\uFF0C\u8FD9\u6837\u7684\u5B66\u4E60\u4E60\u60EF\u517B\u6210\u540E\uFF0C\u5BF9\u5B69\u5B50\u7684\u5B66\u4E60\u4F1A\u6709\u5F88\u5927\u7684\u5E2E\u52A9~'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[16],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u7136\u540E\u662F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BFE\u5802\u76F4\u64AD\u5B66\u4E60'),'\uFF0C\u5916\u6559\u8001\u5E08\u4F1A\u901A\u8FC7\u5404\u79CD\u4E92\u52A8\u6765\u4E3A\u5B69\u5B50\u4EEC\u521B\u9020\u5F00\u53E3\u8BF4\u7684\u673A\u4F1A\uFF0C\u9F13\u52B1\u5B69\u5B50\u5F00\u53E3\u8BF4\u82F1\u8BED\uFF0C\u542C\u8BF4\u7ED3\u5408\u5E2E\u52A9\u5927\u5BB6\u52A0\u6DF1\u8BB0\u5FC6\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[17],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'30\u5206\u949F\u7684\u8BFE\u5802\u5B66\u4E60\u7ED3\u675F\u540E\uFF0C\u8FD8\u4F1A\u6709',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u8BFE\u540E\u4F5C\u4E1A\u73AF\u8282'),'\u3002\u91C7\u7528AI\u667A\u80FD\u4E92\u52A8\u6E38\u620F\u7684\u5F62\u5F0F\uFF0C\u8D81\u70ED\u6253\u94C1\u590D\u4E60\u6240\u5B66\u77E5\u8BC6\uFF0C\u8D77\u5230\u5DE9\u56FA\u52A0\u5F3A\u7684\u4F5C\u7528\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[18],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u53E6\u5916\uFF0C\u4E07\u4E00\u9519\u8FC7\u4E86\u76F4\u64AD\u8BFE\uFF0C\u7231\u8BFE\u7684',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u201C\u56DE\u653E\u201D\u529F\u80FD'),'\uFF0C\u4E5F\u80FD\u5E2E\u5927\u5BB6\u56DE\u653E\u5B66\u4E60\uFF0C\u5B66\u4E60\u4E00\u70B9\u513F\u4E0D\u803D\u8BEF~'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[19],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u201C\u8BFE\u524D-\u8BFE\u4E2D-\u8BFE\u540E\u201D\u7684\u5B8C\u7F8E\u5B66\u4E60\u95ED\u73AF\uFF0C\u52A9\u529B\u5B69\u5B50\u82F1\u8BED\u6C34\u5E73\u8E6D\u8E6D\u8E6D\u4E0A\u5347\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6700\u540E\uFF0C\u5C0F\u7231\u60F3\u8BF4\u7684\u662F\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4F18\u79C0\u5176\u5B9E\u662F\u4E00\u79CD\u4E60\u60EF\uFF0C\u4E0A\u7231\u8BFE\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\uFF0C\u517B\u6210\u81EA\u5F8B\u597D\u4E60\u60EF\uFF01\u8BA9\u6211\u4EEC\u4E00\u8D77\u5B9E\u73B0\u82F1\u8BED\u5F2F\u9053\u8D85\u8F66\uFF01')));}

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BannerArticlePage1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
var source=['https://oss.aircourses.com/web/client/bannerArticle/article2/img_5.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_4.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_11.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_12.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_1.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_6.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_13.png','https://oss.aircourses.com/web/client/bannerArticle/article2/gif_1.gif','https://oss.aircourses.com/web/client/bannerArticle/article2/img_14.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_2.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_15.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_16.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_7.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_8.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_9.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_3.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_10.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_17.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_18.png','https://oss.aircourses.com/web/client/bannerArticle/article2/img_19.png'];function BannerArticlePage1(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BannerArticlePage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u5230\u5E95\u4F18\u79C0\u5728\u54EA\u91CC\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt35',src:source[0],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u5982\u679C\u8BF4\u8BED\u8A00\u662F\u4E00\u95E8\u5DE5\u5177\uFF0C\u90A3\u4E48\u82F1\u8BED\u5219\u662F\u5F53\u4ECA\u4E16\u754C\u4E0A\u5E94\u7528\u6700\u5E7F\u6CDB\u7684\u90A3\u4E00\u4E2A\u3002\u5982\u4ECA\uFF0C\u8BA9\u81EA\u5BB6\u5A03\u4ECE\u5C0F\u5F00\u59CB\u5B66\u82F1\u8BED\u7684\u91CD\u8981\u6027\uFF0C\u5DF2\u7ECF\u662F\u8001\u751F\u5E38\u8C08\u4E86\u3002\u5230\u5E95\u5E94\u8BE5\u600E\u4E48\u9009\u8F85\u5BFC\u8BFE\uFF0C\u600E\u4E48\u6837\u7684\u8BFE\u7A0B\u624D\u662F\u6700\u9002\u5408\u81EA\u5DF1\u5B69\u5B50\uFF0C\u4E00\u5B9A\u662F\u6240\u6709\u5988\u5988\u5173\u5FC3\u7684\u95EE\u9898\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4ECA\u5929\u6211\u4EEC\u5C31\u6765\u8BF4\u8BF4 \uFF0C\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u4E3A\u4EC0\u4E48\u53D7\u90A3\u4E48\u591A\u5988\u5988\u559C\u6B22\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle mlr-auto',src:source[1],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u6BD4\u8D77\u52A8\u8F84\u6570\u4E07\u7684\u5C11\u513F\u82F1\u8BED\u8BFE\uFF0CAirCourse\u7231\u8BFE\u300A\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u300B\u7684\u4EF7\u683C\u53EF\u4EE5\u8BF4\u662F\u975E\u5E38\u7684\u7F8E\u4E3D\u4E86\uFF1A',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4E00\u5E74365\u5929\uFF0C365\u4E2A\u4E3B\u9898\u8BFE\uFF0C\u5E73\u5747\u6BCF\u8282\u8BFE\u7ADF\u7136\u4E0D\u52305\u5757\u94B1'),'\u2026\u2026\u5373\u4FBF\u662F\u7ECF\u8FC7\u91CD\u78C5\u5347\u7EA7\uFF0C\u6DA8\u4EF7\u540E\u7684\u6BCF\u8282\u8BFE\u4F9D\u65E7\u53EA\u8981\u4E0D\u523010\u5757\u94B1\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u4E0D\u523010\u5757\u94B1\uFF0C\u8FD8\u4E0D\u591F\u4E70\u4E00\u676F\u5976\u8336\uFF0C\u4F46\u662F\u5374\u80FD\u8BA9\u5B69\u5B50\u5B66\u4E60\u7531\u54C8\u4F5B\u5916\u6559\u6559\u6388\u7684\u7CBE\u54C1\u8BFE\u7A0B\uFF0C\u7B80\u76F4\u4E0D\u8981\u592A\u5212\u7B97\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5BB6\u957F\u4EEC\u4E00\u5B9A\u8981\u60F3\uFF0C\u8FD9\u4E48\u4FBF\u5B9C\u7ADF\u7136\u80FD\u542C\u5230\u54C8\u4F5B\u5916\u6559\u7684\u8BFE\uFF0C\u9760\u8C31\u561B\uFF1F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[2],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'AirCourse\u7231\u8BFE\u662F\u76EE\u524D\u552F\u4E00\u4E00\u5BB6\u76F4\u63A5\u548C\u54C8\u4F5BHSA\uFF08\u54C8\u4F5B\u5927\u5B66\u5B66\u751F\u8054\u76DF\u4F1A\uFF09\u5408\u4F5C\u7684\u8BED\u57F9\u673A\u6784'),'\uFF0C\u6240\u6709\u5916\u6559\u5747\u7531\u7231\u8BFE\u4E0E\u54C8\u4F5BHSA\u8054\u5408\u7504\u9009\u57F9\u517B\uFF0C\u7D20\u8D28\u6760\u6760\u6EF4~'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[3],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle mlr-auto',src:source[4],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u300A\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u300B\u7684\u8BFE\u7A0B\u5185\u5BB9\u5305\u62EC365\u4E2A\u4E3B\u9898\u8BFE\u7A0B\uFF0C\u6DB5\u76D6\u751F\u547D\u79D1\u5B66\u3001\u81EA\u7136\u5730\u7406\u3001\u97F3\u4E50\u6587\u5316\u3001\u54F2\u5B66\u5B97\u6559\u3001\u4EBA\u6587\u827A\u672F\u7B49\u5168\u65B9\u4F4D\u7684\u767E\u79D1\u77E5\u8BC6\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[5],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:''},'\u540C\u65F6\uFF0CAirCourse\u7231\u8BFE\u6839\u636E\u4E0D\u540C\u5E74\u9F84\u6BB5\u5B69\u5B50\u8BA4\u77E5\u57FA\u7840\u3001\u5B66\u4E60\u80FD\u529B\u7B49\u65B9\u9762\u4E0D\u540C\uFF0C\u7814\u53D1\u4E862\u5957\u8BFE\u7A0B\u53EF\u4F9B\u5BB6\u957F\u4EEC\u9009\u62E9\uFF0C\u5E76\u4E14\u53EF\u4EE5\u968F\u65F6\u5207\u6362\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'L0\u542F\u8499\u8BFE\uFF1A\u9002\u54081\u5E74\u4EE5\u4E0B\u82F1\u8BED\u57FA\u7840\u7684\u5B9D\u8D1D\u5B66\u4E60\u3002'),'\u8BFE\u7A0B\u77E5\u8BC6\u96BE\u5EA6\u76F8\u5BF9\u7B80\u5355\uFF0C\u6D89\u53CA\u7B80\u5355\u7684\u8BCD\u6C47\u53CA\u57FA\u7840\u53E5\u578B\uFF0C\u8BA9\u5B9D\u8D1D\u5728\u5B66\u4E60\u82F1\u8BED\u7684\u8FC7\u7A0B\u4E2D\u4E86\u89E3\u4E16\u754C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[6],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u751F\u6D3B\u5316\u7684\u573A\u666F\u53CA\u5185\u5BB9\uFF0C\u66F4\u5BB9\u6613\u6FC0\u53D1\u5B9D\u8D1D\u7684\u5B66\u4E60\u5174\u8DA3\uFF0C\u4E5F\u80FD\u591F\u8BA9\u5B9D\u8D1D\u7684\u5E94\u7528\u80FD\u529B\u5927\u5927\u63D0\u5347\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[7],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'L1\u62D3\u5C55\u8BFE\uFF1A\u9002\u5408\u67091-2\u5E74\u82F1\u8BED\u57FA\u7840\u7684\u5B9D\u8D1D\u5B66\u4E60\u3002'),'\u8BFE\u7A0B\u6D89\u53CA\u8BCD\u6C47\u91CF\u8F83\u5927\uFF0C\u53E5\u578B\u4E30\u5BCC\uFF0C\u6BD4\u8F83\u9002\u5408\u5DF2\u6709\u4E00\u5B9A\u82F1\u8BED\u57FA\u7840\u7684\u5B9D\u8D1D\u8FDB\u884C\u77E5\u8BC6\u62D3\u5C55\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[8],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u4E86\u89E3\u7684\u77E5\u8BC6\u8D8A\u591A\uFF0C\u624D\u80FD\u8D70\u5F97\u66F4\u8FDC\u3002'),'\u76F8\u4FE1\u4E0D\u5C11\u5B9D\u7238\u5B9D\u5988\u90FD\u53D1\u73B0\u4E86\u4E00\u4E2A\u95EE\u9898\uFF1A\u5B9D\u8D1D\u77E5\u9053\u718A\u732B\u7684\u201C\u82F1\u6587\u540D\u201D\u662FPanda\uFF0C\u4F46\u5374\u4E0D\u4E86\u89E3\u718A\u732B\u7684\u751F\u6D3B\u4E60\u6027\uFF1B\u5B9D\u8D1D\u77E5\u9053\u4E86Halloween\uFF0C\u5374\u4E0D\u4E86\u89E3\u8FD9\u4E2A\u8282\u65E5\u80CC\u540E\u7684\u6587\u5316\u5185\u6DB5\u2026\u2026'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5982\u679C\u5B9D\u8D1D\u53EA\u5B66\u4F1A\u4E86\u5355\u8BCD\u3001\u53E5\u5F0F\uFF0C\u5374\u4E0D\u4E86\u89E3\u80CC\u540E\u7684\u77E5\u8BC6\uFF0C\u90A3\u5B66\u5230\u7684\u8BED\u8A00\u80FD\u529B\u5C31\u53EA\u662F\u505C\u7559\u5728\u8868\u5C42\u4E0A\uFF0C\u65E0\u6CD5\u5B8C\u6210\u4F18\u79C0\u7684\u4E0E\u4E16\u754C\u3001\u4ED6\u4EBA\u5BF9\u8BDD\u7684\u80FD\u529B\u3002\u6211\u4EEC\u4E0D\u4EC5\u8981\u8BA9\u5B69\u5B50\u5B66\u4E60\u57FA\u672C\u7684\u8BED\u6CD5\uFF0C\u66F4\u8981\u6CE8\u91CD\u77E5\u8BC6\u62D3\u5C55\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle mlr-auto',src:source[9],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u300A\u54C8\u4F5B\u5916\u6559\u767E\u79D1\u82F1\u8BED\u300B\u91C7\u7528',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7EBF\u4E0AAI\u667A\u80FD\u8BFE\u5802+\u54C8\u4F5B\u5916\u6559\u76F4\u64AD\u7684\u5F62\u5F0F\u6388\u8BFE'),'\uFF0C\u4E0EAI\u7ED3\u5408\u53EF\u80FD\u662F\u65F6\u4E0B\u6700\u6D41\u884C\u7684\u82F1\u8BED\u5B66\u4E60\u65B9\u5F0F\uFF0C\u8BFE\u7A0B\u8BBE\u7F6E\u4E5F\u662F\u4EAE\u70B9\u9887\u591A\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u5728\u4E0A\u8BFE\u524D\uFF0C\u5C0F\u670B\u53CB\u4EEC\u53EF\u4EE5\u81EA\u884C\u9884\u4E60\u8BFE\u7A0B\uFF1AL0\u8BFE\u7A0B\u7684\u9884\u4E60\u5F62\u5F0F\u662F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u7ED8\u672C\u9605\u8BFB'),'\uFF0C\u53EF\u4EE5\u6839\u636E\u9700\u6C42\u9009\u62E9\u4E0D\u540C\u7684\u5B57\u5E55\uFF1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[10],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'L1\u8BFE\u7A0B\u7684\u9884\u4E60\u5F62\u5F0F\u662F',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u89C6\u9891\u5C0F\u8BFE'),'\uFF0C\u6709\u8001\u5E08\u6F14\u793A\u8BB2\u89E3\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[11],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'\u6BCF\u665A19:30/20:00\uFF0C\u54C8\u4F5B\u5916\u6559\u4F1A\u51C6\u65F6\u8FDB\u884C\u534A\u5C0F\u65F6\u7684\u76F4\u64AD\u6559\u5B66\uFF0C\u4E0A\u8BFE\u7684\u5C0F\u670B\u53CB\u4F1A\u88AB\u667A\u80FD\u5339\u914D\u52304\u4EBA\u5C0F\u73ED\u8BFE\u5802\u3002'),'\u73B0\u5728\uFF0C\u5C0F\u670B\u53CB\u4EEC\u4E5F\u53EF\u4EE5\u81EA\u884C\u9080\u8BF7\u5B66\u4F34\u7EC4\u961F\u5B66\u4E60\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[12],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u8BFE\u5802\u5F62\u5F0F\u7684\u4EAE\u70B9\u4E3B\u8981\u5728\u4E8E\u5916\u6559\u4E13\u4E1A\u6027\u3001\u4EBA\u673A\u4E92\u52A8\u6027\u5F3A\u4EE5\u53CAPK\u5B66\u4E60\u6C1B\u56F4\u6D53\u539A\u3002\u5531\u6B4C\u3001\u62C9\u5C0F\u63D0\u7434\u3001\u89D2\u8272\u626E\u6F14\u2026\u2026\u53EA\u8981\u662F\u4E0E\u8BFE\u7A0B\u5185\u5BB9\u76F8\u5173\uFF0C\u80FD\u591F\u5438\u5F15\u5C0F\u670B\u53CB\u5B66\u4E60\u5174\u8DA3\u7684\uFF0C\u54C8\u4F5B\u5916\u6559\u4EEC\u90FD\u79EF\u6781\u5C1D\u8BD5\uFF0C\u5C55\u73B0\u4E00\u4E2A\u9C9C\u6D3B\u7684\u8001\u5E08\u5F62\u8C61\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[13],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'AI\u8BFE\u5802\u7684\u4EBA\u673A\u4E92\u52A8\u4E5F\u662F\u5341\u5206\u91CD\u8981\u7684\u529F\u80FD\u3002\u8BFE\u7A0B\u5185\u5BB9\u4E2D\u7A7F\u63D2\u6E38\u620FPK\uFF0C\u56DE\u7B54\u95EE\u9898\u5F97\u94BB\u77F3\u7684\u73AF\u8282\uFF0C\u80FD\u591F\u6FC0\u53D1\u5B69\u5B50\u7684\u7ADE\u4E89\u610F\u8BC6\uFF0C\u4E0A\u8BFE\u66F4\u52A0\u4E13\u6CE8\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[14],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'imgTitle mlr-auto',src:source[15],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'2018\u5E74\uFF0C\u7231\u8BFE\u65A9\u83B7\u4E86\u817E\u8BAF\u7F51\u9881\u53D1\u7684\u201C2018\u5E74\u5EA6\u77E5\u540D\u5C11\u513F\u82F1\u8BED\u54C1\u724C\u201D\u3001\u5988\u5988\u7F51\u5E74\u5EA6\u53E3\u7891\u738B\u5956\u9879\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[16],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'2019\u5E7411\u6708\uFF0C\u7231\u8BFE\u65A9\u83B7\u56FD\u5BB6\u521B\u65B0\u521B\u4E1A\u5927\u8D5B\u5168\u56FD\u94F6\u5956\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[17],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'2019\u5E7412\u6708\uFF0C\u7231\u8BFE\u53C8\u65A9\u83B7\u201C\u7F51\u6613\u91D1\u7FFC\u5956\u5E74\u5EA6\u5BB6\u957F\u4FE1\u8D56\u5C11\u513F\u82F1\u8BED\u54C1\u724C\u201D\u884C\u4E1A\u5927\u5956\uFF01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[18],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u6B64\u5916\uFF0C\u7231\u8BFE\u8FD8\u4F5C\u4E3A\u5168\u7403\u8303\u56F4\u5185\u552F\u4E00\u53D7\u9080\u7684\u5C11\u513F\u82F1\u8BED\u54C1\u724C\u8D74\u745E\u58EB\u53C2\u52A0\u4E86\u6709\u201C\u6559\u80B2\u754C\u5965\u6797\u5339\u514B\u201D\u4E4B\u79F0\u76842019\u5E74\u5168\u7403\u6559\u80B2\u9886\u8896\u5CF0\u4F1A\uFF0C\u4E0E\u4F17\u591A\u6559\u80B2\u5927\u725B\u4EA4\u6D41\u5408\u4F5C\u3002'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'mt28',src:source[19],alt:'\u7231\u8BFEAirCourse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mt28'},'\u597D\u8001\u5E08\uFF0C\u597D\u8BFE\u7A0B\uFF0C\u597D\u5E73\u53F0\uFF0C\u5728\u672A\u6765\uFF0C\u6211\u4EEC\u8FD8\u5C06\u521B\u9020\u66F4\u591A\u9002\u5408\u4E2D\u56FD\u5C0F\u670B\u53CB\u4EEC\u7684\u4F18\u8D28\u8BFE\u7A0B\uFF01'));}

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countBtn__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_icon_tan_png__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_icon_tan_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_icon_tan_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_tools__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var acTips=["已购课程、钻石、成就等信息","个人资料及订单信息","学习记录、上课记录等相关信息"];var pdTips=["已购课程、奖杯、熊猫币等信息","个人资料及订单信息","学习记录、上课记录等相关信息"];var Logoff=function(_React$PureComponent){_inherits(Logoff,_React$PureComponent);function Logoff(props){_classCallCheck(this,Logoff);var _this=_possibleConstructorReturn(this,(Logoff.__proto__||Object.getPrototypeOf(Logoff)).call(this,props));_initialiseProps.call(_this);var queryObj=Object(__WEBPACK_IMPORTED_MODULE_9__utils_tools__["g" /* parseQuery */])(props.location.search.slice(1));_this.state={step:0,// 0 注销提示页面 1 注销发送验证码
active:true,codeText:'获取验证码',smsCode:"",appType:queryObj.apptype,tips:queryObj.apptype==='ac'?acTips:pdTips};var data=__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].getClientDataSync({data:['phone']})||'{"phone": "00110011099"}';console.log(data,'===');_this.clientData=JSON.parse(data);return _this;}_createClass(Logoff,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_6__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_6__api_web__["a" /* apiCancel */])('alertViewBack');}},{key:'render',value:function render(){var _state=this.state,step=_state.step,active=_state.active,codeText=_state.codeText,smsCode=_state.smsCode,tips=_state.tips;var phone=this.clientData.phone;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u8D26\u53F7\u6CE8\u9500'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-logoff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'375px',margin:'0 auto'}},step===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon',src:__WEBPACK_IMPORTED_MODULE_3__static_images_icon_tan_png___default.a,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-1 mt20 mb40 center'},'\u6CE8\u9500\u540E\u4EE5\u4E0B\u8D26\u53F7\u4FE1\u606F\u5C06\u88AB\u6E05\u7A7A\u4E14\u65E0\u6CD5\u627E\u56DE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'230px',margin:'0 auto'}},tips.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-2',key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-3'},'\u4E3A\u4E86\u9632\u6B62\u60A8\u91CD\u8981\u7684\u5B66\u4E60\u8BB0\u5F55\u4E22\u5931\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'60px 36px 100px 36px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-4'},'\u8D26\u53F7\uFF1A',phone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{maxLength:6,type:'tel',className:'input-code',placeholder:'\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801',value:smsCode,onChange:this.codeChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'code-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__countBtn__["a" /* default */],{type:'code',ref:'countBtn',num:60,onEnd:this.timeEnd,onStart:this.timeStart,isActive:true},codeText))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-1 mt74 mb20'},'\u4E3A\u4E86\u9632\u6B62\u60A8\u91CD\u8981\u7684\u5B66\u4E60\u8BB0\u5F55\u4E22\u5931\uFF0C\u8BF7\u8BA4\u771F\u9605\u8BFB\u4EE5\u4E0B\u5185\u5BB9\uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u5982\u679C\u60A8\u5728\u6CE8\u9500\u540E\uFF0C\u60A8\u7684\u8D26\u53F7\u4FE1\u606F\u4F1A\u88AB\u7CFB\u7EDF\u81EA\u52A8\u6E05\u9664')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'con-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u6CE8\u9500\u540E\u8D26\u53F7\u4FE1\u606F\u5C06\u4F1A\u65E0\u6CD5\u6062\u590D\uFF0C\u8BF7\u60A8\u8C28\u614E\u64CD\u4F5C'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__countBtn__["a" /* default */],{onClick:this.handleSubmit,isActive:active,num:30},step===0?'继续注销':'确认注销'))));}}]);return Logoff;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleSubmit=function(){var _state2=_this2.state,step=_state2.step,appType=_state2.appType;var params={content:'你是真的想要狠心的注销账号呢？还是仅仅要退出APP？',confirm:'退出APP',cancel:'注销账号',id:'H5_1002'};if(step===1){params={content:appType==='ac'?'确定要注销吗？注销后你的账号信息会被系统自动清除，且账号无法再次在爱课AirCourse使用':'确定要注销么？注销后您的账号信息会被系统自动清除，且账号无法再次在爱课精品小班使用',confirm:'确认注销',cancel:'再想想',id:'H5_1002'};}__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].alertView(params);// 本地模拟客户端回调
// this.alertViewBack(JSON.stringify({select: 'cancel', id: 'H5_1002'}));
};this.alertViewBack=function(str){var data=JSON.parse(str);var select=data.select,id=data.id;var step=_this2.state.step;if(id==='H5_1002'){if(select==='confirm'){if(step===0){// 选择退出APP
__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].toClientLogin();}if(step===1){// 注销账号 - 确认注销
_this2.handleWriteOff();}}if(select==='cancel'){if(step===0){// 选择注销账号
_this2.setState({step:1,active:false});}}}};this.timeEnd=function(){_this2.setState({codeText:'获取验证码'});};this.timeStart=function(){_this2.setState({codeText:''});var phone=_this2.clientData.phone;var appType=_this2.state.appType;if(appType==='ac'){__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].smsCode({data:{phone:phone,type:1}},_this2.timeStartCallBack);}else{__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].smsCodePd({data:{phone:phone,type:2,signType:1}},_this2.timeStartCallBack);}};this.timeStartCallBack=function(res,err){if(err){__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:err.errorMessage});_this2.setState({codeText:'获取验证码'});_this2.refs.countBtn.clearTimer();}else{__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:'验证码已发送'});}};this.codeChange=function(e){var active=_this2.state.active;var value=e.target.value;if(value&&!/^\d+$/.test(value))return;_this2.value=value.trim();_this2.setState({smsCode:value});if(_this2.value&&_this2.value.length===6){!active&&_this2.setState({active:true});}else{active&&_this2.setState({active:false});}};this.handleWriteOff=function(){var phone=_this2.clientData.phone;var _state3=_this2.state,smsCode=_state3.smsCode,appType=_state3.appType;if(appType==='ac'){__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].writeOff({data:{phone:phone,smsCode:smsCode}},_this2.handleWriteOffCallback);}else{__WEBPACK_IMPORTED_MODULE_8__api_axios__["a" /* default */].writeOffPd({data:{phone:phone,smsCode:smsCode}},_this2.handleWriteOffCallback);}};this.handleWriteOffCallback=function(res,err){if(err)__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:err.errorMessage});else{__WEBPACK_IMPORTED_MODULE_4__api_client__["a" /* default */].toClientLogin();}};};/* harmony default export */ __webpack_exports__["a"] = (Logoff);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CountBtn=function(_React$PureComponent){_inherits(CountBtn,_React$PureComponent);function CountBtn(props){_classCallCheck(this,CountBtn);var _this=_possibleConstructorReturn(this,(CountBtn.__proto__||Object.getPrototypeOf(CountBtn)).call(this,props));_this.startTimer=function(num,cb){_this.setState({num:num});_this.timer=setInterval(function(){_this.setState(function(preState){console.log('==',preState);if(preState.num-1<=0){clearInterval(_this.timer);typeof cb==='function'&&cb();}return{num:preState.num-1};});},1000);};_this.clearTimer=function(){clearInterval(_this.timer);_this.setState({num:0});};_this.click=function(){var _this$props=_this.props,onClick=_this$props.onClick,isActive=_this$props.isActive,type=_this$props.type,onEnd=_this$props.onEnd,n=_this$props.num,onStart=_this$props.onStart;var num=_this.state.num;if(type==='code'){if(num<=0){typeof onStart==='function'&&onStart();_this.startTimer(n,onEnd);}return;}if(num<=0&&isActive){typeof onClick==='function'&&onClick();}};_this.state={num:0};return _this;}_createClass(CountBtn,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,type=_props.type,num=_props.num;type!=='code'&&this.startTimer(num);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.timer);}},{key:'render',value:function render(){var _props2=this.props,children=_props2.children,isActive=_props2.isActive,type=_props2.type;var num=this.state.num;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'count-btn'+(num<=0&&isActive?' active':'')+' '+(type?type:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn',onClick:this.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,children,num?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'\uFF08',num,'s\uFF09'):null)));}}]);return CountBtn;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (CountBtn);;

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Manage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_less__);
function Manage(props){var queryObj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["g" /* parseQuery */])(props.location.search.slice(1));// ac：爱课app  pd：爱课精品小班
var appType=queryObj.apptype||'ac';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,{title:'\u8D26\u53F7\u7BA1\u7406'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'account-manage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'item',to:'./logoff?appType='+appType},'\u8D26\u53F7\u6CE8\u9500'))));}

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_arrow_top_png__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_images_arrow_top_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_images_arrow_top_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_common_nothing_png__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_images_common_nothing_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_images_common_nothing_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ua__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_web__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_client__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_less__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_toast__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassRegularPlan=function(_Component){_inherits(ClassRegularPlan,_Component);function ClassRegularPlan(props){_classCallCheck(this,ClassRegularPlan);var _this=_possibleConstructorReturn(this,(ClassRegularPlan.__proto__||Object.getPrototypeOf(ClassRegularPlan)).call(this,props));_this.handleSubmit=function(){var _this$state=_this.state,currentPlanId=_this$state.currentPlanId,currentClassTableId=_this$state.currentClassTableId,plans=_this$state.plans;if(currentPlanId===_this.originalPlanId&&currentClassTableId===_this.originalTableId){__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:'计划与当前一致，无需重复提交'});return;}if(!plans||!plans.length){return;}var params={title:'确定修改学习计划',content:'您正在提交新的学习计划',confirm:'确定',cancel:'取消',id:'H5_1002'};__WEBPACK_IMPORTED_MODULE_7__api_client__["a" /* default */].alertView(params);// 本地模拟客户端回调
// this.alertViewBack(JSON.stringify({select: 'confirm', id: 'H5_1002'}));
};_this.alertViewBack=function(str){var data=JSON.parse(str);var select=data.select;if(select==='confirm'){_this.updateClassPlan();}};_this.choosePlan=function(item){_this.setState({currentPlanId:item.id,currentPlanName:item.name,classRegularTable:item.classRegularTable,currentClassTableId:item.classRegularTable[0].id,currentClassTableName:'课表1',classTable:_this.normalizeClassTable(item.classRegularTable[0].classTable)});};_this.chooseClassTable=function(item,index){_this.setState({currentClassTableId:item.id,currentClassTableName:'\u8BFE\u8868'+(index+1),classTable:_this.normalizeClassTable(item.classTable)});};_this.state={isMobile:__WEBPACK_IMPORTED_MODULE_5__utils_ua__["a" /* default */].mobileClient,currentPlanId:-1,// 当前选择的学习计划id
currentPlanName:'',// 当前选择的学习计划名称
plans:[],// 学习计划列表
classRegularTable:[],// 学习计划对应的课表列表
currentClassTableId:-1,// 当前选择的课表id
currentClassTableName:'',// 当前选择的课表名称
classTable:[],effectType:-1,// 0-立即生效 1-隔日生效 2-次周生效
changeValidDivisionTime:'',isLoading:true};return _this;}_createClass(ClassRegularPlan,[{key:'componentDidMount',value:function componentDidMount(){var queryObj=Object(__WEBPACK_IMPORTED_MODULE_8__utils_tools__["g" /* parseQuery */])(this.props.location.search.slice(1));this.courseId=queryObj.courseid||'';this.getClassPlan();Object(__WEBPACK_IMPORTED_MODULE_6__api_web__["b" /* apiDefine */])({apiName:'alertViewBack',fn:this.alertViewBack});}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_6__api_web__["a" /* apiCancel */])('alertViewBack');}},{key:'getClassPlan',value:function getClassPlan(){var _this2=this;__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].getClassPlan({data:{courseId:this.courseId}},function(res,err){if(err)__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:err.errorMessage});if(res&&res.list){var list=res.list,effectType=res.effectType,changeValidDivisionTime=res.changeValidDivisionTime;list.forEach(function(item){if(item.isSelectPlan){_this2.originalPlanId=item.id;}});var defaultPlan=list.find(function(item){return item.isSelectPlan;});// 默认选中的学习计划
if(defaultPlan){// 保存原始的学习计划id和课表id，用于修改时校验
_this2.originalPlanId=defaultPlan.id;var defaultTableIndex=defaultPlan.classRegularTable?defaultPlan.classRegularTable.findIndex(function(item){return item.isSelectPlan;}):null;if(defaultTableIndex>-1){var defaultTable=defaultPlan.classRegularTable[defaultTableIndex];_this2.originalTableId=defaultTable.id;_this2.setState({effectType:effectType,changeValidDivisionTime:changeValidDivisionTime,currentClassTableId:_this2.originalTableId,currentClassTableName:'\u8BFE\u8868'+(defaultTableIndex+1),currentPlanId:_this2.originalPlanId,currentPlanName:defaultPlan.name,plans:list,classRegularTable:defaultPlan.classRegularTable,classTable:_this2.normalizeClassTable(defaultTable.classTable)});}}else{console.error('找不到默认学习计划');_this2.setState({plans:list,effectType:effectType,changeValidDivisionTime:changeValidDivisionTime});_this2.choosePlan(list[0]);}}_this2.setState({isLoading:false});});}},{key:'updateClassPlan',value:function updateClassPlan(){var _this3=this;var _state=this.state,currentClassTableId=_state.currentClassTableId,currentPlanId=_state.currentPlanId;__WEBPACK_IMPORTED_MODULE_4__api_axios__["a" /* default */].updateClassPlan({data:{courseId:this.courseId,classRegularTableId:currentClassTableId}},function(res,err){if(err){__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:err.errorMessage});return;}_this3.originalTableId=currentClassTableId;_this3.originalPlanId=currentPlanId;__WEBPACK_IMPORTED_MODULE_10__utils_toast__["a" /* default */].info({text:'修改成功'});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_7__api_client__["a" /* default */].closeH5Page({reason:"closeSafe"});},2000);});}},{key:'normalizeClassTable',// 将接口返回的课表处理成需要展示的格式
value:function normalizeClassTable(lists){var result=[];lists.forEach(function(item,index){var duplicateWeek=result.find(function(v){return v.weekDay===item.weekDay;});if(duplicateWeek){++duplicateWeek.count;duplicateWeek.startTimes.push(item.startTime);duplicateWeek.endTimes.push(item.endTime);}else{result.push({weekDay:item.weekDay,count:1,startTimes:[item.startTime],endTimes:[item.endTime]});}});result=result.map(function(item){item.startTimes=item.startTimes.sort();item.endTimes=item.endTimes.sort();return item;});return result;}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,isLoading=_state2.isLoading,plans=_state2.plans,currentPlanId=_state2.currentPlanId,classRegularTable=_state2.classRegularTable,currentClassTableId=_state2.currentClassTableId,isMobile=_state2.isMobile,classTable=_state2.classTable,currentClassTableName=_state2.currentClassTableName,currentPlanName=_state2.currentPlanName,effectType=_state2.effectType,changeValidDivisionTime=_state2.changeValidDivisionTime;var hasPlan=plans&&plans.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u5B66\u4E60\u8BA1\u5212'},isLoading?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'class-regular-plan-wrapper '+(!isMobile?'pc':'')},hasPlan?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'common-title'},'\u5B66\u4E60\u8BA1\u5212'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'common-grid'},plans.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,onClick:function onClick(){return _this4.choosePlan(item);},className:'common-item '+(currentPlanId===item.id&&'active')},item.name.length>4?item.name.slice(0,4)+'...':item.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'common-title common-title-table'},'\u8BFE\u8868\u8BA1\u5212'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'common-grid'},classRegularTable.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item.id,className:'common-item '+(currentClassTableId===item.id&&'active'),onClick:function onClick(){return _this4.chooseClassTable(item,index);}},'\u8BFE\u8868'+(index+1));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'class-table-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__static_images_arrow_top_png___default.a,className:'arrow',alt:''}),currentPlanName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'class-table-title'},currentPlanName,'-',currentClassTableName):null,classTable.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'class-table-item',key:item.weekDay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'class-item-week'},__WEBPACK_IMPORTED_MODULE_11__constants__["c" /* WEEK */][item.weekDay],' \uFF1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'class-item-content'},'\u5F00\u8BFE',item.count,'\u8282 \u2014 ',item.startTimes.join('、'),'\u4E0A\u8BFE'));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'empty-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__static_images_common_nothing_png___default.a,className:'empty-img',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'empty-text'},'\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-btn-wrap'},hasPlan?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-tip'},effectType===0||effectType===1?changeValidDivisionTime+'\u524D\u66F4\u6539\u4E0A\u8BFE\u65F6\u95F4\uFF0C\u5F53\u65E5\u751F\u6548\uFF1B'+changeValidDivisionTime+'\u540E\u66F4\u6539\uFF0C\u6B21\u65E5\u751F\u6548':effectType===2?'更新学习计划后，次周生效新课表':''):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-btn '+(!hasPlan&&'disabled'),onClick:this.handleSubmit},'\u786E\u5B9A\u5B66\u4E60\u8BA1\u5212')))));}}]);return ClassRegularPlan;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClassRegularPlan);

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAWCAYAAAChWZ5EAAAB2ElEQVRIS8WUPW5aQRSFzxk75vEYsBvEBtxbQlTxAlC8B1tKnxJWYdcpU8AeYrEAp0JI6dmABYUNw2Mg9twoxCEhfry/UZRp5845n0YzH/GfF336RURPp1PW6/V50ZxCACJyOI/sRwDvSQqITzoofSD5lBekEMAsstcQ6eyUkTe1MOj+cwBjbVscPouI+rOMpKPChQ6CQR6IXDdgjDQcl18BNuJL5F5J+Uxr3meFyAwgIjTR6lYg7aRwggMdlt5t3kaGlRnARLbjRK4zZEKRXR0GN1lmMwE8LNatAzzfCXCUMXT9jIPzk8rRMG0+FWAymVRLFT2C4DQtbPdXYLxamGaaI1IBZtGqB3GXucp/DVP1a2HpKvnNJOya5fLSOfQKlb8cUgpXulzu78vYewOP1p7ySUYgqj4AEMzlkM3jIBjH5cQCiMibeWS/AGh5lf8+PKyGwVuS3/7OiwWIVa0vyR5VvwJ4NLat1GvV+vfTOYeLY72r6h0AY0zDUSWo1hfjh6rdmdZ6q+otwE/V2lsBElXri0BgoMNgq+otwCyyHWRUrS8EyG7tRdUbgIfFoqWg7pBRtd4AwNrBnZ9UKkNuVBvqEZBTtf4U41VkmpxFyx4ExVTrC0H0vwNuDLZmZwrq4QAAAABJRU5ErkJggg=="

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organization_less__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__organization_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__organization_less__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 第二教室APP - 机构介绍
var Organization=function(_React$Component){_inherits(Organization,_React$Component);function Organization(props){_classCallCheck(this,Organization);var _this=_possibleConstructorReturn(this,(Organization.__proto__||Object.getPrototypeOf(Organization)).call(this,props));_this.handleSelect=function(){var history=_this.props.history;history.push({pathname:__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* COURSE_URL */]+'/lesson2/org-select',search:'?channelId='+_this.channelId});};var queryObj=Object(__WEBPACK_IMPORTED_MODULE_3__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));// 优先取切换后的channelId
if(sessionStorage.getItem("selectChannelId")){_this.channelId=sessionStorage.getItem("selectChannelId");}else{_this.channelId=queryObj.channelid;}_this.state={name:'',// 名称
logoUrl:'',// logo图片
description:'',// 描述
picUrls:[],// 介绍图片
changeStatus:0// 切换状态 0-不可切换 1-可切换
};return _this;}_createClass(Organization,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_2__api_axios__["a" /* default */].getOrgInfo(this.channelId,function(res,err){if(err){console.log(err);}else{_this2.setState({name:res.name||'',logoUrl:res.logoUrl||'',description:res.description||'',picUrls:res.picUrls||[],changeStatus:res.changeStatus||0});}});}},{key:'render',value:function render(){var _state=this.state,name=_state.name,logoUrl=_state.logoUrl,description=_state.description,picUrls=_state.picUrls,changeStatus=_state.changeStatus;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:'\u673A\u6784\u4E2D\u5FC3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'organization-wrap'},logoUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:logoUrl,alt:'',className:'organization-logo'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'organization-name'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'organization-desc'},description),picUrls.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item,alt:'',className:'organization-img',key:item});}),!!changeStatus&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'organization-select-btn',onClick:this.handleSelect},'\u5207\u6362\u673A\u6784')));}}]);return Organization;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Organization);

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orgSelect_less__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orgSelect_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orgSelect_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_tools__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_toast__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 第二教室APP - 机构介绍
var OrgSelect=function(_React$Component){_inherits(OrgSelect,_React$Component);function OrgSelect(props){_classCallCheck(this,OrgSelect);var _this=_possibleConstructorReturn(this,(OrgSelect.__proto__||Object.getPrototypeOf(OrgSelect)).call(this,props));_this.handleSelect=function(item){__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].changeOrg({data:{channelId:item.channelId}},function(res,err){if(err){__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:err.errorMessage});}else{sessionStorage.setItem("selectChannelId",item.channelId);_this.handleBack();}});};_this.handleBack=function(){_this.props.history.goBack();};_this.state={lists:[]};var queryObj=Object(__WEBPACK_IMPORTED_MODULE_4__utils_tools__["g" /* parseQuery */])(window.location.search.slice(1));_this.channelId=queryObj.channelid;return _this;}_createClass(OrgSelect,[{key:"componentDidMount",value:function componentDidMount(){this.getOrgList();}},{key:"getOrgList",value:function getOrgList(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3__api_axios__["a" /* default */].getOrgList({},function(res,err){if(err){__WEBPACK_IMPORTED_MODULE_5__utils_toast__["a" /* default */].info({text:err.errorMessage});}else{_this2.setState({lists:res});}});}},{key:"render",value:function render(){var _this3=this;var lists=this.state.lists;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:"\u673A\u6784\u4E2D\u5FC3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"org-select-wrap"},lists.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"org-list",onClick:function onClick(){return _this3.handleSelect(item);},key:item.channelId},item.logoUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:item.logoUrl,alt:"",className:"org-logo"}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"org-name"},item.name),item.isSelect===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"org-current"},"\u5F53\u524D"):null);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"back-btn",onClick:this.handleBack},"\u8FD4\u56DE")));}}]);return OrgSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (OrgSelect);

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

/*! eruda v2.4.1 https://eruda.liriliri.io/ */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.eruda=e():t.eruda=e()}(window,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/assets/",n(n.s=30)}([function(t,e,n){"use strict";(function(t,r,i){n.d(e,"W",(function(){return $})),n.d(e,"T",(function(){return j})),n.d(e,"P",(function(){return S})),n.d(e,"V",(function(){return T})),n.d(e,"db",(function(){return D})),n.d(e,"U",(function(){return L})),n.d(e,"ub",(function(){return q})),n.d(e,"s",(function(){return W})),n.d(e,"u",(function(){return Q})),n.d(e,"v",(function(){return J})),n.d(e,"w",(function(){return Y})),n.d(e,"x",(function(){return Z})),n.d(e,"zb",(function(){return tt})),n.d(e,"B",(function(){return et})),n.d(e,"D",(function(){return ot})),n.d(e,"kb",(function(){return st})),n.d(e,"J",(function(){return ct})),n.d(e,"O",(function(){return ft})),n.d(e,"t",(function(){return dt})),n.d(e,"S",(function(){return bt})),n.d(e,"m",(function(){return yt})),n.d(e,"H",(function(){return wt})),n.d(e,"E",(function(){return xt})),n.d(e,"G",(function(){return Ot})),n.d(e,"I",(function(){return $t})),n.d(e,"K",(function(){return St})),n.d(e,"L",(function(){return Tt})),n.d(e,"M",(function(){return Pt})),n.d(e,"N",(function(){return Dt})),n.d(e,"Q",(function(){return Rt})),n.d(e,"R",(function(){return It})),n.d(e,"Y",(function(){return Ft})),n.d(e,"Z",(function(){return zt})),n.d(e,"o",(function(){return qt})),n.d(e,"lb",(function(){return Kt})),n.d(e,"tb",(function(){return Vt})),n.d(e,"bb",(function(){return Qt})),n.d(e,"sb",(function(){return Jt})),n.d(e,"r",(function(){return Xt})),n.d(e,"cb",(function(){return Yt})),n.d(e,"eb",(function(){return Zt})),n.d(e,"gb",(function(){return te})),n.d(e,"hb",(function(){return ee})),n.d(e,"z",(function(){return ie})),n.d(e,"yb",(function(){return ae})),n.d(e,"q",(function(){return ue})),n.d(e,"C",(function(){return le})),n.d(e,"y",(function(){return ce})),n.d(e,"j",(function(){return he})),n.d(e,"n",(function(){return pe})),n.d(e,"ab",(function(){return fe})),n.d(e,"rb",(function(){return _e})),n.d(e,"b",(function(){return de})),n.d(e,"f",(function(){return ge})),n.d(e,"g",(function(){return Ee})),n.d(e,"l",(function(){return Ce})),n.d(e,"c",(function(){return Re})),n.d(e,"e",(function(){return Me})),n.d(e,"F",(function(){return Le})),n.d(e,"fb",(function(){return ze})),n.d(e,"k",(function(){return He})),n.d(e,"a",(function(){return We})),n.d(e,"ib",(function(){return Ge})),n.d(e,"jb",(function(){return Ke})),n.d(e,"vb",(function(){return Qe})),n.d(e,"X",(function(){return Xe})),n.d(e,"h",(function(){return Ze})),n.d(e,"A",(function(){return tn})),n.d(e,"i",(function(){return en})),n.d(e,"mb",(function(){return nn})),n.d(e,"nb",(function(){return rn})),n.d(e,"ob",(function(){return on})),n.d(e,"d",(function(){return un})),n.d(e,"pb",(function(){return cn})),n.d(e,"qb",(function(){return hn})),n.d(e,"wb",(function(){return pn})),n.d(e,"xb",(function(){return fn})),n.d(e,"Ab",(function(){return _n})),n.d(e,"Bb",(function(){return dn})),n.d(e,"Cb",(function(){return vn}));var o,a,s,u,l,c,h,p,f,_,d,v,g,m,b,y,w,x=n(14),k=n.n(x),O={},$=O.last=function(t){var e=t?t.length:0;if(e)return t[e-1]},j=O.isUndef=function(t){return void 0===t},S=(O.types={},O.isObj=function(t){var e=k()(t);return!!t&&("function"===e||"object"===e)}),E=O.has=(o=Object.prototype.hasOwnProperty,function(t,e){return o.call(t,e)}),A=O.slice=function(t,e,n){var r=t.length;e=null==e?0:e<0?Math.max(r+e,0):Math.min(e,r),n=null==n?r:n<0?Math.max(r+n,0):Math.min(n,r);for(var i=[];e<n;)i.push(t[e++]);return i},T=O.keys=Object.keys?Object.keys:function(t){var e=[];for(var n in t)E(t,n)&&e.push(n);return e},C=O.freeze=function(t){return Object.freeze?Object.freeze(t):(T(t).forEach((function(e){Object.getOwnPropertyDescriptor(t,e).configurable&&Object.defineProperty(t,e,{writable:!1,configurable:!1})})),t)},P=O.reverse=function(t){var e=t.length,n=Array(e);e--;for(var r=0;r<=e;r++)n[e-r]=t[r];return n},N=O.isBrowser="object"===("undefined"==typeof window?"undefined":k()(window))&&"object"===("undefined"==typeof document?"undefined":k()(document))&&9===document.nodeType,D=O.noop=function(){},R=O.before=function(t,e){var n;return function(){return--t>0&&(n=e.apply(this,arguments)),t<=1&&(e=null),n}},M=O.splitCase=(a=/([A-Z])/g,s=/[_.\- ]+/g,u=/(^-)|(-$)/g,function(t){return(t=t.replace(a,"-$1").toLowerCase().replace(s,"-").replace(u,"")).split("-")}),I=O.camelCase=function(t){function e(t,e){this[e]=t.replace(/\w/,(function(t){return t.toUpperCase()}))}return function(t){var n=M(t),r=n[0];return n.shift(),n.forEach(e,n),r+=n.join("")}}(),L=O.kebabCase=function(t){return M(t).join("-")},F=O.clamp=function(t,e,n){return j(n)&&(n=e,e=void 0),!j(e)&&t<e?e:t>n?n:t},z=O.idxOf=function(t,e,n){return Array.prototype.indexOf.call(t,e,n)},B=O.create=function(t){t=function(t){if(!S(t))return{};if(e)return e(t);function n(){}return n.prototype=t,new n};var e=Object.create;return t}({}),H=O.inherits=function(t,e){t.prototype=B(e.prototype)},q=O.toStr=function(t){return null==t?"":t.toString()},U=O.debounce=function(t,e,n){var r;return function(){var i=this,o=arguments,a=function(){r=null,t.apply(i,o)};n||clearTimeout(r),n&&r||(r=setTimeout(a,e))}},W=O.detectOs=function(t){if(t=(t=t||(N?navigator.userAgent:"")).toLowerCase(),e("windows phone"))return"windows phone";if(e("win"))return"windows";if(e("android"))return"android";if(e("ipad")||e("iphone")||e("ipod"))return"ios";if(e("mac"))return"os x";if(e("linux"))return"linux";function e(e){return t.indexOf(e)>-1}return"unknown"},G=O.restArgs=function(t,e){return e=null==e?t.length-1:+e,function(){var n,r=Math.max(arguments.length-e,0),i=new Array(r);for(n=0;n<r;n++)i[n]=arguments[n+e];switch(e){case 0:return t.call(this,i);case 1:return t.call(this,arguments[0],i);case 2:return t.call(this,arguments[0],arguments[1],i)}var o=new Array(e+1);for(n=0;n<e;n++)o[n]=arguments[n];return o[e]=i,t.apply(this,o)}},K=O.mergeArr=G((function(t,e){for(var n=t.length,r=0,i=e.length;r<i;r++)for(var o=e[r],a=0,s=o.length;a<s;a++)t[n++]=o[a];return t.length=n,t})),V=O.optimizeCb=function(t,e,n){if(j(e))return t;switch(null==n?3:n){case 1:return function(n){return t.call(e,n)};case 3:return function(n,r,i){return t.call(e,n,r,i)};case 4:return function(n,r,i,o){return t.call(e,n,r,i,o)}}return function(){return t.apply(e,arguments)}},Q=O.endWith=function(t,e){var n=t.length-e.length;return n>=0&&t.indexOf(e,n)===n},J=O.escape=function(t){var e=(t=function(t){return r.test(t)?t.replace(i,o):t}).map={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},n="(?:"+T(e).join("|")+")",r=new RegExp(n),i=new RegExp(n,"g"),o=function(t){return e[t]};return t}({}),X=O.escapeJsStr=function(t){t=function(t){return q(t).replace(e,(function(t){switch(t){case'"':case"'":case"\\":return"\\"+t;case"\n":return"\\n";case"\r":return"\\r";case"\u2028":return"\\u2028";case"\u2029":return"\\u2029"}}))};var e=/["'\\\n\r\u2028\u2029]/g;return t}({}),Y=O.escapeJsonStr=function(t){return X(t).replace(/\\'/g,"'").replace(/\t/g,"\\t")},Z=O.escapeRegExp=function(t){return t.replace(/\W/g,"\\$&")},tt=O.upperFirst=function(t){return t.length<1?t:t[0].toUpperCase()+t.slice(1)},et=O.getObjType=function(t){return t.constructor&&t.constructor.name?t.constructor.name:tt({}.toString.call(t).replace(/(\[object )|]/g,""))},nt=O.identity=function(t){return t},rt=O.objToStr=(l=Object.prototype.toString,function(t){return l.call(t)}),it=O.isArgs=function(t){return"[object Arguments]"===rt(t)},ot=O.isArr=Array.isArray?Array.isArray:function(t){return"[object Array]"===rt(t)},at=O.castPath=function(t){t=function(t,r){if(ot(t))return t;if(r&&E(r,t))return[t];var i=[];return t.replace(e,(function(t,e,r,o){i.push(r?o.replace(n,"$1"):e||t)})),i};var e=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,n=/\\(\\)?/g;return t}({}),st=O.safeGet=function(t,e){var n;for(n=(e=at(e,t)).shift();!j(n);){if(null==(t=t[n]))return;n=e.shift()}return t},ut=O.flatten=function(t){return function t(e,n){for(var r,i=e.length,o=-1;i--;)r=e[++o],ot(r)?t(r,n):n.push(r);return n}(t,[])},lt=O.isDate=function(t){return"[object Date]"===rt(t)},ct=O.isFn=function(t){var e=rt(t);return"[object Function]"===e||"[object GeneratorFunction]"===e||"[object AsyncFunction]"===e},ht=O.getProto=(c=Object.getPrototypeOf,h={}.constructor,function(t){if(S(t)){if(c)return c(t);var e=t.__proto__;return e||null===e?e:ct(t.constructor)?t.constructor.prototype:t instanceof h?h.prototype:void 0}}),pt=O.isMiniProgram="undefined"!=typeof wx&&ct(wx.openLocation),ft=O.isNum=function(t){return"[object Number]"===rt(t)},_t=O.isArrLike=(p=Math.pow(2,53)-1,function(t){if(!t)return!1;var e=t.length;return ft(e)&&e>=0&&e<=p&&!ct(t)}),dt=O.each=function(t,e,n){var r,i;if(e=V(e,n),_t(t))for(r=0,i=t.length;r<i;r++)e(t[r],r,t);else{var o=T(t);for(r=0,i=o.length;r<i;r++)e(t[o[r]],o[r],t)}return t},vt=O.createAssigner=function(t,e){return function(n){return dt(arguments,(function(r,i){if(0!==i){var o=t(r);dt(o,(function(t){e&&!j(n[t])||(n[t]=r[t])}))}})),n}},gt=O.extendOwn=vt(T),mt=O.values=function(t){var e=[];return dt(t,(function(t){e.push(t)})),e},bt=O.isStr=function(t){return"[object String]"===rt(t)},yt=O.contain=function(t,e){return bt(t)?t.indexOf(e)>-1:(_t(t)||(t=mt(t)),z(t,e)>=0)},wt=O.isEmpty=function(t){return null==t||(_t(t)&&(ot(t)||bt(t)||it(t))?0===t.length:0===T(t).length)},xt=O.isBool=function(t){return!0===t||!1===t},kt=O.isBuffer=function(t){return null!=t&&(!!t._isBuffer||t.constructor&&ct(t.constructor.isBuffer)&&t.constructor.isBuffer(t))},Ot=O.isEl=function(t){return!(!t||1!==t.nodeType)},$t=O.isErr=function(t){return"[object Error]"===rt(t)},jt=O.root=N?window:t,St=O.isHidden=function(t){var e=jt.getComputedStyle,n=jt.document;function r(t,e){return t.right<e.left||t.left>e.right||t.bottom<e.top||t.top>e.bottom}return function(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=i.display,a=void 0===o||o,s=i.visibility,u=void 0!==s&&s,l=i.opacity,c=void 0!==l&&l,h=i.size,p=void 0!==h&&h,f=i.viewport,_=void 0!==f&&f,d=i.overflow,v=void 0!==d&&d;if(a)return null===t.offsetParent;var g=e(t);if(u&&"hidden"===g.visibility)return!0;if(c){if("0"===g.opacity)return!0;for(var m=t;m=m.parentElement;){var b=e(m);if("0"===b.opacity)return!0}}var y=t.getBoundingClientRect();if(p&&(0===y.width||0===y.height))return!0;if(_){var w={top:0,left:0,right:n.documentElement.clientWidth,bottom:n.documentElement.clientHeight};return r(y,w)}if(v)for(var x=t;x=x.parentElement;){var k=e(x),O=k.overflow;if("scroll"===O||"hidden"===O){var $=x.getBoundingClientRect();if(r(y,$))return!0}}return!1}}(),Et=O.isMatch=function(t,e){var n=T(e),r=n.length;if(null==t)return!r;t=Object(t);for(var i=0;i<r;i++){var o=n[i];if(e[o]!==t[o]||!(o in t))return!1}return!0},At=O.memoize=function(t,e){var n=function n(r){var i=n.cache,o=""+(e?e.apply(this,arguments):r);return E(i,o)||(i[o]=t.apply(this,arguments)),i[o]};return n.cache={},n},Tt=O.isMobile=(f=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,_=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i,At((function(t){return t=t||(N?navigator.userAgent:""),f.test(t)||_.test(t.substr(0,4))}))),Ct=O.prefix=function(t){(t=At((function(t){if(t=t.replace(n,""),t=I(t),E(r,t))return t;for(var i=e.length;i--;){var o=e[i]+tt(t);if(E(r,o))return o}return t}))).dash=At((function(e){var r=t(e);return(n.test(r)?"-":"")+L(r)}));var e=["O","ms","Moz","Webkit"],n=/^(O)|(ms)|(Moz)|(Webkit)|(-o-)|(-ms-)|(-moz-)|(-webkit-)/g,r=document.createElement("p").style;return t}({}),Pt=O.isNaN=function(t){return ft(t)&&t!==+t},Nt=O.isNil=function(t){return null==t},Dt=O.isNull=function(t){return null===t},Rt=O.isPrimitive=function(t){var e=k()(t);return null==t||"function"!==e&&"object"!==e},Mt=O.isPromise=function(t){return S(t)&&ct(t.then)&&ct(t.catch)},It=O.isRegExp=function(t){return"[object RegExp]"===rt(t)},Lt=O.isSorted=(d={},(d=function(t){for(var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:d.defComparator,n=0,r=t.length;n<r-1;n++)if(e(t[n],t[n+1])>0)return!1;return!0}).defComparator=function(t,e){return t<e?-1:t>e?1:0},d),Ft=O.loadJs=function(t,e){var n=document.createElement("script");n.src=t,n.onload=function(){var t=n.readyState&&"complete"!=n.readyState&&"loaded"!=n.readyState;e&&e(!t)},n.onerror=function(){e(!1)},document.body.appendChild(n)},zt=O.lowerCase=function(t){return q(t).toLocaleLowerCase()},Bt=O.repeat=function(t,e){var n="";if(e<1)return"";for(;e>0;)1&e&&(n+=t),e>>=1,t+=t;return n},Ht=O.lpad=function(t,e,n){var r=(t=q(t)).length;return n=n||" ",r<e&&(t=(Bt(n,e-r)+t).slice(-e)),t},qt=O.dateFormat=function(t){t=function(a,s,u,l){1===arguments.length&&bt(a)&&!i.test(a)&&(s=a,a=void 0),a=a||new Date,lt(a)||(a=new Date(a));var c=(s=q(t.masks[s]||s||t.masks.default)).slice(0,4);"UTC:"!==c&&"GMT:"!==c||(s=s.slice(4),u=!0,"GMT:"===c&&(l=!0));var h=u?"getUTC":"get",p=a[h+"Date"](),f=a[h+"Day"](),_=a[h+"Month"](),d=a[h+"FullYear"](),v=a[h+"Hours"](),g=a[h+"Minutes"](),m=a[h+"Seconds"](),b=a[h+"Milliseconds"](),y=u?0:a.getTimezoneOffset(),w={d:p,dd:e(p),ddd:t.i18n.dayNames[f],dddd:t.i18n.dayNames[f+7],m:_+1,mm:e(_+1),mmm:t.i18n.monthNames[_],mmmm:t.i18n.monthNames[_+12],yy:q(d).slice(2),yyyy:d,h:v%12||12,hh:e(v%12||12),H:v,HH:e(v),M:g,MM:e(g),s:m,ss:e(m),l:e(b,3),L:e(Math.round(b/10)),t:v<12?"a":"p",tt:v<12?"am":"pm",T:v<12?"A":"P",TT:v<12?"AM":"PM",Z:l?"GMT":u?"UTC":(q(a).match(r)||[""]).pop().replace(o,""),o:(y>0?"-":"+")+e(100*Math.floor(Math.abs(y)/60)+Math.abs(y)%60,4),S:["th","st","nd","rd"][p%10>3?0:(p%100-p%10!=10)*p%10]};return s.replace(n,(function(t){return t in w?w[t]:t.slice(1,t.length-1)}))};var e=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2;return Ht(q(t),e,"0")},n=/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g,r=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,i=/\d/,o=/[^-+\dA-Z]/g;return t.masks={default:"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"},t.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"]},t}({}),Ut=O.ltrim=(v=/^\s+/,function(t,e){if(null==e)return t.replace(v,"");for(var n,r,i=0,o=t.length,a=e.length,s=!0;s&&i<o;)for(s=!1,n=-1,r=t.charAt(i);++n<a;)if(r===e[n]){s=!0,i++;break}return i>=o?"":t.substr(i,o)}),Wt=O.matcher=function(t){return t=gt({},t),function(e){return Et(e,t)}},Gt=O.memStorage=function(t){t={getItem:function(t){return(n[t]?e[t]:this[t])||null},setItem:function(t,r){n[t]?e[t]=r:this[t]=r},removeItem:function(t){n[t]?delete e[t]:delete this[t]},key:function(t){var e=r();return t>=0&&t<e.length?e[t]:null},clear:function(){for(var t,n=i(),r=0;t=n[r];r++)delete this[t];n=o();for(var a,s=0;a=n[s];s++)delete e[a]}},Object.defineProperty(t,"length",{enumerable:!1,configurable:!0,get:function(){return r().length}});var e={},n={getItem:1,setItem:1,removeItem:1,key:1,clear:1,length:1};function r(){return i().concat(o())}function i(){return T(t).filter((function(t){return!n[t]}))}function o(){return T(e)}return t}({}),Kt=O.safeStorage=function(t,e){var n;switch(j(e)&&(e=!0),t){case"local":n=window.localStorage;break;case"session":n=window.sessionStorage}try{var r="test-localStorage-"+Date.now();n.setItem(r,r);var i=n.getItem(r);if(n.removeItem(r),i!==r)throw new Error}catch(t){return e?Gt:void 0}return n},Vt=O.toNum=function(t){if(ft(t))return t;if(S(t)){var e=ct(t.valueOf)?t.valueOf():t;t=S(e)?e+"":e}return bt(t)?+t:0===t?t:+t},Qt=O.ms=function(t){t=function(t){if(bt(t)){var i=t.match(r);return i?Vt(i[1])*e[i[2]||"ms"]:0}for(var o=t,a="ms",s=0,u=n.length;s<u;s++)if(o>=e[n[s]]){a=n[s];break}return+(o/e[a]).toFixed(2)+a};var e={ms:1,s:1e3};e.m=60*e.s,e.h=60*e.m,e.d=24*e.h,e.y=365.25*e.d;var n=["y","d","h","m","s"],r=/^((?:\d+)?\.?\d+) *(s|m|h|d|y)?$/;return t}({}),Jt=O.toInt=function(t){return t?(t=Vt(t))-t%1:0===t?t:0},Xt=O.detectBrowser=function(t){t=function(t){var o=i(t=(t=t||(N?navigator.userAgent:"")).toLowerCase(),"msie ");if(o)return{version:o,name:"ie"};if(n.test(t))return{version:11,name:"ie"};for(var a=0,s=r.length;a<s;a++){var u=r[a],l=t.match(e[u]);if(null!=l){var c=Jt(l[1].split(".")[0]);return"opera"===u&&(c=i(t,"version/")||c),{name:u,version:c}}}return{name:"unknown",version:-1}};var e={edge:/edge\/([0-9._]+)/,firefox:/firefox\/([0-9.]+)(?:\s|$)/,opera:/opera\/([0-9.]+)(?:\s|$)/,android:/android\s([0-9.]+)/,ios:/version\/([0-9._]+).*mobile.*safari.*/,safari:/version\/([0-9._]+).*safari/,chrome:/(?!chrom.*opr)chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/},n=/trident\/7\./,r=T(e);function i(t,e){var n=t.indexOf(e);if(n>-1)return Jt(t.substring(n+e.length,t.indexOf(".",n)))}return t}({}),Yt=O.nextTick=function(t){function e(t){if("function"!=typeof t)throw new TypeError(t+" is not a function");return t}return"object"===(void 0===r?"undefined":k()(r))&&r.nextTick?r.nextTick:"function"==typeof i?function(t){i(e(t))}:function(t){setTimeout(e(t),0)}}(),Zt=O.now=Date.now?Date.now:function(){return(new Date).getTime()},te=O.perfNow=function(t){var e,n=jt.performance,r=jt.process;if(n&&n.now)t=function(){return n.now()};else if(r&&r.hrtime){var i=function(){var t=r.hrtime();return 1e9*t[0]+t[1]};e=i()-1e9*r.uptime(),t=function(){return(i()-e)/1e6}}else e=Zt(),t=function(){return Zt()-e};return t}({}),ee=O.pick=function(t,e,n){if(bt(e)&&(e=[e]),ot(e)){var r=e;e=function(t,e){return yt(r,e)}}var i={},o=function(t,n){e(t,n)&&(i[n]=t)};return n&&(o=function(t,n){e(t,n)||(i[n]=t)}),dt(t,o),i},ne=O.property=function(t){return ot(t)?function(e){return st(e,t)}:(e=t,function(t){return null==t?void 0:t[e]});var e},re=O.safeCb=function(t,e,n){return null==t?nt:ct(t)?V(t,e,n):S(t)&&!ot(t)?Wt(t):ne(t)},ie=O.filter=function(t,e,n){var r=[];return e=re(e,n),dt(t,(function(t,n,i){e(t,n,i)&&r.push(t)})),r},oe=O.difference=G((function(t,e){return e=ut(e),ie(t,(function(t){return!yt(e,t)}))})),ae=O.unique=function(t){function e(t,e){return t===e}return function(t,n){return n=n||e,ie(t,(function(t,e,r){for(var i=r.length;++e<i;)if(n(t,r[e]))return!1;return!0}))}}(),se=O.allKeys=(g=Object.getOwnPropertyNames,m=Object.getOwnPropertySymbols,function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.prototype,r=void 0===n||n,i=e.unenumerable,o=void 0!==i&&i,a=e.symbol,s=void 0!==a&&a,u=[];if((o||s)&&g){var l=T;o&&g&&(l=g);do{u=u.concat(l(t)),s&&m&&(u=u.concat(m(t)))}while(r&&(t=ht(t))&&t!==Object.prototype);u=ae(u)}else if(r)for(var c in t)u.push(c);else u=T(t);return u}),ue=O.defaults=vt(se,!0),le=O.highlight=function(t){t=function(r){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"js",o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};ue(o,e),r=r.replace(/</g,"&lt;").replace(/>/g,"&gt;"),i=n[i];var a=0,s=[];dt(i,(function(e){e.language&&(r=r.replace(e.re,(function(n,r){return s[a++]=t(r,e.language,o),n.replace(r,"___subtmpl"+(a-1)+"___")})))})),dt(i,(function(t,e){n[t.language]||(r=r.replace(t.re,"___"+e+"___$1___end"+e+"___"))}));var u=[];return r=r.replace(/___(?!subtmpl)\w+?___/g,(function(t){var e="end"===t.substr(3,3),n=(e?t.substr(6):t.substr(3)).replace(/_/g,""),r=u.length>0?u[u.length-1]:null;return!e&&(null==r||n==r||null!=r&&i[r]&&null!=i[r].embed&&i[r].embed.indexOf(n)>-1)?(u.push(n),t):e&&n==r?(u.pop(),t):""})),dt(i,(function(t,e){r=r.replace(new RegExp("___end"+e+"___","g"),"</span>").replace(new RegExp("___"+e+"___","g"),'<span style="'+o[t.style]+'">')})),dt(i,(function(t){t.language&&(r=r.replace(/___subtmpl\d+___/g,(function(t){var e=parseInt(t.replace(/___subtmpl(\d+)___/,"$1"),10);return s[e]})))})),r};var e={comment:"color:#63a35c;",string:"color:#183691;",number:"color:#0086b3;",keyword:"color:#a71d5d;",operator:"color:#994500;"},n={js:{comment:{re:/(\/\/.*|\/\*([\s\S]*?)\*\/)/g,style:"comment"},string:{re:/(('.*?')|(".*?"))/g,style:"string"},numbers:{re:/(-?(\d+|\d+\.\d+|\.\d+))/g,style:"number"},keywords:{re:/(?:\b)(function|for|foreach|while|if|else|elseif|switch|break|as|return|this|class|self|default|var|const|let|false|true|null|undefined)(?:\b)/gi,style:"keyword"},operator:{re:/(\+|-|\/|\*|%|=|&lt;|&gt;|\||\?|\.)/g,style:"operator"}}};return n.html={comment:{re:/(&lt;!--([\s\S]*?)--&gt;)/g,style:"comment"},tag:{re:/(&lt;\/?\w(.|\n)*?\/?&gt;)/g,style:"keyword",embed:["string"]},string:n.js.string,css:{re:/(?:&lt;style.*?&gt;)([\s\S]*)?(?:&lt;\/style&gt;)/gi,language:"css"},script:{re:/(?:&lt;script.*?&gt;)([\s\S]*?)(?:&lt;\/script&gt;)/gi,language:"js"}},n.css={comment:n.js.comment,string:n.js.string,numbers:{re:/((-?(\d+|\d+\.\d+|\.\d+)(%|px|em|pt|in)?)|#[0-9a-fA-F]{3}[0-9a-fA-F]{3})/g,style:"number"},keywords:{re:/(@\w+|:?:\w+|[a-z-]+:)/g,style:"keyword"}},t}({}),ce=O.extend=vt(se),he=O.clone=function(t){return S(t)?ot(t)?t.slice():ce({},t):t},pe=O.copy=function(t,e){e=e||D;var n=document.createElement("textarea"),r=document.body;ce(n.style,{fontSize:"12pt",border:"0",padding:"0",margin:"0",position:"absolute",left:"-9999px"}),n.value=t,r.appendChild(n),n.setAttribute("readonly",""),n.select(),n.setSelectionRange(0,t.length);try{document.execCommand("copy"),e()}catch(t){e(t)}finally{r.removeChild(n)}},fe=O.map=function(t,e,n){e=re(e,n);for(var r=!_t(t)&&T(t),i=(r||t).length,o=Array(i),a=0;a<i;a++){var s=r?r[a]:a;o[a]=e(t[s],s,t)}return o},_e=O.toArr=function(t){return t?ot(t)?t:_t(t)&&!bt(t)?fe(t):[t]:[]},de=O.Class=function(t){var e=(t=function(t,n){return e.extend(t,n)}).Base=function t(e,n,r){r=r||{};var i=n.className||st(n,"initialize.name")||"";delete n.className;var o=function(){var t=_e(arguments);return this.initialize&&this.initialize.apply(this,t)||this};if(!pt)try{o=new Function("toArr","return function "+i+"(){var args = toArr(arguments);return this.initialize ? this.initialize.apply(this, args) || this : this;};")(_e)}catch(t){}return H(o,e),o.prototype.constructor=o,o.extend=function(e,n){return t(o,e,n)},o.inherits=function(t){H(o,t)},o.methods=function(t){return ce(o.prototype,t),o},o.statics=function(t){return ce(o,t),o},o.methods(n).statics(r),o}(Object,{className:"Base",callSuper:function(t,e,n){return t.prototype[e].apply(this,n)},toString:function(){return this.constructor.name}});return t}({}),ve=O.Enum=de({initialize:function(t){ot(t)?(this.size=t.length,dt(t,(function(t,e){this[t]=e}),this)):(this.size=T(t).length,dt(t,(function(t,e){this[e]=t}),this)),C(this)}}),ge=O.MutationObserver=function(t){return(t=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver)||(t=de({initialize:function(){},observe:function(){},disconnect:function(){},takeRecords:function(){}})),t}({}),me=O.Select=function(t){var e=new(t=de({className:"Select",initialize:function(t){return this.length=0,t?bt(t)?e.find(t):void(t.nodeType&&(this[0]=t,this.length=1)):this},find:function(e){var n=new t;return this.each((function(){K(n,this.querySelectorAll(e))})),n},each:function(t){return dt(this,(function(e,n){t.call(e,n,e)})),this}}))(document);return t}({}),be=O.$safeEls=function(t){return _e(bt(t)?new me(t):t)},ye=O.$attr=function(t){return(t=function(t,e,n){if(t=be(t),j(n)&&bt(e))return function(t,e){return t.getAttribute(e)}(t[0],e);var r=e;S(r)||((r={})[e]=n),function(t,e){dt(t,(function(t){dt(e,(function(e,n){t.setAttribute(n,e)}))}))}(t,r)}).remove=function(t,e){t=be(t),e=_e(e),dt(t,(function(t){dt(e,(function(e){t.removeAttribute(e)}))}))},t}({}),we=O.$css=function(t){t=function(t,n,r){if(t=be(t),j(r)&&bt(n))return function(t,e){return t.style[Ct(e)]||getComputedStyle(t,"").getPropertyValue(e)}(t[0],n);var i=n;S(i)||((i={})[n]=r),function(t,n){dt(t,(function(t){var r=";";dt(n,(function(t,n){n=Ct.dash(n),r+=n+":"+function(t,n){return ft(n)&&!yt(e,L(t))?n+"px":n}(n,t)+";"})),t.style.cssText+=r}))}(t,i)};var e=["column-count","columns","font-weight","line-weight","opacity","z-index","zoom"];return t}({}),xe=O.$data=function(t,e,n){var r=e;return bt(e)&&(r="data-"+e),S(e)&&(r={},dt(e,(function(t,e){r["data-"+e]=t}))),ye(t,r,n)},ke=O.$insert=function(t){function e(t){return function(e,n){e=be(e),dt(e,(function(e){e.insertAdjacentHTML(t,n)}))}}return{before:e("beforebegin"),after:e("afterend"),append:e("beforeend"),prepend:e("afterbegin")}}(),Oe=O.$offset=function(t){var e=(t=be(t))[0].getBoundingClientRect();return{left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:Math.round(e.width),height:Math.round(e.height)}},$e=O.$property=function(t){function e(t){return function(e,n){var r=(e=be(e))[0];if(j(n))return r?r[t]:"";r&&dt(e,(function(e){e[t]=n}))}}return{html:e("innerHTML"),text:e("textContent"),val:e("value")}}(),je=O.$remove=function(t){t=be(t),dt(t,(function(t){var e=t.parentNode;e&&e.removeChild(t)}))},Se=O.$show=function(t){t=function(t){t=be(t),dt(t,(function(t){(function(t){return"none"==getComputedStyle(t,"").getPropertyValue("display")})(t)&&(t.style.display=function(t){var n,r;e[t]||(n=document.createElement(t),document.documentElement.appendChild(n),r=getComputedStyle(n,"").getPropertyValue("display"),n.parentNode.removeChild(n),"none"==r&&(r="block"),e[t]=r);return e[t]}(t.nodeName))}))};var e={};return t}({}),Ee=O.Stack=de({initialize:function(){this.clear()},clear:function(){this._items=[],this.size=0},push:function(t){return this._items.push(t),++this.size},pop:function(){if(this.size)return this.size--,this._items.pop()},peek:function(){return this._items[this.size-1]},forEach:function(t,e){e=arguments.length>1?e:this;for(var n=this._items,r=this.size-1,i=0;r>=0;r--,i++)t.call(e,n[r],i,this)},toArr:function(){return P(this._items)}}),Ae=O.delegate=function(t){function e(){return!0}function n(){return!1}function r(e){var n,r=this.events[e.type],o=i.call(this,e,r);e=new t.Event(e);for(var a,s,u=0;(s=o[u++])&&!e.isPropagationStopped();)for(e.curTarget=s.el,a=0;(n=s.handlers[a++])&&!e.isImmediatePropagationStopped();)!1===n.handler.apply(s.el,[e])&&(e.preventDefault(),e.stopPropagation())}function i(t,e){var n,r,i,o,a=t.target,s=[],u=e.delegateCount;if(a.nodeType)for(;a!==this;a=a.parentNode||this){for(r=[],o=0;o<u;o++)void 0===r[n=(i=e[o]).selector+" "]&&(r[n]=yt(this.querySelectorAll(n),a)),r[n]&&r.push(i);r.length&&s.push({el:a,handlers:r})}return u<e.length&&s.push({el:this,handlers:e.slice(u)}),s}return t={add:function(t,e,n,i){var o,a={selector:n,handler:i};t.events||(t.events={}),(o=t.events[e])||((o=t.events[e]=[]).delegateCount=0,t.addEventListener(e,(function(){r.apply(t,arguments)}),!1)),n?o.splice(o.delegateCount++,0,a):o.push(a)},remove:function(t,e,n,r){var i=t.events;if(i&&i[e])for(var o,a=i[e],s=a.length;s--;)o=a[s],n&&o.selector!=n||o.handler!=r||(a.splice(s,1),o.selector&&a.delegateCount--)},Event:de({className:"Event",initialize:function(t){this.origEvent=t},isDefaultPrevented:n,isPropagationStopped:n,isImmediatePropagationStopped:n,preventDefault:function(){var t=this.origEvent;this.isDefaultPrevented=e,t&&t.preventDefault&&t.preventDefault()},stopPropagation:function(){var t=this.origEvent;this.isPropagationStopped=e,t&&t.stopPropagation&&t.stopPropagation()},stopImmediatePropagation:function(){var t=this.origEvent;this.isImmediatePropagationStopped=e,t&&t.stopImmediatePropagation&&t.stopImmediatePropagation(),this.stopPropagation()}})}}({}),Te=O.$event=function(t){function e(t){return function(e,n,r,i){e=be(e),j(i)&&(i=r,r=void 0),dt(e,(function(e){Ae[t](e,n,r,i)}))}}return{on:e("add"),off:e("remove")}}(),Ce=O.concat=function(){for(var t=_e(arguments),e=[],n=0,r=t.length;n<r;n++)e=e.concat(_e(t[n]));return e},Pe=O.meta=function(t){(t=function(t,i){if(j(t))return o={},n((function(t,e){o[t]=e})),o;var o;if(bt(t)&&j(i)||ot(t))return function(t){if(!bt(t)){var e={};return n((function(n,r){yt(t,n)&&(e[n]=r)})),e}var i=r(t);if(i)return i.getAttribute("content")}(t);var a=t;S(a)||((a={})[t]=i),function(t){dt(t,(function(t,n){var i=r(n);if(i)return i.setAttribute("content",t);(i=e.createElement("meta")).setAttribute("name",n),i.setAttribute("content",t),e.head.appendChild(i)}))}(a)}).remove=function(t){t=_e(t),dt(t,(function(t){var n=r(t);n&&e.head.removeChild(n)}))};var e=document;function n(t){var n=e.querySelectorAll("meta");dt(n,(function(e){var n=e.getAttribute("name"),r=e.getAttribute("content");n&&r&&t(n,r)}))}function r(t){return e.querySelector('meta[name="'+t+'"]')}return t}({}),Ne=O.partial=G((function(t,e){return function(){var n=[];return n=(n=n.concat(e)).concat(_e(arguments)),t.apply(this,n)}})),De=O.once=Ne(R,2),Re=O.Emitter=function(t){return t=de({initialize:function(){this._events=this._events||{}},on:function(t,e){return this._events[t]=this._events[t]||[],this._events[t].push(e),this},off:function(t,e){var n=this._events;if(E(n,t)){var r=n[t].indexOf(e);return r>-1&&n[t].splice(r,1),this}},once:function(t,e){return this.on(t,De(e)),this},emit:function(t){if(E(this._events,t)){var e=A(arguments,1);return dt(this._events[t],(function(t){t.apply(this,e)}),this),this}},removeAllListeners:function(t){return t?delete this._events[t]:this._events={},this}},{mixin:function(e){dt(["on","off","once","emit"],(function(n){e[n]=t.prototype[n]})),e._events=e._events||{}}})}({}),Me=O.Logger=function(t){return t=Re.extend({initialize:function(e,n){this.name=e,this.setLevel(j(n)?t.level.DEBUG:n),this.callSuper(Re,"initialize",arguments)},setLevel:function(e){return bt(e)?((e=t.level[e.toUpperCase()])&&(this._level=e),this):(ft(e)&&(this._level=e),this)},getLevel:function(){return this._level},formatter:function(t,e){return e},trace:function(){return this._log("trace",arguments)},debug:function(){return this._log("debug",arguments)},info:function(){return this._log("info",arguments)},warn:function(){return this._log("warn",arguments)},error:function(){return this._log("error",arguments)},_log:function(e,n){return 0===(n=_e(n)).length?this:(this.emit("all",e,he(n)),t.level[e.toUpperCase()]<this._level||(this.emit(e,he(n)),("debug"===e?console.log:console[e]).apply(console,this.formatter(e,n))),this)}},{level:new ve({TRACE:0,DEBUG:1,INFO:2,WARN:3,ERROR:4,SILENT:5})})}({}),Ie=O.MediaQuery=Re.extend({className:"MediaQuery",initialize:function(t){var e=this;this.callSuper(Re,"initialize"),this._mql=window.matchMedia(t),this._mql.addListener((function(){e.emit(e.isMatch()?"match":"unmatch")}))},isMatch:function(){return this._mql.matches}}),Le=O.isDarkMode=(b=new Ie("(prefers-color-scheme: dark)"),function(){return b.isMatch()}),Fe=O.Store=Re.extend({initialize:function(t){this.callSuper(Re,"initialize",arguments),this._data=t||{},this.save(this._data)},set:function(t,e){var n;bt(t)?(n={})[t]=e:S(t)&&(n=t);var r=this;dt(n,(function(t,e){var n=r._data[e];r._data[e]=t,r.emit("change",e,t,n)})),this.save(this._data)},get:function(t){var e=this._data;if(bt(t))return e[t];var n={};return dt(t,(function(t){n[t]=e[t]})),n},remove:function(t){t=_e(t);var e=this._data;dt(t,(function(t){delete e[t]})),this.save(e)},clear:function(){this._data={},this.save(this._data)},each:function(t){dt(this._data,t)},save:function(t){this._data=t}}),ze=O.orientation=function(t){var e=window.screen;return t={get:function(){if(e){var t=st(e,"orientation.type");if(t)return t.split("-").shift()}return window.innerWidth>window.innerHeight?"landscape":"portrait"}},Re.mixin(t),window.addEventListener("orientationchange",(function(){setTimeout((function(){t.emit("change",t.get())}),200)}),!1),t}({}),Be=O.mapObj=function(t,e,n){e=re(e,n);for(var r=T(t),i=r.length,o={},a=0;a<i;a++){var s=r[a];o[s]=e(t[s],s,t)}return o},He=O.cloneDeep=(y={},y=function(t){return ot(t)?t.map((function(t){return y(t)})):S(t)&&!ct(t)?Be(t,(function(t){return y(t)})):t}),qe=O.some=function(t,e,n){e=re(e,n);for(var r=!_t(t)&&T(t),i=(r||t).length,o=0;o<i;o++){var a=r?r[o]:o;if(e(t[a],a,t))return!0}return!1},Ue=O.$class=function(t){function e(t){return bt(t)?t.split(/\s+/):_e(t)}return t={add:function(n,r){n=be(n);var i=e(r);dt(n,(function(e){var n=[];dt(i,(function(r){t.has(e,r)||n.push(r)})),0!==n.length&&(e.className+=(e.className?" ":"")+n.join(" "))}))},has:function(t,e){t=be(t);var n=new RegExp("(^|\\s)"+e+"(\\s|$)");return qe(t,(function(t){return n.test(t.className)}))},toggle:function(e,n){e=be(e),dt(e,(function(e){if(!t.has(e,n))return t.add(e,n);t.remove(e,n)}))},remove:function(t,n){t=be(t);var r=e(n);dt(t,(function(t){dt(r,(function(e){t.classList.remove(e)}))}))}}}({}),We=O.$=function(t){t=function(t){return new me(t)},me.methods({offset:function(){return Oe(this)},hide:function(){return this.css("display","none")},show:function(){return Se(this),this},first:function(){return t(this[0])},last:function(){return t($(this))},get:function(t){return this[t]},eq:function(e){return t(this[e])},on:function(t,e,n){return Te.on(this,t,e,n),this},off:function(t,e,n){return Te.off(this,t,e,n),this},html:function(t){var e=$e.html(this,t);return j(t)?e:this},text:function(t){var e=$e.text(this,t);return j(t)?e:this},val:function(t){var e=$e.val(this,t);return j(t)?e:this},css:function(t,n){var r=we(this,t,n);return e(t,n)?r:this},attr:function(t,n){var r=ye(this,t,n);return e(t,n)?r:this},data:function(t,n){var r=xe(this,t,n);return e(t,n)?r:this},rmAttr:function(t){return ye.remove(this,t),this},remove:function(){return je(this),this},addClass:function(t){return Ue.add(this,t),this},rmClass:function(t){return Ue.remove(this,t),this},toggleClass:function(t){return Ue.toggle(this,t),this},hasClass:function(t){return Ue.has(this,t)},parent:function(){return t(this[0].parentNode)},append:function(t){return ke.append(this,t),this},prepend:function(t){return ke.prepend(this,t),this},before:function(t){return ke.before(this,t),this},after:function(t){return ke.after(this,t),this}});var e=function(t,e){return j(e)&&bt(t)};return t}({}),Ge=O.pxToNum=function(t){return Vt(t.replace("px",""))},Ke=O.raf=function(t){var e,n,r=0;if(N){e=window.requestAnimationFrame,n=window.cancelAnimationFrame;for(var i=["ms","moz","webkit","o"],o=0,a=i.length;o<a&&!e;o++)e=window[i[o]+"RequestAnimationFrame"],n=window[i[o]+"CancelAnimationFrame"]||window[i[o]+"CancelRequestAnimationFrame"]}return n=n||function(t){clearTimeout(t)},(e=e||function(t){var e=Zt(),n=Math.max(0,16-(e-r)),i=setTimeout((function(){t(e+n)}),n);return r=e+n,i}).cancel=n,e}(),Ve=O.rtrim=function(t){var e=/\s+$/;return function(t,n){if(null==n)return t.replace(e,"");for(var r,i,o=t.length-1,a=n.length,s=!0;s&&o>=0;)for(s=!1,r=-1,i=t.charAt(o);++r<a;)if(i===n[r]){s=!0,o--;break}return o>=0?t.substring(0,o+1):""}}(),Qe=O.trim=function(t){var e=/^\s+|\s+$/g;return function(t,n){return null==n?t.replace(e,""):Ut(Ve(t,n),n)}}(),Je=O.extractUrls=function(t){t=function(t){var n=_e(t.match(e));return ae(fe(n,(function(t){return Qe(t)})))};var e=/((https?)|(ftp)):\/\/[\w.]+[^ \f\n\r\t\v"\\<>[\]\u2100-\uFFFF(),]*/gi;return t}({}),Xe=O.linkify=function(t){function e(t){return'<a href="'+t+'">'+t+"</a>"}return function(t,n){n=n||e;var r=Je(t);return dt(r,(function(e){t=t.replace(new RegExp(Z(e),"g"),n)})),t}}(),Ye=O.query=function(t){t={parse:function(t){var n={};return t=Qe(t).replace(e,""),dt(t.split("&"),(function(t){var e=t.split("="),r=e.shift(),i=e.length>0?e.join("="):null;r=decodeURIComponent(r),i=decodeURIComponent(i),j(n[r])?n[r]=i:ot(n[r])?n[r].push(i):n[r]=[n[r],i]})),n},stringify:function(e,n){return ie(fe(e,(function(e,r){return S(e)&&wt(e)?"":ot(e)?t.stringify(e,r):(n?encodeURIComponent(n):encodeURIComponent(r))+"="+encodeURIComponent(e)})),(function(t){return t.length>0})).join("&")}};var e=/^(\?|#|&)/g;return t}({}),Ze=O.Url=function(t){t=de({className:"Url",initialize:function(e){!e&&N&&(e=window.location.href),ce(this,t.parse(e||""))},setQuery:function(t,e){var n=this.query;return S(t)?dt(t,(function(t,e){n[e]=t})):n[t]=e,this},rmQuery:function(t){var e=this.query;return ot(t)||(t=_e(t)),dt(t,(function(t){delete e[t]})),this},toString:function(){return t.stringify(this)}},{parse:function(t){var i={protocol:"",auth:"",hostname:"",hash:"",query:{},port:"",pathname:"",slashes:!1},o=Qe(t),a=!1,s=o.match(e);if(s&&(s=s[0],i.protocol=s.toLowerCase(),o=o.substr(s.length)),s&&(a="//"===o.substr(0,2))&&(o=o.slice(2),i.slashes=!0),a){for(var u=o,l=-1,c=0,h=r.length;c<h;c++){var p=o.indexOf(r[c]);-1!==p&&(-1===l||p<l)&&(l=p)}l>-1&&(u=o.slice(0,l),o=o.slice(l));var f=u.lastIndexOf("@");-1!==f&&(i.auth=decodeURIComponent(u.slice(0,f)),u=u.slice(f+1)),i.hostname=u;var _=u.match(n);_&&(":"!==(_=_[0])&&(i.port=_.substr(1)),i.hostname=u.substr(0,u.length-_.length))}var d=o.indexOf("#");-1!==d&&(i.hash=o.substr(d),o=o.slice(0,d));var v=o.indexOf("?");return-1!==v&&(i.query=Ye.parse(o.substr(v+1)),o=o.slice(0,v)),i.pathname=o||"/",i},stringify:function(t){var e=t.protocol+(t.slashes?"//":"")+(t.auth?encodeURIComponent(t.auth)+"@":"")+t.hostname+(t.port?":"+t.port:"")+t.pathname;return wt(t.query)||(e+="?"+Ye.stringify(t.query)),t.hash&&(e+=t.hash),e}});var e=/^([a-z0-9.+-]+:)/i,n=/:[0-9]*$/,r=["/","?","#"];return t}({}),tn=O.getFileName=function(t){var e=$(t.split("/"));return e.indexOf("?")>-1&&(e=Qe(e.split("?")[0])),""===e&&(e=(t=new Ze(t)).hostname),e},en=O.ajax=function(t){function e(t,e,n,r){return ct(e)&&(r=n,n=e,e={}),{url:t,data:e,success:n,dataType:r}}return(t=function(e){ue(e,t.setting);var n,r=e.type,i=e.url,o=e.data,a=e.dataType,s=e.success,u=e.error,l=e.timeout,c=e.complete,h=e.xhr();return h.onreadystatechange=function(){if(4===h.readyState){var t;clearTimeout(n);var e=h.status;if(e>=200&&e<300||304===e){t=h.responseText,"xml"===a&&(t=h.responseXML);try{"json"===a&&(t=JSON.parse(t))}catch(t){}s(t,h)}else u(h);c(h)}},"GET"===r?(o=Ye.stringify(o),i+=i.indexOf("?")>-1?"&"+o:"?"+o):"application/x-www-form-urlencoded"===e.contentType?S(o)&&(o=Ye.stringify(o)):"application/json"===e.contentType&&S(o)&&(o=JSON.stringify(o)),h.open(r,i,!0),h.setRequestHeader("Content-Type",e.contentType),l>0&&(n=setTimeout((function(){h.onreadystatechange=D,h.abort(),u(h,"timeout"),c(h)}),l)),h.send("GET"===r?null:o),h}).setting={type:"GET",success:D,error:D,complete:D,dataType:"json",contentType:"application/x-www-form-urlencoded",data:{},xhr:function(){return new XMLHttpRequest},timeout:0},t.get=function(){return t(e.apply(null,arguments))},t.post=function(){var n=e.apply(null,arguments);return n.type="POST",t(n)},t}({}),nn=O.sameOrigin=function(t,e){return t=new Ze(t),e=new Ze(e),t.port=0|t.port||("https"===t.protocol?443:80),e.port=0|e.port||("https"===e.protocol?443:80),t.protocol===e.protocol&&t.hostname===e.hostname&&t.port===e.port},rn=O.sortKeys=function(t){t=function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};ue(n,e);var r=n.deep,i=n.comparator,o=[],a=[];function s(t){var e,n=o.indexOf(t);if(n>-1)return a[n];if(ot(t)){e=[],o.push(t),a.push(e);for(var u=0,l=t.length;u<l;u++){var c=t[u];r&&S(c)?e[u]=s(c):e[u]=c}}else{e={},o.push(t),a.push(e);for(var h=T(t).sort(i),p=0,f=h.length;p<f;p++){var _=h[p],d=t[_];r&&S(d)?e[_]=s(d):e[_]=d}}return e}return s(t)};var e={deep:!1,comparator:Lt.defComparator};return t}({}),on=O.startWith=function(t,e){return 0===t.indexOf(e)},an=O.type=function(t){t=function(t){var n,r=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return null===t&&(n="Null"),void 0===t&&(n="Undefined"),Pt(t)&&(n="NaN"),kt(t)&&(n="Buffer"),n||(n=rt(t).match(e))&&(n=n[1]),n?r?zt(n):n:""};var e=/^\[object\s+(.*?)]$/;return t}({}),sn=O.stringify=function(t,e){return JSON.stringify(t,function(){var t=[],e=[];return function(n,r){if(t.length>0){var i=t.indexOf(this);i>-1?(t.splice(i+1),e.splice(i,1/0,n)):(t.push(this),e.push(n));var o=t.indexOf(r);o>-1&&(r=t[0]===r?"[Circular ~]":"[Circular ~."+e.slice(0,o).join(".")+"]")}else t.push(r);return It(r)||ct(r)?r="["+tt(an(r))+" "+q(r)+"]":j(r)&&(r=null),r}}(),e)},un=O.LocalStore=function(t){var e=Kt("local");return Fe.extend({initialize:function(t,n){this._name=t,n=n||{};var r=e.getItem(t);try{r=JSON.parse(r)}catch(t){r={}}S(r)||(r={}),n=ue(r,n),this.callSuper(Fe,"initialize",[n])},save:function(t){if(wt(t))return e.removeItem(this._name);e.setItem(this._name,sn(t))}})}(),ln=O.toSrc=function(t){t=function(t){if(Nt(t))return"";try{return e.call(t)}catch(t){}try{return t+""}catch(t){}return""};var e=Function.prototype.toString;return t}({}),cn=O.stringifyAll=function(t){function e(e,r,i,o){var a=[];return dt(r,(function(e){var r,s=Object.getOwnPropertyDescriptor(i,e),u=s&&s.get,l=s&&s.set;if(!o.accessGetter&&u)r="(...)";else try{if(r=i[e],yt(o.ignore,r))return;Mt(r)&&r.catch((function(){}))}catch(t){r=t.message}a.push("".concat(n(e),":").concat(t(r,o))),u&&a.push("".concat(n("get "+q(e)),":").concat(t(s.get,o))),l&&a.push("".concat(n("set "+q(e)),":").concat(t(s.set,o)))})),'"'.concat(e,'":{')+a.join(",")+"}"}function n(t){return'"'.concat(i(t),'"')}function r(t){return'"'.concat(i(q(t)),'"')}function i(t){return X(t).replace(/\\'/g,"'").replace(/\t/g,"\\t")}t=function(n){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=i.self,s=i.startTime,u=void 0===s?Zt():s,l=i.timeout,c=void 0===l?0:l,h=i.depth,p=void 0===h?0:h,f=i.curDepth,_=void 0===f?1:f,d=i.visitor,v=void 0===d?new o:d,g=i.unenumerable,m=void 0!==g&&g,b=i.symbol,y=void 0!==b&&b,w=i.accessGetter,x=void 0!==w&&w,O=i.ignore,$=void 0===O?[]:O,j="",S={visitor:v,unenumerable:m,symbol:y,accessGetter:x,depth:p,curDepth:_+1,timeout:c,startTime:u,ignore:$},E=an(n,!1);if("String"===E)j=r(n);else if("Number"===E)j=q(n),Q(j,"Infinity")&&(j='{"value":"'.concat(j,'","type":"Number"}'));else if("NaN"===E)j='{"value":"NaN","type":"Number"}';else if("Boolean"===E)j=n?"true":"false";else if("Null"===E)j="null";else if("Undefined"===E)j='{"type":"Undefined"}';else if("Symbol"===E){var A="Symbol";try{A=q(n)}catch(t){}j='{"value":'.concat(r(A),',"type":"Symbol"}')}else{if(c&&Zt()-u>c)return r("Timeout");if(p&&_>p)return r("{...}");j="{";var C,P=[],N=v.get(n);if(N?(C=N.id,P.push('"reference":'.concat(C))):(C=v.set(n),P.push('"id":'.concat(C))),P.push('"type":"'.concat(E,'"')),Q(E,"Function")?P.push('"value":'.concat(r(ln(n)))):"RegExp"===E&&P.push('"value":'.concat(r(n))),!N){var D=T(n);if(D.length&&P.push(e("enumerable",D,a||n,S)),m){var R=oe(se(n,{prototype:!1,unenumerable:!0}),D);R.length&&P.push(e("unenumerable",R,a||n,S))}if(y){var M=ie(se(n,{prototype:!1,symbol:!0}),(function(t){return"symbol"===k()(t)}));M.length&&P.push(e("symbol",M,a||n,S))}var I=ht(n);if(I&&!yt($,I)){var L='"proto":'.concat(t(I,ce(S,{self:a||n})));P.push(L)}}j+=P.join(",")+"}"}return j};var o=de({initialize:function(){this.id=0,this.visited=[]},set:function(t){var e=this.visited,n=this.id,r={id:n,val:t};return e.push(r),this.id++,n},get:function(t){for(var e=this.visited,n=0,r=e.length;n<r;n++){var i=e[n];if(t===i.val)return i}return!1}});return t}({}),hn=O.throttle=function(t,e){return U(t,e,!0)},pn=O.uncaught=function(t){var e=[],n=!1;function i(t){if(n)for(var r=0,i=e.length;r<i;r++)e[r](t)}return t={start:function(){n=!0},stop:function(){n=!1},addListener:function(t){e.push(t)},rmListener:function(t){var n=e.indexOf(t);n>-1&&e.splice(n,1)},rmAllListeners:function(){e=[]}},N?(window.addEventListener("error",(function(t){i(t.error)})),window.addEventListener("unhandledrejection",(function(t){i(t.reason)}))):(r.on("uncaughtException",i),r.on("unhandledRejection",i)),t}({}),fn=O.uniqId=(w=0,function(t){var e=++w+"";return t?t+e:e}),_n=O.viewportScale=function(){var t=Pe("viewport");if(!t)return 1;t=fe(t.split(","),(function(t){return Qe(t)}));var e=.25,n=5,r=1;dt(t,(function(t){var i=(t=t.split("="))[0];t=t[1],"initial-scale"===i&&(r=+t),"maximum-scale"===i&&(n=+t),"minimum-scale"===i&&(e=+t)}));var i=F(r,e,n);return Pt(i)?1:i},dn=O.wrap=function(t,e){return Ne(e,t)},vn=O.xpath=function(t){for(var e=[],n=document.evaluate(t,document,null,XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,null),r=0;r<n.snapshotLength;r++)e.push(n.snapshotItem(r));return e};e.p=O}).call(this,n(16),n(21),n(36).setImmediate)},function(t,e){function n(e){return t.exports=n=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},n(e)}t.exports=n},function(t,e){t.exports=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e){function n(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}t.exports=function(t,e,r){return e&&n(t.prototype,e),r&&n(t,r),t}},function(t,e,n){var r=n(38);function i(e,n,o){return"undefined"!=typeof Reflect&&Reflect.get?t.exports=i=Reflect.get:t.exports=i=function(t,e,n){var i=r(t,e);if(i){var o=Object.getOwnPropertyDescriptor(i,e);return o.get?o.get.call(n):o.value}},i(e,n,o||e)}t.exports=i},function(t,e,n){var r=n(31);t.exports=function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&r(t,e)}},function(t,e,n){var r=n(14),i=n(9);t.exports=function(t,e){return!e||"object"!==r(e)&&"function"!=typeof e?i(t):e}},function(t,e,n){var r=n(41);r.registerHelper("repeat",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1?arguments[1]:void 0;if(t<1)return e.inverse(this);var n=1,r=0,i=t*n+r,o=r,a="";do{var s={index:o,count:t,start:r,step:n,first:o===r,last:o>=i-n},u=[o,s];a+=e.fn(this,{data:s,blockParams:u}),o+=s.step}while(o<i);return a})),r.registerHelper("class",(function(t){var e=t.split(/\s+/);return e=e.map((function(t){return"eruda-".concat(t)})),'class="'.concat(e.join(" "),'"')})),r.registerHelper("concat",(function(){for(var t="",e=0,n=arguments.length;e<n;e++){var r=arguments[e];"string"==typeof r&&(t+=r)}return t})),t.exports=r},function(t,e,n){"use strict";t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=(a=r,s=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),u="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s),"/*# ".concat(u," */")),o=r.sources.map((function(t){return"/*# sourceURL=".concat(r.sourceRoot||"").concat(t," */")}));return[n].concat(o).concat([i]).join("\n")}var a,s,u;return[n].join("\n")}(e,t);return e[2]?"@media ".concat(e[2]," {").concat(n,"}"):n})).join("")},e.i=function(t,n,r){"string"==typeof t&&(t=[[null,t,""]]);var i={};if(r)for(var o=0;o<this.length;o++){var a=this[o][0];null!=a&&(i[a]=!0)}for(var s=0;s<t.length;s++){var u=[].concat(t[s]);r&&i[u[0]]||(n&&(u[2]?u[2]="".concat(n," and ").concat(u[2]):u[2]=n),e.push(u))}},e}},function(t,e){t.exports=function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(module,exports,__webpack_require__){var t;window,t=function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=69)}([function(t,e,n){var r=n(14),i=n(2),o=n(39);e=function(t,e,n){var a,s;if(e=o(e,n),r(t))for(a=0,s=t.length;a<s;a++)e(t[a],a,t);else{var u=i(t);for(a=0,s=u.length;a<s;a++)e(t[u[a]],u[a],t)}return t},t.exports=e},function(t,e,n){var r=n(7);e=function(t){return"[object String]"===r(t)},t.exports=e},function(t,e,n){var r=n(12);e=Object.keys?Object.keys:function(t){var e=[];for(var n in t)r(t,n)&&e.push(n);return e},t.exports=e},function(t,e){e=function(t){return void 0===t},t.exports=e},function(t,e,n){var r=n(7);e=function(t){var e=r(t);return"[object Function]"===e||"[object GeneratorFunction]"===e||"[object AsyncFunction]"===e},t.exports=e},function(t,e){e=function(t){var e=typeof t;return!!t&&("function"===e||"object"===e)},t.exports=e},function(t,e,n){var r=n(1),i=n(9),o=n(51);e=function(t){return i(r(t)?new o(t):t)},t.exports=e},function(t,e){var n=Object.prototype.toString;e=function(t){return n.call(t)},t.exports=e},function(t,e,n){var r=n(7);e=Array.isArray?Array.isArray:function(t){return"[object Array]"===r(t)},t.exports=e},function(t,e,n){var r=n(14),i=n(13),o=n(8),a=n(1);e=function(t){return t?o(t)?t:r(t)&&!a(t)?i(t):[t]:[]},t.exports=e},function(t,e,n){"use strict";var r,i=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return i(e,t),e.prototype.trigger=function(t,e){this.emit("message",JSON.stringify({method:t,params:e}))},e}(o(n(16)).default);e.default=new a},function(t,e,n){var r=n(92),i=n(93),o=/^\s+|\s+$/g;e=function(t,e){return null==e?t.replace(o,""):r(i(t,e),e)},t.exports=e},function(t,e){var n=Object.prototype.hasOwnProperty;e=function(t,e){return n.call(t,e)},t.exports=e},function(t,e,n){var r=n(20),i=n(2),o=n(14);e=function(t,e,n){e=r(e,n);for(var a=!o(t)&&i(t),s=(a||t).length,u=Array(s),l=0;l<s;l++){var c=a?a[l]:l;u[l]=e(t[c],c,t)}return u},t.exports=e},function(t,e,n){var r=n(18),i=n(4),o=Math.pow(2,53)-1;e=function(t){if(!t)return!1;var e=t.length;return r(e)&&e>=0&&e<=o&&!i(t)},t.exports=e},function(t,e){e=function(t,e){return 0===t.indexOf(e)},t.exports=e},function(t,e,n){var r=n(17),i=n(12),o=n(0),a=n(79),s=n(32);e=r({initialize:function(){this._events=this._events||{}},on:function(t,e){return this._events[t]=this._events[t]||[],this._events[t].push(e),this},off:function(t,e){var n=this._events;if(i(n,t)){var r=n[t].indexOf(e);return r>-1&&n[t].splice(r,1),this}},once:function(t,e){return this.on(t,s(e)),this},emit:function(t){if(i(this._events,t)){var e=a(arguments,1);return o(this._events[t],(function(t){t.apply(this,e)}),this),this}},removeAllListeners:function(t){return t?delete this._events[t]:this._events={},this}},{mixin:function(t){o(["on","off","once","emit"],(function(n){t[n]=e.prototype[n]})),t._events=t._events||{}}}),t.exports=e},function(t,e,n){var r=n(27),i=n(9),o=n(76),a=n(31),s=n(78),u=(e=function(t,e){return u.extend(t,e)}).Base=function t(e,n,u){u=u||{};var l=n.className||a(n,"initialize.name")||"";delete n.className;var c=function(){var t=i(arguments);return this.initialize&&this.initialize.apply(this,t)||this};if(!s)try{c=new Function("toArr","return function "+l+"(){var args = toArr(arguments);return this.initialize ? this.initialize.apply(this, args) || this : this;};")(i)}catch(t){}return o(c,e),c.prototype.constructor=c,c.extend=function(e,n){return t(c,e,n)},c.inherits=function(t){o(c,t)},c.methods=function(t){return r(c.prototype,t),c},c.statics=function(t){return r(c,t),c},c.methods(n).statics(u),c}(Object,{className:"Base",callSuper:function(t,e,n){return t.prototype[e].apply(this,n)},toString:function(){return this.constructor.name}});t.exports=e},function(t,e,n){var r=n(7);e=function(t){return"[object Number]"===r(t)},t.exports=e},function(t,e){e="object"==typeof window&&"object"==typeof document&&9===document.nodeType,t.exports=e},function(t,e,n){var r=n(4),i=n(5),o=n(8),a=n(39),s=n(70),u=n(73),l=n(74);e=function(t,e,n){return null==t?u:r(t)?a(t,e,n):i(t)&&!o(t)?s(t):l(t)},t.exports=e},function(t,e){e=function(){},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__assign||function(){return(r=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},i=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getProperties=e.releaseObj=e.getObj=e.wrap=e.clear=void 0;var o=i(n(46)),a=i(n(47)),s=i(n(8)),u=i(n(4)),l=i(n(34)),c=i(n(94)),h=i(n(95)),p=i(n(96)),f=i(n(2)),_=i(n(33)),d=i(n(29)),v=i(n(48)),g=i(n(40)),m=i(n(99)),b=i(n(12)),y=new Map,w=new Map,x=new Map,k=1;function O(t,e){var n=w.get(t);return n||(n=JSON.stringify({injectedScriptId:0,id:k++}),w.set(t,n),y.set(n,t),x.set(n,e),n)}function $(t,e){var n=void 0===e?{}:e,i=n.generatePreview,a=void 0!==i&&i,s=n.self,u=void 0===s?t:s,l=S(t),c=l.type,h=l.subtype;return"undefined"===c?l:"string"===c||"boolean"===c||"null"===h?(l.value=t,l):"number"===c?(l.description=o.default(t),l.value=t,l):"symbol"===c?(l.objectId=O(t,u),l.description=o.default(t),l):("function"===c?(l.className="Function",l.description=_.default(t)):"array"===h?(l.className="Array",l.description="Array("+t.length+")"):"regexp"===h?(l.className="RegExp",l.description=o.default(t)):"error"===h?(l.className=t.name,l.description=t.stack):(l.className=p.default(t,!1),l.description=l.className),a&&(l.preview=r(r({},l),function(t,e){var n=!1,r=[],i=f.default(t),a=i.length;a>5&&(a=5,n=!0);for(var s=0;s<a;s++){var u=i[s],l=e[u],c=S(l);c.name=u;var h,_=c.subtype;h="object"===c.type?"null"===_?"null":"array"===_?"Array("+l.length+")":p.default(l,!1):o.default(l),c.value=h,r.push(c)}return{overflow:n,properties:r}}(t,u))),l.objectId=O(t,u),l)}function j(t){return y.get(t)}function S(t){var e={type:typeof t};if(a.default(t))e.subtype="null";else if(s.default(t))e.subtype="array";else if(h.default(t))e.subtype="regexp";else if(c.default(t))e.subtype="error";else try{l.default(t)&&(e.subtype="node")}catch(t){}return e}e.clear=function(){y.clear(),w.clear(),x.clear()},e.wrap=$,e.getObj=j,e.releaseObj=function(t){var e=j(t);w.delete(e),x.delete(t),y.delete(t)},e.getProperties=function(t){for(var e=t.accessorPropertiesOnly,n=t.objectId,r=t.ownProperties,i=t.generatePreview,a=[],s={prototype:!r,unenumerable:!0,symbol:!e},l=y.get(n),c=x.get(n),h=d.default(l,s),p=g.default(l),f=0,_=h.length;f<_;f++){var w=h[f],k=void 0;try{k=c[w]}catch(t){}var O={name:o.default(w),isOwn:b.default(c,w)},j=Object.getOwnPropertyDescriptor(l,w);if(!j&&p&&(j=Object.getOwnPropertyDescriptor(p,w)),j){if(e&&!j.get&&!j.set)continue;O.configurable=j.configurable,O.enumerable=j.enumerable,O.writable=j.writable,j.get&&(O.get=$(j.get)),j.set&&(O.set=$(j.set))}p&&b.default(p,w)&&O.enumerable&&(O.isOwn=!0);var S=!0;!O.isOwn&&O.get&&(S=!1),S&&(m.default(w)?(O.symbol=$(w),O.value={type:"undefined"}):O.value=$(k,{generatePreview:i})),e&&u.default(k)&&v.default(k)||a.push(O)}return p&&a.push({name:"__proto__",configurable:!0,enumerable:!1,isOwn:b.default(l,"__proto__"),value:$(p,{self:c}),writable:!1}),{result:a}}},function(t,e,n){var r=n(105),i=n(1),o=n(14),a=n(106);e=function(t,e){return i(t)?t.indexOf(e)>-1:(o(t)||(t=a(t)),r(t,e)>=0)},t.exports=e},function(t,e){e=function(t){var e=t?t.length:0;if(e)return t[e-1]},t.exports=e},function(t,e,n){var r=n(14),i=n(8),o=n(1),a=n(122),s=n(2);e=function(t){return null==t||(r(t)&&(i(t)||o(t)||a(t))?0===t.length:0===s(t).length)},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=e.filterNodes=e.getPreviousNode=e.getChildNodes=e.wrap=e.getNodeId=e.clear=e.getOrCreateNodeId=void 0;var i=r(n(13)),o=r(n(30)),a=r(n(0)),s=r(n(11)),u=r(n(23)),l=new Map,c=new Map,h=1;function p(t){var e=c.get(t);return e||(e=h++,c.set(t,e),l.set(e,t),e)}function f(t,e){var n=(void 0===e?{}:e).depth,r=void 0===n?1:n,i=p(t),o={nodeName:t.nodeName,nodeType:t.nodeType,localName:t.localName||"",nodeValue:t.nodeValue||"",nodeId:i,backendNodeId:i};if(t.parentNode&&(o.parentId=p(t.parentNode)),t.attributes){var s=[];a.default(t.attributes,(function(t){var e=t.name,n=t.value;return s.push(e,n)})),o.attributes=s}var u=d(t.childNodes);o.childNodeCount=u.length;var l=1===o.childNodeCount&&3===u[0].nodeType;return(r>0||l)&&(o.children=_(t,r)),o}function _(t,e){var n=d(t.childNodes);return i.default(n,(function(t){return f(t,{depth:e-1})}))}function d(t){return o.default(t,(function(t){return v(t)}))}function v(t){if(1===t.nodeType){var e=t.getAttribute("class")||"";if(u.default(e,"__chii-hide__"))return!1}return!(3===t.nodeType&&""===s.default(t.nodeValue||""))}e.getOrCreateNodeId=p,e.clear=function(){l.clear(),c.clear()},e.getNodeId=function(t){return c.get(t)},e.wrap=f,e.getChildNodes=_,e.getPreviousNode=function(t){var e=t.previousSibling;if(e){for(;!v(e)&&e.previousSibling;)e=e.previousSibling;return e&&v(e)?e:void 0}},e.filterNodes=d,e.getNode=function(t){return l.get(t)}},function(t,e,n){e=n(28)(n(29)),t.exports=e},function(t,e,n){var r=n(3),i=n(0);e=function(t,e){return function(n){return i(arguments,(function(o,a){if(0!==a){var s=t(o);i(s,(function(t){e&&!r(n[t])||(n[t]=o[t])}))}})),n}},t.exports=e},function(t,e,n){var r=n(2),i=n(40),o=n(41),a=Object.getOwnPropertyNames,s=Object.getOwnPropertySymbols;e=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.prototype,u=void 0===n||n,l=e.unenumerable,c=void 0!==l&&l,h=e.symbol,p=void 0!==h&&h,f=[];if((c||p)&&a){var _=r;c&&a&&(_=a);do{f=f.concat(_(t)),p&&s&&(f=f.concat(s(t)))}while(u&&(t=i(t))&&t!==Object.prototype);f=o(f)}else if(u)for(var d in t)f.push(d);else f=r(t);return f},t.exports=e},function(t,e,n){var r=n(20),i=n(0);e=function(t,e,n){var o=[];return e=r(e,n),i(t,(function(t,n,r){e(t,n,r)&&o.push(t)})),o},t.exports=e},function(t,e,n){var r=n(3),i=n(75);e=function(t,e){var n;for(n=(e=i(e,t)).shift();!r(n);){if(null==(t=t[n]))return;n=e.shift()}return t},t.exports=e},function(t,e,n){e=n(80)(n(81),2),t.exports=e},function(t,e,n){var r=n(88);e=function(t){if(r(t))return"";try{return i.call(t)}catch(t){}try{return t+""}catch(t){}return""};var i=Function.prototype.toString;t.exports=e},function(t,e){e=function(t){return!(!t||1!==t.nodeType)},t.exports=e},function(t,e,n){var r=n(46);e=function(t){return r(t).toLocaleLowerCase()},t.exports=e},function(t,e,n){var r=n(51),i=n(103),o=n(104),a=n(52),s=n(56),u=n(110),l=n(24),c=n(111),h=n(112),p=n(113),f=n(57),_=n(116),d=n(3),v=n(1);e=function(t){return new r(t)},r.methods({offset:function(){return i(this)},hide:function(){return this.css("display","none")},show:function(){return o(this),this},first:function(){return e(this[0])},last:function(){return e(l(this))},get:function(t){return this[t]},eq:function(t){return e(this[t])},on:function(t,e,n){return p.on(this,t,e,n),this},off:function(t,e,n){return p.off(this,t,e,n),this},html:function(t){var e=u.html(this,t);return d(t)?e:this},text:function(t){var e=u.text(this,t);return d(t)?e:this},val:function(t){var e=u.val(this,t);return d(t)?e:this},css:function(t,e){var n=a(this,t,e);return g(t,e)?n:this},attr:function(t,e){var n=s(this,t,e);return g(t,e)?n:this},data:function(t,e){var n=h(this,t,e);return g(t,e)?n:this},rmAttr:function(t){return s.remove(this,t),this},remove:function(){return c(this),this},addClass:function(t){return f.add(this,t),this},rmClass:function(t){return f.remove(this,t),this},toggleClass:function(t){return f.toggle(this,t),this},hasClass:function(t){return f.has(this,t)},parent:function(){return e(this[0].parentNode)},append:function(t){return _.append(this,t),this},prepend:function(t){return _.prepend(this,t),this},before:function(t){return _.before(this,t),this},after:function(t){return _.after(this,t),this}});var g=function(t,e){return d(e)&&v(t)};t.exports=e},function(t,e,n){e=n(28)(n(29),!0),t.exports=e},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.createId=void 0;var i=r(n(123)),o=r(n(43)).default(1e3,9999)+".";e.createId=function(){return i.default(o)}},function(t,e,n){var r=n(3);e=function(t,e,n){if(r(e))return t;switch(null==n?3:n){case 1:return function(n){return t.call(e,n)};case 3:return function(n,r,i){return t.call(e,n,r,i)};case 4:return function(n,r,i,o){return t.call(e,n,r,i,o)}}return function(){return t.apply(e,arguments)}},t.exports=e},function(t,e,n){var r=n(5),i=n(4),o=Object.getPrototypeOf,a={}.constructor;e=function(t){if(r(t)){if(o)return o(t);var e=t.__proto__;return e||null===e?e:i(t.constructor)?t.constructor.prototype:t instanceof a?a.prototype:void 0}},t.exports=e},function(t,e,n){var r=n(30);function i(t,e){return t===e}e=function(t,e){return e=e||i,r(t,(function(t,n,r){for(var i=r.length;++n<i;)if(e(t,r[n]))return!1;return!0}))},t.exports=e},function(t,e){e=function(t,e){return e=null==e?t.length-1:+e,function(){var n,r=Math.max(arguments.length-e,0),i=new Array(r);for(n=0;n<r;n++)i[n]=arguments[n+e];switch(e){case 0:return t.call(this,i);case 1:return t.call(this,arguments[0],i);case 2:return t.call(this,arguments[0],arguments[1],i)}var o=new Array(e+1);for(n=0;n<e;n++)o[n]=arguments[n];return o[e]=i,t.apply(this,o)}},t.exports=e},function(t,e){e=function(t,e,n){null==e&&(e=t,t=0);var r=Math.random();return n||t%1||e%1?Math.min(t+r*(e-t+parseFloat("1e-"+((r+"").length-1))),e):t+Math.floor(r*(e-t+1))},t.exports=e},function(t,e){var n,r,i=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{r="function"==typeof clearTimeout?clearTimeout:a}catch(t){r=a}}();var u,l=[],c=!1,h=-1;function p(){c&&u&&(c=!1,u.length?l=u.concat(l):h=-1,l.length&&f())}function f(){if(!c){var t=s(p);c=!0;for(var e=l.length;e;){for(u=l,l=[];++h<e;)u&&u[h].run();h=-1,e=l.length}u=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function _(t,e){this.fun=t,this.array=e}function d(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];l.push(new _(t,e)),1!==l.length||c||s(f)},_.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=d,i.addListener=d,i.once=d,i.off=d,i.removeListener=d,i.removeAllListeners=d,i.emit=d,i.prependListener=d,i.prependOnceListener=d,i.listeners=function(t){return[]},i.binding=function(t){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(t){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(t,e){e=Date.now?Date.now:function(){return(new Date).getTime()},t.exports=e},function(t,e){e=function(t){return null==t?"":t.toString()},t.exports=e},function(t,e){e=function(t){return null===t},t.exports=e},function(t,e,n){var r=n(5),i=n(4),o=n(33);e=function(t){return!!r(t)&&(i(t)?s.test(o(t)):u.test(o(t)))};var a=Object.prototype.hasOwnProperty,s=new RegExp("^"+o(a).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),u=/^\[object .+?Constructor\]$/;t.exports=e},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.setGlobal=void 0;var i=r(n(1)),o=r(n(100)),a=r(n(9)),s=r(n(2)),u=r(n(50)),l=r(n(0)),c={copy:function(t){i.default(t)||(t=JSON.stringify(t,null,2)),o.default(t)},$:function(t){return document.querySelector(t)},$$:function(t){return a.default(document.querySelectorAll(t))},$x:function(t){return u.default(t)},keys:s.default};e.setGlobal=function(t,e){c[t]=e},e.default=function(t){var e;l.default(c,(function(t,e){window[e]||(window[e]=t)}));try{e=eval.call(window,"("+t+")")}catch(n){e=eval.call(window,t)}return l.default(c,(function(t,e){window[e]&&window[e]===t&&delete window[e]})),e}},function(t,e){e=function(t){for(var e=[],n=document.evaluate(t,document,null,XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,null),r=0;r<n.snapshotLength;r++)e.push(n.snapshotItem(r));return e},t.exports=e},function(t,e,n){var r=n(17),i=n(1),o=n(0),a=n(102),s=new(e=r({className:"Select",initialize:function(t){return this.length=0,t?i(t)?s.find(t):void(t.nodeType&&(this[0]=t,this.length=1)):this},find:function(t){var n=new e;return this.each((function(){a(n,this.querySelectorAll(t))})),n},each:function(t){return o(this,(function(e,n){t.call(e,n,e)})),this}}))(document);t.exports=e},function(t,e,n){var r=n(1),i=n(5),o=n(53),a=n(3),s=n(23),u=n(18),l=n(6),c=n(107),h=n(0);e=function(t,e,n){if(t=l(t),a(n)&&r(e))return function(t,e){return t.style[c(e)]||getComputedStyle(t,"").getPropertyValue(e)}(t[0],e);var f=e;i(f)||((f={})[e]=n),function(t,e){h(t,(function(t){var n=";";h(e,(function(t,e){e=c.dash(e),n+=e+":"+function(t,e){return u(e)&&!s(p,o(t))?e+"px":e}(e,t)+";"})),t.style.cssText+=n}))}(t,f)};var p=["column-count","columns","font-weight","line-weight","opacity","z-index","zoom"];t.exports=e},function(t,e,n){var r=n(54);e=function(t){return r(t).join("-")},t.exports=e},function(t,e){var n=/([A-Z])/g,r=/[_.\- ]+/g,i=/(^-)|(-$)/g;e=function(t){return(t=t.replace(n,"-$1").toLowerCase().replace(r,"-").replace(i,"")).split("-")},t.exports=e},function(t,e,n){var r=n(12);e=function(t,e){var n=function(i){var o=n.cache,a=""+(e?e.apply(this,arguments):i);return r(o,a)||(o[a]=t.apply(this,arguments)),o[a]};return n.cache={},n},t.exports=e},function(t,e,n){var r=n(9),i=n(5),o=n(1),a=n(0),s=n(3),u=n(6);(e=function(t,e,n){if(t=u(t),s(n)&&o(e))return function(t,e){return t.getAttribute(e)}(t[0],e);var r=e;i(r)||((r={})[e]=n),function(t,e){a(t,(function(t){a(e,(function(e,n){t.setAttribute(n,e)}))}))}(t,r)}).remove=function(t,e){t=u(t),e=r(e),a(t,(function(t){a(e,(function(e){t.removeAttribute(e)}))}))},t.exports=e},function(t,e,n){var r=n(9),i=n(115),o=n(6),a=n(1),s=n(0);function u(t){return a(t)?t.split(/\s+/):r(t)}e={add:function(t,n){t=o(t);var r=u(n);s(t,(function(t){var n=[];s(r,(function(r){e.has(t,r)||n.push(r)})),0!==n.length&&(t.className+=(t.className?" ":"")+n.join(" "))}))},has:function(t,e){t=o(t);var n=new RegExp("(^|\\s)"+e+"(\\s|$)");return i(t,(function(t){return n.test(t.className)}))},toggle:function(t,n){t=o(t),s(t,(function(t){if(!e.has(t,n))return e.add(t,n);e.remove(t,n)}))},remove:function(t,e){t=o(t);var n=u(e);s(t,(function(t){s(n,(function(e){t.classList.remove(e)}))}))}},t.exports=e},function(t,e,n){"use strict";var r,i=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.fullUrl=e.FetchRequest=e.XhrRequest=void 0;var a=o(n(16)),s=o(n(1)),u=o(n(24)),l=o(n(120)),c=o(n(25)),h=o(n(11)),p=o(n(45)),f=o(n(0)),_=o(n(15)),d=o(n(59)),v=n(38),g=function(t){function e(e,n,r){var i=t.call(this)||this;return i.xhr=e,i.reqHeaders={},i.method=n,i.url=O(r),i.id=v.createId(),i}return i(e,t),e.prototype.handleSend=function(t){s.default(t)||(t=""),t={name:$(this.url),url:this.url,data:t,time:p.default(),reqHeaders:this.reqHeaders,method:this.method},c.default(this.reqHeaders)||(t.reqHeaders=this.reqHeaders),this.emit("send",this.id,t)},e.prototype.handleReqHeadersSet=function(t,e){t&&e&&(this.reqHeaders[t]=e)},e.prototype.handleHeadersReceived=function(){var t=this.xhr,e=j(t.getResponseHeader("Content-Type")||"");this.emit("headersReceived",this.id,{type:e.type,subType:e.subType,size:x(t,!0,this.url),time:p.default(),resHeaders:w(t)})},e.prototype.handleDone=function(){var t,e,n,r=this,i=this.xhr,o=i.responseType,a="",s=function(){r.emit("done",r.id,{status:i.status,size:x(i,!1,r.url),time:p.default(),resTxt:a})},u=j(i.getResponseHeader("Content-Type")||"");"blob"!==o||"text"!==u.type&&"javascript"!==u.subType&&"json"!==u.subType?(""!==o&&"text"!==o||(a=i.responseText),"json"===o&&(a=JSON.stringify(i.response)),s()):(t=i.response,e=function(t,e){e&&(a=e),s()},(n=new FileReader).onload=function(){e(0,n.result)},n.onerror=function(t){e()},n.readAsText(t))},e}(a.default);e.XhrRequest=g;var m=function(t){function e(e,n){void 0===n&&(n={});var r=t.call(this)||this;return e instanceof window.Request&&(e=e.url),r.url=O(e),r.id=v.createId(),r.options=n,r.reqHeaders=n.headers||{},r.method=n.method||"GET",r}return i(e,t),e.prototype.send=function(t){var e=this,n=this.options,r=s.default(n.body)?n.body:"";this.emit("send",this.id,{name:$(this.url),url:this.url,data:r,reqHeaders:this.reqHeaders,time:p.default(),method:this.method}),t.then((function(t){var n=j((t=t.clone()).headers.get("Content-Type"));return t.text().then((function(r){var i={type:n.type,subType:n.subType,time:p.default(),size:b(t,r),resTxt:r,resHeaders:y(t),status:t.status};c.default(e.reqHeaders)||(i.reqHeaders=e.reqHeaders),e.emit("done",e.id,i)})),t}))},e}(a.default);function b(t,e){var n=t.headers.get("Content-length");return n?d.default(n):E(e)}function y(t){var e={};return t.headers.forEach((function(t,n){return e[n]=t})),e}function w(t){var e=t.getAllResponseHeaders().split("\n"),n={};return f.default(e,(function(t){if(""!==(t=h.default(t))){var e=t.split(":",2),r=e[0],i=e[1];n[r]=h.default(i)}})),n}function x(t,e,n){var r=0;function i(){if(!e){var n=t.responseType,i="";""!==n&&"text"!==n||(i=t.responseText),i&&(r=E(i))}}if(function(t){return!_.default(t,S)}(n))i();else try{r=d.default(t.getResponseHeader("Content-Length"))}catch(t){i()}return 0===r&&i(),r}e.FetchRequest=m;var k=document.createElement("a");function O(t){return k.href=t,k.protocol+"//"+k.host+k.pathname+k.search+k.hash}function $(t){var e=u.default(t.split("/"));return e.indexOf("?")>-1&&(e=h.default(e.split("?")[0])),""===e&&(e=new l.default(t).hostname),e}function j(t){if(!t)return{type:"unknown",subType:"unknown"};var e=t.split(";")[0].split("/");return{type:e[0],subType:u.default(e)}}e.fullUrl=O;var S=window.location.origin;function E(t){var e=encodeURIComponent(t).match(/%[89ABab]/g);return t.length+(e?e.length:0)}},function(t,e,n){var r=n(18),i=n(5),o=n(4),a=n(1);e=function(t){if(r(t))return t;if(i(t)){var e=o(t.valueOf)?t.valueOf():t;t=i(e)?e+"":e}return a(t)?+t:0===t?t:+t},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),i=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),o=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&r(e,t,n);return i(e,t),e},a=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.setOuterHTML=e.setNodeValue=e.setInspectedNode=e.setAttributeValue=e.setAttributesAsText=e.resolveNode=e.requestNode=e.requestChildNodes=e.removeNode=e.pushNodesByBackendIdsToFrontend=e.discardSearchResults=e.pushNodesToFrontend=e.getSearchResults=e.performSearch=e.moveTo=e.getOuterHTML=e.getDocument=e.enable=e.copyTo=e.collectClassNamesFromSubtree=void 0;var s=a(n(10)),u=o(n(26)),l=n(26),c=o(n(22)),h=a(n(61)),p=a(n(36)),f=a(n(47)),_=a(n(25)),d=a(n(124)),v=a(n(13)),g=a(n(41)),m=n(49),b=a(n(23)),y=n(38),w=a(n(35)),x=a(n(0)),k=a(n(9)),O=a(n(50)),$=a(n(62));e.collectClassNamesFromSubtree=function(t){var e=l.getNode(t.nodeId),n=[];return A(e,(function(t){if(1===t.nodeType){var e=t.getAttribute("class");if(e)for(var r=0,i=e.split(/\s+/);r<i.length;r++){var o=i[r];n.push(o)}}})),{classNames:g.default(n)}},e.copyTo=function(t){var e=t.nodeId,n=t.targetNodeId,r=l.getNode(e),i=l.getNode(n),o=r.cloneNode(!0);i.appendChild(o)},e.enable=function(){h.default.observe(),u.clear()},e.getDocument=function(){return{root:u.wrap(document,{depth:2})}},e.getOuterHTML=function(t){return{outerHTML:l.getNode(t.nodeId).outerHTML}},e.moveTo=function(t){var e=t.nodeId,n=t.targetNodeId,r=l.getNode(e);l.getNode(n).appendChild(r)};var j=new Map;function S(t){for(var e=[t],n=t.parentNode;n&&(e.push(n),!(i=l.getNodeId(n)));)n=n.parentNode;for(;e.length;){var r=e.pop(),i=l.getNodeId(r);s.default.trigger("DOM.setChildNodes",{parentId:i,nodes:u.getChildNodes(r,1)})}return l.getNodeId(t)}e.performSearch=function(t){var e=w.default(t.query),n=[];try{n=$.default(n,k.default(document.querySelectorAll(e)))}catch(t){}try{n=$.default(n,O.default(e))}catch(t){}A(document,(function(t){var r=t.nodeType;if(1===r){var i=t.localName;if(b.default("<"+i+" ",e)||b.default("</"+i+">",e))return void n.push(t);var o=[];x.default(t.attributes,(function(t){var e=t.name,n=t.value;return o.push(e,n)}));for(var a=0,s=o.length;a<s;a++)if(b.default(w.default(o[a]),e)){n.push(t);break}}else 3===r&&b.default(w.default(t.nodeValue),e)&&n.push(t)}));var r=y.createId();return j.set(r,n),{searchId:r,resultCount:n.length}},e.getSearchResults=function(t){var e=t.searchId,n=t.fromIndex,r=t.toIndex,i=j.get(e).slice(n,r);return{nodeIds:v.default(i,(function(t){return l.getNodeId(t)||S(t)}))}},e.pushNodesToFrontend=S,e.discardSearchResults=function(t){j.delete(t.searchId)},e.pushNodesByBackendIdsToFrontend=function(t){return{nodeIds:t.backendNodeIds}},e.removeNode=function(t){var e=l.getNode(t.nodeId);p.default(e).remove()},e.requestChildNodes=function(t){var e=t.nodeId,n=t.depth,r=void 0===n?1:n,i=l.getNode(e);s.default.trigger("DOM.setChildNodes",{parentId:e,nodes:u.getChildNodes(i,r)})},e.requestNode=function(t){var e=c.getObj(t.objectId);return{nodeId:l.getNodeId(e)}},e.resolveNode=function(t){var e=l.getNode(t.nodeId);return{object:c.wrap(e)}},e.setAttributesAsText=function(t){var e,n=t.name,r=t.text,i=t.nodeId,o=l.getNode(i);n&&o.removeAttribute(n),p.default(o).attr((e="<div "+(e=r)+"></div>",d.default.parse(e)[0].attrs))},e.setAttributeValue=function(t){var e=t.nodeId,n=t.name,r=t.value;l.getNode(e).setAttribute(n,r)};var E=[];function A(t,e){for(var n=u.filterNodes(t.childNodes),r=0,i=n.length;r<i;r++){var o=n[r];e(o),A(o,e)}}e.setInspectedNode=function(t){var e=l.getNode(t.nodeId);E.unshift(e),E.length>5&&E.pop();for(var n=0;n<5;n++)m.setGlobal("$"+n,E[n])},e.setNodeValue=function(t){var e=t.nodeId,n=t.value;l.getNode(e).nodeValue=n},e.setOuterHTML=function(t){var e=t.nodeId,n=t.outerHTML;l.getNode(e).outerHTML=n},h.default.on("attributes",(function(t,e){var n=l.getNodeId(t);if(n){var r=t.getAttribute(e);f.default(r)?s.default.trigger("DOM.attributeRemoved",{nodeId:n,name:e}):s.default.trigger("DOM.attributeModified",{nodeId:n,name:e,value:r})}})),h.default.on("childList",(function(t,e,n){var r=l.getNodeId(t);if(r){if(!_.default(e)){f();for(var i=0,o=e.length;i<o;i++){var a=e[i],c=u.getPreviousNode(a),h=c?l.getNodeId(c):0,p={node:u.wrap(a,{depth:0}),parentNodeId:r,previousNodeId:h};s.default.trigger("DOM.childNodeInserted",p)}}if(!_.default(n))for(i=0,o=n.length;i<o;i++){if(a=n[i],!l.getNodeId(a)){f();break}s.default.trigger("DOM.childNodeRemoved",{nodeId:l.getNodeId(a),parentNodeId:r})}}function f(){s.default.trigger("DOM.childNodeCountUpdated",{childNodeCount:u.wrap(t,{depth:0}).childNodeCount,nodeId:r})}})),h.default.on("characterData",(function(t){var e=l.getNodeId(t);e&&s.default.trigger("DOM.characterDataModified",{characterData:t.nodeValue,nodeId:e})}))},function(t,e,n){"use strict";var r,i=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var a=o(n(16)),s=o(n(0)),u=function(t){function e(){var e=t.call(this)||this;return e.observer=new MutationObserver((function(t){s.default(t,(function(t){return e.handleMutation(t)}))})),e}return i(e,t),e.prototype.observe=function(){var t=this.observer;t.disconnect(),t.observe(document.documentElement,{attributes:!0,childList:!0,characterData:!0,subtree:!0})},e.prototype.handleMutation=function(t){"attributes"===t.type?this.emit("attributes",t.target,t.attributeName):"childList"===t.type?this.emit("childList",t.target,t.addedNodes,t.removedNodes):"characterData"===t.type&&this.emit("characterData",t.target)},e}(a.default);e.default=new u},function(t,e,n){var r=n(9);e=function(){for(var t=r(arguments),e=[],n=0,i=t.length;n<i;n++)e=e.concat(r(t[n]));return e},t.exports=e},function(t,e,n){var r=n(133);e=function(t){var e;switch(t=t||"local"){case"local":e=window.localStorage;break;case"session":e=window.sessionStorage}try{var n="test-localStorage-"+Date.now();e.setItem(n,n);var i=e.getItem(n);if(e.removeItem(n),i!==n)throw new Error}catch(t){return r}return e},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__spreadArrays||function(){for(var t=0,e=0,n=arguments.length;e<n;e++)t+=arguments[e].length;var r=Array(t),i=0;for(e=0;e<n;e++)for(var o=arguments[e],a=0,s=o.length;a<s;a++,i++)r[i]=o[a];return r},i=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getResponseBody=e.enable=e.getCookies=e.deleteCookies=void 0;var o=i(n(11)),a=i(n(0)),s=i(n(65)),u=i(n(67)),l=i(n(32)),c=i(n(48)),h=n(58),p=i(n(10));e.deleteCookies=function(t){u.default(t.name)},e.getCookies=function(){var t=[],e=document.cookie;return""!==o.default(e)&&a.default(e.split(";"),(function(e){e=e.split("=");var n=o.default(e.shift());e=s.default(e.join("=")),t.push({name:n,value:e})})),{cookies:t}};var f=new Map;e.enable=l.default((function(){var t=window.XMLHttpRequest.prototype,e=t.send,n=t.open,i=t.setRequestHeader;t.open=function(t,e){var r=this,i=r.chiiRequest=new h.XhrRequest(r,t,e);i.on("send",(function(t,e){var n={method:e.method,url:e.url,headers:e.reqHeaders};e.data&&(n.postData=e.data),p.default.trigger("Network.requestWillBeSent",{requestId:t,type:"XHR",request:n,timestamp:e.time/1e3})})),i.on("headersReceived",(function(t,e){p.default.trigger("Network.responseReceivedExtraInfo",{requestId:t,blockedCookies:[],headers:e.resHeaders})})),i.on("done",(function(t,e){p.default.trigger("Network.responseReceived",{requestId:t,type:"XHR",response:{status:e.status},timestamp:e.time/1e3}),f.set(t,e.resTxt),p.default.trigger("Network.loadingFinished",{requestId:t,encodedDataLength:e.size,timestamp:e.time/1e3})})),r.addEventListener("readystatechange",(function(){switch(r.readyState){case 2:return i.handleHeadersReceived();case 4:return i.handleDone()}})),n.apply(this,arguments)},t.send=function(t){var n=this.chiiRequest;n&&n.handleSend(t),e.apply(this,arguments)},t.setRequestHeader=function(t,e){var n=this.chiiRequest;n&&n.handleReqHeadersSet(t,e),i.apply(this,arguments)};var o=!1;if(window.fetch&&(o=c.default(window.fetch)),o){var a=window.fetch;window.fetch=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n=new(h.FetchRequest.bind.apply(h.FetchRequest,r([void 0],t)));n.on("send",(function(t,e){var n={method:e.method,url:e.url,headers:e.reqHeaders};e.data&&(n.postData=e.data),p.default.trigger("Network.requestWillBeSent",{requestId:t,type:"Fetch",request:n,timestamp:e.time/1e3})})),n.on("done",(function(t,e){p.default.trigger("Network.responseReceived",{requestId:t,type:"Fetch",response:{status:e.status,headers:e.resHeaders},timestamp:e.time/1e3}),f.set(t,e.resTxt),p.default.trigger("Network.loadingFinished",{requestId:t,encodedDataLength:e.size,timestamp:e.time/1e3})}));var i=a.apply(void 0,t);return n.send(i),i}}})),e.getResponseBody=function(t){return{base64Encoded:!1,body:f.get(t.requestId)}}},function(t,e,n){var r=n(0),i=n(66),o=n(13),a=n(135);function s(t){return+("0x"+t)}e=function(t){try{return decodeURIComponent(t)}catch(n){var e=t.match(u);return e?(r(e,(function(e){t=t.replace(e,function(t){t=t.split("%").slice(1);var e=o(t,s);return t=i.encode(e),a.decode(t,!0)}(e))})),t):t}};var u=/(%[a-f0-9]{2})+/gi;t.exports=e},function(t,e){e={encode:function(t){return String.fromCodePoint.apply(String,t)},decode:function(t){for(var e=[],n=0,r=t.length;n<r;){var i=t.charCodeAt(n++);if(i>=55296&&i<=56319&&n<r){var o=t.charCodeAt(n++);56320==(64512&o)?e.push(((1023&i)<<10)+(1023&o)+65536):(e.push(i),n--)}else e.push(i)}return e}},t.exports=e},function(t,e,n){var r=n(136);e=function(t){var e,n=window.location,i=n.hostname,o=n.pathname,a=i.split("."),s=o.split("/"),u="",l=s.length;if(!_())for(var c=a.length-1;c>=0;c--){var h=a[c];if(""!==h){if(_({domain:u=""===u?h:h+"."+u,path:e="/"})||_({domain:u}))return;for(var p=0;p<l;p++){var f=s[p];if(""!==f){if(_({domain:u,path:e+=f})||_({path:e}))return;if(_({domain:u,path:e+="/"})||_({path:e}))return}}}}function _(e){return e=e||{},r.remove(t,e),!r.get(t)}},t.exports=e},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.get=void 0;var r={scriptId:"1",startColumn:0,startLine:0,endColumn:1e5,endLine:1e5,scriptLanguage:"JavaScript",url:""};e.get=function(){return r}},function(t,e,n){"use strict";var r=this&&this.__awaiter||function(t,e,n,r){return new(n||(n=Promise))((function(i,o){function a(t){try{u(r.next(t))}catch(t){o(t)}}function s(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){var e;t.done?i(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(a,s)}u((r=r.apply(t,e||[])).next())}))},i=this&&this.__generator||function(t,e){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=e.call(t,a)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}},o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var a=o(n(10)),s=o(n(21)),u=o(n(82)),l=o(n(85)),c=o(n(0)),h=o(n(16)),p=function(){function t(){var t=this;this.resolves=new Map,this.domains=new Map,this.onMessage=s.default,a.default.on("message",(function(e){var n=JSON.parse(e),r=t.resolves.get(n.id);if(r&&r(n.result),!n.id){var i=n.method.split("."),o=i[0],a=i[1],s=t.domains.get(o);s&&s.emit(a,n.params)}t.onMessage(e)})),this.initDomains()}return t.prototype.domain=function(t){return this.domains.get(t)},t.prototype.setOnMessage=function(t){this.onMessage=t},t.prototype.sendMessage=function(t,e){var n=this;void 0===e&&(e={});var r=u.default();return this.sendRawMessage(JSON.stringify({id:r,method:t,params:e})),new Promise((function(t){n.resolves.set(r,t)}))},t.prototype.sendRawMessage=function(t){return r(this,void 0,void 0,(function(){var e,n,r,o,s,u,l;return i(this,(function(i){switch(i.label){case 0:e=JSON.parse(t),n=e.method,r=e.params,o=e.id,s={id:o},i.label=1;case 1:return i.trys.push([1,3,,4]),u=s,[4,this.callMethod(n,r)];case 2:return u.result=i.sent(),[3,4];case 3:return l=i.sent(),s.error={message:l.message},[3,4];case 4:return a.default.emit("message",JSON.stringify(s)),[2]}}))}))},t.prototype.initDomains=function(){var t=this.domains;c.default(l.default,(function(e,n){var r=n.split("."),i=r[0],o=r[1],a=t.get(i);a||(a={},h.default.mixin(a)),a[o]=e,t.set(i,a)}))},t.prototype.callMethod=function(t,e){return r(this,void 0,void 0,(function(){return i(this,(function(n){if(l.default[t])return[2,l.default[t](e)||{}];throw Error(t+" unimplemented")}))}))},t}();t.exports=new p},function(t,e,n){var r=n(71),i=n(72);e=function(t){return t=r({},t),function(e){return i(e,t)}},t.exports=e},function(t,e,n){var r=n(2);e=n(28)(r),t.exports=e},function(t,e,n){var r=n(2);e=function(t,e){var n=r(e),i=n.length;if(null==t)return!i;t=Object(t);for(var o=0;o<i;o++){var a=n[o];if(e[a]!==t[a]||!(a in t))return!1}return!0},t.exports=e},function(t,e){e=function(t){return t},t.exports=e},function(t,e,n){var r=n(8),i=n(31);e=function(t){return r(t)?function(e){return i(e,t)}:(e=t,function(t){return null==t?void 0:t[e]});var e},t.exports=e},function(t,e,n){var r=n(12),i=n(8);e=function(t,e){if(i(t))return t;if(e&&r(e,t))return[t];var n=[];return t.replace(o,(function(t,e,r,i){n.push(r?i.replace(a,"$1"):e||t)})),n};var o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,a=/\\(\\)?/g;t.exports=e},function(t,e,n){var r=n(77);e=function(t,e){t.prototype=r(e.prototype)},t.exports=e},function(t,e,n){var r=n(5);e=function(t){if(!r(t))return{};if(i)return i(t);function e(){}return e.prototype=t,new e};var i=Object.create;t.exports=e},function(t,e,n){var r=n(4);e="undefined"!=typeof wx&&r(wx.openLocation),t.exports=e},function(t,e){e=function(t,e,n){var r=t.length;e=null==e?0:e<0?Math.max(r+e,0):Math.min(e,r),n=null==n?r:n<0?Math.max(r+n,0):Math.min(n,r);for(var i=[];e<n;)i.push(t[e++]);return i},t.exports=e},function(t,e,n){var r=n(42),i=n(9);e=r((function(t,e){return function(){var n=[];return n=(n=n.concat(e)).concat(i(arguments)),t.apply(this,n)}})),t.exports=e},function(t,e){e=function(t,e){var n;return function(){return--t>0&&(n=e.apply(this,arguments)),t<=1&&(e=null),n}},t.exports=e},function(t,e,n){var r=n(83);e=function(){var t=r(16);return t[6]=15&t[6]|64,t[8]=63&t[8]|128,i[t[0]]+i[t[1]]+i[t[2]]+i[t[3]]+"-"+i[t[4]]+i[t[5]]+"-"+i[t[6]]+i[t[7]]+"-"+i[t[8]]+i[t[9]]+"-"+i[t[10]]+i[t[11]]+i[t[12]]+i[t[13]]+i[t[14]]+i[t[15]]};for(var i=[],o=0;o<256;o++)i[o]=(o+256).toString(16).substr(1);t.exports=e},function(module,exports,__webpack_require__){var random=__webpack_require__(43),isBrowser=__webpack_require__(19),isNode=__webpack_require__(84),crypto;exports=function(t){for(var e=new Uint8Array(t),n=0;n<t;n++)e[n]=random(0,255);return e},isBrowser?(crypto=window.crypto||window.msCrypto,crypto&&(exports=function(t){var e=new Uint8Array(t);return crypto.getRandomValues(e),e})):isNode&&(crypto=eval("require")("crypto"),exports=function(t){return crypto.randomBytes(t)}),module.exports=exports},function(t,e,n){(function(r){var i=n(7);e=void 0!==r&&"[object process]"===i(r),t.exports=e}).call(this,n(44))},function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),i=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),o=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&r(e,t,n);return i(e,t),e},a=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var s=a(n(21)),u=o(n(86)),l=o(n(101)),c=o(n(60)),h=o(n(130)),p=o(n(132)),f=o(n(64)),_=o(n(137)),d=o(n(140)),v=o(n(142)),g=o(n(143)),m={"Debugger.enable":v.enable,"Debugger.setAsyncCallStackDepth":s.default,"Debugger.setBlackboxPatterns":s.default,"Debugger.setPauseOnExceptions":s.default,"DOM.collectClassNamesFromSubtree":c.collectClassNamesFromSubtree,"DOM.copyTo":c.copyTo,"DOM.discardSearchResults":c.discardSearchResults,"DOM.enable":c.enable,"DOM.getDocument":c.getDocument,"DOM.getOuterHTML":c.getOuterHTML,"DOM.getSearchResults":c.getSearchResults,"DOM.markUndoableState":s.default,"DOM.moveTo":c.moveTo,"DOM.performSearch":c.performSearch,"DOM.pushNodesByBackendIdsToFrontend":c.pushNodesByBackendIdsToFrontend,"DOM.removeNode":c.removeNode,"DOM.requestChildNodes":c.requestChildNodes,"DOM.requestNode":c.requestNode,"DOM.resolveNode":c.resolveNode,"DOM.setAttributesAsText":c.setAttributesAsText,"DOM.setAttributeValue":c.setAttributeValue,"DOM.setInspectedNode":c.setInspectedNode,"DOM.setNodeValue":c.setNodeValue,"DOM.setOuterHTML":c.setOuterHTML,"DOM.undo":s.default,"DOMDebugger.getEventListeners":d.getEventListeners,"Emulation.setEmulatedMedia":s.default,"Log.clear":s.default,"Log.enable":s.default,"Log.startViolationsReport":s.default,"Network.deleteCookies":f.deleteCookies,"Network.enable":f.enable,"Network.getCookies":f.getCookies,"Network.getResponseBody":f.getResponseBody,"Page.getResourceContent":s.default,"Page.getResourceTree":l.getResourceTree,"Runtime.callFunctionOn":u.callFunctionOn,"Runtime.compileScript":s.default,"Runtime.discardConsoleEntries":s.default,"Runtime.enable":u.enable,"Runtime.evaluate":u.evaluate,"Runtime.getHeapUsage":s.default,"Runtime.getIsolateId":s.default,"Runtime.getProperties":u.getProperties,"Runtime.releaseObject":s.default,"Runtime.releaseObjectGroup":s.default,"Runtime.runIfWaitingForDebugger":s.default,"ApplicationCache.enable":s.default,"ApplicationCache.getFramesWithManifests":s.default,"Page.getManifestIcons":s.default,"Page.bringToFront":s.default,"Page.enable":s.default,"Page.getAppManifest":l.getAppManifest,"Page.getInstallabilityErrors":s.default,"Profiler.enable":s.default,"Audits.enable":s.default,"BackgroundService.startObserving":s.default,"CacheStorage.requestCacheNames":s.default,"CSS.enable":h.enable,"CSS.getComputedStyleForNode":h.getComputedStyleForNode,"CSS.getInlineStylesForNode":h.getInlineStylesForNode,"CSS.getMatchedStylesForNode":h.getMatchedStylesForNode,"CSS.getPlatformFontsForNode":s.default,"CSS.getStyleSheetText":h.getStyleSheetText,"CSS.getBackgroundColors":h.getBackgroundColors,"CSS.setStyleTexts":h.setStyleTexts,"Database.enable":s.default,"DOMStorage.clear":p.clear,"DOMStorage.enable":p.enable,"DOMStorage.getDOMStorageItems":p.getDOMStorageItems,"DOMStorage.removeDOMStorageItem":p.removeDOMStorageItem,"DOMStorage.setDOMStorageItem":p.setDOMStorageItem,"HeapProfiler.enable":s.default,"IndexedDB.enable":s.default,"Inspector.enable":s.default,"IndexedDB.requestDatabaseNames":s.default,"Overlay.enable":s.default,"Overlay.hideHighlight":_.hideHighlight,"Overlay.highlightFrame":s.default,"Overlay.highlightNode":_.highlightNode,"Overlay.setInspectMode":_.setInspectMode,"Overlay.setShowViewportSizeOnResize":_.setShowViewportSizeOnResize,"ServiceWorker.enable":s.default,"Storage.getUsageAndQuota":g.getUsageAndQuota,"Storage.trackCacheStorageForOrigin":s.default,"Storage.trackIndexedDBForOrigin":s.default,"Storage.clearDataForOrigin":g.clearDataForOrigin};e.default=m},function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),i=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),o=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&r(e,t,n);return i(e,t),e},a=this&&this.__awaiter||function(t,e,n,r){return new(n||(n=Promise))((function(i,o){function a(t){try{u(r.next(t))}catch(t){o(t)}}function s(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){var e;t.done?i(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(a,s)}u((r=r.apply(t,e||[])).next())}))},s=this&&this.__generator||function(t,e){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=e.call(t,a)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}},u=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.releaseObject=e.evaluate=e.getProperties=e.enable=e.callFunctionOn=void 0;var l=u(n(10)),c=u(n(0)),h=u(n(13)),p=u(n(45)),f=u(n(1)),_=u(n(87)),d=u(n(90)),v=u(n(15)),g=u(n(91)),m=u(n(11)),b=o(n(22)),y=o(n(49)),w={id:1,name:"top",origin:location.origin};e.callFunctionOn=function(t){return a(this,void 0,void 0,(function(){var e,n,r,i,o,a,u;return s(this,(function(s){switch(s.label){case 0:return e=t.functionDeclaration,n=t.objectId,r=t.arguments||[],r=h.default(r,(function(t){var e=t.objectId,n=t.value;if(e){var r=b.getObj(e);if(r)return r}return n})),i=null,n&&(i=b.getObj(n)),o={},u=(a=b).wrap,[4,O(e,r,i)];case 1:return[2,(o.result=u.apply(a,[s.sent()]),o)]}}))}))},e.enable=function(){d.default.start(),c.default({log:"log",warn:"warning",error:"error",info:"info",dir:"dir",table:"table",group:"startGroup",groupCollapsed:"startGroupCollapsed",groupEnd:"endGroup",debug:"debug",clear:"clear"},(function(t,e){var n=console[e].bind(console);console[e]=function(){for(var e=[],r=0;r<arguments.length;r++)e[r]=arguments[r];n.apply(void 0,e),e=h.default(e,(function(t){return b.wrap(t,{generatePreview:!0})})),l.default.trigger("Runtime.consoleAPICalled",{type:t,args:e,stackTrace:{callFrames:"error"===t||"warning"===t?$():[]},executionContextId:w.id,timestamp:p.default()})}})),l.default.trigger("Runtime.executionContextCreated",{context:w})},e.getProperties=function(t){return b.getProperties(t)},e.evaluate=function(t){var e,n={};try{e=y.default(t.expression),y.setGlobal("$_",e),n.result=b.wrap(e)}catch(t){n.exceptionDetails={exception:b.wrap(t),text:"Uncaught"},n.result=b.wrap(t,{generatePreview:!0})}return n},e.releaseObject=function(t){b.releaseObj(t.objectId)};var x=window.Function,k=Object.getPrototypeOf((function(){return a(this,void 0,void 0,(function(){return s(this,(function(t){return[2]}))}))})).constructor;function O(t,e,n){return void 0===n&&(n=null),a(this,void 0,void 0,(function(){var r;return s(this,(function(i){switch(i.label){case 0:return o=t,a=_.default(o),"}"!==o[o.length-1]?a.push("return "+o.slice(o.indexOf("=>")+2)):a.push(o.slice(o.indexOf("{")+1,o.lastIndexOf("}"))),r=a,v.default(t,"async")?[4,k.apply(null,r).apply(n,e)]:[3,2];case 1:return[2,i.sent()];case 2:return[2,x.apply(null,r).apply(n,e)]}var o,a}))}))}function $(t){var e=[],n=t?t.stack:g.default();return f.default(n)?(e=n.split("\n"),t||e.shift(),e.shift(),e=h.default(e,(function(t){return{functionName:m.default(t)}}))):(n.shift(),e=h.default(n,(function(t){return{functionName:t.getFunctionName(),lineNumber:t.getLineNumber(),columnNumber:t.getColumnNumber(),url:t.getFileName()}}))),e}d.default.addListener((function(t){l.default.trigger("Runtime.exceptionThrown",{exceptionDetails:{exception:b.wrap(t),stackTrace:{callFrames:$(t)},text:"Uncaught"},timestamp:p.default})}))},function(t,e,n){var r=n(33),i=n(89),o=n(15),a=n(1);e=function(t){var e,n,u=i(a(t)?t:r(t));o(u,"async")||o(u,"function")||o(u,"(")?(e=u.indexOf("(")+1,n=u.indexOf(")")):(e=0,n=u.indexOf("=>"));var l=u.slice(e,n);return null===(l=l.match(s))?[]:l};var s=/[^\s,]+/g;t.exports=e},function(t,e){e=function(t){return null==t},t.exports=e},function(t,e){e=function(t){for(var e={singleQuote:!1,doubleQuote:!1,regex:!1,blockComment:!1,lineComment:!1,condComp:!1},n=0,r=(t=("__"+t+"__").split("")).length;n<r;n++)if(e.regex)"/"===t[n]&&"\\"!==t[n-1]&&(e.regex=!1);else if(e.singleQuote)"'"===t[n]&&"\\"!==t[n-1]&&(e.singleQuote=!1);else if(e.doubleQuote)'"'===t[n]&&"\\"!==t[n-1]&&(e.doubleQuote=!1);else if(e.blockComment)"*"===t[n]&&"/"===t[n+1]&&(t[n+1]="",e.blockComment=!1),t[n]="";else if(e.lineComment)"\n"===t[n+1]&&(e.lineComment=!1),t[n]="";else if(e.doubleQuote='"'===t[n],e.singleQuote="'"===t[n],"/"===t[n]){if("*"===t[n+1]){t[n]="",e.blockComment=!0;continue}if("/"===t[n+1]){t[n]="",e.lineComment=!0;continue}e.regex=!0}return t.join("").slice(2,-2)},t.exports=e},function(t,e,n){(function(r){var i=n(19),o=[],a=!1;function s(t){if(a)for(var e=0,n=o.length;e<n;e++)o[e](t)}e={start:function(){a=!0},stop:function(){a=!1},addListener:function(t){o.push(t)},rmListener:function(t){var e=o.indexOf(t);e>-1&&o.splice(e,1)},rmAllListeners:function(){o=[]}},i?(window.addEventListener("error",(function(t){s(t.error)})),window.addEventListener("unhandledrejection",(function(t){s(t.reason)}))):(r.on("uncaughtException",s),r.on("unhandledRejection",s)),t.exports=e}).call(this,n(44))},function(t,e){e=function(){var t=Error.prepareStackTrace;Error.prepareStackTrace=function(t,e){return e};var e=(new Error).stack.slice(1);return Error.prepareStackTrace=t,e},t.exports=e},function(t,e){var n=/^\s+/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=0,a=t.length,s=e.length,u=!0;u&&o<a;)for(u=!1,r=-1,i=t.charAt(o);++r<s;)if(i===e[r]){u=!0,o++;break}return o>=a?"":t.substr(o,a)},t.exports=e},function(t,e){var n=/\s+$/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=t.length-1,a=e.length,s=!0;s&&o>=0;)for(s=!1,r=-1,i=t.charAt(o);++r<a;)if(i===e[r]){s=!0,o--;break}return o>=0?t.substring(0,o+1):""},t.exports=e},function(t,e,n){var r=n(7);e=function(t){return"[object Error]"===r(t)},t.exports=e},function(t,e,n){var r=n(7);e=function(t){return"[object RegExp]"===r(t)},t.exports=e},function(t,e,n){var r=n(7),i=n(97),o=n(35),a=n(98);e=function(t){var e,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return null===t&&(e="Null"),void 0===t&&(e="Undefined"),i(t)&&(e="NaN"),a(t)&&(e="Buffer"),e||(e=r(t).match(s))&&(e=e[1]),e?n?o(e):e:""};var s=/^\[object\s+(.*?)]$/;t.exports=e},function(t,e,n){var r=n(18);e=function(t){return r(t)&&t!==+t},t.exports=e},function(t,e,n){var r=n(4);e=function(t){return null!=t&&(!!t._isBuffer||t.constructor&&r(t.constructor.isBuffer)&&t.constructor.isBuffer(t))},t.exports=e},function(t,e){e=function(t){return"symbol"==typeof t},t.exports=e},function(t,e,n){var r=n(27),i=n(21);e=function(t,e){e=e||i;var n=document.createElement("textarea"),o=document.body;r(n.style,{fontSize:"12pt",border:"0",padding:"0",margin:"0",position:"absolute",left:"-9999px"}),n.value=t,o.appendChild(n),n.setAttribute("readonly",""),n.select(),n.setSelectionRange(0,t.length);try{document.execCommand("copy"),e()}catch(t){e(t)}finally{o.removeChild(n)}},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__awaiter||function(t,e,n,r){return new(n||(n=Promise))((function(i,o){function a(t){try{u(r.next(t))}catch(t){o(t)}}function s(t){try{u(r.throw(t))}catch(t){o(t)}}function u(t){var e;t.done?i(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e)}))).then(a,s)}u((r=r.apply(t,e||[])).next())}))},i=this&&this.__generator||function(t,e){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=e.call(t,a)}catch(t){o=[6,t],r=0}finally{n=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}},o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getResourceTree=e.getAppManifest=void 0;var a=o(n(36)),s=o(n(117)),u=n(58);e.getAppManifest=function(){return r(this,void 0,void 0,(function(){var t,e,n,r,o;return i(this,(function(i){switch(i.label){case 0:return t=a.default("link"),e={errors:[]},n="",t.each((function(){var t=a.default(this);"manifest"===t.attr("rel")&&(n=u.fullUrl(t.attr("href")))})),e.url=n,n?[4,s.default(n)]:[3,3];case 1:return r=i.sent(),o=e,[4,r.text()];case 2:o.data=i.sent(),i.label=3;case 3:return[2,e]}}))}))},e.getResourceTree=function(){return{frameTree:{frame:{id:"",mimeType:"text/html",securityOrigin:location.origin,url:location.href},resources:[]}}}},function(t,e,n){e=n(42)((function(t,e){for(var n=t.length,r=0,i=e.length;r<i;r++)for(var o=e[r],a=0,s=o.length;a<s;a++)t[n++]=o[a];return t.length=n,t})),t.exports=e},function(t,e,n){var r=n(6);e=function(t){var e=(t=r(t))[0].getBoundingClientRect();return{left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:Math.round(e.width),height:Math.round(e.height)}},t.exports=e},function(t,e,n){var r=n(0),i=n(6);e=function(t){t=i(t),r(t,(function(t){(function(t){return"none"==getComputedStyle(t,"").getPropertyValue("display")})(t)&&(t.style.display=function(t){var e,n;return o[t]||(e=document.createElement(t),document.documentElement.appendChild(e),n=getComputedStyle(e,"").getPropertyValue("display"),e.parentNode.removeChild(e),"none"==n&&(n="block"),o[t]=n),o[t]}(t.nodeName))}))};var o={};t.exports=e},function(t,e){e=function(t,e,n){return Array.prototype.indexOf.call(t,e,n)},t.exports=e},function(t,e,n){var r=n(0);e=function(t){var e=[];return r(t,(function(t){e.push(t)})),e},t.exports=e},function(t,e,n){var r=n(55),i=n(108),o=n(109),a=n(12),s=n(53);(e=r((function(t){if(t=t.replace(l,""),t=i(t),a(c,t))return t;for(var e=u.length;e--;){var n=u[e]+o(t);if(a(c,n))return n}return t}))).dash=r((function(t){var n=e(t);return(l.test(n)?"-":"")+s(n)}));var u=["O","ms","Moz","Webkit"],l=/^(O)|(ms)|(Moz)|(Webkit)|(-o-)|(-ms-)|(-moz-)|(-webkit-)/g,c=document.createElement("p").style;t.exports=e},function(t,e,n){var r=n(54);function i(t,e){this[e]=t.replace(/\w/,(function(t){return t.toUpperCase()}))}e=function(t){var e=r(t),n=e[0];return e.shift(),e.forEach(i,e),n+e.join("")},t.exports=e},function(t,e){e=function(t){return t.length<1?t:t[0].toUpperCase()+t.slice(1)},t.exports=e},function(t,e,n){var r=n(3),i=n(0),o=n(6);function a(t){return function(e,n){var a=(e=o(e))[0];if(r(n))return a?a[t]:"";a&&i(e,(function(e){e[t]=n}))}}e={html:a("innerHTML"),text:a("textContent"),val:a("value")},t.exports=e},function(t,e,n){var r=n(0),i=n(6);e=function(t){t=i(t),r(t,(function(t){var e=t.parentNode;e&&e.removeChild(t)}))},t.exports=e},function(t,e,n){var r=n(56),i=n(1),o=n(5),a=n(0);n(6),e=function(t,e,n){var s=e;return i(e)&&(s="data-"+e),o(e)&&(s={},a(e,(function(t,e){s["data-"+e]=t}))),r(t,s,n)},t.exports=e},function(t,e,n){var r=n(114),i=n(3),o=n(6),a=n(0);function s(t){return function(e,n,s,u){e=o(e),i(u)&&(u=s,s=void 0),a(e,(function(e){r[t](e,n,s,u)}))}}e={on:s("add"),off:s("remove")},t.exports=e},function(t,e,n){var r=n(17),i=n(23);function o(){return!0}function a(){return!1}function s(t){var n,r=this.events[t.type],i=u.call(this,t,r);t=new e.Event(t);for(var o,a,s=0;(a=i[s++])&&!t.isPropagationStopped();)for(t.curTarget=a.el,o=0;(n=a.handlers[o++])&&!t.isImmediatePropagationStopped();)!1===n.handler.apply(a.el,[t])&&(t.preventDefault(),t.stopPropagation())}function u(t,e){var n,r,o,a,s=t.target,u=[],l=e.delegateCount;if(s.nodeType)for(;s!==this;s=s.parentNode||this){for(r=[],a=0;a<l;a++)void 0===r[n=(o=e[a]).selector+" "]&&(r[n]=i(this.querySelectorAll(n),s)),r[n]&&r.push(o);r.length&&u.push({el:s,handlers:r})}return l<e.length&&u.push({el:this,handlers:e.slice(l)}),u}e={add:function(t,e,n,r){var i,o={selector:n,handler:r};t.events||(t.events={}),(i=t.events[e])||((i=t.events[e]=[]).delegateCount=0,t.addEventListener(e,(function(){s.apply(t,arguments)}),!1)),n?i.splice(i.delegateCount++,0,o):i.push(o)},remove:function(t,e,n,r){var i=t.events;if(i&&i[e])for(var o,a=i[e],s=a.length;s--;)o=a[s],n&&o.selector!=n||o.handler!=r||(a.splice(s,1),o.selector&&a.delegateCount--)},Event:r({className:"Event",initialize:function(t){this.origEvent=t},isDefaultPrevented:a,isPropagationStopped:a,isImmediatePropagationStopped:a,preventDefault:function(){var t=this.origEvent;this.isDefaultPrevented=o,t&&t.preventDefault&&t.preventDefault()},stopPropagation:function(){var t=this.origEvent;this.isPropagationStopped=o,t&&t.stopPropagation&&t.stopPropagation()},stopImmediatePropagation:function(){var t=this.origEvent;this.isImmediatePropagationStopped=o,t&&t.stopImmediatePropagation&&t.stopImmediatePropagation(),this.stopPropagation()}})},t.exports=e},function(t,e,n){var r=n(20),i=n(14),o=n(2);e=function(t,e,n){e=r(e,n);for(var a=!i(t)&&o(t),s=(a||t).length,u=0;u<s;u++){var l=a?a[u]:u;if(e(t[l],l,t))return!0}return!1},t.exports=e},function(t,e,n){var r=n(0),i=n(6);function o(t){return function(e,n){e=i(e),r(e,(function(e){e.insertAdjacentHTML(t,n)}))}}e={before:o("beforebegin"),after:o("afterend"),append:o("beforeend"),prepend:o("afterbegin")},t.exports=e},function(t,e,n){var r=n(0),i=n(37),o=n(21),a=n(12),s=n(118).Promise;e=function(t,n){return i(n=n||{},e.setting),new s((function(e,i){var l=n.xhr(),c=n.headers,h=n.body,p=n.timeout;l.withCredentials="include"==n.credentials,l.onload=function(){clearTimeout(void 0),e(function t(e){var n,r=[],i=[],o={};return e.getAllResponseHeaders().replace(u,(function(t,e,a){e=e.toLowerCase(),r.push(e),i.push([e,a]),n=o[e],o[e]=n?n+","+a:a})),{ok:e.status>=200&&e.status<400,status:e.status,statusText:e.statusText,url:e.responseURL,clone:function(){return t(e)},text:function(){return s.resolve(e.responseText)},json:function(){return s.resolve(e.responseText).then(JSON.parse)},xml:function(){return s.resolve(e.responseXML)},blob:function(){return s.resolve(new Blob([e.response]))},headers:{keys:function(){return r},entries:function(){return i},get:function(t){return o[t.toLowerCase()]},has:function(t){return a(o,t)}}}}(l))},l.onerror=i,l.open(n.method,t,!0),r(c,(function(t,e){l.setRequestHeader(e,t)})),p>0&&setTimeout((function(){l.onload=o,l.abort(),i(Error("timeout"))}),p),l.send(h)}))};var u=/^(.*?):\s*([\s\S]*?)$/gm;e.setting={method:"GET",headers:{},timeout:0,xhr:function(){return new XMLHttpRequest}},t.exports=e},function(t,e,n){(function(r){var i=n(19);e=i?window:r,t.exports=e}).call(this,n(119))},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var r=n(17),i=n(27),o=n(11),a=n(121),s=n(25),u=n(0),l=n(8),c=n(9),h=n(19),p=n(5);e=r({className:"Url",initialize:function(t){!t&&h&&(t=window.location.href),i(this,e.parse(t||""))},setQuery:function(t,e){var n=this.query;return p(t)?u(t,(function(t,e){n[e]=t})):n[t]=e,this},rmQuery:function(t){var e=this.query;return l(t)||(t=c(t)),u(t,(function(t){delete e[t]})),this},toString:function(){return e.stringify(this)}},{parse:function(t){var e={protocol:"",auth:"",hostname:"",hash:"",query:{},port:"",pathname:"",slashes:!1},n=o(t),r=!1,i=n.match(f);if(i&&(i=i[0],e.protocol=i.toLowerCase(),n=n.substr(i.length)),i&&(r="//"===n.substr(0,2))&&(n=n.slice(2),e.slashes=!0),r){for(var s=n,u=-1,l=0,c=d.length;l<c;l++){var h=n.indexOf(d[l]);-1!==h&&(-1===u||h<u)&&(u=h)}u>-1&&(s=n.slice(0,u),n=n.slice(u));var p=s.lastIndexOf("@");-1!==p&&(e.auth=decodeURIComponent(s.slice(0,p)),s=s.slice(p+1)),e.hostname=s;var v=s.match(_);v&&(":"!==(v=v[0])&&(e.port=v.substr(1)),e.hostname=s.substr(0,s.length-v.length))}var g=n.indexOf("#");-1!==g&&(e.hash=n.substr(g),n=n.slice(0,g));var m=n.indexOf("?");return-1!==m&&(e.query=a.parse(n.substr(m+1)),n=n.slice(0,m)),e.pathname=n||"/",e},stringify:function(t){var e=t.protocol+(t.slashes?"//":"")+(t.auth?encodeURIComponent(t.auth)+"@":"")+t.hostname+(t.port?":"+t.port:"")+t.pathname;return s(t.query)||(e+="?"+a.stringify(t.query)),t.hash&&(e+=t.hash),e}});var f=/^([a-z0-9.+-]+:)/i,_=/:[0-9]*$/,d=["/","?","#"];t.exports=e},function(t,e,n){var r=n(11),i=n(0),o=n(3),a=n(8),s=n(13),u=n(25),l=n(30),c=n(5);e={parse:function(t){var e={};return t=r(t).replace(h,""),i(t.split("&"),(function(t){var n=t.split("="),r=n.shift(),i=n.length>0?n.join("="):null;r=decodeURIComponent(r),i=decodeURIComponent(i),o(e[r])?e[r]=i:a(e[r])?e[r].push(i):e[r]=[e[r],i]})),e},stringify:function(t,n){return l(s(t,(function(t,r){return c(t)&&u(t)?"":a(t)?e.stringify(t,r):(n?encodeURIComponent(n):encodeURIComponent(r))+"="+encodeURIComponent(t)})),(function(t){return t.length>0})).join("&")}};var h=/^(\?|#|&)/g;t.exports=e},function(t,e,n){var r=n(7);e=function(t){return"[object Arguments]"===r(t)},t.exports=e},function(t,e){var n=0;e=function(t){var e=++n+"";return t?t+e:e},t.exports=e},function(t,e,n){var r=n(125),i=n(127),o=n(8),a=n(0),s=n(1),u=n(129);e={parse:function(t){var e=[],n=new i;return r(t,{start:function(t,e){e=u(e,(function(t){return function(t){return t.replace(/&quot;/g,'"')}(t)})),n.push({tag:t,attrs:e})},end:function(){var t=n.pop();if(n.size){var r=n.peek();o(r.content)||(r.content=[]),r.content.push(t)}else e.push(t)},comment:function(t){var r="\x3c!--".concat(t,"--\x3e"),i=n.peek();i?(i.content||(i.content=[]),i.content.push(r)):e.push(r)},text:function(t){var r=n.peek();r?(r.content||(r.content=[]),r.content.push(t)):e.push(t)}}),e},stringify:function t(e){var n="";return o(e)?a(e,(function(e){return n+=t(e)})):s(e)?n=e:(n+="<".concat(e.tag),a(e.attrs,(function(t,e){return n+=" ".concat(e,'="').concat(function(t){return t.replace(/"/g,"&quot;")}(t),'"')})),n+=">",e.content&&(n+=t(e.content)),n+="</".concat(e.tag,">")),n}},t.exports=e},function(t,e,n){var r=n(24),i=n(126),o=n(15),a=n(35);e=function(t,e){for(var n,i=[],p=t;t;){if(n=!0,r(i)&&h[r(i)]){var f=new RegExp("</".concat(r(i),"[^>]*>")).exec(t);if(f){var _=t.substring(0,f.index);t=t.substring(f.index+f[0].length),_&&e.text&&e.text(_)}x(0,r(i))}else{if(o(t,"\x3c!--")){var d=t.indexOf("--\x3e");d>=0&&(e.comment&&e.comment(t.substring(4,d)),t=t.substring(d+3),n=!1)}else if(o(t,"<!")){var v=t.match(s);v&&(e.text&&e.text(t.substring(0,v[0].length)),t=t.substring(v[0].length),n=!1)}else if(o(t,"</")){var g=t.match(u);g&&(t=t.substring(g[0].length),g[0].replace(u,x),n=!1)}else if(o(t,"<")){var m=t.match(l);m&&(t=t.substring(m[0].length),m[0].replace(l,w),n=!1)}if(n){var b=t.indexOf("<"),y=b<0?t:t.substring(0,b);t=b<0?"":t.substring(b),e.text&&e.text(y)}}if(p===t)throw Error("Parse Error: "+t);p=t}function w(t,n,r,o){if(n=a(n),(o=!!o)||i.push(n),e.start){var s={};r.replace(c,(function(t,e,n,r,i){s[e]=n||r||i||""})),e.start(n,s,o)}}function x(t,n){var r;if(n=a(n))for(r=i.length-1;r>=0&&i[r]!==n;r--);else r=0;if(r>=0){for(var o=i.length-1;o>=r;o--)e.end&&e.end(i[o]);i.length=r}}x()};var s=/^<!\s*doctype((?:\s+[\w:]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/i,u=/^<\/([-A-Za-z0-9_]+)[^>]*>/,l=/^<([-A-Za-z0-9_]+)((?:\s+[-A-Za-z0-9_:@.]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/i,c=/([-A-Za-z0-9_:@.]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))?/g,h=i("script,style".split(","));t.exports=e},function(t,e,n){var r=n(0),i=n(3),o=n(4);e=function(t,e){i(e)&&(e=!0);var n=o(e),a={};return r(t,(function(t){a[t]=n?e(t):e})),a},t.exports=e},function(t,e,n){var r=n(17),i=n(128);e=r({initialize:function(){this.clear()},clear:function(){this._items=[],this.size=0},push:function(t){return this._items.push(t),++this.size},pop:function(){if(this.size)return this.size--,this._items.pop()},peek:function(){return this._items[this.size-1]},forEach:function(t,e){e=arguments.length>1?e:this;for(var n=this._items,r=this.size-1,i=0;r>=0;r--,i++)t.call(e,n[r],i,this)},toArr:function(){return i(this._items)}}),t.exports=e},function(t,e){e=function(t){var e=t.length,n=Array(e);e--;for(var r=0;r<=e;r++)n[e-r]=t[r];return n},t.exports=e},function(t,e,n){var r=n(20),i=n(2);e=function(t,e,n){e=r(e,n);for(var o=i(t),a=o.length,s={},u=0;u<a;u++){var l=o[u];s[l]=e(t[l],l,t)}return s},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__assign||function(){return(r=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},i=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),o=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),a=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&i(e,t,n);return o(e,t),e},s=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.setStyleTexts=e.getStyleSheetText=e.getBackgroundColors=e.getMatchedStylesForNode=e.getInlineStylesForNode=e.getComputedStyleForNode=e.enable=void 0;var u=n(26),l=a(n(131)),c=s(n(13)),h=s(n(24)),p=s(n(0)),f=s(n(11)),_=s(n(15)),d=s(n(62)),v=s(n(10)),g=s(n(61));function m(t){var e,n,r,i=t.nodeId,o=u.getNode(i),a=o.style,s={shorthandEntries:[],cssProperties:[]};if(a){var v=l.getOrCreateInlineStyleSheetId(i);s.styleSheetId=v;var g=o.getAttribute("style")||"";s.cssText=g,s.range={startLine:0,startColumn:0,endLine:(r=g,r.split("\n").length-1),endColumn:h.default(g.split("\n")).length};var m=b((e=g.replace(/\/\*/g,"").replace(/\*\//g,"").split(";"),n={},p.default(e,(function(t){if(t=f.default(t)){var e=t.indexOf(":");if(e){var r=f.default(t.slice(0,e)),i=f.default(t.slice(e+1));n[r]=i}}})),n));m=c.default(m,(function(t){var e=t.name,n=t.value,r=function(t,e,n){for(var r=n.split("\n"),i=0,o=0,a=0,s=0,u="",l=new RegExp("(\\/\\*)?\\s*"+t+":\\s*"+e+";?\\s*(\\*\\/)?"),c=0,h=r.length;c<h;c++){var p=r[c].match(l);if(p){u=p[0],i=c,o=c,s=(a=p.index||0)+u.length;break}}return{range:{startLine:i,endLine:o,startColumn:a,endColumn:s},text:u}}(e,n,g),i=r.text,o={name:e,value:n,text:i,range:r.range};return _.default(i,"/*")?o.disabled=!0:(o.disabled=!1,o.implicit=!1,o.parsedOk=""!==a[e]),o}));var y=l.formatStyle(a);p.default(m,(function(t){var e=t.name;return delete y[e]}));var x=b(y);s.shorthandEntries=w(a),s.cssProperties=d.default(m,x)}return{inlineStyle:s}}function b(t){var e=[];return p.default(t,(function(t,n){e.push({name:n,value:t})})),e}e.enable=function(){p.default(l.getStyleSheets(),(function(t){t.styleSheetId&&v.default.trigger("CSS.styleSheetAdded",{header:{styleSheetId:t.styleSheetId,sourceURL:"",startColumn:0,startLine:0,endColumn:0,endLine:0}})}))},e.getComputedStyleForNode=function(t){var e=u.getNode(t.nodeId);return{computedStyle:b(l.formatStyle(window.getComputedStyle(e)))}},e.getInlineStylesForNode=m,e.getMatchedStylesForNode=function(t){var e=u.getNode(t.nodeId),n=l.getMatchedCssRules(e);return r({matchedCSSRules:c.default(n,(function(t){return function(t,e){var n=e.selectorText,r=c.default(n.split(","),(function(t){return f.default(t)})),i=w(e.style),o=l.formatStyle(e.style),a={styleSheetId:e.styleSheetId,selectorList:{selectors:c.default(r,(function(t){return{text:t}})),text:n},style:{cssProperties:b(o),shorthandEntries:i}},s=[];return p.default(r,(function(e,n){l.matchesSelector(t,e)&&s.push(n)})),{matchingSelectors:[0],rule:a}}(e,t)}))},m(t))},e.getBackgroundColors=function(t){var e=u.getNode(t.nodeId),n=l.formatStyle(window.getComputedStyle(e));return{backgroundColors:[n["background-color"]],computedFontSize:n["font-size"],computedFontWeight:n["font-weight"]}},e.getStyleSheetText=function(t){var e=l.getInlineStyleNodeId(t.styleSheetId),n="";return e&&(n=u.getNode(e).getAttribute("style")||""),{text:n}},e.setStyleTexts=function(t){var e=t.edits;return{styles:c.default(e,(function(t){var e=t.styleSheetId,n=t.text,r=t.range,i=l.getInlineStyleNodeId(e);if(i){var o=u.getNode(i),a=o.getAttribute("style")||"",s=function(t,e){for(var n=t.startLine,r=t.startColumn,i=t.endLine,o=t.endColumn,a=0,s=0,u=e.split("\n"),l=0;l<=i;l++){var c=(u[l]+1).length;l<n?a+=c:l===n&&(a+=r),l<i?s+=c:l===i&&(s+=o)}return{start:a,end:s}}(r,a),c=s.start,h=s.end;return a=a.slice(0,c)+n+a.slice(h),o.setAttribute("style",a),m({nodeId:i}).inlineStyle}return{styleSheetId:e}}))}},l.onStyleSheetAdded((function(t){v.default.trigger("CSS.styleSheetAdded",{header:{styleSheetId:t.styleSheetId,sourceURL:"",startColumn:0,startLine:0,endColumn:0,endLine:0}})}));var y=["background","font","border","margin","padding"];function w(t){var e=[];return p.default(y,(function(n){var r=t[n];r&&e.push({name:n,value:r})})),e}g.default.on("attributes",(function(t,e){var n=u.getNodeId(t);if(n&&"style"===e){var r=l.getInlineStyleSheetId(n);r&&v.default.trigger("CSS.styleSheetChanged",{styleSheetId:r})}}))},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getInlineStyleNodeId=e.getInlineStyleSheetId=e.getOrCreateInlineStyleSheetId=e.formatStyle=e.getMatchedCssRules=e.getStyleSheets=e.onStyleSheetAdded=e.matchesSelector=void 0;var i=r(n(0)),o=r(n(16)),a=n(38),s=Element.prototype,u=function(){return!1};function l(t,e){return u(t,e)}s.webkitMatchesSelector?u=function(t,e){return t.webkitMatchesSelector(e)}:s.mozMatchesSelector&&(u=function(t,e){return t.mozMatchesSelector(e)}),e.matchesSelector=l;var c=new o.default;e.onStyleSheetAdded=function(t){c.on("styleSheetAdded",t)},e.getStyleSheets=function(){return document.styleSheets},e.getMatchedCssRules=function(t){var e=[];return i.default(document.styleSheets,(function(n){var r=n.styleSheetId;r||(r=a.createId(),n.styleSheetId=r,c.emit("styleSheetAdded",n));try{if(!n.cssRules)return}catch(t){return}i.default(n.cssRules,(function(n){var i=!1;try{i=l(t,n.selectorText)}catch(t){}i&&e.push({selectorText:n.selectorText,style:n.style,styleSheetId:r})}))})),e},e.formatStyle=function(t){for(var e={},n=0,r=t.length;n<r;n++){var i=t[n];e[i]=t[i]}return e};var h=new Map,p=new Map;e.getOrCreateInlineStyleSheetId=function(t){var e=h.get(t);return e||(e=a.createId(),h.set(t,e),p.set(e,t),e)},e.getInlineStyleSheetId=function(t){return h.get(t)},e.getInlineStyleNodeId=function(t){return p.get(t)}},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.enable=e.setDOMStorageItem=e.removeDOMStorageItem=e.getDOMStorageItems=e.clear=void 0;var i=r(n(63)),o=r(n(0)),a=r(n(1)),s=r(n(32)),u=r(n(134)),l=r(n(10)),c=i.default("local"),h=i.default("session");function p(t){return t.isLocalStorage?c:h}e.clear=function(t){p(t.storageId).clear()},e.getDOMStorageItems=function(t){var e=p(t.storageId),n=[];return o.default(u.default(e),(function(t,e){a.default(t)&&n.push([e,t])})),{entries:n}},e.removeDOMStorageItem=function(t){var e=t.key;p(t.storageId).removeItem(e)},e.setDOMStorageItem=function(t){var e=t.key,n=t.value;p(t.storageId).setItem(e,n)},e.enable=s.default((function(){o.default(["local","session"],(function(t){var e="local"===t?c:h,n=function(t){return{securityOrigin:location.origin,isLocalStorage:"local"===t}}(t),r=e.setItem.bind(e);e.setItem=function(t,i){if(a.default(t)&&a.default(i)){var o=e.getItem(t);r(t,i),o?l.default.trigger("DOMStorage.domStorageItemUpdated",{key:t,newValue:i,oldValue:o,storageId:n}):l.default.trigger("DOMStorage.domStorageItemAdded",{key:t,newValue:i,storageId:n})}};var i=e.removeItem.bind(e);e.removeItem=function(t){a.default(t)&&e.getItem(t)&&(i(t),l.default.trigger("DOMStorage.domStorageItemRemoved",{key:t,storageId:n}))};var o=e.clear.bind(e);e.clear=function(){o(),l.default.trigger("DOMStorage.domStorageItemsCleared",{storageId:n})}}))}))},function(t,e,n){var r=n(2);e={getItem:function(t){return(o[t]?i[t]:this[t])||null},setItem:function(t,e){o[t]?i[t]=e:this[t]=e},removeItem:function(t){o[t]?delete i[t]:delete this[t]},key:function(t){var e=a();return t>=0&&t<e.length?e[t]:null},clear:function(){for(var t,e=s(),n=0;t=e[n];n++)delete this[t];e=u();for(var r,o=0;r=e[o];o++)delete i[r]}},Object.defineProperty(e,"length",{enumerable:!1,configurable:!0,get:function(){return a().length}});var i={},o={getItem:1,setItem:1,removeItem:1,key:1,clear:1,length:1};function a(){return s().concat(u())}function s(){return r(e).filter((function(t){return!o[t]}))}function u(){return r(i)}t.exports=e},function(t,e){e=function(t){return JSON.parse(JSON.stringify(t))},t.exports=e},function(t,e,n){var r=n(66);e={encode:function(t){for(var e=r.decode(t),n="",i=0,o=e.length;i<o;i++)n+=f(e[i]);return n},decode:function(t,e){i=r.decode(t),o=0,a=i.length,s=0,u=0,l=0,c=128,h=191;for(var n,p=[];!1!==(n=_(e));)p.push(n);return r.encode(p)}};var i,o,a,s,u,l,c,h,p=String.fromCharCode;function f(t){if(0==(4294967168&t))return p(t);var e,n,r="";for(0==(4294965248&t)?(e=1,n=192):0==(4294901760&t)?(e=2,n=224):0==(4292870144&t)&&(e=3,n=240),r+=p((t>>6*e)+n);e>0;)r+=p(128|63&t>>6*(e-1)),e--;return r}function _(t){for(;;){if(o>=a&&l){if(t)return d();throw new Error("Invalid byte index")}if(o===a)return!1;var e=i[o];if(o++,l){if(e<c||e>h){if(t)return o--,d();throw new Error("Invalid continuation byte")}if(c=128,h=191,s=s<<6|63&e,++u===l){var n=s;return s=0,l=0,u=0,n}}else{if(0==(128&e))return e;if(192==(224&e))l=1,s=31&e;else if(224==(240&e))224===e&&(c=160),237===e&&(h=159),l=2,s=15&e;else{if(240!=(248&e)){if(t)return d();throw new Error("Invalid UTF-8 detected")}240===e&&(c=144),244===e&&(h=143),l=3,s=7&e}}}}function d(){var t=o-u-1;return o=t+1,s=0,l=0,u=0,c=128,h=191,i[t]}t.exports=e},function(t,e,n){var r=n(37),i=n(18),o=n(3),a=n(65),s={path:"/"};function u(t,n,u){if(!o(n)){if(u=r(u=u||{},s),i(u.expires)){var l=new Date;l.setMilliseconds(l.getMilliseconds()+864e5*u.expires),u.expires=l}return n=encodeURIComponent(n),t=encodeURIComponent(t),document.cookie=[t,"=",n,u.expires&&"; expires="+u.expires.toUTCString(),u.path&&"; path="+u.path,u.domain&&"; domain="+u.domain,u.secure?"; secure":""].join(""),e}for(var c=document.cookie?document.cookie.split("; "):[],h=t?void 0:{},p=0,f=c.length;p<f;p++){var _=c[p],d=_.split("="),v=a(d.shift());if(_=d.join("="),_=a(_),t===v){h=_;break}t||(h[v]=_)}return h}e={get:u,set:u,remove:function(t,e){return(e=e||{}).expires=-1,u(t,"",e)}},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__assign||function(){return(r=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)},i=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),o=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),a=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&i(e,t,n);return o(e,t),e},s=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.setInspectMode=e.setShowViewportSizeOnResize=e.hideHighlight=e.highlightNode=void 0;var u=n(26),l=n(60),c=s(n(36)),h=s(n(138)),p=s(n(139)),f=s(n(59)),_=s(n(1)),d=s(n(0)),v=s(n(11)),g=s(n(10)),m=a(n(22)),b={r:0,g:0,b:0,a:0};function y(t){var e,n=t.nodeId,r=t.highlightConfig,i=t.objectId,o=r.marginColor,a=void 0===o?b:o,s=r.paddingColor,l=void 0===s?b:s,h=r.borderColor,p=void 0===h?b:h,g=r.contentColor,y=void 0===g?b:g,w=r.showInfo;if(n&&(e=u.getNode(n)),i&&(e=m.getObj(i)),3===e.nodeType){var x=document.createRange();x.selectNode(e);var k=x.getBoundingClientRect(),O=k.left,$=k.width,j=k.top,S=k.height;return x.detach(),N.css({left:O,top:j,width:$,height:S}).show(),R.css({width:0,height:0}),I.css({width:0,height:0}),F.css({width:0,height:0}),B.css({left:0,top:0,width:$,height:S,background:W(y)}),void(w?q.css({top:j<25?0:-25,left:0}).html('<span style="color:#881280;">#text</span> | '+Math.round($)+" × "+Math.round(S)).show():q.hide())}if(1===e.nodeType){var E=c.default(e).offset(),A=E.left,T=E.width,C=E.top,P=E.height;N.css({left:A,top:C,width:T,height:P}).show();var D=window.getComputedStyle(e),M=function(t){return e=D.getPropertyValue(t),f.default(e.replace("px",""));var e},L=M("margin-left"),z=M("margin-right"),H=M("margin-top"),U=M("margin-bottom"),G=M("border-left-width"),K=M("border-right-width"),V=M("border-top-width"),Q=M("border-bottom-width"),J=M("padding-left"),X=M("padding-right"),Y=M("padding-top"),Z=M("padding-bottom"),tt=T-G-K,et=P-V-Q;a=W(a),R.css({left:-L,top:-H,width:T+L+z,height:P+H+U,borderTop:H+"px solid "+a,borderLeft:L+"px solid "+a,borderRight:z+"px solid "+a,borderBottom:U+"px solid "+a}),p=W(p),I.css({left:0,top:0,width:T,height:P,borderTop:V+"px solid "+p,borderLeft:G+"px solid "+p,borderRight:K+"px solid "+p,borderBottom:Q+"px solid "+p}),l=W(l),F.css({left:G,top:V,width:tt,height:et,borderTop:Y+"px solid "+l,borderLeft:J+"px solid "+l,borderRight:X+"px solid "+l,borderBottom:Z+"px solid "+l}),B.css({left:G+J,top:V+Y,width:tt-J-X,height:et-Y-Z,background:W(y)}),w?q.css({top:-H-(C-H<25?0:25),left:-L}).html(function(t){var e=t.id,n=t.className,r='<span style="color:#881280;">'+t.tagName.toLowerCase()+"</span>";""!==e&&(r+='<span style="color:1a1aa8;">#'+e+"</span>");var i="";return _.default(n)&&d.default(n.split(/\s+/g),(function(t){""!==v.default(t)&&(i+="."+t)})),r+'<span style="color:1a1aa8;">'+i+"</span>"}(e)+" | "+Math.round(T)+" × "+Math.round(P)).show():q.hide()}}function w(){N.hide()}e.highlightNode=y,e.hideHighlight=w;var x=!1;e.setShowViewportSizeOnResize=function(t){x=t.show};var k={},O="none";function $(t){if(p.default()){var e=t.touches[0]||t.changedTouches[0];return document.elementFromPoint(e.pageX,e.pageY)}return document.elementFromPoint(t.clientX,t.clientY)}function j(t){if("none"!==O){var e=$(t);if(e){var n=u.getNodeId(e);n||(n=l.pushNodesToFrontend(e)),y({nodeId:n,highlightConfig:k}),g.default.trigger("Overlay.nodeHighlightRequested",{nodeId:n})}}}function S(t){if("none"!==O){t.preventDefault(),t.stopImmediatePropagation();var e=$(t);g.default.trigger("Overlay.inspectNodeRequested",{backendNodeId:u.getNodeId(e)}),w()}}function E(t,e){document.documentElement.addEventListener(t,e,!0)}e.setInspectMode=function(t){k=t.highlightConfig,O=t.mode},p.default()?(E("touchstart",j),E("touchmove",j),E("touchend",S)):(E("mousemove",j),E("mouseout",(function(){"none"!==O&&w()})),E("click",S));var A,T=h.default("div",{class:"__chii-hide__",style:{position:"fixed",right:0,top:0,background:"#fff",fontSize:13,opacity:.5,padding:"4px 6px"}}),C=c.default(T);window.addEventListener("resize",(function(){x&&(C.text(window.innerWidth+"px × "+window.innerHeight+"px"),A?clearTimeout(A):document.documentElement.appendChild(T),A=setTimeout((function(){C.remove(),A=null}),1e3))}));var P=h.default("div",{class:"__chii-hide__",style:{display:"none",position:"absolute",pointerEvents:"none"}}),N=c.default(P);document.documentElement.appendChild(P);var D=U(),R=c.default(D),M=U(),I=c.default(M),L=U(),F=c.default(L),z=U(),B=c.default(z),H=U({height:25,lineHeight:25,background:"#fff",color:"#222",fontSize:12,padding:"0 5px",whiteSpace:"nowrap",overflowX:"hidden",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, 0.05), 0 1px 4px 0 rgba(0, 0, 0, 0.08), 0 3px 1px -2px rgba(0, 0, 0, 0.2)"}),q=c.default(H);function U(t){void 0===t&&(t={});var e=h.default("div",{style:r({position:"absolute",boxSizing:"border-box",zIndex:1e5},t)});return P.appendChild(e),e}function W(t){return t.a=t.a||0,"rgba("+t.r+","+t.g+","+t.b+","+t.a+")"}},function(t,e,n){var r=n(34),i=n(1),o=n(15),a=n(57),s=n(52),u=n(0),l=n(4);function c(t){for(var e="div",n="",r=[],i=[],a="",s=0,u=t.length;s<u;s++){var l=t[s];"#"===l||"."===l?(i.push(a),a=l):a+=l}i.push(a);for(var c=0,h=i.length;c<h;c++)(a=i[c])&&(o(a,"#")?n=a.slice(1):o(a,".")?r.push(a.slice(1)):e=a);return{tagName:e,id:n,classes:r}}e=function(t,e){for(var n=arguments.length,h=new Array(n>2?n-2:0),p=2;p<n;p++)h[p-2]=arguments[p];(r(e)||i(e))&&(h.unshift(e),e=null),e||(e={});var f=c(t),_=f.tagName,d=f.id,v=f.classes,g=document.createElement(_);return d&&g.setAttribute("id",d),a.add(g,v),u(h,(function(t){i(t)?g.appendChild(document.createTextNode(t)):r(t)&&g.appendChild(t)})),u(e,(function(t,e){i(t)?g.setAttribute(e,t):l(t)&&o(e,"on")?g.addEventListener(e.slice(2),t,!1):"style"===e&&s(g,t)})),g},t.exports=e},function(t,e,n){var r=n(19),i=n(55),o=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i;e=i((function(t){return t=t||(r?navigator.userAgent:""),o.test(t)||a.test(t.substr(0,4))})),t.exports=e},function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),i=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),o=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&r(e,t,n);return i(e,t),e},a=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.getEventListeners=void 0;var s=a(n(31)),u=a(n(34)),l=a(n(4)),c=a(n(141)),h=a(n(2)),p=a(n(0)),f=a(n(37)),_=o(n(22)),d=o(n(68));e.getEventListeners=function(t){var e=_.getObj(t.objectId).chiiEvents||[],n=[],r=d.get();return p.default(e,(function(t,e){p.default(t,(function(t){n.push({type:e,useCapture:t.useCapture,handler:_.wrap(t.listener),passive:t.passive,once:t.once,scriptId:r.scriptId,columnNumber:0,lineNumber:0})}))})),{listeners:n}};var v=s.default(window,"EventTarget.prototype")||window.Node.prototype,g=v.addEventListener,m=v.removeEventListener;function b(t,e,n,r){if(void 0===r&&(r=!1),u.default(t)&&l.default(n)){c.default(r)&&(r={capture:r}),f.default(r,{capture:!1,passive:!1,once:!1});var i=t.chiiEvents=t.chiiEvents||{};i[e]=i[e]||[],i[e].push({listener:n,useCapture:r.capture,passive:r.passive,once:r.once})}}function y(t,e,n){if(u.default(t)&&l.default(n)){var r=t.chiiEvents;if(r&&r[e]){for(var i=r[e],o=0,a=i.length;o<a;o++)if(i[o].listener===n){i.splice(o,1);break}0===i.length&&delete r[e],0===h.default(r).length&&delete t.chiiEvents}}}v.addEventListener=function(t,e,n){b(this,t,e,n),g.apply(this,arguments)},v.removeEventListener=function(t,e){y(this,t,e),m.apply(this,arguments)}},function(t,e){e=function(t){return!0===t||!1===t},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__createBinding||(Object.create?function(t,e,n,r){void 0===r&&(r=n),Object.defineProperty(t,r,{enumerable:!0,get:function(){return e[n]}})}:function(t,e,n,r){void 0===r&&(r=n),t[r]=e[n]}),i=this&&this.__setModuleDefault||(Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e})}:function(t,e){t.default=e}),o=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)"default"!==n&&Object.hasOwnProperty.call(t,n)&&r(e,t,n);return i(e,t),e},a=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.enable=void 0;var s=a(n(10)),u=o(n(68));e.enable=function(){s.default.trigger("Debugger.scriptParsed",u.get())}},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),e.clearDataForOrigin=e.getUsageAndQuota=void 0;var i=r(n(0)),o=r(n(67)),a=r(n(63)),s=n(64),u=a.default("local"),l=a.default("session");e.getUsageAndQuota=function(){return{quota:0,usage:0,usageBreakdown:[]}},e.clearDataForOrigin=function(t){var e=t.storageTypes.split(",");i.default(e,(function(t){if("cookies"===t){var e=s.getCookies().cookies;i.default(e,(function(t){var e=t.name;return o.default(e)}))}else"local_storage"===t&&(u.clear(),l.clear())}))}}])},module.exports=t()},function(t,e,n){"use strict";e.__esModule=!0,e.extend=s,e.indexOf=function(t,e){for(var n=0,r=t.length;n<r;n++)if(t[n]===e)return n;return-1},e.escapeExpression=function(t){if("string"!=typeof t){if(t&&t.toHTML)return t.toHTML();if(null==t)return"";if(!t)return t+"";t=""+t}if(!o.test(t))return t;return t.replace(i,a)},e.isEmpty=function(t){return!t&&0!==t||!(!c(t)||0!==t.length)},e.createFrame=function(t){var e=s({},t);return e._parent=t,e},e.blockParams=function(t,e){return t.path=e,t},e.appendContextPath=function(t,e){return(t?t+".":"")+e};var r={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},i=/[&<>"'`=]/g,o=/[&<>"'`=]/;function a(t){return r[t]}function s(t){for(var e=1;e<arguments.length;e++)for(var n in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],n)&&(t[n]=arguments[e][n]);return t}var u=Object.prototype.toString;e.toString=u;var l=function(t){return"function"==typeof t};l(/x/)&&(e.isFunction=l=function(t){return"function"==typeof t&&"[object Function]"===u.call(t)}),e.isFunction=l;var c=Array.isArray||function(t){return!(!t||"object"!=typeof t)&&"[object Array]"===u.call(t)};e.isArray=c},function(t,e,n){"use strict";var r,i;r=[n(19),n(20),n(70)],void 0===(i=function(t,e,n){return function(t,e,n){var r=function(e,n){return t.js_beautify(e,n)};return r.js=t.js_beautify,r.css=e.css_beautify,r.html=n.html_beautify,r.js_beautify=t.js_beautify,r.css_beautify=e.css_beautify,r.html_beautify=n.html_beautify,r}(t,e,n)}.apply(e,r))||(t.exports=i)},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n},function(t,e,n){"use strict";e.__esModule=!0;var r=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];function i(t,e){var n=e&&e.loc,o=void 0,a=void 0,s=void 0,u=void 0;n&&(o=n.start.line,a=n.end.line,s=n.start.column,u=n.end.column,t+=" - "+o+":"+s);for(var l=Error.prototype.constructor.call(this,t),c=0;c<r.length;c++)this[r[c]]=l[r[c]];Error.captureStackTrace&&Error.captureStackTrace(this,i);try{n&&(this.lineNumber=o,this.endLineNumber=a,Object.defineProperty?(Object.defineProperty(this,"column",{value:s,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:u,enumerable:!0})):(this.column=s,this.endColumn=u))}catch(t){}}i.prototype=new Error,e.default=i,t.exports=e.default},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){window,t.exports=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/assets/",n(n.s=39)}([function(t,e,n){var r=n(9),i=n(4),o=n(23);e=function(t,e,n){var a,s;if(e=o(e,n),r(t))for(a=0,s=t.length;a<s;a++)e(t[a],a,t);else{var u=i(t);for(a=0,s=u.length;a<s;a++)e(t[u[a]],u[a],t)}return t},t.exports=e},function(t,e,n){var r=n(10);e=function(t){return"[object String]"===r(t)},t.exports=e},function(t,e){e=function(t){var e=typeof t;return!!t&&("function"===e||"object"===e)},t.exports=e},function(t,e,n){var r=n(1),i=n(12),o=n(31);e=function(t){return i(r(t)?new o(t):t)},t.exports=e},function(t,e,n){var r=n(11);e=Object.keys?Object.keys:function(t){var e=[];for(var n in t)r(t,n)&&e.push(n);return e},t.exports=e},function(t,e){e=function(t){return void 0===t},t.exports=e},function(t,e,n){var r=n(10);e=function(t){var e=r(t);return"[object Function]"===e||"[object GeneratorFunction]"===e||"[object AsyncFunction]"===e},t.exports=e},function(t,e,n){var r=n(10);e=function(t){return"[object Number]"===r(t)},t.exports=e},function(t,e,n){var r=n(10);e=Array.isArray?Array.isArray:function(t){return"[object Array]"===r(t)},t.exports=e},function(t,e,n){var r=n(7),i=n(6),o=Math.pow(2,53)-1;e=function(t){if(!t)return!1;var e=t.length;return r(e)&&e>=0&&e<=o&&!i(t)},t.exports=e},function(t,e){var n=Object.prototype.toString;e=function(t){return n.call(t)},t.exports=e},function(t,e){var n=Object.prototype.hasOwnProperty;e=function(t,e){return n.call(t,e)},t.exports=e},function(t,e,n){var r=n(9),i=n(47),o=n(8),a=n(1);e=function(t){return t?o(t)?t:r(t)&&!a(t)?i(t):[t]:[]},t.exports=e},function(t,e,n){var r=n(21),i=n(12),o=n(48),a=n(26),s=n(50),u=(e=function(t,e){return u.extend(t,e)}).Base=function t(e,n,u){u=u||{};var l=n.className||a(n,"initialize.name")||"";delete n.className;var c=function(){var t=i(arguments);return this.initialize&&this.initialize.apply(this,t)||this};if(!s)try{c=new Function("toArr","return function "+l+"(){var args = toArr(arguments);return this.initialize ? this.initialize.apply(this, args) || this : this;};")(i)}catch(t){}return o(c,e),c.prototype.constructor=c,c.extend=function(e,n){return t(c,e,n)},c.inherits=function(t){o(c,t)},c.methods=function(t){return r(c.prototype,t),c},c.statics=function(t){return r(c,t),c},c.methods(n).statics(u),c}(Object,{className:"Base",callSuper:function(t,e,n){return t.prototype[e].apply(this,n)},toString:function(){return this.constructor.name}});t.exports=e},function(t,e,n){var r=n(15),i=n(0);e=function(t,e,n){var o=[];return e=r(e,n),i(t,(function(t,n,r){e(t,n,r)&&o.push(t)})),o},t.exports=e},function(t,e,n){var r=n(6),i=n(2),o=n(8),a=n(23),s=n(41),u=n(44),l=n(45);e=function(t,e,n){return null==t?u:r(t)?a(t,e,n):i(t)&&!o(t)?s(t):l(t)},t.exports=e},function(t,e,n){var r=n(17);e=function(t){return r(t).toLocaleLowerCase()},t.exports=e},function(t,e){e=function(t){return null==t?"":t.toString()},t.exports=e},function(t,e){e=function(t){return t.length<1?t:t[0].toUpperCase()+t.slice(1)},t.exports=e},function(t,e,n){var r=n(63),i=n(1),o=n(9),a=n(64);e=function(t,e){return i(t)?t.indexOf(e)>-1:(o(t)||(t=a(t)),r(t,e)>=0)},t.exports=e},function(t,e,n){var r=n(13),i=n(11),o=n(0),a=n(51),s=n(52);e=r({initialize:function(){this._events=this._events||{}},on:function(t,e){return this._events[t]=this._events[t]||[],this._events[t].push(e),this},off:function(t,e){if(i(this._events,t))return this._events[t].splice(this._events[t].indexOf(e),1),this},once:function(t,e){return this.on(t,s(e)),this},emit:function(t){if(i(this._events,t)){var e=a(arguments,1);return o(this._events[t],(function(t){t.apply(this,e)}),this),this}}},{mixin:function(t){o(["on","off","once","emit"],(function(n){t[n]=e.prototype[n]})),t._events=t._events||{}}}),t.exports=e},function(t,e,n){e=n(22)(n(24)),t.exports=e},function(t,e,n){var r=n(5),i=n(0);e=function(t,e){return function(n){return i(arguments,(function(o,a){if(0!==a){var s=t(o);i(s,(function(t){e&&!r(n[t])||(n[t]=o[t])}))}})),n}},t.exports=e},function(t,e,n){var r=n(5);e=function(t,e,n){if(r(e))return t;switch(null==n?3:n){case 1:return function(n){return t.call(e,n)};case 3:return function(n,r,i){return t.call(e,n,r,i)};case 4:return function(n,r,i,o){return t.call(e,n,r,i,o)}}return function(){return t.apply(e,arguments)}},t.exports=e},function(t,e,n){var r=n(4),i=n(25),o=n(40),a=Object.getOwnPropertyNames,s=Object.getOwnPropertySymbols;e=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.prototype,u=void 0===n||n,l=e.unenumerable,c=void 0!==l&&l,h=e.symbol,p=void 0!==h&&h,f=[];if((c||p)&&a){var _=r;c&&a&&(_=a);do{f=f.concat(_(t)),p&&s&&(f=f.concat(s(t)))}while(u&&(t=i(t))&&t!==Object.prototype);f=o(f)}else if(u)for(var d in t)f.push(d);else f=r(t);return f},t.exports=e},function(t,e,n){var r=n(2),i=n(6),o=Object.getPrototypeOf,a={}.constructor;e=function(t){if(r(t)){if(o)return o(t);var e=t.__proto__;return e||null===e?e:i(t.constructor)?t.constructor.prototype:t instanceof a?a.prototype:void 0}},t.exports=e},function(t,e,n){var r=n(5),i=n(46);e=function(t,e){var n;for(n=(e=i(e,t)).shift();!r(n);){if(null==(t=t[n]))return;n=e.shift()}return t},t.exports=e},function(t,e){e=function(t,e){return e=null==e?t.length-1:+e,function(){var n,r=Math.max(arguments.length-e,0),i=new Array(r);for(n=0;n<r;n++)i[n]=arguments[n+e];switch(e){case 0:return t.call(this,i);case 1:return t.call(this,arguments[0],i);case 2:return t.call(this,arguments[0],arguments[1],i)}var o=new Array(e+1);for(n=0;n<e;n++)o[n]=arguments[n];return o[e]=i,t.apply(this,o)}},t.exports=e},function(t,e){e=function(t){return!0===t||!1===t},t.exports=e},function(t,e,n){var r=n(7);e=function(t){return r(t)&&t!==+t},t.exports=e},function(t,e,n){var r=n(31),i=n(60),o=n(61),a=n(62),s=n(34),u=n(68),l=n(69),c=n(70),h=n(71),p=n(72),f=n(74),_=n(76),d=n(5),v=n(1);e=function(t){return new r(t)},r.methods({offset:function(){return i(this)},hide:function(){return this.css("display","none")},show:function(){return o(this),this},first:function(){return e(this[0])},last:function(){return e(l(this))},get:function(t){return this[t]},eq:function(t){return e(this[t])},on:function(t,e,n){return p.on(this,t,e,n),this},off:function(t,e,n){return p.off(this,t,e,n),this},html:function(t){var e=u.html(this,t);return d(t)?e:this},text:function(t){var e=u.text(this,t);return d(t)?e:this},val:function(t){var e=u.val(this,t);return d(t)?e:this},css:function(t,e){var n=a(this,t,e);return g(t,e)?n:this},attr:function(t,e){var n=s(this,t,e);return g(t,e)?n:this},data:function(t,e){var n=h(this,t,e);return g(t,e)?n:this},rmAttr:function(t){return s.remove(this,t),this},remove:function(){return c(this),this},addClass:function(t){return f.add(this,t),this},rmClass:function(t){return f.remove(this,t),this},toggleClass:function(t){return f.toggle(this,t),this},hasClass:function(t){return f.has(this,t)},parent:function(){return e(this[0].parentNode)},append:function(t){return _.append(this,t),this},prepend:function(t){return _.prepend(this,t),this},before:function(t){return _.before(this,t),this},after:function(t){return _.after(this,t),this}});var g=function(t,e){return d(e)&&v(t)};t.exports=e},function(t,e,n){var r=n(13),i=n(1),o=n(0),a=new(e=r({className:"Select",initialize:function(t){return this.length=0,t?i(t)?a.find(t):void(t.nodeType&&(this[0]=t,this.length=1)):this},find:function(t){var n=new e;return this.each((function(){!function(t,e){for(var n=e.length,r=t.length,i=0;i<n;i++)t[r++]=e[i];t.length=r}(n,this.querySelectorAll(t))})),n},each:function(t){return o(this,(function(e,n){t.call(e,n,e)})),this}}))(document);t.exports=e},function(t,e,n){var r=n(33);e=function(t){return r(t).join("-")},t.exports=e},function(t,e){var n=/([A-Z])/g,r=/[_.\- ]+/g,i=/(^-)|(-$)/g;e=function(t){return(t=t.replace(n,"-$1").toLowerCase().replace(r,"-").replace(i,"")).split("-")},t.exports=e},function(t,e,n){var r=n(12),i=n(2),o=n(1),a=n(0),s=n(5),u=n(3);(e=function(t,e,n){if(t=u(t),s(n)&&o(e))return function(t,e){return t.getAttribute(e)}(t[0],e);var r=e;i(r)||((r={})[e]=n),function(t,e){a(t,(function(t){a(e,(function(e,n){t.setAttribute(n,e)}))}))}(t,r)}).remove=function(t,e){t=u(t),e=r(e),a(t,(function(t){a(e,(function(e){t.removeAttribute(e)}))}))},t.exports=e},function(t,e){e=function(t,e){var n=[];e=e||1;for(var r=0,i=Math.ceil(t.length/e);r<i;r++){var o=r*e,a=o+e;n.push(t.slice(o,a))}return n},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var i=r(n(17)),o=r(n(81)),a=r(n(37)),s=r(n(38)),u=r(n(84));e.encode=function(t){return u.default(i.default(t)).replace(/\n/g,"↵").replace(/\f|\r|\t/g,"")},e.getFnAbstract=function(t){return t.length>500&&(t=t.slice(0,500)+"..."),"ƒ "+o.default(function(t){var e=t.match(l);return e?e[0]:t}(t).replace("function",""))};var l=/function(.*?)\((.*?)\)/;function c(t,e){return(t=h(t))>(e=h(e))?1:t<e?-1:0}function h(t){return 95===t?123:t}e.sortObjName=function(t,e){t=i.default(t),e=i.default(e);var n=a.default(t),r=a.default(e);if(!isNaN(n)&&!isNaN(r))return n>r?1:n<r?-1:0;(s.default(t,"get ")||s.default(t,"set "))&&(t=t.slice(4)),(s.default(e,"get ")||s.default(e,"set "))&&(e=e.slice(4));for(var o=t.length,u=e.length,l=o>u?u:o,h=0;h<l;h++){var p=c(t.charCodeAt(h),e.charCodeAt(h));if(0!==p)return p}return o>u?1:o<u?-1:0}},function(t,e,n){var r=n(7),i=n(2),o=n(6),a=n(1);e=function(t){if(r(t))return t;if(i(t)){var e=o(t.valueOf)?t.valueOf():t;t=i(e)?e+"":e}return a(t)?+t:0===t?t:+t},t.exports=e},function(t,e){e=function(t,e){return 0===t.indexOf(e)},t.exports=e},function(t,e,n){"use strict";var r,i,o=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),a=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var s=a(n(20)),u=a(n(25)),l=a(n(7)),c=a(n(28)),h=a(n(16)),p=a(n(2)),f=a(n(8)),_=a(n(18)),d=a(n(4)),v=a(n(0)),g=a(n(55)),m=a(n(57)),b=a(n(58)),y=a(n(30)),w=a(n(77)),x=a(n(24)),k=a(n(14)),O=a(n(35)),$=a(n(17)),j=a(n(79)),S=a(n(80)),E=n(36),A=a(n(85));n(87);var T="luna-object-viewer-";t.exports=((i=function(t){function e(e,n){var r=void 0===n?{}:n,i=r.unenumerable,o=void 0!==i&&i,a=r.accessGetter,s=void 0!==a&&a,u=t.call(this)||this;return u.$container=y.default(e),u.$container.addClass("luna-object-viewer"),u.unenumerable=o,u.accessGetter=s,u.bindEvent(),u}return o(e,t),e.prototype.set=function(t){this.data=[t],this.visitor=new S.default,this.map={},this.appendTpl()},e.prototype.objToHtml=function(t,e){var n=this,r=this.visitor,i=t,o=!1,a=r.get(t);a&&a.self&&(i=a.self);var s="",l=["enumerable"],c=d.default(t),h=[],p=[],_=[],g={};if(this.unenumerable&&!e&&(l.push("unenumerable"),l.push("symbol"),h=w.default(x.default(t,{prototype:!1,unenumerable:!0}),c),p=k.default(x.default(t,{prototype:!1,symbol:!0}),(function(t){return"symbol"==typeof t}))),f.default(t)&&t.length>100){l.unshift("virtual"),o=!0;var b=0,y={};v.default(O.default(t,100),(function(t){var e=Object.create(null),n=b,r="["+n;v.default(t,(function(t){e[b]=t,y[b]=!0,b++}));var i=b-1;g[r+=(i-n>0?" … "+i:"")+"]"]=e})),_=d.default(g),c=k.default(c,(function(t){return!y[t]}))}v.default(l,(function(r){var a=[];a="symbol"===r?p:"unenumerable"===r?h:"virtual"===r?_:c,o||a.sort(E.sortObjName);for(var u=0,l=a.length;u<l;u++){var f=$.default(a[u]),d="",v=Object.getOwnPropertyDescriptor(t,f),b=v&&v.get,y=v&&v.set;if(b&&!n.accessGetter)d="(...)";else try{d="virtual"===r?g[f]:i[f],m.default(d)&&d.catch(j.default)}catch(t){d=t.message}s+=n.createEl(f,t,d,r,e),b&&(s+=n.createEl("get "+f,t,v.get,r,e)),y&&(s+=n.createEl("set "+f,t,v.set,r,e))}}));var S=u.default(t);if(!e&&S)if(""===s){var A=r.set(S,{self:t});this.map[A]=S,s=this.objToHtml(S)}else s+=this.createEl("__proto__",i||t,S,"proto");return s},e.prototype.createEl=function(t,e,n,r,i){void 0===i&&(i=!1);var o=this.visitor,a=typeof n,s=b.default(n,!1);if("virtual"===r&&(s=t),null===n)return"<li>"+y(t)+'<span class="'+T+'null">null</span></li>';if(l.default(n)||c.default(n))return"<li>"+y(t)+'<span class="'+(T+a)+'">'+E.encode(n)+"</span></li>";if("RegExp"===s&&(a="regexp"),"Number"===s&&(a="number"),"Number"===s||"RegExp"===s)return"<li>"+y(t)+'<span class="'+(T+a)+'">'+E.encode(n.value)+"</span></li>";if("Undefined"===s||"Symbol"===s)return"<li>"+y(t)+'<span class="'+T+'special">'+h.default(s)+"</span></li>";if("(...)"===n)return"<li>"+y(t)+'<span class="'+T+'special">'+n+"</span></li>";if(p.default(n)){var u=o.get(n),f=void 0;if(u)f=u.id;else{var d={};"proto"===r&&(d.self=e),f=o.set(n,d),this.map[f]=n}var v=function(t,e){if(e)return"Function"===e?E.getFnAbstract(g.default(t)):"Array"===e?"Array("+t.length+")":e}(n,s)||_.default(a),m="<li "+(i?'data-first-level="true"':"")+' data-object-id="'+f+'"><span class="'+(i?"":T+"expanded "+T+"collapsed")+'"></span>'+y(t)+'<span class="'+T+'open">'+(i?"":v)+'</span><ul class="'+(T+a)+'" '+(i?"":'style="display:none"')+">";return i&&(m+=this.objToHtml(n)),m+'</ul><span class="'+T+'close"></span></li>'}function y(t){if(i)return"";if(p.default(n)&&"virtual"===r)return"";var e=T+"key";return"unenumerable"!==r&&"proto"!==r&&"symbol"!==r||(e=T+"key-lighter"),'<span class="'+e+'">'+E.encode(t)+"</span>: "}return"<li>"+y(t)+'<span class="'+T+typeof n+'">"'+E.encode(n)+'"</span></li>'},e.prototype.appendTpl=function(){this.$container.html(this.objToHtml(this.data,!0))},e.prototype.bindEvent=function(){var t=this;this.$container.on("click","li",(function(e){var n=t.map,r=y.default(this),i=r.data("object-id"),o=y.default(this).find("span").eq(0);if(!r.data("first-level")&&(i&&(r.find("ul").html(t.objToHtml(n[i],!1)),r.rmAttr("data-object-id")),e.stopImmediatePropagation(),o.hasClass(T+"expanded"))){var a=r.find("ul").eq(0);o.hasClass(T+"collapsed")?(o.rmClass(T+"collapsed"),a.show()):(o.addClass(T+"collapsed"),a.hide()),t.emit("change")}}))},e}(s.default)).Static=A.default,i)},function(t,e,n){var r=n(14);function i(t,e){return t===e}e=function(t,e){return e=e||i,r(t,(function(t,n,r){for(var i=r.length;++n<i;)if(e(t,r[n]))return!1;return!0}))},t.exports=e},function(t,e,n){var r=n(42),i=n(43);e=function(t){return t=r({},t),function(e){return i(e,t)}},t.exports=e},function(t,e,n){var r=n(4);e=n(22)(r),t.exports=e},function(t,e,n){var r=n(4);e=function(t,e){var n=r(e),i=n.length;if(null==t)return!i;t=Object(t);for(var o=0;o<i;o++){var a=n[o];if(e[a]!==t[a]||!(a in t))return!1}return!0},t.exports=e},function(t,e){e=function(t){return t},t.exports=e},function(t,e,n){var r=n(8),i=n(26);e=function(t){return r(t)?function(e){return i(e,t)}:(e=t,function(t){return null==t?void 0:t[e]});var e},t.exports=e},function(t,e,n){var r=n(11),i=n(8);e=function(t,e){if(i(t))return t;if(e&&r(e,t))return[t];var n=[];return t.replace(o,(function(t,e,r,i){n.push(r?i.replace(a,"$1"):e||t)})),n};var o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,a=/\\(\\)?/g;t.exports=e},function(t,e,n){var r=n(15),i=n(4),o=n(9);e=function(t,e,n){e=r(e,n);for(var a=!o(t)&&i(t),s=(a||t).length,u=Array(s),l=0;l<s;l++){var c=a?a[l]:l;u[l]=e(t[c],c,t)}return u},t.exports=e},function(t,e,n){var r=n(49);e=function(t,e){t.prototype=r(e.prototype)},t.exports=e},function(t,e,n){var r=n(2);e=function(t){if(!r(t))return{};if(i)return i(t);function e(){}return e.prototype=t,new e};var i=Object.create;t.exports=e},function(t,e,n){var r=n(6);e="undefined"!=typeof wx&&r(wx.openLocation),t.exports=e},function(t,e){e=function(t,e,n){var r=t.length;e=null==e?0:e<0?Math.max(r+e,0):Math.min(e,r),n=null==n?r:n<0?Math.max(r+n,0):Math.min(n,r);for(var i=[];e<n;)i.push(t[e++]);return i},t.exports=e},function(t,e,n){e=n(53)(n(54),2),t.exports=e},function(t,e,n){var r=n(27),i=n(12);e=r((function(t,e){return function(){var n=[];return n=(n=n.concat(e)).concat(i(arguments)),t.apply(this,n)}})),t.exports=e},function(t,e){e=function(t,e){var n;return function(){return--t>0&&(n=e.apply(this,arguments)),t<=1&&(e=null),n}},t.exports=e},function(t,e,n){var r=n(56);e=function(t){if(r(t))return"";try{return i.call(t)}catch(t){}try{return t+""}catch(t){}return""};var i=Function.prototype.toString;t.exports=e},function(t,e){e=function(t){return null==t},t.exports=e},function(t,e,n){var r=n(2),i=n(6);e=function(t){return r(t)&&i(t.then)&&i(t.catch)},t.exports=e},function(t,e,n){var r=n(10),i=n(29),o=n(16),a=n(59);e=function(t){var e,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return null===t&&(e="Null"),void 0===t&&(e="Undefined"),i(t)&&(e="NaN"),a(t)&&(e="Buffer"),e||(e=r(t).match(s))&&(e=e[1]),e?n?o(e):e:""};var s=/^\[object\s+(.*?)]$/;t.exports=e},function(t,e,n){var r=n(6);e=function(t){return null!=t&&(!!t._isBuffer||t.constructor&&r(t.constructor.isBuffer)&&t.constructor.isBuffer(t))},t.exports=e},function(t,e,n){var r=n(3);e=function(t){var e=(t=r(t))[0].getBoundingClientRect();return{left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:Math.round(e.width),height:Math.round(e.height)}},t.exports=e},function(t,e,n){var r=n(0),i=n(3);e=function(t){t=i(t),r(t,(function(t){(function(t){return"none"==getComputedStyle(t,"").getPropertyValue("display")})(t)&&(t.style.display=function(t){var e,n;return o[t]||(e=document.createElement(t),document.documentElement.appendChild(e),n=getComputedStyle(e,"").getPropertyValue("display"),e.parentNode.removeChild(e),"none"==n&&(n="block"),o[t]=n),o[t]}(t.nodeName))}))};var o={};t.exports=e},function(t,e,n){var r=n(1),i=n(2),o=n(32),a=n(5),s=n(19),u=n(7),l=n(3),c=n(65),h=n(0);e=function(t,e,n){if(t=l(t),a(n)&&r(e))return function(t,e){return t.style[c(e)]||getComputedStyle(t,"").getPropertyValue(e)}(t[0],e);var f=e;i(f)||((f={})[e]=n),function(t,e){h(t,(function(t){var n=";";h(e,(function(t,e){e=c.dash(e),n+=e+":"+function(t,e){return u(e)&&!s(p,o(t))?e+"px":e}(e,t)+";"})),t.style.cssText+=n}))}(t,f)};var p=["column-count","columns","font-weight","line-weight","opacity","z-index","zoom"];t.exports=e},function(t,e){e=function(t,e,n){return Array.prototype.indexOf.call(t,e,n)},t.exports=e},function(t,e,n){var r=n(0);e=function(t){var e=[];return r(t,(function(t){e.push(t)})),e},t.exports=e},function(t,e,n){var r=n(66),i=n(67),o=n(18),a=n(11),s=n(32);(e=r((function(t){if(t=t.replace(l,""),t=i(t),a(c,t))return t;for(var e=u.length;e--;){var n=u[e]+o(t);if(a(c,n))return n}return t}))).dash=r((function(t){var n=e(t);return(l.test(n)?"-":"")+s(n)}));var u=["O","ms","Moz","Webkit"],l=/^(O)|(ms)|(Moz)|(Webkit)|(-o-)|(-ms-)|(-moz-)|(-webkit-)/g,c=document.createElement("p").style;t.exports=e},function(t,e,n){var r=n(11);e=function(t,e){var n=function(i){var o=n.cache,a=""+(e?e.apply(this,arguments):i);return r(o,a)||(o[a]=t.apply(this,arguments)),o[a]};return n.cache={},n},t.exports=e},function(t,e,n){var r=n(33);function i(t,e){this[e]=t.replace(/\w/,(function(t){return t.toUpperCase()}))}e=function(t){var e=r(t),n=e[0];return e.shift(),e.forEach(i,e),n+e.join("")},t.exports=e},function(t,e,n){var r=n(5),i=n(0),o=n(3);function a(t){return function(e,n){var a=(e=o(e))[0];if(r(n))return a?a[t]:"";a&&i(e,(function(e){e[t]=n}))}}e={html:a("innerHTML"),text:a("textContent"),val:a("value")},t.exports=e},function(t,e){e=function(t){var e=t?t.length:0;if(e)return t[e-1]},t.exports=e},function(t,e,n){var r=n(0),i=n(3);e=function(t){t=i(t),r(t,(function(t){var e=t.parentNode;e&&e.removeChild(t)}))},t.exports=e},function(t,e,n){var r=n(34),i=n(1),o=n(2),a=n(0);n(3),e=function(t,e,n){var s=e;return i(e)&&(s="data-"+e),o(e)&&(s={},a(e,(function(t,e){s["data-"+e]=t}))),r(t,s,n)},t.exports=e},function(t,e,n){var r=n(73),i=n(5),o=n(3),a=n(0);function s(t){return function(e,n,s,u){e=o(e),i(u)&&(u=s,s=void 0),a(e,(function(e){r[t](e,n,s,u)}))}}e={on:s("add"),off:s("remove")},t.exports=e},function(t,e,n){var r=n(13),i=n(19);function o(){return!0}function a(){return!1}function s(t){var n,r=this.events[t.type],i=u.call(this,t,r);t=new e.Event(t);for(var o,a,s=0;(a=i[s++])&&!t.isPropagationStopped();)for(t.curTarget=a.el,o=0;(n=a.handlers[o++])&&!t.isImmediatePropagationStopped();)!1===n.handler.apply(a.el,[t])&&(t.preventDefault(),t.stopPropagation())}function u(t,e){var n,r,o,a,s=t.target,u=[],l=e.delegateCount;if(s.nodeType)for(;s!==this;s=s.parentNode||this){for(r=[],a=0;a<l;a++)void 0===r[n=(o=e[a]).selector+" "]&&(r[n]=i(this.querySelectorAll(n),s)),r[n]&&r.push(o);r.length&&u.push({el:s,handlers:r})}return l<e.length&&u.push({el:this,handlers:e.slice(l)}),u}e={add:function(t,e,n,r){var i,o={selector:n,handler:r};t.events||(t.events={}),(i=t.events[e])||((i=t.events[e]=[]).delegateCount=0,t.addEventListener(e,(function(){s.apply(t,arguments)}),!1)),n?i.splice(i.delegateCount++,0,o):i.push(o)},remove:function(t,e,n,r){var i=t.events;if(i&&i[e])for(var o,a=i[e],s=a.length;s--;)o=a[s],n&&o.selector!=n||o.handler!=r||(a.splice(s,1),o.selector&&a.delegateCount--)},Event:r({className:"Event",initialize:function(t){this.origEvent=t},isDefaultPrevented:a,isPropagationStopped:a,isImmediatePropagationStopped:a,preventDefault:function(){var t=this.origEvent;this.isDefaultPrevented=o,t&&t.preventDefault&&t.preventDefault()},stopPropagation:function(){var t=this.origEvent;this.isPropagationStopped=o,t&&t.stopPropagation&&t.stopPropagation()},stopImmediatePropagation:function(){var t=this.origEvent;this.isImmediatePropagationStopped=o,t&&t.stopImmediatePropagation&&t.stopImmediatePropagation(),this.stopPropagation()}})},t.exports=e},function(t,e,n){var r=n(12),i=n(75),o=n(3),a=n(1),s=n(0);function u(t){return a(t)?t.split(/\s+/):r(t)}e={add:function(t,n){t=o(t);var r=u(n);s(t,(function(t){var n=[];s(r,(function(r){e.has(t,r)||n.push(r)})),0!==n.length&&(t.className+=(t.className?" ":"")+n.join(" "))}))},has:function(t,e){t=o(t);var n=new RegExp("(^|\\s)"+e+"(\\s|$)");return i(t,(function(t){return n.test(t.className)}))},toggle:function(t,n){t=o(t),s(t,(function(t){if(!e.has(t,n))return e.add(t,n);e.remove(t,n)}))},remove:function(t,e){t=o(t);var n=u(e);s(t,(function(t){s(n,(function(e){t.classList.remove(e)}))}))}},t.exports=e},function(t,e,n){var r=n(15),i=n(9),o=n(4);e=function(t,e,n){e=r(e,n);for(var a=!i(t)&&o(t),s=(a||t).length,u=0;u<s;u++){var l=a?a[u]:u;if(e(t[l],l,t))return!0}return!1},t.exports=e},function(t,e,n){var r=n(0),i=n(3);function o(t){return function(e,n){e=i(e),r(e,(function(e){e.insertAdjacentHTML(t,n)}))}}e={before:o("beforebegin"),after:o("afterend"),append:o("beforeend"),prepend:o("afterbegin")},t.exports=e},function(t,e,n){var r=n(27),i=n(78),o=n(14),a=n(19);e=r((function(t,e){return e=i(e),o(t,(function(t){return!a(e,t)}))})),t.exports=e},function(t,e,n){var r=n(8);e=function(t){return function t(e,n){for(var i,o=e.length,a=-1;o--;)i=e[++a],r(i)?t(i,n):n.push(i);return n}(t,[])},t.exports=e},function(t,e){e=function(){},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var i=r(n(21)),o=function(){function t(){this.id=0,this.visited=[]}return t.prototype.set=function(t,e){var n=this.visited,r=this.id,o={id:r,val:t};return i.default(o,e),n.push(o),this.id++,r},t.prototype.get=function(t){for(var e=this.visited,n=0,r=e.length;n<r;n++){var i=e[n];if(t===i.val)return i}return!1},t}();e.default=o},function(t,e,n){var r=n(82),i=n(83),o=/^\s+|\s+$/g;e=function(t,e){return null==e?t.replace(o,""):r(i(t,e),e)},t.exports=e},function(t,e){var n=/^\s+/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=0,a=t.length,s=e.length,u=!0;u&&o<a;)for(u=!1,r=-1,i=t.charAt(o);++r<s;)if(i===e[r]){u=!0,o++;break}return o>=a?"":t.substr(o,a)},t.exports=e},function(t,e){var n=/\s+$/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=t.length-1,a=e.length,s=!0;s&&o>=0;)for(s=!1,r=-1,i=t.charAt(o);++r<a;)if(i===e[r]){s=!0,o--;break}return o>=0?t.substring(0,o+1):""},t.exports=e},function(t,e,n){var r=n(4),i=(e=function(t){return a.test(t)?t.replace(s,u):t}).map={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},o="(?:"+r(i).join("|")+")",a=new RegExp(o),s=new RegExp(o,"g"),u=function(t){return i[t]};t.exports=e},function(t,e,n){"use strict";var r,i=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}),o=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0});var a=o(n(30)),s=o(n(38)),u=o(n(2)),l=o(n(86)),c=o(n(18)),h=o(n(37)),p=o(n(35)),f=o(n(0)),_=o(n(29)),d=o(n(7)),v=o(n(28)),g=o(n(1)),m=o(n(4)),b=o(n(16)),y=o(n(20)),w=n(36),x="luna-object-viewer-",k=function(t){function e(e){var n=t.call(this)||this;return n.$container=a.default(e),n.$container.addClass("luna-object-viewer"),n.bindEvent(),n}return i(e,t),e.prototype.set=function(t){g.default(t)&&(t=JSON.parse(t)),this.data={id:l.default("json"),enumerable:{0:t}},this.map={},function t(e,n){var r=n.id;if(r||0===r){if(n.type&&s.default(n.type,"Array")&&n.enumerable){var i=function(t,e,n){var r=[],i={};return f.default(t.enumerable,(function(t,e){var n=h.default(e);_.default(n)?i[e]=t:r[n]=t})),r.enumerable=i,r.type=n,r.id=e,t.unenumerable&&(r.unenumerable=t.unenumerable),t.symbol&&(r.symbol=t.symbol),t.proto&&(r.proto=t.proto),r}(n,r,n.type);i.length>100&&(n=function(t){var e=0,n={};f.default(p.default(t,100),(function(t){var r={},i=e;r.type="["+i,r.enumerable={},f.default(t,(function(t){r.enumerable[e]=t,e+=1}));var o=e-1;r.type+=(o-i>0?" … "+o:"")+"]",r.id=l.default("json"),r.jsonSplitArr=!0,n[e]=r}));var r={};return r.enumerable=n,r.id=t.id,r.type=t.type,t.unenumerable&&(r.unenumerable=t.unenumerable),t.symbol&&(r.symbol=t.symbol),t.proto&&(r.proto=t.proto),r}(i))}e[r]=n;var o=[];f.default(["enumerable","unenumerable","symbol"],(function(t){if(n[t])for(var e in n[t])o.push(n[t][e])})),n.proto&&o.push(n.proto);for(var a=0,c=o.length;a<c;a++){var d=o[a];u.default(d)&&t(e,d)}}}(this.map,this.data),this.appendTpl()},e.prototype.objToHtml=function(t,e){var n=this,r="";return f.default(["enumerable","unenumerable","symbol"],(function(i){if(t[i]){var o=m.default(t[i]);o.sort(w.sortObjName);for(var a=0,s=o.length;a<s;a++){var u=o[a];r+=n.createEl(u,t[i][u],i,e)}}})),t.proto&&(""===r?r=this.objToHtml(t.proto):r+=this.createEl("__proto__",t.proto,"proto")),r},e.prototype.createEl=function(t,e,n,r){void 0===r&&(r=!1);var i=typeof e;if(null===e)return"<li>"+h(t)+'<span class="'+x+'null">null</span></li>';if(d.default(e)||v.default(e))return"<li>"+h(t)+'<span class="'+(x+i)+'">'+w.encode(e)+"</span></li>";if("RegExp"===e.type&&(i="regexp"),"Number"===e.type&&(i="number"),"Number"===e.type||"RegExp"===e.type)return"<li>"+h(t)+'<span class="'+(x+i)+'">'+w.encode(e.value)+"</span></li>";if("Undefined"===e.type||"Symbol"===e.type)return"<li>"+h(t)+'<span class="'+x+'special">'+b.default(e.type)+"</span></li>";if("(...)"===e)return"<li>"+h(t)+'<span class="'+x+'special">'+e+"</span></li>";if(u.default(e)){var o=e.id,a=e.reference,s=O(e)||c.default(i),l="<li "+(r?'data-first-level="true"':"")+' data-object-id="'+(a||o)+'"><span class="'+(r?"":x+"expanded "+x+"collapsed")+'"></span>'+h(t)+'<span class="'+x+'open">'+(r?"":s)+'</span><ul class="'+(x+i)+'" '+(r?"":'style="display:none"')+">";return r&&(l+=this.objToHtml(this.map[o])),l+'</ul><span class="'+x+'close"></span></li>'}function h(t){if(r)return"";if(u.default(e)&&e.jsonSplitArr)return"";var i=x+"key";return"unenumerable"!==n&&"proto"!==n&&"symbol"!==n||(i=x+"key-lighter"),'<span class="'+i+'">'+w.encode(t)+"</span>: "}return"<li>"+h(t)+'<span class="'+x+typeof e+'">"'+w.encode(e)+'"</span></li>'},e.prototype.appendTpl=function(){var t=this.map[this.data.id];this.$container.html(this.objToHtml(t,!0))},e.prototype.bindEvent=function(){var t=this;this.$container.on("click","li",(function(e){var n=t.map,r=a.default(this),i=r.data("object-id"),o=a.default(this).find("span").eq(0);if(!r.data("first-level")&&(i&&(r.find("ul").html(t.objToHtml(n[i],!1)),r.rmAttr("data-object-id")),e.stopImmediatePropagation(),o.hasClass(x+"expanded"))){var s=r.find("ul").eq(0);o.hasClass(x+"collapsed")?(o.rmClass(x+"collapsed"),s.show()):(o.addClass(x+"collapsed"),s.hide()),t.emit("change")}}))},e}(y.default);function O(t){var e=t.type,n=t.value;if(e)return"Function"===e?w.getFnAbstract(n):"Array"===e&&t.unenumerable?"Array("+t.unenumerable.length+")":t.type}e.default=k,e.getObjAbstract=O},function(t,e){var n=0;e=function(t){var e=++n+"";return t?t+e:e},t.exports=e},function(t,e,n){}])},function(t,e,n){var r=n(64),i=n(65),o=n(66),a=n(68);t.exports=function(t,e){return r(t)||i(t,e)||o(t,e)||a()}},function(t,e,n){var r,i;i=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){"use strict";var r=n(1).Beautifier,i=n(5).Options;t.exports=function(t,e){return new r(t,e).beautify()},t.exports.defaultOptions=function(){return new i}},function(t,e,n){"use strict";var r=n(2).Output,i=n(3).Token,o=n(4),a=n(5).Options,s=n(7).Tokenizer,u=n(7).line_starters,l=n(7).positionable_operators,c=n(7).TOKEN;function h(t,e){return-1!==e.indexOf(t)}function p(t,e){return t&&t.type===c.RESERVED&&t.text===e}function f(t,e){return t&&t.type===c.RESERVED&&h(t.text,e)}var _=["case","return","do","if","throw","else","await","break","continue","async"],d=function(t){for(var e={},n=0;n<t.length;n++)e[t[n].replace(/-/g,"_")]=t[n];return e}(["before-newline","after-newline","preserve-newline"]),v=[d.before_newline,d.preserve_newline],g="BlockStatement",m="Statement",b="ObjectLiteral",y="ArrayLiteral",w="ForInitializer",x="Conditional",k="Expression";function O(t,e){e.multiline_frame||e.mode===w||e.mode===x||t.remove_indent(e.start_line_index)}function $(t){return t===y}function j(t){return h(t,[k,w,x])}function S(t,e){e=e||{},this._source_text=t||"",this._output=null,this._tokens=null,this._last_last_text=null,this._flags=null,this._previous_flags=null,this._flag_store=null,this._options=new a(e)}S.prototype.create_flags=function(t,e){var n=0;return t&&(n=t.indentation_level,!this._output.just_added_newline()&&t.line_indent_level>n&&(n=t.line_indent_level)),{mode:e,parent:t,last_token:t?t.last_token:new i(c.START_BLOCK,""),last_word:t?t.last_word:"",declaration_statement:!1,declaration_assignment:!1,multiline_frame:!1,inline_frame:!1,if_block:!1,else_block:!1,do_block:!1,do_while:!1,import_block:!1,in_case_statement:!1,in_case:!1,case_body:!1,indentation_level:n,alignment:0,line_indent_level:t?t.line_indent_level:n,start_line_index:this._output.get_line_number(),ternary_depth:0}},S.prototype._reset=function(t){var e=t.match(/^[\t ]*/)[0];this._last_last_text="",this._output=new r(this._options,e),this._output.raw=this._options.test_output_raw,this._flag_store=[],this.set_mode(g);var n=new s(t,this._options);return this._tokens=n.tokenize(),t},S.prototype.beautify=function(){if(this._options.disabled)return this._source_text;var t=this._reset(this._source_text),e=this._options.eol;"auto"===this._options.eol&&(e="\n",t&&o.lineBreak.test(t||"")&&(e=t.match(o.lineBreak)[0]));for(var n=this._tokens.next();n;)this.handle_token(n),this._last_last_text=this._flags.last_token.text,this._flags.last_token=n,n=this._tokens.next();return this._output.get_code(e)},S.prototype.handle_token=function(t,e){t.type===c.START_EXPR?this.handle_start_expr(t):t.type===c.END_EXPR?this.handle_end_expr(t):t.type===c.START_BLOCK?this.handle_start_block(t):t.type===c.END_BLOCK?this.handle_end_block(t):t.type===c.WORD||t.type===c.RESERVED?this.handle_word(t):t.type===c.SEMICOLON?this.handle_semicolon(t):t.type===c.STRING?this.handle_string(t):t.type===c.EQUALS?this.handle_equals(t):t.type===c.OPERATOR?this.handle_operator(t):t.type===c.COMMA?this.handle_comma(t):t.type===c.BLOCK_COMMENT?this.handle_block_comment(t,e):t.type===c.COMMENT?this.handle_comment(t,e):t.type===c.DOT?this.handle_dot(t):t.type===c.EOF?this.handle_eof(t):(t.type,c.UNKNOWN,this.handle_unknown(t,e))},S.prototype.handle_whitespace_and_comments=function(t,e){var n=t.newlines,r=this._options.keep_array_indentation&&$(this._flags.mode);if(t.comments_before)for(var i=t.comments_before.next();i;)this.handle_whitespace_and_comments(i,e),this.handle_token(i,e),i=t.comments_before.next();if(r)for(var o=0;o<n;o+=1)this.print_newline(o>0,e);else if(this._options.max_preserve_newlines&&n>this._options.max_preserve_newlines&&(n=this._options.max_preserve_newlines),this._options.preserve_newlines&&n>1){this.print_newline(!1,e);for(var a=1;a<n;a+=1)this.print_newline(!0,e)}};var E=["async","break","continue","return","throw","yield"];S.prototype.allow_wrap_or_preserved_newline=function(t,e){if(e=void 0!==e&&e,!this._output.just_added_newline()){var n=this._options.preserve_newlines&&t.newlines||e;if(h(this._flags.last_token.text,l)||h(t.text,l)){var r=h(this._flags.last_token.text,l)&&h(this._options.operator_position,v)||h(t.text,l);n=n&&r}if(n)this.print_newline(!1,!0);else if(this._options.wrap_line_length){if(f(this._flags.last_token,E))return;this._output.set_wrap_point()}}},S.prototype.print_newline=function(t,e){if(!e&&";"!==this._flags.last_token.text&&","!==this._flags.last_token.text&&"="!==this._flags.last_token.text&&(this._flags.last_token.type!==c.OPERATOR||"--"===this._flags.last_token.text||"++"===this._flags.last_token.text))for(var n=this._tokens.peek();!(this._flags.mode!==m||this._flags.if_block&&p(n,"else")||this._flags.do_block);)this.restore_mode();this._output.add_new_line(t)&&(this._flags.multiline_frame=!0)},S.prototype.print_token_line_indentation=function(t){this._output.just_added_newline()&&(this._options.keep_array_indentation&&t.newlines&&("["===t.text||$(this._flags.mode))?(this._output.current_line.set_indent(-1),this._output.current_line.push(t.whitespace_before),this._output.space_before_token=!1):this._output.set_indent(this._flags.indentation_level,this._flags.alignment)&&(this._flags.line_indent_level=this._flags.indentation_level))},S.prototype.print_token=function(t){if(this._output.raw)this._output.add_raw_token(t);else{if(this._options.comma_first&&t.previous&&t.previous.type===c.COMMA&&this._output.just_added_newline()&&","===this._output.previous_line.last()){var e=this._output.previous_line.pop();this._output.previous_line.is_empty()&&(this._output.previous_line.push(e),this._output.trim(!0),this._output.current_line.pop(),this._output.trim()),this.print_token_line_indentation(t),this._output.add_token(","),this._output.space_before_token=!0}this.print_token_line_indentation(t),this._output.non_breaking_space=!0,this._output.add_token(t.text),this._output.previous_token_wrapped&&(this._flags.multiline_frame=!0)}},S.prototype.indent=function(){this._flags.indentation_level+=1,this._output.set_indent(this._flags.indentation_level,this._flags.alignment)},S.prototype.deindent=function(){this._flags.indentation_level>0&&(!this._flags.parent||this._flags.indentation_level>this._flags.parent.indentation_level)&&(this._flags.indentation_level-=1,this._output.set_indent(this._flags.indentation_level,this._flags.alignment))},S.prototype.set_mode=function(t){this._flags?(this._flag_store.push(this._flags),this._previous_flags=this._flags):this._previous_flags=this.create_flags(null,t),this._flags=this.create_flags(this._previous_flags,t),this._output.set_indent(this._flags.indentation_level,this._flags.alignment)},S.prototype.restore_mode=function(){this._flag_store.length>0&&(this._previous_flags=this._flags,this._flags=this._flag_store.pop(),this._previous_flags.mode===m&&O(this._output,this._previous_flags),this._output.set_indent(this._flags.indentation_level,this._flags.alignment))},S.prototype.start_of_object_property=function(){return this._flags.parent.mode===b&&this._flags.mode===m&&(":"===this._flags.last_token.text&&0===this._flags.ternary_depth||f(this._flags.last_token,["get","set"]))},S.prototype.start_of_statement=function(t){var e=!1;return!!(e=(e=(e=(e=(e=(e=(e=e||f(this._flags.last_token,["var","let","const"])&&t.type===c.WORD)||p(this._flags.last_token,"do"))||!(this._flags.parent.mode===b&&this._flags.mode===m)&&f(this._flags.last_token,E)&&!t.newlines)||p(this._flags.last_token,"else")&&!(p(t,"if")&&!t.comments_before))||this._flags.last_token.type===c.END_EXPR&&(this._previous_flags.mode===w||this._previous_flags.mode===x))||this._flags.last_token.type===c.WORD&&this._flags.mode===g&&!this._flags.in_case&&!("--"===t.text||"++"===t.text)&&"function"!==this._last_last_text&&t.type!==c.WORD&&t.type!==c.RESERVED)||this._flags.mode===b&&(":"===this._flags.last_token.text&&0===this._flags.ternary_depth||f(this._flags.last_token,["get","set"])))&&(this.set_mode(m),this.indent(),this.handle_whitespace_and_comments(t,!0),this.start_of_object_property()||this.allow_wrap_or_preserved_newline(t,f(t,["do","for","if","while"])),!0)},S.prototype.handle_start_expr=function(t){this.start_of_statement(t)||this.handle_whitespace_and_comments(t);var e=k;if("["===t.text){if(this._flags.last_token.type===c.WORD||")"===this._flags.last_token.text)return f(this._flags.last_token,u)&&(this._output.space_before_token=!0),this.print_token(t),this.set_mode(e),this.indent(),void(this._options.space_in_paren&&(this._output.space_before_token=!0));e=y,$(this._flags.mode)&&("["!==this._flags.last_token.text&&(","!==this._flags.last_token.text||"]"!==this._last_last_text&&"}"!==this._last_last_text)||this._options.keep_array_indentation||this.print_newline()),h(this._flags.last_token.type,[c.START_EXPR,c.END_EXPR,c.WORD,c.OPERATOR])||(this._output.space_before_token=!0)}else{if(this._flags.last_token.type===c.RESERVED)"for"===this._flags.last_token.text?(this._output.space_before_token=this._options.space_before_conditional,e=w):h(this._flags.last_token.text,["if","while"])?(this._output.space_before_token=this._options.space_before_conditional,e=x):h(this._flags.last_word,["await","async"])?this._output.space_before_token=!0:"import"===this._flags.last_token.text&&""===t.whitespace_before?this._output.space_before_token=!1:(h(this._flags.last_token.text,u)||"catch"===this._flags.last_token.text)&&(this._output.space_before_token=!0);else if(this._flags.last_token.type===c.EQUALS||this._flags.last_token.type===c.OPERATOR)this.start_of_object_property()||this.allow_wrap_or_preserved_newline(t);else if(this._flags.last_token.type===c.WORD){this._output.space_before_token=!1;var n=this._tokens.peek(-3);if(this._options.space_after_named_function&&n){var r=this._tokens.peek(-4);f(n,["async","function"])||"*"===n.text&&f(r,["async","function"])?this._output.space_before_token=!0:this._flags.mode===b&&("{"!==n.text&&","!==n.text&&("*"!==n.text||"{"!==r.text&&","!==r.text)||(this._output.space_before_token=!0))}}else this.allow_wrap_or_preserved_newline(t);(this._flags.last_token.type===c.RESERVED&&("function"===this._flags.last_word||"typeof"===this._flags.last_word)||"*"===this._flags.last_token.text&&(h(this._last_last_text,["function","yield"])||this._flags.mode===b&&h(this._last_last_text,["{",","])))&&(this._output.space_before_token=this._options.space_after_anon_function)}";"===this._flags.last_token.text||this._flags.last_token.type===c.START_BLOCK?this.print_newline():this._flags.last_token.type!==c.END_EXPR&&this._flags.last_token.type!==c.START_EXPR&&this._flags.last_token.type!==c.END_BLOCK&&"."!==this._flags.last_token.text&&this._flags.last_token.type!==c.COMMA||this.allow_wrap_or_preserved_newline(t,t.newlines),this.print_token(t),this.set_mode(e),this._options.space_in_paren&&(this._output.space_before_token=!0),this.indent()},S.prototype.handle_end_expr=function(t){for(;this._flags.mode===m;)this.restore_mode();this.handle_whitespace_and_comments(t),this._flags.multiline_frame&&this.allow_wrap_or_preserved_newline(t,"]"===t.text&&$(this._flags.mode)&&!this._options.keep_array_indentation),this._options.space_in_paren&&(this._flags.last_token.type!==c.START_EXPR||this._options.space_in_empty_paren?this._output.space_before_token=!0:(this._output.trim(),this._output.space_before_token=!1)),this.deindent(),this.print_token(t),this.restore_mode(),O(this._output,this._previous_flags),this._flags.do_while&&this._previous_flags.mode===x&&(this._previous_flags.mode=k,this._flags.do_block=!1,this._flags.do_while=!1)},S.prototype.handle_start_block=function(t){this.handle_whitespace_and_comments(t);var e=this._tokens.peek(),n=this._tokens.peek(1);"switch"===this._flags.last_word&&this._flags.last_token.type===c.END_EXPR?(this.set_mode(g),this._flags.in_case_statement=!0):this._flags.case_body?this.set_mode(g):n&&(h(n.text,[":",","])&&h(e.type,[c.STRING,c.WORD,c.RESERVED])||h(e.text,["get","set","..."])&&h(n.type,[c.WORD,c.RESERVED]))?h(this._last_last_text,["class","interface"])?this.set_mode(g):this.set_mode(b):this._flags.last_token.type===c.OPERATOR&&"=>"===this._flags.last_token.text?this.set_mode(g):h(this._flags.last_token.type,[c.EQUALS,c.START_EXPR,c.COMMA,c.OPERATOR])||f(this._flags.last_token,["return","throw","import","default"])?this.set_mode(b):this.set_mode(g);var r=!e.comments_before&&"}"===e.text,i=r&&"function"===this._flags.last_word&&this._flags.last_token.type===c.END_EXPR;if(this._options.brace_preserve_inline){var o=0,a=null;this._flags.inline_frame=!0;do{if(o+=1,(a=this._tokens.peek(o-1)).newlines){this._flags.inline_frame=!1;break}}while(a.type!==c.EOF&&(a.type!==c.END_BLOCK||a.opened!==t))}("expand"===this._options.brace_style||"none"===this._options.brace_style&&t.newlines)&&!this._flags.inline_frame?this._flags.last_token.type!==c.OPERATOR&&(i||this._flags.last_token.type===c.EQUALS||f(this._flags.last_token,_)&&"else"!==this._flags.last_token.text)?this._output.space_before_token=!0:this.print_newline(!1,!0):(!$(this._previous_flags.mode)||this._flags.last_token.type!==c.START_EXPR&&this._flags.last_token.type!==c.COMMA||((this._flags.last_token.type===c.COMMA||this._options.space_in_paren)&&(this._output.space_before_token=!0),(this._flags.last_token.type===c.COMMA||this._flags.last_token.type===c.START_EXPR&&this._flags.inline_frame)&&(this.allow_wrap_or_preserved_newline(t),this._previous_flags.multiline_frame=this._previous_flags.multiline_frame||this._flags.multiline_frame,this._flags.multiline_frame=!1)),this._flags.last_token.type!==c.OPERATOR&&this._flags.last_token.type!==c.START_EXPR&&(this._flags.last_token.type!==c.START_BLOCK||this._flags.inline_frame?this._output.space_before_token=!0:this.print_newline())),this.print_token(t),this.indent(),r||this._options.brace_preserve_inline&&this._flags.inline_frame||this.print_newline()},S.prototype.handle_end_block=function(t){for(this.handle_whitespace_and_comments(t);this._flags.mode===m;)this.restore_mode();var e=this._flags.last_token.type===c.START_BLOCK;this._flags.inline_frame&&!e?this._output.space_before_token=!0:"expand"===this._options.brace_style?e||this.print_newline():e||($(this._flags.mode)&&this._options.keep_array_indentation?(this._options.keep_array_indentation=!1,this.print_newline(),this._options.keep_array_indentation=!0):this.print_newline()),this.restore_mode(),this.print_token(t)},S.prototype.handle_word=function(t){if(t.type===c.RESERVED&&(h(t.text,["set","get"])&&this._flags.mode!==b||"import"===t.text&&"("===this._tokens.peek().text||h(t.text,["as","from"])&&!this._flags.import_block||this._flags.mode===b&&":"===this._tokens.peek().text)&&(t.type=c.WORD),this.start_of_statement(t)?f(this._flags.last_token,["var","let","const"])&&t.type===c.WORD&&(this._flags.declaration_statement=!0):!t.newlines||j(this._flags.mode)||this._flags.last_token.type===c.OPERATOR&&"--"!==this._flags.last_token.text&&"++"!==this._flags.last_token.text||this._flags.last_token.type===c.EQUALS||!this._options.preserve_newlines&&f(this._flags.last_token,["var","let","const","set","get"])?this.handle_whitespace_and_comments(t):(this.handle_whitespace_and_comments(t),this.print_newline()),this._flags.do_block&&!this._flags.do_while){if(p(t,"while"))return this._output.space_before_token=!0,this.print_token(t),this._output.space_before_token=!0,void(this._flags.do_while=!0);this.print_newline(),this._flags.do_block=!1}if(this._flags.if_block)if(!this._flags.else_block&&p(t,"else"))this._flags.else_block=!0;else{for(;this._flags.mode===m;)this.restore_mode();this._flags.if_block=!1,this._flags.else_block=!1}if(this._flags.in_case_statement&&f(t,["case","default"]))return this.print_newline(),this._flags.last_token.type!==c.END_BLOCK&&(this._flags.case_body||this._options.jslint_happy)&&this.deindent(),this._flags.case_body=!1,this.print_token(t),void(this._flags.in_case=!0);if(this._flags.last_token.type!==c.COMMA&&this._flags.last_token.type!==c.START_EXPR&&this._flags.last_token.type!==c.EQUALS&&this._flags.last_token.type!==c.OPERATOR||this.start_of_object_property()||this.allow_wrap_or_preserved_newline(t),p(t,"function"))return(h(this._flags.last_token.text,["}",";"])||this._output.just_added_newline()&&!h(this._flags.last_token.text,["(","[","{",":","=",","])&&this._flags.last_token.type!==c.OPERATOR)&&(this._output.just_added_blankline()||t.comments_before||(this.print_newline(),this.print_newline(!0))),this._flags.last_token.type===c.RESERVED||this._flags.last_token.type===c.WORD?f(this._flags.last_token,["get","set","new","export"])||f(this._flags.last_token,E)||p(this._flags.last_token,"default")&&"export"===this._last_last_text||"declare"===this._flags.last_token.text?this._output.space_before_token=!0:this.print_newline():this._flags.last_token.type===c.OPERATOR||"="===this._flags.last_token.text?this._output.space_before_token=!0:(this._flags.multiline_frame||!j(this._flags.mode)&&!$(this._flags.mode))&&this.print_newline(),this.print_token(t),void(this._flags.last_word=t.text);var e="NONE";this._flags.last_token.type===c.END_BLOCK?this._previous_flags.inline_frame?e="SPACE":f(t,["else","catch","finally","from"])?"expand"===this._options.brace_style||"end-expand"===this._options.brace_style||"none"===this._options.brace_style&&t.newlines?e="NEWLINE":(e="SPACE",this._output.space_before_token=!0):e="NEWLINE":this._flags.last_token.type===c.SEMICOLON&&this._flags.mode===g?e="NEWLINE":this._flags.last_token.type===c.SEMICOLON&&j(this._flags.mode)?e="SPACE":this._flags.last_token.type===c.STRING?e="NEWLINE":this._flags.last_token.type===c.RESERVED||this._flags.last_token.type===c.WORD||"*"===this._flags.last_token.text&&(h(this._last_last_text,["function","yield"])||this._flags.mode===b&&h(this._last_last_text,["{",","]))?e="SPACE":this._flags.last_token.type===c.START_BLOCK?e=this._flags.inline_frame?"SPACE":"NEWLINE":this._flags.last_token.type===c.END_EXPR&&(this._output.space_before_token=!0,e="NEWLINE"),f(t,u)&&")"!==this._flags.last_token.text&&(e=this._flags.inline_frame||"else"===this._flags.last_token.text||"export"===this._flags.last_token.text?"SPACE":"NEWLINE"),f(t,["else","catch","finally"])?(this._flags.last_token.type!==c.END_BLOCK||this._previous_flags.mode!==g||"expand"===this._options.brace_style||"end-expand"===this._options.brace_style||"none"===this._options.brace_style&&t.newlines)&&!this._flags.inline_frame?this.print_newline():(this._output.trim(!0),"}"!==this._output.current_line.last()&&this.print_newline(),this._output.space_before_token=!0):"NEWLINE"===e?f(this._flags.last_token,_)||"declare"===this._flags.last_token.text&&f(t,["var","let","const"])?this._output.space_before_token=!0:this._flags.last_token.type!==c.END_EXPR?this._flags.last_token.type===c.START_EXPR&&f(t,["var","let","const"])||":"===this._flags.last_token.text||(p(t,"if")&&p(t.previous,"else")?this._output.space_before_token=!0:this.print_newline()):f(t,u)&&")"!==this._flags.last_token.text&&this.print_newline():this._flags.multiline_frame&&$(this._flags.mode)&&","===this._flags.last_token.text&&"}"===this._last_last_text?this.print_newline():"SPACE"===e&&(this._output.space_before_token=!0),!t.previous||t.previous.type!==c.WORD&&t.previous.type!==c.RESERVED||(this._output.space_before_token=!0),this.print_token(t),this._flags.last_word=t.text,t.type===c.RESERVED&&("do"===t.text?this._flags.do_block=!0:"if"===t.text?this._flags.if_block=!0:"import"===t.text?this._flags.import_block=!0:this._flags.import_block&&p(t,"from")&&(this._flags.import_block=!1))},S.prototype.handle_semicolon=function(t){this.start_of_statement(t)?this._output.space_before_token=!1:this.handle_whitespace_and_comments(t);for(var e=this._tokens.peek();!(this._flags.mode!==m||this._flags.if_block&&p(e,"else")||this._flags.do_block);)this.restore_mode();this._flags.import_block&&(this._flags.import_block=!1),this.print_token(t)},S.prototype.handle_string=function(t){this.start_of_statement(t)?this._output.space_before_token=!0:(this.handle_whitespace_and_comments(t),this._flags.last_token.type===c.RESERVED||this._flags.last_token.type===c.WORD||this._flags.inline_frame?this._output.space_before_token=!0:this._flags.last_token.type===c.COMMA||this._flags.last_token.type===c.START_EXPR||this._flags.last_token.type===c.EQUALS||this._flags.last_token.type===c.OPERATOR?this.start_of_object_property()||this.allow_wrap_or_preserved_newline(t):this.print_newline()),this.print_token(t)},S.prototype.handle_equals=function(t){this.start_of_statement(t)||this.handle_whitespace_and_comments(t),this._flags.declaration_statement&&(this._flags.declaration_assignment=!0),this._output.space_before_token=!0,this.print_token(t),this._output.space_before_token=!0},S.prototype.handle_comma=function(t){this.handle_whitespace_and_comments(t,!0),this.print_token(t),this._output.space_before_token=!0,this._flags.declaration_statement?(j(this._flags.parent.mode)&&(this._flags.declaration_assignment=!1),this._flags.declaration_assignment?(this._flags.declaration_assignment=!1,this.print_newline(!1,!0)):this._options.comma_first&&this.allow_wrap_or_preserved_newline(t)):this._flags.mode===b||this._flags.mode===m&&this._flags.parent.mode===b?(this._flags.mode===m&&this.restore_mode(),this._flags.inline_frame||this.print_newline()):this._options.comma_first&&this.allow_wrap_or_preserved_newline(t)},S.prototype.handle_operator=function(t){var e="*"===t.text&&(f(this._flags.last_token,["function","yield"])||h(this._flags.last_token.type,[c.START_BLOCK,c.COMMA,c.END_BLOCK,c.SEMICOLON])),n=h(t.text,["-","+"])&&(h(this._flags.last_token.type,[c.START_BLOCK,c.START_EXPR,c.EQUALS,c.OPERATOR])||h(this._flags.last_token.text,u)||","===this._flags.last_token.text);if(this.start_of_statement(t));else{var r=!e;this.handle_whitespace_and_comments(t,r)}if(f(this._flags.last_token,_))return this._output.space_before_token=!0,void this.print_token(t);if("*"!==t.text||this._flags.last_token.type!==c.DOT)if("::"!==t.text){if(this._flags.last_token.type===c.OPERATOR&&h(this._options.operator_position,v)&&this.allow_wrap_or_preserved_newline(t),":"===t.text&&this._flags.in_case)return this.print_token(t),this._flags.in_case=!1,this._flags.case_body=!0,void(this._tokens.peek().type!==c.START_BLOCK?(this.indent(),this.print_newline()):this._output.space_before_token=!0);var i=!0,o=!0,a=!1;if(":"===t.text?0===this._flags.ternary_depth?i=!1:(this._flags.ternary_depth-=1,a=!0):"?"===t.text&&(this._flags.ternary_depth+=1),!n&&!e&&this._options.preserve_newlines&&h(t.text,l)){var s=":"===t.text,p=s&&a,b=s&&!a;switch(this._options.operator_position){case d.before_newline:return this._output.space_before_token=!b,this.print_token(t),s&&!p||this.allow_wrap_or_preserved_newline(t),void(this._output.space_before_token=!0);case d.after_newline:return this._output.space_before_token=!0,!s||p?this._tokens.peek().newlines?this.print_newline(!1,!0):this.allow_wrap_or_preserved_newline(t):this._output.space_before_token=!1,this.print_token(t),void(this._output.space_before_token=!0);case d.preserve_newline:return b||this.allow_wrap_or_preserved_newline(t),i=!(this._output.just_added_newline()||b),this._output.space_before_token=i,this.print_token(t),void(this._output.space_before_token=!0)}}if(e){this.allow_wrap_or_preserved_newline(t),i=!1;var y=this._tokens.peek();o=y&&h(y.type,[c.WORD,c.RESERVED])}else"..."===t.text?(this.allow_wrap_or_preserved_newline(t),i=this._flags.last_token.type===c.START_BLOCK,o=!1):(h(t.text,["--","++","!","~"])||n)&&(this._flags.last_token.type!==c.COMMA&&this._flags.last_token.type!==c.START_EXPR||this.allow_wrap_or_preserved_newline(t),i=!1,o=!1,!t.newlines||"--"!==t.text&&"++"!==t.text||this.print_newline(!1,!0),";"===this._flags.last_token.text&&j(this._flags.mode)&&(i=!0),this._flags.last_token.type===c.RESERVED?i=!0:this._flags.last_token.type===c.END_EXPR?i=!("]"===this._flags.last_token.text&&("--"===t.text||"++"===t.text)):this._flags.last_token.type===c.OPERATOR&&(i=h(t.text,["--","-","++","+"])&&h(this._flags.last_token.text,["--","-","++","+"]),h(t.text,["+","-"])&&h(this._flags.last_token.text,["--","++"])&&(o=!0)),(this._flags.mode!==g||this._flags.inline_frame)&&this._flags.mode!==m||"{"!==this._flags.last_token.text&&";"!==this._flags.last_token.text||this.print_newline());this._output.space_before_token=this._output.space_before_token||i,this.print_token(t),this._output.space_before_token=o}else this.print_token(t);else this.print_token(t)},S.prototype.handle_block_comment=function(t,e){return this._output.raw?(this._output.add_raw_token(t),void(t.directives&&"end"===t.directives.preserve&&(this._output.raw=this._options.test_output_raw))):t.directives?(this.print_newline(!1,e),this.print_token(t),"start"===t.directives.preserve&&(this._output.raw=!0),void this.print_newline(!1,!0)):o.newline.test(t.text)||t.newlines?void this.print_block_commment(t,e):(this._output.space_before_token=!0,this.print_token(t),void(this._output.space_before_token=!0))},S.prototype.print_block_commment=function(t,e){var n,r=function(t){for(var e=[],n=(t=t.replace(o.allLineBreaks,"\n")).indexOf("\n");-1!==n;)e.push(t.substring(0,n)),n=(t=t.substring(n+1)).indexOf("\n");return t.length&&e.push(t),e}(t.text),i=!1,a=!1,s=t.whitespace_before,u=s.length;if(this.print_newline(!1,e),this.print_token_line_indentation(t),this._output.add_token(r[0]),this.print_newline(!1,e),r.length>1){for(i=function(t,e){for(var n=0;n<t.length;n++)if(t[n].trim().charAt(0)!==e)return!1;return!0}(r=r.slice(1),"*"),a=function(t,e){for(var n,r=0,i=t.length;r<i;r++)if((n=t[r])&&0!==n.indexOf(e))return!1;return!0}(r,s),i&&(this._flags.alignment=1),n=0;n<r.length;n++)i?(this.print_token_line_indentation(t),this._output.add_token(r[n].replace(/^\s+/g,""))):a&&r[n]?(this.print_token_line_indentation(t),this._output.add_token(r[n].substring(u))):(this._output.current_line.set_indent(-1),this._output.add_token(r[n])),this.print_newline(!1,e);this._flags.alignment=0}},S.prototype.handle_comment=function(t,e){t.newlines?this.print_newline(!1,e):this._output.trim(!0),this._output.space_before_token=!0,this.print_token(t),this.print_newline(!1,e)},S.prototype.handle_dot=function(t){this.start_of_statement(t)||this.handle_whitespace_and_comments(t,!0),f(this._flags.last_token,_)?this._output.space_before_token=!1:this.allow_wrap_or_preserved_newline(t,")"===this._flags.last_token.text&&this._options.break_chained_methods),this._options.unindent_chained_methods&&this._output.just_added_newline()&&this.deindent(),this.print_token(t)},S.prototype.handle_unknown=function(t,e){this.print_token(t),"\n"===t.text[t.text.length-1]&&this.print_newline(!1,e)},S.prototype.handle_eof=function(t){for(;this._flags.mode===m;)this.restore_mode();this.handle_whitespace_and_comments(t)},t.exports.Beautifier=S},function(t,e,n){"use strict";function r(t){this.__parent=t,this.__character_count=0,this.__indent_count=-1,this.__alignment_count=0,this.__wrap_point_index=0,this.__wrap_point_character_count=0,this.__wrap_point_indent_count=-1,this.__wrap_point_alignment_count=0,this.__items=[]}function i(t,e){this.__cache=[""],this.__indent_size=t.indent_size,this.__indent_string=t.indent_char,t.indent_with_tabs||(this.__indent_string=new Array(t.indent_size+1).join(t.indent_char)),e=e||"",t.indent_level>0&&(e=new Array(t.indent_level+1).join(this.__indent_string)),this.__base_string=e,this.__base_string_length=e.length}function o(t,e){this.__indent_cache=new i(t,e),this.raw=!1,this._end_with_newline=t.end_with_newline,this.indent_size=t.indent_size,this.wrap_line_length=t.wrap_line_length,this.indent_empty_lines=t.indent_empty_lines,this.__lines=[],this.previous_line=null,this.current_line=null,this.next_line=new r(this),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1,this.__add_outputline()}r.prototype.clone_empty=function(){var t=new r(this.__parent);return t.set_indent(this.__indent_count,this.__alignment_count),t},r.prototype.item=function(t){return t<0?this.__items[this.__items.length+t]:this.__items[t]},r.prototype.has_match=function(t){for(var e=this.__items.length-1;e>=0;e--)if(this.__items[e].match(t))return!0;return!1},r.prototype.set_indent=function(t,e){this.is_empty()&&(this.__indent_count=t||0,this.__alignment_count=e||0,this.__character_count=this.__parent.get_indent_size(this.__indent_count,this.__alignment_count))},r.prototype._set_wrap_point=function(){this.__parent.wrap_line_length&&(this.__wrap_point_index=this.__items.length,this.__wrap_point_character_count=this.__character_count,this.__wrap_point_indent_count=this.__parent.next_line.__indent_count,this.__wrap_point_alignment_count=this.__parent.next_line.__alignment_count)},r.prototype._should_wrap=function(){return this.__wrap_point_index&&this.__character_count>this.__parent.wrap_line_length&&this.__wrap_point_character_count>this.__parent.next_line.__character_count},r.prototype._allow_wrap=function(){if(this._should_wrap()){this.__parent.add_new_line();var t=this.__parent.current_line;return t.set_indent(this.__wrap_point_indent_count,this.__wrap_point_alignment_count),t.__items=this.__items.slice(this.__wrap_point_index),this.__items=this.__items.slice(0,this.__wrap_point_index),t.__character_count+=this.__character_count-this.__wrap_point_character_count,this.__character_count=this.__wrap_point_character_count," "===t.__items[0]&&(t.__items.splice(0,1),t.__character_count-=1),!0}return!1},r.prototype.is_empty=function(){return 0===this.__items.length},r.prototype.last=function(){return this.is_empty()?null:this.__items[this.__items.length-1]},r.prototype.push=function(t){this.__items.push(t);var e=t.lastIndexOf("\n");-1!==e?this.__character_count=t.length-e:this.__character_count+=t.length},r.prototype.pop=function(){var t=null;return this.is_empty()||(t=this.__items.pop(),this.__character_count-=t.length),t},r.prototype._remove_indent=function(){this.__indent_count>0&&(this.__indent_count-=1,this.__character_count-=this.__parent.indent_size)},r.prototype._remove_wrap_indent=function(){this.__wrap_point_indent_count>0&&(this.__wrap_point_indent_count-=1)},r.prototype.trim=function(){for(;" "===this.last();)this.__items.pop(),this.__character_count-=1},r.prototype.toString=function(){var t="";return this.is_empty()?this.__parent.indent_empty_lines&&(t=this.__parent.get_indent_string(this.__indent_count)):(t=this.__parent.get_indent_string(this.__indent_count,this.__alignment_count),t+=this.__items.join("")),t},i.prototype.get_indent_size=function(t,e){var n=this.__base_string_length;return e=e||0,t<0&&(n=0),n+=t*this.__indent_size,n+=e},i.prototype.get_indent_string=function(t,e){var n=this.__base_string;return e=e||0,t<0&&(t=0,n=""),e+=t*this.__indent_size,this.__ensure_cache(e),n+=this.__cache[e]},i.prototype.__ensure_cache=function(t){for(;t>=this.__cache.length;)this.__add_column()},i.prototype.__add_column=function(){var t=this.__cache.length,e=0,n="";this.__indent_size&&t>=this.__indent_size&&(t-=(e=Math.floor(t/this.__indent_size))*this.__indent_size,n=new Array(e+1).join(this.__indent_string)),t&&(n+=new Array(t+1).join(" ")),this.__cache.push(n)},o.prototype.__add_outputline=function(){this.previous_line=this.current_line,this.current_line=this.next_line.clone_empty(),this.__lines.push(this.current_line)},o.prototype.get_line_number=function(){return this.__lines.length},o.prototype.get_indent_string=function(t,e){return this.__indent_cache.get_indent_string(t,e)},o.prototype.get_indent_size=function(t,e){return this.__indent_cache.get_indent_size(t,e)},o.prototype.is_empty=function(){return!this.previous_line&&this.current_line.is_empty()},o.prototype.add_new_line=function(t){return!(this.is_empty()||!t&&this.just_added_newline()||(this.raw||this.__add_outputline(),0))},o.prototype.get_code=function(t){this.trim(!0);var e=this.current_line.pop();e&&("\n"===e[e.length-1]&&(e=e.replace(/\n+$/g,"")),this.current_line.push(e)),this._end_with_newline&&this.__add_outputline();var n=this.__lines.join("\n");return"\n"!==t&&(n=n.replace(/[\n]/g,t)),n},o.prototype.set_wrap_point=function(){this.current_line._set_wrap_point()},o.prototype.set_indent=function(t,e){return t=t||0,e=e||0,this.next_line.set_indent(t,e),this.__lines.length>1?(this.current_line.set_indent(t,e),!0):(this.current_line.set_indent(),!1)},o.prototype.add_raw_token=function(t){for(var e=0;e<t.newlines;e++)this.__add_outputline();this.current_line.set_indent(-1),this.current_line.push(t.whitespace_before),this.current_line.push(t.text),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1},o.prototype.add_token=function(t){this.__add_space_before_token(),this.current_line.push(t),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=this.current_line._allow_wrap()},o.prototype.__add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&(this.non_breaking_space||this.set_wrap_point(),this.current_line.push(" "))},o.prototype.remove_indent=function(t){for(var e=this.__lines.length;t<e;)this.__lines[t]._remove_indent(),t++;this.current_line._remove_wrap_indent()},o.prototype.trim=function(t){for(t=void 0!==t&&t,this.current_line.trim();t&&this.__lines.length>1&&this.current_line.is_empty();)this.__lines.pop(),this.current_line=this.__lines[this.__lines.length-1],this.current_line.trim();this.previous_line=this.__lines.length>1?this.__lines[this.__lines.length-2]:null},o.prototype.just_added_newline=function(){return this.current_line.is_empty()},o.prototype.just_added_blankline=function(){return this.is_empty()||this.current_line.is_empty()&&this.previous_line.is_empty()},o.prototype.ensure_empty_line_above=function(t,e){for(var n=this.__lines.length-2;n>=0;){var i=this.__lines[n];if(i.is_empty())break;if(0!==i.item(0).indexOf(t)&&i.item(-1)!==e){this.__lines.splice(n+1,0,new r(this)),this.previous_line=this.__lines[this.__lines.length-2];break}n--}},t.exports.Output=o},function(t,e,n){"use strict";t.exports.Token=function(t,e,n,r){this.type=t,this.text=e,this.comments_before=null,this.newlines=n||0,this.whitespace_before=r||"",this.parent=null,this.next=null,this.previous=null,this.opened=null,this.closed=null,this.directives=null}},function(t,e,n){"use strict";var r="\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc",i="\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f",o="(?:\\\\u[0-9a-fA-F]{4}|[\\x23\\x24\\x40\\x41-\\x5a\\x5f\\x61-\\x7a"+r+"])";e.identifier=new RegExp(o+"(?:\\\\u[0-9a-fA-F]{4}|[\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f])*","g"),e.identifierStart=new RegExp(o),e.identifierMatch=new RegExp("(?:\\\\u[0-9a-fA-F]{4}|[\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a"+r+i+"])+"),e.newline=/[\n\r\u2028\u2029]/,e.lineBreak=new RegExp("\r\n|"+e.newline.source),e.allLineBreaks=new RegExp(e.lineBreak.source,"g")},function(t,e,n){"use strict";var r=n(6).Options,i=["before-newline","after-newline","preserve-newline"];function o(t){r.call(this,t,"js");var e=this.raw_options.brace_style||null;"expand-strict"===e?this.raw_options.brace_style="expand":"collapse-preserve-inline"===e?this.raw_options.brace_style="collapse,preserve-inline":void 0!==this.raw_options.braces_on_own_line&&(this.raw_options.brace_style=this.raw_options.braces_on_own_line?"expand":"collapse");var n=this._get_selection_list("brace_style",["collapse","expand","end-expand","none","preserve-inline"]);this.brace_preserve_inline=!1,this.brace_style="collapse";for(var o=0;o<n.length;o++)"preserve-inline"===n[o]?this.brace_preserve_inline=!0:this.brace_style=n[o];this.unindent_chained_methods=this._get_boolean("unindent_chained_methods"),this.break_chained_methods=this._get_boolean("break_chained_methods"),this.space_in_paren=this._get_boolean("space_in_paren"),this.space_in_empty_paren=this._get_boolean("space_in_empty_paren"),this.jslint_happy=this._get_boolean("jslint_happy"),this.space_after_anon_function=this._get_boolean("space_after_anon_function"),this.space_after_named_function=this._get_boolean("space_after_named_function"),this.keep_array_indentation=this._get_boolean("keep_array_indentation"),this.space_before_conditional=this._get_boolean("space_before_conditional",!0),this.unescape_strings=this._get_boolean("unescape_strings"),this.e4x=this._get_boolean("e4x"),this.comma_first=this._get_boolean("comma_first"),this.operator_position=this._get_selection("operator_position",i),this.test_output_raw=this._get_boolean("test_output_raw"),this.jslint_happy&&(this.space_after_anon_function=!0)}o.prototype=new r,t.exports.Options=o},function(t,e,n){"use strict";function r(t,e){this.raw_options=i(t,e),this.disabled=this._get_boolean("disabled"),this.eol=this._get_characters("eol","auto"),this.end_with_newline=this._get_boolean("end_with_newline"),this.indent_size=this._get_number("indent_size",4),this.indent_char=this._get_characters("indent_char"," "),this.indent_level=this._get_number("indent_level"),this.preserve_newlines=this._get_boolean("preserve_newlines",!0),this.max_preserve_newlines=this._get_number("max_preserve_newlines",32786),this.preserve_newlines||(this.max_preserve_newlines=0),this.indent_with_tabs=this._get_boolean("indent_with_tabs","\t"===this.indent_char),this.indent_with_tabs&&(this.indent_char="\t",1===this.indent_size&&(this.indent_size=4)),this.wrap_line_length=this._get_number("wrap_line_length",this._get_number("max_char")),this.indent_empty_lines=this._get_boolean("indent_empty_lines"),this.templating=this._get_selection_list("templating",["auto","none","django","erb","handlebars","php"],["auto"])}function i(t,e){var n,r={};for(n in t=o(t))n!==e&&(r[n]=t[n]);if(e&&t[e])for(n in t[e])r[n]=t[e][n];return r}function o(t){var e,n={};for(e in t)n[e.replace(/-/g,"_")]=t[e];return n}r.prototype._get_array=function(t,e){var n=this.raw_options[t],r=e||[];return"object"==typeof n?null!==n&&"function"==typeof n.concat&&(r=n.concat()):"string"==typeof n&&(r=n.split(/[^a-zA-Z0-9_\/\-]+/)),r},r.prototype._get_boolean=function(t,e){var n=this.raw_options[t];return void 0===n?!!e:!!n},r.prototype._get_characters=function(t,e){var n=this.raw_options[t],r=e||"";return"string"==typeof n&&(r=n.replace(/\\r/,"\r").replace(/\\n/,"\n").replace(/\\t/,"\t")),r},r.prototype._get_number=function(t,e){var n=this.raw_options[t];e=parseInt(e,10),isNaN(e)&&(e=0);var r=parseInt(n,10);return isNaN(r)&&(r=e),r},r.prototype._get_selection=function(t,e,n){var r=this._get_selection_list(t,e,n);if(1!==r.length)throw new Error("Invalid Option Value: The option '"+t+"' can only be one of the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r[0]},r.prototype._get_selection_list=function(t,e,n){if(!e||0===e.length)throw new Error("Selection list cannot be empty.");if(n=n||[e[0]],!this._is_valid_selection(n,e))throw new Error("Invalid Default Value!");var r=this._get_array(t,n);if(!this._is_valid_selection(r,e))throw new Error("Invalid Option Value: The option '"+t+"' can contain only the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r},r.prototype._is_valid_selection=function(t,e){return t.length&&e.length&&!t.some((function(t){return-1===e.indexOf(t)}))},t.exports.Options=r,t.exports.normalizeOpts=o,t.exports.mergeOpts=i},function(t,e,n){"use strict";var r=n(8).InputScanner,i=n(9).Tokenizer,o=n(9).TOKEN,a=n(13).Directives,s=n(4),u=n(12).Pattern,l=n(14).TemplatablePattern;function c(t,e){return-1!==e.indexOf(t)}var h={START_EXPR:"TK_START_EXPR",END_EXPR:"TK_END_EXPR",START_BLOCK:"TK_START_BLOCK",END_BLOCK:"TK_END_BLOCK",WORD:"TK_WORD",RESERVED:"TK_RESERVED",SEMICOLON:"TK_SEMICOLON",STRING:"TK_STRING",EQUALS:"TK_EQUALS",OPERATOR:"TK_OPERATOR",COMMA:"TK_COMMA",BLOCK_COMMENT:"TK_BLOCK_COMMENT",COMMENT:"TK_COMMENT",DOT:"TK_DOT",UNKNOWN:"TK_UNKNOWN",START:o.START,RAW:o.RAW,EOF:o.EOF},p=new a(/\/\*/,/\*\//),f=/0[xX][0123456789abcdefABCDEF]*|0[oO][01234567]*|0[bB][01]*|\d+n|(?:\.\d+|\d+\.?\d*)(?:[eE][+-]?\d+)?/,_=/[0-9]/,d=/[^\d\.]/,v=">>> === !== << && >= ** != == <= >> || |> < / - + > : & % ? ^ | *".split(" "),g=">>>= ... >>= <<= === >>> !== **= => ^= :: /= << <= == && -= >= >> != -- += ** || ++ %= &= *= |= |> = ! ? > < : / ^ - + * & % ~ |";g=(g="\\?\\.(?!\\d) "+(g=g.replace(/[-[\]{}()*+?.,\\^$|#]/g,"\\$&"))).replace(/ /g,"|");var m,b=new RegExp(g),y="continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(","),w=y.concat(["do","in","of","else","get","set","new","catch","finally","typeof","yield","async","await","from","as"]),x=new RegExp("^(?:"+w.join("|")+")$"),k=function(t,e){i.call(this,t,e),this._patterns.whitespace=this._patterns.whitespace.matching(/\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff/.source,/\u2028\u2029/.source);var n=new u(this._input),r=new l(this._input).read_options(this._options);this.__patterns={template:r,identifier:r.starting_with(s.identifier).matching(s.identifierMatch),number:n.matching(f),punct:n.matching(b),comment:n.starting_with(/\/\//).until(/[\n\r\u2028\u2029]/),block_comment:n.starting_with(/\/\*/).until_after(/\*\//),html_comment_start:n.matching(/<!--/),html_comment_end:n.matching(/-->/),include:n.starting_with(/#include/).until_after(s.lineBreak),shebang:n.starting_with(/#!/).until_after(s.lineBreak),xml:n.matching(/[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[\s\S]+?}|!\[CDATA\[[\s\S]*?\]\])(\s+{[\s\S]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{[\s\S]+?}))*\s*(\/?)\s*>/),single_quote:r.until(/['\\\n\r\u2028\u2029]/),double_quote:r.until(/["\\\n\r\u2028\u2029]/),template_text:r.until(/[`\\$]/),template_expression:r.until(/[`}\\]/)}};(k.prototype=new i)._is_comment=function(t){return t.type===h.COMMENT||t.type===h.BLOCK_COMMENT||t.type===h.UNKNOWN},k.prototype._is_opening=function(t){return t.type===h.START_BLOCK||t.type===h.START_EXPR},k.prototype._is_closing=function(t,e){return(t.type===h.END_BLOCK||t.type===h.END_EXPR)&&e&&("]"===t.text&&"["===e.text||")"===t.text&&"("===e.text||"}"===t.text&&"{"===e.text)},k.prototype._reset=function(){m=!1},k.prototype._get_next_token=function(t,e){var n=null;this._readWhitespace();var r=this._input.peek();return null===r?this._create_token(h.EOF,""):n=(n=(n=(n=(n=(n=(n=(n=(n=n||this._read_non_javascript(r))||this._read_string(r))||this._read_word(t))||this._read_singles(r))||this._read_comment(r))||this._read_regexp(r,t))||this._read_xml(r,t))||this._read_punctuation())||this._create_token(h.UNKNOWN,this._input.next())},k.prototype._read_word=function(t){var e;return""!==(e=this.__patterns.identifier.read())?(e=e.replace(s.allLineBreaks,"\n"),t.type!==h.DOT&&(t.type!==h.RESERVED||"set"!==t.text&&"get"!==t.text)&&x.test(e)?"in"===e||"of"===e?this._create_token(h.OPERATOR,e):this._create_token(h.RESERVED,e):this._create_token(h.WORD,e)):""!==(e=this.__patterns.number.read())?this._create_token(h.WORD,e):void 0},k.prototype._read_singles=function(t){var e=null;return"("===t||"["===t?e=this._create_token(h.START_EXPR,t):")"===t||"]"===t?e=this._create_token(h.END_EXPR,t):"{"===t?e=this._create_token(h.START_BLOCK,t):"}"===t?e=this._create_token(h.END_BLOCK,t):";"===t?e=this._create_token(h.SEMICOLON,t):"."===t&&d.test(this._input.peek(1))?e=this._create_token(h.DOT,t):","===t&&(e=this._create_token(h.COMMA,t)),e&&this._input.next(),e},k.prototype._read_punctuation=function(){var t=this.__patterns.punct.read();if(""!==t)return"="===t?this._create_token(h.EQUALS,t):"?."===t?this._create_token(h.DOT,t):this._create_token(h.OPERATOR,t)},k.prototype._read_non_javascript=function(t){var e="";if("#"===t){if(this._is_first_token()&&(e=this.__patterns.shebang.read()))return this._create_token(h.UNKNOWN,e.trim()+"\n");if(e=this.__patterns.include.read())return this._create_token(h.UNKNOWN,e.trim()+"\n");t=this._input.next();var n="#";if(this._input.hasNext()&&this._input.testChar(_)){do{n+=t=this._input.next()}while(this._input.hasNext()&&"#"!==t&&"="!==t);return"#"===t||("["===this._input.peek()&&"]"===this._input.peek(1)?(n+="[]",this._input.next(),this._input.next()):"{"===this._input.peek()&&"}"===this._input.peek(1)&&(n+="{}",this._input.next(),this._input.next())),this._create_token(h.WORD,n)}this._input.back()}else if("<"===t&&this._is_first_token()){if(e=this.__patterns.html_comment_start.read()){for(;this._input.hasNext()&&!this._input.testChar(s.newline);)e+=this._input.next();return m=!0,this._create_token(h.COMMENT,e)}}else if(m&&"-"===t&&(e=this.__patterns.html_comment_end.read()))return m=!1,this._create_token(h.COMMENT,e);return null},k.prototype._read_comment=function(t){var e=null;if("/"===t){var n="";if("*"===this._input.peek(1)){n=this.__patterns.block_comment.read();var r=p.get_directives(n);r&&"start"===r.ignore&&(n+=p.readIgnored(this._input)),n=n.replace(s.allLineBreaks,"\n"),(e=this._create_token(h.BLOCK_COMMENT,n)).directives=r}else"/"===this._input.peek(1)&&(n=this.__patterns.comment.read(),e=this._create_token(h.COMMENT,n))}return e},k.prototype._read_string=function(t){if("`"===t||"'"===t||'"'===t){var e=this._input.next();return this.has_char_escapes=!1,e+="`"===t?this._read_string_recursive("`",!0,"${"):this._read_string_recursive(t),this.has_char_escapes&&this._options.unescape_strings&&(e=function(t){for(var e="",n=0,i=new r(t),o=null;i.hasNext();)if((o=i.match(/([\s]|[^\\]|\\\\)+/g))&&(e+=o[0]),"\\"===i.peek()){if(i.next(),"x"===i.peek())o=i.match(/x([0-9A-Fa-f]{2})/g);else{if("u"!==i.peek()){e+="\\",i.hasNext()&&(e+=i.next());continue}o=i.match(/u([0-9A-Fa-f]{4})/g)}if(!o)return t;if((n=parseInt(o[1],16))>126&&n<=255&&0===o[0].indexOf("x"))return t;if(n>=0&&n<32){e+="\\"+o[0];continue}e+=34===n||39===n||92===n?"\\"+String.fromCharCode(n):String.fromCharCode(n)}return e}(e)),this._input.peek()===t&&(e+=this._input.next()),e=e.replace(s.allLineBreaks,"\n"),this._create_token(h.STRING,e)}return null},k.prototype._allow_regexp_or_xml=function(t){return t.type===h.RESERVED&&c(t.text,["return","case","throw","else","do","typeof","yield"])||t.type===h.END_EXPR&&")"===t.text&&t.opened.previous.type===h.RESERVED&&c(t.opened.previous.text,["if","while","for"])||c(t.type,[h.COMMENT,h.START_EXPR,h.START_BLOCK,h.START,h.END_BLOCK,h.OPERATOR,h.EQUALS,h.EOF,h.SEMICOLON,h.COMMA])},k.prototype._read_regexp=function(t,e){if("/"===t&&this._allow_regexp_or_xml(e)){for(var n=this._input.next(),r=!1,i=!1;this._input.hasNext()&&(r||i||this._input.peek()!==t)&&!this._input.testChar(s.newline);)n+=this._input.peek(),r?r=!1:(r="\\"===this._input.peek(),"["===this._input.peek()?i=!0:"]"===this._input.peek()&&(i=!1)),this._input.next();return this._input.peek()===t&&(n+=this._input.next(),n+=this._input.read(s.identifier)),this._create_token(h.STRING,n)}return null},k.prototype._read_xml=function(t,e){if(this._options.e4x&&"<"===t&&this._allow_regexp_or_xml(e)){var n="",r=this.__patterns.xml.read_match();if(r){for(var i=r[2].replace(/^{\s+/,"{").replace(/\s+}$/,"}"),o=0===i.indexOf("{"),a=0;r;){var u=!!r[1],l=r[2];if(!(r[r.length-1]||"![CDATA["===l.slice(0,8))&&(l===i||o&&l.replace(/^{\s+/,"{").replace(/\s+}$/,"}"))&&(u?--a:++a),n+=r[0],a<=0)break;r=this.__patterns.xml.read_match()}return r||(n+=this._input.match(/[\s\S]*/g)[0]),n=n.replace(s.allLineBreaks,"\n"),this._create_token(h.STRING,n)}}return null},k.prototype._read_string_recursive=function(t,e,n){var r,i;"'"===t?i=this.__patterns.single_quote:'"'===t?i=this.__patterns.double_quote:"`"===t?i=this.__patterns.template_text:"}"===t&&(i=this.__patterns.template_expression);for(var o=i.read(),a="";this._input.hasNext();){if((a=this._input.next())===t||!e&&s.newline.test(a)){this._input.back();break}"\\"===a&&this._input.hasNext()?("x"===(r=this._input.peek())||"u"===r?this.has_char_escapes=!0:"\r"===r&&"\n"===this._input.peek(1)&&this._input.next(),a+=this._input.next()):n&&("${"===n&&"$"===a&&"{"===this._input.peek()&&(a+=this._input.next()),n===a&&(a+="`"===t?this._read_string_recursive("}",e,"`"):this._read_string_recursive("`",e,"${"),this._input.hasNext()&&(a+=this._input.next()))),o+=a+=i.read()}return o},t.exports.Tokenizer=k,t.exports.TOKEN=h,t.exports.positionable_operators=v.slice(),t.exports.line_starters=y.slice()},function(t,e,n){"use strict";var r=RegExp.prototype.hasOwnProperty("sticky");function i(t){this.__input=t||"",this.__input_length=this.__input.length,this.__position=0}i.prototype.restart=function(){this.__position=0},i.prototype.back=function(){this.__position>0&&(this.__position-=1)},i.prototype.hasNext=function(){return this.__position<this.__input_length},i.prototype.next=function(){var t=null;return this.hasNext()&&(t=this.__input.charAt(this.__position),this.__position+=1),t},i.prototype.peek=function(t){var e=null;return t=t||0,(t+=this.__position)>=0&&t<this.__input_length&&(e=this.__input.charAt(t)),e},i.prototype.__match=function(t,e){t.lastIndex=e;var n=t.exec(this.__input);return!n||r&&t.sticky||n.index!==e&&(n=null),n},i.prototype.test=function(t,e){return e=e||0,(e+=this.__position)>=0&&e<this.__input_length&&!!this.__match(t,e)},i.prototype.testChar=function(t,e){var n=this.peek(e);return t.lastIndex=0,null!==n&&t.test(n)},i.prototype.match=function(t){var e=this.__match(t,this.__position);return e?this.__position+=e[0].length:e=null,e},i.prototype.read=function(t,e,n){var r,i="";return t&&(r=this.match(t))&&(i+=r[0]),!e||!r&&t||(i+=this.readUntil(e,n)),i},i.prototype.readUntil=function(t,e){var n,r=this.__position;t.lastIndex=this.__position;var i=t.exec(this.__input);return i?(r=i.index,e&&(r+=i[0].length)):r=this.__input_length,n=this.__input.substring(this.__position,r),this.__position=r,n},i.prototype.readUntilAfter=function(t){return this.readUntil(t,!0)},i.prototype.get_regexp=function(t,e){var n=null,i="g";return e&&r&&(i="y"),"string"==typeof t&&""!==t?n=new RegExp(t,i):t&&(n=new RegExp(t.source,i)),n},i.prototype.get_literal_regexp=function(t){return RegExp(t.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"))},i.prototype.peekUntilAfter=function(t){var e=this.__position,n=this.readUntilAfter(t);return this.__position=e,n},i.prototype.lookBack=function(t){var e=this.__position-1;return e>=t.length&&this.__input.substring(e-t.length,e).toLowerCase()===t},t.exports.InputScanner=i},function(t,e,n){"use strict";var r=n(8).InputScanner,i=n(3).Token,o=n(10).TokenStream,a=n(11).WhitespacePattern,s={START:"TK_START",RAW:"TK_RAW",EOF:"TK_EOF"},u=function(t,e){this._input=new r(t),this._options=e||{},this.__tokens=null,this._patterns={},this._patterns.whitespace=new a(this._input)};u.prototype.tokenize=function(){var t;this._input.restart(),this.__tokens=new o,this._reset();for(var e=new i(s.START,""),n=null,r=[],a=new o;e.type!==s.EOF;){for(t=this._get_next_token(e,n);this._is_comment(t);)a.add(t),t=this._get_next_token(e,n);a.isEmpty()||(t.comments_before=a,a=new o),t.parent=n,this._is_opening(t)?(r.push(n),n=t):n&&this._is_closing(t,n)&&(t.opened=n,n.closed=t,n=r.pop(),t.parent=n),t.previous=e,e.next=t,this.__tokens.add(t),e=t}return this.__tokens},u.prototype._is_first_token=function(){return this.__tokens.isEmpty()},u.prototype._reset=function(){},u.prototype._get_next_token=function(t,e){this._readWhitespace();var n=this._input.read(/.+/g);return n?this._create_token(s.RAW,n):this._create_token(s.EOF,"")},u.prototype._is_comment=function(t){return!1},u.prototype._is_opening=function(t){return!1},u.prototype._is_closing=function(t,e){return!1},u.prototype._create_token=function(t,e){return new i(t,e,this._patterns.whitespace.newline_count,this._patterns.whitespace.whitespace_before_token)},u.prototype._readWhitespace=function(){return this._patterns.whitespace.read()},t.exports.Tokenizer=u,t.exports.TOKEN=s},function(t,e,n){"use strict";function r(t){this.__tokens=[],this.__tokens_length=this.__tokens.length,this.__position=0,this.__parent_token=t}r.prototype.restart=function(){this.__position=0},r.prototype.isEmpty=function(){return 0===this.__tokens_length},r.prototype.hasNext=function(){return this.__position<this.__tokens_length},r.prototype.next=function(){var t=null;return this.hasNext()&&(t=this.__tokens[this.__position],this.__position+=1),t},r.prototype.peek=function(t){var e=null;return t=t||0,(t+=this.__position)>=0&&t<this.__tokens_length&&(e=this.__tokens[t]),e},r.prototype.add=function(t){this.__parent_token&&(t.parent=this.__parent_token),this.__tokens.push(t),this.__tokens_length+=1},t.exports.TokenStream=r},function(t,e,n){"use strict";var r=n(12).Pattern;function i(t,e){r.call(this,t,e),e?this._line_regexp=this._input.get_regexp(e._line_regexp):this.__set_whitespace_patterns("",""),this.newline_count=0,this.whitespace_before_token=""}i.prototype=new r,i.prototype.__set_whitespace_patterns=function(t,e){t+="\\t ",e+="\\n\\r",this._match_pattern=this._input.get_regexp("["+t+e+"]+",!0),this._newline_regexp=this._input.get_regexp("\\r\\n|["+e+"]")},i.prototype.read=function(){this.newline_count=0,this.whitespace_before_token="";var t=this._input.read(this._match_pattern);if(" "===t)this.whitespace_before_token=" ";else if(t){var e=this.__split(this._newline_regexp,t);this.newline_count=e.length-1,this.whitespace_before_token=e[this.newline_count]}return t},i.prototype.matching=function(t,e){var n=this._create();return n.__set_whitespace_patterns(t,e),n._update(),n},i.prototype._create=function(){return new i(this._input,this)},i.prototype.__split=function(t,e){t.lastIndex=0;for(var n=0,r=[],i=t.exec(e);i;)r.push(e.substring(n,i.index)),n=i.index+i[0].length,i=t.exec(e);return n<e.length?r.push(e.substring(n,e.length)):r.push(""),r},t.exports.WhitespacePattern=i},function(t,e,n){"use strict";function r(t,e){this._input=t,this._starting_pattern=null,this._match_pattern=null,this._until_pattern=null,this._until_after=!1,e&&(this._starting_pattern=this._input.get_regexp(e._starting_pattern,!0),this._match_pattern=this._input.get_regexp(e._match_pattern,!0),this._until_pattern=this._input.get_regexp(e._until_pattern),this._until_after=e._until_after)}r.prototype.read=function(){var t=this._input.read(this._starting_pattern);return this._starting_pattern&&!t||(t+=this._input.read(this._match_pattern,this._until_pattern,this._until_after)),t},r.prototype.read_match=function(){return this._input.match(this._match_pattern)},r.prototype.until_after=function(t){var e=this._create();return e._until_after=!0,e._until_pattern=this._input.get_regexp(t),e._update(),e},r.prototype.until=function(t){var e=this._create();return e._until_after=!1,e._until_pattern=this._input.get_regexp(t),e._update(),e},r.prototype.starting_with=function(t){var e=this._create();return e._starting_pattern=this._input.get_regexp(t,!0),e._update(),e},r.prototype.matching=function(t){var e=this._create();return e._match_pattern=this._input.get_regexp(t,!0),e._update(),e},r.prototype._create=function(){return new r(this._input,this)},r.prototype._update=function(){},t.exports.Pattern=r},function(t,e,n){"use strict";function r(t,e){t="string"==typeof t?t:t.source,e="string"==typeof e?e:e.source,this.__directives_block_pattern=new RegExp(t+/ beautify( \w+[:]\w+)+ /.source+e,"g"),this.__directive_pattern=/ (\w+)[:](\w+)/g,this.__directives_end_ignore_pattern=new RegExp(t+/\sbeautify\signore:end\s/.source+e,"g")}r.prototype.get_directives=function(t){if(!t.match(this.__directives_block_pattern))return null;var e={};this.__directive_pattern.lastIndex=0;for(var n=this.__directive_pattern.exec(t);n;)e[n[1]]=n[2],n=this.__directive_pattern.exec(t);return e},r.prototype.readIgnored=function(t){return t.readUntilAfter(this.__directives_end_ignore_pattern)},t.exports.Directives=r},function(t,e,n){"use strict";var r=n(12).Pattern,i={django:!1,erb:!1,handlebars:!1,php:!1};function o(t,e){r.call(this,t,e),this.__template_pattern=null,this._disabled=Object.assign({},i),this._excluded=Object.assign({},i),e&&(this.__template_pattern=this._input.get_regexp(e.__template_pattern),this._excluded=Object.assign(this._excluded,e._excluded),this._disabled=Object.assign(this._disabled,e._disabled));var n=new r(t);this.__patterns={handlebars_comment:n.starting_with(/{{!--/).until_after(/--}}/),handlebars_unescaped:n.starting_with(/{{{/).until_after(/}}}/),handlebars:n.starting_with(/{{/).until_after(/}}/),php:n.starting_with(/<\?(?:[=]|php)/).until_after(/\?>/),erb:n.starting_with(/<%[^%]/).until_after(/[^%]%>/),django:n.starting_with(/{%/).until_after(/%}/),django_value:n.starting_with(/{{/).until_after(/}}/),django_comment:n.starting_with(/{#/).until_after(/#}/)}}o.prototype=new r,o.prototype._create=function(){return new o(this._input,this)},o.prototype._update=function(){this.__set_templated_pattern()},o.prototype.disable=function(t){var e=this._create();return e._disabled[t]=!0,e._update(),e},o.prototype.read_options=function(t){var e=this._create();for(var n in i)e._disabled[n]=-1===t.templating.indexOf(n);return e._update(),e},o.prototype.exclude=function(t){var e=this._create();return e._excluded[t]=!0,e._update(),e},o.prototype.read=function(){var t="";t=this._match_pattern?this._input.read(this._starting_pattern):this._input.read(this._starting_pattern,this.__template_pattern);for(var e=this._read_template();e;)this._match_pattern?e+=this._input.read(this._match_pattern):e+=this._input.readUntil(this.__template_pattern),t+=e,e=this._read_template();return this._until_after&&(t+=this._input.readUntilAfter(this._until_pattern)),t},o.prototype.__set_templated_pattern=function(){var t=[];this._disabled.php||t.push(this.__patterns.php._starting_pattern.source),this._disabled.handlebars||t.push(this.__patterns.handlebars._starting_pattern.source),this._disabled.erb||t.push(this.__patterns.erb._starting_pattern.source),this._disabled.django||(t.push(this.__patterns.django._starting_pattern.source),t.push(this.__patterns.django_value._starting_pattern.source),t.push(this.__patterns.django_comment._starting_pattern.source)),this._until_pattern&&t.push(this._until_pattern.source),this.__template_pattern=this._input.get_regexp("(?:"+t.join("|")+")")},o.prototype._read_template=function(){var t="",e=this._input.peek();if("<"===e){var n=this._input.peek(1);this._disabled.php||this._excluded.php||"?"!==n||(t=t||this.__patterns.php.read()),this._disabled.erb||this._excluded.erb||"%"!==n||(t=t||this.__patterns.erb.read())}else"{"===e&&(this._disabled.handlebars||this._excluded.handlebars||(t=(t=(t=t||this.__patterns.handlebars_comment.read())||this.__patterns.handlebars_unescaped.read())||this.__patterns.handlebars.read()),this._disabled.django||(this._excluded.django||this._excluded.handlebars||(t=t||this.__patterns.django_value.read()),this._excluded.django||(t=(t=t||this.__patterns.django_comment.read())||this.__patterns.django.read())));return t},t.exports.TemplatablePattern=o}]),void 0===(r=function(){return{js_beautify:i}}.apply(e,[]))||(t.exports=r)},function(t,e,n){var r,i;i=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=15)}([,,function(t,e,n){"use strict";function r(t){this.__parent=t,this.__character_count=0,this.__indent_count=-1,this.__alignment_count=0,this.__wrap_point_index=0,this.__wrap_point_character_count=0,this.__wrap_point_indent_count=-1,this.__wrap_point_alignment_count=0,this.__items=[]}function i(t,e){this.__cache=[""],this.__indent_size=t.indent_size,this.__indent_string=t.indent_char,t.indent_with_tabs||(this.__indent_string=new Array(t.indent_size+1).join(t.indent_char)),e=e||"",t.indent_level>0&&(e=new Array(t.indent_level+1).join(this.__indent_string)),this.__base_string=e,this.__base_string_length=e.length}function o(t,e){this.__indent_cache=new i(t,e),this.raw=!1,this._end_with_newline=t.end_with_newline,this.indent_size=t.indent_size,this.wrap_line_length=t.wrap_line_length,this.indent_empty_lines=t.indent_empty_lines,this.__lines=[],this.previous_line=null,this.current_line=null,this.next_line=new r(this),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1,this.__add_outputline()}r.prototype.clone_empty=function(){var t=new r(this.__parent);return t.set_indent(this.__indent_count,this.__alignment_count),t},r.prototype.item=function(t){return t<0?this.__items[this.__items.length+t]:this.__items[t]},r.prototype.has_match=function(t){for(var e=this.__items.length-1;e>=0;e--)if(this.__items[e].match(t))return!0;return!1},r.prototype.set_indent=function(t,e){this.is_empty()&&(this.__indent_count=t||0,this.__alignment_count=e||0,this.__character_count=this.__parent.get_indent_size(this.__indent_count,this.__alignment_count))},r.prototype._set_wrap_point=function(){this.__parent.wrap_line_length&&(this.__wrap_point_index=this.__items.length,this.__wrap_point_character_count=this.__character_count,this.__wrap_point_indent_count=this.__parent.next_line.__indent_count,this.__wrap_point_alignment_count=this.__parent.next_line.__alignment_count)},r.prototype._should_wrap=function(){return this.__wrap_point_index&&this.__character_count>this.__parent.wrap_line_length&&this.__wrap_point_character_count>this.__parent.next_line.__character_count},r.prototype._allow_wrap=function(){if(this._should_wrap()){this.__parent.add_new_line();var t=this.__parent.current_line;return t.set_indent(this.__wrap_point_indent_count,this.__wrap_point_alignment_count),t.__items=this.__items.slice(this.__wrap_point_index),this.__items=this.__items.slice(0,this.__wrap_point_index),t.__character_count+=this.__character_count-this.__wrap_point_character_count,this.__character_count=this.__wrap_point_character_count," "===t.__items[0]&&(t.__items.splice(0,1),t.__character_count-=1),!0}return!1},r.prototype.is_empty=function(){return 0===this.__items.length},r.prototype.last=function(){return this.is_empty()?null:this.__items[this.__items.length-1]},r.prototype.push=function(t){this.__items.push(t);var e=t.lastIndexOf("\n");-1!==e?this.__character_count=t.length-e:this.__character_count+=t.length},r.prototype.pop=function(){var t=null;return this.is_empty()||(t=this.__items.pop(),this.__character_count-=t.length),t},r.prototype._remove_indent=function(){this.__indent_count>0&&(this.__indent_count-=1,this.__character_count-=this.__parent.indent_size)},r.prototype._remove_wrap_indent=function(){this.__wrap_point_indent_count>0&&(this.__wrap_point_indent_count-=1)},r.prototype.trim=function(){for(;" "===this.last();)this.__items.pop(),this.__character_count-=1},r.prototype.toString=function(){var t="";return this.is_empty()?this.__parent.indent_empty_lines&&(t=this.__parent.get_indent_string(this.__indent_count)):(t=this.__parent.get_indent_string(this.__indent_count,this.__alignment_count),t+=this.__items.join("")),t},i.prototype.get_indent_size=function(t,e){var n=this.__base_string_length;return e=e||0,t<0&&(n=0),n+=t*this.__indent_size,n+=e},i.prototype.get_indent_string=function(t,e){var n=this.__base_string;return e=e||0,t<0&&(t=0,n=""),e+=t*this.__indent_size,this.__ensure_cache(e),n+=this.__cache[e]},i.prototype.__ensure_cache=function(t){for(;t>=this.__cache.length;)this.__add_column()},i.prototype.__add_column=function(){var t=this.__cache.length,e=0,n="";this.__indent_size&&t>=this.__indent_size&&(t-=(e=Math.floor(t/this.__indent_size))*this.__indent_size,n=new Array(e+1).join(this.__indent_string)),t&&(n+=new Array(t+1).join(" ")),this.__cache.push(n)},o.prototype.__add_outputline=function(){this.previous_line=this.current_line,this.current_line=this.next_line.clone_empty(),this.__lines.push(this.current_line)},o.prototype.get_line_number=function(){return this.__lines.length},o.prototype.get_indent_string=function(t,e){return this.__indent_cache.get_indent_string(t,e)},o.prototype.get_indent_size=function(t,e){return this.__indent_cache.get_indent_size(t,e)},o.prototype.is_empty=function(){return!this.previous_line&&this.current_line.is_empty()},o.prototype.add_new_line=function(t){return!(this.is_empty()||!t&&this.just_added_newline()||(this.raw||this.__add_outputline(),0))},o.prototype.get_code=function(t){this.trim(!0);var e=this.current_line.pop();e&&("\n"===e[e.length-1]&&(e=e.replace(/\n+$/g,"")),this.current_line.push(e)),this._end_with_newline&&this.__add_outputline();var n=this.__lines.join("\n");return"\n"!==t&&(n=n.replace(/[\n]/g,t)),n},o.prototype.set_wrap_point=function(){this.current_line._set_wrap_point()},o.prototype.set_indent=function(t,e){return t=t||0,e=e||0,this.next_line.set_indent(t,e),this.__lines.length>1?(this.current_line.set_indent(t,e),!0):(this.current_line.set_indent(),!1)},o.prototype.add_raw_token=function(t){for(var e=0;e<t.newlines;e++)this.__add_outputline();this.current_line.set_indent(-1),this.current_line.push(t.whitespace_before),this.current_line.push(t.text),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1},o.prototype.add_token=function(t){this.__add_space_before_token(),this.current_line.push(t),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=this.current_line._allow_wrap()},o.prototype.__add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&(this.non_breaking_space||this.set_wrap_point(),this.current_line.push(" "))},o.prototype.remove_indent=function(t){for(var e=this.__lines.length;t<e;)this.__lines[t]._remove_indent(),t++;this.current_line._remove_wrap_indent()},o.prototype.trim=function(t){for(t=void 0!==t&&t,this.current_line.trim();t&&this.__lines.length>1&&this.current_line.is_empty();)this.__lines.pop(),this.current_line=this.__lines[this.__lines.length-1],this.current_line.trim();this.previous_line=this.__lines.length>1?this.__lines[this.__lines.length-2]:null},o.prototype.just_added_newline=function(){return this.current_line.is_empty()},o.prototype.just_added_blankline=function(){return this.is_empty()||this.current_line.is_empty()&&this.previous_line.is_empty()},o.prototype.ensure_empty_line_above=function(t,e){for(var n=this.__lines.length-2;n>=0;){var i=this.__lines[n];if(i.is_empty())break;if(0!==i.item(0).indexOf(t)&&i.item(-1)!==e){this.__lines.splice(n+1,0,new r(this)),this.previous_line=this.__lines[this.__lines.length-2];break}n--}},t.exports.Output=o},,,,function(t,e,n){"use strict";function r(t,e){this.raw_options=i(t,e),this.disabled=this._get_boolean("disabled"),this.eol=this._get_characters("eol","auto"),this.end_with_newline=this._get_boolean("end_with_newline"),this.indent_size=this._get_number("indent_size",4),this.indent_char=this._get_characters("indent_char"," "),this.indent_level=this._get_number("indent_level"),this.preserve_newlines=this._get_boolean("preserve_newlines",!0),this.max_preserve_newlines=this._get_number("max_preserve_newlines",32786),this.preserve_newlines||(this.max_preserve_newlines=0),this.indent_with_tabs=this._get_boolean("indent_with_tabs","\t"===this.indent_char),this.indent_with_tabs&&(this.indent_char="\t",1===this.indent_size&&(this.indent_size=4)),this.wrap_line_length=this._get_number("wrap_line_length",this._get_number("max_char")),this.indent_empty_lines=this._get_boolean("indent_empty_lines"),this.templating=this._get_selection_list("templating",["auto","none","django","erb","handlebars","php"],["auto"])}function i(t,e){var n,r={};for(n in t=o(t))n!==e&&(r[n]=t[n]);if(e&&t[e])for(n in t[e])r[n]=t[e][n];return r}function o(t){var e,n={};for(e in t)n[e.replace(/-/g,"_")]=t[e];return n}r.prototype._get_array=function(t,e){var n=this.raw_options[t],r=e||[];return"object"==typeof n?null!==n&&"function"==typeof n.concat&&(r=n.concat()):"string"==typeof n&&(r=n.split(/[^a-zA-Z0-9_\/\-]+/)),r},r.prototype._get_boolean=function(t,e){var n=this.raw_options[t];return void 0===n?!!e:!!n},r.prototype._get_characters=function(t,e){var n=this.raw_options[t],r=e||"";return"string"==typeof n&&(r=n.replace(/\\r/,"\r").replace(/\\n/,"\n").replace(/\\t/,"\t")),r},r.prototype._get_number=function(t,e){var n=this.raw_options[t];e=parseInt(e,10),isNaN(e)&&(e=0);var r=parseInt(n,10);return isNaN(r)&&(r=e),r},r.prototype._get_selection=function(t,e,n){var r=this._get_selection_list(t,e,n);if(1!==r.length)throw new Error("Invalid Option Value: The option '"+t+"' can only be one of the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r[0]},r.prototype._get_selection_list=function(t,e,n){if(!e||0===e.length)throw new Error("Selection list cannot be empty.");if(n=n||[e[0]],!this._is_valid_selection(n,e))throw new Error("Invalid Default Value!");var r=this._get_array(t,n);if(!this._is_valid_selection(r,e))throw new Error("Invalid Option Value: The option '"+t+"' can contain only the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r},r.prototype._is_valid_selection=function(t,e){return t.length&&e.length&&!t.some((function(t){return-1===e.indexOf(t)}))},t.exports.Options=r,t.exports.normalizeOpts=o,t.exports.mergeOpts=i},,function(t,e,n){"use strict";var r=RegExp.prototype.hasOwnProperty("sticky");function i(t){this.__input=t||"",this.__input_length=this.__input.length,this.__position=0}i.prototype.restart=function(){this.__position=0},i.prototype.back=function(){this.__position>0&&(this.__position-=1)},i.prototype.hasNext=function(){return this.__position<this.__input_length},i.prototype.next=function(){var t=null;return this.hasNext()&&(t=this.__input.charAt(this.__position),this.__position+=1),t},i.prototype.peek=function(t){var e=null;return t=t||0,(t+=this.__position)>=0&&t<this.__input_length&&(e=this.__input.charAt(t)),e},i.prototype.__match=function(t,e){t.lastIndex=e;var n=t.exec(this.__input);return!n||r&&t.sticky||n.index!==e&&(n=null),n},i.prototype.test=function(t,e){return e=e||0,(e+=this.__position)>=0&&e<this.__input_length&&!!this.__match(t,e)},i.prototype.testChar=function(t,e){var n=this.peek(e);return t.lastIndex=0,null!==n&&t.test(n)},i.prototype.match=function(t){var e=this.__match(t,this.__position);return e?this.__position+=e[0].length:e=null,e},i.prototype.read=function(t,e,n){var r,i="";return t&&(r=this.match(t))&&(i+=r[0]),!e||!r&&t||(i+=this.readUntil(e,n)),i},i.prototype.readUntil=function(t,e){var n,r=this.__position;t.lastIndex=this.__position;var i=t.exec(this.__input);return i?(r=i.index,e&&(r+=i[0].length)):r=this.__input_length,n=this.__input.substring(this.__position,r),this.__position=r,n},i.prototype.readUntilAfter=function(t){return this.readUntil(t,!0)},i.prototype.get_regexp=function(t,e){var n=null,i="g";return e&&r&&(i="y"),"string"==typeof t&&""!==t?n=new RegExp(t,i):t&&(n=new RegExp(t.source,i)),n},i.prototype.get_literal_regexp=function(t){return RegExp(t.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"))},i.prototype.peekUntilAfter=function(t){var e=this.__position,n=this.readUntilAfter(t);return this.__position=e,n},i.prototype.lookBack=function(t){var e=this.__position-1;return e>=t.length&&this.__input.substring(e-t.length,e).toLowerCase()===t},t.exports.InputScanner=i},,,,,function(t,e,n){"use strict";function r(t,e){t="string"==typeof t?t:t.source,e="string"==typeof e?e:e.source,this.__directives_block_pattern=new RegExp(t+/ beautify( \w+[:]\w+)+ /.source+e,"g"),this.__directive_pattern=/ (\w+)[:](\w+)/g,this.__directives_end_ignore_pattern=new RegExp(t+/\sbeautify\signore:end\s/.source+e,"g")}r.prototype.get_directives=function(t){if(!t.match(this.__directives_block_pattern))return null;var e={};this.__directive_pattern.lastIndex=0;for(var n=this.__directive_pattern.exec(t);n;)e[n[1]]=n[2],n=this.__directive_pattern.exec(t);return e},r.prototype.readIgnored=function(t){return t.readUntilAfter(this.__directives_end_ignore_pattern)},t.exports.Directives=r},,function(t,e,n){"use strict";var r=n(16).Beautifier,i=n(17).Options;t.exports=function(t,e){return new r(t,e).beautify()},t.exports.defaultOptions=function(){return new i}},function(t,e,n){"use strict";var r=n(17).Options,i=n(2).Output,o=n(8).InputScanner,a=new(0,n(13).Directives)(/\/\*/,/\*\//),s=/\r\n|[\r\n]/,u=/\r\n|[\r\n]/g,l=/\s/,c=/(?:\s|\n)+/g,h=/\/\*(?:[\s\S]*?)((?:\*\/)|$)/g,p=/\/\/(?:[^\n\r\u2028\u2029]*)/g;function f(t,e){this._source_text=t||"",this._options=new r(e),this._ch=null,this._input=null,this.NESTED_AT_RULE={"@page":!0,"@font-face":!0,"@keyframes":!0,"@media":!0,"@supports":!0,"@document":!0},this.CONDITIONAL_GROUP_RULE={"@media":!0,"@supports":!0,"@document":!0}}f.prototype.eatString=function(t){var e="";for(this._ch=this._input.next();this._ch;){if(e+=this._ch,"\\"===this._ch)e+=this._input.next();else if(-1!==t.indexOf(this._ch)||"\n"===this._ch)break;this._ch=this._input.next()}return e},f.prototype.eatWhitespace=function(t){for(var e=l.test(this._input.peek()),n=!0;l.test(this._input.peek());)this._ch=this._input.next(),t&&"\n"===this._ch&&(this._options.preserve_newlines||n)&&(n=!1,this._output.add_new_line(!0));return e},f.prototype.foundNestedPseudoClass=function(){for(var t=0,e=1,n=this._input.peek(e);n;){if("{"===n)return!0;if("("===n)t+=1;else if(")"===n){if(0===t)return!1;t-=1}else if(";"===n||"}"===n)return!1;e++,n=this._input.peek(e)}return!1},f.prototype.print_string=function(t){this._output.set_indent(this._indentLevel),this._output.non_breaking_space=!0,this._output.add_token(t)},f.prototype.preserveSingleSpace=function(t){t&&(this._output.space_before_token=!0)},f.prototype.indent=function(){this._indentLevel++},f.prototype.outdent=function(){this._indentLevel>0&&this._indentLevel--},f.prototype.beautify=function(){if(this._options.disabled)return this._source_text;var t=this._source_text,e=this._options.eol;"auto"===e&&(e="\n",t&&s.test(t||"")&&(e=t.match(s)[0]));var n=(t=t.replace(u,"\n")).match(/^[\t ]*/)[0];this._output=new i(this._options,n),this._input=new o(t),this._indentLevel=0,this._nestedLevel=0,this._ch=null;for(var r,f,_=0,d=!1,v=!1,g=!1,m=!1,b=!1,y=this._ch;r=""!==this._input.read(c),f=y,this._ch=this._input.next(),"\\"===this._ch&&this._input.hasNext()&&(this._ch+=this._input.next()),y=this._ch,this._ch;)if("/"===this._ch&&"*"===this._input.peek()){this._output.add_new_line(),this._input.back();var w=this._input.read(h),x=a.get_directives(w);x&&"start"===x.ignore&&(w+=a.readIgnored(this._input)),this.print_string(w),this.eatWhitespace(!0),this._output.add_new_line()}else if("/"===this._ch&&"/"===this._input.peek())this._output.space_before_token=!0,this._input.back(),this.print_string(this._input.read(p)),this.eatWhitespace(!0);else if("@"===this._ch)if(this.preserveSingleSpace(r),"{"===this._input.peek())this.print_string(this._ch+this.eatString("}"));else{this.print_string(this._ch);var k=this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);k.match(/[ :]$/)&&(k=this.eatString(": ").replace(/\s$/,""),this.print_string(k),this._output.space_before_token=!0),"extend"===(k=k.replace(/\s$/,""))?m=!0:"import"===k&&(b=!0),k in this.NESTED_AT_RULE?(this._nestedLevel+=1,k in this.CONDITIONAL_GROUP_RULE&&(g=!0)):d||0!==_||-1===k.indexOf(":")||(v=!0,this.indent())}else"#"===this._ch&&"{"===this._input.peek()?(this.preserveSingleSpace(r),this.print_string(this._ch+this.eatString("}"))):"{"===this._ch?(v&&(v=!1,this.outdent()),this.indent(),this._output.space_before_token=!0,this.print_string(this._ch),g?(g=!1,d=this._indentLevel>this._nestedLevel):d=this._indentLevel>=this._nestedLevel,this._options.newline_between_rules&&d&&this._output.previous_line&&"{"!==this._output.previous_line.item(-1)&&this._output.ensure_empty_line_above("/",","),this.eatWhitespace(!0),this._output.add_new_line()):"}"===this._ch?(this.outdent(),this._output.add_new_line(),"{"===f&&this._output.trim(!0),b=!1,m=!1,v&&(this.outdent(),v=!1),this.print_string(this._ch),d=!1,this._nestedLevel&&this._nestedLevel--,this.eatWhitespace(!0),this._output.add_new_line(),this._options.newline_between_rules&&!this._output.just_added_blankline()&&"}"!==this._input.peek()&&this._output.add_new_line(!0)):":"===this._ch?!d&&!g||this._input.lookBack("&")||this.foundNestedPseudoClass()||this._input.lookBack("(")||m||0!==_?(this._input.lookBack(" ")&&(this._output.space_before_token=!0),":"===this._input.peek()?(this._ch=this._input.next(),this.print_string("::")):this.print_string(":")):(this.print_string(":"),v||(v=!0,this._output.space_before_token=!0,this.eatWhitespace(!0),this.indent())):'"'===this._ch||"'"===this._ch?(this.preserveSingleSpace(r),this.print_string(this._ch+this.eatString(this._ch)),this.eatWhitespace(!0)):";"===this._ch?0===_?(v&&(this.outdent(),v=!1),m=!1,b=!1,this.print_string(this._ch),this.eatWhitespace(!0),"/"!==this._input.peek()&&this._output.add_new_line()):(this.print_string(this._ch),this.eatWhitespace(!0),this._output.space_before_token=!0):"("===this._ch?this._input.lookBack("url")?(this.print_string(this._ch),this.eatWhitespace(),_++,this.indent(),this._ch=this._input.next(),")"===this._ch||'"'===this._ch||"'"===this._ch?this._input.back():this._ch&&(this.print_string(this._ch+this.eatString(")")),_&&(_--,this.outdent()))):(this.preserveSingleSpace(r),this.print_string(this._ch),this.eatWhitespace(),_++,this.indent()):")"===this._ch?(_&&(_--,this.outdent()),this.print_string(this._ch)):","===this._ch?(this.print_string(this._ch),this.eatWhitespace(!0),!this._options.selector_separator_newline||v||0!==_||b?this._output.space_before_token=!0:this._output.add_new_line()):">"!==this._ch&&"+"!==this._ch&&"~"!==this._ch||v||0!==_?"]"===this._ch?this.print_string(this._ch):"["===this._ch?(this.preserveSingleSpace(r),this.print_string(this._ch)):"="===this._ch?(this.eatWhitespace(),this.print_string("="),l.test(this._ch)&&(this._ch="")):"!"!==this._ch||this._input.lookBack("\\")?(this.preserveSingleSpace(r),this.print_string(this._ch)):(this.print_string(" "),this.print_string(this._ch)):this._options.space_around_combinator?(this._output.space_before_token=!0,this.print_string(this._ch),this._output.space_before_token=!0):(this.print_string(this._ch),this.eatWhitespace(),this._ch&&l.test(this._ch)&&(this._ch=""));return this._output.get_code(e)},t.exports.Beautifier=f},function(t,e,n){"use strict";var r=n(6).Options;function i(t){r.call(this,t,"css"),this.selector_separator_newline=this._get_boolean("selector_separator_newline",!0),this.newline_between_rules=this._get_boolean("newline_between_rules",!0);var e=this._get_boolean("space_around_selector_separator");this.space_around_combinator=this._get_boolean("space_around_combinator")||e}i.prototype=new r,t.exports.Options=i}]),void 0===(r=function(){return{css_beautify:i}}.apply(e,[]))||(t.exports=r)},function(t,e){var n,r,i=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{r="function"==typeof clearTimeout?clearTimeout:a}catch(t){r=a}}();var u,l=[],c=!1,h=-1;function p(){c&&u&&(c=!1,u.length?l=u.concat(l):h=-1,l.length&&f())}function f(){if(!c){var t=s(p);c=!0;for(var e=l.length;e;){for(u=l,l=[];++h<e;)u&&u[h].run();h=-1,e=l.length}u=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function _(t,e){this.fun=t,this.array=e}function d(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];l.push(new _(t,e)),1!==l.length||c||s(f)},_.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=d,i.addListener=d,i.once=d,i.off=d,i.removeListener=d,i.removeAllListeners=d,i.emit=d,i.prependListener=d,i.prependOnceListener=d,i.listeners=function(t){return[]},i.binding=function(t){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(t){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.HandlebarsEnvironment=c;var i=n(12),o=r(n(15)),a=n(23),s=n(49),u=r(n(24)),l=n(25);e.VERSION="4.7.6";e.COMPILER_REVISION=8;e.LAST_COMPATIBLE_COMPILER_REVISION=7;e.REVISION_CHANGES={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};function c(t,e,n){this.helpers=t||{},this.partials=e||{},this.decorators=n||{},a.registerDefaultHelpers(this),s.registerDefaultDecorators(this)}c.prototype={constructor:c,logger:u.default,log:u.default.log,registerHelper:function(t,e){if("[object Object]"===i.toString.call(t)){if(e)throw new o.default("Arg not supported with multiple helpers");i.extend(this.helpers,t)}else this.helpers[t]=e},unregisterHelper:function(t){delete this.helpers[t]},registerPartial:function(t,e){if("[object Object]"===i.toString.call(t))i.extend(this.partials,t);else{if(void 0===e)throw new o.default('Attempting to register a partial called "'+t+'" as undefined');this.partials[t]=e}},unregisterPartial:function(t){delete this.partials[t]},registerDecorator:function(t,e){if("[object Object]"===i.toString.call(t)){if(e)throw new o.default("Arg not supported with multiple decorators");i.extend(this.decorators,t)}else this.decorators[t]=e},unregisterDecorator:function(t){delete this.decorators[t]},resetLoggedPropertyAccesses:function(){l.resetLoggedProperties()}};var h=u.default.log;e.log=h,e.createFrame=i.createFrame,e.logger=u.default},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0,e.registerDefaultHelpers=function(t){i.default(t),o.default(t),a.default(t),s.default(t),u.default(t),l.default(t),c.default(t)},e.moveHelperToHooks=function(t,e,n){t.helpers[e]&&(t.hooks[e]=t.helpers[e],n||delete t.helpers[e])};var i=r(n(42)),o=r(n(43)),a=r(n(44)),s=r(n(45)),u=r(n(46)),l=r(n(47)),c=r(n(48))},function(t,e,n){"use strict";e.__esModule=!0;var r=n(12),i={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(t){if("string"==typeof t){var e=r.indexOf(i.methodMap,t.toLowerCase());t=e>=0?e:parseInt(t,10)}return t},log:function(t){if(t=i.lookupLevel(t),"undefined"!=typeof console&&i.lookupLevel(i.level)<=t){var e=i.methodMap[t];console[e]||(e="log");for(var n=arguments.length,r=Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];console[e].apply(console,r)}}};e.default=i,t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.createProtoAccessControl=function(t){var e=Object.create(null);e.constructor=!1,e.__defineGetter__=!1,e.__defineSetter__=!1,e.__lookupGetter__=!1;var n=Object.create(null);return n.__proto__=!1,{properties:{whitelist:r.createNewLookupObject(n,t.allowedProtoProperties),defaultValue:t.allowProtoPropertiesByDefault},methods:{whitelist:r.createNewLookupObject(e,t.allowedProtoMethods),defaultValue:t.allowProtoMethodsByDefault}}},e.resultIsAllowed=function(t,e,n){return a("function"==typeof t?e.methods:e.properties,n)},e.resetLoggedProperties=function(){Object.keys(o).forEach((function(t){delete o[t]}))};var r=n(51),i=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(n(24)),o=Object.create(null);function a(t,e){return void 0!==t.whitelist[e]?!0===t.whitelist[e]:void 0!==t.defaultValue?t.defaultValue:(function(t){!0!==o[t]&&(o[t]=!0,i.log("error",'Handlebars: Access has been denied to resolve the property "'+t+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'))}(e),!1)}},function(t,e,n){(e=n(8)(!1)).push([t.i,"@font-face{$ff:eruda-icon;src:url('data:application/x-font-woff;charset=utf-8;base64,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') format('woff')}[class*=' _icon-'],[class^='_icon-']{$ff:eruda-icon!important;$fs:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}._icon-arrow-left:before{$co:'\\f101'}._icon-arrow-right:before{$co:'\\f102'}._icon-caret-down:before{$co:'\\f103'}._icon-caret-right:before{$co:'\\f104'}._icon-clear:before{$co:'\\f105'}._icon-compress:before{$co:'\\f106'}._icon-delete:before{$co:'\\f107'}._icon-error:before{$co:'\\f108'}._icon-expand:before{$co:'\\f109'}._icon-eye:before{$co:'\\f10a'}._icon-play:before{$co:'\\f10b'}._icon-refresh:before{$co:'\\f10c'}._icon-reset:before{$co:'\\f10d'}._icon-search:before{$co:'\\f10e'}._icon-select:before{$co:'\\f10f'}._icon-tool:before{$co:'\\f110'}._icon-warn:before{$co:'\\f111'}",""]),t.exports=e},function(t,e,n){var r,i;
/*!
 * Draggabilly v2.2.0
 * Make that shiz draggable
 * https://draggabilly.desandro.com
 * MIT license
 */!function(o,a){r=[n(32),n(33)],void 0===(i=function(t,e){return function(t,e,n){"use strict";function r(t,e){for(var n in e)t[n]=e[n];return t}var i=t.jQuery;function o(t,e){this.element="string"==typeof t?document.querySelector(t):t,i&&(this.$element=i(this.element)),this.options=r({},this.constructor.defaults),this.option(e),this._create()}var a=o.prototype=Object.create(n.prototype);o.defaults={},a.option=function(t){r(this.options,t)};var s={relative:!0,absolute:!0,fixed:!0};function u(t,e,n){return n=n||"round",e?Math[n](t/e)*e:t}a._create=function(){this.position={},this._getPosition(),this.startPoint={x:0,y:0},this.dragPoint={x:0,y:0},this.startPosition=r({},this.position);var t=getComputedStyle(this.element);s[t.position]||(this.element.style.position="relative"),this.on("pointerDown",this.onPointerDown),this.on("pointerMove",this.onPointerMove),this.on("pointerUp",this.onPointerUp),this.enable(),this.setHandles()},a.setHandles=function(){this.handles=this.options.handle?this.element.querySelectorAll(this.options.handle):[this.element],this.bindHandles()},a.dispatchEvent=function(t,e,n){var r=[e].concat(n);this.emitEvent(t,r),this.dispatchJQueryEvent(t,e,n)},a.dispatchJQueryEvent=function(e,n,r){var i=t.jQuery;if(i&&this.$element){var o=i.Event(n);o.type=e,this.$element.trigger(o,r)}},a._getPosition=function(){var t=getComputedStyle(this.element),e=this._getPositionCoord(t.left,"width"),n=this._getPositionCoord(t.top,"height");this.position.x=isNaN(e)?0:e,this.position.y=isNaN(n)?0:n,this._addTransformPosition(t)},a._getPositionCoord=function(t,n){if(-1!=t.indexOf("%")){var r=e(this.element.parentNode);return r?parseFloat(t)/100*r[n]:0}return parseInt(t,10)},a._addTransformPosition=function(t){var e=t.transform;if(0===e.indexOf("matrix")){var n=e.split(","),r=0===e.indexOf("matrix3d")?12:4,i=parseInt(n[r],10),o=parseInt(n[r+1],10);this.position.x+=i,this.position.y+=o}},a.onPointerDown=function(t,e){this.element.classList.add("is-pointer-down"),this.dispatchJQueryEvent("pointerDown",t,[e])},a.dragStart=function(t,e){this.isEnabled&&(this._getPosition(),this.measureContainment(),this.startPosition.x=this.position.x,this.startPosition.y=this.position.y,this.setLeftTop(),this.dragPoint.x=0,this.dragPoint.y=0,this.element.classList.add("is-dragging"),this.dispatchEvent("dragStart",t,[e]),this.animate())},a.measureContainment=function(){var t=this.getContainer();if(t){var n=e(this.element),r=e(t),i=this.element.getBoundingClientRect(),o=t.getBoundingClientRect(),a=r.borderLeftWidth+r.borderRightWidth,s=r.borderTopWidth+r.borderBottomWidth,u=this.relativeStartPosition={x:i.left-(o.left+r.borderLeftWidth),y:i.top-(o.top+r.borderTopWidth)};this.containSize={width:r.width-a-u.x-n.width,height:r.height-s-u.y-n.height}}},a.getContainer=function(){var t=this.options.containment;if(t)return t instanceof HTMLElement?t:"string"==typeof t?document.querySelector(t):this.element.parentNode},a.onPointerMove=function(t,e,n){this.dispatchJQueryEvent("pointerMove",t,[e,n])},a.dragMove=function(t,e,n){if(this.isEnabled){var r=n.x,i=n.y,o=this.options.grid,a=o&&o[0],s=o&&o[1];r=u(r,a),i=u(i,s),r=this.containDrag("x",r,a),i=this.containDrag("y",i,s),r="y"==this.options.axis?0:r,i="x"==this.options.axis?0:i,this.position.x=this.startPosition.x+r,this.position.y=this.startPosition.y+i,this.dragPoint.x=r,this.dragPoint.y=i,this.dispatchEvent("dragMove",t,[e,n])}},a.containDrag=function(t,e,n){if(!this.options.containment)return e;var r="x"==t?"width":"height",i=u(-this.relativeStartPosition[t],n,"ceil"),o=this.containSize[r];return o=u(o,n,"floor"),Math.max(i,Math.min(o,e))},a.onPointerUp=function(t,e){this.element.classList.remove("is-pointer-down"),this.dispatchJQueryEvent("pointerUp",t,[e])},a.dragEnd=function(t,e){this.isEnabled&&(this.element.style.transform="",this.setLeftTop(),this.element.classList.remove("is-dragging"),this.dispatchEvent("dragEnd",t,[e]))},a.animate=function(){if(this.isDragging){this.positionDrag();var t=this;requestAnimationFrame((function(){t.animate()}))}},a.setLeftTop=function(){this.element.style.left=this.position.x+"px",this.element.style.top=this.position.y+"px"},a.positionDrag=function(){this.element.style.transform="translate3d( "+this.dragPoint.x+"px, "+this.dragPoint.y+"px, 0)"},a.staticClick=function(t,e){this.dispatchEvent("staticClick",t,[e])},a.setPosition=function(t,e){this.position.x=t,this.position.y=e,this.setLeftTop()},a.enable=function(){this.isEnabled=!0},a.disable=function(){this.isEnabled=!1,this.isDragging&&this.dragEnd()},a.destroy=function(){this.disable(),this.element.style.transform="",this.element.style.left="",this.element.style.top="",this.element.style.position="",this.unbindHandles(),this.$element&&this.$element.removeData("draggabilly")},a._init=function(){},i&&i.bridget&&i.bridget("draggabilly",o);return o}(o,t,e)}.apply(e,r))||(t.exports=i)}(window)},function(t,e){t.exports={background:"b","background-image":"bi",border:"bo","border-bottom":"bb","border-collapse":"bc","border-left-color":"blc","border-right":"br","border-radius":"bra","border-top":"bt","border-top-color":"btc","box-shadow":"bs","box-sizing":"bsi",clear:"cl",color:"c",content:"co",cursor:"cu",display:"d",flex:"fl","flex-shrink":"fsh",float:"f","font-family":"ff","font-size":"fs","font-weight":"fw",height:"h",left:"l","line-height":"lh",margin:"m","margin-bottom":"mb","margin-left":"ml","margin-top":"mt","min-height":"mh",outline:"ou",overflow:"o","overflow-x":"ox","overflow-y":"oy",padding:"p","padding-bottom":"pb","padding-left":"pl","padding-top":"pt","pointer-events":"pe",position:"po","text-align":"ta","text-transform":"tt",top:"t",transition:"tr","user-select":"us","vertical-aligin":"va",visibility:"v",width:"w","will-change":"wc","white-space":"ws","-webkit-overflow-scrolling":"wos","z-index":"z"}},function(t,e,n){window,t.exports=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/assets/",n(n.s=24)}([function(t,e,n){var r=n(5),i=n(4),o=n(17);e=function(t,e,n){var a,s;if(e=o(e,n),r(t))for(a=0,s=t.length;a<s;a++)e(t[a],a,t);else{var u=i(t);for(a=0,s=u.length;a<s;a++)e(t[u[a]],u[a],t)}return t},t.exports=e},function(t,e,n){var r=n(9);e=function(t){return"[object String]"===r(t)},t.exports=e},function(t,e,n){var r=n(1),i=n(8),o=n(13);e=function(t){return i(r(t)?new o(t):t)},t.exports=e},function(t,e){e=function(t){return void 0===t},t.exports=e},function(t,e,n){var r=n(11);e=Object.keys?Object.keys:function(t){var e=[];for(var n in t)r(t,n)&&e.push(n);return e},t.exports=e},function(t,e,n){var r=n(16),i=n(10),o=Math.pow(2,53)-1;e=function(t){if(!t)return!1;var e=t.length;return r(e)&&e>=0&&e<=o&&!i(t)},t.exports=e},function(t,e){e=function(t){var e=typeof t;return!!t&&("function"===e||"object"===e)},t.exports=e},function(t,e,n){var r=n(10),i=n(6),o=n(12),a=n(17),s=n(32),u=n(35),l=n(36);e=function(t,e,n){return null==t?u:r(t)?a(t,e,n):i(t)&&!o(t)?s(t):l(t)},t.exports=e},function(t,e,n){var r=n(5),i=n(19),o=n(12),a=n(1);e=function(t){return t?o(t)?t:r(t)&&!a(t)?i(t):[t]:[]},t.exports=e},function(t,e){var n=Object.prototype.toString;e=function(t){return n.call(t)},t.exports=e},function(t,e,n){var r=n(9);e=function(t){var e=r(t);return"[object Function]"===e||"[object GeneratorFunction]"===e||"[object AsyncFunction]"===e},t.exports=e},function(t,e){var n=Object.prototype.hasOwnProperty;e=function(t,e){return n.call(t,e)},t.exports=e},function(t,e,n){var r=n(9);e=Array.isArray?Array.isArray:function(t){return"[object Array]"===r(t)},t.exports=e},function(t,e,n){var r=n(14),i=n(1),o=n(0),a=new(e=r({className:"Select",initialize:function(t){return this.length=0,t?i(t)?a.find(t):void(t.nodeType&&(this[0]=t,this.length=1)):this},find:function(t){var n=new e;return this.each((function(){!function(t,e){for(var n=e.length,r=t.length,i=0;i<n;i++)t[r++]=e[i];t.length=r}(n,this.querySelectorAll(t))})),n},each:function(t){return o(this,(function(e,n){t.call(e,n,e)})),this}}))(document);t.exports=e},function(t,e,n){var r=n(27),i=n(8),o=n(38),a=n(18),s=n(40),u=(e=function(t,e){return u.extend(t,e)}).Base=function t(e,n,u){u=u||{};var l=n.className||a(n,"initialize.name")||"";delete n.className;var c=function(){var t=i(arguments);return this.initialize&&this.initialize.apply(this,t)||this};if(!s)try{c=new Function("toArr","return function "+l+"(){var args = toArr(arguments);return this.initialize ? this.initialize.apply(this, args) || this : this;};")(i)}catch(t){}return o(c,e),c.prototype.constructor=c,c.extend=function(e,n){return t(c,e,n)},c.inherits=function(t){o(c,t)},c.methods=function(t){return r(c.prototype,t),c},c.statics=function(t){return r(c,t),c},c.methods(n).statics(u),c}(Object,{className:"Base",callSuper:function(t,e,n){return t.prototype[e].apply(this,n)},toString:function(){return this.constructor.name}});t.exports=e},function(t,e,n){var r=n(3),i=n(0);e=function(t,e){return function(n){return i(arguments,(function(o,a){if(0!==a){var s=t(o);i(s,(function(t){e&&!r(n[t])||(n[t]=o[t])}))}})),n}},t.exports=e},function(t,e,n){var r=n(9);e=function(t){return"[object Number]"===r(t)},t.exports=e},function(t,e,n){var r=n(3);e=function(t,e,n){if(r(e))return t;switch(null==n?3:n){case 1:return function(n){return t.call(e,n)};case 3:return function(n,r,i){return t.call(e,n,r,i)};case 4:return function(n,r,i,o){return t.call(e,n,r,i,o)}}return function(){return t.apply(e,arguments)}},t.exports=e},function(t,e,n){var r=n(3),i=n(37);e=function(t,e){var n;for(n=(e=i(e,t)).shift();!r(n);){if(null==(t=t[n]))return;n=e.shift()}return t},t.exports=e},function(t,e,n){var r=n(7),i=n(4),o=n(5);e=function(t,e,n){e=r(e,n);for(var a=!o(t)&&i(t),s=(a||t).length,u=Array(s),l=0;l<s;l++){var c=a?a[l]:l;u[l]=e(t[c],c,t)}return u},t.exports=e},function(t,e,n){var r=n(21);e=function(t){return r(t).join("-")},t.exports=e},function(t,e){var n=/([A-Z])/g,r=/[_.\- ]+/g,i=/(^-)|(-$)/g;e=function(t){return(t=t.replace(n,"-$1").toLowerCase().replace(r,"-").replace(i,"")).split("-")},t.exports=e},function(t,e,n){var r=n(44),i=n(1),o=n(5),a=n(45);e=function(t,e){return i(t)?t.indexOf(e)>-1:(o(t)||(t=a(t)),r(t,e)>=0)},t.exports=e},function(t,e,n){var r=n(8),i=n(6),o=n(1),a=n(0),s=n(3),u=n(2);(e=function(t,e,n){if(t=u(t),s(n)&&o(e))return function(t,e){return t.getAttribute(e)}(t[0],e);var r=e;i(r)||((r={})[e]=n),function(t,e){a(t,(function(t){a(e,(function(e,n){t.setAttribute(n,e)}))}))}(t,r)}).remove=function(t,e){t=u(t),e=r(e),a(t,(function(t){a(e,(function(e){t.removeAttribute(e)}))}))},t.exports=e},function(t,e,n){"use strict";var r=this&&this.__makeTemplateObject||function(t,e){return Object.defineProperty?Object.defineProperty(t,"raw",{value:e}):t.raw=e,t},i=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{default:t}};Object.defineProperty(e,"__esModule",{value:!0}),n(25);var o,a,s=i(n(26)),u=i(n(59)),l=i(n(64)),c=i(n(65)),h=function(){function t(t,e){var n=void 0===e?{}:e,r=n.position,i=void 0===r?{x:"right",y:"bottom"}:r,o=n.duration,a=void 0===o?2e3:o;this.notifications=[],this.$container=s.default(t),this.position=i,this.duration=a,this.appendTpl()}return t.prototype.notify=function(t,e){var n=this,r=(void 0===e?{}:e).duration,i=void 0===r?this.duration:r,o=new p(this,t);this.notifications.push(o),this.add(o),i&&setTimeout((function(){return n.remove(o.id)}),i)},t.prototype.dismissAll=function(){for(var t=this.notifications,e=t[0];e;)this.remove(e.id),e=t[0]},t.prototype.add=function(t){this.$notification.append(t.html())},t.prototype.remove=function(t){var e=this.notifications,n=c.default(e,(function(e){return e.id===t}));if(n){this.$notification.find("#"+t).remove();var r=e.indexOf(n);e.splice(r,1)}},t.prototype.appendTpl=function(){var t=this.$container,e=this.position,n=e.x,i=e.y,a="flex-end",s="flex-end";switch(n){case"center":s="center";break;case"left":s="flex-start"}"top"===i&&(a="flex-start"),t.append(u.default(o||(o=r(['\n      <div class="luna-notification" style="justify-content: ',"; align-items: ",'"></div>\n    '],['\n      <div class="luna-notification" style="justify-content: ',"; align-items: ",'"></div>\n    '])),a,s)),this.$notification=t.find(".luna-notification")},t}(),p=function(){function t(t,e){this.container=t,this.content=e,this.id=l.default("luna-notification-")}return t.prototype.html=function(){var t=this.container.position.y;return u.default(a||(a=r(['\n      <div id="','" class="luna-notification-item luna-notification-','">\n        <div class="luna-notification-content">',"</div>\n      </div>\n    "],['\n      <div id="','" class="luna-notification-item luna-notification-','">\n        <div class="luna-notification-content">',"</div>\n      </div>\n    "])),this.id,"bottom"===t?"lower":"upper",this.content)},t}();t.exports=h},function(t,e,n){},function(t,e,n){var r=n(13),i=n(41),o=n(42),a=n(43),s=n(23),u=n(50),l=n(51),c=n(52),h=n(53),p=n(54),f=n(56),_=n(58),d=n(3),v=n(1);e=function(t){return new r(t)},r.methods({offset:function(){return i(this)},hide:function(){return this.css("display","none")},show:function(){return o(this),this},first:function(){return e(this[0])},last:function(){return e(l(this))},get:function(t){return this[t]},eq:function(t){return e(this[t])},on:function(t,e,n){return p.on(this,t,e,n),this},off:function(t,e,n){return p.off(this,t,e,n),this},html:function(t){var e=u.html(this,t);return d(t)?e:this},text:function(t){var e=u.text(this,t);return d(t)?e:this},val:function(t){var e=u.val(this,t);return d(t)?e:this},css:function(t,e){var n=a(this,t,e);return g(t,e)?n:this},attr:function(t,e){var n=s(this,t,e);return g(t,e)?n:this},data:function(t,e){var n=h(this,t,e);return g(t,e)?n:this},rmAttr:function(t){return s.remove(this,t),this},remove:function(){return c(this),this},addClass:function(t){return f.add(this,t),this},rmClass:function(t){return f.remove(this,t),this},toggleClass:function(t){return f.toggle(this,t),this},hasClass:function(t){return f.has(this,t)},parent:function(){return e(this[0].parentNode)},append:function(t){return _.append(this,t),this},prepend:function(t){return _.prepend(this,t),this},before:function(t){return _.before(this,t),this},after:function(t){return _.after(this,t),this}});var g=function(t,e){return d(e)&&v(t)};t.exports=e},function(t,e,n){e=n(15)(n(28)),t.exports=e},function(t,e,n){var r=n(4),i=n(29),o=n(30),a=Object.getOwnPropertyNames,s=Object.getOwnPropertySymbols;e=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.prototype,u=void 0===n||n,l=e.unenumerable,c=void 0!==l&&l,h=e.symbol,p=void 0!==h&&h,f=[];if((c||p)&&a){var _=r;c&&a&&(_=a);do{f=f.concat(_(t)),p&&s&&(f=f.concat(s(t)))}while(u&&(t=i(t))&&t!==Object.prototype);f=o(f)}else if(u)for(var d in t)f.push(d);else f=r(t);return f},t.exports=e},function(t,e,n){var r=n(6),i=n(10),o=Object.getPrototypeOf,a={}.constructor;e=function(t){if(r(t)){if(o)return o(t);var e=t.__proto__;return e||null===e?e:i(t.constructor)?t.constructor.prototype:t instanceof a?a.prototype:void 0}},t.exports=e},function(t,e,n){var r=n(31);function i(t,e){return t===e}e=function(t,e){return e=e||i,r(t,(function(t,n,r){for(var i=r.length;++n<i;)if(e(t,r[n]))return!1;return!0}))},t.exports=e},function(t,e,n){var r=n(7),i=n(0);e=function(t,e,n){var o=[];return e=r(e,n),i(t,(function(t,n,r){e(t,n,r)&&o.push(t)})),o},t.exports=e},function(t,e,n){var r=n(33),i=n(34);e=function(t){return t=r({},t),function(e){return i(e,t)}},t.exports=e},function(t,e,n){var r=n(4);e=n(15)(r),t.exports=e},function(t,e,n){var r=n(4);e=function(t,e){var n=r(e),i=n.length;if(null==t)return!i;t=Object(t);for(var o=0;o<i;o++){var a=n[o];if(e[a]!==t[a]||!(a in t))return!1}return!0},t.exports=e},function(t,e){e=function(t){return t},t.exports=e},function(t,e,n){var r=n(12),i=n(18);e=function(t){return r(t)?function(e){return i(e,t)}:(e=t,function(t){return null==t?void 0:t[e]});var e},t.exports=e},function(t,e,n){var r=n(11),i=n(12);e=function(t,e){if(i(t))return t;if(e&&r(e,t))return[t];var n=[];return t.replace(o,(function(t,e,r,i){n.push(r?i.replace(a,"$1"):e||t)})),n};var o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,a=/\\(\\)?/g;t.exports=e},function(t,e,n){var r=n(39);e=function(t,e){t.prototype=r(e.prototype)},t.exports=e},function(t,e,n){var r=n(6);e=function(t){if(!r(t))return{};if(i)return i(t);function e(){}return e.prototype=t,new e};var i=Object.create;t.exports=e},function(t,e,n){var r=n(10);e="undefined"!=typeof wx&&r(wx.openLocation),t.exports=e},function(t,e,n){var r=n(2);e=function(t){var e=(t=r(t))[0].getBoundingClientRect();return{left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:Math.round(e.width),height:Math.round(e.height)}},t.exports=e},function(t,e,n){var r=n(0),i=n(2);e=function(t){t=i(t),r(t,(function(t){(function(t){return"none"==getComputedStyle(t,"").getPropertyValue("display")})(t)&&(t.style.display=function(t){var e,n;return o[t]||(e=document.createElement(t),document.documentElement.appendChild(e),n=getComputedStyle(e,"").getPropertyValue("display"),e.parentNode.removeChild(e),"none"==n&&(n="block"),o[t]=n),o[t]}(t.nodeName))}))};var o={};t.exports=e},function(t,e,n){var r=n(1),i=n(6),o=n(20),a=n(3),s=n(22),u=n(16),l=n(2),c=n(46),h=n(0);e=function(t,e,n){if(t=l(t),a(n)&&r(e))return function(t,e){return t.style[c(e)]||getComputedStyle(t,"").getPropertyValue(e)}(t[0],e);var f=e;i(f)||((f={})[e]=n),function(t,e){h(t,(function(t){var n=";";h(e,(function(t,e){e=c.dash(e),n+=e+":"+function(t,e){return u(e)&&!s(p,o(t))?e+"px":e}(e,t)+";"})),t.style.cssText+=n}))}(t,f)};var p=["column-count","columns","font-weight","line-weight","opacity","z-index","zoom"];t.exports=e},function(t,e){e=function(t,e,n){return Array.prototype.indexOf.call(t,e,n)},t.exports=e},function(t,e,n){var r=n(0);e=function(t){var e=[];return r(t,(function(t){e.push(t)})),e},t.exports=e},function(t,e,n){var r=n(47),i=n(48),o=n(49),a=n(11),s=n(20);(e=r((function(t){if(t=t.replace(l,""),t=i(t),a(c,t))return t;for(var e=u.length;e--;){var n=u[e]+o(t);if(a(c,n))return n}return t}))).dash=r((function(t){var n=e(t);return(l.test(n)?"-":"")+s(n)}));var u=["O","ms","Moz","Webkit"],l=/^(O)|(ms)|(Moz)|(Webkit)|(-o-)|(-ms-)|(-moz-)|(-webkit-)/g,c=document.createElement("p").style;t.exports=e},function(t,e,n){var r=n(11);e=function(t,e){var n=function(i){var o=n.cache,a=""+(e?e.apply(this,arguments):i);return r(o,a)||(o[a]=t.apply(this,arguments)),o[a]};return n.cache={},n},t.exports=e},function(t,e,n){var r=n(21);function i(t,e){this[e]=t.replace(/\w/,(function(t){return t.toUpperCase()}))}e=function(t){var e=r(t),n=e[0];return e.shift(),e.forEach(i,e),n+e.join("")},t.exports=e},function(t,e){e=function(t){return t.length<1?t:t[0].toUpperCase()+t.slice(1)},t.exports=e},function(t,e,n){var r=n(3),i=n(0),o=n(2);function a(t){return function(e,n){var a=(e=o(e))[0];if(r(n))return a?a[t]:"";a&&i(e,(function(e){e[t]=n}))}}e={html:a("innerHTML"),text:a("textContent"),val:a("value")},t.exports=e},function(t,e){e=function(t){var e=t?t.length:0;if(e)return t[e-1]},t.exports=e},function(t,e,n){var r=n(0),i=n(2);e=function(t){t=i(t),r(t,(function(t){var e=t.parentNode;e&&e.removeChild(t)}))},t.exports=e},function(t,e,n){var r=n(23),i=n(1),o=n(6),a=n(0);n(2),e=function(t,e,n){var s=e;return i(e)&&(s="data-"+e),o(e)&&(s={},a(e,(function(t,e){s["data-"+e]=t}))),r(t,s,n)},t.exports=e},function(t,e,n){var r=n(55),i=n(3),o=n(2),a=n(0);function s(t){return function(e,n,s,u){e=o(e),i(u)&&(u=s,s=void 0),a(e,(function(e){r[t](e,n,s,u)}))}}e={on:s("add"),off:s("remove")},t.exports=e},function(t,e,n){var r=n(14),i=n(22);function o(){return!0}function a(){return!1}function s(t){var n,r=this.events[t.type],i=u.call(this,t,r);t=new e.Event(t);for(var o,a,s=0;(a=i[s++])&&!t.isPropagationStopped();)for(t.curTarget=a.el,o=0;(n=a.handlers[o++])&&!t.isImmediatePropagationStopped();)!1===n.handler.apply(a.el,[t])&&(t.preventDefault(),t.stopPropagation())}function u(t,e){var n,r,o,a,s=t.target,u=[],l=e.delegateCount;if(s.nodeType)for(;s!==this;s=s.parentNode||this){for(r=[],a=0;a<l;a++)void 0===r[n=(o=e[a]).selector+" "]&&(r[n]=i(this.querySelectorAll(n),s)),r[n]&&r.push(o);r.length&&u.push({el:s,handlers:r})}return l<e.length&&u.push({el:this,handlers:e.slice(l)}),u}e={add:function(t,e,n,r){var i,o={selector:n,handler:r};t.events||(t.events={}),(i=t.events[e])||((i=t.events[e]=[]).delegateCount=0,t.addEventListener(e,(function(){s.apply(t,arguments)}),!1)),n?i.splice(i.delegateCount++,0,o):i.push(o)},remove:function(t,e,n,r){var i=t.events;if(i&&i[e])for(var o,a=i[e],s=a.length;s--;)o=a[s],n&&o.selector!=n||o.handler!=r||(a.splice(s,1),o.selector&&a.delegateCount--)},Event:r({className:"Event",initialize:function(t){this.origEvent=t},isDefaultPrevented:a,isPropagationStopped:a,isImmediatePropagationStopped:a,preventDefault:function(){var t=this.origEvent;this.isDefaultPrevented=o,t&&t.preventDefault&&t.preventDefault()},stopPropagation:function(){var t=this.origEvent;this.isPropagationStopped=o,t&&t.stopPropagation&&t.stopPropagation()},stopImmediatePropagation:function(){var t=this.origEvent;this.isImmediatePropagationStopped=o,t&&t.stopImmediatePropagation&&t.stopImmediatePropagation(),this.stopPropagation()}})},t.exports=e},function(t,e,n){var r=n(8),i=n(57),o=n(2),a=n(1),s=n(0);function u(t){return a(t)?t.split(/\s+/):r(t)}e={add:function(t,n){t=o(t);var r=u(n);s(t,(function(t){var n=[];s(r,(function(r){e.has(t,r)||n.push(r)})),0!==n.length&&(t.className+=(t.className?" ":"")+n.join(" "))}))},has:function(t,e){t=o(t);var n=new RegExp("(^|\\s)"+e+"(\\s|$)");return i(t,(function(t){return n.test(t.className)}))},toggle:function(t,n){t=o(t),s(t,(function(t){if(!e.has(t,n))return e.add(t,n);e.remove(t,n)}))},remove:function(t,e){t=o(t);var n=u(e);s(t,(function(t){s(n,(function(e){t.classList.remove(e)}))}))}},t.exports=e},function(t,e,n){var r=n(7),i=n(5),o=n(4);e=function(t,e,n){e=r(e,n);for(var a=!i(t)&&o(t),s=(a||t).length,u=0;u<s;u++){var l=a?a[u]:u;if(e(t[l],l,t))return!0}return!1},t.exports=e},function(t,e,n){var r=n(0),i=n(2);function o(t){return function(e,n){e=i(e),r(e,(function(e){e.insertAdjacentHTML(t,n)}))}}e={before:o("beforebegin"),after:o("afterend"),append:o("beforeend"),prepend:o("afterbegin")},t.exports=e},function(t,e,n){var r=n(1),i=n(8),o=n(60),a=n(19),s=n(61);e=function(t){r(t)&&(t=i(t));for(var e="",n=arguments.length,l=new Array(n>1?n-1:0),c=1;c<n;c++)l[c-1]=arguments[c];for(var h=0,p=t.length;h<p;h++)e+=t[h],l[h]&&(e+=l[h]);for(var f=e.split("\n"),_=[],d=0,v=f.length;d<v;d++){var g=f[d],m=g.match(u);m&&_.push(m[1].length)}var b=_.length>0?o.apply(null,_):0;return s(a(f,(function(t){return" "===t[0]?t.slice(b):t})).join("\n"))};var u=/^(\s+)\S+/;t.exports=e},function(t,e){e=function(){for(var t=arguments,e=t[0],n=1,r=t.length;n<r;n++)t[n]<e&&(e=t[n]);return e},t.exports=e},function(t,e,n){var r=n(62),i=n(63),o=/^\s+|\s+$/g;e=function(t,e){return null==e?t.replace(o,""):r(i(t,e),e)},t.exports=e},function(t,e){var n=/^\s+/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=0,a=t.length,s=e.length,u=!0;u&&o<a;)for(u=!1,r=-1,i=t.charAt(o);++r<s;)if(i===e[r]){u=!0,o++;break}return o>=a?"":t.substr(o,a)},t.exports=e},function(t,e){var n=/\s+$/;e=function(t,e){if(null==e)return t.replace(n,"");for(var r,i,o=t.length-1,a=e.length,s=!0;s&&o>=0;)for(s=!1,r=-1,i=t.charAt(o);++r<a;)if(i===e[r]){s=!0,o--;break}return o>=0?t.substring(0,o+1):""},t.exports=e},function(t,e){var n=0;e=function(t){var e=++n+"";return t?t+e:e},t.exports=e},function(t,e,n){var r=n(66),i=n(67),o=n(5),a=n(3);e=function(t,e,n){var s=(o(t)?i:r)(t,e,n);if(!a(s)&&-1!==s)return t[s]},t.exports=e},function(t,e,n){var r=n(7),i=n(4);e=function(t,e,n){e=r(e,n);for(var o,a=i(t),s=0,u=a.length;s<u;s++)if(e(t[o=a[s]],o,t))return o},t.exports=e},function(t,e,n){var r=n(7);e=function(t,e,n,i){i=i||1,e=r(e,n);for(var o=t.length,a=i>0?0:o-1;a>=0&&a<o;){if(e(t[a],a,t))return a;a+=i}return-1},t.exports=e}])},function(t,e,n){t.exports=n(101).default},function(t,e){function n(e,r){return t.exports=n=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},n(e,r)}t.exports=n},function(t,e,n){var r,i;
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */window,void 0===(i="function"==typeof(r=function(){"use strict";function t(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var e="undefined"==typeof console?function(){}:function(t){console.error(t)},n=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],r=n.length;function i(t){var n=getComputedStyle(t);return n||e("Style returned "+n+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),n}var o,a=!1;function s(e){if(function(){if(!a){a=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var n=document.body||document.documentElement;n.appendChild(e);var r=i(e);o=200==Math.round(t(r.width)),s.isBoxSizeOuter=o,n.removeChild(e)}}(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var u=i(e);if("none"==u.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<r;e++)t[n[e]]=0;return t}();var l={};l.width=e.offsetWidth,l.height=e.offsetHeight;for(var c=l.isBorderBox="border-box"==u.boxSizing,h=0;h<r;h++){var p=n[h],f=u[p],_=parseFloat(f);l[p]=isNaN(_)?0:_}var d=l.paddingLeft+l.paddingRight,v=l.paddingTop+l.paddingBottom,g=l.marginLeft+l.marginRight,m=l.marginTop+l.marginBottom,b=l.borderLeftWidth+l.borderRightWidth,y=l.borderTopWidth+l.borderBottomWidth,w=c&&o,x=t(u.width);!1!==x&&(l.width=x+(w?0:d+b));var k=t(u.height);return!1!==k&&(l.height=k+(w?0:v+y)),l.innerWidth=l.width-(d+b),l.innerHeight=l.height-(v+y),l.outerWidth=l.width+g,l.outerHeight=l.height+m,l}}return s})?r.call(e,n,e,t):r)||(t.exports=i)},function(t,e,n){var r,i;
/*!
 * Unidragger v2.3.1
 * Draggable base class
 * MIT license
 */!function(o,a){r=[n(34)],void 0===(i=function(t){return function(t,e){"use strict";function n(){}var r=n.prototype=Object.create(e.prototype);r.bindHandles=function(){this._bindHandles(!0)},r.unbindHandles=function(){this._bindHandles(!1)},r._bindHandles=function(e){for(var n=(e=void 0===e||e)?"addEventListener":"removeEventListener",r=e?this._touchActionValue:"",i=0;i<this.handles.length;i++){var o=this.handles[i];this._bindStartEvent(o,e),o[n]("click",this),t.PointerEvent&&(o.style.touchAction=r)}},r._touchActionValue="none",r.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var i={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},o={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return r.okayPointerDown=function(t){var e=i[t.target.nodeName],n=o[t.target.type],r=!e||n;return r||this._pointerReset(),r},r.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},r.pointerMove=function(t,e){var n=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,n]),this._dragMove(t,e,n)},r._dragPointerMove=function(t,e){var n={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(n)&&this._dragStart(t,e),n},r.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},r.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},r._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},r._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},r.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},r._dragMove=function(t,e,n){this.isDragging&&this.dragMove(t,e,n)},r.dragMove=function(t,e,n){t.preventDefault(),this.emitEvent("dragMove",[t,e,n])},r._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},r.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},r.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},r._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},r.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},n.getPointerPoint=e.getPointerPoint,n}(o,t)}.apply(e,r))||(t.exports=i)}(window)},function(t,e,n){var r,i;
/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */!function(o,a){r=[n(35)],void 0===(i=function(t){return function(t,e){"use strict";function n(){}var r=n.prototype=Object.create(e.prototype);r.bindStartEvent=function(t){this._bindStartEvent(t,!0)},r.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},r._bindStartEvent=function(e,n){var r=(n=void 0===n||n)?"addEventListener":"removeEventListener",i="mousedown";t.PointerEvent?i="pointerdown":"ontouchstart"in t&&(i="touchstart"),e[r](i,this)},r.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.getTouch=function(t){for(var e=0;e<t.length;e++){var n=t[e];if(n.identifier==this.pointerIdentifier)return n}},r.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},r.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},r.onpointerdown=function(t){this._pointerDown(t,t)},r._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},r.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var i={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return r._bindPostStartEvents=function(e){if(e){var n=i[e.type];n.forEach((function(e){t.addEventListener(e,this)}),this),this._boundPointerEvents=n}},r._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach((function(e){t.removeEventListener(e,this)}),this),delete this._boundPointerEvents)},r.onmousemove=function(t){this._pointerMove(t,t)},r.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},r.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},r._pointerMove=function(t,e){this.pointerMove(t,e)},r.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},r.onmouseup=function(t){this._pointerUp(t,t)},r.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},r.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},r._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},r.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},r._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},r._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},r.pointerDone=function(){},r.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},r.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},r._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},r.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},n.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},n}(o,t)}.apply(e,r))||(t.exports=i)}(window)},function(t,e,n){var r,i;"undefined"!=typeof window&&window,void 0===(i="function"==typeof(r=function(){"use strict";function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var n=this._events=this._events||{},r=n[t]=n[t]||[];return-1==r.indexOf(e)&&r.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var n=this._onceEvents=this._onceEvents||{};return(n[t]=n[t]||{})[e]=!0,this}},e.off=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){var r=n.indexOf(e);return-1!=r&&n.splice(r,1),this}},e.emitEvent=function(t,e){var n=this._events&&this._events[t];if(n&&n.length){n=n.slice(0),e=e||[];for(var r=this._onceEvents&&this._onceEvents[t],i=0;i<n.length;i++){var o=n[i];r&&r[o]&&(this.off(t,o),delete r[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t})?r.call(e,n,e,t):r)||(t.exports=i)},function(t,e,n){(function(t){var r=void 0!==t&&t||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function o(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new o(i.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new o(i.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout((function(){t._onTimeout&&t._onTimeout()}),e))},n(37),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,n(16))},function(t,e,n){(function(t,e){!function(t,n){"use strict";if(!t.setImmediate){var r,i,o,a,s,u=1,l={},c=!1,h=t.document,p=Object.getPrototypeOf&&Object.getPrototypeOf(t);p=p&&p.setTimeout?p:t,"[object process]"==={}.toString.call(t.process)?r=function(t){e.nextTick((function(){_(t)}))}:!function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?t.MessageChannel?((o=new MessageChannel).port1.onmessage=function(t){_(t.data)},r=function(t){o.port2.postMessage(t)}):h&&"onreadystatechange"in h.createElement("script")?(i=h.documentElement,r=function(t){var e=h.createElement("script");e.onreadystatechange=function(){_(t),e.onreadystatechange=null,i.removeChild(e),e=null},i.appendChild(e)}):r=function(t){setTimeout(_,0,t)}:(a="setImmediate$"+Math.random()+"$",s=function(e){e.source===t&&"string"==typeof e.data&&0===e.data.indexOf(a)&&_(+e.data.slice(a.length))},t.addEventListener?t.addEventListener("message",s,!1):t.attachEvent("onmessage",s),r=function(e){t.postMessage(a+e,"*")}),p.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var i={callback:t,args:e};return l[u]=i,r(u),u++},p.clearImmediate=f}function f(t){delete l[t]}function _(t){if(c)setTimeout(_,0,t);else{var e=l[t];if(e){c=!0;try{!function(t){var e=t.callback,n=t.args;switch(n.length){case 0:e();break;case 1:e(n[0]);break;case 2:e(n[0],n[1]);break;case 3:e(n[0],n[1],n[2]);break;default:e.apply(void 0,n)}}(e)}finally{f(t),c=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,n(16),n(21))},function(t,e,n){var r=n(1);t.exports=function(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=r(t)););return t}},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_settings{$oy:auto;$wos:touch}#_settings ._separator{$h:10px}#_settings ._text{$p:10px;$c:var(--accent);$fs:12px}#_settings ._color,#_settings ._range,#_settings ._select{$cu:pointer}#_settings ._color ._head,#_settings ._range ._head,#_settings ._select ._head,#_settings ._switch{$p:10px;$b:var(--darker-background);$fs:14px;$bb:1px solid var(--border);$bt:1px solid var(--border);$c:var(--primary);$mt:-1px}#_settings ._color ._head,#_settings ._range ._head,#_settings ._select ._head{$tr:background .3s,color .3s}#_settings ._color ._head span,#_settings ._range ._head span,#_settings ._select ._head span{$f:right}#_settings ._color ._head:active,#_settings ._range ._head:active,#_settings ._select ._head:active{$b:var(--highlight);$c:var(--select-foreground)}#_settings ._color ._head span{$d:inline-block;$bo:1px solid var(--border);$w:15px;$h:15px}#_settings ._select ul{$d:none;$bb:1px solid var(--border);$c:var(--foreground)}#_settings ._select ul._open{$d:block}#_settings ._select ul li{$p:10px;$tr:background .3s,color .3s}#_settings ._select ul li:active{$b:var(--highlight);$c:var(--select-foreground)}#_settings ._color ul{$d:none;$p:10px;$fs:0;$bb:1px solid var(--border)}#_settings ._color ul._open{$d:block}#_settings ._color ul li{$d:inline-block;$w:20px;$bo:1px solid var(--border);$h:20px;margin-right:10px}#_settings ._range ._input-container{$d:none;$p:10px;$bb:1px solid var(--border);$po:relative}#_settings ._range ._input-container._open{$d:block}#_settings ._range ._input-container ._range-track{$h:4px;$w:100%;$p:0 10px;$po:absolute;$l:0;$t:16px}#_settings ._range ._input-container ._range-track ._range-track-bar{$b:var(--darker-background);$bra:2px;$o:hidden;$w:100%;$h:4px}#_settings ._range ._input-container ._range-track ._range-track-bar ._range-track-progress{$h:100%;$b:var(--accent);$w:50%}#_settings ._range ._input-container input{-webkit-appearance:none;$b:0 0;$h:4px;$w:100%;$po:relative;$t:-3px;$m:0 auto;$ou:0;$bra:2px}#_settings ._range ._input-container input::-webkit-slider-thumb{-webkit-appearance:none;$po:relative;$t:0;$z:1;$w:16px;$bo:none;$h:16px;$bra:10px;$bo:1px solid var(--border);$b:radial-gradient(circle at center,var(--dark) 0,var(--dark) 15%,var(--light) 22%,var(--light) 100%)}#_settings ._switch ._checkbox{$f:right;$po:relative;vertical-align:top;$w:46px;$h:20px;$p:3px;$bra:18px;$bo:1px solid var(--border);$cu:pointer;$bi:linear-gradient(to bottom,var(--dark),var(--light) 25px)}#_settings ._switch ._checkbox ._input{$po:absolute;$t:0;$l:0;opacity:0}#_settings ._switch ._checkbox ._label{$pe:none;$po:relative;$d:block;$h:12px;$fs:10px;$tt:uppercase;$b:var(--darker-background);$bra:inherit;$bs:inset 0 1px 2px rgba(0,0,0,.12),inset 0 0 2px rgba(0,0,0,.15);$tr:.15s ease-out;transition-property:opacity background}#_settings ._switch ._checkbox ._label:after,#_settings ._switch ._checkbox ._label:before{$po:absolute;$t:50%;$mt:-.5em;$lh:1;$tr:inherit}#_settings ._switch ._checkbox ._input:checked~._label{$b:var(--accent);$bs:inset 0 1px 2px rgba(0,0,0,.15),inset 0 0 3px rgba(0,0,0,.2)}#_settings ._switch ._checkbox ._input:checked~._label:before{opacity:0}#_settings ._switch ._checkbox ._input:checked~._label:after{opacity:1}#_settings ._switch ._checkbox ._handle{$po:absolute;$pe:none;$t:0;$l:0;$w:18px;$h:18px;$bra:10px;$bs:1px 1px 5px rgba(0,0,0,.2);$bi:linear-gradient(to bottom,var(--light) 40%,var(--dark));$tr:left .15s ease-out}#_settings ._switch ._checkbox ._handle:before{$co:'';$po:absolute;$t:50%;$l:50%;$m:-6px 0 0 -6px;$w:12px;$h:12px;$bra:6px;$bs:inset 0 1px rgba(0,0,0,.02);$bi:linear-gradient(to bottom,var(--dark),var(--light))}#_settings ._switch ._checkbox ._input:checked~._handle{$l:30px;$bs:-1px 1px 5px rgba(0,0,0,.2)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){return' checked="checked" '},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=null!=e?e:t.nullContext||{},l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return'<div id="'+s(a(null!=e?l(e,"id"):e,e))+'" '+(null!=(o=l(n,"class").call(u,"switch",{name:"class",hash:{},data:i}))?o:"")+"> "+s(a(null!=e?l(e,"desc"):e,e))+" <label "+(null!=(o=l(n,"class").call(u,"checkbox",{name:"class",hash:{},data:i}))?o:"")+'><input type="checkbox" '+(null!=(o=l(n,"class").call(u,"input",{name:"class",hash:{},data:i}))?o:"")+' data-id="'+s(a(null!=e?l(e,"id"):e,e))+'" '+(null!=(o=l(n,"if").call(u,null!=e?l(e,"val"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+"> <span "+(null!=(o=l(n,"class").call(u,"label",{name:"class",hash:{},data:i}))?o:"")+"></span> <span "+(null!=(o=l(n,"class").call(u,"handle",{name:"class",hash:{},data:i}))?o:"")+"></span></label></div>"},useData:!0})},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}e.__esModule=!0;var o=i(n(22)),a=r(n(52)),s=r(n(15)),u=i(n(12)),l=i(n(53)),c=r(n(55));function h(){var t=new o.HandlebarsEnvironment;return u.extend(t,o),t.SafeString=a.default,t.Exception=s.default,t.Utils=u,t.escapeExpression=u.escapeExpression,t.VM=l,t.template=function(e){return l.template(e,t)},t}var p=h();p.create=h,c.default(p),p.default=p,e.default=p,t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0;var r=n(12);e.default=function(t){t.registerHelper("blockHelperMissing",(function(e,n){var i=n.inverse,o=n.fn;if(!0===e)return o(this);if(!1===e||null==e)return i(this);if(r.isArray(e))return e.length>0?(n.ids&&(n.ids=[n.name]),t.helpers.each(e,n)):i(this);if(n.data&&n.ids){var a=r.createFrame(n.data);a.contextPath=r.appendContextPath(n.data.contextPath,n.name),n={data:a}}return o(e,n)}))},t.exports=e.default},function(t,e,n){"use strict";(function(r){e.__esModule=!0;var i,o=n(12),a=n(15),s=(i=a)&&i.__esModule?i:{default:i};e.default=function(t){t.registerHelper("each",(function(t,e){if(!e)throw new s.default("Must pass iterator to #each");var n,i=e.fn,a=e.inverse,u=0,l="",c=void 0,h=void 0;function p(e,n,r){c&&(c.key=e,c.index=n,c.first=0===n,c.last=!!r,h&&(c.contextPath=h+e)),l+=i(t[e],{data:c,blockParams:o.blockParams([t[e],e],[h+e,null])})}if(e.data&&e.ids&&(h=o.appendContextPath(e.data.contextPath,e.ids[0])+"."),o.isFunction(t)&&(t=t.call(this)),e.data&&(c=o.createFrame(e.data)),t&&"object"==typeof t)if(o.isArray(t))for(var f=t.length;u<f;u++)u in t&&p(u,u,u===t.length-1);else if(r.Symbol&&t[r.Symbol.iterator]){for(var _=[],d=t[r.Symbol.iterator](),v=d.next();!v.done;v=d.next())_.push(v.value);for(f=(t=_).length;u<f;u++)p(u,u,u===t.length-1)}else n=void 0,Object.keys(t).forEach((function(t){void 0!==n&&p(n,u-1),n=t,u++})),void 0!==n&&p(n,u-1,!0);return 0===u&&(l=a(this)),l}))},t.exports=e.default}).call(this,n(16))},function(t,e,n){"use strict";e.__esModule=!0;var r,i=n(15),o=(r=i)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("helperMissing",(function(){if(1!==arguments.length)throw new o.default('Missing helper: "'+arguments[arguments.length-1].name+'"')}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0;var r,i=n(12),o=n(15),a=(r=o)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("if",(function(t,e){if(2!=arguments.length)throw new a.default("#if requires exactly one argument");return i.isFunction(t)&&(t=t.call(this)),!e.hash.includeZero&&!t||i.isEmpty(t)?e.inverse(this):e.fn(this)})),t.registerHelper("unless",(function(e,n){if(2!=arguments.length)throw new a.default("#unless requires exactly one argument");return t.helpers.if.call(this,e,{fn:n.inverse,inverse:n.fn,hash:n.hash})}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t){t.registerHelper("log",(function(){for(var e=[void 0],n=arguments[arguments.length-1],r=0;r<arguments.length-1;r++)e.push(arguments[r]);var i=1;null!=n.hash.level?i=n.hash.level:n.data&&null!=n.data.level&&(i=n.data.level),e[0]=i,t.log.apply(t,e)}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t){t.registerHelper("lookup",(function(t,e,n){return t?n.lookupProperty(t,e):t}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0;var r,i=n(12),o=n(15),a=(r=o)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("with",(function(t,e){if(2!=arguments.length)throw new a.default("#with requires exactly one argument");i.isFunction(t)&&(t=t.call(this));var n=e.fn;if(i.isEmpty(t))return e.inverse(this);var r=e.data;return e.data&&e.ids&&((r=i.createFrame(e.data)).contextPath=i.appendContextPath(e.data.contextPath,e.ids[0])),n(t,{data:r,blockParams:i.blockParams([t],[r&&r.contextPath])})}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.registerDefaultDecorators=function(t){o.default(t)};var r,i=n(50),o=(r=i)&&r.__esModule?r:{default:r}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(12);e.default=function(t){t.registerDecorator("inline",(function(t,e,n,i){var o=t;return e.partials||(e.partials={},o=function(i,o){var a=n.partials;n.partials=r.extend({},a,e.partials);var s=t(i,o);return n.partials=a,s}),e.partials[i.args[0]]=i.fn,o}))},t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.createNewLookupObject=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];return r.extend.apply(void 0,[Object.create(null)].concat(e))};var r=n(12)},function(t,e,n){"use strict";function r(t){this.string=t}e.__esModule=!0,r.prototype.toString=r.prototype.toHTML=function(){return""+this.string},e.default=r,t.exports=e.default},function(t,e,n){"use strict";e.__esModule=!0,e.checkRevision=function(t){var e=t&&t[0]||1,n=s.COMPILER_REVISION;if(e>=s.LAST_COMPATIBLE_COMPILER_REVISION&&e<=s.COMPILER_REVISION)return;if(e<s.LAST_COMPATIBLE_COMPILER_REVISION){var r=s.REVISION_CHANGES[n],i=s.REVISION_CHANGES[e];throw new a.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+r+") or downgrade your runtime to an older version ("+i+").")}throw new a.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+t[1]+").")},e.template=function(t,e){if(!e)throw new a.default("No environment passed to template");if(!t||!t.main)throw new a.default("Unknown template object: "+typeof t);t.main.decorator=t.main_d,e.VM.checkRevision(t.compiler);var n=t.compiler&&7===t.compiler[0];var r={strict:function(t,e,n){if(!t||!(e in t))throw new a.default('"'+e+'" not defined in '+t,{loc:n});return t[e]},lookupProperty:function(t,e){var n=t[e];return null==n||Object.prototype.hasOwnProperty.call(t,e)||c.resultIsAllowed(n,r.protoAccessControl,e)?n:void 0},lookup:function(t,e){for(var n=t.length,i=0;i<n;i++){if(null!=(t[i]&&r.lookupProperty(t[i],e)))return t[i][e]}},lambda:function(t,e){return"function"==typeof t?t.call(e):t},escapeExpression:i.escapeExpression,invokePartial:function(n,r,o){o.hash&&(r=i.extend({},r,o.hash),o.ids&&(o.ids[0]=!0)),n=e.VM.resolvePartial.call(this,n,r,o);var s=i.extend({},o,{hooks:this.hooks,protoAccessControl:this.protoAccessControl}),u=e.VM.invokePartial.call(this,n,r,s);if(null==u&&e.compile&&(o.partials[o.name]=e.compile(n,t.compilerOptions,e),u=o.partials[o.name](r,s)),null!=u){if(o.indent){for(var l=u.split("\n"),c=0,h=l.length;c<h&&(l[c]||c+1!==h);c++)l[c]=o.indent+l[c];u=l.join("\n")}return u}throw new a.default("The partial "+o.name+" could not be compiled when running in runtime-only mode")},fn:function(e){var n=t[e];return n.decorator=t[e+"_d"],n},programs:[],program:function(t,e,n,r,i){var o=this.programs[t],a=this.fn(t);return e||i||r||n?o=h(this,t,a,e,n,r,i):o||(o=this.programs[t]=h(this,t,a)),o},data:function(t,e){for(;t&&e--;)t=t._parent;return t},mergeIfNeeded:function(t,e){var n=t||e;return t&&e&&t!==e&&(n=i.extend({},e,t)),n},nullContext:Object.seal({}),noop:e.VM.noop,compilerInfo:t.compiler};function o(e){var n=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],i=n.data;o._setup(n),!n.partial&&t.useData&&(i=f(e,i));var a=void 0,s=t.useBlockParams?[]:void 0;function u(e){return""+t.main(r,e,r.helpers,r.partials,i,s,a)}return t.useDepths&&(a=n.depths?e!=n.depths[0]?[e].concat(n.depths):n.depths:[e]),(u=_(t.main,u,r,n.depths||[],i,s))(e,n)}return o.isTop=!0,o._setup=function(o){if(o.partial)r.protoAccessControl=o.protoAccessControl,r.helpers=o.helpers,r.partials=o.partials,r.decorators=o.decorators,r.hooks=o.hooks;else{var a=i.extend({},e.helpers,o.helpers);!function(t,e){Object.keys(t).forEach((function(n){var r=t[n];t[n]=function(t,e){var n=e.lookupProperty;return l.wrapHelper(t,(function(t){return i.extend({lookupProperty:n},t)}))}(r,e)}))}(a,r),r.helpers=a,t.usePartial&&(r.partials=r.mergeIfNeeded(o.partials,e.partials)),(t.usePartial||t.useDecorators)&&(r.decorators=i.extend({},e.decorators,o.decorators)),r.hooks={},r.protoAccessControl=c.createProtoAccessControl(o);var s=o.allowCallsToHelperMissing||n;u.moveHelperToHooks(r,"helperMissing",s),u.moveHelperToHooks(r,"blockHelperMissing",s)}},o._child=function(e,n,i,o){if(t.useBlockParams&&!i)throw new a.default("must pass block params");if(t.useDepths&&!o)throw new a.default("must pass parent depths");return h(r,e,t[e],n,0,i,o)},o},e.wrapProgram=h,e.resolvePartial=function(t,e,n){t?t.call||n.name||(n.name=t,t=n.partials[t]):t="@partial-block"===n.name?n.data["partial-block"]:n.partials[n.name];return t},e.invokePartial=function(t,e,n){var r=n.data&&n.data["partial-block"];n.partial=!0,n.ids&&(n.data.contextPath=n.ids[0]||n.data.contextPath);var o=void 0;n.fn&&n.fn!==p&&function(){n.data=s.createFrame(n.data);var t=n.fn;o=n.data["partial-block"]=function(e){var n=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return n.data=s.createFrame(n.data),n.data["partial-block"]=r,t(e,n)},t.partials&&(n.partials=i.extend({},n.partials,t.partials))}();void 0===t&&o&&(t=o);if(void 0===t)throw new a.default("The partial "+n.name+" could not be found");if(t instanceof Function)return t(e,n)},e.noop=p;var r,i=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e.default=t,e}(n(12)),o=n(15),a=(r=o)&&r.__esModule?r:{default:r},s=n(22),u=n(23),l=n(54),c=n(25);function h(t,e,n,r,i,o,a){function s(e){var i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],s=a;return!a||e==a[0]||e===t.nullContext&&null===a[0]||(s=[e].concat(a)),n(t,e,t.helpers,t.partials,i.data||r,o&&[i.blockParams].concat(o),s)}return(s=_(n,s,t,a,r,o)).program=e,s.depth=a?a.length:0,s.blockParams=i||0,s}function p(){return""}function f(t,e){return e&&"root"in e||((e=e?s.createFrame(e):{}).root=t),e}function _(t,e,n,r,o,a){if(t.decorator){var s={};e=t.decorator(e,s,n,r&&r[0],o,a,r),i.extend(e,s)}return e}},function(t,e,n){"use strict";e.__esModule=!0,e.wrapHelper=function(t,e){if("function"!=typeof t)return t;return function(){var n=arguments[arguments.length-1];return arguments[arguments.length-1]=e(n),t.apply(this,arguments)}}},function(t,e,n){"use strict";(function(n){e.__esModule=!0,e.default=function(t){var e=void 0!==n?n:window,r=e.Handlebars;t.noConflict=function(){return e.Handlebars===t&&(e.Handlebars=r),t}},t.exports=e.default}).call(this,n(16))},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){return" <li>"+t.escapeExpression(t.lambda(e,e))+"</li> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=null!=e?e:t.nullContext||{},l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return'<div id="'+s(a(null!=e?l(e,"id"):e,e))+'" '+(null!=(o=l(n,"class").call(u,"select",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(u,"head",{name:"class",hash:{},data:i}))?o:"")+"> "+s(a(null!=e?l(e,"desc"):e,e))+" <span "+(null!=(o=l(n,"class").call(u,"val",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(null!=e?l(e,"val"):e,e))+'</span></div><ul data-id="'+s(a(null!=e?l(e,"id"):e,e))+'"> '+(null!=(o=l(n,"each").call(u,null!=e?l(e,"selections"):e,{name:"each",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" </ul></div>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=null!=e?e:t.nullContext||{},l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return'<div id="'+s(a(null!=e?l(e,"id"):e,e))+'" '+(null!=(o=l(n,"class").call(u,"range",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(u,"head",{name:"class",hash:{},data:i}))?o:"")+"> "+s(a(null!=e?l(e,"desc"):e,e))+" <span "+(null!=(o=l(n,"class").call(u,"val",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(null!=e?l(e,"val"):e,e))+"</span></div><div "+(null!=(o=l(n,"class").call(u,"input-container",{name:"class",hash:{},data:i}))?o:"")+' data-id="'+s(a(null!=e?l(e,"id"):e,e))+'"><div '+(null!=(o=l(n,"class").call(u,"range-track",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(u,"range-track-bar",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(u,"range-track-progress",{name:"class",hash:{},data:i}))?o:"")+' style="width: '+s(a(null!=e?l(e,"progress"):e,e))+'%"></div></div></div><input type="range" min="'+s(a(null!=e?l(e,"min"):e,e))+'" max="'+s(a(null!=e?l(e,"max"):e,e))+'" step="'+s(a(null!=e?l(e,"step"):e,e))+'" value="'+s(a(null!=e?l(e,"val"):e,e))+'"></div></div>'},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){return' <li style="background: '+t.escapeExpression(t.lambda(e,e))+'"></li> '},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=null!=e?e:t.nullContext||{},l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return'<div id="'+s(a(null!=e?l(e,"id"):e,e))+'" '+(null!=(o=l(n,"class").call(u,"color",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(u,"head",{name:"class",hash:{},data:i}))?o:"")+"> "+s(a(null!=e?l(e,"desc"):e,e))+" <span "+(null!=(o=l(n,"class").call(u,"val",{name:"class",hash:{},data:i}))?o:"")+' style="background-color: '+s(a(null!=e?l(e,"val"):e,e))+'"></span></div><ul data-id="'+s(a(null!=e?l(e,"id"):e,e))+'"> '+(null!=(o=l(n,"each").call(u,null!=e?l(e,"colors"):e,{name:"each",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" </ul></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"._container ._entry-btn{$w:40px;$h:40px;$d:flex;$b:#000;opacity:.3;$bra:10px;$po:relative;$z:1000;$tr:opacity .3s;$c:#fff;$fs:25px;align-items:center;justify-content:center}._container ._entry-btn._active,._container ._entry-btn:active{opacity:.8}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"entry-btn",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-tool",{name:"class",hash:{},data:i}))?o:"")+"></span></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"._container ._nav-bar-container{$po:absolute;$w:100%;$h:40px;$l:0;$t:0;$z:100}._container ._nav-bar-container ._nav-bar{$ox:auto;$wos:touch;$bt:1px solid var(--border);$bb:1px solid var(--border);$w:100%;$h:100%;$b:var(--darker-background);$fs:0;$ws:nowrap}._container ._nav-bar-container ._nav-bar-item{$cu:pointer;$d:inline-block;$h:38px;$lh:38px;$p:0 10px;$c:var(--foreground);$fs:12px;$ta:center;$tt:capitalize;$tr:all .3s}._container ._nav-bar-container ._nav-bar-item:active{$b:var(--highlight);$c:var(--select-foreground)}._container ._nav-bar-container ._nav-bar-item._active{$b:var(--highlight);$c:var(--select-foreground)}._container ._nav-bar-container ._bottom-bar{$tr:left .3s,width .3s;$h:1px;$b:var(--accent);$po:absolute;bottom:0;$l:0}",""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,"._dev-tools{$po:absolute;$w:100%;$h:100%;$l:0;bottom:0;$b:var(--background);$z:500;$d:none;$pt:40px!important;opacity:0;$tr:opacity .3s,height .3s}._dev-tools ._tools{$o:auto;$wos:touch;$h:100%;$w:100%;$po:relative}._dev-tools ._tools ._tool{$po:absolute;$w:100%;$h:100%;$l:0;$t:0;$o:hidden;$d:none}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"dev-tools",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"nav-bar-container",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"nav-bar",{name:"class",hash:{},data:i}))?o:"")+'></div><div class="eruda-bottom-bar"></div></div><div '+(null!=(o=s(n,"class").call(a,"tools",{name:"class",hash:{},data:i}))?o:"")+"></div></div>"},useData:!0})},function(t,e){t.exports=function(t){if(Array.isArray(t))return t}},function(t,e){t.exports=function(t,e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t)){var n=[],r=!0,i=!1,o=void 0;try{for(var a,s=t[Symbol.iterator]();!(r=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(t){i=!0,o=t}finally{try{r||null==s.return||s.return()}finally{if(i)throw o}}return n}}},function(t,e,n){var r=n(67);t.exports=function(t,e){if(t){if("string"==typeof t)return r(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(t,e):void 0}}},function(t,e){t.exports=function(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}},function(t,e,n){(e=n(8)(!1)).push([t.i,"._container ._abstract ._key{$c:var(--var-color)}._container ._abstract ._number{$c:var(--number-color)}._container ._abstract ._null{$c:var(--operator-color)}._container ._abstract ._string{$c:var(--string-color)}._container ._abstract ._boolean{$c:var(--keyword-color)}._container ._abstract ._special{$c:var(--operator-color)}",""]),t.exports=e},function(t,e,n){var r,i,o;o=function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=18)}([,,function(t,e,n){"use strict";function r(t){this.__parent=t,this.__character_count=0,this.__indent_count=-1,this.__alignment_count=0,this.__wrap_point_index=0,this.__wrap_point_character_count=0,this.__wrap_point_indent_count=-1,this.__wrap_point_alignment_count=0,this.__items=[]}function i(t,e){this.__cache=[""],this.__indent_size=t.indent_size,this.__indent_string=t.indent_char,t.indent_with_tabs||(this.__indent_string=new Array(t.indent_size+1).join(t.indent_char)),e=e||"",t.indent_level>0&&(e=new Array(t.indent_level+1).join(this.__indent_string)),this.__base_string=e,this.__base_string_length=e.length}function o(t,e){this.__indent_cache=new i(t,e),this.raw=!1,this._end_with_newline=t.end_with_newline,this.indent_size=t.indent_size,this.wrap_line_length=t.wrap_line_length,this.indent_empty_lines=t.indent_empty_lines,this.__lines=[],this.previous_line=null,this.current_line=null,this.next_line=new r(this),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1,this.__add_outputline()}r.prototype.clone_empty=function(){var t=new r(this.__parent);return t.set_indent(this.__indent_count,this.__alignment_count),t},r.prototype.item=function(t){return t<0?this.__items[this.__items.length+t]:this.__items[t]},r.prototype.has_match=function(t){for(var e=this.__items.length-1;e>=0;e--)if(this.__items[e].match(t))return!0;return!1},r.prototype.set_indent=function(t,e){this.is_empty()&&(this.__indent_count=t||0,this.__alignment_count=e||0,this.__character_count=this.__parent.get_indent_size(this.__indent_count,this.__alignment_count))},r.prototype._set_wrap_point=function(){this.__parent.wrap_line_length&&(this.__wrap_point_index=this.__items.length,this.__wrap_point_character_count=this.__character_count,this.__wrap_point_indent_count=this.__parent.next_line.__indent_count,this.__wrap_point_alignment_count=this.__parent.next_line.__alignment_count)},r.prototype._should_wrap=function(){return this.__wrap_point_index&&this.__character_count>this.__parent.wrap_line_length&&this.__wrap_point_character_count>this.__parent.next_line.__character_count},r.prototype._allow_wrap=function(){if(this._should_wrap()){this.__parent.add_new_line();var t=this.__parent.current_line;return t.set_indent(this.__wrap_point_indent_count,this.__wrap_point_alignment_count),t.__items=this.__items.slice(this.__wrap_point_index),this.__items=this.__items.slice(0,this.__wrap_point_index),t.__character_count+=this.__character_count-this.__wrap_point_character_count,this.__character_count=this.__wrap_point_character_count," "===t.__items[0]&&(t.__items.splice(0,1),t.__character_count-=1),!0}return!1},r.prototype.is_empty=function(){return 0===this.__items.length},r.prototype.last=function(){return this.is_empty()?null:this.__items[this.__items.length-1]},r.prototype.push=function(t){this.__items.push(t);var e=t.lastIndexOf("\n");-1!==e?this.__character_count=t.length-e:this.__character_count+=t.length},r.prototype.pop=function(){var t=null;return this.is_empty()||(t=this.__items.pop(),this.__character_count-=t.length),t},r.prototype._remove_indent=function(){this.__indent_count>0&&(this.__indent_count-=1,this.__character_count-=this.__parent.indent_size)},r.prototype._remove_wrap_indent=function(){this.__wrap_point_indent_count>0&&(this.__wrap_point_indent_count-=1)},r.prototype.trim=function(){for(;" "===this.last();)this.__items.pop(),this.__character_count-=1},r.prototype.toString=function(){var t="";return this.is_empty()?this.__parent.indent_empty_lines&&(t=this.__parent.get_indent_string(this.__indent_count)):(t=this.__parent.get_indent_string(this.__indent_count,this.__alignment_count),t+=this.__items.join("")),t},i.prototype.get_indent_size=function(t,e){var n=this.__base_string_length;return e=e||0,t<0&&(n=0),n+=t*this.__indent_size,n+=e},i.prototype.get_indent_string=function(t,e){var n=this.__base_string;return e=e||0,t<0&&(t=0,n=""),e+=t*this.__indent_size,this.__ensure_cache(e),n+=this.__cache[e]},i.prototype.__ensure_cache=function(t){for(;t>=this.__cache.length;)this.__add_column()},i.prototype.__add_column=function(){var t=this.__cache.length,e=0,n="";this.__indent_size&&t>=this.__indent_size&&(t-=(e=Math.floor(t/this.__indent_size))*this.__indent_size,n=new Array(e+1).join(this.__indent_string)),t&&(n+=new Array(t+1).join(" ")),this.__cache.push(n)},o.prototype.__add_outputline=function(){this.previous_line=this.current_line,this.current_line=this.next_line.clone_empty(),this.__lines.push(this.current_line)},o.prototype.get_line_number=function(){return this.__lines.length},o.prototype.get_indent_string=function(t,e){return this.__indent_cache.get_indent_string(t,e)},o.prototype.get_indent_size=function(t,e){return this.__indent_cache.get_indent_size(t,e)},o.prototype.is_empty=function(){return!this.previous_line&&this.current_line.is_empty()},o.prototype.add_new_line=function(t){return!(this.is_empty()||!t&&this.just_added_newline()||(this.raw||this.__add_outputline(),0))},o.prototype.get_code=function(t){this.trim(!0);var e=this.current_line.pop();e&&("\n"===e[e.length-1]&&(e=e.replace(/\n+$/g,"")),this.current_line.push(e)),this._end_with_newline&&this.__add_outputline();var n=this.__lines.join("\n");return"\n"!==t&&(n=n.replace(/[\n]/g,t)),n},o.prototype.set_wrap_point=function(){this.current_line._set_wrap_point()},o.prototype.set_indent=function(t,e){return t=t||0,e=e||0,this.next_line.set_indent(t,e),this.__lines.length>1?(this.current_line.set_indent(t,e),!0):(this.current_line.set_indent(),!1)},o.prototype.add_raw_token=function(t){for(var e=0;e<t.newlines;e++)this.__add_outputline();this.current_line.set_indent(-1),this.current_line.push(t.whitespace_before),this.current_line.push(t.text),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=!1},o.prototype.add_token=function(t){this.__add_space_before_token(),this.current_line.push(t),this.space_before_token=!1,this.non_breaking_space=!1,this.previous_token_wrapped=this.current_line._allow_wrap()},o.prototype.__add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&(this.non_breaking_space||this.set_wrap_point(),this.current_line.push(" "))},o.prototype.remove_indent=function(t){for(var e=this.__lines.length;t<e;)this.__lines[t]._remove_indent(),t++;this.current_line._remove_wrap_indent()},o.prototype.trim=function(t){for(t=void 0!==t&&t,this.current_line.trim();t&&this.__lines.length>1&&this.current_line.is_empty();)this.__lines.pop(),this.current_line=this.__lines[this.__lines.length-1],this.current_line.trim();this.previous_line=this.__lines.length>1?this.__lines[this.__lines.length-2]:null},o.prototype.just_added_newline=function(){return this.current_line.is_empty()},o.prototype.just_added_blankline=function(){return this.is_empty()||this.current_line.is_empty()&&this.previous_line.is_empty()},o.prototype.ensure_empty_line_above=function(t,e){for(var n=this.__lines.length-2;n>=0;){var i=this.__lines[n];if(i.is_empty())break;if(0!==i.item(0).indexOf(t)&&i.item(-1)!==e){this.__lines.splice(n+1,0,new r(this)),this.previous_line=this.__lines[this.__lines.length-2];break}n--}},t.exports.Output=o},function(t,e,n){"use strict";t.exports.Token=function(t,e,n,r){this.type=t,this.text=e,this.comments_before=null,this.newlines=n||0,this.whitespace_before=r||"",this.parent=null,this.next=null,this.previous=null,this.opened=null,this.closed=null,this.directives=null}},,,function(t,e,n){"use strict";function r(t,e){this.raw_options=i(t,e),this.disabled=this._get_boolean("disabled"),this.eol=this._get_characters("eol","auto"),this.end_with_newline=this._get_boolean("end_with_newline"),this.indent_size=this._get_number("indent_size",4),this.indent_char=this._get_characters("indent_char"," "),this.indent_level=this._get_number("indent_level"),this.preserve_newlines=this._get_boolean("preserve_newlines",!0),this.max_preserve_newlines=this._get_number("max_preserve_newlines",32786),this.preserve_newlines||(this.max_preserve_newlines=0),this.indent_with_tabs=this._get_boolean("indent_with_tabs","\t"===this.indent_char),this.indent_with_tabs&&(this.indent_char="\t",1===this.indent_size&&(this.indent_size=4)),this.wrap_line_length=this._get_number("wrap_line_length",this._get_number("max_char")),this.indent_empty_lines=this._get_boolean("indent_empty_lines"),this.templating=this._get_selection_list("templating",["auto","none","django","erb","handlebars","php"],["auto"])}function i(t,e){var n,r={};for(n in t=o(t))n!==e&&(r[n]=t[n]);if(e&&t[e])for(n in t[e])r[n]=t[e][n];return r}function o(t){var e,n={};for(e in t)n[e.replace(/-/g,"_")]=t[e];return n}r.prototype._get_array=function(t,e){var n=this.raw_options[t],r=e||[];return"object"==typeof n?null!==n&&"function"==typeof n.concat&&(r=n.concat()):"string"==typeof n&&(r=n.split(/[^a-zA-Z0-9_\/\-]+/)),r},r.prototype._get_boolean=function(t,e){var n=this.raw_options[t];return void 0===n?!!e:!!n},r.prototype._get_characters=function(t,e){var n=this.raw_options[t],r=e||"";return"string"==typeof n&&(r=n.replace(/\\r/,"\r").replace(/\\n/,"\n").replace(/\\t/,"\t")),r},r.prototype._get_number=function(t,e){var n=this.raw_options[t];e=parseInt(e,10),isNaN(e)&&(e=0);var r=parseInt(n,10);return isNaN(r)&&(r=e),r},r.prototype._get_selection=function(t,e,n){var r=this._get_selection_list(t,e,n);if(1!==r.length)throw new Error("Invalid Option Value: The option '"+t+"' can only be one of the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r[0]},r.prototype._get_selection_list=function(t,e,n){if(!e||0===e.length)throw new Error("Selection list cannot be empty.");if(n=n||[e[0]],!this._is_valid_selection(n,e))throw new Error("Invalid Default Value!");var r=this._get_array(t,n);if(!this._is_valid_selection(r,e))throw new Error("Invalid Option Value: The option '"+t+"' can contain only the following values:\n"+e+"\nYou passed in: '"+this.raw_options[t]+"'");return r},r.prototype._is_valid_selection=function(t,e){return t.length&&e.length&&!t.some((function(t){return-1===e.indexOf(t)}))},t.exports.Options=r,t.exports.normalizeOpts=o,t.exports.mergeOpts=i},,function(t,e,n){"use strict";var r=RegExp.prototype.hasOwnProperty("sticky");function i(t){this.__input=t||"",this.__input_length=this.__input.length,this.__position=0}i.prototype.restart=function(){this.__position=0},i.prototype.back=function(){this.__position>0&&(this.__position-=1)},i.prototype.hasNext=function(){return this.__position<this.__input_length},i.prototype.next=function(){var t=null;return this.hasNext()&&(t=this.__input.charAt(this.__position),this.__position+=1),t},i.prototype.peek=function(t){var e=null;return t=t||0,(t+=this.__position)>=0&&t<this.__input_length&&(e=this.__input.charAt(t)),e},i.prototype.__match=function(t,e){t.lastIndex=e;var n=t.exec(this.__input);return!n||r&&t.sticky||n.index!==e&&(n=null),n},i.prototype.test=function(t,e){return e=e||0,(e+=this.__position)>=0&&e<this.__input_length&&!!this.__match(t,e)},i.prototype.testChar=function(t,e){var n=this.peek(e);return t.lastIndex=0,null!==n&&t.test(n)},i.prototype.match=function(t){var e=this.__match(t,this.__position);return e?this.__position+=e[0].length:e=null,e},i.prototype.read=function(t,e,n){var r,i="";return t&&(r=this.match(t))&&(i+=r[0]),!e||!r&&t||(i+=this.readUntil(e,n)),i},i.prototype.readUntil=function(t,e){var n,r=this.__position;t.lastIndex=this.__position;var i=t.exec(this.__input);return i?(r=i.index,e&&(r+=i[0].length)):r=this.__input_length,n=this.__input.substring(this.__position,r),this.__position=r,n},i.prototype.readUntilAfter=function(t){return this.readUntil(t,!0)},i.prototype.get_regexp=function(t,e){var n=null,i="g";return e&&r&&(i="y"),"string"==typeof t&&""!==t?n=new RegExp(t,i):t&&(n=new RegExp(t.source,i)),n},i.prototype.get_literal_regexp=function(t){return RegExp(t.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"))},i.prototype.peekUntilAfter=function(t){var e=this.__position,n=this.readUntilAfter(t);return this.__position=e,n},i.prototype.lookBack=function(t){var e=this.__position-1;return e>=t.length&&this.__input.substring(e-t.length,e).toLowerCase()===t},t.exports.InputScanner=i},function(t,e,n){"use strict";var r=n(8).InputScanner,i=n(3).Token,o=n(10).TokenStream,a=n(11).WhitespacePattern,s={START:"TK_START",RAW:"TK_RAW",EOF:"TK_EOF"},u=function(t,e){this._input=new r(t),this._options=e||{},this.__tokens=null,this._patterns={},this._patterns.whitespace=new a(this._input)};u.prototype.tokenize=function(){var t;this._input.restart(),this.__tokens=new o,this._reset();for(var e=new i(s.START,""),n=null,r=[],a=new o;e.type!==s.EOF;){for(t=this._get_next_token(e,n);this._is_comment(t);)a.add(t),t=this._get_next_token(e,n);a.isEmpty()||(t.comments_before=a,a=new o),t.parent=n,this._is_opening(t)?(r.push(n),n=t):n&&this._is_closing(t,n)&&(t.opened=n,n.closed=t,n=r.pop(),t.parent=n),t.previous=e,e.next=t,this.__tokens.add(t),e=t}return this.__tokens},u.prototype._is_first_token=function(){return this.__tokens.isEmpty()},u.prototype._reset=function(){},u.prototype._get_next_token=function(t,e){this._readWhitespace();var n=this._input.read(/.+/g);return n?this._create_token(s.RAW,n):this._create_token(s.EOF,"")},u.prototype._is_comment=function(t){return!1},u.prototype._is_opening=function(t){return!1},u.prototype._is_closing=function(t,e){return!1},u.prototype._create_token=function(t,e){return new i(t,e,this._patterns.whitespace.newline_count,this._patterns.whitespace.whitespace_before_token)},u.prototype._readWhitespace=function(){return this._patterns.whitespace.read()},t.exports.Tokenizer=u,t.exports.TOKEN=s},function(t,e,n){"use strict";function r(t){this.__tokens=[],this.__tokens_length=this.__tokens.length,this.__position=0,this.__parent_token=t}r.prototype.restart=function(){this.__position=0},r.prototype.isEmpty=function(){return 0===this.__tokens_length},r.prototype.hasNext=function(){return this.__position<this.__tokens_length},r.prototype.next=function(){var t=null;return this.hasNext()&&(t=this.__tokens[this.__position],this.__position+=1),t},r.prototype.peek=function(t){var e=null;return t=t||0,(t+=this.__position)>=0&&t<this.__tokens_length&&(e=this.__tokens[t]),e},r.prototype.add=function(t){this.__parent_token&&(t.parent=this.__parent_token),this.__tokens.push(t),this.__tokens_length+=1},t.exports.TokenStream=r},function(t,e,n){"use strict";var r=n(12).Pattern;function i(t,e){r.call(this,t,e),e?this._line_regexp=this._input.get_regexp(e._line_regexp):this.__set_whitespace_patterns("",""),this.newline_count=0,this.whitespace_before_token=""}i.prototype=new r,i.prototype.__set_whitespace_patterns=function(t,e){t+="\\t ",e+="\\n\\r",this._match_pattern=this._input.get_regexp("["+t+e+"]+",!0),this._newline_regexp=this._input.get_regexp("\\r\\n|["+e+"]")},i.prototype.read=function(){this.newline_count=0,this.whitespace_before_token="";var t=this._input.read(this._match_pattern);if(" "===t)this.whitespace_before_token=" ";else if(t){var e=this.__split(this._newline_regexp,t);this.newline_count=e.length-1,this.whitespace_before_token=e[this.newline_count]}return t},i.prototype.matching=function(t,e){var n=this._create();return n.__set_whitespace_patterns(t,e),n._update(),n},i.prototype._create=function(){return new i(this._input,this)},i.prototype.__split=function(t,e){t.lastIndex=0;for(var n=0,r=[],i=t.exec(e);i;)r.push(e.substring(n,i.index)),n=i.index+i[0].length,i=t.exec(e);return n<e.length?r.push(e.substring(n,e.length)):r.push(""),r},t.exports.WhitespacePattern=i},function(t,e,n){"use strict";function r(t,e){this._input=t,this._starting_pattern=null,this._match_pattern=null,this._until_pattern=null,this._until_after=!1,e&&(this._starting_pattern=this._input.get_regexp(e._starting_pattern,!0),this._match_pattern=this._input.get_regexp(e._match_pattern,!0),this._until_pattern=this._input.get_regexp(e._until_pattern),this._until_after=e._until_after)}r.prototype.read=function(){var t=this._input.read(this._starting_pattern);return this._starting_pattern&&!t||(t+=this._input.read(this._match_pattern,this._until_pattern,this._until_after)),t},r.prototype.read_match=function(){return this._input.match(this._match_pattern)},r.prototype.until_after=function(t){var e=this._create();return e._until_after=!0,e._until_pattern=this._input.get_regexp(t),e._update(),e},r.prototype.until=function(t){var e=this._create();return e._until_after=!1,e._until_pattern=this._input.get_regexp(t),e._update(),e},r.prototype.starting_with=function(t){var e=this._create();return e._starting_pattern=this._input.get_regexp(t,!0),e._update(),e},r.prototype.matching=function(t){var e=this._create();return e._match_pattern=this._input.get_regexp(t,!0),e._update(),e},r.prototype._create=function(){return new r(this._input,this)},r.prototype._update=function(){},t.exports.Pattern=r},function(t,e,n){"use strict";function r(t,e){t="string"==typeof t?t:t.source,e="string"==typeof e?e:e.source,this.__directives_block_pattern=new RegExp(t+/ beautify( \w+[:]\w+)+ /.source+e,"g"),this.__directive_pattern=/ (\w+)[:](\w+)/g,this.__directives_end_ignore_pattern=new RegExp(t+/\sbeautify\signore:end\s/.source+e,"g")}r.prototype.get_directives=function(t){if(!t.match(this.__directives_block_pattern))return null;var e={};this.__directive_pattern.lastIndex=0;for(var n=this.__directive_pattern.exec(t);n;)e[n[1]]=n[2],n=this.__directive_pattern.exec(t);return e},r.prototype.readIgnored=function(t){return t.readUntilAfter(this.__directives_end_ignore_pattern)},t.exports.Directives=r},function(t,e,n){"use strict";var r=n(12).Pattern,i={django:!1,erb:!1,handlebars:!1,php:!1};function o(t,e){r.call(this,t,e),this.__template_pattern=null,this._disabled=Object.assign({},i),this._excluded=Object.assign({},i),e&&(this.__template_pattern=this._input.get_regexp(e.__template_pattern),this._excluded=Object.assign(this._excluded,e._excluded),this._disabled=Object.assign(this._disabled,e._disabled));var n=new r(t);this.__patterns={handlebars_comment:n.starting_with(/{{!--/).until_after(/--}}/),handlebars_unescaped:n.starting_with(/{{{/).until_after(/}}}/),handlebars:n.starting_with(/{{/).until_after(/}}/),php:n.starting_with(/<\?(?:[=]|php)/).until_after(/\?>/),erb:n.starting_with(/<%[^%]/).until_after(/[^%]%>/),django:n.starting_with(/{%/).until_after(/%}/),django_value:n.starting_with(/{{/).until_after(/}}/),django_comment:n.starting_with(/{#/).until_after(/#}/)}}o.prototype=new r,o.prototype._create=function(){return new o(this._input,this)},o.prototype._update=function(){this.__set_templated_pattern()},o.prototype.disable=function(t){var e=this._create();return e._disabled[t]=!0,e._update(),e},o.prototype.read_options=function(t){var e=this._create();for(var n in i)e._disabled[n]=-1===t.templating.indexOf(n);return e._update(),e},o.prototype.exclude=function(t){var e=this._create();return e._excluded[t]=!0,e._update(),e},o.prototype.read=function(){var t="";t=this._match_pattern?this._input.read(this._starting_pattern):this._input.read(this._starting_pattern,this.__template_pattern);for(var e=this._read_template();e;)this._match_pattern?e+=this._input.read(this._match_pattern):e+=this._input.readUntil(this.__template_pattern),t+=e,e=this._read_template();return this._until_after&&(t+=this._input.readUntilAfter(this._until_pattern)),t},o.prototype.__set_templated_pattern=function(){var t=[];this._disabled.php||t.push(this.__patterns.php._starting_pattern.source),this._disabled.handlebars||t.push(this.__patterns.handlebars._starting_pattern.source),this._disabled.erb||t.push(this.__patterns.erb._starting_pattern.source),this._disabled.django||(t.push(this.__patterns.django._starting_pattern.source),t.push(this.__patterns.django_value._starting_pattern.source),t.push(this.__patterns.django_comment._starting_pattern.source)),this._until_pattern&&t.push(this._until_pattern.source),this.__template_pattern=this._input.get_regexp("(?:"+t.join("|")+")")},o.prototype._read_template=function(){var t="",e=this._input.peek();if("<"===e){var n=this._input.peek(1);this._disabled.php||this._excluded.php||"?"!==n||(t=t||this.__patterns.php.read()),this._disabled.erb||this._excluded.erb||"%"!==n||(t=t||this.__patterns.erb.read())}else"{"===e&&(this._disabled.handlebars||this._excluded.handlebars||(t=(t=(t=t||this.__patterns.handlebars_comment.read())||this.__patterns.handlebars_unescaped.read())||this.__patterns.handlebars.read()),this._disabled.django||(this._excluded.django||this._excluded.handlebars||(t=t||this.__patterns.django_value.read()),this._excluded.django||(t=(t=t||this.__patterns.django_comment.read())||this.__patterns.django.read())));return t},t.exports.TemplatablePattern=o},,,,function(t,e,n){"use strict";var r=n(19).Beautifier,i=n(20).Options;t.exports=function(t,e,n,i){return new r(t,e,n,i).beautify()},t.exports.defaultOptions=function(){return new i}},function(t,e,n){"use strict";var r=n(20).Options,i=n(2).Output,o=n(21).Tokenizer,a=n(21).TOKEN,s=/\r\n|[\r\n]/,u=/\r\n|[\r\n]/g,l=function(t,e){this.indent_level=0,this.alignment_size=0,this.max_preserve_newlines=t.max_preserve_newlines,this.preserve_newlines=t.preserve_newlines,this._output=new i(t,e)};l.prototype.current_line_has_match=function(t){return this._output.current_line.has_match(t)},l.prototype.set_space_before_token=function(t,e){this._output.space_before_token=t,this._output.non_breaking_space=e},l.prototype.set_wrap_point=function(){this._output.set_indent(this.indent_level,this.alignment_size),this._output.set_wrap_point()},l.prototype.add_raw_token=function(t){this._output.add_raw_token(t)},l.prototype.print_preserved_newlines=function(t){var e=0;t.type!==a.TEXT&&t.previous.type!==a.TEXT&&(e=t.newlines?1:0),this.preserve_newlines&&(e=t.newlines<this.max_preserve_newlines+1?t.newlines:this.max_preserve_newlines+1);for(var n=0;n<e;n++)this.print_newline(n>0);return 0!==e},l.prototype.traverse_whitespace=function(t){return!(!t.whitespace_before&&!t.newlines||(this.print_preserved_newlines(t)||(this._output.space_before_token=!0),0))},l.prototype.previous_token_wrapped=function(){return this._output.previous_token_wrapped},l.prototype.print_newline=function(t){this._output.add_new_line(t)},l.prototype.print_token=function(t){t.text&&(this._output.set_indent(this.indent_level,this.alignment_size),this._output.add_token(t.text))},l.prototype.indent=function(){this.indent_level++},l.prototype.get_full_indent=function(t){return(t=this.indent_level+(t||0))<1?"":this._output.get_indent_string(t)};var c=function(t,e){var n=null,r=null;return e.closed?("script"===t?n="text/javascript":"style"===t&&(n="text/css"),(n=function(t){for(var e=null,n=t.next;n.type!==a.EOF&&t.closed!==n;){if(n.type===a.ATTRIBUTE&&"type"===n.text){n.next&&n.next.type===a.EQUALS&&n.next.next&&n.next.next.type===a.VALUE&&(e=n.next.next.text);break}n=n.next}return e}(e)||n).search("text/css")>-1?r="css":n.search(/module|((text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect))/)>-1?r="javascript":n.search(/(text|application|dojo)\/(x-)?(html)/)>-1?r="html":n.search(/test\/null/)>-1&&(r="null"),r):null};function h(t,e){return-1!==e.indexOf(t)}function p(t,e,n){this.parent=t||null,this.tag=e?e.tag_name:"",this.indent_level=n||0,this.parser_token=e||null}function f(t){this._printer=t,this._current_frame=null}function _(t,e,n,i){this._source_text=t||"",e=e||{},this._js_beautify=n,this._css_beautify=i,this._tag_stack=null;var o=new r(e,"html");this._options=o,this._is_wrap_attributes_force="force"===this._options.wrap_attributes.substr(0,"force".length),this._is_wrap_attributes_force_expand_multiline="force-expand-multiline"===this._options.wrap_attributes,this._is_wrap_attributes_force_aligned="force-aligned"===this._options.wrap_attributes,this._is_wrap_attributes_aligned_multiple="aligned-multiple"===this._options.wrap_attributes,this._is_wrap_attributes_preserve="preserve"===this._options.wrap_attributes.substr(0,"preserve".length),this._is_wrap_attributes_preserve_aligned="preserve-aligned"===this._options.wrap_attributes}f.prototype.get_parser_token=function(){return this._current_frame?this._current_frame.parser_token:null},f.prototype.record_tag=function(t){var e=new p(this._current_frame,t,this._printer.indent_level);this._current_frame=e},f.prototype._try_pop_frame=function(t){var e=null;return t&&(e=t.parser_token,this._printer.indent_level=t.indent_level,this._current_frame=t.parent),e},f.prototype._get_frame=function(t,e){for(var n=this._current_frame;n&&-1===t.indexOf(n.tag);){if(e&&-1!==e.indexOf(n.tag)){n=null;break}n=n.parent}return n},f.prototype.try_pop=function(t,e){var n=this._get_frame([t],e);return this._try_pop_frame(n)},f.prototype.indent_to_tag=function(t){var e=this._get_frame(t);e&&(this._printer.indent_level=e.indent_level)},_.prototype.beautify=function(){if(this._options.disabled)return this._source_text;var t=this._source_text,e=this._options.eol;"auto"===this._options.eol&&(e="\n",t&&s.test(t)&&(e=t.match(s)[0]));var n=(t=t.replace(u,"\n")).match(/^[\t ]*/)[0],r={text:"",type:""},i=new d,c=new l(this._options,n),h=new o(t,this._options).tokenize();this._tag_stack=new f(c);for(var p=null,_=h.next();_.type!==a.EOF;)_.type===a.TAG_OPEN||_.type===a.COMMENT?i=p=this._handle_tag_open(c,_,i,r):_.type===a.ATTRIBUTE||_.type===a.EQUALS||_.type===a.VALUE||_.type===a.TEXT&&!i.tag_complete?p=this._handle_inside_tag(c,_,i,h):_.type===a.TAG_CLOSE?p=this._handle_tag_close(c,_,i):_.type===a.TEXT?p=this._handle_text(c,_,i):c.add_raw_token(_),r=p,_=h.next();return c._output.get_code(e)},_.prototype._handle_tag_close=function(t,e,n){var r={text:e.text,type:e.type};return t.alignment_size=0,n.tag_complete=!0,t.set_space_before_token(e.newlines||""!==e.whitespace_before,!0),n.is_unformatted?t.add_raw_token(e):("<"===n.tag_start_char&&(t.set_space_before_token("/"===e.text[0],!0),this._is_wrap_attributes_force_expand_multiline&&n.has_wrapped_attrs&&t.print_newline(!1)),t.print_token(e)),!n.indent_content||n.is_unformatted||n.is_content_unformatted||(t.indent(),n.indent_content=!1),n.is_inline_element||n.is_unformatted||n.is_content_unformatted||t.set_wrap_point(),r},_.prototype._handle_inside_tag=function(t,e,n,r){var i=n.has_wrapped_attrs,o={text:e.text,type:e.type};if(t.set_space_before_token(e.newlines||""!==e.whitespace_before,!0),n.is_unformatted)t.add_raw_token(e);else if("{"===n.tag_start_char&&e.type===a.TEXT)t.print_preserved_newlines(e)?(e.newlines=0,t.add_raw_token(e)):t.print_token(e);else{if(e.type===a.ATTRIBUTE?(t.set_space_before_token(!0),n.attr_count+=1):(e.type===a.EQUALS||e.type===a.VALUE&&e.previous.type===a.EQUALS)&&t.set_space_before_token(!1),e.type===a.ATTRIBUTE&&"<"===n.tag_start_char&&((this._is_wrap_attributes_preserve||this._is_wrap_attributes_preserve_aligned)&&(t.traverse_whitespace(e),i=i||0!==e.newlines),this._is_wrap_attributes_force)){var s=n.attr_count>1;if(this._is_wrap_attributes_force_expand_multiline&&1===n.attr_count){var u,l=!0,c=0;do{if((u=r.peek(c)).type===a.ATTRIBUTE){l=!1;break}c+=1}while(c<4&&u.type!==a.EOF&&u.type!==a.TAG_CLOSE);s=!l}s&&(t.print_newline(!1),i=!0)}t.print_token(e),i=i||t.previous_token_wrapped(),n.has_wrapped_attrs=i}return o},_.prototype._handle_text=function(t,e,n){var r={text:e.text,type:"TK_CONTENT"};return n.custom_beautifier_name?this._print_custom_beatifier_text(t,e,n):n.is_unformatted||n.is_content_unformatted?t.add_raw_token(e):(t.traverse_whitespace(e),t.print_token(e)),r},_.prototype._print_custom_beatifier_text=function(t,e,n){var r=this;if(""!==e.text){var i,o=e.text,a=1,s="",u="";"javascript"===n.custom_beautifier_name&&"function"==typeof this._js_beautify?i=this._js_beautify:"css"===n.custom_beautifier_name&&"function"==typeof this._css_beautify?i=this._css_beautify:"html"===n.custom_beautifier_name&&(i=function(t,e){return new _(t,e,r._js_beautify,r._css_beautify).beautify()}),"keep"===this._options.indent_scripts?a=0:"separate"===this._options.indent_scripts&&(a=-t.indent_level);var l=t.get_full_indent(a);if(o=o.replace(/\n[ \t]*$/,""),"html"!==n.custom_beautifier_name&&"<"===o[0]&&o.match(/^(<!--|<!\[CDATA\[)/)){var c=/^(<!--[^\n]*|<!\[CDATA\[)(\n?)([ \t\n]*)([\s\S]*)(-->|]]>)$/.exec(o);if(!c)return void t.add_raw_token(e);s=l+c[1]+"\n",o=c[4],c[5]&&(u=l+c[5]),o=o.replace(/\n[ \t]*$/,""),(c[2]||-1!==c[3].indexOf("\n"))&&(c=c[3].match(/[ \t]+$/))&&(e.whitespace_before=c[0])}if(o)if(i){var h=function(){this.eol="\n"};h.prototype=this._options.raw_options,o=i(l+o,new h)}else{var p=e.whitespace_before;p&&(o=o.replace(new RegExp("\n("+p+")?","g"),"\n")),o=l+o.replace(/\n/g,"\n"+l)}s&&(o=o?s+o+"\n"+u:s+u),t.print_newline(!1),o&&(e.text=o,e.whitespace_before="",e.newlines=0,t.add_raw_token(e),t.print_newline(!0))}},_.prototype._handle_tag_open=function(t,e,n,r){var i=this._get_tag_open_token(e);return(n.is_unformatted||n.is_content_unformatted)&&e.type===a.TAG_OPEN&&0===e.text.indexOf("</")?(t.add_raw_token(e),i.start_tag_token=this._tag_stack.try_pop(i.tag_name)):(t.traverse_whitespace(e),this._set_tag_position(t,e,i,n,r),i.is_inline_element||t.set_wrap_point(),t.print_token(e)),(this._is_wrap_attributes_force_aligned||this._is_wrap_attributes_aligned_multiple||this._is_wrap_attributes_preserve_aligned)&&(i.alignment_size=e.text.length+1),i.tag_complete||i.is_unformatted||(t.alignment_size=i.alignment_size),i};var d=function(t,e){var n;this.parent=t||null,this.text="",this.type="TK_TAG_OPEN",this.tag_name="",this.is_inline_element=!1,this.is_unformatted=!1,this.is_content_unformatted=!1,this.is_empty_element=!1,this.is_start_tag=!1,this.is_end_tag=!1,this.indent_content=!1,this.multiline_content=!1,this.custom_beautifier_name=null,this.start_tag_token=null,this.attr_count=0,this.has_wrapped_attrs=!1,this.alignment_size=0,this.tag_complete=!1,this.tag_start_char="",this.tag_check="",e?(this.tag_start_char=e.text[0],this.text=e.text,"<"===this.tag_start_char?(n=e.text.match(/^<([^\s>]*)/),this.tag_check=n?n[1]:""):(n=e.text.match(/^{{(?:[\^]|#\*?)?([^\s}]+)/),this.tag_check=n?n[1]:"","{{#>"===e.text&&">"===this.tag_check&&null!==e.next&&(this.tag_check=e.next.text)),this.tag_check=this.tag_check.toLowerCase(),e.type===a.COMMENT&&(this.tag_complete=!0),this.is_start_tag="/"!==this.tag_check.charAt(0),this.tag_name=this.is_start_tag?this.tag_check:this.tag_check.substr(1),this.is_end_tag=!this.is_start_tag||e.closed&&"/>"===e.closed.text,this.is_end_tag=this.is_end_tag||"{"===this.tag_start_char&&(this.text.length<3||/[^#\^]/.test(this.text.charAt(2)))):this.tag_complete=!0};_.prototype._get_tag_open_token=function(t){var e=new d(this._tag_stack.get_parser_token(),t);return e.alignment_size=this._options.wrap_attributes_indent_size,e.is_end_tag=e.is_end_tag||h(e.tag_check,this._options.void_elements),e.is_empty_element=e.tag_complete||e.is_start_tag&&e.is_end_tag,e.is_unformatted=!e.tag_complete&&h(e.tag_check,this._options.unformatted),e.is_content_unformatted=!e.is_empty_element&&h(e.tag_check,this._options.content_unformatted),e.is_inline_element=h(e.tag_name,this._options.inline)||"{"===e.tag_start_char,e},_.prototype._set_tag_position=function(t,e,n,r,i){n.is_empty_element||(n.is_end_tag?n.start_tag_token=this._tag_stack.try_pop(n.tag_name):(this._do_optional_end_element(n)&&(n.is_inline_element||(n.parent&&(n.parent.multiline_content=!0),t.print_newline(!1))),this._tag_stack.record_tag(n),"script"!==n.tag_name&&"style"!==n.tag_name||n.is_unformatted||n.is_content_unformatted||(n.custom_beautifier_name=c(n.tag_check,e)))),h(n.tag_check,this._options.extra_liners)&&(t.print_newline(!1),t._output.just_added_blankline()||t.print_newline(!0)),n.is_empty_element?("{"===n.tag_start_char&&"else"===n.tag_check&&(this._tag_stack.indent_to_tag(["if","unless","each"]),n.indent_content=!0,t.current_line_has_match(/{{#if/)||t.print_newline(!1)),"!--"===n.tag_name&&i.type===a.TAG_CLOSE&&r.is_end_tag&&-1===n.text.indexOf("\n")||n.is_inline_element||n.is_unformatted||t.print_newline(!1)):n.is_unformatted||n.is_content_unformatted?n.is_inline_element||n.is_unformatted||t.print_newline(!1):n.is_end_tag?(n.start_tag_token&&n.start_tag_token.multiline_content||!(n.is_inline_element||r.is_inline_element||i.type===a.TAG_CLOSE&&n.start_tag_token===r||"TK_CONTENT"===i.type))&&t.print_newline(!1):(n.indent_content=!n.custom_beautifier_name,"<"===n.tag_start_char&&("html"===n.tag_name?n.indent_content=this._options.indent_inner_html:"head"===n.tag_name?n.indent_content=this._options.indent_head_inner_html:"body"===n.tag_name&&(n.indent_content=this._options.indent_body_inner_html)),n.is_inline_element||"TK_CONTENT"===i.type||(n.parent&&(n.parent.multiline_content=!0),t.print_newline(!1)))};var v=["address","article","aside","blockquote","details","div","dl","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hr","main","nav","ol","p","pre","section","table","ul"],g=["a","audio","del","ins","map","noscript","video"];_.prototype._do_optional_end_element=function(t){var e=null;if(!t.is_empty_element&&t.is_start_tag&&t.parent){if("body"===t.tag_name)e=e||this._tag_stack.try_pop("head");else if("li"===t.tag_name)e=e||this._tag_stack.try_pop("li",["ol","ul"]);else if("dd"===t.tag_name||"dt"===t.tag_name)e=(e=e||this._tag_stack.try_pop("dt",["dl"]))||this._tag_stack.try_pop("dd",["dl"]);else if("p"===t.parent.tag_name&&-1!==v.indexOf(t.tag_name)){var n=t.parent.parent;n&&-1!==g.indexOf(n.tag_name)||(e=e||this._tag_stack.try_pop("p"))}else"rp"===t.tag_name||"rt"===t.tag_name?e=(e=e||this._tag_stack.try_pop("rt",["ruby","rtc"]))||this._tag_stack.try_pop("rp",["ruby","rtc"]):"optgroup"===t.tag_name?e=e||this._tag_stack.try_pop("optgroup",["select"]):"option"===t.tag_name?e=e||this._tag_stack.try_pop("option",["select","datalist","optgroup"]):"colgroup"===t.tag_name?e=e||this._tag_stack.try_pop("caption",["table"]):"thead"===t.tag_name?e=(e=e||this._tag_stack.try_pop("caption",["table"]))||this._tag_stack.try_pop("colgroup",["table"]):"tbody"===t.tag_name||"tfoot"===t.tag_name?e=(e=(e=(e=e||this._tag_stack.try_pop("caption",["table"]))||this._tag_stack.try_pop("colgroup",["table"]))||this._tag_stack.try_pop("thead",["table"]))||this._tag_stack.try_pop("tbody",["table"]):"tr"===t.tag_name?e=(e=(e=e||this._tag_stack.try_pop("caption",["table"]))||this._tag_stack.try_pop("colgroup",["table"]))||this._tag_stack.try_pop("tr",["table","thead","tbody","tfoot"]):"th"!==t.tag_name&&"td"!==t.tag_name||(e=(e=e||this._tag_stack.try_pop("td",["table","thead","tbody","tfoot","tr"]))||this._tag_stack.try_pop("th",["table","thead","tbody","tfoot","tr"]));return t.parent=this._tag_stack.get_parser_token(),e}},t.exports.Beautifier=_},function(t,e,n){"use strict";var r=n(6).Options;function i(t){r.call(this,t,"html"),1===this.templating.length&&"auto"===this.templating[0]&&(this.templating=["django","erb","handlebars","php"]),this.indent_inner_html=this._get_boolean("indent_inner_html"),this.indent_body_inner_html=this._get_boolean("indent_body_inner_html",!0),this.indent_head_inner_html=this._get_boolean("indent_head_inner_html",!0),this.indent_handlebars=this._get_boolean("indent_handlebars",!0),this.wrap_attributes=this._get_selection("wrap_attributes",["auto","force","force-aligned","force-expand-multiline","aligned-multiple","preserve","preserve-aligned"]),this.wrap_attributes_indent_size=this._get_number("wrap_attributes_indent_size",this.indent_size),this.extra_liners=this._get_array("extra_liners",["head","body","/html"]),this.inline=this._get_array("inline",["a","abbr","area","audio","b","bdi","bdo","br","button","canvas","cite","code","data","datalist","del","dfn","em","embed","i","iframe","img","input","ins","kbd","keygen","label","map","mark","math","meter","noscript","object","output","progress","q","ruby","s","samp","select","small","span","strong","sub","sup","svg","template","textarea","time","u","var","video","wbr","text","acronym","big","strike","tt"]),this.void_elements=this._get_array("void_elements",["area","base","br","col","embed","hr","img","input","keygen","link","menuitem","meta","param","source","track","wbr","!doctype","?xml","basefont","isindex"]),this.unformatted=this._get_array("unformatted",[]),this.content_unformatted=this._get_array("content_unformatted",["pre","textarea"]),this.unformatted_content_delimiter=this._get_characters("unformatted_content_delimiter"),this.indent_scripts=this._get_selection("indent_scripts",["normal","keep","separate"])}i.prototype=new r,t.exports.Options=i},function(t,e,n){"use strict";var r=n(9).Tokenizer,i=n(9).TOKEN,o=n(13).Directives,a=n(14).TemplatablePattern,s=n(12).Pattern,u={TAG_OPEN:"TK_TAG_OPEN",TAG_CLOSE:"TK_TAG_CLOSE",ATTRIBUTE:"TK_ATTRIBUTE",EQUALS:"TK_EQUALS",VALUE:"TK_VALUE",COMMENT:"TK_COMMENT",TEXT:"TK_TEXT",UNKNOWN:"TK_UNKNOWN",START:i.START,RAW:i.RAW,EOF:i.EOF},l=new o(/<\!--/,/-->/),c=function(t,e){r.call(this,t,e),this._current_tag_name="";var n=new a(this._input).read_options(this._options),i=new s(this._input);if(this.__patterns={word:n.until(/[\n\r\t <]/),single_quote:n.until_after(/'/),double_quote:n.until_after(/"/),attribute:n.until(/[\n\r\t =>]|\/>/),element_name:n.until(/[\n\r\t >\/]/),handlebars_comment:i.starting_with(/{{!--/).until_after(/--}}/),handlebars:i.starting_with(/{{/).until_after(/}}/),handlebars_open:i.until(/[\n\r\t }]/),handlebars_raw_close:i.until(/}}/),comment:i.starting_with(/<!--/).until_after(/-->/),cdata:i.starting_with(/<!\[CDATA\[/).until_after(/]]>/),conditional_comment:i.starting_with(/<!\[/).until_after(/]>/),processing:i.starting_with(/<\?/).until_after(/\?>/)},this._options.indent_handlebars&&(this.__patterns.word=this.__patterns.word.exclude("handlebars")),this._unformatted_content_delimiter=null,this._options.unformatted_content_delimiter){var o=this._input.get_literal_regexp(this._options.unformatted_content_delimiter);this.__patterns.unformatted_content_delimiter=i.matching(o).until_after(o)}};(c.prototype=new r)._is_comment=function(t){return!1},c.prototype._is_opening=function(t){return t.type===u.TAG_OPEN},c.prototype._is_closing=function(t,e){return t.type===u.TAG_CLOSE&&e&&((">"===t.text||"/>"===t.text)&&"<"===e.text[0]||"}}"===t.text&&"{"===e.text[0]&&"{"===e.text[1])},c.prototype._reset=function(){this._current_tag_name=""},c.prototype._get_next_token=function(t,e){var n=null;this._readWhitespace();var r=this._input.peek();return null===r?this._create_token(u.EOF,""):n=(n=(n=(n=(n=(n=(n=(n=(n=n||this._read_open_handlebars(r,e))||this._read_attribute(r,t,e))||this._read_raw_content(r,t,e))||this._read_close(r,e))||this._read_content_word(r))||this._read_comment_or_cdata(r))||this._read_processing(r))||this._read_open(r,e))||this._create_token(u.UNKNOWN,this._input.next())},c.prototype._read_comment_or_cdata=function(t){var e=null,n=null,r=null;return"<"===t&&("!"===this._input.peek(1)&&((n=this.__patterns.comment.read())?(r=l.get_directives(n))&&"start"===r.ignore&&(n+=l.readIgnored(this._input)):n=this.__patterns.cdata.read()),n&&((e=this._create_token(u.COMMENT,n)).directives=r)),e},c.prototype._read_processing=function(t){var e=null,n=null;if("<"===t){var r=this._input.peek(1);"!"!==r&&"?"!==r||(n=(n=this.__patterns.conditional_comment.read())||this.__patterns.processing.read()),n&&((e=this._create_token(u.COMMENT,n)).directives=null)}return e},c.prototype._read_open=function(t,e){var n=null,r=null;return e||"<"===t&&(n=this._input.next(),"/"===this._input.peek()&&(n+=this._input.next()),n+=this.__patterns.element_name.read(),r=this._create_token(u.TAG_OPEN,n)),r},c.prototype._read_open_handlebars=function(t,e){var n=null,r=null;return e||this._options.indent_handlebars&&"{"===t&&"{"===this._input.peek(1)&&("!"===this._input.peek(2)?(n=(n=this.__patterns.handlebars_comment.read())||this.__patterns.handlebars.read(),r=this._create_token(u.COMMENT,n)):(n=this.__patterns.handlebars_open.read(),r=this._create_token(u.TAG_OPEN,n))),r},c.prototype._read_close=function(t,e){var n=null,r=null;return e&&("<"===e.text[0]&&(">"===t||"/"===t&&">"===this._input.peek(1))?(n=this._input.next(),"/"===t&&(n+=this._input.next()),r=this._create_token(u.TAG_CLOSE,n)):"{"===e.text[0]&&"}"===t&&"}"===this._input.peek(1)&&(this._input.next(),this._input.next(),r=this._create_token(u.TAG_CLOSE,"}}"))),r},c.prototype._read_attribute=function(t,e,n){var r=null,i="";if(n&&"<"===n.text[0])if("="===t)r=this._create_token(u.EQUALS,this._input.next());else if('"'===t||"'"===t){var o=this._input.next();o+='"'===t?this.__patterns.double_quote.read():this.__patterns.single_quote.read(),r=this._create_token(u.VALUE,o)}else(i=this.__patterns.attribute.read())&&(r=e.type===u.EQUALS?this._create_token(u.VALUE,i):this._create_token(u.ATTRIBUTE,i));return r},c.prototype._is_content_unformatted=function(t){return-1===this._options.void_elements.indexOf(t)&&(-1!==this._options.content_unformatted.indexOf(t)||-1!==this._options.unformatted.indexOf(t))},c.prototype._read_raw_content=function(t,e,n){var r="";if(n&&"{"===n.text[0])r=this.__patterns.handlebars_raw_close.read();else if(e.type===u.TAG_CLOSE&&"<"===e.opened.text[0]){var i=e.opened.text.substr(1).toLowerCase();if("script"===i||"style"===i){var o=this._read_comment_or_cdata(t);if(o)return o.type=u.TEXT,o;r=this._input.readUntil(new RegExp("</"+i+"[\\n\\r\\t ]*?>","ig"))}else this._is_content_unformatted(i)&&(r=this._input.readUntil(new RegExp("</"+i+"[\\n\\r\\t ]*?>","ig")))}return r?this._create_token(u.TEXT,r):null},c.prototype._read_content_word=function(t){var e="";if(this._options.unformatted_content_delimiter&&t===this._options.unformatted_content_delimiter[0]&&(e=this.__patterns.unformatted_content_delimiter.read()),e||(e=this.__patterns.word.read()),e)return this._create_token(u.TEXT,e)},t.exports.Tokenizer=c,t.exports.TOKEN=u}]),r=[n,n(19),n(20)],void 0===(i=function(t){var e=n(19),r=n(20);return{html_beautify:function(t,n){return o(t,n,e.js_beautify,r.css_beautify)}}}.apply(e,r))||(t.exports=i)},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=l(n,"class").call(a,"header",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=l(n,"repeat").call(a,null!=(o=null!=e?l(e,"group"):e)?l(o,"indentLevel"):o,{name:"repeat",hash:{},fn:t.program(2,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=l(n,"class").call(a,"time-container",{name:"class",hash:{},data:i}))?o:"")+"><span>"+u(s(null!=(o=null!=e?l(e,"headers"):e)?l(o,"time"):o,e))+"</span><span>"+u(s(null!=(o=null!=e?l(e,"headers"):e)?l(o,"from"):o,e))+"</span></div></div> "},2:function(t,e,n,r,i){var o;return" <div "+(null!=(o=(t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]})(n,"class").call(null!=e?e:t.nullContext||{},"nesting-level",{name:"class",hash:{},data:i}))?o:"")+"></div> "},4:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"icon-container",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,"icon icon-",null!=e?s(e,"icon"):e,{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+"></span></div> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return(null!=(o=s(n,"if").call(a,null!=e?s(e,"headers"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,null!=e?s(e,"type"):e," log-item",{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"repeat").call(a,null!=(o=null!=e?s(e,"group"):e)?s(o,"indentLevel"):o,{name:"repeat",hash:{},fn:t.program(2,i,0),inverse:t.noop,data:i}))?o:"")+" "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"icon"):e,{name:"if",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=s(n,"class").call(a,"count-container hidden",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"count",{name:"class",hash:{},data:i}))?o:"")+"></div></div><div "+(null!=(o=s(n,"class").call(a,"log-content-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"log-content",{name:"class",hash:{},data:i}))?o:"")+">"+(null!=(o=t.lambda(null!=e?s(e,"msg"):e,e))?o:"")+"</div></div></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"._console-container ._logs-container{$oy:auto;$wos:touch;$h:100%;$po:relative;$wc:scroll-position}._console-container ._fake-logs{$po:absolute;$l:0;$t:0;$pe:none;$v:hidden;$w:100%}._console-container ._fake-logs *{$o:hidden;$c:#000;$po:static}._console-container ._logs{$fs:14px;$pt:1px;$po:absolute;$w:100%}._console-container ._log-container{$bsi:content-box}._console-container ._header{$ws:nowrap;$d:flex;$fs:12px;$c:var(--link-color);$bt:1px solid transparent;$bb:1px solid var(--border)}._console-container ._header ._time-container{$ox:auto;$wos:touch;$p:3px 10px}._console-container ._nesting-level{$w:14px;$fsh:0;$mt:-1px;$mb:-1px;$po:relative;$br:1px solid var(--border)}._console-container ._nesting-level._group-closed::before{$co:''}._console-container ._nesting-level::before{$bb:1px solid var(--border);$po:absolute;$t:0;$l:0;$ml:100%;$w:5px;$h:100%;$bsi:border-box}._console-container ._log-item{$po:relative;$d:flex;$bt:1px solid transparent;$bb:1px solid var(--border);$mt:-1px;$mh:24px;$c:var(--foreground)}._console-container ._log-item:after{$co:'';$d:block;$cl:both}._console-container ._log-item a{$c:var(--link-color)!important}._console-container ._log-item ._icon-container{$pt:2px;$m:0 -6px 0 10px}._console-container ._log-item ._icon-container ._icon{$lh:20px;$fs:12px;$c:var(--foreground);$po:relative}._console-container ._log-item ._icon-container ._icon-caret-down,._console-container ._log-item ._icon-container ._icon-caret-right{$l:-2px}._console-container ._log-item ._icon-container ._icon-error{$c:#ef3842}._console-container ._log-item ._icon-container ._icon-warn{$t:-1px;$c:#e8a400}._console-container ._log-item ._count{$b:var(--text-color);$p:2px 4px;$c:#000;$bra:10px;$fs:12px;$f:left;$m:2px -6px 0 10px}._console-container ._log-item ._log-content-wrapper{$fl:1;$o:hidden}._console-container ._log-item ._log-content{$p:3px 0;$m:0 10px;$ox:auto;$wos:touch;$ws:pre-wrap;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}._console-container ._log-item ._log-content *{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}._console-container ._log-item._html table,._console-container ._log-item._table table{$w:100%;$bc:collapse;$o:hidden;$c:var(--foreground)}._console-container ._log-item._html table th,._console-container ._log-item._table table th{$b:var(--darker-background)}._console-container ._log-item._html table td,._console-container ._log-item._html table th,._console-container ._log-item._table table td,._console-container ._log-item._table table th{$bo:1px solid var(--border);$p:3px 10px}._console-container ._log-item._html table tr:nth-child(even),._console-container ._log-item._table table tr:nth-child(even){$b:var(--contrast)}._console-container ._log-item._error{$z:50;$b:var(--console-error-background);$c:var(--console-error-foreground);$bt:1px solid var(--console-error-border);$bb:1px solid var(--console-error-border)}._console-container ._log-item._error ._stack{$pl:1.2em;$ws:nowrap}._console-container ._log-item._error ._count{$b:var(--console-error-foreground)}._console-container ._log-item._debug{$z:20}._console-container ._log-item._input{border-bottom-color:transparent}._console-container ._log-item._warn{$z:40;$c:var(--console-warn-foreground);$b:var(--console-warn-background);$bt:1px solid var(--console-warn-border);$bb:1px solid var(--console-warn-border)}._console-container ._log-item._warn ._count{$b:#e8a400}._console-container ._log-item._info{$z:30}._console-container ._log-item._group,._console-container ._log-item._groupCollapsed{$fw:700}",""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,"._container ._console-container{$pt:40px;$pb:24px}._console-container{$w:100%;$h:100%}._console-container._js-input-hidden{$pb:0}._console-container ._control{$po:absolute;$w:100%;$h:40px;$l:0;$t:0;$cu:default;$fs:0;$p:10px 10px 10px 35px;$b:var(--darker-background);$c:var(--primary);$lh:20px;$bb:1px solid var(--border)}._console-container ._control ._icon-clear,._console-container ._control ._icon-search{$d:inline-block;$p:10px;$fs:16px;$po:absolute;$t:1px;$cu:pointer;$tr:color .3s}._console-container ._control ._icon-clear:active,._console-container ._control ._icon-search:active{$c:var(--accent)}._console-container ._control ._icon-clear{padding-right:0;$l:0}._console-container ._control ._icon-search{right:0}._console-container ._control ._filter{$cu:pointer;$fs:12px;$h:20px;$d:inline-block;$m:0 2px;$p:0 4px;$lh:20px;$tr:background .3s,color .3s}._console-container ._control ._filter._active{$b:var(--highlight);$c:var(--select-foreground)}._console-container ._control ._search-keyword{$po:absolute;$lh:20px;max-width:80px;$o:hidden;right:40px;$fs:14px;text-overflow:ellipsis}._console-container ._js-input{$pe:none;$po:absolute;$z:100;$l:0;bottom:0;$w:100%;$bt:1px solid var(--border);$h:24px}._console-container ._js-input ._icon-arrow-right{$lh:23px;$c:var(--accent);$po:absolute;$l:10px;$t:0;$z:10}._console-container ._js-input._active{$h:100%;$pt:40px;$pb:40px;$bt:none}._console-container ._js-input._active ._icon-arrow-right{$d:none}._console-container ._js-input._active textarea{$pl:10px}._console-container ._js-input ._buttons{$d:none;$po:absolute;$l:0;bottom:0;$w:100%;$h:40px;$c:var(--primary);$b:var(--darker-background);$fs:12px;$bt:1px solid var(--border)}._console-container ._js-input ._buttons ._button{$pe:all;$cu:pointer;$w:50%;$d:inline-block;$ta:center;$br:1px solid var(--border);$h:40px;$lh:40px;$tr:background .3s,color .3s}._console-container ._js-input ._buttons ._button:last-child{$br:none}._console-container ._js-input ._buttons ._button:active{$c:var(--select-foreground);$b:var(--highlight)}._console-container ._js-input textarea{$pe:all;$p:3px 10px;$pl:25px;$ou:0;$bo:none;$fs:14px;$w:100%;$h:100%;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;resize:none;$c:var(--primary);$b:var(--background)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"console-container",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"control",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-clear clear-console",{name:"class",hash:{},data:i}))?o:"")+"></span> <span "+(null!=(o=s(n,"class").call(a,"filter active",{name:"class",hash:{},data:i}))?o:"")+' data-filter="all">All</span> <span '+(null!=(o=s(n,"class").call(a,"filter",{name:"class",hash:{},data:i}))?o:"")+' data-filter="error">Error</span> <span '+(null!=(o=s(n,"class").call(a,"filter",{name:"class",hash:{},data:i}))?o:"")+' data-filter="warn">Warning</span> <span '+(null!=(o=s(n,"class").call(a,"filter",{name:"class",hash:{},data:i}))?o:"")+' data-filter="info">Info</span> <span '+(null!=(o=s(n,"class").call(a,"search-keyword",{name:"class",hash:{},data:i}))?o:"")+"></span> <span "+(null!=(o=s(n,"class").call(a,"icon-search search",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"logs-container",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"logs-space",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"fake-logs",{name:"class",hash:{},data:i}))?o:"")+"></div><div "+(null!=(o=s(n,"class").call(a,"logs",{name:"class",hash:{},data:i}))?o:"")+"></div></div></div><div "+(null!=(o=s(n,"class").call(a,"js-input",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"buttons",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"button cancel",{name:"class",hash:{},data:i}))?o:"")+">Cancel</div><div "+(null!=(o=s(n,"class").call(a,"button execute",{name:"class",hash:{},data:i}))?o:"")+">Execute</div></div><span "+(null!=(o=s(n,"class").call(a,"icon-arrow-right",{name:"class",hash:{},data:i}))?o:"")+"></span> <textarea></textarea></div></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_network{$pt:36px}#_network ._title{$po:absolute;$w:100%;$h:36px;$l:0;$t:0;$b:var(--darker-background);$p:10px;$c:var(--primary);$h:36px;$bb:1px solid var(--border)}#_network ._title ._btn{$d:flex;$ml:5px;$f:right;$c:var(--primary);$w:18px;$h:18px;justify-content:center;align-items:center;$fs:16px;$cu:pointer;$tr:color .3s}#_network ._title ._btn._search-keyword{$w:auto;max-width:80px;$fs:14px;$o:hidden;text-overflow:ellipsis;$d:inline-block}#_network ._title ._btn:active{$c:var(--accent)}#_network ._requests{$oy:auto;$wos:touch;$h:100%;$bb:1px solid var(--border);$mb:10px}#_network ._requests li{$d:flex;$w:100%;$cu:pointer;$bb:1px solid var(--border);$h:41px;$c:var(--foreground);$ws:nowrap}#_network ._requests li._error span{$c:var(--console-error-foreground)}#_network ._requests li span{$d:block;$lh:40px;$h:40px;$p:0 5px;$fs:12px;vertical-align:top;text-overflow:ellipsis;$o:hidden}#_network ._requests li ._name{$fl:1;$pl:10px}#_network ._requests li ._status{$w:40px}#_network ._requests li ._method,#_network ._requests li ._type{$w:50px}#_network ._requests li ._size{$w:70px}#_network ._requests li ._time{$w:60px;padding-right:10px}#_network ._requests li:nth-child(even){$b:var(--contrast)}#_network ._detail{$po:absolute;$w:100%;$h:100%;$l:0;$t:0;$z:10;$d:none;$pb:40px;$b:var(--background)}#_network ._detail ._http{$oy:auto;$wos:touch;$h:100%}#_network ._detail ._http ._breadcrumb{$b:var(--darker-background);$c:var(--primary);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$mb:10px;word-break:break-all;$p:10px;$fs:16px;$mh:40px;$bb:1px solid var(--border)}#_network ._detail ._http ._section{$bt:1px solid var(--border);$bb:1px solid var(--border);$mb:10px}#_network ._detail ._http ._section h2{$b:var(--darker-background);$c:var(--primary);$p:10px;$fs:14px}#_network ._detail ._http ._section table{$c:var(--foreground)}#_network ._detail ._http ._section table *{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}#_network ._detail ._http ._section table td{$fs:12px;$p:5px 10px;word-break:break-all}#_network ._detail ._http ._section table ._key{$ws:nowrap;$fw:700;$c:var(--accent)}#_network ._detail ._http ._data,#_network ._detail ._http ._response{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$ox:auto;$wos:touch;$p:10px;$fs:12px;$mb:10px;$ws:pre-wrap;$bt:1px solid var(--border);$c:var(--foreground);$bb:1px solid var(--border)}#_network ._detail ._back{$po:absolute;$l:0;bottom:0;$c:var(--foreground);$w:100%;$bt:1px solid var(--border);$b:var(--darker-background);$d:block;$h:40px;$lh:40px;text-decoration:none;$ta:center;$mt:10px;$tr:background .3s;$cu:pointer}#_network ._detail ._back:active{$c:var(--select-foreground)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Request<div "+(null!=(o=s(n,"class").call(a,"btn clear-request",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-clear",{name:"class",hash:{},data:i}))?o:"")+"></span></div></div><ul "+(null!=(o=s(n,"class").call(a,"requests",{name:"class",hash:{},data:i}))?o:"")+"></ul><div "+(null!=(o=s(n,"class").call(a,"detail",{name:"class",hash:{},data:i}))?o:"")+"></div>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <pre "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"data",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"data"):e,e))+"</pre> "},3:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"reqHeaders"):e,{name:"each",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" "},4:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <tr><td "+(null!=(o=u(n,"class").call(null!=e?e:t.nullContext||{},"key",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(i&&u(i,"key"),e))+"</td><td>"+s(a(e,e))+"</td></tr> "},6:function(t,e,n,r,i){return" <tr><td>Empty</td></tr> "},8:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"resHeaders"):e,{name:"each",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" "},10:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <pre "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"response",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"resTxt"):e,e))+"</pre> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"http",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"breadcrumb",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?s(e,"url"):e,e))+"</div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"data"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=s(n,"class").call(a,"section",{name:"class",hash:{},data:i}))?o:"")+"><h2>Request Headers</h2><table "+(null!=(o=s(n,"class").call(a,"headers",{name:"class",hash:{},data:i}))?o:"")+"><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"reqHeaders"):e,{name:"if",hash:{},fn:t.program(3,i,0),inverse:t.program(6,i,0),data:i}))?o:"")+" </tbody></table><h2>Response Headers</h2><table "+(null!=(o=s(n,"class").call(a,"headers",{name:"class",hash:{},data:i}))?o:"")+"><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"resHeaders"):e,{name:"if",hash:{},fn:t.program(8,i,0),inverse:t.program(6,i,0),data:i}))?o:"")+" </tbody></table></div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"resTxt"):e,{name:"if",hash:{},fn:t.program(10,i,0),inverse:t.noop,data:i}))?o:"")+" </div><div "+(null!=(o=s(n,"class").call(a,"back",{name:"class",hash:{},data:i}))?o:"")+">Back to the List</div>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"requests"):e,{name:"each",hash:{},fn:t.program(2,i,0),inverse:t.noop,data:i}))?o:"")+" "},2:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <li class="eruda-request '+(null!=(o=l(n,"if").call(a,null!=e?l(e,"hasErr"):e,{name:"if",hash:{},fn:t.program(3,i,0),inverse:t.noop,data:i}))?o:"")+'" data-id="'+u(s(i&&l(i,"key"),e))+'"><span '+(null!=(o=l(n,"class").call(a,"name",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"name"):e,e))+"</span><span "+(null!=(o=l(n,"class").call(a,"status",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"status"):e,e))+"</span><span "+(null!=(o=l(n,"class").call(a,"method",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"method"):e,e))+"</span><span "+(null!=(o=l(n,"class").call(a,"type",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"subType"):e,e))+"</span><span "+(null!=(o=l(n,"class").call(a,"size",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"size"):e,e))+"</span><span "+(null!=(o=l(n,"class").call(a,"time",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"displayTime"):e,e))+"</span></li> "},3:function(t,e,n,r,i){return"eruda-error"},5:function(t,e,n,r,i){var o;return" <li><span "+(null!=(o=(t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]})(n,"class").call(null!=e?e:t.nullContext||{},"name",{name:"class",hash:{},data:i}))?o:"")+">Empty</span></li> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return null!=(o=a(n,"if").call(null!=e?e:t.nullContext||{},null!=e?a(e,"requests"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.program(5,i,0),data:i}))?o:""},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"._elements-highlight{$d:none;$po:absolute;$l:0;right:0;$z:-100;$pe:none!important}._elements-highlight *{$pe:none!important}._elements-highlight ._indicator{$po:absolute;$l:0;right:0;$w:100%;$h:100%}._elements-highlight ._margin{$po:absolute}._elements-highlight ._border{$po:absolute;$l:0;right:0;$w:100%;$h:100%}._elements-highlight ._padding{$po:absolute}._elements-highlight ._content{$po:absolute}._elements-highlight ._size{$po:absolute;$t:0;$l:0;$b:#fff;$c:#222;$fs:12px;$h:25px;$lh:25px;$ta:center;$p:0 5px;$ws:nowrap;$ox:hidden;$bs:0 2px 2px 0 rgba(0,0,0,.05),0 1px 4px 0 rgba(0,0,0,.08),0 3px 1px -2px rgba(0,0,0,.2)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"elements-highlight",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"indicator",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"margin",{name:"class",hash:{},data:i}))?o:"")+"></div><div "+(null!=(o=s(n,"class").call(a,"border",{name:"class",hash:{},data:i}))?o:"")+"></div><div "+(null!=(o=s(n,"class").call(a,"padding",{name:"class",hash:{},data:i}))?o:"")+"></div><div "+(null!=(o=s(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"></div></div><div "+(null!=(o=s(n,"class").call(a,"size",{name:"class",hash:{},data:i}))?o:"")+"></div></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_elements{$pb:40px;$fs:14px}#_elements ._show-area{$oy:auto;$wos:touch;$h:100%}#_elements ._parents{$ox:auto;$wos:touch;$b:var(--darker-background);$c:var(--primary);$p:10px;$ws:nowrap;$bb:1px solid var(--border);$cu:pointer;$fs:12px}#_elements ._parents li{$d:inline-block}#_elements ._parents li ._parent{$d:inline-block}#_elements ._parents li:last-child{margin-right:0}#_elements ._parents ._icon-arrow-right{$fs:8px;$po:relative;$t:-1px}#_elements ._breadcrumb{$b:var(--darker-background);$c:var(--primary);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$mb:10px;word-break:break-all;$p:10px;$fs:16px;$mh:40px;$bb:1px solid var(--border);$cu:pointer;$tr:background .3s,color .3s}#_elements ._breadcrumb:active{$b:var(--highlight);$c:var(--select-foreground)}#_elements ._breadcrumb:active span{$c:var(--select-foreground)}#_elements ._section{$bb:1px solid var(--border);$c:var(--foreground);$mb:10px}#_elements ._section h2{$c:var(--primary);$b:var(--darker-background);$bt:1px solid var(--border);$p:10px;$fs:14px;$tr:background .3s}#_elements ._section h2 ._btn{$d:flex;$ml:5px;$f:right;$c:var(--primary);$w:18px;$h:18px;justify-content:center;align-items:center;$fs:16px;$cu:pointer;$tr:color .3s}#_elements ._section h2 ._btn._search-keyword{$w:auto;max-width:80px;$fs:14px;$o:hidden;text-overflow:ellipsis;$d:inline-block}#_elements ._section h2 ._btn:active{$c:var(--accent)}#_elements ._section h2._active-effect{$cu:pointer}#_elements ._section h2._active-effect:active{$b:var(--highlight);$c:var(--select-foreground)}#_elements ._children{$b:var(--darker-background);$c:var(--foreground);$mb:10px!important;$bb:1px solid var(--border)}#_elements ._children li{$ox:auto;$wos:touch;$cu:default;$p:10px;$bt:1px solid var(--border);$ws:nowrap;$tr:background .3s,color .3s}#_elements ._children li span{$tr:color .3s}#_elements ._children li._active-effect{$cu:pointer}#_elements ._children li._active-effect:active{$b:var(--highlight);$c:var(--select-foreground)}#_elements ._children li._active-effect:active span{$c:var(--select-foreground)}#_elements ._attributes{$fs:12px}#_elements ._attributes a{$c:var(--link-color)}#_elements ._attributes ._table-wrapper{$ox:auto;$wos:touch}#_elements ._attributes table td{$p:5px 10px}#_elements ._text-content{$b:#fff}#_elements ._text-content ._content{$ox:auto;$wos:touch;$p:10px}#_elements ._style-color{$po:relative;$t:1px;$w:10px;$h:10px;$bra:50%;margin-right:2px;$bo:1px solid var(--border);$d:inline-block}#_elements ._box-model{$ox:auto;$wos:touch;$c:#222;$fs:12px;$p:10px;$ta:center;$ws:nowrap;$bb:1px solid var(--color)}#_elements ._box-model ._label{$po:absolute;$ml:3px;$p:0 2px}#_elements ._box-model ._bottom,#_elements ._box-model ._left,#_elements ._box-model ._right,#_elements ._box-model ._top{$d:inline-block}#_elements ._box-model ._left,#_elements ._box-model ._right{vertical-align:middle}#_elements ._box-model ._border,#_elements ._box-model ._content,#_elements ._box-model ._margin,#_elements ._box-model ._padding,#_elements ._box-model ._position{$po:relative;$b:#fff;$d:inline-block;$ta:center;vertical-align:middle;$p:3px;$m:3px}#_elements ._box-model ._position{$bo:1px grey dotted}#_elements ._box-model ._margin{$bo:1px dashed;$b:rgba(246,178,107,.66)}#_elements ._box-model ._border{$bo:1px #000 solid;$b:rgba(255,229,153,.66)}#_elements ._box-model ._padding{$bo:1px grey dashed;$b:rgba(147,196,125,.55)}#_elements ._box-model ._content{$bo:1px grey solid;min-width:100px;$b:rgba(111,168,220,.66)}#_elements ._computed-style{$fs:12px}#_elements ._computed-style a{$c:var(--link-color)}#_elements ._computed-style ._table-wrapper{$oy:auto;$wos:touch;max-height:200px;$bt:1px solid var(--border)}#_elements ._computed-style table td{$p:5px 10px}#_elements ._computed-style table td._key{$ws:nowrap;$c:var(--var-color)}#_elements ._styles{$fs:12px}#_elements ._styles ._style-wrapper{$p:10px}#_elements ._styles ._style-wrapper ._style-rules{$bo:1px solid var(--border);$p:10px;$mb:10px}#_elements ._styles ._style-wrapper ._style-rules ._rule{$pl:2em;word-break:break-all}#_elements ._styles ._style-wrapper ._style-rules ._rule a{$c:var(--link-color)}#_elements ._styles ._style-wrapper ._style-rules ._rule span{$c:var(--var-color)}#_elements ._styles ._style-wrapper ._style-rules:last-child{$mb:0}#_elements ._listeners{$fs:12px}#_elements ._listeners ._listener-wrapper{$p:10px}#_elements ._listeners ._listener-wrapper ._listener{$mb:10px;$o:hidden;$bo:1px solid var(--border)}#_elements ._listeners ._listener-wrapper ._listener ._listener-type{$p:10px;$b:var(--darker-background);$c:var(--primary)}#_elements ._listeners ._listener-wrapper ._listener ._listener-content li{$ox:auto;$wos:touch;$p:10px;$bt:none}#_elements ._bottom-bar{$h:40px;$b:var(--darker-background);$po:absolute;$l:0;bottom:0;$w:100%;$fs:0;$bt:1px solid var(--border)}#_elements ._bottom-bar ._btn{$cu:pointer;$ta:center;$c:var(--primary);$fs:14px;$lh:40px;$w:25%;$d:inline-block;$tr:background .3s,color .3s}#_elements ._bottom-bar ._btn:active{$b:var(--highlight);$c:var(--select-foreground)}#_elements ._bottom-bar ._btn._active{$c:var(--accent)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <ul "+(null!=(o=s(n,"class").call(a,"parents",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"parents"):e,{name:"each",hash:{},fn:t.program(2,i,0),inverse:t.noop,data:i}))?o:"")+" </ul> "},2:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <li><div "+(null!=(o=u(n,"class").call(a,"parent",{name:"class",hash:{},data:i}))?o:"")+' data-idx="'+t.escapeExpression(s(null!=e?u(e,"idx"):e,e))+'">'+(null!=(o=s(null!=e?u(e,"text"):e,e))?o:"")+"</div><span "+(null!=(o=u(n,"class").call(a,"icon-arrow-right",{name:"class",hash:{},data:i}))?o:"")+"></span></li> "},4:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <ul "+(null!=(o=s(n,"class").call(a,"children",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"children"):e,{name:"each",hash:{},fn:t.program(5,i,0),inverse:t.noop,data:i}))?o:"")+" </ul> "},5:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <li class="eruda-child '+(null!=(o=u(n,"if").call(a,null!=e?u(e,"isCmt"):e,{name:"if",hash:{},fn:t.program(6,i,0),inverse:t.noop,data:i}))?o:"")+" "+(null!=(o=u(n,"if").call(a,null!=e?u(e,"isEl"):e,{name:"if",hash:{},fn:t.program(8,i,0),inverse:t.noop,data:i}))?o:"")+'" data-idx="'+t.escapeExpression(s(null!=e?u(e,"idx"):e,e))+'">'+(null!=(o=s(null!=e?u(e,"text"):e,e))?o:"")+"</li> "},6:function(t,e,n,r,i){return"eruda-green"},8:function(t,e,n,r,i){return"eruda-active-effect"},10:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"attributes"):e,{name:"each",hash:{},fn:t.program(11,i,0),inverse:t.noop,data:i}))?o:"")+" "},11:function(t,e,n,r,i){var o,a=t.lambda,s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <tr><td class="eruda-attribute-name-color">'+t.escapeExpression(a(null!=e?s(e,"name"):e,e))+'</td><td class="eruda-string-color">'+(null!=(o=a(null!=e?s(e,"value"):e,e))?o:"")+"</td></tr> "},13:function(t,e,n,r,i){return" <tr><td>Empty</td></tr> "},15:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"styles section",{name:"class",hash:{},data:i}))?o:"")+"><h2>Styles</h2><div "+(null!=(o=s(n,"class").call(a,"style-wrapper",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"styles"):e,{name:"each",hash:{},fn:t.program(16,i,0),inverse:t.noop,data:i}))?o:"")+" </div></div> "},16:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"style-rules",{name:"class",hash:{},data:i}))?o:"")+"><div>"+t.escapeExpression(t.lambda(null!=e?s(e,"selectorText"):e,e))+" {</div> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"style"):e,{name:"each",hash:{},fn:t.program(17,i,0),inverse:t.noop,data:i}))?o:"")+" <div>}</div></div> "},17:function(t,e,n,r,i){var o,a=t.lambda,s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(null!=e?e:t.nullContext||{},"rule",{name:"class",hash:{},data:i}))?o:"")+"><span>"+t.escapeExpression(a(i&&s(i,"key"),e))+"</span>: "+(null!=(o=a(e,e))?o:"")+";</div> "},19:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=l(n,"class").call(a,"computed-style section",{name:"class",hash:{},data:i}))?o:"")+"><h2>Computed Style "+(null!=(o=l(n,"if").call(a,null!=e?l(e,"rmDefComputedStyle"):e,{name:"if",hash:{},fn:t.program(20,i,0),inverse:t.program(22,i,0),data:i}))?o:"")+" <div "+(null!=(o=l(n,"class").call(a,"btn computed-style-search",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=l(n,"class").call(a,"icon-search",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "+(null!=(o=l(n,"if").call(a,null!=e?l(e,"computedStyleSearchKeyword"):e,{name:"if",hash:{},fn:t.program(24,i,0),inverse:t.noop,data:i}))?o:"")+" </h2><div "+(null!=(o=l(n,"class").call(a,"box-model",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=l(n,"if").call(a,null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o,{name:"if",hash:{},fn:t.program(26,i,0),inverse:t.noop,data:i}))?o:"")+"<div "+(null!=(o=l(n,"class").call(a,"margin",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(a,"label",{name:"class",hash:{},data:i}))?o:"")+">margin</div><div "+(null!=(o=l(n,"class").call(a,"top",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"margin"):o)?l(o,"top"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"left",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"margin"):o)?l(o,"left"):o,e))+"</div><div "+(null!=(o=l(n,"class").call(a,"border",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(a,"label",{name:"class",hash:{},data:i}))?o:"")+">border</div><div "+(null!=(o=l(n,"class").call(a,"top",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"border"):o)?l(o,"top"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"left",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"border"):o)?l(o,"left"):o,e))+"</div><div "+(null!=(o=l(n,"class").call(a,"padding",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(a,"label",{name:"class",hash:{},data:i}))?o:"")+">padding</div><div "+(null!=(o=l(n,"class").call(a,"top",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"padding"):o)?l(o,"top"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"left",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"padding"):o)?l(o,"left"):o,e))+"</div><div "+(null!=(o=l(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"><span>"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"content"):o)?l(o,"width"):o,e))+"</span>&nbsp;×&nbsp;<span>"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"content"):o)?l(o,"height"):o,e))+"</span></div><div "+(null!=(o=l(n,"class").call(a,"right",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"padding"):o)?l(o,"right"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"bottom",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"padding"):o)?l(o,"bottom"):o,e))+"</div></div><div "+(null!=(o=l(n,"class").call(a,"right",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"border"):o)?l(o,"right"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"bottom",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"border"):o)?l(o,"bottom"):o,e))+"</div></div><div "+(null!=(o=l(n,"class").call(a,"right",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"margin"):o)?l(o,"right"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"bottom",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"margin"):o)?l(o,"bottom"):o,e))+"</div></div>"+(null!=(o=l(n,"if").call(a,null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o,{name:"if",hash:{},fn:t.program(28,i,0),inverse:t.noop,data:i}))?o:"")+" </div><div "+(null!=(o=l(n,"class").call(a,"table-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><table><tbody> "+(null!=(o=l(n,"each").call(a,null!=e?l(e,"computedStyle"):e,{name:"each",hash:{},fn:t.program(30,i,0),inverse:t.noop,data:i}))?o:"")+" </tbody></table></div></div> "},20:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"btn toggle-all-computed-style",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-compress",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "},22:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"btn toggle-all-computed-style",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-expand",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "},24:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"btn search-keyword",{name:"class",hash:{},data:i}))?o:"")+"> "+t.escapeExpression(t.lambda(null!=e?a(e,"computedStyleSearchKeyword"):e,e))+" </div> "},26:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=l(n,"class").call(a,"position",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(a,"label",{name:"class",hash:{},data:i}))?o:"")+">position</div><div "+(null!=(o=l(n,"class").call(a,"top",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o)?l(o,"top"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"left",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o)?l(o,"left"):o,e))+"</div>"},28:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=l(n,"class").call(a,"right",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o)?l(o,"right"):o,e))+"</div><br><div "+(null!=(o=l(n,"class").call(a,"bottom",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=(o=null!=(o=null!=e?l(e,"boxModel"):e)?l(o,"position"):o)?l(o,"bottom"):o,e))+"</div></div>"},30:function(t,e,n,r,i){var o,a=t.lambda,s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <tr><td "+(null!=(o=s(n,"class").call(null!=e?e:t.nullContext||{},"key",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(a(i&&s(i,"key"),e))+"</td><td>"+(null!=(o=a(e,e))?o:"")+"</td></tr> "},32:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"listeners section",{name:"class",hash:{},data:i}))?o:"")+"><h2>Event Listeners</h2><div "+(null!=(o=s(n,"class").call(a,"listener-wrapper",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"listeners"):e,{name:"each",hash:{},fn:t.program(33,i,0),inverse:t.noop,data:i}))?o:"")+" </div></div> "},33:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"listener",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"listener-type",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(i&&s(i,"key"),e))+"</div><ul "+(null!=(o=s(n,"class").call(a,"listener-content",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,e,{name:"each",hash:{},fn:t.program(34,i,0),inverse:t.noop,data:i}))?o:"")+" </ul></div> "},34:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <li "+(null!=(o=a(n,"if").call(null!=e?e:t.nullContext||{},null!=e?a(e,"useCapture"):e,{name:"if",hash:{},fn:t.program(35,i,0),inverse:t.noop,data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"listenerStr"):e,e))+"</li> "},35:function(t,e,n,r,i){var o;return null!=(o=(t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]})(n,"class").call(null!=e?e:t.nullContext||{},"capture",{name:"class",hash:{},data:i}))?o:""},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return(null!=(o=s(n,"if").call(a,null!=e?s(e,"parents"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=s(n,"class").call(a,"breadcrumb",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=t.lambda(null!=e?s(e,"name"):e,e))?o:"")+" </div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"children"):e,{name:"if",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" <div "+(null!=(o=s(n,"class").call(a,"attributes section",{name:"class",hash:{},data:i}))?o:"")+"><h2>Attributes</h2><div "+(null!=(o=s(n,"class").call(a,"table-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><table><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"attributes"):e,{name:"if",hash:{},fn:t.program(10,i,0),inverse:t.program(13,i,0),data:i}))?o:"")+" </tbody></table></div></div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"styles"):e,{name:"if",hash:{},fn:t.program(15,i,0),inverse:t.noop,data:i}))?o:"")+" "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"computedStyle"):e,{name:"if",hash:{},fn:t.program(19,i,0),inverse:t.noop,data:i}))?o:"")+" "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"listeners"):e,{name:"if",hash:{},fn:t.program(32,i,0),inverse:t.noop,data:i}))?o:"")},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"bottom-bar",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"btn select",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon icon-select",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn refresh",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn highlight",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon icon-eye",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn reset",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon icon-reset",{name:"class",hash:{},data:i}))?o:"")+"></span></div></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"._search-highlight-block{$d:inline}._search-highlight-block ._keyword{$b:var(--console-warn-background);$c:var(--console-warn-foreground)}",""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_snippets{$oy:auto;$wos:touch;$p:10px}#_snippets ._section{$mb:10px;$bo:1px solid var(--border);$o:hidden;$cu:pointer}#_snippets ._section:active ._name{$b:var(--highlight);$c:var(--select-foreground)}#_snippets ._section ._name{$p:10px;$c:var(--primary);$b:var(--darker-background);$tr:background .3s}#_snippets ._section ._name ._btn{$ml:10px;$f:right;$ta:center;$w:18px;$h:18px;$lh:18px;$fs:12px}#_snippets ._section ._description{$c:var(--foreground);$p:10px;$tr:background .3s}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o=t.lambda,a=t.escapeExpression,s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <div class="eruda-section eruda-run" data-idx="'+a(o(i&&s(i,"index"),e))+'"><h2 class="eruda-name">'+a(o(null!=e?s(e,"name"):e,e))+' <div class="eruda-btn"><span class="eruda-icon-play"></span></div></h2><div class="eruda-description"> '+a(o(null!=e?s(e,"desc"):e,e))+" </div></div> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"snippets"):e,{name:"each",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:""},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_resources{$oy:auto;$wos:touch;$p:10px;$fs:14px}#_resources ._section{$mb:10px;$o:hidden;$bo:1px solid var(--border)}#_resources ._section ._content{$oy:auto;$wos:touch;max-height:400px}#_resources ._section._warn{$bo:1px solid var(--console-warn-border)}#_resources ._section._warn ._title{$b:var(--console-warn-background);$c:var(--console-warn-foreground)}#_resources ._section._danger{$bo:1px solid var(--console-error-border)}#_resources ._section._danger ._title{$b:var(--console-error-background);$c:var(--console-error-foreground)}#_resources ._title{$p:10px;$c:var(--primary);$b:var(--darker-background)}#_resources ._title ._btn{$d:flex;$ml:5px;$f:right;$c:var(--primary);$w:18px;$h:18px;justify-content:center;align-items:center;$fs:16px;$cu:pointer;$tr:color .3s}#_resources ._title ._btn._search-keyword{$w:auto;max-width:80px;$fs:14px;$o:hidden;text-overflow:ellipsis;$d:inline-block}#_resources ._title ._btn:active{$c:var(--accent)}#_resources ._link-list{$fs:12px;$c:var(--foreground)}#_resources ._link-list li{$p:10px;word-break:break-all}#_resources ._link-list li a{$c:var(--link-color)!important}#_resources ._image-list{$c:var(--foreground);$fs:12px;$d:flex;flex-wrap:wrap;$p:10px!important}#_resources ._image-list:after{$co:'';$d:block;$cl:both}#_resources ._image-list li{flex-grow:1;$cu:pointer;$oy:hidden}#_resources ._image-list li._image{$h:100px;$fs:0}#_resources ._image-list li img{$h:100px;min-width:100%;-o-object-fit:cover;object-fit:cover}#_resources table{$c:var(--foreground);$bc:collapse;$w:100%;$fs:12px}#_resources table tr:nth-child(even){$b:var(--contrast)}#_resources table td{$p:10px;word-break:break-all}#_resources table td._key{$ox:auto;$wos:touch;$ws:nowrap;max-width:120px}#_resources table td._control{$p:0;$fs:0;$w:40px}#_resources table td._control ._icon-delete{$cu:pointer;$c:var(--primary);$fs:14px;$d:inline-block;$w:40px;$h:40px;$ta:center;$lh:40px;$tr:color .3s}#_resources table td._control ._icon-delete:active{$c:var(--accent)}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"btn search-keyword",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"localStoreSearchKeyword"):e,e))+"</div>"},3:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"localStoreData"):e,{name:"each",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" "},4:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <tr><td "+(null!=(o=l(n,"class").call(a,"key",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"key"):e,e))+"</td><td "+(null!=(o=l(n,"class").call(a,"storage-val",{name:"class",hash:{},data:i}))?o:"")+' data-key="'+u(s(null!=e?l(e,"key"):e,e))+'" data-type="local">'+u(s(null!=e?l(e,"val"):e,e))+"</td><td "+(null!=(o=l(n,"class").call(a,"control",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=l(n,"class").call(a,"icon-delete delete-storage",{name:"class",hash:{},data:i}))?o:"")+' data-key="'+u(s(null!=e?l(e,"key"):e,e))+'" data-type="local"></span></td></tr> '},6:function(t,e,n,r,i){return" <tr><td>Empty</td></tr> "},8:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"btn search-keyword",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"sessionStoreSearchKeyword"):e,e))+"</div>"},10:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"sessionStoreData"):e,{name:"each",hash:{},fn:t.program(11,i,0),inverse:t.noop,data:i}))?o:"")+" "},11:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <tr><td "+(null!=(o=l(n,"class").call(a,"key",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"key"):e,e))+"</td><td "+(null!=(o=l(n,"class").call(a,"storage-val",{name:"class",hash:{},data:i}))?o:"")+' data-key="'+u(s(null!=e?l(e,"key"):e,e))+'" data-type="session">'+u(s(null!=e?l(e,"val"):e,e))+"</td><td "+(null!=(o=l(n,"class").call(a,"control",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=l(n,"class").call(a,"icon-delete delete-storage",{name:"class",hash:{},data:i}))?o:"")+' data-key="'+u(s(null!=e?l(e,"key"):e,e))+'" data-type="session"></span></td></tr> '},13:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"btn search-keyword",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"cookieSearchKeyword"):e,e))+"</div>"},15:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"cookieData"):e,{name:"each",hash:{},fn:t.program(16,i,0),inverse:t.noop,data:i}))?o:"")+" "},16:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <tr><td "+(null!=(o=l(n,"class").call(a,"key",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"key"):e,e))+"</td><td>"+u(s(null!=e?l(e,"val"):e,e))+"</td><td "+(null!=(o=l(n,"class").call(a,"control",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=l(n,"class").call(a,"icon-delete delete-cookie",{name:"class",hash:{},data:i}))?o:"")+' data-key="'+u(s(null!=e?l(e,"key"):e,e))+'"></span></td></tr> '},18:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"scriptData"):e,{name:"each",hash:{},fn:t.program(19,i,0),inverse:t.noop,data:i}))?o:"")+" "},19:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <li><a href="'+s(a(e,e))+'" target="_blank" '+(null!=(o=u(n,"class").call(null!=e?e:t.nullContext||{},"js-link",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(e,e))+"</a></li> "},21:function(t,e,n,r,i){return" <li>Empty</li> "},23:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"stylesheetData"):e,{name:"each",hash:{},fn:t.program(24,i,0),inverse:t.noop,data:i}))?o:"")+" "},24:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <li><a href="'+s(a(e,e))+'" target="_blank" '+(null!=(o=u(n,"class").call(null!=e?e:t.nullContext||{},"css-link",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(e,e))+"</a></li> "},26:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"iframeData"):e,{name:"each",hash:{},fn:t.program(27,i,0),inverse:t.noop,data:i}))?o:"")+" "},27:function(t,e,n,r,i){var o,a=t.lambda,s=t.escapeExpression,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return' <li><a href="'+s(a(e,e))+'" target="_blank" '+(null!=(o=u(n,"class").call(null!=e?e:t.nullContext||{},"iframe-link",{name:"class",hash:{},data:i}))?o:"")+">"+s(a(e,e))+"</a></li> "},29:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"imageData"):e,{name:"each",hash:{},fn:t.program(30,i,0),inverse:t.noop,data:i}))?o:"")+" "},30:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <li "+(null!=(o=s(n,"class").call(a,"image",{name:"class",hash:{},data:i}))?o:"")+'><img src="'+t.escapeExpression(t.lambda(e,e))+'" data-exclude="true" '+(null!=(o=s(n,"class").call(a,"img-link",{name:"class",hash:{},data:i}))?o:"")+"></li> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"section local-storage",{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Local Storage<div "+(null!=(o=s(n,"class").call(a,"btn refresh-local-storage",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn clear-storage",{name:"class",hash:{},data:i}))?o:"")+' data-type="local"><span '+(null!=(o=s(n,"class").call(a,"icon-clear",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn search",{name:"class",hash:{},data:i}))?o:"")+' data-type="local"><span '+(null!=(o=s(n,"class").call(a,"icon-search",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"localStoreSearchKeyword"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" </h2><div "+(null!=(o=s(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"><table><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"localStoreData"):e,{name:"if",hash:{},fn:t.program(3,i,0),inverse:t.program(6,i,0),data:i}))?o:"")+" </tbody></table></div></div><div "+(null!=(o=s(n,"class").call(a,"section session-storage",{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Session Storage<div "+(null!=(o=s(n,"class").call(a,"btn refresh-session-storage",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn clear-storage",{name:"class",hash:{},data:i}))?o:"")+' data-type="session"><span '+(null!=(o=s(n,"class").call(a,"icon-clear",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn search",{name:"class",hash:{},data:i}))?o:"")+' data-type="session"><span '+(null!=(o=s(n,"class").call(a,"icon-search",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"sessionStoreSearchKeyword"):e,{name:"if",hash:{},fn:t.program(8,i,0),inverse:t.noop,data:i}))?o:"")+" </h2><div "+(null!=(o=s(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"><table><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"sessionStoreData"):e,{name:"if",hash:{},fn:t.program(10,i,0),inverse:t.program(6,i,0),data:i}))?o:"")+" </tbody></table></div></div><div "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,"section cookie ",null!=e?s(e,"cookieState"):e,{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Cookie<div "+(null!=(o=s(n,"class").call(a,"btn refresh-cookie",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn clear-cookie",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-clear",{name:"class",hash:{},data:i}))?o:"")+"></span></div><div "+(null!=(o=s(n,"class").call(a,"btn search",{name:"class",hash:{},data:i}))?o:"")+' data-type="cookie"><span '+(null!=(o=s(n,"class").call(a,"icon-search",{name:"class",hash:{},data:i}))?o:"")+"></span></div> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"cookieSearchKeyword"):e,{name:"if",hash:{},fn:t.program(13,i,0),inverse:t.noop,data:i}))?o:"")+" </h2><div "+(null!=(o=s(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"><table><tbody> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"cookieData"):e,{name:"if",hash:{},fn:t.program(15,i,0),inverse:t.program(6,i,0),data:i}))?o:"")+" </tbody></table></div></div><div "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,"section script ",null!=e?s(e,"scriptState"):e,{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Script<div "+(null!=(o=s(n,"class").call(a,"btn refresh-script",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div></h2><ul "+(null!=(o=s(n,"class").call(a,"link-list",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"scriptData"):e,{name:"if",hash:{},fn:t.program(18,i,0),inverse:t.program(21,i,0),data:i}))?o:"")+" </ul></div><div "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,"section stylesheet ",null!=e?s(e,"stylesheetState"):e,{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Stylesheet<div "+(null!=(o=s(n,"class").call(a,"btn refresh-stylesheet",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div></h2><ul "+(null!=(o=s(n,"class").call(a,"link-list",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"stylesheetData"):e,{name:"if",hash:{},fn:t.program(23,i,0),inverse:t.program(21,i,0),data:i}))?o:"")+" </ul></div><div "+(null!=(o=s(n,"class").call(a,"section iframe",{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">Iframe<div "+(null!=(o=s(n,"class").call(a,"btn refresh-iframe",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div></h2><ul "+(null!=(o=s(n,"class").call(a,"link-list",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"iframeData"):e,{name:"if",hash:{},fn:t.program(26,i,0),inverse:t.program(21,i,0),data:i}))?o:"")+" </ul></div><div "+(null!=(o=s(n,"class").call(a,"section image",{name:"class",hash:{},data:i}))?o:"")+"><h2 "+(null!=(o=s(n,"class").call(a,s(n,"concat").call(a,"title ",null!=e?s(e,"imageState"):e,{name:"concat",hash:{},data:i}),{name:"class",hash:{},data:i}))?o:"")+">Image<div "+(null!=(o=s(n,"class").call(a,"btn refresh-image",{name:"class",hash:{},data:i}))?o:"")+"><span "+(null!=(o=s(n,"class").call(a,"icon-refresh",{name:"class",hash:{},data:i}))?o:"")+"></span></div></h2><ul "+(null!=(o=s(n,"class").call(a,"image-list",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"if").call(a,null!=e?s(e,"imageData"):e,{name:"if",hash:{},fn:t.program(29,i,0),inverse:t.program(21,i,0),data:i}))?o:"")+" </ul></div>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_info{$oy:auto;$wos:touch}#_info li{$m:10px;$bo:1px solid var(--border)}#_info li ._content,#_info li ._title{$p:10px}#_info li ._title{$pb:0;$fs:16px;$c:var(--accent)}#_info li ._content{$m:0;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$c:var(--foreground);word-break:break-all}#_info li ._content table{$w:100%;$bc:collapse}#_info li ._content table td,#_info li ._content table th{$bo:1px solid var(--border);$p:10px}#_info li ._content *{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}#_info li ._content a{$c:var(--link-color)}#_info li ._device-key,#_info li ._system-key{$w:100px}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <li><h2 "+(null!=(o=u(n,"class").call(a,"title",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(s(null!=e?u(e,"name"):e,e))+"</h2><div "+(null!=(o=u(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+">"+(null!=(o=s(null!=e?u(e,"val"):e,e))?o:"")+"</div></li> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<ul> "+(null!=(o=a(n,"each").call(null!=e?e:t.nullContext||{},null!=e?a(e,"infos"):e,{name:"each",hash:{},fn:t.program(1,i,0),inverse:t.noop,data:i}))?o:"")+" </ul>"},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,"#_sources{$oy:auto;$wos:touch;$c:var(--foreground)}#_sources ._code-wrapper,#_sources ._raw-wrapper{$ox:auto;$wos:touch;$w:100%;$mh:100%}#_sources ._raw{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$p:10px}#_sources ._code{$fs:12px}#_sources ._code ._content *{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}#_sources pre._code{$p:10px}#_sources table._code{$bc:collapse}#_sources table._code ._gutter{$b:var(--background);$c:var(--primary)}#_sources table._code ._line-num{$br:1px solid var(--border);$p:0 3px 0 5px;$ta:right}#_sources table._code ._code-line{$p:0 4px;$ws:pre}#_sources ._image ._breadcrumb{$b:var(--darker-background);$c:var(--primary);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text;$mb:10px;word-break:break-all;$p:10px;$fs:16px;$mh:40px;$bb:1px solid var(--border)}#_sources ._image ._img-container{$ta:center}#_sources ._image ._img-container img{max-width:100%}#_sources ._image ._img-info{$ta:center;$m:20px 0;$c:var(--foreground)}#_sources ._json{$p:0 10px}#_sources ._json *{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;$us:text}#_sources iframe{$w:100%;$h:100%}",""]),t.exports=e},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({1:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"code-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><table "+(null!=(o=s(n,"class").call(a,"code",{name:"class",hash:{},data:i}))?o:"")+"><tbody><tr><td "+(null!=(o=s(n,"class").call(a,"gutter",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"code"):e,{name:"each",hash:{},fn:t.program(2,i,0),inverse:t.noop,data:i}))?o:"")+" </td><td "+(null!=(o=s(n,"class").call(a,"content",{name:"class",hash:{},data:i}))?o:"")+"> "+(null!=(o=s(n,"each").call(a,null!=e?s(e,"code"):e,{name:"each",hash:{},fn:t.program(4,i,0),inverse:t.noop,data:i}))?o:"")+" </td></tr></tbody></table></div> "},2:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"line-num",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?a(e,"idx"):e,e))+"</div> "},4:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <pre "+(null!=(o=a(n,"class").call(null!=e?e:t.nullContext||{},"code-line",{name:"class",hash:{},data:i}))?o:"")+">"+(null!=(o=t.lambda(null!=e?a(e,"val"):e,e))?o:"")+"</pre> "},6:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return" <div "+(null!=(o=s(n,"class").call(a,"code-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><pre "+(null!=(o=s(n,"class").call(a,"code",{name:"class",hash:{},data:i}))?o:"")+">"+(null!=(o=t.lambda(null!=e?s(e,"code"):e,e))?o:"")+"</pre></div> "},compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return null!=(o=a(n,"if").call(null!=e?e:t.nullContext||{},null!=e?a(e,"showLineNum"):e,{name:"if",hash:{},fn:t.program(1,i,0),inverse:t.program(6,i,0),data:i}))?o:""},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lambda,u=t.escapeExpression,l=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=l(n,"class").call(a,"image",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=l(n,"class").call(a,"breadcrumb",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"src"):e,e))+"</div><div "+(null!=(o=l(n,"class").call(a,"img-container",{name:"class",hash:{},data:i}))?o:"")+' data-exclude="true"><img src="'+u(s(null!=e?l(e,"src"):e,e))+'"></div><div '+(null!=(o=l(n,"class").call(a,"img-info",{name:"class",hash:{},data:i}))?o:"")+">"+u(s(null!=e?l(e,"width"):e,e))+" × "+u(s(null!=e?l(e,"height"):e,e))+"</div></div>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o;return"<ul "+(null!=(o=(t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]})(n,"class").call(null!=e?e:t.nullContext||{},"json",{name:"class",hash:{},data:i}))?o:"")+"></ul>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=null!=e?e:t.nullContext||{},s=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return"<div "+(null!=(o=s(n,"class").call(a,"raw-wrapper",{name:"class",hash:{},data:i}))?o:"")+"><div "+(null!=(o=s(n,"class").call(a,"raw",{name:"class",hash:{},data:i}))?o:"")+">"+t.escapeExpression(t.lambda(null!=e?s(e,"val"):e,e))+"</div></div>"},useData:!0})},function(t,e,n){var r=n(7);t.exports=(r.default||r).template({compiler:[8,">= 4.3.0"],main:function(t,e,n,r,i){var o,a=t.lookupProperty||function(t,e){if(Object.prototype.hasOwnProperty.call(t,e))return t[e]};return'<iframe src="'+(null!=(o=t.lambda(null!=e?a(e,"src"):e,e))?o:"")+'"></iframe>'},useData:!0})},function(t,e,n){(e=n(8)(!1)).push([t.i,'.luna-object-viewer{$ox:auto;$wos:touch;$cu:default;$fs:12px;$lh:1.2;$mh:100%;$c:#333;list-style:none!important}.luna-object-viewer>li>.luna-object-viewer-key{$d:none}.luna-object-viewer>li{$p:10px 0}.luna-object-viewer ul{list-style:none!important}.luna-object-viewer ul{$p:0!important;$pl:15px!important;$m:0!important}.luna-object-viewer li{$po:relative;$ws:nowrap;$lh:16px;$mh:16px}.luna-object-viewer span{$po:static!important}.luna-object-viewer li .luna-object-viewer-collapsed~.luna-object-viewer-close:before{$c:#999}.luna-object-viewer-array .luna-object-viewer-object .luna-object-viewer-key{$d:inline}.luna-object-viewer-null{$c:grey}.luna-object-viewer-regexp,.luna-object-viewer-string{$c:#1a1aa6}.luna-object-viewer-number{$c:#1c00cf}.luna-object-viewer-boolean{$c:#881280}.luna-object-viewer-special{$c:grey}.luna-object-viewer-key,.luna-object-viewer-key-lighter{$c:#c80000}.luna-object-viewer-key-lighter{opacity:.6}.luna-object-viewer-expanded:before{$co:"";$w:0;$h:0;$bo:4px solid transparent;$po:absolute;$btc:#333;$l:-12px;$t:6px}.luna-object-viewer-collapsed:before{$co:"";$blc:#333;$btc:transparent;$l:-10px;$t:4px}.luna-object-viewer-hidden~ul{$d:none}',""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,".luna-notification{$po:fixed;$t:0;$l:0;$w:100%;$h:100%;$p:20px;$bsi:border-box;$pe:none;$d:flex;flex-direction:column;$fs:14px}.luna-notification-item{$d:flex;$bs:0 3px 7px 0 rgba(0,0,0,.25);$p:10px 16px;$b:#fff}.luna-notification-lower{$mt:16px}.luna-notification-upper{$mb:16px}",""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,'.luna-object-viewer{$c:var(--primary);$fs:12px!important}.luna-object-viewer>li{$p:10px 0!important}.luna-object-viewer-null{$c:var(--operator-color)}.luna-object-viewer-regexp,.luna-object-viewer-string{$c:var(--string-color)}.luna-object-viewer-number{$c:var(--number-color)}.luna-object-viewer-boolean{$c:var(--keyword-color)}.luna-object-viewer-special{$c:var(--operator-color)}.luna-object-viewer-key,.luna-object-viewer-key-lighter{$c:var(--var-color)}.luna-object-viewer-expanded:before{border-color:transparent;$btc:var(--foreground)}.luna-object-viewer-collapsed:before{$btc:transparent;$blc:var(--foreground)}.luna-notification{$pe:none!important;$p:10px;$z:1000}.luna-notification-item{$z:500;$c:var(--foreground);$b:var(--background);$bs:none;$p:5px 10px;$bo:1px solid var(--border)}.luna-notification-upper{$mb:10px}.luna-notification-lower{$mt:10px}._container{$pe:none;$po:fixed;$l:0;$t:0;$w:100%;$h:100%;$z:100000;$c:var(--foreground);$ff:".SFNSDisplay-Regular","Helvetica Neue","Lucida Grande","Segoe UI",Tahoma,sans-seri;$fs:14px;direction:ltr}._container *{$bsi:border-box;$pe:all;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;$us:none;-webkit-tap-highlight-color:transparent;-webkit-text-size-adjust:none}._container ul{list-style:none;$p:0;$m:0}._container h1,._container h2,._container h3,._container h4{$m:0}._hidden{$d:none}._tag-name-color{$c:var(--tag-name-color)}._function-color{$c:var(--function-color)}._attribute-name-color{$c:var(--attribute-name-color)}._operator-color{$c:var(--operator-color)}._string-color{$c:var(--string-color)}',""]),t.exports=e},function(t,e,n){(e=n(8)(!1)).push([t.i,"._container a,._container abbr,._container acronym,._container address,._container applet,._container article,._container aside,._container audio,._container b,._container big,._container blockquote,._container canvas,._container caption,._container center,._container cite,._container code,._container dd,._container del,._container details,._container dfn,._container dl,._container dt,._container em,._container embed,._container fieldset,._container figcaption,._container figure,._container footer,._container form,._container h1,._container h2,._container h3,._container h4,._container h5,._container h6,._container header,._container hgroup,._container i,._container iframe,._container img,._container ins,._container kbd,._container label,._container legend,._container li,._container mark,._container menu,._container nav,._container object,._container ol,._container output,._container p,._container pre,._container q,._container ruby,._container s,._container samp,._container section,._container small,._container span,._container strike,._container strong,._container sub,._container summary,._container sup,._container table,._container tbody,._container td,._container tfoot,._container th,._container thead,._container time,._container tr,._container tt,._container u,._container ul,._container var,._container video{$m:0;$p:0;$bo:0;$fs:100%;font:inherit;vertical-align:baseline}._container article,._container aside,._container details,._container figcaption,._container figure,._container footer,._container header,._container hgroup,._container menu,._container nav,._container section{$d:block}._container body{$lh:1}._container ol,._container ul{list-style:none}._container blockquote,._container q{quotes:none}._container blockquote:after,._container blockquote:before,._container q:after,._container q:before{$co:'';$co:none}._container table{$bc:collapse;border-spacing:0}",""]),t.exports=e},function(t,e,n){"use strict";n.r(e);var r=n(2),i=n.n(r),o=n(3),a=n.n(o),s=n(5),u=n.n(s),l=n(6),c=n.n(l),h=n(1),p=n.n(h),f=n(27),_=n.n(f),d=n(0),v=new d.c;v.ADD="ADD",v.SHOW="SHOW",v.SCALE="SCALE";var g=v,m=n(4),b=n.n(m),y=Object(d.b)({init:function(t){this._$el=t},show:function(){return this._$el.show(),this},hide:function(){return this._$el.hide(),this},destroy:function(){this._$el.remove()}}),w=["background","foreground","selectForeground","accent","highlight","border","primary","contrast","varColor","stringColor","keywordColor","numberColor","operatorColor","linkColor","textColor","tagNameColor","functionColor","attributeNameColor","commentColor"],x=w.length;function k(t){for(var e={},n=0;n<x;n++)e[w[n]]=t[n];return e}function O(t){return Object(d.D)(t)&&(t=k(t)),t.darkerBackground||(t.darkerBackground=t.contrast),Object(d.y)({consoleWarnBackground:"#332a00",consoleWarnForeground:"#ffcb6b",consoleWarnBorder:"#650",consoleErrorBackground:"#290000",consoleErrorForeground:"#ff8080",consoleErrorBorder:"#5c0000",light:"#ccc",dark:"#aaa"},t)}function $(t){return Object(d.D)(t)&&(t=k(t)),t.darkerBackground||(t.darkerBackground=t.contrast),Object(d.y)({consoleWarnBackground:"#fffbe5",consoleWarnForeground:"#5c5c00",consoleWarnBorder:"#fff5c2",consoleErrorBackground:"#fff0f0",consoleErrorForeground:"#f00",consoleErrorBorder:"#ffd6d6",light:"#fff",dark:"#eee"},t)}var j={Light:$({darkerBackground:"#f3f3f3",background:"#fff",foreground:"#333",selectForeground:"#333",accent:"#1a73e8",highlight:"#eaeaea",border:"#ccc",primary:"#333",contrast:"#f2f7fd",varColor:"#c80000",stringColor:"#1a1aa6",keywordColor:"#881280",numberColor:"#1c00cf",operatorColor:"#808080",linkColor:"#1155cc",textColor:"#8097bd",tagNameColor:"#881280",functionColor:"#222",attributeNameColor:"#994500",commentColor:"#236e25",cssProperty:"#c80000"}),Dark:O({darkerBackground:"#333",background:"#242424",foreground:"#a5a5a5",selectForeground:"#eaeaea",accent:"#555",highlight:"#000",border:"#3d3d3d",primary:"#ccc",contrast:"#0b2544",varColor:"#e36eec",stringColor:"#f29766",keywordColor:"#9980ff",numberColor:"#9980ff",operatorColor:"#7f7f7f",linkColor:"#ababab",textColor:"#42597f",tagNameColor:"#5db0d7",functionColor:"#d5d5d5",attributeNameColor:"#9bbbdc",commentColor:"#747474"}),"Material Oceanic":O(["#263238","#B0BEC5","#FFFFFF","#009688","#425B67","#2A373E","#607D8B","#1E272C","#eeffff","#c3e88d","#c792ea","#f78c6c","#89ddff","#80cbc4","#B0BEC5","#f07178","#82aaff","#ffcb6b","#546e7a"]),"Material Darker":O(["#212121","#B0BEC5","#FFFFFF","#FF9800","#3F3F3F","#292929","#727272","#1A1A1A","#eeffff","#c3e88d","#c792ea","#f78c6c","#89ddff","#80cbc4","#B0BEC5","#f07178","#82aaff","#ffcb6b","#616161"]),"Material Lighter":$(["#FAFAFA","#546E7A","#546e7a","#00BCD4","#E7E7E8","#d3e1e8","#94A7B0","#F4F4F4","#272727","#91B859","#7C4DFF","#F76D47","#39ADB5","#39ADB5","#546E7A","#E53935","#6182B8","#F6A434","#AABFC9"]),"Material Palenight":O(["#292D3E","#A6ACCD","#FFFFFF","#ab47bc","#444267","#2b2a3e","#676E95","#202331","#eeffff","#c3e88d","#c792ea","#f78c6c","#89ddff","#80cbc4","#A6ACCD","#f07178","#82aaff","#ffcb6b","#676E95"]),"Material Deep Ocean":O(["#0F111A","#8F93A2","#FFFFFF","#84ffff","#1F2233","#41465b","#4B526D","#090B10","#eeffff","#c3e88d","#c792ea","#f78c6c","#89ddff","#80cbc4","#8F93A2","#f07178","#82aaff","#ffcb6b","#717CB4"]),"Monokai Pro":O(["#2D2A2E","#fcfcfa","#FFFFFF","#ffd866","#5b595c","#423f43","#939293","#221F22","#FCFCFA","#FFD866","#FF6188","#AB9DF2","#FF6188","#78DCE8","#fcfcfa","#FF6188","#A9DC76","#78DCE8","#727072"]),Dracula:O(["#282A36","#F8F8F2","#8BE9FD","#FF79C5","#6272A4","#21222C","#6272A4","#191A21","#F8F8F2","#F1FA8C","#FF79C6","#BD93F9","#FF79C6","#F1FA8C","#F8F8F2","#FF79C6","#50FA78","#50FA7B","#6272A4"]),"Arc Dark":O(["#2f343f","#D3DAE3","#FFFFFF","#42A5F5","#3F3F46","#404552","#8b9eb5","#262b33","#CF6A4C","#8F9D6A","#9B859D","#CDA869","#A7A7A7","#7587A6","#D3DAE3","#CF6A4C","#7587A6","#F9EE98","#747C84"]),"Atom One Dark":O(["#282C34","#979FAD","#FFFFFF","#2979ff","#383D48","#2e3239","#979FAD","#21252B","#D19A66","#98C379","#C679DD","#D19A66","#61AFEF","#56B6C2","#979FAD","#F07178","#61AEEF","#E5C17C","#59626F"]),"Atom One Light":$(["#FAFAFA","#232324","#232324","#2979ff","#EAEAEB","#DBDBDC","#9D9D9F","#FFFFFF","#986801","#50A14E","#A626A4","#986801","#4078F2","#0184BC","#232324","#E4564A","#4078F2","#C18401","#A0A1A7"]),"Solarized Dark":O(["#002B36","#839496","#FFFFFF","#d33682","#11353F","#0D3640","#586e75","#00252E","#268BD2","#2AA198","#859900","#D33682","#93A1A1","#268BD2","#839496","#268BD2","#B58900","#B58900","#657B83"]),"Solarized Light":$(["#fdf6e3","#586e75","#002b36","#d33682","#F6F0DE","#f7f2e2","#93a1a1","#eee8d5","#268BD2","#2AA198","#859900","#D33682","#657B83","#268BD2","#586e75","#268BD2","#B58900","#657B83","#93A1A1"]),Github:$(["#F7F8FA","#5B6168","#FFFFFF","#79CB60","#CCE5FF","#DFE1E4","#292D31","#FFFFFF","#24292E","#032F62","#D73A49","#005CC5","#D73A49","#005CC5","#5B6168","#22863A","#6F42C1","#6F42C1","#6A737D"]),"Night Owl":O(["#011627","#b0bec5","#ffffff","#7e57c2","#152C3B","#2a373e","#607d8b","#001424","#addb67","#ecc48d","#c792ea","#f78c6c","#c792ea","#80CBC4","#b0bec5","#7fdbca","#82AAFF","#FAD430","#637777"]),"Light Owl":$(["#FAFAFA","#546e7a","#403f53","#269386","#E0E7EA","#efefef","#403F53","#FAFAFA","#0C969B","#c96765","#994cc3","#aa0982","#7d818b","#994cc3","#546e7a","#994cc3","#4876d6","#4876d6","#637777"])},S=n(28),E=n.n(S),A=[],T=1,C=j.Light,P=function t(e,n){e=Object(d.ub)(e);for(var r=0,i=A.length;r<i;r++)if(A[r].css===e)return;n=n||t.container||document.head;var o=document.createElement("style");o.type="text/css",n.appendChild(o);var a={css:e,el:o,container:n};return D(a),A.push(a),a};function N(){Object(d.t)(A,(function(t){return D(t)}))}function D(t){var e=t.css,n=t.el;e=(e=e.replace(/(\d+)px/g,(function(t,e){return+e*T+"px"}))).replace(/_/g,"eruda-"),Object(d.t)(E.a,(function(t,n){e=e.replace(new RegExp(Object(d.x)("$".concat(t,":")),"g"),n+":")}));var r=Object(d.V)(j.Light);Object(d.t)(r,(function(t){e=e.replace(new RegExp("var\\(--".concat(Object(d.U)(t),"\\)"),"g"),C[t])})),n.innerText=e}P.setScale=function(t){T=t,N()},P.setTheme=function(t){C=Object(d.S)(t)?j[t]||j.Light:Object(d.q)(t,j.Light),N()},P.getCurTheme=function(){return C},P.getThemes=function(){return j},P.clear=function(){Object(d.t)(A,(function(t){var e=t.container,n=t.el;return e.removeChild(n)})),A=[]},P.remove=function(t){A=Object(d.z)(A,(function(e){return e!==t})),t.container.removeChild(t.el)};var R=P;function M(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var I=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(M()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(39)),t.name="settings",t._switchTpl=n(40),t._selectTpl=n(56),t._rangeTpl=n(57),t._colorTpl=n(58),t._settings=[],t}return a()(o,[{key:"init",value:function(t){b()(p()(o.prototype),"init",this).call(this,t),this._bindEvent()}},{key:"remove",value:function(t,e){var n=this;return Object(d.S)(t)?this._$el.find(".eruda-text").each((function(){var e=Object(d.a)(this);e.text()===t&&e.remove()})):this._settings=Object(d.z)(this._settings,(function(r){return r.config!==t||r.key!==e||(n._$el.find("#"+r.id).remove(),!1)})),this._cleanSeparator(),this}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style)}},{key:"clear",value:function(){this._settings=[],this._$el.html("")}},{key:"switch",value:function(t,e,n){var r=this._genId("settings");return this._settings.push({config:t,key:e,id:r}),this._$el.append(this._switchTpl({desc:n,key:e,id:r,val:t.get(e)})),this}},{key:"color",value:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:["#2196f3","#707d8b","#f44336","#009688","#ffc107"],i=this._genId("settings");return this._settings.push({config:t,key:e,id:i}),this._$el.append(this._colorTpl({desc:n,colors:r,id:i,val:t.get(e)})),this}},{key:"select",value:function(t,e,n,r){var i=this._genId("settings");return this._settings.push({config:t,key:e,id:i}),this._$el.append(this._selectTpl({desc:n,selections:r,id:i,val:t.get(e)})),this}},{key:"range",value:function(t,e,n,r){var i=r.min,o=void 0===i?0:i,a=r.max,s=void 0===a?1:a,u=r.step,l=void 0===u?.1:u,c=this._genId("settings");this._settings.push({config:t,key:e,min:o,max:s,step:l,id:c});var h=t.get(e);return this._$el.append(this._rangeTpl({desc:n,min:o,max:s,step:l,val:h,progress:L(h,o,s),id:c})),this}},{key:"separator",value:function(){return this._$el.append('<div class="eruda-separator"></div>'),this}},{key:"text",value:function(t){return this._$el.append('<div class="eruda-text">'.concat(t,"</div>")),this}},{key:"_cleanSeparator",value:function(){var t=Object(d.j)(this._$el.get(0).children);function e(t){return"eruda-separator"===t.getAttribute("class")}for(var n=0,r=t.length;n<r-1;n++)e(t[n])&&e(t[n+1])&&Object(d.a)(t[n]).remove()}},{key:"_genId",value:function(){return Object(d.xb)("eruda-settings")}},{key:"_closeAll",value:function(){this._$el.find(".eruda-open").rmClass("eruda-open")}},{key:"_getSetting",value:function(t){var e;return Object(d.t)(this._settings,(function(n){n.id===t&&(e=n)})),e}},{key:"_bindEvent",value:function(){var t=this;this._$el.on("click",".eruda-checkbox",(function(){var e=Object(d.a)(this).find("input"),n=e.data("id"),r=e.get(0).checked,i=t._getSetting(n);i.config.set(i.key,r)})).on("click",".eruda-select .eruda-head",(function(){var e=Object(d.a)(this).parent().find("ul"),n=e.hasClass("eruda-open");t._closeAll(),n?e.rmClass("eruda-open"):e.addClass("eruda-open")})).on("click",".eruda-select li",(function(){var e=Object(d.a)(this),n=e.parent(),r=e.text(),i=n.data("id"),o=t._getSetting(i);n.rmClass("eruda-open"),n.parent().find(".eruda-head span").text(r),o.config.set(o.key,r)})).on("click",".eruda-range .eruda-head",(function(){var e=Object(d.a)(this).parent().find(".eruda-input-container"),n=e.hasClass("eruda-open");t._closeAll(),n?e.rmClass("eruda-open"):e.addClass("eruda-open")})).on("change",".eruda-range input",(function(){var e=Object(d.a)(this),n=e.parent().data("id"),r=+e.val(),i=t._getSetting(n);i.config.set(i.key,r)})).on("input",".eruda-range input",(function(){var e=Object(d.a)(this),n=e.parent(),r=n.data("id"),i=+e.val(),o=t._getSetting(r),a=o.min,s=o.max;n.parent().find(".eruda-head span").text(i),n.find(".eruda-range-track-progress").css("width",L(i,a,s)+"%")})).on("click",".eruda-color .eruda-head",(function(){var e=Object(d.a)(this).parent().find("ul"),n=e.hasClass("eruda-open");t._closeAll(),n?e.rmClass("eruda-open"):e.addClass("eruda-open")})).on("click",".eruda-color li",(function(){var e=Object(d.a)(this),n=e.parent(),r=e.css("background-color"),i=n.data("id"),o=t._getSetting(i);n.rmClass("eruda-open"),n.parent().find(".eruda-head span").css("background-color",r),o.config.set(o.key,r)}))}}],[{key:"createCfg",value:function(t,e){return new d.d("eruda-"+t,e)}}]),o}(y),L=function(t,e,n){return((t-e)/(n-e)*100).toFixed(2)};function F(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var z=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(F()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(t){var e;return i()(this,o),(e=r.call(this))._style=R(n(59)),e._$container=t,e._appendTpl(),e._makeDraggable(),e._bindEvent(),e._registerListener(),e}return a()(o,[{key:"hide",value:function(){this._$el.hide()}},{key:"show",value:function(){this._$el.show()}},{key:"setPos",value:function(t){this._isOutOfRange(t)&&(t=this._getDefPos()),this._$el.css({left:t.x,top:t.y}),this.config.set("pos",t)}},{key:"getPos",value:function(){return this.config.get("pos")}},{key:"destroy",value:function(){R.remove(this._style),this._unregisterListener(),this._$el.remove()}},{key:"_isOutOfRange",value:function(t){t=t||this.config.get("pos");var e=this._getDefPos();return t.x>e.x+10||t.x<0||t.y<0||t.y>e.y+10}},{key:"_registerListener",value:function(){var t=this;this._scaleListener=function(){return Object(d.cb)((function(){t._isOutOfRange()&&t._resetPos()}))},g.on(g.SCALE,this._scaleListener)}},{key:"_unregisterListener",value:function(){g.off(g.SCALE,this._scaleListener)}},{key:"_appendTpl",value:function(){var t=this._$container;t.append(n(60)()),this._$el=t.find(".eruda-entry-btn")}},{key:"_resetPos",value:function(t){var e=this.config,n=e.get("pos"),r=this._getDefPos();e.get("rememberPos")&&!t||(n=r),this.setPos(n)}},{key:"_bindEvent",value:function(){var t=this,e=this._draggabilly,n=this._$el;e.on("staticClick",(function(){return t.emit("click")})).on("dragStart",(function(){return n.addClass("eruda-active")})),e.on("dragEnd",(function(){var e=t.config;e.get("rememberPos")&&e.set("pos",{x:Object(d.ib)(t._$el.css("left")),y:Object(d.ib)(t._$el.css("top"))}),n.rmClass("eruda-active")})),d.fb.on("change",(function(){return t._resetPos(!0)})),window.addEventListener("resize",(function(){return t._resetPos()}))}},{key:"_makeDraggable",value:function(){this._draggabilly=new _.a(this._$el.get(0),{containment:!0})}},{key:"initCfg",value:function(t){var e=this.config=I.createCfg("entry-button",{rememberPos:!0,pos:this._getDefPos()});t.separator().switch(e,"rememberPos","Remember Entry Button Position"),this._resetPos()}},{key:"_getDefPos",value:function(){var t=this._$el.get(0).offsetWidth+10;return{x:window.innerWidth-t,y:window.innerHeight-t}}}]),o}(d.c);function B(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var H,q=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(B()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(t){var e;return i()(this,o),(e=r.call(this))._style=R(n(61)),e._$el=t.find(".eruda-nav-bar"),e._$bottomBar=t.find(".eruda-bottom-bar"),e._len=0,e._bindEvent(),e}return a()(o,[{key:"add",value:function(t){var e=this._$el;this._len++;var n=e.find(".eruda-nav-bar-item").last(),r='<div class="eruda-nav-bar-item">'.concat(t,"</div>");n.length>0&&"settings"===n.text()?n.before(r):e.append(r),this.resetBottomBar()}},{key:"remove",value:function(t){this._len--,this._$el.find(".eruda-nav-bar-item").each((function(){var e=Object(d.a)(this);e.text().toLowerCase()===t.toLowerCase()&&e.remove()})),this.resetBottomBar()}},{key:"activateTool",value:function(t){var e=this;this._$el.find(".eruda-nav-bar-item").each((function(){var n=Object(d.a)(this);n.text()===t?(n.addClass("eruda-active"),e.resetBottomBar(),e._scrollItemToView()):n.rmClass("eruda-active")}))}},{key:"destroy",value:function(){R.remove(this._style),this._$el.remove()}},{key:"_scrollItemToView",value:function(){var t,e=this._$el,n=e.find(".eruda-active").get(0),r=e.get(0),i=n.offsetLeft,o=n.offsetWidth,a=r.offsetWidth,s=r.scrollLeft;i<s?t=i:i+o>a+s&&(t=i+o-a),Object(d.O)(t)&&(r.scrollLeft=t)}},{key:"resetBottomBar",value:function(){var t=this._$bottomBar,e=this._$el,n=e.find(".eruda-active").get(0);n&&t.css({width:n.offsetWidth,left:n.offsetLeft-e.get(0).scrollLeft})}},{key:"_bindEvent",value:function(){var t=this,e=this;this._$el.on("click",".eruda-nav-bar-item",(function(){e.emit("showTool",Object(d.a)(this).text())})).on("scroll",(function(){return t.resetBottomBar()}))}}]),o}(d.c),U=H=new d.e("[Eruda]","warn");H.formatter=function(t,e){return e.unshift(this.name),e};var W=n(29),G=n.n(W);function K(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var V=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(K()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(t){var e,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},s=a.defaults,u=void 0===s?{}:s;return i()(this,o),(e=r.call(this))._defCfg=Object(d.y)({transparency:1,displaySize:80,theme:Object(d.F)()?"Dark":"Light"},u),e._style=R(n(62)),e.$container=t,e._isShow=!1,e._opacity=1,e._tools={},e._isResizing=!1,e._resizeTimer=null,e._resizeStartY=0,e._resizeStartSize=0,e._appendTpl(),e._initNavBar(),e._initNotification(),e._bindEvent(),e}return a()(o,[{key:"show",value:function(){var t=this;return this._isShow=!0,this._$el.show(),this._navBar.resetBottomBar(),setTimeout((function(){t._$el.css("opacity",t._opacity)}),50),this.emit("show"),this}},{key:"hide",value:function(){var t=this;return this._isShow=!1,this.emit("hide"),this._$el.css({opacity:0}),setTimeout((function(){return t._$el.hide()}),300),this}},{key:"toggle",value:function(){return this._isShow?this.hide():this.show()}},{key:"add",value:function(t){if(!(t instanceof y)){var e=new y,n=e.init,r=e.show,i=e.hide,o=e.destroy;Object(d.q)(t,{init:n,show:r,hide:i,destroy:o})}var a=t.name;return a?(a=a.toLowerCase(),this._tools[a]?U.warn("Tool ".concat(a," already exists")):(this._$tools.prepend('<div id="eruda-'.concat(a,'" class="eruda-').concat(a,' eruda-tool"></div>')),t.init(this._$tools.find(".eruda-".concat(a,".eruda-tool")),this),t.active=!1,this._tools[a]=t,this._navBar.add(a),this)):U.error("You must specify a name for a tool")}},{key:"remove",value:function(t){var e=this._tools;if(!e[t])return U.warn("Tool ".concat(t," doesn't exist"));this._navBar.remove(t);var n=e[t];if(delete e[t],n.active){var r=Object(d.V)(e);r.length>0&&this.showTool(e[Object(d.W)(r)].name)}return n.destroy(),this}},{key:"removeAll",value:function(){var t=this;return Object(d.t)(this._tools,(function(e){return t.remove(e.name)})),this}},{key:"get",value:function(t){var e=this._tools[t];if(e)return e}},{key:"showTool",value:function(t){if(this._curTool===t)return this;this._curTool=t;var e=this._tools,n=e[t];if(n){var r={};return Object(d.t)(e,(function(t){t.active&&(r=t,t.active=!1,t.hide())})),n.active=!0,n.show(),this._navBar.activateTool(t),this.emit("showTool",t,r),this}}},{key:"initCfg",value:function(t){var e=this,n=this.config=I.createCfg("dev-tools",this._defCfg);this._setTransparency(n.get("transparency")),this._setDisplaySize(n.get("displaySize")),R.setTheme(n.get("theme")),n.on("change",(function(t,n){switch(t){case"transparency":return e._setTransparency(n);case"displaySize":return e._setDisplaySize(n);case"theme":return R.setTheme(n)}})),t.separator().select(n,"theme","Theme",Object(d.V)(R.getThemes())).range(n,"transparency","Transparency",{min:.2,max:1,step:.01}).range(n,"displaySize","Display Size",{min:40,max:100,step:1}).separator()}},{key:"notify",value:function(t,e){this._notification.notify(t,e)}},{key:"destroy",value:function(){R.remove(this._style),this.removeAll(),this._navBar.destroy(),this._$el.remove()}},{key:"_setTransparency",value:function(t){Object(d.O)(t)&&(this._opacity=t,this._isShow&&this._$el.css({opacity:t}))}},{key:"_setDisplaySize",value:function(t){Object(d.O)(t)&&this._$el.css({height:t+"%"})}},{key:"_appendTpl",value:function(){var t=this.$container;t.append(n(63)()),this._$el=t.find(".eruda-dev-tools"),this._$tools=this._$el.find(".eruda-tools")}},{key:"_initNavBar",value:function(){var t=this;this._navBar=new q(this._$el.find(".eruda-nav-bar-container")),this._navBar.on("showTool",(function(e){return t.showTool(e)}))}},{key:"_initNotification",value:function(){this._notification=new G.a(this._$el.get(0),{position:{x:"center",y:"top"}})}},{key:"_bindEvent",value:function(){var t=this,e=this._$el.find(".eruda-nav-bar"),n=function(n){n=n.origEvent,t._resizeTimer=setTimeout((function(){n.preventDefault(),n.stopPropagation(),t._isResizing=!0,t._resizeStartSize=t.config.get("displaySize"),t._resizeStartY=a(n),e.css("filter","brightness(1.2)")}),1e3)},r=Object(d.qb)((function(e){return t.config.set("displaySize",e)}),50),i=function(e){if(!t._isResizing)return clearTimeout(t._resizeTimer);e.preventDefault(),e.stopPropagation(),e=e.origEvent;var n=Math.round((t._resizeStartY-a(e))/window.innerHeight*100),i=t._resizeStartSize+n;i<40?i=40:i>100&&(i=100),r(i)},o=function(){clearTimeout(t._resizeTimer),t._isResizing=!1,e.css("filter","brightness(1)")},a=function(t){return t.clientY?t.clientY:t.touches?t.touches[0].clientY:0};e.on("contextmenu",(function(t){return t.preventDefault()}));var s=Object(d.a)(document.documentElement);Object(d.L)()?(e.on("touchstart",n).on("touchmove",i),s.on("touchend",o)):(e.on("mousedown",n),s.on("mousemove",i),s.on("mouseup",o))}}]),o}(d.c),Q=n(9),J=n.n(Q),X=n(10),Y=n.n(X),Z=n(18),tt=n.n(Z),et=!1;var nt=["(...)","undefined","Symbol","Object","ƒ"];function rt(t){var e=Object(d.H)(Object.getOwnPropertyNames(t)),n=Object.getPrototypeOf(t);return e&&n&&n!==Object.prototype}var it=n(13),ot=n.n(it),at=n(17),st=n.n(at);function ut(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var lt=function(t){u()(r,t);var e,n=(e=r,function(){var t,n=p()(e);if(ut()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function r(t){var e,o=t.type,a=void 0===o?"log":o,s=t.args,u=void 0===s?[]:s,l=t.id,c=t.group,h=void 0===c?{}:c,p=t.targetGroup,f=void 0===p?{}:p,_=t.headers,v=t.ignoreFilter,g=void 0!==v&&v;return i()(this,r),(e=n.call(this)).type=a,e.group=h,e.targetGroup=f,e.args=u,e.count=1,e.id=l,e.headers=_,e.ignoreFilter=g,e.collapsed=!1,e.el=document.createElement("div"),e.el.log=J()(e),e.height=0,e.width=0,e._$el=Object(d.a)(e.el),e._formatMsg(),e.group&&e.checkGroup(),e}return a()(r,[{key:"checkGroup",value:function(){for(var t=this.group,e=!1;t;){if(t.collapsed){e=!0;break}t=t.parent}return e!==this.collapsed&&(this.collapsed=e,!0)}},{key:"updateIcon",value:function(t){return this._$el.find(".eruda-icon").rmAttr("class").addClass(["eruda-icon","eruda-icon-".concat(t)]),this}},{key:"addCount",value:function(){this.count++;var t=this.count,e=this._$el,n=e.find(".eruda-count-container"),r=e.find(".eruda-icon-container"),i=n.find(".eruda-count");return 2===t&&n.rmClass("eruda-hidden"),i.text(t),r.addClass("eruda-hidden"),this}},{key:"groupEnd",value:function(){return this._$el.find(".eruda-nesting-level:not(.eruda-group-closed)").last().addClass("eruda-group-closed"),this}},{key:"updateTime",value:function(t){var e=this._$el.find(".eruda-time-container");return this.time&&(e.find("span").eq(0).text(t),this.time=t),this}},{key:"isAttached",value:function(){return!!this.el.parentNode}},{key:"updateSize",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=this.el.offsetHeight,n=this.el.offsetWidth;this.height===e&&this.width===n||(this.height=e,this.width=n,t||this.emit("updateSize"))}},{key:"html",value:function(){return this.el.outerHTML}},{key:"text",value:function(){return this._content.textContent}},{key:"_needSrc",value:function(){var t=this.type,e=this.args;if("html"===t)return!1;for(var n=0,r=e.length;n<r;n++)if(Object(d.P)(e[n]))return!0;return!1}},{key:"extractObj",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:d.db,n=this.args,r=this.type,i=function(n){t.src=n,e()};$t("table"===r||1===n.length&&Object(d.P)(n[0])?n[0]:n,{},i)}},{key:"click",value:function(t){var e=this,n=this.type,i=this.src,o=this.args,a=this._$el;switch(n){case"log":case"warn":case"info":case"debug":case"output":case"table":case"dir":case"group":case"groupCollapsed":if(i||o){var s=a.find(".eruda-json");if(s.hasClass("eruda-hidden")){if("true"!==s.data("init")){if(i){var u=new st.a.Static(s.get(0));u.set(i),u.on("change",(function(){return e.updateSize(!1)}))}else{"table"!==n&&1!==o.length||Object(d.P)(o[0])&&(o=o[0]);var l=new st.a(s.get(0),{unenumerable:r.showUnenumerable,accessGetter:r.showGetterVal});l.set(o),l.on("change",(function(){return e.updateSize(!1)}))}s.data("init","true")}s.rmClass("eruda-hidden")}else s.addClass("eruda-hidden")}else"group"!==n&&"groupCollapsed"!==n||t.toggleGroup(this);break;case"error":a.find(".eruda-stack").toggleClass("eruda-hidden")}this.updateSize(!1)}},{key:"_formatMsg",value:function(){var t=this.args,e=this.type,n=this.id,i=this.headers,o=this.group;t=Object(d.j)(t),this._needSrc()&&!r.lazyEvaluation&&this.extractObj();var a,s,u="";switch("group"!==e&&"groupCollapsed"!==e||0===t.length&&(t=["console.group"]),e){case"log":case"debug":u=vt(t);break;case"dir":u=gt(t);break;case"info":u=vt(t);break;case"warn":a="warn",u=vt(t);break;case"error":Object(d.S)(t[0])&&1!==t.length&&(t=mt(t)),s=t[0],a="error",s=Object(d.I)(s)?s:new Error(vt(t)),this.src=s,u=function(t){var e=t.stack?t.stack.split("\n"):[],n="".concat(t.message||e[0],"<br/>");e=e.filter((function(t){return!_t.test(t)})).map((function(t){return Object(d.v)(t)}));var r='<div class="eruda-stack eruda-hidden">'.concat(e.slice(1).join("<br/>"),"</div>");return n+r.replace(ft,(function(t){return'<a href="'.concat(t,'" target="_blank">').concat(t,"</a>")}))}(s);break;case"table":u=function(t){var e=t[0],n="",r=t[1],i=[];Object(d.S)(r)&&(r=Object(d.rb)(r));Object(d.D)(r)||(r=null);if(!Object(d.P)(e))return vt(t);Object(d.t)(e,(function(t){Object(d.Q)(t)?i.push(ht):Object(d.P)(t)&&(i=i.concat(Object(d.V)(t)))})),(i=Object(d.yb)(i)).sort(),r&&(i=i.filter((function(t){return Object(d.m)(r,t)})));i.length>20&&(i=i.slice(0,20));return Object(d.H)(i)?vt(t):(n+="<table><thead><tr><th>(index)</th>",i.forEach((function(t){return n+="<th>".concat(t===ht?"Value":Object(d.ub)(t),"</th>")})),n+="</tr></thead><tbody>",Object(d.t)(e,(function(t,e){n+="<tr><td>".concat(e,"</td>"),i.forEach((function(e){Object(d.P)(t)?n+=e===ht?"<td></td>":"<td>".concat(pt(t[e]),"</td>"):Object(d.Q)(t)&&(n+=e===ht?"<td>".concat(pt(t),"</td>"):"<td></td>")})),n+="</tr>"})),n+="</tbody></table>",n+='<div class="eruda-json eruda-hidden"></div>')}(t);break;case"html":u=t[0];break;case"input":u=dt(t[0]),a="arrow-right";break;case"output":u=vt(t),a="arrow-left";break;case"groupCollapsed":u=vt(t),a="caret-right";break;case"group":u=vt(t),a="caret-down"}this._needSrc()&&r.lazyEvaluation||delete this.args,"error"===e||this.args||(u=Object(d.X)(u,(function(t){return'<a href="'.concat(t,'" target="_blank">').concat(t,"</a>")}))),u=Ot({msg:u,type:e,icon:a,id:n,headers:i,group:o}),this._$el.addClass("eruda-log-container").html(u),this._$content=this._$el.find(".eruda-log-content"),this._content=this._$content.get(0)}}]),r}(d.c);Y()(lt,"showGetterVal",!1),Y()(lt,"showUnenumerable",!0),Y()(lt,"lazyEvaluation",!0);var ct=Object(d.Bb)((function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=r.topObj,o=r.level,a=void 0===o?0:o,s=r.getterVal,u=void 0!==s&&s,l=r.unenumerable,c=void 0===l||l;et||(R(n(69)),et=!0);var h,p="",f="",_=5,v=[],g=[],m="",b=!1;i=i||e;var y={getterVal:u,unenumerable:c,level:a+1},w=0===a,x='<span class="eruda-key">',k='<span class="eruda-number">',O='<span class="eruda-null">',$='<span class="eruda-string">',j='<span class="eruda-boolean">',S='<span class="eruda-special">',E=function(t){return Object(d.v)(t).replace(/\\n/g,"↵").replace(/\\f|\\r|\\t/g,"").replace(/\\/g,"")},A="</span>",T=function(t){return x+E(t)+A},C=function(t){return k+t+A},P=function(t){return $+t+A},N=function(t){return j+t+A},D=function(t){return O+t+A};function M(t){return t=Object(d.ub)(t),Object(d.m)(nt,t)||Object(d.ob)(t,"Array[")?S+E(t)+A:$+E('"'.concat(t,'"'))+A}function I(n){if(h>_)m=", …";else{var r=T(Object(d.w)(n));if(!u)if(Object.getOwnPropertyDescriptor(e,n).get)return v.push("".concat(r,": ").concat(M("(...)"))),void h++;v.push("".concat(r,": ").concat(t(i[n],y))),h++}}try{f={}.toString.call(e)}catch(t){f="[object Object]"}var L="[object String]"==f,F="[object Array]"==f,z="[object Object]"==f,B="[object Number]"==f,H="[object RegExp]"==f,q="[object Symbol]"==f,U="[object Function]"==f,W="[object Boolean]"==f;if(b)p=M("[circular]");else if(L)p=M(Object(d.w)(e));else if(H)p=P(Object(d.w)(e.toString()));else if(U)p=M("ƒ");else if(F)if(w){p="[";var G=e.length,K="";G>100&&(G=100,K=", …");for(var V=0;V<G;V++)v.push("".concat(t(e[V],y)));p+=v.join(", ")+K+"]"}else p="Array(".concat(e.length,")");else if(z)rt(e)&&(e=Object.getPrototypeOf(e)),g=c?Object.getOwnPropertyNames(e):Object.keys(e),w?(h=1,p="{ ",Object(d.t)(g,I),p+=v.join(", ")+m+" }"):"Object"===(p=Object(d.B)(e))&&(p="{…}");else if(B)p=e+"",p=Object(d.u)(p,"Infinity")||"NaN"===p?'"'.concat(p,'"'):C(p);else if(W)p=N(e?"true":"false");else if(null===e)p=D("null");else if(q)p=M("Symbol");else if(void 0===e)p=M("undefined");else try{rt(e)&&(e=Object.getPrototypeOf(e)),w?(h=1,p="{ ",g=c?Object.getOwnPropertyNames(e):Object.keys(e),Object(d.t)(g,I),p+=v.join(", ")+m+" }"):"Object"===(p=Object(d.B)(e))&&(p="{…}")}catch(t){p=M(e)}return p}),(function(t,e){return'<span class="eruda-abstract">'+t(e,{getterVal:lt.showGetterVal,unenumerable:!1})+"</span>"})),ht="__ErudaValue";function pt(t){return Object(d.P)(t)?"{…}":Object(d.Q)(t)?ct(t):Object(d.ub)(t)}var ft=/https?:\/\/([0-9.\-A-Za-z]+)(?::(\d+))?\/[A-Z.a-z0-9/]*\.js/g,_t=/eruda(\.min)?\.js/;function dt(t){var e=R.getCurTheme();return Object(d.C)(ot()(t,{indent_size:2}),"js",{keyword:"color:".concat(e.keywordColor),number:"color:".concat(e.numberColor),operator:"color:".concat(e.operatorColor),comment:"color:".concat(e.commentColor),string:"color:".concat(e.stringColor)})}function vt(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.htmlForEl,r=void 0===n||n,i=Object(d.S)(t[0])&&1!==t.length;i&&(t=mt(t));for(var o=0,a=t.length;o<a;o++){var s=t[o];Object(d.G)(s)&&r?t[o]=xt(s):Object(d.J)(s)?t[o]=wt(s):Object(d.P)(s)?t[o]=yt(s):Object(d.T)(s)?t[o]="undefined":Object(d.N)(s)?t[o]="null":(s=Object(d.ub)(s),0===o&&i||(s=Object(d.v)(s)),t[o]=s)}return t.join(" ")+'<div class="eruda-json eruda-hidden"></div>'}var gt=function(t){return vt(t,{htmlForEl:!1})};function mt(t){var e=Object(d.v)(t[0]),n=!1,r="";t.shift();for(var i=0,o=e.length;i<o;i++){var a=e[i];if("%"===a&&0!==t.length){i++;var s=t.shift();switch(e[i]){case"i":case"d":r+=Object(d.sb)(s);break;case"f":r+=Object(d.tb)(s);break;case"s":r+=Object(d.ub)(s);break;case"O":Object(d.P)(s)&&(r+=ct(s));break;case"o":Object(d.G)(s)?r+=xt(s):Object(d.P)(s)&&(r+=ct(s));break;case"c":if(e.length<=i+1)break;n&&(r+="</span>"),n=!0,r+='<span style="'.concat(bt(s),'">');break;default:i--,t.unshift(s),r+=a}}else r+=a}return n&&(r+="</span>"),t.unshift(r),t}function bt(t){var e=(t=Object(d.Z)(t)).split(";"),n={};Object(d.t)(e,(function(t){if(Object(d.m)(t,":")){var e=t.split(":"),r=tt()(e,2),i=r[0],o=r[1];n[Object(d.vb)(i)]=Object(d.vb)(o)}})),n.display="inline-block",n["max-width"]="100%",n.contain="paint",delete n.width,delete n.height;var r="";return Object(d.t)(n,(function(t,e){r+="".concat(e,":").concat(t,";")})),r}function yt(t){var e=Object(d.B)(t);return"Array"===e&&t.length>1&&(e="(".concat(t.length,")")),"".concat(e," ").concat(ct(t))}function wt(t){return'<pre style="display:inline">'.concat(dt(t.toString()),"</pre>")}function xt(t){return'<pre style="display:inline">'.concat(Object(d.C)(ot.a.html(t.outerHTML,{unformatted:[],indent_size:2}),"html"),"</pre>")}var kt=n(71),Ot=function(t){return kt(t)};function $t(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2?arguments[2]:void 0;Object(d.q)(e,{accessGetter:lt.showGetterVal,unenumerable:lt.showUnenumerable,symbol:lt.showUnenumerable,timeout:1e3}),jt(t,e,(function(t){return n(JSON.parse(t))}))}function jt(t,e,n){var r=Object(d.pb)(t,e);Object(d.cb)((function(){return n(r)}))}function St(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var Et=navigator.userAgent,At=Et.indexOf("Android")>-1||Et.indexOf("Adr")>-1,Tt=0,Ct=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(St()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(t){var e;return i()(this,o),(e=r.call(this))._style=R(n(72)),e._$container=t,e._container=t.get(0),e._$el=t.find(".eruda-logs"),e._el=e._$el.get(0),e._$fakeEl=t.find(".eruda-fake-logs"),e._fakeEl=e._$fakeEl.get(0),e._$space=t.find(".eruda-logs-space"),e._space=e._$space.get(0),e._spaceHeight=0,e._topSpaceHeight=0,e._bottomSpaceHeight=0,e._lastScrollTop=0,e._lastTimestamp=0,e._speedToleranceFactor=100,e._maxSpeedTolerance=2e3,e._minSpeedTolerance=100,e._logs=[],e._displayLogs=[],e._timer={},e._count={},e._lastLog={},e._filter="all",e._maxNum="infinite",e._displayHeader=!1,e._asyncRender=!1,e._asyncList=[],e._asyncTimer=null,e._isAtBottom=!0,e._groupStack=new d.g,At&&(e._speedToleranceFactor=800,e._maxSpeedTolerance=3e3,e._minSpeedTolerance=800),e.renderViewport=Object(d.qb)((function(t){e._renderViewport(t)}),16),e._global={copy:function(t){Object(d.S)(t)||(t=JSON.stringify(t,null,2)),Object(d.n)(t)},$:function(){return document.querySelector.apply(document,arguments)},$$:function(){return Object(d.rb)(document.querySelectorAll.apply(document,arguments))},$x:function(t){return Object(d.Cb)(t)},clear:function(){e.clear()},dir:function(t){e.dir(t)},table:function(t,n){e.table(t,n)},keys:d.V},e._bindEvent(),e}return a()(o,[{key:"renderAsync",value:function(t){this._asyncRender=t}},{key:"setGlobal",value:function(t,e){this._global[t]=e}},{key:"displayHeader",value:function(t){this._displayHeader=t}},{key:"maxNum",value:function(t){var e=this._logs;this._maxNum=t,Object(d.O)(t)&&e.length>t&&(this._logs=e.slice(e.length-t),this.render())}},{key:"displayUnenumerable",value:function(t){lt.showUnenumerable=t}},{key:"displayGetterVal",value:function(t){lt.showGetterVal=t}},{key:"lazyEvaluation",value:function(t){lt.lazyEvaluation=t}},{key:"viewLogInSources",value:function(t){lt.showSrcInSources=t}},{key:"destroy",value:function(){this._style&&R.remove(this._style)}},{key:"filter",value:function(t){return this._filter=t,this.emit("filter",t),this.render()}},{key:"count",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"default",e=this._count;return Object(d.T)(e[t])?e[t]=1:e[t]++,this.info("".concat(t,": ").concat(e[t]))}},{key:"countReset",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"default";return this._count[t]=0,this}},{key:"assert",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e)){var r=e.shift();return r?void 0:(0===e.length&&e.unshift("console.assert"),e.unshift("Assertion failed: "),this.insert("error",e))}}},{key:"log",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("log",e)}},{key:"debug",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("debug",e)}},{key:"dir",value:function(t){if(!Object(d.T)(t))return this.insert("dir",[t])}},{key:"table",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("table",e)}},{key:"time",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"default";return this._timer[t]?this.insert("warn",["Timer '".concat(t,"' already exists")]):(this._timer[t]=Object(d.gb)(),this)}},{key:"timeLog",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"default",e=this._timer[t];return e?this.info("".concat(t,": ").concat(Object(d.gb)()-e,"ms")):this.insert("warn",["Timer '".concat(t,"' does not exist")])}},{key:"timeEnd",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"default";return this.timeLog(t),delete this._timer[t],this}},{key:"clear",value:function(){return this.silentClear(),this.insert("log",["%cConsole was cleared","color:#808080;font-style:italic;"])}},{key:"silentClear",value:function(){return this._logs=[],this._displayLogs=[],this._lastLog={},this._count={},this._timer={},this._groupStack=new d.g,this._asyncList=[],this._asyncTimer&&(clearTimeout(this._asyncTimer),this._asyncTimer=null),this.render()}},{key:"info",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("info",e)}},{key:"error",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("error",e)}},{key:"warn",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!Object(d.H)(e))return this.insert("warn",e)}},{key:"group",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.insert({type:"group",args:e,ignoreFilter:!0})}},{key:"groupCollapsed",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.insert({type:"groupCollapsed",args:e,ignoreFilter:!0})}},{key:"groupEnd",value:function(){this.insert("groupEnd")}},{key:"input",value:function(t){this.insert({type:"input",args:[t],ignoreFilter:!0});try{this.output(this._evalJs(t))}catch(t){this.insert({type:"error",ignoreFilter:!0,args:[t]})}return this}},{key:"output",value:function(t){return this.insert({type:"output",args:[t],ignoreFilter:!0})}},{key:"html",value:function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return this.insert("html",e)}},{key:"render",value:function(){var t=this._logs;this._$el.html(""),this._isAtBottom=!0,this._updateBottomSpace(0),this._updateTopSpace(0),this._displayLogs=[];for(var e=0,n=t.length;e<n;e++)this._attachLog(t[e]);return this}},{key:"insert",value:function(t,e){var n;this._displayHeader&&(n={time:Pt(),from:Nt()}),this._asyncRender?this.insertAsync(t,e,n):this.insertSync(t,e,n)}},{key:"insertAsync",value:function(t,e,n){this._asyncList.push([t,e,n]),this._handleAsyncList()}},{key:"insertSync",value:function(t,e,n){var r=this,i=this._logs,o=this._groupStack;if("groupEnd"===t)return this._lastLog.groupEnd(),this._groupStack.pop(),this;var a=Object(d.S)(t)?{type:t,args:e}:t;if(o.size>0&&(a.group=o.peek()),Object(d.y)(a,{id:++Tt,headers:n}),"group"===a.type||"groupCollapsed"===a.type){var s={id:Object(d.xb)("group"),collapsed:!1,parent:o.peek(),indentLevel:o.size+1};"groupCollapsed"===a.type&&(s.collapsed=!0),a.targetGroup=s,o.push(s)}var u=new lt(a);u.on("updateSize",(function(){r._isAtBottom=!1,r.renderViewport()}));var l=this._lastLog;if(Object(d.m)(["html","group","groupCollapsed"],u.type)||l.type!==u.type||u.src||u.args||l.text()!==u.text()?(i.push(u),this._lastLog=u):(l.addCount(),u.time&&l.updateTime(u.time),u=l,this._detachLog(l)),"infinite"!==this._maxNum&&i.length>this._maxNum){var c=i[0];this._detachLog(c),i.shift()}return this._attachLog(u),this.emit("insert",u),this}},{key:"toggleGroup",value:function(t){t.targetGroup.collapsed?this._openGroup(t):this._collapseGroup(t)}},{key:"_updateTopSpace",value:function(t){this._topSpaceHeight=t,this._el.style.top=t+"px"}},{key:"_updateBottomSpace",value:function(t){this._bottomSpaceHeight=t}},{key:"_updateSpace",value:function(t){this._spaceHeight!==t&&(this._spaceHeight=t,this._space.style.height=t+"px")}},{key:"_updateLogSize",value:function(t){var e=this._fakeEl;if(!Object(d.K)(this._fakeEl))return t.isAttached()?void t.updateSize():(e.appendChild(t.el),t.updateSize(),void(e.children>100&&(e.innerHTML="")))}},{key:"_detachLog",value:function(t){var e=this._displayLogs,n=e.indexOf(t);n>-1&&(e.splice(n,1),this.renderViewport())}},{key:"_attachLog",value:function(t){if(this._filterLog(t)&&!t.collapsed){var e=this._displayLogs;if(0===e.length)return e.push(t),void this.renderViewport();var n=Object(d.W)(e);if(t.id>n.id)return e.push(t),void this.renderViewport();for(var r,i,o=0,a=e.length-1;o<=a;){if((r=e[i=o+Math.floor((a-o)/2)]).id===t.id)return;r.id<t.id?o=i+1:a=i-1}r.id<t.id?e.splice(i+1,0,t):e.splice(i,0,t),this.renderViewport()}}},{key:"_handleAsyncList",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:20,n=this._asyncList;this._asyncTimer||(this._asyncTimer=setTimeout((function(){t._asyncTimer=null;var e,r,i=!1,o=n.length;o<1e3?(r=200,e=400):o<5e3?(r=500,e=800):o<1e4?(r=800,e=1e3):o<25e3?(r=1e3,e=1200):o<5e4?(r=1500,e=1500):(r=2e3,e=2500),r>o&&(r=o,i=!0);for(var a=0;a<r;a++){var s=n.shift(),u=tt()(s,3),l=u[0],c=u[1],h=u[2];t.insertSync(l,c,h)}i||Object(d.jb)((function(){return t._handleAsyncList(e)}))}),e))}},{key:"_injectGlobal",value:function(){Object(d.t)(this._global,(function(t,e){window[e]||(window[e]=t)}))}},{key:"_clearGlobal",value:function(){Object(d.t)(this._global,(function(t,e){window[e]&&window[e]===t&&delete window[e]}))}},{key:"_evalJs",value:function(t){var e;this._injectGlobal();try{e=eval.call(window,"(".concat(t,")"))}catch(n){e=eval.call(window,t)}return this.setGlobal("$_",e),this._clearGlobal(),e}},{key:"_filterLog",value:function(t){var e=this._filter;if("all"===e)return!0;var n=Object(d.R)(e),r=Object(d.J)(e);return!!t.ignoreFilter||(r?e(t):n?e.test(Object(d.Z)(t.text())):t.type===e)}},{key:"_getLog",value:function(t){for(var e,n=this._logs,r=0,i=n.length;r<i&&(e=n[r]).id!==t;r++);return e}},{key:"_collapseGroup",value:function(t){t.targetGroup.collapsed=!0,t.updateIcon("caret-right"),this._updateGroup(t)}},{key:"_openGroup",value:function(t){t.targetGroup.collapsed=!1,t.updateIcon("caret-down"),this._updateGroup(t)}},{key:"_updateGroup",value:function(t){for(var e=t.targetGroup,n=this._logs,r=n.length,i=n.indexOf(t)+1;i<r;){var o=n[i];if(!o.checkGroup()&&o.group===e)break;o.collapsed?this._detachLog(o):this._attachLog(o),i++}}},{key:"_bindEvent",value:function(){var t=this,e=this;this._$el.on("click",".eruda-log-container",(function(){this.log.click(e)})).on("click",".eruda-icon-caret-down",(function(){var t=Object(d.a)(this).parent().parent().parent();e._collapseGroup(t.get(0).log)})).on("click",".eruda-icon-caret-right",(function(){var t=Object(d.a)(this).parent().parent().parent();e._openGroup(t.get(0).log)})),this._$container.on("scroll",(function(){var e=t._container,n=e.scrollHeight,r=e.offsetHeight,i=e.scrollTop;if(!(i<=0||r+i>n)){var o=!1;(n===r||i===n-r)&&(o=!0),t._isAtBottom=o;var a=t._lastScrollTop,s=t._lastTimestamp,u=Object(d.eb)(),l=u-s,c=i-a,h=Math.abs(c/l)*t._speedToleranceFactor;l>1e3&&(h=1e3),h>t._maxSpeedTolerance&&(h=t._maxSpeedTolerance),h<t._minSpeedTolerance&&(h=t._minSpeedTolerance),t._lastScrollTop=i,t._lastTimestamp=u;var p=0,f=0;a<i?(p=t._minSpeedTolerance,f=h):(p=h,f=t._minSpeedTolerance),t._topSpaceHeight<i-p&&t._topSpaceHeight+t._el.offsetHeight>i+r+f||t.renderViewport({topTolerance:2*p,bottomTolerance:2*f})}}))}},{key:"_renderViewport",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.topTolerance,n=void 0===e?500:e,r=t.bottomTolerance,i=void 0===r?500:r,o=this._container,a=this._el;if(!Object(d.K)(o)){for(var s=o.scrollTop,u=o.clientWidth,l=o.offsetHeight,c=s-n,h=s+l+i,p=this._displayLogs,f=0,_=0,v=0,g=p.length,m=this._fakeEl,b=document.createDocumentFragment(),y=[],w=0;w<g;w++){var x=p[w],k=x.width,O=x.height;0!==O&&k===u||(b.appendChild(x.el),y.push(x))}if(y.length>0){m.appendChild(b);for(var $=0,j=y.length;$<j;$++)y[$].updateSize();m.innerHTML=""}for(var S=document.createDocumentFragment(),E=0;E<g;E++){var A=p[E],T=A.el,C=A.height;v>h?_+=C:v+C>c?S.appendChild(T):v<c&&(f+=C),v+=C}for(this._updateSpace(v),this._updateTopSpace(f),this._updateBottomSpace(_);a.firstChild;)a.removeChild(a.lastChild);a.appendChild(S);var P=o.scrollHeight;this._isAtBottom&&s<=P-l&&(o.scrollTop=1e7)}}}]),o}(d.c),Pt=function(){return Object(d.o)("HH:MM:ss ")};function Nt(){for(var t=new Error,e="",n=t.stack?t.stack.split("\n"):"",r=0,i=n.length;r<i;r++)if((e=n[r]).indexOf("winConsole")>-1&&r<i-1){e=n[r+1];break}return e}function Dt(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}d.wb.start();var Rt=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(Dt()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=e.name,a=void 0===n?"console":n;return i()(this,o),t=r.call(this),Y()(J()(t),"_handleShow",(function(){Object(d.K)(t._$el.get(0))||t._logger.renderViewport()})),Y()(J()(t),"_handleErr",(function(e){t._logger.error(e)})),d.c.mixin(J()(t)),t.name=a,t._scale=1,t._registerListener(),t}return a()(o,[{key:"init",value:function(t,e){b()(p()(o.prototype),"init",this).call(this,t),this._container=e,this._appendTpl(),this._initLogger(),this._exposeLogger(),this._initCfg(),this._bindEvent()}},{key:"show",value:function(){b()(p()(o.prototype),"show",this).call(this),this._handleShow()}},{key:"overrideConsole",value:function(){var t=this,e=this._origConsole={},n=window.console;return Mt.forEach((function(r){var i=e[r]=d.db;n[r]&&(i=e[r]=n[r].bind(n)),n[r]=function(){t[r].apply(t,arguments),i.apply(void 0,arguments)}})),this}},{key:"setGlobal",value:function(t,e){this._logger.setGlobal(t,e)}},{key:"restoreConsole",value:function(){var t=this;return this._origConsole?(Mt.forEach((function(e){return window.console[e]=t._origConsole[e]})),delete this._origConsole,this):this}},{key:"catchGlobalErr",value:function(){return d.wb.addListener(this._handleErr),this}},{key:"ignoreGlobalErr",value:function(){return d.wb.rmListener(this._handleErr),this}},{key:"destroy",value:function(){this._logger.destroy(),b()(p()(o.prototype),"destroy",this).call(this),this._container.off("show",this._handleShow),this._style&&R.remove(this._style),this.ignoreGlobalErr(),this.restoreConsole(),this._unregisterListener(),this._rmCfg()}},{key:"_enableJsExecution",value:function(t){var e=this._$el,n=e.find(".eruda-console-container"),r=e.find(".eruda-js-input");t?(r.show(),n.rmClass("eruda-js-input-hidden")):(r.hide(),n.addClass("eruda-js-input-hidden"))}},{key:"_registerListener",value:function(){var t=this;this._scaleListener=function(e){return t._scale=e},g.on(g.SCALE,this._scaleListener)}},{key:"_unregisterListener",value:function(){g.off(g.SCALE,this._scaleListener)}},{key:"_appendTpl",value:function(){var t=this._$el;this._style=R(n(73)),t.append(n(74)());var e=t.find(".eruda-js-input"),r=e.find("textarea"),i=e.find(".eruda-buttons");Object.assign(this,{_$control:t.find(".eruda-control"),_$logs:t.find(".eruda-logs-container"),_$inputContainer:e,_$input:r,_$inputBtns:i,_$searchKeyword:t.find(".eruda-search-keyword")})}},{key:"_initLogger",value:function(){var t=this._$control.find(".eruda-filter");(this._logger=new Ct(this._$logs)).on("filter",(function(e){return t.each((function(){var t=Object(d.a)(this),n=t.data("filter")===e;t[n?"addClass":"rmClass"]("eruda-active")}))}))}},{key:"_exposeLogger",value:function(){var t=this,e=this._logger;["filter","html"].concat(Mt).forEach((function(n){return t[n]=function(){for(var r=arguments.length,i=new Array(r),o=0;o<r;o++)i[o]=arguments[o];return e[n].apply(e,i),t.emit.apply(t,[n].concat(i)),t}}))}},{key:"_bindEvent",value:function(){var t=this,e=this._container,n=this._$input,r=this._$inputBtns,i=this._$control,o=this._$searchKeyword,a=this._logger,s=this.config;i.on("click",".eruda-clear-console",(function(){return a.silentClear()})).on("click",".eruda-filter",(function(){o.text(""),a.filter(Object(d.a)(this).data("filter"))})).on("click",".eruda-search",(function(){var e=prompt("Filter");Object(d.N)(e)||(o.text(e),""!==Object(d.vb)(e)?t._logger.filter(new RegExp(Object(d.x)(Object(d.Z)(e)))):a.filter("all"))})),r.on("click",".eruda-cancel",(function(){return t._hideInput()})).on("click",".eruda-execute",(function(){var e=n.val().trim();""!==e&&(a.input(e),n.val("").get(0).blur(),t._hideInput())})),n.on("focusin",(function(){return t._showInput()})),a.on("insert",(function(t){"error"===t.type&&s.get("displayIfErr")&&e.showTool("console").show()})),e.on("show",this._handleShow)}},{key:"_hideInput",value:function(){this._$inputContainer.rmClass("eruda-active"),this._$inputBtns.hide()}},{key:"_showInput",value:function(){this._$inputContainer.addClass("eruda-active"),this._$inputBtns.show()}},{key:"_rmCfg",value:function(){var t=this.config,e=this._container.get("settings");e&&e.remove(t,"asyncRender").remove(t,"jsExecution").remove(t,"catchGlobalErr").remove(t,"overrideConsole").remove(t,"displayExtraInfo").remove(t,"displayUnenumerable").remove(t,"displayGetterVal").remove(t,"lazyEvaluation").remove(t,"displayIfErr").remove(t,"maxLogNum").remove(Object(d.zb)(this.name))}},{key:"_initCfg",value:function(){var t=this,e=this._container,n=this._logger,r=this.config=I.createCfg(this.name,{asyncRender:!0,catchGlobalErr:!0,jsExecution:!0,overrideConsole:!0,displayExtraInfo:!1,displayUnenumerable:!0,displayGetterVal:!0,lazyEvaluation:!0,displayIfErr:!1,maxLogNum:"infinite"}),i=r.get("maxLogNum");i="infinite"===i?i:+i,this._enableJsExecution(r.get("jsExecution")),r.get("asyncRender")&&n.renderAsync(!0),r.get("catchGlobalErr")&&this.catchGlobalErr(),r.get("overrideConsole")&&this.overrideConsole(),n.displayHeader(r.get("displayExtraInfo")),n.displayUnenumerable(r.get("displayUnenumerable")),n.displayGetterVal(r.get("displayGetterVal")),n.lazyEvaluation(r.get("lazyEvaluation")),n.maxNum(i),r.on("change",(function(e,r){switch(e){case"asyncRender":return n.renderAsync(r);case"jsExecution":return t._enableJsExecution(r);case"catchGlobalErr":return r?t.catchGlobalErr():t.ignoreGlobalErr();case"overrideConsole":return r?t.overrideConsole():t.restoreConsole();case"maxLogNum":return n.maxNum("infinite"===r?r:+r);case"displayExtraInfo":return n.displayHeader(r);case"displayUnenumerable":return n.displayUnenumerable(r);case"displayGetterVal":return n.displayGetterVal(r);case"lazyEvaluation":return n.lazyEvaluation(r)}}));var o=e.get("settings");o&&o.text(Object(d.zb)(this.name)).switch(r,"asyncRender","Asynchronous Rendering").switch(r,"jsExecution","Enable JavaScript Execution").switch(r,"catchGlobalErr","Catch Global Errors").switch(r,"overrideConsole","Override Console").switch(r,"displayIfErr","Auto Display If Error Occurs").switch(r,"displayExtraInfo","Display Extra Information").switch(r,"displayUnenumerable","Display Unenumerable Properties").switch(r,"displayGetterVal","Access Getter Value").switch(r,"lazyEvaluation","Lazy Evaluation").select(r,"maxLogNum","Max Log Number",["infinite","250","125","100","50","10"]).separator()}}]),o}(y),Mt=["log","error","info","warn","dir","time","timeLog","timeEnd","clear","table","assert","count","countReset","debug","group","groupCollapsed","groupEnd"],It=n(11),Lt=n.n(It);function Ft(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}Lt.a.domain("Network").enable();var zt=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(Ft()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),t=r.call(this),Y()(J()(t),"_reqWillBeSent",(function(e){t._requests[e.requestId]={name:Object(d.A)(e.request.url),url:e.request.url,status:"pending",type:"unknown",subType:"unknown",size:0,data:e.request.postData,method:e.request.method,startTime:1e3*e.timestamp,time:0,resTxt:"",done:!1,reqHeaders:e.request.headers||{},resHeaders:{}}})),Y()(J()(t),"_resReceivedExtraInfo",(function(e){var n=t._requests[e.requestId];n&&(n.resHeaders=e.headers,t._updateType(n),t._render())})),Y()(J()(t),"_resReceived",(function(e){var n=t._requests[e.requestId];if(n){var r=e.response,i=r.status,o=r.headers;n.status=i,(i<200||i>=300)&&(n.hasErr=!0),o&&(n.resHeaders=o,t._updateType(n)),t._render()}})),Y()(J()(t),"_loadingFinished",(function(e){var n=t._requests[e.requestId];if(n){var r=1e3*e.timestamp;n.time=r-n.startTime,n.displayTime=Object(d.bb)(n.time),n.size=e.encodedDataLength,n.done=!0,n.resTxt=Lt.a.domain("Network").getResponseBody({requestId:e.requestId}).body,t._render()}})),t._style=R(n(75)),t.name="network",t._requests={},t._tpl=n(76),t._detailTpl=n(77),t._requestsTpl=n(78),t._detailData={},t}return a()(o,[{key:"init",value:function(t,e){b()(p()(o.prototype),"init",this).call(this,t),this._container=e,this._bindEvent(),this._appendTpl()}},{key:"show",value:function(){b()(p()(o.prototype),"show",this).call(this),this._render()}},{key:"clear",value:function(){this._requests={},this._render()}},{key:"requests",value:function(){var t=[];return Object(d.t)(this._requests,(function(e){t.push(e)})),t}},{key:"_updateType",value:function(t){var e=function(t){if(!t)return"unknown";var e=t.split(";")[0].split("/");return{type:e[0],subType:Object(d.W)(e)}}(t.resHeaders["content-type"]||""),n=e.type,r=e.subType;t.type=n,t.subType=r}},{key:"_bindEvent",value:function(){var t=this,e=this._$el,n=this._container,r=this;function i(t,e){var r=n.get("sources");r&&(r.set(t,e),n.showTool("sources"))}e.on("click",".eruda-request",(function(){var t=Object(d.a)(this).data("id"),e=r._requests[t];e.done&&r._showDetail(e)})).on("click",".eruda-clear-request",(function(){return t.clear()})).on("click",".eruda-back",(function(){return t._hideDetail()})).on("click",".eruda-http .eruda-response",(function(){var e=t._detailData,n=e.resTxt;switch(e.subType){case"css":return i("css",n);case"html":return i("html",n);case"javascript":return i("js",n);case"json":return i("object",n)}switch(e.type){case"image":return i("img",e.url)}}));var o=Lt.a.domain("Network");o.on("requestWillBeSent",this._reqWillBeSent),o.on("responseReceivedExtraInfo",this._resReceivedExtraInfo),o.on("responseReceived",this._resReceived),o.on("loadingFinished",this._loadingFinished)}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style);var t=Lt.a.domain("Network");t.off("requestWillBeSent",this._reqWillBeSent),t.off("responseReceivedExtraInfo",this._resReceivedExtraInfo),t.off("responseReceived",this._resReceived),t.off("loadingFinished",this._loadingFinished)}},{key:"_showDetail",value:function(t){t.resTxt&&""===Object(d.vb)(t.resTxt)&&delete t.resTxt,Object(d.H)(t.resHeaders)&&delete t.resHeaders,Object(d.H)(t.reqHeaders)&&delete t.reqHeaders,this._$detail.html(this._detailTpl(t)).show(),this._detailData=t}},{key:"_hideDetail",value:function(){this._$detail.hide()}},{key:"_appendTpl",value:function(){var t=this._$el;t.html(this._tpl()),this._$detail=t.find(".eruda-detail"),this._$requests=t.find(".eruda-requests")}},{key:"_render",value:function(){if(this.active){var t={};Object(d.H)(this._requests)||(t.requests=this._requests),this._renderHtml(this._requestsTpl(t))}}},{key:"_renderHtml",value:function(t){t!==this._lastHtml&&(this._lastHtml=t,this._$requests.html(t))}}]),o}(y);function Bt(t){for(var e={},n=0,r=t.length;n<r;n++){var i=t[n];"initial"!==t[i]&&(e[i]=t[i])}return function(t){return Object(d.nb)(t,{comparator:function(t,e){for(var n=t.length,r=e.length,i=n>r?r:n,o=0;o<i;o++){var a=Wt(t.charCodeAt(o),e.charCodeAt(o));if(0!==a)return a}return n>r?1:n<r?-1:0}})}(e)}var Ht=Element.prototype,qt=function(){return!1};Ht.webkitMatchesSelector?qt=function(t,e){return t.webkitMatchesSelector(e)}:Ht.mozMatchesSelector&&(qt=function(t,e){return t.mozMatchesSelector(e)});var Ut=function(){function t(e){i()(this,t),this._el=e}return a()(t,[{key:"getComputedStyle",value:function(){return Bt(window.getComputedStyle(this._el))}},{key:"getMatchedCSSRules",value:function(){var t=this,e=[];return Object(d.t)(document.styleSheets,(function(n){try{if(!n.cssRules)return}catch(t){return}Object(d.t)(n.cssRules,(function(n){var r=!1;try{r=t._elMatchesSel(n.selectorText)}catch(t){}r&&e.push({selectorText:n.selectorText,style:Bt(n.style)})}))})),e}},{key:"_elMatchesSel",value:function(t){return qt(this._el,t)}}]),t}();function Wt(t,e){return(t=Gt(t))>(e=Gt(e))?1:t<e?-1:0}function Gt(t){return 45===t?123:t}var Kt=function(){function t(e){i()(this,t),this._style=R(n(79)),this._isShow=!1,this._appendTpl(e),this._bindEvent()}return a()(t,[{key:"setEl",value:function(t){this._$target=Object(d.a)(t),this._target=t}},{key:"show",value:function(){this._isShow=!0,this.render(),this._$el.show()}},{key:"destroy",value:function(){R.remove(this._style)}},{key:"hide",value:function(){this._isShow=!1,this._$el.hide()}},{key:"render",value:function(){var t=this._$target.offset(),e=t.left,n=t.width,r=t.top,i=t.height;this._$el.css({left:e,top:r-window.scrollY,width:n,height:i});var o=getComputedStyle(this._target,"");if("none"===o.display)return this._$el.css("visibility","hidden");this._$el.css("visibility","visible");var a=function(t){return Object(d.ib)(o.getPropertyValue(t))},s=a("margin-left"),u=a("margin-right"),l=a("margin-top"),c=a("margin-bottom"),h=a("border-left-width"),p=a("border-right-width"),f=a("border-top-width"),_=a("border-bottom-width"),v=a("padding-left"),g=a("padding-right"),m=a("padding-top"),b=a("padding-bottom"),y=n-h-p,w=i-f-_,x="rgba(246, 178, 107, 0.66)",k="rgba(255, 229, 153, 0.66)",O="rgba(147, 196, 125, 0.55)";this._$margin.css({left:-s,top:-l,width:n+s+u,height:i+l+c,borderTop:"".concat(l,"px solid ").concat(x),borderLeft:"".concat(s,"px solid ").concat(x),borderRight:"".concat(u,"px solid ").concat(x),borderBottom:"".concat(c,"px solid ").concat(x)}),this._$border.css({left:0,top:0,width:n,height:i,borderTop:"".concat(f,"px solid ").concat(k),borderLeft:"".concat(h,"px solid ").concat(k),borderRight:"".concat(p,"px solid ").concat(k),borderBottom:"".concat(_,"px solid ").concat(k)}),this._$padding.css({left:h,top:f,width:y,height:w,borderTop:"".concat(m,"px solid ").concat(O),borderLeft:"".concat(v,"px solid ").concat(O),borderRight:"".concat(g,"px solid ").concat(O),borderBottom:"".concat(b,"px solid ").concat(O)}),this._$content.css({left:h+v,top:f+m,width:y-v-g,height:w-m-b,background:"rgba(111, 168, 220, 0.66)"}),this._$size.css({top:-l-(r-l<25?0:25),left:-s}).html("".concat(function(t){var e=t.id,n=t.className,r='<span style="color:#881280;">'.concat(t.tagName.toLowerCase(),"</span>");""!==e&&(r+='<span style="color:1a1aa8;">#'.concat(e,"</span>"));var i="";Object(d.S)(n)&&Object(d.t)(n.split(/\s+/g),(function(t){""!==Object(d.vb)(t)&&(i+=".".concat(t))}));return r+='<span style="color:1a1aa8;">'.concat(i,"</span>")}(this._target)," | ").concat(n," × ").concat(i))}},{key:"_bindEvent",value:function(){var t=this;window.addEventListener("scroll",(function(){t._isShow&&t.render()}),!1)}},{key:"_appendTpl",value:function(t){t.append(n(80)());var e=this._$el=t.find(".eruda-elements-highlight");this._$margin=e.find(".eruda-margin"),this._$padding=e.find(".eruda-padding"),this._$content=e.find(".eruda-content"),this._$border=e.find(".eruda-border"),this._$size=e.find(".eruda-size")}}]),t}();function Vt(t){var e=t.parentNode;if(!e)return!1;for(;e;)if((e=e.parentNode)&&"eruda"===e.id)return!0;return!1}function Qt(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var Jt=function(t){u()(r,t);var e,n=(e=r,function(){var t,n=p()(e);if(Qt()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function r(){var t;i()(this,r),t=n.call(this);var e=J()(t);return t._startListener=function(t){if(!Vt(t.target))return e._timer=setTimeout((function(){e.emit("select",t.target)}),200),!1},t._moveListener=function(){clearTimeout(e._timer)},t._clickListener=function(t){Vt(t.target)||(t.preventDefault(),t.stopImmediatePropagation())},t}return a()(r,[{key:"enable",value:function(){function t(t,e){document.body.addEventListener(t,e,!0)}return this.disable(),Object(d.L)()?(t("touchstart",this._startListener),t("touchmove",this._moveListener)):(t("mousedown",this._startListener),t("mousemove",this._moveListener)),t("click",this._clickListener),this}},{key:"disable",value:function(){function t(t,e){document.body.removeEventListener(t,e,!0)}return Object(d.L)()?(t("touchstart",this._startListener),t("touchmove",this._moveListener)):(t("mousedown",this._startListener),t("mousemove",this._moveListener)),t("click",this._clickListener),this}}]),r}(d.c);function Xt(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var Yt=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(Xt()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(81)),t.name="elements",t._tpl=n(82),t._rmDefComputedStyle=!0,t._highlightElement=!1,t._selectElement=!1,t._observeElement=!0,t._computedStyleSearchKeyword="",t._history=[],d.c.mixin(J()(t)),t}return a()(o,[{key:"init",value:function(t,e){var r=this;b()(p()(o.prototype),"init",this).call(this,t),this._container=e,t.html('<div class="eruda-show-area"></div>'),this._$showArea=t.find(".eruda-show-area"),t.append(n(83)()),this._htmlEl=document.documentElement,this._highlight=new Kt(this._container.$container),this._select=new Jt,this._bindEvent(),this._initObserver(),this._initCfg(),Object(d.cb)((function(){return r._updateHistory()}))}},{key:"show",value:function(){b()(p()(o.prototype),"show",this).call(this),this._observeElement&&this._enableObserver(),this._curEl||this._setEl(this._htmlEl),this._render()}},{key:"hide",value:function(){return this._disableObserver(),b()(p()(o.prototype),"hide",this).call(this)}},{key:"set",value:function(t){if(t!==this._curEl)return this._setEl(t),this.scrollToTop(),this._render(),this._updateHistory(),this.emit("change",t),this}},{key:"overrideEventTarget",value:function(){var t=ce(),e=this._origAddEvent=t.addEventListener,n=this._origRmEvent=t.removeEventListener;t.addEventListener=function(t,n,r){ue(this,t,n,r),e.apply(this,arguments)},t.removeEventListener=function(t,e,r){le(this,t,e,r),n.apply(this,arguments)}}},{key:"scrollToTop",value:function(){this._$showArea.get(0).scrollTop=0}},{key:"restoreEventTarget",value:function(){var t=ce();this._origAddEvent&&(t.addEventListener=this._origAddEvent),this._origRmEvent&&(t.removeEventListener=this._origRmEvent)}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style),this._select.disable(),this._highlight.destroy(),this._disableObserver(),this.restoreEventTarget(),this._rmCfg()}},{key:"_back",value:function(){if(this._curEl!==this._htmlEl){for(var t=this._curParentQueue,e=t.shift();!re(e);)e=t.shift();this.set(e)}}},{key:"_bindEvent",value:function(){var t=this,e=this,n=this._container,r=this._select;this._$el.on("click",".eruda-child",(function(){var t=Object(d.a)(this).data("idx"),r=e._curEl,i=r.childNodes[t];if(i&&3===i.nodeType){var o;switch(r.tagName){case"SCRIPT":o="js";break;case"STYLE":o="css";break;default:return}var a=n.get("sources");a&&(a.set(o,i.nodeValue),n.showTool("sources"))}else re(i)?e.set(i):e._render()})).on("click",".eruda-listener-content",(function(){var t=Object(d.a)(this).text(),e=n.get("sources");e&&(e.set("js",t),n.showTool("sources"))})).on("click",".eruda-breadcrumb",(function(){var e=n.get("sources");e&&(e.set("object",t._curEl),n.showTool("sources"))})).on("click",".eruda-parent",(function(){for(var t=Object(d.a)(this).data("idx"),n=e._curEl.parentNode;t--&&n.parentNode;)n=n.parentNode;re(n)?e.set(n):e._render()})).on("click",".eruda-toggle-all-computed-style",(function(){return t._toggleAllComputedStyle()})).on("click",".eruda-computed-style-search",(function(){var e=prompt("Filter");Object(d.N)(e)||(e=Object(d.vb)(e),t._computedStyleSearchKeyword=e,t._render())})),this._$el.find(".eruda-bottom-bar").on("click",".eruda-refresh",(function(){t._render(),n.notify("Refreshed")})).on("click",".eruda-highlight",(function(){return t._toggleHighlight()})).on("click",".eruda-select",(function(){return t._toggleSelect()})).on("click",".eruda-reset",(function(){return t.set(t._htmlEl)})),r.on("select",(function(e){return t.set(e)}))}},{key:"_toggleAllComputedStyle",value:function(){this._rmDefComputedStyle=!this._rmDefComputedStyle,this._render()}},{key:"_enableObserver",value:function(){this._observer.observe(this._htmlEl,{attributes:!0,childList:!0,subtree:!0})}},{key:"_disableObserver",value:function(){this._observer.disconnect()}},{key:"_toggleHighlight",value:function(){this._selectElement||(this._$el.find(".eruda-highlight").toggleClass("eruda-active"),this._highlightElement=!this._highlightElement,this._render())}},{key:"_toggleSelect",value:function(){var t=this._select;this._$el.find(".eruda-select").toggleClass("eruda-active"),this._selectElement||this._highlightElement||this._toggleHighlight(),this._selectElement=!this._selectElement,this._selectElement?(t.enable(),this._container.hide()):t.disable()}},{key:"_setEl",value:function(t){this._curEl=t,this._curCssStore=new Ut(t),this._highlight.setEl(t),this._rmDefComputedStyle=!0;for(var e=[],n=t.parentNode;n;)e.push(n),n=n.parentNode;this._curParentQueue=e}},{key:"_getData",value:function(){var t={},e=this._curEl,n=this._curCssStore,r=e.className,i=e.id,o=e.attributes,a=e.tagName;t.computedStyleSearchKeyword=this._computedStyleSearchKeyword,t.parents=function(t){var e=[],n=0,r=t.parentNode;for(;r&&1===r.nodeType;)e.push({text:ie(r,{noAttr:!0}),idx:n++}),r=r.parentNode;return e.reverse()}(e),t.children=function(t){for(var e=[],n=0,r=t.length;n<r;n++){var i=t[n],o=i.nodeType;if(3!==o&&8!==o){var a=!Object(d.S)(i.className);1===o&&"eruda"!==i.id&&(a||i.className.indexOf("eruda")<0)&&e.push({text:ie(i),isEl:!0,idx:n})}else{var s=i.nodeValue.trim();""!==s&&e.push({text:s,isCmt:8===o,idx:n})}}return e}(e.childNodes),t.attributes=oe(o),t.name=ie({tagName:a,id:i,className:r,attributes:o});var s=e.erudaEvents;if(s&&0!==Object(d.V)(s).length&&(t.listeners=s),se(a))return t;var u=n.getComputedStyle();function l(t){var e=["top","left","right","bottom"];return"position"!==t&&(e=Object(d.ab)(e,(function(e){return"".concat(t,"-").concat(e)}))),"border"===t&&(e=Object(d.ab)(e,(function(t){return"".concat(t,"-width")}))),{top:pe(u[e[0]],t),left:pe(u[e[1]],t),right:pe(u[e[2]],t),bottom:pe(u[e[3]],t)}}var c={margin:l("margin"),border:l("border"),padding:l("padding"),content:{width:pe(u.width),height:pe(u.height)}};"static"!==u.position&&(c.position=l("position")),t.boxModel=c;var h=n.getMatchedCSSRules();h.unshift(function(t){for(var e={selectorText:"element.style",style:{}},n=0,r=t.length;n<r;n++){var i=t[n];e.style[i]=t[i]}return e}(e.style)),h.forEach((function(t){return Zt(t.style)})),t.styles=h,this._rmDefComputedStyle&&(u=function(t,e){var n={},r=["display","width","height"];return Object(d.t)(e,(function(t){r=r.concat(Object(d.V)(t.style))})),r=Object(d.yb)(r),Object(d.t)(t,(function(t,e){Object(d.m)(r,e)&&(n[e]=t)})),n}(u,h)),t.rmDefComputedStyle=this._rmDefComputedStyle;var p=Object(d.Z)(t.computedStyleSearchKeyword);return p&&(u=Object(d.hb)(u,(function(t,e){return Object(d.m)(e,p)||Object(d.m)(t,p)}))),Zt(u),t.computedStyle=u,t}},{key:"_render",value:function(){if(!re(this._curEl))return this._back();this._highlight[this._highlightElement?"show":"hide"](),this._renderHtml(this._tpl(this._getData()))}},{key:"_renderHtml",value:function(t){t!==this._lastHtml&&(this._lastHtml=t,this._$showArea.html(t))}},{key:"_updateHistory",value:function(){var t=this._container.get("console");if(t){var e=this._history;e.unshift(this._curEl),e.length>5&&e.pop();for(var n=0;n<5;n++)t.setGlobal("$".concat(n),e[n])}}},{key:"_initObserver",value:function(){var t=this;this._observer=new d.f((function(e){Object(d.t)(e,(function(e){return t._handleMutation(e)}))}))}},{key:"_handleMutation",value:function(t){var e,n;if(!Vt(t.target))if("attributes"===t.type){if(t.target!==this._curEl)return;this._render()}else if("childList"===t.type){if(t.target===this._curEl)return this._render();var r=t.addedNodes;for(e=0,n=r.length;e<n;e++)if(r[e].parentNode===this._curEl)return this._render();var i=t.removedNodes;for(e=0,n=i.length;e<n;e++)if(i[e]===this._curEl)return this.set(this._htmlEl)}}},{key:"_rmCfg",value:function(){var t=this.config,e=this._container.get("settings");e&&e.remove(t,"overrideEventTarget").remove(t,"observeElement").remove("Elements")}},{key:"_initCfg",value:function(){var t=this,e=this.config=I.createCfg("elements",{overrideEventTarget:!0,observeElement:!0});e.get("overrideEventTarget")&&this.overrideEventTarget(),e.get("observeElement")&&(this._observeElement=!1),e.on("change",(function(e,n){switch(e){case"overrideEventTarget":return n?t.overrideEventTarget():t.restoreEventTarget();case"observeElement":return t._observeElement=n,n?t._enableObserver():t._disableObserver()}}));var n=this._container.get("settings");n&&(n.text("Elements").switch(e,"overrideEventTarget","Catch Event Listeners"),this._observer&&n.switch(e,"observeElement","Auto Refresh"),n.separator())}}]),o}(y);function Zt(t){Object(d.t)(t,(function(e,n){return t[n]=ne(e)}))}var te=/rgba?\((.*?)\)/g,ee=/url\("?(.*?)"?\)/g;function ne(t){return(t=Object(d.ub)(t)).replace(te,'<span class="eruda-style-color" style="background-color: $&"></span>$&').replace(ee,(function(t,e){return'url("'.concat(he(e),'")')}))}var re=function(t){return Object(d.G)(t)&&t.parentNode};function ie(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.noAttr,r=void 0!==n&&n,i=t.id,o=t.className,a=t.attributes,s='<span class="eruda-tag-name-color">'.concat(t.tagName.toLowerCase(),"</span>");if(""!==i&&(s+='<span class="eruda-function-color">#'.concat(i,"</span>")),Object(d.S)(o)){var u="";Object(d.t)(o.split(/\s+/g),(function(t){""!==t.trim()&&(u+=".".concat(t))})),s+='<span class="eruda-attribute-name-color">'.concat(u,"</span>")}return r||Object(d.t)(a,(function(t){var e=t.name;"id"!==e&&"class"!==e&&"style"!==e&&(s+=' <span class="eruda-attribute-name-color">'.concat(e,'</span><span class="eruda-operator-color">="</span><span class="eruda-string-color">').concat(t.value,'</span><span class="eruda-operator-color">"</span>'))})),s}var oe=function(t){return Object(d.ab)(t,(function(t){var e=t.value,n=t.name;return e=Object(d.v)(e),("src"===n||"href"===n)&&!Object(d.ob)(e,"data")&&(e=he(e)),"style"===n&&(e=ne(e)),{name:n,value:e}}))};var ae=["script","style","meta","title","link","head"],se=function(t){return ae.indexOf(t.toLowerCase())>-1};function ue(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(Object(d.G)(t)&&Object(d.J)(n)&&Object(d.E)(r)){var i=t.erudaEvents=t.erudaEvents||{};i[e]=i[e]||[],i[e].push({listener:n,listenerStr:n.toString(),useCapture:r})}}function le(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(Object(d.G)(t)&&Object(d.J)(n)&&Object(d.E)(r)){var i=t.erudaEvents;if(i&&i[e]){for(var o=i[e],a=0,s=o.length;a<s;a++)if(o[a].listener===n){o.splice(a,1);break}0===o.length&&delete i[e],0===Object(d.V)(i).length&&delete t.erudaEvents}}}var ce=function(){return Object(d.kb)(window,"EventTarget.prototype")||window.Node.prototype},he=function(t){return'<a href="'.concat(t,'" target="_blank">').concat(t,"</a>")};function pe(t,e){if(Object(d.O)(t))return t;if(!Object(d.S)(t))return"‒";var n=Object(d.ib)(t);return Object(d.M)(n)?t:"position"===e?n:0===n?"‒":n}var fe=null,_e=[{name:"Border All",fn:function(){if(fe)return R.remove(fe),void(fe=null);fe=R("* { outline: 2px dashed #707d8b; outline-offset: -3px; }",document.head)},desc:"Add color borders to all elements"},{name:"Refresh Page",fn:function(){var t=new d.h;t.setQuery("timestamp",Object(d.eb)()),window.location.replace(t.toString())},desc:"Add timestamp to url and refresh"},{name:"Search Text",fn:function(){var t,e,n,r=prompt("Enter the text")||"";""!==Object(d.vb)(r)&&(t=r,e=document.body,n=new RegExp(t,"ig"),de(e,(function(t){var e=Object(d.a)(t);if(e.hasClass("eruda-search-highlight-block"))return document.createTextNode(e.text())})),de(e,(function(t){if(3===t.nodeType){var e=t.nodeValue;if((e=e.replace(n,(function(t){return'<span class="eruda-keyword">'.concat(t,"</span>")})))!==t.nodeValue){var r=Object(d.a)(document.createElement("div"));return r.html(e),r.addClass("eruda-search-highlight-block"),r.get(0)}}})))},desc:"Highlight given text on page"},{name:"Edit Page",fn:function(){var t=document.body;t.contentEditable="true"!==t.contentEditable},desc:"Toggle body contentEditable"},{name:"Fit Screen",fn:function(){var t=document.body,e=document.documentElement,n=Object(d.a)(t);if(n.data("scaled"))window.scrollTo(0,+n.data("scaled")),n.rmAttr("data-scaled"),n.css("transform","none");else{var r=Math.max(t.scrollHeight,t.offsetHeight,e.clientHeight,e.scrollHeight,e.offsetHeight),i=Math.max(document.documentElement.clientHeight,window.innerHeight||0),o=i/r;n.css("transform","scale(".concat(o,")")),n.data("scaled",window.scrollY),window.scrollTo(0,r/2-i/2)}},desc:"Scale down the whole page to fit screen"},{name:"Load Fps Plugin",fn:function(){ve("fps")},desc:"Display page fps"},{name:"Load Features Plugin",fn:function(){ve("features")},desc:"Browser feature detections"},{name:"Load Timing Plugin",fn:function(){ve("timing")},desc:"Show performance and resource timing"},{name:"Load Memory Plugin",fn:function(){ve("memory")},desc:"Display memory"},{name:"Load Code Plugin",fn:function(){ve("code")},desc:"Edit and run JavaScript"},{name:"Load Benchmark Plugin",fn:function(){ve("benchmark")},desc:"Run JavaScript benchmarks"},{name:"Load Geolocation Plugin",fn:function(){ve("geolocation")},desc:"Test geolocation"},{name:"Load Dom Plugin",fn:function(){ve("dom")},desc:"Navigate dom tree"},{name:"Load Orientation Plugin",fn:function(){ve("orientation")},desc:"Test orientation api"},{name:"Load Touches Plugin",fn:function(){ve("touches")},desc:"Visualize screen touches"},{name:"Restore Settings",fn:function(){var t=Object(d.lb)("local"),e=JSON.parse(JSON.stringify(t));Object(d.t)(e,(function(e,n){Object(d.S)(e)&&Object(d.ob)(n,"eruda")&&t.removeItem(n)})),window.location.reload()},desc:"Restore defaults and reload"}];function de(t,e){var n=t.childNodes;if(!Vt(t)){for(var r=0,i=n.length;r<i;r++){var o=de(n[r],e);o&&t.replaceChild(o,n[r])}return e(t)}}function ve(t){var e="eruda"+Object(d.zb)(t);if(!window[e]){var n=location.protocol;Object(d.ob)(n,"http")||(n="http:"),Object(d.Y)("".concat(n,"//cdn.jsdelivr.net/npm/eruda-").concat(t,"@").concat(ge[t]),(function(n){if(!n||!window[e])return U.error("Fail to load plugin "+t);g.emit(g.ADD,window[e]),g.emit(g.SHOW,t)}))}}R(n(84),document.head);var ge={fps:"2.0.0",features:"2.0.0",timing:"2.0.0",memory:"2.0.0",code:"2.0.0",benchmark:"2.0.0",geolocation:"2.0.0",dom:"2.0.0",orientation:"2.0.0",touches:"2.0.0"};function me(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var be=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(me()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(85)),t.name="snippets",t._snippets=[],t._tpl=n(86),t}return a()(o,[{key:"init",value:function(t){b()(p()(o.prototype),"init",this).call(this,t),this._bindEvent(),this._addDefSnippets()}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style)}},{key:"add",value:function(t,e,n){return this._snippets.push({name:t,fn:e,desc:n}),this._render(),this}},{key:"remove",value:function(t){for(var e=this._snippets,n=0,r=e.length;n<r;n++)e[n].name===t&&e.splice(n,1);return this._render(),this}},{key:"run",value:function(t){for(var e=this._snippets,n=0,r=e.length;n<r;n++)e[n].name===t&&this._run(n);return this}},{key:"clear",value:function(){return this._snippets=[],this._render(),this}},{key:"_bindEvent",value:function(){var t=this;this._$el.on("click",".eruda-run",(function(){var e=Object(d.a)(this).data("idx");t._run(e)}))}},{key:"_run",value:function(t){this._snippets[t].fn.call(null)}},{key:"_addDefSnippets",value:function(){var t=this;Object(d.t)(_e,(function(e){t.add(e.name,e.fn,e.desc)}))}},{key:"_render",value:function(){this._renderHtml(this._tpl({snippets:this._snippets}))}},{key:"_renderHtml",value:function(t){t!==this._lastHtml&&(this._lastHtml=t,this._$el.html(t))}}]),o}(y);function ye(t){if("undefined"==typeof Symbol||null==t[Symbol.iterator]){if(Array.isArray(t)||(t=function(t,e){if(!t)return;if("string"==typeof t)return we(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(n);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return we(t,e)}(t))){var e=0,n=function(){};return{s:n,n:function(){return e>=t.length?{done:!0}:{done:!1,value:t[e++]}},e:function(t){throw t},f:n}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var r,i,o=!0,a=!1;return{s:function(){r=t[Symbol.iterator]()},n:function(){var t=r.next();return o=t.done,t},e:function(t){a=!0,i=t},f:function(){try{o||null==r.return||r.return()}finally{if(a)throw i}}}}function we(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function xe(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var ke=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(xe()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(87)),t.name="resources",t._localStoreData=[],t._localStoreSearchKeyword="",t._hideErudaSetting=!1,t._sessionStoreData=[],t._sessionStoreSearchKeyword="",t._cookieData=[],t._cookieSearchKeyword="",t._scriptData=[],t._stylesheetData=[],t._iframeData=[],t._imageData=[],t._observeElement=!0,t._tpl=n(88),t}return a()(o,[{key:"init",value:function(t,e){b()(p()(o.prototype),"init",this).call(this,t),this._container=e,this.refresh(),this._bindEvent(),this._initObserver(),this._initCfg()}},{key:"refresh",value:function(){return this.refreshLocalStorage().refreshSessionStorage().refreshCookie().refreshScript().refreshStylesheet().refreshIframe().refreshImage()._render()}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),this._disableObserver(),R.remove(this._style),this._rmCfg()}},{key:"refreshScript",value:function(){var t=[];return Object(d.a)("script").each((function(){var e=this.src;""!==e&&t.push(e)})),t=Object(d.yb)(t),this._scriptData=t,this}},{key:"refreshStylesheet",value:function(){var t=[];return Object(d.a)("link").each((function(){"stylesheet"===this.rel&&t.push(this.href)})),t=Object(d.yb)(t),this._stylesheetData=t,this}},{key:"refreshIframe",value:function(){var t=[];return Object(d.a)("iframe").each((function(){var e=Object(d.a)(this).attr("src");e&&t.push(e)})),t=Object(d.yb)(t),this._iframeData=t,this}},{key:"refreshLocalStorage",value:function(){return this._refreshStorage("local"),this}},{key:"refreshSessionStorage",value:function(){return this._refreshStorage("session"),this}},{key:"_refreshStorage",value:function(t){var e=this,n=Object(d.lb)(t,!1);if(n){var r=[];n=JSON.parse(JSON.stringify(n)),Object(d.t)(n,(function(t,n){Object(d.S)(t)&&(e._hideErudaSetting&&(Object(d.ob)(n,"eruda")||"active-eruda"===n)||r.push({key:n,val:$e(t,200)}))})),this["_"+t+"StoreData"]=r}}},{key:"refreshCookie",value:function(){var t=Lt.a.domain("Network").getCookies().cookies,e=Object(d.ab)(t,(function(t){return{key:t.name,val:t.value}}));return this._cookieData=e,this}},{key:"refreshImage",value:function(){var t=[],e=this._performance=window.webkitPerformance||window.performance;e&&e.getEntries?this._performance.getEntries().forEach((function(e){("img"===e.initiatorType||Se(e.name))&&t.push(e.name)})):Object(d.a)("img").each((function(){var e=Object(d.a)(this),n=e.attr("src");"true"!==e.data("exclude")&&t.push(n)}));return(t=Object(d.yb)(t)).sort(),this._imageData=t,this}},{key:"show",value:function(){return b()(p()(o.prototype),"show",this).call(this),this._observeElement&&this._enableObserver(),this.refresh()}},{key:"hide",value:function(){return this._disableObserver(),b()(p()(o.prototype),"hide",this).call(this)}},{key:"_bindEvent",value:function(){var t=this,e=this,n=this._$el,r=this._container;function i(t,e){var n=r.get("sources");if(n)return n.set(t,e),r.showTool("sources"),!0}function o(t){return function(e){if(r.get("sources")){e.preventDefault();var n=Object(d.a)(this).attr("href");"iframe"!==t&&Object(d.mb)(location.href,n)?Object(d.i)({url:n,success:function(e){i(t,e)},dataType:"raw"}):i("iframe",n)}}}n.on("click",".eruda-refresh-local-storage",(function(){r.notify("Refreshed"),t.refreshLocalStorage()._render()})).on("click",".eruda-refresh-session-storage",(function(){r.notify("Refreshed"),t.refreshSessionStorage()._render()})).on("click",".eruda-refresh-cookie",(function(){r.notify("Refreshed"),t.refreshCookie()._render()})).on("click",".eruda-refresh-script",(function(){r.notify("Refreshed"),t.refreshScript()._render()})).on("click",".eruda-refresh-stylesheet",(function(){r.notify("Refreshed"),t.refreshStylesheet()._render()})).on("click",".eruda-refresh-iframe",(function(){r.notify("Refreshed"),t.refreshIframe()._render()})).on("click",".eruda-refresh-image",(function(){r.notify("Refreshed"),t.refreshImage()._render()})).on("click",".eruda-search",(function(){var t=Object(d.a)(this).data("type"),n=prompt("Filter");if(!Object(d.N)(n)){switch(n=Object(d.vb)(n),t){case"local":e._localStoreSearchKeyword=n;break;case"session":e._sessionStoreSearchKeyword=n;break;case"cookie":e._cookieSearchKeyword=n}e._render()}})).on("click",".eruda-delete-storage",(function(){var t=Object(d.a)(this),n=t.data("key");"local"===t.data("type")?(localStorage.removeItem(n),e.refreshLocalStorage()._render()):(sessionStorage.removeItem(n),e.refreshSessionStorage()._render())})).on("click",".eruda-delete-cookie",(function(){var t=Object(d.a)(this).data("key");Lt.a.domain("Network").deleteCookies({name:t}),e.refreshCookie()._render()})).on("click",".eruda-clear-storage",(function(){"local"===Object(d.a)(this).data("type")?(Object(d.t)(e._localStoreData,(function(t){return localStorage.removeItem(t.key)})),e.refreshLocalStorage()._render()):(Object(d.t)(e._sessionStoreData,(function(t){return sessionStorage.removeItem(t.key)})),e.refreshSessionStorage()._render())})).on("click",".eruda-clear-cookie",(function(){Lt.a.domain("Storage").clearDataForOrigin({storageTypes:"cookies"}),t.refreshCookie()._render()})).on("click",".eruda-storage-val",(function(){var t=Object(d.a)(this),e=t.data("key"),n="local"===t.data("type")?localStorage.getItem(e):sessionStorage.getItem(e);try{i("object",JSON.parse(n))}catch(t){i("raw",n)}})).on("click",".eruda-img-link",(function(){i("img",Object(d.a)(this).attr("src"))})).on("click",".eruda-css-link",o("css")).on("click",".eruda-js-link",o("js")).on("click",".eruda-iframe-link",o("iframe")),d.fb.on("change",(function(){return t._render()}))}},{key:"_rmCfg",value:function(){var t=this.config,e=this._container.get("settings");e&&e.remove(t,"hideErudaSetting").remove(t,"observeElement").remove("Resources")}},{key:"_initCfg",value:function(){var t=this,e=this.config=I.createCfg("resources",{hideErudaSetting:!0,observeElement:!0});e.get("hideErudaSetting")&&(this._hideErudaSetting=!0),e.get("observeElement")||(this._observeElement=!1),e.on("change",(function(e,n){switch(e){case"hideErudaSetting":return void(t._hideErudaSetting=n);case"observeElement":return t._observeElement=n,n?t._enableObserver():t._disableObserver()}})),this._container.get("settings").text("Resources").switch(e,"hideErudaSetting","Hide Eruda Setting").switch(e,"observeElement","Auto Refresh Elements").separator()}},{key:"_render",value:function(){var t=this._cookieData,e=this._scriptData,n=this._stylesheetData,r=this._imageData,i=this._localStoreSearchKeyword,o=this._sessionStoreSearchKeyword,a=this._cookieSearchKeyword;function s(t,e){return(e=Object(d.Z)(e))?Object(d.z)(t,(function(t){var n=t.key,r=t.val;return Object(d.m)(Object(d.Z)(n),e)||Object(d.m)(Object(d.Z)(r),e)})):t}this._renderHtml(this._tpl({localStoreData:s(this._localStoreData,i),localStoreSearchKeyword:i,sessionStoreData:s(this._sessionStoreData,o),sessionStoreSearchKeyword:o,cookieData:s(t,a),cookieSearchKeyword:a,cookieState:Oe("cookie",t.length),scriptData:e,scriptState:Oe("script",e.length),stylesheetData:n,stylesheetState:Oe("stylesheet",n.length),iframeData:this._iframeData,imageData:r,imageState:Oe("image",r.length)}))}},{key:"_renderHtml",value:function(t){t!==this._lastHtml&&(this._lastHtml=t,this._$el.html(t))}},{key:"_initObserver",value:function(){var t=this;this._observer=new d.f((function(e){var n=!1;Object(d.t)(e,(function(e){t._handleMutation(e)&&(n=!0)})),n&&t._render()}))}},{key:"_handleMutation",value:function(t){var e=this;if(!Vt(t.target)){var n=function(t){switch(function(t){return t.tagName?t.tagName.toLowerCase():""}(t)){case"script":return e.refreshScript(),!0;case"img":return e.refreshImage(),!0;case"link":return e.refreshStylesheet(),!0}return!1};if("attributes"===t.type){if(n(t.target))return!0}else if("childList"===t.type){if(n(t.target))return!0;var r,i=Object(d.rb)(t.addedNodes),o=ye(i=Object(d.l)(i,Object(d.rb)(t.removedNodes)));try{for(o.s();!(r=o.n()).done;){if(n(r.value))return!0}}catch(t){o.e(t)}finally{o.f()}}return!1}}},{key:"_enableObserver",value:function(){this._observer.observe(document.documentElement,{attributes:!0,childList:!0,subtree:!0})}},{key:"_disableObserver",value:function(){this._observer.disconnect()}}]),o}(y);function Oe(t,e){if(0===e)return"";var n=0,r=0;switch(t){case"cookie":n=30,r=60;break;case"script":n=5,r=10;break;case"stylesheet":n=4,r=8;break;case"image":n=50,r=100}return e>=r?"danger":e>=n?"warn":"ok"}var $e=function(t,e){return t.length<e?t:t.slice(0,e)+"..."},je=/\.(jpeg|jpg|gif|png)$/,Se=function(t){return je.test(t)},Ee=Object(d.r)(),Ae=[{name:"Location",val:function(){return Object(d.v)(location.href)}},{name:"User Agent",val:navigator.userAgent},{name:"Device",val:["<table><tbody>",'<tr><td class="eruda-device-key">screen</td><td>'.concat(screen.width," * ").concat(screen.height,"</td></tr>"),"<tr><td>viewport</td><td>".concat(window.innerWidth," * ").concat(window.innerHeight,"</td></tr>"),"<tr><td>pixel ratio</td><td>".concat(window.devicePixelRatio,"</td></tr>"),"</tbody></table>"].join("")},{name:"System",val:["<table><tbody>",'<tr><td class="eruda-system-key">os</td><td>'.concat(Object(d.s)(),"</td></tr>"),"<tr><td>browser</td><td>".concat(Ee.name+" "+Ee.version,"</td></tr>"),"</tbody></table>"].join("")},{name:"About",val:'<a href="https://github.com/liriliri/eruda" target="_blank">Eruda v2.4.1</a>'}];function Te(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var Ce=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(Te()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(89)),t.name="info",t._tpl=n(90),t._infos=[],t}return a()(o,[{key:"init",value:function(t){b()(p()(o.prototype),"init",this).call(this,t),this._addDefInfo()}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style)}},{key:"add",value:function(t,e){var n=this._infos,r=!1;return Object(d.t)(n,(function(n){t===n.name&&(n.val=e,r=!0)})),r||n.push({name:t,val:e}),this._render(),this}},{key:"get",value:function(t){var e,n=this._infos;return Object(d.T)(t)?Object(d.k)(n):(Object(d.t)(n,(function(n){t===n.name&&(e=n.val)})),e)}},{key:"remove",value:function(t){for(var e=this._infos,n=e.length-1;n>=0;n--)e[n].name===t&&e.splice(n,1);return this._render(),this}},{key:"clear",value:function(){return this._infos=[],this._render(),this}},{key:"_addDefInfo",value:function(){var t=this;Object(d.t)(Ae,(function(e){return t.add(e.name,e.val)}))}},{key:"_render",value:function(){var t=[];Object(d.t)(this._infos,(function(e){var n=e.name,r=e.val;Object(d.J)(r)&&(r=r()),t.push({name:n,val:r})})),this._renderHtml(this._tpl({infos:t}))}},{key:"_renderHtml",value:function(t){t!==this._lastHtml&&(this._lastHtml=t,this._$el.html(t))}}]),o}(y);function Pe(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}var Ne,De=function(t){u()(o,t);var e,r=(e=o,function(){var t,n=p()(e);if(Pe()){var r=p()(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return c()(this,t)});function o(){var t;return i()(this,o),(t=r.call(this))._style=R(n(91)),t.name="sources",t._showLineNum=!0,t._formatCode=!0,t._indentSize=4,t._loadTpl(),t}return a()(o,[{key:"init",value:function(t,e){b()(p()(o.prototype),"init",this).call(this,t),this._container=e,this._bindEvent(),this._initCfg()}},{key:"destroy",value:function(){b()(p()(o.prototype),"destroy",this).call(this),R.remove(this._style),this._rmCfg()}},{key:"set",value:function(t,e){if("img"===t){this._isFetchingData=!0;var n=new Image,r=this;return n.onload=function(){r._isFetchingData=!1,r._data={type:"img",val:{width:this.width,height:this.height,src:e}},r._render()},n.onerror=function(){r._isFetchingData=!1},void(n.src=e)}return this._data={type:t,val:e},this._render(),this}},{key:"show",value:function(){return b()(p()(o.prototype),"show",this).call(this),this._data||this._isFetchingData||this._renderDef(),this}},{key:"_renderDef",value:function(){var t=this;if(this._html)return this._data={type:"html",val:this._html},this._render();this._isGettingHtml||(this._isGettingHtml=!0,Object(d.i)({url:location.href,success:function(e){return t._html=e},error:function(){return t._html="Sorry, unable to fetch source code:("},complete:function(){t._isGettingHtml=!1,t._renderDef()},dataType:"raw"}))}},{key:"_bindEvent",value:function(){var t=this;this._container.on("showTool",(function(e,n){e!==t.name&&n.name===t.name&&delete t._data}))}},{key:"_loadTpl",value:function(){this._codeTpl=n(92),this._imgTpl=n(93),this._objTpl=n(94),this._rawTpl=n(95),this._iframeTpl=n(96)}},{key:"_rmCfg",value:function(){var t=this.config,e=this._container.get("settings");e&&e.remove(t,"showLineNum").remove(t,"formatCode").remove(t,"indentSize").remove("Sources")}},{key:"_initCfg",value:function(){var t=this,e=this.config=I.createCfg("sources",{showLineNum:!0,formatCode:!0,indentSize:4});e.get("showLineNum")||(this._showLineNum=!1),e.get("formatCode")||(this._formatCode=!1),this._indentSize=e.get("indentSize"),e.on("change",(function(e,n){switch(e){case"showLineNum":return void(t._showLineNum=n);case"formatCode":return void(t._formatCode=n);case"indentSize":return void(t._indentSize=+n)}})),this._container.get("settings").text("Sources").switch(e,"showLineNum","Show Line Numbers").switch(e,"formatCode","Beautify Code").select(e,"indentSize","Indent Size",["2","4"]).separator()}},{key:"_render",value:function(){switch(this._isInit=!0,this._data.type){case"html":case"js":case"css":return this._renderCode();case"img":return this._renderImg();case"object":return this._renderObj();case"raw":return this._renderRaw();case"iframe":return this._renderIframe()}}},{key:"_renderImg",value:function(){this._renderHtml(this._imgTpl(this._data.val))}},{key:"_renderCode",value:function(){var t=this._data,e=this._indentSize,n=t.val,r=t.val.length;if(r<Re&&this._formatCode){switch(t.type){case"html":n=ot.a.html(n,{unformatted:[],indent_size:e});break;case"css":n=ot.a.css(n,{indent_size:e});break;case"js":n=ot()(n,{indent_size:e})}var i=R.getCurTheme();n=Object(d.C)(n,t.type,{keyword:"color:".concat(i.keywordColor),number:"color:".concat(i.numberColor),operator:"color:".concat(i.operatorColor),comment:"color:".concat(i.commentColor),string:"color:".concat(i.stringColor)})}else n=Object(d.v)(n);r<Me&&this._showLineNum&&(n=n.split("\n").map((function(t,e){return""===Object(d.vb)(t)&&(t="&nbsp;"),{idx:e+1,val:t}}))),this._renderHtml(this._codeTpl({code:n,showLineNum:r<Me&&this._showLineNum}))}},{key:"_renderObj",value:function(){this._renderHtml(this._objTpl(),!1);var t=this._data.val;try{Object(d.S)(t)&&(t=JSON.parse(t))}catch(t){}new st.a(this._$el.find(".eruda-json").get(0),{unenumerable:!0,accessGetter:!0}).set(t)}},{key:"_renderRaw",value:function(){this._renderHtml(this._rawTpl({val:this._data.val}))}},{key:"_renderIframe",value:function(){this._renderHtml(this._iframeTpl({src:this._data.val}))}},{key:"_renderHtml",value:function(t){var e=this,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];n&&t===this._lastHtml||(this._lastHtml=t,this._$el.html(t),setTimeout((function(){return e._$el.get(0).scrollTop=0}),0))}}]),o}(y),Re=1e5,Me=4e5;e.default={init:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.container,n=t.tool,r=t.autoScale,i=void 0===r||r,o=t.useShadowDom,a=void 0===o||o,s=t.defaults,u=void 0===s?{}:s;this._isInit||(this._isInit=!0,this._scale=1,this._initContainer(e,a),this._initStyle(),this._initDevTools(u),this._initEntryBtn(),this._initSettings(),this._initTools(n),this._registerListener(),i&&this._autoScale())},_isInit:!1,version:"2.4.1",util:d.p,chobitsu:Lt.a,Tool:y,Console:Rt,Elements:Yt,Network:zt,Sources:De,Resources:ke,Info:Ce,Snippets:be,Settings:I,get:function(t){if(this._checkInit()){if("entryBtn"===t)return this._entryBtn;var e=this._devTools;return t?e.get(t):e}},add:function(t){if(this._checkInit())return Object(d.J)(t)&&(t=t(this)),this._devTools.add(t),this},remove:function(t){return this._devTools.remove(t),this},show:function(t){if(this._checkInit()){var e=this._devTools;return t?e.showTool(t):e.show(),this}},hide:function(){if(this._checkInit())return this._devTools.hide(),this},destroy:function(){this._devTools.destroy(),delete this._devTools,this._entryBtn.destroy(),delete this._entryBtn,this._unregisterListener(),this._$el.remove(),R.clear(),this._isInit=!1},scale:function(t){return Object(d.O)(t)?(this._scale=t,g.emit(g.SCALE,t),this):this._scale},position:function(t){var e=this._entryBtn;return Object(d.P)(t)?(e.setPos(t),this):e.getPos()},_autoScale:function(){Object(d.L)()&&this.scale(1/Object(d.Ab)())},_registerListener:function(){var t=this;this._addListener=function(){return t.add.apply(t,arguments)},this._showListener=function(){return t.show.apply(t,arguments)},g.on(g.ADD,this._addListener),g.on(g.SHOW,this._showListener),g.on(g.SCALE,R.setScale)},_unregisterListener:function(){g.off(g.ADD,this._addListener),g.off(g.SHOW,this._showListener),g.off(g.SCALE,R.setScale)},_checkInit:function(){return this._isInit||U.error('Please call "eruda.init()" first'),this._isInit},_initContainer:function(t,e){var r;t||(t=document.createElement("div"),document.documentElement.appendChild(t),t.style.all="initial"),e&&(t.attachShadow?r=t.attachShadow({mode:"open"}):t.createShadowRoot&&(r=t.createShadowRoot()),r&&(R.container=document.head,R(n(26)),t=document.createElement("div"),r.appendChild(t),this._shadowRoot=r)),Object.assign(t,{id:"eruda",className:"eruda-container",contentEditable:!1}),"ios"===Object(d.r)().name&&t.setAttribute("ontouchstart",""),this._$el=Object(d.a)(t)},_initDevTools:function(t){this._devTools=new V(this._$el,{defaults:t})},_initStyle:function(){var t=this._$el;this._shadowRoot?(R.container=this._shadowRoot,R(":host { all: initial }")):(t.append('<div class="'.concat("eruda-style-container",'"></div>')),R.container=t.find(".".concat("eruda-style-container")).get(0)),R(n(97)+n(98)+n(99)+n(100)+n(26))},_initEntryBtn:function(){var t=this;this._entryBtn=new z(this._$el),this._entryBtn.on("click",(function(){return t._devTools.toggle()}))},_initSettings:function(){var t=this._devTools,e=new I;t.add(e),this._entryBtn.initCfg(e),t.initCfg(e)},_initTools:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["console","elements","network","resources","sources","info","snippets"];e=Object(d.rb)(e);var n=this._devTools;e.forEach((function(e){var r=t[Object(d.zb)(e)];try{r&&n.add(new r)}catch(t){Object(d.cb)((function(){U.error("Something wrong when initializing tool ".concat(e,":"),t.message)}))}})),n.showTool(e[0]||"settings")}};Ne=d.p,Object.assign(Ne,{beautify:ot.a,evalCss:R,isErudaEl:Vt})}])}));
//# sourceMappingURL=eruda.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e169b974.js